/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 222);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(229);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(236)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header_Header__ = __webpack_require__(516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__Header_Header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer_Footer__ = __webpack_require__(518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__Footer_Footer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentesBasicos_Select__ = __webpack_require__(519);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__ComponentesBasicos_Select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComponentesBasicos_MaskedInput__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_3__ComponentesBasicos_MaskedInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComponentesBasicos_TextInput__ = __webpack_require__(522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_4__ComponentesBasicos_TextInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComponentesBasicos_Input__ = __webpack_require__(523);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__ComponentesBasicos_Input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ComponentesBasicos_Button__ = __webpack_require__(526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__ComponentesBasicos_Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ComponentesBasicos_DataGrid__ = __webpack_require__(527);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__ComponentesBasicos_DataGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ComponentesBasicos_SimpleGrid__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__ComponentesBasicos_SimpleGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComponentesBasicos_Table__ = __webpack_require__(528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_9__ComponentesBasicos_Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ComponentesBasicos_Modal__ = __webpack_require__(529);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_10__ComponentesBasicos_Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ComponentesBasicos_ListaEncerramentoExigencias__ = __webpack_require__(530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__ComponentesBasicos_ListaEncerramentoExigencias__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ComponentesBasicos_Title__ = __webpack_require__(531);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_12__ComponentesBasicos_Title__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ComponentesBasicos_DocumentControl__ = __webpack_require__(532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__ComponentesBasicos_DocumentControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ComponentesBasicos_ProgressBar__ = __webpack_require__(555);
/* unused harmony reexport ProgressBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ComponentesBasicos_Spinner__ = __webpack_require__(556);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_15__ComponentesBasicos_Spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ComponentesBasicos_Radio__ = __webpack_require__(557);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_16__ComponentesBasicos_Radio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ComponentesBasicos_FileUpload__ = __webpack_require__(558);
/* unused harmony reexport FileUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ComponentesBasicos_Checkbox__ = __webpack_require__(196);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ComponentesBasicos_PeriodosVigenciaControl__ = __webpack_require__(559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_19__ComponentesBasicos_PeriodosVigenciaControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ComponentesBasicos_ListaUos__ = __webpack_require__(561);
/* unused harmony reexport ListaUos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ComponentesBasicos_ListaAbrangenciaRPPS__ = __webpack_require__(562);
/* unused harmony reexport ListaAbrangenciaRPPS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ComponentesBasicos_OrgaosCentralizadosControl__ = __webpack_require__(563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_22__ComponentesBasicos_OrgaosCentralizadosControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ComponentesBasicos_DownloadItem__ = __webpack_require__(565);
/* unused harmony reexport DownloadItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ComponentesBasicos_SelecaoMultipla__ = __webpack_require__(566);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_24__ComponentesBasicos_SelecaoMultipla__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ComponentesBasicos_Grid__ = __webpack_require__(567);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_25__ComponentesBasicos_Grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_8__ComponentesBasicos_SimpleGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ComponentesBasicos_DataGridCustom__ = __webpack_require__(568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_26__ComponentesBasicos_DataGridCustom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ComponentesBasicos_RadioComLabel__ = __webpack_require__(569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_27__ComponentesBasicos_RadioComLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ComponentesBasicos_UploadDragDrop__ = __webpack_require__(38);
/* unused harmony reexport UploadDragDrop */


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export exibirMensagem */
/* unused harmony export exibirMensagensSnackbar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return trataMensagemSucesso; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return trataMensagensErro; });
/* unused harmony export exibirMensagemBloqueioDesbloqueio */
/* unused harmony export exibirMensagensSnackbarBloqueioDesbloqueio */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return trataMensagemSucessoBloqueioDesbloqueio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return validateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return doPost; });
/* unused harmony export doPostPaginado */
/* unused harmony export doPostExigencias */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return doMultipartFormPost; });
/* unused harmony export doMultipartFormPostTratamento */
/* unused harmony export doMultipartFormPostMotivos */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return doMultipartFormPostExigencias; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return doGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return doGetPaginado; });
/* unused harmony export doGetListaMotivosCessacaoAposentadoria */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return doGetFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return doGetFileMsgPagamento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return doPostDocumentoComUrlDinamica; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return doGetDocumentoComUrlDinamica; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return doPut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return doDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return doDeleteMotivo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buscaDestinatarios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return requestTiposDocumentos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return requestExigencias; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return requestExigenciasRPPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return requestValoresMediosBeneficios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return requestMotivos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return requestMotivosCessacaoRequerimentoAposentadoria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return requestMotivosCessacaoRequerimentoPensao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return requestMotivosCessacaoDependente; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return requestPeriodosVigencia; });
/* unused harmony export requestApagaPeriodosVigencia */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return solicitarCompetenciaAberta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return solicitarEntesControlados; });
/* unused harmony export solicitarParticipante */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return requestOrgaosCentralizados; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return solicitarHabilitarQualificacao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return requestAbrangenciasEntidadeParticipanteRPPS; });
/* unused harmony export requestApagaAbrangenciasEntidadeParticipanteRPPS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return salvarListaMensagens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return requestSalvaFiltroBloqueio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return requestApagaFiltroBloqueio; });
/* unused harmony export doPostComprovantes */
/* unused harmony export doMultipartFormPostComprovantes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return requestSalvaComplementoTitulo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return requestApagaComplementoTitulo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return requestMotivosRelatorio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return requestExigenciasRelatorio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buscaEstadosSimulacaoCompensacao; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseActions__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_constants__ = __webpack_require__(9);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* eslint-disable */var exibirMensagem=function exibirMensagem(mensagem,type){var snackMessage={title:'Título da Mensagem',text:mensagem,timeout:24000,type:type};window.DtpSnackbar.addMessage(snackMessage);};var exibirMensagensSnackbar=function exibirMensagensSnackbar(listaMensagens,type){listaMensagens.forEach(function(mensagem){exibirMensagem(mensagem,type);});};var trataMensagemSucesso=function trataMensagemSucesso(mensagem){exibirMensagensSnackbar([mensagem],'success');};var trataMensagensErro=function trataMensagensErro(listaMensagens){exibirMensagensSnackbar(listaMensagens,'danger');};var exibirMensagemBloqueioDesbloqueio=function exibirMensagemBloqueioDesbloqueio(mensagem,type){var snackMessage={title:'Título da Mensagem',text:mensagem,timeout:600000,type:type};window.DtpSnackbar.addMessage(snackMessage);};var exibirMensagensSnackbarBloqueioDesbloqueio=function exibirMensagensSnackbarBloqueioDesbloqueio(listaMensagens,type){listaMensagens.forEach(function(mensagem){exibirMensagemBloqueioDesbloqueio(mensagem,type);});};var trataMensagemSucessoBloqueioDesbloqueio=function trataMensagemSucessoBloqueioDesbloqueio(mensagem){exibirMensagensSnackbarBloqueioDesbloqueio([mensagem],'success');};var validateObject=function validateObject(listFieldValidation){return Object.keys(listFieldValidation).reduce(function(currValidation,pn){return listFieldValidation[pn]===true&&currValidation;},true);};// Funcoes uteis para requests (tratamento de mensagens de erros, GET, POST, PUT)
var handleErrorMessages=function handleErrorMessages(error,callback,mensagemErro){if(error.response){var _error$response=Object.assign({},error.response),data=_error$response.data;switch(error.response.status){case 400:{var listaMensagens=[];if(data.tipo===2)break;// Mensagens de alerta
if(data.erros&&data.erros.length>=1){data.erros.forEach(function(erro){if(mensagemErro&&erro.codigo===mensagemErro.codigo){listaMensagens.push(mensagemErro.mensagem);}else{listaMensagens.push(erro.mensagem+' '+erro.descricao);}});trataMensagensErro(listaMensagens);}else if(mensagemErro&&data.codigo===mensagemErro.codigo){trataMensagensErro([mensagemErro.mensagem]);}else{trataMensagensErro([data.mensagem+' '+data.descricao]);}break;}case 401:{if(error.response.data.error&&error.response.data.error[0]==='expired_accessToken'){trataMensagensErro(['Acesso expirado. Faça o login de novo para acessar o recurso.']);}else{trataMensagensErro(['Acesso não autorizado. O usuário não possui permissão para acessar o recurso.']);}break;}case 403:{if(mensagemErro){trataMensagensErro([mensagemErro.mensagem]);}else{trataMensagensErro(['Operação não permitida. O usuário não possui permissão para realizar a operação.']);}break;}case 404:{if(data.mensagem&&data.descricao){trataMensagensErro([data.mensagem+' '+data.descricao]);}break;}case 409:{if(data.mensagem&&data.descricao){trataMensagensErro([data.mensagem+' '+data.descricao]);}break;}case 500:{var _listaMensagens=[];if(data.mensagem){_listaMensagens.push(data.mensagem+' '+data.descricao);}else{_listaMensagens.push('Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.');}trataMensagensErro(_listaMensagens);break;}default:trataMensagensErro(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);}if(callback){callback(error.response);}}else{trataMensagensErro(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);if(callback){callback(error.response);}}};var getURLParams=function getURLParams(params){var urlParams=new URLSearchParams();if(params){var keys=Object.keys(params);keys.forEach(function(key){if(Array.isArray(params[key])){params[key].forEach(function(item){urlParams.append(key,item);});}else{urlParams.append(key,params[key]);}});}return urlParams;};var comprevNewdooUrl=window.comprevConfig.comprevNewdooUrl;var baseUrl=comprevNewdooUrl+'/apis/comprevws';var doPost=function doPost(url,body,successCallback,failCallback,config){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](true));var configComAuth={};var headersOpcionais={};if(config){headersOpcionais=config;}configComAuth={headers:Object.assign({Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()},headersOpcionais)};__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl+'/'+url,body,configComAuth).then(function(response){successCallback(response);}).catch(function(error){var erroServico=error;handleErrorMessages(erroServico||error,failCallback);}).then(function(){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));});};var doPostPaginado=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url,body,maxResult,successCallback,failCallback,config){var instance,configComAuth,headersOpcionais,responseFinal,parametros,keep,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](true));instance=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,headers:{'Content-Type':'application/json',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()},data:{}});configComAuth={};headersOpcionais={};responseFinal={data:[]};parametros=body;parametros.start=1;parametros.maxResult=maxResult;keep=true;if(config){headersOpcionais=config;}configComAuth={headers:Object.assign({Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()},headersOpcionais)};_context.prev=11;case 12:if(!keep){_context.next=21;break;}_context.next=15;return instance.post(baseUrl+'/'+url,body,configComAuth);case 15:response=_context.sent;if(response.data.length<parametros.maxResult){keep=false;}responseFinal.data=responseFinal.data.concat(response.data);parametros.start+=parametros.maxResult;_context.next=12;break;case 21:__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));successCallback(responseFinal);_context.next=29;break;case 25:_context.prev=25;_context.t0=_context['catch'](11);__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));handleErrorMessages(_context.t0,failCallback);case 29:case'end':return _context.stop();}}},_callee,this,[[11,25]]);}));return function doPostPaginado(_x,_x2,_x3,_x4,_x5,_x6){return _ref.apply(this,arguments);};}();;var doPostExigencias=function doPostExigencias(url,body,successCallback,failCallback,config,tamanhoArquivo){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](true));var configComAuth={};var headersOpcionais={};if(config){headersOpcionais=config;}configComAuth={headers:Object.assign({Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()},headersOpcionais)};__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl+'/'+url,body,configComAuth).then(function(response){successCallback(response);}).catch(function(error){var erroServico=error;if(url==='documentos'){if(erroServico.response.status===500||erroServico.response.status===400){var msgErro='';var msgDescricao='';if(erroServico.response.data.erros){if(erroServico.response.data.erros.length>0){var colecaoErro=erroServico.response.data.erros;colecaoErro.forEach(function(erro){if(erro.mensagem){msgErro=erro.mensagem;}});}msgDescricao+=' '+msgErro+' ';}erroServico.response.data={};erroServico.response.data.mensagem='Houve um erro na tentativa de fazer a carga do documento.';if(tamanhoArquivo>__WEBPACK_IMPORTED_MODULE_5__utils_constants__["z" /* tamanhoMaximoArquivoUpload */]){erroServico.response.data.descricao='Certifique-se de que o documento possui tamanho inferior a 3 mb.';}else{erroServico.response.data.descricao=msgDescricao;}}}handleErrorMessages(erroServico||error,failCallback);}).then(function(){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));});};var doMultipartFormPost=function doMultipartFormPost(url,body,successCallback,failCallback){var config={'Content-Type':'multipart/form-data',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()};var formData=new FormData();var keys=Object.keys(body);keys.forEach(function(key){formData.set(key,body[key]);});doPost(url,formData,successCallback,failCallback,config);};// apagar
var doMultipartFormPostTratamento=function doMultipartFormPostTratamento(url,body,successCallback,failCallback){var config={'Content-Type':'multipart/form-data',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()};doPost(url,body,successCallback,failCallback,config);};var doMultipartFormPostMotivos=function doMultipartFormPostMotivos(url,body,successCallback,failCallback){var config={'Content-Type':'multipart/form-data',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()};doPost(url,body,successCallback,failCallback,config);};var doMultipartFormPostExigencias=function doMultipartFormPostExigencias(url,body,successCallback,failCallback){var config={'Content-Type':'multipart/form-data',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()};var formData=new FormData();var keys=Object.keys(body);var tamanhoArquivo=body.documento.size;keys.forEach(function(key){formData.set(key,body[key]);});doPostExigencias(url,formData,successCallback,failCallback,config,tamanhoArquivo);};var doGet=function doGet(url,successCallback,failCallback,params){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](true));var instance=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,headers:{'Content-Type':'application/json',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()},data:{}});instance.get(''+url,{params:getURLParams(params)}).then(function(response){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));successCallback(response);}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));handleErrorMessages(error,failCallback);});};var doGetPaginado=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url,successCallback,failCallback,params,maxResult){var instance,responseFinal,parametros,keep,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](true));instance=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,headers:{'Content-Type':'application/json',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()},data:{}});responseFinal={data:[]};parametros=params;parametros.start=1;parametros.maxResult=maxResult;keep=true;_context2.prev=7;case 8:if(!keep){_context2.next=17;break;}_context2.next=11;return instance.get(''+url,{params:getURLParams(parametros)});case 11:response=_context2.sent;if(response.data.length<parametros.maxResult){keep=false;}responseFinal.data=responseFinal.data.concat(response.data);parametros.start+=parametros.maxResult;_context2.next=8;break;case 17:__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));successCallback(responseFinal);_context2.next=25;break;case 21:_context2.prev=21;_context2.t0=_context2['catch'](7);__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));handleErrorMessages(_context2.t0,failCallback);case 25:case'end':return _context2.stop();}}},_callee2,this,[[7,21]]);}));return function doGetPaginado(_x7,_x8,_x9,_x10,_x11){return _ref2.apply(this,arguments);};}();var doGetListaMotivosCessacaoAposentadoria=function doGetListaMotivosCessacaoAposentadoria(url,tipoBeneficio,successCallback,failCallback,params){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](true));var instance=__WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({baseURL:baseUrl,headers:{'Content-Type':'application/json',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()},data:{}});instance.get(''+url,{params:getURLParams(params)}).then(function(response){successCallback(response,tipoBeneficio);}).catch(function(error){handleErrorMessages(error,failCallback);}).then(function(){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));});};var doGetFile=function doGetFile(fileId,filename){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl+'/documentos/'+fileId,{responseType:'arraybuffer',headers:{Accept:'application/pdf',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()}}).then(function(response){var url=window.URL.createObjectURL(new Blob([response.data]));var link=document.createElement('a');link.href=url;link.setAttribute('download',filename+'.pdf');document.body.appendChild(link);link.click();}).catch(function(error){handleErrorMessages(error);});};var doGetFileMsgPagamento=function doGetFileMsgPagamento(fileId,filename){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl+'/documentos-mensagem/'+fileId,{responseType:'arraybuffer',headers:{Accept:'application/pdf',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()}}).then(function(response){var url=window.URL.createObjectURL(new Blob([response.data]));var link=document.createElement('a');link.href=url;link.setAttribute('download',filename+'.pdf');document.body.appendChild(link);link.click();}).catch(function(error){handleErrorMessages(error);});};var doPostDocumentoComUrlDinamica=function doPostDocumentoComUrlDinamica(caminho){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(''+baseUrl+caminho,null,{responseType:'arraybuffer',headers:{Accept:['application/pdf','application/json'],Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()}}).then(function(response){var url=window.URL.createObjectURL(new Blob([response.data]));var link=document.createElement('a');link.href=url;link.setAttribute('download','gru.pdf');document.body.appendChild(link);link.click();}).catch(function(error){var responseDecodificado=JSON.parse(new TextDecoder().decode(error.response.data));error.response.data=responseDecodificado;handleErrorMessages(error);});};var doGetDocumentoComUrlDinamica=function doGetDocumentoComUrlDinamica(fileId,filename,caminho){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(''+baseUrl+caminho+fileId,{responseType:'arraybuffer',headers:{Accept:'application/pdf',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()}}).then(function(response){var url=window.URL.createObjectURL(new Blob([response.data]));var link=document.createElement('a');link.href=url;link.setAttribute('download',filename+'.pdf');document.body.appendChild(link);link.click();}).catch(function(error){handleErrorMessages(error);});};var doPut=function doPut(url,body,successCallback,failCallback,mensagemErro,config){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](true));var configComAuth={};var headersOpcionais={};if(config){headersOpcionais=config;}configComAuth={headers:Object.assign({Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()},headersOpcionais)};__WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(baseUrl+'/'+url,body,configComAuth).then(function(response){successCallback(response);}).catch(function(error){handleErrorMessages(error,failCallback,mensagemErro);}).then(function(){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));});};var doDelete=function doDelete(url,id,successCallback,failCallback,mensagemErro){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](true));var config={method:'delete',url:baseUrl+'/'+url+'/'+id,headers:{Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */](),'Content-Type':'application/json'}};__WEBPACK_IMPORTED_MODULE_1_axios___default()(config).then(function(){successCallback();}).catch(function(error){handleErrorMessages(error,failCallback,mensagemErro);}).then(function(){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));});};var doDeleteMotivo=function doDeleteMotivo(url,successCallback,failCallback,mensagemErro){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](true));var config={method:'delete',url:baseUrl+'/'+url,headers:{Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */](),'Content-Type':'application/json'}};__WEBPACK_IMPORTED_MODULE_1_axios___default()(config).then(function(){successCallback();}).catch(function(error){handleErrorMessages(error,failCallback,mensagemErro);}).then(function(){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));});};/**
 * Requisicoes de dados a serem guardados globalmente no estado do Redux
 */var buscaDestinatariosSuccess=function buscaDestinatariosSuccess(response){// TipoRegimeProprio : Federal: 1, Municipal: 2, Estadual 3
var listaParticipantesRenderizada=response.data.map(function(item){return{label:item.nome?item.nome:'RGPS',value:item.codigo,uf:item.uf,tipoRegimeProprio:item.tipoRegimeProprio,codigoOrgaoCentralizador:item.codigoOrgaoCentralizador,inOrgaoExtinto:item.inOrgaoExtinto,inOrgaoUniao:item.inOrgaoUniao,inOrgaoCentralizador:item.inOrgaoCentralizador};});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["i" /* salvaDestinatarios */](listaParticipantesRenderizada));};var buscaDestinatarios=function buscaDestinatarios(callback){doGet('participantes-compensacao',buscaDestinatariosSuccess,callback);};var successTiposDocumentos=function successTiposDocumentos(response){var tiposDocumentos=response.data.map(function(item){return{value:item.codigo,label:item.descricao,acordoAplicavel:item.acordoAplicavel,regimeAplicavel:item.regimeAplicavel,abrangenciaAplicavel:item.abrangenciaAplicavel,categoria:item.categoria};});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["A" /* salvaTiposDocumentos */](tiposDocumentos));};var requestTiposDocumentos=function requestTiposDocumentos(callback){doGet('tipos-documentos',successTiposDocumentos,callback);};var successExigencias=function successExigencias(response){var exigencias=response.data.map(function(item){return{value:item.tipo,label:item.acao,abrangenciaAplicavel:item.abrangenciaAplicavel,regimeAplicavel:item.regimeAplicavel,acordoAplicavel:item.acordoAplicavel};});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["k" /* salvaExigencias */](exigencias));};var requestExigencias=function requestExigencias(callback){doGet('exigencias',successExigencias,callback);};var successExigenciasRPPS=function successExigenciasRPPS(response){var exigencias=[];response.data.forEach(function(item){// if (item.regimeAplicavel === 2) {
exigencias.push({value:item.tipo,label:item.acao,abrangenciaAplicavel:item.abrangenciaAplicavel,regimeAplicavel:item.regimeAplicavel,proprietario:item.proprietario,acordoAplicavel:item.acordoAplicavel});// }
});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["k" /* salvaExigencias */](exigencias));};var requestExigenciasRPPS=function requestExigenciasRPPS(callback){doGet('exigencias',successExigenciasRPPS,callback);};var successValoresMediosBeneficios=function successValoresMediosBeneficios(response){var lista=[];var valor=void 0;if(response.data){response.data.forEach(function(item){if(item.valorMedioBeneficio){valor=item.valorMedioBeneficio.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3});}else{valor=0;valor=valor.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3});}lista.push({competencia:item.dataCompetencia,valorMedioBeneficio:valor,exibirBotaoAlteracao:item.exibirBotaoAlteracao});});}__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["B" /* salvaValoresMediosBeneficios */](lista));};var requestValoresMediosBeneficios=function requestValoresMediosBeneficios(callback,paramCompetencia){doGet('valores-medios-beneficios',successValoresMediosBeneficios,callback,{competencia:paramCompetencia});};var successMotivos=function successMotivos(response){var motivosIndeferimento=[];var motivosSuspensao=[];var motivosCessacao=[];var motivosNaoCumprimento=[];var motivosRejeicao=[];response.data.forEach(function(item){if(item.tipoMotivo===1){motivosIndeferimento.push({value:item.codigo,label:item.descricao,acordoAplicavel:item.acordoAplicavel,abrangenciaAplicavel:item.abrangenciaAplicavel,regimeAplicavel:item.regimeAplicavel});}if(item.tipoMotivo===2){motivosSuspensao.push({value:item.codigo,label:item.descricao,acordoAplicavel:item.acordoAplicavel,abrangenciaAplicavel:item.abrangenciaAplicavel,regimeAplicavel:item.regimeAplicavel});}if(item.tipoMotivo===3){motivosCessacao.push({value:item.codigo,label:item.descricao,acordoAplicavel:item.acordoAplicavel,abrangenciaAplicavel:item.abrangenciaAplicavel,regimeAplicavel:item.regimeAplicavel});}if(item.tipoMotivo===4){motivosNaoCumprimento.push({value:item.codigo,label:item.descricao,acordoAplicavel:item.acordoAplicavel,abrangenciaAplicavel:item.abrangenciaAplicavel,regimeAplicavel:item.regimeAplicavel});}if(item.tipoMotivo===5){motivosRejeicao.push({value:item.codigo,label:item.descricao,acordoAplicavel:item.acordoAplicavel,abrangenciaAplicavel:item.abrangenciaAplicavel,regimeAplicavel:item.regimeAplicavel});}});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["s" /* salvaMotivosIndeferimento */](motivosIndeferimento));__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["w" /* salvaMotivosSuspensao */](motivosSuspensao));__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["n" /* salvaMotivosCessacao */](motivosCessacao));__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["u" /* salvaMotivosNaoCumprimento */](motivosNaoCumprimento));__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["v" /* salvaMotivosRejeicao */](motivosRejeicao));};var requestMotivos=function requestMotivos(callback){doGet('motivos',successMotivos,callback);};var successMotivosCessacaoRequerimentoAposentadoria=function successMotivosCessacaoRequerimentoAposentadoria(response,paramTipoBeneficio){var motivosCessacao=[];if(paramTipoBeneficio!==3){response.data.forEach(function(item){if(item.codigo!==24){motivosCessacao.push({value:item.codigo,label:item.descricao,acordoAplicavel:item.acordoAplicavel,regimeAplicavel:item.regimeAplicavel,abrangenciaAplicavel:item.abrangenciaAplicavel,tipoMotivo:item.tipoMotivo});}});}else{response.data.forEach(function(item){motivosCessacao.push({value:item.codigo,label:item.descricao,acordoAplicavel:item.acordoAplicavel,regimeAplicavel:item.regimeAplicavel,abrangenciaAplicavel:item.abrangenciaAplicavel,tipoMotivo:item.tipoMotivo});});}__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["q" /* salvaMotivosCessacaoRequerimentoAposentadoria */](motivosCessacao));};var requestMotivosCessacaoRequerimentoAposentadoria=function requestMotivosCessacaoRequerimentoAposentadoria(callback,paramAplicacao,paramTipoMotivo,paramTipoBeneficio){doGetListaMotivosCessacaoAposentadoria('motivos-cessacao',paramTipoBeneficio,successMotivosCessacaoRequerimentoAposentadoria,callback,{aplicacao:paramAplicacao,tipoMotivo:paramTipoMotivo});};var successMotivosCessacaoRequerimentoPensao=function successMotivosCessacaoRequerimentoPensao(response){var motivosCessacao=[];response.data.forEach(function(item){motivosCessacao.push({value:item.codigo,label:item.descricao,acordoAplicavel:item.acordoAplicavel,regimeAplicavel:item.regimeAplicavel,abrangenciaAplicavel:item.abrangenciaAplicavel,tipoMotivo:item.tipoMotivo});});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["r" /* salvaMotivosCessacaoRequerimentoPensao */](motivosCessacao));};var requestMotivosCessacaoRequerimentoPensao=function requestMotivosCessacaoRequerimentoPensao(callback,paramAplicacao,paramTipoMotivo){doGet('motivos-cessacao',successMotivosCessacaoRequerimentoPensao,callback,{aplicacao:paramAplicacao,tipoMotivo:paramTipoMotivo});};var successMotivosCessacaoDependente=function successMotivosCessacaoDependente(response){var motivosCessacao=[];response.data.forEach(function(item){motivosCessacao.push({value:item.codigo,label:item.descricao,acordoAplicavel:item.acordoAplicavel,regimeAplicavel:item.regimeAplicavel,abrangenciaAplicavel:item.abrangenciaAplicavel,tipoMotivo:item.tipoMotivo});});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["o" /* salvaMotivosCessacaoDependente */](motivosCessacao));};var requestMotivosCessacaoDependente=function requestMotivosCessacaoDependente(callback,paramAplicacao,paramTipoMotivo){doGet('motivos-cessacao',successMotivosCessacaoDependente,callback,{aplicacao:paramAplicacao,tipoMotivo:paramTipoMotivo});};var successPeriodosVigencia=function successPeriodosVigencia(response){var periodosVigencia=response.data.map(function(item){return{cnpj:item.cnpj,// cnpj: item.cnpj.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5'),
dataCriacaoRpps:item.dataCriacaoRpps,dataEncerramentoRpps:item.dataEncerramentoRpps,periodoFinalizado:item.periodoFinalizado};});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["z" /* salvaPeriodosVigencia */](periodosVigencia));};var requestPeriodosVigencia=function requestPeriodosVigencia(callback,codigo){doGet('regimes-proprios/'+codigo,successPeriodosVigencia,callback);};var requestApagaPeriodosVigencia=function requestApagaPeriodosVigencia(){var colecaoVazia=[];__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["d" /* apagaPeriodosVigencia */](colecaoVazia));};var solicitarCompetenciaAberta=function solicitarCompetenciaAberta(){doGet('fechamento-pagamentos/pagamento-aberto',function(response){return __WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["f" /* salvaCompetenciaAberta */](response.data));});};var solicitarEntesControlados=function solicitarEntesControlados(id,success,error){doGet('participantes-compensacao/listacentralizados/'+id,success,error);};var solicitarParticipante=function solicitarParticipante(cnpj,success,error){doGet('participantes-compensacao/'+cnpj,success,error);};var successOrgaosCentralizados=function successOrgaosCentralizados(response){var orgaosCentralizados=[];if(response.data.centralizados&&response.data.centralizados.length>0){orgaosCentralizados=response.data.centralizados.map(function(item){return{codigo:item.codigo,nome:item.nome,extinto:item.inOrgaoExtinto};});}__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["y" /* salvaOrgaosCentralizados */](orgaosCentralizados));};var requestOrgaosCentralizados=function requestOrgaosCentralizados(callback,codigo){doGet('participantes-compensacao/listacentralizados/'+codigo,successOrgaosCentralizados,callback);};var solicitarHabilitarQualificacao=function solicitarHabilitarQualificacao(){doGet('config/frontend',function(response){return __WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["h" /* salvaConfiguracoesDeFrontend */](response.data));});};// const successSolicitarHabilitarQualificacao = (response) => {
//   const retorno = {
//     exibirLinkPesquisaPendenciasAPagar: response.data.exibirLinkPesquisaPendenciasAPagar,
//     exibirLinkPesquisaPendenciasAReceber: response.data.exibirLinkPesquisaPendenciasAReceber,
//     nomeParticipantePendencia: response.data.nomeParticipantePendencia,
//   };
//   store.dispatch(actions.salvaConfiguracoesDeFrontend(retorno));
// };   
// export const solicitarPendenciasPorEnteLogado = () => {
//   doGet('config/frontend-pendencias-por-ente', successSolicitarPendenciasPorEnteLogado);
// };
// const successSolicitarPendenciasPorEnteLogado = (response) => {
//   const retorno = {
//     exibirLinkPesquisaPendenciasAPagar: response.data.exibirLinkPesquisaPendenciasAPagar,
//     exibirLinkPesquisaPendenciasAReceber: response.data.exibirLinkPesquisaPendenciasAReceber,
//     nomeParticipantePendencia: response.data.nomeParticipantePendencia,
//   };
//   store.dispatch(actions.salvaSolicitarPendenciasPorEnteLogado(retorno));
// };
var successAbrangenciasEntidadeParticipanteRPPS=function successAbrangenciasEntidadeParticipanteRPPS(response){var abrangenciasEntidadeParticipanteRPPS=response.data.map(function(item){return{cnpj:item.cnpj,// cnpj: item.cnpj.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5'),
idParticipante:item.idParticipante,nomeOrgaoVinculado:item.nomeOrgaoVinculado,situacao:item.situacao};});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["e" /* salvaAbrangenciasEntPartRPPS */](abrangenciasEntidadeParticipanteRPPS));};var requestAbrangenciasEntidadeParticipanteRPPS=function requestAbrangenciasEntidadeParticipanteRPPS(callback,codigo){doGet('abrangencia-entidade-participante/'+codigo,successAbrangenciasEntidadeParticipanteRPPS,callback);};var requestApagaAbrangenciasEntidadeParticipanteRPPS=function requestApagaAbrangenciasEntidadeParticipanteRPPS(){var colecaoVazia=[];__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["a" /* apagaAbrangenciasEntidadeParticipanteRPPS */](colecaoVazia));};var salvarListaMensagens=function salvarListaMensagens(listaMensagemAlterada){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["C" /* salvarListaMensagens */](listaMensagemAlterada));};var requestSalvaFiltroBloqueio=function requestSalvaFiltroBloqueio(filtroBloqueio){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["m" /* salvaFiltroBloqueio */](filtroBloqueio));};var requestApagaFiltroBloqueio=function requestApagaFiltroBloqueio(){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["c" /* apagaFiltroBloqueio */](null));};var doPostComprovantes=function doPostComprovantes(url,body,successCallback,failCallback,config,tamanhoArquivo){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](true));var configComAuth={};var headersOpcionais={};if(config){headersOpcionais=config;}configComAuth={headers:Object.assign({Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()},headersOpcionais)};__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl+'/'+url,body,configComAuth).then(function(response){successCallback(response);}).catch(function(error){var erroServico=error;if(url==='documentos/comprovante'||url==='documentos/comprovante/tratamento'){if(erroServico.response.status===400||erroServico.response.status===500){if(tamanhoArquivo>__WEBPACK_IMPORTED_MODULE_5__utils_constants__["z" /* tamanhoMaximoArquivoUpload */]){erroServico.response.data.descricao='Certifique-se de que o documento possui tamanho inferior a 3 mb.';erroServico.response.data.mensagem='Houve um erro na tentativa de fazer a carga do documento.';}}}handleErrorMessages(erroServico||error,failCallback);}).then(function(){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["D" /* showLoading */](false));});};var doMultipartFormPostComprovantes=function doMultipartFormPostComprovantes(url,body,successCallback,failCallback){var config={'Content-Type':'multipart/form-data',Authorization:__WEBPACK_IMPORTED_MODULE_2__components_ComponentesAutenticacao_utils__["a" /* getAuthorizationHeader */]()};var formData=new FormData();var keys=Object.keys(body);var tamanhoArquivo=body.documento.size;keys.forEach(function(key){formData.set(key,body[key]);});doPostComprovantes(url,formData,successCallback,failCallback,config,tamanhoArquivo);};var requestSalvaComplementoTitulo=function requestSalvaComplementoTitulo(complementoTitulo){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["g" /* salvaComplementoTitulo */](complementoTitulo));};var requestApagaComplementoTitulo=function requestApagaComplementoTitulo(){__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["b" /* apagaComplementoTitulo */](null));};var criarComplementoLabelPorAbrangencia=function criarComplementoLabelPorAbrangencia(label,abrangencia){var complemento='';if(abrangencia!==null){switch(abrangencia){case 1:complemento='Aposentadoria';break;case 2:complemento='Pensão';break;case 3:complemento='Dependente';break;default:break;}}return label+' - '+complemento;};var successMotivosRelatorio=function successMotivosRelatorio(response){var motivosIndeferimento=[];var motivosSuspensao=[];var motivosCessacao=[];response.data.forEach(function(item){if(item.tipoMotivo===1){motivosIndeferimento.push({value:item.codigo,label:criarComplementoLabelPorAbrangencia(item.descricao,item.abrangenciaAplicavel)});}if(item.tipoMotivo===2){motivosSuspensao.push({value:item.codigo,label:criarComplementoLabelPorAbrangencia(item.descricao,item.abrangenciaAplicavel)});}if(item.tipoMotivo===3){motivosCessacao.push({value:item.codigo,label:criarComplementoLabelPorAbrangencia(item.descricao,item.abrangenciaAplicavel)});}});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["t" /* salvaMotivosIndeferimentoRelatorio */](motivosIndeferimento));__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["x" /* salvaMotivosSuspensaoRelatorio */](motivosSuspensao));__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["p" /* salvaMotivosCessacaoRelatorio */](motivosCessacao));};var requestMotivosRelatorio=function requestMotivosRelatorio(callback){doGet('motivos',successMotivosRelatorio,callback);};var successExigenciasRelatorio=function successExigenciasRelatorio(response){var exigencias=response.data.map(function(item){return{value:item.tipo,label:criarComplementoLabelPorAbrangencia(item.acao,item.abrangenciaAplicavel)};});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["l" /* salvaExigenciasRelatorio */](exigencias));};var requestExigenciasRelatorio=function requestExigenciasRelatorio(callback){doGet('exigencias',successExigenciasRelatorio,callback);};var buscaEstadosSimulacaoCompensacaoSuccess=function buscaEstadosSimulacaoCompensacaoSuccess(response){var estadosSimulacaoCompensacao=response.data.map(function(item){return{value:item.estado,label:item.nome};});__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_3__baseActions__["j" /* salvaEstadosSimulacaoCompensacaoSuccess */](estadosSimulacaoCompensacao));};var buscaEstadosSimulacaoCompensacao=function buscaEstadosSimulacaoCompensacao(callback,codigo){doGet('relatorios/simulacao-calculo/lista-estados-reqs-participante/'+codigo,buscaEstadosSimulacaoCompensacaoSuccess,callback);};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DtpInput_DtpInputText__ = __webpack_require__(279);
/* unused harmony reexport DtpInputText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DtpInput_DtpCheckbox__ = __webpack_require__(280);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__components_DtpInput_DtpCheckbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DtpInput_DtpSwitch__ = __webpack_require__(281);
/* unused harmony reexport DtpSwitch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DtpSelect_DtpSelect__ = __webpack_require__(282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_3__components_DtpSelect_DtpSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DtpInput_DtpOption__ = __webpack_require__(283);
/* unused harmony reexport DtpOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DtpInput_DtpRadio__ = __webpack_require__(284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_5__components_DtpInput_DtpRadio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DtpInput_DtpRadioGroup__ = __webpack_require__(285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_6__components_DtpInput_DtpRadioGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DtpInput_DtpSelectOneButton__ = __webpack_require__(286);
/* unused harmony reexport DtpSelectOneButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DtpInput_DtpOneButton__ = __webpack_require__(287);
/* unused harmony reexport DtpOneButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DtpInput_DtpManyButton__ = __webpack_require__(288);
/* unused harmony reexport DtpManyButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DtpInput_DtpSelectManyButton__ = __webpack_require__(289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_10__components_DtpInput_DtpSelectManyButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DtpInputMask_DtpInputMask__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_11__components_DtpInputMask_DtpInputMask__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_DtpAccordion_DtpAccordionGroup__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_12__components_DtpAccordion_DtpAccordionGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DtpAccordion_DtpAccordionPanel__ = __webpack_require__(292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__components_DtpAccordion_DtpAccordionPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_DtpCard_DtpCard__ = __webpack_require__(293);
/* unused harmony reexport DtpCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_DtpCard_DtpCardGroup__ = __webpack_require__(294);
/* unused harmony reexport DtpCardGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_DtpTab_DtpTab__ = __webpack_require__(295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_16__components_DtpTab_DtpTab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_DtpTab_DtpTabGroup__ = __webpack_require__(296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_17__components_DtpTab_DtpTabGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_DtpPanel_DtpPanel__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_18__components_DtpPanel_DtpPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_DtpButton_DtpButtonIcon__ = __webpack_require__(297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_19__components_DtpButton_DtpButtonIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_DtpInput_DtpInputGroup__ = __webpack_require__(298);
/* unused harmony reexport DtpInputGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_DtpButton_DtpButton__ = __webpack_require__(49);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_21__components_DtpButton_DtpButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_DtpButton_DtpButtonFab__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_22__components_DtpButton_DtpButtonFab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_DtpButton_DtpButtonFabMini__ = __webpack_require__(299);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_23__components_DtpButton_DtpButtonFabMini__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_DtpButton_DtpButtonFlat__ = __webpack_require__(63);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_24__components_DtpButton_DtpButtonFlat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_DtpMenu_DtpMenu__ = __webpack_require__(300);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_25__components_DtpMenu_DtpMenu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_DtpMenu_DtpMenuItem__ = __webpack_require__(301);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_26__components_DtpMenu_DtpMenuItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_DtpMenu_DtpMenuDropdown__ = __webpack_require__(302);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_27__components_DtpMenu_DtpMenuDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_DtpPageHeader_DtpPageHeader__ = __webpack_require__(303);
/* unused harmony reexport DtpPageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_DtpContent_DtpContent__ = __webpack_require__(304);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_29__components_DtpContent_DtpContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_DtpContentContainer_DtpContentContainer__ = __webpack_require__(305);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_30__components_DtpContentContainer_DtpContentContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_DtpHeader_DtpHeader__ = __webpack_require__(308);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_31__components_DtpHeader_DtpHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_DtpFooter_DtpFooter__ = __webpack_require__(312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_32__components_DtpFooter_DtpFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_DtpSnackbar_DtpSnackbar__ = __webpack_require__(313);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_33__components_DtpSnackbar_DtpSnackbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_DtpPopover_DtpPopover__ = __webpack_require__(315);
/* unused harmony reexport DtpPopover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_DtpProgress_DtpProgress__ = __webpack_require__(330);
/* unused harmony reexport DtpProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_DtpSpinner_DtpSpinner__ = __webpack_require__(331);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_36__components_DtpSpinner_DtpSpinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_DtpNoContent_DtpNoContent__ = __webpack_require__(333);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_37__components_DtpNoContent_DtpNoContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_DtpDataGrid_DtpDataGrid__ = __webpack_require__(334);
/* unused harmony reexport DtpDataGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_DtpDataGrid_DtpDataGridColumnItem__ = __webpack_require__(335);
/* unused harmony reexport DtpDataGridColumnItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_DtpDataGrid_DtpDataGridRow__ = __webpack_require__(336);
/* unused harmony reexport DtpDataGridRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_DtpDataGrid_DtpDataGridRowCollection__ = __webpack_require__(337);
/* unused harmony reexport DtpDataGridRowCollection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_DtpListLink_DtpListLink__ = __webpack_require__(338);
/* unused harmony reexport DtpListLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_DtpListLink_DtpListLinkItem__ = __webpack_require__(144);
/* unused harmony reexport DtpListLinkItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_DtpForm_DtpFormGroup__ = __webpack_require__(339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_44__components_DtpForm_DtpFormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_DtpForm_DtpControlLabel__ = __webpack_require__(341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_45__components_DtpForm_DtpControlLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_DtpForm_DtpFormControl__ = __webpack_require__(62);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_46__components_DtpForm_DtpFormControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_DtpForm_DtpFormControlFeedback__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_47__components_DtpForm_DtpFormControlFeedback__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_DtpForm_DtpHelpBlock__ = __webpack_require__(342);
/* unused harmony reexport DtpHelpBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_DtpSlider_DtpSlider__ = __webpack_require__(343);
/* unused harmony reexport DtpSlider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_DtpWizard_DtpWizard__ = __webpack_require__(109);
/* unused harmony reexport DtpWizard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_DtpTitle_DtpTitle__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_51__components_DtpTitle_DtpTitle__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_DtpDivider_DtpDivider__ = __webpack_require__(431);
/* unused harmony reexport DtpDivider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_DtpTooltip_DtpTooltip__ = __webpack_require__(432);
/* unused harmony reexport DtpTooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_DtpTable_DtpTable__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_54__components_DtpTable_DtpTable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_DtpTable_DtpTableHeader__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_55__components_DtpTable_DtpTableHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_DtpModal_DtpModal__ = __webpack_require__(475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_56__components_DtpModal_DtpModal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_DtpDatepicker_DtpDatepicker__ = __webpack_require__(491);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_57__components_DtpDatepicker_DtpDatepicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_DtpFileUpload_DtpFileUpload__ = __webpack_require__(496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_58__components_DtpFileUpload_DtpFileUpload__["a"]; });




























































/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return parecerMedico; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return sexo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return tipoRequerimento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return tipoAposentadoriaRGPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return tipoAposentadoriaRPPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return tipoRegime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return tipoEntidade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return tipoEntidadeControlePagamento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return tipoEntidadeControlePagamentoRGPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return tipoEntidadeSimulacaoCompensacao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return tipoEntidadeDebitosPendentes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return visoesSimulacaoCompensacao; });
/* unused harmony export tipoEntidadeControleDebitosPendentes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return estadoCivil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return vinculo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return capacidade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return motivoInclusao; });
/* unused harmony export destinatarios */
/* unused harmony export tiposDocumento */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return tiposEstado; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return tiposEstadoParecerMedico; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return linhasPorPagina; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return tiposEstadoAnalise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return resultadoAnalise; });
/* unused harmony export motivoSuspensao */
/* unused harmony export motivoIndeferimentoAposentadoria */
/* unused harmony export exigencia */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return tipoParticipacao; });
/* unused harmony export opcaoFiltroPesquisaRelatorio */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return opcaoFiltroTipoParticipacao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return tipoParticipacaoConflitosPeriodos; });
/* unused harmony export atributoOrdenacao */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return tipoRequerimentoFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return tipoAtendimentoExigencia; });
/* unused harmony export beneficioAtivoSimNao */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fonteCessacaoAposentadoria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fonteCessacaoPensao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return pensaoSemDependentesAtivos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return motivosBloqueio; });
/* unused harmony export operacoesGetFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return filaGetFilter; });
/* unused harmony export operacoesGet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return operacoesStatusGet; });
/* unused harmony export operacoesOrigemGet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return prismaFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return situacaoOrgaoVinculado; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return tiposAuditoria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return regrasDeCalculo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convenioComprev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return visoesControlePagamento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return visoesPendenciasRGPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return estadosPagamento; });
/* unused harmony export estadosSimulacaoCompensacao */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return estadosDebitosPendentes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return estadosPendenciasRGPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return estadosPendenciasRPPSaPagar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return estadosPendenciasRPPSaReceber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return pendenteEnvio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return tiposMensagem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return tipoSituacaoGRUControlePagamento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getObject; });
/* unused harmony export getObjectByIndex */
/* unused harmony export tipoCtc */
/* unused harmony export tipoAfastamento */
/* unused harmony export tipoTempoEspecial */
/* unused harmony export ufs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return tiposProRataInicial; });
/* unused harmony export situacaoCTC */
/* unused harmony export meses */
/* unused harmony export moedas */
/* unused harmony export periodosMoedasBrasileiras */
/* unused harmony export anosPorAba */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return tiposSegregacoesDeMassa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return estadoConflito; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return estadoConflitoSimplificado; });
var parecerMedico=[{value:true,label:'Sim'},{value:false,label:'Não'}];var sexo=[{value:1,label:'Masculino'},{value:3,label:'Feminino'}];var tipoRequerimento=[{value:1,label:'Aposentadoria'},{value:2,label:'Pensão'}];var tipoAposentadoriaRGPS=[{value:1,label:'Tempo de Contribuição'},{value:2,label:'Idade'},{value:3,label:'Invalidez'},{value:4,label:'Especial'},{value:5,label:'Tempo de Contribuição Professor'},{value:6,label:'Compulsória'}];var tipoAposentadoriaRPPS=[{value:1,label:'Tempo de Contribuição'},{value:2,label:'Idade'},{value:3,label:'Invalidez'},{value:4,label:'Especial'},{value:5,label:'Tempo de Contribuição Professor'},{value:6,label:'Compulsória'}];var tipoRegime=[{value:1,label:'RGPS'},{value:2,label:'RPPS'}];var tipoEntidade=[{value:1,label:'Federal'},{value:2,label:'Municipal'},{value:3,label:'Estadual'}];var tipoEntidadeControlePagamento=[{value:1,label:'Federal'},{value:2,label:'Municipal'},{value:3,label:'Estadual'},{value:'01000',label:'RGPS'}];var tipoEntidadeControlePagamentoRGPS=[{value:1,label:'Federal'},{value:2,label:'Municipal'},{value:3,label:'Estadual'}];var tipoEntidadeSimulacaoCompensacao=[{value:1,label:'Federal'},{value:2,label:'Municipal'},{value:3,label:'Estadual'},{value:'01000',label:'RGPS'}];var tipoEntidadeDebitosPendentes=[{value:2,label:'Municipal'},{value:3,label:'Estadual'}];var visoesSimulacaoCompensacao=[{value:1,label:'Simulação de Valores a Receber'},{value:2,label:'Simulação de Valores a Pagar'}];var tipoEntidadeControleDebitosPendentes=[{value:2,label:'Municipal'},{value:3,label:'Estadual'}];var estadoCivil=[{value:1,label:'Solteiro'},{value:2,label:'Casado'},{value:3,label:'Viúvo'},{value:4,label:'Separado judicialmente'},{value:5,label:'Divorciado'}];var vinculo=[{value:1,label:'Cônjuge'},{value:2,label:'Filho'},{value:3,label:'Pai/mãe'},{value:4,label:'Irmão'},{value:5,label:'Designado'},{value:6,label:'Companheiro'},{value:7,label:'Ex-cônjuge/companheiro(a)'},{value:8,label:'Filho adotivo ou menor sob guarda'},{value:9,label:'Dependente judicial'},{value:10,label:'Enteado'},{value:11,label:'Companheiro(a) separado de fato'}];var capacidade=[{value:1,label:'Válido/capaz'},{value:3,label:'Inválido/incapaz'},{value:5,label:'Inválido/capaz'},{value:7,label:'Válido/incapaz'}];var motivoInclusao=[{value:1,label:'Filho póstumo'},{value:2,label:'Decisão judicial'}];var destinatarios=[{value:'11000',label:'Estado de São Paulo'},{value:'05045',label:'Município de Fortaleza'},{value:'01000',label:'RGPS'},{value:'17064',label:'São Paulo'},{value:'17018',label:'Engenheiro P. de Frontin'}];var tiposDocumento=[{value:1,label:'Certidão de tempo de Contribuição'},{value:2,label:'Homologação do Tribunal de Contas'},{value:3,label:'Laudo médico'},{value:4,label:'Documento identificação'},{value:5,label:'Documento identificação NIT'}];var tiposEstado=[{value:1,label:'Criado'},{value:2,label:'Em exigência'},{value:3,label:'Alterado'},{value:4,label:'Aguardando Análise'},{value:5,label:'Aguardando análise do médico perito'},{value:6,label:'Em análise'},{value:7,label:'Em análise pelo médico perito'},{value:8,label:'Deferido'},{value:9,label:'Indeferido'},{value:10,label:'Análise Suspensa'},{value:11,label:'Em Compensação'},{value:12,label:'Compensado'},{value:13,label:'Aguardando compensação da aposentadoria'},{value:14,label:'Rejeitado'},{value:15,label:'Exigência/Indeferido'},{value:16,label:'Indeferido Ratificado'},{value:17,label:'Criado rejeitado'},{value:18,label:'Em conflito de período'}];var tiposEstadoParecerMedico=[{value:5,label:'Aguardando análise do médico perito'},{value:7,label:'Em análise pelo médico perito'}];var linhasPorPagina=[{text:'10',value:10},{text:'20',value:20},{text:'30',value:30}];var tiposEstadoAnalise=[{value:4,label:'Aguardando Análise'},{value:6,label:'Em análise'},{value:10,label:'Análise Suspensa'}];var resultadoAnalise=[{value:2,label:'Criar exigência(s)'},{value:8,label:'Deferir'},{value:9,label:'Indeferir'},{value:10,label:'Suspender análise'}];var motivoSuspensao=[{value:1,label:'Aguardando Processo'},{value:2,label:'Aguardando Parecer'}];var motivoIndeferimentoAposentadoria=[{value:3,label:'CTC não atende a portaria 154'},{value:4,label:'CTC destinada a outro Regime'},{value:5,label:'CTC emitida por outro Regime'},{value:6,label:'Tempo de contribuição já utilizado em benefício'},{value:7,label:'Aposentadoria não passível de compensação'},{value:8,label:'Doença isenta de carência'}];var exigencia=[{value:1,label:'Anexar um documento de identificação com CPF'},{value:2,label:'Alterar a data de nascimento informada no requerimento ou anexar um documento de identificação com a data de nascimento informada'},{value:3,label:'Alterar o NIT informado no requerimento ou anexar um documento de identificação com o NIT informado'},{value:4,label:'Alterar sexo informado no requerimento ou anexar um documento de identificação com o sexo informado'},{value:5,label:'Anexar Certidão de Tempo de Contribuição'},{value:6,label:'Anexar a Homologação do Tribunal de Contas'},{value:7,label:'Anexar o Laudo Médico'},{value:8,label:'Alterar data de início de benefício de pensão'},{value:9,label:'Alterar renda mensal inicial de pensão'},{value:10,label:'Incluir dependente'},{value:11,label:'Excluir dependente'},{value:12,label:'Alterar CPF do dependente'},{value:13,label:'Alterar nome da mãe do dependente'},{value:14,label:'Alterar sexo do dependente'},{value:15,label:'Alterar estado civil do dependente'},{value:16,label:'Alterar vínculo do dependente'},{value:17,label:'Alterar capacidade do dependente'},{value:18,label:'Alterar tipo de aposentadoria'},{value:19,label:'Alterar data de início de benefício de aposentadoria'},{value:20,label:'Alterar tempo de contribuição total em dias'},{value:21,label:'Alterar tempo de contribuição do regime origem em dias'},{value:22,label:'Alterar renda mensal inicial de aposentadoria'}];var tipoParticipacao=[{value:1,label:'Solicitante'},{value:2,label:'Destinatário'}];var opcaoFiltroPesquisaRelatorio=[{value:1,label:'Por entidade'},{value:2,label:'Por visão'}];var opcaoFiltroTipoParticipacao=[{value:1,label:'Ambos'},{value:2,label:'Solicitante'},{value:3,label:'Destinatário'}];var tipoParticipacaoConflitosPeriodos=[{value:2,label:'Solicitante'},{value:3,label:'Destinatário'}];var atributoOrdenacao=[{value:'prazo-atendimento-exigencia',label:'Prazo de atendimento da exigência'},{value:'data-disponibilizacao-analise',label:'Data de disponibilização pra análise'}];var tipoRequerimentoFilter=[{value:null,label:'Todos'},{value:1,label:'Aposentadoria'},{value:2,label:'Pensão'}];var tipoAtendimentoExigencia=[{value:0,label:'Não atendida'},{value:1,label:'Atendida'},{value:2,label:'Rejeitada'}];var beneficioAtivoSimNao=[{value:1,label:'Sim'},{value:2,label:'Não'}];var fonteCessacaoAposentadoria=[{value:1,label:'Cálculo Idade'},{value:2,label:'RPPS'},{value:3,label:'SISOB'},{value:4,label:'SUB'},{value:5,label:'Ag. Gestora'},{value:7,label:'SIRC'},{value:6,label:'Outros'}];var fonteCessacaoPensao=[{value:1,label:'Cálculo Idade'},{value:2,label:'RPPS'},{value:4,label:'SUB'},{value:5,label:'Ag. Gestora'},{value:6,label:'Outros'}];var pensaoSemDependentesAtivos=[{value:22,label:'Pensão sem dependentes ativos'}];var motivosBloqueio=[{value:1,label:'CND'},{value:2,label:'Ordem Judicial'},{value:3,label:'Aluguel'},{value:4,label:'Contrato Dataprev'},{value:5,label:'Inadimplência'}];var operacoesGetFilter=[];var filaGetFilter=[];var operacoesGet=[{value:1,label:'Criar tarefa Get'},{value:2,label:'Criar subtarefa GET'},{value:3,label:'Retornar para pendente'},{value:4,label:'Cumprir Exigência'},{value:5,label:'Concluir'},{value:6,label:'Cancelar sem referência no Comprev'},{value:7,label:'Cancelar com referência no Comprev'}];var operacoesStatusGet=[{value:1,label:'Pronta para nova execução'},{value:2,label:'Concluída'},{value:3,label:'Falha de negócio'},{value:4,label:'Indisponibilidade ou falha técnica'}];var operacoesOrigemGet=[{value:1,label:'Transacional'},{value:2,label:'Procedure'},{value:3,label:'Batch'}];var prismaFilter=[{value:1,label:'CPF'},{value:2,label:'NIT'},{value:3,label:'NB'}];var situacaoOrgaoVinculado=[{value:1,label:'Cadastro Incorreto'}];var tiposAuditoria=[{value:1,label:'Valor Médio Benefício'},{value:2,label:'Bloqueio Desbloqueio de Ente Federativo'},{value:3,label:'Cessação Manual de Requerimento de Aposentadoria'},{value:4,label:'Cessação Manual de Requerimento de Pensão'},{value:5,label:'Cessação Manual de Dependente'},{value:6,label:'Entidade Participante Regime Próprio'},{value:7,label:'Orgão Vinculado'},{value:9,label:'Glosa de Dação'}];var regrasDeCalculo=[{value:1,label:'Integralidade'},{value:2,label:'Média'}];var convenioComprev=[{value:0,label:'Não'},{value:1,label:'Sim'}];var visoesControlePagamento=[{value:1,label:'Valores a receber'},{value:2,label:'Valores a pagar'}];var visoesPendenciasRGPS=[{value:1,label:'Valores a receber'}];var estadosPagamento=[{value:1,label:'Em Aberto'},{value:2,label:'Em processamento'},{value:3,label:'Contestado'},{value:4,label:'Aguardando análise'},{value:5,label:'Pago'},{value:6,label:'Rejeitado'},{value:7,label:'Não Pago'},{value:8,label:'Não Monitorado'},{value:9,label:'Aguardando análise da defesa da regularidade do pagamento'},{value:10,label:'Aguardando análise da defesa da GRU'},{value:11,label:'Aguardando análise da defesa extraordinária'},{value:12,label:'Contestação extraordinária'}];var estadosSimulacaoCompensacao=[{value:1,label:'Em Aberto'},{value:2,label:'Em processamento'},{value:3,label:'Contestado'},{value:4,label:'Aguardando análise'},{value:5,label:'Pago'},{value:6,label:'Rejeitado'},{value:7,label:'Não Pago'},{value:8,label:'Não Monitorado'}];var estadosDebitosPendentes=[{value:2,label:'Em processamento'},{value:5,label:'Pago'},{value:7,label:'Não Pago'},{value:9,label:'Aguardando análise da defesa da regularidade do pagamento'},{value:10,label:'Aguardando análise da defesa da GRU'}];var estadosPendenciasRGPS=[{value:2,label:'Em processamento'},{value:7,label:'Não Pago'},{value:9,label:'Aguardando análise da defesa da regularidade do pagamento'},{value:10,label:'Aguardando análise da defesa da GRU'}];var estadosPendenciasRPPSaPagar=[{value:3,label:'Contestado'},{value:7,label:'Não Pago'},{value:12,label:'Contestação extraordinária'}];var estadosPendenciasRPPSaReceber=[{value:4,label:'Aguardando análise'},{value:11,label:'Aguardando análise da defesa extraordinária'}];var pendenteEnvio=[{value:0,label:'0'},{value:1,label:'1'}];var tiposMensagem=[{value:1,label:'1 - Nenhum valor recebido'},{value:2,label:'2 - Valor recebido incorreto'},{value:3,label:'3 - Valor pago corretamente dentro do vencimento'},{value:4,label:'4 - Valor pago em atraso ou pago incorretamente'},{value:5,label:'5 - Pagamento rejeitado por divergencia de conta corrente'},{value:6,label:'6 - Pagamento Aprovado'},{value:7,label:'7 - Confirmação do pagamento rejeitado por divergência de contas'},{value:8,label:'8 - Pagamento reprovado em definitivo'},{value:9,label:'9 - Defesa de regularidade do pagamento'},{value:10,label:'10 - Defesa aprovada integralmente / Defesa aprovada com revisão de valor'},{value:11,label:'11 - Defesa reprovada'},{value:12,label:'12 - Comprovação de pagamento da GRU'},{value:13,label:'13 - Pagamento da GRU aprovado'},{value:14,label:'14 - Pagamento da GRU reprovado'},{value:15,label:'15 - Defesa extraordinária'},{value:16,label:'16 - Contestação extraordinária'}];var tipoSituacaoGRUControlePagamento=[{value:1,label:'Em processamento'},{value:2,label:'Pago'},{value:3,label:'Não pago'}];var getObject=function getObject(lista,value){var objeto=lista.filter(function(obj){return obj.value===value;});return objeto[0];};var getObjectByIndex=function getObjectByIndex(lista,value){var objeto=lista.filter(function(obj){return obj.index===value;});return objeto[0];};var tipoCtc=[{value:1,label:'Normal'},{value:2,label:'Judicial'},{value:3,label:'Recursal'}];var tipoAfastamento=[{value:1,label:'Falta'},{value:2,label:'Licença'},{value:3,label:'Licença sem contribuição'},{value:4,label:'Suspensão'},{value:5,label:'Disponibilidade'},{value:6,label:'Outros'}];var tipoTempoEspecial=[{value:1,label:'Segurado com deficiência grave'},{value:2,label:'Segurado com deficiência moderada'},{value:3,label:'Segurado com deficiência leve'},{value:4,label:'Policial, agente penitenciário ou agente socioeducativo'},{value:5,label:'Atividade especial 25 anos'},{value:6,label:'Atividade especial 20 anos'},{value:7,label:'Atividade especial 15 anos'},{value:8,label:'Professor do ensino infantil, fundamental e médio'}];var ufs=[{value:'AC',label:'ACRE'},{value:'AL',label:'ALAGOAS'},{value:'AP',label:'AMAPA'},{value:'AM',label:'AMAZONAS'},{value:'BA',label:'BAHIA'},{value:'CE',label:'CEARA'},{value:'DF',label:'DISTRITO FEDERAL'},{value:'ES',label:'ESPIRITO SANTO'},{value:'GO',label:'GOIAS'},{value:'MA',label:'MARANHAO'},{value:'MT',label:'MATO GROSSO'},{value:'MS',label:'MATO GROSSO DO SUL'},{value:'MG',label:'MINAS GERAIS'},{value:'PA',label:'PARA'},{value:'PB',label:'PARAIBA'},{value:'PR',label:'PARANA'},{value:'PE',label:'PERNAMBUCO'},{value:'PI',label:'PIAUI'},{value:'RJ',label:'RIO DE JANEIRO (ESTADO)'},{value:'RN',label:'RIO GRANDE DO NORTE'},{value:'RS',label:'RIO GRANDE DO SUL'},{value:'RO',label:'RONDONIA'},{value:'RR',label:'RORAIMA'},{value:'SC',label:'SANTA CATARINA'},{value:'SP',label:'SAO PAULO (ESTADO)'},{value:'SE',label:'SERGIPE'},{value:'TO',label:'TOCANTINS'}];var tiposProRataInicial=[{value:1,label:'RMI do Instituidor'},{value:2,label:'RMI Simulada'},{value:3,label:'Salário Minimo'},{value:4,label:'Media de Benefícios RGPS'}];var situacaoCTC=[{value:1,label:'Ativa / Rascunho'},{value:0,label:'Inativa'}];var meses=[// { value: 0, label: 'Jan', labelCompleto: 'Janeiro' },
// { value: 1, label: 'Fev', labelCompleto: 'Fevereiro' },
// { value: 2, label: 'Mar', labelCompleto: 'Março' },
// { value: 3, label: 'Abr', labelCompleto: 'Abril' },
// { value: 4, label: 'Mai', labelCompleto: 'Maio' },
// { value: 5, label: 'Jun', labelCompleto: 'Junho' },
// { value: 6, label: 'Jul', labelCompleto: 'Julho' },
// { value: 7, label: 'Ago', labelCompleto: 'Agosto' },
// { value: 8, label: 'Set', labelCompleto: 'Setembro' },
// { value: 9, label: 'Out', labelCompleto: 'Outubro' },
// { value: 10, label: 'Nov', labelCompleto: 'Novembro' },
// { value: 11, label: 'Dez', labelCompleto: 'Dezembro' },
// { value: 12, label: '13º', labelCompleto: 'Décimo terceiro salário' },
// { value: 1, label: 'Jan', labelCompleto: 'Janeiro' },
// { value: 2, label: 'Fev', labelCompleto: 'Fevereiro' },
// { value: 3, label: 'Mar', labelCompleto: 'Março' },
// { value: 4, label: 'Abr', labelCompleto: 'Abril' },
// { value: 5, label: 'Mai', labelCompleto: 'Maio' },
// { value: 6, label: 'Jun', labelCompleto: 'Junho' },
// { value: 7, label: 'Jul', labelCompleto: 'Julho' },
// { value: 8, label: 'Ago', labelCompleto: 'Agosto' },
// { value: 9, label: 'Set', labelCompleto: 'Setembro' },
// { value: 10, label: 'Out', labelCompleto: 'Outubro' },
// { value: 11, label: 'Nov', labelCompleto: 'Novembro' },
// { value: 12, label: 'Dez', labelCompleto: 'Dezembro' },
// { value: 13, label: '13º', labelCompleto: 'Décimo terceiro salário' },
{index:0,value:1,label:'Jan',labelCompleto:'Janeiro'},{index:1,value:2,label:'Fev',labelCompleto:'Fevereiro'},{index:2,value:3,label:'Mar',labelCompleto:'Março'},{index:3,value:4,label:'Abr',labelCompleto:'Abril'},{index:4,value:5,label:'Mai',labelCompleto:'Maio'},{index:5,value:6,label:'Jun',labelCompleto:'Junho'},{index:6,value:7,label:'Jul',labelCompleto:'Julho'},{index:7,value:8,label:'Ago',labelCompleto:'Agosto'},{index:8,value:9,label:'Set',labelCompleto:'Setembro'},{index:9,value:10,label:'Out',labelCompleto:'Outubro'},{index:10,value:11,label:'Nov',labelCompleto:'Novembro'},{index:11,value:12,label:'Dez',labelCompleto:'Dezembro'},{index:12,value:13,label:'13º',labelCompleto:'Décimo terceiro salário'}];var moedas=[{value:1,label:'RS$',descricao:'Mil Réis'},{value:2,label:'Cr$',descricao:'Cruzeiro'},{value:3,label:'NCr$',descricao:'Cruzeiro Novo'},{value:4,label:'Cr$',descricao:'Cruzeiro'},{value:5,label:'Cz$',descricao:'Cruzado'},{value:6,label:'NCz$',descricao:'Cruzado Novo'},{value:7,label:'Cr$',descricao:'Cruzeiro'},{value:8,label:'CR$',descricao:'Cruzeiro Real'},{value:9,label:'R$',descricao:'Real'}];var periodosMoedasBrasileiras=[// {
//   value: 1, sigla: 'RS$', descricao: 'Mil Réis', dataInicio: '07/09/1822', dataFim: '31/10/1942',
// },
// {
//   codigo: 2, sigla: 'Cr$', descricao: 'Cruzeiro', dataInicio: '01/11/1942', dataFim: '12/02/1967',
// },
// {
//   codigo: 3, sigla: 'NCr$', descricao: 'Cruzeiro Novo', dataInicio: '13/02/1967', dataFim: '14/05/1970',
// },
// {
//   codigo: 4, sigla: 'Cr$', descricao: 'Cruzeiro', dataInicio: '15/05/1970', dataFim: '27/02/1986',
// },
// {
//   codigo: 5, sigla: 'Cz$', descricao: 'Cruzado', dataInicio: '28/02/1986', dataFim: '15/01/1989',
// },
// {
//   codigo: 6, sigla: 'NCz$', descricao: 'Cruzado Novo', dataInicio: '16/01/1989', dataFim: '15/03/1990',
// },
// {
//   codigo: 7, sigla: 'Cr$', descricao: 'Cruzeiro', dataInicio: '16/03/1990', dataFim: '31/07/1993',
// },
// {
//   codigo: 8, sigla: 'CR$', descricao: 'Cruzeiro Real', dataInicio: '01/08/1993', dataFim: '30/06/1994',
// },
{codigo:9,sigla:'R$',descricao:'Real',dataInicio:'01/07/1994',dataFim:null}];var anosPorAba=[{value:6,label:'6'},{value:12,label:'12'},{value:18,label:'18'}];var tiposSegregacoesDeMassa=[{value:1,label:'Fundo Financeiro (Repartição)'},{value:2,label:'Fundo Previdenciário (Capitalização)'}];var estadoConflito=[{value:0,label:'Não Resolvido'},{value:1,label:'Resolvido, pois um dos requerimentos foi para um estado inválido (indeferido, rejeitado, criado rejeitado, indeferido ratificado)'},{value:2,label:'Resolvido, pois um dos requerimentos teve os períodos ajustados pelo Solicitante eliminando concomitâncias'},{value:3,label:'Resolvido, pois ambos requerimentos tiveram seus períodos aprovados pelo Regime de Origem'},{value:4,label:'Resolvido, pois houve alteração do destinatário do requerimento'},{value:5,label:'Resolvido, pois um dos requerimentos teve alteração de CPF pela Qualificação'},{value:6,label:'Resolvido, pois houve alteração da matrícula do requerimento'}];var estadoConflitoSimplificado=[{value:0,label:'Não Resolvido'},{value:1,label:'Resolvido'},{value:2,label:'Resolvido'},{value:3,label:'Resolvido'},{value:4,label:'Resolvido'},{value:5,label:'Resolvido'},{value:6,label:'Resolvido'}];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return obterMesDaCompetencia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return obterAnoDaCompetencia; });
/* unused harmony export formatarMoedaParaBackend */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return manterApenasFiltro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return habilitarUploadNaConsultaDoRequerimento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ehPapelObservadorRelatorio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ehPapelObservadorPagamento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return stringToData; });
/* unused harmony export stringToDateTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return adicionarQuantidadeAumaData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatarValor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatarCnpj; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var obterMesDaCompetencia=function obterMesDaCompetencia(competencia,split){return Number(competencia.split(split)[0]);};var obterAnoDaCompetencia=function obterAnoDaCompetencia(competencia,split){return Number(competencia.split(split)[1]);};var formatarMoedaParaBackend=function formatarMoedaParaBackend(valor){return parseFloat(valor.replace(/\./g,'').replace(',','.'));};var pad=function pad(n,width,z){var z1=z||'0';var n1=''+n;return n1.length>=width?n1:new Array(width-n1.length+1).join(z1)+n1;};var deveRemover=function deveRemover(keep,f){return!(f===keep||!f.startsWith('filtro'));};var manterApenasFiltro=function manterApenasFiltro(keep){// Remove todos os filtros, exceto "keep".
// Mantem objetos que não são filtros
var toRemove=Object.keys(sessionStorage).filter(function(f){return deveRemover(keep,f);});toRemove.forEach(function(f){return sessionStorage.removeItem(f);});};var habilitarUploadNaConsultaDoRequerimento=function habilitarUploadNaConsultaDoRequerimento(requerimento,acao,temBloqueioAtivoContratoDtp){var retorno=false;if(requerimento){var solicitanteRGPS=requerimento.solicitante&&requerimento.solicitante.codigo==='01000';if(solicitanteRGPS===undefined){solicitanteRGPS=false;}var solicitanteRPPS=requerimento.solicitante&&requerimento.solicitante.codigo!=='01000';if(solicitanteRPPS===undefined){solicitanteRPPS=false;}var isConsulta=['consulta'].includes(acao);var isEstadosHabilitados=[1,2,4,5,7,13].includes(requerimento.estado);var temBloqueio=false;if(temBloqueioAtivoContratoDtp!==null){temBloqueio=temBloqueioAtivoContratoDtp;}else{temBloqueio=false;}retorno=(solicitanteRGPS||solicitanteRPPS)&&isEstadosHabilitados&&isConsulta&&!temBloqueio;return retorno;}return retorno;};var ehPapelObservadorRelatorio=function ehPapelObservadorRelatorio(papelUsuarioLogado){return['auditor-comprev','analista-dtp','analista-sprev'].includes(papelUsuarioLogado);};var ehPapelObservadorPagamento=function ehPapelObservadorPagamento(papelUsuarioLogado){return['auditor-comprev','analista-dtp','analista-sprev'].includes(papelUsuarioLogado);};var stringToData=function stringToData(texto){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(texto,'DD/MM/YYYY').toDate();};var stringToDateTime=function stringToDateTime(texto){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(texto,'DD/MM/YYYY').toDate().getTime;};// https://momentjscom.readthedocs.io/en/latest/moment/03-manipulating/01-add/
var adicionarQuantidadeAumaData=function adicionarQuantidadeAumaData(data,quantidade,unidadeDeTempo){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(data).add(quantidade,unidadeDeTempo);};var formatarValor=function formatarValor(valor){var valorFormatado='0.0';if(valor!==undefined&&valor!==null){var formato={minimumFractionDigits:2,maximumFractionDigits:3,style:'currency',currency:'BRL'};if(valor===0||valor===''){return'R$ 0,00';}valorFormatado=valor.toLocaleString('pt-BR',formato);}return valorFormatado;};var formatarCnpj=function formatarCnpj(cnpj){if(!cnpj)return'';var cnpjLimpo=cnpj.replace(/[.\-/]/g,'');return cnpjLimpo.replace(/([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})/,'$1.$2.$3/$4-$5');};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return rolesCadastradas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return tiposExigenciaSistema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return estadosParaConsulta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return msgsConfirmacao; });
/* unused harmony export msgsConfirmacaoEnte */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return msgsconfirmacaoFechamentoPagamento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return msgsConfirmacaoBloqueio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return msgsConfirmacaoDesbloqueio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return msgsConfirmacaoCessacao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return msgsGlosaDeDacaoManual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return estadosRequerimento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return tamanhoMaximoArquivoUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return orgaoAtivo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return orgaoCentralizador; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return orgaoExtinto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return orgaoAtivoCentralizado; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alertaPesquisarDadosPessoais; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alertaPesquisarDadosBeneficio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return msgsConfirmacaoIndeferimento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return msgsConfirmacaoExclusaoDocumentoRequerimento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return msgsCalculadorConversorNumeroNegativo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return msgSubmeterReprocessamentoGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return msgConfirmacaoRequerimentosPeriodos; });
/* unused harmony export msgConfirmacaoRequerimentosPeriodosConcomitancia */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return msgCtcNaoEncontrada; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return msgReqAprovadoSemDataIngresso; });
/* unused harmony export msgConfirmacaoCtc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return msgRecalcularTempoRO; });
/* unused harmony export mensagensCtc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return msgConflitosPeriodos; });
var rolesCadastradas={'requerer-compensacao-rgps':'INSS@PAPEL_ANALISTA_RGPS','analisar-compensacao-rgps':'INSS@PAPEL_ANALISTA_RGPS','analisar-compensacao-rpps':'CNPJ@PAPEL_ANALISTA_RPPS','requerer-compensacao-rpps':'CNPJ@PAPEL_ANALISTA_RPPS','fornecer-parecer-medico-rgps':'INSS@PAPEL_MEDICO_PERITO_RGPS','fornecer-parecer-medico-rpps':'CNPJ@PAPEL_MEDICO_PERITO_RPPS','analisar-negocio-sprev':'MPS@PAPEL_ANALISTA_SPREV','gerenciar-negocio-dcomp':'INSS@PAPEL_GESTOR_DCOMP','consultar-compensacao-rpps':'CNPJ@PAPEL_RPPS_CONSULTA','consultar-compensacao-rgps':'INSS@PAPEL_RGPS_CONSULTA','auditar-comprev':'MPS@PAPEL_AUDITOR','analisar-negocio-dtpv':'DATAPREV@PAPEL_ANALISTA_DATAPREV','analisar-contrato-dtpv':'DATAPREV@PAPEL_CONTRATO_ANALISTA_DTP'};var getPermissions=function getPermissions(permissionsAllowed){return permissionsAllowed.map(function(permission){return rolesCadastradas[permission];});};var tiposExigenciaSistema=[1,5,6,17,38,39,40,41,72];var estadosParaConsulta={// Em exigencia: 2
exigencia:{acao:'cumprir-exigencia',campoOrdenacao:'prazo-atendimento-exigencia',estados:[2],tipoParticipacao:1},// Em exigencia: 2 com risco de prescricao
'prescricao-exigencia':{acao:'cumprir-exigencia',campoOrdenacao:'prazo-prescricao',estados:[2],tipoParticipacao:1},// Aguardando analise: 4, Em analise: 6, Analise Suspensa: 10
analise:{acao:'realizar-analise',campoOrdenacao:'data-disponibilizacao-analise',estados:[4,6,10],tipoParticipacao:2},// Aguardando analise: 5, Em analise: 7
'parecer-medico':{acao:'emitir-parecer-medico',estados:[5,7],tipoParticipacao:1},/* Em compensação: 11 */'cessacao-requerimento':{acao:'cessar-requerimento',estados:[11],tipoParticipacao:1},indeferido:{acao:'indeferidos',estados:[15],tipoParticipacao:1},'complementar-aposentadoria':{acao:'complementar-aposentadoria',// campoOrdenacao: 'data-disponibilizacao-analise',
estado:4,tipoParticipacao:1,// solicitante
tipoRequerimento:1}};var msgsConfirmacao={indeferimento:{descricao:'O Novo COMPREV possibilita a criação de exigências para correção do requerimento sem a necessidade de indeferi-lo. Confirma o indeferimento deste requerimento?'}};var msgsConfirmacaoEnte={rppsNaoEncontradoParaOEnte:{descricao:'Não existe regime próprio cadastrado para o ente escolhido. Deseja incluir um regime próprio?'}};var msgsconfirmacaoFechamentoPagamento={confirmacaoFechamentoPagamento:{descricao:'Confirma o fechamento do pagamento desta competência?'}};var msgsConfirmacaoBloqueio={bloqueio:{descricao:'Confirma o Bloqueio do Ente Federativo?'}};var msgsConfirmacaoDesbloqueio={desbloqueio:{descricao:'Confirma o desbloqueio do Ente Federativo?'}};var msgsConfirmacaoCessacao={cessacaoAposentadoria:{descricao:'Confirma a cessação do requerimento de aposentadoria?'},cessacaoPensao:{descricao:'Confirma a cessação do requerimento de pensão?'},cessacaoDependente:{descricao:'Confirma a cessação do dependente?'},cessacaoAmbos:{descricao:'Confirma a cessação do requerimento de pensão juntamente com o dependente?'}};var msgsGlosaDeDacaoManual={glosadeDacao:{descricao:'Confirma inclusão de glosa manual para o ente federativo?'},removerGlosadeDacao:{descricao:'Confirma exclusão da glosa para este Ente Federativo?'},alterarGlosadeDacao:{descricao:'Confirma a alteração da glosa?'}};var estadosRequerimento={CRIADO:1,EM_EXIGENCIA:2,ALTERADO:3,AGUARDANDO_ANALISE:4,AGUARDANDO_ANALISE_MEDICO:5,EM_ANALISE:6,EM_ANALISE_MEDICO:7,DEFERIDO:8,INDEFERIDO:9,ANALISE_SUSPENSA:10,EM_COMPENSACAO:11,COMPENSADO:12,AGUARDANDO_COMPENSACAO_APOSENTADORIA:13,REJEITADO:14,EXIGENCIA_INDEFERIDO:15,INDEFERIDO_RATIFICADO:16,CRIADO_REJEITADO:17,EM_CONFLITO_PERIODO:18};var tamanhoMaximoArquivoUpload=3145728;var orgaoAtivo='Ativo';var orgaoCentralizador='Centralizador';var orgaoExtinto='Extinto';var orgaoAtivoCentralizado='Ativo Centralizado';var alertaPesquisarDadosPessoais=[{descricao:'Obrigatório clicar no botão "Pesquisar" para atualizar os dados cadastrais do segurado.'}];var alertaPesquisarDadosBeneficio=[{descricao:'Obrigatório clicar no botão "Pesquisar Benefício" para atualizar os dados do benefício.'}];var msgsConfirmacaoIndeferimento={indeferimento:{descricao:'ATENÇÃO! Após confirmado o indeferimento, a ação será IRREVERSÍVEL!'},reaberturaIndeferimento:{descricao:'Confirma a reabertura do requerimento?'}};var msgsConfirmacaoExclusaoDocumentoRequerimento={exclusao:{descricao:'Confirma a exclusão do documento?'}};var msgsCalculadorConversorNumeroNegativo={aviso:{descricao:'Impossível calcular, resulta número negativo!'}};var msgSubmeterReprocessamentoGet={descricao:'Deseja realmente reprocessar o requerimento no GET ?'};var msgConfirmacaoRequerimentosPeriodos={descricao:'Foram encontrados períodos para a ctc informada, deseja substituir os períodos do requerimento pelos períodos constantes na CTC ?'};var msgConfirmacaoRequerimentosPeriodosConcomitancia={descricao:'Foram encontrados períodos concomitantes. Salvar mesmo assim ? Se salvar o Requerimento será gravado com o estado EM CONFLITO DE PERIODO'};var msgCtcNaoEncontrada={descricao:'A CTC para este CPF não foi encontrada. Recomenda-se a anexação do documento para fins de otimização na análise do requerimento.'};var msgReqAprovadoSemDataIngresso={descricao1:{texto1:'Já existe requerimento de compensação de aposentadoria para este CPF no estado "deferido" ou "em compensação" ou "compensado" sem data de ingresso.'},descricao2:{texto2:'Favor verificar para evitar possível concomitância de períodos.'}};var msgConfirmacaoCtc={apagarRascunhoCtc:{descricao:'Deseja realmente apagar o rascunho da CTC ?'},invalidarCtc:{descricao:'Deseja realmente invalidar a CTC ?'},preencherValoresAutomaticamente:{descricao:'Esta ação preencherá automaticamente os valores das remunerações referentes ao período exibido na aba. Deseja continuar ?'},periodoPossuiAlteracaoDeMoeda:{descricao:'Existe uma competência com o valor diferente das demais. Deseja continuar ?'},limparValoresAutomaticamente:{descricao:'Esta ação apagará automaticamente os valores das remunerações referentes ao período exibido na aba. Deseja continuar ?'}};var msgRecalcularTempoRO={descricaoComPeriodos:{descricao:'Ao desmarcar o indicador de alteração manual do tempo RO, o sistema irá recalcular o tempo RO com base nos períodos informados na tela. Deseja prosseguir?'},descricaoSemPeriodos:{descricao:'Ao desmarcar o indicador de alteração manual do tempo RO, o sistema irá retornar ao tempo de contribuição no regime de origem original. Deseja prosseguir?'}};// NÃO ESTÁ SENDO UTILIZADO
var mensagensCtc={ctcLimiteAtingidoParaCpf:{descricao:'Não é possível adicionar nova CTC. Limite de CTC para este CPF foi atingido.'},ctcNaoEPossivelCriarComRascunho:{descricao:'Não é possível adicionar nova CTC enquanto o rascunho não for salvo em definitivo.'},ctcRascunhoApagadoComSucesso:{descricao:'Rascunho da CTC apagado com sucesso.'},ctcNaoEPossivelExcluirRascunho:{descricao:'Não foi possível excluir o rascunho da CTC.'},ctcInvalidadaComSucesso:{descricao:'CTC invalidada com sucesso.'},ctcNaoEPossivelInvalidar:{descricao:'Não foi possível invalidar a CTC.'},ctcSemFiltroParaConsultarCpf:{descricao:'Escolha pelo menos um filtro de CPF para a consulta.'},ctcNaoFoiPossivelExecutarAConsulta:{descricao:'Não foi possível realizar a consulta.'},ctcContateOAdminDoSistema:{descricao:'Contate o administrador do sistema.'},ctcRascunhoInseridoComSucesso:{descricao:'Rascunho da CTC inserido com sucesso.'},ctcRascunhoAlteradoComSucesso:{descricao:'Rascunho da CTC alterado com sucesso.'},ctcRevisadaComSucesso:{descricao:'CTC revisada com sucesso.'},ctcInseridaComSucesso:{descricao:'CTC inserida com sucesso.'},ctcInformeCorretamenteOsAtributosIndicadosNaTela:{descricao:'Informe corretamente os atributos indicados na tela.'},ctcInformeCNPJValido:{descricao:'CNPJ Inválido. Informe um CNPJ válido.'},ctcPeriodoDataInicioMaiorQueDataFim:{descricao:'O período é inválido. A data de início de período deve ser menor que a data de fim do período.'},ctcPeriodoNaoMaiorQueDataAtual:{descricao:'O período é inválido. A data de fim de período não deve ser maior que a data atual.'},ctcAtividadeSemDestinatario:{descricao:'É necessário possuir pelo menos um destinatário cadastrado para incluir uma atividade.'},ctcQtdDiasLiquidoMaiorQueZero:{descricao:'O período é inválido. A quantidade de dias liquido deve ser maior que zero e menor que diferença entre a data de inicio e fim periodo.'},ctcPeriodoAtividadeAlteradoComSucesso:{descricao:'Período da atividade alterado com sucesso.'},ctcPeriodoAtividadeNaoPreenchido:{descricao:'É necessário preencher a data de início e a data de fim da atividade na aba "Dados Básicos"'},ctcPreenchimentoTempoLiquidoObrigatorio:{descricao:'Prenchimento do tempo líquido é obrigatório.'}};var msgConflitosPeriodos={reconhecimentoRequerimentoDeferidoComConflito:{descricao:'Reconheço que este requerimento está sendo deferido com conflito e atesto que os períodos estão corretos'}};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_text_mask_addons_dist_createAutoCorrectedDatePipe__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_text_mask_addons_dist_createAutoCorrectedDatePipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_text_mask_addons_dist_createAutoCorrectedDatePipe__);
var alfanum=/[A-Za-z0-9]/;var masks={cpf:[/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'-',/\d/,/\d/],cpfFiltroExigencia:[/\w/,/\w/,/\w/,'.',/\w/,/\w/,/\w/,'.',/\d/,/\d/,/\d/,'-',/\d/,/\d/],/*
  cnpj: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  */cnpj:[alfanum,alfanum,'.',alfanum,alfanum,alfanum,'.',alfanum,alfanum,alfanum,'/',alfanum,alfanum,alfanum,alfanum,'-',alfanum,alfanum],date:[/\d/,/\d/,'/',/\d/,/\d/,'/',/\d/,/\d/,/\d/,/\d/],nit:[/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'-',/\d/],competencia:[/\d/,/\d/,'/',/\d/,/\d/,/\d/,/\d/],cep:[/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/],telefoneMovel:['(',/\d/,/\d/,')',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],telefoneFixo:['(',/\d/,/\d/,')',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],compet:[/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],integer:__WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask___default()({prefix:'',suffix:'',includeThousandsSeparator:true,thousandsSeparatorSymbol:'.',allowDecimal:false}),currency:__WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask___default()({prefix:'',suffix:'',includeThousandsSeparator:true,thousandsSeparatorSymbol:'.',allowDecimal:true,decimalSymbol:',',decimalLimit:2}),participation:__WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask___default()({prefix:'',suffix:'',includeThousandsSeparator:false,thousandsSeparatorSymbol:'',allowDecimal:true,decimalSymbol:',',decimalLimit:8}),dateCorrect:__WEBPACK_IMPORTED_MODULE_1_text_mask_addons_dist_createAutoCorrectedDatePipe___default()('dd/mm/yyyy'),competenciaCorrect:__WEBPACK_IMPORTED_MODULE_1_text_mask_addons_dist_createAutoCorrectedDatePipe___default()('mm/yyyy')};/* harmony default export */ __webpack_exports__["a"] = (masks);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(230);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(190)(module)))

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var User=function(){function User(jwt){_classCallCheck(this,User);try{this.data=JSON.parse(atob(jwt.split('.')[1]));}catch(e){return false;}}_createClass(User,[{key:'papelJWT',value:function papelJWT(){var roleRaw=this.data.roles.filter(function(e){return e.startsWith('|PA|');})[0].split('|');var roleData={};for(var i=1;i<roleRaw.length;i+=2){roleData[roleRaw[i]]=roleRaw[i+1];}return roleData;}},{key:'cpf',value:function cpf(){return this.data.prevCpf;}},{key:'dominio',value:function dominio(){return this.papelJWT().TD;}},{key:'cnpjDoPapel',value:function cnpjDoPapel(){return this.papelJWT().D.split('#')[1];}},{key:'lotacao',value:function lotacao(){return this.data.lotacoes[0];}},{key:'lotacaoDoEmissor',value:function lotacaoDoEmissor(){return this.papelJWT().LE.split(',')[0].split('#')[1];}},{key:'mail',value:function mail(){return this.data.mail;}},{key:'nome',value:function nome(){return this.data.name;}},{key:'papel',value:function papel(){return this.papelJWT().PA;}},{key:'isUsuarioRGPS',value:function isUsuarioRGPS(){var papel=this.papel();var retorno=papel.split('@')[0];if(retorno==='INSS'){return true;}return false;}},{key:'regime',value:function regime(){return this.dominio()==='CNPJ'?'rpps':'rgps';}},{key:'isRPPS',value:function isRPPS(){return this.regime()==='rpps';}},{key:'isRGPS',value:function isRGPS(){return this.regime()==='rgps';}},{key:'codigosDeRegime',value:function codigosDeRegime(){if(this.isRGPS()){return[1,3];}return[2,3];}}],[{key:'logged',value:function logged(){if(localStorage.getItem('jwt')){return new User(localStorage.getItem('jwt'));}return null;}}]);return User;}();/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONST_VAR = {
  SORT_DESC: 'desc',
  SORT_ASC: 'asc',
  AWAIT_BEFORE_CELL_EDIT: 1,
  SIZE_PER_PAGE: 10,
  NEXT_PAGE: '>',
  NEXT_PAGE_TITLE: 'next page',
  LAST_PAGE: '>>',
  LAST_PAGE_TITLE: 'last page',
  PRE_PAGE: '<',
  PRE_PAGE_TITLE: 'previous page',
  FIRST_PAGE: '<<',
  FIRST_PAGE_TITLE: 'first page',
  PAGE_START_INDEX: 1,
  ROW_SELECT_BG_COLOR: '',
  ROW_SELECT_NONE: 'none',
  ROW_SELECT_SINGLE: 'radio',
  ROW_SELECT_MULTI: 'checkbox',
  CELL_EDIT_NONE: 'none',
  CELL_EDIT_CLICK: 'click',
  CELL_EDIT_DBCLICK: 'dbclick',
  SIZE_PER_PAGE_LIST: [10, 25, 30, 50],
  PAGINATION_SIZE: 5,
  PAGINATION_POS_TOP: 'top',
  PAGINATION_POS_BOTTOM: 'bottom',
  PAGINATION_POS_BOTH: 'both',
  TOOLBAR_POS_TOP: 'top',
  TOOLBAR_POS_BOTTOM: 'bottom',
  TOOLBAR_POS_BOTH: 'both',
  NO_DATA_TEXT: 'There is no data to display',
  SHOW_ONLY_SELECT: 'Show Selected Only',
  SHOW_ALL: 'Show All',
  EXPORT_CSV_TEXT: 'Export to CSV',
  INSERT_BTN_TEXT: 'New',
  DELETE_BTN_TEXT: 'Delete',
  SAVE_BTN_TEXT: 'Save',
  CLOSE_BTN_TEXT: 'Close',
  FILTER_DELAY: 500,
  SCROLL_TOP: 'Top',
  SCROLL_BOTTOM: 'Bottom',
  FILTER_TYPE: {
    TEXT: 'TextFilter',
    REGEX: 'RegexFilter',
    SELECT: 'SelectFilter',
    NUMBER: 'NumberFilter',
    DATE: 'DateFilter',
    CUSTOM: 'CustomFilter',
    ARRAY: 'ArrayFilter'
  },
  FILTER_COND_EQ: 'eq',
  FILTER_COND_LIKE: 'like',
  EXPAND_BY_ROW: 'row',
  EXPAND_BY_COL: 'column',
  REMOTE_SORT: 'sort',
  REMOTE_PAGE: 'pagination',
  REMOTE_CELL_EDIT: 'cellEdit',
  REMOTE_INSERT_ROW: 'insertRow',
  REMOTE_DROP_ROW: 'dropRow',
  REMOTE_FILTER: 'filter',
  REMOTE_SEARCH: 'search',
  REMOTE_EXPORT_CSV: 'exportCSV',
  INSERT_FAIL_INDICATOR: 'Validation errors, please check!',
  DEFAULT_CSV_SEPARATOR: ',',
  CSV_STRING_TYPE: 'string',
  CSV_NUMBER_TYPE: 'number',
  AUTO_COLLAPSE_WHEN_SORT: false,
  AUTO_COLLAPSE_WHEN_SEARCH: false,
  AUTO_COLLAPSE_WHEN_FILTER: false
};

CONST_VAR.REMOTE = {};
CONST_VAR.REMOTE[CONST_VAR.REMOTE_SORT] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_PAGE] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_CELL_EDIT] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_INSERT_ROW] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_DROP_ROW] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_FILTER] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_SEARCH] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_EXPORT_CSV] = false;

var _default = CONST_VAR;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CONST_VAR, 'CONST_VAR', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Const.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Const.js');
}();

;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Provider__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProtectedItemWithAuth__ = __webpack_require__(517);
var ProtectedItem=function ProtectedItem(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Provider__["a" /* default */].Consumer,null,function(auth){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProtectedItemWithAuth__["a" /* default */],Object.assign({auth:auth},props));});};/* harmony default export */ __webpack_exports__["a"] = (ProtectedItem);ProtectedItem.defaultProps={allowedPermissions:[]};ProtectedItem.propTypes={allowedPermissions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(99);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(375);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(379);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(99);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(346);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(198);
var isBuffer = __webpack_require__(536);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  renderReactSortCaret: function renderReactSortCaret(order, isBootstrap4) {
    var orderClass = void 0;
    if (isBootstrap4) {
      orderClass = (0, _classnames2.default)('fa', {
        'fa-sort-asc': order === _Const2.default.SORT_ASC,
        'fa-sort-desc': order === _Const2.default.SORT_DESC
      });
      return _react2.default.createElement('span', { className: orderClass, style: { margin: '10px 5px' } });
    } else {
      orderClass = (0, _classnames2.default)('order', {
        'dropup': order === _Const2.default.SORT_ASC
      });
      return _react2.default.createElement(
        'span',
        { className: orderClass },
        _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 5px' } })
      );
    }
  },
  isFunction: function isFunction(obj) {
    return obj && typeof obj === 'function';
  },
  getScrollBarWidth: function getScrollBarWidth() {
    var inner = document.createElement('p');
    inner.style.width = '100%';
    inner.style.height = '200px';

    var outer = document.createElement('div');
    outer.style.position = 'absolute';
    outer.style.top = '0px';
    outer.style.left = '0px';
    outer.style.visibility = 'hidden';
    outer.style.width = '200px';
    outer.style.height = '150px';
    outer.style.overflow = 'hidden';
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.getBoundingClientRect().width;
    outer.style.overflow = 'scroll';
    var w2 = inner.getBoundingClientRect().width;

    if (w1 === w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return w1 - w2;
  },
  canUseDOM: function canUseDOM() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
  },


  // We calculate an offset here in order to properly fetch the indexed data,
  // despite the page start index not always being 1
  getNormalizedPage: function getNormalizedPage(pageStartIndex, page) {
    pageStartIndex = this.getFirstPage(pageStartIndex);
    if (page === undefined) page = pageStartIndex;
    var offset = Math.abs(_Const2.default.PAGE_START_INDEX - pageStartIndex);
    return page + offset;
  },
  getFirstPage: function getFirstPage(pageStartIndex) {
    return pageStartIndex !== undefined ? pageStartIndex : _Const2.default.PAGE_START_INDEX;
  },
  isBootstrap4: function isBootstrap4(version) {
    return version === '4';
  },
  isSelectRowDefined: function isSelectRowDefined(mode) {
    return mode === _Const2.default.ROW_SELECT_SINGLE || mode === _Const2.default.ROW_SELECT_MULTI;
  },
  renderColGroup: function renderColGroup(columns, selectRow) {
    var expandColumnOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var version = arguments[3];

    var selectRowHeader = null;
    var expandRowHeader = null;
    var isBootstrap4 = this.isBootstrap4(version);
    var isSelectRowDefined = this.isSelectRowDefined(selectRow.mode);
    var columnWidth = isBootstrap4 ? '38px' : '30px';
    if (isSelectRowDefined) {
      var style = {
        width: selectRow.columnWidth || columnWidth,
        minWidth: selectRow.columnWidth || columnWidth
      };
      if (!selectRow.hideSelectColumn) {
        selectRowHeader = _react2.default.createElement('col', { key: 'select-col', style: style });
      }
    }
    if (expandColumnOptions.expandColumnVisible) {
      var _style = {
        width: expandColumnOptions.columnWidth || columnWidth,
        minWidth: expandColumnOptions.columnWidth || columnWidth
      };
      expandRowHeader = _react2.default.createElement('col', { key: 'expand-col', style: _style });
    }
    var theader = columns.map(function (column, i) {
      var style = {
        display: column.hidden ? 'none' : null
      };
      if (column.width) {
        var width = !isNaN(column.width) ? column.width + 'px' : column.width;
        style.width = width;
        /** add min-wdth to fix user assign column width
        not eq offsetWidth in large column table **/
        style.minWidth = width;
      }
      return _react2.default.createElement('col', { style: style, key: i });
    });

    return _react2.default.createElement(
      'colgroup',
      null,
      expandColumnOptions.expandColumnVisible && expandColumnOptions.expandColumnBeforeSelectColumn && expandRowHeader,
      selectRowHeader,
      expandColumnOptions.expandColumnVisible && !expandColumnOptions.expandColumnBeforeSelectColumn && expandRowHeader,
      theader
    );
  }
}; /* eslint react/display-name: 0 */

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/util.js');
}();

;

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
var ModalAlerta=function ModalAlerta(props){/*
  const montaAlerta = alerta => (
    <div style={{ 'text-align': 'justify', 'font-weight': '300' }}>
      {alerta.descricao}
    </div>
  );
  */var montaAlerta=function montaAlerta(alerta){var possuiQuebra=alerta.descricao.includes('\n')||alerta.descricao.includes('\\n');var descricaoFormatada=alerta.descricao.replace(/\\n/g,'\n');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'justify',fontWeight:300,paddingBottom:'10px',whiteSpace:possuiQuebra?'pre-line':'normal'}},descricaoFormatada);};var montaListaAlertas=function montaListaAlertas(){var listaRelacoes=[];props.alertas.forEach(function(alerta){listaRelacoes.push(montaAlerta(alerta));});return listaRelacoes;};var montaModalContent=function montaModalContent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,montaListaAlertas());};var modalFooter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},!props.esconderBotaoCancelar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{title:props.labelBotaoCancelarAcao?props.labelBotaoCancelarAcao:'Cancelar',onClick:props.handleModal,hint:props.labelBotaoCancelarAcao?props.labelBotaoCancelarAcao:'Cancelar'}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',title:props.labelBotaoConfirmarAcao?props.labelBotaoConfirmarAcao:'Confirmar ação',onClick:props.aceitar})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},props,{alert:true,alertType:'warning',conteudomodal:montaModalContent(),conteudofooter:modalFooter,onHide:props.handleModal,showTitle:true,size:props.tamanho?props.tamanho:'lg',title:props.labelTitulo?props.labelTitulo:'Confirma a ação?',showModal:true}));};ModalAlerta.propTypes={handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,aceitar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,alertas:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({descricao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired,labelTitulo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,labelBotaoConfirmarAcao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,labelBotaoCancelarAcao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,esconderBotaoCancelar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,tamanho:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ModalAlerta);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(619));
//# sourceMappingURL=index.js.map

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(96)('wks');
var uid = __webpack_require__(67);
var Symbol = __webpack_require__(30).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(42);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var core = __webpack_require__(21);
var ctx = __webpack_require__(90);
var hide = __webpack_require__(43);
var has = __webpack_require__(36);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(44);
var IE8_DOM_DEFINE = __webpack_require__(145);
var toPrimitive = __webpack_require__(91);
var dP = Object.defineProperty;

exports.f = __webpack_require__(35) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(150);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(150);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(46)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 36 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(148);
var defined = __webpack_require__(93);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UploadDragDrop=function(_Component){_inherits(UploadDragDrop,_Component);function UploadDragDrop(props){_classCallCheck(this,UploadDragDrop);var _this=_possibleConstructorReturn(this,(UploadDragDrop.__proto__||Object.getPrototypeOf(UploadDragDrop)).call(this,props));_this.simulateProgress=function(){_this.setState({uploadProgress:0});var progress=0;var interval=setInterval(function(){progress+=10;if(progress>=100){progress=100;clearInterval(interval);}_this.setState({uploadProgress:progress});},80);};_this.handleDrag=function(e){e.preventDefault();e.stopPropagation();if(e.type==='dragenter'||e.type==='dragover'){_this.setState({dragActive:true});}else if(e.type==='dragleave'){_this.setState({dragActive:false});}};_this.handleDrop=function(e){e.preventDefault();e.stopPropagation();_this.setState({dragActive:false});if(e.dataTransfer.files&&e.dataTransfer.files.length>0){_this.processFiles(Array.from(e.dataTransfer.files));}};_this.handleChangeFile=function(files){var arquivos=Array.isArray(files)?files:Array.from(files);_this.processFiles(arquivos);};_this.removeFile=function(index){var _this$props=_this.props,files=_this$props.files,onChange=_this$props.onChange,onSelect=_this$props.onSelect;var novaLista=files.filter(function(_,i){return i!==index;});onChange(novaLista);// avisa o componente pai que removeu o arquivo
if(onSelect){onSelect(null);}// limpa o input para permitir selecionar o mesmo arquivo novamente
if(_this.fileInputRef.current){_this.fileInputRef.current.value='';}};_this.processFiles=function(files){var _this$props2=_this.props,accept=_this$props2.accept,multiple=_this$props2.multiple,currentFiles=_this$props2.files,onChange=_this$props2.onChange,onSelect=_this$props2.onSelect;var arquivosFiltrados=files;// valida extensões permitidas
if(accept){var tiposAceitos=accept.split(',').map(function(tipo){return tipo.trim().toLowerCase();});arquivosFiltrados=files.filter(function(file){var nomeArquivo=file.name.toLowerCase();var mimeType=file.type.toLowerCase();return tiposAceitos.some(function(tipoAceito){// ex: .pdf
if(tipoAceito.startsWith('.')){return nomeArquivo.endsWith(tipoAceito);}// ex: application/pdf
return mimeType===tipoAceito;});});}var novaLista=[];if(multiple){// múltiplos arquivos
// evita duplicados
var arquivosExistentes=currentFiles||[];var arquivosNovos=arquivosFiltrados.filter(function(file){return!arquivosExistentes.some(function(existente){return existente.name===file.name&&existente.lastModified===file.lastModified;});});novaLista=[].concat(_toConsumableArray(arquivosExistentes),_toConsumableArray(arquivosNovos));}else{// apenas um arquivo
novaLista=arquivosFiltrados.slice(0,1);}onChange(novaLista);if(onSelect&&novaLista.length>0){onSelect(multiple?novaLista:novaLista[0]);}// só exibe progresso se houver arquivo válido
if(arquivosFiltrados.length>0){_this.simulateProgress();}};_this.renderProgressBar=function(){var _this$props3=_this.props,uploading=_this$props3.uploading,progress=_this$props3.progress;if(!uploading){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:12}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%',height:8,background:'#e0e0e0',borderRadius:4,overflow:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:progress+'%',height:'100%',background:'#1976d2',transition:'width 0.3s ease'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:6,fontSize:12,color:'#666',textAlign:'right'}},progress,'%'));};_this.fileInputRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.state={dragActive:false,uploadProgress:0};return _this;}_createClass(UploadDragDrop,[{key:'render',value:function render(){var _this2=this;var _props=this.props,files=_props.files,multiple=_props.multiple,accept=_props.accept,textoPrincipal=_props.textoPrincipal,textoSecundario=_props.textoSecundario,minHeight=_props.minHeight,largura=_props.largura,disabled=_props.disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-'+largura},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onDragEnter:!disabled?this.handleDrag:undefined,onDragLeave:!disabled?this.handleDrag:undefined,onDragOver:!disabled?this.handleDrag:undefined,onDrop:!disabled?this.handleDrop:undefined,style:{position:'relative',border:this.state.dragActive?'2px dashed #1976d2':'2px dashed #ccc',width:'100%',boxSizing:'border-box',borderRadius:8,padding:files.length>0?'8px 12px 4px 12px':12,textAlign:'center',background:this.state.dragActive?'#f5f9ff':'#fff',transition:'all 0.2s ease',minHeight:minHeight,cursor:disabled?'not-allowed':'pointer',opacity:disabled?0.6:1,marginBottom:8}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:this.fileInputRef,type:'file',accept:accept||'.pdf',multiple:multiple,onChange:function onChange(e){return _this2.handleChangeFile(Array.from(e.target.files));},onClick:function onClick(e){return e.stopPropagation();},disabled:disabled,style:{position:'absolute',width:'100%',height:'100%',opacity:0,top:0,left:0,cursor:'pointer',zIndex:1,pointerEvents:disabled?'none':'auto'}}),files.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',minHeight:40}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:16,marginBottom:8,color:'#546E7A'}},textoPrincipal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:13,color:'#546E7A'}},textoSecundario)),this.state.uploadProgress>0&&this.state.uploadProgress<100&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%',marginTop:12,marginBottom:12}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:8,background:'#e0e0e0',borderRadius:4,overflow:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:this.state.uploadProgress+'%',height:'100%',background:'#1976d2',transition:'width 0.1s linear'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:4,fontSize:12,color:'#666'}},'Enviando...',' ',this.state.uploadProgress,'%')),files.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:files.length>0?6:20,textAlign:'left',position:'relative',zIndex:2,maxHeight:320,overflowY:'auto',overflowX:'hidden',paddingRight:4,scrollbarWidth:'thin'}},files.map(function(file,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:file.name+'-'+file.lastModified,style:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8,padding:'2px 8px',minHeight:36,background:'#f5f5f5',borderRadius:4}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,file.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{mini:true,icon:'ico-cancel',className:'dtp-inverse',hint:'Remover arquivo',onClick:function onClick(){return _this2.removeFile(index);}}));})))));}}]);return UploadDragDrop;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UploadDragDrop.propTypes={files:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,lastModified:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number})),onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,multiple:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,accept:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,textoPrincipal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,textoSecundario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,minHeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,progress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,uploading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,largura:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};UploadDragDrop.defaultProps={files:[],multiple:false,accept:'.pdf',textoPrincipal:'Arraste o arquivo aqui',textoSecundario:'ou clique para selecionar',minHeight:110,progress:0,uploading:false,largura:12,onSelect:null,disabled:false};/* harmony default export */ __webpack_exports__["a"] = (UploadDragDrop);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(256);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(259);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(260);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(61);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(48);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31);
var createDesc = __webpack_require__(54);
module.exports = __webpack_require__(35) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(45);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__ = __webpack_require__(5);
var SelecaoEntidade=function SelecaoEntidade(props){var listaFiltradaDestinatarios=function listaFiltradaDestinatarios(){var listaOrgaosFederais=[];var listaParticipantes=props.destinatarios.filter(function(item){if(item.inOrgaoUniao&&(!item.inOrgaoExtinto&&item.inOrgaoCentralizador===1||!item.inOrgaoExtinto&&item.inOrgaoCentralizador===0)){listaOrgaosFederais.push(item);}else if(!item.inOrgaoExtinto&&item.tipoRegimeProprio===props.tipoEntidade&&(item.uf&&props.tipoEntidade===2?item.uf===props.uf:true)){return item;}return null;});if(listaOrgaosFederais.length>0&&props.tipoEntidade===1){listaParticipantes=listaOrgaosFederais;}if(props.papelUsuarioLogado==='analista-rgps'||props.tipoRegimeObservador===1){var index=listaParticipantes.findIndex(function(item){return item.value==='01000';});if(index!==-1){listaParticipantes.splice(index,1);}}return listaParticipantes;};var carregaUfDosMunicipios=function carregaUfDosMunicipios(){var listaUf=[];props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};var regimes=props.listaTiposRegimes;var selecaoEntidade=void 0;var selecaoTipoRegime=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{label:'Tipo de Regime',number:true,onChange:function onChange(e){return props.handleChange(e,props.nomeAtributoComboboxRegime);},placeholder:'Selecione o tipo de regime origem',value:props.tipoRegime,itemList:regimes,required:true,custom:true,disabled:props.desabilitar})));if(props.tipoRegime===2){selecaoEntidade=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{label:'Entidade',onChange:function onChange(e){return props.handleChange(e,props.nomeAtributoComboboxTipoEntidade);},placeholder:'Selecione a entidade',value:props.tipoEntidade,itemList:__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["E" /* tipoEntidade */],required:true,custom:true,number:true,disabled:props.desabilitar})),props.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{label:'UF',onChange:function onChange(e){return props.handleChange(e,props.nomeAtributoComboboxUF);},placeholder:'Selecione a UF',value:props.uf,itemList:carregaUfDosMunicipios(),custom:true,required:true,disabled:props.desabilitar})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{label:props.labelComboboxParticipante,onChange:function onChange(e){return props.handleChange(e,props.nomeAtributoComboboxParticipante);},placeholder:'Selecione o destinat\xE1rio',value:props.participante,itemList:listaFiltradaDestinatarios(),required:true,custom:true,disabled:props.desabilitar})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["f" /* DataGridCustom */],{title:props.titulo,retirarLinhaSeparadora:props.retirarLinhaSeparadora},selecaoTipoRegime,selecaoEntidade);};SelecaoEntidade.propTypes={destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tipoRegimeProprio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,listaTiposRegimes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,titulo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,retirarLinhaSeparadora:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,nomeAtributoComboboxRegime:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,nomeAtributoComboboxParticipante:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,nomeAtributoComboboxTipoEntidade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,nomeAtributoComboboxUF:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,participante:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,papelUsuarioLogado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,tipoRegime:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,tipoRegimeObservador:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,tipoEntidade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,uf:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,labelComboboxParticipante:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,desabilitar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SelecaoEntidade);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DtpButton = function (_Component) {
    _inherits(DtpButton, _Component);

    function DtpButton() {
        _classCallCheck(this, DtpButton);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpButton.prototype.render = function render() {
        var _props = this.props,
            className = _props.className,
            id = _props.id,
            onChange = _props.onChange,
            onClick = _props.onClick,
            hint = _props.hint,
            title = _props.title,
            disabled = _props.disabled,
            accessibilityName = _props.accessibilityName,
            icon = _props.icon;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-btn', className ? className : '', { 'disabled': disabled }),
                id: id,
                onChange: onChange,
                onClick: onClick,
                title: hint,
                disabled: disabled,
                'aria-label': accessibilityName },
            title && title,
            icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: icon })
        );
    };

    return DtpButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

;

DtpButton.propTypes =  false ? {
    /** Classe de estilização CSS */
    className: PropTypes.string,

    /** Identificador único do elemento */
    id: PropTypes.string,

    /** Valor apresentado pelo componente */
    title: PropTypes.string,

    /** Valor apresentado como dica para acessibilidade */
    hint: PropTypes.string,

    /** Função que será executada ao alterar o value */
    onChange: PropTypes.func,

    /** Função que será executada ao clicar no botão */
    onClick: PropTypes.func,

    /** Atributo que controla se o botão está ou não desabilitado */
    disabled: PropTypes.bool,

    /** Atributo obrigatório por questões de acessibilidade */
    accessibilityName: PropTypes.string,

    /** Ícone apresentado pelo componente */
    icon: PropTypes.string
} : {};

DtpButton.defaultProps = {
    disabled: false
};

/* harmony default export */ __webpack_exports__["a"] = (DtpButton);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(133);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = offset;

var _contains = _interopRequireDefault(__webpack_require__(87));

var _isWindow = _interopRequireDefault(__webpack_require__(53));

var _ownerDocument = _interopRequireDefault(__webpack_require__(42));

function offset(node) {
  var doc = (0, _ownerDocument.default)(node),
      win = (0, _isWindow.default)(doc),
      docElem = doc && doc.documentElement,
      box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  if (!doc) return; // Make sure it's not a disconnected DOM node

  if (!(0, _contains.default)(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };
  return box;
}

module.exports = exports["default"];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_promise__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_baseReducer__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_glosas_reducer__ = __webpack_require__(515);
var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({base:__WEBPACK_IMPORTED_MODULE_2__utils_baseReducer__["a" /* default */],glosa:__WEBPACK_IMPORTED_MODULE_3__pages_glosas_reducer__["a" /* default */]});// eslint-disable-next-line no-underscore-dangle
var devTools=window.__REDUX_DEVTOOLS_EXTENSION__&&window.__REDUX_DEVTOOLS_EXTENSION__();var store=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_0_redux_promise___default.a)(__WEBPACK_IMPORTED_MODULE_1_redux__["d" /* createStore */])(rootReducer,devTools);/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 58 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(261);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(262);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(264);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(266);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(268);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(81);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(270);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(274);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(275);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_elementType__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DtpFormControlFeedback__ = __webpack_require__(134);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DtpFormControl = function (_Component) {
    _inherits(DtpFormControl, _Component);

    function DtpFormControl(props) {
        _classCallCheck(this, DtpFormControl);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.getFocused = function (value) {
            var valueIsNumber = typeof value === 'number';
            var focused = false;
            if (valueIsNumber === true) {
                focused = true;
            } else {
                focused = value && value.length > 0;
            }
            return focused;
        };

        _this.state = {
            value: props.value ? props.value : ''
        };

        _this.getPlaceholder = _this.getPlaceholder.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.setValue = _this.setValue.bind(_this);
        return _this;
    }

    DtpFormControl.prototype.componentDidMount = function componentDidMount() {
        var value = this.state.value;

        var formGroup = this.context.$dtp_formGroup;

        if (this.getFocused(value) === true) {
            if (formGroup) {
                formGroup.setFocused(true);
            }
        }
    };

    DtpFormControl.prototype.setValue = function setValue(newValue) {
        var formGroup = this.context.$dtp_formGroup;
        if (formGroup) {
            formGroup.setFocused(this.getFocused(newValue));
        }
        this.setState({
            value: newValue
        });
    };

    DtpFormControl.prototype.getPlaceholder = function getPlaceholder() {
        var formGroup = this.context.$dtp_formGroup;
        if (this.props.placeholder && formGroup.focused === true) {
            return this.props.placeholder;
        }
    };

    DtpFormControl.prototype.handleChange = function handleChange(e) {
        this.setState({ value: e.target.value });
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    };

    DtpFormControl.prototype.handleFocus = function handleFocus() {
        var value = this.props.value;

        if (value) {
            this.setState({
                value: value
            });
        }
        var formGroup = this.context.$dtp_formGroup;
        if (formGroup) {
            formGroup.setFocused(true);
        }
        if (this.props.onFocus) {
            this.props.onFocus();
        }
    };

    DtpFormControl.prototype.dismissFocus = function dismissFocus() {
        var formGroup = this.context.$dtp_formGroup;
        if (formGroup) {
            formGroup.setFocused(false);
        }
    };

    DtpFormControl.prototype.handleBlur = function handleBlur(e) {
        var formGroup = this.context.$dtp_formGroup;
        if (formGroup) {
            formGroup.setFocused(this.getFocused(this.state.value));
        }
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    };

    DtpFormControl.prototype.handleClick = function handleClick(e) {
        if (this.props.onKeyDown) {
            this.props.onKeyDown(e);
        }
        if (this.props.onClick) {
            this.props.onClick(e);
        }
    };

    DtpFormControl.prototype.handleKeyDown = function handleKeyDown(e) {
        if (this.props.onKeyDown) {
            this.props.onKeyDown(e);
        }
    };

    DtpFormControl.prototype.render = function render() {
        var _this2 = this;

        var formGroup = this.context.$dtp_formGroup;
        var controlId = formGroup && formGroup.controlId;

        var _props = this.props,
            Component = _props.componentClass,
            type = _props.type,
            _props$id = _props.id,
            id = _props$id === undefined ? controlId : _props$id,
            inputRef = _props.inputRef,
            className = _props.className,
            disabled = _props.disabled,
            placeholder = _props.placeholder,
            changeValue = _props.changeValue,
            props = _objectWithoutProperties(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'disabled', 'placeholder', 'changeValue']);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, props, {
            type: type,
            disabled: disabled,
            id: id,
            name: controlId,
            ref: inputRef,
            onFocus: this.handleFocus.bind(this),
            onBlur: this.handleBlur.bind(this),
            placeholder: this.getPlaceholder(),
            onChange: function onChange(e) {
                return _this2.handleChange(e);
            },
            onKeyDown: this.handleKeyDown.bind(this),
            onClick: this.handleClick.bind(this),
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-form-control', className, {
                'disabled': disabled && disabled === true
            })
        }));
    };

    return DtpFormControl;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpFormControl.propTypes =  false ? {
    /** Classe React desse componente */
    componentClass: elementType,

    /** Somente relevante se `componentClass` for `'input'`. */
    type: PropTypes.string,

    /** Usa `controlId` do `<DtpFormGroup>` se não for explicitamente definido. */
    id: PropTypes.string,

    /** Cria uma referência (ref) para o elemento `<input>`. */
    inputRef: PropTypes.func,

    /** Função que será executada ao alterar o value */
    onChange: PropTypes.func,

    /** Função invocada quando o foco sair deste componente */
    onBlur: PropTypes.func,

    /** Função invocada quando este componente recebe foco  */
    onFocus: PropTypes.func,

    /** Função invocada ao se digitar no componente */
    onKeyDown: PropTypes.func,

    /** Função invocada ao clicar no componente */
    onClick: PropTypes.func
} : {};

DtpFormControl.defaultProps = {
    componentClass: 'input',
    disabled: false
};

DtpFormControl.contextTypes = {
    $dtp_formGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

DtpFormControl.Feedback = __WEBPACK_IMPORTED_MODULE_4__DtpFormControlFeedback__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (DtpFormControl);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DtpButton__ = __webpack_require__(49);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var DtpButtonFlat = function DtpButtonFlat(props) {
    var className = props.className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DtpButton__["a" /* default */], _extends({}, props, {
        className: 'dtp-btn-flat ' + className
    }));
};

/* harmony default export */ __webpack_exports__["a"] = (DtpButtonFlat);

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(328);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(329);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(147);
var enumBugKeys = __webpack_require__(97);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(93);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({changeUser:function changeUser(){},checkPermission:function checkPermission(){},jwt:null,user:null}));

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getParameterByName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return storeJwt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getJwt; });
/* unused harmony export storeToken */
/* unused harmony export getToken */
/* unused harmony export unstoreToken */
/* unused harmony export unstoreJwt */
/* unused harmony export resetarExibirLogotipo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAuthorizationHeader; });
/* unused harmony export checkUser */
/* unused harmony export checkTokenUsuario */
var getParameterByName=function getParameterByName(nameParam,urlParam){var url=urlParam||window.location.href;var name=nameParam.replace(/[[\]]/g,'\\$&');var regex=new RegExp('[?#&]'+name+'(=([^&#]*)|&|#|$)');var results=regex.exec(url);if(!results)return null;if(!results[2])return'';return decodeURIComponent(results[2].replace(/\+/g,' '));};var storeJwt=function storeJwt(jwt){localStorage.setItem('jwt',jwt);};var getJwt=function getJwt(){return localStorage.getItem('jwt');};var storeToken=function storeToken(jwt){localStorage.setItem('token',jwt);};var getToken=function getToken(){return localStorage.getItem('token');};var unstoreToken=function unstoreToken(){localStorage.removeItem('token');};var unstoreJwt=function unstoreJwt(){localStorage.removeItem('jwt');};var resetarExibirLogotipo=function resetarExibirLogotipo(){if(sessionStorage.getItem('comprevConfigLogotipo')){var logotipoJson={exibirLogo:1};window.comprevConfigLogotipo=logotipoJson;sessionStorage.setItem('comprevConfigLogotipo',JSON.stringify(logotipoJson));}};var logout=function logout(){unstoreJwt();unstoreToken();resetarExibirLogotipo();};var getAuthorizationHeader=function getAuthorizationHeader(){return getJwt()?'Bearer '+getJwt():'';};var checkUser=function checkUser(userData){if(userData){var userPermissions=null;userData.roles.forEach(function(role){var isRGPS=role.match(/RGPS/g);if(isRGPS){userPermissions=1;}var isRPPS=role.match(/RPPS/g);if(isRPPS){userPermissions=2;}});return userPermissions;}return null;};var checkTokenUsuario=function checkTokenUsuario(userData){var retorno=false;if(userData){// ************** CAMPO EXP VINDO DO JWT **************
var campoExpVindoJWT=userData.exp+'000';// ************** CAMPO EXP VINDO DO JWT **************
// ************** CAMPO EXP NUMERICO     **************
var expiracaoToken=parseInt(campoExpVindoJWT,10);// ************** CAMPO EXP NUMERICO     **************
// ************** DATA E HORA ATUAL    **************
var agoraData=Date.now();var agora=parseInt(agoraData,10);// ************** DATA E HORA ATUAL    **************
// ************** SE A DATA E HORA DO TOKEN FOR MAIOR QUE A DATA/HORA ATUAL,   **************
// ************** FAZER LOGOUT E DAR UM REFRESH NA TELA                        **************
if(agora>expiracaoToken){retorno=true;return retorno;}}return retorno;};

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
var SolicitanteDestinatario=function SolicitanteDestinatario(props){if(props.requerimento.solicitante&&props.requerimento.destinatario){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["e" /* DataGrid */],{title:'Destina\xE7\xE3o',icon:'ico-route'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{disabled:true,label:'Data de Cria\xE7\xE3o do Requerimento',value:props.requerimento.dataAberturaRequerimento}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{disabled:true,label:'Solicitante',value:props.requerimento.solicitante.nome})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{disabled:true,label:'Destinat\xE1rio',value:props.requerimento.destinatario.nome}))),props.requerimento.destinatarioOrigem?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{disabled:true,label:'Destinat\xE1rio Origem',value:props.requerimento.destinatarioOrigem.nome}))):'');}return'';};SolicitanteDestinatario.propTypes={requerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tipoRegimeProprio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (SolicitanteDestinatario);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var destinoRGPS='01000';var FiltroPesquisa=function(_Component){_inherits(FiltroPesquisa,_Component);function FiltroPesquisa(){_classCallCheck(this,FiltroPesquisa);var _this=_possibleConstructorReturn(this,(FiltroPesquisa.__proto__||Object.getPrototypeOf(FiltroPesquisa)).call(this));_this.getTipoConsulta=function(){return _this.props.tipoConsulta?_this.props.tipoConsulta:'consulta';};_this.controleFiltrosAlternativos=function(campo){switch(campo){case'destinatario-rpps':return['requerer-compensacao-rgps','analisar-negocio-sprev','gerenciar-negocio-dcomp','auditar-comprev'];default:return[];}};_this.preparaNovaConsulta=function(){var filtroPesquisa={cpf:null,nit:null,numeroBeneficio:null,tipoRequerimento:null,participacao:1,estado:null,'destinatario-rpps':null,filtraExigenciaHomologacao:false,tipoEntidade:null,cliqueiNoBotao:0,filtro:null,tipoFiltroFilaGet:null,tipoFiltroPrisma:null,mascara:'',dtPrismaInicio:null,dtPrismaFim:null,dtComprevInicio:null,dtComprevFim:null,especieBeneficio:null,tipoPesquisa:_this.getTipoConsulta()};filtroPesquisa=JSON.stringify(filtroPesquisa);sessionStorage.setItem('filtroPesquisa',filtroPesquisa);_this.setState({cpf:null,tipoRequerimento:null,participacao:1,'destinatario-rpps':null,filtraExigenciaHomologacao:false,tipoEntidade:null});};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.handleKeyDown=function(e){var retorno=null;if(e.keyCode===13){retorno=_this.handleSearchButton();}return retorno;};_this.handleChangeMascaraFiltro=function(changeObj,name){var _this$setState2;var mascaraAtual='';switch(changeObj.value){case 1:mascaraAtual='cpf';break;case 2:mascaraAtual='nit';break;case 3:mascaraAtual='nb';break;default:mascaraAtual='cpf';break;}_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,changeObj.value),_defineProperty(_this$setState2,'mascara',mascaraAtual),_this$setState2),function(){return _this.trataFormulario(name);});};_this.trataFormulario=function(campoAlterado){if(campoAlterado==='tipoEntidade'){_this.trataTipoEntidade();}if(campoAlterado==='uf'){_this.trataUf();}if(campoAlterado==='participacao'){_this.trataCombosEntidade();}if(campoAlterado==='tipoFiltroPrisma'){_this.trataFiltroPrisma();}if(campoAlterado==='tipoFiltroFilaGet'){_this.trataFiltroFilaGet();}};_this.trataFiltroPrisma=function(){_this.setState({cpf:null,nit:null,numeroBeneficio:null});};_this.trataFiltroFilaGet=function(){_this.setState({idProtocolo:null,pendenteEnvio:null});};_this.trataUf=function(){_this.setState({destinatario:null,'destinatario-rpps':null});};_this.trataCombosEntidade=function(){_this.setState({tipoEntidade:null,'destinatario-rpps':null,uf:null});};_this.trataTipoEntidade=function(){_this.setState({'destinatario-rpps':null,destinatario:null,uf:null});};_this.trataTipoRegime=function(){var tipoEntidadeAposAlteracao=null;var destinatarioAposAlteracao=null;if(_this.state.tipoRegime===1){destinatarioAposAlteracao=destinoRGPS;}_this.setState({tipoEntidade:tipoEntidadeAposAlteracao,destinatario:destinatarioAposAlteracao},function(){_this.props.handleChange({value:destinatarioAposAlteracao,isValid:destinatarioAposAlteracao!==null},'destinatario');});};_this.handleSearchButton=function(){var filtroPesquisa={cpf:_this.state.cpf,nit:_this.state.nit,numeroBeneficio:_this.state.numeroBeneficio,tipoRequerimento:_this.state.tipoRequerimento,participacao:_this.state.participacao,estado:_this.state.estado,'destinatario-rpps':_this.state['destinatario-rpps'],filtraExigenciaHomologacao:_this.state.filtraExigenciaHomologacao,tipoEntidade:_this.state.tipoEntidade,cliqueiNoBotao:_this.state.cliqueiNoBotao,filtro:_this.state.filtro,tipoFiltroFilaGet:_this.state.tipoFiltroFilaGet,tipoFiltroPrisma:_this.state.tipoFiltroPrisma,mascara:_this.state.mascara,dtPrismaInicio:_this.state.dtPrismaInicio,dtPrismaFim:_this.state.dtPrismaFim,dtComprevInicio:_this.state.dtComprevInicio,dtComprevFim:_this.state.dtComprevFim,tipoPesquisa:_this.getTipoConsulta()};filtroPesquisa=JSON.stringify(filtroPesquisa);sessionStorage.setItem('filtroPesquisa',filtroPesquisa);_this.setState({cliqueiNoBotao:1},function(){_this.handleChange({value:1,isValid:true},'cliqueiNoBotao');});if(!_this.props.tipoConsulta){_this.handleSearch();}else if(_this.props.tipoConsulta==='exigencia'||_this.props.tipoConsulta==='prescricao-exigencia'||_this.props.tipoConsulta==='parecer-medico'||_this.props.tipoConsulta==='cessacao-requerimento'||_this.props.tipoConsulta==='indeferido'){_this.handleSearch();}else if(_this.props.tipoConsulta==='consulta-prisma'){_this.handleSearchPrisma();}else if(_this.props.tipoConsulta==='consulta-filaget'){_this.handleSearchFilaGet();}else if(_this.props.tipoConsulta==='analise'||_this.props.tipoConsulta==='complementar-aposentadoria'){_this.handleSearchComplementarAposentadoria();}};_this.handleListFilter=function(){var listaFiltrada=_this.props.list;if(_this.state.filtraExigenciaHomologacao){listaFiltrada=listaFiltrada.filter(function(requerimento){var exigenciasDiferentesHomologacao=requerimento.exigencias.filter(function(exigencia){return exigencia.tipo!==(6||23);});if(exigenciasDiferentesHomologacao.length>0)return true;return false;});}_this.props.handleChangeList(listaFiltrada);};_this.handleSearch=function(){if(_this.props.tipoConsulta==='exigencia'||_this.props.tipoConsulta==='indeferido'){var paramCpf='';if(_this.state.cpf){paramCpf=_this.state.cpf.toUpperCase();if(_this.state.cpf.indexOf('_')!==-1){paramCpf=_this.state.cpf.toString().replace(/_/g,'');}}_this.state.cpf=paramCpf;}if(_this.state.cpf||_this.state.tipoRequerimento){if(_this.state.tipoEntidade===2&&!_this.state.uf&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_7__utils_requests__["L" /* trataMensagensErro */])(['Escolha uma UF']);return;}if(_this.state.tipoEntidade&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_7__utils_requests__["L" /* trataMensagensErro */])(['Escolha um filtro de destinatário para a consulta']);return;}if(_this.state.tipoEntidade&&_this.state.uf&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_7__utils_requests__["L" /* trataMensagensErro */])(['Escolha um filtro de destinatário para a consulta']);return;}_this.props.handleSearchFilter(_this.state);}else{Object(__WEBPACK_IMPORTED_MODULE_7__utils_requests__["L" /* trataMensagensErro */])(['Escolha pelo menos um filtro de CPF ou de Tipo de Requerimento para a consulta']);}};_this.handleSearchPrisma=function(){// if (!this.state.filtro) {
// trataMensagensErro(['É necessário digitar um filtro']);
// return;
// }
if(_this.state.cpf){_this.state.filtro=_this.state.cpf;}else if(_this.state.nit){_this.state.filtro=_this.state.nit;}else if(_this.state.numeroBeneficio){_this.state.filtro=_this.state.numeroBeneficio;}_this.props.handleSearchFilter(_this.state);};_this.handleSearchFilaGet=function(){_this.props.handleSearchFilter(_this.state);};_this.handleSearchAnalise=function(){// this.state.estado = this.state.estado;
_this.props.handleSearchFilter(_this.state);};_this.handleSearchComplementarAposentadoria=function(){_this.props.handleSearchFilter(_this.state);};_this.exibirFiltroDestinatario=function(){return _this.state.participacao===1;};_this.listaFiltradaDestinatarios=function(){var listaParticipantes=_this.props.destinatarios.filter(function(item){if(item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)){return item;}return null;});return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.montaFiltrosDefault=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{cpf:true,integer:true,label:'CPF',mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].cpf,onChange:function onChange(e){return _this.handleChange(e,'cpf');},onKeyDown:function onKeyDown(e){return _this.handleKeyDown(e,'cpf');},showMask:true,value:_this.state.cpf,validationState:'active'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Tipo de Requerimento',name:'tipoRequerimento',onChange:function onChange(e){return _this.handleChange(e,'tipoRequerimento');},itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["N" /* tipoRequerimentoFilter */],radio:true,value:_this.state.tipoRequerimento,validationState:'active',custom:true})),!_this.props.auth.checkPermission(['analisar-negocio-sprev'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Tipo de Participa\xE7\xE3o',name:'participacao',onChange:function onChange(e){return _this.handleChange(e,'participacao');},itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["J" /* tipoParticipacao */],radio:true,value:_this.state.participacao,validationState:'active',custom:true})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Estado do requerimento',name:'estado',onChange:function onChange(e){return _this.handleChange(e,'estado');},itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["Q" /* tiposEstado */],value:_this.state.estado,validationState:'active',custom:true}))),_this.exibirFiltroDestinatario()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:_this.controleFiltrosAlternativos('destinatario-rpps')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Entidade',onChange:function onChange(e){return _this.handleChange(e,'tipoEntidade');},placeholder:'Selecione a entidade',value:_this.state.tipoEntidade,itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["E" /* tipoEntidade */],custom:true,number:true})),_this.state.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'UF',onChange:function onChange(e){return _this.handleChange(e,'uf');},placeholder:'Selecione a UF',value:_this.state.uf,itemList:_this.carregaUfDosMunicipios(),custom:true})):'',_this.state.tipoEntidade?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Destinat\xE1rio',name:'destinatario-rpps',onChange:function onChange(e){return _this.handleChange(e,'destinatario-rpps');},placeholder:'Selecione o destinat\xE1rio',value:_this.state['destinatario-rpps'],itemList:_this.listaFiltradaDestinatarios(),custom:true})):'')):'');};_this.montaFiltrosCessacao=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{cpf:true,integer:true,label:'CPF',mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].cpf,onChange:function onChange(e){return _this.handleChange(e,'cpf');},onKeyDown:function onKeyDown(e){return _this.handleKeyDown(e,'cpf');},showMask:true,value:_this.state.cpf,validationState:'active'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Tipo de Requerimento',name:'tipoRequerimento',onChange:function onChange(e){return _this.handleChange(e,'tipoRequerimento');},itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["N" /* tipoRequerimentoFilter */],radio:true,value:_this.state.tipoRequerimento,validationState:'active',custom:true})));};_this.montaFiltrosExigencia=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{cpf:true,label:'CPF',filtroExigencia:true,mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].cpfFiltroExigencia,onChange:function onChange(e){return _this.handleChange(e,'cpf');}// onBlur={e => this.handleBlurCpfExigencia(e, 'cpf')}
,onKeyDown:function onKeyDown(e){return _this.handleKeyDown(e,'cpf');},showMask:true,value:_this.state.cpf,validationState:'active'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Tipo de Requerimento',name:'tipoRequerimento',onChange:function onChange(e){return _this.handleChange(e,'tipoRequerimento');},itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["N" /* tipoRequerimentoFilter */],radio:true,value:_this.state.tipoRequerimento,validationState:'active',custom:true})));};_this.montaFiltrosAnalise=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Estado do requerimento',name:'estado',onChange:function onChange(e){return _this.handleChange(e,'estado');},itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["R" /* tiposEstadoAnalise */],value:_this.state.estado,validationState:'active',custom:true})));};_this.montaFiltrosComplementarAposentadoria=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{cpf:true,integer:true,label:'CPF',mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].cpf,onChange:function onChange(e){return _this.handleChange(e,'cpf');},onKeyDown:function onKeyDown(e){return _this.handleKeyDown(e,'cpf');},showMask:true,value:_this.state.cpf,validationState:'active'})));};_this.montaFiltrosExigenciaParecerMedico=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{cpf:true,integer:true,label:'CPF',mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].cpf,onChange:function onChange(e){return _this.handleChange(e,'cpf');},onKeyDown:function onKeyDown(e){return _this.handleKeyDown(e,'cpf');},showMask:true,value:_this.state.cpf,validationState:'active'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Tipo de Requerimento',name:'tipoRequerimento',onChange:function onChange(e){return _this.handleChange(e,'tipoRequerimento');},itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["N" /* tipoRequerimentoFilter */],radio:true,value:_this.state.tipoRequerimento,validationState:'active'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Estado do requerimento',name:'estado',onChange:function onChange(e){return _this.handleChange(e,'estado');},itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["S" /* tiposEstadoParecerMedico */],value:_this.state.estado,validationState:'active',custom:true})));};_this.montaFiltrosPrisma=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Pesquisar por',name:'tipoFiltroPrisma',onChange:function onChange(e){return _this.handleChangeMascaraFiltro(e,'tipoFiltroPrisma');},itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["w" /* prismaFilter */],radio:true,value:_this.state.tipoFiltroPrisma,validationState:'active'})),_this.state.mascara==='cpf'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{integer:true,label:'Filtro',onChange:function onChange(e){return _this.handleChangeMascaraFiltro(e,'cpf');},showMask:true,value:_this.state.cpf,validationState:'active',mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].cpf})):'',_this.state.mascara==='nit'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{integer:true,label:'Filtro',onChange:function onChange(e){return _this.handleChangeMascaraFiltro(e,'nit');},showMask:true,value:_this.state.nit,validationState:'active',mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].nit})):'',_this.state.mascara==='nb'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{integer:true,label:'Filtro',maxlength:'15',onChange:function onChange(e){return _this.handleChange(e,'numeroBeneficio');},showMask:true,value:_this.state.numeroBeneficio,validationState:'active'})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].date,label:'In\xEDcio recebimento PRISMA',onChange:function onChange(e){return _this.handleChange(e,'dtPrismaInicio');},showMask:true,value:_this.state.dtPrismaInicio,validationState:'active'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].date,label:'Fim recebimento PRISMA',onChange:function onChange(e){return _this.handleChange(e,'dtPrismaFim');},showMask:true,value:_this.state.dtPrismaFim,validationState:'active'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].date,label:'In\xEDcio envio COMPREV',onChange:function onChange(e){return _this.handleChange(e,'dtComprevInicio');},showMask:true,value:_this.state.dtComprevInicio,validationState:'active'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].date,label:'Fim envio COMPREV',onChange:function onChange(e){return _this.handleChange(e,'dtComprevFim');},showMask:true,value:_this.state.dtComprevFim,validationState:'active'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{integer:true,maxlength:'2',label:'N\xFAmero Esp\xE9cie',onChange:function onChange(e){return _this.handleChange(e,'especieBeneficio');},showMask:true,value:_this.state.especieBeneficio,validationState:'active'}))));};_this.montaFiltrosGet=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Pesquisar por',name:'tipoFiltroFilaGet',itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["k" /* filaGetFilter */],radio:true,value:_this.state.tipoFiltroFilaGet,validationState:'active'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Protocolo',onChange:function onChange(e){return _this.handleChange(e,'idProtocolo');},value:_this.state.idProtocolo,validationState:'active',consultaFilaGet:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Pendente Envio GET',name:'pendenteEnvio',onChange:function onChange(e){return _this.handleChange(e,'pendenteEnvio');},itemList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["u" /* pendenteEnvio */],value:_this.state.pendenteEnvio,validationState:'active',custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'2 2 2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Retorno',onChange:function onChange(e){return _this.handleChange(e,'mensagemRetorno');},value:_this.state.mensagemRetorno,validationState:'active',consultaFilaGet:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'2 2 2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Body Envio',onChange:function onChange(e){return _this.handleChange(e,'bodyEnvio');},value:_this.state.bodyEnvio,validationState:'active',consultaFilaGet:true}))));};_this.montaFiltros=function(){if(!_this.props.tipoConsulta){return _this.montaFiltrosDefault();}else if(_this.props.tipoConsulta==='exigencia'){return _this.montaFiltrosExigencia();}else if(_this.props.tipoConsulta==='parecer-medico'){return _this.montaFiltrosExigenciaParecerMedico();}else if(_this.props.tipoConsulta==='prescricao-exigencia'){return _this.montaFiltrosExigencia();}else if(_this.props.tipoConsulta==='cessacao-requerimento'){return _this.montaFiltrosCessacao();}else if(_this.props.tipoConsulta==='consulta-prisma'){return _this.montaFiltrosPrisma();}else if(_this.props.tipoConsulta==='consulta-filaget'){return _this.montaFiltrosGet();}else if(_this.props.tipoConsulta==='indeferido'){return _this.montaFiltrosExigencia();}else if(_this.props.tipoConsulta==='analise'){return _this.montaFiltrosAnalise();}else if(_this.props.tipoConsulta==='complementar-aposentadoria'){return _this.montaFiltrosComplementarAposentadoria();}return null;};_this.filtroPesquisa=JSON.parse(sessionStorage.getItem('filtroPesquisa'));// tipoRequerimento: null,
_this.state={cpf:_this.filtroPesquisa&&_this.filtroPesquisa.cpf?_this.filtroPesquisa.cpf:null,nit:_this.filtroPesquisa&&_this.filtroPesquisa.nit?_this.filtroPesquisa.nit:null,numeroBeneficio:_this.filtroPesquisa&&_this.filtroPesquisa.numeroBeneficio?_this.filtroPesquisa.numeroBeneficio:null,tipoRequerimento:_this.filtroPesquisa&&_this.filtroPesquisa.tipoRequerimento?_this.filtroPesquisa.tipoRequerimento:null,participacao:_this.filtroPesquisa&&_this.filtroPesquisa.participacao?_this.filtroPesquisa.participacao:1,estado:_this.filtroPesquisa&&_this.filtroPesquisa.estado?_this.filtroPesquisa.estado:null,'destinatario-rpps':_this.filtroPesquisa&&_this.filtroPesquisa['destinatario-rpps']?_this.filtroPesquisa['destinatario-rpps']:null,filtraExigenciaHomologacao:_this.filtroPesquisa&&_this.filtroPesquisa.filtraExigenciaHomologacao?_this.filtroPesquisa.filtraExigenciaHomologacao:false,tipoEntidade:_this.filtroPesquisa&&_this.filtroPesquisa.tipoEntidade?_this.filtroPesquisa.tipoEntidade:null,cliqueiNoBotao:_this.filtroPesquisa&&_this.filtroPesquisa.cliqueiNoBotao?_this.filtroPesquisa.cliqueiNoBotao:0,filtro:_this.filtroPesquisa&&_this.filtroPesquisa.filtro?_this.filtroPesquisa.filtro:null,tipoFiltroFilaGet:_this.filtroStorage&&_this.filtroStorage.tipoFiltroFilaGet?_this.filtroStorage.tipoFiltroFilaGet:null,tipoFiltroPrisma:_this.filtroPesquisa&&_this.filtroPesquisa.tipoFiltroPrisma?_this.filtroPesquisa.tipoFiltroPrisma:null,mascara:_this.filtroPesquisa&&_this.filtroPesquisa.mascara?_this.filtroPesquisa.mascara:'',dtPrismaInicio:_this.filtroPesquisa&&_this.filtroPesquisa.dtPrismaInicio?_this.filtroPesquisa.dtPrismaInicio:null,dtPrismaFim:_this.filtroPesquisa&&_this.filtroPesquisa.dtPrismaFim?_this.filtroPesquisa.dtPrismaFim:null,dtComprevInicio:_this.filtroPesquisa&&_this.filtroPesquisa.dtComprevInicio?_this.filtroPesquisa.dtComprevInicio:null,dtComprevFim:_this.filtroPesquisa&&_this.filtroPesquisa.dtComprevFim?_this.filtroPesquisa.dtComprevFim:null,especieBeneficio:_this.filtroPesquisa&&_this.filtroPesquisa.especieBeneficio?_this.filtroPesquisa.especieBeneficio:null,tipoPesquisa:_this.filtroPesquisa&&_this.filtroPesquisa.tipoPesquisa?_this.filtroPesquisa.tipoPesquisa:null,pendenteEnvio:_this.filtroPesquisa&&_this.filtroPesquisa.pendenteEnvio?_this.filtroPesquisa.pendenteEnvio:null,mensagemRetorno:_this.filtroPesquisa&&_this.filtroPesquisa.mensagemRetorno?_this.filtroPesquisa.mensagemRetorno:null,bodyEnvio:_this.filtroPesquisa&&_this.filtroPesquisa.bodyEnvio?_this.filtroPesquisa.bodyEnvio:null};return _this;}_createClass(FiltroPesquisa,[{key:'componentDidMount',value:function componentDidMount(){if(sessionStorage.getItem('filtroPesquisa')&&this.state.tipoPesquisa===this.getTipoConsulta()){this.handleSearchButton();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.tipoConsulta!==prevProps.tipoConsulta){this.preparaNovaConsulta();}else if(this.props.tipoConsulta==='exigencia'&&this.props.listaRequerimentosIndexadaAtualizada){this.handleListFilter();}}/**
   * Encaminha para as funcoes que tratam alteracoes em cada campo
   */// handleBlurCpfExigencia = () => {
//   const { cpf } = { ...this.state };
//   let paramCpf = '';
//   if (cpf) {
//     paramCpf = cpf.toUpperCase();
//     if (cpf.indexOf('_') !== -1) {
//       paramCpf = cpf.toString().replace(/_/g, '');
//     }
//   }
//   this.setState({ cpf: paramCpf });
// }
},{key:'render',value:function render(){var _this2=this;var filtrosPesquisa=this.montaFiltros();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'pesquisa',panelId:'filtro-pesquisa',icon:'ico-filter',title:'Filtro de Pesquisa'},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroPesquisa;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroPesquisa.propTypes={destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf().isRequired,handleChangeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroPesquisa);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
// class SelecaoSuperintendencia extends Component {
var SelecaoSuperintendencia=function SelecaoSuperintendencia(props){var selecaoSuperintendencia=void 0;var selecaoGex=void 0;if(!props.tipoRegime&&['analista-rgps','analista-dtp','analista-sprev','analista-dcomp'].includes(props.papelUsuarioLogado)){selecaoSuperintendencia=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{label:'Superintend\xEAncia',onChange:function onChange(e){return props.handleChange(e,'superintendencia');},value:props.superintendencia,custom:true,disabled:!props.papelUsuarioLogado==='analista-rgps'&&props.ehPapelObservadorRelatorio&&!props.tipoRegimeObservador,itemList:props.listaSuperintendencias,required:true})),props.superintendencia?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{label:'GEX',onChange:function onChange(e){return props.handleChange(e,'gex');},placeholder:'Todas',value:props.gex,itemList:props.listaGexs,custom:true})):'');}if(props.gex&&(props.papelUsuarioLogado==='analista-rgps'||props.tipoRegimeObservador===1)){selecaoGex=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{label:'APS',onChange:function onChange(e){return props.handleChange(e,'aps');},placeholder:'Todas',value:props.aps,itemList:props.listaAps,custom:true})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["f" /* DataGridCustom */],{title:props.titulo,retirarLinhaSeparadora:props.retirarLinhaSeparadora},selecaoSuperintendencia,selecaoGex);// }
};SelecaoSuperintendencia.propTypes={listaSuperintendencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tipoRegimeProprio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,listaGexs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,listaAps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,superintendencia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,gex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,aps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,titulo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,retirarLinhaSeparadora:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,tipoRegime:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,papelUsuarioLogado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,tipoRegimeObservador:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,ehPapelObservadorRelatorio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SelecaoSuperintendencia);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(240);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(82);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(79);

var _createChainableTypeChecker = __webpack_require__(133);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(84);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(86);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(140);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(143);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(50);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(51);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(28);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(316);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(34));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(142));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(321));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(323));

var _removeStyle = _interopRequireDefault(__webpack_require__(324));

var _properties = __webpack_require__(325);

var _isTransform = _interopRequireDefault(__webpack_require__(326));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(53));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}

module.exports = exports["default"];

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(349);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(45);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(96)('keys');
var uid = __webpack_require__(67);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(21);
var global = __webpack_require__(30);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(66) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 97 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 98 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(355);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(365);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(44);
var dPs = __webpack_require__(359);
var enumBugKeys = __webpack_require__(97);
var IE_PROTO = __webpack_require__(95)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(146)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(360).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(31).f;
var has = __webpack_require__(36);
var TAG = __webpack_require__(27)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(27);


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var core = __webpack_require__(21);
var LIBRARY = __webpack_require__(66);
var wksExt = __webpack_require__(102);
var defineProperty = __webpack_require__(31).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(68);
var createDesc = __webpack_require__(54);
var toIObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(91);
var has = __webpack_require__(36);
var IE8_DOM_DEFINE = __webpack_require__(145);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(35) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__ = __webpack_require__(70);












var Handle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Handle, _React$Component);

  function Handle() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Handle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clickFocused: false
    }, _this.setHandleRef = function (node) {
      _this.handle = node;
    }, _this.handleMouseUp = function () {
      if (document.activeElement === _this.handle) {
        _this.setClickFocus(true);
      }
    }, _this.handleMouseDown = function () {
      // fix https://github.com/ant-design/ant-design/issues/15324
      _this.focus();
    }, _this.handleBlur = function () {
      _this.setClickFocus(false);
    }, _this.handleKeyDown = function () {
      _this.setClickFocus(false);
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Handle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // mouseup won't trigger if mouse moved out of handle,
      // so we listen on document here.
      this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(document, 'mouseup', this.handleMouseUp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: 'setClickFocus',
    value: function setClickFocus(focused) {
      this.setState({ clickFocused: focused });
    }
  }, {
    key: 'clickFocus',
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.handle.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref2, _ref3;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          vertical = _props.vertical,
          reverse = _props.reverse,
          offset = _props.offset,
          style = _props.style,
          disabled = _props.disabled,
          min = _props.min,
          max = _props.max,
          value = _props.value,
          tabIndex = _props.tabIndex,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'vertical', 'reverse', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);

      var className = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(this.props.className, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, prefixCls + '-handle-click-focused', this.state.clickFocused));
      var positionStyle = vertical ? (_ref2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, reverse ? 'top' : 'bottom', offset + '%'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, reverse ? 'bottom' : 'top', 'auto'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, 'transform', 'translateY(+50%)'), _ref2) : (_ref3 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3, reverse ? 'right' : 'left', offset + '%'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3, reverse ? 'left' : 'right', 'auto'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3, 'transform', 'translateX(' + (reverse ? '+' : '-') + '50%)'), _ref3);
      var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, positionStyle);

      var _tabIndex = tabIndex || 0;
      if (disabled || tabIndex === null) {
        _tabIndex = null;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        ref: this.setHandleRef,
        tabIndex: _tabIndex
      }, restProps, {
        className: className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown

        // aria attribute
        , role: 'slider',
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': !!disabled
      }));
    }
  }]);

  return Handle;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Handle);


Handle.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  offset: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  min: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  tabIndex: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  reverse: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isEventFromHandle;
/* harmony export (immutable) */ __webpack_exports__["i"] = isValueOutOfRange;
/* harmony export (immutable) */ __webpack_exports__["h"] = isNotTouchEvent;
/* unused harmony export getClosestPoint */
/* unused harmony export getPrecision */
/* harmony export (immutable) */ __webpack_exports__["e"] = getMousePosition;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTouchPosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = getHandleCenterPosition;
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureValueInRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = ensureValuePrecision;
/* harmony export (immutable) */ __webpack_exports__["j"] = pauseEvent;
/* unused harmony export calculateNextValue */
/* harmony export (immutable) */ __webpack_exports__["d"] = getKeyboardValueMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__ = __webpack_require__(403);




function isEventFromHandle(e, handles) {
  try {
    return Object.keys(handles).some(function (key) {
      return e.target === Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(handles[key]);
    });
  } catch (error) {
    return false;
  }
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min,
      max = _ref2.max;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var maxSteps = Math.floor((max - min) / step);
    var steps = Math.min((val - min) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(diffs)))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

function calculateNextValue(func, value, props) {
  var operations = {
    increase: function increase(a, b) {
      return a + b;
    },
    decrease: function decrease(a, b) {
      return a - b;
    }
  };

  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
  var keyToGet = Object.keys(props.marks)[indexToGet];

  if (props.step) {
    return operations[func](value, props.step);
  } else if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
    return props.marks[keyToGet];
  }
  return value;
}

function getKeyboardValueMutator(e, vertical, reverse) {
  var increase = 'increase';
  var decrease = 'decrease';
  var method = increase;
  switch (e.keyCode) {
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].UP:
      method = vertical && reverse ? decrease : increase;break;
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].RIGHT:
      method = !vertical && reverse ? decrease : increase;break;
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].DOWN:
      method = vertical && reverse ? increase : decrease;break;
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].LEFT:
      method = !vertical && reverse ? increase : decrease;break;

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].END:
      return function (value, props) {
        return props.max;
      };
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].HOME:
      return function (value, props) {
        return props.min;
      };
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }
  return function (value, props) {
    return calculateNextValue(method, value, props);
  };
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TYPES */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DtpWizardHeader__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DtpWizardBody__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TYPES = {
  sync: 'SYNC',
  async: 'ASYNC'
};

var DtpWizard = function (_Component) {
  _inherits(DtpWizard, _Component);

  function DtpWizard(props) {
    _classCallCheck(this, DtpWizard);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.next = function () {
      var nextStepIndex = _this.state.currentStep + 1;
      _this.handleChangeStep(nextStepIndex);
    };

    _this.previous = function () {
      var previousStepIndex = _this.state.currentStep - 1;
      previousStepIndex = previousStepIndex < 0 ? 0 : previousStepIndex;
      _this.handleChangeStep(previousStepIndex);
    };

    _this.handleChangeStep = function (stepIndex) {
      var _this$props = _this.props,
          validate = _this$props.validate,
          type = _this$props.type,
          showErrors = _this$props.showErrors,
          onChange = _this$props.onChange,
          wizardItens = _this$props.wizardItens;

      var isSync = type && type === TYPES.sync;
      var currentStep = _this.state.currentStep;

      var hasError = !validate();
      var isShowErrors = false;

      var newStepIndex = currentStep;

      if (!isSync) {
        newStepIndex = stepIndex;
        isShowErrors = true;
      } else {
        if (stepIndex < currentStep || stepIndex === currentStep) {
          newStepIndex = stepIndex;
          isShowErrors = false;
        } else {
          if (hasError === true) {
            isShowErrors = true;
            newStepIndex = currentStep;
          } else {
            if (!(stepIndex > currentStep + 1)) {
              newStepIndex = stepIndex;
              var executeOnNext = wizardItens[currentStep].executeOnNext;
              executeOnNext && executeOnNext();
            }
          }
        }
      }

      var stepsWithError = _this.state.stepsWithError;

      if (hasError) {
        if (stepsWithError.indexOf(currentStep) === -1) {
          stepsWithError.push(currentStep);
        }
        if (isShowErrors === true) {
          showErrors();
        }
      } else {
        var errorIndex = stepsWithError.indexOf(currentStep);
        if (errorIndex !== -1) {
          stepsWithError.splice(errorIndex);
        }
      }

      _this.setState({ currentStep: newStepIndex, stepsWithError: stepsWithError });
      if (onChange) {
        onChange(newStepIndex);
      }
    };

    _this.showPreviousButton = function () {
      if (_this.state.currentStep === 0) {
        return false;
      }return true;
    };

    _this.showNextButton = function () {
      if (_this.state.currentStep === _this.props.wizardItens.length - 1) {
        return false;
      }return true;
    };

    _this.hasError = function (index) {
      return _this.state.stepsWithError.indexOf(index) !== -1 ? true : false;
    };

    _this.state = {
      currentStep: props.currentStep,
      stepsWithError: []
    };

    _this.handleChangeStep = _this.handleChangeStep.bind(_this);
    return _this;
  }

  DtpWizard.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        navigateOnStepClick = _props.navigateOnStepClick,
        type = _props.type,
        usePanel = _props.usePanel,
        wizardItens = _props.wizardItens,
        info = _props.info,
        useNextPrevButtons = _props.useNextPrevButtons;

    var stateCurrentStep = this.state.currentStep;
    var propsCurrentStep = this.props.currentStep;
    var currentStep = stateCurrentStep;

    var headers = this.props.wizardItens.map(function (item, index) {
      return _extends({
        hasError: _this2.hasError(index)
      }, item);
    });

    if (propsCurrentStep !== undefined && propsCurrentStep !== stateCurrentStep) {
      currentStep = propsCurrentStep;
      this.setState({
        currentStep: currentStep
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('dtp-wizard', 'with-header-lg') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DtpWizardHeader__["a" /* default */], {
        navigateOnStepClick: navigateOnStepClick,
        type: type,
        headers: headers,
        onChangeStep: this.handleChangeStep,
        currentStep: currentStep,
        info: info }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DtpWizardBody__["a" /* default */], {
        usePanel: usePanel,
        wizardItens: wizardItens,
        currentStep: currentStep,
        previous: this.showPreviousButton() ? this.previous : null,
        next: this.showNextButton() ? this.next : null,
        useNextPrevButtons: useNextPrevButtons })
    );
  };

  return DtpWizard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpWizard.TYPES = {
  sync: 'SYNC',
  async: 'ASYNC'
};

DtpWizard.propTypes =  false ? {
  /** <b>Identifica</b> o que se faz necessario para a criacao de um step */
  wizardItens: PropTypes.arrayOf(PropTypes.shape({
    /** Descricao para o header */
    description: PropTypes.string.isRequired,

    /** Componente a ser renderizado quando o step for chamado */
    component: PropTypes.element.isRequired,

    /** Funcao a ser executada quando o clique do botao Proximo referenciar o step a ser visto */
    executeOnNext: PropTypes.func
  })).isRequired,

  /** Funcao que sinaliza para o wizard a possibilidade de avancar o step */
  validate: PropTypes.func.isRequired,

  /** Funcao que trata os possiveis erros */
  showErrors: PropTypes.func.isRequired,

  /** Atributo que escolhe o step a ser renderizado */
  currentStep: PropTypes.number.isRequired,

  /** Funcao que passa o controle da atualizacao do currentStep para quem o instanciar */
  onChange: PropTypes.func.isRequired,

  /** Define se é um wizard síncrono ou assíncrono */
  type: PropTypes.oneOf([TYPES.sync, TYPES.async]).isRequired,

  /** Atributo que define se é possível navegar ao clicar em uma das etapas do wizard */
  navigateOnStepClick: PropTypes.bool.isRequired,

  /** Define se usará o DtpPanel para englobar o conteúdo dos steps */
  usePanel: PropTypes.bool.isRequired,

  /**
   * Define as informações que serão exibidas no canto direito do header do wizard.
   * No wizard síncrono são exibidas as informações de line1 e line2 enquanto no
   * wizard assíncrono são exibidas as três linhas.
   */
  info: PropTypes.shape({
    line1: PropTypes.string,
    line2: PropTypes.string,
    line3: PropTypes.string
  }),

  useNextPrevButtons: PropTypes.bool.isRequired
} : {};

DtpWizard.defaultProps = {
  navigateOnStepClick: true,
  usePanel: true,
  useNextPrevButtons: true
};

/* harmony default export */ __webpack_exports__["a"] = (DtpWizard);

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.sAlertTools = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    var actualGlobalConfig = void 0;

    var sAlertTools = {
        randomId: function randomId() {
            return Math.random().toString(36).split('.')[1];
        },
        returnFirstDefined: function returnFirstDefined() {
            var value = void 0;
            var i = void 0;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            for (i = 0; i < args.length; i++) {
                if (typeof args[i] !== 'undefined') {
                    value = args[i];
                    break;
                }
            }
            return value;
        },
        styleToObj: function styleToObj(input) {
            var result = {},
                i = void 0,
                entry = void 0,
                attributes = input && input.split(';').filter(Boolean);

            for (i = 0; i < attributes.length; i++) {
                entry = attributes[i].split(':');
                result[entry.splice(0, 1)[0].trim()] = entry.join(':').trim();
            }
            return result;
        },
        setGlobalConfig: function setGlobalConfig(config) {
            if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
                actualGlobalConfig = config;
            }
        },
        getGlobalConfig: function getGlobalConfig() {
            return actualGlobalConfig;
        }
    };

    exports.default = sAlertTools;
});

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.sAlertStore = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                arr2[i] = arr[i];
            }

            return arr2;
        } else {
            return Array.from(arr);
        }
    }

    // custom simple store based on a awesome Redux library https://github.com/rackt/redux

    var createSAlertStore = function createSAlertStore(reducer) {
        var state = void 0;
        var listeners = [];
        var getState = function getState() {
            return state;
        };
        var dispatch = function dispatch(action) {
            state = reducer(state, action);
            listeners.forEach(function (listener) {
                return listener();
            });
        };
        var subscribe = function subscribe(listener) {
            listeners.push(listener);
            return function () {
                listeners = listeners.filter(function (l) {
                    return l !== listener;
                });
            };
        };
        dispatch({});
        return {
            getState: getState, dispatch: dispatch, subscribe: subscribe
        };
    };

    var insert = function insert(state, action) {
        return [].concat(_toConsumableArray(state), [action.data]);
    };

    var remove = function remove(state, action) {
        var elemToRemoveArray = state.slice().filter(function (item) {
            return item.id === action.data.id;
        });
        if (Array.isArray(elemToRemoveArray)) {
            var elemToRemoveIndex = state.indexOf(elemToRemoveArray[0]);
            return [].concat(_toConsumableArray(state.slice(0, elemToRemoveIndex)), _toConsumableArray(state.slice(elemToRemoveIndex + 1)));
        }
        return state;
    };

    var alertsReducer = function alertsReducer() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var action = arguments[1];

        switch (action.type) {
            case 'INSERT':
                return insert(state, action);
            case 'REMOVE':
                return remove(state, action);
            case 'REMOVEALL':
                return [];
            default:
                return state;
        }
    };

    var sAlertStore = createSAlertStore(alertsReducer);

    exports.default = sAlertStore;
});

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(461);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(499);


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(190)(module)))

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(22);
var normalizeHeaderName = __webpack_require__(538);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(199);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(199);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191)))

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalRejeicaoRequerimento=function(_Component){_inherits(ModalRejeicaoRequerimento,_Component);function ModalRejeicaoRequerimento(props){_classCallCheck(this,ModalRejeicaoRequerimento);var _this=_possibleConstructorReturn(this,(ModalRejeicaoRequerimento.__proto__||Object.getPrototypeOf(ModalRejeicaoRequerimento)).call(this,props));_this.getInitialState=function(){var initialState={requerimento:{exigencias:[],justificativaRejeicao:null}};return initialState;};_this.atualizaRequerimento=function(){var _this$props=Object.assign({},_this.props),requerimento=_this$props.requerimento;_this.setState(Object.assign({},_this.state,{requerimento:requerimento}));};_this.handleChange=function(changeObj,name){_this.setState({requerimento:Object.assign({},_this.state.requerimento,_defineProperty({},name,changeObj.value))});};_this.trataSucessoResponseEnvio=function(){_this.props.handleRejeicaoRequerimentoSent();};_this.trataErrosResponse=function(error){// eslint-disable-next-line
console.log(error);};_this.diffRequerimento=function(tipoRequerimento){if(tipoRequerimento===2){return'pensao';}return'aposentadoria';};_this.handleSave=function(){var _this$state=Object.assign({},_this.state),requerimento=_this$state.requerimento;var _this$props2=Object.assign({},_this.props),acao=_this$props2.acao;var _this$props3=Object.assign({},_this.props),rejeitar=_this$props3.rejeitar;var tipo=_this.diffRequerimento(_this.props.tipoRequerimento);requerimento.estado=14;if(acao==='salvarERejeitar'){_this.props.handleSalvarERejeitar(_this.state.requerimento.motivo,_this.state.requerimento.justificativaRejeicao);}else{var url='requerimentos-compensacao-'+tipo+'/'+requerimento.protocolo;if(rejeitar){url='requerimentos-compensacao-'+tipo+'/rejeitar/'+requerimento.protocolo;}Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["n" /* doPut */])(url,requerimento,_this.trataSucessoResponseEnvio,_this.trataErrosResponse);}};_this.filtraExigencias=function(){if(_this.props.requerimento.exigencias){return _this.props.requerimento.exigencias.filter(function(exigencia){return!__WEBPACK_IMPORTED_MODULE_5__utils_constants__["A" /* tiposExigenciaSistema */].includes(exigencia.tipo);});}return'';};_this.handlePositionalChange=function(changeObj,name,tipoExigencia){// console.log(tipoExigencia);
var listaExigenciasModificada=_this.state.requerimento.exigencias.map(function(exigencia,index){if(tipoExigencia===exigencia.tipo){var exigenciaAlterada=_this.state.requerimento.exigencias[index];exigenciaAlterada[name]=changeObj.value;var atendida=0;if(exigenciaAlterada.motivoNaoAtendimento!==0||exigenciaAlterada.comentarioNaoAtendimento!==''){atendida=2;}exigenciaAlterada.atendida=atendida;return exigenciaAlterada;}return _this.state.requerimento.exigencias[index];});_this.setState({requerimento:Object.assign({},_this.state.requerimento,{exigencias:listaExigenciasModificada})});};_this.doRequest=function(typeRequest){switch(typeRequest){case'exigencia':if(_this.props.exigencias.length===0){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["r" /* requestExigencias */])(_this.failCallback);}break;case'motivo':if(_this.props.motivosRejeicao.length===0){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["u" /* requestMotivos */])(_this.failCallback);}break;default:break;}};_this.buscaDadosDeDominio=function(){if(_this.props.motivosRejeicao.length===0){_this.doRequest('motivo');return null;}return null;};_this.retornaTamanhoExigencias=function(){var colecao=[];if(_this.props.requerimento.exigencias){colecao=_this.props.requerimento.exigencias.filter(function(exigencia){return!__WEBPACK_IMPORTED_MODULE_5__utils_constants__["A" /* tiposExigenciaSistema */].includes(exigencia.tipo);});}return colecao.length;};_this.modalRejeicaoRequerimentoContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{number:true,itemList:_this.recuperarListaMotivos(),label:'Motivo da rejei\xE7\xE3o',onChange:function onChange(e){return _this.handleChange(e,'motivo');},placeholder:'Selecione o Motivo',value:_this.state.requerimento.motivo,custom:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{cols:'80',componentClass:'textarea',label:'Justificativa',maxlength:'630',onChange:function onChange(e){return _this.handleChange(e,'justificativaRejeicao');},rows:'5',value:_this.state.requerimento.justificativaRejeicao,textarea:true})));};_this.modalRejeicaoRequerimentoFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{className:'dtp-primary',hint:'Rejeitar o requerimento',onClick:_this.handleSave,title:'Confirmar'})));};_this.handleClose=function(){_this.props.handleModal('showRejeicaoRequerimentoModal');};var state=_this.getInitialState();if(props.requerimento){state.requerimento=props.requerimento;}_this.state=state;return _this;}_createClass(ModalRejeicaoRequerimento,[{key:'componentDidMount',value:function componentDidMount(){this.buscaDadosDeDominio();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Preenche requerimento se requerimento for alterado
if(this.props.requerimento&&this.props.requerimento.protocolo!==prevProps.requerimento.protocolo){this.atualizaRequerimento();}}},{key:'recuperarListaMotivos',value:function recuperarListaMotivos(){var _this2=this;var _props=Object.assign({},this.props),acao=_props.acao;// ACAO IGUAL A UNDEFINED VEIO DA TELA DE CONSULTA DE EXIGENCIAS, RECUPERAR O SOLIC. E O DESTINATARIO DO OBJ REQUERIMENTO
var isSolicitanteRGPS=this.props.requerimento.solicitante==='01000';var isDestinatarioRGPS=this.props.requerimento.destinatario==='01000';if(acao===undefined||this.props.rejeitar){isSolicitanteRGPS=this.props.requerimento.solicitante.codigo==='01000';isDestinatarioRGPS=this.props.requerimento.destinatario.codigo==='01000';}var rgpsNaRelacao=isSolicitanteRGPS||isDestinatarioRGPS?1:2;var reqRegimeAplicado=isSolicitanteRGPS?1:2;var motivosRejeicaoFiltrados=[];this.props.motivosRejeicao.forEach(function(motivo){if((motivo.regimeAplicavel===3||motivo.regimeAplicavel===reqRegimeAplicado)&&motivo.abrangenciaAplicavel===_this2.props.tipoRequerimento&&(motivo.acordoAplicavel===3||motivo.acordoAplicavel===rgpsNaRelacao)){motivosRejeicaoFiltrados.push(motivo);}});return motivosRejeicaoFiltrados;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalRejeicaoRequerimentoFooter(),conteudomodal:this.modalRejeicaoRequerimentoContent(),onHide:this.handleClose,size:'md',showModal:true,title:'Rejei\xE7\xE3o do Requerimento'}));}}]);return ModalRejeicaoRequerimento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalRejeicaoRequerimento.propTypes={acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,requerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleRejeicaoRequerimentoSent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSalvarERejeitar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,motivosRejeicao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),rejeitar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}.isRequired;var mapStateToProps=function mapStateToProps(state){return{motivosRejeicao:state.base.motivosRejeicao};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ModalRejeicaoRequerimento));

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var validarCNPJ=function validarCNPJ(paramCnpj){// if (paramCnpj) {
//   const cnpj = paramCnpj.replace(/[^\d]+/g, '');
//   if (cnpj.length !== 14) {
//     return false;
//   }
//   if (/^(\d)\1+$/.test(cnpj)) {
//     return false;
//   }
//   const t = cnpj.length - 2;
//   const d = cnpj.substring(t);
//   // eslint-disable-next-line
//   const d1 = parseInt(d.charAt(0));
//   // eslint-disable-next-line
//   const d2 = parseInt(d.charAt(1));
//   const calc = (x) => {
//     const n = cnpj.substring(0, x);
//     let y = x - 7;
//     let s = 0;
//     let r = 0;
//     // eslint-disable-next-line
//     for (let i = x; i >= 1; i--) {
//       // eslint-disable-next-line
//       s += n.charAt(x - i) * y--;
//       if (y < 2) {
//         y = 9;
//       }
//     }
//     // eslint-disable-next-line
//     r = 11 - s % 11;
//     return r > 9 ? 0 : r;
//   };
//   return calc(t) === d1 && calc(t + 1) === d2;
// }
// return true;
if(paramCnpj){var cnpj=paramCnpj.replace(/[^a-zA-Z0-9]/g,'').toUpperCase();if(cnpj.length!==14)return false;if(cnpj==='00000000000000')return false;if(!/^([A-Z\d]){12}(\d){2}$/.test(cnpj))return false;var valorBase='0'.charCodeAt(0);var pesosDV=[6,5,4,3,2,9,8,7,6,5,4,3,2];var somatorioDV1=0;var somatorioDV2=0;for(var i=0;i<12;i+=1){var asciiDigito=cnpj.charCodeAt(i)-valorBase;somatorioDV1+=asciiDigito*pesosDV[i+1];somatorioDV2+=asciiDigito*pesosDV[i];}var dv1=somatorioDV1%11<2?0:11-somatorioDV1%11;somatorioDV2+=dv1*pesosDV[12];var dv2=somatorioDV2%11<2?0:11-somatorioDV2%11;return cnpj.substring(12)===''+dv1+dv2;}return true;};/* harmony default export */ __webpack_exports__["a"] = (validarCNPJ);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(225);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(121);










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* unused harmony export compose */
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(245);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers);
  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(125);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(76);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(130);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(83);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(265)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DtpFormControlFeedback = function (_Component) {
    _inherits(DtpFormControlFeedback, _Component);

    function DtpFormControlFeedback() {
        _classCallCheck(this, DtpFormControlFeedback);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpFormControlFeedback.prototype.getIcon = function getIcon(validationState) {
        switch (validationState) {
            case 'success':
                return this.props.successIconClass;
            case 'warning':
                return this.props.warningIconClass;
            case 'error':
                return this.props.errorIconClass;
            case 'info':
                return this.props.infoIconClass;
            default:
                return null;
        }
    };

    DtpFormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, elementProps) {
        var ico = this.getIcon(formGroup && formGroup.validationState);
        if (!ico) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', _extends({}, elementProps, {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-form-control-feedback', className, ico) }));
    };

    DtpFormControlFeedback.prototype.render = function render() {
        var _props = this.props,
            className = _props.className,
            children = _props.children,
            props = _objectWithoutProperties(_props, ['className', 'children']);

        var formGroup = this.context.$dtp_formGroup;

        if (formGroup && !formGroup.getUseFeedback()) {
            return null;
        }

        if (!children) {
            return this.renderDefaultFeedback.apply(this, [formGroup, className].concat(props));
        }

        var child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, props, {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a.apply(undefined, [child.props.className, className].concat(props))
        }));
    };

    return DtpFormControlFeedback;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpFormControlFeedback.propTypes =  false ? {
    /** Classe CSS contendo o ícone a ser exibido para a contexto 'success' */
    successIconClass: PropTypes.string,

    /** Classe CSS contendo o ícone a ser exibido para a contexto 'info' */
    infoIconClass: PropTypes.string,

    /** Classe CSS contendo o ícone a ser exibido para a contexto 'error' */
    errorIconClass: PropTypes.string,

    /** Classe CSS contendo o ícone a ser exibido para a contexto 'warning' */
    warningIconClass: PropTypes.string
} : {};

DtpFormControlFeedback.defaultProps = {
    successIconClass: 'ico-confirm',
    infoIconClass: 'ico-chat',
    errorIconClass: 'ico-alert-t',
    warningIconClass: 'ico-cancel'
};

DtpFormControlFeedback.contextTypes = {
    $dtp_formGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (DtpFormControlFeedback);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DtpForm_DtpFormControl__ = __webpack_require__(62);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DtpInputMask = function (_Component) {
    _inherits(DtpInputMask, _Component);

    function DtpInputMask() {
        _classCallCheck(this, DtpInputMask);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpInputMask.prototype.renderInputMask = function renderInputMask(ref, props) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DtpForm_DtpFormControl__["a" /* default */], _extends({
            inputRef: ref,
            ref: function ref(input) {
                if (input) {
                    _this2.formControl = input;
                }
            }
        }, props));
    };

    DtpInputMask.prototype.handleFocus = function handleFocus() {
        this.formControl.handleFocus();
    };

    DtpInputMask.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, _extends({
            render: this.renderInputMask.bind(this)
        }, this.props));
    };

    return DtpInputMask;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpInputMask.defaultProps = {
    guide: true,
    placeholderChar: '_',
    keepCharPositions: false,
    showMask: true
};

DtpInputMask.propTypes =  false ? {
    /** Aceita uma string contendo classes CSS que serão incluídas no atributo HTML `class` do componente. Por padrão, inclui a classe `dtp-form-control`.  Se for informado algum valor nesse atributo, o valor padrão será sobrescrito */
    className: PropTypes.string,

    /** Aceita um array ou uma função que define como o valor do input será mascarado */
    mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,

    /** Informa o componente de estar no modo *com guia* ou *sem guia*. Quando <code>guide</code> é <code>true</code> sempre é exibido o caractere de placeholder nos locais onde o usuário pode digitar. */
    guide: PropTypes.bool,

    /** Caractere que será exibido quando o valor esperado não tiver sido preenchido */
    placeholderChar: PropTypes.string,

    /** Quando <code>true</code>, adicionar ou excluir caracteres não afetará as posições de caracteres existentes. */
    keepCharPositions: PropTypes.bool,

    /** Você pode fornecer uma função `pipe` que lhe dará a oportunidade de modificar
     * o valor mascarado antes de ser exibido na tela. A função `pipe` recebe os parâmetros
     * `conformedValue` e `config`. O `conformedValue` é o valor que o usuário inseriu
     * depoisde ter sido mascarado. `config` é um objeto que contém todas as configurações
     * do componente (props do componente DtpInputMask). A função `pipe` deve retornar uma
     * das seguintes opções:` false`, `string` ou `object`. Retornar `false` para rejeitar
     * o novo valor marcarado e evitar que o campo de entrada mude. Se o `pipe` modifica a
     * seqüência de caracteres sem adicionar novos caracteres, por exemplo, alterando
     * maiúsculas de letras ou removendo caracteres, ele deve retornar a seqüência modificada.
     * Se o `pipe` adicionar novos caracteres à string, ele deve retornar um objeto com as
     * seguintes chaves: `value`, a nova string e `indexesOfPipedChars`, uma matriz de números
     * inteiros, que contém os índices de todos os caracteres que foram adicionados pelo
     * `pipe` ao valor mascarado. */
    pipe: PropTypes.func,

    /** é um booleano que informa o componente para exibir a máscara como placeholder no lugar do placeholder regular quando o valor do elemento de entrada está vazio. */
    showMask: PropTypes.bool,

    /** Valor que será exibido no input */
    value: PropTypes.string.isRequired,

    /** Função que será executada quando o valor do input for alterado */
    onChange: PropTypes.func
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpInputMask);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var DtpPanel = function DtpPanel(props) {
    var className = props.className,
        title = props.title,
        heading = props.heading,
        children = props.children,
        footer = props.footer;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'dtp-panel ' + className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-panel-heading' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                { className: 'dtp-panel-title' },
                title
            ),
            heading
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-panel-body' },
            children
        ),
        footer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-panel-footer' },
            footer
        )
    );
};

DtpPanel.propTypes =  false ? {
    /** 
     * Aceita uma string contendo classes CSS que serão incluídas no atributo HTML `class` da tag div raiz do componente.
     * Por padrão, inclui a classe `dtp-panel`. As classes que podem ser incluídas são as classes contextuais:
     * `dtp-primary`, `dtp-default` ou `dtp-inverse`.
     */
    className: PropTypes.oneOf(['dtp-primary', 'dtp-default', 'dtp-inverse']),

    /** Título do painel */
    title: PropTypes.string,

    /** Permite passar um conteúdo ao header do painel */
    heading: PropTypes.element,

    /** Conteúdo do painel */
    children: PropTypes.any.isRequired,

    /** Conteúdo do rodapé */
    footer: PropTypes.element
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpPanel);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DtpButton__ = __webpack_require__(49);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var DtpButtonFab = function DtpButtonFab(props) {
    var className = props.className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DtpButton__["a" /* default */], _extends({}, props, {
        className: 'dtp-btn-fab ' + className
    }));
};

/* harmony default export */ __webpack_exports__["a"] = (DtpButtonFab);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAGE; });
/* unused harmony export SECTION */
/* unused harmony export LIGHT_34 */
/* unused harmony export LIGHT_48 */
/* unused harmony export LIGHT_56 */
/* unused harmony export LIGHT_72 */
/* unused harmony export LIGHT_120 */
/* unused harmony export SEMI_BOLD_12 */
/* unused harmony export SEMI_BOLD_14 */
/* unused harmony export SEMI_BOLD_15 */
/* unused harmony export SEMI_BOLD_18 */
/* unused harmony export SEMI_BOLD_20 */
/* unused harmony export SEMI_BOLD_42 */
/* unused harmony export REGULAR_10 */
/* unused harmony export REGULAR_12 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REGULAR_16; });
/* unused harmony export REGULAR_28 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var PAGE = 'page';
var SECTION = 'section';
var LIGHT_34 = 'light-34';
var LIGHT_48 = 'light-48';
var LIGHT_56 = 'light-56';
var LIGHT_72 = 'light-72';
var LIGHT_120 = 'light-120';
var SEMI_BOLD_12 = 'semibold-12';
var SEMI_BOLD_14 = 'semibold-14';
var SEMI_BOLD_15 = 'semibold-15';
var SEMI_BOLD_18 = 'semibold-18';
var SEMI_BOLD_20 = 'semibold-20';
var SEMI_BOLD_42 = 'semibold-42';
var REGULAR_10 = 'regular-10';
var REGULAR_12 = 'regular-12';
var REGULAR_16 = 'regular-16';
var REGULAR_28 = 'regular-28';

var DtpTitle = function (_Component) {
    _inherits(DtpTitle, _Component);

    function DtpTitle() {
        _classCallCheck(this, DtpTitle);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpTitle.prototype.render = function render() {
        var _props = this.props,
            type = _props.type,
            fontWeight = _props.fontWeight,
            title = _props.title;


        var titleContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-' + type + '-title', 'aria-hidden': 'true' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: fontWeight },
                title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        );

        if (type === PAGE) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h1',
                { className: 'dtp-title' },
                titleContent
            );
        } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: 'dtp-title' },
                titleContent
            );
        }
    };

    return DtpTitle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpTitle.propTypes =  false ? {
    /** String contendo o texto a ser exibido no título */
    title: PropTypes.string.isRequired,

    /** Atributo que define o tipo do título */
    type: PropTypes.oneOf([PAGE, SECTION]),

    /** Espessura da fonte do título */
    fontWeight: PropTypes.oneOf([LIGHT_34, LIGHT_48, LIGHT_56, LIGHT_72, LIGHT_120, REGULAR_10, REGULAR_12, REGULAR_16, REGULAR_28, SEMI_BOLD_12, SEMI_BOLD_14, SEMI_BOLD_15, SEMI_BOLD_18, SEMI_BOLD_20, SEMI_BOLD_42])
} : {};

DtpTitle.defaultProps = {
    type: PAGE,
    fontWeight: REGULAR_16
};

/* harmony default export */ __webpack_exports__["c"] = (DtpTitle);

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.5.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2020-05-04T22:49Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.5.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( _i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.5
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2020-03-14
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px";
				tr.style.height = "1px";
				trChild.style.height = "9px";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = (
					dataPriv.get( cur, "events" ) || Object.create( null )
				)[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script
			if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			if ( typeof props.top === "number" ) {
				props.top += "px";
			}
			if ( typeof props.left === "number" ) {
				props.left += "px";
			}
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(50);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(317);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(51);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(28);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = offsetParent;

var _ownerDocument = _interopRequireDefault(__webpack_require__(42));

var _style = _interopRequireDefault(__webpack_require__(88));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}

module.exports = exports["default"];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(320));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(87);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(64);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(28);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DtpListLinkItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DtpListLinkItem = function (_Component) {
    _inherits(DtpListLinkItem, _Component);

    function DtpListLinkItem() {
        _classCallCheck(this, DtpListLinkItem);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpListLinkItem.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: this.props.active ? "dtp-list-link-item selectable" : "dtp-list-link-item" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "dtp-list-link-item-content" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { className: "dtp-list-link-item-label", key: this.props.keyItem },
                    this.props.itemLabel
                ),
                this.props.itemSubLabel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    this.props.itemSubLabel
                )
            ),
            this.props.active && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "dtp-list-link-item-ico-link" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "ico-carret-right" })
            )
        );
    };

    return DtpListLinkItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);



/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(35) && !__webpack_require__(46)(function () {
  return Object.defineProperty(__webpack_require__(146)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(45);
var document = __webpack_require__(30).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(36);
var toIObject = __webpack_require__(37);
var arrayIndexOf = __webpack_require__(351)(false);
var IE_PROTO = __webpack_require__(95)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(92);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(94);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(353), __esModule: true };

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(357)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(152)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(66);
var $export = __webpack_require__(29);
var redefine = __webpack_require__(153);
var hide = __webpack_require__(43);
var Iterators = __webpack_require__(55);
var $iterCreate = __webpack_require__(358);
var setToStringTag = __webpack_require__(101);
var getPrototypeOf = __webpack_require__(154);
var ITERATOR = __webpack_require__(27)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(43);


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(36);
var toObject = __webpack_require__(69);
var IE_PROTO = __webpack_require__(95)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(147);
var hiddenKeys = __webpack_require__(97).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);


/* eslint-disable react/prop-types */


var Track = function Track(props) {
  var _ref, _ref2;

  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style,
      reverse = props.reverse;

  var positonStyle = vertical ? (_ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, reverse ? 'top' : 'bottom', offset + '%'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, reverse ? 'bottom' : 'top', 'auto'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'height', length + '%'), _ref) : (_ref2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, reverse ? 'right' : 'left', offset + '%'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, reverse ? 'left' : 'right', 'auto'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref2, 'width', length + '%'), _ref2);

  var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, positonStyle);
  return included ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: className, style: elStyle }) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (Track);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSlider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Steps__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Marks__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Handle__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(107);


















function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ComponentEnhancer);

      var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["e" /* getMousePosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.removeDocumentEvents();
        _this.onStart(position);
        _this.addDocumentMouseEvents();
      };

      _this.onTouchStart = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_16__utils__["h" /* isNotTouchEvent */](e)) return;

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["f" /* getTouchPosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        __WEBPACK_IMPORTED_MODULE_16__utils__["j" /* pauseEvent */](e);
      };

      _this.onFocus = function (e) {
        var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            vertical = _this$props.vertical;

        if (__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getHandleCenterPosition */](vertical, e.target);
          _this.dragOffset = 0;
          _this.onStart(handlePosition);
          __WEBPACK_IMPORTED_MODULE_16__utils__["j" /* pauseEvent */](e);
          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        _this.onEnd();
        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseUp = function () {
        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["e" /* getMousePosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_16__utils__["h" /* isNotTouchEvent */](e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["f" /* getTouchPosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && __WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.onClickMarkLabel = function (e, value) {
        e.stopPropagation();
        _this.onChange({ value: value });
        _this.setState({ value: value }, function () {
          return _this.onEnd(true);
        });
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      var step = props.step,
          max = props.max,
          min = props.min;

      var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
      __WEBPACK_IMPORTED_MODULE_12_warning___default()(step && Math.floor(step) === step ? isPointDiffEven : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      _this.handlesRefs = {};
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ComponentEnhancer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // Snapshot testing cannot handle refs, so be sure to null-check this.
        this.document = this.sliderRef && this.sliderRef.ownerDocument;

        var _props = this.props,
            autoFocus = _props.autoFocus,
            disabled = _props.disabled;

        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: 'getSliderStart',
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var _props2 = this.props,
            vertical = _props2.vertical,
            reverse = _props2.reverse;

        var rect = slider.getBoundingClientRect();
        if (vertical) {
          return reverse ? rect.bottom : rect.top;
        }
        return window.pageXOffset + (reverse ? rect.right : rect.left);
      }
    }, {
      key: 'getSliderLength',
      value: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: 'addDocumentTouchEvents',
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchend', this.onEnd);
      }
    }, {
      key: 'addDocumentMouseEvents',
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mouseup', this.onEnd);
      }
    }, {
      key: 'removeDocumentEvents',
      value: function removeDocumentEvents() {
        /* eslint-disable no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();

        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (!this.props.disabled) {
          this.handlesRefs[0].focus();
        }
      }
    }, {
      key: 'blur',
      value: function blur() {
        var _this2 = this;

        if (!this.props.disabled) {
          Object.keys(this.handlesRefs).forEach(function (key) {
            if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
              _this2.handlesRefs[key].blur();
            }
          });
        }
      }
    }, {
      key: 'calcValue',
      value: function calcValue(offset) {
        var _props3 = this.props,
            vertical = _props3.vertical,
            min = _props3.min,
            max = _props3.max;

        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: 'calcValueByPos',
      value: function calcValueByPos(position) {
        var sign = this.props.reverse ? -1 : +1;
        var pixelOffset = sign * (position - this.getSliderStart());
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: 'calcOffset',
      value: function calcOffset(value) {
        var _props4 = this.props,
            min = _props4.min,
            max = _props4.max;

        var ratio = (value - min) / (max - min);
        return ratio * 100;
      }
    }, {
      key: 'saveHandle',
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _props5 = this.props,
            prefixCls = _props5.prefixCls,
            className = _props5.className,
            marks = _props5.marks,
            dots = _props5.dots,
            step = _props5.step,
            included = _props5.included,
            disabled = _props5.disabled,
            vertical = _props5.vertical,
            reverse = _props5.reverse,
            min = _props5.min,
            max = _props5.max,
            children = _props5.children,
            maximumTrackStyle = _props5.maximumTrackStyle,
            style = _props5.style,
            railStyle = _props5.railStyle,
            dotStyle = _props5.dotStyle,
            activeDotStyle = _props5.activeDotStyle;

        var _get$call = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(prefixCls, (_classNames = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-vertical', vertical), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'div',
          {
            ref: this.saveSlider,
            className: sliderClassName,
            onTouchStart: disabled ? noop : this.onTouchStart,
            onMouseDown: disabled ? noop : this.onMouseDown,
            onMouseUp: disabled ? noop : this.onMouseUp,
            onKeyDown: disabled ? noop : this.onKeyDown,
            onFocus: disabled ? noop : this.onFocus,
            onBlur: disabled ? noop : this.onBlur,
            style: style
          },
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
            className: prefixCls + '-rail',
            style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, maximumTrackStyle, railStyle)
          }),
          tracks,
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Steps__["a" /* default */], {
            prefixCls: prefixCls,
            vertical: vertical,
            reverse: reverse,
            marks: marks,
            dots: dots,
            step: step,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            dotStyle: dotStyle,
            activeDotStyle: activeDotStyle
          }),
          handles,
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Marks__["a" /* default */], {
            className: prefixCls + '-mark',
            onClickLabel: disabled ? noop : this.onClickMarkLabel,
            vertical: vertical,
            marks: marks,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            reverse: reverse
          }),
          children
        );
      }
    }]);

    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.propTypes, {
    min: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    max: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    step: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    marks: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    included: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    className: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    prefixCls: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any,
    onBeforeChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onAfterChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    handle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    dots: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    vertical: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    reverse: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    minimumTrackStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, // just for compatibility, will be deperecate
    maximumTrackStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, // just for compatibility, will be deperecate
    handleStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object)]),
    trackStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object)]),
    railStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    dotStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    activeDotStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    autoFocus: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    onFocus: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
  }), _class.defaultProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['index']);

      delete restProps.dragging;
      if (restProps.value === null) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    reverse: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _temp;
}

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(29);
var core = __webpack_require__(21);
var fails = __webpack_require__(46);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(394);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizePerPageDropDown = exports.ButtonGroup = exports.SearchField = exports.ClearSearchButton = exports.ExportCSVButton = exports.ShowSelectedOnlyButton = exports.DeleteButton = exports.InsertButton = exports.InsertModalFooter = exports.InsertModalBody = exports.InsertModalHeader = exports.TableHeaderColumn = exports.BootstrapTable = undefined;

var _BootstrapTable = __webpack_require__(434);

var _BootstrapTable2 = _interopRequireDefault(_BootstrapTable);

var _TableHeaderColumn = __webpack_require__(168);

var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);

var _InsertModalHeader = __webpack_require__(175);

var _InsertModalHeader2 = _interopRequireDefault(_InsertModalHeader);

var _InsertModalBody = __webpack_require__(177);

var _InsertModalBody2 = _interopRequireDefault(_InsertModalBody);

var _InsertModalFooter = __webpack_require__(176);

var _InsertModalFooter2 = _interopRequireDefault(_InsertModalFooter);

var _InsertButton = __webpack_require__(178);

var _InsertButton2 = _interopRequireDefault(_InsertButton);

var _DeleteButton = __webpack_require__(179);

var _DeleteButton2 = _interopRequireDefault(_DeleteButton);

var _ExportCSVButton = __webpack_require__(180);

var _ExportCSVButton2 = _interopRequireDefault(_ExportCSVButton);

var _ShowSelectedOnlyButton = __webpack_require__(181);

var _ShowSelectedOnlyButton2 = _interopRequireDefault(_ShowSelectedOnlyButton);

var _ClearSearchButton = __webpack_require__(183);

var _ClearSearchButton2 = _interopRequireDefault(_ClearSearchButton);

var _SearchField = __webpack_require__(182);

var _SearchField2 = _interopRequireDefault(_SearchField);

var _ButtonGroup = __webpack_require__(473);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _SizePerPageDropDown = __webpack_require__(171);

var _SizePerPageDropDown2 = _interopRequireDefault(_SizePerPageDropDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof window !== 'undefined') {
  window.BootstrapTable = _BootstrapTable2.default;
  window.TableHeaderColumn = _TableHeaderColumn2.default;
  window.InsertModalHeader = _InsertModalHeader2.default;
  window.InsertModalBody = _InsertModalBody2.default;
  window.InsertModalFooter = _InsertModalFooter2.default;
  window.InsertButton = _InsertButton2.default;
  window.DeleteButton = _DeleteButton2.default;
  window.ShowSelectedOnlyButton = _ShowSelectedOnlyButton2.default;
  window.ExportCSVButton = _ExportCSVButton2.default;
  window.ClearSearchButton = _ClearSearchButton2.default;
  window.SearchField = _SearchField2.default;
  window.ButtonGroup = _ButtonGroup2.default;
  window.SizePerPageDropDown = _SizePerPageDropDown2.default;
}
exports.BootstrapTable = _BootstrapTable2.default;
exports.TableHeaderColumn = _TableHeaderColumn2.default;
exports.InsertModalHeader = _InsertModalHeader2.default;
exports.InsertModalBody = _InsertModalBody2.default;
exports.InsertModalFooter = _InsertModalFooter2.default;
exports.InsertButton = _InsertButton2.default;
exports.DeleteButton = _DeleteButton2.default;
exports.ShowSelectedOnlyButton = _ShowSelectedOnlyButton2.default;
exports.ExportCSVButton = _ExportCSVButton2.default;
exports.ClearSearchButton = _ClearSearchButton2.default;
exports.SearchField = _SearchField2.default;
exports.ButtonGroup = _ButtonGroup2.default;
exports.SizePerPageDropDown = _SizePerPageDropDown2.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(435);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(11), __webpack_require__(1), __webpack_require__(110), __webpack_require__(111), __webpack_require__(436)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('react-dom'), require('prop-types'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-store'), require('./SAlertContentTmpl'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.reactDom, global.propTypes, global.sAlertTools, global.sAlertStore, global.SAlertContentTmpl);
        global.SAlertContent = mod.exports;
    }
})(this, function (exports, _react, _reactDom, _propTypes, _sAlertTools, _sAlertStore, _SAlertContentTmpl) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _SAlertContentTmpl2 = _interopRequireDefault(_SAlertContentTmpl);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var SAlertContent = function (_React$Component) {
        _inherits(SAlertContent, _React$Component);

        function SAlertContent(props) {
            _classCallCheck(this, SAlertContent);

            return _possibleConstructorReturn(this, (SAlertContent.__proto__ || Object.getPrototypeOf(SAlertContent)).call(this, props));
        }

        _createClass(SAlertContent, [{
            key: 'handleCloseAlert',
            value: function handleCloseAlert() {
                var closingTimeout = void 0;
                var alertId = this.props.id;
                var currentAlertElem = _reactDom2.default.findDOMNode(this);
                var animationClose = function animationClose() {
                    currentAlertElem.style.display = 'none';
                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
                    clearTimeout(closingTimeout);
                };
                if (document.hidden || document.webkitHidden || !currentAlertElem.classList.contains('s-alert-is-effect')) {
                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
                } else {
                    currentAlertElem.classList.remove('s-alert-show');
                    closingTimeout = setTimeout(function () {
                        currentAlertElem.classList.add('s-alert-hide');
                    }, 100);
                    currentAlertElem.removeEventListener('webkitAnimationEnd', animationClose, false);
                    currentAlertElem.removeEventListener('animationend', animationClose, false);
                    currentAlertElem.addEventListener('webkitAnimationEnd', animationClose, false);
                    currentAlertElem.addEventListener('animationend', animationClose, false);
                }
                // stop audio when closing
                this.alertAudio && this.alertAudio.load();
            }
        }, {
            key: 'componentWillMount',
            value: function componentWillMount() {
                var beep = this.props.beep;
                var condition = this.props.condition;
                if (beep && typeof beep === 'string') {
                    this.alertAudio = new Audio(beep);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'info') {
                    this.alertAudio = new Audio(beep.info);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'error') {
                    this.alertAudio = new Audio(beep.error);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'success') {
                    this.alertAudio = new Audio(beep.success);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'warning') {
                    this.alertAudio = new Audio(beep.warning);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;

                if (typeof this.props.timeout === 'number') {
                    this.closeTimer = setTimeout(function () {
                        _this2.handleCloseAlert();
                    }, this.props.timeout);
                }
                if (this.props.onShow) {
                    this.props.onShow();
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.closeTimer) {
                    clearTimeout(this.closeTimer);
                }
                if (this.props.onClose) {
                    this.props.onClose();
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var classNames = 's-alert-box s-alert-' + this.props.condition + ' s-alert-' + this.props.position + ' ' + (this.props.effect ? 's-alert-is-effect s-alert-effect-' + this.props.effect : '') + ' s-alert-show';
                var message = this.props.html ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.message } }) : this.props.message;
                var styles = this.props.boxPosition ? _sAlertTools2.default.styleToObj(this.props.boxPosition) : {};
                var id = this.props.id;
                var handleClose = this.handleCloseAlert.bind(this);
                var contentTemplate = this.props.contentTemplate || _SAlertContentTmpl2.default;
                var customFields = this.props.customFields || {};
                var condition = this.props.condition;

                return _react2.default.createElement(contentTemplate, { classNames: classNames, id: id, styles: styles, message: message, handleClose: handleClose, customFields: customFields, condition: condition });
            }
        }]);

        return SAlertContent;
    }(_react2.default.Component);

    SAlertContent.propTypes = {
        condition: _propTypes2.default.string.isRequired,
        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
        position: _propTypes2.default.string.isRequired,
        boxPosition: _propTypes2.default.string,
        id: _propTypes2.default.string.isRequired,
        effect: _propTypes2.default.string,
        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
        html: _propTypes2.default.bool,
        onClose: _propTypes2.default.func,
        onShow: _propTypes2.default.func,
        customFields: _propTypes2.default.object,
        contentTemplate: _propTypes2.default.func
    };

    exports.default = SAlertContent;
});

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(24);

var _util2 = _interopRequireDefault(_util);

var _Date = __webpack_require__(438);

var _Date2 = _interopRequireDefault(_Date);

var _Text = __webpack_require__(439);

var _Text2 = _interopRequireDefault(_Text);

var _Regex = __webpack_require__(440);

var _Regex2 = _interopRequireDefault(_Regex);

var _Select = __webpack_require__(441);

var _Select2 = _interopRequireDefault(_Select);

var _Number = __webpack_require__(442);

var _Number2 = _interopRequireDefault(_Number);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint default-case: 0 */
/* eslint guard-for-in: 0 */


var TableHeaderColumn = function (_Component) {
  _inherits(TableHeaderColumn, _Component);

  function TableHeaderColumn(props) {
    _classCallCheck(this, TableHeaderColumn);

    var _this = _possibleConstructorReturn(this, (TableHeaderColumn.__proto__ || Object.getPrototypeOf(TableHeaderColumn)).call(this, props));

    _this.handleColumnClick = function () {
      return _this.__handleColumnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleFilter = _this.handleFilter.bind(_this);
    return _this;
  }

  _createClass(TableHeaderColumn, [{
    key: '__handleColumnClick__REACT_HOT_LOADER__',
    value: function __handleColumnClick__REACT_HOT_LOADER__() {
      return this.__handleColumnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.reset) {
        this.cleanFiltered();
      }

      // If column not displaying the same dataField, reset the filter accordingly
      if (nextProps.filter && nextProps.dataField !== this.props.dataField) {
        var emitter = nextProps.filter.emitter || {};
        var currentFilter = emitter.currentFilter || {};
        var filter = currentFilter[nextProps.dataField];
        var value = filter ? filter.value : '';

        var _ref = this.getFilters(nextProps) || {},
            ref = _ref.ref;

        if (this.refs[ref]) {
          this.refs[ref].setState({ value: value });
        }
      }
    }
  }, {
    key: '__handleColumnClick__REACT_HOT_LOADER__',
    value: function __handleColumnClick__REACT_HOT_LOADER__() {
      if (this.props.isOnlyHead || !this.props.dataSort) return;
      var order = this.props.sort;

      if (!order && this.props.defaultASC) order = _Const2.default.SORT_ASC;else order = this.props.sort === _Const2.default.SORT_DESC ? _Const2.default.SORT_ASC : _Const2.default.SORT_DESC;
      this.props.onSort(order, this.props.dataField);
    }
  }, {
    key: 'handleFilter',
    value: function handleFilter(value, type) {
      var filter = this.props.filter;

      filter.emitter.handleFilter(this.props.dataField, value, type, filter);
    }
  }, {
    key: 'getFilters',
    value: function getFilters() {
      var _this2 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var headerText = props.headerText,
          children = props.children;

      switch (props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            return _react2.default.createElement(_Text2.default, _extends({ ref: function ref(n) {
                return _this2.textFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            return _react2.default.createElement(_Regex2.default, _extends({ ref: function ref(n) {
                return _this2.regexFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            return _react2.default.createElement(_Select2.default, _extends({ ref: function ref(n) {
                return _this2.selectFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            return _react2.default.createElement(_Number2.default, _extends({ ref: function ref(n) {
                return _this2.numberFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            return _react2.default.createElement(_Date2.default, _extends({ ref: function ref(n) {
                return _this2.dateFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.CUSTOM:
          {
            var elm = props.filter.getElement(this.handleFilter, props.filter.customFilterParameters);

            return _react2.default.cloneElement(elm, { ref: function ref(n) {
                return _this2.customFilter = n;
              } });
          }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.headerCol.setAttribute('data-field', this.props.dataField);
    }
  }, {
    key: 'renderDefaultCaret',
    value: function renderDefaultCaret(dataSort, isBootstrap4) {
      if (!dataSort) return null;
      if (isBootstrap4) {
        return _react2.default.createElement('span', { className: 'order fa fa-sort',
          style: { margin: '10px 0 10px 5px', color: '#ccc' } });
      } else {
        return _react2.default.createElement(
          'span',
          { className: 'order' },
          _react2.default.createElement(
            'span',
            { className: 'dropdown' },
            _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 0 10px 5px', color: '#ccc' } })
          ),
          _react2.default.createElement(
            'span',
            { className: 'dropup' },
            _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 0', color: '#ccc' } })
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var defaultCaret = void 0;
      var sortCaret = void 0;
      var sortClass = void 0;
      var _props = this.props,
          headerText = _props.headerText,
          dataAlign = _props.dataAlign,
          dataField = _props.dataField,
          headerAlign = _props.headerAlign,
          headerTitle = _props.headerTitle,
          hidden = _props.hidden,
          sort = _props.sort,
          dataSort = _props.dataSort,
          sortIndicator = _props.sortIndicator,
          children = _props.children,
          caretRender = _props.caretRender,
          className = _props.className,
          isOnlyHead = _props.isOnlyHead,
          version = _props.version,
          customSortClass = _props.sortHeaderColumnClassName,
          style = _props.thStyle;

      var thStyle = _extends({
        textAlign: headerAlign || dataAlign,
        display: hidden ? 'none' : null
      }, style);
      var isBootstrap4 = _util2.default.isBootstrap4(version);
      if (!isOnlyHead) {
        if (sortIndicator) {
          defaultCaret = this.renderDefaultCaret(dataSort, isBootstrap4);
        }
        sortCaret = sort ? _util2.default.renderReactSortCaret(sort, isBootstrap4) : defaultCaret;
        if (caretRender) {
          sortCaret = caretRender(sort, dataField);
        }
      }

      if (sort) {
        sortClass = _util2.default.isFunction(customSortClass) ? customSortClass(sort, dataField) : customSortClass;
      }
      var classes = (0, _classnames2.default)(_util2.default.isFunction(className) ? className() : className, !isOnlyHead && dataSort ? 'sort-column' : '', sortClass);

      var attr = {};
      if (headerTitle) {
        if (typeof children === 'string' && !headerText) {
          attr.title = children;
        } else {
          attr.title = headerText;
        }
      }
      return _react2.default.createElement(
        'th',
        _extends({ ref: function ref(node) {
            return _this3.headerCol = node;
          },
          className: classes,
          style: thStyle,
          onClick: this.handleColumnClick,
          rowSpan: this.props.rowSpan,
          colSpan: this.props.colSpan,
          'data-is-only-head': this.props.isOnlyHead
        }, attr),
        children,
        sortCaret,
        _react2.default.createElement(
          'div',
          { onClick: function onClick(e) {
              return e.stopPropagation();
            } },
          this.props.filter && !isOnlyHead ? this.getFilters() : null
        )
      );
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      if (!this.props.filter) return;

      switch (this.props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            this.textFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            this.regexFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            this.selectFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            this.numberFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            this.dateFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.CUSTOM:
          {
            this.customFilter.cleanFiltered();
            break;
          }
      }
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(val) {
      if (!this.props.filter) return;
      switch (this.props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            this.textFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            this.regexFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            this.selectFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            this.numberFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            this.dateFilter.applyFilter(val);
            break;
          }
      }
    }
  }]);

  return TableHeaderColumn;
}(_react.Component);

var filterTypeArray = [];
for (var key in _Const2.default.FILTER_TYPE) {
  filterTypeArray.push(_Const2.default.FILTER_TYPE[key]);
}

TableHeaderColumn.propTypes = {
  dataField: _propTypes2.default.string,
  dataAlign: _propTypes2.default.string,
  headerAlign: _propTypes2.default.string,
  headerTitle: _propTypes2.default.bool,
  headerText: _propTypes2.default.string,
  dataSort: _propTypes2.default.bool,
  onSort: _propTypes2.default.func,
  dataFormat: _propTypes2.default.func,
  csvFormat: _propTypes2.default.func,
  csvHeader: _propTypes2.default.string,
  csvFieldType: _propTypes2.default.oneOf([_Const2.default.CSV_STRING_TYPE, _Const2.default.CSV_NUMBER_TYPE]),
  isKey: _propTypes2.default.bool,
  editable: _propTypes2.default.any,
  hidden: _propTypes2.default.bool,
  hiddenOnInsert: _propTypes2.default.bool,
  searchable: _propTypes2.default.bool,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  width: _propTypes2.default.string,
  sortFunc: _propTypes2.default.func,
  sortFuncExtraData: _propTypes2.default.any,
  sortHeaderColumnClassName: _propTypes2.default.any,
  columnClassName: _propTypes2.default.any,
  editColumnClassName: _propTypes2.default.any,
  invalidEditColumnClassName: _propTypes2.default.any,
  columnTitle: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.string]),
  filterFormatted: _propTypes2.default.bool,
  filterValue: _propTypes2.default.func,
  sort: _propTypes2.default.string,
  caretRender: _propTypes2.default.func,
  formatExtraData: _propTypes2.default.any,
  csvFormatExtraData: _propTypes2.default.any,
  filter: _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(filterTypeArray),
    delay: _propTypes2.default.number,
    options: _propTypes2.default.oneOfType([_propTypes2.default.object, // for SelectFilter
    _propTypes2.default.arrayOf(_propTypes2.default.number) // for NumberFilter
    ]),
    numberComparators: _propTypes2.default.arrayOf(_propTypes2.default.string),
    emitter: _propTypes2.default.object,
    placeholder: _propTypes2.default.string,
    getElement: _propTypes2.default.func,
    customFilterParameters: _propTypes2.default.object,
    condition: _propTypes2.default.oneOf([_Const2.default.FILTER_COND_EQ, _Const2.default.FILTER_COND_LIKE])
  }),
  sortIndicator: _propTypes2.default.bool,
  export: _propTypes2.default.bool,
  expandable: _propTypes2.default.bool,
  tdAttr: _propTypes2.default.object,
  editTdAttr: _propTypes2.default.object,
  tdStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  thStyle: _propTypes2.default.object,
  keyValidator: _propTypes2.default.bool,
  defaultASC: _propTypes2.default.bool
};

TableHeaderColumn.defaultProps = {
  dataAlign: 'left',
  headerAlign: undefined,
  headerTitle: true,
  dataSort: false,
  dataFormat: undefined,
  csvFormat: undefined,
  csvHeader: undefined,
  csvFieldType: _Const2.default.CSV_STRING_TYPE,
  isKey: false,
  editable: true,
  onSort: undefined,
  hidden: false,
  hiddenOnInsert: false,
  searchable: true,
  className: '',
  columnTitle: false,
  width: null,
  sortFunc: undefined,
  columnClassName: '',
  editColumnClassName: '',
  invalidEditColumnClassName: '',
  filterFormatted: false,
  filterValue: undefined,
  sort: undefined,
  formatExtraData: undefined,
  sortFuncExtraData: undefined,
  filter: undefined,
  sortIndicator: true,
  expandable: true,
  tdAttr: undefined,
  editTdAttr: undefined,
  tdStyle: undefined,
  thStyle: undefined,
  keyValidator: false,
  defaultASC: false
};

var _default = TableHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableHeaderColumn, 'TableHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');

  __REACT_HOT_LOADER__.register(filterTypeArray, 'filterTypeArray', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');
}();

;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = __webpack_require__(24);

var _util2 = _interopRequireDefault(_util);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var editor = function editor(editable, attr, format, editorClass, defaultValue, ignoreEditable, row) {
  if (editable === true || editable === false && ignoreEditable || typeof editable === 'string') {
    // simple declare
    var type = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: type, defaultValue: defaultValue,
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (!editable) {
    var _type = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: _type, defaultValue: defaultValue,
      disabled: 'disabled',
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (editable && (editable.type === undefined || editable.type === null || editable.type.trim() === '')) {
    var _type2 = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: _type2, defaultValue: defaultValue,
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (editable.type) {
    // standard declare
    // put style if exist
    editable.style && (attr.style = editable.style);
    // put class if exist
    attr.className = (editorClass || '') + ' form-control editor edit-' + editable.type + (editable.className ? ' ' + editable.className : '');

    if (editable.type === 'select') {
      // process select input
      var options = [];
      var values = editable.options.values;
      var _editable$options = editable.options,
          textKey = _editable$options.textKey,
          valueKey = _editable$options.valueKey;

      if (_util2.default.isFunction(values)) {
        values = values(row);
      }
      if (Array.isArray(values)) {
        // only can use arrray data for options
        var text = void 0;
        var value = void 0;
        options = values.map(function (option, i) {
          if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
            text = textKey ? option[textKey] : option.text;
            value = valueKey ? option[valueKey] : option.value;
          } else {
            text = format ? format(option) : option;
            value = option;
          }
          return _react2.default.createElement(
            'option',
            { key: 'option' + i, value: value },
            text
          );
        });
      }
      return _react2.default.createElement(
        'select',
        _extends({}, attr, { defaultValue: defaultValue }),
        options
      );
    } else if (editable.type === 'textarea') {
      // process textarea input
      // put other if exist
      editable.cols && (attr.cols = editable.cols);
      editable.rows && (attr.rows = editable.rows);
      var saveBtn = void 0;
      var keyUpHandler = attr.onKeyDown;
      if (keyUpHandler) {
        attr.onKeyDown = function (e) {
          if (e.keyCode !== 13) {
            // not Pressed ENTER
            keyUpHandler(e);
          }
        };
        saveBtn = _react2.default.createElement(
          'button',
          {
            className: 'btn btn-info btn-xs textarea-save-btn',
            onClick: keyUpHandler },
          'save'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('textarea', _extends({}, attr, { defaultValue: defaultValue })),
        saveBtn
      );
    } else if (editable.type === 'checkbox') {
      var _values = 'true:false';
      if (editable.options && editable.options.values) {
        // values = editable.options.values.split(':');
        _values = editable.options.values;
      }
      attr.className = attr.className.replace('form-control', '');
      attr.className += ' checkbox pull-right';

      var checked = defaultValue && defaultValue.toString() === _values.split(':')[0] ? true : false;

      return _react2.default.createElement('input', _extends({}, attr, { type: 'checkbox',
        value: _values, defaultChecked: checked }));
    } else if (editable.type === 'datetime') {
      return _react2.default.createElement('input', _extends({}, attr, { type: 'datetime-local', defaultValue: defaultValue }));
    } else {
      // process other input type. as password,url,email...
      return _react2.default.createElement('input', _extends({}, attr, { type: editable.type, defaultValue: defaultValue }));
    }
  }
  // default return for other case of editable
  return _react2.default.createElement('input', _extends({}, attr, { type: 'text',
    className: (editorClass || '') + ' form-control editor edit-text' }));
};

var _default = editor;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(editor, 'editor', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Editor.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Editor.js');
}();

;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notice = undefined;

var _reactSAlert = __webpack_require__(166);

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notice = function notice(type, msg, title) {
  var titleHTML = title ? '<h4><strong>' + title + '</strong></h4>' : '';

  var bodyHTML = '\n    ' + titleHTML + '\n    <div>\n      <span class=\'fa fa-exclamation-triangle glyphicon glyphicon-alert\'></span>&nbsp;\n      <span>' + msg + '</span>\n    </div>\n  ';

  _reactSAlert2.default.error(bodyHTML, {
    position: 'top-right',
    timeout: 3000,
    html: true,
    effect: 'scale'
  });
};

exports.notice = notice;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(notice, 'notice', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Notification.js');
}();

;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizePerPageDefaultClass = 'react-bs-table-sizePerPage-dropdown';

var SizePerPageDropDown = function (_Component) {
  _inherits(SizePerPageDropDown, _Component);

  function SizePerPageDropDown() {
    _classCallCheck(this, SizePerPageDropDown);

    return _possibleConstructorReturn(this, (SizePerPageDropDown.__proto__ || Object.getPrototypeOf(SizePerPageDropDown)).apply(this, arguments));
  }

  _createClass(SizePerPageDropDown, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          open = _props.open,
          hidden = _props.hidden,
          onClick = _props.onClick,
          onBlur = _props.onBlur,
          options = _props.options,
          className = _props.className,
          variation = _props.variation,
          btnContextual = _props.btnContextual,
          isBootstrap4 = _props.isBootstrap4,
          currSizePerPage = _props.currSizePerPage;


      if (hidden) return null;

      var openClass = open ? 'open show' : '';

      var renderOptions = function renderOptions() {
        var attrs = {
          className: 'dropdown-menu ' + openClass,
          role: 'menu',
          'aria-labelledby': 'pageDropDown'
        };
        var type = isBootstrap4 ? 'div' : 'ul';

        return _react2.default.createElement(type, attrs, options);
      };

      return _react2.default.createElement(
        'span',
        {
          className: variation + ' ' + openClass + ' ' + className + ' ' + sizePerPageDefaultClass },
        _react2.default.createElement(
          'button',
          { className: 'btn ' + btnContextual + ' dropdown-toggle',
            id: 'pageDropDown', 'data-toggle': 'dropdown',
            'aria-expanded': open,
            'aria-haspopup': !open,
            onClick: onClick,
            onBlur: onBlur },
          currSizePerPage,
          _react2.default.createElement(
            'span',
            null,
            ' ',
            _react2.default.createElement('span', { className: 'caret' })
          )
        ),
        renderOptions()
      );
    }
  }]);

  return SizePerPageDropDown;
}(_react.Component);

SizePerPageDropDown.propTypes = {
  open: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  btnContextual: _propTypes2.default.string,
  currSizePerPage: _propTypes2.default.string,
  options: _propTypes2.default.array,
  variation: _propTypes2.default.oneOf(['dropdown', 'dropup']),
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  onBlur: _propTypes2.default.func
};
SizePerPageDropDown.defaultProps = {
  open: false,
  hidden: false,
  btnContextual: 'btn-default btn-secondary',
  variation: 'dropdown',
  className: ''
};

var _default = SizePerPageDropDown;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(sizePerPageDefaultClass, 'sizePerPageDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');

  __REACT_HOT_LOADER__.register(SizePerPageDropDown, 'SizePerPageDropDown', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');
}();

;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(460);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

exports.default = portalOpenInstances;
module.exports = exports["default"];

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = __webpack_require__(24);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InsertModalHeader = function (_Component) {
  _inherits(InsertModalHeader, _Component);

  function InsertModalHeader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModalHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModalHeader.__proto__ || Object.getPrototypeOf(InsertModalHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseBtnClick = function () {
      var _this2;

      return (_this2 = _this).__handleCloseBtnClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModalHeader, [{
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__() {
      return this.__handleCloseBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          onModalClose = _props.onModalClose,
          beforeClose = _props.beforeClose;

      beforeClose && beforeClose(e);
      onModalClose();
    }
  }, {
    key: 'renderContent',
    value: function renderContent(closeBtn) {
      var _props2 = this.props,
          version = _props2.version,
          titleText = _props2.title;

      var title = _react2.default.createElement(
        'h4',
        { key: 'title', className: 'modal-title' },
        titleText
      );
      if (_util2.default.isBootstrap4(version)) {
        return [title, closeBtn];
      } else {
        return _react2.default.createElement(
          'span',
          null,
          closeBtn,
          title
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          hideClose = _props3.hideClose,
          className = _props3.className,
          children = _props3.children;


      var closeBtn = hideClose ? null : _react2.default.createElement(
        'button',
        { type: 'button',
          className: 'close', onClick: this.handleCloseBtnClick },
        _react2.default.createElement(
          'span',
          { 'aria-hidden': 'true' },
          '\xD7'
        ),
        _react2.default.createElement(
          'span',
          { className: 'sr-only' },
          'Close'
        )
      );

      var content = children || this.renderContent(closeBtn);

      return _react2.default.createElement(
        'div',
        { className: 'modal-header ' + className },
        content
      );
    }
  }]);

  return InsertModalHeader;
}(_react.Component);

InsertModalHeader.propTypes = {
  version: _propTypes2.default.string,
  className: _propTypes2.default.string,
  title: _propTypes2.default.string,
  onModalClose: _propTypes2.default.func,
  hideClose: _propTypes2.default.bool,
  beforeClose: _propTypes2.default.func
};
InsertModalHeader.defaultProps = {
  version: '3',
  className: '',
  title: 'Add Row',
  onModalClose: undefined,
  hideClose: false,
  beforeClose: undefined
};

var _default = InsertModalHeader;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalHeader, 'InsertModalHeader', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalHeader.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalHeader.js');
}();

;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InsertModalFooter = function (_Component) {
  _inherits(InsertModalFooter, _Component);

  function InsertModalFooter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModalFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModalFooter.__proto__ || Object.getPrototypeOf(InsertModalFooter)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseBtnClick = function () {
      var _this2;

      return (_this2 = _this).__handleCloseBtnClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleSaveBtnClick = function () {
      var _this3;

      return (_this3 = _this).__handleSaveBtnClick__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModalFooter, [{
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__() {
      return this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__() {
      return this.__handleCloseBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          beforeClose = _props.beforeClose,
          onModalClose = _props.onModalClose;

      beforeClose && beforeClose(e);
      onModalClose();
    }
  }, {
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__(e) {
      var _props2 = this.props,
          beforeSave = _props2.beforeSave,
          onSave = _props2.onSave;

      beforeSave && beforeSave(e);
      onSave();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          saveBtnText = _props3.saveBtnText,
          closeBtnText = _props3.closeBtnText,
          closeBtnContextual = _props3.closeBtnContextual,
          saveBtnContextual = _props3.saveBtnContextual,
          closeBtnClass = _props3.closeBtnClass,
          saveBtnClass = _props3.saveBtnClass,
          children = _props3.children;


      var content = children || [_react2.default.createElement(
        'button',
        {
          key: 'closeBtn',
          type: 'button',
          className: 'btn ' + closeBtnContextual + ' ' + closeBtnClass,
          onClick: this.handleCloseBtnClick },
        closeBtnText
      ), _react2.default.createElement(
        'button',
        {
          key: 'saveBtn',
          type: 'button',
          className: 'btn ' + saveBtnContextual + ' ' + saveBtnClass,
          onClick: this.handleSaveBtnClick },
        saveBtnText
      )];

      return _react2.default.createElement(
        'div',
        { className: 'modal-footer ' + className },
        content
      );
    }
  }]);

  return InsertModalFooter;
}(_react.Component);

InsertModalFooter.propTypes = {
  className: _propTypes2.default.string,
  saveBtnText: _propTypes2.default.string,
  closeBtnText: _propTypes2.default.string,
  closeBtnContextual: _propTypes2.default.string,
  saveBtnContextual: _propTypes2.default.string,
  closeBtnClass: _propTypes2.default.string,
  saveBtnClass: _propTypes2.default.string,
  beforeClose: _propTypes2.default.func,
  beforeSave: _propTypes2.default.func,
  onSave: _propTypes2.default.func,
  onModalClose: _propTypes2.default.func
};
InsertModalFooter.defaultProps = {
  className: '',
  saveBtnText: _Const2.default.SAVE_BTN_TEXT,
  closeBtnText: _Const2.default.CLOSE_BTN_TEXT,
  closeBtnContextual: 'btn-default btn-secondary',
  saveBtnContextual: 'btn-primary',
  closeBtnClass: '',
  saveBtnClass: '',
  beforeClose: undefined,
  beforeSave: undefined
};

var _default = InsertModalFooter;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalFooter, 'InsertModalFooter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalFooter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalFooter.js');
}();

;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editor = __webpack_require__(169);

var _Editor2 = _interopRequireDefault(_Editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/display-name: 0 */


var InsertModalBody = function (_Component) {
  _inherits(InsertModalBody, _Component);

  function InsertModalBody() {
    _classCallCheck(this, InsertModalBody);

    return _possibleConstructorReturn(this, (InsertModalBody.__proto__ || Object.getPrototypeOf(InsertModalBody)).apply(this, arguments));
  }

  _createClass(InsertModalBody, [{
    key: 'getFieldValue',
    value: function getFieldValue() {
      var _this2 = this;

      var newRow = {};
      this.props.columns.forEach(function (column, i) {
        var inputVal = void 0;
        if (column.autoValue) {
          // when you want same auto generate value and not allow edit, example ID field
          var time = new Date().getTime();
          inputVal = typeof column.autoValue === 'function' ? column.autoValue() : 'autovalue-' + time;
        } else if (column.hiddenOnInsert || !column.field) {
          inputVal = '';
        } else {
          var dom = _this2.refs[column.field + i];
          inputVal = dom.value;

          if (column.editable && column.editable.type === 'checkbox') {
            var values = inputVal.split(':');
            inputVal = dom.checked ? values[0] : values[1];
          } else if (column.customInsertEditor) {
            inputVal = inputVal || dom.getFieldValue();
          }
        }
        newRow[column.field] = inputVal;
      }, this);
      return newRow;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          columns = _props.columns,
          validateState = _props.validateState,
          ignoreEditable = _props.ignoreEditable;

      return _react2.default.createElement(
        'div',
        { className: 'modal-body' },
        columns.map(function (column, i) {
          var editable = column.editable,
              format = column.format,
              field = column.field,
              name = column.name,
              autoValue = column.autoValue,
              hiddenOnInsert = column.hiddenOnInsert,
              customInsertEditor = column.customInsertEditor;

          var attr = {
            ref: field + i,
            placeholder: editable.placeholder ? editable.placeholder : name
          };
          var fieldElement = void 0;
          var defaultValue = editable.defaultValue || undefined;
          if (customInsertEditor) {
            var getElement = customInsertEditor.getElement;

            fieldElement = getElement(column, attr, 'form-control', ignoreEditable, defaultValue);
          }

          // fieldElement = false, means to use default editor when enable custom editor
          // Becasuse some users want to have default editor based on some condition.
          if (!customInsertEditor || fieldElement === false) {
            fieldElement = (0, _Editor2.default)(editable, attr, format, '', defaultValue, ignoreEditable);
          }

          if (autoValue || hiddenOnInsert || !column.field) {
            // when you want same auto generate value
            // and not allow edit, for example ID field
            return null;
          }
          var error = validateState[field] ? _react2.default.createElement(
            'span',
            { className: 'help-block bg-danger' },
            validateState[field]
          ) : null;
          return _react2.default.createElement(
            'div',
            { className: 'form-group', key: field },
            _react2.default.createElement(
              'label',
              null,
              name
            ),
            fieldElement,
            error
          );
        })
      );
    }
  }]);

  return InsertModalBody;
}(_react.Component);

InsertModalBody.propTypes = {
  columns: _propTypes2.default.array,
  validateState: _propTypes2.default.object,
  ignoreEditable: _propTypes2.default.bool
};

InsertModalBody.defaultProps = {
  validateState: {},
  ignoreEditable: false
};

var _default = InsertModalBody;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalBody, 'InsertModalBody', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalBody.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalBody.js');
}();

;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var insertBtnDefaultClass = 'react-bs-table-add-btn';

var InsertButton = function (_Component) {
  _inherits(InsertButton, _Component);

  function InsertButton() {
    _classCallCheck(this, InsertButton);

    return _possibleConstructorReturn(this, (InsertButton.__proto__ || Object.getPrototypeOf(InsertButton)).apply(this, arguments));
  }

  _createClass(InsertButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
        ' ',
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + insertBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return InsertButton;
}(_react.Component);

InsertButton.propTypes = {
  btnText: _propTypes2.default.string,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  btnGlyphicon: _propTypes2.default.string
};
InsertButton.defaultProps = {
  btnText: _Const2.default.INSERT_BTN_TEXT,
  btnContextual: 'btn-info',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-plus fa-plus'
};

var _default = InsertButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(insertBtnDefaultClass, 'insertBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');

  __REACT_HOT_LOADER__.register(InsertButton, 'InsertButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');
}();

;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var deleteBtnDefaultClass = 'react-bs-table-del-btn';

var DeleteButton = function (_Component) {
  _inherits(DeleteButton, _Component);

  function DeleteButton() {
    _classCallCheck(this, DeleteButton);

    return _possibleConstructorReturn(this, (DeleteButton.__proto__ || Object.getPrototypeOf(DeleteButton)).apply(this, arguments));
  }

  _createClass(DeleteButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
        ' ',
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + deleteBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return DeleteButton;
}(_react.Component);

DeleteButton.propTypes = {
  btnText: _propTypes2.default.string,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  btnGlyphicon: _propTypes2.default.string
};
DeleteButton.defaultProps = {
  btnText: _Const2.default.DELETE_BTN_TEXT,
  btnContextual: 'btn-warning',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-trash fa-trash'
};

var _default = DeleteButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(deleteBtnDefaultClass, 'deleteBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');

  __REACT_HOT_LOADER__.register(DeleteButton, 'DeleteButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');
}();

;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var exportCsvBtnDefaultClass = 'react-bs-table-csv-btn';

var ExportCSVButton = function (_Component) {
  _inherits(ExportCSVButton, _Component);

  function ExportCSVButton() {
    _classCallCheck(this, ExportCSVButton);

    return _possibleConstructorReturn(this, (ExportCSVButton.__proto__ || Object.getPrototypeOf(ExportCSVButton)).apply(this, arguments));
  }

  _createClass(ExportCSVButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
        ' ',
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + exportCsvBtnDefaultClass + ' ' + className + ' hidden-print',
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ExportCSVButton;
}(_react.Component);

ExportCSVButton.propTypes = {
  btnText: _propTypes2.default.string,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  btnGlyphicon: _propTypes2.default.string
};
ExportCSVButton.defaultProps = {
  btnText: _Const2.default.EXPORT_CSV_TEXT,
  btnContextual: 'btn-success',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-export fa-download'
};

var _default = ExportCSVButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(exportCsvBtnDefaultClass, 'exportCsvBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');

  __REACT_HOT_LOADER__.register(ExportCSVButton, 'ExportCSVButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');
}();

;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var showSelectedOnlyBtnDefaultClass = 'react-bs-table-show-sel-only-btn';

var ShowSelectedOnlyButton = function (_Component) {
  _inherits(ShowSelectedOnlyButton, _Component);

  function ShowSelectedOnlyButton() {
    _classCallCheck(this, ShowSelectedOnlyButton);

    return _possibleConstructorReturn(this, (ShowSelectedOnlyButton.__proto__ || Object.getPrototypeOf(ShowSelectedOnlyButton)).apply(this, arguments));
  }

  _createClass(ShowSelectedOnlyButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          toggle = _props.toggle,
          showAllText = _props.showAllText,
          showOnlySelectText = _props.showOnlySelectText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'toggle', 'showAllText', 'showOnlySelectText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        toggle ? showAllText : showOnlySelectText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          'aria-pressed': 'false',
          'data-toggle': 'button',
          className: 'btn ' + btnContextual + ' ' + showSelectedOnlyBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ShowSelectedOnlyButton;
}(_react.Component);

ShowSelectedOnlyButton.propTypes = {
  showAllText: _propTypes2.default.string,
  showOnlySelectText: _propTypes2.default.string,
  toggle: _propTypes2.default.bool,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
ShowSelectedOnlyButton.defaultProps = {
  showAllText: _Const2.default.SHOW_ALL,
  showOnlySelectText: _Const2.default.SHOW_ONLY_SELECT,
  toggle: false,
  btnContextual: 'btn-primary',
  className: '',
  onClick: undefined
};

var _default = ShowSelectedOnlyButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(showSelectedOnlyBtnDefaultClass, 'showSelectedOnlyBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');

  __REACT_HOT_LOADER__.register(ShowSelectedOnlyButton, 'ShowSelectedOnlyButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');
}();

;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchField = function (_Component) {
  _inherits(SearchField, _Component);

  function SearchField() {
    _classCallCheck(this, SearchField);

    return _possibleConstructorReturn(this, (SearchField.__proto__ || Object.getPrototypeOf(SearchField)).apply(this, arguments));
  }

  _createClass(SearchField, [{
    key: 'getValue',
    value: function getValue() {
      return _reactDom2.default.findDOMNode(this).value;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      _reactDom2.default.findDOMNode(this).value = value;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          defaultValue = _props.defaultValue,
          placeholder = _props.placeholder,
          onKeyUp = _props.onKeyUp,
          rest = _objectWithoutProperties(_props, ['className', 'defaultValue', 'placeholder', 'onKeyUp']);

      return _react2.default.createElement('input', _extends({
        className: 'form-control ' + className,
        type: 'text',
        defaultValue: defaultValue,
        placeholder: placeholder || SearchField.defaultProps.placeholder,
        onKeyUp: onKeyUp,
        style: { zIndex: 0 }
      }, rest));
    }
  }]);

  return SearchField;
}(_react.Component);

SearchField.propTypes = {
  className: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  onKeyUp: _propTypes2.default.func
};
SearchField.defaultProps = {
  className: '',
  defaultValue: '',
  placeholder: 'Search',
  onKeyUp: undefined
};

var _default = SearchField;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SearchField, 'SearchField', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/SearchField.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/SearchField.js');
}();

;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var clearBtnDefaultClass = 'react-bs-table-search-clear-btn';

var ClearSearchButton = function (_Component) {
  _inherits(ClearSearchButton, _Component);

  function ClearSearchButton() {
    _classCallCheck(this, ClearSearchButton);

    return _possibleConstructorReturn(this, (ClearSearchButton.__proto__ || Object.getPrototypeOf(ClearSearchButton)).apply(this, arguments));
  }

  _createClass(ClearSearchButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({
          className: 'btn ' + btnContextual + ' ' + className + ' ' + clearBtnDefaultClass,
          type: 'button',
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ClearSearchButton;
}(_react.Component);

ClearSearchButton.propTypes = {
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  btnText: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
ClearSearchButton.defaultProps = {
  btnContextual: 'btn-default btn-secondary',
  className: '',
  btnText: 'Clear',
  onClick: undefined
};

var _default = ClearSearchButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(clearBtnDefaultClass, 'clearBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');

  __REACT_HOT_LOADER__.register(ClearSearchButton, 'ClearSearchButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');
}();

;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.RootCloseWrapper = exports.Position = exports.Portal = exports.Overlay = exports.Modal = exports.AutoAffix = exports.Affix = undefined;

var _Affix2 = __webpack_require__(185);

var _Affix3 = _interopRequireDefault(_Affix2);

var _AutoAffix2 = __webpack_require__(478);

var _AutoAffix3 = _interopRequireDefault(_AutoAffix2);

var _Modal2 = __webpack_require__(479);

var _Modal3 = _interopRequireDefault(_Modal2);

var _Overlay2 = __webpack_require__(85);

var _Overlay3 = _interopRequireDefault(_Overlay2);

var _Portal2 = __webpack_require__(86);

var _Portal3 = _interopRequireDefault(_Portal2);

var _Position2 = __webpack_require__(140);

var _Position3 = _interopRequireDefault(_Position2);

var _RootCloseWrapper2 = __webpack_require__(143);

var _RootCloseWrapper3 = _interopRequireDefault(_RootCloseWrapper2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Affix = _Affix3.default;
exports.AutoAffix = _AutoAffix3.default;
exports.Modal = _Modal3.default;
exports.Overlay = _Overlay3.default;
exports.Portal = _Portal3.default;
exports.Position = _Position3.default;
exports.RootCloseWrapper = _RootCloseWrapper3.default;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _height = __webpack_require__(476);

var _height2 = _interopRequireDefault(_height);

var _offset = __webpack_require__(52);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(141);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(89);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _requestAnimationFrame = __webpack_require__(186);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(64);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _getDocumentHeight = __webpack_require__(187);

var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);

var _ownerDocument = __webpack_require__(28);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(188);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Affix/>` component toggles `position: fixed;` on and off, emulating
 * the effect found with `position: sticky;`.
 */
var Affix = function (_React$Component) {
  _inherits(Affix, _React$Component);

  function Affix(props, context) {
    _classCallCheck(this, Affix);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.onWindowScroll = function () {
      _this.onUpdate();
    };

    _this.onDocumentClick = function () {
      (0, _requestAnimationFrame2.default)(function () {
        return _this.onUpdate();
      });
    };

    _this.onUpdate = function () {
      if (!_this._isMounted) {
        return;
      }

      var _this$props = _this.props,
          offsetTop = _this$props.offsetTop,
          viewportOffsetTop = _this$props.viewportOffsetTop;

      var scrollTop = (0, _scrollTop2.default)((0, _ownerWindow2.default)(_this));
      var positionTopMin = scrollTop + (viewportOffsetTop || 0);

      if (positionTopMin <= offsetTop) {
        _this.updateState('top', null, null);
        return;
      }

      if (positionTopMin > _this.getPositionTopMax()) {
        if (_this.state.affixed === 'bottom') {
          _this.updateStateAtBottom();
        } else {
          // Setting position away from `fixed` can change the offset parent of
          // the affix, so we can't calculate the correct position until after
          // we've updated its position.
          _this.setState({
            affixed: 'bottom',
            position: 'absolute',
            top: null
          }, function () {
            if (!_this._isMounted) {
              return;
            }

            _this.updateStateAtBottom();
          });
        }
        return;
      }

      _this.updateState('affix', 'fixed', viewportOffsetTop);
    };

    _this.getPositionTopMax = function () {
      var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));
      var height = (0, _height2.default)(_reactDom2.default.findDOMNode(_this));

      return documentHeight - height - _this.props.offsetBottom;
    };

    _this.updateState = function (affixed, position, top) {
      if (affixed === _this.state.affixed && position === _this.state.position && top === _this.state.top) {
        return;
      }

      var upperName = affixed === 'affix' ? '' : affixed.charAt(0).toUpperCase() + affixed.substr(1);

      if (_this.props['onAffix' + upperName]) {
        _this.props['onAffix' + upperName]();
      }

      _this.setState({ affixed: affixed, position: position, top: top }, function () {
        if (_this.props['onAffixed' + upperName]) {
          _this.props['onAffixed' + upperName]();
        }
      });
    };

    _this.updateStateAtBottom = function () {
      var positionTopMax = _this.getPositionTopMax();
      var offsetParent = (0, _offsetParent2.default)(_reactDom2.default.findDOMNode(_this));
      var parentTop = (0, _offset2.default)(offsetParent).top;

      _this.updateState('bottom', 'absolute', positionTopMax - parentTop);
    };

    _this.state = {
      affixed: 'top',
      position: null,
      top: null
    };

    _this._needPositionUpdate = false;
    return _this;
  }

  Affix.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._isMounted = true;

    this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
      return _this2.onWindowScroll();
    });
    this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
      return _this2.onDocumentClick();
    });

    this.onUpdate();
  };

  Affix.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needPositionUpdate = true;
  };

  Affix.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this._needPositionUpdate) {
      this._needPositionUpdate = false;
      this.onUpdate();
    }
  };

  Affix.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;

    if (this._windowScrollListener) {
      this._windowScrollListener.remove();
    }
    if (this._documentClickListener) {
      this._documentClickListener.remove();
    }
  };

  Affix.prototype.render = function render() {
    var child = _react2.default.Children.only(this.props.children);
    var _child$props = child.props,
        className = _child$props.className,
        style = _child$props.style;
    var _state = this.state,
        affixed = _state.affixed,
        position = _state.position,
        top = _state.top;

    var positionStyle = { position: position, top: top };

    var affixClassName = void 0;
    var affixStyle = void 0;
    if (affixed === 'top') {
      affixClassName = this.props.topClassName;
      affixStyle = this.props.topStyle;
    } else if (affixed === 'bottom') {
      affixClassName = this.props.bottomClassName;
      affixStyle = this.props.bottomStyle;
    } else {
      affixClassName = this.props.affixClassName;
      affixStyle = this.props.affixStyle;
    }

    return _react2.default.cloneElement(child, {
      className: (0, _classnames2.default)(affixClassName, className),
      style: _extends({}, positionStyle, affixStyle, style)
    });
  };

  return Affix;
}(_react2.default.Component);

Affix.propTypes = {
  /**
   * Pixels to offset from top of screen when calculating position
   */
  offsetTop: _propTypes2.default.number,

  /**
   * When affixed, pixels to offset from top of viewport
   */
  viewportOffsetTop: _propTypes2.default.number,

  /**
   * Pixels to offset from bottom of screen when calculating position
   */
  offsetBottom: _propTypes2.default.number,

  /**
   * CSS class or classes to apply when at top
   */
  topClassName: _propTypes2.default.string,

  /**
   * Style to apply when at top
   */
  topStyle: _propTypes2.default.object,

  /**
   * CSS class or classes to apply when affixed
   */
  affixClassName: _propTypes2.default.string,
  /**
   * Style to apply when affixed
   */
  affixStyle: _propTypes2.default.object,

  /**
   * CSS class or classes to apply when at bottom
   */
  bottomClassName: _propTypes2.default.string,

  /**
   * Style to apply when at bottom
   */
  bottomStyle: _propTypes2.default.object,

  /**
   * Callback fired when the right before the `affixStyle` and `affixStyle` props are rendered
   */
  onAffix: _propTypes2.default.func,
  /**
   * Callback fired after the component `affixStyle` and `affixClassName` props have been rendered.
   */
  onAffixed: _propTypes2.default.func,

  /**
   * Callback fired when the right before the `topStyle` and `topClassName` props are rendered
   */
  onAffixTop: _propTypes2.default.func,

  /**
   * Callback fired after the component `topStyle` and `topClassName` props have been rendered.
   */
  onAffixedTop: _propTypes2.default.func,

  /**
   * Callback fired when the right before the `bottomStyle` and `bottomClassName` props are rendered
   */
  onAffixBottom: _propTypes2.default.func,

  /**
   * Callback fired after the component `bottomStyle` and `bottomClassName` props have been rendered.
   */
  onAffixedBottom: _propTypes2.default.func
};

Affix.defaultProps = {
  offsetTop: 0,
  viewportOffsetTop: null,
  offsetBottom: 0
};

exports.default = Affix;
module.exports = exports['default'];

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(34));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (doc) {
  return Math.max(doc.documentElement.offsetHeight || 0, doc.height || 0, doc.body.scrollHeight || 0, doc.body.offsetHeight || 0);
};

module.exports = exports["default"]; /**
                                      * Get the height of the document
                                      *
                                      * @returns {documentHeight: number}
                                      */

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerWindow2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerWindow = __webpack_require__(477);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 191 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(193),
    getRawTag = __webpack_require__(508),
    objectToString = __webpack_require__(509);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(506);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 194 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masks__ = __webpack_require__(10);
var InputMask=function InputMask(props){var handleChange=function handleChange(e){if(props.mask===__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date&&e.target.value==='__/__/____'){e.target.value=null;}props.onChange(e);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["s" /* DtpInputMask */],Object.assign({},props,{className:props.className,value:props.value,pipe:props.mask===__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date?__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].dateCorrect:'',onChange:handleChange}));};InputMask.defaultProps={className:'dtp-form-control'};InputMask.propTypes={/** Classe css que podera substituir a classe default dtp-form-control */className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,/** Valor inicial */value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (InputMask);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
var Checkbox=function Checkbox(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["h" /* DtpCheckbox */],Object.assign({label:props.label,selectedValue:props.value,disabled:props.disabled},props));};Checkbox.defaultProps={value:null,name:null,disabled:false};Checkbox.propTypes={label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,optionsList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var SimpleGrid=function SimpleGrid(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'dtp-datagrid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dtp-datagrid-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dtp-datagrid-items-box'},props.children)));};SimpleGrid.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (SimpleGrid);

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);
var settle = __webpack_require__(539);
var buildURL = __webpack_require__(541);
var parseHeaders = __webpack_require__(542);
var isURLSameOrigin = __webpack_require__(543);
var createError = __webpack_require__(200);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(544);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(545);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(540);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
var ListaExigencias=function ListaExigencias(props){if(!props.exigencias||props.exigencias.length===0){return null;}var montaExigencia=function montaExigencia(exigencia,index){if(exigencia.comentario){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,index+1,' - ',exigencia.acao)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Coment\xE1rio:'),' ',exigencia.comentario));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,index+1,' - ',exigencia.acao));};// Vinicius
var listaExigenciasFiltradas=props.exigencias.filter(function(exigencia){return exigencia.atributo||exigencia.tipo===10||exigencia.tipo===11;});// const listaExigenciasFiltradas = props.exigencias.filter(exigencia => exigencia.atributo);
var listaExigencias=listaExigenciasFiltradas.map(function(exigencia,index){return montaExigencia(exigencia,index);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'exigencias',panelId:'lista-exigencias',icon:'ico-alert',title:'Exig\xEAncias'},listaExigencias));};ListaExigencias.propTypes={// Conteúdo exibido no corpo do modal
exigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({codigo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ListaExigencias);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
var ListaAlertas=function ListaAlertas(props){if(!props.alertas||props.alertas.length===0){return null;}var montaAlerta=function montaAlerta(alerta,index){if(alerta.descricao){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,index+1,' - ',alerta.descricao)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,index+1,' - ',alerta.descricao));};var listaAlertas=props.alertas.map(function(alerta,index){return montaAlerta(alerta,index);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'alertas',panelId:'lista-alertas',icon:'ico-alert',title:'Alertas'},listaAlertas));};ListaAlertas.propTypes={// Conteúdo exibido no corpo do modal
alertas:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({descricao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ListaAlertas);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masks__ = __webpack_require__(10);
var CalculoCompensacao=function CalculoCompensacao(props){if(!(props.requerimento.rendaMensalInicialSimulada||props.requerimento.rendaMensalInicialReajustada||props.requerimento.salarioMinimoDataInicioBeneficio||props.requerimento.valorMedioBeneficios||props.requerimento.percentualParticipacao||props.requerimento.proRataInicial)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["e" /* DataGrid */],{title:'C\xE1lculo da Compensa\xE7\xE3o',icon:'ico-calc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{currency:true,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].currency,number:true,showMask:false,disabled:true,label:'Renda Mensal Simulada',onChange:function onChange(e){return props.handleChange(e,'rendaMensalInicialSimulada');},value:props.requerimento.rendaMensalInicialSimulada?props.requerimento.rendaMensalInicialSimulada.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3}):props.requerimento.rendaMensalInicialSimulada})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{currency:true,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].currency,number:true,showMask:false,disabled:true,label:'Renda Mensal Reajustada na Data de Benef\xEDcio',onChange:function onChange(e){return props.handleChange(e,'rendaMensalInicialReajustada');},value:props.requerimento.rendaMensalInicialReajustada?props.requerimento.rendaMensalInicialReajustada.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3}):props.requerimento.rendaMensalInicialReajustada}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{currency:true,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].currency,number:true,showMask:false,disabled:true,label:'Sal\xE1rio M\xEDnimo na Data de In\xEDcio de Benef\xEDcio',onChange:function onChange(e){return props.handleChange(e,'salarioMinimoDataInicioBeneficio');},value:props.requerimento.salarioMinimoDataInicioBeneficio?props.requerimento.salarioMinimoDataInicioBeneficio.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3}):props.requerimento.salarioMinimoDataInicioBeneficio})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{currency:true,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].currency,number:true,showMask:false,disabled:true,label:'M\xE9dia na Data de In\xEDcio de Benef\xEDcio',onChange:function onChange(e){return props.handleChange(e,'valorMedioBeneficios');},value:props.requerimento.valorMedioBeneficios?props.requerimento.valorMedioBeneficios.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3}):props.requerimento.valorMedioBeneficios}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{currency:true,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].currency,number:true,showMask:false,disabled:true,label:'Renda Mensal de Compensa\xE7\xE3o Previdenci\xE1ria',onChange:function onChange(e){return props.handleChange(e,'rendaMensalInicialCompensacaoPrevidenciaria');},value:props.requerimento.rendaMensalInicialCompensacaoPrevidenciaria?props.requerimento.rendaMensalInicialCompensacaoPrevidenciaria.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3}):props.requerimento.rendaMensalInicialCompensacaoPrevidenciaria})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{participation:true,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].participation,number:true,showMask:false,disabled:true,label:'Percentual de Participa\xE7\xE3o do Regime Origem',onChange:function onChange(e){return props.handleChange(e,'percentualParticipacao');},value:props.requerimento.percentualParticipacao})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{currency:true,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].currency,number:true,showMask:false,disabled:true,label:'Pr\xF3-Rata Inicial',onChange:function onChange(e){return props.handleChange(e,'proRataInicial');},value:props.requerimento.proRataInicial?props.requerimento.proRataInicial.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3}):props.requerimento.proRataInicial}))));};CalculoCompensacao.propTypes={handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,requerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (CalculoCompensacao);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Exigencia__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Motivo__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ComponentesBasicos_UploadDragDrop__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var ResultadoAnalise=function(_Component){_inherits(ResultadoAnalise,_Component);function ResultadoAnalise(props){_classCallCheck(this,ResultadoAnalise);var _this=_possibleConstructorReturn(this,(ResultadoAnalise.__proto__||Object.getPrototypeOf(ResultadoAnalise)).call(this,props));_this.failCallback=function(){_this.alteraEstado(6);};_this.alteraEstado=function(changeObj){_this.props.alteraEstado(changeObj);if(changeObj.value===2){_this.doRequest('exigencia');}if(changeObj.value===9||changeObj.value===10){_this.doRequest('motivo');}if(changeObj.value===8){if(_this.props.tipoRequerimento===1){var resultado=_this.props.validacaoDeVinculosConcomitantes();_this.props.atualizarVinculosConcomitantesConfirmado(resultado);}}_this.montaListaDocumentosDisponiveis(changeObj.value);};_this.handleModal=function(callback){if(callback){_this.setState({showModal:!_this.state.showModal},callback);}else{_this.setState({showModal:!_this.state.showModal});}};_this.mostraModal=function(e,acaoModal){if(_this.props.requerimento.estado===9){if(_this.props.inIndefericaoAnalise){_this.doRequest('motivo');}_this.setState({acaoModal:acaoModal,motivoSelecionado:null},_this.handleModal);}else{_this.setState({acaoModal:acaoModal,exigenciaSelecionada:null},_this.handleModal);}};_this.escondeModal=function(){_this.handleModal();};_this.alteraExigencia=function(exigencia,title){_this.setState({acaoModal:title,exigenciaSelecionada:exigencia},_this.handleModal);};_this.alteraMotivo=function(motivo,title){_this.setState({acaoModalMotivo:title,motivoSelecionado:motivo},_this.handleModal);};_this.salvaExigencia=function(exigencia){var _this$props$requerime=Object.assign({},_this.props.requerimento),exigencias=_this$props$requerime.exigencias;var exigenciaExistente=exigencias.filter(function(item){return exigencia.codigoDependente&&item.codigoDependente?item.codigoDependente===exigencia.codigoDependente&&item.tipo===exigencia.tipo:item.tipo===exigencia.tipo;});if(exigenciaExistente.length>0&&exigenciaExistente[0].index!==exigencia.index){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Não é possível adicionar duas exigências de mesma natureza.']);}else{if(!exigencia.codigoDependente){// eslint-disable-next-line no-param-reassign
delete exigencia.codigoDependente;}if(exigencia.index!==null){exigencias[exigencia.index]=exigencia;}else{exigencias.push(exigencia);}_this.handleModal(_this.props.handleChange({value:exigencias,isValid:true},'exigencias'));}};_this.deleteExigencia=function(index){var _this$props$requerime2=Object.assign({},_this.props.requerimento),exigencias=_this$props$requerime2.exigencias;exigencias.splice(index,1);_this.props.handleChange({value:exigencias,isValid:true},'exigencias');};_this.salvaMotivo=function(paramMotivo){var _this$props=Object.assign({},_this.props),motivosIndeferimentoControle=_this$props.motivosIndeferimentoControle;var motivoExistente=motivosIndeferimentoControle.filter(function(item){return item.motivo===paramMotivo.motivo;});var url='requerimentos-compensacao/motivos';if(motivoExistente.length>0&&motivoExistente[0].index!==paramMotivo.index){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Não é possível adicionar dois motivos de mesma natureza.']);}else{if(paramMotivo.arquivo){paramMotivo.nomeArquivo='Documento de indeferimento';var tamanhoDocumentoUpload=paramMotivo.arquivo.size;if(tamanhoDocumentoUpload>__WEBPACK_IMPORTED_MODULE_9__utils_constants__["z" /* tamanhoMaximoArquivoUpload */]){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Certifique-se de que o documento possui tamanho inferior a 3 mb.']);return;}}if(paramMotivo.index!==null){motivosIndeferimentoControle[paramMotivo.index]=paramMotivo;}_this.setState({motivo:paramMotivo});_this.handleSaveMotivos(url,paramMotivo);}};_this.deleteMotivo=function(index){var _this$props2=Object.assign({},_this.props),motivosIndeferimentoControle=_this$props2.motivosIndeferimentoControle;var _this$props3=Object.assign({},_this.props),requerimento=_this$props3.requerimento;var motivo=motivosIndeferimentoControle[index];_this.setState({indexExclusao:index});var url='requerimentos-compensacao/motivos/'+requerimento.protocolo+'/6/'+motivo.dataInicio+'/'+motivo.motivo;Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["d" /* doDeleteMotivo */])(url,_this.trataSucessoResponseExclusaoArquivo,_this.trataErrosResponseExclusaoArquivo,'');};_this.trataSucessoInclusaoMotivo=function(response){var _this$props4=Object.assign({},_this.props),motivosIndeferimentoControle=_this$props4.motivosIndeferimentoControle;var _this$state=Object.assign({},_this.state),motivo=_this$state.motivo;var motivoResponse={protocolo:response.data.protocolo,dataInicio:response.data.dataInicio,estado:response.data.estado,comentario:response.data.comentario,motivo:response.data.motivo,descricao:response.data.descricao};if(response.data.codigoDocumento){motivo.codigoDocumento=response.data.codigoDocumento;}var obj=Object.assign({},motivo,motivoResponse);motivosIndeferimentoControle.push(obj);_this.handleModal(_this.props.handleChange({value:motivosIndeferimentoControle,isValid:true},'motivosIndeferimentoControle'));if(obj.arquivo!==null){_this.props.atualizarDocumentosProbatorios();}Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["J" /* trataMensagemSucesso */])(['Motivo de indeferimento incluído com sucesso.']);};_this.trataSucessoResponseExclusaoArquivo=function(){var _this$props5=Object.assign({},_this.props),motivosIndeferimentoControle=_this$props5.motivosIndeferimentoControle;_this.props.handleChange({value:motivosIndeferimentoControle,isValid:true},'motivosIndeferimentoControle');var motivo=motivosIndeferimentoControle[_this.state.indexExclusao];motivosIndeferimentoControle.splice(motivo.index,1);if(motivo.arquivo!==null){_this.props.atualizarDocumentosProbatorios();}_this.setState({motivosIndeferimentoControle:motivosIndeferimentoControle});var mensagemSucesso=['Motivo de indeferimento excluído com sucesso.'];Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);};_this.trataErrosResponseExclusaoArquivo=function(){var mensagemErro=['Não foi possível excluir o motivo.'];Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(mensagemErro);};_this.trataErrosResponse=function(error){if(error){if(error.status===400){if(error&&error.data){var _error=Object.assign({},error),data=_error.data;_this.setState({chaveConfirmacao:data.chaveConfirmacao,alertas:data.alertas,showModalAlerta:!_this.state.showModalAlerta});}}}var mensagemErro=['Falha ao incluir o motivo de indeferimento.'];Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(mensagemErro);};_this.handleSaveMotivos=function(url,motivo){var options=void 0;if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}var _this$props6=Object.assign({},_this.props),requerimento=_this$props6.requerimento;if(motivo){var body={protocolo:requerimento.protocolo,motivo:motivo.motivo,justificativa:motivo.justificativaIndeferimento!==null?motivo.justificativaIndeferimento:''};if(motivo.arquivo){body.arquivo=motivo.arquivo;}Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["j" /* doMultipartFormPost */])(url,body,_this.trataSucessoInclusaoMotivo,_this.trataErrosResponse,options);}};_this.createCustomInsertButton=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{onClick:function onClick(e){return _this.mostraModal(e,'Inclusão de Exigência');},hint:'Adicionar exig\xEAncia',icon:'ico-plus'});};_this.createCustomInsertButtonMotivo=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{onClick:function onClick(e){return _this.mostraModal(e,'Inclusão de Motivo');},hint:'Adicionar motivo',icon:'ico-plus'});};_this.createActionColumn=function(index,exigencia){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:'Editar exig\xEAncia',icon:'ico-pencil',mini:true,onClick:function onClick(){return _this.alteraExigencia(exigencia,'Edição de Exigência');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:'Excluir exig\xEAncia',icon:'ico-minus',mini:true,onClick:function onClick(){return _this.deleteExigencia(index);}}));};_this.createActionColumnMotivo=function(index,motivo){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{className:'dtp-inverse',hint:'Excluir motivo',icon:'ico-doc-minus',mini:true,onClick:function onClick(){return _this.deleteMotivo(index);}}));};_this.addDependenteLabel=function(dependenteSelecionado){if(dependenteSelecionado){var dependentesFormatados=_this.props.requerimento.dependentes.map(function(dependente){return{label:dependente.nome,value:dependente.codigo};});return __WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */](dependentesFormatados,dependenteSelecionado).label;}return null;};_this.doRequest=function(typeRequest){switch(typeRequest){case'exigencia':if(_this.props.exigencias.length===0){var _this$props$requerime3=Object.assign({},_this.props.requerimento),solicitante=_this$props$requerime3.solicitante;var _this$props$requerime4=Object.assign({},_this.props.requerimento),destinatario=_this$props$requerime4.destinatario;// ALTERAR O VALOR DO SOLICITANTE APOS OS TESTES
if(solicitante.codigo!=='01000'&&destinatario.codigo!=='01000'){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["s" /* requestExigenciasRPPS */])(_this.failCallback);}else{Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["r" /* requestExigencias */])(_this.failCallback);}}break;case'motivo':if(_this.props.motivosIndeferimento.length===0&&_this.props.motivosSuspensao.length===0){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["u" /* requestMotivos */])(_this.failCallback);}break;default:break;}};_this.diffTipoRequerimento=function(){return _this.props.requerimento.tipoAposentadoria;};_this.exigenciasTableHeaderAposentadoria=[{id:'acao',label:'Ação Exigida'},{id:'comentario',label:'Comentário'},{id:'index',label:null,dataFormat:_this.createActionColumn}];_this.exigenciasTableHeaderPensao=[{id:'acao',label:'Ação Exigida'},{id:'codigoDependente',label:'Dependente',dataFormat:_this.addDependenteLabel},{id:'comentario',label:'Comentário'},{id:'index',label:null,dataFormat:_this.createActionColumn}];_this.motivosTableHeader=[{id:'descricao',label:'Motivo'},{id:'comentario',label:'Comentário'},{id:'nomeArquivo',label:'Arquivo'},{id:'index',label:'ações',dataFormat:_this.createActionColumnMotivo}];_this.montarListaDocumentosAdicionais=function(estado){var lista=[];var tiposDocumentos=_this.props.tiposDocumentos?_this.props.tiposDocumentos:[];var codigos=[22,23];if(estado===8){codigos=[23];}if(estado===10){codigos=[22];}lista=tiposDocumentos.filter(function(doc){return codigos.includes(doc.value);});return lista;};_this.montaListaDocumentosDisponiveis=function(estado){var lista=_this.montarListaDocumentosAdicionais(estado);_this.setState({tiposDisponiveis:lista});};_this.handleChange=function(e,name){_this.setState(_defineProperty({},name,e.value));};_this.state={acaoModal:'Inclusão de Exigência',exigenciaSelecionada:null,showModal:false,acaoModalMotivo:'Inclusão de Motivo',motivoSelecionado:null,showModalMotivo:false,indexExclusao:null,motivo:{protocolo:null,dataInicio:null,estado:null,justificativaIndeferimento:null,motivo:null,nomeArquivo:null,descricao:null},arquivo:{documento:null,protocolo:null,tipoDocumento:null},document:null,documents:[],tiposDisponiveis:[],tipoDocumento:null};return _this;}_createClass(ResultadoAnalise,[{key:'componentDidMount',value:function componentDidMount(){this.montaListaDocumentosDisponiveis(null);}},{key:'render',value:function render(){var _this2=this;var complemento=void 0;var modal=void 0;var nota=void 0;var upload=void 0;var options={insertBtn:this.createCustomInsertButton,noDataText:'Adicione uma exigência'};var optionsMotivos={insertBtn:this.createCustomInsertButtonMotivo,noDataText:'Adicione um motivo'};var peloMenosDoisRegimes=false;var colecao=this.props.requerimento.relacoesPrevidenciariasDestinatario;if(colecao){peloMenosDoisRegimes=colecao.map(function(e){return e.regimePrevidenciario;}).flat().length>=2;}//if ((!User.logged().isRGPS()) && (this.props.requerimento.estado === 8 && this.props.vinculosConcomitantesConfirmado /*&& peloMenosDoisRegimes*/)) {
if(!__WEBPACK_IMPORTED_MODULE_8__domain_User__["a" /* default */].logged().isRGPS()&&this.props.requerimento.estado===8&&this.props.possuiVinculosConcomitantes){complemento=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'V\xEDnculos concomitantes encontrados. Verifique a aba "Rela\xE7\xF5es Previdenci\xE1rias Regime Origem"');}// Acao de deferir
if(this.props.requerimento.estado===8){var retorno=false;if(this.props.tipoRequerimento===1){var resultado=this.props.validacaoDeVinculosConcomitantes();this.props.atualizarVinculosConcomitantesConfirmado(resultado);retorno=resultado.existeConcomitancia;}if(this.props.tipoRequerimento===2){retorno=false;}if(retorno===false){nota=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{cols:'74',componentClass:'textarea',label:'Conclus\xE3o da an\xE1lise',maxlength:'200',onChange:function onChange(e){return _this2.props.handleChange(e,'conclusaoAnalise');},rows:'3',value:this.props.requerimento.conclusaoAnalise,textarea:true})));upload=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Se desejar, anexe um documento para justificar o deferimento.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{label:'Tipo de documento',number:true,placeholder:'Selecione o tipo de documento',onChange:function onChange(e){return _this2.props.handleChangeTipoDocumento(e,'tipoDocumento');},value:this.props.tipoDocumento,itemList:this.state.tiposDisponiveis,custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_ComponentesBasicos_UploadDragDrop__["a" /* default */],{files:this.state.document?[this.state.document]:[],onChange:function onChange(arquivos){return _this2.setState({document:arquivos[0]||null});},onSelect:function onSelect(arquivo){return _this2.props.handleChangeFile(arquivo);},multiple:false,accept:'application/pdf,.pdf',minHeight:70,titulo:'Arraste o arquivo PDF aqui',subtitulo:'ou clique para selecionar',largura:'8',disabled:!this.props.tipoDocumento}));}}// Acao de criar exigencias
if(this.props.requerimento.estado===2){var _props$requerimento=Object.assign({},this.props.requerimento),exigencias=_props$requerimento.exigencias;var listaExigenciasIndexada=exigencias.map(function(item,i){var itemIndexado=item;itemIndexado.index=i;return itemIndexado;});complemento=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{bordered:true,data:listaExigenciasIndexada,insertRow:true,options:options,listaTableHeader:this.diffTipoRequerimento()?this.exigenciasTableHeaderAposentadoria:this.exigenciasTableHeaderPensao});if(this.state.showModal){modal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Exigencia__["a" /* default */],{exigencias:this.props.exigencias,dependentes:this.props.requerimento.dependentes,tipoRequerimento:this.diffTipoRequerimento()?'aposentadoria':'pensao',salvaExigencia:this.salvaExigencia,exigencia:this.state.exigenciaSelecionada,onHide:this.escondeModal,title:this.state.acaoModal,showModal:true,size:'md',userData:this.props.userData,solicitante:this.props.requerimento.solicitante,destinatario:this.props.requerimento.destinatario});}}// Acao de indeferir
if(this.props.requerimento.estado===9||this.props.inIndefericaoAnalise){var listaMotivosIndexada=this.props.motivosIndeferimentoControle.map(function(item,i){var itemIndexado=item;itemIndexado.index=i;itemIndexado.nomeArquivo=itemIndexado.documento||itemIndexado.arquivo?'Documento de indeferimento':'';return itemIndexado;});complemento=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{bordered:true,data:listaMotivosIndexada,insertRow:true,options:optionsMotivos,listaTableHeader:this.motivosTableHeader});if(this.state.showModal){modal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Motivo__["a" /* default */],{motivos:this.props.motivosIndeferimento,salvaMotivo:this.salvaMotivo,motivo:this.state.motivoSelecionado,onHide:this.escondeModal,title:this.state.acaoModalMotivo,showModal:true,size:'md',tipoRequerimento:this.props.tipoRequerimento,solicitante:this.props.requerimento.solicitante,destinatario:this.props.requerimento.destinatario,atualizarDocumentosProbatorios:this.props.atualizarDocumentosProbatorios});}}// Acao de Suspender
if(this.props.requerimento.estado===10){var motivosSuspensaoFiltrado=[];var inss='01000';var destinatarioOuSolicitanteRGPS=__WEBPACK_IMPORTED_MODULE_8__domain_User__["a" /* default */].logged().isRGPS()||this.props.requerimento.solicitante.codigo===inss;var acordos=destinatarioOuSolicitanteRGPS?[1,3]:[2,3];if(this.props.requerimento.tipoAposentadoria){motivosSuspensaoFiltrado=this.props.motivosSuspensao.filter(function(item){return item.abrangenciaAplicavel===1&&__WEBPACK_IMPORTED_MODULE_8__domain_User__["a" /* default */].logged().codigosDeRegime().includes(item.regimeAplicavel)&&acordos.includes(item.acordoAplicavel);});}else{motivosSuspensaoFiltrado=this.props.motivosSuspensao.filter(function(item){return item.abrangenciaAplicavel!==1&&__WEBPACK_IMPORTED_MODULE_8__domain_User__["a" /* default */].logged().codigosDeRegime().includes(item.regimeAplicavel)&&acordos.includes(item.acordoAplicavel);});}complemento=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{itemList:motivosSuspensaoFiltrado,label:'Motivo para a suspens\xE3o',onChange:function onChange(e){return _this2.props.handleChange(e,'motivo');},placeholder:'Selecione o motivo',value:this.props.requerimento.motivo}))));nota=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{cols:'74',componentClass:'textarea',label:'Observa\xE7\xE3o da suspens\xE3o',maxlength:'200',onChange:function onChange(e){return _this2.props.handleChange(e,'conclusaoAnalise');},rows:'3',value:this.props.requerimento.conclusaoAnalise,textarea:true}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["e" /* DataGrid */],{title:'An\xE1lise',icon:'ico-process-check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{itemList:__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["y" /* resultadoAnalise */],label:'Resultado da an\xE1lise',onChange:function onChange(e){return _this2.alteraEstado(e);},placeholder:'Selecione o resultado da an\xE1lise',value:this.props.requerimento.estado}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},complemento)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},nota)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},upload))),modal);}}]);return ResultadoAnalise;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ResultadoAnalise.propTypes={alteraEstado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,requerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({estado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,exigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({tipo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,comentario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),tipoAposentadoria:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,motivo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,dependentes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array}).isRequired,exigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),motivosIndeferimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),motivosSuspensao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),atualizarDocumentosProbatorios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,motivosIndeferimentoControle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,validacaoDeVinculosConcomitantes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,atualizarVinculosConcomitantesConfirmado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChangeFile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChangeTipoDocumento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,tipoDocumento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};ResultadoAnalise.defaultProps={motivosIndeferimento:null,motivosSuspensao:null,exigencias:null,userData:null,tiposDocumentos:[]};var mapStateToProps=function mapStateToProps(state){return{exigencias:state.base.exigencias,motivosIndeferimento:state.base.motivosIndeferimento,motivosSuspensao:state.base.motivosSuspensao,tiposDocumentos:state.base.tiposDocumentos};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ResultadoAnalise));

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ComponentesAutenticacao_utils__ = __webpack_require__(72);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var Exigencia=function(_Component){_inherits(Exigencia,_Component);function Exigencia(props){_classCallCheck(this,Exigencia);var _this=_possibleConstructorReturn(this,(Exigencia.__proto__||Object.getPrototypeOf(Exigencia)).call(this,props));_initialiseProps.call(_this);var estadoInicial=void 0;var dependentes=null;var exigenciaFiltrada=_this.filtragemExigencia(props);if(props.dependentes){dependentes=props.dependentes.map(function(dependente){return{label:dependente.nome,value:dependente.codigo};});}if(props.exigencia){var exigenciaSelecionada=Object.assign({},props.exigencia);estadoInicial={exigenciaFiltrada:exigenciaFiltrada,exigenciaSelecionada:exigenciaSelecionada,dependentes:dependentes,touched:true,validadeCampos:{tipo:true}};}else{estadoInicial={exigenciaFiltrada:exigenciaFiltrada,dependentes:dependentes,exigenciaSelecionada:{abrangenciaAplicavel:null,acao:null,atendida:0,tipo:null,comentario:null,index:null},touched:false,validadeCampos:{tipo:false}};}_this.state=estadoInicial;return _this;}_createClass(Exigencia,[{key:'render',value:function render(){var _this2=this;var escolhaDependente=null;if(this.state.exigenciaSelecionada.abrangenciaAplicavel===3){escolhaDependente=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.props.cumprimentoExigencia,itemList:this.state.dependentes,label:'Escolha de dependente',number:true,onChange:function onChange(e){return _this2.handleChange(e,'codigoDependente');},placeholder:'Selecione o dependente',required:true,touched:this.state.touched,value:this.state.exigenciaSelecionada.codigoDependente,custom:true})));}var naoCumprimentoExigencia=void 0;if(this.state.exigenciaSelecionada.atendida===2){naoCumprimentoExigencia=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{error:!this.state.validadeCampos.motivoNaoAtendimento,itemList:this.props.motivosNaoCumprimento,label:'Tipo de atendimento',number:true,onChange:function onChange(e){return _this2.handleChange(e,'motivoNaoAtendimento');},placeholder:'Selecione o motivo para o n\xE3o atendimento',required:true,touched:this.state.touched,value:this.state.exigenciaSelecionada.motivoNaoAtendimento,custom:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{cols:'74',componentClass:'textarea',label:'Coment\xE1rio para n\xE3o cumprimento',maxlength:'600',onChange:function onChange(e){return _this2.handleChange(e,'comentarioNaoAtendimento');},rows:'3',value:this.state.exigenciaSelecionada.comentarioNaoAtendimento,textarea:true})));}var atendimentoExigencia=void 0;if(this.props.cumprimentoExigencia){atendimentoExigencia=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{error:!this.state.validadeCampos.atendida,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["D" /* tipoAtendimentoExigencia */],label:'Tipo de atendimento',number:true,onChange:function onChange(e){return _this2.handleChange(e,'atendida');},placeholder:'Selecione o tipo de atendimento',required:true,touched:this.state.touched,value:this.state.exigenciaSelecionada.atendida,custom:true}),naoCumprimentoExigencia));}var modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.props.cumprimentoExigencia,error:!this.state.validadeCampos.tipo,itemList:this.state.exigenciaFiltrada,label:'A\xE7\xE3o para cumprimento da exig\xEAncia',number:true,onChange:function onChange(e){return _this2.handleChange(e,'tipo');},placeholder:'Selecione a a\xE7\xE3o exigida',required:true,touched:this.state.touched,value:this.state.exigenciaSelecionada.tipo,custom:true}))),escolhaDependente,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{cols:'74',componentClass:'textarea',disabled:this.props.cumprimentoExigencia,label:'Coment\xE1rio',maxlength:'600',onChange:function onChange(e){return _this2.handleChange(e,'comentario');},rows:'3',value:this.state.exigenciaSelecionada.comentario,textarea:true}))),atendimentoExigencia);var modalFooter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{title:'Cancelar',onClick:this.props.onHide,hint:'Cancelar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!this.exigenciaValida(),title:this.props.exigencia?'Salvar':'Adicionar',onClick:this.handleButton,hint:this.props.exigencia?'Salvar exigencia':'Adicionar exigencia'})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:modalContent,conteudofooter:modalFooter,onHide:this.props.onHide,size:this.props.size}));}}]);return Exigencia;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.getInitialState=function(){var initialState={touched:false,validadeCampos:{tipo:false}};return initialState;};this.exigenciaValida=function(){var exigenciaDependenteValida=!(_this3.state.exigenciaSelecionada.abrangenciaAplicavel===3&&!_this3.state.exigenciaSelecionada.codigoDependente);var validadeCampos=Object.assign({},_this3.state.validadeCampos);return Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["M" /* validateObject */])(validadeCampos)&&exigenciaDependenteValida;};this.filtragemExigencia=function(props){var EXIGENCIA_DE_SISTEMA=2;var exigenciaFiltrada=[];// const userPermissions = checkUser(props.userData); // quem está logado no comprev
// const logadoComoAnalistaRPPS = (userPermissions === 2);
// CS_APLICACAO = abrangenciaAplicavel (1 APOSENTADORIA, 2 PENSAO)
// CS_REGIME_APLICADO = regimeAplicavel (1 RGPS, 2 RPPS, 3 AMBOS)
// CS_PARTICIPANTES = acordoAplicavel (1 RGPS-RPPS, 2 RPPS-RPPS, 3 AMBOS)
// CS_PROPRIETARIO_EXIGENCIA = proprietario (1 Usuario, 2 Sistema)
var isSolicitanteRGPS=props.solicitante.codigo==='01000';var isDestinatarioRGPS=props.destinatario.codigo==='01000';var reqParticipantes=isSolicitanteRGPS||isDestinatarioRGPS?1:2;var reqRegimeAplicado=isSolicitanteRGPS?1:2;var reqTipoRequerimento=props.tipoRequerimento==='aposentadoria'?1:2;exigenciaFiltrada=props.exigencias.filter(function(exigencia){return(exigencia.regimeAplicavel===reqRegimeAplicado||exigencia.regimeAplicavel===3)&&(reqParticipantes===exigencia.acordoAplicavel||exigencia.acordoAplicavel===3)&&(reqTipoRequerimento===exigencia.abrangenciaAplicavel||reqTipoRequerimento===2&&exigencia.abrangenciaAplicavel===3)&&exigencia.proprietario!==EXIGENCIA_DE_SISTEMA;});return exigenciaFiltrada;};this.handleButton=function(){var touched=true;_this3.setState(Object.assign({},_this3.state,{touched:touched}),_this3.handleAdicionarExigencia);};this.handleAdicionarExigencia=function(){if(_this3.exigenciaValida()){_this3.props.salvaExigencia(_this3.state.exigenciaSelecionada);}};this.validateChange=function(changeObj,name){var _state=Object.assign({},_this3.state),exigenciaSelecionada=_state.exigenciaSelecionada;var abrangenciaAplicavel=null;var acao=null;var codigoDependente=null;if(name==='tipo'){exigenciaSelecionada=changeObj.value?__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */](_this3.state.exigenciaFiltrada,changeObj.value):null;// eslint-disable-next-line prefer-destructuring
abrangenciaAplicavel=exigenciaSelecionada.abrangenciaAplicavel;acao=exigenciaSelecionada.label;}else{if(exigenciaSelecionada.abrangenciaAplicavel){// eslint-disable-next-line prefer-destructuring
abrangenciaAplicavel=exigenciaSelecionada.abrangenciaAplicavel;}// eslint-disable-next-line prefer-destructuring
acao=exigenciaSelecionada.acao;// eslint-disable-next-line prefer-destructuring
codigoDependente=exigenciaSelecionada.codigoDependente;}return{abrangenciaAplicavel:abrangenciaAplicavel,acao:acao,codigoDependente:codigoDependente};};this.handleChange=function(changeObj,name){var exigenciaValidada=_this3.validateChange(changeObj,name);_this3.setState({exigenciaSelecionada:Object.assign({},_this3.state.exigenciaSelecionada,_defineProperty({abrangenciaAplicavel:exigenciaValidada.abrangenciaAplicavel,acao:exigenciaValidada.acao,codigoDependente:exigenciaValidada.codigoDependente},name,changeObj.value)),validadeCampos:Object.assign({},_this3.state.validadeCampos,_defineProperty({},name,changeObj.isValid))});};};Exigencia.propTypes={salvaExigencia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onHide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (Exigencia);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var destinoRGPS='01000';var Destinacao=function(_Component){_inherits(Destinacao,_Component);function Destinacao(props){_classCallCheck(this,Destinacao);var _this=_possibleConstructorReturn(this,(Destinacao.__proto__||Object.getPrototypeOf(Destinacao)).call(this,props));_this.getInitialState=function(){return{tipoRegime:null,tipoEntidade:null,uf:null,destinatario:null,destinatarioOrigem:null,carregamentoExterno:false};};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.trataFormulario=function(campoAlterado){if(campoAlterado==='tipoRegime'){_this.trataTipoRegime();_this.props.apagaRegraDeCalculo();}if(campoAlterado==='tipoEntidade'){_this.trataTipoEntidade();}if(campoAlterado==='uf'){_this.trataUf();}if(campoAlterado==='destinatario'){_this.trataDestinatario();}};_this.trataUf=function(){_this.setState({destinatario:null},function(){_this.props.handleChange({value:null,isValid:false},'destinatario');});};_this.trataDestinatario=function(){_this.props.handleChange({value:_this.state.destinatario,isValid:true},'destinatario');_this.props.calcularTempoRO(_this.state.destinatario,false);};_this.trataDestinatarioOrigem=function(orgaoCentralizador){_this.props.handleChange({value:orgaoCentralizador,isValid:true},'destinatarioOrigem');};_this.trataTipoEntidade=function(){_this.setState({destinatario:null,uf:null},function(){_this.props.handleChange({value:null,isValid:false},'destinatario');});};_this.trataTipoRegime=function(){var tipoEntidadeAposAlteracao=null;var destinatarioAposAlteracao=null;if(_this.state.tipoRegime===1){destinatarioAposAlteracao=destinoRGPS;}_this.setState({tipoEntidade:tipoEntidadeAposAlteracao,destinatario:destinatarioAposAlteracao},function(){_this.props.handleChange({value:destinatarioAposAlteracao,isValid:destinatarioAposAlteracao!==null},'destinatario');},_this.props.calcularTempoRO(destinatarioAposAlteracao,false));};_this.listaFiltradaDestinatarios=function(){var listaParticipantes=_this.props.destinatarios.filter(function(item){if(item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)){return item;}return null;});return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.buscaDestinatariosFail=function(){_this.setState({tipoRegime:null});};_this.obterValorEntidade=function(){if(_this.props.requerimento.destinatario&&_this.props.requerimento.destinatario.codigo){var objDestinatario=_this.props.destinatarios.find(function(d){return d.value===_this.props.requerimento.destinatario.codigo;});return objDestinatario.tipoRegimeProprio;}return _this.state.tipoEntidade;};_this.state=_this.getInitialState();return _this;}_createClass(Destinacao,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["a" /* buscaDestinatarios */])(this.buscaDestinatariosFail);}}},{key:'carregarDestinaratio',value:function carregarDestinaratio(dest){var _this2=this;var objDestinatario=null;if(!this.state.tipoEntidade&&this.props.requerimento.destinatario){objDestinatario=this.props.destinatarios.find(function(d){return d.value===_this2.props.requerimento.destinatario.codigo;});this.setState({tipoRegime:dest.codigo==='01000'?1:2,tipoEntidade:objDestinatario.tipoRegimeProprio,uf:dest.uf,destinatario:dest.codigo,carregamentoExterno:true});}}// Encaminha para as funcoes que tratam alteracoes em cada campo
},{key:'render',value:function render(){var _this3=this;if(!this.state.carregamentoExterno&&this.props.destinatarios.length>0){this.carregarDestinaratio(this.props.requerimento.destinatario);}var labelAviso=void 0;if(this.state.tipoEntidade===1&&this.state.destinatario){var orgao=this.props.destinatarios.find(function(itemLista){return itemLista.value===_this3.state.destinatario;});var orgaoCentralizador='';if(orgao.codigoOrgaoCentralizador){orgaoCentralizador=this.props.destinatarios.find(function(item){return item.value===orgao.codigoOrgaoCentralizador;});labelAviso='Este requerimento ser\xE1 destinado a '+orgaoCentralizador.label+'\n        que '+(orgao.inOrgaoExtinto?'Sucede':'Centraliza')+' : '+orgao.label;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["e" /* DataGrid */],{title:'Destina\xE7\xE3o',icon:'ico-route'},this.props.requerimento.solicitante.codigo==='01000'&&this.props.tipoRequerimento===1&&this.props.destinatarios.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:true,label:'Solicitante',value:this.props.requerimento.solicitante.nome}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Entidade',onChange:function onChange(e){return _this3.handleChange(e,'tipoEntidade');},placeholder:'Selecione a entidade',value:this.obterValorEntidade(),itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["E" /* tipoEntidade */],custom:true,number:true})),this.state.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'UF',onChange:function onChange(e){return _this3.handleChange(e,'uf');},placeholder:'Selecione a UF',value:this.state.uf,itemList:this.carregaUfDosMunicipios(),custom:true})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Destinat\xE1rio',onChange:function onChange(e){return _this3.handleChange(e,'destinatario');},placeholder:'Selecione o destinat\xE1rio',value:this.state.destinatario,itemList:this.listaFiltradaDestinatarios(),custom:true})))),(this.props.tipoRequerimento===2||this.props.requerimento.solicitante.codigo!=='01000')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:true,label:'Solicitante',value:this.props.requerimento.solicitante.nome})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:true,label:'Destinat\xE1rio',value:this.props.requerimento.destinatario.nome}))),this.props.requerimento.destinatarioOrigem&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:true,label:'Destinat\xE1rio Origem',value:this.props.requerimento.destinatarioOrigem.nome}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 12 12',style:{color:'#27AE60'}},labelAviso)));}}]);return Destinacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Destinacao.propTypes={requerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tipoRegimeProprio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,apagaRegraDeCalculo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,calcularTempoRO:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Destinacao));

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_requerimentos_ModalUploadArquivos__ = __webpack_require__(576);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UploadArquivos=function(_Component){_inherits(UploadArquivos,_Component);function UploadArquivos(){_classCallCheck(this,UploadArquivos);var _this=_possibleConstructorReturn(this,(UploadArquivos.__proto__||Object.getPrototypeOf(UploadArquivos)).call(this));_this.getInitialState=function(){return{acaoModal:'criacao',showModal:false,errosDependenteSelecionado:null,exigenciasDependentes:null,dependenteSelecionado:null,showDocumentUploadModal:false,requerimentoModalDocumento:{},possuiExigenciaDocumento:false,apagouArquivo:false,botaoNovoUploadDesabilitado:false};};_this.showDocumentUploadModal=function(){if(_this.props.requerimento.estado===2){_this.showDocumentUploadModalExigencias();}else{_this.setState({showDocumentUploadModal:!_this.state.showDocumentUploadModal});}};_this.verificarHabilitacaoBotao=function(){if(_this.props.requerimento.estado===2&&_this.props.listaExigencias.length===0){_this.setState({botaoNovoUploadDesabilitado:true});}else if(_this.props.requerimento.estado===2&&_this.props.listaExigencias.length>0){_this.setState({botaoNovoUploadDesabilitado:false});}};_this.createCustomInsertButton=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{disabled:_this.state.botaoNovoUploadDesabilitado,onClick:function onClick(){return _this.showDocumentUploadModal();},hint:'Carregar Arquivo',icon:'ico-upload'});};_this.addVinculoLabel=function(vinculoSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["W" /* vinculo */],vinculoSelecionado);return obj.label;};_this.alterarDependenteMedico=function(dependenteSelecionado){if(_this.props.acao==='emitir-parecer-medico'){if(dependenteSelecionado.capacidade===3||dependenteSelecionado.capacidade===5){return true;}return false;}return false;};_this.validacaoExigenciaDependente=function(exigenciasDependenteSelecionado){var exigenciasNovas=_this.state.exigenciasDependentes.filter(function(item){return exigenciasDependenteSelecionado.includes(item)?null:item;});_this.setState({exigenciasDependentes:exigenciasNovas});};_this.createActionColumn=function(indice){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.props.estadoFormulario!=='criado'&&['novo','indeferidos','cumprir-exigencia'].includes(_this.props.acao)||Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["f" /* habilitarUploadNaConsultaDoRequerimento */])(_this.props.requerimento,_this.props.acao,null)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-inverse',hint:'Excluir arquivo',icon:'ico-doc-minus',mini:true,onClick:function onClick(){return _this.deleteArquivo(indice);}}):'');};_this.addSituacaoLabel=function(tipoDocumento){var obj=Object(__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["n" /* getObject */])(_this.props.tiposDocumentos,tipoDocumento);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;// const obj = getObject(situacao, situacaoSelecionado);
// return obj.label;
};_this.montaArquivosTableHeader=function(){var tableHeader=[{id:'tipoDocumento',label:'Tipo de Documento',dataFormat:_this.addSituacaoLabel},{id:'nome',label:'Arquivo'}];if(_this.props.tipoRequerimento===2){tableHeader.push({id:'nomeDependente',label:'Dependente'});}tableHeader.push({id:'acoes',label:'Ação',dataFormat:_this.createActionColumn});return tableHeader;};_this.options={hideSizePerPage:true,insertBtn:_this.createCustomInsertButton,noDataText:'Nenhum arquivo foi adicionado à lista',sizePerPage:5};_this.editArquivo=function(indice,arquivoSelecionado){_this.setState({cell:indice,arquivoSelecionado:arquivoSelecionado});};_this.deleteArquivo=function(row){var _this$props=Object.assign({},_this.props),arquivos=_this$props.arquivos;if(_this.props.requerimento.estado===2){// "recuperar o objeto row e joga-lo devolta para a lista de exigencias"
// pesquisar na lista de exigencias do requerimento onde
// o tipoDocumento que esta sendo excluido é igual ao
// tipoDocumento da exigencia e jog-la devolta na colecao de exigencias
_this.setState({apagouArquivo:true});if(_this.props.requerimento.dependentes){var indexExigencia=_this.props.requerimento.exigencias.findIndex(function(exi){return exi.tipoDocumento===arquivos[row].tipoDocumento&&exi.codigoDependente===arquivos[row].codigoDependente;});_this.props.listaExigencias.push(_this.props.requerimento.exigencias[indexExigencia]);}else{// aposentadoria
var _indexExigencia=_this.props.requerimento.exigencias.findIndex(function(exi){return exi.tipoDocumento===arquivos[row].tipoDocumento;});_this.props.listaExigencias.push(_this.props.requerimento.exigencias[_indexExigencia]);}}arquivos.splice(row,1);_this.alteraListaArquivos(arquivos);// this.verificarHabilitacaoBotao();
};_this.alteraListaArquivos=function(listaArquivos){_this.props.handleChange({value:listaArquivos,isValid:listaArquivos.length>0});};_this.handleModal=function(modal){_this.setState(_defineProperty({},modal,!_this.state[modal]));};_this.addArquivo=function(arquivosRecebidos){if(!arquivosRecebidos||arquivosRecebidos.length===0){return;}var arquivos=_this.props.arquivos;arquivosRecebidos.forEach(function(arquivo){var tamanhoDocumentoUpload=arquivo.documento.size;if(tamanhoDocumentoUpload>__WEBPACK_IMPORTED_MODULE_6__utils_constants__["z" /* tamanhoMaximoArquivoUpload */]){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(['Certifique-se de que o documento '+arquivo.documento.name+' possui tamanho inferior a 3 mb.']);}else{arquivos.push(arquivo);}});_this.alteraListaArquivos(arquivos);_this.handleModal('showDocumentUploadModal');};_this.showDocumentUploadModalExigencias=function(){_this.setState({requerimentoModalDocumento:_this.props.requerimento});var tipo='pensao';if(_this.props.tipoRequerimento===1){tipo='aposentadoria';}Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["e" /* doGet */])('requerimentos-compensacao-'+tipo+'/'+_this.props.requerimento.protocolo,_this.handleResponseUploadDocumento,_this.handleErrorEncerramentoExigencia);};_this.handleResponseUploadDocumento=function(response){if(response.data.exigencias&&response.data.exigencias.length>0){var paramPossuiExigenciaDocumento=response.data.exigencias.filter(function(exigencia){return exigencia.tipoDocumento;}).length>0;_this.setState({requerimentoModalDocumento:response.data,possuiExigenciaDocumento:paramPossuiExigenciaDocumento},function(){return _this.handleModal('showDocumentUploadModal');});}};_this.handleErrorEncerramentoExigencia=function(){};var initialState=_this.getInitialState();_this.state=initialState;return _this;}/**
   * Identifica dependentes a ter parecer emitido:
   *  - capacidades: INVALIDO_INCAPAZ, INVALIDO_CAPAZ
   *//**
   * Determina a acao que estara disponivel para cada dependente:
   * - Usuario esta criando um requerimento ou cumprindo exigencias, dependente pode ser alterado;
   * - Usuario esta emitindo parecer, dependente pode ser alterado se tiver a Capacidade adequada;
   * - Em outras situacoes, o dependente pode apenas ser visualizado.
   *//**
   * Determina quais colunas devem ser exibidas na tabela de arquivos
   *//**
   * Altera um dependente da lista
   *//**
   * Exclui um arquivo da lista
   *//**
   * Adiciona arquivo a lista
   */_createClass(UploadArquivos,[{key:'render',value:function render(){var _this2=this;var listaArquivosIndexada=this.props.arquivos!==undefined?this.props.arquivos.map(function(item,i){return Object.assign({},item,{acoes:i,nome:item.documento.name});}):[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["e" /* DataGrid */],{title:'Upload de Arquivos',icon:'ico-doc-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["u" /* Table */],{bordered:true,data:listaArquivosIndexada,insertRow:this.props.estadoFormulario!=='criado'&&['novo','cumprir-exigencia','indeferidos'].includes(this.props.acao)||Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["f" /* habilitarUploadNaConsultaDoRequerimento */])(this.props.requerimento,this.props.acao,this.props.temBloqueioAtivoContratoDtp),options:this.options,listaTableHeader:this.montaArquivosTableHeader(),pagination:true,fetchInfo:this.fetchInfo}),this.state.showDocumentUploadModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__pages_requerimentos_ModalUploadArquivos__["a" /* default */],Object.assign({},this.props,{requerimento:this.props.requerimento,handleDocumentSent:this.handleDocumentSent,handleFailDocumentSent:this.realizaConsulta,handleModal:function handleModal(){return _this2.handleModal('showDocumentUploadModal');},showModal:this.state.showDocumentUploadModal,tiposDocumentos:this.props.tiposDocumentos,addArquivo:this.addArquivo,possuiExigenciaDocumento:this.state.possuiExigenciaDocumento,listaExigencias:this.props.listaExigencias})):'');}}]);return UploadArquivos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UploadArquivos.propTypes={acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,arquivos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({tipo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired,tiposDocumentos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};UploadArquivos.defaultProps={tiposDocumentos:[]};/* harmony default export */ __webpack_exports__["a"] = (UploadArquivos);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAlteracaoDataCessacao=function(_Component){_inherits(ModalAlteracaoDataCessacao,_Component);function ModalAlteracaoDataCessacao(props,context){_classCallCheck(this,ModalAlteracaoDataCessacao);var _this=_possibleConstructorReturn(this,(ModalAlteracaoDataCessacao.__proto__||Object.getPrototypeOf(ModalAlteracaoDataCessacao)).call(this,props,context));_this.getInitialState=function(){return{dataCessacaoBeneficio:_this.props.dataCessacaoBeneficio,motivoCessacaoManual:_this.props.estadoFormulario.requerimento.motivoCessacaoManual,touched:false};};_this.checkIfFileCanBeSent=function(){return _this.state.dataCessacaoBeneficio||_this.state.dataCessacaoBeneficio==='';};_this.diffRequerimento=function(){var _this$props=Object.assign({},_this.props),tipoRequerimento=_this$props.tipoRequerimento;if(tipoRequerimento===2){return'pensao';}return'aposentadoria';};_this.handleSave=function(){var tipo=_this.diffRequerimento();var url='alterar-data-cessacao-requerimento-'+tipo;var _this$props2=Object.assign({},_this.props),protocolo=_this$props2.protocolo;var _this$state=Object.assign({},_this.state),motivoCessacaoManual=_this$state.motivoCessacaoManual,dataCessacaoBeneficio=_this$state.dataCessacaoBeneficio;var objProtocolo=protocolo;var objMotivoCessacaoManual=motivoCessacaoManual;if(objMotivoCessacaoManual===''){objMotivoCessacaoManual=null;}var objAlteracao={protocolo:objProtocolo,motivoCessacaoManual:objMotivoCessacaoManual,dataCessacao:dataCessacaoBeneficio};var options=void 0;if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["n" /* doPut */])(url,objAlteracao,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,options);};_this.trataSucessoResponseEnvio=function(){var _this$props3=Object.assign({},_this.props),tipoRequerimento=_this$props3.tipoRequerimento;_this.handleClose();_this.props.atualizarDataCessacao(_this.state.dataCessacaoBeneficio);if(tipoRequerimento===1){_this.props.atualizarMotivoCessacao(_this.props.estadoFormulario.requerimento.motivoCessacaoManual);}Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["J" /* trataMensagemSucesso */])(['Data de cessação do benefício alterada']);};_this.modalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Data de Cessa\xE7\xE3o',mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,value:_this.state.dataCessacaoBeneficio,onChange:function onChange(e){return _this.handleChange(e,'dataCessacaoBeneficio');},touched:_this.state.touched}))));};_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!_this.checkIfFileCanBeSent(),hint:'Salvar',onClick:_this.handleSave,title:'Salvar'})));};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value));};_this.handleClose=function(){_this.setState({dataCessacaoBeneficio:null},_this.props.handleModal('exibirModalDataCessacao'));};_this.state=_this.getInitialState();return _this;}_createClass(ModalAlteracaoDataCessacao,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalFooter(),conteudomodal:this.modalContent(),onHide:this.handleClose,size:'md',showModal:this.props.showModal,title:'Alterar a data de cessa\xE7\xE3o do requerimento'}));}}]);return ModalAlteracaoDataCessacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalAlteracaoDataCessacao.propTypes={tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,dataCessacaoBeneficio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,atualizarDataCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,atualizarMotivoCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalAlteracaoDataCessacao);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masks__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable*/var Periodo=function(_Component){_inherits(Periodo,_Component);function Periodo(props){_classCallCheck(this,Periodo);return _possibleConstructorReturn(this,(Periodo.__proto__||Object.getPrototypeOf(Periodo)).call(this,props));}_createClass(Periodo,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:"2 2 2 2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{id:"dataInicio-"+this.props.periodo.index,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:"Data de In\xEDcio",required:true,disabled:this.props.disabledInputDate,value:this.props.state["dataInicio-"+this.props.periodo.index]?this.props.state["dataInicio-"+this.props.periodo.index]:this.props.periodo["dataInicio-"+this.props.periodo.index],onChange:function onChange(e){return _this2.props.changePeriodo(e,"dataInicio-"+_this2.props.periodo.index);},onBlur:function onBlur(){return _this2.props.validarRegras();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:"2 2 2 2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{id:"dataFim-"+this.props.periodo.index,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:"Data de Fim",required:true,disabled:this.props.disabledInputDate,value:this.props.state["dataFim-"+this.props.periodo.index]?this.props.state["dataFim-"+this.props.periodo.index]:this.props.periodo["dataFim-"+this.props.periodo.index],onChange:function onChange(e){return _this2.props.changePeriodo(e,"dataFim-"+_this2.props.periodo.index);},onBlur:function onBlur(){return _this2.props.validarRegras();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:"1 1 1 1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:"Anos",integer:true,disabled:true,value:this.props.periodo.totalAno})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:"1 1 1 1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:"Meses",integer:true,disabled:true,value:this.props.periodo.totalMes})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:"1 1 1 1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:"Dia",integer:true,disabled:true,value:this.props.periodo.totalDia})),this.props.periodo.index!==this.props.listaPeriodos.length-1&&this.props.displayButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:"1 1 1 1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Button */],{className:"ico-eraser",mini:true,hint:"Remover per\xEDodo",onClick:function onClick(){return _this2.props.removerPeriodo(_this2.props.periodo.index);}})),this.props.periodo.index===this.props.listaPeriodos.length-1&&this.props.displayButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:"1 1 1 1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Button */],{className:"ico-plus",mini:true,hint:"Adicionar per\xEDodo",disabled:this.props.verificarPreenchimentoPeriodos(),onClick:function onClick(){return _this2.props.adicionarPeriodo();}})));}}]);return Periodo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Periodo.propTypes={state:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,periodo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,listaPeriodos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({index:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,dataInicio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataFim:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,totalAno:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,totalMes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,totalDia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,diasCorridos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,displayButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,disabledInputDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,changePeriodo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validarRegras:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,verificarPreenchimentoPeriodos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,adicionarPeriodo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,removerPeriodo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Periodo);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_User__ = __webpack_require__(13);
/* eslint-disable */var RGPS='01000';var SegregacaoDeMassa=function SegregacaoDeMassa(props){var desabilitarSegregacaoMassaSolicitante=function desabilitarSegregacaoMassaSolicitante(){if(isAcaoNovo()){return false;}if(isAcaoConsulta()&&isSolicitanteIgualAoUsuarioLogado()&&isUsuarioLogadoRPPS()){return true;}if(isAcaoCumprirExigencia()&&isSolicitanteIgualAoUsuarioLogado()&&isUsuarioLogadoRPPS()){return false;}if(isAcaoIndeferidos()&&isSolicitanteIgualAoUsuarioLogado()&&isUsuarioLogadoRPPS()){return false;}return true;};var desabilitarSegregacaoMassaDestinatario=function desabilitarSegregacaoMassaDestinatario(){if((isAcaoNovo()||isAcaoCumprirExigencia()||isAcaoIndeferidos())&&isUsuarioLogadoRPPS()){return true;}if(isAcaoConsulta()&&isDestinatarioIgualAoUsuarioLogado()&&isUsuarioLogadoRPPS()){return true;}if(isAcaoRealizarAnalise()&&isDestinatarioIgualAoUsuarioLogado()&&isDestinatarioRPPS()&&isUsuarioLogadoRPPS()){return false;}return true;};var isAcaoNovo=function isAcaoNovo(){return props.estadoFormulario.acao==='novo';};var isAcaoCumprirExigencia=function isAcaoCumprirExigencia(){return props.estadoFormulario.acao==='cumprir-exigencia';};var isAcaoIndeferidos=function isAcaoIndeferidos(){return props.estadoFormulario.acao==='indeferidos';};var isAcaoConsulta=function isAcaoConsulta(){return props.estadoFormulario.acao==='consulta';};var isAcaoRealizarAnalise=function isAcaoRealizarAnalise(){return props.estadoFormulario.acao==='realizar-analise';};var isUsuarioLogadoRPPS=function isUsuarioLogadoRPPS(){return __WEBPACK_IMPORTED_MODULE_4__domain_User__["a" /* default */].logged().isRPPS();};var isUsuarioLogadoRGPS=function isUsuarioLogadoRGPS(){return __WEBPACK_IMPORTED_MODULE_4__domain_User__["a" /* default */].logged().isRGPS();};var isDestinatarioRGPS=function isDestinatarioRGPS(){return props.estadoFormulario.requerimento.destinatario&&props.estadoFormulario.requerimento.destinatario.codigo===RGPS;};var isDestinatarioRPPS=function isDestinatarioRPPS(){return props.estadoFormulario.requerimento.destinatario&&props.estadoFormulario.requerimento.destinatario.codigo!==RGPS;};var isSolicitanteRPPS=function isSolicitanteRPPS(){return props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.requerimento.solicitante.codigo!==RGPS;};var isDestinatarioIgualAoUsuarioLogado=function isDestinatarioIgualAoUsuarioLogado(){if(props.estadoFormulario.requerimento){return(props.estadoFormulario.requerimento.destinatario&&props.estadoFormulario.requerimento.destinatario.cnpj)===__WEBPACK_IMPORTED_MODULE_4__domain_User__["a" /* default */].logged().cnpjDoPapel();}return false;};var isSolicitanteIgualAoUsuarioLogado=function isSolicitanteIgualAoUsuarioLogado(){if(props.estadoFormulario.requerimento){return(props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.requerimento.solicitante.cnpj)===__WEBPACK_IMPORTED_MODULE_4__domain_User__["a" /* default */].logged().cnpjDoPapel();}return false;};var exibirBotaoAlterarSegregacaoMassaDestinatario=function exibirBotaoAlterarSegregacaoMassaDestinatario(){if(isUsuarioLogadoRPPS()&&isDestinatarioRPPS()&&props.estadoFormulario.requerimento&&props.estadoFormulario.requerimento.destinatario&&isAcaoConsulta()&&props.estadoFormulario.requerimento.destinatario.cnpj===__WEBPACK_IMPORTED_MODULE_4__domain_User__["a" /* default */].logged().cnpjDoPapel()){return true;}return false;};var exibirBotaoAlterarSegregacaoMassaSolicitante=function exibirBotaoAlterarSegregacaoMassaSolicitante(){if(isUsuarioLogadoRPPS()&&isSolicitanteRPPS()&&props.estadoFormulario.requerimento&&props.estadoFormulario.requerimento.solicitante&&isAcaoConsulta()&&props.estadoFormulario.requerimento.solicitante.cnpj===__WEBPACK_IMPORTED_MODULE_4__domain_User__["a" /* default */].logged().cnpjDoPapel()){return true;}return false;};var diffRequerimento=function diffRequerimento(){var _props$estadoFormular=Object.assign({},props.estadoFormulario),tipoRequerimento=_props$estadoFormular.tipoRequerimento;if(tipoRequerimento===2){return'pensao';}return'aposentadoria';};var addTiposSegregacaoDeMassaLabel=function addTiposSegregacaoDeMassaLabel(tipo){if(tipo){return __WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["V" /* tiposSegregacoesDeMassa */],Number(tipo)).label;}return'';};var labelSegregacaoDeMassaSolicitante=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Segrega\xE7\xE3o de massa do solicitante',value:addTiposSegregacaoDeMassaLabel(props.estadoFormulario.requerimento.tipoSegregacaoSolicitante)}));var comboSegregacaoDeMassaSolicitante=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:desabilitarSegregacaoMassaSolicitante(),placeholder:'',label:'Segrega\xE7\xE3o de massa do solicitante',itemList:__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["V" /* tiposSegregacoesDeMassa */],onChange:function onChange(e){return props.handleChange(e,'tipoSegregacaoSolicitante');},value:props.estadoFormulario.requerimento.tipoSegregacaoSolicitante,touched:props.estadoFormulario.touched,custom:true,exibirBotao:exibirBotaoAlterarSegregacaoMassaSolicitante(),onClickDoBotao:function onClickDoBotao(){return props.handleModalAlteraSegregacaoMassa('solicitante');},hintDoBotao:'Alterar segrega\xE7\xE3o de massa do solicitante',iconeDoBotao:'ico-pencil',classe:'icone'}));var labelSegregacaoDeMassaDestinatario=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Segrega\xE7\xE3o de massa do destinat\xE1rio',value:addTiposSegregacaoDeMassaLabel(props.estadoFormulario.requerimento.tipoSegregacaoDestinatario)}));var comboSegregacaoDeMassaDestinatario=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:desabilitarSegregacaoMassaDestinatario(),placeholder:'',label:'Segrega\xE7\xE3o de massa do destinat\xE1rio',itemList:__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["V" /* tiposSegregacoesDeMassa */],onChange:function onChange(e){return props.handleChange(e,'tipoSegregacaoDestinatario');},value:props.estadoFormulario.requerimento.tipoSegregacaoDestinatario,touched:props.estadoFormulario.touched,custom:true,exibirBotao:exibirBotaoAlterarSegregacaoMassaDestinatario(),onClickDoBotao:function onClickDoBotao(){return props.handleModalAlteraSegregacaoMassa('destinatario');},hintDoBotao:'Alterar segrega\xE7\xE3o de massa do destinat\xE1rio',iconeDoBotao:'ico-pencil',classe:'icone'}));var exibirComboSolicitante=function exibirComboSolicitante(){var retorno=diffRequerimento()==='aposentadoria'?comboSegregacaoDeMassaSolicitante:labelSegregacaoDeMassaSolicitante;if(isUsuarioLogadoRPPS()){if((isAcaoConsulta()||isAcaoCumprirExigencia()||isAcaoIndeferidos()||isAcaoNovo()||isAcaoRealizarAnalise())&&props.estadoFormulario.requerimento.solicitante!==undefined&&props.estadoFormulario.requerimento.solicitante.codigo===RGPS){retorno='';}return retorno;}else{//USUARIO LOGADO É RGPS
if((isAcaoConsulta()||isAcaoCumprirExigencia()||isAcaoIndeferidos()||isAcaoRealizarAnalise())&&props.estadoFormulario.requerimento.solicitante!==undefined&&props.estadoFormulario.requerimento.solicitante.codigo===RGPS){retorno='';}else if(isAcaoNovo()){retorno='';}}return retorno;};var exibirComboDestinatario=function exibirComboDestinatario(){var retorno=diffRequerimento()==='aposentadoria'?comboSegregacaoDeMassaDestinatario:labelSegregacaoDeMassaDestinatario;if((isAcaoConsulta()||isAcaoCumprirExigencia()||isAcaoIndeferidos()||isAcaoNovo()||isAcaoRealizarAnalise())&&props.estadoFormulario.requerimento.destinatario!==undefined&&props.estadoFormulario.requerimento.destinatario&&props.estadoFormulario.requerimento.destinatario.codigo===RGPS){retorno='';}else{if(props.estadoFormulario.requerimento.destinatario===RGPS){retorno='';}}return retorno;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,exibirComboSolicitante(),exibirComboDestinatario());};SegregacaoDeMassa.propTypes={estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleModalAlteraSegregacaoMassa:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (SegregacaoDeMassa);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */// import { DtpList } from 'dtp-react-components';
var DadosHistoricoRequerimento=function(_Component){_inherits(DadosHistoricoRequerimento,_Component);function DadosHistoricoRequerimento(props,context){_classCallCheck(this,DadosHistoricoRequerimento);var _this=_possibleConstructorReturn(this,(DadosHistoricoRequerimento.__proto__||Object.getPrototypeOf(DadosHistoricoRequerimento)).call(this,props,context));_this.getInitialState=function(){return{exigencia:null,showModal:false,montouEstadoMock:false};};_this.visualizaExigencia=function(exigencia){_this.setState({exigencia:exigencia,showModal:!_this.state.showModal});};_this.montaHistoricoEstados=function(){var listaRelacoes=[];// const lista = this.montaEstadoMock(this.props.historicoEstados);
_this.props.historicoEstados.forEach(function(estado,index){listaRelacoes.push(_this.montaListaEstados(estado,index));});return listaRelacoes;};_this.montaListaEstados=function(estado){var titulo='';if(_this.props.auth.checkPermission(['requerer-compensacao-rpps'])){titulo=estado.estado+' - '+estado.dataInicio+' '+(estado.codigoEstado==='4'?'- Dias no estado : '+estado.quantidadeDiasEmAnalise:'');}else{titulo=estado.estado+' - '+estado.dataInicio;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["w" /* Title */],{title:titulo,type:'section',fontWeight:'regular-16'}),_this.montaEstado(estado));};_this.montaEstadoMock=function(estados){var _this$state=Object.assign({},_this.state),montouEstadoMock=_this$state.montouEstadoMock;var listaEstados=estados;var estadoIndeferido={estado:'Indeferido',dataInicio:'27/11/2022',motivos:[{protocolo:'01000002789198471122052019',estado:'9',dataInicioEstado:'12/12/2022',motivo:1000,nome:'Teste Cucumber Outro I',comentario:'teste1'},{protocolo:'01000002789198471122052019',estado:'9',dataInicioEstado:'12/12/2022',motivo:1001,nome:'Teste Cucumber Outro V',comentario:'teste2',idDocumento:'01000002789198471122052019023011202211163248410',tipoDocumento:'Download documento de justificativa'},{protocolo:'01000002789198471122052019',estado:'9',dataInicioEstado:'12/12/2022',motivo:1002,nome:'Teste Cucumber Outro II',comentario:'teste3',idDocumento:'01000002789198471122052019133011202211140763598',tipoDocumento:'Download documento de justificativa'}],codigoEstado:'9'};if(!montouEstadoMock){listaEstados.push(estadoIndeferido);_this.setState({montouEstadoMock:true});}return listaEstados;};_this.montaEstado=function(estado){var listaItens=[];if(estado.motivo){listaItens.push(_this.montaMotivo(estado));}if(estado.comentarioEstadoRequerimento){listaItens.push(_this.montaComentarioEstadoRequerimento(estado));}if(estado.exigencias){if(estado.exigencias.length>0){listaItens.push(_this.montaListaExigencias(estado.exigencias));}}if(estado.acoesAuditoria){listaItens.push(_this.montaListaItensAcaoAuditoria(estado.acoesAuditoria));}if(estado.alertas){listaItens.push(_this.montaListaAlertas(estado.alertas));}if(estado.motivos){listaItens.push(_this.montaListaMotivosIndeferimento(estado.motivos));}// if (listaItens.length === 0) {
//   listaItens
//     .push('Não há detalhes a serem exibidos para este Estado.');
// }
return listaItens;};_this.montaListaExigencias=function(exigencias){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Exig\xEAncia(s) criada(s):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,_this.montaItensExigencia(exigencias)));};_this.montaItensExigencia=function(exigencias){var lista=[];exigencias.forEach(function(exigencia){lista.push(_this.montaExigencia(exigencia));});return lista;};_this.montaExigencia=function(exigencia){var dataEncerramento='';var comentario='';var motivoNaoAtendimento='';var comentarioNaoAtendimento='';if(exigencia.dataEncerramento){dataEncerramento=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Encerrada em: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,exigencia.dataEncerramento),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}if(exigencia.comentario){comentario=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Coment\xE1rio: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,exigencia.comentario),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}if(exigencia.motivoNaoAtendimento){motivoNaoAtendimento=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Motivo para o n\xE3o atendimento: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,exigencia.motivoNaoAtendimento),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}if(exigencia.comentarioNaoAtendimento){comentarioNaoAtendimento=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Coment\xE1rio para o n\xE3o atendimento: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,exigencia.comentarioNaoAtendimento));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,exigencia.acao,' - ',exigencia.situacao)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,dataEncerramento,comentario,motivoNaoAtendimento,comentarioNaoAtendimento)));};_this.montaMotivo=function(estado){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Motivo: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,estado.motivo)));};_this.montaComentarioEstadoRequerimento=function(estado){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Coment\xE1rio do Analista: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,estado.comentarioEstadoRequerimento)));};_this.montaListaItensAcaoAuditoria=function(itens){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'A\xE7\xE3o(\xF5es) ocorrida(s) neste estado:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,_this.montaItensAcaoAuditoria(itens)));};_this.montaItensAcaoAuditoria=function(itens){var listaAcoes=[];itens.forEach(function(acao){listaAcoes.push(_this.montaAcaoAuditoria(acao));});return listaAcoes;};_this.montaAcaoAuditoria=function(acao){var itemAuditoria=[];if(acao.data){itemAuditoria.push(acao.data);}if(acao.nome){itemAuditoria.push(acao.nome);}if(acao.descricao){itemAuditoria.push(acao.descricao);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,itemAuditoria.join(' - '))));};_this.montaAlerta=function(acao){var itemAlerta=[];if(acao.data){itemAlerta.push(acao.operacao);}if(acao.descricao){itemAlerta.push(acao.descricao);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,itemAlerta.join(' : '))));};_this.montaMotivoIndeferimento=function(motivo){var itemMotivo=[];var itemArquivo=[];if(motivo.dataInicio){itemMotivo.push(motivo.descricao);}if(motivo.comentario){itemMotivo.push(motivo.comentario);}var nomeDocumentoMotivo='';if(motivo.documento){nomeDocumentoMotivo=motivo.documento.toString();if(motivo.documento.indexOf('/')!==-1){nomeDocumentoMotivo=motivo.documento.toString().replace('/','-');}itemArquivo.push('Download documento de justificativa');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,itemMotivo.join(' : ')),itemArquivo&&itemArquivo.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{padding:'0',margin:'10px'},href:'#',onClick:function onClick(){return _this.downloadDocument(nomeDocumentoMotivo,'Documento de justificativa');}},itemArquivo))):''));};_this.montaMotivoCessacaoManual=function(){var itemMotivo=[];itemMotivo.push(_this.props.labelMotivoCessacao);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,itemMotivo.join(' : '))));};_this.downloadDocument=function(idDocumento,filename){Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["g" /* doGetFile */])(idDocumento,filename);};_this.montaItensAlerta=function(itens){var listaAlertas=[];itens.forEach(function(acao){listaAlertas.push(_this.montaAlerta(acao));});return listaAlertas;};_this.montaItensMotivoIndeferimento=function(itens){var listaMotivos=[];itens.forEach(function(motivo){if(_this.props.labelMotivoCessacao!==null&&motivo.estado==='12'){listaMotivos.push(_this.montaMotivoCessacaoManual());}else{listaMotivos.push(_this.montaMotivoIndeferimento(motivo));}});return listaMotivos;};_this.montaListaAlertas=function(itens){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Alerta(s) neste estado:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,_this.montaItensAlerta(itens)));};_this.montaListaMotivosIndeferimento=function(itens){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Motivo(s) neste estado:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,_this.montaItensMotivoIndeferimento(itens)));};_this.handleModal=function(){_this.setState({showModal:!_this.state.showModal});};_this.montaModalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'A\xE7\xE3o',value:_this.state.exigencia.acao})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Data de Encerramento',value:_this.state.exigencia.dataEncerramento})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Situa\xE7\xE3o',value:_this.state.exigencia.situacao}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{componentClass:'textarea',disabled:true,label:'Coment\xE1rio',value:_this.state.exigencia.comentario,textarea:true})),_this.state.exigencia.comentarioNaoAtendimento?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{componentClass:'textarea',disabled:true,label:'Coment\xE1rio para n\xE3o cumprimento',value:_this.state.exigencia.comentarioNaoAtendimento,textarea:true})):''));};_this.state=_this.getInitialState();return _this;}_createClass(DadosHistoricoRequerimento,[{key:'render',value:function render(){var modal=void 0;if(this.state.showModal){modal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:this.montaModalContent(),onHide:this.handleModal,showTitle:true,size:'lg',title:'Detalhes da exig\xEAncia',showModal:true}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,this.montaHistoricoEstados()),modal);}}]);return DadosHistoricoRequerimento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DadosHistoricoRequerimento.defaultProps={labelMotivoCessacao:null};DadosHistoricoRequerimento.propTypes={historicoEstados:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,labelMotivoCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (DadosHistoricoRequerimento);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterMotivos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SolicitanteDestinatario__ = __webpack_require__(73);
var filterMotivos=function filterMotivos(lista,requerimento,tipo){var motivosCessacaoFiltrado=[];var codigoTipo=tipo==='aposentadoria'?1:2;if(requerimento.solicitante){var inss='01000';var destinatarioOuSolicitanteRGPS=[requerimento.solicitante.codigo,requerimento.destinatario.codigo].includes(inss);var acordos=destinatarioOuSolicitanteRGPS?[1,3]:[2,3];var regimes=requerimento.solicitante.codigo===inss?[1,3]:[2,3];motivosCessacaoFiltrado=lista.filter(function(motivo){return motivo.abrangenciaAplicavel===codigoTipo&&regimes.includes(motivo.regimeAplicavel)&&acordos.includes(motivo.acordoAplicavel);});}return motivosCessacaoFiltrado;};var DadosCessacaoAposentadoria=function DadosCessacaoAposentadoria(props){var isDestinatarioRPPS=function isDestinatarioRPPS(){var estadoFormulario=props.estadoFormulario;var requerimento=estadoFormulario.requerimento,acao=estadoFormulario.acao;if(acao==='realizar-analise'||acao==='cumprir-exigencia'||acao==='consulta'){return requerimento.destinatario&&requerimento.destinatario.codigo!=='01000'&&requerimento.destinatario.codigo!==null;}if(acao==='novo'){return requerimento.destinatario!=='01000'&&requerimento.destinatario!==null;}return requerimento.destinatario&&requerimento.destinatario.codigo!=='01000';};var addTipoAposentadoriaLabel=function addTipoAposentadoriaLabel(tipo){var lista=isDestinatarioRPPS()?__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["C" /* tipoAposentadoriaRPPS */]:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["B" /* tipoAposentadoriaRGPS */];var objeto=__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */](lista,tipo);return objeto?objeto.label:'';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SolicitanteDestinatario__["a" /* default */],{requerimento:props.estadoFormulario.requerimento}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["e" /* DataGrid */],{title:'Dados do Requerimento de Aposentadoria',icon:'ico-money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Tipo da aposentadoria',value:addTipoAposentadoriaLabel(props.estadoFormulario.requerimento.tipoBeneficio)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Data de In\xEDcio de Benef\xEDcio',value:props.estadoFormulario.requerimento.dataInicioBeneficio})),props.estadoFormulario.requerimento.numeroBeneficio?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'NB',value:props.estadoFormulario.requerimento.numeroBeneficio})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Matr\xEDcula Regime Instituidor',value:props.estadoFormulario.requerimento.matricula}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Nome',value:props.estadoFormulario.requerimento.nome}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:props.estadoFormulario.desabilitarFormulario,label:'Motivo da Cessa\xE7\xE3o',error:!props.estadoFormulario.validadeCampos.motivoCessacao,touched:props.estadoFormulario.touched,placeholder:'Selecione o motivo da cessa\xE7\xE3o',onChange:function onChange(e){return props.handleChange(e,'motivoCessacao');},value:props.estadoFormulario.requerimento.motivoCessacao,itemList:filterMotivos(props.motivosCessacaoRequerimento,props.estadoFormulario.requerimento,'aposentadoria'),number:true,required:true,custom:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:props.estadoFormulario.desabilitarFormulario,label:'Fonte da Cessa\xE7\xE3o',touched:props.estadoFormulario.touched,placeholder:'Selecione a fonte da cessa\xE7\xE3o',onChange:function onChange(e){return props.handleChange(e,'fonteCessacao');},value:props.estadoFormulario.requerimento.fonteCessacao,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["l" /* fonteCessacaoAposentadoria */],number:true,custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:props.estadoFormulario.desabilitarFormulario,mask:__WEBPACK_IMPORTED_MODULE_2__utils_masks__["a" /* default */].date,error:!props.estadoFormulario.validadeCampos.dataCessacaoBeneficio,label:'Data da Cessa\xE7\xE3o',onChange:function onChange(e){return props.handleChange(e,'dataCessacaoBeneficio');},value:props.estadoFormulario.requerimento.dataCessacaoBeneficio,touched:props.estadoFormulario.touched,required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:props.estadoFormulario.desabilitarFormulario,cols:'74',componentClass:'textarea',label:'Descri\xE7\xE3o do motivo da Cessa\xE7\xE3o',maxlength:'200',onChange:function onChange(e){return props.handleChange(e,'descricaoMotivoCessacao');},rows:'3',required:[33,35].includes(props.estadoFormulario.requerimento.motivoCessacao),value:props.estadoFormulario.requerimento.descricaoMotivoCessacao,textarea:true})))));};DadosCessacaoAposentadoria.propTypes={estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,motivosCessacaoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})})};DadosCessacaoAposentadoria.defaultProps={match:null,motivosCessacaoRequerimento:null};/* harmony default export */ __webpack_exports__["a"] = (DadosCessacaoAposentadoria);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__impressaoCronogramaPagamento_css__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__impressaoCronogramaPagamento_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__impressaoCronogramaPagamento_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MENSAGENS={noContentPrimary:'Não foi possível consultar o cronograma.',noContentSecondary:'Contate o administrador do sistema.',cronogramaNaoEncontrado:'Cronograma não encontrado para a chave informada.',informeCronogramaValido:'Informe um cronograma válido.'};var CLASSES_CSS={esconderPrint:'esconder-print',cabecalho:'dtp-header',logoUsuario:'user-target',footer:'dtp-footer'};var STYLES_CSS={painelGeral:{textAlign:'center',margin:'0 auto'},painelCronograma:{display:'inline-block',width:'460px',padding:'6px 6px'},itemCronograma:{display:'flex',padding:'3px',borderRadius:'5px',color:'white',height:'70px',verticalAlign:'middle',marginBottom:'6px',boxShadow:'5px 4px 8px rgba(0, 0, 0, 0.8)'},itemCronogramaData:{display:'inline-block',width:'71px',fontWeight:'500',fontSize:'20px',padding:'17px 6px 0',borderRight:'2px solid rgba(255, 255, 255, 0.5)',verticalAlign:'middle',flexGrow:'1'},itemCronogramaDescricao:{display:'inline-block',textAlign:'left',verticalAlign:'middle',fontWeight:'600',paddingTop:'12px',fontSize:'15px',marginLeft:'10px',flexGrow:'2',width:'367px'}};var ITEMS=[{cor:'rgba(0, 105, 177, 1)',descricao:'Consulta de débito dos entes federativos na RFB/PGFN e do contratação da Dataprev.'},{cor:'rgba(133, 104, 90, 1)',descricao:'Consulta de óbitos dos requerimentos do COMPREV.'},{cor:'rgba(98, 103, 16, 1)',descricao:'Fechamento da prévia da folha de pagamento do COMPREV.'},{cor:'rgba(91, 155, 213, 1)',descricao:'Início do período de consulta prévia da folha de pagamento.'},{cor:'rgba(191, 103, 163, 1)',descricao:'Fechamento da folha de pagamento do COMPREV.'},{cor:'rgba(0, 95, 107, 1)',descricao:'Disponibilização dos relatórios de pagamento com o fechamento.'},{cor:'rgba(110, 91, 110, 1)',descricao:'Envio do arquivo de pagamentos do RGPS ao Banco do Brasil.'},{cor:'rgba(192, 80, 77, 1)',descricao:'Prazo para pagamento dos valores devidos pelos regime.'},{cor:'rgba(226, 148, 2, 1)',descricao:'Marco Limite para Informar Rejeição de Pagamento.'},{cor:'rgba(103, 181, 136, 1)',descricao:'Marco Limite para Analisar Rejeição de Pagamento.'}];var InfoCronogramaVisualCompetencia=function(_React$Component){_inherits(InfoCronogramaVisualCompetencia,_React$Component);function InfoCronogramaVisualCompetencia(props){_classCallCheck(this,InfoCronogramaVisualCompetencia);var _this=_possibleConstructorReturn(this,(InfoCronogramaVisualCompetencia.__proto__||Object.getPrototypeOf(InfoCronogramaVisualCompetencia)).call(this,props));_this.getInitialState=function(){return{infoCronogramaAnterior:_this.createCronograma(),infoCronogramaSelecionada:_this.createCronograma(),infoCronogramaPosterior:_this.createCronograma(),dados:[],showNoContent:false,noContentPrimaryMessage:'',noContentSecondaryMessage:''};};_this.createCronograma=function(){return{ano:null,mes:null,dataCND:null,dataObitos:null,dataFechamentoPrevia:null,dataConsultaPrevia:null,dataFechamentoFolha:null,dataRelatoriosBG:null,dataEnvioBB:null,dataPrazoPagamento:null,dataPrazoDefesa:null,dataPrazoAnalise:null,competencia:null};};_this.mudarPrintClasses=function(action){var elements=[document.getElementsByClassName(CLASSES_CSS.cabecalho)[0],document.getElementsByClassName(CLASSES_CSS.logoUsuario)[0],document.getElementsByClassName(CLASSES_CSS.footer)[0]];elements.forEach(function(element){if(element)element.classList[action](CLASSES_CSS.esconderPrint);});};_this.buscaCronograma=function(){var paramCompetenciaAnterior=_this.props.match.params.mes3+'/'+_this.props.match.params.ano3;var paramCompetenciaEscolhida=_this.props.match.params.mes1+'/'+_this.props.match.params.ano1;var paramCompetenciaPosterior=_this.props.match.params.mes2+'/'+_this.props.match.params.ano2;Object(__WEBPACK_IMPORTED_MODULE_2__utils_requests__["e" /* doGet */])('cronogramas-pagamento/visualizar-cronogramas',_this.handleSuccess,_this.handleError,{competenciaAnterior:paramCompetenciaAnterior,competenciaEscolhida:paramCompetenciaEscolhida,competenciaPosterior:paramCompetenciaPosterior});};_this.handleSuccess=function(response){if(response.data){_this.setState({dados:response.data,infoCronogramaAnterior:Object.assign({},_this.state.infoCronogramaAnterior,response.data[0]),infoCronogramaSelecionada:Object.assign({},_this.state.infoCronogramaSelecionada,response.data[1]),infoCronogramaPosterior:Object.assign({},_this.state.infoCronogramaPosterior,response.data[2])});}};_this.handleError=function(error){var mensagemPrimaria=MENSAGENS.noContentPrimary;var mensagemSecundaria=MENSAGENS.noContentSecondary;if(error){if(error.status){if(error.status===404){mensagemPrimaria=MENSAGENS.cronogramaNaoEncontrado;mensagemSecundaria=MENSAGENS.informeCronogramaValido;}}}_this.setState(Object.assign({},_this.state,{showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria}));};_this.obterDiaMes=function(data){if(data){var lista=data.split('/');return lista[0]+'/'+lista[1];}return'';};_this.obterMesAno=function(data){if(data){var lista=data.split('/');return lista[1]+'/'+lista[2];}return'';};_this.gerarItem=function(cor,data,descricao,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,style:Object.assign({},STYLES_CSS.itemCronograma,{backgroundColor:cor}),className:'imprimirCronograma'+String(index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:STYLES_CSS.itemCronogramaData},_this.obterDiaMes(data)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:STYLES_CSS.itemCronogramaDescricao},descricao));};_this.renderCronograma=function(cronograma,titulo){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:STYLES_CSS.painelCronograma},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{color:'#3060a0',fontSize:'22px',textAlign:'left'}},titulo,': ',cronograma.competencia),ITEMS.map(function(item,index){return _this.gerarItem(item.cor,cronograma[Object.keys(cronograma)[index+2]],item.descricao,index);}));};_this.state=_this.getInitialState();return _this;}_createClass(InfoCronogramaVisualCompetencia,[{key:'componentDidMount',value:function componentDidMount(){this.buscaCronograma();this.mudarPrintClasses('add');}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.mudarPrintClasses('remove');}},{key:'render',value:function render(){var _state=this.state,infoCronogramaAnterior=_state.infoCronogramaAnterior,infoCronogramaSelecionada=_state.infoCronogramaSelecionada,infoCronogramaPosterior=_state.infoCronogramaPosterior;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.state.dados.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:STYLES_CSS.painelGeral},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{style:{color:'#3060a0',fontSize:'24px',fontWeight:'600'}},'Cronograma Comprev'),this.renderCronograma(infoCronogramaAnterior,'Competência Anterior'),this.renderCronograma(infoCronogramaSelecionada,'Competência Escolhida'),this.renderCronograma(infoCronogramaPosterior,'Competência Posterior')));}}]);return InfoCronogramaVisualCompetencia;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);InfoCronogramaVisualCompetencia.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({mes1:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ano1:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mes2:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ano2:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mes3:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ano3:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.function}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func})};InfoCronogramaVisualCompetencia.defaultProps={match:null,auth:null};/* harmony default export */ __webpack_exports__["a"] = (InfoCronogramaVisualCompetencia);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_validator_cnpjValidator__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_masks__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrgaoVinculado=function(_Component){_inherits(OrgaoVinculado,_Component);_createClass(OrgaoVinculado,null,[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){var _state=Object.assign({},state),validadeCampos=_state.validadeCampos;if(props.orgaoVinculado&&!state.didProps){if(props.errosOrgaoVinculado){props.errosOrgaoVinculado.forEach(function(item){validadeCampos[item.atributo]=false;});return{orgaoVinculado:Object.assign({},props.orgaoVinculado),validadeCampos:validadeCampos,errosOrgaoVinculado:props.errosOrgaoVinculado,touched:true,didProps:true};}return{orgaoVinculado:Object.assign({},props.orgaoVinculado),touched:true,didProps:true};}return null;}}]);function OrgaoVinculado(props){_classCallCheck(this,OrgaoVinculado);var _this=_possibleConstructorReturn(this,(OrgaoVinculado.__proto__||Object.getPrototypeOf(OrgaoVinculado)).call(this));_this.getInitialState=function(){var initialState={orgaoVinculado:{cnpj:null,idParticipante:null,nomeOrgaoVinculado:null,situacao:null},touched:false,validadeCampos:{cnpj:false,nomeOrgaoVinculado:false,situacao:true},didUpdate:false,didProps:false,errosOrgaoVinculado:null,estadoFormulario:'inicial'};return initialState;};_this.formularioProntoParaEnvio=function(){return Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);};_this.resetState=function(){_this.setState(_this.getInitialState());_this.props.onHide();_this.props.resetOrgaoVinculado();};_this.validarCnpjOrgaoVinculado=function(cnpj){return Object(__WEBPACK_IMPORTED_MODULE_4__utils_validator_cnpjValidator__["a" /* default */])(cnpj);};_this.handleButton=function(){var cnpjValido=_this.validarCnpjOrgaoVinculado(_this.state.orgaoVinculado.cnpj);if(cnpjValido===false){Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["L" /* trataMensagensErro */])(['CNPJ Inválido. Informe um CNPJ válido.']);}else{var touched=true;_this.setState(Object.assign({},_this.state,{touched:touched}),_this.handleEnviar);}};_this.handleEnviar=function(){_this.props.addOrgaoVinculado(_this.state.orgaoVinculado,_this.props.orgaoVinculado);if(_this.state.errosOrgaoVinculado){_this.props.validacaoErrosOrgaoVinculado(_this.state.errosOrgaoVinculado);}_this.resetState();};_this.handleChange=function(changeObj,name){var _this$props=Object.assign({},_this.props),acao=_this$props.acao;var _this$state=Object.assign({},_this.state),estadoFormulario=_this$state.estadoFormulario;if(acao==='novo'&&_this.state.errosOrgaoVinculado&&_this.state.errosOrgaoVinculado.length>=1){estadoFormulario='alterado';}var valor=changeObj.value;if(name==='nomeOrgaoVinculado'){if(changeObj.value){valor=changeObj.value.toUpperCase();}}_this.setState({orgaoVinculado:Object.assign({},_this.state.orgaoVinculado,_defineProperty({},name,valor)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid)),estadoFormulario:estadoFormulario});};_this.desabilitaInput=function(listaAcoesEditaveis){return(// if (this.props.consulta) {
//   return true;
// }
!listaAcoesEditaveis.includes(_this.props.acaoModal));};_this.determinaTitulo=function(){var titulo=void 0;switch(_this.props.acaoModal){case'edicao':titulo='Edição de Orgão Vinculado';break;default:titulo='Inclusão de Orgão Vinculado';}return titulo;};var state=_this.getInitialState();if(props.orgaoVinculado){var _state2=Object.assign({},state),validadeCampos=_state2.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});state.validadeCampos=validadeCampos;}_this.state=state;return _this;}// Para cada Input, sinalizar as acoes em que o mesmo pode ser alterado
// Escolhe o titulo do modal baseado na acao
_createClass(OrgaoVinculado,[{key:'render',value:function render(){var _this2=this;var modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'370px','overflow-y':'auto','overflow-x':'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.state.orgaoVinculado.idParticipante!=null&&this.desabilitaInput(['criacao']),error:!this.state.validadeCampos.cnpj// integer
,label:'CNPJ',mask:__WEBPACK_IMPORTED_MODULE_6__utils_masks__["a" /* default */].cnpj,onChange:function onChange(e){return _this2.handleChange(e,'cnpj');},required:true,showMask:true,touched:this.state.touched,value:this.state.orgaoVinculado.cnpj})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */]// disabled={this.desabilitaInput(['criacao'])}
,{label:'Nome',maxLength:'100',error:!this.state.validadeCampos.nomeOrgaoVinculado,value:this.state.orgaoVinculado.nomeOrgaoVinculado,onChange:function onChange(e){return _this2.handleChange(e,'nomeOrgaoVinculado');},touched:this.state.touched,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},this.props.acaoModal!=='criacao'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */]// disabled={this.desabilitaInput(['criacao', 'edicao'])}
,{label:'Situa\xE7\xE3o',error:!this.state.validadeCampos.situacao,value:this.state.orgaoVinculado.situacao,number:true,itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["A" /* situacaoOrgaoVinculado */],onChange:function onChange(e){return _this2.handleChange(e,'situacao');},touched:this.state.touched,placeholder:'Selecione a situa\xE7\xE3o',custom:true}):''))));var modalFooter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{title:'Desfazer',onClick:this.resetState,hint:'Desfazer'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!this.formularioProntoParaEnvio(),title:this.props.orgaoVinculado?'Confirmar':'Adicionar',onClick:this.handleButton,hint:this.props.orgaoVinculado?'Confirmar Operação':'Adicionar orgão Vinculado'})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:modalContent,conteudofooter:modalFooter,onHide:this.resetState,showTitle:true,size:'lg',title:this.determinaTitulo()}));}}]);return OrgaoVinculado;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrgaoVinculado.propTypes={acaoModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['criacao','edicao']),onHide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,consulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (OrgaoVinculado);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable*/var jssLinhaCalculadora={display:'flex',padding:'0 30px 0 15px',marginBottom:'3px'};var jssColEsquerdaCalculadora={display:'inline-block'};var jssFillerLinhaCalculadora={display:'inline-block',flexGrow:'1',borderBottomStyle:'dotted',borderBlockWidth:'1px',height:'17px',margin:'0 10px 0 7px'};var jssColDireitaCalculadora={display:'inline-block'};var TIPO_MENSAGEM_DEFESA_EXTRAORDINARIA='15';var CalculadoraPagamento=function(_Component){_inherits(CalculadoraPagamento,_Component);function CalculadoraPagamento(props){_classCallCheck(this,CalculadoraPagamento);var _this=_possibleConstructorReturn(this,(CalculadoraPagamento.__proto__||Object.getPrototypeOf(CalculadoraPagamento)).call(this,props));_this.getInicialState=function(){return{retornoCalculado:false,dataVencimento:_this.props.infoPagamento.dataVencimento,valorCompensacao:_this.props.infoPagamento.valorCompensacao,dataPagamento:null,valorParcial:null,valorParcialNumber:_this.props.valorParcial,valorTotal:null,valorBaseCalculo:_this.props.infoPagamento.valorCompensacao,listaAcrescimosLegaisResultado:[]};};_this.habilitarBotao=function(){var valido=false;if(_this.state.dataVencimento&&_this.state.dataPagamento&&_this.state.valorBaseCalculo){valido=true;}return valido;};_this.handleTextChange=function(changeObj,name){if(!_this.state.retornoCalculado){_this.setState(Object.assign({},_this.state,_defineProperty({},name,changeObj.value)));}//if(name==='valorParcial'){
//  this.setState({valorFaltantePagamento: this.calculaDiferencaEntreValorTotalPagamentoEValorParcial(this.state.valorTotal)})
//}
};_this.handleKeyUp=function(e){var retorno=e.target.value;retorno=_this.formatarValorMonetario(retorno);e.target.value=retorno;return retorno;};_this.handleCalcular=function(){if(_this.state.dataVencimento&&_this.state.dataPagamento&&_this.state.valorBaseCalculo){var dataVencimento=_this.state.dataVencimento.replace(/\//g,'').replace(/_/g,'');var dataPagamento=_this.state.dataPagamento.replace(/\//g,'').replace(/_/g,'');var objValorBaseCalculo=_this.state.valorBaseCalculo;var mensagemErro=null;if(_this.props.infoPagamento&&_this.props.infoPagamento.cronogramaPagamentoTO&&_this.props.infoPagamento.cronogramaPagamentoTO.dataPrazoDefesa){if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(dataPagamento,'DD/MM/YYYY').toDate()>__WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.props.infoPagamento.cronogramaPagamentoTO.dataPrazoDefesa,'DD/MM/YYYY').toDate()){mensagemErro='A data de pagamento deve ser menor ou igual que a data limite de defesa.';//trataMensagensErro(['A data de pagamento deve ser menor ou igual que a data limite de defesa.']);
//valido = false;
}}if(!_this.props.opcaoNovaMensagem||_this.props.opcaoNovaMensagem&&_this.props.opcaoNovaMensagem!==TIPO_MENSAGEM_DEFESA_EXTRAORDINARIA){if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(dataPagamento,'DD/MM/YYYY').toDate()<=__WEBPACK_IMPORTED_MODULE_2_moment___default()(dataVencimento,'DD/MM/YYYY').toDate()){mensagemErro='A data de pagamento deve ser maior que a data de vencimento.';// trataMensagensErro(['A data de pagamento deve ser maior que a data de vencimento.']);
}}if(!mensagemErro){var url='acrescimos-legais/'+dataVencimento+'/'+dataPagamento+'/'+objValorBaseCalculo;if(_this.props.opcaoNovaMensagem===TIPO_MENSAGEM_DEFESA_EXTRAORDINARIA){url='acrescimos-legais/'+dataVencimento+'/'+dataPagamento+'/'+objValorBaseCalculo+'/'+_this.props.opcaoNovaMensagem;}Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])(url,_this.trataSucessoResponse);}else{Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])([mensagemErro]);}}};_this.calculaDiferencaEntreValorTotalPagamentoEValorParcial=function(valorTotalPagamento){if(_this.state.valorParcialNumber){return valorTotalPagamento-_this.state.valorParcialNumber;}var valorParcialFormatado=_this.state.valorParcial===null||_this.state.valorParcial===undefined?0.0:_this.state.valorParcial.replace('.','').replace(',','.');var resultado=valorTotalPagamento-parseFloat(valorParcialFormatado);return resultado;};_this.parseValorParcial=function(){var valorParcialFormatado=_this.state.valorParcial===null||_this.state.valorParcial===undefined?0.0:_this.state.valorParcial.replace('.','');var resultado=parseFloat(valorParcialFormatado);return resultado;};_this.trataSucessoResponse=function(response){if(response.data){_this.setState({valorTotal:response.data.valorTotalPagamento,valorFaltantePagamento:_this.calculaDiferencaEntreValorTotalPagamentoEValorParcial([response.data.valorTotalPagamento]),valorJuros:response.data.valorTotalJuros,valorMulta:response.data.valorTotalMulta,listaAcrescimosLegaisResultado:[response.data],retornoCalculado:true});}if(_this.props.incluirJuroseMultaNaMensagem){_this.props.incluirJuroseMultaNaMensagem(response.data,_this.state.dataPagamento);}};_this.recuperarColunasDescritivoMulta=function(){var cabecalhoTabela=[{id:'diasAtraso',label:'Dias de Atraso'},{id:'multaPorDia',label:'% Multa (diária)',dataFormat:_this.formatarPercentual},{id:'multaAcumulada',label:'% Multa (acumulada)',dataFormat:_this.formatarPercentual},{id:'valorTotalMulta',label:'Valor Total Multa',dataFormat:_this.formatarValor}];return cabecalhoTabela;};_this.recuperarColunasDescritivoJuroSelic=function(){var cabecalhoTabela=[{id:'listaMeAnoSelicAcumulada',label:'Meses Considerados',dataFormat:_this.formatarMesesConsiderados},{id:'selicAcumulada',label:'% Selic Acumulada',dataFormat:_this.formatarPercentual},{id:'valorTotalJuroSelicAcumulada',label:'Valor Total da Selic Acumulada',dataFormat:_this.formatarValor}];return cabecalhoTabela;};_this.recuperarColunasDescritivoJuroFixo=function(){var cabecalhoTabela=[{id:'juroFixo',label:'% Juro Fixo',dataFormat:_this.formatarPercentual},{id:'valorTotalJuroFixo',label:'Valor Total do Juro Fixo',dataFormat:_this.formatarValor}];return cabecalhoTabela;};_this.recuperarColunasCalculoFinal=function(){var cabecalhoTabela=[{id:'dataVencimento',label:'Data de Vencimento',dataFormat:_this.formatarData},{id:'dataPagamento',label:'Data de Pagamento',dataFormat:_this.formatarData},{id:'valorBaseCalculo',label:'Valor Base de Cálculo',dataFormat:_this.formatarValor},{id:'valorTotalMulta',label:'Valor Total da Multa',dataFormat:_this.formatarValor},{id:'valorTotalJuros',label:'Valor Total de Juros',dataFormat:_this.formatarValor},{id:'valorTotalPagamento',label:'Valor Total de Pagamento',dataFormat:_this.formatarValor}];return cabecalhoTabela;};_this.formatarValor=function(valor){var valorFormatado='0.0';if(valor){var formato={minimumFractionDigits:2,maximumFractionDigits:3,style:'currency',currency:'BRL'};valorFormatado=valor.toLocaleString('pt-BR',formato);}return valorFormatado;};_this.formatarPercentual=function(valor){var valorFormatado='0.0';if(valor){var formato={minimumFractionDigits:2,maximumFractionDigits:3};valorFormatado=valor.toLocaleString('pt-BR',formato);}return valorFormatado;};_this.formatarMesesConsiderados=function(lista){var listaMesesConsideradosFormatado='--------';if(lista){if(lista.length===1){listaMesesConsideradosFormatado=lista;}else{listaMesesConsideradosFormatado=lista[0].concat(' a ').concat(lista[lista.length-1]);}}return listaMesesConsideradosFormatado;};_this.formatarData=function(data){var dataFormatada='';if(data){dataFormatada=__WEBPACK_IMPORTED_MODULE_2_moment___default()(data).format('DD/MM/YYYY');}return dataFormatada;};_this.state=_this.getInicialState();/* this.state = {
      acrescimosLegaisPesquisa: {
        dataVencimento: null,
        dataPagamento: null,
        valorBaseCalculo: null,
      },
      listaAcrescimosLegaisResultado: [],
      valorTotal: null,
    };*/return _this;}_createClass(CalculadoraPagamento,[{key:'formatarValorMonetario',value:function formatarValorMonetario(valor){var retorno=valor;if(retorno.length>0&&retorno.indexOf('_')!==-1){retorno=retorno.toString().replace('_','');}retorno=retorno.toString().replace(/\D/g,'');retorno=retorno.toString().replace(/(\d)(\d{11})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{8})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{5})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{2})$/,'$1,$2');return retorno;}},{key:'render',value:function render(){var _this2=this;var options={withoutNoDataText:true};var formatoMoeda={minimumFractionDigits:2,maximumFractionDigits:3,style:'currency',currency:'BRL'};//console.log('AQUI',this.props.infoPagamento);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["s" /* SimpleGrid */],{title:'',icon:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["y" /* DtpPanel */],{title:'Acr\xE9scimos Legais'},this.props.mostrarCamposAdicionais&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].date,label:'Data de Vencimento Original',readOnly:true,onChange:function onChange(e){return _this2.handleTextChange(e,'dataVencimento');},value:this.state.dataVencimento})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{currency:true,readOnly:true,showMask:false,label:'Valor da compensa\xE7\xE3o',maxLength:'12',value:this.state.valorCompensacao,onChange:function onChange(e){return _this2.handleTextChange(e,'valorCompensacao');},onKeyUp:function onKeyUp(e){return _this2.handleKeyUp(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{currency:true,showMask:false,label:'Valor parcial pago',maxLength:'12',value:this.state.valorParcial,onChange:function onChange(e){return _this2.handleTextChange(e,'valorParcial');},onKeyUp:function onKeyUp(e){return _this2.handleKeyUp(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].date,label:'Data efetiva do Pagamento',required:true,value:this.state.dataPagamento,onChange:function onChange(e){return _this2.handleTextChange(e,'dataPagamento');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3'},!this.state.retornoCalculado?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* Button */],{className:'dtp-primary right',disabled:!this.habilitarBotao,title:'Calcular',hint:'Calcular Acr\xE9scimos Legais',onClick:this.handleCalcular}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* Button */],{className:'right',disabled:!this.habilitarBotao,title:'Reiniciar',hint:'Calcular Acr\xE9scimos Legais',onClick:function onClick(){_this2.setState(_this2.getInicialState());if(_this2.props.incluirJuroseMultaNaMensagem){_this2.props.incluirJuroseMultaNaMensagem(null,null);};}}))),this.state.retornoCalculado&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:jssLinhaCalculadora},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColEsquerdaCalculadora},'Vencimento:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssFillerLinhaCalculadora}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColDireitaCalculadora},this.state.dataVencimento)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:jssLinhaCalculadora},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColEsquerdaCalculadora},'Valor da compensa\xE7\xE3o:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssFillerLinhaCalculadora}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColDireitaCalculadora},this.state.valorCompensacao.toLocaleString('pt-BR',formatoMoeda))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:jssLinhaCalculadora},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColEsquerdaCalculadora},'Multa calculada para o pagamento em ',this.state.dataPagamento,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssFillerLinhaCalculadora}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColDireitaCalculadora},this.state.valorMulta.toLocaleString('pt-BR',formatoMoeda),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:jssLinhaCalculadora},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColEsquerdaCalculadora},'Juros calculados para o pagamento em ',this.state.dataPagamento,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssFillerLinhaCalculadora}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColDireitaCalculadora},this.state.valorJuros.toLocaleString('pt-BR',formatoMoeda),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:jssLinhaCalculadora},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColEsquerdaCalculadora},'Valor total a ser transferido at\xE9 ',this.state.dataPagamento,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssFillerLinhaCalculadora}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColDireitaCalculadora},' ',this.state.valorTotal.toLocaleString('pt-BR',formatoMoeda),' ')),(this.state.valorParcialNumber||this.state.valorParcial)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:jssLinhaCalculadora},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColEsquerdaCalculadora},'Valor parcial pago:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssFillerLinhaCalculadora}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColDireitaCalculadora},' ',this.state.valorParcialNumber?this.state.valorParcialNumber.toLocaleString('pt-BR',formatoMoeda):this.state.valorParcial,' ')),(this.state.valorParcialNumber||this.state.valorParcial)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:jssLinhaCalculadora},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColEsquerdaCalculadora},'Valor faltante para completar o pagamento:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssFillerLinhaCalculadora}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssColDireitaCalculadora},' ',this.state.valorFaltantePagamento.toLocaleString('pt-BR',formatoMoeda),' ')))));}}]);return CalculadoraPagamento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CalculadoraPagamento.propTypes={estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,incluirJuroseMultaNaMensagem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,opcaoNovaMensagem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CalculadoraPagamento);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FiltroRelatorio=function(_Component){_inherits(FiltroRelatorio,_Component);function FiltroRelatorio(){_classCallCheck(this,FiltroRelatorio);var _this=_possibleConstructorReturn(this,(FiltroRelatorio.__proto__||Object.getPrototypeOf(FiltroRelatorio)).call(this));_this.getValidationState=function(){var d1=_this.state.competenciaInicial;var d2=_this.state.competenciaFinal;if(d1.length!==6&&d1.length!==0||d2.length!==6&&d1.length!==0){return'error';}var d1Ano=parseInt(d1.substring(2,6),10);var d2Ano=parseInt(d2.substring(2,6),10);var d1Mes=parseInt(d1.substring(0,2),10);var d2Mes=parseInt(d2.substring(0,2),10);if(d1Mes>12||d2Mes>12){return'error';}if(d2Ano<d1Ano||d2Ano===d1Ano&&d2Mes<d1Mes){return'error';}var months=(d2Ano-d1Ano)*12;months-=d1Mes;months+=d2Mes;if(months>12||months<0){return'error';}return'active';};_this.radioRelacao=[{label:'Todos',value:'todos'},{label:'Solicitante',value:'solicitante'},{label:'Destinatário',value:'destinatario'}];_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.handleChangeRadio=function(value){_this.setState({relacao:value});};_this.trataFormulario=function(campoAlterado){if(campoAlterado==='tipoEntidade'){_this.setState({'destinatario-rpps':null,uf:null});}if(campoAlterado==='uf'){_this.setState({'destinatario-rpps':null});}if(campoAlterado==='superintendencia'){_this.setState({gex:null,aps:null,ente:null});if(_this.state.superintendencia){_this.carregaUnidadesOrganicas(3,_this.state.superintendencia,_this.carregaGexs);}}if(campoAlterado==='gex'){_this.setState({aps:null,ente:null});if(_this.state.gex){_this.carregaUnidadesOrganicas(4,_this.state.gex,_this.carregaAps);}}if(campoAlterado==='aps'){_this.setState({ente:null});if(_this.state.aps){_this.carregaEntesFederativos(_this.state.aps);}}};_this.listaFiltradaDestinatarios=function(){var listaParticipantes=_this.props.destinatarios.filter(function(item){if(item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)){return item;}return null;});return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.carregaUnidadesOrganicas=function(categoria,codigoSuperior,sucesso){var parametros={};if(codigoSuperior){parametros.codigoSuperior=codigoSuperior;}if(categoria){parametros.categoria=categoria;}Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('unidades-organicas',sucesso,_this.tratarErro,parametros);};_this.carregaSuperintendencias=function(response){var superintendencias=[];response.data.forEach(function(item){superintendencias.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaSuperintendencias:superintendencias});};_this.carregaGexs=function(response){var gexs=[];response.data.forEach(function(item){gexs.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaGexs:gexs});};_this.carregaAps=function(response){var aps=[];response.data.forEach(function(item){aps.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaAps:aps});};_this.carregaEntesFederativos=function(aps){var parametros={aps:aps};Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('entes-federativos',_this.tratarSucessoEntesFederativos,_this.tratarErro,parametros);};_this.tratarSucessoEntesFederativos=function(response){var entes=[];response.data.forEach(function(item){entes.push({label:item.nomeRpps,value:item.idParticipante});});_this.setState({listaEntes:entes});};_this.montaFiltrosDefault=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{integer:true,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].compet,label:'* Compet\xEAncia Inicial',value:_this.state.competenciaInicial,onChange:function onChange(e){return _this.handleChange(e,'competenciaInicial');},validationState:_this.getValidationState()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{integer:true,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].compet,label:'* Compet\xEAncia Final',value:_this.state.competenciaFinal,onChange:function onChange(e){return _this.handleChange(e,'competenciaFinal');},validationState:_this.getValidationState()}))),!_this.state.tipoEntidade&&_this.props.filtroModalidade&&_this.props.rgps?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["o" /* Radio */],{value:_this.state.relacao,name:'Rela\xE7\xE3o',itemList:_this.radioRelacao,onChange:function onChange(value){return _this.handleChangeRadio(value);}}))):'',!_this.state.tipoEntidade&&_this.props.rgps?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Superintend\xEAncia',onChange:function onChange(e){return _this.handleChange(e,'superintendencia');},placeholder:'Todas',value:_this.state.superintendencia,itemList:_this.state.listaSuperintendencias,custom:true})),_this.state.superintendencia?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'GEX',onChange:function onChange(e){return _this.handleChange(e,'gex');},placeholder:'Todas',value:_this.state.gex,itemList:_this.state.listaGexs,custom:true})):'',_this.state.gex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'APS',onChange:function onChange(e){return _this.handleChange(e,'aps');},placeholder:'Todas',value:_this.state.aps,itemList:_this.state.listaAps,custom:true})):''):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},_this.state.aps?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Ente Federativo',onChange:function onChange(e){return _this.handleChange(e,'ente');},placeholder:'Todos',value:_this.state.ente,itemList:_this.state.listaEntes,custom:true})):''),!_this.state.superintendencia&&_this.props.rgps?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Entidade',onChange:function onChange(e){return _this.handleChange(e,'tipoEntidade');},placeholder:'Selecione a entidade',value:_this.state.tipoEntidade,itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["E" /* tipoEntidade */],custom:true,number:true})),_this.state.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'UF',onChange:function onChange(e){return _this.handleChange(e,'uf');},placeholder:'Selecione a UF',value:_this.state.uf,itemList:_this.carregaUfDosMunicipios(),custom:true})):'',_this.state.tipoEntidade?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Destinat\xE1rio',name:'destinatario-rpps',onChange:function onChange(e){return _this.handleChange(e,'destinatario-rpps');},placeholder:'Selecione o destinat\xE1rio',value:_this.state['destinatario-rpps'],itemList:_this.listaFiltradaDestinatarios(),custom:true})):''):'');};_this.handleSearch=function(){_this.props.handleSearchFilter(_this.state);};_this.state={competenciaInicial:'',competenciaFinal:'',tipoEntidade:null,uf:null,'destinatario-rpps':null,superintendencia:null,gex:null,aps:null,ente:null,listaSuperintendencias:[],listaGexs:[],listaAps:[],listaEntes:[],relacao:'todos'};return _this;}_createClass(FiltroRelatorio,[{key:'componentDidMount',value:function componentDidMount(){this.carregaUnidadesOrganicas(24,null,this.carregaSuperintendencias);}},{key:'render',value:function render(){var _this2=this;var filtrosPesquisa=this.montaFiltrosDefault();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'relatorio',panelId:'filtro-relatorio',icon:'ico-filter',title:'Filtro de Relat\xF3rio de '+this.props.tipo},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearch();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroRelatorio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroRelatorio.propTypes={handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroRelatorio);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index__ = __webpack_require__(2);
// import JsPDF from 'jspdf';
// import 'jspdf-autotable';
// import base64image from '../../utils/base64image';
/* const exportarPdf = (props) => {
  const doc = new JsPDF({
    orientation: props.landscape ? 'landscape' : 'portrait',
  });
  const totalPagesExp = '{total_pages_count_string}';
  const head = [[' '].concat(props.headers)];
  const body = props.data.map((item, i) => [i + 1].concat(Object.values(item)));
  doc.autoTable({
    head,
    body,
    styles: { halign: 'center' },
    didDrawPage(data) {
      const diaAtual = new Date();
const diaAtualFormatado = `${diaAtual.getDate()}/${diaAtual.getMonth()}/${diaAtual.getFullYear()}`;
      doc.setFontSize(10);
      doc.setFontStyle('bold');
      // Header
      doc.addImage(base64image, 'PNG', data.settings.margin.left, 15, 10, 10);
  doc.text(`${props.legend} - Emitido em ${diaAtualFormatado}`, data.settings.margin.left + 15, 22);

      // Footer
      let str = `Página ${doc.internal.getNumberOfPages()}`;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = `${str} de ${totalPagesExp}`;
      }
      doc.setFontSize(10);

      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      const { pageSize } = doc.internal;
      const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      doc.text(str, data.settings.margin.left, pageHeight - 10);
    },
    margin: { top: 30 },
  });

  // Total page number plugin only available in jspdf v1.0+
  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp);
  }

  doc.save('relatorio.pdf');
}; */var exportarCsv=function exportarCsv(props){var dadosRelatorio=null;if(props.exportacao&&props.exportacao!==undefined&&props.exportacao.length>0){dadosRelatorio=props.exportacao;}else{dadosRelatorio=props.data;}if(dadosRelatorio&&dadosRelatorio!==undefined&&dadosRelatorio.length>0){var csvExporter=new __WEBPACK_IMPORTED_MODULE_3_export_to_csv__["ExportToCsv"]({filename:'relatorio',fieldSeparator:';',showTitle:true,title:props.legend,showLabels:true,headers:props.headers.map(function(val){return val.replace(' (*)','');})});csvExporter.generateCsv(dadosRelatorio);}};// const decideTamanhoColuna = numeroCampos => 2000 / numeroCampos;
var atribuirHint=function atribuirHint(props){var hint='';if(props){switch(props.estado){case __WEBPACK_IMPORTED_MODULE_4__utils_constants__["d" /* estadosRequerimento */].INDEFERIDO:hint='Relatorio Analítico estado indeferido';break;case __WEBPACK_IMPORTED_MODULE_4__utils_constants__["d" /* estadosRequerimento */].ANALISE_SUSPENSA:hint='Relatorio Analítico estado análise suspensa';break;case __WEBPACK_IMPORTED_MODULE_4__utils_constants__["d" /* estadosRequerimento */].COMPENSADO:hint='Relatorio Analítico estado compensado';break;case __WEBPACK_IMPORTED_MODULE_4__utils_constants__["d" /* estadosRequerimento */].EM_EXIGENCIA:hint='Relatório Analítico estado em exigência';break;default:break;}}return hint;};var handleExigenciaCompleto=function handleExigenciaCompleto(props){props.exigenciasCompletoAction(props.rowAtual,'analitico-especial-completo',props.estado);};var Relatorio=function Relatorio(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{hint:'Exportar para CSV',onClick:function onClick(){exportarCsv(props);},icon:'ico-doc-sheet',mini:true}),props.voltarAction?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{hint:'Voltar',icon:'ico-arrow-curve-left',mini:true,onClick:function onClick(){return props.voltarAction();}}):null,props.paramExibirBotaoRelatorioAnalitico?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{hint:atribuirHint(props),icon:'ico-clipboard-list',mini:true,onClick:function onClick(){handleExigenciaCompleto(props);}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relatorio',style:{'--relatorioWidth':props.containerStyle.width}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["H" /* DtpTable */],props,props.headers.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["I" /* DtpTableHeader */],{key:item,dataField:props.data[0]?Object.keys(props.data[0])[i]:'default',dataAlign:'center',isKey:i===0,header:item,tdStyle:{wordBreak:'break-word'},dataFormat:props.dataFormatOptions[i],hidden:props.options.hidden&&props.options.hidden.includes(i)});})))):null);};Relatorio.propTypes={dataFormatOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectfunc,voltarAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,exigenciasCompletoAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;Relatorio.defaultProps={voltarAction:function voltarAction(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (Relatorio);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return obterTipoMensagem; });
/* eslint-disable */var obterTipoMensagem=function obterTipoMensagem(idxTipo){var tipo={motivo:'',descricaoMotivo:''};var descricaoMotivoDefesaExtraordinaria='O pagador está fora dos prazos legais para apresentar uma defesa, portanto é facultado ao recebedor analisar esta defesa.';descricaoMotivoDefesaExtraordinaria+='Caso não responda, prevalecerá o último estado pago/não pago, antes da primeira mensagem extraordinária.';var descricaoMotivoContestacaoExtraordinaria='O recebedor está fora dos prazos legais para apresentar uma contestação, portanto é facultado ao pagador responder a esta contestação.';descricaoMotivoContestacaoExtraordinaria+='Caso não responda, prevalecerá o último estado pago/não pago, antes da primeira mensagem extraordinária.';switch(idxTipo){case 1:tipo.motivo='Nenhum valor recebido';tipo.descricaoMotivo='O recebedor não identificou nenhum valor depositado.';break;case 2:tipo.motivo='Valor recebido incorreto';tipo.descricaoMotivo='O recebedor identificou um valor diferente do calculado pelo Comprev.';break;case 3:tipo.motivo='Valor pago corretamento dentro do prazo';tipo.descricaoMotivo='O Pagador informou que a transação bancária foi realizada com o valor correto dentro do prazo.';break;case 4:tipo.motivo='Valor pago após o vencimento (em atraso)';tipo.descricaoMotivo='O Pagador informou que a transação bancária foi realizada após a data de vencimento com o valor acrescido dos juros e multa devidos.';break;case 5:tipo.motivo='Valor foi rejeitado pela instituição financeira';tipo.descricaoMotivo='O Pagador informou que a transação bancária foi rejeitada por diverências nos dados bancários.';break;case 6:tipo.motivo='Pagamento aprovado';tipo.descricaoMotivo='O recebedor aprovou a defesa do pagamento';tipo.msgSistema='Pagamento aprovado automaticamente por perda de prazo de análise.';break;case 7:tipo.motivo='Confirmação do valor rejeitado';tipo.descricaoMotivo='O recebedor confirmou que as informações bancárias deste pagamento estão incorretas impossibilitando o pagamento.';tipo.msgSistema='Confirmação de pagamento rejeitado automaticamente por perda de prazo de análise.';break;case 8:tipo.motivo='Pagamento reprovado';tipo.descricaoMotivo='O recebedor reprovou a defesa do pagamento';tipo.msgSistema='Pagamento reprovado automaticamente por perda de prazo de defesa.';break;case 9:tipo.motivo='Defesa de regularidade do pagamento';tipo.descricaoMotivo='Defesa de regularidade do pagamento';tipo.msgSistema='Defesa de regularidade do pagamento.';break;case 10:tipo.motivo='Defesa de regularidade do pagamento aprovada';tipo.descricaoMotivo='Defesa de regularidade do pagamento aprovada';tipo.msgSistema='Defesa de regularidade do pagamento aprovada.';break;case 11:tipo.motivo='Defesa de regularidade do pagamento reprovada';tipo.descricaoMotivo='Defesa de regularidade do pagamento reprovada';tipo.msgSistema='Defesa de regularidade do pagamento reprovada.';break;case 12:tipo.motivo='Defesa do pagamento da GRU';tipo.descricaoMotivo='Comprovação de pagamento da GRU ';tipo.msgSistema='Comprovação de pagamento da GRU .';break;case 13:tipo.motivo='Defesa do pagamento de GRU';tipo.descricaoMotivo='Pagamento aprovado';tipo.msgSistema='Defesa de regularidade do pagamento da GRU aprovada.';break;case 14:tipo.motivo='Defesa do pagamento de GRU';tipo.descricaoMotivo='Pagamento reprovado';tipo.msgSistema='Defesa de regularidade do pagamento da GRU reprovada.';break;case 15:tipo.motivo='Defesa extraordinária';tipo.descricaoMotivo=descricaoMotivoDefesaExtraordinaria;tipo.msgSistema='';break;case 16:tipo.motivo='Contestação Extraordinária';tipo.descricaoMotivo=descricaoMotivoContestacaoExtraordinaria;tipo.msgSistema='';break;default:tipo.motivo='Mensagem desconhecida';tipo.descricaoMotivo='';}return tipo;};

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelecaoSuperintendencia__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var participanteRGPS='01000';var FiltroRelatorioTotalizadorEstados=function(_Component){_inherits(FiltroRelatorioTotalizadorEstados,_Component);function FiltroRelatorioTotalizadorEstados(){_classCallCheck(this,FiltroRelatorioTotalizadorEstados);var _this=_possibleConstructorReturn(this,(FiltroRelatorioTotalizadorEstados.__proto__||Object.getPrototypeOf(FiltroRelatorioTotalizadorEstados)).call(this));_this.configurarSelecaoMultipla=function(estado){var configuracao=void 0;switch(estado){case'2':configuracao={// listaSource: this.props.exigencias,
labelCombobox:"Exigência",titulo:"Tipos de exigência",exibirBotaoIncluir:true,exibirTabelaItens:true,retirarLinhaSeparadora:false,exibirComboBox:true};break;case'9':configuracao={// listaSource: this.props.motivosIndeferimento,
labelCombobox:"Motivo de indeferimento",titulo:"Tipos de indeferimento",exibirBotaoIncluir:true,exibirTabelaItens:true,retirarLinhaSeparadora:false,exibirComboBox:true};break;case'10':configuracao={// listaSource: this.props.motivosSuspensao,
labelCombobox:"Motivo de suspensão",titulo:"Tipos de suspensão",exibirBotaoIncluir:false,exibirTabelaItens:false,retirarLinhaSeparadora:false,exibirComboBox:true};break;case'12':configuracao={// listaSource: this.props.motivosCessacao,
labelCombobox:"Motivo de cessação",titulo:"Tipos de cessação",exibirBotaoIncluir:false,exibirTabelaItens:false,retirarLinhaSeparadora:false,exibirComboBox:true};break;default:configuracao={// listaSource: [],
labelCombobox:"",titulo:"",exibirBotaoIncluir:false,exibirTabelaItens:false,retirarLinhaSeparadora:true,exibirComboBox:false};break;}return configuracao;};_this.filtrarRegimes=function(){var retorno=_this.state.listaTiposRegimes;if(_this.props.papelUsuarioLogado==='analista-rgps'||_this.state.tipoRegimeObservador===1&&Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)){retorno=_this.state.listaTiposRegimes.filter(function(item){return item.label!=='RGPS';});}if(_this.state.tipoRegimeObservador===2&&Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)){retorno=__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */];}_this.setState({listaTiposRegimes:retorno});};_this.handleChangeOpcao=function(value){_this.filtrarRegimes();var ehVisao=false;if([2,3].includes(value)){ehVisao=true;}else{ehVisao=false;}_this.setState({opcao:value,consultaPorVisao:ehVisao},function(){return _this.limparFormulario(value);});};_this.handleChange=function(changeObj,name){var _this$setState;var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var configuracao=_this.state.configComponenteSelecaoMultipla;var limparCampos=false;if(name==='estado'){configuracao=_this.configurarSelecaoMultipla(changeObj.value);_this.setState({lista:[]});}if(name==='tipoRegimeObservador'){if(changeObj.value===1){_this.setState({participanteObservador:participanteRGPS});}_this.setState({tipoRegimeObservador:changeObj.value},_this.filtrarRegimes);// if (this.state.tipoRegimeObservador !== null && (this.state.tipoRegimeObservador !== changeObj.value)) {
//   limparCampos = true;
// }
}if(name==='tipoRegime'){if(changeObj.value===1){_this.setState({participante:participanteRGPS});}// if (this.state.tipoRegime && (this.state.tipoRegime !== changeObj.value)) {
//   limparCampos = true;
// }
}if(name==='estado'){if(_this.state.valorComboSelecaoMultipla!==null&&_this.state.valorComboSelecaoMultipla!==changeObj.value){limparCampos=true;}}if(callback===null){callback=function callback(){return _this.trataFormulario(limparCampos,name);};}// if(callback === 'filtrarRegimes') {
//   callback = () => this.filtrarRegimes();
// }
_this.setState((_this$setState={},_defineProperty(_this$setState,name,changeObj.value),_defineProperty(_this$setState,'configComponenteSelecaoMultipla',configuracao),_this$setState),callback);};_this.handleChangeRadio=function(changeObj,name){var _this$setState2;_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,changeObj.value),_defineProperty(_this$setState2,'consultaPorVisao',true),_this$setState2));};_this.trataFormulario=function(limparCampos,campoAlterado){if(campoAlterado==='tipoRegimeObservador'&&limparCampos){_this.setState({tipoEntidadeObservador:null,uFObservador:null,participanteObservador:null,opcao:null,participante:null,tipoEntidade:null,uf:null});}if(campoAlterado==='tipoRegime'&&limparCampos){_this.setState({tipoEntidade:null,uF:null,participante:null});}if(campoAlterado==='estado'&&limparCampos){_this.setState({valorComboSelecaoMultipla:null});}if(campoAlterado==='tipoEntidade'){_this.setState({participante:null,uf:null});}if(campoAlterado==='uf'){_this.setState({participante:null});}if(campoAlterado==='superintendencia'){_this.setState({gex:null,aps:null,ente:null});if(_this.state.superintendencia){_this.carregaUnidadesOrganicas(3,_this.state.superintendencia,_this.carregaGexs);}}if(campoAlterado==='gex'){_this.setState({aps:null,ente:null});if(_this.state.gex){_this.carregaUnidadesOrganicas(4,_this.state.gex,_this.carregaAps);}}};_this.limparFormulario=function(valor){if(valor===''||(valor===2||valor===3)&&_this.state.tipoEntidade!==null){_this.setState({tipoEntidade:null});}if((valor===2||valor===3)&&_this.state.participante!==null){_this.setState({participante:null});}if(_this.state.tipoRegime!==null){_this.setState({tipoRegime:null});}if(_this.state.superintendencia!==null){_this.setState({superintendencia:null});}if(_this.state.gex!==null){_this.setState({gex:null});}if(_this.state.visao!==null){_this.setState({visao:null});}_this.props.observardorDeMudanca();};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.carregarListaTiposRegimes=function(){_this.setState({listaTiposRegimes:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */]});};_this.carregaUnidadesOrganicas=function(categoria,codigoSuperior,sucesso){var parametros={};if(codigoSuperior){parametros.codigoSuperior=codigoSuperior;}if(categoria){parametros.categoria=categoria;}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('unidades-organicas',sucesso,_this.tratarErro,parametros);};_this.carregaSuperintendencias=function(response){var superintendencias=[];response.data.forEach(function(item){superintendencias.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaSuperintendencias:superintendencias});};_this.carregaGexs=function(response){var gexs=[];response.data.forEach(function(item){gexs.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaGexs:gexs});};_this.carregaAps=function(response){var aps=[];response.data.forEach(function(item){aps.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaAps:aps});};_this.carregaEntesFederativos=function(aps){var parametros={aps:aps};Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('entes-federativos',_this.tratarSucessoEntesFederativos,_this.tratarErro,parametros);};_this.tratarSucessoEntesFederativos=function(response){var entes=[];response.data.forEach(function(item){entes.push({label:item.nomeRpps,value:item.idParticipante});});_this.setState({listaEntes:entes});};_this.validaNaoEhSuperintendenciaESelecionouAmbos=function(){var opcaoAmbos=1;return!_this.state.superintendencia&&_this.state.opcao===opcaoAmbos;};_this.validaEhPapelObservador=function(){return Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)&&!_this.state.tipoRegimeObservador;};_this.validaEhPapelObservadorERegimeSelecionado=function(){return _this.props.papelUsuarioLogado==='analista-rgps'&&_this.state.opcao!==1||Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)&&_this.state.tipoRegimeObservador===1&&_this.state.opcao!==1;};_this.verificarTextoHintBotaoInclusao=function(){var retorno='item';switch(_this.state.estado){case'2':retorno='exigência';break;case'9':retorno='motivo';break;default:break;}return retorno;};_this.montaFiltrosDefault=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__["a" /* default */],{handleChange:_this.handleChange,destinatarios:_this.props.destinatarios,papelUsuarioLogado:_this.props.papelUsuarioLogado,titulo:'Visualizar como',retirarLinhaSeparadora:false,tipoRegime:_this.state.tipoRegimeObservador,tipoEntidade:_this.state.tipoEntidadeObservador,uf:_this.state.uFObservador,participante:_this.state.participanteObservador,nomeAtributoComboboxRegime:'tipoRegimeObservador',nomeAtributoComboboxParticipante:'participanteObservador',nomeAtributoComboboxTipoEntidade:'tipoEntidadeObservador',nomeAtributoComboboxUF:'uFObservador',listaTiposRegimes:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */],labelComboboxParticipante:'Participante Observador'}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["f" /* DataGridCustom */],{title:'Filtro b\xE1sico'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["p" /* RadioComLabel */],{value:_this.state.opcao,name:'opcao',itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["r" /* opcaoFiltroTipoParticipacao */],onChange:function onChange(value){return _this.handleChangeOpcao(value);},animate:false,label:'Op\xE7\xE3o',disabled:_this.validaEhPapelObservador(),disposicao:'horizontal',required:true}))),_this.validaNaoEhSuperintendenciaESelecionouAmbos()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__["a" /* default */],{handleChange:_this.handleChange,destinatarios:_this.props.destinatarios,papelUsuarioLogado:_this.props.papelUsuarioLogado,titulo:'',retirarLinhaSeparadora:true,tipoRegime:_this.state.tipoRegime,tipoEntidade:_this.state.tipoEntidade,uf:_this.state.uf,participante:_this.state.participante,nomeAtributoComboboxRegime:'tipoRegime',nomeAtributoComboboxParticipante:'participante',nomeAtributoComboboxTipoEntidade:'tipoEntidade',nomeAtributoComboboxUF:'uf',listaTiposRegimes:_this.state.listaTiposRegimes,labelComboboxParticipante:'Participante'}):'',_this.validaEhPapelObservadorERegimeSelecionado()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SelecaoSuperintendencia__["a" /* default */],{handleChange:_this.handleChange,tipoRegime:_this.state.tipoRegime,papelUsuarioLogado:_this.props.papelUsuarioLogado,listaSuperintendencias:_this.state.listaSuperintendencias,listaGexs:_this.state.listaGexs,listaAps:_this.state.listaAps,superintendencia:_this.state.superintendencia,gex:_this.state.gex,aps:_this.state.aps,tipoRegimeObservador:_this.state.tipoRegimeObservador,titulo:'',retirarLinhaSeparadora:true}):''));};_this.handleSearch=function(){var participanteObservadorSelecionado=_this.state.participanteObservador;var regimeSelecionado=_this.state.tipoRegime;var entidadeSelecionada=_this.state.tipoEntidade;var ufSelecionada=_this.state.uf;var participanteSelecionado=_this.state.participante;var opcaoSelecionada=_this.state.opcao;var superintendenciaSelecionada=_this.state.superintendencia;if(Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)&&!participanteObservadorSelecionado){_this.addMessage('Selecione o participante Observador.');return;}if(!opcaoSelecionada){_this.addMessage('Selecione uma opção.');return;}// refatorar essa parte
if(_this.props.papelUsuarioLogado==='analista-rgps'||participanteObservadorSelecionado==='01000'){if(opcaoSelecionada&&opcaoSelecionada===1){if(!regimeSelecionado){_this.addMessage('Selecione um regime.');return;}if(regimeSelecionado!==1&&!entidadeSelecionada){_this.addMessage('Selecione uma entidade.');return;}if(entidadeSelecionada&&entidadeSelecionada===2&&ufSelecionada===null){_this.addMessage('Selecione uma UF.');return;}if(!participanteSelecionado){_this.addMessage('Selecione um participante.');return;}}else if(opcaoSelecionada&&opcaoSelecionada!==1){if(!superintendenciaSelecionada){_this.addMessage('Selecione uma superintendência.');return;}}}else{if(opcaoSelecionada&&opcaoSelecionada===1){if(!regimeSelecionado){_this.addMessage('Selecione um regime.');return;}if(regimeSelecionado!==1&&!entidadeSelecionada){_this.addMessage('Selecione uma entidade.');return;}if(entidadeSelecionada&&entidadeSelecionada===2&&ufSelecionada===null){_this.addMessage('Selecione uma UF.');return;}if(!participanteSelecionado){_this.addMessage('Selecione um participante.');return;}}}_this.props.handleSearchFilter(_this.state);};_this.handleSearchButton=function(){var filtroRelatorioTotalizador={tipoRegime:_this.state.tipoRegime,tipoRegimeObservador:_this.state.tipoRegimeObservador,tipoEntidade:_this.state.tipoEntidade,tipoEntidadeObservador:_this.state.tipoEntidadeObservador,uf:_this.state.uf,uFObservador:_this.state.uFObservador,participante:_this.state.participante,participanteObservador:_this.state.participanteObservador,superintendencia:_this.state.superintendencia,gex:_this.state.gex,aps:_this.state.aps,visao:_this.state.visao,opcao:_this.state.opcao,estado:_this.state.estado,consultaPorVisao:_this.state.consultaPorVisao,lista:_this.state.lista,configComponenteSelecaoMultipla:_this.state.configComponenteSelecaoMultipla,valorComboSelecaoMultipla:_this.state.valorComboSelecaoMultipla};filtroRelatorioTotalizador=JSON.stringify(filtroRelatorioTotalizador);sessionStorage.setItem(_this.props.nomeFiltro,filtroRelatorioTotalizador);_this.handleSearch();};if(_this.props&&_this.props.nomeFiltro){_this.filtroRelatorioTotalizador=JSON.parse(sessionStorage.getItem(_this.props.nomeFiltro));}_this.state={tipoRegime:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.tipoRegime?_this.filtroRelatorioTotalizador.tipoRegime:null,tipoRegimeObservador:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.tipoRegimeObservador?_this.filtroRelatorioTotalizador.tipoRegimeObservador:null,tipoEntidade:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.tipoEntidade?_this.filtroRelatorioTotalizador.tipoEntidade:null,tipoEntidadeObservador:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.tipoEntidadeObservador?_this.filtroRelatorioTotalizador.tipoEntidadeObservador:null,uf:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.uf?_this.filtroRelatorioTotalizador.uf:null,uFObservador:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.uFObservador?_this.filtroRelatorioTotalizador.uFObservador:null,participante:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.participante?_this.filtroRelatorioTotalizador.participante:null,participanteObservador:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.participanteObservador?_this.filtroRelatorioTotalizador.participanteObservador:null,superintendencia:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.superintendencia?_this.filtroRelatorioTotalizador.superintendencia:null,gex:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.gex?_this.filtroRelatorioTotalizador.gex:null,aps:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.aps?_this.filtroRelatorioTotalizador.aps:null,visao:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.visao?_this.filtroRelatorioTotalizador.visao:null,opcao:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.opcao?_this.filtroRelatorioTotalizador.opcao:null,estado:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.estado?_this.filtroRelatorioTotalizador.estado:null,consultaPorVisao:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.consultaPorVisao?_this.filtroRelatorioTotalizador.consultaPorVisao:null,configComponenteSelecaoMultipla:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.configComponenteSelecaoMultipla?_this.filtroRelatorioTotalizador.configComponenteSelecaoMultipla:null,lista:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.lista?_this.filtroRelatorioTotalizador.lista:[],valorComboSelecaoMultipla:_this.filtroRelatorioTotalizador&&_this.filtroRelatorioTotalizador.valorComboSelecaoMultipla?_this.filtroRelatorioTotalizador.valorComboSelecaoMultipla:null,listaSuperintendencias:[],listaGexs:[],listaAps:[],listaEntes:[],listaTiposRegimes:[],listaTiposRegimesOutrosPapeis:[]};return _this;}_createClass(FiltroRelatorioTotalizadorEstados,[{key:'componentDidMount',value:function componentDidMount(){if(sessionStorage.getItem(this.props.nomeFiltro)){this.handleSearch();}this.carregaUnidadesOrganicas(24,null,this.carregaSuperintendencias);this.carregarListaTiposRegimes();}},{key:'render',value:function render(){var _this2=this;var filtrosPesquisa=this.montaFiltrosDefault();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'relatorio',panelId:'filtro-relatorio',icon:'ico-filter',title:''+this.props.tipo},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroRelatorioTotalizadorEstados;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroRelatorioTotalizadorEstados.propTypes={handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,observardorDeMudanca:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,papelUsuarioLogado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nomeFiltro:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroRelatorioTotalizadorEstados);

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(223);
module.exports = __webpack_require__(228);


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(224).enable();
  window.Promise = __webpack_require__(226);
}

// fetch() polyfill for making API calls.
__webpack_require__(227);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(59);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(119);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(119);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 227 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_libicons_libicons_style_css__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_libicons_libicons_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_libicons_libicons_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_starscream_theme_dist_css_inss_css__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_starscream_theme_dist_css_inss_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_starscream_theme_dist_css_inss_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__registerServiceWorker__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers__ = __webpack_require__(57);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_8__reducers__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */],null)),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_7__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(59),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,A=n?Symbol.for("react.memo"):
60115,B=n?Symbol.for("react.lazy"):60116,C="function"===typeof Symbol&&Symbol.iterator;function aa(a,b,e,c,d,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[e,c,d,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},F={};
function G(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}G.prototype.isReactComponent={};G.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};G.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function H(){}H.prototype=G.prototype;function I(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}var J=I.prototype=new H;
J.constructor=I;k(J,G.prototype);J.isPureReactComponent=!0;var K={current:null,currentDispatcher:null},L=Object.prototype.hasOwnProperty,M={key:!0,ref:!0,__self:!0,__source:!0};
function N(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:d,_owner:K.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,e,c){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return e(c,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+U(d,h);g+=T(d,f,e,c)}else if(null===a||"object"!==typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,h++),g+=T(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function V(a,b,e){return null==a?0:T(a,"",b,e)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,function(a){return a}):null!=a&&(O(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+e)),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(P,"$&/")+"/");b=R(b,g,c,d);V(a,da,b);S(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=R(null,null,b,e);V(a,ca,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){O(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:G,PureComponent:I,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:B,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:A,type:a,compare:void 0===b?null:b}},Fragment:r,StrictMode:t,Suspense:z,createElement:N,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==
b.ref&&(h=b.ref,f=K.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=N.bind(null,a);b.type=a;return b},isValidElement:O,version:"16.6.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:K,
assign:k}};X.unstable_ConcurrentMode=x;X.unstable_Profiler=u;var Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(59),ba=__webpack_require__(231);function ca(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[c,d,e,f,g,h],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function t(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:t("227");function da(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,h,k){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,h,k){ka.apply(this,arguments);if(ea){if(ea){var l=fa;ea=!1;fa=null}else t("198"),l=void 0;ha||(ha=!0,ia=l)}}var ma=null,na={};
function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:t("96",a);if(!pa[c]){b.extractEvents?void 0:t("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.hasOwnProperty(h)?t("99",h):void 0;qa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:t("98",d,a)}}}}
function ra(a,b,c){sa[a]?t("100",a):void 0;sa[a]=b;ta[a]=b.eventTypes[c].dependencies}var pa=[],qa={},sa={},ta={},ua=null,va=null,wa=null;function xa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=wa(c);la(d,b,void 0,a);a.currentTarget=null}function ya(a,b){null==b?t("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function za(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Aa=null;function Ba(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)xa(a,b[d],c[d]);else b&&xa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ca={injectEventPluginOrder:function(a){ma?t("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?t("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=ua(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?t("231",b,typeof c):void 0;
return c}function Ea(a){null!==a&&(Aa=ya(Aa,a));a=Aa;Aa=null;if(a&&(za(a,Ba),Aa?t("95"):void 0,ha))throw a=ia,ha=!1,ia=null,a;}var Fa=Math.random().toString(36).slice(2),Ga="__reactInternalInstance$"+Fa,Ha="__reactEventHandlers$"+Fa;function Ia(a){if(a[Ga])return a[Ga];for(;!a[Ga];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ga];return 5===a.tag||6===a.tag?a:null}function Ja(a){a=a[Ga];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ka(a){if(5===a.tag||6===a.tag)return a.stateNode;t("33")}function La(a){return a[Ha]||null}function Ma(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Na(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a)}
function Oa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Ma(b);for(b=c.length;0<b--;)Na(c[b],"captured",a);for(b=0;b<c.length;b++)Na(c[b],"bubbled",a)}}function Pa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a))}function Qa(a){a&&a.dispatchConfig.registrationName&&Pa(a._targetInst,null,a)}
function Ra(a){za(a,Oa)}var Sa=!("undefined"===typeof window||!window.document||!window.document.createElement);function Ta(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ua={animationend:Ta("Animation","AnimationEnd"),animationiteration:Ta("Animation","AnimationIteration"),animationstart:Ta("Animation","AnimationStart"),transitionend:Ta("Transition","TransitionEnd")},Va={},Wa={};
Sa&&(Wa=document.createElement("div").style,"AnimationEvent"in window||(delete Ua.animationend.animation,delete Ua.animationiteration.animation,delete Ua.animationstart.animation),"TransitionEvent"in window||delete Ua.transitionend.transition);function Xa(a){if(Va[a])return Va[a];if(!Ua[a])return a;var b=Ua[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Wa)return Va[a]=b[c];return a}
var Ya=Xa("animationend"),Za=Xa("animationiteration"),$a=Xa("animationstart"),ab=Xa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,eb=null,fb=null;
function gb(){if(fb)return fb;var a,b=eb,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return fb=e.slice(a,1<d?1-d:void 0)}function hb(){return!0}function ib(){return!1}
function A(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?hb:ib;this.isPropagationStopped=ib;return this}
n(A.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=hb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=hb)},persist:function(){this.isPersistent=hb},isPersistent:ib,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ib;this._dispatchInstances=this._dispatchListeners=null}});A.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
A.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;jb(c);return c};jb(A);function kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function lb(a){a instanceof this?void 0:t("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function jb(a){a.eventPool=[];a.getPooled=kb;a.release=lb}var mb=A.extend({data:null}),nb=A.extend({data:null}),ob=[9,13,27,32],pb=Sa&&"CompositionEvent"in window,qb=null;Sa&&"documentMode"in document&&(qb=document.documentMode);
var rb=Sa&&"TextEvent"in window&&!qb,sb=Sa&&(!pb||qb&&8<qb&&11>=qb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
function wb(a,b){switch(a){case "keyup":return-1!==ob.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function zb(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
function Ab(a,b){if(yb)return"compositionend"===a||!pb&&wb(a,b)?(a=gb(),fb=eb=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
var Bb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(pb)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=gb()):(cb=d,eb="value"in cb?cb.value:cb.textContent,yb=
!0)),e=mb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Ra(e),f=e):f=null;(a=rb?zb(a,c):Ab(a,c))?(b=nb.getPooled(ub.beforeInput,b,c,d),b.data=a,Ra(b)):b=null;return null===f?b:null===b?f:[f,b]}},Cb=null,Db=null,Eb=null;function Hb(a){if(a=va(a)){"function"!==typeof Cb?t("280"):void 0;var b=ua(a.stateNode);Cb(a.stateNode,a.type,b)}}function Ib(a){Db?Eb?Eb.push(a):Eb=[a]:Db=a}function Jb(){if(Db){var a=Db,b=Eb;Eb=Db=null;Hb(a);if(b)for(a=0;a<b.length;a++)Hb(b[a])}}
function Kb(a,b){return a(b)}function Lb(a,b,c){return a(b,c)}function Mb(){}var Nb=!1;function Ob(a,b){if(Nb)return a(b);Nb=!0;try{return Kb(a,b)}finally{if(Nb=!1,null!==Db||null!==Eb)Mb(),Jb()}}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Sa)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Yb=/^(.*)[\\\/]/,B="function"===typeof Symbol&&Symbol.for,Zb=B?Symbol.for("react.element"):60103,$b=B?Symbol.for("react.portal"):60106,ac=B?Symbol.for("react.fragment"):60107,bc=B?Symbol.for("react.strict_mode"):60108,cc=B?Symbol.for("react.profiler"):60114,dc=B?Symbol.for("react.provider"):60109,ec=B?Symbol.for("react.context"):60110,fc=B?Symbol.for("react.concurrent_mode"):60111,gc=B?Symbol.for("react.forward_ref"):60112,hc=B?Symbol.for("react.suspense"):
60113,ic=B?Symbol.for("react.memo"):60115,jc=B?Symbol.for("react.lazy"):60116,kc="function"===typeof Symbol&&Symbol.iterator;function lc(a){if(null===a||"object"!==typeof a)return null;a=kc&&a[kc]||a["@@iterator"];return"function"===typeof a?a:null}
function mc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fc:return"ConcurrentMode";case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ic:return mc(a.type);case jc:if(a=1===a._status?a._result:null)return mc(a)}return null}function nc(a){var b="";do{a:switch(a.tag){case 2:case 16:case 0:case 1:case 5:case 8:case 13:var c=a._debugOwner,d=a._debugSource,e=mc(a.type);var f=null;c&&(f=mc(c.type));c=e;e="";d?e=" (at "+d.fileName.replace(Yb,"")+":"+d.lineNumber+")":f&&(e=" (created by "+f+")");f="\n    in "+(c||"Unknown")+e;break a;default:f=""}b+=f;a=a.return}while(a);return b}
var oc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(oc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function E(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var F={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new E(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new E(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new E(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new E(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new E(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){F[a]=new E(a,3,!0,a,null)});
["capture","download"].forEach(function(a){F[a]=new E(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){F[a]=new E(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){F[a]=new E(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function xc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
xc);F[b]=new E(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,xc);F[b]=new E(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,xc);F[b]=new E(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});F.tabIndex=new E("tabIndex",1,!1,"tabindex",null);
function yc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function zc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ac(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=zc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cc(a,b){b=b.checked;null!=b&&yc(a,"checked",b,!1)}
function Dc(a,b){Cc(a,b);var c=zc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Ec(a,b.type,c):b.hasOwnProperty("defaultValue")&&Ec(a,b.type,zc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Fc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Ec(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Gc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Hc(a,b,c){a=A.getPooled(Gc.change,a,b,c);a.type="change";Ib(c);Ra(a);return a}var Jc=null,Kc=null;function Lc(a){Ea(a)}
function Mc(a){var b=Ka(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Sa&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){"value"===a.propertyName&&Mc(Kc)&&(a=Hc(Kc,a,Rb(a)),Ob(Lc,a))}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}
function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
var Vc={eventTypes:Gc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ka(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,g=Rc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Hc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Ec(e,"number",e.value)}},Wc=A.extend({view:null,detail:null}),Xc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ia(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=dd,h=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)g=ed,h=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var m=null==f?e:Ka(f);e=null==b?e:Ka(b);a=g.getPooled(h,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Ma(g))l++;g=0;for(k=e;k;k=Ma(k))g++;for(;0<l-g;)b=Ma(b),l--;for(;0<g-l;)e=Ma(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Ma(b);e=Ma(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=Ma(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Ma(d)}for(d=0;d<b.length;d++)Pa(b[d],"bubbled",a);for(d=f.length;0<d--;)Pa(f[d],"captured",c);return[a,c]}},hd=Object.prototype.hasOwnProperty;function id(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function jd(a,b){if(id(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!hd.call(b,c[d])||!id(a[c[d]],b[c[d]]))return!1;return!0}function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?t("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?t("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}t("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:t("189")}}c.alternate!==d?t("190"):void 0}3!==c.tag?t("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var od=A.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=A.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=Wc.extend({relatedTarget:null});function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=Wc.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=dd.extend({dataTransfer:null}),wd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),xd=A.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[Ya,"animationEnd"],[Za,"animationIteration"],[$a,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ab,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case Ya:case Za:case $a:a=od;break;case ab:a=xd;break;case "scroll":a=Wc;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=A}b=a.getPooled(e,b,c,d);Ra(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ia(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<pa.length;h++){var k=pa[h];k&&(k=k.extractEvents(d,b,f,e))&&(g=ya(g,k))}Ea(g)}}var Hd=!0;
function G(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!1)}function Kd(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!0)}function Id(a,b){Lb(Jd,a,b)}
function Jd(a,b){if(Hd){var c=Rb(b);c=Ia(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Ob(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}var Ld={},Md=0,Nd="_reactListenersID"+(""+Math.random()).slice(2);
function Od(a){Object.prototype.hasOwnProperty.call(a,Nd)||(a[Nd]=Md++,Ld[a[Nd]]={});return Ld[a[Nd]]}function Pd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Td(){for(var a=window,b=Pd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Pd(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=Sa&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Pd(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&jd(Zd,c)?null:(Zd=c,a=A.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ra(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Od(e);f=ta.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ka(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua=La;va=Ja;wa=Ka;Ca.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:be,BeforeInputEventPlugin:Bb});function ce(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function ee(a,b){a=n({children:void 0},b);if(b=ce(b.children))a.children=b;return a}function fe(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+zc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function ge(a,b){null!=b.dangerouslySetInnerHTML?t("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function he(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?t("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:t("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:zc(c)}}
function ie(a,b){var c=zc(b.value),d=zc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function je(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var ke={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function le(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function me(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?le(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ne=void 0,oe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==ke.svg||"innerHTML"in a)a.innerHTML=b;else{ne=ne||document.createElement("div");ne.innerHTML="<svg>"+b+"</svg>";for(b=ne.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},re=["Webkit","ms","Moz","O"];Object.keys(qe).forEach(function(a){re.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qe[b]=qe[a]})});function se(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qe.hasOwnProperty(a)&&qe[a]?(""+b).trim():b+"px"}
function te(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=se(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ue=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function ve(a,b){b&&(ue[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?t("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?t("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:t("61")),null!=b.style&&"object"!==typeof b.style?t("62",""):void 0)}
function we(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function xe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Od(a);b=ta[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Kd("scroll",a);break;case "focus":case "blur":Kd("focus",a);Kd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Sb(e)&&Kd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&G(e,a)}c[e]=!0}}}function ye(){}var ze=null,Ae=null;
function Be(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ce(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var De="function"===typeof setTimeout?setTimeout:void 0,Ee="function"===typeof clearTimeout?clearTimeout:void 0;
function Fe(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ge(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var He=[],Ie=-1;function H(a){0>Ie||(a.current=He[Ie],He[Ie]=null,Ie--)}function I(a,b){Ie++;He[Ie]=a.current;a.current=b}var Je={},J={current:Je},K={current:!1},Ke=Je;
function Le(a,b){var c=a.type.contextTypes;if(!c)return Je;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Me(a){H(K,a);H(J,a)}function Ne(a){H(K,a);H(J,a)}
function Oe(a,b,c){J.current!==Je?t("168"):void 0;I(J,b,a);I(K,c,a)}function Pe(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:t("108",mc(b)||"Unknown",e);return n({},c,d)}function Qe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Je;Ke=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Re(a,b,c){var d=a.stateNode;d?void 0:t("169");c?(b=Pe(a,b,Ke),d.__reactInternalMemoizedMergedChildContext=b,H(K,a),H(J,a),I(J,b,a)):H(K,a);I(K,c,a)}var Se=null,Te=null;function Ue(a){return function(b){try{return a(b)}catch(c){}}}
function Ve(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Se=Ue(function(a){return b.onCommitFiberRoot(c,a)});Te=Ue(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function We(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function M(a,b,c,d){return new We(a,b,c,d)}
function Xe(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Ye(a){if("function"===typeof a)return Xe(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===ic)return 14}return 2}
function Ze(a,b){var c=a.alternate;null===c?(c=M(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.firstContextDependency=a.firstContextDependency;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function $e(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Xe(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ac:return af(c.children,e,f,b);case fc:return bf(c,e|3,f,b);case bc:return bf(c,e|2,f,b);case cc:return a=M(12,c,b,e|4),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=M(13,c,b,e),a.elementType=hc,a.type=hc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:g=10;break a;case ec:g=9;break a;case gc:g=11;break a;case ic:g=
14;break a;case jc:g=16;d=null;break a}t("130",null==a?a:typeof a,"")}b=M(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function af(a,b,c,d){a=M(7,a,d,b);a.expirationTime=c;return a}function bf(a,b,c,d){a=M(8,a,d,b);b=0===(b&1)?bc:fc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function cf(a,b,c){a=M(6,a,null,b);a.expirationTime=c;return a}
function df(a,b,c){b=M(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function ef(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);ff(b,a)}
function gf(a,b){a.didError=!1;var c=a.latestPingedTime;0!==c&&c>=b&&(a.latestPingedTime=0);c=a.earliestPendingTime;var d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);ff(b,a)}
function hf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function ff(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var jf=!1;
function kf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function lf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function mf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function nf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function of(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=kf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=kf(a.memoizedState),e=c.updateQueue=kf(c.memoizedState)):d=a.updateQueue=lf(e):null===e&&(e=c.updateQueue=lf(d));null===e||d===e?nf(d,b):null===d.lastUpdate||null===e.lastUpdate?(nf(d,b),nf(e,b)):(nf(d,b),e.lastUpdate=b)}
function pf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=kf(a.memoizedState):qf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function qf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=lf(b));return b}
function rf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:jf=!0}return d}
function sf(a,b,c,d,e){jf=!1;b=qf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(l=rf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var q=k.expirationTime;q<e?(null===m&&(m=k,null===g&&(f=l)),h<q&&(h=q)):(l=rf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=
32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=l}
function tf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);uf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;uf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function uf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?t("191",c):void 0;c.call(d)}a=a.nextEffect}}
function vf(a,b){return{value:a,source:b,stack:nc(b)}}var wf={current:null},xf=null,yf=null,zf=null;function Af(a,b){var c=a.type._context;I(wf,c._currentValue,a);c._currentValue=b}function Bf(a){var b=wf.current;H(wf,a);a.type._context._currentValue=b}function Cf(a){xf=a;zf=yf=null;a.firstContextDependency=null}
function Df(a,b){if(zf!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)zf=a,b=1073741823;b={context:a,observedBits:b,next:null};null===yf?(null===xf?t("293"):void 0,xf.firstContextDependency=yf=b):yf=yf.next=b}return a._currentValue}var Ef={},N={current:Ef},Ff={current:Ef},Gf={current:Ef};function Hf(a){a===Ef?t("174"):void 0;return a}
function If(a,b){I(Gf,b,a);I(Ff,a,a);I(N,Ef,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:me(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=me(b,c)}H(N,a);I(N,b,a)}function Jf(a){H(N,a);H(Ff,a);H(Gf,a)}function Kf(a){Hf(Gf.current);var b=Hf(N.current);var c=me(b,a.type);b!==c&&(I(Ff,a,a),I(N,c,a))}function Lf(a){Ff.current===a&&(H(N,a),H(Ff,a))}
function O(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}function Mf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:throw a._status=0,b=a._ctor,b=b(),b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)}),a._result=b,b;}}var Nf=Xb.ReactCurrentOwner,Of=(new aa.Component).refs;
function Pf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Uf={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Qf();d=Rf(d,a);var e=mf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf();of(a,e);Tf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Qf();d=Rf(d,a);var e=mf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf();of(a,e);Tf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Qf();c=Rf(c,a);var d=mf(c);d.tag=
2;void 0!==b&&null!==b&&(d.callback=b);Sf();of(a,d);Tf(a,c)}};function Vf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
function Wf(a,b,c){var d=!1,e=Je;var f=b.contextType;"object"===typeof f&&null!==f?f=Nf.currentDispatcher.readContext(f):(e=L(b)?Ke:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Le(a,e):Je);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Uf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Xf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Uf.enqueueReplaceState(b,b.state,null)}
function Yf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Of;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Nf.currentDispatcher.readContext(f):(f=L(b)?Ke:J.current,e.context=Le(a,f));f=a.updateQueue;null!==f&&(sf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Pf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&
"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Uf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(sf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Zf=Array.isArray;
function $f(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?t("289"):void 0,d=c.stateNode);d?void 0:t("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Of&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?t("284"):void 0;c._owner?void 0:t("290",a)}return a}
function ag(a,b){"textarea"!==a.type&&t("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function bg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=$f(a,b,c),d.return=a,d;d=$e(c.type,c.key,c.props,null,a.mode,d);d.ref=$f(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,g){if(null===b||7!==b.tag)return b=af(c,a.mode,d,g),b.return=a,b;b=e(b,c,d);b.return=a;return b}function q(a,b,c){if("string"===typeof b||"number"===typeof b)return b=cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=$e(b.type,b.key,b.props,null,a.mode,c),c.ref=$f(a,null,b),c.return=a,c;case $b:return b=df(b,a.mode,c),b.return=a,b}if(Zf(b)||
lc(b))return b=af(b,a.mode,c,null),b.return=a,b;ag(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(Zf(c)||lc(c))return null!==e?null:m(a,b,c,d,null);ag(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Zf(d)||lc(d))return a=a.get(c)||null,m(b,a,d,e,null);ag(b,d)}return null}function C(e,g,h,k){for(var l=null,r=null,m=g,u=g=0,p=null;null!==m&&u<h.length;u++){m.index>u?(p=m,m=null):p=m.sibling;var v=x(e,m,h[u],k);if(null===v){null===m&&(m=p);break}a&&
m&&null===v.alternate&&b(e,m);g=f(v,g,u);null===r?l=v:r.sibling=v;r=v;m=p}if(u===h.length)return c(e,m),l;if(null===m){for(;u<h.length;u++)if(m=q(e,h[u],k))g=f(m,g,u),null===r?l=m:r.sibling=m,r=m;return l}for(m=d(e,m);u<h.length;u++)if(p=z(m,e,u,h[u],k))a&&null!==p.alternate&&m.delete(null===p.key?u:p.key),g=f(p,g,u),null===r?l=p:r.sibling=p,r=p;a&&m.forEach(function(a){return b(e,a)});return l}function Q(e,g,h,k){var l=lc(h);"function"!==typeof l?t("150"):void 0;h=l.call(h);null==h?t("151"):void 0;
for(var m=l=null,r=g,u=g=0,p=null,v=h.next();null!==r&&!v.done;u++,v=h.next()){r.index>u?(p=r,r=null):p=r.sibling;var y=x(e,r,v.value,k);if(null===y){r||(r=p);break}a&&r&&null===y.alternate&&b(e,r);g=f(y,g,u);null===m?l=y:m.sibling=y;m=y;r=p}if(v.done)return c(e,r),l;if(null===r){for(;!v.done;u++,v=h.next())v=q(e,v.value,k),null!==v&&(g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);return l}for(r=d(e,r);!v.done;u++,v=h.next())v=z(r,e,u,v.value,k),null!==v&&(a&&null!==v.alternate&&r.delete(null===v.key?u:
v.key),g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,h);d.ref=$f(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===ac?(d=af(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=$e(f.type,f.key,f.props,null,a.mode,h),h.ref=$f(a,d,f),h.return=a,a=h)}return g(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=cf(f,a.mode,h),d.return=a,a=d),g(a);if(Zf(f))return C(a,d,f,h);if(lc(f))return Q(a,d,f,h);l&&ag(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,t("152",h.displayName||h.name||"Component")}return c(a,d)}}var cg=bg(!0),dg=bg(!1),eg=null,fg=null,gg=!1;
function hg(a,b){var c=M(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function ig(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}
function jg(a){if(gg){var b=fg;if(b){var c=b;if(!ig(a,b)){b=Fe(c);if(!b||!ig(a,b)){a.effectTag|=2;gg=!1;eg=a;return}hg(eg,c)}eg=a;fg=Ge(b)}else a.effectTag|=2,gg=!1,eg=a}}function kg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;eg=a}function lg(a){if(a!==eg)return!1;if(!gg)return kg(a),gg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ce(b,a.memoizedProps))for(b=fg;b;)hg(a,b),b=Fe(b);kg(a);fg=eg?Fe(a.stateNode):null;return!0}function mg(){fg=eg=null;gg=!1}var ng=Xb.ReactCurrentOwner;
function P(a,b,c,d){b.child=null===a?dg(b,null,c,d):cg(b,a.child,c,d)}function og(a,b,c,d,e){c=c.render;var f=b.ref;Cf(b,e);d=c(d,f);b.effectTag|=1;P(a,b,d,e);return b.child}
function pg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Xe(g)&&void 0===g.defaultProps&&null===c.compare)return b.tag=15,b.type=g,qg(a,b,g,d,e,f);a=$e(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return rg(a,b,f);a=Ze(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function qg(a,b,c,d,e,f){return null!==a&&e<f&&jd(a.memoizedProps,d)&&a.ref===b.ref?rg(a,b,f):sg(a,b,c,d,f)}function tg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function sg(a,b,c,d,e){var f=L(c)?Ke:J.current;f=Le(b,f);Cf(b,e);c=c(d,f);b.effectTag|=1;P(a,b,c,e);return b.child}
function ug(a,b,c,d,e){if(L(c)){var f=!0;Qe(b)}else f=!1;Cf(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Wf(b,c,d,e),Yf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=Nf.currentDispatcher.readContext(l):(l=L(c)?Ke:J.current,l=Le(b,l));var m=c.getDerivedStateFromProps,q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;q||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Xf(b,g,d,l);jf=!1;var x=b.memoizedState;k=g.state=x;var z=b.updateQueue;null!==z&&(sf(b,z,d,g,e),k=b.memoizedState);h!==d||x!==k||K.current||jf?("function"===typeof m&&(Pf(b,c,m,d),k=b.memoizedState),(h=jf||Vf(b,c,h,d,x,k,l))?(q||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:O(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=Nf.currentDispatcher.readContext(l):(l=L(c)?Ke:J.current,l=Le(b,l)),m=c.getDerivedStateFromProps,
(q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Xf(b,g,d,l),jf=!1,k=b.memoizedState,x=g.state=k,z=b.updateQueue,null!==z&&(sf(b,z,d,g,e),x=b.memoizedState),h!==d||k!==x||K.current||jf?("function"===typeof m&&(Pf(b,c,m,d),x=b.memoizedState),(m=jf||Vf(b,c,h,d,k,x,l))?(q||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vg(a,b,c,d,f,e)}
function vg(a,b,c,d,e,f){tg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Re(b,c,!1),rg(a,b,f);d=b.stateNode;ng.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=cg(b,a.child,null,f),b.child=cg(b,null,h,f)):P(a,b,h,f);b.memoizedState=d.state;e&&Re(b,c,!0);return b.child}function wg(a){var b=a.stateNode;b.pendingContext?Oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Oe(a,b.context,!1);If(a,b.containerInfo)}
function xg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;null===a?g?(g=e.fallback,e=af(null,d,0,null),0===(b.mode&1)&&yg(b,e,null!==b.memoizedState?b.child.child:b.child),d=af(g,d,c,null),e.sibling=d,c=e,c.return=d.return=b):c=d=dg(b,null,e.children,c):null!==a.memoizedState?(d=a.child,a=d.sibling,g?(c=e.fallback,e=Ze(d,d.pendingProps,0),e.effectTag|=2,0===(b.mode&1)&&(g=null!==b.memoizedState?
b.child.child:b.child,g!==d.child&&yg(b,e,g)),d=e.sibling=Ze(a,c,a.expirationTime),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):(g=a.child,d=cg(b,d.child,e.children,c),cg(b,g,null,c),c=d)):(a=a.child,g?(g=e.fallback,e=af(null,d,0,null),e.effectTag|=2,e.child=a,a.return=e,0===(b.mode&1)&&yg(b,e,null!==b.memoizedState?b.child.child:b.child),d=e.sibling=af(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=cg(b,a,e.children,c));b.memoizedState=f;b.child=
c;return d}function yg(a,b,c){for(c=b.child=c;null!==c;)null===b.firstEffect&&(b.firstEffect=c.firstEffect),null!==c.lastEffect&&(null!==b.lastEffect&&(b.lastEffect.nextEffect=c.firstEffect),b.lastEffect=c.lastEffect),1<c.effectTag&&(null!==b.lastEffect?b.lastEffect.nextEffect=c:b.firstEffect=c,b.lastEffect=c),c.return=b,c=c.sibling;a.firstEffect=b.firstEffect;a.lastEffect=b.lastEffect}
function rg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?t("153"):void 0;if(null!==b.child){a=b.child;c=Ze(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Ze(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function zg(a,b,c){var d=b.expirationTime;if(null!==a&&a.memoizedProps===b.pendingProps&&!K.current&&d<c){switch(b.tag){case 3:wg(b);mg();break;case 5:Kf(b);break;case 1:L(b.type)&&Qe(b);break;case 4:If(b,b.stateNode.containerInfo);break;case 10:Af(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return xg(a,b,c);b=rg(a,b,c);return null!==b?b.sibling:null}}return rg(a,b,c)}b.expirationTime=0;switch(b.tag){case 2:d=b.elementType;null!==
a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Le(b,J.current);Cf(b,c);e=d(a,e);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;if(L(d)){var f=!0;Qe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Pf(b,d,g,a);e.updater=Uf;b.stateNode=e;e._reactInternalFiber=b;Yf(b,d,a,c);b=vg(null,b,d,!0,f,c)}else b.tag=0,P(null,b,e,c),b=b.child;
return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=Mf(e);b.type=a;e=b.tag=Ye(a);f=O(a,f);g=void 0;switch(e){case 0:g=sg(null,b,a,f,c);break;case 1:g=ug(null,b,a,f,c);break;case 11:g=og(null,b,a,f,c);break;case 14:g=pg(null,b,a,O(a.type,f),d,c);break;default:t("283",a)}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),sg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),ug(a,b,d,
e,c);case 3:wg(b);d=b.updateQueue;null===d?t("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;sf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)mg(),b=rg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)fg=Ge(b.stateNode.containerInfo),eg=b,e=gg=!0;e?(b.effectTag|=2,b.child=dg(b,null,d,c)):(P(a,b,d,c),mg());b=b.child}return b;case 5:return Kf(b),null===a&&jg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ce(d,e)?g=null:null!==
f&&Ce(d,f)&&(b.effectTag|=16),tg(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=1,b=null):(P(a,b,g,c),b=b.child),b;case 6:return null===a&&jg(b),null;case 13:return xg(a,b,c);case 4:return If(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=cg(b,null,d,c):P(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),og(a,b,d,e,c);case 7:return P(a,b,b.pendingProps,c),b.child;case 8:return P(a,b,b.pendingProps.children,c),b.child;case 12:return P(a,b,b.pendingProps.children,
c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Af(b,f);if(null!==g){var h=g.value;f=h===f&&(0!==h||1/h===1/f)||h!==h&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=rg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){h=g.firstContextDependency;if(null!==h){do{if(h.context===d&&0!==(h.observedBits&f)){if(1===g.tag){var k=mf(c);k.tag=2;of(g,k)}g.expirationTime<
c&&(g.expirationTime=c);k=g.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);for(var l=g.return;null!==l;){k=l.alternate;if(l.childExpirationTime<c)l.childExpirationTime=c,null!==k&&k.childExpirationTime<c&&(k.childExpirationTime=c);else if(null!==k&&k.childExpirationTime<c)k.childExpirationTime=c;else break;l=l.return}}k=g.child;h=h.next}while(null!==h)}else k=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==k)k.return=g;else for(k=g;null!==k;){if(k===b){k=null;break}g=k.sibling;
if(null!==g){g.return=k.return;k=g;break}k=k.return}g=k}}P(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Cf(b,c),e=Df(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,P(a,b,d,c),b.child;case 14:return e=b.type,f=O(e.type,b.pendingProps),pg(a,b,e,f,d,c);case 15:return qg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Qe(b)):
a=!1,Cf(b,c),Wf(b,d,e,c),Yf(b,d,e,c),vg(null,b,d,!0,a,c);default:t("156")}}function Ag(a){a.effectTag|=4}var Bg=void 0,Cg=void 0,Gg=void 0,Hg=void 0;Bg=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Cg=function(){};
Gg=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;Hf(N.current);a=null;switch(c){case "input":f=Ac(g,f);d=Ac(g,d);a=[];break;case "option":f=ee(g,f);d=ee(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=ge(g,f);d=ge(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ye)}ve(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(g in k)k.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(sa.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(g in k)!k.hasOwnProperty(g)||l&&l.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in l)l.hasOwnProperty(g)&&k[g]!==l[g]&&(h||
(h={}),h[g]=l[g])}else h||(a||(a=[]),a.push(c,h)),h=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(sa.hasOwnProperty(c)?(null!=l&&xe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&Ag(b)}};Hg=function(a,b,c,d){c!==d&&Ag(b)};
function Ig(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=nc(c));null!==c&&mc(c.type);b=b.value;null!==a&&1===a.tag&&mc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Jg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Kg(a,c)}else b.current=null}
function Lg(a){"function"===typeof Te&&Te(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(null!==d){var e=a;try{d()}catch(f){Kg(e,f)}}c=c.next}while(c!==b)}break;case 1:Jg(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){Kg(a,f)}break;case 5:Jg(a);break;case 4:Mg(a)}}
function Ng(a){return 5===a.tag||3===a.tag||4===a.tag}
function Og(a){a:{for(var b=a.return;null!==b;){if(Ng(b)){var c=b;break a}b=b.return}t("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:t("161")}c.effectTag&16&&(pe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Ng(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=ye)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Mg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?t("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Lg(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Lg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Pg(a,b){switch(b.tag){case 0:case 11:case 14:case 15:break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ha]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cc(c,d);we(a,e);b=we(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?te(c,h):"dangerouslySetInnerHTML"===g?oe(c,h):"children"===g?pe(c,h):yc(c,g,h,b)}switch(a){case "input":Dc(c,d);break;case "textarea":ie(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?fe(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?fe(c,!!d.multiple,d.defaultValue,!0):fe(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:null===b.stateNode?t("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=Qf()));if(null!==a)a:for(b=c=a;;){if(5===
b.tag)a=b.stateNode,d?a.style.display="none":(a=b.stateNode,f=b.memoizedProps.style,f=void 0!==f&&null!==f&&f.hasOwnProperty("display")?f.display:null,a.style.display=se("display",f));else if(6===b.tag)b.stateNode.nodeValue=d?"":b.memoizedProps;else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===c)break a;for(;null===b.sibling;){if(null===b.return||b.return===c)break a;b=b.return}b.sibling.return=b.return;b=b.sibling}break;case 17:break;default:t("163")}}
function Qg(a,b,c){c=mf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Rg(d);Ig(a,b)};return c}
function Sg(a,b,c){c=mf(c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Tg?Tg=new Set([this]):Tg.add(this));var c=b.value,e=b.stack;Ig(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Ug(a){switch(a.tag){case 1:L(a.type)&&Me(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Jf(a),Ne(a),b=a.effectTag,0!==(b&64)?t("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Lf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 4:return Jf(a),null;case 10:return Bf(a),null;default:return null}}
var Vg={readContext:Df},Wg=Xb.ReactCurrentOwner,Xg=1073741822,Yg=0,Zg=!1,R=null,S=null,T=0,$g=-1,ah=!1,U=null,bh=!1,ch=null,dh=null,Tg=null;function eh(){if(null!==R)for(var a=R.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Me(b);break;case 3:Jf(b);Ne(b);break;case 5:Lf(b);break;case 4:Jf(b);break;case 10:Bf(b)}a=a.return}S=null;T=0;$g=-1;ah=!1;R=null}function Sf(){null!==dh&&(ba.unstable_cancelCallback(ch),dh())}
function fh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){R=a;a:{var e=b;b=a;var f=T;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Me(b);break;case 3:Jf(b);Ne(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)lg(b),b.effectTag&=-3;Cg(b);break;case 5:Lf(b);var h=Hf(Gf.current);f=b.type;if(null!==e&&null!=b.stateNode)Gg(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var k=Hf(N.current);if(lg(b)){g=b;e=g.stateNode;var l=g.type,m=g.memoizedProps,q=h;e[Ga]=g;e[Ha]=m;f=void 0;h=l;switch(h){case "iframe":case "object":G("load",e);break;case "video":case "audio":for(l=0;l<bb.length;l++)G(bb[l],e);break;case "source":G("error",e);break;case "img":case "image":case "link":G("error",e);G("load",e);break;case "form":G("reset",e);G("submit",e);break;case "details":G("toggle",e);break;case "input":Bc(e,m);G("invalid",e);xe(q,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};G("invalid",e);xe(q,"onChange");break;case "textarea":he(e,m),G("invalid",e),xe(q,"onChange")}ve(h,m);l=null;for(f in m)m.hasOwnProperty(f)&&(k=m[f],"children"===f?"string"===typeof k?e.textContent!==k&&(l=["children",k]):"number"===typeof k&&e.textContent!==""+k&&(l=["children",""+k]):sa.hasOwnProperty(f)&&null!=k&&xe(q,f));switch(h){case "input":Vb(e);Fc(e,m,!0);break;case "textarea":Vb(e);je(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=ye)}f=l;g.updateQueue=f;g=null!==f?!0:!1;g&&Ag(b)}else{m=b;e=f;q=g;l=9===h.nodeType?h:h.ownerDocument;k===ke.html&&(k=le(e));k===ke.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof q.is?l=l.createElement(e,{is:q.is}):(l=l.createElement(e),"select"===e&&q.multiple&&(l.multiple=!0)):l=l.createElementNS(k,e);e=l;e[Ga]=m;e[Ha]=g;Bg(e,b,!1,!1);q=e;l=f;m=g;var x=h,z=we(l,m);switch(l){case "iframe":case "object":G("load",
q);h=m;break;case "video":case "audio":for(h=0;h<bb.length;h++)G(bb[h],q);h=m;break;case "source":G("error",q);h=m;break;case "img":case "image":case "link":G("error",q);G("load",q);h=m;break;case "form":G("reset",q);G("submit",q);h=m;break;case "details":G("toggle",q);h=m;break;case "input":Bc(q,m);h=Ac(q,m);G("invalid",q);xe(x,"onChange");break;case "option":h=ee(q,m);break;case "select":q._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});G("invalid",q);xe(x,"onChange");break;case "textarea":he(q,
m);h=ge(q,m);G("invalid",q);xe(x,"onChange");break;default:h=m}ve(l,h);k=void 0;var C=l,Q=q,v=h;for(k in v)if(v.hasOwnProperty(k)){var r=v[k];"style"===k?te(Q,r):"dangerouslySetInnerHTML"===k?(r=r?r.__html:void 0,null!=r&&oe(Q,r)):"children"===k?"string"===typeof r?("textarea"!==C||""!==r)&&pe(Q,r):"number"===typeof r&&pe(Q,""+r):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(sa.hasOwnProperty(k)?null!=r&&xe(x,k):null!=r&&yc(Q,k,r,z))}switch(l){case "input":Vb(q);
Fc(q,m,!1);break;case "textarea":Vb(q);je(q,m);break;case "option":null!=m.value&&q.setAttribute("value",""+zc(m.value));break;case "select":h=q;h.multiple=!!m.multiple;q=m.value;null!=q?fe(h,!!m.multiple,q,!1):null!=m.defaultValue&&fe(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(q.onclick=ye)}(g=Be(f,g))&&Ag(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?t("166"):void 0;break;case 6:e&&null!=b.stateNode?Hg(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?t("166"):void 0),e=Hf(Gf.current),Hf(N.current),lg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Ga]=g,(g=f.nodeValue!==e)&&Ag(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Ga]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;b.firstEffect=b.lastEffect=null;R=b;break a}g=null!==g;if(g!==(null!==e&&null!==e.memoizedState)||0===(b.effectTag&1)&&g)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;
case 4:Jf(b);Cg(b);break;case 10:Bf(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Me(b);break;default:t("156")}R=null}b=a;if(1===T||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==R)return R.firstEffect=R.lastEffect=null,R;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=
a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Ug(a,T);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}function gh(a){var b=zg(a.alternate,a,T);a.memoizedProps=a.pendingProps;null===b&&(b=fh(a));Wg.current=null;return b}
function hh(a,b){Zg?t("243"):void 0;Sf();Zg=!0;Wg.currentDispatcher=Vg;var c=a.nextExpirationTimeToWorkOn;if(c!==T||a!==S||null===R)eh(),S=a,T=c,R=Ze(S.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;do{try{if(b)for(;null!==R&&!ih();)R=gh(R);else for(;null!==R;)R=gh(R)}catch(C){if(zf=yf=xf=null,null===R)d=!0,Rg(C);else{null===R?t("271"):void 0;var e=R,f=e.return;if(null===f)d=!0,Rg(C);else{a:{var g=a,h=f,k=e,l=C;f=T;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===
typeof l&&"function"===typeof l.then){var m=l;l=h;var q=-1,x=-1;do{if(13===l.tag){var z=l.alternate;if(null!==z&&(z=z.memoizedState,null!==z)){x=10*(1073741822-z.timedOutAt);break}z=l.pendingProps.maxDuration;if("number"===typeof z)if(0>=z)q=0;else if(-1===q||z<q)q=z}l=l.return}while(null!==l);l=h;do{if(z=13===l.tag)z=void 0===l.memoizedProps.fallback?!1:null===l.memoizedState;if(z){h=jh.bind(null,g,l,k,0===(l.mode&1)?1073741823:f);m.then(h,h);if(0===(l.mode&1)){l.effectTag|=64;P(k.alternate,k,null,
f);k.effectTag&=-1025;k.effectTag&=-933;1===k.tag&&null===k.alternate&&(k.tag=17);k.expirationTime=f;break a}-1===q?g=1073741823:(-1===x&&(x=10*(1073741822-hf(g,f))-5E3),g=x+q);0<=g&&$g<g&&($g=g);l.effectTag|=2048;l.expirationTime=f;break a}l=l.return}while(null!==l);l=Error((mc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+nc(k))}ah=
!0;l=vf(l,k);g=h;do{switch(g.tag){case 3:k=l;g.effectTag|=2048;g.expirationTime=f;f=Qg(g,k,f);pf(g,f);break a;case 1:if(k=l,h=g.type,m=g.stateNode,0===(g.effectTag&64)&&("function"===typeof h.getDerivedStateFromError||null!==m&&"function"===typeof m.componentDidCatch&&(null===Tg||!Tg.has(m)))){g.effectTag|=2048;g.expirationTime=f;f=Sg(g,k,f);pf(g,f);break a}}g=g.return}while(null!==g)}R=fh(e);continue}}}break}while(1);Zg=!1;zf=yf=xf=Wg.currentDispatcher=null;if(d)S=null,a.finishedWork=null;else if(null!==
R)a.finishedWork=null;else{d=a.current.alternate;null===d?t("281"):void 0;S=null;if(ah){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<c||0!==f&&f<c||0!==g&&g<c){gf(a,c);kh(a,d,c,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;c=a.nextExpirationTimeToWorkOn=c;b=a.expirationTime=1073741823;kh(a,d,c,b,-1);return}}b&&-1!==$g?(gf(a,c),b=10*(1073741822-hf(a,c)),b<$g&&($g=b),b=10*(1073741822-Qf()),b=$g-b,kh(a,d,c,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=
c,a.finishedWork=d)}}function Kg(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Tg||!Tg.has(d))){a=vf(b,a);a=Sg(c,a,1073741823);of(c,a);Tf(c,1073741823);return}break;case 3:a=vf(b,a);a=Qg(c,a,1073741823);of(c,a);Tf(c,1073741823);return}c=c.return}3===a.tag&&(c=vf(b,a),c=Qg(a,c,1073741823),of(a,c),Tf(a,1073741823))}
function Rf(a,b){0!==Yg?a=Yg:Zg?a=bh?1073741823:T:b.mode&1?(a=lh?1073741822-10*(((1073741822-a+15)/10|0)+1):1073741822-25*(((1073741822-a+500)/25|0)+1),null!==S&&a===T&&--a):a=1073741823;lh&&(0===mh||a<mh)&&(mh=a);return a}
function jh(a,b,c,d){var e=a.earliestSuspendedTime;var f=a.latestSuspendedTime;if(0!==e&&d<=e&&d>=f){f=e=d;a.didError=!1;var g=a.latestPingedTime;if(0===g||g>f)a.latestPingedTime=f;ff(f,a)}else e=Qf(),e=Rf(e,b),ef(a,e);0!==(b.mode&1)&&a===S&&T===d&&(S=null);nh(b,e);0===(b.mode&1)&&(nh(c,e),1===c.tag&&null!==c.stateNode&&(b=mf(e),b.tag=2,of(c,b)));c=a.expirationTime;0!==c&&oh(a,c)}
function nh(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return null===e?null:e}
function Tf(a,b){a=nh(a,b);null!==a&&(!Zg&&0!==T&&b>T&&eh(),ef(a,b),Zg&&!bh&&S===a||oh(a,a.expirationTime),ph>qh&&(ph=0,t("185")))}function rh(a,b,c,d,e){var f=Yg;Yg=1073741823;try{return a(b,c,d,e)}finally{Yg=f}}var sh=null,V=null,th=0,uh=void 0,W=!1,vh=null,X=0,mh=0,wh=!1,xh=null,Z=!1,yh=!1,lh=!1,zh=null,Ah=ba.unstable_now(),Bh=1073741822-(Ah/10|0),Ch=Bh,qh=50,ph=0,Dh=null;function Eh(){Bh=1073741822-((ba.unstable_now()-Ah)/10|0)}
function Fh(a,b){if(0!==th){if(b<th)return;null!==uh&&ba.unstable_cancelCallback(uh)}th=b;a=ba.unstable_now()-Ah;uh=ba.unstable_scheduleCallback(Gh,{timeout:10*(1073741822-b)-a})}function kh(a,b,c,d,e){a.expirationTime=d;0!==e||ih()?0<e&&(a.timeoutHandle=De(Hh.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Hh(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;Eh();Ch=Bh;Ih(a,c)}function Qf(){if(W)return Ch;Jh();if(0===X||1===X)Eh(),Ch=Bh;return Ch}
function oh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===V?(sh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=sh)):b>a.expirationTime&&(a.expirationTime=b);W||(Z?yh&&(vh=a,X=1073741823,Kh(a,1073741823,!1)):1073741823===b?Lh(1073741823,!1):Fh(a,b))}
function Jh(){var a=0,b=null;if(null!==V)for(var c=V,d=sh;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===V?t("244"):void 0;if(d===d.nextScheduledRoot){sh=V=d.nextScheduledRoot=null;break}else if(d===sh)sh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=sh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===V)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}vh=b;X=a}var Mh=!1;function ih(){return Mh?!0:ba.unstable_shouldYield()?Mh=!0:!1}function Gh(){try{if(!ih()&&null!==sh){Eh();var a=sh;do{var b=a.expirationTime;0!==b&&Bh<=b&&(a.nextExpirationTimeToWorkOn=Bh);a=a.nextScheduledRoot}while(a!==sh)}Lh(0,!0)}finally{Mh=!1}}
function Lh(a,b){Jh();if(b)for(Eh(),Ch=Bh;null!==vh&&0!==X&&a<=X&&!(Mh&&Bh>X);)Kh(vh,X,Bh>X),Jh(),Eh(),Ch=Bh;else for(;null!==vh&&0!==X&&a<=X;)Kh(vh,X,!1),Jh();b&&(th=0,uh=null);0!==X&&Fh(vh,X);ph=0;Dh=null;if(null!==zh)for(a=zh,zh=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){wh||(wh=!0,xh=d)}}if(wh)throw a=xh,xh=null,wh=!1,a;}function Ih(a,b){W?t("253"):void 0;vh=a;X=b;Kh(a,b,!1);Lh(1073741823,!1)}
function Kh(a,b,c){W?t("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Nh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),hh(a,c),d=a.finishedWork,null!==d&&(ih()?a.finishedWork=d:Nh(a,d,b)))}else d=a.finishedWork,null!==d?Nh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),hh(a,c),d=a.finishedWork,null!==d&&Nh(a,d,b));W=!1}
function Nh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===zh?zh=[d]:zh.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===Dh?ph++:(Dh=a,ph=0);bh=Zg=!0;a.current===b?t("177"):void 0;c=a.pendingCommitExpirationTime;0===c?t("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=e>d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=
0):(e=a.latestPendingTime,0!==e&&(e>d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?ef(a,d):d<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,ef(a,d)):d>e&&ef(a,d));ff(0,a);Wg.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ze=Hd;e=Td();if(Ud(e)){if("selectionStart"in e)var f={start:e.selectionStart,
end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var h=g.anchorOffset,k=g.focusNode;g=g.focusOffset;try{f.nodeType,k.nodeType}catch(db){f=null;break a}var l=0,m=-1,q=-1,x=0,z=0,C=e,Q=null;b:for(;;){for(var v;;){C!==f||0!==h&&3!==C.nodeType||(m=l+h);C!==k||0!==g&&3!==C.nodeType||(q=l+g);3===C.nodeType&&(l+=C.nodeValue.length);if(null===(v=C.firstChild))break;Q=C;C=v}for(;;){if(C===e)break b;Q===f&&
++x===h&&(m=l);Q===k&&++z===g&&(q=l);if(null!==(v=C.nextSibling))break;C=Q;Q=C.parentNode}C=v}f=-1===m||-1===q?null:{start:m,end:q}}else f=null}f=f||{start:0,end:0}}else f=null;Ae={focusedElem:e,selectionRange:f};Hd=!1;for(U=d;null!==U;){e=!1;f=void 0;try{for(;null!==U;){if(U.effectTag&256)a:{var r=U.alternate;h=U;switch(h.tag){case 0:case 11:case 15:break a;case 1:if(h.effectTag&256&&null!==r){var u=r.memoizedProps,y=r.memoizedState,Y=h.stateNode,Uh=Y.getSnapshotBeforeUpdate(h.elementType===h.type?
u:O(h.type,u),y);Y.__reactInternalSnapshotBeforeUpdate=Uh}break a;case 3:case 5:case 6:case 4:case 17:break a;default:t("163")}}U=U.nextEffect}}catch(db){e=!0,f=db}e&&(null===U?t("178"):void 0,Kg(U,f),null!==U&&(U=U.nextEffect))}for(U=d;null!==U;){r=!1;u=void 0;try{for(;null!==U;){var w=U.effectTag;w&16&&pe(U.stateNode,"");if(w&128){var D=U.alternate;if(null!==D){var p=D.ref;null!==p&&("function"===typeof p?p(null):p.current=null)}}switch(w&14){case 2:Og(U);U.effectTag&=-3;break;case 6:Og(U);U.effectTag&=
-3;Pg(U.alternate,U);break;case 4:Pg(U.alternate,U);break;case 8:y=U,Mg(y),y.return=null,y.child=null,y.alternate&&(y.alternate.child=null,y.alternate.return=null)}U=U.nextEffect}}catch(db){r=!0,u=db}r&&(null===U?t("178"):void 0,Kg(U,u),null!==U&&(U=U.nextEffect))}p=Ae;D=Td();w=p.focusedElem;u=p.selectionRange;if(D!==w&&w&&w.ownerDocument&&Sd(w.ownerDocument.documentElement,w)){null!==u&&Ud(w)&&(D=u.start,p=u.end,void 0===p&&(p=D),"selectionStart"in w?(w.selectionStart=D,w.selectionEnd=Math.min(p,
w.value.length)):(p=(D=w.ownerDocument||document)&&D.defaultView||window,p.getSelection&&(p=p.getSelection(),y=w.textContent.length,r=Math.min(u.start,y),u=void 0===u.end?r:Math.min(u.end,y),!p.extend&&r>u&&(y=u,u=r,r=y),y=Rd(w,r),Y=Rd(w,u),y&&Y&&(1!==p.rangeCount||p.anchorNode!==y.node||p.anchorOffset!==y.offset||p.focusNode!==Y.node||p.focusOffset!==Y.offset)&&(D=D.createRange(),D.setStart(y.node,y.offset),p.removeAllRanges(),r>u?(p.addRange(D),p.extend(Y.node,Y.offset)):(D.setEnd(Y.node,Y.offset),
p.addRange(D))))));D=[];for(p=w;p=p.parentNode;)1===p.nodeType&&D.push({element:p,left:p.scrollLeft,top:p.scrollTop});"function"===typeof w.focus&&w.focus();for(w=0;w<D.length;w++)p=D[w],p.element.scrollLeft=p.left,p.element.scrollTop=p.top}Ae=null;Hd=!!ze;ze=null;a.current=b;for(U=d;null!==U;){d=!1;w=void 0;try{for(D=c;null!==U;){var Fb=U.effectTag;if(Fb&36){var Gb=U.alternate;p=U;r=D;switch(p.tag){case 0:case 11:case 15:break;case 1:var wc=p.stateNode;if(p.effectTag&4)if(null===Gb)wc.componentDidMount();
else{var di=p.elementType===p.type?Gb.memoizedProps:O(p.type,Gb.memoizedProps);wc.componentDidUpdate(di,Gb.memoizedState,wc.__reactInternalSnapshotBeforeUpdate)}var Dg=p.updateQueue;null!==Dg&&tf(p,Dg,wc,r);break;case 3:var Eg=p.updateQueue;if(null!==Eg){u=null;if(null!==p.child)switch(p.child.tag){case 5:u=p.child.stateNode;break;case 1:u=p.child.stateNode}tf(p,Eg,u,r)}break;case 5:var ei=p.stateNode;null===Gb&&p.effectTag&4&&Be(p.type,p.memoizedProps)&&ei.focus();break;case 6:break;case 4:break;
case 12:break;case 13:break;case 17:break;default:t("163")}}if(Fb&128){var Ic=U.ref;if(null!==Ic){var Fg=U.stateNode;switch(U.tag){case 5:var de=Fg;break;default:de=Fg}"function"===typeof Ic?Ic(de):Ic.current=de}}U=U.nextEffect}}catch(db){d=!0,w=db}d&&(null===U?t("178"):void 0,Kg(U,w),null!==U&&(U=U.nextEffect))}Zg=bh=!1;"function"===typeof Se&&Se(b.stateNode);Fb=b.expirationTime;b=b.childExpirationTime;b=b>Fb?b:Fb;0===b&&(Tg=null);a.expirationTime=b;a.finishedWork=null}
function Rg(a){null===vh?t("246"):void 0;vh.expirationTime=0;wh||(wh=!0,xh=a)}function Oh(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Lh(1073741823,!1)}}function Ph(a,b){if(Z&&!yh){yh=!0;try{return a(b)}finally{yh=!1}}return a(b)}function Qh(a,b,c){if(lh)return a(b,c);Z||W||0===mh||(Lh(mh,!1),mh=0);var d=lh,e=Z;Z=lh=!0;try{return a(b,c)}finally{lh=d,(Z=e)||W||Lh(1073741823,!1)}}
function Rh(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===kd(c)&&1===c.tag?void 0:t("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(L(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);t("171");g=void 0}if(1===c.tag){var h=c.type;if(L(h)){c=Pe(c,h,g);break a}}c=g}else c=Je;null===b.context?b.context=c:b.pendingContext=c;b=e;e=mf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
Sf();of(f,e);Tf(f,d);return d}function Sh(a,b,c,d){var e=b.current,f=Qf();e=Rf(f,e);return Rh(a,b,c,e,d)}function Th(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Vh(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Cb=function(a,b,c){switch(b){case "input":Dc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=La(d);e?void 0:t("90");Wb(d);Dc(d,e)}}}break;case "textarea":ie(a,c);break;case "select":b=c.value,null!=b&&fe(a,!!c.multiple,b,!1)}};
function Wh(a){var b=1073741822-25*(((1073741822-Qf()+500)/25|0)+1);b>=Xg&&(b=Xg-1);this._expirationTime=Xg=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Wh.prototype.render=function(a){this._defer?void 0:t("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Xh;Rh(a,b,null,c,d._onCommit);return d};
Wh.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Wh.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:t("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?t("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Ih(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Wh.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Xh(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Xh.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Xh.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?t("191",c):void 0;c()}}};
function Yh(a,b,c){b=M(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Yh.prototype.render=function(a,b){var c=this._internalRoot,d=new Xh;b=void 0===b?null:b;null!==b&&d.then(b);Sh(a,c,null,d._onCommit);return d};Yh.prototype.unmount=function(a){var b=this._internalRoot,c=new Xh;a=void 0===a?null:a;null!==a&&c.then(a);Sh(null,b,null,c._onCommit);return c};Yh.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Xh;c=void 0===c?null:c;null!==c&&e.then(c);Sh(b,d,a,e._onCommit);return e};
Yh.prototype.createBatch=function(){var a=new Wh(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Zh(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Kb=Oh;Lb=Qh;Mb=function(){W||0===mh||(Lh(mh,!1),mh=0)};
function $h(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Yh(a,!1,b)}
function ai(a,b,c,d,e){Zh(c)?void 0:t("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Th(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=$h(c,d);if("function"===typeof e){var h=e;e=function(){var a=Th(f._internalRoot);h.call(a)}}Ph(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Th(f._internalRoot)}
function bi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Zh(b)?void 0:t("200");return Vh(a,b,null,c)}
var ci={createPortal:bi,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?t("188"):t("268",Object.keys(a)));a=nd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return ai(null,a,b,!0,c)},render:function(a,b,c){return ai(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?t("38"):void 0;return ai(a,b,c,!1,d)},unmountComponentAtNode:function(a){Zh(a)?
void 0:t("40");return a._reactRootContainer?(Ph(function(){ai(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return bi.apply(void 0,arguments)},unstable_batchedUpdates:Oh,unstable_interactiveUpdates:Qh,flushSync:function(a,b){W?t("187"):void 0;var c=Z;Z=!0;try{return rh(a,b)}finally{Z=c,Lh(1073741823,!1)}},unstable_flushControlled:function(a){var b=Z;Z=!0;try{rh(a)}finally{(Z=b)||W||Lh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ja,
Ka,La,Ca.injectEventPluginsByName,qa,Ra,function(a){za(a,Qa)},Ib,Jb,Jd,Ea]},unstable_createRoot:function(a,b){Zh(a)?void 0:t("299","unstable_createRoot");return new Yh(a,!0,null!=b&&!0===b.hydrate)}};(function(a){var b=a.findFiberByHostInstance;return Ve(n({},a,{findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ia,bundleType:0,version:"16.6.1",rendererPackageName:"react-dom"});
var fi={default:ci},gi=fi&&ci||fi;module.exports=gi.default||gi;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(232);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,f=!1,h=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var e=h,Q=l;h=a;l=b;try{var g=c()}finally{h=e,l=Q}if("function"===typeof g)if(g={callback:g,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=g.next=g.previous=g;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=g,p());b=c.previous;b.next=c.previous=g;g.next=c;g.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=f;f=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,f=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w;
if("undefined"!==typeof window&&window._schedMock){var G=window._schedMock;r=G[0];q=G[1];w=G[2]}else if("undefined"===typeof window||"function"!==typeof window.addEventListener){var H=null,I=-1,J=function(a,b){if(null!==H){var c=H;H=null;try{I=b,c(a)}finally{I=-1}}};r=function(a,b){-1!==I?setTimeout(r,0,a,b):(H=a,setTimeout(J,b,!0,b),setTimeout(J,1073741823,!1,1073741823))};q=function(){H=null};w=function(){return!1};exports.unstable_now=function(){return-1===I?0:I}}else{"undefined"!==typeof console&&
("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T="__reactIdleCallback$"+Math.random().toString(36).slice(2);
window.addEventListener("message",function(a){if(a.source===window&&a.data===T){L=!1;a=K;var b=M;K=null;M=-1;var c=exports.unstable_now(),e=!1;if(0>=P-c)if(-1!==b&&b<=c)e=!0;else{N||(N=!0,E(U));K=a;M=b;return}if(null!==a){O=!0;try{a(e)}finally{O=!1}}}},!1);var U=function(a){if(null!==K){E(U);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,window.postMessage(T,"*"))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?window.postMessage(T,"*"):N||(N=!0,E(U))};q=function(){K=null;L=!1;M=-1}}
exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:break;default:a=3}var c=h,e=k;h=a;k=exports.unstable_now();try{return b()}finally{h=c,k=e,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(h){case 1:b=c+-1;break;case 2:b=c+250;break;case 4:b=c+1073741823;break;default:b=c+5E3}a={callback:a,priorityLevel:h,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var e=d;do{if(e.expirationTime>b){c=e;break}e=e.next}while(e!==d);null===c?c=d:c===d&&(d=a,p());b=c.previous;b.next=c.previous=
a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=h;return function(){var c=h,e=k;h=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{h=c,k=e,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return h};
exports.unstable_shouldYield=function(){return!f&&(null!==d&&d.expirationTime<l||w())};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(76);





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(237);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(79);
var React = __webpack_require__(0);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,r=b?Symbol.for("react.memo"):
60115,t=b?Symbol.for("react.lazy"):60116;function u(a){if("object"===typeof a&&null!==a){var q=a.$$typeof;switch(q){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return q}}case d:return q}}}function v(a){return u(a)===m}exports.typeOf=u;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;
exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||u(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return u(a)===k};exports.isContextProvider=function(a){return u(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return u(a)===n};exports.isFragment=function(a){return u(a)===e};exports.isProfiler=function(a){return u(a)===g};exports.isPortal=function(a){return u(a)===d};exports.isStrictMode=function(a){return u(a)===f};


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(251);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(124);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(247);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58), __webpack_require__(246)(module)))

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(124);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(125);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(252);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(76);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_overlays__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_overlays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_overlays__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_css__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_requerimentos_Aposentadoria_RequerimentoAposentadoria__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_requerimentos_Pensao_RequerimentoPensao__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_requerimentos_Cessacao_RequerimentoCessacao__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_consultas_Consulta__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_requerimentos_Indeferido_Indeferido__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_consultas_ConsultaCronogramaPagamentos__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ComponentesAutenticacao_AuthenticationProvider__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ComponentesAutenticacao_Provider__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_cadastros_ValoresMediosBeneficios_ValorMedioBeneficio__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_consultas_ConsultaCessacaoRequerimento__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_consultas_ConsultaBloqueio__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_cadastros_EntesFederativos_BloqueioDesbloqueio_BloqueioDesbloqueioEnte__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_consultas_ConsultaPrisma__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_glosas_ConsultaGlosaDeDacao__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_glosas_CadastroGlosaDeDacao__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_cadastros_EntesFederativos_Rpps_RegimeProprio__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_consultas_ConsultaEnteFederativo__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_consultas_ConsultaPagamentos__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_consultas_ConsultaAuditoria__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_consultas_ConsultaFilaGet__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_consultas_ConsultaOperacoesGet__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_controle_pagamento_ControlePagamentos__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_relatorios_TelaRelatorioPagamentos__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_relatorios_TelaRelatorioRequerimentos__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_Inicio__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_mensagens_Mensagens__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_cadastros_OrgaosVinculadosUniao_CadastroOrgaosVinculados__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_cadastros_PeriodosRppsUniao_CadastroPeriodos__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_acrescimos_legais_Calculadora__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_controle_pagamento_DetalhePagamento__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_cadastros_cronograma_pagamentos_CronogramaPagamento__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_consulta_cpf_ConsultaCpf__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_conversor_amd_Conversor__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_cadastros_cronograma_pagamentos_InfoCronogramaVisualCompetencia__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_calculador_amd_Calculador__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_Logotipo__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_relatorios_TelaRelatorioTotalizadorEstados__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_relatorios_TelaRelatorioAnalitico__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_relatorios_TelaRelatorioTotalizadorExigencias__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_relatorios_TelaRelatorioExigenciaAnalitico__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_relatorios_TelaRelatorioConflitoPeriodos__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_relatorios_ConsultaSimulacaoCompensacao__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pages_calculadora_periodos_CalculadoraPeriodos__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__pages_consultas_ConsultaExtratoCnis__ = __webpack_require__(692);
// import RepositorioCtc from './pages/repositorio-ctc/RepositorioCtc';
// import ConsultaRepositorioCtc from './pages/repositorio-ctc/ConsultaRepositorioCtc';
var HeaderWithRouter=Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_index__["j" /* Header */],props);});var App=function App(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_overlays__["Modal"],{backdropClassName:'dtp-modal-backdrop',containerClassName:'dtp-modal-container',show:props.showLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_index__["t" /* Spinner */],{show:true,divClass:'loading'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ComponentesAutenticacao_AuthenticationProvider__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ComponentesAutenticacao_Provider__["a" /* default */].Consumer,null,function(auth){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderWithRouter,{userData:auth.userData});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["i" /* DtpContent */],null,window.comprevConfigLogotipo.exibirLogo===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__pages_Logotipo__["a" /* default */],null):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/requerimento/aposentadoria/novo',component:__WEBPACK_IMPORTED_MODULE_7__pages_requerimentos_Aposentadoria_RequerimentoAposentadoria__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/requerimento/aposentadoria/:protocolo',component:__WEBPACK_IMPORTED_MODULE_7__pages_requerimentos_Aposentadoria_RequerimentoAposentadoria__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rgps','analisar-compensacao-rpps','fornecer-parecer-medico-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','analisar-negocio-dtpv','consultar-compensacao-rpps','consultar-compensacao-rgps','auditar-comprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/requerimento/aposentadoria/:protocolo/:acao(cumprir-exigencia|realizar-analise|emitir-parecer-medico|qualificar)',component:__WEBPACK_IMPORTED_MODULE_7__pages_requerimentos_Aposentadoria_RequerimentoAposentadoria__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rgps','analisar-compensacao-rpps','fornecer-parecer-medico-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/requerimento/pensao/novo',component:__WEBPACK_IMPORTED_MODULE_8__pages_requerimentos_Pensao_RequerimentoPensao__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/requerimento/pensao/:protocolo',component:__WEBPACK_IMPORTED_MODULE_8__pages_requerimentos_Pensao_RequerimentoPensao__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rgps','analisar-compensacao-rpps','fornecer-parecer-medico-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','analisar-negocio-dtpv','consultar-compensacao-rpps','consultar-compensacao-rgps','auditar-comprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/requerimento/pensao/:protocolo/:acao(cumprir-exigencia|realizar-analise|emitir-parecer-medico)',component:__WEBPACK_IMPORTED_MODULE_8__pages_requerimentos_Pensao_RequerimentoPensao__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rgps','analisar-compensacao-rpps','fornecer-parecer-medico-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/consulta/:regime(rpps|rgps)',component:__WEBPACK_IMPORTED_MODULE_10__pages_consultas_Consulta__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rpps','consultar-compensacao-rgps','auditar-comprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/consulta/:tipoConsulta(exigencia|analise|parecer-medico|prescricao-exigencia)/:regime(rpps|rgps)',component:__WEBPACK_IMPORTED_MODULE_10__pages_consultas_Consulta__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rgps','analisar-compensacao-rpps','fornecer-parecer-medico-rpps','gerenciar-negocio-dcomp']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/exigencia/indeferidos/:regime(rpps|rgps)',component:__WEBPACK_IMPORTED_MODULE_11__pages_requerimentos_Indeferido_Indeferido__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rpps']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/requerimento/aposentadoria/:protocolo/:acao(indeferidos)',component:__WEBPACK_IMPORTED_MODULE_7__pages_requerimentos_Aposentadoria_RequerimentoAposentadoria__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rpps']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/requerimento/pensao/:protocolo/:acao(indeferidos)',component:__WEBPACK_IMPORTED_MODULE_8__pages_requerimentos_Pensao_RequerimentoPensao__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rpps']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/cadastros/valoresMediosBeneficios/novo',component:__WEBPACK_IMPORTED_MODULE_17__pages_cadastros_ValoresMediosBeneficios_ValorMedioBeneficio__["a" /* default */],permissionsAllowed:['requerer-compensacao-rpps','analisar-compensacao-rpps','requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','auditar-comprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/consultaCessacaoRequerimento/:tipoConsulta(cessacao-requerimento)',component:__WEBPACK_IMPORTED_MODULE_18__pages_consultas_ConsultaCessacaoRequerimento__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/requerimento/cessacao/:tipoRequerimento/:protocolo/:acao(cessar-requerimento)',component:__WEBPACK_IMPORTED_MODULE_9__pages_requerimentos_Cessacao_RequerimentoCessacao__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/consultaBloqueio/:tipoConsulta(bloqueio)',component:__WEBPACK_IMPORTED_MODULE_19__pages_consultas_ConsultaBloqueio__["a" /* default */],permissionsAllowed:['gerenciar-negocio-dcomp','analisar-negocio-sprev','analisar-contrato-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/cadastros/entesFederativos/bloqueio/:acao(desbloquear-ente)/:chave/:mes/:ano/:tipo/',component:__WEBPACK_IMPORTED_MODULE_20__pages_cadastros_EntesFederativos_BloqueioDesbloqueio_BloqueioDesbloqueioEnte__["a" /* default */],permissionsAllowed:['gerenciar-negocio-dcomp','analisar-negocio-sprev','analisar-contrato-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/cadastros/entesFederativos/bloqueio/:chave/:tipoEntidade/:uf/:codigo',component:__WEBPACK_IMPORTED_MODULE_20__pages_cadastros_EntesFederativos_BloqueioDesbloqueio_BloqueioDesbloqueioEnte__["a" /* default */],permissionsAllowed:['gerenciar-negocio-dcomp','analisar-negocio-sprev','analisar-contrato-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/cadastros/entesFederativos/bloqueio/:chave',component:__WEBPACK_IMPORTED_MODULE_20__pages_cadastros_EntesFederativos_BloqueioDesbloqueio_BloqueioDesbloqueioEnte__["a" /* default */],permissionsAllowed:['gerenciar-negocio-dcomp','analisar-negocio-sprev','analisar-contrato-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/consultaGlosaDeDacao/:tipoConsulta(consulta-glosa)',component:__WEBPACK_IMPORTED_MODULE_22__pages_glosas_ConsultaGlosaDeDacao__["a" /* default */],permissionsAllowed:['gerenciar-negocio-dcomp']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/cadastros/glosaDeDacao/:idglosa?',component:__WEBPACK_IMPORTED_MODULE_23__pages_glosas_CadastroGlosaDeDacao__["a" /* default */],permissionsAllowed:['gerenciar-negocio-dcomp']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/consultaPrisma/:tipoConsulta(consulta-prisma)',component:__WEBPACK_IMPORTED_MODULE_21__pages_consultas_ConsultaPrisma__["a" /* default */],permissionsAllowed:['analisar-compensacao-rgps','gerenciar-negocio-dcomp','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/consultaFilaGet/:tipoConsulta(consulta-filaget)',component:__WEBPACK_IMPORTED_MODULE_28__pages_consultas_ConsultaFilaGet__["a" /* default */],permissionsAllowed:['analisar-negocio-dtpv','analisar-compensacao-rgps','gerenciar-negocio-dcomp','analisar-negocio-sprev']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/consultaOperacoesGet/consulta-operacoes-get',component:__WEBPACK_IMPORTED_MODULE_29__pages_consultas_ConsultaOperacoesGet__["a" /* default */],permissionsAllowed:['analisar-negocio-dtpv','analisar-compensacao-rgps','gerenciar-negocio-dcomp']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/consultaOperacoesGet/:idTarefaGet',component:__WEBPACK_IMPORTED_MODULE_29__pages_consultas_ConsultaOperacoesGet__["a" /* default */],permissionsAllowed:['analisar-negocio-dtpv','analisar-compensacao-rgps','gerenciar-negocio-dcomp']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/consultaEnteFederativo/:tipoConsulta(consulta-rpps)',component:__WEBPACK_IMPORTED_MODULE_25__pages_consultas_ConsultaEnteFederativo__["a" /* default */],permissionsAllowed:['requerer-compensacao-rpps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','consultar-compensacao-rgps','auditar-comprev','analisar-negocio-dtpv','requerer-compensacao-rgps','requerer-compensacao-rpps']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/cadastros/entesFederativos/rpps/:idParticipante/:acao(atualizar-rpps)',component:__WEBPACK_IMPORTED_MODULE_24__pages_cadastros_EntesFederativos_Rpps_RegimeProprio__["a" /* default */],permissionsAllowed:['requerer-compensacao-rpps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rpps','consultar-compensacao-rgps','auditar-comprev','analisar-negocio-dtpv','requerer-compensacao-rgps','requerer-compensacao-rpps']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/consulta/consultaPagamentos',component:__WEBPACK_IMPORTED_MODULE_26__pages_consultas_ConsultaPagamentos__["a" /* default */],permissionsAllowed:['gerenciar-negocio-dcomp']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/consultaAuditoria/auditoria',component:__WEBPACK_IMPORTED_MODULE_27__pages_consultas_ConsultaAuditoria__["a" /* default */],permissionsAllowed:['analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rpps','consultar-compensacao-rgps','auditar-comprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/relatorios/pagamentos',component:__WEBPACK_IMPORTED_MODULE_31__pages_relatorios_TelaRelatorioPagamentos__["a" /* default */],permissionsAllowed:['analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','auditar-comprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/relatorios/requerimentos',component:__WEBPACK_IMPORTED_MODULE_32__pages_relatorios_TelaRelatorioRequerimentos__["a" /* default */],permissionsAllowed:['analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','auditar-comprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/',component:__WEBPACK_IMPORTED_MODULE_33__pages_Inicio__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rpps','fornecer-parecer-medico-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rpps','consultar-compensacao-rgps','auditar-comprev','analisar-negocio-dtpv','analisar-contrato-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/mensagens/novo',component:__WEBPACK_IMPORTED_MODULE_34__pages_mensagens_Mensagens__["a" /* default */],permissionsAllowed:['analisar-negocio-dtpv','analisar-negocio-sprev']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/cadastros/OrgaosVinculadosUniao',component:__WEBPACK_IMPORTED_MODULE_35__pages_cadastros_OrgaosVinculadosUniao_CadastroOrgaosVinculados__["a" /* default */],permissionsAllowed:['analisar-negocio-sprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/cadastros/PeriodosRppsUniao',component:__WEBPACK_IMPORTED_MODULE_36__pages_cadastros_PeriodosRppsUniao_CadastroPeriodos__["a" /* default */],permissionsAllowed:['analisar-negocio-sprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/controledepagamentos/home/:tipoControle(controle-pagamentos|controle-debitos-pendentes|pendencias)',component:__WEBPACK_IMPORTED_MODULE_30__pages_controle_pagamento_ControlePagamentos__["a" /* default */],permissionsAllowed:['gerenciar-negocio-dcomp','requerer-compensacao-rpps','analisar-compensacao-rpps','analisar-negocio-sprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/controledepagamentos/home/:visaoRota/:tipoControle(controle-pagamentos|controle-debitos-pendentes|pendencias)',component:__WEBPACK_IMPORTED_MODULE_30__pages_controle_pagamento_ControlePagamentos__["a" /* default */],permissionsAllowed:['gerenciar-negocio-dcomp','requerer-compensacao-rpps','analisar-compensacao-rpps','analisar-negocio-sprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/controledepagamentos/detalhe/:idControlePagamento/:tipoControle(controle-pagamentos|controle-debitos-pendentes|pendencias)',component:__WEBPACK_IMPORTED_MODULE_38__pages_controle_pagamento_DetalhePagamento__["a" /* default */],permissionsAllowed:['gerenciar-negocio-dcomp','requerer-compensacao-rpps','analisar-compensacao-rpps','analisar-negocio-sprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/relatorios/simulacaocompensacao',component:__WEBPACK_IMPORTED_MODULE_50__pages_relatorios_ConsultaSimulacaoCompensacao__["a" /* default */],permissionsAllowed:['auditar-comprev','analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/cadastros/cronogramaPagamento',component:__WEBPACK_IMPORTED_MODULE_12__pages_consultas_ConsultaCronogramaPagamentos__["a" /* default */],permissionsAllowed:['analisar-negocio-sprev']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/cadastros/cronograma-pagamento/:mes/:ano/:acao(novo)',component:__WEBPACK_IMPORTED_MODULE_39__pages_cadastros_cronograma_pagamentos_CronogramaPagamento__["a" /* default */],permissionsAllowed:['analisar-negocio-sprev']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/cadastros/cronograma-pagamento/detalhe/:mes/:ano/:acao(detalhar|alterar)',component:__WEBPACK_IMPORTED_MODULE_39__pages_cadastros_cronograma_pagamentos_CronogramaPagamento__["a" /* default */],permissionsAllowed:['analisar-negocio-sprev']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/cadastros/cronograma-pagamento/visualizar-cronogramas/:mes1/:ano1/:mes2/:ano2/:mes3/:ano3',component:__WEBPACK_IMPORTED_MODULE_42__pages_cadastros_cronograma_pagamentos_InfoCronogramaVisualCompetencia__["a" /* default */],permissionsAllowed:['analisar-negocio-sprev']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/calculadora/acrescimos-legais',component:__WEBPACK_IMPORTED_MODULE_37__pages_acrescimos_legais_Calculadora__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/consulta-cpf/consultacpf',component:__WEBPACK_IMPORTED_MODULE_40__pages_consulta_cpf_ConsultaCpf__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/conversor-amd/conversor',component:__WEBPACK_IMPORTED_MODULE_41__pages_conversor_amd_Conversor__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/calculador-amd/calculador',component:__WEBPACK_IMPORTED_MODULE_43__pages_calculador_amd_Calculador__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/calculadora-periodos/calculadoraperiodos',component:__WEBPACK_IMPORTED_MODULE_51__pages_calculadora_periodos_CalculadoraPeriodos__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/relatorios/totalizador/estados',component:__WEBPACK_IMPORTED_MODULE_45__pages_relatorios_TelaRelatorioTotalizadorEstados__["a" /* default */],permissionsAllowed:['analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','auditar-comprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/relatorios/estado/tipo',component:__WEBPACK_IMPORTED_MODULE_46__pages_relatorios_TelaRelatorioAnalitico__["a" /* default */],permissionsAllowed:['analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','auditar-comprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{exact:true,path:'/relatorios/estado/exigencias',component:__WEBPACK_IMPORTED_MODULE_47__pages_relatorios_TelaRelatorioTotalizadorExigencias__["a" /* default */],permissionsAllowed:['analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','auditar-comprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/consulta/:tipoConsulta(complementar-aposentadoria)/:regime(rpps|rgps)',component:__WEBPACK_IMPORTED_MODULE_10__pages_consultas_Consulta__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rgps','analisar-compensacao-rpps']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/requerimento/aposentadoria/:protocolo/:acao(complementar-aposentadoria)',component:__WEBPACK_IMPORTED_MODULE_7__pages_requerimentos_Aposentadoria_RequerimentoAposentadoria__["a" /* default */],permissionsAllowed:['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rgps','analisar-compensacao-rpps']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/relatorios/estado/exigencias/analitico',component:__WEBPACK_IMPORTED_MODULE_48__pages_relatorios_TelaRelatorioExigenciaAnalitico__["a" /* default */],permissionsAllowed:['analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','auditar-comprev','analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/consultaExtratoCnis/consulta-extrato',component:__WEBPACK_IMPORTED_MODULE_52__pages_consultas_ConsultaExtratoCnis__["a" /* default */],permissionsAllowed:['analisar-negocio-dtpv']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ComponentesAutenticacao_PrivateRoute__["a" /* default */],{path:'/relatorios/conflito-periodos',component:__WEBPACK_IMPORTED_MODULE_49__pages_relatorios_TelaRelatorioConflitoPeriodos__["a" /* default */],permissionsAllowed:['analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','auditar-comprev','analisar-negocio-dtpv']})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_index__["h" /* Footer */],{mensagem:props.configuracoesFrontend?props.configuracoesFrontend.msgrodape:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["D" /* DtpSnackbar */],null)));};App.defaultProps={configuracoesFrontend:null};App.propTypes={configuracoesFrontend:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),showLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};var mapStateToProps=function mapStateToProps(state){return{showLoading:state.base.showLoading,configuracoesFrontend:state.base.configuracoesFrontend};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(App));

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(81);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(127);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(127);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(80);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(81);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(263);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(82);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(267);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(269);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(132);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(271);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(82);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(273);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(83);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(132);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(83);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(277);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpInputText = function (_Component) {
    _inherits(DtpInputText, _Component);

    function DtpInputText() {
        _classCallCheck(this, DtpInputText);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpInputText.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            name = _props.name,
            className = _props.className,
            value = _props.value;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                className: 'dtp-form-control ' + (className ? className : ''),
                type: 'text',
                name: name,
                id: id,
                defaultValue: value })
        );
    };

    return DtpInputText;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpInputText.propTypes =  false ? {
    /** Aceita uma string contendo classes CSS que serão incluídas no atributo HTML `class` do componente. */
    className: PropTypes.string,

    /** Atributo obrigatório utilizado para questões de acessibilidade */
    name: PropTypes.string.isRequired,

    /** Identificador do componente */
    id: PropTypes.string.isRequired,

    /** Atributo que será passado para o defaultValue do componente */
    value: PropTypes.any,

    /** Valor que será passado ao placeholder do componente */
    placeHolder: PropTypes.string,

    /** Atributo que define se o campo é obrigatório */
    required: PropTypes.bool
} : {};

DtpInputText.defaultProps = {
    required: false
};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpInputText);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NONE */
/* unused harmony export LEFT */
/* unused harmony export RIGHT */
/* unused harmony export TOP */
/* unused harmony export BOTTON */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var NONE = 'none';
var LEFT = 'left';
var RIGHT = 'right';
var TOP = 'top';
var BOTTON = 'botton';

var DIRECTION = [NONE, LEFT, RIGHT, TOP, BOTTON];

var DtpCheckbox = function (_Component) {
    _inherits(DtpCheckbox, _Component);

    function DtpCheckbox(props) {
        _classCallCheck(this, DtpCheckbox);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            checked: props.selectedValue
        };

        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    DtpCheckbox.prototype.handleChange = function handleChange(e) {
        this.setState(function (prevState) {
            return { checked: !prevState.checked };
        });
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    };

    DtpCheckbox.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            direction = _props.direction,
            className = _props.className,
            label = _props.label;

        var labelId = 'labelForCheckbox_' + id;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-controls-container ' + direction },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { id: labelId, className: 'hide' },
                label
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                'aria-labelledby': labelId,
                checked: this.state.checked,
                className: 'dtp-checkbox ' + className,
                type: 'checkbox',
                id: id,
                onChange: this.handleChange }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                label
            )
        );
    };

    return DtpCheckbox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

;

DtpCheckbox.propTypes =  false ? {
    /** DOM ID */
    id: PropTypes.string.isRequired,

    /** Classe de estilização CSS */
    className: PropTypes.string,

    /** Valor armazenado pelo componente */
    selectedValue: PropTypes.bool.isRequired,

    /** Função que será executada ao alterar o value */
    onChange: PropTypes.func,

    /** Direção do label */
    direction: PropTypes.oneOf(DIRECTION)
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpCheckbox);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NONE */
/* unused harmony export LEFT */
/* unused harmony export RIGHT */
/* unused harmony export TOP */
/* unused harmony export BOTTON */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var NONE = 'none';
var LEFT = 'left';
var RIGHT = 'right';
var TOP = 'top';
var BOTTON = 'botton';

var DIRECTION = [NONE, LEFT, RIGHT, TOP, BOTTON];

var DtpSwitch = function (_Component) {
    _inherits(DtpSwitch, _Component);

    function DtpSwitch() {
        var _temp, _this, _ret;

        _classCallCheck(this, DtpSwitch);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            checked: _this.props.checked
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    DtpSwitch.prototype.handleChange = function handleChange(e) {
        this.setState(function (prevState) {
            return { checked: !prevState.checked };
        });
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    };

    DtpSwitch.prototype.render = function render() {
        var _props = this.props,
            direction = _props.direction,
            className = _props.className,
            id = _props.id,
            label = _props.label;

        var labelId = 'labelForDtpSwitch_' + id;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-controls-container ' + direction },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { id: labelId, className: 'hide' },
                label
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                'aria-labelledby': labelId,
                className: 'dtp-switch ' + (className ? className : ''),
                type: 'checkbox',
                id: id,
                checked: this.state.checked,
                onChange: this.handleChange.bind(this) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                label
            )
        );
    };

    return DtpSwitch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpSwitch.propTypes =  false ? {
    /** Texto que descreve o valor que o switch representa */
    label: PropTypes.string.isRequired,

    /** Classe de estilização CSS */
    className: PropTypes.string,

    /** DOM id */
    id: PropTypes.string.isRequired,

    /** Define o estado do componente.  */
    checked: PropTypes.bool.isRequired,

    /** Função que será executada quando o valor checked sofrer alteração */
    onChange: PropTypes.func,

    /** Direção do label */
    direction: PropTypes.oneOf(DIRECTION)
} : {};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpSwitch);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DtpForm_DtpFormControl__ = __webpack_require__(62);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DtpSelect = function (_Component) {
  _inherits(DtpSelect, _Component);

  function DtpSelect(props) {
    _classCallCheck(this, DtpSelect);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      open: false,
      cursor: -1
    };

    _this.renderHideOption = function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'option',
        { className: 'hide', key: index, value: item.value, label: item.label },
        item.label
      );
    };

    _this.renderHideOptions = function (items) {
      return items.map(function (item, index) {
        return _this.renderHideOption(item, index);
      });
    };

    _this.renderOption = function (item, index, value) {
      var cursor = _this.state.cursor;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-select-option', { 'selecting': cursor === index }, { 'selected': value === item.value }),
          onClick: function onClick() {
            return _this.handleSelectOption(item);
          },
          key: index,
          value: item.value,
          ref: function ref(itemRef) {
            _this.elements[index] = itemRef;
          } },
        item.label
      );
    };

    _this.renderOptions = function (items, value) {
      return items.map(function (item, index) {
        return _this.renderOption(item, index, value);
      });
    };

    _this.elements = [];
    return _this;
  }

  DtpSelect.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('mousedown', this.handleClickOutside.bind(this), true);
    var formGroup = this.context.$dtp_formGroup;
    if (formGroup) {
      formGroup.setUseFeedback(false);
    }
  };

  DtpSelect.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('mousedown', this.handleClickOutside.bind(this), true);
  };

  DtpSelect.prototype.handleClickOutside = function handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      var value = this.props.value;

      if (this.state.open === true) {
        this.handleOpenClose();
      }
      this.handleFormGroupFocused(value);
    }
  };

  DtpSelect.prototype.handleFormGroupFocused = function handleFormGroupFocused(value) {
    var formGroup = this.context.$dtp_formGroup;
    if (formGroup) {
      var focused = !(value === '' || value === undefined || value === null);
      formGroup.setFocused(focused);
    }
  };

  DtpSelect.prototype.handleSelectOption = function handleSelectOption(option) {
    this.props.onSelect(option.value);
    this.formControlRef.setValue(option.value);
  };

  DtpSelect.prototype.handleMouseDown = function handleMouseDown(e) {
    e.preventDefault();
  };

  DtpSelect.prototype.handleClick = function handleClick() {
    this.formControlRef.handleFocus();
  };

  DtpSelect.prototype.handleOpenClose = function handleOpenClose() {
    var _props = this.props,
        items = _props.items,
        value = _props.value;

    var cursor = 0;

    items.forEach(function (item, index) {
      if (item.value === value) {
        cursor = index;
      }
    });

    if (!this.props.disabled) {
      this.setState(function (prevState) {
        return {
          open: !prevState.open,
          cursor: cursor
        };
      });
    }
  };

  DtpSelect.prototype.handleFocus = function handleFocus() {
    this.handleOpenClose();
  };

  DtpSelect.prototype.handleBlur = function handleBlur(e) {
    if (this.state.open === true) {
      this.handleOpenClose();
    }
    e.preventDefault();
  };

  DtpSelect.prototype.handleKeyDown = function handleKeyDown(e) {
    var cursor = this.state.cursor;
    var items = this.props.items;

    if (e.keyCode === 38 && cursor > 0) {
      this.setState(function (prevState) {
        return {
          cursor: prevState.cursor - 1
        };
      });
    } else if (e.keyCode === 40 && cursor < items.length - 1) {
      this.setState(function (prevState) {
        return {
          cursor: prevState.cursor + 1
        };
      });
    } else if (e.keyCode === 13) {
      this.handleSelectOption(items[cursor]);
      this.handleClick();
      e.preventDefault();
    } else if (e.keyCode === 27) {
      this.handleOpenClose();
    }

    var nodeItem = Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this.elements[cursor]);
    if (nodeItem) {
      nodeItem.parentNode.scrollTop = nodeItem.offsetTop - nodeItem.parentNode.offsetTop;
    }
  };

  DtpSelect.prototype.render = function render() {
    var _this2 = this;

    var open = this.state.open;

    var _props2 = this.props,
        items = _props2.items,
        placeholder = _props2.placeholder,
        value = _props2.value,
        props = _objectWithoutProperties(_props2, ['items', 'placeholder', 'value']);

    var focused = false;
    var formGroup = this.context.$dtp_formGroup;

    if (formGroup) {
      focused = formGroup.focused;
    }

    var placeholderLabel = focused ? placeholder ? placeholder : 'Selecione' : '';

    var emptyOption = {
      label: placeholderLabel,
      value: ''
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        ref: function ref(_ref2) {
          _this2.wrapperRef = _ref2;
        },
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-select-wrapper', { 'open': open === true }),
        onClick: this.handleClick.bind(this),
        onKeyDown: this.handleKeyDown.bind(this) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__DtpForm_DtpFormControl__["a" /* default */],
        _extends({
          onFocus: this.handleFocus.bind(this),
          onMouseDown: this.handleMouseDown.bind(this),
          onBlur: this.handleBlur.bind(this),
          componentClass: 'select',
          className: 'dtp-select',
          ref: function ref(_ref) {
            _this2.formControlRef = _ref;
          },
          value: value
        }, props),
        this.renderHideOption(emptyOption, 'keyEmptyOptionHide'),
        this.renderHideOptions(items)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-select-list', { 'hide': !open }),
          ref: function ref(listItemsRef) {
            _this2.listItemsRef = listItemsRef;
          } },
        this.renderOptions(items, value)
      )
    );
  };

  return DtpSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpSelect.propTypes =  false ? {
  /** Array com os itens a serem pesquisados enquanto se é digitado um valor no input */
  items: PropTypes.arrayOf(PropTypes.shape({
    /** Label do item que será renderizado na caixa de resultados da pesquisa */
    label: PropTypes.string.isRequired,

    /** Valor do item */
    value: PropTypes.any.isRequired
  })).isRequired,

  /** Função invocada toda vez que um item é selecionada na caixa de resultados da pesquisa */
  onSelect: PropTypes.func,

  /** Define qual o item selecionado */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
} : {};

DtpSelect.contextTypes = {
  $dtp_formGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (DtpSelect);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DtpOption = function (_Component) {
    _inherits(DtpOption, _Component);

    function DtpOption() {
        _classCallCheck(this, DtpOption);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpOption.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            { value: this.props.value },
            this.props.label
        );
    };

    return DtpOption;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (DtpOption);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpRadio = function (_Component) {
    _inherits(DtpRadio, _Component);

    function DtpRadio() {
        _classCallCheck(this, DtpRadio);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpRadio.prototype.render = function render() {
        var _context$radioGroup = this.context.radioGroup,
            name = _context$radioGroup.name,
            selectedValue = _context$radioGroup.selectedValue,
            onChange = _context$radioGroup.onChange;

        var optional = {};
        var _props = this.props,
            value = _props.value,
            direction = _props.direction,
            className = _props.className,
            label = _props.label,
            id = _props.id;

        var labelId = 'labelForDtpRadio_' + id;

        if (selectedValue !== undefined) {
            optional.checked = value === selectedValue;
        }

        if (typeof onChange === 'function') {
            optional.onChange = onChange.bind(null, value);
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-controls-container ' + direction },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { id: labelId, className: 'hide' },
                label
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, this.props, {
                'aria-labelledby': labelId,
                type: 'radio',
                name: name,
                className: 'dtp-radio ' + (className ? className : '')
            }, optional)),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                label
            )
        );
    };

    return DtpRadio;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpRadio.contextTypes = {
    radioGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (DtpRadio);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpRadioGroup = function (_Component) {
    _inherits(DtpRadioGroup, _Component);

    function DtpRadioGroup() {
        _classCallCheck(this, DtpRadioGroup);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpRadioGroup.prototype.getChildContext = function getChildContext() {
        var _props = this.props,
            name = _props.name,
            selectedValue = _props.selectedValue,
            onChange = _props.onChange;

        return {
            radioGroup: {
                name: name,
                selectedValue: selectedValue,
                onChange: onChange
            }
        };
    };

    DtpRadioGroup.prototype.render = function render() {
        var _props2 = this.props,
            Component = _props2.Component,
            name = _props2.name,
            selectedValue = _props2.selectedValue,
            onChange = _props2.onChange,
            children = _props2.children,
            rest = _objectWithoutProperties(_props2, ['Component', 'name', 'selectedValue', 'onChange', 'children']);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Component,
            _extends({ className: 'dtp-radiogroup' }, rest),
            children
        );
    };

    return DtpRadioGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpRadioGroup.defaultProps = {
    Component: 'div'
};

DtpRadioGroup.propTypes =  false ? {
    name: PropTypes.string,
    selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    onChange: PropTypes.func,
    children: PropTypes.node.isRequired,
    Component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
} : {};

DtpRadioGroup.childContextTypes = {
    radioGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (DtpRadioGroup);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DtpSelectOneButton = function (_Component) {
  _inherits(DtpSelectOneButton, _Component);

  function DtpSelectOneButton() {
    _classCallCheck(this, DtpSelectOneButton);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  DtpSelectOneButton.prototype.handleClick = function handleClick() {};

  DtpSelectOneButton.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        name = _props.name,
        selectedValue = _props.selectedValue,
        onClick = _props.onClick;

    return {
      selectButton: {
        name: name,
        selectedValue: selectedValue,
        onClick: onClick
      }
    };
  };

  DtpSelectOneButton.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.Component,
        children = _props2.children,
        className = _props2.className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Component,
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-button-group', className ? className : ''),
        onClick: this.handleClick.bind(this) },
      children
    );
  };

  return DtpSelectOneButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpSelectOneButton.defaultProps = {
  Component: 'div'
};

DtpSelectOneButton.propTypes =  false ? {
  name: PropTypes.string,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired,
  Component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
} : {};

DtpSelectOneButton.childContextTypes = {
  selectButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpSelectOneButton);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpOneButton = function (_Component) {
    _inherits(DtpOneButton, _Component);

    function DtpOneButton() {
        _classCallCheck(this, DtpOneButton);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpOneButton.prototype.render = function render() {
        var _context$selectButton = this.context.selectButton,
            selectedValue = _context$selectButton.selectedValue,
            onClick = _context$selectButton.onClick;
        var _props = this.props,
            value = _props.value,
            className = _props.className,
            label = _props.label;

        var optional = {};

        if (typeof onClick === 'function') {
            optional.onClick = onClick.bind(null, value);
        }

        if (selectedValue === value) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                _extends({
                    className: 'dtp-btn selected ' + className,
                    type: 'button'
                }, optional),
                label
            );
        } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                _extends({
                    className: 'dtp-btn ' + className,
                    type: 'button'
                }, optional),
                label
            );
        }
    };

    return DtpOneButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpOneButton.contextTypes = {
    selectButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpOneButton);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpManyButton = function (_Component) {
    _inherits(DtpManyButton, _Component);

    function DtpManyButton() {
        _classCallCheck(this, DtpManyButton);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpManyButton.prototype.find = function find(lista, elemento) {
        for (var i = 0; i < lista.length; i++) {
            if (lista[i] === elemento) {
                return true;
            }
        }
        return false;
    };

    DtpManyButton.prototype.render = function render() {
        var _context$selectManyBu = this.context.selectManyButton,
            selectedValue = _context$selectManyBu.selectedValue,
            onClick = _context$selectManyBu.onClick;
        var _props = this.props,
            label = _props.label,
            className = _props.className,
            value = _props.value;

        var optional = {};

        if (typeof onClick === 'function') {
            optional.onClick = onClick.bind(null, value);
        }

        if (this.find(selectedValue, value)) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                _extends({
                    className: 'dtp-btn selected ' + className,
                    type: 'button'
                }, optional),
                label
            );
        } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                _extends({
                    className: 'dtp-btn ' + this.props.className,
                    type: 'button'
                }, optional),
                this.props.label
            );
        }
    };

    return DtpManyButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpManyButton.contextTypes = {
    selectManyButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpManyButton);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpSelectManyButton = function (_Component) {
  _inherits(DtpSelectManyButton, _Component);

  function DtpSelectManyButton() {
    _classCallCheck(this, DtpSelectManyButton);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  DtpSelectManyButton.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        name = _props.name,
        selectedValue = _props.selectedValue,
        onClick = _props.onClick;

    return {
      selectManyButton: {
        name: name,
        selectedValue: selectedValue,
        onClick: onClick
      }
    };
  };

  DtpSelectManyButton.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.Component,
        children = _props2.children,
        className = _props2.className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Component,
      {
        className: 'dtp-button-group ' + className,
        onClick: this.handleClick },
      children
    );
  };

  return DtpSelectManyButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpSelectManyButton.defaultProps = {
  Component: 'div'
};

DtpSelectManyButton.propTypes =  false ? {
  name: PropTypes.string,
  selectedValue: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array])),
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired,
  Component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
} : {};

DtpSelectManyButton.childContextTypes = {
  selectManyButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (DtpSelectManyButton);

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactTextMask=t(require("react")):e.reactTextMask=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0,m.isNil)(n)&&!(0,m.isNil)(e.pipe)||!(0,m.isNil)(n)&&(0,m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask()}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e)}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0,i.processCaretTraps)(t).maskWithoutCaretTraps}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0,i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g)}for(var M=e.split(s).map(function(e,t){return{char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1)}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--}else V+=F;continue e}N=!0}b===!1&&(V+=v.substr(A,C));break}V+=B}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s}return{conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s=""},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else{var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0,d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0,d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0,d.convertMaskToPlaceholder)(x,g)}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0,p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0,d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0,f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D))}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y))}function a(e){if((0,d.isString)(e))return e;if((0,d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DtpAccordionGroup = function (_Component) {
    _inherits(DtpAccordionGroup, _Component);

    function DtpAccordionGroup() {
        _classCallCheck(this, DtpAccordionGroup);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpAccordionGroup.prototype.render = function render() {
        var children = this.props.children;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "dtp-accordion" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { role: "tablist", className: "panel-group" },
                children
            )
        );
    };

    return DtpAccordionGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DtpAccordionGroup);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpAccordionPanel = function (_Component) {
    _inherits(DtpAccordionPanel, _Component);

    function DtpAccordionPanel() {
        _classCallCheck(this, DtpAccordionPanel);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpAccordionPanel.prototype.render = function render() {
        var children = this.props.children;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'panel fancy' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    role: 'tab',
                    id: this.props.headingId,
                    'aria-selected': 'false',
                    className: 'panel-heading' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    {
                        role: 'button',
                        'data-toggle': 'collapse',
                        href: '#' + this.props.panelId,
                        'aria-expanded': 'false',
                        'aria-controls': this.props.panelId,
                        tabIndex: '0',
                        className: 'accordion-toggle panel-title collapsed' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'acc-container-icon' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: this.props.icon })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'acc-container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            this.props.title
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'acc-container-action' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ico-triangle-down' })
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    id: this.props.panelId,
                    'aria-labelledby': this.props.headingId,
                    role: 'tabpanel',
                    className: 'panel-collapse collapse' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'panel-body' },
                    children
                )
            )
        );
    };

    return DtpAccordionPanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpAccordionPanel.propTypes =  false ? {
    /** Identificador do header */
    headingId: PropTypes.string.isRequired,

    /** Identificador do painel */
    panelId: PropTypes.string.isRequired,

    /** Atributo opcional para inserir ícone através de uma classe da libicons. Ex: ico-doc, ico-user, ico-plus etc. */
    icon: PropTypes.string,

    /** String contendo o texto a ser exibido no título */
    title: PropTypes.string
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpAccordionPanel);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DtpButton_DtpButtonFlat__ = __webpack_require__(63);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpCard = function (_Component) {
    _inherits(DtpCard, _Component);

    function DtpCard(props) {
        _classCallCheck(this, DtpCard);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            showInfo: false
        };
        _this.handleShowInfo = _this.handleShowInfo.bind(_this);
        return _this;
    }

    DtpCard.prototype.handleShowInfo = function handleShowInfo() {
        if (this.state.showInfo) {
            this.setState({ showInfo: false });
        } else {
            this.setState({ showInfo: true });
        }
    };

    DtpCard.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-lg-3 col-md-4 col-sm-6 col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-card' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dtp-card-body' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: this.state.showInfo ? 'hidden dtp-card-content' : 'dtp-card-content' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'dtp-card-icon' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: this.props.icon })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'dtp-card-text' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'strong',
                                    null,
                                    this.props.text
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: this.state.showInfo ? 'dtp-card-info' : 'hidden dtp-card-info' },
                        this.props.children
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: this.state.showInfo ? 'hidden dtp-card-buttons-top' : 'dtp-card-buttons-top' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'a',
                            { href: '#' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ico-lock' })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'dtp-card-buttons-bottom' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'a',
                            { className: this.state.showInfo ? 'hidden' : '',
                                onClick: this.handleShowInfo },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ico-info-c' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'a',
                            { className: this.state.showInfo ? '' : 'hidden',
                                onClick: this.handleShowInfo },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ico-eye-no' })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dtp-card-footer' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'dtp-card-footer-group-btn' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DtpButton_DtpButtonFlat__["a" /* default */], { title: 'A\xE7\xE3o1' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DtpButton_DtpButtonFlat__["a" /* default */], { title: 'A\xE7\xE3o2' })
                    )
                )
            )
        );
    };

    return DtpCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (DtpCard);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DtpCardGroup = function (_Component) {
    _inherits(DtpCardGroup, _Component);

    function DtpCardGroup() {
        _classCallCheck(this, DtpCardGroup);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpCardGroup.prototype.render = function render() {
        var children = this.props.children;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "dtp-card-container" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "row" },
                children
            )
        );
    };

    return DtpCardGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (DtpCardGroup);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpTab = function (_Component) {
    _inherits(DtpTab, _Component);

    function DtpTab() {
        _classCallCheck(this, DtpTab);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpTab.prototype.render = function render() {
        var children = this.props.children;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                role: 'tabpanel',
                className: 'tab-pane ' + this.props.className,
                id: this.props.id },
            children
        );
    };

    return DtpTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

;

DtpTab.propTypes =  false ? {
    /** String contendo o texto a ser exibido no título */
    title: PropTypes.string,

    /** Identificador da tab */
    id: PropTypes.string.isRequired,

    /** Atributo opcional para inserir ícone através de uma classe da libicons. Ex: ico-doc, ico-user, ico-plus etc. */
    icon: PropTypes.string
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpTab);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var DtpTabGroup = function DtpTabGroup(props) {
    var children = props.children,
        className = props.className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "dtp-panel dtp-tabs " + className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "dtp-panel-heading" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "ul",
                { className: "dtp-tabs-nav", role: "tablist" },
                children.map(function (object, i) {
                    var titleText = object.props.icon && !object.props.title ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        null,
                        "\xA0",
                        object.props.title
                    );
                    var titleContent = object.props.icon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: object.props.icon }),
                        titleText
                    ) : object.props.title;

                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "li",
                        { role: "presentation", key: i, className: "dtp-nav-item " + object.props.className },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "a",
                            {
                                href: "#" + object.props.id,
                                "aria-controls": object.props.id,
                                onClick: object.props.onClick,
                                role: "tab",
                                "data-toggle": "tab" },
                            titleContent
                        )
                    );
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "dtp-panel-body" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "tab-content" },
                children
            )
        )
    );
};

/* harmony default export */ __webpack_exports__["a"] = (DtpTabGroup);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DtpButton__ = __webpack_require__(49);



var DtpButtonIcon = function DtpButtonIcon(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DtpButton__["a" /* default */], props);
};

/* harmony default export */ __webpack_exports__["a"] = (DtpButtonIcon);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NONE */
/* unused harmony export LEFT */
/* unused harmony export RIGHT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var NONE = 'none';
var LEFT = 'left';
var RIGHT = 'right';

var DIRECTION = [NONE, LEFT, RIGHT];

var DtpInputGroup = function (_Component) {
    _inherits(DtpInputGroup, _Component);

    function DtpInputGroup() {
        _classCallCheck(this, DtpInputGroup);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpInputGroup.prototype.render = function render() {
        var _props = this.props,
            Component = _props.Component,
            direction = _props.direction,
            children = _props.children;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Component,
            {
                className: 'dtp-input-group ' + direction },
            children
        );
    };

    return DtpInputGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpInputGroup.propTypes =  false ? {
    /** Aceita uma string contendo classes CSS que serão incluídas no atributo HTML `class` do componente. */
    className: PropTypes.string,

    /** Identificador do componente */
    id: PropTypes.string,

    /** Direção do label */
    direction: PropTypes.oneOf(DIRECTION)
} : {};

DtpInputGroup.defaultProps = {
    Component: 'div',
    direction: NONE
};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpInputGroup);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DtpButton__ = __webpack_require__(49);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var DtpButtonFabMini = function DtpButtonFabMini(props) {
    var className = props.className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DtpButton__["a" /* default */], _extends({}, props, {
        className: 'dtp-btn-mini-fab ' + className
    }));
};

/* harmony default export */ __webpack_exports__["a"] = (DtpButtonFabMini);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpMenu = function (_Component) {
    _inherits(DtpMenu, _Component);

    function DtpMenu() {
        _classCallCheck(this, DtpMenu);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpMenu.prototype.render = function render() {
        var inheritPosition = this.props.inheritPosition;


        var menuStyles = {};

        if (inheritPosition) {
            menuStyles = {
                position: 'inherit',
                top: 'inherit'
            };
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'nav',
            { className: 'dtp-navbar-menu', style: menuStyles },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'navbar-toggle' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
                    type: 'button',
                    className: ' collapsed',
                    'data-toggle': 'collapse',
                    'data-target': '#dtp-menu',
                    'aria-expanded': 'false' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'dtp-menu', className: 'navbar-collapse collapse' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'nav navbar-nav main-menu', role: 'menubar' },
                    this.props.children
                )
            )
        );
    };

    return DtpMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpMenu.propTypes =  false ? {
    /** Itens do menu. Várias instâncias de <DtpMenuItem /> */
    children: PropTypes.any,

    /** Define se a posição do menu será herdada do componente o que declarar */
    inheritPosition: PropTypes.bool
} : {};

DtpMenu.defaultProps = {
    inheritPosition: false
};

/* harmony default export */ __webpack_exports__["a"] = (DtpMenu);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(60);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DtpMenuItem = function (_Component) {
    _inherits(DtpMenuItem, _Component);

    function DtpMenuItem() {
        var _temp, _this, _ret;

        _classCallCheck(this, DtpMenuItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _this.isURL = function (url) {
            var strRegex = "^(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:/?#[\\]@!\\$&'\\(\\)\\*\\+,;=.]+$";
            var re = new RegExp(strRegex);
            var result = re.test(url);
            return result;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    DtpMenuItem.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    };

    DtpMenuItem.prototype.resize = function resize() {
        this.setState({ isMobile: window.innerWidth <= 425 });
    };

    DtpMenuItem.prototype.render = function render() {
        var isMobile = this.state.isMobile;
        var _props = this.props,
            active = _props.active,
            path = _props.path,
            target = _props.target,
            onClick = _props.onClick,
            label = _props.label;


        var idDtpMenuDropdown;
        var dtpMenuDropdown = this.context.$dtpMenuDropdown;
        var dataToggle = 'none';

        if (dtpMenuDropdown) {
            idDtpMenuDropdown = dtpMenuDropdown.id;
            dataToggle = 'collapse';
        }

        var props = {
            'data-toggle': dataToggle,
            'data-target': isMobile ? '#dtp-menu' : idDtpMenuDropdown,
            target: target,
            onClick: onClick
        };

        var link = void 0;
        if (this.isURL(path)) {
            link = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                _extends({
                    href: path
                }, props),
                label
            );
        } else {
            link = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],
                _extends({
                    to: path
                }, props),
                label
            );
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
                role: 'menuitem',
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
                    'active': active && active === true
                }) },
            link
        );
    };

    return DtpMenuItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpMenuItem.propTypes =  false ? {
    /** Label do item de menu */
    label: PropTypes.string.isRequired,

    /** Define se esse é o item do menu que está ativo no momento e adiciona a class CSS 'active' caso positivo. */
    active: PropTypes.bool.isRequired,

    /** URL contendo a rota para onde deve o sistema deve ser direcionado. */
    path: PropTypes.string,

    /** Caso seja informada, é a função que será executada ao clicar no neste item do menu. */
    onClick: PropTypes.func
} : {};

DtpMenuItem.contextTypes = {
    $dtpMenuDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (DtpMenuItem);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DtpMenuDropdown = function (_Component) {
    _inherits(DtpMenuDropdown, _Component);

    function DtpMenuDropdown() {
        _classCallCheck(this, DtpMenuDropdown);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpMenuDropdown.prototype.getChildContext = function getChildContext() {
        var id = 'DtpMenuDropdown' + Math.random();

        return {
            $dtpMenuDropdown: {
                id: id
            }
        };
    };

    DtpMenuDropdown.prototype.render = function render() {
        var _props = this.props,
            active = _props.active,
            onClick = _props.onClick,
            label = _props.label,
            children = _props.children;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            {
                role: 'menuitem',
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dropdown-toggle', {
                    'active': active && active === true
                }) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                    'data-toggle': 'dropdown',
                    'aria-haspopup': 'true',
                    'aria-expanded': 'false',
                    role: 'button',
                    onClick: onClick },
                label
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'dropdown-menu' },
                children
            )
        );
    };

    return DtpMenuDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpMenuDropdown.propTypes =  false ? {
    label: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired
} : {};

DtpMenuDropdown.childContextTypes = {
    $dtpMenuDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DtpMenuDropdown);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DtpTitle_DtpTitle__ = __webpack_require__(138);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DtpPageHeader = function (_Component) {
    _inherits(DtpPageHeader, _Component);

    function DtpPageHeader() {
        _classCallCheck(this, DtpPageHeader);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpPageHeader.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DtpTitle_DtpTitle__["c" /* default */], { type: __WEBPACK_IMPORTED_MODULE_2__DtpTitle_DtpTitle__["a" /* PAGE */], fontWeight: __WEBPACK_IMPORTED_MODULE_2__DtpTitle_DtpTitle__["b" /* REGULAR_16 */], title: this.props.title });
    };

    return DtpPageHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpPageHeader.propTypes =  false ? {
    /** Texto a ser exibido no título */
    title: PropTypes.string.isRequired
} : {};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpPageHeader);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DtpContent = function (_Component) {
    _inherits(DtpContent, _Component);

    function DtpContent() {
        _classCallCheck(this, DtpContent);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpContent.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "main",
            { className: "dtp-content" },
            this.props.children
        );
    };

    return DtpContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DtpContent);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_starscream_theme__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_starscream_theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_starscream_theme__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DtpContentContainer = function (_Component) {
    _inherits(DtpContentContainer, _Component);

    function DtpContentContainer() {
        _classCallCheck(this, DtpContentContainer);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpContentContainer.prototype.componentDidMount = function componentDidMount() {
        Object(__WEBPACK_IMPORTED_MODULE_2_starscream_theme__["applyHighContrast"])();
    };

    DtpContentContainer.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container' },
            this.props.pageHeader ? this.props.pageHeader : null,
            this.props.children
        );
    };

    return DtpContentContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpContentContainer.propTypes =  false ? {
    /** Instância do DtpPageHeader */
    pageHeader: PropTypes.object,

    /** Conteúdo da página */
    children: PropTypes.node.isRequired
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpContentContainer);

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* Starscream-Theme Main JS file */
var $ = __webpack_require__(139);

$(document).ready(function () {
    console.log(' ====          LOADING STARSCREAM-THEME        ====');

    if ($) {
        window.jQuery = $;
        window.$ = $;
        console.log('jQuery was loaded! Version=' + $().jquery);
    }

    var bs = __webpack_require__(307);
    if (bs) {
        console.log('Bootstrap javascripts loaded!');
    }

    console.log(' ==== STARSCREAM-THEME WAS LOADED SUCCESSFULLY ====');
});

function applyHighContrast(activate) {
    if (activate && activate === true) {
        localStorage.setItem("ahc", true);
        addClassContraste();
    } else if (activate === false) {
        localStorage.setItem("ahc", false);
        removeClassContraste();
    } else {
        if (localStorage.ahc === "true") {
            addClassContraste();
        }
    }
}

var addClassContraste = function () {
    $('*')
        .not('pre, .code, .token, .error-text, .dtp-card-text')
        .addClass('dtp-contrast');
    $('*')
        .not('pre, .code, .dropdown-menu, .token, .dtp-panel, .dtp-panel-heading, .panel-headi' +
            'ng, .dtp-page-header, table > tbody > tr, .md-button, input, .panel, button, .dt' +
            'p-card, .card-user, md-select, md-checkbox > .md-container, md-dialog')
        .addClass('dtp-no-border');
    $('.dropdown-menu, .dtp-panel, .panel, button, table > tbody > tr, .md-button, inpu' +
        't, .dtp-card, .card-user, md-select, md-checkbox > .md-container, md-dialog').addClass('dtp-contrast-border');
    $('.dtp-panel-heading, .dtp-page-header, .panel-heading').addClass('dtp-contrast-border-bottom');
}

var removeClassContraste = function () {
    $('*').removeClass('dtp-contrast');
    $('*').removeClass('dtp-no-border');
    $('*').removeClass('dtp-contrast-border');
    $('*').removeClass('dtp-contrast-border-bottom');
}

function aumentarDiminuirFonte() {
    var $btnAumentar = $('.letra_maior');
    var $btnDiminuir = $('.letra_menor');
    var $body = $('body').find('*');
    var $pre = $('pre').find('*');

    var fonts = [];

    function obterTamanhoFonte(elemento) {
        for (var i = 0; i < elemento.length; i++) {
            fonts.push(parseFloat(elemento.eq(i).css('font-size')));
        }
    }

    function aumentarTamanhoFonte(elemento) {
        $btnAumentar
            .on('click', function () {
                for (var i = 0; i < elemento.length; i++) {
                    ++fonts[i];
                    elemento
                        .eq(i)
                        .css('font-size', fonts[i]);
                }
            });
    }

    function diminuirTamanhoFonte(elemento) {
        $btnDiminuir
            .on('click', function () {
                for (var i = 0; i < elemento.length; i++) {
                    --fonts[i];
                    elemento
                        .eq(i)
                        .css('font-size', fonts[i]);
                }
            });
    }
    obterTamanhoFonte($body);
    aumentarTamanhoFonte($body);
    diminuirTamanhoFonte($body);
}

module.exports = {
    applyHighContrast: applyHighContrast,
    aumentarDiminuirFonte: aumentarDiminuirFonte
};
/**
 * jquery.mask.js
 * @version: v1.14.15
 * @author: Igor Escobar
 *
 * Created by Igor Escobar on 2012-03-10. Please report any bug at github.com/igorescobar/jQuery-Mask-Plugin
 *
 * Copyright (c) 2012 Igor Escobar http://igorescobar.com
 *
 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

/* jshint laxbreak: true */
/* jshint maxcomplexity:17 */
/* global define */

// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
// https://github.com/umdjs/umd/blob/master/templates/jqueryPlugin.js
(function (factory, jQuery, Zepto) {

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(139)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery || Zepto);
    }

}(function ($) {
    'use strict';

    var Mask = function (el, mask, options) {

        var p = {
            invalid: [],
            getCaret: function () {
                try {
                    var sel,
                        pos = 0,
                        ctrl = el.get(0),
                        dSel = document.selection,
                        cSelStart = ctrl.selectionStart;

                    // IE Support
                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
                        sel = dSel.createRange();
                        sel.moveStart('character', -p.val().length);
                        pos = sel.text.length;
                    }
                    // Firefox support
                    else if (cSelStart || cSelStart === '0') {
                        pos = cSelStart;
                    }

                    return pos;
                } catch (e) {}
            },
            setCaret: function(pos) {
                try {
                    if (el.is(':focus')) {
                        var range, ctrl = el.get(0);

                        // Firefox, WebKit, etc..
                        if (ctrl.setSelectionRange) {
                            ctrl.setSelectionRange(pos, pos);
                        } else { // IE
                            range = ctrl.createTextRange();
                            range.collapse(true);
                            range.moveEnd('character', pos);
                            range.moveStart('character', pos);
                            range.select();
                        }
                    }
                } catch (e) {}
            },
            events: function() {
                el
                .on('keydown.mask', function(e) {
                    el.data('mask-keycode', e.keyCode || e.which);
                    el.data('mask-previus-value', el.val());
                    el.data('mask-previus-caret-pos', p.getCaret());
                    p.maskDigitPosMapOld = p.maskDigitPosMap;
                })
                .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
                .on('paste.mask drop.mask', function() {
                    setTimeout(function() {
                        el.keydown().keyup();
                    }, 100);
                })
                .on('change.mask', function(){
                    el.data('changed', true);
                })
                .on('blur.mask', function(){
                    if (oldValue !== p.val() && !el.data('changed')) {
                        el.trigger('change');
                    }
                    el.data('changed', false);
                })
                // it's very important that this callback remains in this position
                // otherwhise oldValue it's going to work buggy
                .on('blur.mask', function() {
                    oldValue = p.val();
                })
                // select all text on focus
                .on('focus.mask', function (e) {
                    if (options.selectOnFocus === true) {
                        $(e.target).select();
                    }
                })
                // clear the value if it not complete the mask
                .on('focusout.mask', function() {
                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
                       p.val('');
                   }
                });
            },
            getRegexMask: function() {
                var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;

                for (var i = 0; i < mask.length; i++) {
                    translation = jMask.translation[mask.charAt(i)];

                    if (translation) {

                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
                        optional = translation.optional;
                        recursive = translation.recursive;

                        if (recursive) {
                            maskChunks.push(mask.charAt(i));
                            oRecursive = {digit: mask.charAt(i), pattern: pattern};
                        } else {
                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
                        }

                    } else {
                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
                    }
                }

                r = maskChunks.join('');

                if (oRecursive) {
                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
                         .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
                }

                return new RegExp(r);
            },
            destroyEvents: function() {
                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
            },
            val: function(v) {
                var isInput = el.is('input'),
                    method = isInput ? 'val' : 'text',
                    r;

                if (arguments.length > 0) {
                    if (el[method]() !== v) {
                        el[method](v);
                    }
                    r = el;
                } else {
                    r = el[method]();
                }

                return r;
            },
            calculateCaretPosition: function() {
                var oldVal = el.data('mask-previus-value') || '',
                    newVal = p.getMasked(),
                    caretPosNew = p.getCaret();
                if (oldVal !== newVal) {
                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
                        newValL = newVal.length,
                        oldValL = oldVal.length,
                        maskDigitsBeforeCaret = 0,
                        maskDigitsAfterCaret = 0,
                        maskDigitsBeforeCaretAll = 0,
                        maskDigitsBeforeCaretAllOld = 0,
                        i = 0;

                    for (i = caretPosNew; i < newValL; i++) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsAfterCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsBeforeCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (p.maskDigitPosMap[i]) {
                            maskDigitsBeforeCaretAll++;
                        }
                    }

                    for (i = caretPosOld - 1; i >= 0; i--) {
                        if (p.maskDigitPosMapOld[i]) {
                            maskDigitsBeforeCaretAllOld++;
                        }
                    }

                    // if the cursor is at the end keep it there
                    if (caretPosNew > oldValL) {
                      caretPosNew = newValL * 10;
                    } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
                        if (!p.maskDigitPosMapOld[caretPosNew])  {
                          var caretPos = caretPosNew;
                          caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
                          caretPosNew -= maskDigitsBeforeCaret;
                          if (p.maskDigitPosMap[caretPosNew])  {
                            caretPosNew = caretPos;
                          }
                        }
                    }
                    else if (caretPosNew > caretPosOld) {
                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
                        caretPosNew += maskDigitsAfterCaret;
                    }
                }
                return caretPosNew;
            },
            behaviour: function(e) {
                e = e || window.event;
                p.invalid = [];

                var keyCode = el.data('mask-keycode');

                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
                    var newVal = p.getMasked(),
                        caretPos = p.getCaret();

                    // this is a compensation to devices/browsers that don't compensate
                    // caret positioning the right way
                    setTimeout(function() {
                      p.setCaret(p.calculateCaretPosition());
                    }, $.jMaskGlobals.keyStrokeCompensation);

                    p.val(newVal);
                    p.setCaret(caretPos);
                    return p.callbacks(e);
                }
            },
            getMasked: function(skipMaskChars, val) {
                var buf = [],
                    value = val === undefined ? p.val() : val + '',
                    m = 0, maskLen = mask.length,
                    v = 0, valLen = value.length,
                    offset = 1, addMethod = 'push',
                    resetPos = -1,
                    maskDigitCount = 0,
                    maskDigitPosArr = [],
                    lastMaskChar,
                    check;

                if (options.reverse) {
                    addMethod = 'unshift';
                    offset = -1;
                    lastMaskChar = 0;
                    m = maskLen - 1;
                    v = valLen - 1;
                    check = function () {
                        return m > -1 && v > -1;
                    };
                } else {
                    lastMaskChar = maskLen - 1;
                    check = function () {
                        return m < maskLen && v < valLen;
                    };
                }

                var lastUntranslatedMaskChar;
                while (check()) {
                    var maskDigit = mask.charAt(m),
                        valDigit = value.charAt(v),
                        translation = jMask.translation[maskDigit];

                    if (translation) {
                        if (valDigit.match(translation.pattern)) {
                            buf[addMethod](valDigit);
                             if (translation.recursive) {
                                if (resetPos === -1) {
                                    resetPos = m;
                                } else if (m === lastMaskChar && m !== resetPos) {
                                    m = resetPos - offset;
                                }

                                if (lastMaskChar === resetPos) {
                                    m -= offset;
                                }
                            }
                            m += offset;
                        } else if (valDigit === lastUntranslatedMaskChar) {
                            // matched the last untranslated (raw) mask character that we encountered
                            // likely an insert offset the mask character from the last entry; fall
                            // through and only increment v
                            maskDigitCount--;
                            lastUntranslatedMaskChar = undefined;
                        } else if (translation.optional) {
                            m += offset;
                            v -= offset;
                        } else if (translation.fallback) {
                            buf[addMethod](translation.fallback);
                            m += offset;
                            v -= offset;
                        } else {
                          p.invalid.push({p: v, v: valDigit, e: translation.pattern});
                        }
                        v += offset;
                    } else {
                        if (!skipMaskChars) {
                            buf[addMethod](maskDigit);
                        }

                        if (valDigit === maskDigit) {
                            maskDigitPosArr.push(v);
                            v += offset;
                        } else {
                            lastUntranslatedMaskChar = maskDigit;
                            maskDigitPosArr.push(v + maskDigitCount);
                            maskDigitCount++;
                        }

                        m += offset;
                    }
                }

                var lastMaskCharDigit = mask.charAt(lastMaskChar);
                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
                    buf.push(lastMaskCharDigit);
                }

                var newVal = buf.join('');
                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
                return newVal;
            },
            mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
              var maskDiff = options.reverse ? newVal.length - valLen : 0;
              p.maskDigitPosMap = {};
              for (var i = 0; i < maskDigitPosArr.length; i++) {
                p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
              }
            },
            callbacks: function (e) {
                var val = p.val(),
                    changed = val !== oldValue,
                    defaultArgs = [val, e, el, options],
                    callback = function(name, criteria, args) {
                        if (typeof options[name] === 'function' && criteria) {
                            options[name].apply(this, args);
                        }
                    };

                callback('onChange', changed === true, defaultArgs);
                callback('onKeyPress', changed === true, defaultArgs);
                callback('onComplete', val.length === mask.length, defaultArgs);
                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
            }
        };

        el = $(el);
        var jMask = this, oldValue = p.val(), regexMask;

        mask = typeof mask === 'function' ? mask(p.val(), undefined, el,  options) : mask;

        // public methods
        jMask.mask = mask;
        jMask.options = options;
        jMask.remove = function() {
            var caret = p.getCaret();
            if (jMask.options.placeholder) {
                el.removeAttr('placeholder');
            }
            if (el.data('mask-maxlength')) {
                el.removeAttr('maxlength');
            }
            p.destroyEvents();
            p.val(jMask.getCleanVal());
            p.setCaret(caret);
            return el;
        };

        // get value without mask
        jMask.getCleanVal = function() {
           return p.getMasked(true);
        };

        // get masked value without the value being in the input or element
        jMask.getMaskedVal = function(val) {
           return p.getMasked(false, val);
        };

       jMask.init = function(onlyMask) {
            onlyMask = onlyMask || false;
            options = options || {};

            jMask.clearIfNotMatch  = $.jMaskGlobals.clearIfNotMatch;
            jMask.byPassKeys       = $.jMaskGlobals.byPassKeys;
            jMask.translation      = $.extend({}, $.jMaskGlobals.translation, options.translation);

            jMask = $.extend(true, {}, jMask, options);

            regexMask = p.getRegexMask();

            if (onlyMask) {
                p.events();
                p.val(p.getMasked());
            } else {
                if (options.placeholder) {
                    el.attr('placeholder' , options.placeholder);
                }

                // this is necessary, otherwise if the user submit the form
                // and then press the "back" button, the autocomplete will erase
                // the data. Works fine on IE9+, FF, Opera, Safari.
                if (el.data('mask')) {
                  el.attr('autocomplete', 'off');
                }

                // detect if is necessary let the user type freely.
                // for is a lot faster than forEach.
                for (var i = 0, maxlength = true; i < mask.length; i++) {
                    var translation = jMask.translation[mask.charAt(i)];
                    if (translation && translation.recursive) {
                        maxlength = false;
                        break;
                    }
                }

                if (maxlength) {
                    el.attr('maxlength', mask.length).data('mask-maxlength', true);
                }

                p.destroyEvents();
                p.events();

                var caret = p.getCaret();
                p.val(p.getMasked());
                p.setCaret(caret);
            }
        };

        jMask.init(!el.is('input'));
    };

    $.maskWatchers = {};
    var HTMLAttributes = function () {
        var input = $(this),
            options = {},
            prefix = 'data-mask-',
            mask = input.attr('data-mask');

        if (input.attr(prefix + 'reverse')) {
            options.reverse = true;
        }

        if (input.attr(prefix + 'clearifnotmatch')) {
            options.clearIfNotMatch = true;
        }

        if (input.attr(prefix + 'selectonfocus') === 'true') {
           options.selectOnFocus = true;
        }

        if (notSameMaskObject(input, mask, options)) {
            return input.data('mask', new Mask(this, mask, options));
        }
    },
    notSameMaskObject = function(field, mask, options) {
        options = options || {};
        var maskObject = $(field).data('mask'),
            stringify = JSON.stringify,
            value = $(field).val() || $(field).text();
        try {
            if (typeof mask === 'function') {
                mask = mask(value);
            }
            return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
        } catch (e) {}
    },
    eventSupported = function(eventName) {
        var el = document.createElement('div'), isSupported;

        eventName = 'on' + eventName;
        isSupported = (eventName in el);

        if ( !isSupported ) {
            el.setAttribute(eventName, 'return;');
            isSupported = typeof el[eventName] === 'function';
        }
        el = null;

        return isSupported;
    };

    $.fn.mask = function(mask, options) {
        options = options || {};
        var selector = this.selector,
            globals = $.jMaskGlobals,
            interval = globals.watchInterval,
            watchInputs = options.watchInputs || globals.watchInputs,
            maskFunction = function() {
                if (notSameMaskObject(this, mask, options)) {
                    return $(this).data('mask', new Mask(this, mask, options));
                }
            };

        $(this).each(maskFunction);

        if (selector && selector !== '' && watchInputs) {
            clearInterval($.maskWatchers[selector]);
            $.maskWatchers[selector] = setInterval(function(){
                $(document).find(selector).each(maskFunction);
            }, interval);
        }
        return this;
    };

    $.fn.masked = function(val) {
        return this.data('mask').getMaskedVal(val);
    };

    $.fn.unmask = function() {
        clearInterval($.maskWatchers[this.selector]);
        delete $.maskWatchers[this.selector];
        return this.each(function() {
            var dataMask = $(this).data('mask');
            if (dataMask) {
                dataMask.remove().removeData('mask');
            }
        });
    };

    $.fn.cleanVal = function() {
        return this.data('mask').getCleanVal();
    };

    $.applyDataMask = function(selector) {
        selector = selector || $.jMaskGlobals.maskElements;
        var $selector = (selector instanceof $) ? selector : $(selector);
        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
    };

    var globals = {
        maskElements: 'input,td,span,div',
        dataMaskAttr: '*[data-mask]',
        dataMask: true,
        watchInterval: 300,
        watchInputs: true,
        keyStrokeCompensation: 10,
        // old versions of chrome dont work great with input event
        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
        watchDataMask: false,
        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
        translation: {
            '0': {pattern: /\d/},
            '9': {pattern: /\d/, optional: true},
            '#': {pattern: /\d/, recursive: true},
            'A': {pattern: /[a-zA-Z0-9]/},
            'S': {pattern: /[a-zA-Z]/}
        }
    };

    $.jMaskGlobals = $.jMaskGlobals || {};
    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);

    // looking for inputs with data-mask attribute
    if (globals.dataMask) {
        $.applyDataMask();
    }

    setInterval(function() {
        if ($.jMaskGlobals.watchDataMask) {
            $.applyDataMask();
        }
    }, globals.watchInterval);
}, window.jQuery, window.Zepto));


/***/ }),
/* 307 */
/***/ (function(module, exports) {

/*!
 * Bootstrap v3.4.1 (https://getbootstrap.com/)
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under the MIT license
 */

if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery')
}

+function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
  }
}(jQuery);

/* ========================================================================
 * Bootstrap: transition.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // https://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: alert.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.4.1'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    selector    = selector === '#' ? [] : selector
    var $parent = $(document).find(selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* ========================================================================
 * Bootstrap: button.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.4.1'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);

/* ========================================================================
 * Bootstrap: carousel.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.4.1'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      if (typeof $next === 'object' && $next.length) {
        $next[0].offsetWidth // force reflow
      }
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    if (href) {
      href = href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
    }

    var target  = $this.attr('data-target') || href
    var $target = $(document).find(target)

    if (!$target.hasClass('carousel')) return

    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: collapse.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.4.1'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(document).find(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(document).find(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.4.1'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector !== '#' ? $(document).find(selector) : null

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* ========================================================================
 * Bootstrap: modal.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#modals
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options = options
    this.$body = $(document.body)
    this.$element = $(element)
    this.$dialog = this.$element.find('.modal-dialog')
    this.$backdrop = null
    this.isShown = null
    this.originalBodyPad = null
    this.scrollbarWidth = 0
    this.ignoreBackdropClick = false
    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION = '3.4.1'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
          this.$element[0] !== e.target &&
          !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    var scrollbarWidth = this.scrollbarWidth
    if (this.bodyIsOverflowing) {
      this.$body.css('padding-right', bodyPad + scrollbarWidth)
      $(this.fixedContent).each(function (index, element) {
        var actualPadding = element.style.paddingRight
        var calculatedPadding = $(element).css('padding-right')
        $(element)
          .data('padding-right', actualPadding)
          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
      })
    }
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
    $(this.fixedContent).each(function (index, element) {
      var padding = $(element).data('padding-right')
      $(element).removeData('padding-right')
      element.style.paddingRight = padding ? padding : ''
    })
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this = $(this)
    var href = $this.attr('href')
    var target = $this.attr('data-target') ||
      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7

    var $target = $(document).find(target)
    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']

  var uriAttrs = [
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
  ]

  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i

  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  }

  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi

  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i

  function allowedAttribute(attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase()

    if ($.inArray(attrName, allowedAttributeList) !== -1) {
      if ($.inArray(attrName, uriAttrs) !== -1) {
        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
      }

      return true
    }

    var regExp = $(allowedAttributeList).filter(function (index, value) {
      return value instanceof RegExp
    })

    // Check if a regular expression validates the attribute.
    for (var i = 0, l = regExp.length; i < l; i++) {
      if (attrName.match(regExp[i])) {
        return true
      }
    }

    return false
  }

  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (unsafeHtml.length === 0) {
      return unsafeHtml
    }

    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeHtml)
    }

    // IE 8 and below don't support createHTMLDocument
    if (!document.implementation || !document.implementation.createHTMLDocument) {
      return unsafeHtml
    }

    var createdDocument = document.implementation.createHTMLDocument('sanitization')
    createdDocument.body.innerHTML = unsafeHtml

    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
    var elements = $(createdDocument.body).find('*')

    for (var i = 0, len = elements.length; i < len; i++) {
      var el = elements[i]
      var elName = el.nodeName.toLowerCase()

      if ($.inArray(elName, whitelistKeys) === -1) {
        el.parentNode.removeChild(el)

        continue
      }

      var attributeList = $.map(el.attributes, function (el) { return el })
      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])

      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
          el.removeAttribute(attributeList[j].nodeName)
        }
      }
    }

    return createdDocument.body.innerHTML
  }

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.4.1'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    },
    sanitize : true,
    sanitizeFn : null,
    whiteList : DefaultWhitelist
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    var dataAttributes = this.$element.data()

    for (var dataAttr in dataAttributes) {
      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
        delete dataAttributes[dataAttr]
      }
    }

    options = $.extend({}, this.getDefaults(), dataAttributes, options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    if (options.sanitize) {
      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    if (this.options.html) {
      if (this.options.sanitize) {
        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
      }

      $tip.find('.tooltip-inner').html(title)
    } else {
      $tip.find('.tooltip-inner').text(title)
    }

    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }

  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
  }

  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.4.1'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    if (this.options.html) {
      var typeContent = typeof content

      if (this.options.sanitize) {
        title = this.sanitizeHtml(title)

        if (typeContent === 'string') {
          content = this.sanitizeHtml(content)
        }
      }

      $tip.find('.popover-title').html(title)
      $tip.find('.popover-content').children().detach().end()[
        typeContent === 'string' ? 'html' : 'append'
      ](content)
    } else {
      $tip.find('.popover-title').text(title)
      $tip.find('.popover-content').children().detach().end().text(content)
    }

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
        o.content.call($e[0]) :
        o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.4.1'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tab.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.4.1'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(document).find(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
        .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
        .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
        .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
          .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* ========================================================================
 * Bootstrap: affix.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#affix
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)

    this.$target = target
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.4.1'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ApplicationBar__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserInfo__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InfoBarBtn__ = __webpack_require__(311);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DtpHeader = function (_Component) {
    _inherits(DtpHeader, _Component);

    function DtpHeader() {
        _classCallCheck(this, DtpHeader);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpHeader.prototype.render = function render() {
        var _props = this.props,
            homeUrl = _props.homeUrl,
            appInfo = _props.appInfo,
            showUserInfo = _props.showUserInfo,
            userData = _props.userData,
            doLogout = _props.doLogout,
            doLogin = _props.doLogin,
            showInfoBarBtn = _props.showInfoBarBtn,
            children = _props.children;


        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'header',
            { className: 'dtp-header header-lg' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ApplicationBar__["a" /* default */], {
                appInfo: appInfo,
                homeUrl: homeUrl }),
            showUserInfo === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UserInfo__["a" /* default */], {
                userData: userData,
                doLogout: doLogout,
                doLogin: doLogin }) : null,
            showInfoBarBtn ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__InfoBarBtn__["a" /* default */], null) : null,
            children
        );
    };

    return DtpHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpHeader.propTypes =  false ? {
    /** Path do home da app */
    homeUrl: PropTypes.string.isRequired,

    /** Objeto que define os valores da aplicação */
    appInfo: PropTypes.shape({
        /** Nome do sistema */
        firstName: PropTypes.string.isRequired,

        /** Descrição do sistema */
        lastName: PropTypes.string,

        /** Dono (cliente) do sistema */
        owner: PropTypes.string.isRequired
    }).isRequired,

    /** Define se ícone com as informações do usuário deve ser exibido */
    showUserInfo: PropTypes.bool.isRequired,

    /** Dados do usuário logado */
    userData: PropTypes.shape({
        /** Primeiro nome do usuário */
        firstName: PropTypes.string,

        /** Último nome do usuário */
        lastName: PropTypes.string,

        /** Documento usado pelo usuário para fazer login */
        document: PropTypes.shape({
            /** Descrição do tipo do documento */
            label: PropTypes.string,

            /** Número do documento */
            number: PropTypes.string
        }),

        /** Informações adicionais do usuário logado */
        information: PropTypes.string
    }),

    /** Função a ser executada para efetuar o logout do usuário */
    doLogout: PropTypes.func,

    /** Função que será executada para efetuar o login do usuário */
    doLogin: PropTypes.func,

    /** Define se o componente (i) info deve ser exibido  */
    showInfoBarBtn: PropTypes.bool.isRequired,

    /** Conteúdo a ser passado via props, se desejar */
    children: PropTypes.any
} : {};

DtpHeader.defaultProps = {
    showInfoBarBtn: true,
    showUserInfo: true,
    homeUrl: '/'
};

/* harmony default export */ __webpack_exports__["a"] = (DtpHeader);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ApplicationBar = function (_Component) {
    _inherits(ApplicationBar, _Component);

    function ApplicationBar() {
        _classCallCheck(this, ApplicationBar);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ApplicationBar.prototype.render = function render() {
        var _props = this.props,
            appInfo = _props.appInfo,
            homeUrl = _props.homeUrl;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'app-id' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h1',
                { className: 'title-app' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { href: homeUrl },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'strong',
                        null,
                        appInfo.firstName
                    ),
                    '\xA0',
                    appInfo.lastName
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: 'title-owner' },
                appInfo.owner
            )
        );
    };

    return ApplicationBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ApplicationBar.propTypes =  false ? {
    homeUrl: PropTypes.string.isRequired,
    appInfo: PropTypes.object.isRequired
} : {};

ApplicationBar.defaultProps = {
    homeUrl: '/'
};

/* harmony default export */ __webpack_exports__["a"] = (ApplicationBar);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var UserInfo = function UserInfo(props) {
    var userData = props.userData,
        doLogin = props.doLogin,
        doLogout = props.doLogout;


    if (!userData) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'user-info user-info-lg' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'signin-icon', onClick: doLogin && function () {
                        return doLogin();
                    } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon ico-user-c' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    'ENTRAR'
                )
            )
        );
    } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'user-info user-info-lg dropdown' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    {
                        className: 'user-target dropdown-toggle',
                        'data-toggle': 'dropdown',
                        'data-target': '.card-user' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon ico-user-c' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h5',
                        { className: 'user-name' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'first-name' },
                            userData.firstName
                        ),
                        '\xA0 ',
                        userData.lastName
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h5',
                        { className: 'user-doc' },
                        userData.document ? userData.document.label : null,
                        '\xA0',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'doc' },
                            userData.document ? userData.document.number : null
                        )
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'card-user' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'user-card-header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon ico-user-c' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h5',
                        { className: 'user-name' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'first-name' },
                            userData.firstName
                        ),
                        '\xA0 ',
                        userData.lastName
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h5',
                        { className: 'user-doc' },
                        userData.document ? userData.document.label : null,
                        '\xA0',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'doc' },
                            userData.document ? userData.document.number : null
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { className: 'card-close' },
                        ' '
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'user-card-body' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        userData.information
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'user-card-footer' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        {
                            className: 'btn btn-danger btn-block ripple text-center',
                            onClick: doLogout && function () {
                                return doLogout();
                            } },
                        'Sair'
                    )
                )
            )
        );
    }
};

UserInfo.propTypes =  false ? {
    /** Dados do usuário logado */
    userData: PropTypes.shape({
        /** Primeiro nome do usuário */
        firstName: PropTypes.string,

        /** Último nome do usuário */
        lastName: PropTypes.string,

        /** Documento usado pelo usuário para fazer login */
        document: PropTypes.shape({
            /** Descrição do tipo do documento */
            label: PropTypes.string,

            /** Número do documento */
            number: PropTypes.string
        }),

        /** Informações adicionais do usuário logado */
        information: PropTypes.string
    }),

    /** Função a ser executada para efetuar o logout do usuário */
    doLogout: PropTypes.func,

    /** Função que será executada para efetuar o login do usuário */
    doLogin: PropTypes.func
} : {};

/* harmony default export */ __webpack_exports__["a"] = (UserInfo);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DtpButton_DtpButtonFab__ = __webpack_require__(137);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var InfoBarBtn = function (_Component) {
    _inherits(InfoBarBtn, _Component);

    function InfoBarBtn() {
        _classCallCheck(this, InfoBarBtn);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    InfoBarBtn.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'info-bar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DtpButton_DtpButtonFab__["a" /* default */], {
                id: 'info-bar-btn',
                className: 'dtp-primary',
                icon: 'ico-info',
                accessibilityName: 'Bot\xE3o de Informa\xE7\xF5es do Sistema' })
        );
    };

    return InfoBarBtn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (InfoBarBtn);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DtpFooter = function (_Component) {
    _inherits(DtpFooter, _Component);

    function DtpFooter() {
        _classCallCheck(this, DtpFooter);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpFooter.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "footer",
            { className: "dtp-footer" },
            this.props.children
        );
    };

    return DtpFooter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DtpFooter);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MESSAGE_TYPES */
/* unused harmony export DtpSnackbarMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutability_helper__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var MESSAGE_TYPES = ['danger', 'info', 'warning', 'success'];

var DtpSnackbar = function (_Component) {
    _inherits(DtpSnackbar, _Component);

    function DtpSnackbar(props) {
        _classCallCheck(this, DtpSnackbar);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            messages: []
        };

        _this.arrayObjectIndexOf = _this.arrayObjectIndexOf.bind(_this);
        _this.verifyNewMessage = _this.verifyNewMessage.bind(_this);

        window.DtpSnackbar = _this;
        return _this;
    }

    DtpSnackbar.prototype.arrayObjectIndexOf = function arrayObjectIndexOf(myArray, searchTerm, property) {
        for (var i = 0, len = myArray.length; i < len; i++) {
            if (myArray[i][property] === searchTerm) return i;
        }
        return -1;
    };

    DtpSnackbar.prototype.addMessage = function addMessage(message) {
        var messages = __WEBPACK_IMPORTED_MODULE_2_immutability_helper___default()(this.state.messages, { $push: [message] });
        this.setState({ messages: messages });

        if (this.state.message === undefined) {
            this.setState({ message: message });
        }

        if (!this.verifyNewMessageTimer) {
            this.verifyNewMessageTimer = setInterval(this.verifyNewMessage, 100);
        }
    };

    DtpSnackbar.prototype.verifyNewMessage = function verifyNewMessage() {
        if (this.state.message === undefined) {
            if (this.state.messages.length > 0) {
                var message = this.state.messages[0];
                this.setState({ message: message });
            } else {
                this.verifyNewMessageTimer = undefined;
            }
        }
    };

    DtpSnackbar.prototype.removeMessage = function removeMessage(message) {
        var index = this.arrayObjectIndexOf(this.state.messages, message.index, message.index);

        var messages = __WEBPACK_IMPORTED_MODULE_2_immutability_helper___default()(this.state.messages, {
            $splice: [[index, 1]]
        });

        this.setState({ messages: messages, message: undefined });
    };

    DtpSnackbar.prototype.render = function render() {
        var _this2 = this;

        var msg = this.state.message;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('dtp-snackbar', {
                    'dtp-snackbar-no-messages': this.state.messages.length === 0
                }) },
            msg && msg !== undefined ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DtpSnackbarMessage, {
                message: msg,
                onClose: function onClose() {
                    return _this2.removeMessage(msg);
                },
                timeout: this.state.message.timeout,
                qtdRemainingMessages: this.state.messages.length - 1 }) : null
        );
    };

    return DtpSnackbar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpSnackbar.propTypes =  false ? {
    message: PropTypes.shape({
        /** Tipo da mensagem */
        type: PropTypes.oneOf(MESSAGE_TYPES),

        /** Título da mensagem. */
        title: PropTypes.string,

        /** Texto da mensagem. */
        text: PropTypes.string,

        /** Configura quanto tempo a mensagem fica em exibição. Deve ser informado em milissegundos. */
        timeout: PropTypes.number,

        /** Configura se a mensagem deve desaparecer automaticamente ou não. */
        dismissOnTimeout: PropTypes.bool
    })
} : {};

DtpSnackbar.defaultProps = {
    message: {
        timeout: 7000,
        dismissOnTimeout: true
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DtpSnackbar);

var DtpSnackbarMessage = function (_Component2) {
    _inherits(DtpSnackbarMessage, _Component2);

    function DtpSnackbarMessage(props) {
        _classCallCheck(this, DtpSnackbarMessage);

        var _this3 = _possibleConstructorReturn(this, _Component2.call(this, props));

        _this3.state = {
            opacity: 0
        };

        _this3.effectDuration = 300;
        _this3.doClose = _this3.doClose.bind(_this3);
        _this3.doOpen = _this3.doOpen.bind(_this3);
        return _this3;
    }

    DtpSnackbarMessage.prototype.componentDidMount = function componentDidMount() {
        this.openTimer = setInterval(this.doOpen, this.effectDuration);
    };

    DtpSnackbarMessage.prototype.componentWillUnmount = function componentWillUnmount() {
        clearInterval(this.remainingTimer);
        clearInterval(this.closeTimer);
    };

    DtpSnackbarMessage.prototype.doOpen = function doOpen() {
        clearInterval(this.openTimer);
        this.setState({ opacity: 0.95 });
        if (this.props.dismissOnTimeout === true) {
            this.remainingTimer = setInterval(this.doClose, this.props.timeout);
        }
    };

    DtpSnackbarMessage.prototype.doClose = function doClose() {
        this.setState({ opacity: 0 });
        this.closeTimer = setInterval(this.props.onClose, this.effectDuration);
    };

    DtpSnackbarMessage.prototype.alertClass = function alertClass(type) {
        var classes = {
            danger: 'danger',
            warning: 'warning',
            info: 'info',
            success: 'success'
        };
        return classes[type] || classes.success;
    };

    DtpSnackbarMessage.prototype.alertIcon = function alertIcon(type) {
        var icons = {
            danger: 'ico-alert-t',
            warning: 'ico-alert-c',
            info: 'ico-info-c',
            success: 'ico-confirm'
        };
        return icons[type] || icons.success;
    };

    DtpSnackbarMessage.prototype.alertButtonText = function alertButtonText(type) {
        var buttonTexts = {
            danger: 'fechar',
            warning: 'entendi',
            info: 'ok',
            success: 'ok'
        };
        return buttonTexts[type] || buttonTexts.success;
    };

    DtpSnackbarMessage.prototype.render = function render() {
        var _this4 = this;

        var message = this.props.message;

        var defaultStyle = {
            transition: 'opacity ' + this.effectDuration + 'ms ease-in-out',
            opacity: this.state.opacity
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-snackbar-message', style: defaultStyle },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'label' },
                this.props.qtdRemainingMessages
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
                className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('dtp-snackbar-message-icon', this.alertIcon(message.type), this.alertClass(message.type)) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'dtp-snackbar-message-text' },
                message.text,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('dtp-snackbar-message-link', this.alertClass(message.type)),
                    onClick: function onClick() {
                        return _this4.doClose();
                    } },
                this.alertButtonText(message.type)
            )
        );
    };

    return DtpSnackbarMessage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpSnackbarMessage.propTypes =  false ? {
    /** Função que é executada quando a mensagem é fechada */
    onClose: PropTypes.func.isRequired,

    /** Tempo de exibição da mensagem */
    timeout: PropTypes.number,

    /** Objeto contendo os dados da mensagem */
    message: PropTypes.shape({
        /** Texto da mensagem */
        text: PropTypes.string.isRequired,

        /** Tipo da Mensagem */
        type: PropTypes.oneOf(MESSAGE_TYPES)
    }).isRequired,

    /** Atributo que define se a mensagem deve ser fechada ao passar o tempo definido no atributo timeout */
    dismissOnTimeout: PropTypes.bool,

    /** Atributo que define quantas mensagens ainda faltam ser exibidas */
    qtdRemainingMessages: PropTypes.number.isRequired
} : {};

DtpSnackbarMessage.defaultProps = {
    timeout: 7000,
    dismissOnTimeout: true,
    qtdRemainingMessages: 0
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(23);

var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;

var toString = Object.prototype.toString
var type = function(obj) {
  return toString.call(obj).slice(8, -1);
}

var assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
  getAllKeys(source).forEach(function(key) {
    if (hasOwnProperty.call(source, key)) {
      target[key] = source[key];
    }
  });
  return target;
};

var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
  /* istanbul ignore next */ function(obj) { return Object.keys(obj) };

/* istanbul ignore next */
function copy(object) {
  if (Array.isArray(object)) {
    return assign(object.constructor(object.length), object)
  } else if (type(object) === 'Map') {
    return new Map(object)
  } else if (type(object) === 'Set') {
    return new Set(object)
  } else if (object && typeof object === 'object') {
    var prototype = Object.getPrototypeOf(object);
    return assign(Object.create(prototype), object);
  } else {
    return object;
  }
}

function newContext() {
  var commands = assign({}, defaultCommands);
  update.extend = function(directive, fn) {
    commands[directive] = fn;
  };
  update.isEquals = function(a, b) { return a === b; };

  return update;

  function update(object, spec) {
    if (typeof spec === 'function') {
      spec = { $apply: spec };
    }

    if (!(Array.isArray(object) && Array.isArray(spec))) {
      invariant(
        !Array.isArray(spec),
        'update(): You provided an invalid spec to update(). The spec may ' +
        'not contain an array except as the value of $set, $push, $unshift, ' +
        '$splice or any custom command allowing an array value.'
      );
    }

    invariant(
      typeof spec === 'object' && spec !== null,
      'update(): You provided an invalid spec to update(). The spec and ' +
      'every included key path must be plain objects containing one of the ' +
      'following commands: %s.',
      Object.keys(commands).join(', ')
    );

    var nextObject = object;
    var index, key;
    getAllKeys(spec).forEach(function(key) {
      if (hasOwnProperty.call(commands, key)) {
        var objectWasNextObject = object === nextObject;
        nextObject = commands[key](spec[key], nextObject, spec, object);
        if (objectWasNextObject && update.isEquals(nextObject, object)) {
          nextObject = object;
        }
      } else {
        var nextValueForKey =
          type(object) === 'Map'
            ? update(object.get(key), spec[key])
            : update(object[key], spec[key]);
        var nextObjectValue =
          type(nextObject) === 'Map'
              ? nextObject.get(key)
              : nextObject[key];
        if (!update.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
          if (nextObject === object) {
            nextObject = copy(object);
          }
          if (type(nextObject) === 'Map') {
            nextObject.set(key, nextValueForKey);
          } else {
            nextObject[key] = nextValueForKey;
          }
        }
      }
    })
    return nextObject;
  }

}

var defaultCommands = {
  $push: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$push');
    return value.length ? nextObject.concat(value) : nextObject;
  },
  $unshift: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$unshift');
    return value.length ? value.concat(nextObject) : nextObject;
  },
  $splice: function(value, nextObject, spec, originalObject) {
    invariantSplices(nextObject, spec);
    value.forEach(function(args) {
      invariantSplice(args);
      if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
      splice.apply(nextObject, args);
    });
    return nextObject;
  },
  $set: function(value, nextObject, spec) {
    invariantSet(spec);
    return value;
  },
  $toggle: function(targets, nextObject) {
    invariantSpecArray(targets, '$toggle');
    var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;

    targets.forEach(function(target) {
      nextObjectCopy[target] = !nextObject[target];
    });

    return nextObjectCopy;
  },
  $unset: function(value, nextObject, spec, originalObject) {
    invariantSpecArray(value, '$unset');
    value.forEach(function(key) {
      if (Object.hasOwnProperty.call(nextObject, key)) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        delete nextObject[key];
      }
    });
    return nextObject;
  },
  $add: function(value, nextObject, spec, originalObject) {
    invariantMapOrSet(nextObject, '$add');
    invariantSpecArray(value, '$add');
    if (type(nextObject) === 'Map') {
      value.forEach(function(pair) {
        var key = pair[0];
        var value = pair[1];
        if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
        nextObject.set(key, value);
      });
    } else {
      value.forEach(function(value) {
        if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
        nextObject.add(value);
      });
    }
    return nextObject;
  },
  $remove: function(value, nextObject, spec, originalObject) {
    invariantMapOrSet(nextObject, '$remove');
    invariantSpecArray(value, '$remove');
    value.forEach(function(key) {
      if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
      nextObject.delete(key);
    });
    return nextObject;
  },
  $merge: function(value, nextObject, spec, originalObject) {
    invariantMerge(nextObject, value);
    getAllKeys(value).forEach(function(key) {
      if (value[key] !== nextObject[key]) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        nextObject[key] = value[key];
      }
    });
    return nextObject;
  },
  $apply: function(value, original) {
    invariantApply(value);
    return value(original);
  }
};

var contextForExport = newContext();

module.exports = contextForExport;
module.exports.default = contextForExport;
module.exports.newContext = newContext;

// invariants

function invariantPushAndUnshift(value, spec, command) {
  invariant(
    Array.isArray(value),
    'update(): expected target of %s to be an array; got %s.',
    command,
    value
  );
  invariantSpecArray(spec[command], command)
}

function invariantSpecArray(spec, command) {
  invariant(
    Array.isArray(spec),
    'update(): expected spec of %s to be an array; got %s. ' +
    'Did you forget to wrap your parameter in an array?',
    command,
    spec
  );
}

function invariantSplices(value, spec) {
  invariant(
    Array.isArray(value),
    'Expected $splice target to be an array; got %s',
    value
  );
  invariantSplice(spec['$splice']);
}

function invariantSplice(value) {
  invariant(
    Array.isArray(value),
    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
    'Did you forget to wrap your parameters in an array?',
    value
  );
}

function invariantApply(fn) {
  invariant(
    typeof fn === 'function',
    'update(): expected spec of $apply to be a function; got %s.',
    fn
  );
}

function invariantSet(spec) {
  invariant(
    Object.keys(spec).length === 1,
    'Cannot have more than one key in an object with $set'
  );
}

function invariantMerge(target, specValue) {
  invariant(
    specValue && typeof specValue === 'object',
    'update(): $merge expects a spec of type \'object\'; got %s',
    specValue
  );
  invariant(
    target && typeof target === 'object',
    'update(): $merge expects a target of type \'object\'; got %s',
    target
  );
}

function invariantMapOrSet(target, command) {
  var typeOfTarget = type(target);
  invariant(
    typeOfTarget === 'Map' || typeOfTarget === 'Set',
    'update(): %s expects a target of type Set or Map; got %s',
    command,
    typeOfTarget
  );
}


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_overlays_lib_Overlay__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DtpPopoverContent = function DtpPopoverContent(props) {
    var style = props.style,
        innerStyle = props.innerStyle,
        children = props.children,
        iconClass = props.iconClass,
        placement = props.placement,
        title = props.title,
        zIndex = props.zIndex;


    var titleContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'dtp-popover-title' },
        iconClass ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-popover-title-icon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: iconClass })
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-popover-title-close' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { onClick: props.onClose },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ico-cancel' })
            )
        )
    );

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('dtp-popover', 'dtp-popover-' + placement, 'dtp-popover-tooltip'),
            style: _extends({
                zIndex: zIndex
            }, style) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'dtp-popover-arrow' }),
        ' ',
        title ? titleContent : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'dtp-popover-inner',
                style: _extends({}, innerStyle) },
            children
        )
    );
};

var DtpPopover = function (_Component) {
    _inherits(DtpPopover, _Component);

    function DtpPopover(props) {
        _classCallCheck(this, DtpPopover);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            show: false
        };

        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.onHide = _this.onHide.bind(_this);
        return _this;
    }

    DtpPopover.prototype.componentDidUpdate = function componentDidUpdate() {
        if (this.state.show !== this.props.show) {
            this.setState({
                show: this.props.show
            });
        }
    };

    DtpPopover.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, true);
    };

    DtpPopover.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
    };

    DtpPopover.prototype.handleScroll = function handleScroll() {
        if (this.overlayRef.props.show) {
            this.setState({
                show: false
            });
        }
    };

    DtpPopover.prototype.onHide = function onHide(e) {
        this.setState({
            show: false
        });
        if (this.props.onHide) {
            this.props.onHide(e);
        }
    };

    DtpPopover.prototype.render = function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_overlays_lib_Overlay___default.a,
            {
                ref: function ref(overlay) {
                    _this2.overlayRef = overlay;
                },
                show: this.state.show,
                onHide: this.onHide,
                placement: this.props.placement,
                container: this.props.container,
                target: this.props.target,
                rootClose: this.props.hideWithOutsideClick },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                DtpPopoverContent,
                {
                    zIndex: this.props.zIndex,
                    innerStyle: this.props.style,
                    style: this.props.containerStyle,
                    title: this.props.title,
                    iconClass: this.props.iconClass,
                    onClose: this.props.onHide },
                this.props.children
            )
        );
    };

    return DtpPopover;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpPopover.propTypes =  false ? {
    /** Atributo obrigatório que controla se o popover deve ou não ser exibido. */
    show: PropTypes.bool.isRequired,

    /** Callback que é executado quando o popover é fechado. */
    onHide: PropTypes.func,

    /** Atributo que controla em qual posição do `target` será exibido o popover. Pode receber os seguintes valores: **left**, **right**, **bottom** ou **top**. O valor padrão é **bottom**. */
    placement: PropTypes.string.isRequired,

    /** Atributo contendo estilos CSS para a o recipiente do conteúdo do popover. */
    style: PropTypes.object,

    /** Atributo contendo estilos CSS para o popover. */
    containerStyle: PropTypes.object,

    /** Referência para o componente que representa o contexto. */
    container: PropTypes.element,

    /** Atributo que define se o popover deve ou não ser fechado quando houver um click fora dele. O valor padrão é **true**. */
    hideWithOutsideClick: PropTypes.bool,

    /** Conteúdo do popover */
    children: PropTypes.element.isRequired,

    /** Atributo opcional contendo uma classe CSS do ícone da barra de título do popover. Pode ser, por exemplo, uma classe da [Libicons](http://v221d047.nuvemdtp/public/showcase-libicons/). Se não for informado omite a exibição do ícone. */
    iconClass: PropTypes.string,

    /** Atributo opcional contendo o título do popover. Se não for informado a barra de título não será exibida. */
    title: PropTypes.string,

    /** Propriedade que permite manipular o valor de z-index do componente */
    zIndex: PropTypes.number
} : {};

DtpPopover.defaultProps = {
    onHide: function onHide() {},
    placement: 'bottom',
    hideWithOutsideClick: true
};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpPopover);

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(50);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(51);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(28);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(52);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(318);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(89);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(28);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = position;

var _extends2 = _interopRequireDefault(__webpack_require__(319));

var _offset = _interopRequireDefault(__webpack_require__(52));

var _offsetParent = _interopRequireDefault(__webpack_require__(141));

var _scrollTop = _interopRequireDefault(__webpack_require__(89));

var _scrollLeft = _interopRequireDefault(__webpack_require__(327));

var _style = _interopRequireDefault(__webpack_require__(88));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = {
    top: 0,
    left: 0
  },
      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if ((0, _style.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent.default)(node);
    offset = (0, _offset.default)(node);
    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
  } // Subtract parent offsets and node margins


  return (0, _extends2.default)({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
  });
}

module.exports = exports["default"];

/***/ }),
/* 319 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(322));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(142));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(34));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(53));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}

module.exports = exports["default"];

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(34));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(34));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DtpProgress = function (_Component) {
    _inherits(DtpProgress, _Component);

    function DtpProgress() {
        _classCallCheck(this, DtpProgress);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpProgress.prototype.render = function render() {
        return this.props.children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: this.props.styleDiv, className: this.props.classDiv },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'dtp-progress-bar', style: this.props.styleProgress }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: this.props.classText },
                this.props.children
            )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: this.props.styleDiv, className: this.props.classDiv },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'dtp-progress-bar', style: this.props.styleProgress })
        );
    };

    return DtpProgress;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (DtpProgress);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SVGSpinner__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DtpSpinner = function (_Component) {
    _inherits(DtpSpinner, _Component);

    function DtpSpinner() {
        _classCallCheck(this, DtpSpinner);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpSpinner.prototype.render = function render() {
        return this.props.show === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: this.props.divClass, title: this.props.title },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SVGSpinner__["a" /* default */], { size: this.props.size })
        ) : null;
    };

    return DtpSpinner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpSpinner.defaultProps = {
    size: 80
};

DtpSpinner.propTypes =  false ? {
    /** Atributo opcional que determina o tamnho do spinner (px). Deve receber apenas valores numéricos. */
    size: PropTypes.number,

    /** Atributo opcional que pode receber os valores <code>true</code> ou <code>false</code>. Se **NÃO** for informado um ou for informado um diferente destes, será assumido **<code>false</code>**. */
    show: PropTypes.bool.isRequired,

    /** Atributo que deverá conter o título da mensagem. */
    title: PropTypes.string,

    /** Atributo opcional que deve conter a classe CSS para a div que envolve o spinner. */
    divClass: PropTypes.string

} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpSpinner);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var SVGSpinner = function (_Component) {
    _inherits(SVGSpinner, _Component);

    function SVGSpinner() {
        _classCallCheck(this, SVGSpinner);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SVGSpinner.prototype.render = function render() {
        var size = this.props.size === undefined ? 80 : this.props.size;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'svg',
            {
                className: 'dtp-spinner',
                width: size + 'px',
                height: size + 'px',
                viewBox: '0 0 66 66',
                xmlns: 'http://www.w3.org/2000/svg' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', {
                className: 'dtp-spinner-path',
                fill: 'none',
                strokeWidth: '6',
                strokeLinecap: 'round',
                cx: '33',
                cy: '33',
                r: '30' })
        );
    };

    return SVGSpinner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SVGSpinner.propTypes =  false ? {
    size: PropTypes.number
} : {};

/* harmony default export */ __webpack_exports__["a"] = (SVGSpinner);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DtpNoContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpNoContent = function (_Component) {
    _inherits(DtpNoContent, _Component);

    function DtpNoContent() {
        _classCallCheck(this, DtpNoContent);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpNoContent.prototype.render = function render() {
        return this.props.show ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-no-content-container' },
            this.props.icon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-no-content-img-container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: this.props.icon, className: 'dtp-no-content-img', alt: this.props.alt })
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-no-content-text' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    { className: 'dtp-no-content-primary-text' },
                    this.props.primaryText ? this.props.primaryText : ''
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    { className: 'dtp-no-content-secondary-text' },
                    this.props.secondaryText ? this.props.secondaryText : ''
                )
            )
        ) : null;
    };

    return DtpNoContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);




DtpNoContent.propTypes =  false ? {

    /** Atributo usado para controlar se o componente é exibido ou não */
    show: PropTypes.bool.isRequired,

    /** Recebe uma string contendo o caminho de uma imagem (JPG, PNG, etc) */
    icon: PropTypes.string,

    /** Texto primário, com maior destaque no componente */
    primaryText: PropTypes.string,

    /** Texto secundário, exbido abaixo do primário, com menor destaque */
    secondaryText: PropTypes.string
} : {};

DtpNoContent.defaultProps = {
    show: true
};

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpDataGrid = function (_Component) {
    _inherits(DtpDataGrid, _Component);

    function DtpDataGrid() {
        _classCallCheck(this, DtpDataGrid);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpDataGrid.prototype.render = function render() {
        var _props = this.props,
            title = _props.title,
            icon = _props.icon,
            children = _props.children;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'section',
            { className: 'dtp-datagrid' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                { className: 'dtp-datagrid-header' },
                title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-datagrid-data' },
                icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dtp-datagrid-icon-box' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'dtp-datagrid-icon ' + icon })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dtp-datagrid-items-box' },
                    children
                )
            )
        );
    };

    return DtpDataGrid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);




DtpDataGrid.propTypes =  false ? {
    /** Título do DataGrid. É exibido ne header */
    title: PropTypes.string,

    /** Ícone da Libicons */
    icon: PropTypes.string,

    /** Conteúdo do DtpDataGrid */
    children: PropTypes.any
} : {};

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpDataGridColumnItem = function (_Component) {
    _inherits(DtpDataGridColumnItem, _Component);

    function DtpDataGridColumnItem() {
        _classCallCheck(this, DtpDataGridColumnItem);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpDataGridColumnItem.prototype.render = function render() {
        var _props = this.props,
            label = _props.label,
            value = _props.value;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-datagrid-columns' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-datagrid-columns-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    { className: 'dtp-datagrid-label' },
                    label
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'dtp-datagrid-value' },
                    value
                )
            )
        );
    };

    return DtpDataGridColumnItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);




DtpDataGridColumnItem.propTypes =  false ? {
    label: PropTypes.string,
    value: PropTypes.any
} : {};

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DtpDataGridRow = function (_Component) {
    _inherits(DtpDataGridRow, _Component);

    function DtpDataGridRow() {
        _classCallCheck(this, DtpDataGridRow);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpDataGridRow.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "dtp-datagrid-item" },
            this.props.children
        );
    };

    return DtpDataGridRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);



/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var DtpDataGridRowCollection = function (_Component) {
    _inherits(DtpDataGridRowCollection, _Component);

    function DtpDataGridRowCollection() {
        _classCallCheck(this, DtpDataGridRowCollection);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpDataGridRowCollection.prototype.render = function render() {
        var _this2 = this;

        var rowsGrid = void 0;

        if (this.props.collection && this.props.collection.length > 0) {
            rowsGrid = this.props.collection.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "a",
                    { onClick: function onClick() {
                            _this2.props.consultarDocumento(item.hash);
                        }, key: index },
                    item.label
                );
            });
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "dtp-datagrid-item" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "dtp-datagrid-collection-item-info" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    null,
                    this.props.title
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    this.props.subTitle
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "dtp-datagrid-collection-elements" },
                rowsGrid
            )
        );
    };

    return DtpDataGridRowCollection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);



/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DtpListLinkItem__ = __webpack_require__(144);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DtpListLink = function (_Component) {
    _inherits(DtpListLink, _Component);

    function DtpListLink() {
        _classCallCheck(this, DtpListLink);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpListLink.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dtp-list-link-conteudo' },
            this.props.titleValue && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-list-link-titulo ' + this.props.titleClass },
                this.props.titleValue
            ),
            this.props.items.map(function (item, key) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],
                    { to: item.path, key: key },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DtpListLinkItem__["a" /* default */], { keyItem: 'it_' + key,
                        itemLabel: item.itemLabel,
                        itemSubLabel: item.itemSubLabel,
                        active: 'true'
                    })
                );
            })
        );
    };

    return DtpListLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpListLink.propTypes =  false ? {
    /** Atributo opcional que deverá conter o título da lista de links. */
    titleValue: PropTypes.string,

    /** Atributo opcional que deverá conter class CSS para decorar o Título da lista de links. */
    titleClass: PropTypes.string,

    /** Atributo obrigatório, com a lista de objetos para montagem dos links. */
    items: PropTypes.array.isRequired
} : {};

DtpListLink.defaultProps = {
    titleValue: undefined,
    titleClass: undefined
};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpListLink);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ValidComponentChildren__ = __webpack_require__(340);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DtpFormGroup = function (_Component) {
    _inherits(DtpFormGroup, _Component);

    function DtpFormGroup(props) {
        _classCallCheck(this, DtpFormGroup);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            focused: false,
            placeholder: '',
            label: '',
            useFeedback: true
        };
        _this.setFocused = _this.setFocused.bind(_this);
        _this.setLabel = _this.setLabel.bind(_this);
        _this.setUseFeedback = _this.setUseFeedback.bind(_this);
        _this.getUseFeedback = _this.getUseFeedback.bind(_this);
        return _this;
    }

    DtpFormGroup.prototype.getChildContext = function getChildContext() {
        var _props = this.props,
            controlId = _props.controlId,
            validationState = _props.validationState;
        var focused = this.state.focused;

        var setFocused = this.setFocused;
        var setLabel = this.setLabel;
        var setUseFeedback = this.setUseFeedback;
        var getUseFeedback = this.getUseFeedback;
        return {
            $dtp_formGroup: {
                controlId: controlId,
                validationState: validationState,
                focused: focused,
                setFocused: setFocused,
                setLabel: setLabel,
                setUseFeedback: setUseFeedback,
                getUseFeedback: getUseFeedback
            }
        };
    };

    DtpFormGroup.prototype.setFocused = function setFocused(focused) {
        this.setState({ focused: focused });
    };

    DtpFormGroup.prototype.setLabel = function setLabel(label) {
        this.setState({ label: label });
    };

    DtpFormGroup.prototype.setPlaceholder = function setPlaceholder(placeholder) {
        this.setState({ placeholder: placeholder });
    };

    DtpFormGroup.prototype.setUseFeedback = function setUseFeedback(useFeedback) {
        this.setState({ useFeedback: useFeedback });
    };

    DtpFormGroup.prototype.getUseFeedback = function getUseFeedback() {
        return this.state.useFeedback;
    };

    DtpFormGroup.prototype.childrenHasClass = function childrenHasClass(children, _class) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_3__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
            return child.props.className === _class || child.props.children && _this2.childrenHasClass(child.props.children, _class);
        });
    };

    DtpFormGroup.prototype.isLabelAnimated = function isLabelAnimated(children) {
        return __WEBPACK_IMPORTED_MODULE_3__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
            return child.props.animate && child.props.animate === true;
        });
    };

    DtpFormGroup.prototype.isRequired = function isRequired(children) {
        return __WEBPACK_IMPORTED_MODULE_3__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
            return child.props.required && child.props.required === true;
        });
    };

    DtpFormGroup.prototype.isDisabled = function isDisabled(children) {
        return __WEBPACK_IMPORTED_MODULE_3__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
            return child.props.disabled && child.props.disabled === true;
        });
    };

    DtpFormGroup.prototype.render = function render() {
        var _props2 = this.props,
            validationState = _props2.validationState,
            className = _props2.className,
            children = _props2.children;
        var focused = this.state.focused;

        var classes = {
            'has-feedback': this.childrenHasClass(children, 'feedback'),
            'required': this.isRequired(children),
            'focused': focused,
            'disabled': this.isDisabled(children)
        };

        if (validationState) {
            classes[validationState] = true;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-form-group', className, classes), role: 'group' },
            children
        );
    };

    return DtpFormGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpFormGroup.propTypes =  false ? {
    /** Define o `id` do `<DtpFormControl>` e `htmlFor` em `<DtpFormGroup.Label>`. */
    controlId: PropTypes.string.isRequired,

    /** Define o estado do componente */
    validationState: PropTypes.oneOf(['active', 'success', 'warning', 'error', 'info', null])
} : {};

DtpFormGroup.childContextTypes = {
    $dtp_formGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

DtpFormGroup.defaultProps = {
    validationState: null
};

/* harmony default export */ __webpack_exports__["a"] = (DtpFormGroup);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
    var index = 0;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
        if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
            return child;
        }

        return func.call(context, child, index++);
    });
}

/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */
function forEach(children, func, context) {
    var index = 0;

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
        if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
            return;
        }

        func.call(context, child, index++);
    });
}

/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */
function count(children) {
    var result = 0;

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
        if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
            return;
        }

        ++result;
    });

    return result;
}

/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */
function filter(children, func, context) {
    var index = 0;
    var result = [];

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
        if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
            return;
        }

        if (func.call(context, child, index++)) {
            result.push(child);
        }
    });

    return result;
}

function find(children, func, context) {
    var index = 0;
    var result = void 0;

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
        if (result) {
            return;
        }
        if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
            return;
        }

        if (func.call(context, child, index++)) {
            result = child;
        }
    });

    return result;
}

function every(children, func, context) {
    var index = 0;
    var result = true;

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
        if (!result) {
            return;
        }
        if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
            return;
        }

        if (!func.call(context, child, index++)) {
            result = false;
        }
    });

    return result;
}

function some(children, func, context) {
    var index = 0;
    var result = false;

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
        if (result) {
            return;
        }
        if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
            return;
        }

        if (func.call(context, child, index++)) {
            result = true;
        }
    });

    return result;
}

function toArray(children) {
    var result = [];

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
        if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
            return;
        }

        result.push(child);
    });

    return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    map: map,
    forEach: forEach,
    count: count,
    find: find,
    filter: filter,
    every: every,
    some: some,
    toArray: toArray
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DtpControlLabel = function (_Component) {
    _inherits(DtpControlLabel, _Component);

    function DtpControlLabel() {
        _classCallCheck(this, DtpControlLabel);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpControlLabel.prototype.componentDidMount = function componentDidMount() {
        var formGroup = this.context.$dtp_formGroup;
        formGroup.setLabel(this.props.label);
    };

    DtpControlLabel.prototype.render = function render() {
        var formGroup = this.context.$dtp_formGroup;
        var controlId = formGroup && formGroup.controlId;

        var _props = this.props,
            _props$htmlFor = _props.htmlFor,
            htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
            srOnly = _props.srOnly,
            className = _props.className,
            animate = _props.animate,
            props = _objectWithoutProperties(_props, ['htmlFor', 'srOnly', 'className', 'animate']);

        var classes = {
            'sr-only': srOnly
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            _extends({}, props, {
                htmlFor: htmlFor,
                className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-label', {
                    'animate': animate && animate === true
                }, className, classes) }),
            this.props.label
        );
    };

    return DtpControlLabel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpControlLabel.contextTypes = {
    $dtp_formGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

DtpControlLabel.propTypes =  false ? {
    /** Define se o label deve conter animação */
    animate: PropTypes.bool.isRequired,
    /** Usa o 'controlId' do <DtpFormGroup> se não for definido explicitamente */
    htmlFor: PropTypes.string,
    /** Atributo que define se o label deve ser exibido apenas para leitores de tela */
    srOnly: PropTypes.bool,
    /** Texto do label */
    label: PropTypes.string.isRequired
} : {};

DtpControlLabel.defaultProps = {
    srOnly: false,
    animate: false
};

/* harmony default export */ __webpack_exports__["a"] = (DtpControlLabel);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpHelpBlock = function (_Component) {
    _inherits(DtpHelpBlock, _Component);

    function DtpHelpBlock() {
        _classCallCheck(this, DtpHelpBlock);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpHelpBlock.prototype.render = function render() {
        var _props = this.props,
            className = _props.className,
            props = _objectWithoutProperties(_props, ['className']);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', _extends({}, props, { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('dtp-help-block', className) }));
    };

    return DtpHelpBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (DtpHelpBlock);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_slider__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DtpSlider = function (_Component) {
    _inherits(DtpSlider, _Component);

    function DtpSlider() {
        _classCallCheck(this, DtpSlider);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpSlider.prototype.render = function render() {
        var _props = _extends({}, this.props),
            className = _props.className,
            props = _objectWithoutProperties(_props, ['className']);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_rc_slider__["a" /* default */], _extends({ className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, 'dtp-slider') }, props));
    };

    return DtpSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpSlider.propTypes =  false ? {
    /** Valor inicial do componente */
    defaultValue: PropTypes.number,

    /** Valor corrente do componente */
    value: PropTypes.number,

    /** CSS Adcional para o componente */
    className: PropTypes.string,

    /** O valor mínimo do slider */
    min: PropTypes.number,

    /** O valor máximo do slider */
    max: PropTypes.number,

    /** Função que será executada quando os eventos touchstart ou mousedown é acionado */
    onBeforeChange: PropTypes.func,

    /** Função que será executada quando o valor do slider for alterado */
    onChange: PropTypes.func,

    /** Função que será executado quando os eventos touchstart ou mousedown terminarem */
    onAfterChange: PropTypes.func
} : {};

DtpSlider.defaultProps = {
    defaultValue: 0,
    className: '',
    min: 0,
    max: 100
};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpSlider);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Range__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Handle__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__ = __webpack_require__(406);
/* unused harmony reexport Range */
/* unused harmony reexport Handle */
/* unused harmony reexport createSliderWithTooltip */





__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Range = __WEBPACK_IMPORTED_MODULE_1__Range__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Handle = __WEBPACK_IMPORTED_MODULE_2__Handle__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].createSliderWithTooltip = __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */]);


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Track__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_createSlider__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(107);





/* eslint-disable react/prop-types */







var Slider = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Slider, _React$Component);

  function Slider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Slider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.onEnd = function (force) {
      var dragging = _this.state.dragging;

      _this.removeDocumentEvents();
      if (dragging || force) {
        _this.props.onAfterChange(_this.getValue());
      }
      _this.setState({ dragging: false });
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };

    __WEBPACK_IMPORTED_MODULE_7_warning___default()(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
    __WEBPACK_IMPORTED_MODULE_7_warning___default()(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Slider, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }
      var _props = this.props,
          value = _props.value,
          onChange = _props.onChange;

      var theValue = value !== undefined ? value : prevState.value;
      var nextValue = this.trimAlignValue(theValue, this.props);
      if (nextValue !== prevState.value) {
        // eslint-disable-next-line
        this.setState({ value: nextValue });
        if (__WEBPACK_IMPORTED_MODULE_10__utils__["i" /* isValueOutOfRange */](theValue, this.props)) {
          onChange(nextValue);
        }
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      var nextState = state.value > this.props.max ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state, { value: this.props.max }) : state;
      if (isNotControlled) {
        this.setState(nextState);
      }

      var changedValue = nextState.value;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      this.setState({ dragging: true });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      if (value === prevValue) return;

      this.prevMovedHandleIndex = 0;

      this.onChange({ value: value });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      __WEBPACK_IMPORTED_MODULE_10__utils__["j" /* pauseEvent */](e);
      var oldValue = this.state.value;

      var value = this.calcValueByPos(position);
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;

      var valueMutator = __WEBPACK_IMPORTED_MODULE_10__utils__["d" /* getKeyboardValueMutator */](e, vertical, reverse);
      if (valueMutator) {
        __WEBPACK_IMPORTED_MODULE_10__utils__["j" /* pauseEvent */](e);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;

        this.onChange({ value: value });
        this.props.onAfterChange(value);
        this.onEnd();
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.props.min;
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      return this.state.value;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (v === null) {
        return null;
      }

      var mergedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, nextProps);
      var val = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* ensureValueInRange */](v, mergedProps);
      return __WEBPACK_IMPORTED_MODULE_10__utils__["b" /* ensureValuePrecision */](val, mergedProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          prefixCls = _props3.prefixCls,
          vertical = _props3.vertical,
          included = _props3.included,
          disabled = _props3.disabled,
          minimumTrackStyle = _props3.minimumTrackStyle,
          trackStyle = _props3.trackStyle,
          handleStyle = _props3.handleStyle,
          tabIndex = _props3.tabIndex,
          min = _props3.min,
          max = _props3.max,
          reverse = _props3.reverse,
          handleGenerator = _props3.handle;
      var _state = this.state,
          value = _state.value,
          dragging = _state.dragging;

      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: prefixCls + '-handle',
        prefixCls: prefixCls,
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        reverse: reverse,
        index: 0,
        tabIndex: tabIndex,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });

      var _trackStyle = trackStyle[0] || trackStyle;
      var track = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Track__["a" /* default */], {
        className: prefixCls + '-track',
        vertical: vertical,
        included: included,
        offset: 0,
        reverse: reverse,
        length: offset,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, minimumTrackStyle, _trackStyle)
      });

      return { tracks: track, handles: handle };
    }
  }]);

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Slider.propTypes = {
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  reverse: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__common_createSlider__["a" /* default */])(Slider));

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(347), __esModule: true };

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(348);
module.exports = __webpack_require__(21).Object.assign;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(29);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(350) });


/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(65);
var gOPS = __webpack_require__(98);
var pIE = __webpack_require__(68);
var toObject = __webpack_require__(69);
var IObject = __webpack_require__(148);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(46)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(37);
var toLength = __webpack_require__(149);
var toAbsoluteIndex = __webpack_require__(352);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(94);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(354);
var $Object = __webpack_require__(21).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(29);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(35), 'Object', { defineProperty: __webpack_require__(31).f });


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(356), __esModule: true };

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(151);
__webpack_require__(361);
module.exports = __webpack_require__(102).f('iterator');


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(94);
var defined = __webpack_require__(93);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(100);
var descriptor = __webpack_require__(54);
var setToStringTag = __webpack_require__(101);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(43)(IteratorPrototype, __webpack_require__(27)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31);
var anObject = __webpack_require__(44);
var getKeys = __webpack_require__(65);

module.exports = __webpack_require__(35) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(30).document;
module.exports = document && document.documentElement;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(362);
var global = __webpack_require__(30);
var hide = __webpack_require__(43);
var Iterators = __webpack_require__(55);
var TO_STRING_TAG = __webpack_require__(27)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(363);
var step = __webpack_require__(364);
var Iterators = __webpack_require__(55);
var toIObject = __webpack_require__(37);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(152)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(366), __esModule: true };

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(367);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
module.exports = __webpack_require__(21).Symbol;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(30);
var has = __webpack_require__(36);
var DESCRIPTORS = __webpack_require__(35);
var $export = __webpack_require__(29);
var redefine = __webpack_require__(153);
var META = __webpack_require__(368).KEY;
var $fails = __webpack_require__(46);
var shared = __webpack_require__(96);
var setToStringTag = __webpack_require__(101);
var uid = __webpack_require__(67);
var wks = __webpack_require__(27);
var wksExt = __webpack_require__(102);
var wksDefine = __webpack_require__(103);
var enumKeys = __webpack_require__(369);
var isArray = __webpack_require__(370);
var anObject = __webpack_require__(44);
var isObject = __webpack_require__(45);
var toIObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(91);
var createDesc = __webpack_require__(54);
var _create = __webpack_require__(100);
var gOPNExt = __webpack_require__(371);
var $GOPD = __webpack_require__(104);
var $DP = __webpack_require__(31);
var $keys = __webpack_require__(65);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(155).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(68).f = $propertyIsEnumerable;
  __webpack_require__(98).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(66)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(43)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(67)('meta');
var isObject = __webpack_require__(45);
var has = __webpack_require__(36);
var setDesc = __webpack_require__(31).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(46)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(65);
var gOPS = __webpack_require__(98);
var pIE = __webpack_require__(68);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(92);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(37);
var gOPN = __webpack_require__(155).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 372 */
/***/ (function(module, exports) {



/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(103)('asyncIterator');


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(103)('observable');


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(376), __esModule: true };

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(377);
module.exports = __webpack_require__(21).Object.setPrototypeOf;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(29);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(378).set });


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(45);
var anObject = __webpack_require__(44);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(90)(Function.call, __webpack_require__(104).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(380), __esModule: true };

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(381);
var $Object = __webpack_require__(21).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(29);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(100) });


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(383);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(386);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(384), __esModule: true };

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(385);
module.exports = __webpack_require__(21).Object.getPrototypeOf;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(69);
var $getPrototypeOf = __webpack_require__(154);

__webpack_require__(158)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(387), __esModule: true };

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(388);
var $Object = __webpack_require__(21).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(37);
var $getOwnPropertyDescriptor = __webpack_require__(104).f;

__webpack_require__(158)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(390);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(391);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(59);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);







var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  __WEBPACK_IMPORTED_MODULE_5_warning___default()(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
    return a - b;
  });
  if (dots && step) {
    for (var i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dotStyle, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, reverse ? 'top' : 'bottom', offset)) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dotStyle, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, reverse ? 'right' : 'left', offset));
    if (isActived) {
      style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, style, activeDotStyle);
    }

    var pointClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-dot', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-dot-active', isActived), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-dot-reverse', reverse), _classNames));

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: pointClassName, style: style, key: point });
  });

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: prefixCls + '-step' },
    elements
  );
};

Steps.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  activeDotStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  dotStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  min: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  upperBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  lowerBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  included: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  dots: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  step: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  marks: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  vertical: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  reverse: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Steps);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);






var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min,
      onClickLabel = _ref.onClickLabel;

  var marksKeys = Object.keys(marks);

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = typeof markPoint === 'object' && !__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, className + '-text', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, className + '-text-active', isActive), _classNames));

    var bottomStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
      marginBottom: '-50%'
    }, reverse ? 'top' : 'bottom', (point - min) / range * 100 + '%');

    var leftStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
      transform: 'translateX(-50%)',
      msTransform: 'translateX(-50%)'
    }, reverse ? 'right' : 'left', reverse ? (point - min / 4) / range * 100 + '%' : (point - min) / range * 100 + '%');

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, markPoint.style) : style;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'span',
      {
        className: markClassName,
        style: markStyle,
        key: point,
        onMouseDown: function onMouseDown(e) {
          return onClickLabel(e, point);
        },
        onTouchStart: function onTouchStart(e) {
          return onClickLabel(e, point);
        }
      },
      markLabel
    );
  });

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: className },
    elements
  );
};

Marks.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  reverse: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  marks: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  included: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  upperBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  lowerBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  onClickLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Marks);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(395), __esModule: true };

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(151);
__webpack_require__(396);
module.exports = __webpack_require__(21).Array.from;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(90);
var $export = __webpack_require__(29);
var toObject = __webpack_require__(69);
var call = __webpack_require__(397);
var isArrayIter = __webpack_require__(398);
var toLength = __webpack_require__(149);
var createProperty = __webpack_require__(399);
var getIterFn = __webpack_require__(400);

$export($export.S + $export.F * !__webpack_require__(402)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(44);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(55);
var ITERATOR = __webpack_require__(27)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(31);
var createDesc = __webpack_require__(54);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(401);
var ITERATOR = __webpack_require__(27)('iterator');
var Iterators = __webpack_require__(55);
module.exports = __webpack_require__(21).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(92);
var TAG = __webpack_require__(27)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(27)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_lifecycles_compat__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shallowequal__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Track__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_createSlider__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(107);







/* eslint-disable react/prop-types */









var _trimAlignValue = function _trimAlignValue(_ref) {
  var value = _ref.value,
      handle = _ref.handle,
      bounds = _ref.bounds,
      props = _ref.props;
  var allowCross = props.allowCross,
      pushable = props.pushable;

  var thershold = Number(pushable);
  var valInRange = __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* ensureValueInRange */](value, props);
  var valNotConflict = valInRange;
  if (!allowCross && handle != null && bounds !== undefined) {
    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
      valNotConflict = bounds[handle - 1] + thershold;
    }
    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
      valNotConflict = bounds[handle + 1] - thershold;
    }
  }
  return __WEBPACK_IMPORTED_MODULE_14__utils__["b" /* ensureValuePrecision */](valNotConflict, props);
};

var Range = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Range, _React$Component);

  function Range(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Range);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

    _this.onEnd = function (force) {
      var handle = _this.state.handle;

      _this.removeDocumentEvents();

      if (handle !== null || force) {
        _this.props.onAfterChange(_this.getValue());
      }

      _this.setState({
        handle: null
      });
    };

    var count = props.count,
        min = props.min,
        max = props.max;

    var initialValue = Array.apply(undefined, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(Array(count + 1))).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _trimAlignValue({
        value: v,
        handle: i,
        props: props
      });
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;

    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Range, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }
      if (this.props.min === prevProps.min && this.props.max === prevProps.max && __WEBPACK_IMPORTED_MODULE_11_shallowequal___default()(this.props.value, prevProps.value)) {
        return;
      }
      var _props = this.props,
          onChange = _props.onChange,
          value = _props.value;

      var currentValue = value || prevState.bounds;
      if (currentValue.some(function (v) {
        return __WEBPACK_IMPORTED_MODULE_14__utils__["i" /* isValueOutOfRange */](v, _this2.props);
      })) {
        var newValues = currentValue.map(function (v) {
          return __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* ensureValueInRange */](v, _this2.props);
        });
        onChange(newValues);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      } else {
        var controlledState = {};

        ['handle', 'recent'].forEach(function (item) {
          if (state[item] !== undefined) {
            controlledState[item] = state[item];
          }
        });

        if (Object.keys(controlledState).length) {
          this.setState(controlledState);
        }
      }

      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.state, state);
      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      var props = this.props;
      var state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);

      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });

      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue) return;

      var nextBounds = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.bounds));
      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({ bounds: nextBounds });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      __WEBPACK_IMPORTED_MODULE_14__utils__["j" /* pauseEvent */](e);
      var state = this.state;

      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;

      this.moveTo(value);
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;

      var valueMutator = __WEBPACK_IMPORTED_MODULE_14__utils__["d" /* getKeyboardValueMutator */](e, vertical, reverse);

      if (valueMutator) {
        __WEBPACK_IMPORTED_MODULE_14__utils__["j" /* pauseEvent */](e);
        var state = this.state,
            props = this.props;
        var bounds = state.bounds,
            handle = state.handle;

        var oldValue = bounds[handle === null ? state.recent : handle];
        var mutatedValue = valueMutator(oldValue, props);
        var value = _trimAlignValue({
          value: mutatedValue,
          handle: handle,
          bounds: state.bounds,
          props: props
        });
        if (value === oldValue) return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: 'getClosestBound',
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;

      var closestBound = 0;
      for (var i = 1; i < bounds.length - 1; ++i) {
        if (value >= bounds[i]) {
          closestBound = i;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }
      return closestBound;
    }
  }, {
    key: 'getBoundNeedMoving',
    value: function getBoundNeedMoving(value, closestBound) {
      var _state = this.state,
          bounds = _state.bounds,
          recent = _state.recent;

      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      var bounds = this.state.bounds;

      return bounds[bounds.length - 1];
    }

    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: 'getPoints',
    value: function getPoints() {
      var _props3 = this.props,
          marks = _props3.marks,
          step = _props3.step,
          min = _props3.min,
          max = _props3.max;

      var cache = this._getPointsCache;
      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, marks);
        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this._getPointsCache = { marks: marks, step: step, points: points };
      }
      return this._getPointsCache.points;
    }
  }, {
    key: 'moveTo',
    value: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;

      var state = this.state,
          props = this.props;

      var nextBounds = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.bounds));
      var handle = state.handle === null ? state.recent : state.handle;
      nextBounds[handle] = value;
      var nextHandle = handle;
      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }
      this.onChange({
        recent: nextHandle,
        handle: nextHandle,
        bounds: nextBounds
      });
      if (isFromKeyboardEvent) {
        // known problem: because setState is async,
        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
        // cause onBeforeChange and onAfterChange receive wrong value.
        // here use setState callback to hack，but not elegant
        this.props.onAfterChange(nextBounds);
        this.setState({}, function () {
          _this3.handlesRefs[nextHandle].focus();
        });
        this.onEnd();
      }
    }
  }, {
    key: 'pushSurroundingHandles',
    value: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var threshold = this.props.pushable;

      threshold = Number(threshold);

      var direction = 0;
      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }
      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: 'pushHandle',
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      // the handle was pushed enough to create the needed `amount` gap
      return true;
    }
  }, {
    key: 'pushHandleOnePoint',
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }
      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var threshold = this.props.pushable;

      var diffToNext = direction * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      }
      // push the handle
      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(value) {
      var _state2 = this.state,
          handle = _state2.handle,
          bounds = _state2.bounds;

      return _trimAlignValue({
        value: value,
        handle: handle,
        bounds: bounds,
        props: this.props
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state3 = this.state,
          handle = _state3.handle,
          bounds = _state3.bounds;
      var _props4 = this.props,
          prefixCls = _props4.prefixCls,
          vertical = _props4.vertical,
          included = _props4.included,
          disabled = _props4.disabled,
          min = _props4.min,
          max = _props4.max,
          reverse = _props4.reverse,
          handleGenerator = _props4.handle,
          trackStyle = _props4.trackStyle,
          handleStyle = _props4.handleStyle,
          tabIndex = _props4.tabIndex;


      var offsets = bounds.map(function (v) {
        return _this4.calcOffset(v);
      });

      var handleClassName = prefixCls + '-handle';
      var handles = bounds.map(function (v, i) {
        var _classNames;

        var _tabIndex = tabIndex[i] || 0;
        if (disabled || tabIndex[i] === null) {
          _tabIndex = null;
        }
        return handleGenerator({
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, handleClassName, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
          prefixCls: prefixCls,
          vertical: vertical,
          offset: offsets[i],
          value: v,
          dragging: handle === i,
          index: i,
          tabIndex: _tabIndex,
          min: min,
          max: max,
          reverse: reverse,
          disabled: disabled,
          style: handleStyle[i],
          ref: function ref(h) {
            return _this4.saveHandle(i, h);
          }
        });
      });

      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames2, prefixCls + '-track', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Track__["a" /* default */], {
          className: trackClassName,
          vertical: vertical,
          reverse: reverse,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          style: trackStyle[index],
          key: i
        });
      });

      return { tracks: tracks, handles: handles };
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if ('value' in props || 'min' in props || 'max' in props) {
        var value = props.value || state.bounds;
        var nextBounds = value.map(function (v, i) {
          return _trimAlignValue({
            value: v,
            handle: i,
            bounds: state.bounds,
            props: props
          });
        });
        if (nextBounds.length === state.bounds.length && nextBounds.every(function (v, i) {
          return v === state.bounds[i];
        })) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
          bounds: nextBounds
        });
      }
      return null;
    }
  }]);

  return Range;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Range.displayName = 'Range';
Range.propTypes = {
  autoFocus: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  defaultValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number),
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number),
  count: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  pushable: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  allowCross: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  reverse: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number),
  min: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number
};
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  tabIndex: []
};


Object(__WEBPACK_IMPORTED_MODULE_10_react_lifecycles_compat__["polyfill"])(Range);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13__common_createSlider__["a" /* default */])(Range));

/***/ }),
/* 405 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSliderWithTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_tooltip__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Handle__ = __webpack_require__(106);












function createSliderWithTooltip(Component) {
  var _class, _temp2;

  return _temp2 = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ComponentWrapper, _React$Component);

    function ComponentWrapper() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ComponentWrapper);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        visibles: {}
      }, _this.handleTooltipVisibleChange = function (index, visible) {
        _this.setState(function (prevState) {
          return {
            visibles: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, prevState.visibles, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, index, visible))
          };
        });
      }, _this.handleWithTooltip = function (_ref2) {
        var value = _ref2.value,
            dragging = _ref2.dragging,
            index = _ref2.index,
            disabled = _ref2.disabled,
            restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['value', 'dragging', 'index', 'disabled']);

        var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle;

        var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === undefined ? 'rc-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === undefined ? 'top' : _tipProps$placement,
            _tipProps$visible = tipProps.visible,
            visible = _tipProps$visible === undefined ? false : _tipProps$visible,
            restTooltipProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(tipProps, ['prefixCls', 'overlay', 'placement', 'visible']);

        var handleStyleWithIndex = void 0;
        if (Array.isArray(handleStyle)) {
          handleStyleWithIndex = handleStyle[index] || handleStyle[0];
        } else {
          handleStyleWithIndex = handleStyle;
        }

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_rc_tooltip__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, restTooltipProps, {
            prefixCls: prefixCls,
            overlay: overlay,
            placement: placement,
            visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
            key: index
          }),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, restProps, {
            style: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, handleStyleWithIndex),
            value: value,
            onMouseEnter: function onMouseEnter() {
              return _this.handleTooltipVisibleChange(index, true);
            },
            onMouseLeave: function onMouseLeave() {
              return _this.handleTooltipVisibleChange(index, false);
            }
          }))
        );
      }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ComponentWrapper, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.props, { handle: this.handleWithTooltip }));
      }
    }]);

    return ComponentWrapper;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    tipFormatter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    handleStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object)]),
    tipProps: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object
  }, _class.defaultProps = {
    tipFormatter: function tipFormatter(value) {
      return value;
    },

    handleStyle: [{}],
    tipProps: {}
  }, _temp2;
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(408);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(426);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(412);

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(Trigger);

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var ContainerRender = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  var _super = _createSuper(ContainerRender);

  function ContainerRender() {
    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    _classCallCheck(this, Portal);

    return _super.apply(this, arguments);
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(161);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(414);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(416);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); parent && parent !== body; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points; // 重置对应部分的翻转逻辑

      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }

      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }

      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2({}, align, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(160);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(163);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(163);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(162);
} catch (err) {
  var index = __webpack_require__(162);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(164);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DtpWizardHeaderItem__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DtpWizard__ = __webpack_require__(109);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DtpWizardHeader = function (_Component) {
  _inherits(DtpWizardHeader, _Component);

  function DtpWizardHeader() {
    _classCallCheck(this, DtpWizardHeader);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  DtpWizardHeader.prototype.render = function render() {
    var _props = this.props,
        type = _props.type,
        currentStep = _props.currentStep,
        onChangeStep = _props.onChangeStep,
        headers = _props.headers,
        navigateOnStepClick = _props.navigateOnStepClick,
        info = _props.info;

    var isSync = type && type === __WEBPACK_IMPORTED_MODULE_4__DtpWizard__["a" /* default */].TYPES.sync;

    if (info) {
      var infoItem = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ 'info-sync': isSync }, { 'info-async': !isSync }, 'pull-right') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'service' },
          info.line1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'info-service' },
          info.line2
        ),
        !isSync ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'info-service' },
          info.line3
        ) : null
      );
    }

    var headerItems = headers.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DtpWizardHeaderItem__["a" /* default */], {
        key: index,
        description: item.description,
        index: index,
        currentStep: currentStep,
        type: type,
        icon: item.icon,
        hasError: item.hasError,
        onClick: navigateOnStepClick && navigateOnStepClick === true ? onChangeStep : null });
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('dtp-wizard-header', { 'dtp-wizard-header-sync': isSync }, { 'dtp-wizard-header-async': !isSync }) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ 'sync': isSync }, { 'async': !isSync }) },
        headerItems
      ),
      info ? infoItem : null
    );
  };

  return DtpWizardHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpWizardHeader.propTypes =  false ? {
  /** Configura a descricao do step do wizard */
  headers: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string.isRequired,
    icon: PropTypes.string,
    hasError: PropTypes.bool.isRequired
  })).isRequired,

  /** Número do passo atual do wizard */
  currentStep: PropTypes.number.isRequired,

  /** Tipo do wizard */
  type: PropTypes.string.isRequired,

  /** Função que deve ser invocada ao realizar a troca do step */
  onChangeStep: PropTypes.func.isRequired,

  /** Atributo que define se é possível navegar ao clicar em uma das etapas do wizard */
  navigateOnStepClick: PropTypes.bool.isRequired,

  /** Define as informações que serão exibidas no canto direito do header */
  info: PropTypes.object
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpWizardHeader);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DtpWizard__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DtpWizardHeaderItem = function (_Component) {
  _inherits(DtpWizardHeaderItem, _Component);

  function DtpWizardHeaderItem() {
    _classCallCheck(this, DtpWizardHeaderItem);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  DtpWizardHeaderItem.prototype.render = function render() {
    var _props = this.props,
        type = _props.type,
        currentStep = _props.currentStep,
        index = _props.index,
        description = _props.description,
        icon = _props.icon,
        onClick = _props.onClick,
        hasError = _props.hasError;

    var isSync = type && type === __WEBPACK_IMPORTED_MODULE_2__DtpWizard__["a" /* default */].TYPES.sync;

    var handleClick = function handleClick(index) {
      if (onClick && onClick !== null) {
        onClick(index);
      }
    };

    var classNameLi = function classNameLi() {
      if (index < currentStep && hasError === false) {
        return 'ok';
      }
      if (index === currentStep && hasError === false) {
        return 'active';
      }
      return 'disabled';
    };

    var descr = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'step-name' },
      description
    );

    var stepContent = void 0;

    if (hasError === true) {
      stepContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ico-alert-t' });
    } else if (classNameLi() === 'ok') {
      stepContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ico-confirm' });
    } else {
      stepContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          className: 'number',
          'aria-hidden': index <= currentStep },
        index + 1
      );
    }

    var stepIdSync = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'li',
      { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(classNameLi(), { 'error': hasError === true }) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { onClick: function onClick() {
            return handleClick(index);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'step-id' },
          stepContent
        ),
        descr
      )
    );

    var stepIdAsync = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'li',
      { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(classNameLi(), { 'error': hasError === true }) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { onClick: function onClick() {
            return handleClick(index);
          } },
        descr,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: icon })
      )
    );

    return isSync ? stepIdSync : stepIdAsync;
  };

  return DtpWizardHeaderItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpWizardHeaderItem.propTypes =  false ? {
  /** Identifica a descricao que aparecera debaixo do marcador do step */
  description: PropTypes.string.isRequired,

  /** Indica o indice que sera utilizado para identificar o passo visualmente */
  index: PropTypes.number.isRequired,

  /** Indica o indice do passo que esta sendo executado no momento */
  currentStep: PropTypes.number.isRequired,

  /** Tipo do Wizard */
  type: PropTypes.string.isRequired,

  /** Classe CSS que represente um ícone */
  icon: PropTypes.string,

  /** Função que será executada ao clicar no ícone do step */
  onClick: PropTypes.func,

  /** Determina se esse step possui erro */
  hasError: PropTypes.bool.isRequired
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpWizardHeaderItem);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DtpPanel_DtpPanel__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DtpWizardButtons__ = __webpack_require__(430);





var DtpWizardBody = function DtpWizardBody(props) {
  var wizardItens = props.wizardItens,
      currentStep = props.currentStep,
      usePanel = props.usePanel,
      next = props.next,
      previous = props.previous,
      useNextPrevButtons = props.useNextPrevButtons;

  var currentStepProps = wizardItens[currentStep];

  var stepContent = currentStepProps.component;

  var wizardBtns = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DtpWizardButtons__["a" /* default */], {
    previous: previous,
    next: next });

  var bodyContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'dtp-wizard-container' },
    stepContent,
    useNextPrevButtons && wizardBtns
  );

  if (usePanel && usePanel === true) {
    bodyContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'dtp-wizard-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__DtpPanel_DtpPanel__["a" /* default */],
        {
          title: currentStepProps.description,
          footer: useNextPrevButtons === true ? wizardBtns : null },
        stepContent
      )
    );
  }

  return bodyContent;
};

DtpWizardBody.propTypes =  false ? {
  /** Identifica as configuracoes necessarias, ver ./tipoWizardStep.js para detalhes */
  wizardItens: PropTypes.arrayOf(PropTypes.shape({
    /** Elementos necessários para montar o header */
    description: PropTypes.string.isRequired,
    /** Componente a ser renderizado quando o step for chamado */
    component: PropTypes.element.isRequired,
    /** Funcao a ser executada quando o clique do botao Proximo referenciar o step a ser visto */
    executeOnNext: PropTypes.func
  })).isRequired,
  /** Indica o indice do passo que esta sendo executado no momento */
  currentStep: PropTypes.number.isRequired,
  /** Define se o conteúdo do passo será exibido dentro de um panel */
  usePanel: PropTypes.bool.isRequired
} : {};

DtpWizardBody.defaultProps = {
  usePanel: true
};

/* harmony default export */ __webpack_exports__["a"] = (DtpWizardBody);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DtpButton_DtpButtonFlat__ = __webpack_require__(63);




var DtpWizardButtons = function DtpWizardButtons(props) {
  var previousButton = null;
  if (props.previous) {
    previousButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DtpButton_DtpButtonFlat__["a" /* default */], {
      className: 'pull-left',
      title: 'Voltar',
      onClick: props.previous });
  }

  var nextButton = null;
  if (props.next) {
    nextButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DtpButton_DtpButtonFlat__["a" /* default */], {
      className: 'pull-right dtp-primary',
      title: 'Avan\xE7ar',
      onClick: props.next });
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'dtp-button-group' },
    previousButton,
    nextButton
  );
};

DtpWizardButtons.defaultProps = {
  previous: null,
  next: null
};

DtpWizardButtons.propTypes =  false ? {
  previous: PropTypes.func,
  next: PropTypes.func
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpWizardButtons);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PRIMARY */
/* unused harmony export SECONDARY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PRIMARY = 'dtp-divider-primary';
var SECONDARY = 'dtp-divider-secondary';

var DtpDivider = function (_Component) {
    _inherits(DtpDivider, _Component);

    function DtpDivider() {
        _classCallCheck(this, DtpDivider);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpDivider.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-divider', { 'dtp-divider-secondary': this.props.type === SECONDARY }) });
    };

    return DtpDivider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpDivider.propTypes =  false ? {
    /** Propriedade que define o tipo do divider */
    type: PropTypes.oneOf([PRIMARY, SECONDARY])
} : {};

DtpDivider.defaultProps = {
    type: PRIMARY
};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpDivider);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_overlays_lib_Overlay__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DtpTooltipContent = function DtpTooltipContent(props) {
    var style = props.style,
        placement = props.placement,
        title = props.title,
        zIndex = props.zIndex;


    var titleContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'dtp-tooltip-title' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            title
        )
    );

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('dtp-tooltip', 'dtp-tooltip-' + placement, 'dtp-tooltip-tooltip'),
            style: _extends({
                zIndex: zIndex
            }, style) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'dtp-tooltip-arrow' }),
        ' ',
        title ? titleContent : null
    );
};

var DtpTooltip = function (_Component) {
    _inherits(DtpTooltip, _Component);

    function DtpTooltip(props) {
        _classCallCheck(this, DtpTooltip);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            show: false
        };

        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.onHide = _this.onHide.bind(_this);
        return _this;
    }

    DtpTooltip.prototype.componentDidUpdate = function componentDidUpdate() {
        if (this.state.show !== this.props.show) {
            this.setState({
                show: this.props.show
            });
        }
    };

    DtpTooltip.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, true);
    };

    DtpTooltip.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
    };

    DtpTooltip.prototype.handleScroll = function handleScroll() {
        if (this.overlayRef.props.show) {
            this.setState({
                show: false
            });
        }
    };

    DtpTooltip.prototype.onHide = function onHide(e) {
        this.setState({
            show: false
        });
        if (this.props.onHide) {
            this.props.onHide(e);
        }
    };

    DtpTooltip.prototype.render = function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_overlays_lib_Overlay___default.a,
            {
                ref: function ref(overlay) {
                    _this2.overlayRef = overlay;
                },
                show: this.state.show,
                onHide: this.onHide,
                placement: this.props.placement,
                container: this.props.container,
                target: this.props.target,
                rootClose: this.props.hideWithOutsideClick },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DtpTooltipContent, {
                zIndex: this.props.zIndex,
                innerStyle: this.props.style,
                style: this.props.containerStyle,
                title: this.props.title,
                onClose: this.props.onHide })
        );
    };

    return DtpTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpTooltip.propTypes =  false ? {
    /** Atributo obrigatório que controla se o popover deve ou não ser exibido. */
    show: PropTypes.bool.isRequired,

    /** Callback que é executado quando o popover é fechado. */
    onHide: PropTypes.func,

    /** Atributo que controla em qual posição do `target` será exibido o popover. Pode receber os seguintes valores: **left**, **right**, **bottom** ou **top**. O valor padrão é **bottom**. */
    placement: PropTypes.string.isRequired,

    /** Atributo contendo estilos CSS para a o recipiente do conteúdo do popover. */
    style: PropTypes.object,

    /** Atributo contendo estilos CSS para o popover. */
    containerStyle: PropTypes.object,

    /** Referência para o componente que representa o contexto. */
    container: PropTypes.element,

    /** Atributo que define se o popover deve ou não ser fechado quando houver um click fora dele. O valor padrão é **true**. */
    hideWithOutsideClick: PropTypes.bool,

    /** Atributo opcional contendo o título do popover. Se não for informado a barra de título não será exibida. */
    title: PropTypes.string,

    /** Propriedade que permite manipular o valor de z-index do componente */
    zIndex: PropTypes.number
} : {};

DtpTooltip.defaultProps = {
    onHide: function onHide() {},
    placement: 'left',
    hideWithOutsideClick: true
};

/* unused harmony default export */ var _unused_webpack_default_export = (DtpTooltip);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_table__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DtpTable = function (_Component) {
    _inherits(DtpTable, _Component);

    function DtpTable() {
        var _temp, _this, _ret;

        _classCallCheck(this, DtpTable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderShowsTotal = function (start, to, total) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'span',
                null,
                'Exibindo ',
                start,
                ' de ',
                to,
                ', de um total de ',
                total,
                '.'
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    DtpTable.prototype.render = function render() {
        var options = {
            page: 1,
            sizePerPageList: [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
            }, {
                text: '15', value: 15
            }, {
                text: '20', value: 20
            }, {
                text: '25', value: 25
            }, {
                text: '50', value: 50
            }, {
                text: '100', value: 100
            }],
            noDataText: 'Nenhum há dados a serem exibidos.',
            sizePerPage: 10, // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3, // the pagination bar size.
            prePage: '<', // Previous page button text
            nextPage: '>', // Next page button text
            firstPage: '<<', // First page button text
            lastPage: '>>', // Last page button text
            paginationShowsTotal: this.renderShowsTotal, // Accept bool or function            
            alwaysShowAllBtns: true, // Always show next and previous button
            withFirstAndLast: true, // Hide the going to First and Last page button
            hideSizePerPage: true
        };

        var _props = this.props,
            legend = _props.legend,
            bordered = _props.bordered,
            pagination = _props.pagination,
            children = _props.children,
            props = _objectWithoutProperties(_props, ['legend', 'bordered', 'pagination', 'children']);

        var legendClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
            'hidden': !this.props.legend,
            'dtp-table-legend': this.props.legend,
            'bordered': this.props.bordered && this.props.legend
        });

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'dtp-table' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: legendClass },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'span',
                    { className: 'text-uppercase' },
                    legend
                )
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_table__["BootstrapTable"],
                _extends({
                    options: options,
                    pagination: this.props.pagination,
                    fetchInfo: this.props.fetchInfo,
                    remote: this.props.remote,
                    bordered: this.props.bordered }, props),
                children
            )
        );
    };

    return DtpTable;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

DtpTable.defaultProps = {
    bordered: false,
    remote: false,
    fetchInfo: {},
    pagination: false
};

/* harmony default export */ __webpack_exports__["a"] = (DtpTable);

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSAlert = __webpack_require__(166);

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

var _TableHeaderColumn = __webpack_require__(168);

var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);

var _TableHeader = __webpack_require__(443);

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _TableFooter = __webpack_require__(446);

var _TableFooter2 = _interopRequireDefault(_TableFooter);

var _TableBody = __webpack_require__(447);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _PaginationList = __webpack_require__(452);

var _PaginationList2 = _interopRequireDefault(_PaginationList);

var _ToolBar = __webpack_require__(454);

var _ToolBar2 = _interopRequireDefault(_ToolBar);

var _TableFilter = __webpack_require__(465);

var _TableFilter2 = _interopRequireDefault(_TableFilter);

var _TableDataStore = __webpack_require__(466);

var _util = __webpack_require__(24);

var _util2 = _interopRequireDefault(_util);

var _csv_export_util = __webpack_require__(467);

var _csv_export_util2 = _interopRequireDefault(_csv_export_util);

var _Filter = __webpack_require__(471);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-alert: 0 */
/* eslint max-len: 0 */


var BootstrapTable = function (_Component) {
  _inherits(BootstrapTable, _Component);

  function BootstrapTable(props) {
    _classCallCheck(this, BootstrapTable);

    var _this = _possibleConstructorReturn(this, (BootstrapTable.__proto__ || Object.getPrototypeOf(BootstrapTable)).call(this, props));

    _this.handleSort = function () {
      return _this.__handleSort__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExpandRow = function () {
      return _this.__handleExpandRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handlePaginationData = function () {
      return _this.__handlePaginationData__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleMouseLeave = function () {
      return _this.__handleMouseLeave__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleMouseEnter = function () {
      return _this.__handleMouseEnter__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOut = function () {
      return _this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOver = function () {
      return _this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleNavigateCell = function () {
      return _this.__handleNavigateCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowClick = function () {
      return _this.__handleRowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowDoubleClick = function () {
      return _this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectAllRow = function () {
      return _this.__handleSelectAllRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleShowOnlySelected = function () {
      return _this.__handleShowOnlySelected__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRow = function () {
      return _this.__handleSelectRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleEditCell = function () {
      return _this.__handleEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleAddRow = function () {
      return _this.__handleAddRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getPageByRowKey = function () {
      return _this.__getPageByRowKey__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDropRow = function () {
      return _this.__handleDropRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleFilterData = function () {
      return _this.__handleFilterData__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExportCSV = function () {
      return _this.__handleExportCSV__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSearch = function () {
      return _this.__handleSearch__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this._scrollTop = function () {
      return _this.___scrollTop__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this._scrollHeader = function () {
      return _this.___scrollHeader__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this._scrollFooter = function () {
      return _this.___scrollFooter__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.isIE = false;
    if (_util2.default.canUseDOM()) {
      _this.isIE = document.documentMode;
    }
    _this.store = new _TableDataStore.TableDataStore(_this.props.data ? _this.props.data.slice() : []);
    _this.isVerticalScroll = false;
    _this.initTable(_this.props);

    if (_this.props.selectRow && _this.props.selectRow.selected) {
      var copy = _this.props.selectRow.selected.slice();
      _this.store.setSelectedRowKey(copy);
    }
    var currPage = _Const2.default.PAGE_START_INDEX;
    if (typeof _this.props.options.page !== 'undefined') {
      currPage = _this.props.options.page;
    } else if (typeof _this.props.options.pageStartIndex !== 'undefined') {
      currPage = _this.props.options.pageStartIndex;
    }

    _this._adjustHeaderWidth = _this._adjustHeaderWidth.bind(_this);
    _this._adjustHeight = _this._adjustHeight.bind(_this);
    _this._adjustTable = _this._adjustTable.bind(_this);
    _this.toggleExpandAllChilds = _this.toggleExpandAllChilds.bind(_this);

    var expandedKeys = [];
    if (_this.props.options.expandAllChilds !== null && _this.props.options.expandAllChilds !== undefined && _this.props.options.expandAllChilds) {
      expandedKeys = _this.store.getAllRowkey();
    } else if (_this.props.options.expanding !== undefined && _this.props.options.expanding !== null) {
      expandedKeys = _this.props.options.expanding;
    }

    _this.state = {
      data: _this.getTableData(),
      currPage: currPage,
      expanding: expandedKeys,
      sizePerPage: _this.props.options.sizePerPage || _Const2.default.SIZE_PER_PAGE_LIST[0],
      selectedRowKeys: _this.store.getSelectedRowKeys(),
      reset: false,
      x: _this.props.keyBoardNav ? 0 : -1,
      y: _this.props.keyBoardNav ? 0 : -1
    };
    return _this;
  }

  _createClass(BootstrapTable, [{
    key: '___scrollFooter__REACT_HOT_LOADER__',
    value: function ___scrollFooter__REACT_HOT_LOADER__() {
      return this.___scrollFooter__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '___scrollHeader__REACT_HOT_LOADER__',
    value: function ___scrollHeader__REACT_HOT_LOADER__() {
      return this.___scrollHeader__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '___scrollTop__REACT_HOT_LOADER__',
    value: function ___scrollTop__REACT_HOT_LOADER__() {
      return this.___scrollTop__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSearch__REACT_HOT_LOADER__',
    value: function __handleSearch__REACT_HOT_LOADER__() {
      return this.__handleSearch__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      return this.__handleExportCSV__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleFilterData__REACT_HOT_LOADER__',
    value: function __handleFilterData__REACT_HOT_LOADER__() {
      return this.__handleFilterData__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleDropRow__REACT_HOT_LOADER__',
    value: function __handleDropRow__REACT_HOT_LOADER__() {
      return this.__handleDropRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getPageByRowKey__REACT_HOT_LOADER__',
    value: function __getPageByRowKey__REACT_HOT_LOADER__() {
      return this.__getPageByRowKey__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleAddRow__REACT_HOT_LOADER__',
    value: function __handleAddRow__REACT_HOT_LOADER__() {
      return this.__handleAddRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__() {
      return this.__handleEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__() {
      return this.__handleSelectRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleShowOnlySelected__REACT_HOT_LOADER__',
    value: function __handleShowOnlySelected__REACT_HOT_LOADER__() {
      return this.__handleShowOnlySelected__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectAllRow__REACT_HOT_LOADER__',
    value: function __handleSelectAllRow__REACT_HOT_LOADER__() {
      return this.__handleSelectAllRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__() {
      return this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__() {
      return this.__handleRowClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleNavigateCell__REACT_HOT_LOADER__',
    value: function __handleNavigateCell__REACT_HOT_LOADER__() {
      return this.__handleNavigateCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleMouseEnter__REACT_HOT_LOADER__',
    value: function __handleMouseEnter__REACT_HOT_LOADER__() {
      return this.__handleMouseEnter__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleMouseLeave__REACT_HOT_LOADER__',
    value: function __handleMouseLeave__REACT_HOT_LOADER__() {
      return this.__handleMouseLeave__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handlePaginationData__REACT_HOT_LOADER__',
    value: function __handlePaginationData__REACT_HOT_LOADER__() {
      return this.__handlePaginationData__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleExpandRow__REACT_HOT_LOADER__',
    value: function __handleExpandRow__REACT_HOT_LOADER__() {
      return this.__handleExpandRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSort__REACT_HOT_LOADER__',
    value: function __handleSort__REACT_HOT_LOADER__() {
      return this.__handleSort__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'initTable',
    value: function initTable(props) {
      var _this2 = this;

      // If columns changed, clean removed columns that had filters
      if (props.children !== this.props.children && this.filter) {
        var nextDataFields = _react2.default.Children.map(props.children, function (column) {
          return column.props.dataField;
        });
        _react2.default.Children.forEach(this.props.children, function (column) {
          var _column$props = column.props,
              dataField = _column$props.dataField,
              filter = _column$props.filter;

          if (filter && !nextDataFields.includes(dataField)) {
            // Clear filter
            _this2.filter.handleFilter(dataField, '', filter.type, filter);
          }
        });
      }

      var keyField = props.keyField;


      var isKeyFieldDefined = typeof keyField === 'string' && keyField.length;
      _react2.default.Children.forEach(props.children, function (column) {
        if (column === null || column === undefined) {
          // Skip null and undefined value
          return;
        }
        if (column.props.isKey) {
          if (keyField) {
            throw new Error('Error. Multiple key column detected in TableHeaderColumn.');
          }
          keyField = column.props.dataField;
        }
        if (column.props.filter) {
          // a column contains a filter
          if (!_this2.filter) {
            // first time create the filter on the BootstrapTable
            _this2.filter = new _Filter.Filter();
          }
          // pass the filter to column with filter
          column.props.filter.emitter = _this2.filter;
        }
      });

      // if a column filter was created, add 'onFilterChange' listener
      if (this.filter) {
        this.filter.removeAllListeners('onFilterChange');
        this.filter.on('onFilterChange', function (currentFilter) {
          _this2.handleFilterData(currentFilter);
        });
      }

      this.colInfos = this.getColumnsDescription(props).reduce(function (prev, curr) {
        prev[curr.name] = curr;
        return prev;
      }, {});

      if (!isKeyFieldDefined && !keyField) {
        throw new Error('Error. No any key column defined in TableHeaderColumn.\n            Use \'isKey={true}\' to specify a unique column after version 0.5.4.');
      }

      this.store.setProps({
        isPagination: props.pagination,
        keyField: keyField,
        colInfos: this.colInfos,
        multiColumnSearch: props.multiColumnSearch,
        strictSearch: props.strictSearch,
        multiColumnSort: props.multiColumnSort,
        remote: this.props.remote
      });
    }
  }, {
    key: 'getTableData',
    value: function getTableData() {
      var result = [];
      var _props = this.props,
          options = _props.options,
          pagination = _props.pagination;

      var sortName = options.defaultSortName || options.sortName;
      var sortOrder = options.defaultSortOrder || options.sortOrder;
      var searchText = options.defaultSearch;

      if (sortName && sortOrder) {
        this.store.setSortInfo(sortOrder, sortName);
        if (!this.allowRemote(_Const2.default.REMOTE_SORT)) {
          this.store.sort();
        }
      }

      if (searchText) {
        this.store.search(searchText);
      }

      if (pagination) {
        var page = void 0;
        var sizePerPage = void 0;
        if (this.store.isChangedPage()) {
          sizePerPage = this.state.sizePerPage;
          page = this.state.currPage;
        } else {
          sizePerPage = options.sizePerPage || _Const2.default.SIZE_PER_PAGE_LIST[0];
          page = options.page || 1;
        }
        result = this.store.page(page, sizePerPage).get();
      } else {
        result = this.store.get();
      }
      return result;
    }
  }, {
    key: 'getColumnsDescription',
    value: function getColumnsDescription(_ref) {
      var _this3 = this;

      var children = _ref.children;

      var rowCount = 0;
      _react2.default.Children.forEach(children, function (column) {
        if (column === null || column === undefined) {
          // Skip null and undefined value
          return;
        }

        if (Number(column.props.row) > rowCount) {
          rowCount = Number(column.props.row);
        }
      });
      return _react2.default.Children.map(children, function (column, i) {
        if (column === null || column === undefined) {
          // Return null for empty objects
          return null;
        }

        var rowIndex = column.props.row ? Number(column.props.row) : 0;
        var rowSpan = column.props.rowSpan ? Number(column.props.rowSpan) : 1;
        if (rowSpan + rowIndex === rowCount + 1) {
          var columnDescription = _this3.getColumnDescription(column);

          columnDescription.index = i;
          return columnDescription;
        }
      });
    }
  }, {
    key: 'getColumnDescription',
    value: function getColumnDescription(column) {
      var columnDescription = {
        name: column.props.dataField,
        align: column.props.dataAlign,
        sort: column.props.dataSort,
        format: column.props.dataFormat,
        formatExtraData: column.props.formatExtraData,
        filterFormatted: column.props.filterFormatted,
        filterValue: column.props.filterValue,
        editable: column.props.editable,
        customEditor: column.props.customEditor,
        hidden: column.props.hidden,
        hiddenOnInsert: column.props.hiddenOnInsert,
        searchable: column.props.searchable,
        className: column.props.columnClassName,
        editClassName: column.props.editColumnClassName,
        invalidEditColumnClassName: column.props.invalidEditColumnClassName,
        columnTitle: column.props.columnTitle,
        width: column.props.width,
        text: column.props.headerText || column.props.children,
        sortFunc: column.props.sortFunc,
        sortFuncExtraData: column.props.sortFuncExtraData,
        export: column.props.export,
        expandable: column.props.expandable,
        attrs: column.props.tdAttr,
        editAttrs: column.props.editTdAttr,
        style: column.props.tdStyle
      };

      if (column.type.name !== _TableHeaderColumn2.default.name && _react2.default.isValidElement(column.props.children)) {
        columnDescription = _extends({}, columnDescription, this.getColumnDescription(_react2.default.Children.only(column.props.children)));
      }

      return columnDescription;
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this4 = this;

      var pageStartIndex = this.props.options.pageStartIndex;

      this.store.clean();
      this.body.setState({ currEditCell: null });
      this.setState(function () {
        return {
          data: _this4.getTableData(),
          currPage: _util2.default.getFirstPage(pageStartIndex),
          expanding: [],
          sizePerPage: _Const2.default.SIZE_PER_PAGE_LIST[0],
          selectedRowKeys: [],
          reset: true
        };
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.initTable(nextProps);
      var options = nextProps.options,
          selectRow = nextProps.selectRow;
      var replace = nextProps.replace;

      replace = replace || this.props.replace;

      if (!nextProps.data) {
        return;
      }
      this.store.setData(nextProps.data.slice());

      if (!replace) {
        // from #481
        var page = this.state.currPage;
        if (this.props.options.page !== options.page) {
          page = options.page;
        }
        // from #481
        var sizePerPage = this.state.sizePerPage;
        if (this.props.options.sizePerPage !== options.sizePerPage) {
          sizePerPage = options.sizePerPage;
        }

        if (this.isRemoteDataSource()) {
          var newState = { sizePerPage: sizePerPage, reset: false, currPage: page };
          var data = nextProps.data.slice();
          if (nextProps.pagination && !this.allowRemote(_Const2.default.REMOTE_PAGE)) {
            data = this.store.page(page, sizePerPage).get();
          }

          if (this.store.isOnFilter) {
            if (this.store.searchText) this.handleSearch(this.store.searchText);
            if (this.store.filterObj) this.handleFilterData(this.store.filterObj);
            newState.currPage = _util2.default.getFirstPage(nextProps.options.pageStartIndex);
          } else {
            if (!this.allowRemote(_Const2.default.REMOTE_SORT)) {
              data = this.store.sort().get();
            } else {
              var currentOptions = this.props.options;

              var sortName = options.sortName;
              var sortOrder = options.sortOrder;
              if (currentOptions.sortName !== sortName || currentOptions.sortOrder !== sortOrder) {
                this.store.setSortInfo(sortOrder, options.sortName);
              }
            }
            newState.data = data;
          }
          this.setState(function () {
            return newState;
          });
        } else {
          // #125
          // remove !options.page for #709
          if (page > Math.ceil(nextProps.data.length / sizePerPage)) {
            page = 1;
          }
          var sortList = this.store.getSortInfo();
          var sortField = options.sortName;
          var _sortOrder = options.sortOrder;
          if (sortField && _sortOrder) {
            this.store.setSortInfo(_sortOrder, sortField);
            this.store.sort();
          } else if (sortList.length > 0) {
            this.store.sort();
          }
          var _data = this.store.page(page, sizePerPage).get();
          this.setState(function () {
            return {
              data: _data,
              currPage: page,
              sizePerPage: sizePerPage,
              reset: false
            };
          });

          if (this.store.isSearching && options.afterSearch) {
            options.afterSearch(this.store.searchText, this.store.getDataIgnoringPagination());
          }

          if (this.store.isFiltering && options.afterColumnFilter) {
            options.afterColumnFilter(this.store.filterObj, this.store.getDataIgnoringPagination());
          }
        }

        // If setting the expanded rows is being handled externally
        // then overwrite the current expanded rows.
        if (this.props.options.expanding !== options.expanding) {
          this.setState(function () {
            return {
              expanding: options.expanding || []
            };
          });
        }

        if (selectRow && selectRow.selected) {
          // set default select rows to store.
          var copy = selectRow.selected.slice();
          this.store.setSelectedRowKey(copy);
          this.setState(function () {
            return {
              selectedRowKeys: copy,
              reset: false
            };
          });
        }
      } else {
        this.reset();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._adjustTable();
      window.addEventListener('resize', this._adjustTable);
      this.body.container.addEventListener('scroll', this._scrollHeader);
      if (this.props.footer) {
        this.body.container.addEventListener('scroll', this._scrollFooter);
      }
      if (this.props.scrollTop) {
        this._scrollTop();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._adjustTable);
      if (this.body && this.body.container) {
        this.body.container.removeEventListener('scroll', this._scrollHeader);
        if (this.props.footer) {
          this.body.container.removeEventListener('scroll', this._scrollFooter);
        }
      }
      if (this.filter) {
        this.filter.removeAllListeners('onFilterChange');
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._adjustTable();
      if (this.props.options.afterTableComplete) {
        this.props.options.afterTableComplete();
      }
    }

    /**
     * Returns true if in the current configuration,
     * the datagrid should load its data remotely.
     *
     * @param  {Object}  [props] Optional. If not given, this.props will be used
     * @return {Boolean}
     */

  }, {
    key: 'isRemoteDataSource',
    value: function isRemoteDataSource(props) {
      var _ref2 = props || this.props,
          remote = _ref2.remote;

      return remote === true || _util2.default.isFunction(remote);
    }

    /**
     * Returns true if this action can be handled remote store
     * From #990, Sometimes, we need some actions as remote, some actions are handled by default
     * so function will tell you the target action is can be handled as remote or not.
     * @param  {String}  [action] Required.
     * @param  {Object}  [props] Optional. If not given, this.props will be used
     * @return {Boolean}
     */

  }, {
    key: 'allowRemote',
    value: function allowRemote(action, props) {
      var _ref3 = props || this.props,
          remote = _ref3.remote;

      if (typeof remote === 'function') {
        var remoteObj = remote(_Const2.default.REMOTE);
        return remoteObj[action];
      } else {
        return remote;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var style = {
        height: this.props.height,
        maxHeight: this.props.maxHeight
      };

      var columns = this.getColumnsDescription(this.props);
      var sortList = this.store.getSortInfo();
      var pagination = this.renderPagination();
      var toolBar = this.renderToolBar();
      var tableFilter = this.renderTableFilter(columns);
      var isSelectAll = this.isSelectAll();
      var expandColumnOptions = this.props.expandColumnOptions;
      if (typeof expandColumnOptions.expandColumnBeforeSelectColumn === 'undefined') {
        expandColumnOptions.expandColumnBeforeSelectColumn = true;
      }
      var colGroups = _util2.default.renderColGroup(columns, this.props.selectRow, expandColumnOptions, this.props.version);
      var tableFooter = this.renderTableFooter(this.props.footerData, this.state.data, columns, colGroups);
      var sortIndicator = this.props.options.sortIndicator;
      if (typeof this.props.options.sortIndicator === 'undefined') sortIndicator = true;

      var _props$options$pagina = this.props.options.paginationPosition,
          paginationPosition = _props$options$pagina === undefined ? _Const2.default.PAGINATION_POS_BOTTOM : _props$options$pagina;

      var showPaginationOnTop = paginationPosition !== _Const2.default.PAGINATION_POS_BOTTOM;
      var showPaginationOnBottom = paginationPosition !== _Const2.default.PAGINATION_POS_TOP;
      var selectRow = _extends({}, this.props.selectRow);
      if (this.props.cellEdit && this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_NONE) {
        selectRow.clickToSelect = false;
      }

      var _props$options$toolba = this.props.options.toolbarPosition,
          toolbarPosition = _props$options$toolba === undefined ? _Const2.default.TOOLBAR_POS_TOP : _props$options$toolba;

      var showToolbarOnTop = toolbarPosition !== _Const2.default.TOOLBAR_POS_BOTTOM;
      var showToolbarOnBottom = toolbarPosition !== _Const2.default.TOOLBAR_POS_TOP;
      var _props$options$hideRo = this.props.options.hideRowOnExpand,
          hideRowOnExpand = _props$options$hideRo === undefined ? false : _props$options$hideRo;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('react-bs-table-container', this.props.className, this.props.containerClass),
          style: this.props.containerStyle },
        showToolbarOnTop ? toolBar : null,
        showPaginationOnTop ? pagination : null,
        _react2.default.createElement(
          'div',
          { ref: function ref(node) {
              return _this5.table = node;
            },
            className: (0, _classnames2.default)('react-bs-table', { 'react-bs-table-bordered': this.props.bordered }, this.props.tableContainerClass),
            style: _extends({}, style, this.props.tableStyle),
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave },
          _react2.default.createElement(
            _TableHeader2.default,
            {
              ref: function ref(node) {
                return _this5.header = node;
              },
              version: this.props.version,
              colGroups: colGroups,
              headerContainerClass: this.props.headerContainerClass,
              tableHeaderClass: this.props.tableHeaderClass,
              style: this.props.headerStyle,
              rowSelectType: this.props.selectRow.mode,
              customComponent: this.props.selectRow.customComponent,
              hideSelectColumn: this.props.selectRow.hideSelectColumn,
              sortList: sortList,
              sortIndicator: sortIndicator,
              onSort: this.handleSort,
              onSelectAllRow: this.handleSelectAllRow,
              bordered: this.props.bordered,
              condensed: this.props.condensed,
              isFiltered: this.filter ? true : false,
              isSelectAll: isSelectAll,
              reset: this.state.reset,
              expandColumnVisible: expandColumnOptions.expandColumnVisible,
              expandColumnComponent: expandColumnOptions.expandColumnComponent,
              expandedColumnHeaderComponent: expandColumnOptions.expandedColumnHeaderComponent,
              noAnyExpand: this.state.expanding.length === 0,
              expandAll: this.props.options.expandAll,
              toggleExpandAllChilds: this.toggleExpandAllChilds,
              expandColumnBeforeSelectColumn: expandColumnOptions.expandColumnBeforeSelectColumn },
            this.props.children
          ),
          _react2.default.createElement(_TableBody2.default, {
            ref: function ref(node) {
              return _this5.body = node;
            },
            bodyContainerClass: this.props.bodyContainerClass,
            tableBodyClass: this.props.tableBodyClass,
            style: _extends({}, style, this.props.bodyStyle),
            data: this.state.data,
            version: this.props.version,
            expandComponent: this.props.expandComponent,
            expandableRow: this.props.expandableRow,
            expandRowBgColor: this.props.options.expandRowBgColor,
            expandBy: this.props.options.expandBy || _Const2.default.EXPAND_BY_ROW,
            expandBodyClass: this.props.options.expandBodyClass,
            expandParentClass: this.props.options.expandParentClass,
            columns: columns,
            trClassName: this.props.trClassName,
            trStyle: this.props.trStyle,
            striped: this.props.striped,
            bordered: this.props.bordered,
            hover: this.props.hover,
            keyField: this.store.getKeyField(),
            condensed: this.props.condensed,
            selectRow: selectRow,
            expandColumnOptions: this.props.expandColumnOptions,
            cellEdit: this.props.cellEdit,
            selectedRowKeys: this.state.selectedRowKeys,
            onRowClick: this.handleRowClick,
            onRowDoubleClick: this.handleRowDoubleClick,
            onRowMouseOver: this.handleRowMouseOver,
            onRowMouseOut: this.handleRowMouseOut,
            onSelectRow: this.handleSelectRow,
            noDataText: this.props.options.noDataText,
            withoutNoDataText: this.props.options.withoutNoDataText,
            expanding: this.state.expanding,
            onExpand: this.handleExpandRow,
            onlyOneExpanding: this.props.options.onlyOneExpanding,
            beforeShowError: this.props.options.beforeShowError,
            keyBoardNav: this.props.keyBoardNav,
            onNavigateCell: this.handleNavigateCell,
            x: this.state.x,
            y: this.state.y,
            withoutTabIndex: this.props.withoutTabIndex,
            hideRowOnExpand: hideRowOnExpand,
            onEditCell: this.handleEditCell }),
          tableFooter
        ),
        tableFilter,
        showPaginationOnBottom ? pagination : null,
        showToolbarOnBottom ? toolBar : null,
        this.props.renderAlert ? _react2.default.createElement(_reactSAlert2.default, { stack: { limit: 3 } }) : null
      );
    }
  }, {
    key: 'isSelectAll',
    value: function isSelectAll() {
      if (this.store.isEmpty()) return false;
      var _props$selectRow = this.props.selectRow,
          unselectable = _props$selectRow.unselectable,
          onlyUnselectVisible = _props$selectRow.onlyUnselectVisible;

      var keyField = this.store.getKeyField();
      var allRowKeys = onlyUnselectVisible ? this.store.get().map(function (r) {
        return r[keyField];
      }) : this.store.getAllRowkey();
      var defaultSelectRowKeys = this.store.getSelectedRowKeys();

      if (onlyUnselectVisible) {
        defaultSelectRowKeys = defaultSelectRowKeys.filter(function (x) {
          return x !== allRowKeys;
        });
      }

      if (defaultSelectRowKeys.length === 0) return false;
      var match = 0;
      var noFound = 0;
      var unSelectableCnt = 0;
      defaultSelectRowKeys.forEach(function (selected) {
        if (allRowKeys.indexOf(selected) !== -1) match++;else noFound++;
        if (unselectable && unselectable.indexOf(selected) !== -1) unSelectableCnt++;
      });

      if (noFound === defaultSelectRowKeys.length) return false;
      if (match === allRowKeys.length) {
        return true;
      } else {
        if (unselectable && match <= unSelectableCnt && unSelectableCnt === unselectable.length) return false;else return 'indeterminate';
      }
      // return (match === allRowKeys.length) ? true : 'indeterminate';
    }
  }, {
    key: 'cleanSelected',
    value: function cleanSelected() {
      this.store.setSelectedRowKey([]);
      this.setState(function () {
        return {
          selectedRowKeys: [],
          reset: false
        };
      });
    }
  }, {
    key: 'cleanSort',
    value: function cleanSort() {
      this.store.cleanSortInfo();
      this.setState(function () {
        return {
          reset: false
        };
      });
    }
  }, {
    key: '__handleSort__REACT_HOT_LOADER__',
    value: function __handleSort__REACT_HOT_LOADER__(order, sortField) {
      var _props2 = this.props,
          sort = _props2.autoCollapse.sort,
          options = _props2.options;

      if (options.onSortChange) {
        options.onSortChange(sortField, order, this.props);
      }
      this.store.setSortInfo(order, sortField);
      if (this.allowRemote(_Const2.default.REMOTE_SORT)) {
        if (sort) {
          this.setState(function () {
            return {
              expanding: []
            };
          });
        }
        return;
      }

      var result = this.store.sort().get();
      this.setState(function () {
        var newState = {
          data: result,
          reset: false
        };
        if (sort) newState.expanding = [];
        return newState;
      });
    }
  }, {
    key: '__handleExpandRow__REACT_HOT_LOADER__',
    value: function __handleExpandRow__REACT_HOT_LOADER__(expanding, rowKey, isRowExpanding, event) {
      var _this6 = this;

      var onExpand = this.props.options.onExpand;

      if (onExpand) {
        onExpand(rowKey, !isRowExpanding, event);
      }
      this.setState(function () {
        return { expanding: expanding, reset: false };
      }, function () {
        _this6._adjustHeaderWidth();
      });
    }
  }, {
    key: 'toggleExpandAllChilds',
    value: function toggleExpandAllChilds() {
      var _this7 = this;

      var expanding = this.state.expanding;

      if (expanding.length > 0) {
        this.setState(function () {
          return {
            expanding: [],
            reset: false
          };
        });
      } else {
        this.setState(function () {
          return {
            expanding: _this7.store.getAllRowkey(),
            reset: false
          };
        });
      }
    }
  }, {
    key: '__handlePaginationData__REACT_HOT_LOADER__',
    value: function __handlePaginationData__REACT_HOT_LOADER__(page, sizePerPage) {
      var _props$options = this.props.options,
          onPageChange = _props$options.onPageChange,
          pageStartIndex = _props$options.pageStartIndex;

      var emptyTable = this.store.isEmpty();
      if (onPageChange) {
        onPageChange(page, sizePerPage);
      }

      var state = {
        sizePerPage: sizePerPage,
        reset: false
      };
      if (!emptyTable) state.currPage = page;
      this.setState(function () {
        return state;
      });

      if (this.allowRemote(_Const2.default.REMOTE_PAGE) || emptyTable) {
        return;
      }

      var result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex, page), sizePerPage).get();
      this.setState(function () {
        return { data: result, reset: false };
      });
    }
  }, {
    key: '__handleMouseLeave__REACT_HOT_LOADER__',
    value: function __handleMouseLeave__REACT_HOT_LOADER__() {
      if (this.props.options.onMouseLeave) {
        this.props.options.onMouseLeave();
      }
    }
  }, {
    key: '__handleMouseEnter__REACT_HOT_LOADER__',
    value: function __handleMouseEnter__REACT_HOT_LOADER__() {
      if (this.props.options.onMouseEnter) {
        this.props.options.onMouseEnter();
      }
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__(row, event) {
      if (this.props.options.onRowMouseOut) {
        this.props.options.onRowMouseOut(row, event);
      }
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__(row, event) {
      if (this.props.options.onRowMouseOver) {
        this.props.options.onRowMouseOver(row, event);
      }
    }
  }, {
    key: '__handleNavigateCell__REACT_HOT_LOADER__',
    value: function __handleNavigateCell__REACT_HOT_LOADER__(_ref4) {
      var offSetX = _ref4.x,
          offSetY = _ref4.y,
          lastEditCell = _ref4.lastEditCell;
      var pagination = this.props.pagination;
      var _state = this.state,
          x = _state.x,
          y = _state.y,
          currPage = _state.currPage;

      x += offSetX;
      y += offSetY;

      var columns = this.store.getColInfos();
      var visibleRowSize = this.state.data.length;
      var visibleColumnSize = Object.keys(columns).filter(function (k) {
        return !columns[k].hidden;
      }).length;

      if (y >= visibleRowSize) {
        currPage++;
        var lastPage = pagination ? this.pagination.getLastPage() : -1;
        if (currPage <= lastPage) {
          this.handlePaginationData(currPage, this.state.sizePerPage);
        } else {
          return;
        }
        y = 0;
      } else if (y < 0) {
        currPage--;
        if (currPage > 0) {
          this.handlePaginationData(currPage, this.state.sizePerPage);
        } else {
          return;
        }
        y = visibleRowSize - 1;
      } else if (x >= visibleColumnSize) {
        if (y + 1 === visibleRowSize) {
          currPage++;
          var _lastPage = pagination ? this.pagination.getLastPage() : -1;
          if (currPage <= _lastPage) {
            this.handlePaginationData(currPage, this.state.sizePerPage);
          } else {
            return;
          }
          y = 0;
        } else {
          y++;
        }
        x = lastEditCell ? 1 : 0;
      } else if (x < 0) {
        x = visibleColumnSize - 1;
        if (y === 0) {
          currPage--;
          if (currPage > 0) {
            this.handlePaginationData(currPage, this.state.sizePerPage);
          } else {
            return;
          }
          y = this.state.sizePerPage - 1;
        } else {
          y--;
        }
      }
      this.setState(function () {
        return {
          x: x, y: y, currPage: currPage, reset: false
        };
      });
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__(row, rowIndex, columnIndex, event) {
      var _props3 = this.props,
          options = _props3.options,
          keyBoardNav = _props3.keyBoardNav;

      if (options.onRowClick) {
        options.onRowClick(row, columnIndex, rowIndex, event);
      }
      if (keyBoardNav) {
        var _ref5 = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav : {},
            clickToNav = _ref5.clickToNav;

        clickToNav = clickToNav === false ? clickToNav : true;
        if (clickToNav) {
          this.setState(function () {
            return {
              x: columnIndex,
              y: rowIndex,
              reset: false
            };
          });
        }
      }
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__(row, event) {
      if (this.props.options.onRowDoubleClick) {
        this.props.options.onRowDoubleClick(row, event);
      }
    }
  }, {
    key: '__handleSelectAllRow__REACT_HOT_LOADER__',
    value: function __handleSelectAllRow__REACT_HOT_LOADER__(e) {
      var isSelected = e.currentTarget.checked;
      var keyField = this.store.getKeyField();
      var _props$selectRow2 = this.props.selectRow,
          onSelectAll = _props$selectRow2.onSelectAll,
          unselectable = _props$selectRow2.unselectable,
          selected = _props$selectRow2.selected,
          onlyUnselectVisible = _props$selectRow2.onlyUnselectVisible;

      var selectedRowKeys = onlyUnselectVisible ? this.state.selectedRowKeys : [];
      var result = true;
      var rows = this.store.get();

      // onlyUnselectVisible default is false, #1276
      if (!isSelected && !onlyUnselectVisible) {
        rows = this.store.getRowByKey(this.state.selectedRowKeys);
      }

      if (unselectable && unselectable.length > 0) {
        if (isSelected) {
          rows = rows.filter(function (r) {
            return unselectable.indexOf(r[keyField]) === -1 || selected && selected.indexOf(r[keyField]) !== -1;
          });
        } else {
          rows = rows.filter(function (r) {
            return unselectable.indexOf(r[keyField]) === -1;
          });
        }
      }

      if (onSelectAll) {
        result = this.props.selectRow.onSelectAll(isSelected, rows);
      }

      if (typeof result == 'undefined' || result !== false) {
        if (isSelected) {
          if (Array.isArray(result)) {
            selectedRowKeys = result;
          } else {
            var currentRowKeys = rows.map(function (r) {
              return r[keyField];
            });
            // onlyUnselectVisible default is false, #1276
            if (onlyUnselectVisible) {
              selectedRowKeys = selectedRowKeys.concat(currentRowKeys);
            } else {
              selectedRowKeys = currentRowKeys;
            }
          }
        } else {
          if (unselectable && selected) {
            selectedRowKeys = selected.filter(function (r) {
              return unselectable.indexOf(r) > -1;
            });
          } else if (onlyUnselectVisible) {
            var _currentRowKeys = rows.map(function (r) {
              return r[keyField];
            });
            selectedRowKeys = selectedRowKeys.filter(function (k) {
              return _currentRowKeys.indexOf(k) === -1;
            });
          }
        }

        this.store.setSelectedRowKey(selectedRowKeys);
        this.setState(function () {
          return { selectedRowKeys: selectedRowKeys, reset: false };
        });
      }
    }
  }, {
    key: '__handleShowOnlySelected__REACT_HOT_LOADER__',
    value: function __handleShowOnlySelected__REACT_HOT_LOADER__() {
      this.store.ignoreNonSelected();
      var pageStartIndex = this.props.options.pageStartIndex;

      var result = void 0;
      if (this.props.pagination) {
        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), this.state.sizePerPage).get();
      } else {
        result = this.store.get();
      }
      this.setState(function () {
        return {
          data: result,
          reset: false,
          currPage: _util2.default.getFirstPage(pageStartIndex)
        };
      });
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__(row, isSelected, e, rowIndex) {
      var result = true;
      var currSelected = this.store.getSelectedRowKeys();
      var rowKey = row[this.store.getKeyField()];
      var selectRow = this.props.selectRow;

      if (selectRow.onSelect) {
        result = selectRow.onSelect(row, isSelected, e, rowIndex);
      }

      if (typeof result === 'undefined' || result !== false) {
        if (selectRow.mode === _Const2.default.ROW_SELECT_SINGLE) {
          currSelected = isSelected ? [rowKey] : [];
        } else {
          if (isSelected) {
            currSelected.push(rowKey);
          } else {
            currSelected = currSelected.filter(function (key) {
              return rowKey !== key;
            });
          }
        }

        this.store.setSelectedRowKey(currSelected);
        this.setState(function () {
          return {
            selectedRowKeys: currSelected,
            reset: false
          };
        });
      }
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__(newVal, rowIndex, colIndex) {
      var _this8 = this;

      var beforeSaveCell = this.props.cellEdit.beforeSaveCell;

      var columns = this.getColumnsDescription(this.props);
      var fieldName = columns[colIndex].name;

      var invalid = function invalid() {
        _this8.setState(function () {
          return {
            data: _this8.store.get(),
            reset: false
          };
        });
        return;
      };

      if (beforeSaveCell) {
        var beforeSaveCellCB = function beforeSaveCellCB(result) {
          _this8.body.cancelEditCell();
          if (result || result === undefined) {
            _this8.editCell(newVal, rowIndex, colIndex);
          } else {
            invalid();
          }
        };
        var props = { rowIndex: rowIndex, colIndex: colIndex };
        var isValid = beforeSaveCell(this.state.data[rowIndex], fieldName, newVal, beforeSaveCellCB, props);
        if (isValid === false && typeof isValid !== 'undefined') {
          return invalid();
        } else if (isValid === _Const2.default.AWAIT_BEFORE_CELL_EDIT) {
          /* eslint consistent-return: 0 */
          return isValid;
        }
      }
      this.editCell(newVal, rowIndex, colIndex);
    }
  }, {
    key: 'editCell',
    value: function editCell(newVal, rowIndex, colIndex) {
      var onCellEdit = this.props.options.onCellEdit;
      var afterSaveCell = this.props.cellEdit.afterSaveCell;

      var columns = this.getColumnsDescription(this.props);
      var fieldName = columns[colIndex].name;
      var props = { rowIndex: rowIndex, colIndex: colIndex };
      if (onCellEdit) {
        newVal = onCellEdit(this.state.data[rowIndex], fieldName, newVal);
      }

      if (this.allowRemote(_Const2.default.REMOTE_CELL_EDIT)) {
        if (afterSaveCell) {
          afterSaveCell(this.state.data[rowIndex], fieldName, newVal, props);
        }
        return;
      }

      var result = this.store.edit(newVal, rowIndex, fieldName).get();
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });

      if (afterSaveCell) {
        afterSaveCell(this.state.data[rowIndex], fieldName, newVal, props);
      }
    }
  }, {
    key: 'handleAddRowAtBegin',
    value: function handleAddRowAtBegin(newObj) {
      try {
        this.store.addAtBegin(newObj);
      } catch (e) {
        return e;
      }
      this._handleAfterAddingRow(newObj, true);
    }
  }, {
    key: '__handleAddRow__REACT_HOT_LOADER__',
    value: function __handleAddRow__REACT_HOT_LOADER__(newObj) {
      var _this9 = this;

      var isAsync = false;
      var onAddRow = this.props.options.onAddRow;


      var afterHandleAddRow = function afterHandleAddRow(errMsg) {
        if (isAsync) {
          _this9.toolbar.afterHandleSaveBtnClick(errMsg);
        } else {
          return errMsg;
        }
      };

      var afterAddRowCB = function afterAddRowCB(errMsg) {
        if (typeof errMsg !== 'undefined' && errMsg !== '') return afterHandleAddRow(errMsg);
        if (_this9.allowRemote(_Const2.default.REMOTE_INSERT_ROW)) {
          if (_this9.props.options.afterInsertRow) {
            _this9.props.options.afterInsertRow(newObj);
          }
          return afterHandleAddRow();
        }

        try {
          _this9.store.add(newObj);
        } catch (e) {
          return afterHandleAddRow(e.message);
        }
        _this9._handleAfterAddingRow(newObj, false);
        return afterHandleAddRow();
      };

      if (onAddRow) {
        var colInfos = this.store.getColInfos();
        var errMsg = onAddRow(newObj, colInfos, afterAddRowCB);

        if (errMsg !== '' && errMsg !== false) {
          return errMsg;
        } else if (typeof errMsg === 'undefined') {
          return afterAddRowCB();
        } else {
          isAsync = true;
          return !isAsync;
        }
      } else {
        return afterAddRowCB();
      }
    }
  }, {
    key: 'getSizePerPage',
    value: function getSizePerPage() {
      return this.state.sizePerPage;
    }
  }, {
    key: 'getCurrentPage',
    value: function getCurrentPage() {
      return this.state.currPage;
    }
  }, {
    key: 'getTableDataIgnorePaging',
    value: function getTableDataIgnorePaging() {
      return this.store.getCurrentDisplayData();
    }
  }, {
    key: '__getPageByRowKey__REACT_HOT_LOADER__',
    value: function __getPageByRowKey__REACT_HOT_LOADER__(rowKey) {
      var sizePerPage = this.state.sizePerPage;

      var currentData = this.store.getCurrentDisplayData();
      var keyField = this.store.getKeyField();
      var result = currentData.findIndex(function (x) {
        return x[keyField] === rowKey;
      });
      if (result > -1) {
        return parseInt(result / sizePerPage, 10) + 1;
      } else {
        return result;
      }
    }
  }, {
    key: '__handleDropRow__REACT_HOT_LOADER__',
    value: function __handleDropRow__REACT_HOT_LOADER__(rowKeys) {
      var _this10 = this;

      var dropRowKeys = rowKeys ? rowKeys : this.store.getSelectedRowKeys();
      // add confirm before the delete action if that option is set.
      if (dropRowKeys && dropRowKeys.length > 0) {
        if (this.props.options.handleConfirmDeleteRow) {
          this.props.options.handleConfirmDeleteRow(function () {
            _this10.deleteRow(dropRowKeys);
          }, dropRowKeys);
        } else if (confirm('Are you sure you want to delete?')) {
          this.deleteRow(dropRowKeys);
        }
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(dropRowKeys) {
      var _this11 = this;

      var dropRow = this.store.getRowByKey(dropRowKeys);
      var _props$options2 = this.props.options,
          onDeleteRow = _props$options2.onDeleteRow,
          afterDeleteRow = _props$options2.afterDeleteRow,
          pageStartIndex = _props$options2.pageStartIndex;


      if (onDeleteRow) {
        onDeleteRow(dropRowKeys, dropRow);
      }

      this.store.setSelectedRowKey([]); // clear selected row key

      if (this.allowRemote(_Const2.default.REMOTE_DROP_ROW)) {
        if (afterDeleteRow) {
          afterDeleteRow(dropRowKeys, dropRow);
        }
        return;
      }

      this.store.remove(dropRowKeys); // remove selected Row
      var result = void 0;
      if (this.props.pagination) {
        // debugger;
        var sizePerPage = this.state.sizePerPage;

        var currLastPage = Math.ceil(this.store.getDataNum() / sizePerPage);
        var currPage = this.state.currPage;

        if (currPage > currLastPage) currPage = currLastPage;
        // console.log(Util.getNormalizedPage(currPage));
        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex, currPage), sizePerPage).get();
        this.setState(function () {
          return {
            data: result,
            selectedRowKeys: _this11.store.getSelectedRowKeys(),
            currPage: currPage,
            reset: false
          };
        });
      } else {
        result = this.store.get();
        this.setState(function () {
          return {
            data: result,
            reset: false,
            selectedRowKeys: _this11.store.getSelectedRowKeys()
          };
        });
      }
      if (afterDeleteRow) {
        afterDeleteRow(dropRowKeys, dropRow);
      }
    }
  }, {
    key: '__handleFilterData__REACT_HOT_LOADER__',
    value: function __handleFilterData__REACT_HOT_LOADER__(filterObj) {
      var _props4 = this.props,
          filter = _props4.autoCollapse.filter,
          options = _props4.options;
      var onFilterChange = options.onFilterChange,
          pageStartIndex = options.pageStartIndex;

      if (onFilterChange) {
        var colInfos = this.store.getColInfos();
        onFilterChange(filterObj, colInfos);
      }

      this.setState(function () {
        var newState = {
          currPage: _util2.default.getFirstPage(pageStartIndex),
          reset: false
        };
        if (filter) newState.expanding = [];
        return newState;
      });

      if (this.allowRemote(_Const2.default.REMOTE_FILTER)) {
        if (this.props.options.afterColumnFilter) {
          this.props.options.afterColumnFilter(filterObj, this.store.getDataIgnoringPagination());
        }
        return;
      }

      this.store.filter(filterObj);

      var sortList = this.store.getSortInfo();

      if (sortList.length > 0) {
        this.store.sort();
      }

      var result = void 0;

      if (this.props.pagination) {
        var sizePerPage = this.state.sizePerPage;

        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
      } else {
        result = this.store.get();
      }
      if (this.props.options.afterColumnFilter) {
        this.props.options.afterColumnFilter(filterObj, this.store.getDataIgnoringPagination());
      }
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      var result = {};

      var csvFileName = this.props.csvFileName;
      var _props$options3 = this.props.options,
          onExportToCSV = _props$options3.onExportToCSV,
          exportCSVSeparator = _props$options3.exportCSVSeparator,
          noAutoBOM = _props$options3.noAutoBOM,
          excludeCSVHeader = _props$options3.excludeCSVHeader;

      if (onExportToCSV) {
        result = onExportToCSV();
      } else {
        result = this.store.getDataIgnoringPagination();
      }
      var separator = exportCSVSeparator || _Const2.default.DEFAULT_CSV_SEPARATOR;
      var keys = [];
      this.props.children.filter(function (_) {
        return _ != null;
      }).map(function (column) {
        if (column.props.export === true || typeof column.props.export === 'undefined' && column.props.hidden === false) {
          keys.push({
            field: column.props.dataField,
            type: column.props.csvFieldType,
            format: column.props.csvFormat,
            extraData: column.props.csvFormatExtraData,
            header: column.props.csvHeader || column.props.dataField,
            row: Number(column.props.row) || 0,
            rowSpan: Number(column.props.rowSpan) || 1,
            colSpan: Number(column.props.colSpan) || 1
          });
        }
      });

      if (_util2.default.isFunction(csvFileName)) {
        csvFileName = csvFileName();
      }

      (0, _csv_export_util2.default)(result, keys, csvFileName, separator, noAutoBOM, excludeCSVHeader);
    }
  }, {
    key: '__handleSearch__REACT_HOT_LOADER__',
    value: function __handleSearch__REACT_HOT_LOADER__(searchText) {
      // Set search field if this function being called outside
      // but it's not necessary if calling fron inside.
      if (this.toolbar) {
        this.toolbar.setSearchInput(searchText);
      }
      var search = this.props.autoCollapse.search;
      var _props$options4 = this.props.options,
          onSearchChange = _props$options4.onSearchChange,
          pageStartIndex = _props$options4.pageStartIndex;

      if (onSearchChange) {
        var colInfos = this.store.getColInfos();
        onSearchChange(searchText, colInfos, this.props.multiColumnSearch);
      }

      this.setState(function () {
        var newState = {
          currPage: _util2.default.getFirstPage(pageStartIndex),
          reset: false
        };
        if (search) newState.expanding = [];
        return newState;
      });

      if (this.allowRemote(_Const2.default.REMOTE_SEARCH)) {
        if (this.props.options.afterSearch) {
          this.props.options.afterSearch(searchText, this.store.getDataIgnoringPagination());
        }
        return;
      }

      this.store.search(searchText);

      var sortList = this.store.getSortInfo();

      if (sortList.length > 0) {
        this.store.sort();
      }

      var result = void 0;
      if (this.props.pagination) {
        var sizePerPage = this.state.sizePerPage;

        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
      } else {
        result = this.store.get();
      }
      if (this.props.options.afterSearch) {
        this.props.options.afterSearch(searchText, this.store.getDataIgnoringPagination());
      }
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });
    }
  }, {
    key: 'renderPagination',
    value: function renderPagination() {
      var _this12 = this;

      if (this.props.pagination) {
        var dataSize = void 0;
        if (this.allowRemote(_Const2.default.REMOTE_PAGE)) {
          dataSize = this.props.fetchInfo.dataTotalSize;
        } else {
          dataSize = this.store.getDataNum();
        }
        var options = this.props.options;

        var withFirstAndLast = options.withFirstAndLast === undefined ? true : options.withFirstAndLast;
        if (Math.ceil(dataSize / this.state.sizePerPage) <= 1 && this.props.ignoreSinglePage) return null;
        return _react2.default.createElement(
          'div',
          { className: 'react-bs-table-pagination' },
          _react2.default.createElement(_PaginationList2.default, {
            ref: function ref(node) {
              return _this12.pagination = node;
            },
            version: this.props.version,
            withFirstAndLast: withFirstAndLast,
            alwaysShowAllBtns: options.alwaysShowAllBtns,
            currPage: this.state.currPage,
            changePage: this.handlePaginationData,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: options.sizePerPageList || _Const2.default.SIZE_PER_PAGE_LIST,
            pageStartIndex: options.pageStartIndex,
            paginationShowsTotal: options.paginationShowsTotal,
            paginationSize: options.paginationSize || _Const2.default.PAGINATION_SIZE,
            dataSize: dataSize,
            onSizePerPageList: options.onSizePerPageList,
            prePage: options.prePage || _Const2.default.PRE_PAGE,
            nextPage: options.nextPage || _Const2.default.NEXT_PAGE,
            firstPage: options.firstPage || _Const2.default.FIRST_PAGE,
            lastPage: options.lastPage || _Const2.default.LAST_PAGE,
            prePageTitle: options.prePageTitle || _Const2.default.PRE_PAGE_TITLE,
            nextPageTitle: options.nextPageTitle || _Const2.default.NEXT_PAGE_TITLE,
            firstPageTitle: options.firstPageTitle || _Const2.default.FIRST_PAGE_TITLE,
            lastPageTitle: options.lastPageTitle || _Const2.default.LAST_PAGE_TITLE,
            hideSizePerPage: options.hideSizePerPage,
            sizePerPageDropDown: options.sizePerPageDropDown,
            hidePageListOnlyOnePage: options.hidePageListOnlyOnePage,
            paginationPanel: options.paginationPanel,
            keepSizePerPageState: options.keepSizePerPageState,
            open: false })
        );
      }
      return null;
    }
  }, {
    key: 'renderToolBar',
    value: function renderToolBar() {
      var _this13 = this;

      var _props5 = this.props,
          exportCSV = _props5.exportCSV,
          selectRow = _props5.selectRow,
          insertRow = _props5.insertRow,
          deleteRow = _props5.deleteRow,
          search = _props5.search,
          children = _props5.children,
          keyField = _props5.keyField;

      var enableShowOnlySelected = selectRow && selectRow.showOnlySelected;
      var print = typeof this.props.options.printToolBar === 'undefined' ? true : this.props.options.printToolBar;
      if (enableShowOnlySelected || insertRow || deleteRow || search || exportCSV || this.props.options.searchPanel || this.props.options.btnGroup || this.props.options.toolBar) {
        var columns = void 0;
        if (Array.isArray(children)) {
          columns = children.filter(function (_) {
            return _ != null;
          }).map(function (column, r) {
            if (!column) return;
            var props = column.props;

            var isKey = props.isKey || keyField === props.dataField;
            return {
              isKey: isKey,
              name: props.headerText || props.children,
              field: props.dataField,
              hiddenOnInsert: props.hiddenOnInsert,
              keyValidator: props.keyValidator,
              customInsertEditor: props.customInsertEditor,
              // when you want same auto generate value and not allow edit, example ID field
              autoValue: props.autoValue || false,
              // for create editor, no params for column.editable() indicate that editor for new row
              editable: props.editable && _util2.default.isFunction(props.editable === 'function') ? props.editable() : props.editable,
              format: props.dataFormat ? function (value) {
                return props.dataFormat(value, null, props.formatExtraData, r).replace(/<.*?>/g, '');
              } : false
            };
          });
        } else {
          columns = [{
            name: children.props.headerText || children.props.children,
            field: children.props.dataField,
            editable: children.props.editable,
            customInsertEditor: children.props.customInsertEditor,
            hiddenOnInsert: children.props.hiddenOnInsert,
            keyValidator: children.props.keyValidator
          }];
        }
        return _react2.default.createElement(
          'div',
          { className: 'react-bs-table-tool-bar ' + (print ? '' : 'hidden-print') },
          _react2.default.createElement(_ToolBar2.default, {
            ref: function ref(node) {
              return _this13.toolbar = node;
            },
            version: this.props.version,
            defaultSearch: this.props.options.defaultSearch,
            clearSearch: this.props.options.clearSearch,
            searchPosition: this.props.options.searchPosition,
            searchDelayTime: this.props.options.searchDelayTime,
            enableInsert: insertRow,
            enableDelete: deleteRow,
            enableSearch: search,
            enableExportCSV: exportCSV,
            enableShowOnlySelected: enableShowOnlySelected,
            columns: columns,
            searchPlaceholder: this.props.searchPlaceholder,
            exportCSVText: this.props.options.exportCSVText,
            insertText: this.props.options.insertText,
            deleteText: this.props.options.deleteText,
            saveText: this.props.options.saveText,
            closeText: this.props.options.closeText,
            ignoreEditable: this.props.options.ignoreEditable,
            onAddRow: this.handleAddRow,
            onDropRow: this.handleDropRow,
            onSearch: this.handleSearch,
            onExportCSV: this.handleExportCSV,
            onShowOnlySelected: this.handleShowOnlySelected,
            insertModalHeader: this.props.options.insertModalHeader,
            insertModalFooter: this.props.options.insertModalFooter,
            insertModalBody: this.props.options.insertModalBody,
            insertModal: this.props.options.insertModal,
            insertBtn: this.props.options.insertBtn,
            deleteBtn: this.props.options.deleteBtn,
            showSelectedOnlyBtn: this.props.options.showSelectedOnlyBtn,
            exportCSVBtn: this.props.options.exportCSVBtn,
            clearSearchBtn: this.props.options.clearSearchBtn,
            searchField: this.props.options.searchField,
            searchPanel: this.props.options.searchPanel,
            btnGroup: this.props.options.btnGroup,
            toolBar: this.props.options.toolBar,
            reset: this.state.reset,
            isValidKey: this.store.isValidKey,
            insertFailIndicator: this.props.options.insertFailIndicator || _Const2.default.INSERT_FAIL_INDICATOR })
        );
      } else {
        return null;
      }
    }
  }, {
    key: 'renderTableFilter',
    value: function renderTableFilter(columns) {
      if (this.props.columnFilter) {
        return _react2.default.createElement(_TableFilter2.default, { columns: columns,
          rowSelectType: this.props.selectRow.mode,
          onFilter: this.handleFilterData });
      } else {
        return null;
      }
    }
  }, {
    key: 'renderTableFooter',
    value: function renderTableFooter(footerData, footerFormatterReturnData, columns, colGroups) {
      var _this14 = this;

      if (this.props.footer) {
        var hideSelectColumn = true;
        var mode = this.props.selectRow.mode;

        var isSelectRowDefined = _util2.default.isSelectRowDefined(mode);
        if (isSelectRowDefined) {
          hideSelectColumn = this.props.selectRow.hideSelectColumn;
        }
        return _react2.default.createElement(
          _TableFooter2.default,
          {
            ref: function ref(node) {
              return _this14.footer = node;
            },
            columns: columns,
            colGroups: colGroups,
            footerFormatterReturnData: footerFormatterReturnData,
            tableFooterClass: this.props.tableFooterClass,
            style: this.props.headerStyle,
            hideSelectColumn: hideSelectColumn,
            expandColumnVisible: this.props.expandColumnOptions.expandColumnVisible,
            bordered: this.props.bordered,
            condensed: this.props.condensed,
            isFiltered: this.filter ? true : false,
            showStickyColumn: this.props.showStickyColumn },
          footerData
        );
      }
      return null;
    }
  }, {
    key: '___scrollTop__REACT_HOT_LOADER__',
    value: function ___scrollTop__REACT_HOT_LOADER__() {
      var scrollTop = this.props.scrollTop;

      if (scrollTop === _Const2.default.SCROLL_TOP) {
        this.body.container.scrollTop = 0;
      } else if (scrollTop === _Const2.default.SCROLL_BOTTOM) {
        this.body.container.scrollTop = this.body.container.scrollHeight;
      } else if (typeof scrollTop === 'number' && !isNaN(scrollTop)) {
        this.body.container.scrollTop = scrollTop;
      }
    }
  }, {
    key: '___scrollHeader__REACT_HOT_LOADER__',
    value: function ___scrollHeader__REACT_HOT_LOADER__(e) {
      this.header.container.scrollLeft = e.currentTarget.scrollLeft;
    }
  }, {
    key: '___scrollFooter__REACT_HOT_LOADER__',
    value: function ___scrollFooter__REACT_HOT_LOADER__(e) {
      if (this.props.footer) {
        this.footer.container.scrollLeft = e.currentTarget.scrollLeft;
      }
    }
  }, {
    key: '_adjustTable',
    value: function _adjustTable() {
      this._adjustHeight();
      if (!this.props.printable) {
        this._adjustHeaderWidth();
      }
    }
  }, {
    key: '_adjustHeaderWidth',
    value: function _adjustHeaderWidth() {
      var header = this.header.getHeaderColGrouop();
      var tbody = this.body.tbody;
      var bodyHeader = this.body.getHeaderColGrouop();
      var firstRow = tbody.childNodes[0];
      var isScroll = tbody.parentNode.getBoundingClientRect().height > tbody.parentNode.parentNode.getBoundingClientRect().height;

      var scrollBarWidth = isScroll ? _util2.default.getScrollBarWidth() : 0;
      if (firstRow && this.store.getDataNum()) {
        if (isScroll || this.isVerticalScroll !== isScroll) {
          var cells = firstRow.childNodes;
          for (var i = 0; i < cells.length; i++) {
            var cell = cells[i];
            var computedStyle = window.getComputedStyle(cell);
            var width = parseFloat(computedStyle.width.replace('px', ''));
            if (this.isIE) {
              var paddingLeftWidth = parseFloat(computedStyle.paddingLeft.replace('px', ''));
              var paddingRightWidth = parseFloat(computedStyle.paddingRight.replace('px', ''));
              var borderRightWidth = parseFloat(computedStyle.borderRightWidth.replace('px', ''));
              var borderLeftWidth = parseFloat(computedStyle.borderLeftWidth.replace('px', ''));
              width = width + paddingLeftWidth + paddingRightWidth + borderRightWidth + borderLeftWidth;
            }
            var lastPadding = cells.length - 1 === i ? scrollBarWidth : 0;
            if (width <= 0) {
              width = 120;
              cell.width = width + lastPadding + 'px';
            }
            var result = width + lastPadding + 'px';
            header[i].style.width = result;
            header[i].style.minWidth = result;
            if (cells.length - 1 === i) {
              bodyHeader[i].style.width = width + 'px';
              bodyHeader[i].style.minWidth = width + 'px';
            } else {
              bodyHeader[i].style.width = result;
              bodyHeader[i].style.minWidth = result;
            }
          }
        }
      } else {
        for (var _i in bodyHeader) {
          if (bodyHeader.hasOwnProperty(_i)) {
            var child = bodyHeader[_i];
            if (child.style) {
              if (child.style.width) {
                header[_i].style.width = child.style.width;
              }
              if (child.style.minWidth) {
                header[_i].style.minWidth = child.style.minWidth;
              }
            }
          }
        }
      }
      this.isVerticalScroll = isScroll;
    }
  }, {
    key: '_adjustHeight',
    value: function _adjustHeight() {
      var height = this.props.height;
      var maxHeight = this.props.maxHeight;

      if (typeof height === 'number' && !isNaN(height) || height.indexOf('%') === -1) {
        this.body.container.style.height = parseFloat(height, 10) - this.header.container.offsetHeight + 'px';
      }
      if (maxHeight) {
        maxHeight = typeof maxHeight === 'number' ? maxHeight : parseInt(maxHeight.replace('px', ''), 10);

        this.body.container.style.maxHeight = maxHeight - this.header.container.offsetHeight + 'px';
      }
    }
  }, {
    key: '_handleAfterAddingRow',
    value: function _handleAfterAddingRow(newObj, atTheBeginning) {
      var result = void 0;
      if (this.props.pagination) {
        // if pagination is enabled and inserting row at the end,
        // change page to the last page
        // otherwise, change it to the first page
        var sizePerPage = this.state.sizePerPage;


        if (atTheBeginning) {
          var pageStartIndex = this.props.options.pageStartIndex;

          result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
          this.setState(function () {
            return {
              data: result,
              currPage: _util2.default.getFirstPage(pageStartIndex),
              reset: false
            };
          });
        } else {
          var currLastPage = Math.ceil(this.store.getDataNum() / sizePerPage);
          result = this.store.page(currLastPage, sizePerPage).get();
          this.setState(function () {
            return {
              data: result,
              currPage: currLastPage,
              reset: false
            };
          });
        }
      } else {
        result = this.store.get();
        this.setState(function () {
          return {
            data: result,
            reset: false
          };
        });
      }

      if (this.props.options.afterInsertRow) {
        this.props.options.afterInsertRow(newObj);
      }
    }
  }]);

  return BootstrapTable;
}(_react.Component);

BootstrapTable.propTypes = {
  keyField: _propTypes2.default.string,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  data: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  version: _propTypes2.default.string, // bootstrap version
  remote: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]), // remote data, default is false
  replace: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  scrollTop: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  striped: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  hover: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  pagination: _propTypes2.default.bool,
  printable: _propTypes2.default.bool,
  withoutTabIndex: _propTypes2.default.bool,
  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  searchPlaceholder: _propTypes2.default.string,
  selectRow: _propTypes2.default.shape({
    mode: _propTypes2.default.oneOf([_Const2.default.ROW_SELECT_NONE, _Const2.default.ROW_SELECT_SINGLE, _Const2.default.ROW_SELECT_MULTI]),
    customComponent: _propTypes2.default.func,
    bgColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    selected: _propTypes2.default.array,
    onSelect: _propTypes2.default.func,
    onSelectAll: _propTypes2.default.func,
    clickToSelect: _propTypes2.default.bool,
    hideSelectColumn: _propTypes2.default.bool,
    clickToSelectAndEditCell: _propTypes2.default.bool,
    clickToExpand: _propTypes2.default.bool,
    showOnlySelected: _propTypes2.default.bool,
    unselectable: _propTypes2.default.array,
    columnWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    onlyUnselectVisible: _propTypes2.default.bool
  }),
  cellEdit: _propTypes2.default.shape({
    mode: _propTypes2.default.string,
    blurToSave: _propTypes2.default.bool,
    blurToEscape: _propTypes2.default.bool,
    beforeSaveCell: _propTypes2.default.func,
    afterSaveCell: _propTypes2.default.func,
    nonEditableRows: _propTypes2.default.func
  }),
  insertRow: _propTypes2.default.bool,
  deleteRow: _propTypes2.default.bool,
  search: _propTypes2.default.bool,
  multiColumnSearch: _propTypes2.default.bool,
  strictSearch: _propTypes2.default.bool,
  columnFilter: _propTypes2.default.bool,
  trClassName: _propTypes2.default.any,
  trStyle: _propTypes2.default.any,
  tableStyle: _propTypes2.default.object,
  containerStyle: _propTypes2.default.object,
  headerStyle: _propTypes2.default.object,
  bodyStyle: _propTypes2.default.object,
  containerClass: _propTypes2.default.string,
  tableContainerClass: _propTypes2.default.string,
  headerContainerClass: _propTypes2.default.string,
  bodyContainerClass: _propTypes2.default.string,
  tableHeaderClass: _propTypes2.default.string,
  tableBodyClass: _propTypes2.default.string,
  tableFooterClass: _propTypes2.default.string,
  options: _propTypes2.default.shape({
    clearSearch: _propTypes2.default.bool,
    sortName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    sortOrder: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    defaultSortName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    defaultSortOrder: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    sortIndicator: _propTypes2.default.bool,
    afterTableComplete: _propTypes2.default.func,
    afterDeleteRow: _propTypes2.default.func,
    afterInsertRow: _propTypes2.default.func,
    afterSearch: _propTypes2.default.func,
    afterColumnFilter: _propTypes2.default.func,
    onRowClick: _propTypes2.default.func,
    onRowDoubleClick: _propTypes2.default.func,
    page: _propTypes2.default.number,
    pageStartIndex: _propTypes2.default.number,
    paginationShowsTotal: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    sizePerPageList: _propTypes2.default.array,
    sizePerPage: _propTypes2.default.number,
    paginationSize: _propTypes2.default.number,
    paginationPosition: _propTypes2.default.oneOf([_Const2.default.PAGINATION_POS_TOP, _Const2.default.PAGINATION_POS_BOTTOM, _Const2.default.PAGINATION_POS_BOTH]),
    toolbarPosition: _propTypes2.default.oneOf([_Const2.default.TOOLBAR_POS_TOP, _Const2.default.TOOLBAR_POS_BOTTOM, _Const2.default.TOOLBAR_POS_BOTH]),
    hideSizePerPage: _propTypes2.default.bool,
    hidePageListOnlyOnePage: _propTypes2.default.bool,
    alwaysShowAllBtns: _propTypes2.default.bool,
    withFirstAndLast: _propTypes2.default.bool,
    keepSizePerPageState: _propTypes2.default.bool,
    onSortChange: _propTypes2.default.func,
    onPageChange: _propTypes2.default.func,
    onSizePerPageList: _propTypes2.default.func,
    onFilterChange: _propTypes2.default.func,
    onSearchChange: _propTypes2.default.func,
    onAddRow: _propTypes2.default.func,
    onExportToCSV: _propTypes2.default.func,
    onCellEdit: _propTypes2.default.func,
    noDataText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    withoutNoDataText: _propTypes2.default.bool,
    handleConfirmDeleteRow: _propTypes2.default.func,
    prePage: _propTypes2.default.any,
    nextPage: _propTypes2.default.any,
    firstPage: _propTypes2.default.any,
    lastPage: _propTypes2.default.any,
    prePageTitle: _propTypes2.default.string,
    nextPageTitle: _propTypes2.default.string,
    firstPageTitle: _propTypes2.default.string,
    lastPageTitle: _propTypes2.default.string,
    searchDelayTime: _propTypes2.default.number,
    excludeCSVHeader: _propTypes2.default.bool,
    exportCSVText: _propTypes2.default.string,
    exportCSVSeparator: _propTypes2.default.string,
    insertText: _propTypes2.default.string,
    deleteText: _propTypes2.default.string,
    saveText: _propTypes2.default.string,
    closeText: _propTypes2.default.string,
    ignoreEditable: _propTypes2.default.bool,
    defaultSearch: _propTypes2.default.string,
    insertModalHeader: _propTypes2.default.func,
    insertModalBody: _propTypes2.default.func,
    insertModalFooter: _propTypes2.default.func,
    insertModal: _propTypes2.default.func,
    insertBtn: _propTypes2.default.func,
    deleteBtn: _propTypes2.default.func,
    showSelectedOnlyBtn: _propTypes2.default.func,
    exportCSVBtn: _propTypes2.default.func,
    clearSearchBtn: _propTypes2.default.func,
    searchField: _propTypes2.default.func,
    searchPanel: _propTypes2.default.func,
    btnGroup: _propTypes2.default.func,
    toolBar: _propTypes2.default.func,
    sizePerPageDropDown: _propTypes2.default.func,
    paginationPanel: _propTypes2.default.func,
    searchPosition: _propTypes2.default.string,
    expandRowBgColor: _propTypes2.default.string,
    expandBy: _propTypes2.default.string,
    expanding: _propTypes2.default.array,
    onExpand: _propTypes2.default.func,
    onlyOneExpanding: _propTypes2.default.bool,
    expandBodyClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    expandParentClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    beforeShowError: _propTypes2.default.func,
    printToolBar: _propTypes2.default.bool,
    insertFailIndicator: _propTypes2.default.string,
    noAutoBOM: _propTypes2.default.bool,
    expandAll: _propTypes2.default.bool,
    hideRowOnExpand: _propTypes2.default.bool
  }),
  fetchInfo: _propTypes2.default.shape({
    dataTotalSize: _propTypes2.default.number
  }),
  renderAlert: _propTypes2.default.bool,
  exportCSV: _propTypes2.default.bool,
  csvFileName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  ignoreSinglePage: _propTypes2.default.bool,
  expandableRow: _propTypes2.default.func,
  expandComponent: _propTypes2.default.func,
  autoCollapse: _propTypes2.default.shape({
    sort: _propTypes2.default.bool,
    filter: _propTypes2.default.bool,
    search: _propTypes2.default.bool
  }),
  expandColumnOptions: _propTypes2.default.shape({
    columnWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    expandColumnVisible: _propTypes2.default.bool,
    expandColumnComponent: _propTypes2.default.func,
    expandedColumnHeaderComponent: _propTypes2.default.func,
    expandColumnBeforeSelectColumn: _propTypes2.default.bool
  }),
  footer: _propTypes2.default.bool
};
BootstrapTable.defaultProps = {
  version: '3',
  replace: false,
  scrollTop: undefined,
  expandComponent: undefined,
  expandableRow: undefined,
  expandColumnOptions: {
    expandColumnVisible: false,
    expandColumnComponent: undefined,
    expandedColumnHeaderComponent: undefined,
    expandColumnBeforeSelectColumn: true
  },
  height: '100%',
  maxHeight: undefined,
  striped: false,
  bordered: true,
  hover: false,
  condensed: false,
  pagination: false,
  printable: false,
  withoutTabIndex: false,
  keyBoardNav: false,
  searchPlaceholder: undefined,
  selectRow: {
    mode: _Const2.default.ROW_SELECT_NONE,
    bgColor: _Const2.default.ROW_SELECT_BG_COLOR,
    selected: [],
    onSelect: undefined,
    onSelectAll: undefined,
    clickToSelect: false,
    hideSelectColumn: false,
    clickToSelectAndEditCell: false,
    clickToExpand: false,
    showOnlySelected: false,
    unselectable: [],
    customComponent: undefined,
    onlyUnselectVisible: false
  },
  cellEdit: {
    mode: _Const2.default.CELL_EDIT_NONE,
    blurToSave: false,
    blurToEscape: false,
    beforeSaveCell: undefined,
    afterSaveCell: undefined,
    nonEditableRows: undefined
  },
  insertRow: false,
  deleteRow: false,
  search: false,
  multiColumnSearch: false,
  strictSearch: undefined,
  multiColumnSort: 1,
  columnFilter: false,
  trClassName: '',
  trStyle: undefined,
  tableStyle: undefined,
  containerStyle: undefined,
  headerStyle: undefined,
  bodyStyle: undefined,
  containerClass: null,
  tableContainerClass: null,
  headerContainerClass: null,
  bodyContainerClass: null,
  tableHeaderClass: null,
  tableBodyClass: null,
  tableFooterClass: null,
  options: {
    clearSearch: false,
    sortName: undefined,
    sortOrder: undefined,
    defaultSortName: undefined,
    defaultSortOrder: undefined,
    sortIndicator: true,
    afterTableComplete: undefined,
    afterDeleteRow: undefined,
    afterInsertRow: undefined,
    afterSearch: undefined,
    afterColumnFilter: undefined,
    onRowClick: undefined,
    onRowDoubleClick: undefined,
    onMouseLeave: undefined,
    onMouseEnter: undefined,
    onRowMouseOut: undefined,
    onRowMouseOver: undefined,
    page: undefined,
    paginationShowsTotal: false,
    sizePerPageList: _Const2.default.SIZE_PER_PAGE_LIST,
    sizePerPage: undefined,
    paginationSize: _Const2.default.PAGINATION_SIZE,
    paginationPosition: _Const2.default.PAGINATION_POS_BOTTOM,
    toolbarPosition: _Const2.default.TOOLBAR_POS_TOP,
    hideSizePerPage: false,
    hidePageListOnlyOnePage: false,
    alwaysShowAllBtns: false,
    withFirstAndLast: true,
    keepSizePerPageState: false,
    onSizePerPageList: undefined,
    noDataText: undefined,
    withoutNoDataText: false,
    handleConfirmDeleteRow: undefined,
    prePage: _Const2.default.PRE_PAGE,
    nextPage: _Const2.default.NEXT_PAGE,
    firstPage: _Const2.default.FIRST_PAGE,
    lastPage: _Const2.default.LAST_PAGE,
    prePageTitle: _Const2.default.PRE_PAGE_TITLE,
    nextPageTitle: _Const2.default.NEXT_PAGE_TITLE,
    firstPageTitle: _Const2.default.FIRST_PAGE_TITLE,
    lastPageTitle: _Const2.default.LAST_PAGE_TITLE,
    pageStartIndex: 1,
    searchDelayTime: undefined,
    excludeCSVHeader: false,
    exportCSVText: _Const2.default.EXPORT_CSV_TEXT,
    exportCSVSeparator: _Const2.default.DEFAULT_CSV_SEPARATOR,
    insertText: _Const2.default.INSERT_BTN_TEXT,
    deleteText: _Const2.default.DELETE_BTN_TEXT,
    saveText: _Const2.default.SAVE_BTN_TEXT,
    closeText: _Const2.default.CLOSE_BTN_TEXT,
    ignoreEditable: false,
    defaultSearch: '',
    insertModalHeader: undefined,
    insertModalBody: undefined,
    insertModalFooter: undefined,
    insertModal: undefined,
    insertBtn: undefined,
    deleteBtn: undefined,
    showSelectedOnlyBtn: undefined,
    exportCSVBtn: undefined,
    clearSearchBtn: undefined,
    searchField: undefined,
    searchPanel: undefined,
    btnGroup: undefined,
    toolBar: undefined,
    sizePerPageDropDown: undefined,
    paginationPanel: undefined,
    searchPosition: 'right',
    expandRowBgColor: undefined,
    expandBy: _Const2.default.EXPAND_BY_ROW,
    expanding: [],
    onExpand: undefined,
    onlyOneExpanding: false,
    expandBodyClass: null,
    expandParentClass: null,
    beforeShowError: undefined,
    printToolBar: true,
    insertFailIndicator: _Const2.default.INSERT_FAIL_INDICATOR,
    noAutoBOM: true,
    expandAll: false,
    hideRowOnExpand: false
  },
  fetchInfo: {
    dataTotalSize: 0
  },
  renderAlert: true,
  exportCSV: false,
  csvFileName: 'spreadsheet.csv',
  ignoreSinglePage: false,
  autoCollapse: {
    sort: _Const2.default.AUTO_COLLAPSE_WHEN_SORT,
    filter: _Const2.default.AUTO_COLLAPSE_WHEN_FILTER,
    search: _Const2.default.AUTO_COLLAPSE_WHEN_SEARCH
  },
  footer: false
};

var _default = BootstrapTable;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BootstrapTable, 'BootstrapTable', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/BootstrapTable.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/BootstrapTable.js');
}();

;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(167), __webpack_require__(1), __webpack_require__(111), __webpack_require__(110), __webpack_require__(437)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('./SAlertContent'), require('prop-types'), require('./s-alert-parts/s-alert-store'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-data-prep'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.SAlertContent, global.propTypes, global.sAlertStore, global.sAlertTools, global.sAlertDataPrep);
        global.SAlert = mod.exports;
    }
})(this, function (exports, _react, _SAlertContent, _propTypes, _sAlertStore, _sAlertTools, _sAlertDataPrep) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    var _sAlertDataPrep2 = _interopRequireDefault(_sAlertDataPrep);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var insertFunc = function insertFunc(msg, data, condition) {
        var id = _sAlertTools2.default.randomId();
        _sAlertStore2.default.dispatch({
            type: 'INSERT',
            data: _extends({}, data, {
                id: id,
                condition: condition,
                message: msg
            })
        });
        return id;
    };

    var SAlert = function (_React$Component) {
        _inherits(SAlert, _React$Component);

        function SAlert(props) {
            _classCallCheck(this, SAlert);

            var _this = _possibleConstructorReturn(this, (SAlert.__proto__ || Object.getPrototypeOf(SAlert)).call(this, props));

            _this.state = {
                dataRight: [],
                dataLeft: [],
                dataTop: [],
                dataBottom: []
            };
            return _this;
        }

        _createClass(SAlert, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;

                var storeStateLeft = void 0;
                var storeStateRight = void 0;
                var storeStateTop = void 0;
                var storeStateBottom = void 0;

                var addToStoreRight = function addToStoreRight() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateRight = (0, _sAlertDataPrep2.default)('right', _this2) || [];
                            length = storeStateRight.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateRight[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateRight = (0, _sAlertDataPrep2.default)('right', _this2) || [];
                            }
                            _this2.setState({ dataRight: storeStateRight });
                        });
                    });
                };
                this.unsubStoreRight = _sAlertStore2.default.subscribe(addToStoreRight);

                var addToStoreLeft = function addToStoreLeft() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateLeft = (0, _sAlertDataPrep2.default)('left', _this2) || [];
                            length = storeStateLeft.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateLeft[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateLeft = (0, _sAlertDataPrep2.default)('left', _this2) || [];
                            }
                            _this2.setState({ dataLeft: storeStateLeft });
                        });
                    });
                };
                this.unsubStoreLeft = _sAlertStore2.default.subscribe(addToStoreLeft);

                var addToStoreTop = function addToStoreTop() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateTop = (0, _sAlertDataPrep2.default)('full-top', _this2) || [];
                            length = storeStateTop.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateTop[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateTop = (0, _sAlertDataPrep2.default)('full-top', _this2) || [];
                            }
                            _this2.setState({ dataTop: storeStateTop });
                        });
                    });
                };
                this.unsubStoreTop = _sAlertStore2.default.subscribe(addToStoreTop);

                var addToStoreBottom = function addToStoreBottom() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom', _this2) || [];
                            length = storeStateBottom.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateBottom[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom', _this2) || [];
                            }
                            _this2.setState({ dataBottom: storeStateBottom });
                        });
                    });
                };
                this.unsubStoreBottom = _sAlertStore2.default.subscribe(addToStoreBottom);

                // set up global config from global SAlert props
                // only stuff needed for getAlertData
                var globalConfig = {
                    contentTemplate: this.props.contentTemplate,
                    offset: this.props.offset,
                    message: this.props.message,
                    stack: this.props.stack,
                    html: this.props.html,
                    customFields: this.props.customFields,
                    position: this.props.position || 'top-right',
                    preserveContext: this.props.preserveContext || false
                };
                _sAlertTools2.default.setGlobalConfig(globalConfig);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unsubStoreTop();
                this.unsubStoreBottom();
                this.unsubStoreLeft();
                this.unsubStoreRight();
            }
        }, {
            key: 'render',
            value: function render() {
                var _this3 = this;

                var mapFunc = function mapFunc(alert, index) {
                    var customKey = 'alert-key-' + alert.id + '-' + alert.position;
                    var id = alert.id;
                    var condition = _sAlertTools2.default.returnFirstDefined(alert.condition, 'info');
                    var message = _sAlertTools2.default.returnFirstDefined(alert.message, _this3.props.message, '');
                    var position = _sAlertTools2.default.returnFirstDefined(alert.position, _this3.props.position, 'top-right');
                    var offset = _sAlertTools2.default.returnFirstDefined(alert.offset, _this3.props.offset, 0);
                    var effect = _sAlertTools2.default.returnFirstDefined(alert.effect, _this3.props.effect);
                    var boxPosition = alert.boxPosition;
                    var beep = _sAlertTools2.default.returnFirstDefined(alert.beep, _this3.props.beep, false);
                    var timeout = _sAlertTools2.default.returnFirstDefined(alert.timeout, _this3.props.timeout, 5000);
                    var html = _sAlertTools2.default.returnFirstDefined(alert.html, _this3.props.html);
                    var onClose = _sAlertTools2.default.returnFirstDefined(alert.onClose, _this3.props.onClose);
                    var onShow = _sAlertTools2.default.returnFirstDefined(alert.onShow, _this3.props.onShow);
                    var customFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, _this3.props.customFields);
                    var contentTemplate = _this3.props.contentTemplate;

                    return _react2.default.createElement(_SAlertContent2.default, {
                        key: customKey,
                        id: id,
                        customFields: customFields,
                        condition: condition,
                        message: message,
                        position: position,
                        effect: effect,
                        boxPosition: boxPosition,
                        beep: beep,
                        timeout: timeout,
                        html: html,
                        onClose: onClose,
                        onShow: onShow,
                        contentTemplate: contentTemplate });
                };
                var sAlertElemsRight = this.state.dataRight.map(mapFunc);
                var sAlertElemsLeft = this.state.dataLeft.map(mapFunc);
                var sAlertElemsTop = this.state.dataTop.map(mapFunc);
                var sAlertElemsBottom = this.state.dataBottom.map(mapFunc);
                return _react2.default.createElement(
                    'div',
                    { className: 's-alert-wrapper' },
                    sAlertElemsRight,
                    sAlertElemsLeft,
                    sAlertElemsTop,
                    sAlertElemsBottom
                );
            }
        }], [{
            key: 'info',
            value: function info(msg, data) {
                return insertFunc(msg, data, 'info');
            }
        }, {
            key: 'error',
            value: function error(msg, data) {
                return insertFunc(msg, data, 'error');
            }
        }, {
            key: 'warning',
            value: function warning(msg, data) {
                return insertFunc(msg, data, 'warning');
            }
        }, {
            key: 'success',
            value: function success(msg, data) {
                return insertFunc(msg, data, 'success');
            }
        }, {
            key: 'close',
            value: function close(id) {
                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
            }
        }, {
            key: 'closeAll',
            value: function closeAll() {
                _sAlertStore2.default.dispatch({ type: 'REMOVEALL' });
            }
        }]);

        return SAlert;
    }(_react2.default.Component);

    SAlert.propTypes = {
        message: _propTypes2.default.string,
        position: _propTypes2.default.string,
        offset: _propTypes2.default.number,
        stack: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
        effect: _propTypes2.default.string,
        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
        html: _propTypes2.default.bool,
        preserveContext: _propTypes2.default.bool,
        onClose: _propTypes2.default.func,
        onShow: _propTypes2.default.func,
        customFields: _propTypes2.default.object,
        contentTemplate: _propTypes2.default.func
    };

    exports.default = SAlert;
});

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('prop-types'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.propTypes);
        global.SAlertContentTmpl = mod.exports;
    }
})(this, function (exports, _react, _propTypes) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var SAlertContentTmpl = function (_React$Component) {
        _inherits(SAlertContentTmpl, _React$Component);

        function SAlertContentTmpl(props) {
            _classCallCheck(this, SAlertContentTmpl);

            return _possibleConstructorReturn(this, (SAlertContentTmpl.__proto__ || Object.getPrototypeOf(SAlertContentTmpl)).call(this, props));
        }

        _createClass(SAlertContentTmpl, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(
                    'div',
                    { className: this.props.classNames, id: this.props.id, style: this.props.styles },
                    _react2.default.createElement(
                        'div',
                        { className: 's-alert-box-inner' },
                        this.props.message
                    ),
                    _react2.default.createElement('span', { className: 's-alert-close', onClick: this.props.handleClose })
                );
            }
        }]);

        return SAlertContentTmpl;
    }(_react2.default.Component);

    SAlertContentTmpl.propTypes = {
        id: _propTypes2.default.string.isRequired,
        classNames: _propTypes2.default.string.isRequired,
        condition: _propTypes2.default.string.isRequired,
        styles: _propTypes2.default.object.isRequired,
        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
        handleClose: _propTypes2.default.func.isRequired,
        customFields: _propTypes2.default.object
    };

    exports.default = SAlertContentTmpl;
});

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(11), __webpack_require__(167), __webpack_require__(111), __webpack_require__(110)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('react-dom'), require('../SAlertContent'), require('./s-alert-store'), require('./s-alert-tools'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.reactDom, global.SAlertContent, global.sAlertStore, global.sAlertTools);
        global.sAlertDataPrep = mod.exports;
    }
})(this, function (exports, _react, _reactDom, _SAlertContent, _sAlertStore, _sAlertTools) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var getAlertData = function getAlertData(sAlertPosition, parentComponent) {
        var positionTop = 0;
        var positionBottom = 0;
        var padding = 0;
        var alerts = {};
        var style = void 0;
        var docElement = void 0;
        var sAlertBoxHeight = void 0;
        var positionTypeTop = void 0;
        var positionTypeBottom = void 0;
        var checkFirst = function checkFirst(type, objId) {
            var collectionOfType = sAlertCollection.filter(function (obj) {
                return obj.position === type || sAlertGlobalConfig.position === type;
            });
            return collectionOfType && collectionOfType[0].id === objId;
        };
        var positionFunc = function positionFunc(position, positionType, alert, docElement, sAlertBoxHeight, reactComponent) {
            padding = aStack.spacing || parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))[positionType]);
            if (checkFirst(aPosition, alert.id) && aOffset) {
                position = 0;
                position = position + parseInt(aOffset);
            }
            if (checkFirst(aPosition, alert.id) && aStack.spacing) {
                position = position;
            } else {
                position = position + parseInt(padding);
            }
            style = positionType + ': ' + position + 'px;';
            position = position + sAlertBoxHeight;
            return position;
        };

        var sAlertGlobalConfig = _sAlertTools2.default.getGlobalConfig();
        var aStack = void 0;
        var aContentTemplate = void 0;
        var aOffset = void 0;
        var aMessage = void 0;
        var aHtml = void 0;
        var aCustomFields = void 0;
        var aPosition = void 0;
        var preserveContext = void 0;

        var query = {};
        if (sAlertPosition === 'left') {
            query = function query(item) {
                return item.position === 'top-left' || item.position === 'bottom-left' || !item.position && (sAlertGlobalConfig.position === 'top-left' || sAlertGlobalConfig.position === 'bottom-left');
            };
        }
        if (sAlertPosition === 'right') {
            query = function query(item) {
                return item.position === 'top-right' || item.position === 'bottom-right' || !item.position && (sAlertGlobalConfig.position === 'top-right' || sAlertGlobalConfig.position === 'bottom-right');
            };
        }
        if (sAlertPosition === 'full-top') {
            query = function query(item) {
                return item.position === 'top' || !item.position && sAlertGlobalConfig.position === 'top';
            };
        }
        if (sAlertPosition === 'full-bottom') {
            query = function query(item) {
                return item.position === 'bottom' || !item.position && sAlertGlobalConfig.position === 'bottom';
            };
        }

        var currentState = _sAlertStore2.default.getState();
        var sAlertCollection = currentState.slice().filter(query);

        return sAlertCollection.map(function (alert) {
            aStack = sAlertGlobalConfig.stack;
            aContentTemplate = sAlertGlobalConfig.contentTemplate;
            aOffset = _sAlertTools2.default.returnFirstDefined(alert.offset, sAlertGlobalConfig.offset);
            aMessage = _sAlertTools2.default.returnFirstDefined(alert.message, sAlertGlobalConfig.message);
            aHtml = _sAlertTools2.default.returnFirstDefined(alert.html, sAlertGlobalConfig.html);
            aCustomFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, sAlertGlobalConfig.customFields);
            aPosition = _sAlertTools2.default.returnFirstDefined(alert.position, sAlertGlobalConfig.position);
            preserveContext = _sAlertTools2.default.returnFirstDefined(alert.preserveContext, sAlertGlobalConfig.preserveContext);
            positionTypeTop = aPosition && /top/g.test(aPosition);
            positionTypeBottom = aPosition && /bottom/g.test(aPosition);

            if (aStack) {
                // checking alert box height - needed to calculate position
                docElement = document.createElement('div');
                docElement.classList.add('s-alert-box-height');

                // mock element, needed for positions calculations
                var reactElement = _react2.default.createElement(_SAlertContent2.default, {
                    key: _sAlertTools2.default.randomId(),
                    id: _sAlertTools2.default.randomId(),
                    condition: alert.condition,
                    message: aMessage,
                    position: aPosition,
                    effect: alert.effect,
                    boxPosition: alert.boxPosition,
                    beep: false,
                    timeout: 'none',
                    html: aHtml,
                    contentTemplate: aContentTemplate,
                    customFields: aCustomFields
                });

                var reactComponent = void 0;

                if (preserveContext) {
                    reactComponent = _reactDom2.default.unstable_renderSubtreeIntoContainer(parentComponent, reactElement, docElement);
                } else {
                    reactComponent = _reactDom2.default.render(reactElement, docElement);
                }

                document.body.appendChild(docElement);
                sAlertBoxHeight = parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))['height']);
                if (positionTypeTop) {
                    positionTop = positionFunc(positionTop, 'top', alert, docElement, sAlertBoxHeight, reactComponent);
                }
                if (positionTypeBottom) {
                    positionBottom = positionFunc(positionBottom, 'bottom', alert, docElement, sAlertBoxHeight, reactComponent);
                }
                var sAlertComputedStyle = getComputedStyle(_reactDom2.default.findDOMNode(reactComponent));
                if (sAlertPosition === 'left') {
                    style = style + 'left: ' + (aStack.spacing || parseInt(sAlertComputedStyle.left)) + 'px;';
                }
                if (sAlertPosition === 'right') {
                    style = style + 'right: ' + (aStack.spacing || parseInt(sAlertComputedStyle.right)) + 'px;';
                }
                alerts = _extends({}, alert, { boxPosition: style });
                _reactDom2.default.unmountComponentAtNode(docElement);
                docElement.parentNode.removeChild(docElement);
            } else if (aOffset && positionTypeTop) {
                alerts = _extends({}, alert, { boxPosition: 'top: ' + parseInt(aOffset) + 'px;' });
            } else if (aOffset && positionTypeBottom) {
                alerts = _extends({}, alert, { boxPosition: 'bottom: ' + parseInt(aOffset) + 'px;' });
            } else {
                alerts = alert;
            }
            return alerts;
        });
    };

    exports.default = getAlertData;
});

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint quotes: 0 */
/* eslint max-len: 0 */


var legalComparators = ['=', '>', '>=', '<', '<=', '!='];

function dateParser(d) {
  return d.getFullYear() + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + ("0" + d.getDate()).slice(-2);
}

var DateFilter = function (_Component) {
  _inherits(DateFilter, _Component);

  function DateFilter(props) {
    _classCallCheck(this, DateFilter);

    var _this = _possibleConstructorReturn(this, (DateFilter.__proto__ || Object.getPrototypeOf(DateFilter)).call(this, props));

    _this.dateComparators = _this.props.dateComparators || legalComparators;
    _this.filter = _this.filter.bind(_this);
    _this.onChangeComparator = _this.onChangeComparator.bind(_this);
    return _this;
  }

  _createClass(DateFilter, [{
    key: 'setDefaultDate',
    value: function setDefaultDate() {
      var defaultDate = '';
      var defaultValue = this.props.defaultValue;

      if (defaultValue && defaultValue.date) {
        // Set the appropriate format for the input type=date, i.e. "YYYY-MM-DD"
        defaultDate = dateParser(new Date(defaultValue.date));
      }
      return defaultDate;
    }
  }, {
    key: 'onChangeComparator',
    value: function onChangeComparator(event) {
      var date = this.inputDate.value;
      var comparator = event.target.value;
      if (date === '') {
        return;
      }
      date = new Date(date);
      this.props.filterHandler({ date: date, comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'getComparatorOptions',
    value: function getComparatorOptions() {
      var optionTags = [];
      optionTags.push(_react2.default.createElement('option', { key: '-1' }));
      for (var i = 0; i < this.dateComparators.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: this.dateComparators[i] },
          this.dateComparators[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'filter',
    value: function filter(event) {
      var comparator = this.dateFilterComparator.value;
      var dateValue = event.target.value;
      if (dateValue) {
        this.props.filterHandler({ date: new Date(dateValue), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
      } else {
        this.props.filterHandler(null, _Const2.default.FILTER_TYPE.DATE);
      }
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.setDefaultDate();
      var comparator = this.props.defaultValue ? this.props.defaultValue.comparator : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.dateFilterComparator.value = comparator;
      this.inputDate.value = value;
      this.props.filterHandler({ date: new Date(value), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterDateObj) {
      var date = filterDateObj.date,
          comparator = filterDateObj.comparator;

      this.setState(function () {
        return { isPlaceholderSelected: date === '' };
      });
      this.dateFilterComparator.value = comparator;
      this.inputDate.value = dateParser(date);
      this.props.filterHandler({ date: date, comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var comparator = this.dateFilterComparator.value;
      var dateValue = this.inputDate.value;
      if (comparator && dateValue) {
        this.props.filterHandler({ date: new Date(dateValue), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          defaultValue = _props.defaultValue,
          _props$style = _props.style,
          date = _props$style.date,
          comparator = _props$style.comparator;

      return _react2.default.createElement(
        'div',
        { className: 'filter date-filter' },
        _react2.default.createElement(
          'select',
          { ref: function ref(n) {
              return _this2.dateFilterComparator = n;
            },
            style: comparator,
            className: 'date-filter-comparator form-control',
            onChange: this.onChangeComparator,
            defaultValue: defaultValue ? defaultValue.comparator : '' },
          this.getComparatorOptions()
        ),
        _react2.default.createElement('input', { ref: function ref(n) {
            return _this2.inputDate = n;
          },
          className: 'filter date-filter-input form-control',
          style: date,
          type: 'date',
          onChange: this.filter,
          defaultValue: this.setDefaultDate() })
      );
    }
  }]);

  return DateFilter;
}(_react.Component);

DateFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  defaultValue: _propTypes2.default.shape({
    date: _propTypes2.default.object,
    comparator: _propTypes2.default.oneOf(legalComparators)
  }),
  style: _propTypes2.default.shape({
    date: _propTypes2.default.oneOfType([_propTypes2.default.object]),
    comparator: _propTypes2.default.oneOfType([_propTypes2.default.object])
  }),
  /* eslint consistent-return: 0 */
  dateComparators: function dateComparators(props, propName) {
    if (!props[propName]) {
      return;
    }
    for (var i = 0; i < props[propName].length; i++) {
      var comparatorIsValid = false;
      for (var j = 0; j < legalComparators.length; j++) {
        if (legalComparators[j] === props[propName][i]) {
          comparatorIsValid = true;
          break;
        }
      }
      if (!comparatorIsValid) {
        return new Error('Date comparator provided is not supported.\n          Use only ' + legalComparators);
      }
    }
  },
  columnName: _propTypes2.default.any
};

DateFilter.defaultProps = {
  style: {
    date: null,
    comparator: null
  }
};

var _default = DateFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(legalComparators, 'legalComparators', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(dateParser, 'dateParser', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(DateFilter, 'DateFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');
}();

;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextFilter = function (_Component) {
  _inherits(TextFilter, _Component);

  function TextFilter(props) {
    _classCallCheck(this, TextFilter);

    var _this = _possibleConstructorReturn(this, (TextFilter.__proto__ || Object.getPrototypeOf(TextFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.timeout = null;
    _this.state = {
      value: _this.props.defaultValue || ''
    };
    return _this;
  }

  _createClass(TextFilter, [{
    key: 'filter',
    value: function filter(event) {
      var _this2 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.setState(function () {
        return { value: filterValue };
      });
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler(filterValue, _Const2.default.FILTER_TYPE.TEXT);
      }, this.props.delay);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue : '';
      this.setState(function () {
        return { value: value };
      });
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterText) {
      this.setState(function () {
        return { value: filterText };
      });
      this.props.filterHandler(filterText, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var defaultValue = this.inputText.value;
      if (defaultValue) {
        this.props.filterHandler(defaultValue, _Const2.default.FILTER_TYPE.TEXT);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.defaultValue !== this.props.defaultValue) {
        this.applyFilter(nextProps.defaultValue || '');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          style = _props.style;

      return _react2.default.createElement('input', { ref: function ref(n) {
          return _this3.inputText = n;
        },
        className: 'filter text-filter form-control',
        type: 'text',
        style: style,
        onChange: this.filter,
        placeholder: placeholder || 'Enter ' + columnName + '...',
        value: this.state.value });
    }
  }]);

  return TextFilter;
}(_react.Component);

TextFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  defaultValue: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
};

TextFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY
};

var _default = TextFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TextFilter, 'TextFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Text.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Text.js');
}();

;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RegexFilter = function (_Component) {
  _inherits(RegexFilter, _Component);

  function RegexFilter(props) {
    _classCallCheck(this, RegexFilter);

    var _this = _possibleConstructorReturn(this, (RegexFilter.__proto__ || Object.getPrototypeOf(RegexFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.timeout = null;
    return _this;
  }

  _createClass(RegexFilter, [{
    key: 'filter',
    value: function filter(event) {
      var _this2 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler(filterValue, _Const2.default.FILTER_TYPE.REGEX);
      }, this.props.delay);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue : '';
      this.inputText.value = value;
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterRegx) {
      this.inputText.value = filterRegx;
      this.props.filterHandler(filterRegx, _Const2.default.FILTER_TYPE.REGEX);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.inputText.value;
      if (value) {
        this.props.filterHandler(value, _Const2.default.FILTER_TYPE.REGEX);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          defaultValue = _props.defaultValue,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          style = _props.style;

      return _react2.default.createElement('input', { ref: function ref(n) {
          return _this3.inputText = n;
        },
        className: 'filter text-filter form-control',
        type: 'text',
        style: style,
        onChange: this.filter,
        placeholder: placeholder || 'Enter Regex for ' + columnName + '...',
        defaultValue: defaultValue ? defaultValue : '' });
    }
  }]);

  return RegexFilter;
}(_react.Component);

RegexFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  defaultValue: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
};

RegexFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY
};

var _default = RegexFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RegexFilter, 'RegexFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Regex.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Regex.js');
}();

;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function optionsEquals(options1, options2) {
  var keys = Object.keys(options1);
  for (var k in keys) {
    if (options1[k] !== options2[k]) {
      return false;
    }
  }
  return Object.keys(options1).length === Object.keys(options2).length;
}

var SelectFilter = function (_Component) {
  _inherits(SelectFilter, _Component);

  function SelectFilter(props) {
    _classCallCheck(this, SelectFilter);

    var _this = _possibleConstructorReturn(this, (SelectFilter.__proto__ || Object.getPrototypeOf(SelectFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.state = {
      isPlaceholderSelected: _this.props.defaultValue === undefined || !_this.props.options.hasOwnProperty(_this.props.defaultValue)
    };
    return _this;
  }

  _createClass(SelectFilter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var currentSelectValue = this.selectInput.value;
      var isPlaceholderSelected = !currentSelectValue || currentSelectValue === '';
      this.setState(function () {
        return {
          isPlaceholderSelected: isPlaceholderSelected
        };
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var needFilter = false;
      if (this.props.defaultValue !== prevProps.defaultValue) {
        needFilter = true;
      } else if (!optionsEquals(this.props.options, prevProps.options)) {
        needFilter = true;
      }
      if (needFilter) {
        var value = this.selectInput.value;
        if (value) {
          this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
        }
      }
    }
  }, {
    key: 'filter',
    value: function filter(event) {
      var value = event.target.value;

      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue !== undefined ? this.props.defaultValue : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.selectInput.value = value;
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterOption) {
      filterOption = filterOption + '';
      this.setState(function () {
        return { isPlaceholderSelected: filterOption === '' };
      });
      this.selectInput.value = filterOption;
      this.props.filterHandler(filterOption, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var optionTags = [];
      var _props = this.props,
          options = _props.options,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          selectText = _props.selectText,
          withoutEmptyOption = _props.withoutEmptyOption;

      var selectTextValue = selectText !== undefined ? selectText : 'Select';
      if (!withoutEmptyOption) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: '-1', value: '' },
          placeholder || selectTextValue + ' ' + columnName + '...'
        ));
      }
      Object.keys(options).map(function (key) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: key, value: key },
          options[key] + ''
        ));
      });
      return optionTags;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.selectInput.value;
      if (value) {
        this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selectClass = (0, _classnames2.default)('filter', 'select-filter', 'form-control', { 'placeholder-selected': this.state.isPlaceholderSelected });

      return _react2.default.createElement(
        'select',
        { ref: function ref(n) {
            return _this2.selectInput = n;
          },
          style: this.props.style,
          className: selectClass,
          onChange: this.filter,
          defaultValue: this.props.defaultValue !== undefined ? this.props.defaultValue : '' },
        this.getOptions()
      );
    }
  }]);

  return SelectFilter;
}(_react.Component);

SelectFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.object.isRequired,
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
};

var _default = SelectFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(optionsEquals, 'optionsEquals', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');

  __REACT_HOT_LOADER__.register(SelectFilter, 'SelectFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');
}();

;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var legalComparators = ['=', '>', '>=', '<', '<=', '!='];

var NumberFilter = function (_Component) {
  _inherits(NumberFilter, _Component);

  function NumberFilter(props) {
    _classCallCheck(this, NumberFilter);

    var _this = _possibleConstructorReturn(this, (NumberFilter.__proto__ || Object.getPrototypeOf(NumberFilter)).call(this, props));

    _this.numberComparators = _this.props.numberComparators || legalComparators;
    _this.timeout = null;
    _this.state = {
      isPlaceholderSelected: _this.props.defaultValue === undefined || _this.props.defaultValue.number === undefined || _this.props.options && _this.props.options.indexOf(_this.props.defaultValue.number) === -1
    };
    _this.onChangeNumber = _this.onChangeNumber.bind(_this);
    _this.onChangeNumberSet = _this.onChangeNumberSet.bind(_this);
    _this.onChangeComparator = _this.onChangeComparator.bind(_this);
    return _this;
  }

  _createClass(NumberFilter, [{
    key: 'onChangeNumber',
    value: function onChangeNumber(event) {
      var _this2 = this;

      var comparator = this.numberFilterComparator.value;
      if (comparator === '') {
        return;
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler({ number: filterValue, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
      }, this.props.delay);
    }
  }, {
    key: 'onChangeNumberSet',
    value: function onChangeNumberSet(event) {
      var comparator = this.numberFilterComparator.value;
      var value = event.target.value;

      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      if (comparator === '') {
        return;
      }
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'onChangeComparator',
    value: function onChangeComparator(event) {
      var value = this.numberFilter.value;
      var comparator = event.target.value;
      if (value === '') {
        return;
      }
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue.number : '';
      var comparator = this.props.defaultValue ? this.props.defaultValue.comparator : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.numberFilterComparator.value = comparator;
      this.numberFilter.value = value;
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterObj) {
      var number = filterObj.number,
          comparator = filterObj.comparator;

      this.setState(function () {
        return { isPlaceholderSelected: number === '' };
      });
      this.numberFilterComparator.value = comparator;
      this.numberFilter.value = number;
      this.props.filterHandler({ number: number, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'getComparatorOptions',
    value: function getComparatorOptions() {
      var optionTags = [];
      var withoutEmptyComparatorOption = this.props.withoutEmptyComparatorOption;

      if (!withoutEmptyComparatorOption) {
        optionTags.push(_react2.default.createElement('option', { key: '-1' }));
      }
      for (var i = 0; i < this.numberComparators.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: this.numberComparators[i] },
          this.numberComparators[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'getNumberOptions',
    value: function getNumberOptions() {
      var optionTags = [];
      var _props = this.props,
          options = _props.options,
          withoutEmptyNumberOption = _props.withoutEmptyNumberOption;

      if (!withoutEmptyNumberOption) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: '-1', value: '' },
          this.props.placeholder || 'Select ' + this.props.columnName + '...'
        ));
      }
      for (var i = 0; i < options.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: options[i] },
          options[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var comparator = this.numberFilterComparator.value;
      var number = this.numberFilter.value;
      if (comparator && number) {
        this.props.filterHandler({ number: number, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var selectClass = (0, _classnames2.default)('select-filter', 'number-filter-input', 'form-control', { 'placeholder-selected': this.state.isPlaceholderSelected });

      return _react2.default.createElement(
        'div',
        { className: 'filter number-filter' },
        _react2.default.createElement(
          'select',
          { ref: function ref(n) {
              return _this3.numberFilterComparator = n;
            },
            style: this.props.style.comparator,
            className: 'number-filter-comparator form-control',
            onChange: this.onChangeComparator,
            defaultValue: this.props.defaultValue ? this.props.defaultValue.comparator : '' },
          this.getComparatorOptions()
        ),
        this.props.options ? _react2.default.createElement(
          'select',
          { ref: function ref(n) {
              return _this3.numberFilter = n;
            },
            className: selectClass,
            onChange: this.onChangeNumberSet,
            defaultValue: this.props.defaultValue ? this.props.defaultValue.number : '' },
          this.getNumberOptions()
        ) : _react2.default.createElement('input', { ref: function ref(n) {
            return _this3.numberFilter = n;
          },
          type: 'number',
          style: this.props.style.number,
          className: 'number-filter-input form-control',
          placeholder: this.props.placeholder || 'Enter ' + this.props.columnName + '...',
          onChange: this.onChangeNumber,
          defaultValue: this.props.defaultValue ? this.props.defaultValue.number : '' })
      );
    }
  }]);

  return NumberFilter;
}(_react.Component);

NumberFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.number),
  defaultValue: _propTypes2.default.shape({
    number: _propTypes2.default.number,
    comparator: _propTypes2.default.oneOf(legalComparators)
  }),
  style: _propTypes2.default.shape({
    number: _propTypes2.default.oneOfType([_propTypes2.default.object]),
    comparator: _propTypes2.default.oneOfType([_propTypes2.default.object])
  }),
  delay: _propTypes2.default.number,
  /* eslint consistent-return: 0 */
  numberComparators: function numberComparators(props, propName) {
    if (!props[propName]) {
      return;
    }
    for (var i = 0; i < props[propName].length; i++) {
      var comparatorIsValid = false;
      for (var j = 0; j < legalComparators.length; j++) {
        if (legalComparators[j] === props[propName][i]) {
          comparatorIsValid = true;
          break;
        }
      }
      if (!comparatorIsValid) {
        return new Error('Number comparator provided is not supported.\n          Use only ' + legalComparators);
      }
    }
  },
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  withoutEmptyComparatorOption: _propTypes2.default.bool,
  withoutEmptyNumberOption: _propTypes2.default.bool
};

NumberFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY,
  withoutEmptyComparatorOption: false,
  withoutEmptyNumberOption: false,
  style: {
    number: null,
    comparator: null
  }
};

var _default = NumberFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(legalComparators, 'legalComparators', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');

  __REACT_HOT_LOADER__.register(NumberFilter, 'NumberFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');
}();

;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _SelectRowHeaderColumn = __webpack_require__(444);

var _SelectRowHeaderColumn2 = _interopRequireDefault(_SelectRowHeaderColumn);

var _ExpandRowHeaderColumn = __webpack_require__(445);

var _ExpandRowHeaderColumn2 = _interopRequireDefault(_ExpandRowHeaderColumn);

var _util = __webpack_require__(24);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.update(this.props.checked);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.update(props.checked);
    }
  }, {
    key: 'update',
    value: function update(checked) {
      _reactDom2.default.findDOMNode(this).indeterminate = checked === 'indeterminate';
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('input', { className: 'react-bs-select-all',
        type: 'checkbox',
        checked: this.props.checked,
        onChange: this.props.onChange });
    }
  }]);

  return Checkbox;
}(_react.Component);

function getSortOrder(sortList, field, enableSort) {
  if (!enableSort) return undefined;
  var result = sortList.filter(function (sortObj) {
    return sortObj.sortField === field;
  });
  if (result.length > 0) {
    return result[0].order;
  } else {
    return undefined;
  }
}

var TableHeader = function (_Component2) {
  _inherits(TableHeader, _Component2);

  function TableHeader() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, TableHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call.apply(_ref, [this].concat(args))), _this2), _this2.getHeaderColGrouop = function () {
      var _this3;

      return (_this3 = _this2).__getHeaderColGrouop__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(TableHeader, [{
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          sortIndicator = _props.sortIndicator,
          sortList = _props.sortList,
          onSort = _props.onSort,
          reset = _props.reset,
          version = _props.version,
          condensed = _props.condensed,
          bordered = _props.bordered,
          expandedColumnHeaderComponent = _props.expandedColumnHeaderComponent,
          noAnyExpand = _props.noAnyExpand,
          toggleExpandAllChilds = _props.toggleExpandAllChilds,
          expandAll = _props.expandAll;

      var containerClasses = (0, _classnames2.default)('react-bs-container-header', 'table-header-wrapper', this.props.headerContainerClass);
      var customTableClasses = {
        'table-bordered': bordered
      };
      if (condensed) {
        if (_util2.default.isBootstrap4(version)) customTableClasses['table-sm'] = true;else customTableClasses['table-condensed'] = true;
      }
      var tableClasses = (0, _classnames2.default)('table', 'table-hover', customTableClasses, this.props.tableHeaderClass);

      var rowCount = Math.max.apply(Math, _toConsumableArray(_react2.default.Children.map(this.props.children, function (elm) {
        return elm && elm.props.row ? Number(elm.props.row) : 0;
      })));

      var rows = [];
      var rowKey = 0;

      rows[0] = [];
      rows[0].push([this.props.expandColumnVisible && this.props.expandColumnBeforeSelectColumn && _react2.default.createElement(_ExpandRowHeaderColumn2.default, { key: 'expandCol', rowCount: rowCount + 1,
        expandedColumnHeaderComponent: expandedColumnHeaderComponent,
        noAnyExpand: noAnyExpand,
        expandAll: expandAll,
        toggleExpandAllChilds: toggleExpandAllChilds })], [this.renderSelectRowHeader(rowCount + 1, rowKey++)], [this.props.expandColumnVisible && !this.props.expandColumnBeforeSelectColumn && _react2.default.createElement(_ExpandRowHeaderColumn2.default, { key: 'expandCol', rowCount: rowCount + 1,
        expandedColumnHeaderComponent: expandedColumnHeaderComponent,
        noAnyExpand: noAnyExpand,
        expandAll: expandAll,
        toggleExpandAllChilds: toggleExpandAllChilds })]);

      _react2.default.Children.forEach(this.props.children, function (elm) {
        if (elm === null || elm === undefined) {
          // Skip null or undefined elements.
          return;
        }
        var _elm$props = elm.props,
            dataField = _elm$props.dataField,
            dataSort = _elm$props.dataSort;

        var sort = getSortOrder(sortList, dataField, dataSort);
        var rowIndex = elm.props.row ? Number(elm.props.row) : 0;
        var rowSpan = elm.props.rowSpan ? Number(elm.props.rowSpan) : 1;
        if (rows[rowIndex] === undefined) {
          rows[rowIndex] = [];
        }
        if (rowSpan + rowIndex === rowCount + 1) {
          rows[rowIndex].push(_react2.default.cloneElement(elm, { reset: reset, key: rowKey++, onSort: onSort, sort: sort, sortIndicator: sortIndicator, isOnlyHead: false, version: version }));
        } else {
          rows[rowIndex].push(_react2.default.cloneElement(elm, { key: rowKey++, isOnlyHead: true, version: version }));
        }
      });

      var trs = rows.map(function (row, indexRow) {
        return _react2.default.createElement(
          'tr',
          { key: indexRow },
          row
        );
      });

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(node) {
            return _this4.container = node;
          },
          className: containerClasses,
          style: this.props.style },
        _react2.default.createElement(
          'table',
          { className: tableClasses },
          _react2.default.cloneElement(this.props.colGroups, { ref: function ref(node) {
              return _this4.headerGrp = node;
            } }),
          _react2.default.createElement(
            'thead',
            { ref: function ref(node) {
                return _this4.header = node;
              } },
            trs
          )
        )
      );
    }
  }, {
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.headerGrp.childNodes;
    }
  }, {
    key: 'renderSelectRowHeader',
    value: function renderSelectRowHeader(rowCount, rowKey) {
      if (this.props.hideSelectColumn) {
        return null;
      } else if (this.props.customComponent) {
        var CustomComponent = this.props.customComponent;
        return _react2.default.createElement(
          _SelectRowHeaderColumn2.default,
          { key: rowKey, rowCount: rowCount },
          _react2.default.createElement(CustomComponent, { type: 'checkbox', checked: this.props.isSelectAll,
            indeterminate: this.props.isSelectAll === 'indeterminate', disabled: false,
            onChange: this.props.onSelectAllRow, rowIndex: 'Header' })
        );
      } else if (this.props.rowSelectType === _Const2.default.ROW_SELECT_SINGLE) {
        return _react2.default.createElement(_SelectRowHeaderColumn2.default, { key: rowKey, rowCount: rowCount });
      } else if (this.props.rowSelectType === _Const2.default.ROW_SELECT_MULTI) {
        return _react2.default.createElement(
          _SelectRowHeaderColumn2.default,
          { key: rowKey, rowCount: rowCount },
          _react2.default.createElement(Checkbox, {
            onChange: this.props.onSelectAllRow,
            checked: this.props.isSelectAll })
        );
      } else {
        return null;
      }
    }
  }]);

  return TableHeader;
}(_react.Component);

TableHeader.propTypes = {
  headerContainerClass: _propTypes2.default.string,
  tableHeaderClass: _propTypes2.default.string,
  style: _propTypes2.default.object,
  rowSelectType: _propTypes2.default.string,
  onSort: _propTypes2.default.func,
  onSelectAllRow: _propTypes2.default.func,
  sortList: _propTypes2.default.array,
  hideSelectColumn: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  isFiltered: _propTypes2.default.bool,
  isSelectAll: _propTypes2.default.oneOf([true, 'indeterminate', false]),
  sortIndicator: _propTypes2.default.bool,
  customComponent: _propTypes2.default.func,
  colGroups: _propTypes2.default.element,
  reset: _propTypes2.default.bool,
  expandColumnVisible: _propTypes2.default.bool,
  expandColumnComponent: _propTypes2.default.func,
  expandedColumnHeaderComponent: _propTypes2.default.func,
  expandColumnBeforeSelectColumn: _propTypes2.default.bool,
  version: _propTypes2.default.string,
  noAnyExpand: _propTypes2.default.bool,
  expandAll: _propTypes2.default.bool,
  toggleExpandAllChilds: _propTypes2.default.func
};

var _default = TableHeader;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Checkbox, 'Checkbox', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(getSortOrder, 'getSortOrder', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(TableHeader, 'TableHeader', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');
}();

;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectRowHeaderColumn = function (_Component) {
  _inherits(SelectRowHeaderColumn, _Component);

  function SelectRowHeaderColumn() {
    _classCallCheck(this, SelectRowHeaderColumn);

    return _possibleConstructorReturn(this, (SelectRowHeaderColumn.__proto__ || Object.getPrototypeOf(SelectRowHeaderColumn)).apply(this, arguments));
  }

  _createClass(SelectRowHeaderColumn, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'th',
        { rowSpan: this.props.rowCount, style: { textAlign: 'center' },
          'data-is-only-head': false },
        this.props.children
      );
    }
  }]);

  return SelectRowHeaderColumn;
}(_react.Component);

SelectRowHeaderColumn.propTypes = {
  children: _propTypes2.default.node,
  rowCount: _propTypes2.default.number
};
var _default = SelectRowHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SelectRowHeaderColumn, 'SelectRowHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/SelectRowHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/SelectRowHeaderColumn.js');
}();

;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExpandRowHeaderColumn = function (_Component) {
  _inherits(ExpandRowHeaderColumn, _Component);

  function ExpandRowHeaderColumn(props) {
    _classCallCheck(this, ExpandRowHeaderColumn);

    var _this = _possibleConstructorReturn(this, (ExpandRowHeaderColumn.__proto__ || Object.getPrototypeOf(ExpandRowHeaderColumn)).call(this, props));

    _this.toggleExpandAllChilds = _this.toggleExpandAllChilds.bind(_this);
    return _this;
  }

  _createClass(ExpandRowHeaderColumn, [{
    key: 'toggleExpandAllChilds',
    value: function toggleExpandAllChilds() {
      this.props.toggleExpandAllChilds();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          expandedColumnHeaderComponent = _props.expandedColumnHeaderComponent,
          noAnyExpand = _props.noAnyExpand,
          expandAll = _props.expandAll;

      var expandedHeaderComponent = noAnyExpand ? _react2.default.createElement('span', { className: 'fa fa-plus glyphicon glyphicon-plus' }) : _react2.default.createElement('span', { className: 'fa fa-minus glyphicon glyphicon-minus' });
      var ExpandedColumnHeaderComponent = expandedColumnHeaderComponent;

      return _react2.default.createElement(
        'th',
        { rowSpan: this.props.rowCount, style: { textAlign: 'center' },
          className: 'react-bs-table-expand-cell',
          'data-is-only-head': false },
        expandAll ? _react2.default.createElement(
          'div',
          { onClick: this.toggleExpandAllChilds },
          expandedColumnHeaderComponent ? _react2.default.createElement(ExpandedColumnHeaderComponent, {
            anyExpand: !noAnyExpand }) : expandedHeaderComponent
        ) : null
      );
    }
  }]);

  return ExpandRowHeaderColumn;
}(_react.Component);

ExpandRowHeaderColumn.propTypes = {
  expandedColumnHeaderComponent: _propTypes2.default.func,
  rowCount: _propTypes2.default.number,
  noAnyExpand: _propTypes2.default.bool,
  expandAll: _propTypes2.default.bool,
  toggleExpandAllChilds: _propTypes2.default.func
};
var _default = ExpandRowHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExpandRowHeaderColumn, 'ExpandRowHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandRowHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandRowHeaderColumn.js');
}();

;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableFooter = function (_Component) {
  _inherits(TableFooter, _Component);

  function TableFooter() {
    _classCallCheck(this, TableFooter);

    return _possibleConstructorReturn(this, (TableFooter.__proto__ || Object.getPrototypeOf(TableFooter)).apply(this, arguments));
  }

  _createClass(TableFooter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          hideSelectColumn = _props.hideSelectColumn,
          expandColumnVisible = _props.expandColumnVisible;

      var containerClasses = (0, _classnames2.default)('react-bs-container-footer', 'table-footer-wrapper');
      var tableClasses = (0, _classnames2.default)('table', 'table-hover', {
        'table-bordered': this.props.bordered,
        'table-condensed': this.props.condensed
      }, this.props.tableFooterClass);
      return _react2.default.createElement(
        'div',
        {
          ref: function ref(node) {
            return _this2.container = node;
          },
          className: containerClasses,
          style: this.props.style },
        this.props.children.map(function (footerItem, footerItemIndex) {
          return _react2.default.createElement(
            'span',
            { key: footerItemIndex },
            _react2.default.createElement(
              'table',
              { className: tableClasses },
              _react2.default.cloneElement(_this2.props.colGroups),
              _react2.default.createElement(
                'tfoot',
                null,
                _react2.default.createElement(
                  'tr',
                  { ref: function ref(node) {
                      return _this2.footer = node;
                    } },
                  hideSelectColumn ? null : _this2.renderSelectionOrExpandCol(),
                  !expandColumnVisible ? null : _this2.renderSelectionOrExpandCol(),
                  _this2.props.columns.map(function (columnItem, colIndex) {
                    if (!columnItem.hidden) {
                      var footerObj = footerItem.filter(function (item) {
                        return item.columnIndex === colIndex;
                      });
                      var footerData = void 0;
                      var thAlignment = 'left';
                      if (footerObj.length) {
                        thAlignment = footerObj[0].align;
                        if (footerObj[0].formatter) {
                          footerData = footerObj[0].formatter(_this2.props.footerFormatterReturnData);
                        } else {
                          footerData = footerObj[0].label;
                        }
                      } else {
                        footerData = '';
                      }
                      return _react2.default.createElement(
                        'th',
                        {
                          key: colIndex,
                          style: {
                            minWidth: _this2.props.columns[colIndex].width + 'px',
                            textAlign: thAlignment
                          } },
                        footerData
                      );
                    }
                  })
                )
              )
            )
          );
        })
      );
    }
  }, {
    key: 'renderSelectionOrExpandCol',
    value: function renderSelectionOrExpandCol() {
      return _react2.default.createElement('th', null);
    }
  }]);

  return TableFooter;
}(_react.Component);

TableFooter.propTypes = {
  tableHeaderClass: _propTypes2.default.string,
  style: _propTypes2.default.object,
  hideSelectColumn: _propTypes2.default.bool,
  expandColumnVisible: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  isFiltered: _propTypes2.default.bool,
  sortIndicator: _propTypes2.default.bool
};

var _default = TableFooter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableFooter, 'TableFooter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFooter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFooter.js');
}();

;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = __webpack_require__(24);

var _util2 = _interopRequireDefault(_util);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

var _TableRow = __webpack_require__(448);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableColumn = __webpack_require__(449);

var _TableColumn2 = _interopRequireDefault(_TableColumn);

var _TableEditColumn = __webpack_require__(450);

var _TableEditColumn2 = _interopRequireDefault(_TableEditColumn);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _ExpandComponent = __webpack_require__(451);

var _ExpandComponent2 = _interopRequireDefault(_ExpandComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableBody = function (_Component) {
  _inherits(TableBody, _Component);

  function TableBody(props) {
    _classCallCheck(this, TableBody);

    var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this, props));

    _this.handleCellKeyDown = function () {
      return _this.__handleCellKeyDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOut = function () {
      return _this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOver = function () {
      return _this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowClick = function () {
      return _this.__handleRowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowDoubleClick = function () {
      return _this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRow = function () {
      return _this.__handleSelectRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRowColumChange = function () {
      return _this.__handleSelectRowColumChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClickCell = function () {
      return _this.__handleClickCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleEditCell = function () {
      return _this.__handleEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.nextEditableCell = function () {
      return _this.__nextEditableCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCompleteEditCell = function () {
      return _this.__handleCompleteEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.cancelEditCell = function () {
      return _this.__cancelEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClickonSelectColumn = function () {
      return _this.__handleClickonSelectColumn__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getHeaderColGrouop = function () {
      return _this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = {
      currEditCell: null
    };
    return _this;
  }

  _createClass(TableBody, [{
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleClickonSelectColumn__REACT_HOT_LOADER__',
    value: function __handleClickonSelectColumn__REACT_HOT_LOADER__() {
      return this.__handleClickonSelectColumn__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__cancelEditCell__REACT_HOT_LOADER__',
    value: function __cancelEditCell__REACT_HOT_LOADER__() {
      return this.__cancelEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCompleteEditCell__REACT_HOT_LOADER__',
    value: function __handleCompleteEditCell__REACT_HOT_LOADER__() {
      return this.__handleCompleteEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__nextEditableCell__REACT_HOT_LOADER__',
    value: function __nextEditableCell__REACT_HOT_LOADER__() {
      return this.__nextEditableCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__() {
      return this.__handleEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleClickCell__REACT_HOT_LOADER__',
    value: function __handleClickCell__REACT_HOT_LOADER__() {
      return this.__handleClickCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectRowColumChange__REACT_HOT_LOADER__',
    value: function __handleSelectRowColumChange__REACT_HOT_LOADER__() {
      return this.__handleSelectRowColumChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__() {
      return this.__handleSelectRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__() {
      return this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__() {
      return this.__handleRowClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCellKeyDown__REACT_HOT_LOADER__',
    value: function __handleCellKeyDown__REACT_HOT_LOADER__() {
      return this.__handleCellKeyDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          cellEdit = _props.cellEdit,
          beforeShowError = _props.beforeShowError,
          x = _props.x,
          y = _props.y,
          keyBoardNav = _props.keyBoardNav,
          trStyle = _props.trStyle,
          version = _props.version;

      var customTableClasses = {
        'table-striped': this.props.striped,
        'table-bordered': this.props.bordered,
        'table-hover': this.props.hover
      };
      if (this.props.condensed) {
        if (_util2.default.isBootstrap4(version)) customTableClasses['table-sm'] = true;else customTableClasses['table-condensed'] = true;
      }
      var tableClasses = (0, _classnames2.default)('table', customTableClasses, this.props.tableBodyClass);

      var noneditableRows = cellEdit.nonEditableRows && cellEdit.nonEditableRows() || [];
      var unselectable = this.props.selectRow.unselectable || [];
      var isSelectRowDefined = _util2.default.isSelectRowDefined(this.props.selectRow.mode);
      var tableHeader = _util2.default.renderColGroup(this.props.columns, this.props.selectRow, this.props.expandColumnOptions, version);
      var inputType = this.props.selectRow.mode === _Const2.default.ROW_SELECT_SINGLE ? 'radio' : 'checkbox';
      var CustomComponent = this.props.selectRow.customComponent;
      var enableKeyBoardNav = keyBoardNav === true || (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object';
      var customEditAndNavStyle = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.customStyleOnEditCell : null;
      var customNavStyle = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.customStyle : null;
      var ExpandColumnCustomComponent = this.props.expandColumnOptions.expandColumnComponent;
      var expandColSpan = this.props.columns.filter(function (col) {
        return col && !col.hidden;
      }).length;
      if (isSelectRowDefined && !this.props.selectRow.hideSelectColumn) {
        expandColSpan += 1;
      }
      var tabIndex = 1;
      if (this.props.expandColumnOptions.expandColumnVisible) {
        expandColSpan += 1;
      }

      var tableRows = this.props.data.map(function (data, r) {
        var tableColumns = this.props.columns.filter(function (_) {
          return _ != null;
        }).map(function (column, i) {
          var fieldValue = data[column.name];
          var isFocusCell = r === y && i === x;
          if (column.name !== this.props.keyField && // Key field can't be edit
          column.editable && // column is editable? default is true, user can set it false
          column.editable.readOnly !== true && this.state.currEditCell !== null && this.state.currEditCell.rid === r && this.state.currEditCell.cid === i && noneditableRows.indexOf(data[this.props.keyField]) === -1) {
            var editable = column.editable;
            var format = column.format ? function (value) {
              return column.format(value, data, column.formatExtraData, r).replace(/<.*?>/g, '');
            } : false;
            if (_util2.default.isFunction(column.editable)) {
              editable = column.editable(fieldValue, data, r, i);
            }

            return _react2.default.createElement(_TableEditColumn2.default, {
              completeEdit: this.handleCompleteEditCell
              // add by bluespring for column editor customize
              , editable: editable,
              attrs: column.editAttrs,
              customEditor: column.customEditor,
              format: column.format ? format : false,
              key: i,
              blurToSave: cellEdit.blurToSave,
              blurToEscape: cellEdit.blurToEscape,
              onTab: this.handleEditCell,
              rowIndex: r,
              colIndex: i,
              row: data,
              fieldValue: fieldValue,
              className: column.editClassName,
              invalidColumnClassName: column.invalidEditColumnClassName,
              beforeShowError: beforeShowError,
              isFocus: isFocusCell,
              customStyleWithNav: customEditAndNavStyle });
          } else {
            // add by bluespring for className customize
            var formattedValue = void 0;
            var columnChild = fieldValue && fieldValue.toString();
            var columnTitle = null;
            var tdClassName = column.className;
            var tdStyles = column.style;
            if (_util2.default.isFunction(column.className)) {
              tdClassName = column.className(fieldValue, data, r, i);
            }

            if (_util2.default.isFunction(column.style)) {
              tdStyles = column.style(fieldValue, data, r, i);
            }

            if (typeof column.format !== 'undefined') {
              formattedValue = column.format(fieldValue, data, column.formatExtraData, r);
              if (!_react2.default.isValidElement(formattedValue)) {
                columnChild = _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: formattedValue } });
              } else {
                columnChild = formattedValue;
              }
            }
            if (_util2.default.isFunction(column.columnTitle)) {
              columnTitle = column.columnTitle(fieldValue, data, r, i);
            } else if (typeof column.columnTitle === 'string') {
              columnTitle = column.columnTitle;
            } else if (column.columnTitle) {
              if (formattedValue) columnTitle = formattedValue.toString();else if (fieldValue) columnTitle = fieldValue.toString();
            }
            return _react2.default.createElement(
              _TableColumn2.default,
              { key: i,
                cIndex: i,
                rIndex: r,
                dataAlign: column.align,
                className: tdClassName,
                columnTitle: columnTitle,
                cellEdit: cellEdit,
                hidden: column.hidden,
                onEdit: this.handleEditCell,
                width: column.width,
                onClick: this.handleClickCell,
                attrs: column.attrs,
                style: tdStyles,
                tabIndex: tabIndex++ + '',
                isFocus: isFocusCell,
                keyBoardNav: enableKeyBoardNav,
                onKeyDown: this.handleCellKeyDown,
                customNavStyle: customNavStyle,
                row: data,
                withoutTabIndex: this.props.withoutTabIndex },
              columnChild
            );
          }
        }, this);
        var key = data[this.props.keyField];
        var disable = unselectable.indexOf(key) !== -1;
        var selected = this.props.selectedRowKeys.indexOf(key) !== -1;
        var selectRowColumn = isSelectRowDefined && !this.props.selectRow.hideSelectColumn ? this.renderSelectRowColumn(selected, inputType, disable, CustomComponent, r, data) : null;
        var expandedRowColumn = this.renderExpandRowColumn(this.props.expandableRow && this.props.expandableRow(data), this.props.expanding.indexOf(key) > -1, ExpandColumnCustomComponent, r);
        var haveExpandContent = this.props.expandableRow && this.props.expandableRow(data);
        var isExpanding = haveExpandContent && this.props.expanding.indexOf(key) > -1;
        var hideRowOnExpand = this.props.hideRowOnExpand;
        // add by bluespring for className customize

        var trClassName = this.props.trClassName;
        if (_util2.default.isFunction(this.props.trClassName)) {
          trClassName = this.props.trClassName(data, r);
        }
        if (isExpanding && this.props.expandParentClass) {
          trClassName += _util2.default.isFunction(this.props.expandParentClass) ? ' ' + this.props.expandParentClass(data, r) : ' ' + this.props.expandParentClass;
        }
        var result = [_react2.default.createElement(
          _TableRow2.default,
          { isSelected: selected, key: key, className: trClassName,
            index: r,
            row: data,
            selectRow: isSelectRowDefined ? this.props.selectRow : undefined,
            enableCellEdit: cellEdit.mode !== _Const2.default.CELL_EDIT_NONE,
            onRowClick: this.handleRowClick,
            onRowDoubleClick: this.handleRowDoubleClick,
            onRowMouseOver: this.handleRowMouseOver,
            onRowMouseOut: this.handleRowMouseOut,
            onSelectRow: this.handleSelectRow,
            onExpandRow: this.handleClickCell,
            unselectableRow: disable,
            style: trStyle,
            hidden: isExpanding && hideRowOnExpand,
            dbClickToEdit: cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK },
          this.props.expandColumnOptions.expandColumnVisible && this.props.expandColumnOptions.expandColumnBeforeSelectColumn && expandedRowColumn,
          selectRowColumn,
          this.props.expandColumnOptions.expandColumnVisible && !this.props.expandColumnOptions.expandColumnBeforeSelectColumn && expandedRowColumn,
          tableColumns
        )];

        if (haveExpandContent) {
          var expandBodyClass = _util2.default.isFunction(this.props.expandBodyClass) ? this.props.expandBodyClass(data, r, isExpanding) : this.props.expandBodyClass;
          result.push(_react2.default.createElement(
            _ExpandComponent2.default,
            {
              key: key + '-expand',
              row: data,
              className: expandBodyClass,
              bgColor: this.props.expandRowBgColor || this.props.selectRow.bgColor || undefined,
              hidden: !isExpanding,
              colSpan: expandColSpan,
              width: "100%" },
            this.props.expandComponent(data)
          ));
        }
        return result;
      }, this);

      if (tableRows.length === 0 && !this.props.withoutNoDataText) {
        var colSpan = this.props.columns.filter(function (c) {
          return !c.hidden;
        }).length + (isSelectRowDefined && !this.props.selectRow.hideSelectColumn ? 1 : 0) + (this.props.expandColumnOptions.expandColumnVisible ? 1 : 0);
        tableRows = [_react2.default.createElement(
          _TableRow2.default,
          { key: '##table-empty##', style: trStyle },
          _react2.default.createElement(
            'td',
            { 'data-toggle': 'collapse',
              colSpan: colSpan,
              className: 'react-bs-table-no-data' },
            this.props.noDataText || _Const2.default.NO_DATA_TEXT
          )
        )];
      }

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(node) {
            return _this2.container = node;
          },
          className: (0, _classnames2.default)('react-bs-container-body', this.props.bodyContainerClass),
          style: this.props.style },
        _react2.default.createElement(
          'table',
          { className: tableClasses },
          _react2.default.cloneElement(tableHeader, { ref: function ref(node) {
              return _this2.header = node;
            } }),
          _react2.default.createElement(
            'tbody',
            { ref: function ref(node) {
                return _this2.tbody = node;
              } },
            tableRows
          )
        )
      );
    }
  }, {
    key: '__handleCellKeyDown__REACT_HOT_LOADER__',
    value: function __handleCellKeyDown__REACT_HOT_LOADER__(e, lastEditCell) {
      e.preventDefault();
      var _props2 = this.props,
          keyBoardNav = _props2.keyBoardNav,
          onNavigateCell = _props2.onNavigateCell,
          cellEdit = _props2.cellEdit,
          selectedRowKeys = _props2.selectedRowKeys;

      var offset = void 0;
      if (e.keyCode === 37) {
        offset = { x: -1, y: 0 };
      } else if (e.keyCode === 38) {
        offset = { x: 0, y: -1 };
      } else if (e.keyCode === 39 || e.keyCode === 9) {
        offset = { x: 1, y: 0 };
        if (e.keyCode === 9 && lastEditCell) {
          offset = _extends({}, offset, {
            lastEditCell: lastEditCell
          });
        }
      } else if (e.keyCode === 40) {
        offset = { x: 0, y: 1 };
      } else if (e.keyCode === 13) {
        var rowIndex = e.target.parentElement.rowIndex + 1;
        var enterToEdit = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToEdit : false;
        var enterToExpand = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToExpand : false;
        var enterToSelect = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToSelect : false;

        if (cellEdit && enterToEdit) {
          this.handleEditCell(rowIndex, e.currentTarget.cellIndex, '', e);
        }

        if (enterToExpand) {
          this.handleClickCell(e, this.props.y + 1, this.props.x);
        }

        if (enterToSelect) {
          var isSelected = selectedRowKeys.indexOf(this.props.data[rowIndex - 1][this.props.keyField]) !== -1;
          this.handleSelectRow(rowIndex, !isSelected, e);
        }
      }
      if (offset && keyBoardNav) {
        onNavigateCell(offset);
      }
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__(rowIndex, event) {
      var targetRow = this.props.data[rowIndex];
      this.props.onRowMouseOut(targetRow, event);
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__(rowIndex, event) {
      var targetRow = this.props.data[rowIndex];
      this.props.onRowMouseOver(targetRow, event);
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__(rowIndex, cellIndex, event) {
      var _props3 = this.props,
          onRowClick = _props3.onRowClick,
          selectRow = _props3.selectRow;

      if (_util2.default.isSelectRowDefined(selectRow.mode)) cellIndex--;
      if (this._isExpandColumnVisible()) cellIndex--;
      onRowClick(this.props.data[rowIndex - 1], rowIndex - 1, cellIndex, event);
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__(rowIndex, event) {
      var onRowDoubleClick = this.props.onRowDoubleClick;

      var targetRow = this.props.data[rowIndex];
      onRowDoubleClick(targetRow, event);
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__(rowIndex, isSelected, e) {
      var selectedRow = void 0;
      var _props4 = this.props,
          data = _props4.data,
          onSelectRow = _props4.onSelectRow;

      data.forEach(function (row, i) {
        if (i === rowIndex - 1) {
          selectedRow = row;
          return false;
        }
      });
      onSelectRow(selectedRow, isSelected, e, rowIndex - 1);
    }
  }, {
    key: '__handleSelectRowColumChange__REACT_HOT_LOADER__',
    value: function __handleSelectRowColumChange__REACT_HOT_LOADER__(e, rowIndex) {
      if (!this.props.selectRow.clickToSelect || !this.props.selectRow.clickToSelectAndEditCell) {
        this.handleSelectRow(rowIndex + 1, e.currentTarget.checked, e);
      }
    }
  }, {
    key: '__handleClickCell__REACT_HOT_LOADER__',
    value: function __handleClickCell__REACT_HOT_LOADER__(event, rowIndex) {
      var columnIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      var _props5 = this.props,
          columns = _props5.columns,
          keyField = _props5.keyField,
          expandBy = _props5.expandBy,
          expandableRow = _props5.expandableRow,
          _props5$selectRow = _props5.selectRow,
          mode = _props5$selectRow.mode,
          clickToExpand = _props5$selectRow.clickToExpand,
          hideSelectColumn = _props5$selectRow.hideSelectColumn,
          onlyOneExpanding = _props5.onlyOneExpanding;

      var isSelectRowDefined = _util2.default.isSelectRowDefined(mode);
      var selectRowAndExpand = isSelectRowDefined && !clickToExpand ? false : true;
      columnIndex = isSelectRowDefined && !hideSelectColumn ? columnIndex - 1 : columnIndex;
      columnIndex = this._isExpandColumnVisible() ? columnIndex - 1 : columnIndex;
      if (expandableRow && selectRowAndExpand && (expandBy === _Const2.default.EXPAND_BY_ROW ||
      /* Below will allow expanding trigger by clicking on selection column
      if configure as expanding by column */
      expandBy === _Const2.default.EXPAND_BY_COL && columnIndex < 0 || expandBy === _Const2.default.EXPAND_BY_COL && columns[columnIndex].expandable)) {
        var expanding = this.props.expanding;
        var rowKey = this.props.data[rowIndex - 1][keyField];
        var isRowExpanding = expanding.indexOf(rowKey) > -1;

        if (isRowExpanding) {
          // collapse
          expanding = expanding.filter(function (k) {
            return k !== rowKey;
          });
        } else {
          // expand
          if (onlyOneExpanding) expanding = [rowKey];else expanding.push(rowKey);
        }
        this.props.onExpand(expanding, rowKey, isRowExpanding, event);
      }
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__(rowIndex, columnIndex, action, e) {
      var selectRow = this.props.selectRow;

      var defineSelectRow = _util2.default.isSelectRowDefined(selectRow.mode);
      var expandColumnVisible = this._isExpandColumnVisible();
      if (defineSelectRow) {
        columnIndex--;
        if (selectRow.hideSelectColumn) columnIndex++;
      }
      if (expandColumnVisible) {
        columnIndex--;
      }
      rowIndex--;

      if (action === 'tab') {
        if (defineSelectRow && !selectRow.hideSelectColumn) columnIndex++;
        if (expandColumnVisible) columnIndex++;
        this.handleCompleteEditCell(e.target.value, rowIndex, columnIndex - 1);
        if (columnIndex >= this.props.columns.length) {
          this.handleCellKeyDown(e, true);
        } else {
          this.handleCellKeyDown(e);
        }

        var _nextEditableCell = this.nextEditableCell(rowIndex, columnIndex),
            nextRIndex = _nextEditableCell.nextRIndex,
            nextCIndex = _nextEditableCell.nextCIndex;

        rowIndex = nextRIndex;
        columnIndex = nextCIndex;
      }

      var stateObj = {
        currEditCell: {
          rid: rowIndex,
          cid: columnIndex
        }
      };

      if (this.props.selectRow.clickToSelectAndEditCell && this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_DBCLICK) {
        var selected = this.props.selectedRowKeys.indexOf(this.props.data[rowIndex][this.props.keyField]) !== -1;
        this.handleSelectRow(rowIndex + 1, !selected, e);
      }
      this.setState(function () {
        return stateObj;
      });
    }
  }, {
    key: '__nextEditableCell__REACT_HOT_LOADER__',
    value: function __nextEditableCell__REACT_HOT_LOADER__(rIndex, cIndex) {
      var keyField = this.props.keyField;

      var nextRIndex = rIndex;
      var nextCIndex = cIndex;
      var row = void 0;
      var column = void 0;
      do {
        if (nextCIndex >= this.props.columns.length) {
          nextRIndex++;
          nextCIndex = 0;
        }
        row = this.props.data[nextRIndex];
        column = this.props.columns[nextCIndex];
        if (!row) break;
        var editable = column.editable;
        if (_util2.default.isFunction(column.editable)) {
          editable = column.editable(column, row, nextRIndex, nextCIndex);
        }
        if (editable && editable.readOnly !== true && !column.hidden && keyField !== column.name) {
          break;
        } else {
          nextCIndex++;
        }
      } while (row);
      return { nextRIndex: nextRIndex, nextCIndex: nextCIndex };
    }
  }, {
    key: '__handleCompleteEditCell__REACT_HOT_LOADER__',
    value: function __handleCompleteEditCell__REACT_HOT_LOADER__(newVal, rowIndex, columnIndex) {
      if (newVal !== null) {
        var result = this.props.onEditCell(newVal, rowIndex, columnIndex);
        if (result !== _Const2.default.AWAIT_BEFORE_CELL_EDIT) {
          this.setState(function () {
            return { currEditCell: null };
          });
        }
      } else {
        this.setState(function () {
          return { currEditCell: null };
        });
      }
    }
  }, {
    key: '__cancelEditCell__REACT_HOT_LOADER__',
    value: function __cancelEditCell__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { currEditCell: null };
      });
    }
  }, {
    key: '__handleClickonSelectColumn__REACT_HOT_LOADER__',
    value: function __handleClickonSelectColumn__REACT_HOT_LOADER__(e, isSelect, rowIndex, row) {
      e.stopPropagation();
      if (e.target.tagName === 'TD' && (this.props.selectRow.clickToSelect || this.props.selectRow.clickToSelectAndEditCell)) {
        var unselectable = this.props.selectRow.unselectable || [];
        if (unselectable.indexOf(row[this.props.keyField]) === -1) {
          this.handleSelectRow(rowIndex + 1, isSelect, e);
          this.handleClickCell(e, rowIndex + 1);
        }
      }
    }
  }, {
    key: 'renderSelectRowColumn',
    value: function renderSelectRowColumn(selected, inputType, disabled) {
      var CustomComponent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var _this3 = this;

      var rowIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var row = arguments[5];

      return _react2.default.createElement(
        'td',
        { onClick: function onClick(e) {
            _this3.handleClickonSelectColumn(e, !selected, rowIndex, row);
          }, style: { textAlign: 'center' } },
        CustomComponent ? _react2.default.createElement(CustomComponent, { type: inputType, checked: selected, disabled: disabled,
          rowIndex: rowIndex,
          onChange: function onChange(e) {
            return _this3.handleSelectRowColumChange(e, rowIndex);
          } }) : _react2.default.createElement('input', { type: inputType, checked: selected, disabled: disabled,
          onChange: function onChange(e) {
            return _this3.handleSelectRowColumChange(e, rowIndex);
          } })
      );
    }
  }, {
    key: 'renderExpandRowColumn',
    value: function renderExpandRowColumn(isExpandableRow, isExpanded, CustomComponent) {
      var _this4 = this;

      var rowIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var content = null;
      if (CustomComponent) {
        content = _react2.default.createElement(CustomComponent, { isExpandableRow: isExpandableRow, isExpanded: isExpanded });
      } else if (isExpandableRow) {
        content = isExpanded ? _react2.default.createElement('span', { className: 'fa fa-minus glyphicon glyphicon-minus' }) : _react2.default.createElement('span', { className: 'fa fa-plus glyphicon glyphicon-plus' });
      } else {
        content = ' ';
      }

      return _react2.default.createElement(
        'td',
        {
          className: 'react-bs-table-expand-cell',
          onClick: function onClick(e) {
            return _this4.handleClickCell(e, rowIndex + 1);
          } },
        content
      );
    }
  }, {
    key: '_isExpandColumnVisible',
    value: function _isExpandColumnVisible() {
      return this.props.expandColumnOptions.expandColumnVisible;
    }
  }, {
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.header.childNodes;
    }
  }]);

  return TableBody;
}(_react.Component);

TableBody.propTypes = {
  version: _propTypes2.default.string,
  data: _propTypes2.default.array,
  columns: _propTypes2.default.array,
  striped: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  hover: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  keyField: _propTypes2.default.string,
  selectedRowKeys: _propTypes2.default.array,
  onRowClick: _propTypes2.default.func,
  onRowDoubleClick: _propTypes2.default.func,
  onSelectRow: _propTypes2.default.func,
  noDataText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  withoutNoDataText: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  tableBodyClass: _propTypes2.default.string,
  bodyContainerClass: _propTypes2.default.string,
  expandableRow: _propTypes2.default.func,
  expandComponent: _propTypes2.default.func,
  expandRowBgColor: _propTypes2.default.string,
  expandBy: _propTypes2.default.string,
  expanding: _propTypes2.default.array,
  onExpand: _propTypes2.default.func,
  expandBodyClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  expandParentClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  onlyOneExpanding: _propTypes2.default.bool,
  beforeShowError: _propTypes2.default.func,
  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  onNavigateCell: _propTypes2.default.func,
  withoutTabIndex: _propTypes2.default.bool,
  hideRowOnExpand: _propTypes2.default.bool
};
var _default = TableBody;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableBody, 'TableBody', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableBody.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableBody.js');
}();

;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = __webpack_require__(24);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var TableRow = function (_Component) {
  _inherits(TableRow, _Component);

  function TableRow(props) {
    _classCallCheck(this, TableRow);

    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));

    _this.rowClick = function () {
      return _this.__rowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.expandRow = function () {
      return _this.__expandRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowDoubleClick = function () {
      return _this.__rowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowMouseOut = function () {
      return _this.__rowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowMouseOver = function () {
      return _this.__rowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.clickNum = 0;
    return _this;
  }

  _createClass(TableRow, [{
    key: '__rowMouseOver__REACT_HOT_LOADER__',
    value: function __rowMouseOver__REACT_HOT_LOADER__() {
      return this.__rowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowMouseOut__REACT_HOT_LOADER__',
    value: function __rowMouseOut__REACT_HOT_LOADER__() {
      return this.__rowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowDoubleClick__REACT_HOT_LOADER__',
    value: function __rowDoubleClick__REACT_HOT_LOADER__() {
      return this.__rowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__expandRow__REACT_HOT_LOADER__',
    value: function __expandRow__REACT_HOT_LOADER__() {
      return this.__expandRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowClick__REACT_HOT_LOADER__',
    value: function __rowClick__REACT_HOT_LOADER__() {
      return this.__rowClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowClick__REACT_HOT_LOADER__',
    value: function __rowClick__REACT_HOT_LOADER__(e) {
      var _this2 = this;

      var rowIndex = this.props.index + 1;
      var cellIndex = e.target.cellIndex;
      if (this.props.onRowClick) this.props.onRowClick(rowIndex, cellIndex, e);
      var _props = this.props,
          selectRow = _props.selectRow,
          unselectableRow = _props.unselectableRow,
          isSelected = _props.isSelected,
          onSelectRow = _props.onSelectRow,
          onExpandRow = _props.onExpandRow,
          dbClickToEdit = _props.dbClickToEdit;

      if (selectRow) {
        if (selectRow.clickToSelect && !unselectableRow) {
          onSelectRow(rowIndex, !isSelected, e);
        } else if (selectRow.clickToSelectAndEditCell && !unselectableRow) {
          this.clickNum++;
          /** if clickToSelectAndEditCell is enabled,
           *  there should be a delay to prevent a selection changed when
           *  user dblick to edit cell on same row but different cell
          **/
          setTimeout(function () {
            if (_this2.clickNum === 1) {
              onSelectRow(rowIndex, !isSelected, e);
              onExpandRow(e, rowIndex, cellIndex);
            }
            _this2.clickNum = 0;
          }, 200);
        } else {
          if (dbClickToEdit) {
            this.expandRow(e, rowIndex, cellIndex);
          }
        }
      }
    }
  }, {
    key: '__expandRow__REACT_HOT_LOADER__',
    value: function __expandRow__REACT_HOT_LOADER__(event, rowIndex, cellIndex) {
      var _this3 = this;

      this.clickNum++;
      setTimeout(function () {
        if (_this3.clickNum === 1) {
          _this3.props.onExpandRow(event, rowIndex, cellIndex);
        }
        _this3.clickNum = 0;
      }, 200);
    }
  }, {
    key: '__rowDoubleClick__REACT_HOT_LOADER__',
    value: function __rowDoubleClick__REACT_HOT_LOADER__(e) {
      if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'SELECT' && e.target.tagName !== 'TEXTAREA') {
        if (this.props.onRowDoubleClick) {
          this.props.onRowDoubleClick(this.props.index, e);
        }
      }
    }
  }, {
    key: '__rowMouseOut__REACT_HOT_LOADER__',
    value: function __rowMouseOut__REACT_HOT_LOADER__(e) {
      var rowIndex = this.props.index;
      if (this.props.onRowMouseOut) {
        this.props.onRowMouseOut(rowIndex, e);
      }
    }
  }, {
    key: '__rowMouseOver__REACT_HOT_LOADER__',
    value: function __rowMouseOver__REACT_HOT_LOADER__(e) {
      var rowIndex = this.props.index;
      if (this.props.onRowMouseOver) {
        this.props.onRowMouseOver(rowIndex, e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      this.clickNum = 0;
      var _props2 = this.props,
          selectRow = _props2.selectRow,
          row = _props2.row,
          isSelected = _props2.isSelected,
          className = _props2.className,
          index = _props2.index,
          hidden = _props2.hidden;
      var style = this.props.style;

      var backgroundColor = null;
      var selectRowClass = null;

      if (selectRow) {
        backgroundColor = _util2.default.isFunction(selectRow.bgColor) ? selectRow.bgColor(row, isSelected) : isSelected ? selectRow.bgColor : null;

        selectRowClass = _util2.default.isFunction(selectRow.className) ? selectRow.className(row, isSelected) : isSelected ? selectRow.className : null;
      }

      if (_util2.default.isFunction(style)) {
        style = style(row, index);
      } else {
        style = _extends({}, style) || {};
      }
      // the bgcolor of row selection always overwrite the bgcolor defined by global.
      if (style && backgroundColor && isSelected) {
        style.backgroundColor = backgroundColor;
      }
      var trCss = {
        style: _extends({}, style),
        className: (0, _classnames2.default)(selectRowClass, className)
      };

      return _react2.default.createElement(
        'tr',
        _extends({}, trCss, {
          onMouseOver: this.rowMouseOver,
          onMouseOut: this.rowMouseOut,
          onClick: this.rowClick,
          hidden: hidden,
          onDoubleClick: this.rowDoubleClick }),
        this.props.children
      );
    }
  }]);

  return TableRow;
}(_react.Component);

TableRow.propTypes = {
  index: _propTypes2.default.number,
  row: _propTypes2.default.any,
  style: _propTypes2.default.any,
  isSelected: _propTypes2.default.bool,
  enableCellEdit: _propTypes2.default.bool,
  onRowClick: _propTypes2.default.func,
  onRowDoubleClick: _propTypes2.default.func,
  onSelectRow: _propTypes2.default.func,
  onExpandRow: _propTypes2.default.func,
  onRowMouseOut: _propTypes2.default.func,
  onRowMouseOver: _propTypes2.default.func,
  unselectableRow: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool
};
TableRow.defaultProps = {
  onRowClick: undefined,
  onRowDoubleClick: undefined,
  hidden: false
};
var _default = TableRow;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableRow, 'TableRow', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableRow.js');
}();

;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(24);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableColumn = function (_Component) {
  _inherits(TableColumn, _Component);

  function TableColumn(props) {
    _classCallCheck(this, TableColumn);

    var _this = _possibleConstructorReturn(this, (TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).call(this, props));

    _this.handleCellEdit = function () {
      return _this.__handleCellEdit__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCellClick = function () {
      return _this.__handleCellClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleKeyDown = function () {
      return _this.__handleKeyDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    return _this;
  }
  /* eslint no-unused-vars: [0, { "args": "after-used" }] */


  _createClass(TableColumn, [{
    key: '__handleKeyDown__REACT_HOT_LOADER__',
    value: function __handleKeyDown__REACT_HOT_LOADER__() {
      return this.__handleKeyDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCellClick__REACT_HOT_LOADER__',
    value: function __handleCellClick__REACT_HOT_LOADER__() {
      return this.__handleCellClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCellEdit__REACT_HOT_LOADER__',
    value: function __handleCellEdit__REACT_HOT_LOADER__() {
      return this.__handleCellEdit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var children = this.props.children;

      var shouldUpdated = this.props.width !== nextProps.width || this.props.className !== nextProps.className || this.props.hidden !== nextProps.hidden || this.props.dataAlign !== nextProps.dataAlign || this.props.isFocus !== nextProps.isFocus || (typeof children === 'undefined' ? 'undefined' : _typeof(children)) !== _typeof(nextProps.children) || ('' + this.props.onEdit).toString() !== ('' + nextProps.onEdit).toString();

      if (shouldUpdated) {
        return shouldUpdated;
      }

      if ((typeof children === 'undefined' ? 'undefined' : _typeof(children)) === 'object' && children !== null && children.props !== null) {
        if (children.props.type === 'checkbox' || children.props.type === 'radio') {
          shouldUpdated = shouldUpdated || children.props.type !== nextProps.children.props.type || children.props.checked !== nextProps.children.props.checked || children.props.disabled !== nextProps.children.props.disabled;
        } else {
          shouldUpdated = true;
        }
      } else {
        shouldUpdated = shouldUpdated || children !== nextProps.children;
      }

      if (shouldUpdated) {
        return shouldUpdated;
      }

      if (!(this.props.cellEdit && nextProps.cellEdit)) {
        return false;
      } else {
        return shouldUpdated || this.props.cellEdit.mode !== nextProps.cellEdit.mode;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: '__handleCellEdit__REACT_HOT_LOADER__',
    value: function __handleCellEdit__REACT_HOT_LOADER__(e) {
      try {
        if (this.props.cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK) {
          if (document.selection && document.selection.empty) {
            document.selection.empty();
          } else if (window.getSelection) {
            var sel = window.getSelection();
            sel.removeAllRanges();
          }
        }
      } catch (err) {} /* eslint no-empty: 0 */
      this.props.onEdit(this.props.rIndex + 1, e.currentTarget.cellIndex, e);
      if (this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_DBCLICK) {
        this.props.onClick(e, this.props.rIndex + 1, e.currentTarget.cellIndex);
      }
    }
  }, {
    key: '__handleCellClick__REACT_HOT_LOADER__',
    value: function __handleCellClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          onClick = _props.onClick,
          rIndex = _props.rIndex;

      if (onClick) {
        onClick(e, rIndex + 1, e.currentTarget.cellIndex);
      }
    }
  }, {
    key: '__handleKeyDown__REACT_HOT_LOADER__',
    value: function __handleKeyDown__REACT_HOT_LOADER__(e) {
      if (this.props.keyBoardNav) {
        this.props.onKeyDown(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          columnTitle = _props2.columnTitle,
          dataAlign = _props2.dataAlign,
          hidden = _props2.hidden,
          cellEdit = _props2.cellEdit,
          attrs = _props2.attrs,
          style = _props2.style,
          isFocus = _props2.isFocus,
          keyBoardNav = _props2.keyBoardNav,
          tabIndex = _props2.tabIndex,
          customNavStyle = _props2.customNavStyle,
          withoutTabIndex = _props2.withoutTabIndex,
          row = _props2.row;
      var className = this.props.className;


      var tdStyle = _extends({
        textAlign: dataAlign,
        display: hidden ? 'none' : null
      }, style);

      var opts = {};

      if (cellEdit) {
        if (cellEdit.mode === _Const2.default.CELL_EDIT_CLICK) {
          opts.onClick = this.handleCellEdit;
        } else if (cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK) {
          opts.onDoubleClick = this.handleCellEdit;
        } else {
          opts.onClick = this.handleCellClick;
        }
      }

      if (keyBoardNav && isFocus) {
        opts.onKeyDown = this.handleKeyDown;
      }

      if (isFocus) {
        if (customNavStyle) {
          var cusmtStyle = _util2.default.isFunction(customNavStyle) ? customNavStyle(children, row) : customNavStyle;
          tdStyle = _extends({}, tdStyle, cusmtStyle);
        } else {
          className = className + ' default-focus-cell';
        }
      }

      var attr = {};
      if (!withoutTabIndex) attr.tabIndex = tabIndex;
      return _react2.default.createElement(
        'td',
        _extends({}, attr, { style: tdStyle,
          title: columnTitle,
          className: className
        }, opts, attrs),
        typeof children === 'boolean' ? children.toString() : children
      );
    }
  }]);

  return TableColumn;
}(_react.Component);

TableColumn.propTypes = {
  rIndex: _propTypes2.default.number,
  dataAlign: _propTypes2.default.string,
  hidden: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  columnTitle: _propTypes2.default.string,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  attrs: _propTypes2.default.object,
  style: _propTypes2.default.object,
  isFocus: _propTypes2.default.bool,
  onKeyDown: _propTypes2.default.func,
  tabIndex: _propTypes2.default.string,
  withoutTabIndex: _propTypes2.default.bool,
  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  customNavStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  row: _propTypes2.default.any /* only used on custom styling for navigation */
};

TableColumn.defaultProps = {
  dataAlign: 'left',
  withoutTabIndex: false,
  hidden: false,
  className: '',
  isFocus: false,
  keyBoardNav: false
};
var _default = TableColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableColumn, 'TableColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableColumn.js');
}();

;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Editor = __webpack_require__(169);

var _Editor2 = _interopRequireDefault(_Editor);

var _Notification = __webpack_require__(170);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _util = __webpack_require__(24);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableEditColumn = function (_Component) {
  _inherits(TableEditColumn, _Component);

  function TableEditColumn(props) {
    _classCallCheck(this, TableEditColumn);

    var _this = _possibleConstructorReturn(this, (TableEditColumn.__proto__ || Object.getPrototypeOf(TableEditColumn)).call(this, props));

    _this.handleKeyPress = function () {
      return _this.__handleKeyPress__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleBlur = function () {
      return _this.__handleBlur__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCustomUpdate = function () {
      return _this.__handleCustomUpdate__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.notifyToastr = function () {
      return _this.__notifyToastr__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClick = function () {
      return _this.__handleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getInputRef = function () {
      return _this.__getInputRef__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getHandleKeyPress = function () {
      return _this.__getHandleKeyPress__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getHandleBlur = function () {
      return _this.__getHandleBlur__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.timeouteClear = 0;
    var _this$props = _this.props,
        fieldValue = _this$props.fieldValue,
        row = _this$props.row,
        className = _this$props.className;

    _this.focusInEditor = _this.focusInEditor.bind(_this);
    _this.state = {
      shakeEditor: false,
      className: _util2.default.isFunction(className) ? className(fieldValue, row) : className
    };
    return _this;
  }

  _createClass(TableEditColumn, [{
    key: '__getHandleBlur__REACT_HOT_LOADER__',
    value: function __getHandleBlur__REACT_HOT_LOADER__() {
      return this.__getHandleBlur__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getHandleKeyPress__REACT_HOT_LOADER__',
    value: function __getHandleKeyPress__REACT_HOT_LOADER__() {
      return this.__getHandleKeyPress__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getInputRef__REACT_HOT_LOADER__',
    value: function __getInputRef__REACT_HOT_LOADER__() {
      return this.__getInputRef__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleClick__REACT_HOT_LOADER__',
    value: function __handleClick__REACT_HOT_LOADER__() {
      return this.__handleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__notifyToastr__REACT_HOT_LOADER__',
    value: function __notifyToastr__REACT_HOT_LOADER__() {
      return this.__notifyToastr__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCustomUpdate__REACT_HOT_LOADER__',
    value: function __handleCustomUpdate__REACT_HOT_LOADER__() {
      return this.__handleCustomUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleBlur__REACT_HOT_LOADER__',
    value: function __handleBlur__REACT_HOT_LOADER__() {
      return this.__handleBlur__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleKeyPress__REACT_HOT_LOADER__',
    value: function __handleKeyPress__REACT_HOT_LOADER__() {
      return this.__handleKeyPress__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'valueShortCircuit',
    value: function valueShortCircuit(value) {
      return value === null || typeof value === 'undefined' ? '' : value;
    }
  }, {
    key: '__handleKeyPress__REACT_HOT_LOADER__',
    value: function __handleKeyPress__REACT_HOT_LOADER__(e) {
      if (e.keyCode === 13 || e.keyCode === 9) {
        // Pressed ENTER or TAB
        var value = e.currentTarget.type === 'checkbox' ? this._getCheckBoxValue(e) : e.currentTarget.value;

        if (e.keyCode === 9 && this.props.blurToSave || !this.validator(value)) {
          return;
        }

        if (e.keyCode === 13) {
          this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
        } else {
          this.props.onTab(this.props.rowIndex + 1, this.props.colIndex + 1, 'tab', e);
          e.preventDefault();
        }
      } else if (e.keyCode === 27) {
        this.props.completeEdit(null, this.props.rowIndex, this.props.colIndex);
      } else if (e.type === 'click' && !this.props.blurToSave) {
        // textarea click save button
        var _value = e.target.parentElement.firstChild.value;
        if (!this.validator(_value)) {
          return;
        }
        this.props.completeEdit(_value, this.props.rowIndex, this.props.colIndex);
      }
    }
  }, {
    key: '__handleBlur__REACT_HOT_LOADER__',
    value: function __handleBlur__REACT_HOT_LOADER__(e) {
      e.stopPropagation();
      if (this.props.blurToSave) {
        var value = e.currentTarget.type === 'checkbox' ? this._getCheckBoxValue(e) : e.currentTarget.value;
        if (!this.validator(value)) {
          return false;
        }
        this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
      } else if (this.props.blurToEscape) {
        this.props.completeEdit(null, this.props.rowIndex, this.props.colIndex);
      }
    }
  }, {
    key: '__handleCustomUpdate__REACT_HOT_LOADER__',


    // modified by iuculanop
    // BEGIN
    value: function __handleCustomUpdate__REACT_HOT_LOADER__(value) {
      if (!this.validator(value)) {
        return;
      }
      this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
    }
  }, {
    key: 'validator',
    value: function validator(value) {
      var ts = this;
      var valid = true;
      if (ts.props.editable.validator) {
        var checkVal = ts.props.editable.validator(value, this.props.row);
        var responseType = typeof checkVal === 'undefined' ? 'undefined' : _typeof(checkVal);
        if (responseType !== 'object' && checkVal !== true) {
          valid = false;
          this.notifyToastr('error', checkVal, '');
        } else if (responseType === 'object' && checkVal.isValid !== true) {
          valid = false;
          this.notifyToastr(checkVal.notification.type, checkVal.notification.msg, checkVal.notification.title);
        }
        if (!valid) {
          // animate input
          ts.clearTimeout();
          var _props = this.props,
              invalidColumnClassName = _props.invalidColumnClassName,
              row = _props.row;

          var className = _util2.default.isFunction(invalidColumnClassName) ? invalidColumnClassName(value, row) : invalidColumnClassName;
          ts.setState({ shakeEditor: true, className: className });
          ts.timeouteClear = setTimeout(function () {
            ts.setState({ shakeEditor: false });
          }, 300);
          this.focusInEditor();
          return valid;
        }
      }
      return valid;
    }
    // END

  }, {
    key: '__notifyToastr__REACT_HOT_LOADER__',
    value: function __notifyToastr__REACT_HOT_LOADER__(type, message, title) {
      var toastr = true;
      var beforeShowError = this.props.beforeShowError;

      if (beforeShowError) {
        toastr = beforeShowError(type, message, title);
      }
      if (toastr) {
        (0, _Notification.notice)(type, message, title);
      }
    }
  }, {
    key: 'clearTimeout',
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      if (this.timeouteClear !== 0) {
        clearTimeout(this.timeouteClear);
        this.timeouteClear = 0;
      }
    })
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.focusInEditor();
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: 'focusInEditor',
    value: function focusInEditor() {
      if (this.inputRef && _util2.default.isFunction(this.inputRef.focus)) {
        this.inputRef.focus();
      }
    }
  }, {
    key: '__handleClick__REACT_HOT_LOADER__',
    value: function __handleClick__REACT_HOT_LOADER__(e) {
      if (e.target.tagName !== 'TD') {
        e.stopPropagation();
      }
    }
  }, {
    key: '__getInputRef__REACT_HOT_LOADER__',
    value: function __getInputRef__REACT_HOT_LOADER__(userRef) {
      var _this2 = this;

      return function (ref) {
        _this2.inputRef = ref;
        if (_util2.default.isFunction(userRef)) {
          userRef(ref);
        } else if (typeof userRef === 'string') {
          throw new Error('Ref must be a function');
        }
      };
    }
  }, {
    key: '__getHandleKeyPress__REACT_HOT_LOADER__',
    value: function __getHandleKeyPress__REACT_HOT_LOADER__(customHandler) {
      var _this3 = this;

      return function (e) {
        _this3.handleKeyPress(e);
        if (_util2.default.isFunction(customHandler)) {
          customHandler(e);
        }
      };
    }
  }, {
    key: '__getHandleBlur__REACT_HOT_LOADER__',
    value: function __getHandleBlur__REACT_HOT_LOADER__(customHandler) {
      var _this4 = this;

      return function (e) {
        _this4.handleBlur(e);
        if (_util2.default.isFunction(customHandler)) {
          customHandler(e);
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          editable = _props2.editable,
          format = _props2.format,
          customEditor = _props2.customEditor,
          isFocus = _props2.isFocus,
          customStyleWithNav = _props2.customStyleWithNav,
          row = _props2.row,
          attrs = _props2.attrs;
      var shakeEditor = this.state.shakeEditor;

      var attr = _extends({}, editable.attrs, {
        ref: this.getInputRef(editable.attrs && editable.attrs.ref),
        onKeyDown: this.getHandleKeyPress(editable.attrs && editable.attrs.onKeyDown),
        onBlur: this.getHandleBlur(editable.attrs && editable.attrs.onBlur)
      });
      var style = { position: 'relative' };
      var fieldValue = this.props.fieldValue;
      var className = this.state.className;


      if (editable.placeholder) {
        attr.placeholder = editable.placeholder;
        /* eslint-disable no-console */
        console.warn('Setting editable.placeholder is deprecated. Use editable.attrs to set input attributes');
        /* eslint-enable no-console */
      }

      var editorClass = (0, _classnames2.default)({ 'animated': shakeEditor, 'shake': shakeEditor });
      fieldValue = fieldValue === 0 ? '0' : fieldValue;
      var cellEditor = void 0;
      if (customEditor) {
        var customEditorProps = _extends({
          row: row
        }, attr, {
          defaultValue: this.valueShortCircuit(fieldValue)
        }, customEditor.customEditorParameters);
        cellEditor = customEditor.getElement(this.handleCustomUpdate, customEditorProps);
      } else {
        cellEditor = (0, _Editor2.default)(editable, attr, format, editorClass, this.valueShortCircuit(fieldValue), null, row);
      }

      if (isFocus) {
        if (customStyleWithNav) {
          var customStyle = _util2.default.isFunction(customStyleWithNav) ? customStyleWithNav(fieldValue, row) : customStyleWithNav;
          style = _extends({}, style, customStyle);
        } else {
          className = className + ' default-focus-cell';
        }
      }

      return _react2.default.createElement(
        'td',
        _extends({}, attrs, {
          style: style,
          className: className,
          onClick: this.handleClick }),
        cellEditor
      );
    }
  }, {
    key: '_getCheckBoxValue',
    value: function _getCheckBoxValue(e) {
      var value = '';
      var values = e.currentTarget.value.split(':');
      value = e.currentTarget.checked ? values[0] : values[1];
      return value;
    }
  }]);

  return TableEditColumn;
}(_react.Component);

TableEditColumn.propTypes = {
  completeEdit: _propTypes2.default.func,
  rowIndex: _propTypes2.default.number,
  colIndex: _propTypes2.default.number,
  blurToSave: _propTypes2.default.bool,
  blurToEscape: _propTypes2.default.bool,
  editable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  format: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  row: _propTypes2.default.any,
  fieldValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.array, _propTypes2.default.object]),
  className: _propTypes2.default.any,
  beforeShowError: _propTypes2.default.func,
  isFocus: _propTypes2.default.bool,
  attrs: _propTypes2.default.object,
  customStyleWithNav: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object])
};

var _default = TableEditColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableEditColumn, 'TableEditColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableEditColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableEditColumn.js');
}();

;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-len: 0 */
/* eslint no-nested-ternary: 0 */


var ExpandComponent = function (_Component) {
  _inherits(ExpandComponent, _Component);

  function ExpandComponent() {
    _classCallCheck(this, ExpandComponent);

    return _possibleConstructorReturn(this, (ExpandComponent.__proto__ || Object.getPrototypeOf(ExpandComponent)).apply(this, arguments));
  }

  _createClass(ExpandComponent, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var trCss = {
        style: {
          backgroundColor: this.props.bgColor
        },
        className: (0, _classnames2.default)(className)
      };
      return _react2.default.createElement(
        'tr',
        _extends({ hidden: this.props.hidden, width: this.props.width }, trCss),
        _react2.default.createElement(
          'td',
          { colSpan: this.props.colSpan },
          this.props.children
        )
      );
    }
  }]);

  return ExpandComponent;
}(_react.Component);

var _default = ExpandComponent;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExpandComponent, 'ExpandComponent', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandComponent.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandComponent.js');
}();

;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _PageButton = __webpack_require__(453);

var _PageButton2 = _interopRequireDefault(_PageButton);

var _SizePerPageDropDown = __webpack_require__(171);

var _SizePerPageDropDown2 = _interopRequireDefault(_SizePerPageDropDown);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(24);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationList = function (_Component) {
  _inherits(PaginationList, _Component);

  function PaginationList(props) {
    _classCallCheck(this, PaginationList);

    var _this = _possibleConstructorReturn(this, (PaginationList.__proto__ || Object.getPrototypeOf(PaginationList)).call(this, props));

    _this.changePage = function () {
      return _this.__changePage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.changeSizePerPage = function () {
      return _this.__changeSizePerPage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.toggleDropDown = function () {
      return _this.__toggleDropDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.closeDropDown = function () {
      return _this.__closeDropDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = {
      open: _this.props.open
    };
    return _this;
  }

  _createClass(PaginationList, [{
    key: '__closeDropDown__REACT_HOT_LOADER__',
    value: function __closeDropDown__REACT_HOT_LOADER__() {
      return this.__closeDropDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__toggleDropDown__REACT_HOT_LOADER__',
    value: function __toggleDropDown__REACT_HOT_LOADER__() {
      return this.__toggleDropDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__changeSizePerPage__REACT_HOT_LOADER__',
    value: function __changeSizePerPage__REACT_HOT_LOADER__() {
      return this.__changeSizePerPage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__changePage__REACT_HOT_LOADER__',
    value: function __changePage__REACT_HOT_LOADER__() {
      return this.__changePage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var keepSizePerPageState = this.props.keepSizePerPageState;

      if (!keepSizePerPageState) {
        this.closeDropDown();
      }
    }
  }, {
    key: '__changePage__REACT_HOT_LOADER__',
    value: function __changePage__REACT_HOT_LOADER__(page) {
      var _props = this.props,
          pageStartIndex = _props.pageStartIndex,
          prePage = _props.prePage,
          currPage = _props.currPage,
          nextPage = _props.nextPage,
          lastPage = _props.lastPage,
          firstPage = _props.firstPage,
          sizePerPage = _props.sizePerPage,
          keepSizePerPageState = _props.keepSizePerPageState;


      if (page === prePage) {
        page = currPage - 1 < pageStartIndex ? pageStartIndex : currPage - 1;
      } else if (page === nextPage) {
        page = currPage + 1 > this.lastPage ? this.lastPage : currPage + 1;
      } else if (page === lastPage) {
        page = this.lastPage;
      } else if (page === firstPage) {
        page = pageStartIndex;
      } else {
        page = parseInt(page, 10);
      }

      if (keepSizePerPageState) {
        this.closeDropDown();
      }

      if (page !== currPage) {
        this.props.changePage(page, sizePerPage);
      }
    }
  }, {
    key: '__changeSizePerPage__REACT_HOT_LOADER__',
    value: function __changeSizePerPage__REACT_HOT_LOADER__(pageNum) {
      var selectSize = typeof pageNum === 'string' ? parseInt(pageNum, 10) : pageNum;
      var currPage = this.props.currPage;

      if (selectSize !== this.props.sizePerPage) {
        this.totalPages = Math.ceil(this.props.dataSize / selectSize);
        this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
        if (currPage > this.lastPage) currPage = this.lastPage;
        this.props.changePage(currPage, selectSize);
        if (this.props.onSizePerPageList) {
          this.props.onSizePerPageList(selectSize);
        }
      }

      this.closeDropDown();
    }
  }, {
    key: '__toggleDropDown__REACT_HOT_LOADER__',
    value: function __toggleDropDown__REACT_HOT_LOADER__() {
      var _this2 = this;

      this.setState(function () {
        return {
          open: !_this2.state.open
        };
      });
    }
  }, {
    key: '__closeDropDown__REACT_HOT_LOADER__',
    value: function __closeDropDown__REACT_HOT_LOADER__() {
      this.setState(function () {
        return {
          open: false
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          currPage = _props2.currPage,
          dataSize = _props2.dataSize,
          sizePerPage = _props2.sizePerPage,
          sizePerPageList = _props2.sizePerPageList,
          paginationShowsTotal = _props2.paginationShowsTotal,
          pageStartIndex = _props2.pageStartIndex,
          paginationPanel = _props2.paginationPanel,
          hidePageListOnlyOnePage = _props2.hidePageListOnlyOnePage;

      this.totalPages = Math.ceil(dataSize / sizePerPage);
      this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
      var pageBtns = this.makePage(_util2.default.isFunction(paginationPanel));
      var dropdown = this.makeDropDown();

      var offset = Math.abs(_Const2.default.PAGE_START_INDEX - pageStartIndex);
      var start = (currPage - pageStartIndex) * sizePerPage;
      start = dataSize === 0 ? 0 : start + 1;
      var to = Math.min(sizePerPage * (currPage + offset) - 1, dataSize);
      if (to >= dataSize) to--;
      var total = paginationShowsTotal ? _react2.default.createElement(
        'span',
        null,
        'Showing rows ',
        start,
        ' to\xA0',
        to + 1,
        ' of\xA0',
        dataSize
      ) : null;

      if (_util2.default.isFunction(paginationShowsTotal)) {
        total = paginationShowsTotal(start, to + 1, dataSize);
      }

      var content = paginationPanel && paginationPanel({
        currPage: currPage,
        sizePerPage: sizePerPage,
        sizePerPageList: sizePerPageList,
        pageStartIndex: pageStartIndex,
        totalPages: this.totalPages,
        changePage: this.changePage,
        toggleDropDown: this.toggleDropDown,
        changeSizePerPage: this.changeSizePerPage,
        components: {
          totalText: total,
          sizePerPageDropdown: dropdown,
          pageList: pageBtns
        }
      });

      var hidePageList = hidePageListOnlyOnePage && this.totalPages === 1 ? 'none' : 'block';
      return _react2.default.createElement(
        'div',
        { className: 'row', style: { marginTop: 15 } },
        content || [_react2.default.createElement(
          'div',
          { key: 'paging-left', className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
          total,
          sizePerPageList.length > 1 ? dropdown : null
        ), _react2.default.createElement(
          'div',
          { key: 'paging-right', style: { display: hidePageList },
            className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
          pageBtns
        )]
      );
    }
  }, {
    key: 'makeDropDown',
    value: function makeDropDown() {
      var _this3 = this;

      var dropdown = void 0;
      var dropdownProps = void 0;
      var sizePerPageText = '';
      var _props3 = this.props,
          sizePerPageDropDown = _props3.sizePerPageDropDown,
          hideSizePerPage = _props3.hideSizePerPage,
          sizePerPage = _props3.sizePerPage,
          sizePerPageList = _props3.sizePerPageList;

      if (sizePerPageDropDown) {
        dropdown = sizePerPageDropDown({
          open: this.state.open,
          hideSizePerPage: hideSizePerPage,
          currSizePerPage: String(sizePerPage),
          sizePerPageList: sizePerPageList,
          toggleDropDown: this.toggleDropDown,
          changeSizePerPage: this.changeSizePerPage,
          onBlur: this.closeDropDown
        });
        if (dropdown.type.name === _SizePerPageDropDown2.default.name) {
          dropdownProps = dropdown.props;
        } else {
          return dropdown;
        }
      }

      if (dropdownProps || !dropdown) {
        var isBootstrap4 = _util2.default.isBootstrap4(this.props.version);
        var sizePerPageOptions = sizePerPageList.map(function (_sizePerPage) {
          var pageText = _sizePerPage.text || _sizePerPage;
          var pageNum = _sizePerPage.value || _sizePerPage;
          if (sizePerPage === pageNum) sizePerPageText = pageText;
          if (isBootstrap4) {
            return _react2.default.createElement(
              'a',
              {
                href: '#',
                tabIndex: '-1',
                key: pageText,
                className: 'dropdown-item',
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  _this3.changeSizePerPage(pageNum);
                } },
              pageText
            );
          } else {
            return _react2.default.createElement(
              'li',
              { key: pageText, role: 'presentation', className: 'dropdown-item' },
              _react2.default.createElement(
                'a',
                { role: 'menuitem',
                  tabIndex: '-1', href: '#',
                  'data-page': pageNum,
                  onMouseDown: function onMouseDown(e) {
                    e.preventDefault();
                    _this3.changeSizePerPage(pageNum);
                  } },
                pageText
              )
            );
          }
        });
        dropdown = _react2.default.createElement(_SizePerPageDropDown2.default, _extends({
          open: this.state.open,
          hidden: hideSizePerPage,
          currSizePerPage: String(sizePerPageText),
          options: sizePerPageOptions,
          onClick: this.toggleDropDown,
          onBlur: this.closeDropDown,
          isBootstrap4: isBootstrap4
        }, dropdownProps));
      }
      return dropdown;
    }
  }, {
    key: 'makePage',
    value: function makePage() {
      var _this4 = this;

      var isCustomPagingPanel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var pages = this.getPages();
      var isStart = function isStart(page, _ref) {
        var currPage = _ref.currPage,
            pageStartIndex = _ref.pageStartIndex,
            firstPage = _ref.firstPage,
            prePage = _ref.prePage;
        return currPage === pageStartIndex && (page === firstPage || page === prePage);
      };
      var isEnd = function isEnd(page, _ref2) {
        var currPage = _ref2.currPage,
            nextPage = _ref2.nextPage,
            lastPage = _ref2.lastPage;
        return currPage === _this4.lastPage && (page === nextPage || page === lastPage);
      };
      var pageBtns = pages.filter(function (page) {
        if (this.props.alwaysShowAllBtns) {
          return true;
        }
        return isStart(page, this.props) || isEnd(page, this.props) ? false : true;
      }, this).map(function (page, index) {
        var isActive = page === this.props.currPage;
        var isDisabled = isStart(page, this.props) || isEnd(page, this.props) ? true : false;
        var title = page + '';
        var pageNumber = page;

        if (page === this.props.nextPage) {
          title = this.props.nextPageTitle;
          pageNumber = this.props.currPage + 1;
        } else if (page === this.props.prePage) {
          title = this.props.prePageTitle;
          pageNumber = this.props.currPage - 1;
        } else if (page === this.props.firstPage) {
          title = this.props.firstPageTitle;
          pageNumber = this.props.pageStartIndex;
        } else if (page === this.props.lastPage) {
          title = this.props.lastPageTitle;
          pageNumber = this.getLastPage();
        }

        return _react2.default.createElement(
          _PageButton2.default,
          { key: index,
            title: title,
            changePage: this.changePage,
            active: isActive,
            disable: isDisabled,
            pageNumber: pageNumber },
          page
        );
      }, this);
      var classname = (0, _classnames2.default)(isCustomPagingPanel ? null : 'react-bootstrap-table-page-btns-ul', 'pagination');
      return _react2.default.createElement(
        'ul',
        { className: classname },
        pageBtns
      );
    }
  }, {
    key: 'getLastPage',
    value: function getLastPage() {
      return this.lastPage;
    }
  }, {
    key: 'getPages',
    value: function getPages() {
      var pages = void 0;
      var endPage = this.totalPages;
      if (endPage <= 0) return [];
      var startPage = Math.max(this.props.currPage - Math.floor(this.props.paginationSize / 2), this.props.pageStartIndex);
      endPage = startPage + this.props.paginationSize - 1;

      if (endPage > this.lastPage) {
        endPage = this.lastPage;
        startPage = endPage - this.props.paginationSize + 1;
      }

      if (startPage !== this.props.pageStartIndex && this.totalPages > this.props.paginationSize && this.props.withFirstAndLast) {
        pages = [this.props.firstPage, this.props.prePage];
      } else if (this.totalPages > 1 || this.props.alwaysShowAllBtns) {
        pages = [this.props.prePage];
      } else {
        pages = [];
      }

      for (var i = startPage; i <= endPage; i++) {
        if (i >= this.props.pageStartIndex) pages.push(i);
      }

      if (endPage <= this.lastPage && pages.length > 1) {
        pages.push(this.props.nextPage);
      }
      if (endPage !== this.lastPage && this.props.withFirstAndLast) {
        pages.push(this.props.lastPage);
      }

      return pages;
    }
  }]);

  return PaginationList;
}(_react.Component);

PaginationList.propTypes = {
  currPage: _propTypes2.default.number,
  sizePerPage: _propTypes2.default.number,
  dataSize: _propTypes2.default.number,
  changePage: _propTypes2.default.func,
  sizePerPageList: _propTypes2.default.array,
  paginationShowsTotal: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  paginationSize: _propTypes2.default.number,
  onSizePerPageList: _propTypes2.default.func,
  prePage: _propTypes2.default.any,
  nextPage: _propTypes2.default.any,
  firstPage: _propTypes2.default.any,
  lastPage: _propTypes2.default.any,
  pageStartIndex: _propTypes2.default.number,
  hideSizePerPage: _propTypes2.default.bool,
  alwaysShowAllBtns: _propTypes2.default.bool,
  withFirstAndLast: _propTypes2.default.bool,
  sizePerPageDropDown: _propTypes2.default.func,
  paginationPanel: _propTypes2.default.func,
  prePageTitle: _propTypes2.default.string,
  nextPageTitle: _propTypes2.default.string,
  firstPageTitle: _propTypes2.default.string,
  lastPageTitle: _propTypes2.default.string,
  hidePageListOnlyOnePage: _propTypes2.default.bool,
  keepSizePerPageState: _propTypes2.default.bool
};

PaginationList.defaultProps = {
  sizePerPage: _Const2.default.SIZE_PER_PAGE,
  pageStartIndex: _Const2.default.PAGE_START_INDEX
};

var _default = PaginationList;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaginationList, 'PaginationList', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PaginationList.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PaginationList.js');
}();

;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageButton = function (_Component) {
  _inherits(PageButton, _Component);

  function PageButton(props) {
    _classCallCheck(this, PageButton);

    var _this = _possibleConstructorReturn(this, (PageButton.__proto__ || Object.getPrototypeOf(PageButton)).call(this, props));

    _this.pageBtnClick = function () {
      return _this.__pageBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    return _this;
  }

  _createClass(PageButton, [{
    key: '__pageBtnClick__REACT_HOT_LOADER__',
    value: function __pageBtnClick__REACT_HOT_LOADER__() {
      return this.__pageBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__pageBtnClick__REACT_HOT_LOADER__',
    value: function __pageBtnClick__REACT_HOT_LOADER__(e) {
      e.preventDefault();
      this.props.changePage(this.props.pageNumber);
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)({
        'active': this.props.active,
        'disabled': this.props.disable,
        'hidden': this.props.hidden,
        'page-item': true
      });
      return _react2.default.createElement(
        'li',
        { className: classes, title: this.props.title },
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.pageBtnClick, className: 'page-link' },
          this.props.children
        )
      );
    }
  }]);

  return PageButton;
}(_react.Component);

PageButton.propTypes = {
  title: _propTypes2.default.string,
  changePage: _propTypes2.default.func,
  active: _propTypes2.default.bool,
  disable: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  pageNumber: _propTypes2.default.number
};

var _default = PageButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PageButton, 'PageButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PageButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PageButton.js');
}();

;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = __webpack_require__(455);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

var _Notification = __webpack_require__(170);

var _InsertModal = __webpack_require__(464);

var _InsertModal2 = _interopRequireDefault(_InsertModal);

var _InsertButton = __webpack_require__(178);

var _InsertButton2 = _interopRequireDefault(_InsertButton);

var _DeleteButton = __webpack_require__(179);

var _DeleteButton2 = _interopRequireDefault(_DeleteButton);

var _ExportCSVButton = __webpack_require__(180);

var _ExportCSVButton2 = _interopRequireDefault(_ExportCSVButton);

var _ShowSelectedOnlyButton = __webpack_require__(181);

var _ShowSelectedOnlyButton2 = _interopRequireDefault(_ShowSelectedOnlyButton);

var _SearchField = __webpack_require__(182);

var _SearchField2 = _interopRequireDefault(_SearchField);

var _ClearSearchButton = __webpack_require__(183);

var _ClearSearchButton2 = _interopRequireDefault(_ClearSearchButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */

// import classSet from 'classnames';

// import editor from '../Editor';


var ToolBar = function (_Component) {
  _inherits(ToolBar, _Component);

  function ToolBar(props) {
    _classCallCheck(this, ToolBar);

    var _this = _possibleConstructorReturn(this, (ToolBar.__proto__ || Object.getPrototypeOf(ToolBar)).call(this, props));

    _this.displayCommonMessage = function () {
      return _this.__displayCommonMessage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSaveBtnClick = function () {
      return _this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.afterHandleSaveBtnClick = function () {
      return _this.__afterHandleSaveBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleModalClose = function () {
      return _this.__handleModalClose__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleModalOpen = function () {
      return _this.__handleModalOpen__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleShowOnlyToggle = function () {
      return _this.__handleShowOnlyToggle__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDropRowBtnClick = function () {
      return _this.__handleDropRowBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDebounce = function () {
      return _this.__handleDebounce__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleKeyUp = function () {
      return _this.__handleKeyUp__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExportCSV = function () {
      return _this.__handleExportCSV__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClearBtnClick = function () {
      return _this.__handleClearBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.timeouteClear = 0;
    _this.modalClassName;
    _this.state = {
      isInsertModalOpen: false,
      validateState: null,
      shakeEditor: false,
      showSelected: false
    };
    return _this;
  }

  _createClass(ToolBar, [{
    key: '__handleClearBtnClick__REACT_HOT_LOADER__',
    value: function __handleClearBtnClick__REACT_HOT_LOADER__() {
      return this.__handleClearBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      return this.__handleExportCSV__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__() {
      return this.__handleKeyUp__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleDebounce__REACT_HOT_LOADER__',
    value: function __handleDebounce__REACT_HOT_LOADER__(func, wait, immediate) {
      var _this2 = this,
          _arguments = arguments;

      var timeout = void 0;

      return function () {
        var later = function later() {
          timeout = null;

          if (!immediate) {
            func.apply(_this2, _arguments);
          }
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait || 0);

        if (callNow) {
          func.appy(_this2, _arguments);
        }
      };
    }
  }, {
    key: '__handleDropRowBtnClick__REACT_HOT_LOADER__',
    value: function __handleDropRowBtnClick__REACT_HOT_LOADER__() {
      return this.__handleDropRowBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleShowOnlyToggle__REACT_HOT_LOADER__',
    value: function __handleShowOnlyToggle__REACT_HOT_LOADER__() {
      return this.__handleShowOnlyToggle__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleModalOpen__REACT_HOT_LOADER__',
    value: function __handleModalOpen__REACT_HOT_LOADER__() {
      return this.__handleModalOpen__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleModalClose__REACT_HOT_LOADER__',
    value: function __handleModalClose__REACT_HOT_LOADER__() {
      return this.__handleModalClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__afterHandleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __afterHandleSaveBtnClick__REACT_HOT_LOADER__() {
      return this.__afterHandleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__() {
      return this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__displayCommonMessage__REACT_HOT_LOADER__',
    value: function __displayCommonMessage__REACT_HOT_LOADER__() {
      return this.__displayCommonMessage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var delay = this.props.searchDelayTime ? this.props.searchDelayTime : 0;
      this.debounceCallback = this.handleDebounce(function () {
        _this3.seachInput && _this3.props.onSearch(_this3.seachInput.getValue());
      }, delay);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.reset) {
        this.setSearchInput('');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: 'setSearchInput',
    value: function setSearchInput(text) {
      if (this.seachInput && this.seachInput.value !== text) {
        this.seachInput.value = text;
      }
    }
  }, {
    key: 'clearTimeout',
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      if (this.timeouteClear) {
        clearTimeout(this.timeouteClear);
        this.timeouteClear = 0;
      }
    })
  }, {
    key: '__displayCommonMessage__REACT_HOT_LOADER__',
    value: function __displayCommonMessage__REACT_HOT_LOADER__() {
      (0, _Notification.notice)('error', this.props.insertFailIndicator, '');
    }
  }, {
    key: 'validateNewRow',
    value: function validateNewRow(newRow) {
      var _this4 = this;

      var validateState = {};
      var isValid = true;
      var tempMsg = void 0;
      var responseType = void 0;

      this.props.columns.forEach(function (column) {
        if (column.isKey && column.keyValidator) {
          // key validator for checking exist key
          tempMsg = _this4.props.isValidKey(newRow[column.field]);
          if (tempMsg) {
            _this4.displayCommonMessage();
            isValid = false;
            validateState[column.field] = tempMsg;
          }
        } else if (column.editable && column.editable.validator) {
          // process validate
          tempMsg = column.editable.validator(newRow[column.field], newRow);
          responseType = typeof tempMsg === 'undefined' ? 'undefined' : _typeof(tempMsg);
          if (responseType !== 'object' && tempMsg !== true) {
            _this4.displayCommonMessage();
            isValid = false;
            validateState[column.field] = tempMsg;
          } else if (responseType === 'object' && tempMsg.isValid !== true) {
            (0, _Notification.notice)(tempMsg.notification.type, tempMsg.notification.msg, tempMsg.notification.title);
            isValid = false;
            validateState[column.field] = tempMsg.notification.msg;
          }
        }
      });

      if (isValid) {
        return true;
      } else {
        this.clearTimeout();
        // show error in form and shake it
        this.setState(function () {
          return { validateState: validateState, shakeEditor: true };
        });
        this.timeouteClear = setTimeout(function () {
          _this4.setState(function () {
            return { shakeEditor: false };
          });
        }, 300);
        return null;
      }
    }
  }, {
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__(newRow) {
      if (!this.validateNewRow(newRow)) {
        // validation fail
        return;
      }
      var msg = this.props.onAddRow(newRow);
      if (msg !== false) {
        this.afterHandleSaveBtnClick(msg);
      }
    }
  }, {
    key: '__afterHandleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __afterHandleSaveBtnClick__REACT_HOT_LOADER__(msg) {
      var _this5 = this;

      if (msg) {
        (0, _Notification.notice)('error', msg, '');
        this.clearTimeout();
        // shake form and hack prevent modal hide
        this.setState(function () {
          return {
            shakeEditor: true,
            validateState: 'this is hack for prevent bootstrap modal hide'
          };
        });
        // clear animate class
        this.timeouteClear = setTimeout(function () {
          _this5.setState(function () {
            return { shakeEditor: false };
          });
        }, 300);
      } else {
        // reset state and hide modal hide
        this.setState(function () {
          return {
            validateState: null,
            shakeEditor: false,
            isInsertModalOpen: false
          };
        });
      }
    }
  }, {
    key: '__handleModalClose__REACT_HOT_LOADER__',
    value: function __handleModalClose__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { isInsertModalOpen: false };
      });
    }
  }, {
    key: '__handleModalOpen__REACT_HOT_LOADER__',
    value: function __handleModalOpen__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { isInsertModalOpen: true };
      });
    }
  }, {
    key: '__handleShowOnlyToggle__REACT_HOT_LOADER__',
    value: function __handleShowOnlyToggle__REACT_HOT_LOADER__() {
      var _this6 = this;

      this.setState(function () {
        return {
          showSelected: !_this6.state.showSelected
        };
      });
      this.props.onShowOnlySelected();
    }
  }, {
    key: '__handleDropRowBtnClick__REACT_HOT_LOADER__',
    value: function __handleDropRowBtnClick__REACT_HOT_LOADER__() {
      this.props.onDropRow();
    }
  }, {
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__(event) {
      event.persist();
      this.debounceCallback(event);
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      this.props.onExportCSV();
    }
  }, {
    key: '__handleClearBtnClick__REACT_HOT_LOADER__',
    value: function __handleClearBtnClick__REACT_HOT_LOADER__() {
      this.seachInput && this.seachInput.setValue('');
      this.props.onSearch('');
    }
  }, {
    key: 'render',
    value: function render() {
      this.modalClassName = 'bs-table-modal-sm' + ToolBar.modalSeq++;
      var toolbar = null;
      var btnGroup = null;
      var insertBtn = null;
      var deleteBtn = null;
      var exportCSVBtn = null;
      var showSelectedOnlyBtn = null;

      if (this.props.enableInsert) {
        if (this.props.insertBtn) {
          insertBtn = this.renderCustomBtn(this.props.insertBtn, [this.handleModalOpen], _InsertButton2.default.name, 'onClick', this.handleModalOpen);
        } else {
          insertBtn = _react2.default.createElement(_InsertButton2.default, { btnText: this.props.insertText,
            onClick: this.handleModalOpen });
        }
      }

      if (this.props.enableDelete) {
        if (this.props.deleteBtn) {
          deleteBtn = this.renderCustomBtn(this.props.deleteBtn, [this.handleDropRowBtnClick], _DeleteButton2.default.name, 'onClick', this.handleDropRowBtnClick);
        } else {
          deleteBtn = _react2.default.createElement(_DeleteButton2.default, { btnText: this.props.deleteText,
            onClick: this.handleDropRowBtnClick });
        }
      }

      if (this.props.enableShowOnlySelected) {
        if (this.props.showSelectedOnlyBtn) {
          showSelectedOnlyBtn = this.renderCustomBtn(this.props.showSelectedOnlyBtn, [this.handleShowOnlyToggle, this.state.showSelected], _ShowSelectedOnlyButton2.default.name, 'onClick', this.handleShowOnlyToggle);
        } else {
          showSelectedOnlyBtn = _react2.default.createElement(_ShowSelectedOnlyButton2.default, { toggle: this.state.showSelected,
            onClick: this.handleShowOnlyToggle });
        }
      }

      if (this.props.enableExportCSV) {
        if (this.props.exportCSVBtn) {
          exportCSVBtn = this.renderCustomBtn(this.props.exportCSVBtn, [this.handleExportCSV], _ExportCSVButton2.default.name, 'onClick', this.handleExportCSV);
        } else {
          exportCSVBtn = _react2.default.createElement(_ExportCSVButton2.default, { btnText: this.props.exportCSVText,
            onClick: this.handleExportCSV });
        }
      }

      if (this.props.btnGroup) {
        btnGroup = this.props.btnGroup({
          exportCSVBtn: exportCSVBtn,
          insertBtn: insertBtn,
          deleteBtn: deleteBtn,
          showSelectedOnlyBtn: showSelectedOnlyBtn
        });
      } else {
        btnGroup = _react2.default.createElement(
          'div',
          { className: 'btn-group btn-group-sm', role: 'group' },
          exportCSVBtn,
          insertBtn,
          deleteBtn,
          showSelectedOnlyBtn
        );
      }

      var _renderSearchPanel = this.renderSearchPanel(),
          _renderSearchPanel2 = _slicedToArray(_renderSearchPanel, 3),
          searchPanel = _renderSearchPanel2[0],
          searchField = _renderSearchPanel2[1],
          clearBtn = _renderSearchPanel2[2];

      var modal = this.props.enableInsert ? this.renderInsertRowModal() : null;

      if (this.props.toolBar) {
        toolbar = this.props.toolBar({
          components: {
            exportCSVBtn: exportCSVBtn,
            insertBtn: insertBtn,
            deleteBtn: deleteBtn,
            showSelectedOnlyBtn: showSelectedOnlyBtn,
            searchPanel: searchPanel,
            btnGroup: btnGroup,
            searchField: searchField,
            clearBtn: clearBtn
          },
          event: {
            openInsertModal: this.handleModalOpen,
            closeInsertModal: this.handleModalClose,
            dropRow: this.handleDropRowBtnClick,
            showOnlyToogle: this.handleShowOnlyToggle,
            exportCSV: this.handleExportCSV,
            search: this.props.onSearch
          }
        });
      } else {
        toolbar = [_react2.default.createElement(
          'div',
          { key: 'toolbar-left', className: 'col-xs-6 col-sm-6 col-md-6 col-lg-8' },
          this.props.searchPosition === 'left' ? searchPanel : btnGroup
        ), _react2.default.createElement(
          'div',
          { key: 'toolbar-right', className: 'col-xs-6 col-sm-6 col-md-6 col-lg-4' },
          this.props.searchPosition === 'left' ? btnGroup : searchPanel
        )];
      }

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        toolbar,
        modal
      );
    }
  }, {
    key: 'renderSearchPanel',
    value: function renderSearchPanel() {
      var _this7 = this;

      if (this.props.enableSearch) {
        var classNames = 'form-group form-group-sm react-bs-table-search-form';
        var clearBtn = null;
        var searchField = null;
        var searchPanel = null;
        if (this.props.clearSearch) {
          if (this.props.clearSearchBtn) {
            clearBtn = this.renderCustomBtn(this.props.clearSearchBtn, [this.handleClearBtnClick], _ClearSearchButton2.default.name, 'onClick', this.handleClearBtnClick); /* eslint max-len: 0*/
          } else {
            clearBtn = _react2.default.createElement(_ClearSearchButton2.default, { onClick: this.handleClearBtnClick });
          }
          classNames += ' input-group input-group-sm';
        }

        if (this.props.searchField) {
          searchField = this.props.searchField({
            search: this.handleKeyUp,
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder
          });
          if (searchField.type.name === _SearchField2.default.name) {
            searchField = _react2.default.cloneElement(searchField, {
              ref: function ref(node) {
                return _this7.seachInput = node;
              },
              onKeyUp: this.handleKeyUp
            });
          } else {
            searchField = _react2.default.cloneElement(searchField, {
              ref: function ref(node) {
                return _this7.seachInput = node;
              }
            });
          }
        } else {
          searchField = _react2.default.createElement(_SearchField2.default, { ref: function ref(node) {
              return _this7.seachInput = node;
            },
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder,
            onKeyUp: this.handleKeyUp });
        }
        if (this.props.searchPanel) {
          searchPanel = this.props.searchPanel({
            searchField: searchField, clearBtn: clearBtn,
            search: this.props.onSearch,
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder,
            clearBtnClick: this.handleClearBtnClick
          });
        } else {
          searchPanel = _react2.default.createElement(
            'div',
            { className: classNames },
            searchField,
            _react2.default.createElement(
              'span',
              { className: 'input-group-btn' },
              clearBtn
            )
          );
        }
        return [searchPanel, searchField, clearBtn];
      } else {
        return [];
      }
    }
  }, {
    key: 'renderInsertRowModal',
    value: function renderInsertRowModal() {
      var validateState = this.state.validateState || {};
      var _props = this.props,
          version = _props.version,
          columns = _props.columns,
          ignoreEditable = _props.ignoreEditable,
          insertModalHeader = _props.insertModalHeader,
          insertModalBody = _props.insertModalBody,
          insertModalFooter = _props.insertModalFooter,
          insertModal = _props.insertModal;


      var modal = void 0;
      modal = insertModal && insertModal(this.handleModalClose, this.handleSaveBtnClick, columns, validateState, ignoreEditable);

      if (!modal) {
        modal = _react2.default.createElement(_InsertModal2.default, {
          version: version,
          columns: columns,
          validateState: validateState,
          ignoreEditable: ignoreEditable,
          onModalClose: this.handleModalClose,
          onSave: this.handleSaveBtnClick,
          headerComponent: insertModalHeader,
          bodyComponent: insertModalBody,
          footerComponent: insertModalFooter });
      }

      return _react2.default.createElement(
        _reactModal2.default,
        { className: 'react-bs-insert-modal modal-dialog',
          isOpen: this.state.isInsertModalOpen,
          ariaHideApp: false,
          onRequestClose: this.handleModalClose,
          contentLabel: 'Modal' },
        modal
      );
    }
  }, {
    key: 'renderCustomBtn',
    value: function renderCustomBtn(cb, params, componentName, eventName, event) {
      var element = cb.apply(null, params);
      if (element.type.name === componentName && !element.props[eventName]) {
        var props = {};
        props[eventName] = event;
        element = _react2.default.cloneElement(element, props);
      }
      return element;
    }
  }]);

  return ToolBar;
}(_react.Component);

ToolBar.modalSeq = 0;


ToolBar.propTypes = {
  version: _propTypes2.default.string,
  onAddRow: _propTypes2.default.func,
  onDropRow: _propTypes2.default.func,
  onShowOnlySelected: _propTypes2.default.func,
  enableInsert: _propTypes2.default.bool,
  enableDelete: _propTypes2.default.bool,
  enableSearch: _propTypes2.default.bool,
  enableShowOnlySelected: _propTypes2.default.bool,
  columns: _propTypes2.default.array,
  searchPlaceholder: _propTypes2.default.string,
  exportCSVText: _propTypes2.default.string,
  insertText: _propTypes2.default.string,
  deleteText: _propTypes2.default.string,
  saveText: _propTypes2.default.string,
  closeText: _propTypes2.default.string,
  clearSearch: _propTypes2.default.bool,
  ignoreEditable: _propTypes2.default.bool,
  defaultSearch: _propTypes2.default.string,
  insertModalHeader: _propTypes2.default.func,
  insertModalBody: _propTypes2.default.func,
  insertModalFooter: _propTypes2.default.func,
  insertModal: _propTypes2.default.func,
  insertBtn: _propTypes2.default.func,
  deleteBtn: _propTypes2.default.func,
  showSelectedOnlyBtn: _propTypes2.default.func,
  exportCSVBtn: _propTypes2.default.func,
  clearSearchBtn: _propTypes2.default.func,
  searchField: _propTypes2.default.func,
  searchPanel: _propTypes2.default.func,
  btnGroup: _propTypes2.default.func,
  toolBar: _propTypes2.default.func,
  searchPosition: _propTypes2.default.string,
  reset: _propTypes2.default.bool,
  isValidKey: _propTypes2.default.func,
  insertFailIndicator: _propTypes2.default.string
};

ToolBar.defaultProps = {
  reset: false,
  enableInsert: false,
  enableDelete: false,
  enableSearch: false,
  enableShowOnlySelected: false,
  clearSearch: false,
  ignoreEditable: false,
  exportCSVText: _Const2.default.EXPORT_CSV_TEXT,
  insertText: _Const2.default.INSERT_BTN_TEXT,
  deleteText: _Const2.default.DELETE_BTN_TEXT,
  saveText: _Const2.default.SAVE_BTN_TEXT,
  closeText: _Const2.default.CLOSE_BTN_TEXT
};

var _default = ToolBar;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ToolBar, 'ToolBar', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ToolBar.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ToolBar.js');
}();

;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(456);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(457);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(173);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(108);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(458);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(459);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(173);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(462);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(174);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(463);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            id: id,
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(172);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(172);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _portalOpenInstances = __webpack_require__(174);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

function focusContent() {
  if (instances.length === 0) {
    if (false) {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before || !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InsertModalHeader = __webpack_require__(175);

var _InsertModalHeader2 = _interopRequireDefault(_InsertModalHeader);

var _InsertModalFooter = __webpack_require__(176);

var _InsertModalFooter2 = _interopRequireDefault(_InsertModalFooter);

var _InsertModalBody = __webpack_require__(177);

var _InsertModalBody2 = _interopRequireDefault(_InsertModalBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */

var defaultModalClassName = 'react-bs-table-insert-modal';

var InsertModal = function (_Component) {
  _inherits(InsertModal, _Component);

  function InsertModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModal.__proto__ || Object.getPrototypeOf(InsertModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleSave = function () {
      var _this2;

      return (_this2 = _this).__handleSave__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModal, [{
    key: '__handleSave__REACT_HOT_LOADER__',
    value: function __handleSave__REACT_HOT_LOADER__() {
      return this.__handleSave__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSave__REACT_HOT_LOADER__',
    value: function __handleSave__REACT_HOT_LOADER__() {
      if (this.body.getFieldValue) {
        this.props.onSave(this.body.getFieldValue());
      } else {
        console.error('Custom InsertModalBody should implement getFieldValue function\n        and should return an object presented as the new row that user input.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          headerComponent = _props.headerComponent,
          footerComponent = _props.footerComponent,
          bodyComponent = _props.bodyComponent;
      var _props2 = this.props,
          columns = _props2.columns,
          validateState = _props2.validateState,
          ignoreEditable = _props2.ignoreEditable,
          onModalClose = _props2.onModalClose;

      var bodyAttr = { columns: columns, validateState: validateState, ignoreEditable: ignoreEditable };

      bodyComponent = bodyComponent && bodyComponent(columns, validateState, ignoreEditable);

      headerComponent = headerComponent && headerComponent(onModalClose, this.handleSave);

      footerComponent = footerComponent && footerComponent(onModalClose, this.handleSave);

      if (bodyComponent) {
        bodyComponent = _react2.default.cloneElement(bodyComponent, { ref: function ref(node) {
            return _this3.body = node;
          } });
      }

      if (headerComponent && headerComponent.type.name === _InsertModalHeader2.default.name) {
        var eventProps = {};
        if (!headerComponent.props.onModalClose) eventProps.onModalClose = onModalClose;
        if (!headerComponent.props.onSave) eventProps.onSave = this.handleSave;
        if (Object.keys(eventProps).length > 0) {
          headerComponent = _react2.default.cloneElement(headerComponent, eventProps);
        }
      } else if (headerComponent && headerComponent.type.name !== _InsertModalHeader2.default.name) {
        var className = headerComponent.props.className;

        if (typeof className === 'undefined' || className.indexOf('modal-header') === -1) {
          headerComponent = _react2.default.createElement(
            'div',
            { className: 'modal-header' },
            headerComponent
          );
        }
      }

      if (footerComponent && footerComponent.type.name === _InsertModalFooter2.default.name) {
        var _eventProps = {};
        if (!footerComponent.props.onModalClose) _eventProps.onModalClose = onModalClose;
        if (!footerComponent.props.onSave) _eventProps.onSave = this.handleSave;
        if (Object.keys(_eventProps).length > 0) {
          footerComponent = _react2.default.cloneElement(footerComponent, _eventProps);
        }
      } else if (footerComponent && footerComponent.type.name !== _InsertModalFooter2.default.name) {
        var _className = footerComponent.props.className;

        if (typeof _className === 'undefined' || _className.indexOf('modal-footer') === -1) {
          footerComponent = _react2.default.createElement(
            'div',
            { className: 'modal-footer' },
            footerComponent
          );
        }
      }

      return _react2.default.createElement(
        'div',
        { className: 'modal-content ' + defaultModalClassName },
        headerComponent || _react2.default.createElement(_InsertModalHeader2.default, {
          version: this.props.version,
          className: 'react-bs-table-inser-modal-header',
          onModalClose: onModalClose }),
        bodyComponent || _react2.default.createElement(_InsertModalBody2.default, _extends({ ref: function ref(node) {
            return _this3.body = node;
          } }, bodyAttr)),
        footerComponent || _react2.default.createElement(_InsertModalFooter2.default, {
          className: 'react-bs-table-inser-modal-footer',
          onModalClose: onModalClose,
          onSave: this.handleSave })
      );
    }
  }]);

  return InsertModal;
}(_react.Component);

var _default = InsertModal;
exports.default = _default;

InsertModal.propTypes = {
  version: _propTypes2.default.string.isRequired,
  columns: _propTypes2.default.array.isRequired,
  validateState: _propTypes2.default.object.isRequired,
  ignoreEditable: _propTypes2.default.bool,
  headerComponent: _propTypes2.default.func,
  bodyComponent: _propTypes2.default.func,
  footerComponent: _propTypes2.default.func,
  onModalClose: _propTypes2.default.func,
  onSave: _propTypes2.default.func
};

InsertModal.defaultProps = {};
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(defaultModalClassName, 'defaultModalClassName', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');

  __REACT_HOT_LOADER__.register(InsertModal, 'InsertModal', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');
}();

;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableFilter = function (_Component) {
  _inherits(TableFilter, _Component);

  function TableFilter(props) {
    _classCallCheck(this, TableFilter);

    var _this = _possibleConstructorReturn(this, (TableFilter.__proto__ || Object.getPrototypeOf(TableFilter)).call(this, props));

    _this.handleKeyUp = function () {
      return _this.__handleKeyUp__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.filterObj = {};
    return _this;
  }

  _createClass(TableFilter, [{
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__() {
      return this.__handleKeyUp__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__(e) {
      var _e$currentTarget = e.currentTarget,
          value = _e$currentTarget.value,
          name = _e$currentTarget.name;

      if (value.trim() === '') {
        delete this.filterObj[name];
      } else {
        this.filterObj[name] = value;
      }
      this.props.onFilter(this.filterObj);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          striped = _props.striped,
          condensed = _props.condensed,
          rowSelectType = _props.rowSelectType,
          columns = _props.columns;

      var tableClasses = (0, _classnames2.default)('table', {
        'table-striped': striped,
        'table-condensed': condensed
      });
      var selectRowHeader = null;

      if (rowSelectType === _Const2.default.ROW_SELECT_SINGLE || rowSelectType === _Const2.default.ROW_SELECT_MULTI) {
        var style = {
          width: 35,
          paddingLeft: 0,
          paddingRight: 0
        };
        selectRowHeader = _react2.default.createElement(
          'th',
          { style: style, key: -1 },
          'Filter'
        );
      }

      var filterField = columns.map(function (column) {
        var hidden = column.hidden,
            width = column.width,
            name = column.name;

        var thStyle = {
          display: hidden ? 'none' : null,
          width: width
        };
        return _react2.default.createElement(
          'th',
          { key: name, style: thStyle },
          _react2.default.createElement(
            'div',
            { className: 'th-inner table-header-column' },
            _react2.default.createElement('input', { size: '10', type: 'text',
              placeholder: name, name: name, onKeyUp: this.handleKeyUp })
          )
        );
      }, this);

      return _react2.default.createElement(
        'table',
        { className: tableClasses, style: { marginTop: 5 } },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            { style: { borderBottomStyle: 'hidden' } },
            selectRowHeader,
            filterField
          )
        )
      );
    }
  }]);

  return TableFilter;
}(_react.Component);

TableFilter.propTypes = {
  columns: _propTypes2.default.array,
  rowSelectType: _propTypes2.default.string,
  onFilter: _propTypes2.default.func
};
var _default = TableFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableFilter, 'TableFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFilter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFilter.js');
}();

;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableDataStore = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint no-nested-ternary: 0 */
/* eslint guard-for-in: 0 */
/* eslint no-console: 0 */
/* eslint eqeqeq: 0 */
/* eslint one-var: 0 */


var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableDataStore = function () {
  function TableDataStore(data) {
    var _this = this;

    _classCallCheck(this, TableDataStore);

    this.isValidKey = function () {
      return _this.__isValidKey__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    this.data = data;
    this.filteredData = null;
    this.isOnFilter = false;
    this.filterObj = null;
    this.searchText = null;
    this.sortList = [];
    this.pageObj = {};
    this.selected = [];
    this.showOnlySelected = false;
  }

  _createClass(TableDataStore, [{
    key: '__isValidKey__REACT_HOT_LOADER__',
    value: function __isValidKey__REACT_HOT_LOADER__() {
      return this.__isValidKey__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'setProps',
    value: function setProps(props) {
      this.keyField = props.keyField;
      this.enablePagination = props.isPagination;
      this.colInfos = props.colInfos;
      this.remote = props.remote;
      this.multiColumnSearch = props.multiColumnSearch;
      // default behaviour if strictSearch prop is not provided: !multiColumnSearch
      this.strictSearch = typeof props.strictSearch === 'undefined' ? !props.multiColumnSearch : props.strictSearch;
      this.multiColumnSort = props.multiColumnSort;
    }
  }, {
    key: 'clean',
    value: function clean() {
      this.filteredData = null;
      this.isOnFilter = false;
      this.filterObj = null;
      this.searchText = null;
      this.sortList = [];
      this.pageObj = {};
      this.selected = [];
    }
  }, {
    key: 'isSearching',
    value: function isSearching() {
      return this.searchText !== null;
    }
  }, {
    key: 'isFiltering',
    value: function isFiltering() {
      return this.filterObj !== null;
    }
  }, {
    key: 'setData',
    value: function setData(data) {
      this.data = data;
      if (this.remote) {
        return;
      }

      this._refresh(true);
    }
  }, {
    key: 'getColInfos',
    value: function getColInfos() {
      return this.colInfos;
    }
  }, {
    key: 'getSortInfo',
    value: function getSortInfo() {
      return this.sortList;
    }
  }, {
    key: 'setSortInfo',
    value: function setSortInfo(order, sortField) {
      if ((typeof order === 'undefined' ? 'undefined' : _typeof(order)) !== (typeof sortField === 'undefined' ? 'undefined' : _typeof(sortField))) {
        throw new Error('The type of sort field and order should be both with String or Array');
      }
      if (Array.isArray(order) && Array.isArray(sortField)) {
        if (order.length !== sortField.length) {
          throw new Error('The length of sort fields and orders should be equivalent');
        }
        order = order.slice().reverse();
        this.sortList = sortField.slice().reverse().map(function (field, i) {
          return {
            order: order[i],
            sortField: field
          };
        });
        this.sortList = this.sortList.slice(0, this.multiColumnSort);
      } else {
        var sortObj = {
          order: order,
          sortField: sortField
        };

        if (this.multiColumnSort > 1) {
          var i = this.sortList.length - 1;
          var sortFieldInHistory = false;

          for (; i >= 0; i--) {
            if (this.sortList[i].sortField === sortField) {
              sortFieldInHistory = true;
              break;
            }
          }

          if (sortFieldInHistory) {
            if (i > 0) {
              this.sortList = this.sortList.slice(0, i);
            } else {
              this.sortList = this.sortList.slice(1);
            }
          }

          this.sortList.unshift(sortObj);
          this.sortList = this.sortList.slice(0, this.multiColumnSort);
        } else {
          this.sortList = [sortObj];
        }
      }
    }
  }, {
    key: 'cleanSortInfo',
    value: function cleanSortInfo() {
      this.sortList = [];
    }
  }, {
    key: 'setSelectedRowKey',
    value: function setSelectedRowKey(selectedRowKeys) {
      this.selected = selectedRowKeys;
    }
  }, {
    key: 'getRowByKey',
    value: function getRowByKey(keys) {
      var _this2 = this;

      // Bad Performance #1164
      // return keys.map(key => {
      //   const result = this.data.filter(d => d[this.keyField] === key);
      //   if (result.length !== 0) return result[0];
      // });
      var result = [];
      if (!keys || keys.length === 0) {
        return result;
      }

      var _loop = function _loop(i) {
        var d = _this2.data[i];
        if (keys.indexOf(d[_this2.keyField]) > -1) {
          keys = keys.filter(function (k) {
            return k !== d[_this2.keyField];
          });
          result.push(d);
        }
      };

      for (var i = 0; i < this.data.length; i++) {
        _loop(i);
      }
      return result;
    }
  }, {
    key: 'getSelectedRowKeys',
    value: function getSelectedRowKeys() {
      return this.selected;
    }
  }, {
    key: 'getCurrentDisplayData',
    value: function getCurrentDisplayData() {
      if (this.isOnFilter) return this.filteredData;else return this.data;
    }
  }, {
    key: '_refresh',
    value: function _refresh(skipSorting) {
      if (this.isOnFilter) {
        if (this.filterObj !== null) this.filter(this.filterObj);
        if (this.searchText !== null) this.search(this.searchText);
      }
      if (!skipSorting && this.sortList.length > 0) {
        this.sort();
      }
    }
  }, {
    key: 'ignoreNonSelected',
    value: function ignoreNonSelected() {
      var _this3 = this;

      this.showOnlySelected = !this.showOnlySelected;
      if (this.showOnlySelected) {
        this.isOnFilter = true;
        this.filteredData = this.data.filter(function (row) {
          var result = _this3.selected.find(function (x) {
            return row[_this3.keyField] === x;
          });
          return typeof result !== 'undefined' ? true : false;
        });
      } else {
        this.isOnFilter = false;
      }
    }
  }, {
    key: 'sort',
    value: function sort() {
      var currentDisplayData = this.getCurrentDisplayData();

      currentDisplayData = this._sort(currentDisplayData);

      return this;
    }
  }, {
    key: 'page',
    value: function page(_page, sizePerPage) {
      this.pageObj.end = _page * sizePerPage - 1;
      this.pageObj.start = this.pageObj.end - (sizePerPage - 1);
      return this;
    }
  }, {
    key: 'edit',
    value: function edit(newVal, rowIndex, fieldName) {
      var currentDisplayData = this.getCurrentDisplayData();
      var rowKeyCache = void 0;
      if (!this.enablePagination) {
        currentDisplayData[rowIndex][fieldName] = newVal;
        rowKeyCache = currentDisplayData[rowIndex][this.keyField];
      } else {
        currentDisplayData[this.pageObj.start + rowIndex][fieldName] = newVal;
        rowKeyCache = currentDisplayData[this.pageObj.start + rowIndex][this.keyField];
      }
      if (this.isOnFilter) {
        this.data.forEach(function (row) {
          if (row[this.keyField] === rowKeyCache) {
            row[fieldName] = newVal;
          }
        }, this);
        if (this.filterObj !== null) this.filter(this.filterObj);
        if (this.searchText !== null) this.search(this.searchText);
      }
      return this;
    }
  }, {
    key: 'addAtBegin',
    value: function addAtBegin(newObj) {
      if (!newObj[this.keyField] || newObj[this.keyField].toString() === '') {
        throw new Error(this.keyField + ' can\'t be empty value.');
      }
      var currentDisplayData = this.getCurrentDisplayData();
      currentDisplayData.forEach(function (row) {
        if (row[this.keyField].toString() === newObj[this.keyField].toString()) {
          throw new Error(this.keyField + ' ' + newObj[this.keyField] + ' already exists');
        }
      }, this);
      currentDisplayData.unshift(newObj);
      if (this.isOnFilter) {
        this.data.unshift(newObj);
      }
      this._refresh(false);
    }
  }, {
    key: 'add',
    value: function add(newObj) {
      var e = this.isValidKey(newObj[this.keyField]);
      if (e) throw new Error(e);

      var currentDisplayData = this.getCurrentDisplayData();
      currentDisplayData.push(newObj);
      if (this.isOnFilter) {
        this.data.push(newObj);
      }
      this._refresh(false);
    }
  }, {
    key: '__isValidKey__REACT_HOT_LOADER__',
    value: function __isValidKey__REACT_HOT_LOADER__(key) {
      var _this4 = this;

      if (key === null || key === undefined || key.toString() === '') {
        return this.keyField + ' can\'t be empty value.';
      }
      var currentDisplayData = this.getCurrentDisplayData();
      var exist = currentDisplayData.find(function (row) {
        return row[_this4.keyField].toString() === key.toString();
      });
      if (exist) return this.keyField + ' ' + key + ' already exists';
    }
  }, {
    key: 'remove',
    value: function remove(rowKey) {
      var _this5 = this;

      var currentDisplayData = this.getCurrentDisplayData();
      var result = currentDisplayData.filter(function (row) {
        return rowKey.indexOf(row[_this5.keyField]) === -1;
      });

      if (this.isOnFilter) {
        this.data = this.data.filter(function (row) {
          return rowKey.indexOf(row[_this5.keyField]) === -1;
        });
        this.filteredData = result;
      } else {
        this.data = result;
      }
    }
  }, {
    key: 'filter',
    value: function filter(filterObj) {
      if (Object.keys(filterObj).length === 0) {
        this.filteredData = null;
        this.isOnFilter = false;
        this.filterObj = null;
        if (this.searchText) this._search(this.data);
      } else {
        var source = this.data;
        this.filterObj = filterObj;
        if (this.searchText) {
          this._search(source);
          source = this.filteredData;
        }
        this._filter(source);
      }
    }
  }, {
    key: 'filterNumber',
    value: function filterNumber(targetVal, filterVal, comparator) {
      var valid = true;
      switch (comparator) {
        case '=':
          {
            if (targetVal != filterVal) {
              valid = false;
            }
            break;
          }
        case '>':
          {
            if (targetVal <= filterVal) {
              valid = false;
            }
            break;
          }
        case '>=':
          {
            if (targetVal < filterVal) {
              valid = false;
            }
            break;
          }
        case '<':
          {
            if (targetVal >= filterVal) {
              valid = false;
            }
            break;
          }
        case '<=':
          {
            if (targetVal > filterVal) {
              valid = false;
            }
            break;
          }
        case '!=':
          {
            if (targetVal == filterVal) {
              valid = false;
            }
            break;
          }
        default:
          {
            console.error('Number comparator provided is not supported');
            break;
          }
      }
      return valid;
    }
  }, {
    key: 'filterDate',
    value: function filterDate(targetVal, filterVal, comparator) {
      if (!targetVal) return false;

      var filterDate = filterVal.getDate();
      var filterMonth = filterVal.getMonth();
      var filterYear = filterVal.getFullYear();

      if ((typeof targetVal === 'undefined' ? 'undefined' : _typeof(targetVal)) !== 'object') {
        targetVal = new Date(targetVal);
      }

      var targetDate = targetVal.getDate();
      var targetMonth = targetVal.getMonth();
      var targetYear = targetVal.getFullYear();

      var valid = true;
      switch (comparator) {
        case '=':
          {
            if (filterDate !== targetDate || filterMonth !== targetMonth || filterYear !== targetYear) {
              valid = false;
            }
            break;
          }
        case '>':
          {
            if (targetVal <= filterVal) {
              valid = false;
            }
            break;
          }
        case '>=':
          {
            if (targetYear < filterYear) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth < filterMonth) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth === filterMonth && targetDate < filterDate) {
              valid = false;
            }
            break;
          }
        case '<':
          {
            if (targetVal >= filterVal) {
              valid = false;
            }
            break;
          }
        case '<=':
          {
            if (targetYear > filterYear) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth > filterMonth) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth === filterMonth && targetDate > filterDate) {
              valid = false;
            }
            break;
          }
        case '!=':
          {
            if (filterDate === targetDate && filterMonth === targetMonth && filterYear === targetYear) {
              valid = false;
            }
            break;
          }
        default:
          {
            console.error('Date comparator provided is not supported');
            break;
          }
      }
      return valid;
    }
  }, {
    key: 'filterRegex',
    value: function filterRegex(targetVal, filterVal) {
      try {
        return new RegExp(filterVal, 'i').test(targetVal);
      } catch (e) {
        return true;
      }
    }
  }, {
    key: 'filterCustom',
    value: function filterCustom(targetVal, filterVal, callbackInfo, cond) {
      if (callbackInfo !== null && (typeof callbackInfo === 'undefined' ? 'undefined' : _typeof(callbackInfo)) === 'object') {
        return callbackInfo.callback(targetVal, callbackInfo.callbackParameters);
      }

      return this.filterText(targetVal, filterVal, cond);
    }
  }, {
    key: 'filterText',
    value: function filterText() {
      var targetVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var filterVal = arguments[1];
      var cond = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Const2.default.FILTER_COND_LIKE;

      targetVal = targetVal === null ? '' : targetVal.toString();
      filterVal = filterVal.toString();
      if (cond === _Const2.default.FILTER_COND_EQ) {
        return targetVal === filterVal;
      } else {
        targetVal = targetVal.toLowerCase();
        filterVal = filterVal.toLowerCase();
        return !(targetVal.indexOf(filterVal) === -1);
      }
    }

    /**
     * Filter if targetVal is contained in filterVal.
     */

  }, {
    key: 'filterArray',
    value: function filterArray(targetVal, filterVal) {
      // case insensitive
      return filterVal.indexOf(targetVal) > -1;
    }

    /* General search function
     * It will search for the text if the input includes that text;
     */

  }, {
    key: 'search',
    value: function search(searchText) {
      if (searchText.trim() === '') {
        this.filteredData = null;
        this.isOnFilter = false;
        this.searchText = null;
        if (this.filterObj) this._filter(this.data);
      } else {
        var source = this.data;
        this.searchText = searchText;
        if (this.filterObj) {
          this._filter(source);
          source = this.filteredData;
        }
        this._search(source);
      }
    }
  }, {
    key: '_filter',
    value: function _filter(source) {
      var _this6 = this;

      var filterObj = this.filterObj;
      this.filteredData = source.filter(function (row, r) {
        var valid = true;
        var filterVal = void 0;
        for (var key in filterObj) {
          var targetVal = row[key];
          if (targetVal === null || targetVal === undefined) {
            targetVal = '';
          }

          switch (filterObj[key].type) {
            case _Const2.default.FILTER_TYPE.NUMBER:
              {
                filterVal = filterObj[key].value.number;
                break;
              }
            case _Const2.default.FILTER_TYPE.CUSTOM:
              {
                filterVal = _typeof(filterObj[key].value) === 'object' ? undefined : typeof filterObj[key].value === 'string' ? filterObj[key].value.toLowerCase() : filterObj[key].value;
                break;
              }
            case _Const2.default.FILTER_TYPE.DATE:
              {
                filterVal = filterObj[key].value.date;
                break;
              }
            case _Const2.default.FILTER_TYPE.REGEX:
              {
                filterVal = filterObj[key].value;
                break;
              }
            case _Const2.default.FILTER_TYPE.ARRAY:
              {
                filterVal = filterObj[key].value;
                if (!Array.isArray(filterVal)) {
                  throw new Error('Value must be an Array');
                }
                break;
              }
            default:
              {
                filterVal = filterObj[key].value;
                if (filterVal === undefined) {
                  // Support old filter
                  filterVal = filterObj[key];
                }
                break;
              }
          }
          var format = void 0,
              filterFormatted = void 0,
              formatExtraData = void 0,
              filterValue = void 0;
          if (_this6.colInfos[key]) {
            format = _this6.colInfos[key].format;
            filterFormatted = _this6.colInfos[key].filterFormatted;
            formatExtraData = _this6.colInfos[key].formatExtraData;
            filterValue = _this6.colInfos[key].filterValue;
            if (filterFormatted && format) {
              targetVal = format(row[key], row, formatExtraData, r);
            } else if (filterValue) {
              targetVal = filterValue(row[key], row);
            }
          }

          switch (filterObj[key].type) {
            case _Const2.default.FILTER_TYPE.NUMBER:
              {
                valid = _this6.filterNumber(targetVal, filterVal, filterObj[key].value.comparator);
                break;
              }
            case _Const2.default.FILTER_TYPE.DATE:
              {
                valid = _this6.filterDate(targetVal, filterVal, filterObj[key].value.comparator);
                break;
              }
            case _Const2.default.FILTER_TYPE.REGEX:
              {
                valid = _this6.filterRegex(targetVal, filterVal);
                break;
              }
            case _Const2.default.FILTER_TYPE.CUSTOM:
              {
                var cond = filterObj[key].props ? filterObj[key].props.cond : _Const2.default.FILTER_COND_LIKE;
                valid = _this6.filterCustom(targetVal, filterVal, filterObj[key].value, cond);
                break;
              }
            case _Const2.default.FILTER_TYPE.ARRAY:
              {
                valid = _this6.filterArray(targetVal, filterVal);
                break;
              }
            default:
              {
                if (filterObj[key].type === _Const2.default.FILTER_TYPE.SELECT && filterFormatted && filterFormatted && format) {
                  filterVal = format(filterVal, row, formatExtraData, r);
                }
                var _cond = filterObj[key].props ? filterObj[key].props.cond : _Const2.default.FILTER_COND_LIKE;
                valid = _this6.filterText(targetVal, filterVal, _cond);
                break;
              }
          }
          if (!valid) {
            break;
          }
        }
        return valid;
      });
      this.isOnFilter = true;
    }

    /*
     * Four different sort modes, all case insensitive:
     * (1) strictSearch && !multiColumnSearch
     *     search text must be contained as provided in a single column
     * (2) strictSearch && multiColumnSearch
     *     conjunction (AND combination) of whitespace separated terms over multiple columns
     * (3) !strictSearch && !multiColumnSearch
     *     conjunction (AND combination) of whitespace separated terms in a single column
     * (4) !strictSearch && multiColumnSearch
     *     any of the whitespace separated terms must be contained in any column
     */

  }, {
    key: '_search',
    value: function _search(source) {
      var _this7 = this;

      var searchTextArray = void 0;
      if (this.multiColumnSearch || !this.strictSearch) {
        // ignore leading and trailing whitespaces
        searchTextArray = this.searchText.trim().toLowerCase().split(/\s+/);
      } else {
        searchTextArray = [this.searchText.toLowerCase()];
      }
      var searchTermCount = searchTextArray.length;
      var multipleTerms = searchTermCount > 1;
      var nonStrictMultiCol = multipleTerms && !this.strictSearch && this.multiColumnSearch;
      var nonStrictSingleCol = multipleTerms && !this.strictSearch && !this.multiColumnSearch;
      this.filteredData = source.filter(function (row, r) {
        var keys = Object.keys(row);
        // only clone array if necessary
        var searchTerms = multipleTerms ? searchTextArray.slice() : searchTextArray;
        // for loops are ugly, but performance matters here.
        // And you cant break from a forEach.
        // http://jsperf.com/for-vs-foreach/66
        for (var i = 0, keysLength = keys.length; i < keysLength; i++) {
          var key = keys[i];
          var colInfo = _this7.colInfos[key];
          if (colInfo && colInfo.searchable) {
            var format = colInfo.format,
                filterFormatted = colInfo.filterFormatted,
                filterValue = colInfo.filterValue,
                formatExtraData = colInfo.formatExtraData;

            var targetVal = void 0;
            if (filterFormatted && format) {
              targetVal = format(row[key], row, formatExtraData, r);
            } else if (filterValue) {
              targetVal = filterValue(row[key], row);
            } else {
              targetVal = row[key];
            }
            if (targetVal !== null && typeof targetVal !== 'undefined') {
              targetVal = targetVal.toString().toLowerCase();
              if (nonStrictSingleCol && searchTermCount > searchTerms.length) {
                // reset search terms for single column search
                searchTerms = searchTextArray.slice();
              }
              for (var j = searchTerms.length - 1; j > -1; j--) {
                if (targetVal.indexOf(searchTerms[j]) !== -1) {
                  if (nonStrictMultiCol || searchTerms.length === 1) {
                    // match found: the last or only one
                    return true;
                  }
                  // match found: but there are more search terms to check for
                  searchTerms.splice(j, 1);
                } else if (!_this7.multiColumnSearch) {
                  // one of the search terms was not found in this column
                  break;
                }
              }
            }
          }
        }
        return false;
      });
      this.isOnFilter = true;
    }
  }, {
    key: '_sort',
    value: function _sort(arr) {
      var _this8 = this;

      if (this.sortList.length === 0 || typeof this.sortList[0] === 'undefined') {
        return arr;
      }

      arr.sort(function (a, b) {
        var result = 0;

        for (var i = 0; i < _this8.sortList.length; i++) {
          var sortDetails = _this8.sortList[i];
          var isDesc = sortDetails.order.toLowerCase() === _Const2.default.SORT_DESC;

          var _colInfos$sortDetails = _this8.colInfos[sortDetails.sortField],
              sortFunc = _colInfos$sortDetails.sortFunc,
              sortFuncExtraData = _colInfos$sortDetails.sortFuncExtraData;


          if (sortFunc) {
            result = sortFunc(a, b, sortDetails.order, sortDetails.sortField, sortFuncExtraData);
          } else {
            var valueA = a[sortDetails.sortField] == null ? '' : a[sortDetails.sortField];
            var valueB = b[sortDetails.sortField] == null ? '' : b[sortDetails.sortField];

            if (isDesc) {
              if (typeof valueB === 'string') {
                result = valueB.localeCompare(valueA);
              } else {
                result = valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
              }
            } else {
              if (typeof valueA === 'string') {
                result = valueA.localeCompare(valueB);
              } else {
                result = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
              }
            }
          }

          if (result !== 0) {
            return result;
          }
        }

        return result;
      });

      return arr;
    }
  }, {
    key: 'getDataIgnoringPagination',
    value: function getDataIgnoringPagination() {
      return this.getCurrentDisplayData();
    }
  }, {
    key: 'get',
    value: function get() {
      var _data = this.getCurrentDisplayData();

      if (_data.length === 0) return _data;

      var remote = typeof this.remote === 'function' ? this.remote(_Const2.default.REMOTE)[_Const2.default.REMOTE_PAGE] : this.remote;

      if (remote || !this.enablePagination) {
        return _data;
      } else {
        var result = [];
        for (var i = this.pageObj.start; i <= this.pageObj.end; i++) {
          result.push(_data[i]);
          if (i + 1 === _data.length) break;
        }
        return result;
      }
    }
  }, {
    key: 'getKeyField',
    value: function getKeyField() {
      return this.keyField;
    }
  }, {
    key: 'getDataNum',
    value: function getDataNum() {
      return this.getCurrentDisplayData().length;
    }
  }, {
    key: 'isChangedPage',
    value: function isChangedPage() {
      return this.pageObj.start && this.pageObj.end ? true : false;
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return this.data.length === 0 || this.data === null || this.data === undefined;
    }
  }, {
    key: 'getAllRowkey',
    value: function getAllRowkey() {
      var _this9 = this;

      return this.data.map(function (row) {
        return row[_this9.keyField];
      });
    }
  }]);

  return TableDataStore;
}();

exports.TableDataStore = TableDataStore;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableDataStore, 'TableDataStore', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/store/TableDataStore.js');
}();

;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(24);

var _util2 = _interopRequireDefault(_util);

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint block-scoped-var: 0 */
/* eslint vars-on-top: 0 */
/* eslint no-var: 0 */
/* eslint no-unused-vars: 0 */
if (_util2.default.canUseDOM()) {
  var filesaver = __webpack_require__(468);
  var saveAs = filesaver.saveAs;
}

function toString(data, keys, separator, excludeCSVHeader) {
  var dataString = '';
  if (data.length === 0) return dataString;

  var headCells = [];
  var rowCount = 0;
  keys.forEach(function (key) {
    if (key.row > rowCount) {
      rowCount = key.row;
    }
    // rowCount += (key.rowSpan + key.colSpan - 1);
    for (var index = 0; index < key.colSpan; index++) {
      headCells.push(key);
    }
  });

  var firstRow = excludeCSVHeader ? 1 : 0;

  var _loop = function _loop(i) {
    dataString += headCells.map(function (x) {
      if (x.row + (x.rowSpan - 1) === i) {
        return '"' + x.header + '"';
      }
      if (x.row === i && x.rowSpan > 1) {
        return '';
      }
    }).filter(function (key) {
      return typeof key !== 'undefined';
    }).join(separator) + '\n';
  };

  for (var i = firstRow; i <= rowCount; i++) {
    _loop(i);
  }

  keys = keys.filter(function (key) {
    return key.field !== undefined;
  });

  data.map(function (row) {
    keys.map(function (col, i) {
      var field = col.field,
          format = col.format,
          extraData = col.extraData,
          type = col.type;

      var value = typeof format !== 'undefined' ? format(row[field], row, extraData) : row[field];
      value = type === _Const2.default.CSV_NUMBER_TYPE ? Number(value) : '"' + value + '"';
      var cell = typeof value !== 'undefined' ? value : '';
      dataString += cell;
      if (i + 1 < keys.length) dataString += separator;
    });

    dataString += '\n';
  });

  return dataString;
}

var exportCSV = function exportCSV(data, keys, filename, separator, noAutoBOM, excludeCSVHeader) {
  var dataString = toString(data, keys, separator, excludeCSVHeader);
  if (typeof window !== 'undefined') {
    noAutoBOM = noAutoBOM === undefined ? true : noAutoBOM;
    saveAs(new Blob(['\uFEFF', dataString], { type: 'text/plain;charset=utf-8' }), filename, noAutoBOM);
  }
};

var _default = exportCSV;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(saveAs, 'saveAs', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(toString, 'toString', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(exportCSV, 'exportCSV', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');
}();

;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || function (view) {
	"use strict";
	// IE <10 is explicitly unsupported

	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var doc = view.document
	// only get URL when necessary in case Blob.js hasn't overridden it yet
	,
	    get_URL = function get_URL() {
		return view.URL || view.webkitURL || view;
	},
	    save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"),
	    can_use_save_link = "download" in save_link,
	    click = function click(node) {
		var event = new MouseEvent("click");
		node.dispatchEvent(event);
	},
	    is_safari = /constructor/i.test(view.HTMLElement) || view.safari,
	    is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent),
	    throw_outside = function throw_outside(ex) {
		(view.setImmediate || view.setTimeout)(function () {
			throw ex;
		}, 0);
	},
	    force_saveable_type = "application/octet-stream"
	// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
	,
	    arbitrary_revoke_timeout = 1000 * 40 // in ms
	,
	    revoke = function revoke(file) {
		var revoker = function revoker() {
			if (typeof file === "string") {
				// file is an object URL
				get_URL().revokeObjectURL(file);
			} else {
				// file is a File
				file.remove();
			}
		};
		setTimeout(revoker, arbitrary_revoke_timeout);
	},
	    dispatch = function dispatch(filesaver, event_types, event) {
		event_types = [].concat(event_types);
		var i = event_types.length;
		while (i--) {
			var listener = filesaver["on" + event_types[i]];
			if (typeof listener === "function") {
				try {
					listener.call(filesaver, event || filesaver);
				} catch (ex) {
					throw_outside(ex);
				}
			}
		}
	},
	    auto_bom = function auto_bom(blob) {
		// prepend BOM for UTF-8 XML and text/* types (including HTML)
		// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
		if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
			return new Blob([String.fromCharCode(0xFEFF), blob], { type: blob.type });
		}
		return blob;
	},
	    FileSaver = function FileSaver(blob, name, no_auto_bom) {
		if (!no_auto_bom) {
			blob = auto_bom(blob);
		}
		// First try a.download, then web filesystem, then object URLs
		var filesaver = this,
		    type = blob.type,
		    force = type === force_saveable_type,
		    object_url,
		    dispatch_all = function dispatch_all() {
			dispatch(filesaver, "writestart progress write writeend".split(" "));
		}
		// on any filesys errors revert to saving with object URLs
		,
		    fs_error = function fs_error() {
			if ((is_chrome_ios || force && is_safari) && view.FileReader) {
				// Safari doesn't allow downloading of blob urls
				var reader = new FileReader();
				reader.onloadend = function () {
					var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
					var popup = view.open(url, '_blank');
					if (!popup) view.location.href = url;
					url = undefined; // release reference before dispatching
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
				};
				reader.readAsDataURL(blob);
				filesaver.readyState = filesaver.INIT;
				return;
			}
			// don't create more object URLs than needed
			if (!object_url) {
				object_url = get_URL().createObjectURL(blob);
			}
			if (force) {
				view.location.href = object_url;
			} else {
				var opened = view.open(object_url, "_blank");
				if (!opened) {
					// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
					view.location.href = object_url;
				}
			}
			filesaver.readyState = filesaver.DONE;
			dispatch_all();
			revoke(object_url);
		};
		filesaver.readyState = filesaver.INIT;

		if (can_use_save_link) {
			object_url = get_URL().createObjectURL(blob);
			setTimeout(function () {
				save_link.href = object_url;
				save_link.download = name;
				click(save_link);
				dispatch_all();
				revoke(object_url);
				filesaver.readyState = filesaver.DONE;
			});
			return;
		}

		fs_error();
	},
	    FS_proto = FileSaver.prototype,
	    saveAs = function saveAs(blob, name, no_auto_bom) {
		return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
	};
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function (blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function () {};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;

	return saveAs;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content);
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
	module.exports.saveAs = saveAs;
} else if ("function" !== "undefined" && __webpack_require__(469) !== null && __webpack_require__(470) !== null) {
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
		return saveAs;
	}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(saveAs, "saveAs", "/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filesaver.js");
}();

;

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 470 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Const = __webpack_require__(14);

var _Const2 = _interopRequireDefault(_Const);

var _events = __webpack_require__(472);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = exports.Filter = function (_EventEmitter) {
  _inherits(Filter, _EventEmitter);

  function Filter(data) {
    _classCallCheck(this, Filter);

    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, data));

    _this.currentFilter = {};
    return _this;
  }

  _createClass(Filter, [{
    key: 'handleFilter',
    value: function handleFilter(dataField, value, type, filterObj) {
      var filterType = type || _Const2.default.FILTER_TYPE.CUSTOM;

      var props = {
        cond: filterObj.condition // Only for select and text filter
      };

      if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        // value of the filter is an object
        var hasValue = true;
        for (var prop in value) {
          if (!value[prop] || value[prop] === '') {
            hasValue = false;
            break;
          }
        }
        // if one of the object properties is undefined or empty, we remove the filter
        if (hasValue) {
          this.currentFilter[dataField] = { value: value, type: filterType, props: props };
        } else {
          delete this.currentFilter[dataField];
        }
      } else if (!value || value.trim() === '') {
        delete this.currentFilter[dataField];
      } else {
        this.currentFilter[dataField] = { value: value.trim(), type: filterType, props: props };
      }
      this.emit('onFilterChange', this.currentFilter);
    }
  }]);

  return Filter;
}(_events.EventEmitter);

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Filter, 'Filter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Filter.js');
}();

;

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonGroup = function (_Component) {
  _inherits(ButtonGroup, _Component);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).apply(this, arguments));
  }

  _createClass(ButtonGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          sizeClass = _props.sizeClass,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['className', 'sizeClass', 'children']);

      return _react2.default.createElement(
        'div',
        _extends({ className: 'btn-group ' + sizeClass + ' ' + className, role: 'group' }, rest),
        children
      );
    }
  }]);

  return ButtonGroup;
}(_react.Component);

ButtonGroup.propTypes = {
  sizeClass: _propTypes2.default.string,
  className: _propTypes2.default.string
};
ButtonGroup.defaultProps = {
  sizeClass: 'btn-group-sm',
  className: ''
};

var _default = ButtonGroup;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ButtonGroup, 'ButtonGroup', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ButtonGroup.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ButtonGroup.js');
}();

;

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_table__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DtpTableHeader = function (_Component) {
  _inherits(DtpTableHeader, _Component);

  function DtpTableHeader() {
    _classCallCheck(this, DtpTableHeader);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  DtpTableHeader.prototype.render = function render() {
    var _props = this.props,
        header = _props.header,
        props = _objectWithoutProperties(_props, ['header']);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_table__["TableHeaderColumn"],
      props,
      header
    );
  };

  return DtpTableHeader;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DtpTableHeader);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_overlays__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_overlays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_overlays__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DtpModal = function (_Component) {
    _inherits(DtpModal, _Component);

    function DtpModal() {
        var _temp, _this, _ret;

        _classCallCheck(this, DtpModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleClose = function () {
            _this.props.onHide();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    DtpModal.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            title = _props.title,
            showTitle = _props.showTitle,
            size = _props.size,
            alert = _props.alert,
            children = _props.children,
            alertType = _props.alertType,
            props = _objectWithoutProperties(_props, ['id', 'title', 'showTitle', 'size', 'alert', 'children', 'alertType']);

        var modalLabelId = id + '_modal-label';

        var isAlert = alert && alert === true;

        if (isAlert) {
            var alertIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('type-icon', { 'ico-confirm': alertType === 'success' }, { 'ico-alert-t': alertType === 'danger' }, { 'ico-info-c': alertType === 'info' }, { 'ico-alert-c': alertType === 'warning' }) });
        }

        var titleContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'title-container' },
            isAlert ? alertIcon : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { id: modalLabelId },
                title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'close-icon pull-right', onClick: this.handleClose.bind(this) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'ico-cancel' })
            )
        );

        var alertTypeClass = '';
        var contentTitle = null;
        if (isAlert) {
            alertTypeClass = alertType;
            contentTitle = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'content-title' },
                title
            );
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_overlays__["Modal"],
            _extends({
                'aria-labelledby': modalLabelId,
                backdropClassName: 'dtp-modal-backdrop',
                containerClassName: 'dtp-modal-container'
            }, props),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('dtp-modal', size, { 'alert': isAlert }, alertTypeClass) },
                isAlert || showTitle ? titleContent : null,
                isAlert ? contentTitle : null,
                children
            )
        );
    };

    return DtpModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var DtpModalContent = function DtpModalContent(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content-container' },
        props.children
    );
};

var DtpModalFooter = function DtpModalFooter(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'footer-container' },
        props.children
    );
};

DtpModal.DtpModalContent = DtpModalContent;
DtpModal.DtpModalFooter = DtpModalFooter;

DtpModal.propTypes =  false ? {
    /** Id do modal */
    id: PropTypes.string.isRequired,

    /** Define se o título do modal será exibido */
    showTitle: PropTypes.bool,

    /** Texto com o conteúdo do título do modal */
    title: PropTypes.string,

    /** Tipo do modal */
    size: PropTypes.oneOf(['sm', 'md', 'lg']),

    /** Define se o modal é para ser exibido como alert */
    alert: PropTypes.bool,

    /** Define o tipo de alert caso o 'alert' seja 'true' */
    alertType: PropTypes.oneOf(['success', 'danger', 'info', 'warning']),

    /** Conteúdo do modal */
    children: PropTypes.any,

    /** Função que é executada antes da transição de entrada */
    onEnter: PropTypes.func,

    /** Função que é executada depois da transição de entrada */
    onEntered: PropTypes.func,

    /** Função que é executada durante a transição de entrada */
    onEntering: PropTypes.func,

    /** Função que é executada antes da transição de saída */
    onExit: PropTypes.func,

    /** Função que é executada depois da transição de saída */
    onExited: PropTypes.func,

    /** Função que é executada durante a transição de saída  */
    onExiting: PropTypes.func,

    /** Função que é executada depois do modal ser escondido */
    onHide: PropTypes.func,

    /** Função que é executada quando o modal é exibido */
    onShow: PropTypes.func,

    /** Define se o modal está visível ou não */
    show: PropTypes.bool.isRequired
} : {};

DtpModal.defaultProps = {
    showTitle: true,
    show: false,
    size: 'md',
    alert: false,
    alertType: 'success'
};

/* harmony default export */ __webpack_exports__["a"] = (DtpModal);

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = height;

var _offset = _interopRequireDefault(__webpack_require__(52));

var _isWindow = _interopRequireDefault(__webpack_require__(53));

function height(node, client) {
  var win = (0, _isWindow.default)(node);
  return win ? win.innerHeight : client ? node.clientHeight : (0, _offset.default)(node).height;
}

module.exports = exports["default"];

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = ownerWindow;

var _ownerDocument = _interopRequireDefault(__webpack_require__(42));

function ownerWindow(node) {
  var doc = (0, _ownerDocument.default)(node);
  return doc && doc.defaultView || doc.parentWindow;
}

module.exports = exports["default"];

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _offset = __webpack_require__(52);

var _offset2 = _interopRequireDefault(_offset);

var _requestAnimationFrame = __webpack_require__(186);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(50);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Affix = __webpack_require__(185);

var _Affix2 = _interopRequireDefault(_Affix);

var _addEventListener = __webpack_require__(64);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _getContainer = __webpack_require__(51);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _getDocumentHeight = __webpack_require__(187);

var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);

var _ownerDocument = __webpack_require__(28);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(188);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = 'AutoAffix';

var propTypes = _extends({}, _Affix2.default.propTypes, {
  /**
   * The logical container node or component for determining offset from bottom
   * of viewport, or a function that returns it
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Automatically set width when affixed
   */
  autoWidth: _propTypes2.default.bool
});

// This intentionally doesn't inherit default props from `<Affix>`, so that the
// auto-calculated offsets can apply.
var defaultProps = {
  viewportOffsetTop: 0,
  autoWidth: true
};

/**
 * The `<AutoAffix/>` component wraps `<Affix/>` to automatically calculate
 * offsets in many common cases.
 */

var AutoAffix = function (_React$Component) {
  _inherits(AutoAffix, _React$Component);

  function AutoAffix(props, context) {
    _classCallCheck(this, AutoAffix);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.onWindowScroll = function () {
      _this.onUpdate();
    };

    _this.onWindowResize = function () {
      if (_this.props.autoWidth) {
        (0, _requestAnimationFrame2.default)(function () {
          return _this.onUpdate();
        });
      }
    };

    _this.onDocumentClick = function () {
      (0, _requestAnimationFrame2.default)(function () {
        return _this.onUpdate();
      });
    };

    _this.onUpdate = function () {
      if (!_this._isMounted) {
        return;
      }

      var _getOffset = (0, _offset2.default)(_this.positioner),
          offsetTop = _getOffset.top,
          width = _getOffset.width;

      var container = (0, _getContainer2.default)(_this.props.container);
      var offsetBottom = void 0;
      if (container) {
        var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));

        var _getOffset2 = (0, _offset2.default)(container),
            top = _getOffset2.top,
            height = _getOffset2.height;

        offsetBottom = documentHeight - top - height;
      } else {
        offsetBottom = null;
      }

      _this.updateState(offsetTop, offsetBottom, width);
    };

    _this.updateState = function (offsetTop, offsetBottom, width) {
      if (offsetTop === _this.state.offsetTop && offsetBottom === _this.state.offsetBottom && width === _this.state.width) {
        return;
      }

      _this.setState({ offsetTop: offsetTop, offsetBottom: offsetBottom, width: width });
    };

    _this.state = {
      offsetTop: null,
      offsetBottom: null,
      width: null
    };
    return _this;
  }

  AutoAffix.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._isMounted = true;

    this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
      return _this2.onWindowScroll();
    });

    this._windowResizeListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'resize', function () {
      return _this2.onWindowResize();
    });

    this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
      return _this2.onDocumentClick();
    });

    this.onUpdate();
  };

  AutoAffix.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needPositionUpdate = true;
  };

  AutoAffix.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this._needPositionUpdate) {
      this._needPositionUpdate = false;
      this.onUpdate();
    }
  };

  AutoAffix.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;

    if (this._windowScrollListener) {
      this._windowScrollListener.remove();
    }
    if (this._documentClickListener) {
      this._documentClickListener.remove();
    }
    if (this._windowResizeListener) {
      this._windowResizeListener.remove();
    }
  };

  AutoAffix.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        autoWidth = _props.autoWidth,
        viewportOffsetTop = _props.viewportOffsetTop,
        children = _props.children,
        props = _objectWithoutProperties(_props, ['autoWidth', 'viewportOffsetTop', 'children']);

    var _state = this.state,
        offsetTop = _state.offsetTop,
        offsetBottom = _state.offsetBottom,
        width = _state.width;


    delete props.container;

    var effectiveOffsetTop = Math.max(offsetTop, viewportOffsetTop || 0);

    var _props2 = this.props,
        affixStyle = _props2.affixStyle,
        bottomStyle = _props2.bottomStyle;

    if (autoWidth) {
      affixStyle = _extends({ width: width }, affixStyle);
      bottomStyle = _extends({ width: width }, bottomStyle);
    }

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement('div', { ref: function ref(c) {
          _this3.positioner = c;
        } }),
      _react2.default.createElement(
        _Affix2.default,
        _extends({}, props, {
          offsetTop: effectiveOffsetTop,
          viewportOffsetTop: viewportOffsetTop,
          offsetBottom: offsetBottom,
          affixStyle: affixStyle,
          bottomStyle: bottomStyle
        }),
        children
      )
    );
  };

  return AutoAffix;
}(_react2.default.Component);

AutoAffix.displayName = displayName;
AutoAffix.propTypes = propTypes;
AutoAffix.defaultProps = defaultProps;

exports.default = AutoAffix;
module.exports = exports['default'];

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeElement = __webpack_require__(480);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(87);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(34);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(50);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = __webpack_require__(481);

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = __webpack_require__(84);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(11);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

var _ModalManager = __webpack_require__(482);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Portal = __webpack_require__(86);

var _Portal2 = _interopRequireDefault(_Portal);

var _RefHolder = __webpack_require__(489);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _addEventListener = __webpack_require__(64);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(490);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _getContainer = __webpack_require__(51);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(28);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.omitProps = function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          appear: true,
          unmountOnExit: true,
          'in': show,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container,
        onRendered: this.onPortalRendered
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: this.setModalNodeRef,
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        _react2.default.createElement(
          _RefHolder2.default,
          { ref: this.setDialogRef },
          dialog
        )
      )
    );
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  };

  Modal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        show = _props2.show,
        transition = _props2.transition;


    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  Modal.prototype.autoFocus = function autoFocus() {
    if (!this.props.autoFocus) {
      return;
    }

    var dialogElement = this.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      this.lastFocus = currentActiveElement;

      if (!dialogElement.hasAttribute('tabIndex')) {
        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');

        dialogElement.setAttribute('tabIndex', -1);
      }

      dialogElement.focus();
    }
  };

  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  };

  Modal.prototype.getDialogElement = function getDialogElement() {
    return _reactDom2.default.findDOMNode(this.dialog);
  };

  Modal.prototype.isTopModal = function isTopModal() {
    return this.props.manager.isTopModal(this);
  };

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes2.default.func,

  /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */
  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */
  transition: _elementType2.default,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */
  backdropTransition: _elementType2.default,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props,
        backdropStyle = _props3.backdropStyle,
        backdropClassName = _props3.backdropClassName,
        renderBackdrop = _props3.renderBackdrop,
        Transition = _props3.backdropTransition;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        {
          appear: true,
          'in': _this2.props.show
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onPortalRendered = function () {
    _this2.autoFocus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeydownListener.remove();

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNodeRef = function (ref) {
    _this2.modalNode = ref;
  };

  this.setDialogRef = function (ref) {
    _this2.dialog = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyDown = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyDown) {
        _this2.props.onEscapeKeyDown(e);
      }

      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.enforceFocus = function () {
    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var dialogElement = _this2.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      dialogElement.focus();
    }
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(42));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

module.exports = exports['default'];

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class = __webpack_require__(483);

var _class2 = _interopRequireDefault(_class);

var _style = __webpack_require__(88);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(486);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(487);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(488);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
      _ref2$handleContainer = _ref2.handleContainerOverflow,
      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = void 0;

var _addClass = _interopRequireDefault(__webpack_require__(484));

exports.addClass = _addClass.default;

var _removeClass = _interopRequireDefault(__webpack_require__(485));

exports.removeClass = _removeClass.default;

var _hasClass = _interopRequireDefault(__webpack_require__(189));

exports.hasClass = _hasClass.default;
var _default = {
  addClass: _addClass.default,
  removeClass: _removeClass.default,
  hasClass: _hasClass.default
};
exports.default = _default;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(189));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(15);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(34));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(53);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(42);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.node
};

/**
 * Internal helper component to allow attaching a non-conflicting ref to a
 * child element that may not accept refs.
 */

var RefHolder = function (_React$Component) {
  _inherits(RefHolder, _React$Component);

  function RefHolder() {
    _classCallCheck(this, RefHolder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RefHolder.prototype.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes = propTypes;

exports.default = RefHolder;
module.exports = exports['default'];

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_pt_br__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_locale_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DtpInputMask_DtpInputMask__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DtpDropdown_DtpDropdown__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DtpDropdown_DtpDropdownToggle__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DtpDropdown_DtpDropdownContent__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DtpButton_DtpButtonFlat__ = __webpack_require__(63);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var DtpDatepicker = function (_Component) {
    _inherits(DtpDatepicker, _Component);

    function DtpDatepicker(props) {
        _classCallCheck(this, DtpDatepicker);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.renderActionBar = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-datepicker-footer' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DtpButton_DtpButtonFlat__["a" /* default */], {
                    title: 'CANCELAR',
                    onClick: _this.handleCancel.bind(_this) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DtpButton_DtpButtonFlat__["a" /* default */], {
                    title: 'OK',
                    className: 'dtp-primary',
                    onClick: _this.handleConfirm.bind(_this) })
            );
        };

        var date = props.date;

        if (!date) {
            date = new Date();
        }

        var currentMonth = date.getMonth();
        var currentYear = date.getFullYear();

        _this.state = {
            currentMonth: currentMonth,
            month: currentMonth,
            year: currentYear,
            days: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            months: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            calendar: [{ id: 'week-1', data: [0, 0, 0, 0, 0, 0, 0] }, { id: 'week-2', data: [0, 0, 0, 0, 0, 0, 0] }, { id: 'week-3', data: [0, 0, 0, 0, 0, 0, 0] }, { id: 'week-4', data: [0, 0, 0, 0, 0, 0, 0] }, { id: 'week-5', data: [0, 0, 0, 0, 0, 0, 0] }, { id: 'week-6', data: [0, 0, 0, 0, 0, 0, 0] }],
            switchToTimepicker: false,
            inputDateTimeValue: ''
        };

        _this.previousCalendar = _this.previousCalendar.bind(_this);
        _this.nextCalendar = _this.nextCalendar.bind(_this);
        return _this;
    }

    DtpDatepicker.prototype.componentDidMount = function componentDidMount() {
        var _props = this.props,
            date = _props.date,
            hour = _props.hour,
            minutes = _props.minutes;

        this.refreshComponent(date, hour, minutes);
    };

    DtpDatepicker.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        var date = nextProps.date,
            hour = nextProps.hour,
            minutes = nextProps.minutes;

        this.refreshComponent(date, hour, minutes);
    };

    DtpDatepicker.prototype.refreshComponent = function refreshComponent(date, hour, minutes) {
        var date_ = date ? date : new Date();

        if (date) {
            this.updateInputDateTimeValue(date_, hour, minutes);
        }

        this.setCalendar(new Date(date_.getFullYear(), date_.getMonth(), 1));
    };

    DtpDatepicker.prototype.updateInputDateTimeValue = function updateInputDateTimeValue(date, hour, minutes) {
        var language = this.props.language;

        var momentDate = date ? new __WEBPACK_IMPORTED_MODULE_2_moment___default.a(date) : new __WEBPACK_IMPORTED_MODULE_2_moment___default.a();
        momentDate.locale(language);
        var formatedDate = momentDate.format('L');
        var formatedTime = hour ? hour + ':' + (minutes ? minutes < 10 ? minutes + '0' : minutes : '00') : '';
        var inputDateTimeValue = formatedDate + ' ' + formatedTime;
        this.setState({
            inputDateTimeValue: inputDateTimeValue
        });
        if (inputDateTimeValue) {
            this.inputDateTimeRef.handleFocus();
        }
    };

    DtpDatepicker.prototype.setMonth = function setMonth(date) {
        var month = date.getMonth();
        var lastMonth = month === 0 ? 11 : month - 1;
        var nextMonth = month === 11 ? 0 : month + 1;
        var currentMonth = date.getMonth();

        this.setState({
            lastMonth: lastMonth,
            month: month,
            nextMonth: nextMonth,
            currentMonth: currentMonth
        });

        return { lastMonth: lastMonth, month: month, nextMonth: nextMonth };
    };

    DtpDatepicker.prototype.setCalendar = function setCalendar(date) {
        var _setMonth = this.setMonth(date),
            lastMonth = _setMonth.lastMonth,
            month = _setMonth.month,
            nextMonth = _setMonth.nextMonth;

        var year = date.getFullYear();
        var weekday = date.getDay();
        var days = this.checkLeapYear(year);
        var nextMonthDay = 0;

        var firstWeek = this.state.calendar[0].data.map(function (day, index) {
            if (index < weekday) {
                var value = days[lastMonth] - (weekday - index) + 1;
                return {
                    value: value,
                    class: 'dtp-datepicker-day-disabled',
                    month: lastMonth
                };
            }
            return {
                value: index - weekday + 1,
                class: '',
                month: month
            };
        });

        var secondWeek = this.state.calendar[0].data.map(function (day, index) {
            var value = firstWeek[6].value + index + 1;
            return {
                value: value,
                class: '',
                month: month
            };
        });

        var thirdWeek = this.state.calendar[0].data.map(function (day, index) {
            var value = secondWeek[6].value + index + 1;
            return {
                value: value,
                class: '',
                month: month
            };
        });

        var forthWeek = this.state.calendar[0].data.map(function (day, index) {
            var value = thirdWeek[6].value + index + 1;
            return {
                value: value,
                class: '',
                month: month
            };
        });

        var fifthWeek = this.state.calendar[0].data.map(function (day, index) {
            if (forthWeek[6].value + index + 1 > days[month]) {
                nextMonthDay += 1;
                return {
                    value: nextMonthDay,
                    class: 'dtp-datepicker-day-disabled',
                    month: nextMonth
                };
            }
            var value = forthWeek[6].value + index + 1;
            return {
                value: value,
                class: '',
                month: month
            };
        });

        var sixthWeek = this.state.calendar[0].data.map(function (day, index) {
            if (fifthWeek[6].value + index + 1 > days[month] || fifthWeek[6].value < 10) {
                nextMonthDay += 1;
                return {
                    value: nextMonthDay,
                    class: 'dtp-datepicker-day-disabled',
                    month: nextMonth
                };
            }

            var value = fifthWeek[6].value + index + 1;
            return {
                value: value,
                class: '',
                month: month
            };
        });

        this.setState({
            month: month,
            year: year,
            calendar: [{ id: 'week-1', data: firstWeek }, { id: 'week-2', data: secondWeek }, { id: 'week-3', data: thirdWeek }, { id: 'week-4', data: forthWeek }, { id: 'week-5', data: fifthWeek }, { id: 'week-6', data: sixthWeek }]
        });
    };

    DtpDatepicker.prototype.checkLeapYear = function checkLeapYear(year) {
        var days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
            days = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        }
        this.setState({
            days: days
        });
        return days;
    };

    DtpDatepicker.prototype.previousCalendar = function previousCalendar() {
        var month = this.state.month !== 0 ? this.state.month - 1 : 11;
        var year = this.state.month !== 0 ? this.state.year : this.state.year - 1;
        this.setCalendar(new Date(year, month, 1));
    };

    DtpDatepicker.prototype.nextCalendar = function nextCalendar() {
        var month = this.state.month !== 11 ? this.state.month + 1 : 0;
        var year = this.state.month !== 11 ? this.state.year : this.state.year + 1;
        this.setCalendar(new Date(year, month, 1));
    };

    DtpDatepicker.prototype.handleBlur = function handleBlur() {
        var inputDateTimeValue = this.state.inputDateTimeValue;

        if (inputDateTimeValue && inputDateTimeValue !== '') {
            this.inputDateTimeRef.handleFocus();
        }
    };

    DtpDatepicker.prototype.handleChangeHour = function handleChangeHour(selectedHour) {
        var _props2 = this.props,
            date = _props2.date,
            hour = _props2.hour,
            onChangeHour = _props2.onChangeHour,
            minutes = _props2.minutes;

        this.updateInputDateTimeValue(date, selectedHour, minutes);
        if (selectedHour !== hour && onChangeHour) {
            onChangeHour(selectedHour, undefined, minutes ? minutes : 0);
        }
    };

    DtpDatepicker.prototype.renderHours = function renderHours(activeHour, use24HoursFormat) {
        var _this2 = this;

        var HourItem = function HourItem(_ref) {
            var hour = _ref.hour,
                activeHour = _ref.activeHour,
                small = _ref.small;

            var isActive = false;
            var isAM = activeHour < 13;

            if (use24HoursFormat) {
                isActive = hour === activeHour;
            } else {
                if (activeHour > 12) {
                    isActive = hour === activeHour - 12;
                } else {
                    isActive = hour === activeHour;
                }
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('dtp-datepicker-clock-num', { 'small': small }, { 'dtp-datepicker-clock-num--active': isActive }),
                    onClick: function onClick() {
                        return _this2.handleChangeHour(use24HoursFormat ? hour : isAM ? hour : hour + 12);
                    } },
                hour
            );
        };

        var hoursAm = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2];
        var hoursPm = [15, 16, 17, 18, 19, 20, 21, 22, 23, 0, 13, 14];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()({ 'dtp-datepicker-clock-hours': !use24HoursFormat }, { 'dtp-datepicker-clock-hours-small': use24HoursFormat }) },
                hoursAm.map(function (hour) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HourItem, {
                        key: hour,
                        hour: hour,
                        activeHour: activeHour,
                        small: use24HoursFormat });
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dtp-datepicker-clock-hands' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('dtp-datepicker-hour-hand', { 'small': use24HoursFormat }) })
                )
            ),
            use24HoursFormat && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-datepicker-clock-hours' },
                hoursPm.map(function (hour) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HourItem, {
                        key: hour,
                        hour: hour,
                        activeHour: activeHour });
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dtp-datepicker-clock-hands' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('dtp-datepicker-hour-hand') })
                )
            )
        );
    };

    DtpDatepicker.prototype.renderTimePicker = function renderTimePicker() {
        var _this3 = this;

        var _props3 = this.props,
            hour = _props3.hour,
            use24HoursFormat = _props3.use24HoursFormat,
            showActionBar = _props3.showActionBar;

        var isAM = hour && hour < 13;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-timepicker-header' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dtp-datepicker-header-hour' },
                    hour !== undefined ? (!use24HoursFormat && hour > 12 ? hour - 12 : hour) + ':00' : '__:__',
                    !use24HoursFormat && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'dtp-datepicker-header-hour-ampm-toggle' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            {
                                className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()({ 'dtp-datepicker-header-hour-ampm-toggle-active': isAM }),
                                onClick: !isAM ? hour ? function () {
                                    return _this3.handleChangeHour(hour - 12);
                                } : function () {} : function () {} },
                            'AM'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            {
                                className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()({ 'dtp-datepicker-header-hour-ampm-toggle-active': !isAM }),
                                onClick: isAM ? hour ? function () {
                                    return _this3.handleChangeHour(hour + 12);
                                } : function () {} : function () {} },
                            'PM'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
                    className: 'dtp-datepicker-header-icon dtp-datepicker-header-icon-calendar',
                    onClick: this.handleSwitchDatepickerTimepicker.bind(this) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-datepicker-clock' },
                this.renderHours(hour, use24HoursFormat)
            ),
            showActionBar && this.renderActionBar()
        );
    };

    DtpDatepicker.prototype.selectDate = function selectDate(day) {
        var hideOnSelect = this.props.hideOnSelect;
        var currentMonth = this.state.currentMonth;
        var _props4 = this.props,
            hour = _props4.hour,
            minutes = _props4.minutes;

        var year = this.state.year;

        if (currentMonth !== day.month) {
            if (currentMonth === 0 && day.month === 11) {
                year--;
            } else if (currentMonth === 11 && day.month === 0) {
                year++;
            }
        }

        var date = new Date(year, day.month, day.value);

        if (hideOnSelect === true) {
            this.dropDownRef.handleChangeState();
        }

        this.setCalendar(new Date(year, day.month, 1));
        this.updateInputDateTimeValue(date, hour, minutes);
        this.props.onChange && this.props.onChange(date);
    };

    DtpDatepicker.prototype.handleCancel = function handleCancel() {
        var onCancel = this.props.onCancel;

        if (onCancel) {
            onCancel();
        }
        this.dropDownRef.handleChangeState();
    };

    DtpDatepicker.prototype.handleConfirm = function handleConfirm() {
        var onConfirm = this.props.onConfirm;

        if (onConfirm) {
            onConfirm();
        }
        this.dropDownRef.handleChangeState();
    };

    DtpDatepicker.prototype.renderDatePicker = function renderDatePicker() {
        var _this4 = this;

        var _props5 = this.props,
            date = _props5.date,
            language = _props5.language,
            showActionBar = _props5.showActionBar,
            useTimepicker = _props5.useTimepicker;

        var date_ = date && date !== null ? date : new Date();
        var momentDate = new __WEBPACK_IMPORTED_MODULE_2_moment___default.a(date_);
        momentDate.locale(language);
        var weekDays = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
        var _state = this.state,
            currentMonth = _state.currentMonth,
            month = _state.month,
            months = _state.months,
            year = _state.year;

        var dayOfWeek = momentDate.format('dddd');
        var selectedDay = momentDate.format('DD');
        var selectedYear = momentDate.format('YYYY');
        var selectedMonth = months[date_.getMonth()];
        var extendedDate = selectedDay + ' ' + selectedMonth + ' de ' + selectedYear;
        var montLabel = (months[month] + ' ' + year).toUpperCase();
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-datepicker-header' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dtp-datepicker-header-weekday' },
                    dayOfWeek
                ),
                useTimepicker === true && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
                    className: 'dtp-datepicker-header-icon dtp-datepicker-header-icon-time',
                    onClick: this.handleSwitchDatepickerTimepicker.bind(this) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dtp-datepicker-header-extendeddate' },
                    extendedDate
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-datepicker-month' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    {
                        className: 'dtp-datepicker-month-back',
                        onClick: this.previousCalendar },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'hide' },
                        '>'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    {
                        className: 'dtp-datepicker-month-next',
                        onClick: this.nextCalendar },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'hide' },
                        '>'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'dtp-datepicker-month-label' },
                    montLabel
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dtp-datepicker-body' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'table',
                    { className: 'dtp-datepicker-days' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'thead',
                        { className: 'dtp-datepicker-days-head' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'tr',
                            { className: 'dtp-datepicker-days-row' },
                            weekDays.map(function (weekDay, ix) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'th',
                                    { key: ix, className: 'dtp-datepicker-day-head' },
                                    weekDay
                                );
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tbody',
                        { className: 'dtp-datepicker-days-body' },
                        this.state.calendar.map(function (week) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'tr',
                                { key: week.id, className: 'dtp-datepicker-days-row' },
                                week.data.map(function (day, ix) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'td',
                                        {
                                            onClick: function onClick() {
                                                _this4.selectDate(day);
                                            },
                                            key: 'day_' + ix,
                                            className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('dtp-datepicker-day-body', { 'dtp-datepicker-day-selected': day.value === parseInt(selectedDay, 10) && day.month === currentMonth }, day.class) },
                                        day.value < 10 && day.value !== ' ' ? '0' + day.value : day.value
                                    );
                                })
                            );
                        })
                    )
                )
            ),
            showActionBar && this.renderActionBar()
        );
    };

    DtpDatepicker.prototype.handleSwitchDatepickerTimepicker = function handleSwitchDatepickerTimepicker() {
        this.setState(function (prevProps) {
            return {
                switchToTimepicker: !prevProps.switchToTimepicker
            };
        });
    };

    DtpDatepicker.prototype.onHide = function onHide() {
        this.setState({
            switchToTimepicker: false
        });
    };

    DtpDatepicker.prototype.handleChangeDateTime = function handleChangeDateTime(e) {
        var actualDate = this.props.date;
        var dateTime = e.target.value;
        var splittedDateTime = dateTime.match(/([a-zA-Z0-9]+)/g);

        if (splittedDateTime) {
            var day = splittedDateTime[0],
                month = splittedDateTime[1],
                year = splittedDateTime[2],
                hour = splittedDateTime[3],
                minutes = splittedDateTime[4];

            if (year && year.length === 4) {
                var newDate = new __WEBPACK_IMPORTED_MODULE_2_moment___default.a(year + '-' + month + '-' + day);
                var actualDate_ = null;

                if (newDate.isValid()) {
                    actualDate_ = new __WEBPACK_IMPORTED_MODULE_2_moment___default.a(actualDate);
                }

                if (newDate.isValid() === true && newDate.diff(actualDate_) !== 0) {
                    this.setState({
                        year: year,
                        currentYear: year
                    });
                    this.setCalendar(new Date(year, month - 1, 1));
                    this.props.onChange && this.props.onChange(new Date(year, month - 1, day), e);
                }

                if (hour && minutes) {
                    var newDateTime = new __WEBPACK_IMPORTED_MODULE_2_moment___default.a(year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':00');
                    if (newDateTime.isValid() === true) {
                        this.props.onChangeHour && this.props.onChangeHour(Number(hour), e, Number(minutes));
                    }
                }
            }
        }

        this.setState({
            inputDateTimeValue: dateTime
        });
    };

    DtpDatepicker.prototype.handleKeyDown = function handleKeyDown(e) {
        var keyCode = e.keyCode;

        switch (keyCode) {
            case 13:
            case 27:
            case 9:
                e.target.blur();
                this.dropDownRef.handleChangeState();
                break;
            default:
                break;
        }
    };

    DtpDatepicker.prototype.handleKeyUp = function handleKeyUp() {
        if (!this.dropDownRef.isOpen()) {
            this.dropDownRef.handleChangeState();
        }
    };

    DtpDatepicker.prototype.render = function render() {
        var _this5 = this;

        var _state2 = this.state,
            switchToTimepicker = _state2.switchToTimepicker,
            inputDateTimeValue = _state2.inputDateTimeValue;
        var _props6 = this.props,
            useTimepicker = _props6.useTimepicker,
            keepCharPositions = _props6.keepCharPositions,
            placeholder = _props6.placeholder;


        var mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
        if (useTimepicker) {
            mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/];
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__DtpDropdown_DtpDropdown__["a" /* default */],
            {
                ref: function ref(dropDown) {
                    _this5.dropDownRef = dropDown;
                },
                onHide: this.onHide.bind(this) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__DtpDropdown_DtpDropdownToggle__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DtpInputMask_DtpInputMask__["a" /* default */], {
                    mask: mask,
                    keepCharPositions: keepCharPositions,
                    showMask: false,
                    value: inputDateTimeValue,
                    onChange: this.handleChangeDateTime.bind(this),
                    ref: function ref(_ref2) {
                        _this5.inputDateTimeRef = _ref2;
                    },
                    onBlur: this.handleBlur.bind(this),
                    placeholder: placeholder,
                    onKeyDown: this.handleKeyDown.bind(this),
                    onKeyUp: this.handleKeyUp.bind(this) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__DtpDropdown_DtpDropdownContent__["a" /* default */],
                { className: 'dtp-datepicker' },
                switchToTimepicker === false ? this.renderDatePicker() : this.renderTimePicker()
            )
        );
    };

    return DtpDatepicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpDatepicker.propTypes =  false ? {
    /** Data selecionada */
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),

    /** Hora selecionada */
    hour: PropTypes.number,

    /** Minutos selecionados */
    minutes: PropTypes.number,

    /**
     * Função que é executada ao mudar a data selecionada. É chamada ao selecionar uma nova data
     * com um clique ou ao digitar no input. No primeiro caro é enviado como parâmetros apenas a
     * data selecionada. No segundo caso são enviados como parâmetro 1) data; 2) event;
     */
    onChange: PropTypes.func,

    /** Idioma da Data utilizada. Valores possíveis para a lib moment.js */
    language: PropTypes.string,

    /** Define se deverá ser exibida a barra de ações no rodapé */
    showActionBar: PropTypes.bool,

    /** Função que é executada ao clicar no botão de ação 'OK' */
    onConfirm: PropTypes.func,

    /** Função que é executada ao clicar no botão de ação 'Cancelar' */
    onCancel: PropTypes.func,

    /** Define se o calendário deve ser fechado ao selecionar uma data */
    hideOnSelect: PropTypes.bool,

    /** Define se o componente permitirá selecionar a hora também, além da data */
    useTimepicker: PropTypes.bool,

    /**
     * Função que é executada ao selecionar uma nova hora. É chamada ao selecionar uma nova hora
     * com um clique ou ao digitar no input. No primeiro caro é enviado como parâmetros apenas a
     * hora selecionada. No segundo caso são enviados como parâmetro 1) hora; 2) event; 3) minutos
     */
    onChangeHour: PropTypes.func,

    /** Define se é para exibir o relógio usando 12 horas com AM/PM ou se deve mostrar as 24 hrs */
    use24HoursFormat: PropTypes.bool.isRequired,

    /** Quando verdadeiro, adicionar ou excluir caracteres não afetará as posições dos caracteres existentes. */
    keepCharPositions: PropTypes.bool.isRequired
} : {};

DtpDatepicker.defaultProps = {
    language: 'pt-BR',
    showActionBar: false,
    hideOnSelect: true,
    useTimepicker: false,
    use24HoursFormat: false,
    keepCharPositions: false,
    minutes: 0
};

/* harmony default export */ __webpack_exports__["a"] = (DtpDatepicker);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DtpDropdown = function (_Component) {
    _inherits(DtpDropdown, _Component);

    function DtpDropdown() {
        var _temp, _this, _ret;

        _classCallCheck(this, DtpDropdown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            open: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    DtpDropdown.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('mousedown', this.handleClickOutside.bind(this), true);
    };

    DtpDropdown.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('mousedown', this.handleClickOutside.bind(this), true);
    };

    DtpDropdown.prototype.handleClickOutside = function handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.contentRef && !this.contentRef.contains(event.target)) {
            if (this.state.open === true) {
                this.handleChangeState();
            }
        }
    };

    DtpDropdown.prototype.setWrapperRef = function setWrapperRef(node) {
        this.wrapperRef = node;
    };

    DtpDropdown.prototype.setContentRef = function setContentRef(node) {
        this.contentRef = node;
    };

    DtpDropdown.prototype.isOpen = function isOpen() {
        return this.state.open === true;
    };

    DtpDropdown.prototype.getChildContext = function getChildContext() {
        var open = this.state.open;

        var handleChangeState = this.handleChangeState.bind(this);
        var setContentRef = this.setContentRef.bind(this);

        return {
            $dtpDropdown: {
                open: open,
                handleChangeState: handleChangeState,
                setContentRef: setContentRef
            }
        };
    };

    DtpDropdown.prototype.handleChangeState = function handleChangeState() {
        var _props = this.props,
            onShow = _props.onShow,
            onHide = _props.onHide;
        var open = this.state.open;


        this.setState(function (prevState) {
            return {
                open: !prevState.open
            };
        });

        if (onShow && open === false) {
            onShow();
        }

        if (onHide && open === true) {
            onHide();
        }
    };

    DtpDropdown.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { ref: this.setWrapperRef.bind(this), className: 'dtp-dropdown-wrapper' },
            this.props.children
        );
    };

    return DtpDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpDropdown.childContextTypes = {
    $dtpDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

DtpDropdown.propTypes =  false ? {
    /** Função que é executada quando o Dropdown é escondido */
    onHide: PropTypes.func,

    /** Função que é executada quando o Dropdown é exibido */
    onShow: PropTypes.func
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpDropdown);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




var DtpDropdownToggle = function DtpDropdownToggle(_ref, context) {
    var children = _ref.children,
        className = _ref.className;

    var dropDown = context.$dtpDropdown;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-dropdown-toggle', className),
            onClick: dropDown.handleChangeState },
        children
    );
};

DtpDropdownToggle.contextTypes = {
    $dtpDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

DtpDropdownToggle.propTypes =  false ? {
    /** Aceita qualquer elemento HTML que, ao ser clicado, vai abrir/fechar o dropdown */
    children: PropTypes.any,

    /** Aceita classe CSS para customizar a exibição do elemento */
    className: PropTypes.string
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpDropdownToggle);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var DtpDropdownContent = function DtpDropdownContent(_ref, context) {
    var children = _ref.children,
        className = _ref.className,
        props = _objectWithoutProperties(_ref, ['children', 'className']);

    var dropDown = context.$dtpDropdown;
    var open = dropDown.open;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
            ref: function ref(dtpDropdownContent) {
                dropDown.setContentRef(dtpDropdownContent);
            },
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dtp-dropdown', className, { 'open': open === true }, { 'hide': open === false })
        }, props),
        children
    );
};

DtpDropdownContent.contextTypes = {
    $dtpDropdown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

DtpDropdownContent.propTypes =  false ? {
    /** Aceita um array de DtpDropdownItem ou qualquer elemento HTML */
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),

    /** Aceita classe CSS para customizar a exibição do elemento. */
    className: PropTypes.string
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DtpDropdownContent);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DtpForm_DtpFormControl__ = __webpack_require__(62);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DtpFileUpload = function (_Component) {
    _inherits(DtpFileUpload, _Component);

    function DtpFileUpload() {
        _classCallCheck(this, DtpFileUpload);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DtpFileUpload.prototype.handleChange = function handleChange(event) {
        var _props = this.props,
            multiple = _props.multiple,
            onSelect = _props.onSelect;

        if (multiple) {
            onSelect(event.target.files);
        } else {
            onSelect(event.target.files[0]);
        }
    };

    DtpFileUpload.prototype.render = function render() {
        var _props2 = this.props,
            props = _props2.props,
            types = _props2.types,
            multiple = _props2.multiple;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DtpForm_DtpFormControl__["a" /* default */], _extends({
            componentClass: 'input',
            type: 'file',
            className: 'dtp-file-upload',
            onChange: this.handleChange.bind(this),
            accept: types,
            multiple: multiple
        }, props));
    };

    return DtpFileUpload;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DtpFileUpload.propTypes =  false ? {
    /**
     * Essa unção é disparada ao ser selecionado um arquivo.
     * Envia como parâmetro o(s) arquivo(s), dependendo do valor da prop multiple
     */
    onSelect: PropTypes.func,

    /** Define se o componente deve permitir a seleção de um ou diversos arquivos */
    multiple: PropTypes.bool.isRequired,

    /**
     * Tipos de arquivos permitidos para a seleção. Os tipos devem ser passados em uma string, seguindo o seguinte padrão:
     * <input accept="file_extension|audio/*|video/*|image/*|media_type">
     * 
     * Onde:
     * 
     * - file_extension: A file extension starting with the STOP character, e.g: .gif, .jpg, .png, .doc
     * - audio/*: All sound files are accepted.
     * - video/*: All video files are accepted.
     * - image/*: All image files are accepted.
     * - media_type: A valid media type, with no parameters. Look at IANA (http://www.iana.org/assignments/media-types/) Media Types for a complete list of standard media types.
     */
    types: PropTypes.string.isRequired
} : {};

DtpFileUpload.defaultProps = {
    multiple: false,
    types: '*.*'
};

/* harmony default export */ __webpack_exports__["a"] = (DtpFileUpload);

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutability_helper__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ListaExigencias__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ListaAlertas__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DadosRequerimentoAposentadoria__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DadosHistoricoRequerimento__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DadosHistoricoPrescricao__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DadosRelacoesPrevidenciarias__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DadosResultadoSimulacao__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalAlerta__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__consultas_Exigencia_ModalRejeicaoRequerimento__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ModalTempoRO__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ListaConflitosPeriodos__ = __webpack_require__(589);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var camposPreenchidosPorServico={cnis:['nome','nit','dataNascimento','sexo','nomeMae','isObtidoPelaRFB'],centralService:['tipoAposentadoria','dataInicioBeneficio','dataInicioPagamentoBeneficio','dataCessacaoBeneficio','rendaMensalInicial','dataCreditoPagamento','tempoContribuicaoTotalDias','idUOMantenedora']};var DOC_HOMOLOGACAO_TRIBUNAL=2;var DATA_MARCO_COMPENSACAO='01/01/2020';var ESTADO_INDEFERIDO_RATIFICADO=16;var EXIGENCIA_PERIODOS_ORIGEM=83;// Definir como atributos bloqueados para edição na abertura:
// Tipo aposentadoria, data de inicío de benefício,
// data de inicio de pagamento, data de cessação, RMI, UO mantenedora e Data de crédito
var RequerimentoAposentadoria=function(_Component){_inherits(RequerimentoAposentadoria,_Component);function RequerimentoAposentadoria(props,context){var _this2=this;_classCallCheck(this,RequerimentoAposentadoria);var _this=_possibleConstructorReturn(this,(RequerimentoAposentadoria.__proto__||Object.getPrototypeOf(RequerimentoAposentadoria)).call(this,props,context));_this.getInitialState=function(){return{tabPaginaAtual:0,requerimento:{cpf:null,dataCessacaoBeneficio:null,dataInicioBeneficio:null,dataInicioPagamentoBeneficio:null,dataNascimento:null,destinatario:null,solicitanteOrigem:null,documentosProbatorios:[],exigencias:[],estadoAtual:null,estado:null,matricula:null,nome:null,nomeMae:null,nit:null,elos:[],numeroBeneficio:null,protocoloCertidao:null,rendaMensalInicial:null,sexo:null,tempoContribuicaoRegimeOrigemDias:null,tempoContribuicaoTotalDias:null,tipoAposentadoria:null,dataDesvinculacao:null,dataIngresso:null,valorRmiSimulada:null,valorRmiReajustada:null,valorRmiCompensacaoPrevidenciaria:null,valorPercentualParticipacao:null,valorProRataInicial:null,valorSalarioMinimo:null,valorMedioBeneficios:null,estados:[],resultadoSimulacao:[],relacoesPrevidenciariasDestinatario:[],dataCreditoPagamento:null,dataMigracao:null,idUOMantenedora:null,qtdDiasEstadoAguardandoAnalise:null,arquivos:[],alertas:[],regraDeCalculo:null,destinatarioOrigem:null,cpfUsuarioResponsavel:null,listaMotivosIndeferimento:[],requerimentoPeriodos:[],requerimentoPeriodosExcluidos:[],tipoSegregacaoSolicitante:null,tipoSegregacaoDestinatario:null,alteracaoTempoRO:0,ctcEspecifica:0,conclusaoAnalise:null,listaConflitosPeriodos:[],motivoCessacaoManual:null,prescricao:null},vinculosSelecionados:[],touched:false,cpfTouched:false,exigenciasInvalidas:{dataIngresso:false,dataDesvinculacao:false,tempoContribuicaoRegimeOrigemDias:false},validadeCampos:{cpf:false,dataInicioBeneficio:false,dataNascimento:false,destinatario:false,solicitanteOrigem:false,nit:false,rendaMensalInicial:false,sexo:false,tempoContribuicaoTotalDias:false,tipoAposentadoria:false,idUOMantenedora:false,requerimentoPeriodos:false,dataMotivoCessacao:true},isObtidoPelaRFB:false,tipoRequerimento:1,sucessoUpload:false,acao:'novo',estadoFormulario:'inicial',showNoContent:false,noContentPrimaryMessage:'Requerimento não encontrado para o protocolo informado.',noContentSecondaryMessage:'Informe um protocolo válido.',requestPesquisa:null,showModalAlerta:false,showModalAlertaRequerimentosPeriodos:false,showModalAlertaRequerPerConcomitancia:false,showModalAlertaCtcNaoEncontrada:false,showModalAlertaReqAprovadoSemDataIngresso:false,showModalRecalcularTempoRO:false,chaveConfirmacao:null,isRmiZerada:false,rendaMensalInicialRequest:null,requerimentoVindoDoRequest:null,vinculosConcomitantesConfirmado:false,possuiVinculosConcomitantes:false,exibirBotaoVoltar:true,exibirCampoUoInss:false,exibirUploadArquivosNaConsulta:false,exibirModalCadeiaDeNit:false,exibirModalDataCessacao:false,exibirModalMotivoCessacao:false,exibirModalSegregacaoMassa:false,exibirModalDataEMotivoCessacao:false,origemModalSegregacaoMassa:null,showRejeicaoRequerimentoModal:false,habilitarBotaoCarregarDocumento:false,exigenciasOriginais:[],isCpfLogadoIgualCpfUsuarioResponsavel:false,validadeBotoesIndeferidos:{pesquisarDadosPessoais:false,pesquisarDadosBeneficio:false},destinatarioAlterado:{codigoDestinatario:null,codigoDestinatarioOrigem:null},checkExigirQualificacao:false,inIndefericaoAnalise:false,motivosIndeferimentoControle:[],exibirMultiplosPeriodos:false,protocoloCertidaoTouched:false,requerimentosPeriodosVindosDoRequest:[],habilitarCamposParaAlteracaoNaAnalise:true,duplaDestinacao:false,concomitanciaDePeriodosNoRequerimento:false,listaExigenciasAtendidas:[],periodosOriginais:[],rejeitar:false,clicouBotaoPesquisarCtc:false,historyTempoRO:null,historyCheckTempoRO:null,tipoDocumento:null,// listaConflitosPeriodos: [],
listaMotivosCessacao:[],labelMotivoCessacaoManual:null};};_this.getLotacao=function(roles){var array='';var lotacao=[];roles.forEach(function(role){var eNovo=role.match(/TD/g);var temPA=role.indexOf('|PA|')!==-1;if(temPA&&eNovo){array=role.split('|');for(var i=0,tam=array.length;i<tam;i+=1){if(array[i]==='TD'){lotacao.push(array[i+3]);break;}}}});return lotacao;};_this.apagaRegraDeCalculo=function(){var requerimento=Object.assign({},_this.state.requerimento);requerimento.regraDeCalculo=null;_this.setState({requerimento:requerimento});};_this.carregarMotivosCessacao=function(){if(_this.props.motivosCessacao.length===0){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["u" /* requestMotivos */])();}};_this.addMotivoCessacaoManualLabel=function(motivo){if(motivo!==null){var obj=Object(__WEBPACK_IMPORTED_MODULE_21__utils_listsSelect__["n" /* getObject */])(_this.props.motivosCessacao,motivo);if(obj!==undefined){_this.setState({labelMotivoCessacaoManual:obj.label});}}};_this.isDataMotivoValido=function(estadoParam){var estado=estadoParam||_this.state;var acao=estado.acao,requerimento=estado.requerimento;var listaAcoes=['realizar-analise','novo','cumprir-exigencia','indeferidos'];var temMotivo=requerimento.motivoCessacaoManual!==null&&requerimento.motivoCessacaoManual!==undefined&&requerimento.motivoCessacaoManual!=='';var temData=requerimento.dataCessacaoBeneficio!==null&&requerimento.dataCessacaoBeneficio!==undefined&&requerimento.dataCessacaoBeneficio!=='';return!listaAcoes.includes(acao)||// fora das ações → ignora
temMotivo&&temData||// ambos preenchidos
!temMotivo&&!temData// ambos vazios
;};_this.validarCamposMotivo=function(){var requerimento=_this.state.requerimento;var temMotivo=!!requerimento.motivoCessacaoManual;var temData=!!requerimento.dataCessacaoBeneficio;return temMotivo===temData;};_this.montaFormulario=function(){_this.carregarMotivosCessacao();if(_this.props.match.params.protocolo){var acao=_this.props.match.params.acao?_this.props.match.params.acao:'consulta';_this.setState({acao:acao},_this.buscaRequerimento);}else{Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["g" /* manterApenasFiltro */])('');if(_this.props.auth.checkPermission(['requerer-compensacao-rgps','gerenciar-negocio-dcomp'])){_this.setState({validadeCampos:Object.assign({},_this.state.validadeCampos,{numeroBeneficio:false})},_this.buscarTiposDocumentosUpload);}else if(_this.props.auth.checkPermission(['requerer-compensacao-rpps'])){_this.setState(_this.buscaParticipantePeloCnpjLogado());_this.setState({validadeCampos:Object.assign({},_this.state.validadeCampos,{matricula:false})},_this.buscarTiposDocumentosUpload);}_this.controlarExibicaoMultiplosPeriodos();}};_this.buscaRequerimento=function(){var metodoSucesso=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.handleSuccessBuscaRequerimento;if(_this.state.acao!=='novo'){var url='requerimentos-compensacao-aposentadoria/'+_this.props.match.params.protocolo;Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["e" /* doGet */])(url,metodoSucesso,_this.handleErrorBuscaRequerimento);}};_this.buscaMotivosCessacaoRequerimentoAposentadoria=function(tipo,tipoMotivo,tipoBeneficio){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["w" /* requestMotivosCessacaoRequerimentoAposentadoria */])(_this.handleErrorBusca,tipo,tipoMotivo,tipoBeneficio);};_this.handleSuccessBuscaParticipantePeloCnpjLogado=function(response){var _this$state=Object.assign({},_this.state),requerimento=_this$state.requerimento;//requerimento.idUOMantenedora = response.data.idUOInssConvenio;
var idUOMantenedora=response.data.idUOInssConvenio;_this.setState({// requerimento: { ...this.state.requerimento, requerimento },
requerimento:Object.assign({},requerimento,{idUOMantenedora:idUOMantenedora})},function(){if(response.data.inOrgaoUniao){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["H" /* solicitarEntesControlados */])(response.data.codigo,_this.handleEntesControlados);}});};_this.handleEntesControlados=function(e){__WEBPACK_IMPORTED_MODULE_7__reducers__["a" /* default */].dispatch({type:'SALVA_ENTES_CONTROLADOS',payload:e.data});};_this.handleErrorBuscaParticipantePeloCnpjLogado=function(){var mensagemPrimaria='Não foi possível consultar o ente participante.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.buscaParticipantePeloCnpjLogado=function(){var metodoSucesso=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.handleSuccessBuscaParticipantePeloCnpjLogado;var lotacaoUsuario=_this.getLotacao(_this.props.auth.userData.roles);if(lotacaoUsuario.length>0){var primParte=[];var segParte=[];if(lotacaoUsuario[0].indexOf('#')!==-1){var arrayLotacao=lotacaoUsuario[0].split('#');primParte.push(arrayLotacao[0]);segParte.push(arrayLotacao[1]);}var url='participantes-compensacao/'+segParte;Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["e" /* doGet */])(url,metodoSucesso,_this.handleErrorBuscaParticipantePeloCnpjLogado);}};_this.handleSuccessBuscaQuantidadeAprovadosSemDataIngresso=function(response){if(response.data>0){_this.setState({chaveConfirmacao:'',alertas:[],showModalAlertaReqAprovadoSemDataIngresso:!_this.state.showModalAlertaReqAprovadoSemDataIngresso});}};_this.handleSuccessBuscaListaConflitosPeriodos=function(response){if(response.data){var lista=[];if(response.data&&response.data.length>0){lista=response.data;}_this.setState(function(prevState){return{requerimento:Object.assign({},prevState.requerimento,{listaConflitosPeriodos:lista})};});}};_this.buscaQuantidadeAprovadosSemDataIngresso=function(cpf){var url='requerimentos-compensacao-aposentadoria/quantidade-aprovados-sem-data/cpf/'+cpf;Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["e" /* doGet */])(url,_this.handleSuccessBuscaQuantidadeAprovadosSemDataIngresso,_this.handleErrorBuscaRequerimento);};_this.buscaListaConflitosPeriodos=function(){var url='requerimentos-compensacao-aposentadoria/conflito-periodos/lista';var protocolo=_this.props.match.params.protocolo;Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["e" /* doGet */])(url+'/'+protocolo,_this.handleSuccessBuscaListaConflitosPeriodos,_this.handleErrorBuscaRequerimento);};_this.handleSuccessBuscaRequerimentoAposSalvarERejeitar=function(response){_this.setState({requerimento:Object.assign({},_this.state.requerimento,response.data)});};_this.isDataCessacaoManualPreenchida=function(){return _this.state.requerimento.dataCessacaoBeneficio!==null&&_this.state.requerimento.dataCessacaoBeneficio!==''&&_this.state.requerimento.dataCessacaoBeneficio!==undefined;};_this.isMotivoCessacaoManualPreenchido=function(){return _this.state.requerimento.motivoCessacaoManual!==null&&_this.state.requerimento.motivoCessacaoManual!==''&&_this.state.requerimento.motivoCessacaoManual!==undefined;};_this.verificarValidadeMotivoCessacaoManual=function(dataCessacaoBeneficio,motivoCessacaoManual){var existeDataPreenchida=dataCessacaoBeneficio!==null&&dataCessacaoBeneficio!==''&&dataCessacaoBeneficio!==undefined;var existeMotivoCessacaoManual=motivoCessacaoManual!==null&&motivoCessacaoManual!==''&&motivoCessacaoManual!==undefined;if(existeDataPreenchida&&existeMotivoCessacaoManual){return true;}if(!existeDataPreenchida&&!existeMotivoCessacaoManual){return true;}return false;};_this.handleSuccessBuscaRequerimentoAtualizacao=function(response){var validadeCampos=_this.montaValidadeCampos(response.data);if(response.data){if(response.data.estado===2){var requerimentoVindoDoRequest=response.data;_this.setState({requerimentoVindoDoRequest:requerimentoVindoDoRequest});}}_this.setState({requerimento:response.data,estadoInicialRequerimento:response.data.estado,touched:true,validadeCampos:validadeCampos},_this.validaVoltaPagina);};_this.validaVoltaPagina=function(){if(!_this.state.requerimento.exigencias||_this.state.requerimento.exigencias.filter(function(exigencia){return exigencia.tipoDocumento;}).length===_this.state.requerimento.exigencias.length){_this.props.history.goBack();}};_this.montaValidadeCampos=function(requerimento){var _this$state2=Object.assign({},_this.state),validadeCampos=_this$state2.validadeCampos;Object.keys(requerimento).forEach(function(key){if(!['tempoContribuicaoRegimeOrigemDias','dataIngresso','dataDesvinculacao'].includes(key)){validadeCampos[key]=true;}});if(_this.state.acao==='cumprir-exigencia'&&requerimento.estado===2){if(requerimento.exigencias){var exigenciaComAtributo=requerimento.exigencias.filter(function(item){return item.atributo;});exigenciaComAtributo.forEach(function(exigencia){if(!['tempoContribuicaoRegimeOrigemDias','dataIngresso','dataDesvinculacao'].includes(exigencia.atributo)){validadeCampos[exigencia.atributo]=false;}});}if(_this.verificarValidadeMotivoCessacaoManual(requerimento.dataCessacaoBeneficio,requerimento.motivoCessacaoManual)){validadeCampos.dataMotivoCessacao=true;}else{validadeCampos.dataMotivoCessacao=false;}}if(_this.state.acao==='qualificar'&&requerimento.estado===2&&requerimento.exigencias){var exigenciaQualificacao=requerimento.exigencias.find(function(item){return item.tipo===72;});if(exigenciaQualificacao){validadeCampos.cpf=false;}}return validadeCampos;};_this.handleSearchNBButtonExigencia=function(){_this.setState(_this.handleNBSearchExigencia);};_this.trataSucessoResponseNBExigencia=function(response){var _this$state3=Object.assign({},_this.state),validadeCampos=_this$state3.validadeCampos;var _this$state4=Object.assign({},_this.state),requerimento=_this$state4.requerimento;var idUoMantenedoraRequest=response.data.idUOMantenedora;var idUOMantenedora=idUoMantenedoraRequest;var novoRequerimento=Object.assign({},requerimento,response.data);var dataMotivoValido=_this.isDataMotivoValido(Object.assign({},_this.state,{requerimento:novoRequerimento}));_this.setState({requerimento:novoRequerimento,requestPesquisa:null,validadeCampos:Object.assign({},validadeCampos,{dataMotivoCessacao:dataMotivoValido})});_this.setState({requerimento:Object.assign({},requerimento,{idUOMantenedora:idUOMantenedora}),requestPesquisa:null,validadeCampos:validadeCampos});};_this.handleNBSearchExigencia=function(){var _this$state5=Object.assign({},_this.state),requerimento=_this$state5.requerimento;if(requerimento.numeroBeneficio){var _this$state$requerime=Object.assign({},_this.state.requerimento),numeroBeneficio=_this$state$requerime.numeroBeneficio;_this.setState({requestPesquisa:'centralService'},Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["e" /* doGet */])('beneficio-rgps/'+numeroBeneficio,_this.trataSucessoResponseNBExigencia,_this.trataErrosResponse));}};_this.verificaIndefericaoAnalise=function(){var _this$state$requerime2=Object.assign({},_this.state.requerimento),estados=_this$state$requerime2.estados;var _this$state6=Object.assign({},_this.state),motivosIndeferimentoControle=_this$state6.motivosIndeferimentoControle;if(estados&&estados.length>0){if(estados[0].motivos&&estados[0].motivos.length>0){motivosIndeferimentoControle=estados[0].motivos;_this.setState({motivosIndeferimentoControle:motivosIndeferimentoControle,inIndefericaoAnalise:true});var changeObj={value:9};_this.alteraEstadoRequerimento(changeObj);Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["u" /* requestMotivos */])();}}};_this.handleSuccessBuscaRequerimento=function(response){var validadeCampos=_this.montaValidadeCampos(response.data);var _this$state7=Object.assign({},_this.state),exibirCampoUoInss=_this$state7.exibirCampoUoInss;var _this$state8=Object.assign({},_this.state),historyTempoRO=_this$state8.historyTempoRO;if(response.data){var requerimentoVindoDoRequest=response.data;var solicitanteRGPS=requerimentoVindoDoRequest.solicitante&&requerimentoVindoDoRequest.solicitante.codigo==='01000';var destinatarioRGPS=requerimentoVindoDoRequest.destinatario&&requerimentoVindoDoRequest.destinatario.codigo==='01000';historyTempoRO=response.data.tempoContribuicaoRegimeOrigemDias;if(response.data.estado===2){// em exigência mas pode nao ser consulta
if(requerimentoVindoDoRequest.solicitanteOrigem===undefined){validadeCampos.solicitanteOrigem=true;}var _this$state9=Object.assign({},_this.state),periodosOriginais=_this$state9.periodosOriginais;if(requerimentoVindoDoRequest.requerimentoPeriodos!==undefined){requerimentoVindoDoRequest.requerimentoPeriodos.forEach(function(periodo){if(periodosOriginais.length!==0){var index=periodosOriginais.findIndex(function(p){return p.idPeriodo!==periodo.idPeriodo;});if(index!==-1){periodosOriginais.push(periodo);}}else{periodosOriginais.push(periodo);}});_this.setState({periodosOriginais:periodosOriginais});}_this.setState({requerimentoVindoDoRequest:requerimentoVindoDoRequest});// IB 282195
if(_this.state.acao==='consulta'){var _this$state10=Object.assign({},_this.state),exigenciasOriginais=_this$state10.exigenciasOriginais;var _this$state11=Object.assign({},_this.state),exibirUploadArquivosNaConsulta=_this$state11.exibirUploadArquivosNaConsulta;requerimentoVindoDoRequest.exigencias.forEach(function(exigencia){exigenciasOriginais.push(exigencia);});var usuarioLogado=__WEBPACK_IMPORTED_MODULE_23__domain_User__["a" /* default */].logged();var isCpfLogadoIgualCpfUsuarioResponsavel=usuarioLogado.data.prevCpf===requerimentoVindoDoRequest.cpfUsuarioResponsavel;// isCpfLogadoIgualCpfUsuarioResponsavel é o cpf de quem pegou o requerimento para analisar no GET
if(!solicitanteRGPS){exibirUploadArquivosNaConsulta=true;}else if(isCpfLogadoIgualCpfUsuarioResponsavel&&solicitanteRGPS){exibirUploadArquivosNaConsulta=true;}_this.setState({exigenciasOriginais:exigenciasOriginais,exibirUploadArquivosNaConsulta:exibirUploadArquivosNaConsulta});}}// pesquisar a quantidade de requerimentos aprovados sem data de ingresso
if(response.data.estado===6&&_this.state.tipoRequerimento===1){_this.buscaQuantidadeAprovadosSemDataIngresso(response.data.cpf);}// buscar requerimentos com conflitos de periodos
// if (!this.props.auth.checkPermission(['fornecer-parecer-medico-rpps'])) {
//   this.buscaListaConflitosPeriodos();
// }
if(_this.state.acao==='indeferidos'||_this.state.acao==='complementar-aposentadoria'){validadeCampos.solicitanteOrigem=true;}// if (this.state.acao === 'complementar-aposentadoria') {
//   validadeCampos.solicitanteOrigem = true;
//   validadeCampos.dataHomologacaoTribunalContas = false;
// }
// IB 282195
if(_this.state.acao==='consulta'&&response.data.estado!==2){// !this.isConsultaExigencia()
var paramUploadArquivosNaConsulta=Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["f" /* habilitarUploadNaConsultaDoRequerimento */])(requerimentoVindoDoRequest,_this.state.acao,null);_this.setState({exibirUploadArquivosNaConsulta:paramUploadArquivosNaConsulta});}if(solicitanteRGPS||destinatarioRGPS){exibirCampoUoInss=true;_this.setState({exibirCampoUoInss:exibirCampoUoInss});}_this.addMotivoCessacaoManualLabel(response.data.motivoCessacaoManual);}_this.setState({requerimento:Object.assign({},_this.state.requerimento,response.data),estadoInicialRequerimento:response.data.estado,touched:true,validadeCampos:validadeCampos,historyTempoRO:historyTempoRO},function(){if(_this.state.acao==='realizar-analise'){_this.state.requerimento.relacoesPrevidenciariasDestinatario.map(function(relacao){return relacao.regimePrevidenciario;}).flat().forEach(function(regime){return _this.marcarRegime(regime);});}_this.buscarTiposDocumentos();});if(_this.state.requerimento.estado===6){_this.verificaIndefericaoAnalise();}// IB422810 - MÉTODOS PARA OS SUBPERIODOS
_this.controlarExibicaoMultiplosPeriodos();// this.atualizarDataIngressoDesvinculacaoETempo(this.state.requerimento.requerimentoPeriodos);
_this.verificarHabilitacaoDataIngressoDesvinculacaoETempo();_this.marcarExigenciaInvalidaDataIngressoDesvinculacaoETempoRO();// IB422810 - MÉTODOS PARA OS SUBPERIODOS
};_this.buscarTiposDocumentosUpload=function(){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["D" /* requestTiposDocumentos */])(_this.handleErrorBusca);};_this.isConsultaExigencia=function(){return _this.state.acao==='consulta'&&_this.state.requerimento.estado===2;};_this.buscarTiposDocumentos=function(){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["D" /* requestTiposDocumentos */])(_this.handleErrorBusca);};_this.montaListaMotivosDisponiveis=function(){var listaMotivos=[];_this.props.motivosCessacaoRequerimentoAposentadoria.forEach(function(motivo){if(motivo.value!==24){listaMotivos.push({value:motivo.value,label:motivo.label});}});_this.setState({listaMotivosCessacao:listaMotivos});};_this.handleErrorBuscaRequerimento=function(error){var mensagemPrimaria='Não foi possível consultar o requerimento.';var mensagemSecundaria='Contate o administrador do sistema.';if(error){if(error.status){if(error.status===404){mensagemPrimaria='Requerimento não encontrado para o protocolo informado.';mensagemSecundaria='Informe um protocolo válido.';}}}_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.handleErrorBusca=function(){var mensagemPrimaria='Não foi possível consultar o requerimento.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({mostraPaginaSemConteudo:true,mensagemPrincipalSemConteudo:mensagemPrimaria,mensagemSecundariaSemConteudo:mensagemSecundaria});};_this.alteraEstadoRequerimento=function(changeObj){if(changeObj.value!==9&&_this.state.motivosIndeferimentoControle&&_this.state.motivosIndeferimentoControle.length>0){_this.setState({inIndefericaoAnalise:false});}_this.setState({requerimento:Object.assign({},_this.state.requerimento,{exigencias:[],motivo:null,justificativaIndeferimento:null,conclusaoAnalise:null})},function(){return _this.handleChange(changeObj,'estado');});};_this.verificaCumprimentoExigencia=function(){var exigenciaCumprida=false;var houveAlteracao=false;if(_this.state.requerimento.exigencias){_this.state.requerimento.exigencias.forEach(function(item){if(item.atributo){if(item.atributo in _this.state.validadeCampos&&_this.state.validadeCampos[item.atributo]){exigenciaCumprida=true;}}else{// IB557704 uploads na tela de exigencia
var _this$state$requerime3=Object.assign({},_this.state.requerimento),arquivos=_this$state$requerime3.arquivos;if(arquivos){var index=arquivos.findIndex(function(i){return i.tipoDocumento===item.tipoDocumento;});if(index!==-1){exigenciaCumprida=true;}}}});}if(exigenciaCumprida){_this.state.requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo&&exigencia.atendida===0){if(paramAtributo in _this.state.validadeCampos){_this.state.validadeCampos[paramAtributo]=true;}}});var _valido=Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);_this.state.requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo&&exigencia.atendida===0){if(paramAtributo in _this.state.validadeCampos){_this.state.validadeCampos[paramAtributo]=false;}}});if(!_valido){houveAlteracao=_valido;}else{houveAlteracao=exigenciaCumprida;}}else{var lista=_this.verificaAlteracaoCamposEstadoExigencia();if(lista&&lista.length===0){// verificar campos alterados que nao sao exigencia
lista=_this.verificaAlteracaoCamposQueNaoSaoExigencia();}houveAlteracao=lista&&lista.length>0;var _this$state12=Object.assign({},_this.state),requestPesquisa=_this$state12.requestPesquisa;var alterouPeloBotaoPesquisar=requestPesquisa;if(alterouPeloBotaoPesquisar){return true;}if(houveAlteracao){_this.state.requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo&&exigencia.atendida===0){if(paramAtributo in _this.state.validadeCampos){_this.state.validadeCampos[paramAtributo]=true;}}});houveAlteracao=Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);_this.state.requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo&&exigencia.atendida===0){if(paramAtributo in _this.state.validadeCampos){_this.state.validadeCampos[paramAtributo]=false;}}});}}if(!_this.isDataMotivoValido()){return false;}console.log({exigenciaCumprida:exigenciaCumprida,houveAlteracao:houveAlteracao,validadeCampos:_this.state.validadeCampos,dataMotivoCessacao:_this.state.validadeCampos.dataMotivoCessacao,motivo:_this.state.requerimento.motivoCessacaoManual,data:_this.state.requerimento.dataCessacaoBeneficio});var valido=Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);console.log('validateObject=',valido,_this.state.validadeCampos);return houveAlteracao;};_this.existeTipoDocumentoCarregadoNoRequerimento=function(tipoEmDocumentosProbatorios){var existeTipoDocumento=_this.state.requerimento.documentosProbatorios.some(function(documento){return documento.tipoDocumento===tipoEmDocumentosProbatorios;});return existeTipoDocumento;};_this.verificaPreenchimentoDataHomologacaoTribunalContas=function(){var _this$state13=Object.assign({},_this.state),requerimento=_this$state13.requerimento;return requerimento.dataHomologacaoTribunalContas!==null&&requerimento.dataHomologacaoTribunalContas!==''&&requerimento.dataHomologacaoTribunalContas!==undefined;};_this.verificarCondicaoValidaParaComplementar=function(){// testar se existe o doc de homologacao do tribunal.
var existeHomologacaoTribunalAnexada=false;var dataHomologacaoPreenchida=false;var dataAberturaRequerimento=__WEBPACK_IMPORTED_MODULE_8_moment___default()(_this.state.requerimento.dataAberturaRequerimento,'DD/MM/YYYY').toDate();var marcoCompensacao=__WEBPACK_IMPORTED_MODULE_8_moment___default()(DATA_MARCO_COMPENSACAO,'DD/MM/YYYY').toDate();// '01/01/2020'
var condicaoValidaParaComplementar=false;if(dataAberturaRequerimento<=marcoCompensacao){// se a data de abertura do req for menor doque 01/01/2020
existeHomologacaoTribunalAnexada=_this.existeTipoDocumentoCarregadoNoRequerimento(DOC_HOMOLOGACAO_TRIBUNAL);dataHomologacaoPreenchida=_this.verificaPreenchimentoDataHomologacaoTribunalContas();condicaoValidaParaComplementar=dataHomologacaoPreenchida||existeHomologacaoTribunalAnexada;}else{condicaoValidaParaComplementar=_this.verificaPreenchimentoDataHomologacaoTribunalContas();}return condicaoValidaParaComplementar;};_this.formularioProntoParaEnvio=function(){var _this$state14=Object.assign({},_this.state),acao=_this$state14.acao;var _this$state15=Object.assign({},_this.state),estadoFormulario=_this$state15.estadoFormulario;var _this$state16=Object.assign({},_this.state),requerimento=_this$state16.requerimento;switch(acao){case'novo':{if(estadoFormulario==='inicial'){_this.state.validadeCampos.idUOMantenedora=true;return Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);}if(estadoFormulario==='criado'){return true;}if(estadoFormulario==='alterado'){return Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);;}}case'cumprir-exigencia':return _this.verificaCumprimentoExigencia();case'realizar-analise':return _this.verificaSeAnaliseCompleta();case'emitir-parecer-medico':return typeof _this.state.requerimento.enquadraArtigo151Lei8213==='boolean'&&typeof _this.state.requerimento.invalidezAcidentaria==='boolean';case'qualificar':return _this.verificaQualificacao();case'consulta':return Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["f" /* habilitarUploadNaConsultaDoRequerimento */])(requerimento,acao,null)&&_this.state.habilitarBotaoCarregarDocumento;case'indeferidos':{if(_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps'])){return _this.verificaIndeferidos('rgps');}if(_this.props.auth.checkPermission(['analisar-compensacao-rpps','requerer-compensacao-rpps'])){return _this.verificaIndeferidos('rpps');}}case'salvarERejeitar':return Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);case'complementar-aposentadoria':var condicaoValidaParaComplementar=_this.verificarCondicaoValidaParaComplementar();return Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos)&&condicaoValidaParaComplementar;default:return false;}};_this.verificaIndeferidos=function(regime){var retorno=true;if(regime==='rgps'){var _this$state17=Object.assign({},_this.state),validadeCampos=_this$state17.validadeCampos;var _this$state18=Object.assign({},_this.state),isRmiZerada=_this$state18.isRmiZerada;var _this$state19=Object.assign({},_this.state),isObtidoPelaRFB=_this$state19.isObtidoPelaRFB;var _this$state20=Object.assign({},_this.state),validadeBotoesIndeferidos=_this$state20.validadeBotoesIndeferidos;var _this$state$requerime4=Object.assign({},_this.state.requerimento),requerimentoPeriodos=_this$state$requerime4.requerimentoPeriodos;var camposMotivoValidos=_this.validarCamposMotivo();var camposValidos=false;if(validadeCampos.destinatario&&camposMotivoValidos){camposValidos=true;}var camposValidosRetornoRFB=true;if(isObtidoPelaRFB){camposValidosRetornoRFB=validadeCampos.nit&&validadeCampos.sexo;}var camposValidosRMIZerada=true;if(isRmiZerada){camposValidosRMIZerada=isRmiZerada&&validadeCampos.rendaMensalInicial;}if(validadeBotoesIndeferidos.pesquisarDadosPessoais===true){retorno=camposValidos&&camposValidosRetornoRFB&&validadeBotoesIndeferidos.pesquisarDadosBeneficio&&camposValidosRMIZerada&&requerimentoPeriodos&&requerimentoPeriodos.length>0;}else{retorno=camposValidos&&camposValidosRetornoRFB&&validadeBotoesIndeferidos.pesquisarDadosBeneficio&&_this.state.checkExigirQualificacao&&_this.state.cpfTouched&&camposValidosRMIZerada&&requerimentoPeriodos&&requerimentoPeriodos.length>0;}}else{var _this$state21=Object.assign({},_this.state),_validadeCampos=_this$state21.validadeCampos;var _this$state22=Object.assign({},_this.state),_validadeBotoesIndeferidos=_this$state22.validadeBotoesIndeferidos;var _this$state$requerime5=Object.assign({},_this.state.requerimento),_requerimentoPeriodos=_this$state$requerime5.requerimentoPeriodos;var _camposValidos=false;var _camposMotivoValidos=_this.validarCamposMotivo();if(_validadeCampos.matricula&&_validadeCampos.tipoAposentadoria&&_validadeCampos.dataInicioBeneficio&&_validadeCampos.tempoContribuicaoTotalDias&&_validadeCampos.rendaMensalInicial&&_camposMotivoValidos){_camposValidos=true;}var _camposValidosRetornoRFB=true;if(_this.state.isObtidoPelaRFB){_camposValidosRetornoRFB=_validadeCampos.nit&&_validadeCampos.sexo;}if(_validadeBotoesIndeferidos.pesquisarDadosPessoais===true){retorno=_camposValidos&&_camposValidosRetornoRFB&&_requerimentoPeriodos&&_requerimentoPeriodos.length>0;}else{retorno=_camposValidos&&_camposValidosRetornoRFB&&_this.state.checkExigirQualificacao&&_this.state.cpfTouched&&_requerimentoPeriodos&&_requerimentoPeriodos.length>0;}}return retorno;};_this.verificaQualificacao=function(){return _this.state.validadeCampos.cpf&&_this.state.validadeCampos.nit&&_this.state.validadeCampos.dataNascimento&&_this.state.validadeCampos.sexo;};_this.validarCamposNulo=function(nome){var retorno=false;if(nome!==null){retorno=true;}return retorno;};_this.validarCamposUndefined=function(nome){var retorno=false;if(nome!==undefined){retorno=true;}return retorno;};_this.validarCamposColecaoVazio=function(nome){var retorno=false;if(nome&&nome!==undefined&&nome!==null&&nome.length>0){retorno=true;}return retorno;};_this.verificarMudancaNosValoresDaColecao=function(colecaoOriginal,colecaoAlterada,nomeColecao){var colecaoOriginalOrdenada=[];var colecaoAlteradaOrdenada=[];if(colecaoOriginal&&colecaoOriginal.length>0){colecaoOriginalOrdenada=_this.ordenarListaPeriodos(colecaoOriginal);}if(colecaoAlterada&&colecaoAlterada.length>0){colecaoAlteradaOrdenada=_this.ordenarListaPeriodos(colecaoAlterada);}if(nomeColecao==='requerimentoPeriodos'){colecaoOriginalOrdenada.forEach(function(item){var indexPeriodo=colecaoAlteradaOrdenada.findIndex(function(i){return i.idPeriodo===item.idPeriodo;});var isDataFimAlterada=colecaoOriginalOrdenada[indexPeriodo].dataFim!==colecaoAlteradaOrdenada[indexPeriodo].dataFim;var isDataInicioAlterada=colecaoOriginalOrdenada[indexPeriodo].dataInicio!==colecaoAlteradaOrdenada[indexPeriodo].dataInicio;var isQtdDiasDescontoAlterada=colecaoOriginalOrdenada[indexPeriodo].qtdDiasDesconto!==colecaoAlteradaOrdenada[indexPeriodo].qtdDiasDesconto;if(isDataFimAlterada||isDataInicioAlterada||isQtdDiasDescontoAlterada){return true;}else{return false;}});}else{for(var i=0;i<colecaoAlteradaOrdenada.length;i++){if(colecaoOriginalOrdenada[i]!==colecaoAlteradaOrdenada[i]){// mudou o valor de algum campo dentro da coleção
return true;}else{return false;}}}};_this.verificarMudancaNosValoresDaColecaoPeriodos=function(colecaoOriginal,colecaoAlterada,deveValidarTempoDescontado){var colecaoOriginalOrdenada=[];var colecaoAlteradaOrdenada=[];var retorno=false;if(colecaoOriginal&&colecaoOriginal.length>0){colecaoOriginalOrdenada=_this.ordenarListaPeriodos(colecaoOriginal);}if(colecaoAlterada&&colecaoAlterada.length>0){colecaoAlteradaOrdenada=_this.ordenarListaPeriodos(colecaoAlterada);}colecaoOriginalOrdenada.forEach(function(item,i){if(retorno){return retorno;}var indexPeriodo=i;var isDataFimAlterada=colecaoOriginalOrdenada[indexPeriodo].dataFim!==colecaoAlteradaOrdenada[indexPeriodo].dataFim;var isDataInicioAlterada=colecaoOriginalOrdenada[indexPeriodo].dataInicio!==colecaoAlteradaOrdenada[indexPeriodo].dataInicio;var isQtdDiasDescontoAlterada=deveValidarTempoDescontado&&colecaoOriginalOrdenada[indexPeriodo].qtdDiasDesconto!==colecaoAlteradaOrdenada[indexPeriodo].qtdDiasDesconto;if(isDataFimAlterada||isDataInicioAlterada||isQtdDiasDescontoAlterada){retorno=true;}else{retorno=false;}});return retorno;};_this.verificarMudancaNaColecaoDePeriodos=function(colecaoOriginal,colecaoAlterada,deveValidarTempoDescontado){var retorno=false;if(colecaoOriginal&&colecaoAlterada){if(colecaoOriginal.length!==colecaoAlterada.length){retorno=true;// houve alteracao - cumpre exigencia
}else if(colecaoOriginal.length===colecaoAlterada.length){// verificar se houve mudanca nos valores
retorno=_this.verificarMudancaNosValoresDaColecaoPeriodos(colecaoOriginal,colecaoAlterada,deveValidarTempoDescontado);}}return retorno;};_this.verificarMudancaNoValorDoCampo=function(campo1,campo2){var retorno=false;if(campo1!==campo2){retorno=true;}if(campo1===undefined&&campo2===null){retorno=false;}return retorno;};_this.verificaAlteracaoCamposEstadoExigencia=function(){// requerimento que está sendo manipulado.
var _this$state23=Object.assign({},_this.state),requerimento=_this$state23.requerimento;// requerimento que está salvo na tabela.
var _this$state24=Object.assign({},_this.state),requerimentoVindoDoRequest=_this$state24.requerimentoVindoDoRequest;var camposExigencia=['destinatario','idUOMantenedora','nome','nit','dataNascimento','sexo','nomeMae','matricula','numeroBeneficio','tipoAposentadoria','dataInicioBeneficio','dataInicioPagamentoBeneficio','dataCessacaoBeneficio','tempoContribuicaoTotalDias','tempoContribuicaoRegimeOrigemDias','rendaMensalInicial','dataIngresso','dataDesvinculacao','dataHomologacaoTribunalContas','dataCreditoPagamento','regraDeCalculo','requerimentoPeriodos','arquivos','motivoCessacaoManual'];if(requerimentoVindoDoRequest!==null&&requerimento!==null){var lista=[];camposExigencia.forEach(function(exigencia){var campoRequerimento=requerimento[exigencia];var campoRequerimentoVindoDoRequest=requerimentoVindoDoRequest[exigencia];if(exigencia==='destinatario'){campoRequerimento=requerimento[exigencia];if(campoRequerimento!==null){campoRequerimento=requerimento[exigencia].codigo;}campoRequerimentoVindoDoRequest=requerimentoVindoDoRequest[exigencia];if(campoRequerimentoVindoDoRequest!==null){campoRequerimentoVindoDoRequest=requerimentoVindoDoRequest[exigencia].codigo;}}if(exigencia==='requerimentoPeriodos'){var _this$state25=Object.assign({},_this.state),periodosOriginais=_this$state25.periodosOriginais;campoRequerimentoVindoDoRequest=periodosOriginais;}switch(exigencia){case'destinatario':if(_this.validarCamposNulo(campoRequerimento)&&_this.validarCamposNulo(campoRequerimentoVindoDoRequest)&&_this.verificarMudancaNoValorDoCampo(campoRequerimentoVindoDoRequest,campoRequerimento)){lista.push(exigencia);}break;case'requerimentoPeriodos':if(_this.verificarMudancaNaColecaoDePeriodos(campoRequerimentoVindoDoRequest,campoRequerimento,true)){lista.push(exigencia);}break;case'arquivos':if(_this.validarCamposColecaoVazio(campoRequerimento)){lista.push(exigencia);}break;default:if(_this.validarCamposNulo(campoRequerimento)&&_this.validarCamposNulo(campoRequerimentoVindoDoRequest)){if(_this.verificarMudancaNoValorDoCampo(campoRequerimentoVindoDoRequest,campoRequerimento)){lista.push(exigencia);}}break;}});return lista;}};_this.verificaAlteracaoCamposQueNaoSaoExigencia=function(){// requerimento que está sendo manipulado.
var _this$state26=Object.assign({},_this.state),requerimento=_this$state26.requerimento;// requerimento que está salvo na tabela.
var _this$state27=Object.assign({},_this.state),requerimentoVindoDoRequest=_this$state27.requerimentoVindoDoRequest;var camposNaoExigencia=['protocoloCertidao','tipoSegregacaoSolicitante','tipoSegregacaoDestinatario'];if(requerimentoVindoDoRequest!==null&&requerimento!==null){var lista=[];camposNaoExigencia.forEach(function(campo){var campoRequerimento=requerimento[campo];var campoRequerimentoVindoDoRequest=requerimentoVindoDoRequest[campo];if(['tipoSegregacaoSolicitante','tipoSegregacaoDestinatario'].includes(campo)){if(_this.validarCamposUndefined(campoRequerimentoVindoDoRequest)){if(_this.verificarMudancaNoValorDoCampo(campoRequerimentoVindoDoRequest,campoRequerimento)){lista.push(campo);}}else{if(_this.verificarMudancaNoValorDoCampo(campoRequerimentoVindoDoRequest,campoRequerimento)){lista.push(campo);}}}else{if(_this.validarCamposNulo(campoRequerimento)&&_this.validarCamposNulo(campoRequerimentoVindoDoRequest)){if(_this.verificarMudancaNoValorDoCampo(campoRequerimentoVindoDoRequest,campoRequerimento)){lista.push(campo);}}}});return lista;}};_this.existeConcomitanciaRegimes=function(lista){var formatos=["DD/MM/YYYY","DD/MM/YY"];if(!Array.isArray(lista)||lista.length===0){return{existeConcomitancia:false};}// Apenas itens ativos (não descartados)
var ativos=lista.filter(function(item){return item.tipoConcomitanteDescartado!==1;});var ordenados=[].concat(_toConsumableArray(ativos)).sort(function(a,b){return __WEBPACK_IMPORTED_MODULE_8_moment___default()(a.dataInicio,formatos,true).diff(__WEBPACK_IMPORTED_MODULE_8_moment___default()(b.dataInicio,formatos,true));});for(var i=0;i<ordenados.length-1;i++){var atualFim=__WEBPACK_IMPORTED_MODULE_8_moment___default()(ordenados[i].dataFim,formatos,true);var proxInicio=__WEBPACK_IMPORTED_MODULE_8_moment___default()(ordenados[i+1].dataInicio,formatos,true);if(proxInicio.isSameOrBefore(atualFim)){return{existeConcomitancia:true};}}return{existeConcomitancia:false};};_this.existeConcomitanciaRemuneracoes=function(lista){// Função que detecta pares mes/ano duplicados (sobrepostos)
var vistos={};// Armazena combinações já vistas
var duplicados=[];// Armazena entradas que se repetem
var retorno=false;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=lista[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var item=_step.value;var chave=item.mes+'-'+item.ano;if(vistos[chave]){duplicados.push(item);// Achou sobreposição
}else{vistos[chave]=true;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(duplicados.length>0){retorno=true;}return retorno;};_this.carregarListaRegimes=function(lista){var retorno=[];lista.forEach(function(relacao){if(relacao.regimePrevidenciario){relacao.regimePrevidenciario.forEach(function(regime){retorno.push(regime);});}});return retorno;};_this.carregarRemuneracoes=function(lista){var retorno=[];var ativos=lista.filter(function(item){return item.tipoConcomitanteDescartado!==1;});ativos.forEach(function(regime){if(regime.remuneracoes){regime.remuneracoes.forEach(function(remuneracao){retorno.push(remuneracao);});}});return retorno;};_this.atualizarVinculosConcomitantesConfirmado=function(resultado){if(!resultado.datasValidas){return;}_this.setState({vinculosConcomitantesConfirmado:true,possuiVinculosConcomitantes:resultado.existeConcomitancia});};_this.validacaoDeVinculosConcomitantes=function(){var requerimento=_this.state.requerimento;var listaDeRelacoes=requerimento&&requerimento.relacoesPrevidenciariasDestinatario||[];if(_this.state.requerimento&&_this.state.requerimento.destinatario&&_this.state.requerimento.destinatario.codigo==='01000'){return{datasValidas:true,existeConcomitancia:false};}if(listaDeRelacoes.length<=1){return{datasValidas:true,existeConcomitancia:false};}var listaRegimes=_this.carregarListaRegimes(listaDeRelacoes);// valida integridade das datas
var integridade=_this.validarDatasRegimes(listaRegimes);if(!integridade.valido){return{datasValidas:false,existeConcomitancia:false,mensagemErro:integridade.mensagemErro};}// verifica concomitância dos regimes
var concomitancia=_this.existeConcomitanciaRegimes(listaRegimes);if(!concomitancia.existeConcomitancia){var listaRemuneracoes=_this.carregarRemuneracoes(listaRegimes);var concomitanciaRemuneracoes=_this.existeConcomitanciaRemuneracoes(listaRemuneracoes);return{datasValidas:true,existeConcomitancia:concomitanciaRemuneracoes};}return{datasValidas:true,existeConcomitancia:true};};_this.peloMenosUmVinculoSelecionado=function(){var colecao=_this.state.requerimento.relacoesPrevidenciariasDestinatario;var regimes=colecao.map(function(e){return e.regimePrevidenciario;}).flat();if(_this.state.requerimento&&_this.state.requerimento.destinatario&&_this.state.requerimento.destinatario.codigo==='01000'){return true;}else if(regimes.length>1){var regimesSelecionados=regimes.filter(function(e){return e.tipoConcomitanteDescartado===0;});return regimesSelecionados.length>=1;}return true;};_this.validarDatasRegimes=function(lista){var formatos=["DD/MM/YYYY","DD/MM/YY"];if(!Array.isArray(lista)){return{valido:false,mensagemErro:"Vínculos inválidos. Verifique a aba Relações Previdenciárias Regime Origem"};}// Ordena os períodos por data de início sem alterar o array original
var ordenados=[].concat(_toConsumableArray(lista)).sort(function(a,b){return __WEBPACK_IMPORTED_MODULE_8_moment___default()(a.dataInicio,formatos,true).diff(__WEBPACK_IMPORTED_MODULE_8_moment___default()(b.dataInicio,formatos,true));});// Valida cada período individualmente
for(var i=0;i<ordenados.length;i++){var periodo=ordenados[i];var inicio=__WEBPACK_IMPORTED_MODULE_8_moment___default()(periodo.dataInicio,formatos,true);var fim=__WEBPACK_IMPORTED_MODULE_8_moment___default()(periodo.dataFim,formatos,true);if((!inicio.isValid()||!fim.isValid())&&periodo.tipoConcomitanteDescartado===0){return{valido:false,mensagemErro:'Data no formato inv\xE1lido do v\xEDnculos '+periodo.dataInicio+' a '+periodo.dataFim+'. Verifique a aba "Rela\xE7\xF5es Previdenci\xE1rias Regime Origem"'};}if(inicio.isAfter(fim)&&periodo.tipoConcomitanteDescartado===0){return{valido:false,mensagemErro:'Data de in\xEDcio do v\xEDnculo '+periodo.dataInicio+' a '+periodo.dataFim+' deve ser menor que a data fim. Verifique a aba "Rela\xE7\xF5es Previdenci\xE1rias Regime Origem"'};}}return{valido:true};};_this.verificaSeAnaliseCompleta=function(){switch(_this.state.requerimento.estado){case 2:return _this.state.requerimento.exigencias.length>0;case 8:{var resultado=_this.validacaoDeVinculosConcomitantes();var temPeloMenosUmVinculo=_this.peloMenosUmVinculoSelecionado();// erro de dados → bloqueia botão e mostra mensagem
if(!resultado.datasValidas){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["L" /* trataMensagensErro */])([resultado.mensagemErro||'Vínculos no formato inválido']);return false;}return!resultado.existeConcomitancia&&temPeloMenosUmVinculo&&_this.state.vinculosConcomitantesConfirmado;}case 9:return _this.state.motivosIndeferimentoControle.length>0;case 10:return typeof _this.state.requerimento.motivo==='number';default:return false;}};_this.isDestinatarioRGPS=function(changeObj){return changeObj&&changeObj.value==='01000';};_this.isSolicitanteRGPS=function(){return __WEBPACK_IMPORTED_MODULE_23__domain_User__["a" /* default */].logged().isRGPS();};_this.handleChangeExigirQualificacao=function(changeObj){_this.setState({checkExigirQualificacao:changeObj.value});};_this.handleChangeTempoROManual=function(changeObj,checkTempoRO){var _this$state28=Object.assign({},_this.state),requerimento=_this$state28.requerimento;_this.setState({requerimento:Object.assign({},requerimento,{alteracaoTempoRO:changeObj.value}),historyCheckTempoRO:checkTempoRO});};_this.handleChangeCtcEspecifica=function(changeObj){var _this$state29=Object.assign({},_this.state),requerimento=_this$state29.requerimento;_this.setState({requerimento:Object.assign({},requerimento,{ctcEspecifica:changeObj.value})});};_this.handleChange=function(changeObj,name){var _Object$assign2,_Object$assign3;var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var _this$state30=Object.assign({},_this.state),estadoFormulario=_this$state30.estadoFormulario;var callbackFinal=null;var _this$state31=Object.assign({},_this.state),requerimento=_this$state31.requerimento;var valido=changeObj.isValid;var destinatarioIndeferido={};var destinatarioExigencia={};if(_this.state.acao==='cumprir-exigencia'){estadoFormulario='alterado';var _this$state32=Object.assign({},_this.state),requestPesquisa=_this$state32.requestPesquisa;var _this$state33=Object.assign({},_this.state),listaExigenciasAtendidas=_this$state33.listaExigenciasAtendidas;if(requestPesquisa){_this.setState({requestPesquisa:false});}requerimento.exigencias.forEach(function(exigencia){if(exigencia.atributo){if(exigencia.atributo===name&&exigencia.atendida===0){exigencia.atendida=1;listaExigenciasAtendidas.push(exigencia);}}else{// IB557704 uploads em exigencia
if(name==='arquivos'&&Array.isArray(changeObj.value)&&changeObj.value.length>0){var possuiDocumento=changeObj.value.some(function(arquivo){return arquivo.tipoDocumento===exigencia.tipoDocumento;});if(possuiDocumento){exigencia.atendida=1;listaExigenciasAtendidas.push(exigencia);}}}});_this.setState({listaExigenciasAtendidas:listaExigenciasAtendidas});if(name==='destinatario'){destinatarioExigencia={codigo:changeObj.value};}}else if(_this.state.acao==='novo'&&estadoFormulario==='erro-regra'){estadoFormulario='alterado';}// else if (this.state.acao === 'complementar-aposentadoria') {
//   const { validadeCampos } = { ...this.state };
//   validadeCampos.dataHomologacaoTribunalContas = true;
// }
if(name==='arquivos'&&_this.state.acao!=='consulta'){valido=true;}else if(name==='arquivos'&&_this.state.acao==='consulta'){if(valido){_this.setState({habilitarBotaoCarregarDocumento:true});}else{_this.setState({habilitarBotaoCarregarDocumento:false});}}if(name==='cpf'&&valido){callbackFinal=_this.handleSearchButton;}if(name==='destinatario'){// --- NOVA LÓGICA PARA LIMPAR DESTINATARIO_ORIGEM ---
var orgaoSelecionado=_this.props.destinatarios&&_this.props.destinatarios.find(function(item){return item.value===changeObj.value;});if(orgaoSelecionado&&!orgaoSelecionado.codigoOrgaoCentralizador){_this.state.requerimento.destinatarioOrigem=null;}var _this$state34=Object.assign({},_this.state),validadeCampos=_this$state34.validadeCampos;validadeCampos.solicitanteOrigem=true;var _this$state35=Object.assign({},_this.state),exibirCampoUoInss=_this$state35.exibirCampoUoInss;if(_this.isDestinatarioRGPS(changeObj)||_this.isSolicitanteRGPS(changeObj)){exibirCampoUoInss=true;}else{exibirCampoUoInss=false;}_this.setState({exibirCampoUoInss:exibirCampoUoInss});// INICIO - Alteração IB 292641
// LIMPAR O CAMPO DESTINATARIO ORIGEM SE ESTIVER PREENCHIDO
if(_this.state.acao==='novo'&&!_this.isDestinatarioRGPS(changeObj)&&!_this.isSolicitanteRGPS(changeObj)){validadeCampos.regraDeCalculo=false;}else if(_this.state.acao==='novo'&&_this.isDestinatarioRGPS(changeObj)&&!_this.isSolicitanteRGPS()){validadeCampos.regraDeCalculo=true;}else if(_this.state.acao==='cumprir-exigencia'){var orgao=_this.props.destinatarios.find(function(item){return item.value===changeObj.value;});if(_this.isDestinatarioRGPS(changeObj)&&!_this.isSolicitanteRGPS()){// DESTINATARIO = RGPS E SOLICITANTE = RPPS
// if (!orgao.codigoOrgaoCentralizador) {
requerimento.destinatarioOrigem={codigo:''};// }
}// INICIO IB362835 - Não exibir o campo destinatario Origem se o
// destinatário escolhido na combobox não for órgão centralizador.
if(!_this.isDestinatarioRGPS(changeObj)&&_this.isSolicitanteRGPS()){// DESTINATARIO = RPPS E SOLICITANTE = RGPS
if(orgao&&!orgao.codigoOrgaoCentralizador){requerimento.destinatarioOrigem={codigo:''};}}// FIM IB362835 - Não exibir o campo destinatario Origem se o
// destinatário escolhido na combobox não for órgão centralizador.
if(!_this.isDestinatarioRGPS(changeObj)&&!_this.isSolicitanteRGPS()){// DESTINATARIO = RPPS E SOLICITANTE = RPPS
if(requerimento.regraDeCalculo===null){validadeCampos.regraDeCalculo=false;}// LIMPAR A CAIXA DE TEXTO DESTINATARIO ORIGEM QUE APARECE DESABILITADA
if(requerimento.destinatarioOrigem){requerimento.destinatarioOrigem.nome='';}// ATUALIZAR O DESTINATARIO E O DESTINATARIO ORIGEM
if(orgao&&orgao.codigoOrgaoCentralizador){requerimento.destinatarioOrigem={codigo:orgao.value};requerimento.destinatario={codigo:orgao.codigoOrgaoCentralizador};}else{requerimento.destinatarioOrigem={codigo:''};}}}// FIM - Alteração IB 292641
}if(name==='destinatario'&&_this.state.acao==='indeferidos'){destinatarioIndeferido={codigo:changeObj.value};}if(name==='rendaMensalInicial'){if(changeObj.value===''){valido=false;}}// se for verdadeiro quer dizer que uma ctc foi pesquisada anteriormente.
if(name==='protocoloCertidao'&&valido){var _this$state36=Object.assign({},_this.state),_requestPesquisa=_this$state36.requestPesquisa;var _this$state37=Object.assign({},_this.state),_validadeCampos2=_this$state37.validadeCampos;if(_requestPesquisa&&_requestPesquisa==='protocoloCertidao'){_validadeCampos2.requerimentoPeriodos=false;}}if(name==='tempoContribuicaoRegimeOrigemDias'&&valido){var _this$state38=Object.assign({},_this.state),exigenciasInvalidas=_this$state38.exigenciasInvalidas;requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo&&exigencia.atendida===1){if(paramAtributo in _this.state.exigenciasInvalidas){exigenciasInvalidas.tempoContribuicaoRegimeOrigemDias=false;_this.setState({exigenciasInvalidas:exigenciasInvalidas});}}});}if((name==='motivoCessacaoManual'||name==='dataCessacaoBeneficio')&&(changeObj.value===''||changeObj.value===null)){valido=true;}if(name==='motivoCessacaoManual'){// Se for string vazia, converte para null (caso ele clique em Selecione...)
//evita erro de conversao para integer no backend
if(changeObj.value===''||changeObj.value===undefined){changeObj.value=null;valido=true;// Campo vazio é considerado válido
}}if(!callbackFinal){callbackFinal=callback;}var dataMotivoValido=_this.isDataMotivoValido(Object.assign({},_this.state,{requerimento:Object.assign({},requerimento,_defineProperty({},name,changeObj.value))}));_this.setState({requerimento:Object.assign({},requerimento,(_Object$assign2={},_defineProperty(_Object$assign2,name,destinatarioIndeferido.codigo?destinatarioIndeferido:changeObj.value),_defineProperty(_Object$assign2,name,destinatarioExigencia.codigo?destinatarioExigencia:changeObj.value),_Object$assign2)),validadeCampos:Object.assign({},_this.state.validadeCampos,(_Object$assign3={},_defineProperty(_Object$assign3,name,valido),_defineProperty(_Object$assign3,'dataMotivoCessacao',dataMotivoValido),_Object$assign3)),estadoFormulario:estadoFormulario},callbackFinal);};_this.atualizarMotivoCessacaoManual=function(){};_this.handleClick=function(changeObj,name){var paramExibirBotaoVoltar=void 0;switch(name){case'item2':_this.addMotivoCessacaoManualLabel(_this.state.requerimento.motivoCessacaoManual);paramExibirBotaoVoltar=true;break;case'item3':paramExibirBotaoVoltar=false;break;default:paramExibirBotaoVoltar=true;break;}// if (name === 'item3') {
//   paramExibirBotaoVoltar = false;
// } else {
//   paramExibirBotaoVoltar = true;
// }
_this.setState({exibirBotaoVoltar:paramExibirBotaoVoltar});};_this.handleKeyUp=function(e){var retorno=e.target.value;if(retorno.indexOf('_')!==-1){retorno=retorno.toString().replace('_','');}retorno=retorno.toString().replace(/\D/g,'');retorno=retorno.toString().replace(/(\d)(\d{11})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{8})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{5})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{2})$/,'$1,$2');e.target.value=retorno;return retorno;};_this.handleSearchButton=function(){var cpfTouched=true;_this.setState(Object.assign({},_this.state,{cpfTouched:cpfTouched}),_this.handleSearch);};_this.handleSearch=function(){// if (this.state.validadeCampos.cpf) {
if(_this.state.acao==='qualificar'){var _this$state39=Object.assign({},_this.state),validadeCampos=_this$state39.validadeCampos;if(validadeCampos.cpf===false){validadeCampos.cpf=true;}_this.setState({validadeCampos:validadeCampos});}var _this$state$requerime6=Object.assign({},_this.state.requerimento),cpf=_this$state$requerime6.cpf;_this.setState({requestPesquisa:'cnis'},Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["e" /* doGet */])('pessoas-fisicas/'+cpf,_this.trataSucessoResponsePesquisa,_this.trataErrosResponse));// }
};_this.calcularPeriodoRgps=function(periodo,calcularAmd){var acrescentarDia=1;var acrescentarMesDias=30;var trintaUm=31;var qtdDiasMes=30;var qtdMesesAno=12;var acrescentarAno=12;var reduzirMes=1;var reduzirAno=1;var mesFev=2;var ultimoDiaFevBissexto=29;var ultimoDiaFevNaoBissexto=28;var acrescentarAnoDias=365;var resultadoDia=0;var resultadoMes=0;var resultadoAno=0;var resultadoQtdMeses=0;var restoDivisaoDia=0;var resultadoQtdAnos=0;var restoDivisaoMes=0;var retorno=0;var retornoAmd={};var diaInicio=periodo.dataInicio.split('/')[0];var mesInicio=periodo.dataInicio.split('/')[1];var anoInicio=periodo.dataInicio.split('/')[2];var diaFim=periodo.dataFim.split('/')[0];var mesFim=periodo.dataFim.split('/')[1];var anoFim=periodo.dataFim.split('/')[2];if(__WEBPACK_IMPORTED_MODULE_8_moment___default()([anoFim]).isLeapYear()){if(Number(mesFim)===mesFev&&Number(diaFim)===ultimoDiaFevBissexto){diaFim=Number(diaFim)+1;}}else{if(Number(mesFim)===mesFev&&Number(diaFim)===ultimoDiaFevNaoBissexto){diaFim=Number(diaFim)+2;}}if(Number(diaFim)<trintaUm){diaFim=Number(diaFim)+acrescentarDia;if(Number(diaInicio>diaFim)){diaFim=Number(diaFim)+acrescentarMesDias;mesFim=Number(mesFim)-reduzirMes;}}resultadoDia=Number(diaFim-diaInicio);resultadoQtdMeses=Math.trunc(resultadoDia/qtdDiasMes);restoDivisaoDia=resultadoDia%qtdDiasMes;resultadoDia=restoDivisaoDia;if(Number(mesFim<mesInicio)){mesFim=Number(mesFim)+acrescentarAno;anoFim=Number(anoFim)-reduzirAno;}resultadoMes=Number(mesFim-mesInicio);resultadoMes+=resultadoQtdMeses;resultadoQtdAnos=Math.trunc(resultadoMes/qtdMesesAno);restoDivisaoMes=resultadoMes%qtdMesesAno;resultadoMes=restoDivisaoMes;resultadoAno=Number(anoFim-anoInicio);resultadoAno+=resultadoQtdAnos;if(calcularAmd){retornoAmd.dataInicio=periodo.dataInicio;retornoAmd.dataFim=periodo.dataFim;retornoAmd.totalDia=resultadoDia;retornoAmd.totalMes=resultadoMes;retornoAmd.totalAno=resultadoAno;return retornoAmd;}else{retorno=Number(resultadoAno*acrescentarAnoDias+resultadoMes*acrescentarMesDias+resultadoDia);return retorno;}};_this.calcularPeriodoRpps=function(periodo){var retorno=periodo;var dataInicioCorrido=__WEBPACK_IMPORTED_MODULE_8_moment___default()(periodo.dataInicio,'DD/MM/YYYY');var dataFimCorrido=__WEBPACK_IMPORTED_MODULE_8_moment___default()(periodo.dataFim,'DD/MM/YYYY');var acrescentarDataFinal=1;var diffDatas=dataFimCorrido.diff(dataInicioCorrido,'days')+acrescentarDataFinal;retorno=diffDatas;return retorno;};_this.atualizarDataIngressoDesvinculacaoETempoPorAcao=function(lista,origem){var _this$state40=Object.assign({},_this.state),requerimento=_this$state40.requerimento;var _this$state41=Object.assign({},_this.state),historyTempoRO=_this$state41.historyTempoRO;var existePeriodo=false;if(lista&&lista.length>0){lista=_this.ordenarListaPeriodos(lista);var primeiroItemDaLista=lista&&lista.length>0?lista[0]:'';var ultimoItemDaLista=lista&&lista.length>0?lista[lista.length-1]:'';var dataComUmDiaAdicionado=Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["a" /* adicionarQuantidadeAumaData */])(Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["k" /* stringToData */])(ultimoItemDaLista.dataFim),1,'d');var somatorioTempoContribuicao=0;var periodoAux={};var listaAux=[];if(_this.isRelacaoRgpsRpps(requerimento.destinatario)){lista.forEach(function(periodo){periodoAux=_this.calcularPeriodoRgps(periodo,true);listaAux.push(periodoAux);if(!periodo.operacao){periodo.operacao=0;}});somatorioTempoContribuicao=_this.calcularTempoTotalAmdRgps(listaAux,lista);}else{lista.forEach(function(periodo){if(periodo.qtdDiasContribuicaoLiquido){somatorioTempoContribuicao+=periodo.qtdDiasContribuicaoLiquido;if(!periodo.operacao){periodo.operacao=0;}}});}requerimento.dataIngresso=primeiroItemDaLista.dataInicio;requerimento.dataDesvinculacao=dataComUmDiaAdicionado.format('DD/MM/YYYY');requerimento.tempoContribuicaoRegimeOrigemDias=somatorioTempoContribuicao;historyTempoRO=somatorioTempoContribuicao;existePeriodo=true;}else{existePeriodo=false;}if(origem&&origem===3){var _this$state42=Object.assign({},_this.state),requerimentoVindoDoRequest=_this$state42.requerimentoVindoDoRequest;if(requerimentoVindoDoRequest&&lista.length===0){requerimento.dataIngresso=requerimentoVindoDoRequest.dataIngresso;requerimento.dataDesvinculacao=requerimentoVindoDoRequest.dataDesvinculacao;requerimento.tempoContribuicaoRegimeOrigemDias=requerimentoVindoDoRequest.tempoContribuicaoRegimeOrigemDias;}else if(!requerimentoVindoDoRequest&&lista.length===0){requerimento.dataIngresso=null;requerimento.dataDesvinculacao=null;requerimento.tempoContribuicaoRegimeOrigemDias=null;}}if(origem){_this.cumprirExigenciaDataIngressoDesvinculacaoETempo();}_this.setState({requerimento:Object.assign({},requerimento),validadeCampos:Object.assign({},_this.state.validadeCampos,{requerimentoPeriodos:existePeriodo}),historyTempoRO:historyTempoRO});};_this.marcarExigenciaInvalidaDataIngressoDesvinculacaoETempoRO=function(){var _this$state43=Object.assign({},_this.state),requerimento=_this$state43.requerimento;var _this$state44=Object.assign({},_this.state),exigenciasInvalidas=_this$state44.exigenciasInvalidas;if(requerimento.exigencias){requerimento.exigencias.forEach(function(item){if(item.atributo){if(['tempoContribuicaoRegimeOrigemDias','dataIngresso','dataDesvinculacao'].includes(item.atributo)){exigenciasInvalidas[item.atributo]=true;}}});}_this.setState({exigenciasInvalidas:exigenciasInvalidas});};_this.cumprirExigenciaDataIngressoDesvinculacaoETempo=function(){var _this$state45=Object.assign({},_this.state),requerimento=_this$state45.requerimento;var _this$state46=Object.assign({},_this.state),exigenciasInvalidas=_this$state46.exigenciasInvalidas;var _this$state47=Object.assign({},_this.state),validadeCampos=_this$state47.validadeCampos;var _this$state48=Object.assign({},_this.state),acao=_this$state48.acao;var _this$state49=Object.assign({},_this.state),listaExigenciasAtendidas=_this$state49.listaExigenciasAtendidas;if(requerimento.exigencias){if(acao==='cumprir-exigencia'){var lista=_this.verificaAlteracaoCamposEstadoExigencia();if(lista!==undefined){lista.forEach(function(item){var index=requerimento.exigencias.findIndex(function(i){return i.atributo===item;});if(index!==-1){if(['tempoContribuicaoRegimeOrigemDias','dataIngresso','dataDesvinculacao','requerimentoPeriodos'].includes(item)){requerimento.exigencias[index].atendida=1;exigenciasInvalidas[item]=false;// validadeCampos[item] = true;
var i=listaExigenciasAtendidas.findIndex(function(exAtend){return exAtend.atributo===item;});if(i===-1){listaExigenciasAtendidas.push(requerimento.exigencias[index]);}}}});}}else{requerimento.exigencias.forEach(function(item){if(item.atributo){if(['tempoContribuicaoRegimeOrigemDias','dataIngresso','dataDesvinculacao'].includes(item.atributo)){item.atendida=1;exigenciasInvalidas[item.atributo]=false;// validadeCampos[item.atributo] = true;
listaExigenciasAtendidas.push(item);}}});}}_this.setState({requerimento:Object.assign({},requerimento),exigenciasInvalidas:exigenciasInvalidas,listaExigenciasAtendidas:listaExigenciasAtendidas,validadeCampos:validadeCampos});};_this.atualizarDataIngressoDesvinculacaoETempo=function(lista,origem){var _this$state50=Object.assign({},_this.state),acao=_this$state50.acao;switch(acao){case'novo':{_this.atualizarDataIngressoDesvinculacaoETempoPorAcao(lista,origem);break;}case'cumprir-exigencia':{_this.atualizarDataIngressoDesvinculacaoETempoPorAcao(lista,origem);break;}case'indeferidos':{_this.atualizarDataIngressoDesvinculacaoETempoPorAcao(lista,origem);break;}case'complementar-aposentadoria':{_this.atualizarDataIngressoDesvinculacaoETempoPorAcao(lista,origem);break;}// case 'realizar-analise': {
//   this.atualizarDataIngressoDesvinculacaoETempoPorAcao(lista, origem);
//   break;
// }
default:break;}};_this.controlarExibicaoMultiplosPeriodos=function(){var _this$state51=Object.assign({},_this.state),exibirMultiplosPeriodos=_this$state51.exibirMultiplosPeriodos;var _this$state$requerime7=Object.assign({},_this.state.requerimento),requerimentoPeriodos=_this$state$requerime7.requerimentoPeriodos;var _this$state52=Object.assign({},_this.state),acao=_this$state52.acao;var possuiPeriodos=requerimentoPeriodos&&requerimentoPeriodos.length>0;// if (this.isSolicitanteRGPS()) {
switch(acao){case'novo':exibirMultiplosPeriodos=true;break;case'cumprir-exigencia':exibirMultiplosPeriodos=true;break;case'realizar-analise':if(possuiPeriodos){exibirMultiplosPeriodos=true;break;}exibirMultiplosPeriodos=false;break;case'complementar-aposentadoria':exibirMultiplosPeriodos=true;break;case'qualificar':if(possuiPeriodos){exibirMultiplosPeriodos=true;}break;case'indeferidos':exibirMultiplosPeriodos=true;break;case'consulta':if(possuiPeriodos){exibirMultiplosPeriodos=true;break;}break;default:break;}// } else {
//   exibirMultiplosPeriodos = true;
// }
_this.setState({exibirMultiplosPeriodos:exibirMultiplosPeriodos});};_this.handleSearchPeriodos=function(){var protocoloCertidaoTouched=true;_this.setState(Object.assign({},_this.state,{protocoloCertidaoTouched:protocoloCertidaoTouched}),_this.recuperarPeriodosCtc);};_this.trataSucessoResponsePeriodosCtc=function(response){//alterar o atributo periodos pelo nome response
var _this$state$requerime8=Object.assign({},_this.state.requerimento),requerimentoPeriodos=_this$state$requerime8.requerimentoPeriodos;var _this$state53=Object.assign({},_this.state),requerimento=_this$state53.requerimento;var _this$state54=Object.assign({},_this.state),acao=_this$state54.acao;if(acao!=='complementar-aposentadoria'){requerimento.protocoloCertidao=response.data.protocoloCertidao?response.data.protocoloCertidao:'';}_this.setState({requerimento:Object.assign({},requerimento),duplaDestinacao:response.data.duplaDestinacao});if(response.data.periodos&&response.data.periodos.length>0&&requerimentoPeriodos.length>0){// exibe o modal de confirmação de substituicao dos peridos
var texto=__WEBPACK_IMPORTED_MODULE_20__utils_constants__["f" /* msgConfirmacaoRequerimentosPeriodos */].descricao;var alerta={descricao:texto};_this.setState({requerimentosPeriodosVindosDoRequest:response.data.periodos,clicouBotaoPesquisarCtc:true,alertas:[alerta],showModalAlertaRequerimentosPeriodos:!_this.state.showModalAlertaRequerimentosPeriodos,requerimento:Object.assign({},requerimento,{tempoContribuicaoRegimeOrigemDias:response.data.tempoCertificado}),historyTempoRO:response.data.tempoCertificado});}else if(response.data.periodos&&response.data.periodos.length>0&&requerimentoPeriodos.length===0){// substitui os periodos cadastrados anteriormente pelo usuario e substitui pelos periodos que vieram do servico
_this.setState({requerimentosPeriodosVindosDoRequest:response.data.periodos,clicouBotaoPesquisarCtc:true},_this.substituirRequerimentosPeriodos(response.data));}else if(response.data.periodos&&response.data.periodos.length===0){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["L" /* trataMensagensErro */])(['N\xE3o foram encontrados per\xEDodos para o protocolo da certid\xE3o pesquisado.']);}};_this.compararDatasInicio=function(a,b){if(__WEBPACK_IMPORTED_MODULE_8_moment___default()(a.dataInicio,'DD/MM/YYYY').toDate()<__WEBPACK_IMPORTED_MODULE_8_moment___default()(b.dataInicio,'DD/MM/YYYY').toDate()){return-1;}if(__WEBPACK_IMPORTED_MODULE_8_moment___default()(a.dataInicio,'DD/MM/YYYY').toDate()>__WEBPACK_IMPORTED_MODULE_8_moment___default()(b.dataInicio,'DD/MM/YYYY').toDate()){return 1;}return 0;};_this.ordenarListaPeriodos=function(lista){lista.sort(_this.compararDatasInicio);return lista;};_this.alteraListaAposExclusao=function(listaPeriodos,origem){_this.atualizarDataIngressoDesvinculacaoETempo(listaPeriodos,origem);_this.handleFechamentoModalAlertaRequerimentosPeriodos();};_this.calcularTempoDeContribuicaoBruto=function(periodo){var retorno='';if(periodo){if(periodo.dataInicio&&periodo.dataInicio.indexOf('_')===-1&&periodo.dataFim&&periodo.dataFim.indexOf('_')===-1){var data1=__WEBPACK_IMPORTED_MODULE_8_moment___default()(periodo.dataInicio,'DD/MM/YYYY');var data2=__WEBPACK_IMPORTED_MODULE_8_moment___default()(periodo.dataFim,'DD/MM/YYYY');var diferenca=data2.diff(data1,'days');retorno=Number(diferenca)+1;return retorno;}else{var _this$state55=Object.assign({},_this.state),requerimento=_this$state55.requerimento;retorno=requerimento.tempoContribuicaoRegimeOrigemDias;}}return retorno;};_this.substituirRequerimentosPeriodos=function(data){//inserir os periodos novos na lista
var _this$state56=Object.assign({},_this.state),requerimento=_this$state56.requerimento;var _this$state$requerime9=Object.assign({},_this.state.requerimento),requerimentoPeriodos=_this$state$requerime9.requerimentoPeriodos;var _this$state$requerime10=Object.assign({},_this.state.requerimento),requerimentoPeriodosExcluidos=_this$state$requerime10.requerimentoPeriodosExcluidos;var _this$state57=Object.assign({},_this.state),requerimentosPeriodosVindosDoRequest=_this$state57.requerimentosPeriodosVindosDoRequest;var _this$state58=Object.assign({},_this.state),listaExigenciasAtendidas=_this$state58.listaExigenciasAtendidas;var _this$state59=Object.assign({},_this.state),exigenciasInvalidas=_this$state59.exigenciasInvalidas;var _this$state60=Object.assign({},_this.state),historyTempoRO=_this$state60.historyTempoRO;var resultadoExclusao=[];var periodosResponse=[];if(requerimentosPeriodosVindosDoRequest.length>0){requerimentosPeriodosVindosDoRequest.forEach(function(item){var periodos={};periodos.dataInicio=item.dataInicio;periodos.dataFim=item.dataFim;periodos.qtdDiasDesconto=0;periodosResponse.push(periodos);});}else{data.periodos.forEach(function(item){var periodos={};periodos.dataInicio=item.dataInicio;periodos.dataFim=item.dataFim;periodos.qtdDiasDesconto=0;periodosResponse.push(periodos);});}var periodosComId=[];requerimentoPeriodos.forEach(function(periodo){if(periodo.idPeriodo){periodosComId.push(periodo);}});requerimentoPeriodos=periodosComId;var houveAlteracaoPeriodos=_this.verificarMudancaNaColecaoDePeriodos(requerimentoPeriodos,periodosResponse,true);if(houveAlteracaoPeriodos){requerimento.exigencias.filter(function(ex){return ex.atributo==='requerimentoPeriodos';}).forEach(function(ex){ex.atendida=1;if(!listaExigenciasAtendidas.some(function(e){return e.tipo===ex.tipo;})){listaExigenciasAtendidas.push(ex);}});//limpar a coleção de exclusões.
requerimentoPeriodosExcluidos=[];//incluir os periodos que vêm da lista de periodos da tabela do bd na lista de periodos excluídos.
requerimentoPeriodos.forEach(function(periodo){requerimentoPeriodosExcluidos.push(periodo);});resultadoExclusao=requerimentoPeriodosExcluidos;if(data.periodos){requerimentosPeriodosVindosDoRequest=data.periodos;}requerimentosPeriodosVindosDoRequest.forEach(function(periodo){if(!periodo.operacao){periodo.operacao=1;}});var resultado=requerimentosPeriodosVindosDoRequest;resultado=_this.ordenarListaPeriodos(resultado);var existePeriodo=false;var primeiroItemDaLista=resultado&&resultado.length>0?resultado[0]:'';var ultimoItemDaLista=resultado&&resultado.length>0?resultado[resultado.length-1]:'';var dataComUmDiaAdicionado=Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["a" /* adicionarQuantidadeAumaData */])(Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["k" /* stringToData */])(ultimoItemDaLista.dataFim),1,'d');var somatorioTempoContribuicao=0;if(_this.state.requestPesquisa==='periodosCtc'){if(data.periodos){requerimento.tempoContribuicaoRegimeOrigemDias=data.tempoCertificado;historyTempoRO=data.tempoCertificado;}}else{resultado.forEach(function(periodo){if(periodo.qtdDiasContribuicaoLiquido){somatorioTempoContribuicao+=periodo.qtdDiasContribuicaoLiquido;}});requerimento.tempoContribuicaoRegimeOrigemDias=somatorioTempoContribuicao;historyTempoRO=somatorioTempoContribuicao;}requerimento.dataIngresso=primeiroItemDaLista.dataInicio;requerimento.dataDesvinculacao=dataComUmDiaAdicionado.format('DD/MM/YYYY');existePeriodo=true;_this.setState({requerimento:Object.assign({},requerimento,{requerimentoPeriodos:resultado,requerimentoPeriodosExcluidos:resultadoExclusao}),validadeCampos:Object.assign({},_this.state.validadeCampos,{requerimentoPeriodos:existePeriodo}),historyTempoRO:historyTempoRO},_this.acaoDeAcordoComTamanhoDoRequerimentoPeriodos(requerimentoPeriodos,requerimentosPeriodosVindosDoRequest));}else{_this.handleFechamentoModalAlertaRequerimentosPeriodos();_this.setState({requerimento:Object.assign({},requerimento,{requerimentoPeriodos:periodosComId})});}var lista=_this.verificaAlteracaoCamposEstadoExigencia();if(lista!==undefined){lista.forEach(function(item){var indice=requerimento.exigencias.findIndex(function(i){return i.atributo===item;});if(indice!==-1){if(['tempoContribuicaoRegimeOrigemDias'].includes(item)){requerimento.exigencias[indice].atendida=1;exigenciasInvalidas[item]=false;// validadeCampos[item] = true;
var i=listaExigenciasAtendidas.findIndex(function(exAtend){return exAtend.atributo===item;});if(i===-1){listaExigenciasAtendidas.push(requerimento.exigencias[indice]);}}}});}_this.setState({exigenciasInvalidas:exigenciasInvalidas,listaExigenciasAtendidas:listaExigenciasAtendidas});};_this.acaoDeAcordoComTamanhoDoRequerimentoPeriodos=function(requerimentoPeriodos,requerimentosPeriodosVindosDoRequest){if(requerimentoPeriodos.length>0&&requerimentosPeriodosVindosDoRequest.length>0){_this.handleFechamentoModalAlertaRequerimentosPeriodos();}else if(requerimentoPeriodos.length===0&&requerimentosPeriodosVindosDoRequest.length>0){_this.cumprirExigenciaDataIngressoDesvinculacaoETempo();if(_this.state.showModalAlertaRequerimentosPeriodos){_this.handleFechamentoModalAlertaRequerimentosPeriodos();}}};_this.determinarConcomitancias=function(periodos,index){var periodoAtual=periodos[index];for(var i=0,tamanhoI=periodos.length;i<tamanhoI;i+=1){if(index!=i){var periodoAux=periodos[i];if(Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["k" /* stringToData */])(periodoAtual.dataInicio)<=Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["k" /* stringToData */])(periodoAux.dataFim)&&Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["k" /* stringToData */])(periodoAux.dataInicio)<=Object(__WEBPACK_IMPORTED_MODULE_22__utils_helpers__["k" /* stringToData */])(periodoAtual.dataFim)){return true;}}}return false;};_this.recuperarPeriodosCtc=function(){var _this$state$requerime11=Object.assign({},_this.state.requerimento),cpf=_this$state$requerime11.cpf;_this.setState({requestPesquisa:'periodosCtc'},Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["e" /* doGet */])('ctc/'+cpf,_this.trataSucessoResponsePeriodosCtc,_this.trataErrosResponse));};_this.verificarHabilitacaoDataIngressoDesvinculacaoETempo=function(){var habilitar=true;var _this$state61=Object.assign({},_this.state),requerimento=_this$state61.requerimento;var _this$state62=Object.assign({},_this.state),acao=_this$state62.acao;var possuiDataInicioOuDesvinculacaoOuTempoRONulo=requerimento.tempoContribuicaoRegimeOrigemDias===null||requerimento.dataIngresso===null||requerimento.dataDesvinculacao===null;if(_this.isSolicitanteRGPS()){switch(acao){case'realizar-analise':if(possuiDataInicioOuDesvinculacaoOuTempoRONulo){habilitar=true;break;}habilitar=false;break;default:break;}}_this.setState({habilitarCamposParaAlteracaoNaAnalise:habilitar});};_this.handlePesquisaBotaoEloNit=function(){_this.setState({exibirModalCadeiaDeNit:true});};_this.handleModalAlteraDataCessacao=function(){_this.setState({exibirModalDataCessacao:!_this.state.exibirModalDataCessacao});};_this.handleModalAlteraMotivoCessacao=function(){_this.setState({exibirModalMotivoCessacao:!_this.state.exibirModalMotivoCessacao});};_this.handleModalAlteraDataEMotivoCessacao=function(){_this.setState({exibirModalDataEMotivoCessacao:!_this.state.exibirModalDataEMotivoCessacao});};_this.handleModalCadeiaDeNitModal=function(){_this.setState({exibirModalCadeiaDeNit:false});};_this.handleSearchNBButton=function(){var numeroBeneficioTouched=true;_this.setState(Object.assign({},_this.state,{numeroBeneficioTouched:numeroBeneficioTouched}),_this.handleNBSearch);};_this.handleModalAlteraSegregacaoMassa=function(origem){_this.setState({exibirModalSegregacaoMassa:!_this.state.exibirModalSegregacaoMassa,origemModalSegregacaoMassa:origem});};_this.handleNBSearch=function(){if(_this.state.validadeCampos.numeroBeneficio){var _this$state$requerime12=Object.assign({},_this.state.requerimento),numeroBeneficio=_this$state$requerime12.numeroBeneficio;_this.setState({requestPesquisa:'centralService'},Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["e" /* doGet */])('beneficio-rgps/'+numeroBeneficio,_this.trataSucessoResponsePesquisa,_this.trataErrosResponse));}};_this.trataSucessoResponsePesquisa=function(response){var _this$state63=Object.assign({},_this.state),validadeCampos=_this$state63.validadeCampos;var _this$state64=Object.assign({},_this.state),requestPesquisa=_this$state64.requestPesquisa;// const requerimentoAtual = this.state.requerimento;
var requerimento=_this.cumpreExigenciasEmAtributosDeServico(response);camposPreenchidosPorServico[requestPesquisa].forEach(function(key){validadeCampos[key]=true;});if(requestPesquisa==='cnis'){if(response.data.isObtidoPelaRFB===true){if(requerimento.nit!==null){requerimento.nit=null;validadeCampos.nit=false;}if(requerimento.sexo!==null){requerimento.sexo=null;validadeCampos.sexo=false;}}if(!response.data.nome){requerimento.nome='';}if(!response.data.nit){requerimento.nit=null;validadeCampos.nit=false;}if(!response.data.dataNascimento){requerimento.dataNascimento=null;validadeCampos.dataNascimento=false;}if(!response.data.sexo){requerimento.sexo=null;validadeCampos.sexo=false;}if(!response.data.nomeMae){requerimento.nomeMae='';}_this.setState({isObtidoPelaRFB:response.data.isObtidoPelaRFB});if(_this.state.acao==='indeferidos'){var _this$state65=Object.assign({},_this.state),validadeBotoesIndeferidos=_this$state65.validadeBotoesIndeferidos;if(validadeBotoesIndeferidos.pesquisarDadosPessoais===false){validadeBotoesIndeferidos.pesquisarDadosPessoais=true;}_this.setState({validadeBotoesIndeferidos:validadeBotoesIndeferidos});}}if(requestPesquisa==='centralService'){// Apaga campos quando nao vierem do serviço
if(!response.data.tipoAposentadoria){requerimento.tipoAposentadoria=null;validadeCampos.tipoAposentadoria=false;}if(!response.data.dataInicioBeneficio){requerimento.dataInicioBeneficio=null;validadeCampos.dataInicioBeneficio=false;}if(!response.data.dataInicioPagamentoBeneficio){requerimento.dataInicioPagamentoBeneficio=null;}if(!response.data.dataCessacaoBeneficio){requerimento.dataCessacaoBeneficio=null;}//IB603425
// requerimento.dataCessacaoBeneficio = '28/01/2026';
if(!response.data.rendaMensalInicial){if(response.data.rendaMensalInicial===0){if(requerimento.rendaMensalInicial!==null){requerimento.rendaMensalInicial='';}response.data.rendaMensalInicial=null;validadeCampos.rendaMensalInicial=false;_this.setState({isRmiZerada:true,rendaMensalInicialRequest:null});}}else if(_this.state.isRmiZerada){_this.setState({isRmiZerada:false});}if(!response.data.dataCreditoPagamento){requerimento.dataCreditoPagamento=null;// validadeCampos.dataCreditoPagamento = false;
}if(!response.data.tempoContribuicaoTotalDias){validadeCampos.tempoContribuicaoTotalDias=false;requerimento.tempoContribuicaoTotalDias=null;}if(!response.data.idUOMantenedora){requerimento.idUOMantenedora=null;validadeCampos.idUOMantenedora=false;}if(_this.state.acao==='indeferidos'){var _this$state66=Object.assign({},_this.state),_validadeBotoesIndeferidos2=_this$state66.validadeBotoesIndeferidos;if(_validadeBotoesIndeferidos2.pesquisarDadosBeneficio===false){_validadeBotoesIndeferidos2.pesquisarDadosBeneficio=true;}_this.setState({validadeBotoesIndeferidos:_validadeBotoesIndeferidos2});}}var novoRequerimento=Object.assign({},requerimento,response.data);validadeCampos.dataMotivoCessacao=_this.isDataMotivoValido(Object.assign({},_this.state,{requerimento:novoRequerimento}));_this.setState({requerimento:novoRequerimento,requestPesquisa:null,validadeCampos:validadeCampos});};_this.cumpreExigenciasEmAtributosDeServico=function(reqResponse){// camposPreenchidosPorServico
// cnis
// benMigrado
var _reqResponse=Object.assign({},reqResponse),data=_reqResponse.data;var _this$state67=Object.assign({},_this.state),requerimento=_this$state67.requerimento;var _requerimento=Object.assign({},requerimento),exigencias=_requerimento.exigencias;var _this$state68=Object.assign({},_this.state),requestPesquisa=_this$state68.requestPesquisa;if(_this.state.acao==='cumprir-exigencia'&&exigencias){requerimento.exigencias.forEach(function(exigencia){if(data[exigencia.atributo]&&data[exigencia.atributo]!==requerimento[exigencia.atributo]){// eslint-disable-next-line
exigencia.atendida=1;}if(requestPesquisa==='centralService')//no caso de data de cessação ter sido preenchida errada pelo usuario ou migrada errada e ela não existir no central-service
if(exigencia.atributo==='dataCessacaoBeneficio'&&data[exigencia.atributo]===undefined&&requerimento[exigencia.atributo]!==null){exigencia.atendida=1;requerimento.dataCessacaoBeneficio=null;}});}return requerimento;};_this.extrairMotivosParaSalvar=function(){var _this$state69=Object.assign({},_this.state),motivosIndeferimentoControle=_this$state69.motivosIndeferimentoControle;if(motivosIndeferimentoControle.length>0){var _this$state70=Object.assign({},_this.state),requerimento=_this$state70.requerimento;var lista=[];motivosIndeferimentoControle.forEach(function(item){lista.push(item.motivo);});requerimento.listaMotivosIndeferimento=lista;_this.setState(Object.assign({},requerimento));}};_this.resetarCumprimentoExigencias=function(campo){var requerimento=_this.state.requerimento;var tipo=campo&&campo.tipo?campo.tipo:null;var atributoCampo=campo&&campo.atributo?campo.atributo:campo;requerimento.exigencias.forEach(function(exigencia){var ehMesmaExigenciaPorTipo=tipo!==null&&exigencia.tipo===tipo;var ehMesmoAtributoCampo=tipo===null&&exigencia.atributo===atributoCampo;if((ehMesmaExigenciaPorTipo||ehMesmoAtributoCampo)&&exigencia.atendida===1){exigencia.atendida=0;}});return requerimento;};_this.resetarCumprimentoExigenciasInvalidas=function(campo){var _this$state71=Object.assign({},_this.state),requerimento=_this$state71.requerimento;var _this$state72=Object.assign({},_this.state),exigenciasInvalidas=_this$state72.exigenciasInvalidas;var atributoCampo=campo.atributo?campo.atributo:campo;if(['tempoContribuicaoRegimeOrigemDias','dataIngresso','dataDesvinculacao'].includes(atributoCampo)){var index=requerimento.exigencias.findIndex(function(item){return item.atributo===atributoCampo;});if(index!==-1){if(atributoCampo&&campo.atendida===1){if(atributoCampo in _this.state.exigenciasInvalidas){exigenciasInvalidas[atributoCampo]=true;}}}}return exigenciasInvalidas;};_this.handleSaveButton=function(){if(_this.state.acao==='consulta'){_this.uploadFileAvulso();}else{if(_this.state.requerimento.estado===9){_this.extrairMotivosParaSalvar();_this.setState({alertas:[__WEBPACK_IMPORTED_MODULE_20__utils_constants__["m" /* msgsConfirmacao */].indeferimento],showModalAlerta:!_this.state.showModalAlerta});}else if(_this.state.acao==='cumprir-exigencia'){var lista=_this.verificaAlteracaoCamposEstadoExigencia();if(lista.length===0){// verificar se a exigencia foi cumprida cumprida mas voltou a ter o mesmo valor.
var _this$state73=Object.assign({},_this.state),requerimento=_this$state73.requerimento;var _this$state74=Object.assign({},_this.state),exigenciasInvalidas=_this$state74.exigenciasInvalidas;var _this$state$requerime13=Object.assign({},_this.state.requerimento),exigencias=_this$state$requerime13.exigencias;exigencias.forEach(function(exigencia){var resultadoExigencia=_this.verificarSeExigenciaFoiCumpridaAnteriormente(exigencia);if(resultadoExigencia.deveResetar){exigenciasInvalidas=_this.resetarCumprimentoExigenciasInvalidas(exigencia);requerimento=_this.resetarCumprimentoExigencias(resultadoExigencia.exigencia);}});_this.setState({requerimento:Object.assign({},requerimento),exigenciasInvalidas:exigenciasInvalidas});// se a lista estiver vazia, não cumpriu exigência alguma.
}else if(lista.length>0){var _this$state75=Object.assign({},_this.state),_requerimento2=_this$state75.requerimento;var _this$state76=Object.assign({},_this.state),_exigenciasInvalidas=_this$state76.exigenciasInvalidas;lista.forEach(function(exigencia){var resultadoExigencia=_this.verificarSeExigenciaFoiCumpridaAnteriormente(exigencia);if(resultadoExigencia.deveResetar){_exigenciasInvalidas=_this.resetarCumprimentoExigenciasInvalidas(exigencia);_requerimento2=_this.resetarCumprimentoExigencias(resultadoExigencia.exigencia);}});_this.setState({requerimento:Object.assign({},_requerimento2),exigenciasInvalidas:_exigenciasInvalidas});}_this.confirmSendData();}else if(_this.state.acao==='indeferidos'){var _this$state77=Object.assign({},_this.state),_requerimento3=_this$state77.requerimento;var _this$state78=Object.assign({},_this.state),concomitanciaDePeriodosNoRequerimento=_this$state78.concomitanciaDePeriodosNoRequerimento;_requerimento3.estado=3;var mensagemConfirmacao=__WEBPACK_IMPORTED_MODULE_20__utils_constants__["r" /* msgsConfirmacaoIndeferimento */].reaberturaIndeferimento;// exibir o modal de confirmação somente se o requerimento nao possuir periodos concomitantes
if(!concomitanciaDePeriodosNoRequerimento){_this.setState({requerimento:Object.assign({},_requerimento3),alertas:[mensagemConfirmacao],showModalAlerta:!_this.state.showModalAlerta});}else{// alterar o requerimento após clicar no botao "SIM" do modal de concomitancia (modalAlertaRequerPerConcomitancia)
_this.setState({concomitanciaDePeriodosNoRequerimento:false});_this.confirmSendData();}}else if(_this.state.acao==='complementar-aposentadoria'){var _this$state79=Object.assign({},_this.state),_requerimento4=_this$state79.requerimento;_requerimento4.estado=3;_this.setState({requerimento:Object.assign({},_requerimento4)});_this.confirmSendData();}else{_this.confirmSendData();}}};_this.handleSaveButtonConfirmarIndeferimento=function(){var _this$state80=Object.assign({},_this.state),requerimento=_this$state80.requerimento;requerimento.estado=ESTADO_INDEFERIDO_RATIFICADO;var mensagemConfirmacao='';mensagemConfirmacao=__WEBPACK_IMPORTED_MODULE_20__utils_constants__["r" /* msgsConfirmacaoIndeferimento */].indeferimento;_this.setState({requerimento:Object.assign({},requerimento),alertas:[mensagemConfirmacao],showModalAlerta:!_this.state.showModalAlerta});};_this.validarCamposSegregacao=function(nome){var _this$state81=Object.assign({},_this.state),requerimento=_this$state81.requerimento;if(requerimento[nome]&&requerimento[nome]!==null&&requerimento[nome]!==''){requerimento[nome]=Number(requerimento[nome]);}else if(requerimento[nome]===''){requerimento[nome]=null;}_this.setState({requerimento:Object.assign({},requerimento)});};_this.validarCtcEspecifica=function(){var _this$state82=Object.assign({},_this.state),requerimento=_this$state82.requerimento,acao=_this$state82.acao,exibirUploadArquivosNaConsulta=_this$state82.exibirUploadArquivosNaConsulta;var existeDocCtc=false;if(requerimento.estado!==ESTADO_INDEFERIDO_RATIFICADO){if(requerimento.ctcEspecifica===1){if(acao==='novo'||acao==='criado'||exibirUploadArquivosNaConsulta){var arquivos=requerimento.arquivos;if(arquivos.length>0){for(var i=0,docs=arquivos.length;i<docs;i+=1){existeDocCtc=arquivos[i].tipoDocumento===1;if(existeDocCtc){return true;}}}}else if(acao==='indeferidos'||acao==='cumprir-exigencia'){var docProbIndeferido=requerimento.documentosProbatorios;var arqIndeferido=requerimento.arquivos;if(docProbIndeferido.length>0){for(var j=0,_docs=docProbIndeferido.length;j<_docs;j+=1){existeDocCtc=docProbIndeferido[j].tipoDocumento===1;if(existeDocCtc){return true;}}}if(arqIndeferido.length>0){for(var k=0,_docs2=arqIndeferido.length;k<_docs2;k+=1){existeDocCtc=arqIndeferido[k].tipoDocumento===1;if(existeDocCtc){return true;}}}}else{var docProbatorio=requerimento.documentosProbatorios;if(docProbatorio.length>0){for(var n=0,doc=docProbatorio.length;n<doc;n+=1){existeDocCtc=docProbatorio[n].tipoDocumento===1;if(existeDocCtc){return true;}}}}return false;}}return true;};_this.calcularTempoDeContribuicaoLiquido=function(periodo){if(periodo){var qtdDiasDesconto=periodo.qtdDiasDesconto?Number(periodo.qtdDiasDesconto):0;var tempoBruto=periodo.qtdDiasContribuicaoBruto?Number(periodo.qtdDiasContribuicaoBruto):0;var retorno=Math.trunc(tempoBruto-qtdDiasDesconto);return retorno;}return 0;};_this.calcularTempoTotalAmdRgps=function(lista,listaIndexada){var resultadoDia=0;var resultadoMes=0;var resultadoAno=0;var resultadoQtdMeses=0;var restoDivisaoDia=0;var resultadoQtdAnos=0;var restoDivisaoMes=0;var totalDiasDescontados=0;var acrescentarMesDias=30;var qtdDiasMes=30;var qtdMesesAno=12;var acrescentarAnoDias=365;lista.forEach(function(periodo){if(periodo.totalDia!==''&&periodo.totalMes!==''&&periodo.totalAno!==''){resultadoDia+=periodo.totalDia;resultadoQtdMeses=Math.trunc(resultadoDia/qtdDiasMes);restoDivisaoDia=resultadoDia%qtdDiasMes;resultadoDia=restoDivisaoDia;resultadoMes+=periodo.totalMes+resultadoQtdMeses;resultadoQtdAnos=Math.trunc(resultadoMes/qtdMesesAno);restoDivisaoMes=resultadoMes%qtdMesesAno;resultadoMes=restoDivisaoMes;resultadoAno+=periodo.totalAno+resultadoQtdAnos;}});listaIndexada.forEach(function(item){if(item.qtdDiasDesconto>0){totalDiasDescontados+=item.qtdDiasDesconto;}});return Number(resultadoAno*acrescentarAnoDias+resultadoMes*acrescentarMesDias+resultadoDia-totalDiasDescontados);};_this.isRelacaoRgpsRpps=function(destinatario){var _this$state$requerime14=Object.assign({},_this.state.requerimento),solicitante=_this$state$requerime14.solicitante;var retorno=false;if(destinatario&&destinatario==='01000'||destinatario&&destinatario.codigo==='01000'||__WEBPACK_IMPORTED_MODULE_23__domain_User__["a" /* default */].logged().isRGPS()||solicitante&&solicitante.codigo==='01000'){retorno=true;}return retorno;};_this.calcularTempoRO=function(destinatario,alteracaoManual){var _this$state83=Object.assign({},_this.state),requerimento=_this$state83.requerimento;var lista=[];var somatorioTempoContribuicao=0;var periodoAux={};var listaAux=[];var retorno=false;if(_this.state.acao!=='realizar-analise'&&_this.state.acao!=='emitir-parecer-medico'&&requerimento.estado!==ESTADO_INDEFERIDO_RATIFICADO){if(requerimento.requerimentoPeriodos){lista=requerimento.requerimentoPeriodos;}var listaIndexada=lista.map(function(item,i){var itemIndexado=item;itemIndexado.indice=i;itemIndexado.qtdDiasContribuicaoBruto=_this.isRelacaoRgpsRpps(destinatario)?_this.calcularPeriodoRgps(itemIndexado,false):_this.calcularPeriodoRpps(itemIndexado);itemIndexado.qtdDiasContribuicaoLiquido=_this.calcularTempoDeContribuicaoLiquido(itemIndexado);itemIndexado.qtdDiasDesconto=itemIndexado.qtdDiasDesconto?itemIndexado.qtdDiasDesconto:0;return itemIndexado;});if(listaIndexada.length>0){if(_this.isRelacaoRgpsRpps(destinatario)){listaIndexada.forEach(function(periodo){periodoAux=_this.calcularPeriodoRgps(periodo,true);listaAux.push(periodoAux);});somatorioTempoContribuicao=_this.calcularTempoTotalAmdRgps(listaAux,listaIndexada);}else{listaIndexada.forEach(function(periodo){if(periodo.qtdDiasContribuicaoLiquido){somatorioTempoContribuicao+=periodo.qtdDiasContribuicaoLiquido;}});}if(!alteracaoManual){requerimento.destinatario=destinatario;requerimento.tempoContribuicaoRegimeOrigemDias=somatorioTempoContribuicao;_this.setState({requerimento:Object.assign({},requerimento)});}else{// Verifica se o tempo RO informado manualmente é maior que o calculado pelo sistema
retorno=true;if(requerimento.alteracaoTempoRO===1&&requerimento.tempoContribuicaoRegimeOrigemDias>somatorioTempoContribuicao){retorno=false;}return retorno;}}}else{retorno=true;return retorno;}};_this.recalcularTempoRO=function(){var _this$state84=Object.assign({},_this.state),requerimento=_this$state84.requerimento;var _this$state$requerime15=Object.assign({},_this.state.requerimento),destinatario=_this$state$requerime15.destinatario;var _this$state85=Object.assign({},_this.state),historyTempoRO=_this$state85.historyTempoRO;var lista=[];var somatorioTempoContribuicao=0;var periodoAux={};var listaAux=[];var checkboxMarcado=0;if(requerimento.requerimentoPeriodos){lista=requerimento.requerimentoPeriodos;}var listaIndexada=lista.map(function(item,i){var itemIndexado=item;itemIndexado.indice=i;itemIndexado.qtdDiasContribuicaoBruto=_this.isRelacaoRgpsRpps(destinatario)?_this.calcularPeriodoRgps(itemIndexado,false):_this.calcularPeriodoRpps(itemIndexado);itemIndexado.qtdDiasContribuicaoLiquido=_this.calcularTempoDeContribuicaoLiquido(itemIndexado);itemIndexado.qtdDiasDesconto=itemIndexado.qtdDiasDesconto?itemIndexado.qtdDiasDesconto:0;return itemIndexado;});if(listaIndexada.length>0){if(_this.isRelacaoRgpsRpps(destinatario)){listaIndexada.forEach(function(periodo){periodoAux=_this.calcularPeriodoRgps(periodo,true);listaAux.push(periodoAux);});somatorioTempoContribuicao=_this.calcularTempoTotalAmdRgps(listaAux,listaIndexada);}else{listaIndexada.forEach(function(periodo){if(periodo.qtdDiasContribuicaoLiquido){somatorioTempoContribuicao+=periodo.qtdDiasContribuicaoLiquido;}});}requerimento.destinatario=destinatario;requerimento.tempoContribuicaoRegimeOrigemDias=somatorioTempoContribuicao;historyTempoRO=somatorioTempoContribuicao;var changeObj={value:somatorioTempoContribuicao,isValid:true};_this.setState({requerimento:Object.assign({},requerimento),historyTempoRO:historyTempoRO,showModalRecalcularTempoRO:!_this.state.showModalRecalcularTempoRO,checkTempoRo:checkboxMarcado}),_this.handleChange(changeObj,'tempoContribuicaoRegimeOrigemDias');}else{// no caso do requerimento não possuir períodos cadastrados
_this.setState({requerimento:Object.assign({},requerimento,{tempoContribuicaoRegimeOrigemDias:historyTempoRO}),showModalRecalcularTempoRO:!_this.state.showModalRecalcularTempoRO,checkTempoRo:checkboxMarcado});}};_this.atualizarTempoRO=function(tempoRO){var _this$state86=Object.assign({},_this.state),requerimento=_this$state86.requerimento;var historyTempoRO=tempoRO;requerimento.tempoContribuicaoRegimeOrigemDias=historyTempoRO;_this.setState({requerimento:Object.assign({},requerimento)});};_this.confirmSendData=function(){var touched=true;var url='requerimentos-compensacao-aposentadoria';if(_this.state.acao!=='novo'){if(_this.state.acao==='qualificar'){url='requerimentos-compensacao-aposentadoria/qualificar/'+_this.state.requerimento.protocolo;}else if(_this.state.acao==='salvarERejeitar'){url='requerimentos-compensacao-aposentadoria/solicitar-e-rejeitar';}else{url='requerimentos-compensacao-aposentadoria/'+_this.state.requerimento.protocolo;}}var _this$state87=Object.assign({},_this.state),requerimento=_this$state87.requerimento;// Alteração para transformar o valor do campo rendaMensalInicial
// para numero antes de persistir na tabela.
if(typeof _this.state.requerimento.rendaMensalInicial!=='number'){var renda=_this.state.requerimento.rendaMensalInicial;renda=renda.replace(/\./g,'').replace(/,/g,'.');// const { requerimento } = { ...this.state };
requerimento.rendaMensalInicial=Number(renda);_this.setState({requerimento:Object.assign({},requerimento)});}_this.validarCamposSegregacao('tipoSegregacaoSolicitante');_this.validarCamposSegregacao('tipoSegregacaoDestinatario');// Vinicius
var _this$state88=Object.assign({},_this.state),validadeCampos=_this$state88.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});var codigoDestinatario='';if(requerimento.destinatario){codigoDestinatario=requerimento.destinatario;}if(requerimento.destinatario.codigo){codigoDestinatario=requerimento.destinatario.codigo;}if(codigoDestinatario){var orgaoCentralizador=null;var orgao=_this.props.destinatarios.find(function(item){return item.value===codigoDestinatario;});if(orgao){if(orgao.codigoOrgaoCentralizador&&orgao.inOrgaoUniao){orgaoCentralizador=_this.props.destinatarios.find(function(item){return item.value===orgao.codigoOrgaoCentralizador;});// Se o destinatario escolhido for um orgao centralizado, abrir o requerimento para o
// orgão centralizador
// inserir o valor do orgao centralizador no destinatario e o orgao origem será
// o orgão centralizado
if(orgaoCentralizador!==null){if(_this.state.acao==='novo'){requerimento.destinatarioOrigem=codigoDestinatario;requerimento.destinatario=orgaoCentralizador.value;}if(_this.state.acao==='cumprir-exigencia'||_this.state.acao==='indeferidos'){requerimento.destinatario={codigo:orgaoCentralizador.value};requerimento.destinatarioOrigem={codigo:codigoDestinatario};}_this.setState({requerimento:Object.assign({},requerimento)});}}else{if(_this.state.acao==='cumprir-exigencia'||_this.state.acao==='indeferidos'){requerimento.destinatario={codigo:codigoDestinatario};if(_this.state.acao==='indeferidos'){var _this$state89=Object.assign({},_this.state),checkExigirQualificacao=_this$state89.checkExigirQualificacao;//if (checkExigirQualificacao) {
requerimento.exigirQualificacao=checkExigirQualificacao;//}
}}_this.setState({requerimento:Object.assign({},requerimento)});}}}_this.setState({touched:touched,validadeCampos:validadeCampos,requestPesquisa:null},function(){return _this.handleSave(url);});};_this.houveAlteracaoCamposRequerimento=function(){var houveAlteracao=false;var lista=_this.verificaAlteracaoCamposEstadoExigencia();var existeAlteracaoNosOutrosCampos=false;if(lista&&lista.length===0){// verificar campos alterados que nao sao exigencia
lista=_this.verificaAlteracaoCamposQueNaoSaoExigencia();}if(lista&&lista.length>0){var indexNaoArquivo=lista.findIndex(function(i){return i!=='arquivos';});// campos alterados que nao sao upload avulso
if(indexNaoArquivo!==-1){existeAlteracaoNosOutrosCampos=true;}}houveAlteracao=existeAlteracaoNosOutrosCampos;return houveAlteracao;};_this.atualizarConflitosPeriodos=function(novaLista){_this.setState(function(prevState){return{requerimento:Object.assign({},prevState.requerimento,{listaConflitosPeriodos:novaLista})};});};_this.handleSave=function(url){var _this$state90=Object.assign({},_this.state),requerimento=_this$state90.requerimento,clicouBotaoPesquisarCtc=_this$state90.clicouBotaoPesquisarCtc;var _this$state$requerime16=Object.assign({},_this.state.requerimento),listaConflitosPeriodos=_this$state$requerime16.listaConflitosPeriodos;if(_this.formularioProntoParaEnvio()||requerimento.estado===ESTADO_INDEFERIDO_RATIFICADO){if(_this.calcularTempoRO(requerimento.destinatario,true)){if(_this.validarCtcEspecifica()){if(requerimento.estado===2){var _this$state91=Object.assign({},_this.state),exigenciasInvalidas=_this$state91.exigenciasInvalidas;var _this$state$requerime17=Object.assign({},_this.state.requerimento),exigencias=_this$state$requerime17.exigencias;exigencias.forEach(function(exigencia){var resultadoExigencia=_this.verificarSeExigenciaFoiCumpridaAnteriormente(exigencia);if(resultadoExigencia.deveResetar){exigenciasInvalidas=_this.resetarCumprimentoExigenciasInvalidas(exigencia);requerimento=_this.resetarCumprimentoExigencias(resultadoExigencia.exigencia);}});if(requerimento.arquivos&&requerimento.arquivos.length>0){_this.uploadFileAvulso();}_this.setState({requerimento:Object.assign({},requerimento),exigenciasInvalidas:exigenciasInvalidas});}var options=void 0;var requerimentoAtualizado=Object.assign({},requerimento,{listaConflitosPeriodos:listaConflitosPeriodos});if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}if(_this.state.acao==='novo'||_this.state.acao==='salvarERejeitar'){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["l" /* doPost */])(url,requerimentoAtualizado,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,options);}else{if(_this.state.acao!=='cumprir-exigencia'||_this.state.acao==='cumprir-exigencia'&&_this.houveAlteracaoCamposRequerimento()){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["n" /* doPut */])(url,requerimentoAtualizado,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,{codigo:3009,mensagem:'Esta solicitação já foi atendida por outro usuário.'},options);}}}else{Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["L" /* trataMensagensErro */])(['Documento de CTC não encontrado. Obrigatório anexar a CTC específica em requerimento com indicador de existência de CTC específica informado']);}}else{Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["L" /* trataMensagensErro */])(['Tempo de contribuição de regime de origem inválido. Tempo de Regime de Origem informado manualmente deve ser menor ou igual ao calculado pelo sistema.']);}}else if(clicouBotaoPesquisarCtc){_this.setState({clicouBotaoPesquisarCtc:false});Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["L" /* trataMensagensErro */])(['Alteração não permitida. Não foram identificadas modificações nos períodos do requerimento']);}else{Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["L" /* trataMensagensErro */])(['Informe corretamente os atributos indicados na tela.']);}};_this.handleDocumentSent=function(){_this.setState({sucessoUpload:true});};_this.handleFailDocumentSent=function(){};_this.uploadFile=function(response){var _this$state92=Object.assign({},_this.state),requerimento=_this$state92.requerimento;if(_this.state.acao==='novo'){requerimento.protocolo=response.headers.location.substring(response.headers.location.lastIndexOf('/')+1,response.headers.location.length);}var url='documentos';var documentos=requerimento.arquivos;if(documentos.length>0){for(var i=0,docs=documentos.length;i<docs;i+=1){var body={protocolo:requerimento.protocolo,tipoDocumento:documentos[i].tipoDocumento,documento:documentos[i].documento};Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["j" /* doMultipartFormPost */])(url,body,_this.handleDocumentSent,_this.handleFailDocumentSent);}}};_this.isUploadAvulsoNaTelaDeExigencia=function(requerimento){var retorno=false;if(requerimento.exigencias&&requerimento.exigencias.length>0&&requerimento.arquivos&&requerimento.arquivos.length>0){var listaExigenciasCumpridas=requerimento.exigencias.filter(function(exigencia){return exigencia.atendida===1;});if(listaExigenciasCumpridas.length>0){listaExigenciasCumpridas.forEach(function(exig){var index=requerimento.arquivos.findIndex(function(arq){return arq.tipoDocumento===exig.tipoDocumento;});if(index!==-1){retorno=true;}});}}return retorno;};_this.trataSucessoUploadAvulsoExigencias=function(){var _this$state93=Object.assign({},_this.state),requerimento=_this$state93.requerimento;_this.setState({sucessoUpload:true});var mensagemSucesso='';var consultaExigencia=_this.isConsultaExigencia();var uploadNoDetalhamentoEmExigencia=_this.isUploadAvulsoNaTelaDeExigencia(requerimento);if(_this.state.sucessoUpload){if(consultaExigencia){mensagemSucesso='Documento(s) anexado(s) ao requerimento com sucesso.';}else if(uploadNoDetalhamentoEmExigencia){mensagemSucesso='Documento(s) anexado(s) ao requerimento com sucesso. Exigência(s) encerrada(s).';}else{mensagemSucesso='Documento(s) anexado(s) ao requerimento com sucesso.';}requerimento.arquivos=[];_this.setState({habilitarBotaoCarregarDocumento:false,requerimento:requerimento},_this.atualizarDocumentosProbatorios);Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["J" /* trataMensagemSucesso */])([mensagemSucesso]);}};_this.trataSucessoUploadAvulso=function(){var _this$state94=Object.assign({},_this.state),requerimento=_this$state94.requerimento;_this.setState({sucessoUpload:true});var mensagemSucesso=['Documento(s) anexado(s) ao requerimento com sucesso.'];if(_this.state.sucessoUpload){requerimento.arquivos=[];_this.setState({habilitarBotaoCarregarDocumento:false,requerimento:requerimento},_this.atualizarDocumentosProbatorios);Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);}};_this.handleFailUploadAvulso=function(){var mensagemErro=['Falha ao anexar documento(s) ao requerimento.'];Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["L" /* trataMensagensErro */])(mensagemErro);};_this.trataSucessoResponseDocs=function(response){var _this$state95=Object.assign({},_this.state),requerimento=_this$state95.requerimento;var listaDocs=response.data;_this.setState({requerimento:Object.assign({},requerimento,{documentosProbatorios:listaDocs})});};_this.uploadFileAvulso=function(){var _this$state96=Object.assign({},_this.state),requerimento=_this$state96.requerimento;var url='documentos';if(requerimento.estado===2){var documentos=requerimento.arquivos;if(documentos.length>0){documentos.forEach(function(documento){var body={protocolo:requerimento.protocolo,documento:documento.documento,tipoDocumento:documento.tipoDocumento};Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["k" /* doMultipartFormPostExigencias */])(url,body,_this.trataSucessoUploadAvulsoExigencias,_this.handleFailUploadAvulso);});}}else{// const url = 'documentos';
var _documentos=requerimento.arquivos;if(_documentos.length>0){for(var i=0,docs=_documentos.length;i<docs;i+=1){var body={protocolo:requerimento.protocolo,tipoDocumento:_documentos[i].tipoDocumento,documento:_documentos[i].documento};Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["j" /* doMultipartFormPost */])(url,body,_this.trataSucessoUploadAvulso,_this.handleFailUploadAvulso);}}}};_this.atualizarDocumentosProbatorios=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.sleep(1000);case 2:// }
Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["e" /* doGet */])('/requerimentos-compensacao-aposentadoria/documentos-probatorios/'+_this.state.requerimento.protocolo,_this.trataSucessoResponseDocs,_this.trataErrosResponse);case 3:case'end':return _context.stop();}}},_callee,_this2);}));_this.sleep=function(time){return new Promise(function(resolve){return setTimeout(resolve,time);});};_this.verificarSucessoUpload=function(){if(_this.state.sucessoUpload){var mensagemSucesso=['Documentos anexados ao requerimento com sucesso.'];Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);}};_this.trataSucessoResponseEnvio=function(response){if(['novo','indeferidos','realizar-analise'].includes(_this.state.acao)){_this.uploadFile(response);_this.verificarSucessoUpload();}if(_this.state.acao==='cumprir-exigencia'){_this.setState(_this.buscaRequerimentoAposAlteracaoPeriodo);}if((_this.state.chaveConfirmacao||response.data==='')&&(response.status===201||response.status===200)){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlertaRequerPerConcomitancia:false,showModalAlerta:false});}_this.trataSucesso();};_this.handleFechamentoModalAlerta=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta});};_this.handleFechamentoModalAlertaRequerimentosPeriodos=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlertaRequerimentosPeriodos:!_this.state.showModalAlertaRequerimentosPeriodos});};_this.handleFechamentoModalAlertaRequerPerConcomitancia=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlertaRequerPerConcomitancia:!_this.state.showModalAlertaRequerPerConcomitancia});};_this.handleFechamentoModalCtcNaoEncontrada=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlertaCtcNaoEncontrada:!_this.state.showModalAlertaCtcNaoEncontrada});};_this.handleFechamentoModalAlertaReqAprovadoSemData=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlertaReqAprovadoSemDataIngresso:!_this.state.showModalAlertaReqAprovadoSemDataIngresso});};_this.handleModalRecalcularTempoRO=function(){var _this$state97=Object.assign({},_this.state),requerimento=_this$state97.requerimento,historyCheckTempoRO=_this$state97.historyCheckTempoRO;var checkTempoRo=historyCheckTempoRO;_this.setState({chaveConfirmacao:null,alertas:[],showModalRecalcularTempoRO:!_this.state.showModalRecalcularTempoRO,requerimento:Object.assign({},requerimento,{alteracaoTempoRO:checkTempoRo}),historyCheckTempoRO:historyCheckTempoRO});};_this.trataSucesso=function(){var mensagemSucesso='Requerimento aberto.';var cumpriuExigencia=false;switch(_this.state.acao){case'novo':{_this.setState({estadoFormulario:'criado'});break;}case'qualificar':{mensagemSucesso='Requerimento qualificado com sucesso.';_this.props.history.goBack();break;}case'cumprir-exigencia':mensagemSucesso='Requerimento atualizado.';var houveAlteracao=_this.verificaAlteracaoCamposEstadoExigencia().length>0;_this.state.requerimento.exigencias.forEach(function(exigencia){if(exigencia.atendida){cumpriuExigencia=true;}});if(houveAlteracao&&cumpriuExigencia){mensagemSucesso='Requerimento atualizado e exigência encerrada.';}else if(houveAlteracao&&!cumpriuExigencia){mensagemSucesso='Requerimento atualizado.';}// mensagemSucesso = 'Requerimento atualizado e exigência encerrada.';
_this.buscaRequerimento(_this.handleSuccessBuscaRequerimentoAtualizacao);break;case'realizar-analise':mensagemSucesso='Requerimento analisado.';_this.props.history.goBack();break;case'emitir-parecer-medico':mensagemSucesso='Requerimento atualizado com o parecer do médico.';_this.props.history.goBack();break;case'indeferidos':{mensagemSucesso='Requerimento atualizado com sucesso.';_this.props.history.goBack();break;}case'salvarERejeitar':{mensagemSucesso='Requerimento criado no estado rejeitado.';_this.handleModalRejeicaoRequerimento();_this.setState({acao:'novo',estadoFormulario:'criado'});break;}case'complementar-aposentadoria':{mensagemSucesso='Requerimento complementado com sucesso.';_this.props.history.goBack();break;}default:mensagemSucesso='Requerimento atualizado e exigência encerrada.';}Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["J" /* trataMensagemSucesso */])([mensagemSucesso]);};_this.trataSucessoRejeitar=function(){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["J" /* trataMensagemSucesso */])(['Requerimento rejeitado.']);_this.props.history.goBack();};_this.trataErrosResponse=function(error){var _this$state98=Object.assign({},_this.state),validadeCampos=_this$state98.validadeCampos;var _this$state99=Object.assign({},_this.state),requerimento=_this$state99.requerimento;if(error&&error.data&&error.data.tipo===2){var _error=Object.assign({},error),data=_error.data;if(error.data.alertas[0].codigo===4513){_this.setState({chaveConfirmacao:data.chaveConfirmacao,alertas:data.alertas,showModalAlerta:false,showModalAlertaRequerPerConcomitancia:!_this.state.showModalAlertaRequerPerConcomitancia,concomitanciaDePeriodosNoRequerimento:true});}else{_this.setState({chaveConfirmacao:data.chaveConfirmacao,alertas:data.alertas,showModalAlerta:!_this.state.showModalAlerta});}}else{if(_this.state.requestPesquisa&&!_this.state.acao==='qualificar'){camposPreenchidosPorServico[_this.state.requestPesquisa].forEach(function(key){validadeCampos[key]=false;requerimento[key]='';});_this.setState({requerimento:Object.assign({},_this.state.requerimento,{requerimento:requerimento}),validadeCampos:validadeCampos});}else if(_this.state.requestPesquisa&&_this.state.acao==='qualificar'){validadeCampos.cpf=false;_this.setState({requerimento:Object.assign({},_this.state.requerimento,{requerimento:requerimento}),validadeCampos:validadeCampos});}if(error){var _error2=Object.assign({},error),_data=_error2.data;if(error.status===400){if(_data.erros&&_data.erros.length>=1){_data.erros.forEach(function(erro){if(erro.atributo in validadeCampos){validadeCampos[[erro.atributo]]=false;}});// if (this.state.acao === 'cumprir-exigencia'
// && requerimento.estado === 2 && requerimento.exigencias) {
//   const exigenciaComAtributo = requerimento.exigencias.filter(item => item.atributo);
//   exigenciaComAtributo.forEach((exigencia) => {
//     if (!['dataIngresso', 'dataDesvinculacao'].includes(exigencia.atributo)) {
//       validadeCampos[exigencia.atributo] = false;
//     }
//   });
// }
_this.setState(Object.assign({},_this.state,{validadeCampos:validadeCampos,estadoFormulario:'erro-regra'}));}var _this$state100=Object.assign({},_this.state),acao=_this$state100.acao;if(acao==='cumprir-exigencia'&&requerimento.estado===2&&requerimento.exigencias){var exigenciaComAtributo=requerimento.exigencias.filter(function(item){return item.atributo;});exigenciaComAtributo.forEach(function(exigencia){if(!['dataIngresso','dataDesvinculacao'].includes(exigencia.atributo)){validadeCampos[exigencia.atributo]=false;}});}_this.setState(Object.assign({},_this.state,{validadeCampos:validadeCampos,estadoFormulario:'erro-regra'}));var _this$state101=Object.assign({},_this.state),validadeBotoesIndeferidos=_this$state101.validadeBotoesIndeferidos;if(_this.state.requestPesquisa==='centralService'&&validadeBotoesIndeferidos.pesquisarDadosBeneficio===true){validadeBotoesIndeferidos.pesquisarDadosBeneficio=false;_this.setState({validadeBotoesIndeferidos:validadeBotoesIndeferidos});}if(_this.state.requestPesquisa==='cnis'&&validadeBotoesIndeferidos.pesquisarDadosPessoais===true){validadeBotoesIndeferidos.pesquisarDadosPessoais=false;_this.setState({validadeBotoesIndeferidos:validadeBotoesIndeferidos});}if(acao==='indeferidos'&&_this.state.showModalAlerta){_this.setState({showModalAlerta:false});}_this.setState(Object.assign({},_this.state,{validadeCampos:validadeCampos,estadoFormulario:'erro-regra'}));}else if(error.status===404){if(_this.state.requestPesquisa&&_this.state.requestPesquisa==='periodosCtc'){var _error3=Object.assign({},error),_data2=_error3.data;_this.setState({chaveConfirmacao:_data2.chaveConfirmacao,alertas:[],showModalAlertaCtcNaoEncontrada:!_this.state.showModalAlertaCtcNaoEncontrada});}}}}};_this.handleNewButton=function(){if(_this.props.auth.checkPermission(['requerer-compensacao-rpps'])){_this.setState(_this.buscaParticipantePeloCnpjLogado());}_this.setState(Object.assign({},_this.getInitialState(),{reset:true}),function(){return _this.setState({reset:false},function(){return window.scrollTo(0,0);});});_this.controlarExibicaoMultiplosPeriodos();};_this.formularioRequerimento=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__DadosRequerimentoAposentadoria__["a" /* default */],{acao:_this.state.acao,alteraEstadoRequerimento:_this.alteraEstadoRequerimento,auth:_this.props.auth,camposCnis:camposPreenchidosPorServico.cnis,camposCentralService:camposPreenchidosPorServico.centralService,estadoFormulario:_this.state,handleChange:_this.handleChange,handleKeyUp:_this.handleKeyUp,handleSearchButton:_this.handleSearchButton,handlePesquisaBotaoEloNit:_this.handlePesquisaBotaoEloNit,handleModalCadeiaDeNitModal:_this.handleModalCadeiaDeNitModal,handleModalAlteraDataCessacao:_this.handleModalAlteraDataCessacao,handleModalAlteraMotivoCessacao:_this.handleModalAlteraMotivoCessacao,handleModalAlteraDataEMotivoCessacao:_this.handleModalAlteraDataEMotivoCessacao,handleModalAlteraSegregacaoMassa:_this.handleModalAlteraSegregacaoMassa,handleSearchNBButton:_this.handleSearchNBButton,match:_this.props.match,tiposDocumentos:_this.props.tiposDocumentos,arquivos:_this.props.arquivos,apagaRegraDeCalculo:_this.apagaRegraDeCalculo,vinculosConcomitantesConfirmado:_this.state.vinculosConcomitantesConfirmado,possuiVinculosConcomitantes:_this.state.possuiVinculosConcomitantes,clickVinculosTab:_this.clickVinculosTab,exibirUploadArquivosNaConsulta:_this.state.exibirUploadArquivosNaConsulta,exibirModalCadeiaDeNit:_this.state.exibirModalCadeiaDeNit,exibirModalDataCessacao:_this.state.exibirModalDataCessacao,exibirModalMotivoCessacao:_this.state.exibirModalMotivoCessacao,exibirModalDataEMotivoCessacao:_this.state.exibirModalDataEMotivoCessacao,exibirModalSegregacaoMassa:_this.state.exibirModalSegregacaoMassa,listaExigencias:_this.state.exigenciasOriginais,atualizarDocumentosProbatorios:_this.atualizarDocumentosProbatorios,temBloqueioAtivoContratoDtp:_this.props.temBloqueioAtivoContratoDtp,atualizarDataCessacao:_this.atualizarDataCessacao,atualizarMotivoCessacao:_this.atualizarMotivoCessacao,atualizarHistoricoAuditorias:_this.atualizarHistoricoAuditorias,atualizarTipoSegregacaoMassaDestinatario:_this.atualizarTipoSegregacaoMassaDestinatario,atualizarTipoSegregacaoMassaSolicitante:_this.atualizarTipoSegregacaoMassaSolicitante,handleChangeExigirQualificacao:_this.handleChangeExigirQualificacao,handleChangeTempoROManual:_this.handleChangeTempoROManual,handleChangeCtcEspecifica:_this.handleChangeCtcEspecifica,handleChangeProtocoloNaoConstaOuIlegivel:_this.handleChangeProtocoloNaoConstaOuIlegivel,handleSearchPeriodos:_this.handleSearchPeriodos,atualizarDataIngressoDesvinculacaoETempo:_this.atualizarDataIngressoDesvinculacaoETempo,determinarConcomitancias:_this.determinarConcomitancias,ordenarListaPeriodos:_this.ordenarListaPeriodos,verificarHabilitacaoDataIngressoDesvinculacaoETempo:_this.verificarHabilitacaoDataIngressoDesvinculacaoETempo,verificarHabilitacaoDataHomologacaoTc:_this.verificarHabilitacaoDataIngressoDesvinculacaoETempo,calcularPeriodoRgps:_this.calcularPeriodoRgps,calcularPeriodoRpps:_this.calcularPeriodoRpps,calcularTempoRO:_this.calcularTempoRO,atualizarTempoRO:_this.atualizarTempoRO,handleModalTempoRO:_this.handleModalRecalcularTempoRO,validacaoDeVinculosConcomitantes:_this.validacaoDeVinculosConcomitantes,atualizarVinculosConcomitantesConfirmado:_this.atualizarVinculosConcomitantesConfirmado,handleChangeFile:_this.handleChangeFile,handleChangeTipoDocumento:_this.handleChangeTipoDocumento,isDataCessacaoManualPreenchida:_this.isDataCessacaoManualPreenchida});};_this.montaCorpoRequerimento=function(){var todasTabs=_this.montaTabs();// console.log('tabPaginaAtual:', this.state.tabPaginaAtual, 'totalTabs:', todasTabs.length, 'tabs:', todasTabs.map(t => t.props.title));
var maxTabs=4;var temPaginacao=todasTabs.length>maxTabs;var inicio=_this.state.tabPaginaAtual*maxTabs;var fim=inicio+maxTabs;var tabsExibidas=todasTabs;if(temPaginacao){tabsExibidas=todasTabs.map(function(tab,idx){var visivel=idx>=inicio&&idx<fim;var cls='';if(visivel&&idx===inicio)cls='active';if(!visivel)cls='tab-oculta';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(tab,{className:cls});});}var corpoRequerimento=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tabs-container-paginado'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_dtp_react_components__["G" /* DtpTabGroup */],{className:'dtp-default'},tabsExibidas),temPaginacao&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tabs-navegacao'},_this.state.tabPaginaAtual>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'#',className:'tab-nav-link',onClick:function onClick(e){e.preventDefault();_this.setState({tabPaginaAtual:_this.state.tabPaginaAtual-1});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'ico-triangle-left',title:'Anterior'})),fim<todasTabs.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'#',className:'tab-nav-link',onClick:function onClick(e){e.preventDefault();_this.setState({tabPaginaAtual:_this.state.tabPaginaAtual+1});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'ico-triangle-right',title:'Pr\xF3ximo'}))));return corpoRequerimento;};_this.tabRequerimento=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_dtp_react_components__["F" /* DtpTab */],{id:'item1',className:'active',title:'Dados b\xE1sicos',onClick:function onClick(e){return _this.handleClick(e,'item1');}},_this.formularioRequerimento());};_this.tabHistorico=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_dtp_react_components__["F" /* DtpTab */],{id:'item2',title:'Estados',onClick:function onClick(e){return _this.handleClick(e,'item2');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DadosHistoricoRequerimento__["a" /* default */],{historicoEstados:_this.state.requerimento.estados,auth:_this.props.auth,labelMotivoCessacao:_this.state.labelMotivoCessacaoManual}));};_this.tabPrescricao=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_dtp_react_components__["F" /* DtpTab */],{id:'item5',title:'Prescri\xE7\xE3o',onClick:function onClick(e){return _this.handleClick(e,'item5');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__DadosHistoricoPrescricao__["a" /* default */],{estadoFormulario:_this.state}));};_this.indiceRelacao=function(regime){return _this.state.requerimento.relacoesPrevidenciariasDestinatario.findIndex(function(e){return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.includes(e.regimePrevidenciario.map(function(r){return r.idRegimePrevidenciarioSimulacao;}),regime.idRegimePrevidenciarioSimulacao);});};_this.indiceRegime=function(regime){return _this.state.requerimento.relacoesPrevidenciariasDestinatario[_this.indiceRelacao(regime)].regimePrevidenciario.findIndex(function(e){return e.idRegimePrevidenciarioSimulacao===regime.idRegimePrevidenciarioSimulacao;});};_this.atualizarTipoConcomitanteDescartado=function(regime,valor){_this.setState(function(currentState){return __WEBPACK_IMPORTED_MODULE_4_immutability_helper___default()(currentState,{requerimento:{relacoesPrevidenciariasDestinatario:_defineProperty({},_this.indiceRelacao(regime),{regimePrevidenciario:_defineProperty({},_this.indiceRegime(regime),{tipoConcomitanteDescartado:{$set:valor}})})}});});};_this.confirmaVinculosConcomitantes=function(){var resultado=_this.validacaoDeVinculosConcomitantes();if(!resultado.datasValidas){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["L" /* trataMensagensErro */])([resultado.mensagemErro||'Datas no formato inválido']);return;}_this.setState({vinculosConcomitantesConfirmado:true,possuiVinculosConcomitantes:resultado.existeConcomitancia});};_this.competencias=function(regime){var colecao=regime.remuneracoes;if(colecao){return regime.remuneracoes.map(function(c){return{ano:c.ano,mes:c.mes};});}};_this.marcarRegime=function(regime){var competenciasParaAdicionar=_this.competencias(regime);var regimesUtilizadosConcomitantes=_this.state.requerimento.relacoesPrevidenciariasDestinatario.map(function(e){return e.regimePrevidenciario;}).flat().filter(function(e){return e.tipoConcomitanteDescartado===0||e.tipoConcomitanteDescartado==null;}).filter(function(e){return!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.intersectionWith(competenciasParaAdicionar,_this.competencias(e),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEqual));});// Descarta todos que colidem
regimesUtilizadosConcomitantes.forEach(function(r){return _this.atualizarTipoConcomitanteDescartado(r,1);});// Adiciona o marcado
_this.atualizarTipoConcomitanteDescartado(regime,0);};_this.desmarcarRegime=function(regime){// const competenciasParaAdicionar = this.competencias(regime);
// const regimesConcomitantes = this.state.requerimento.relacoesPrevidenciariasDestinatario
// .map(e => e.regimePrevidenciario)
// .flat()
// .filter(e => e.idRegimePrevidenciarioSimulacao !== regime.idRegimePrevidenciarioSimulacao)
// .filter(e => !_.isEmpty(_.intersectionWith(competenciasParaAdicionar,
// this.competencias(e),_.isEqual)));
// if (!_.isEmpty(regimesConcomitantes)) {
_this.atualizarTipoConcomitanteDescartado(regime,1);_this.setState({vinculosConcomitantesConfirmado:false});// }
};_this.marcarRegimeClick=function(regime){var competenciasParaAdicionar=_this.competencias(regime);var regimesUtilizadosConcomitantes=_this.state.requerimento.relacoesPrevidenciariasDestinatario.map(function(e){return e.regimePrevidenciario;}).flat().filter(function(e){return e.tipoConcomitanteDescartado===0||e.tipoConcomitanteDescartado==null;}).filter(function(e){return!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.intersectionWith(competenciasParaAdicionar,_this.competencias(e),__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEqual));});var descartar=true;regimesUtilizadosConcomitantes.forEach(function(regimeConcomitante){if(regimeConcomitante.dataInicio===regime.dataFim||regimeConcomitante.dataFim===regime.dataInicio){descartar=false;}// else if ((regimeConcomitante.dataInicio !== regime.dataFim) ||
// (regimeConcomitante.dataFim !== regime.dataInicio)) {
//   descartar = false;
// }
});if(descartar){// Descarta todos que colidem
regimesUtilizadosConcomitantes.forEach(function(r){return _this.atualizarTipoConcomitanteDescartado(r,1);});}// Adiciona o marcado
_this.atualizarTipoConcomitanteDescartado(regime,0);_this.setState({vinculosConcomitantesConfirmado:false});};_this.tabRelacoesPrevidenciarias=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_dtp_react_components__["F" /* DtpTab */],{ref:_this.tabVinculosRef,id:'item3',title:'Rela\xE7\xF5es Previdenci\xE1rias Regime Origem',onClick:function onClick(e){return _this.handleClick(e,'item3');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__DadosRelacoesPrevidenciarias__["a" /* default */],{relacoesPrevidenciarias:_this.state.requerimento.relacoesPrevidenciariasDestinatario,marcarRegime:_this.marcarRegimeClick,desmarcarRegime:_this.desmarcarRegime,confirmar:_this.confirmaVinculosConcomitantes,confirmado:_this.state.vinculosConcomitantesConfirmado,validacaoConcomitancia:_this.validacaoDeVinculosConcomitantes,acao:_this.state.acao,estadoDoFormulario:_this.state,rgpsEnvolvido:!(_this.isDestinatarioRPPS()&&_this.isSolicitanteRPPS())// rgpsEnvolvido={!(this.state.requerimento.destinatario === '01000' && this.state.requerimento.solicitante.codigo === '01000')}
}));};_this.isSolicitanteRPPS=function(){return __WEBPACK_IMPORTED_MODULE_23__domain_User__["a" /* default */].logged().isRPPS();};_this.tabResultadoSimulacao=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_dtp_react_components__["F" /* DtpTab */],{id:'item4',title:'Resultado da simula\xE7\xE3o',onClick:function onClick(e){return _this.handleClick(e,'item4');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__DadosResultadoSimulacao__["a" /* default */],{resultadoSimulacao:_this.state.requerimento.resultadoSimulacao}));};_this.tabConflitosPeriodos=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_dtp_react_components__["F" /* DtpTab */],{id:'item6',title:'Conflitos de per\xEDodos',onClick:function onClick(e){return _this.handleClick(e,'item6');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__ListaConflitosPeriodos__["a" /* default */],{lista:_this.state.requerimento.listaConflitosPeriodos,atualizarConflitosPeriodos:_this.atualizarConflitosPeriodos,acao:_this.state.acao,protocolo:_this.state.requerimento.protocolo}));};_this.montaTabs=function(){var listaTabs=[];listaTabs.push(_this.tabRequerimento());if(_this.state.requerimento.estados&&_this.state.requerimento.estados.length>0){listaTabs.push(_this.tabHistorico());}if(_this.state.requerimento.prescricao!==null&&_this.state.requerimento.prescricao&&(_this.state.requerimento.estado===11||_this.state.requerimento.estado===12)){listaTabs.push(_this.tabPrescricao());}if(_this.state.requerimento.relacoesPrevidenciariasDestinatario&&_this.state.requerimento.relacoesPrevidenciariasDestinatario.length>0){listaTabs.push(_this.tabRelacoesPrevidenciarias());}if(_this.state.requerimento.resultadoSimulacao&&_this.state.requerimento.resultadoSimulacao.length>0){listaTabs.push(_this.tabResultadoSimulacao());}if(_this.state.requerimento.listaConflitosPeriodos&&_this.state.requerimento.listaConflitosPeriodos.length>0&&!_this.props.auth.checkPermission(['fornecer-parecer-medico-rpps'])){listaTabs.push(_this.tabConflitosPeriodos());}return listaTabs;};_this.atualizarDataCessacao=function(dataCessacao){var requerimento=Object.assign({},_this.state.requerimento);requerimento.dataCessacaoBeneficio=dataCessacao;_this.setState({requerimento:requerimento});};_this.atualizarMotivoCessacao=function(motivoCessacao){var requerimento=Object.assign({},_this.state.requerimento);requerimento.motivoCessacaoManual=motivoCessacao;_this.setState({requerimento:requerimento});};_this.atualizarHistoricoAuditorias=function(estadoAtualizado){_this.setState(function(prevState){// console.log(prevState.requerimento.estados);
return{requerimento:Object.assign({},prevState.requerimento,{estados:prevState.requerimento.estados.map(function(estado){return estado.codigoEstado===estadoAtualizado.codigoEstado?estadoAtualizado:estado;})})};});};_this.atualizarTipoSegregacaoMassaDestinatario=function(tipo){var requerimento=Object.assign({},_this.state.requerimento);requerimento.tipoSegregacaoDestinatario=tipo;_this.setState({requerimento:requerimento});};_this.atualizarTipoSegregacaoMassaSolicitante=function(tipo){var requerimento=Object.assign({},_this.state.requerimento);requerimento.tipoSegregacaoSolicitante=tipo;_this.setState({requerimento:requerimento});};_this.atualizarMotivoRejeicao=function(paramMotivo,paramJustificativa){var requerimento=Object.assign({},_this.state.requerimento);requerimento.motivo=paramMotivo;requerimento.justificativaRejeicao=paramJustificativa;_this.setState({requerimento:Object.assign({},requerimento)},function(){return _this.confirmSendData();});;};_this.handleModalRejeicaoRequerimento=function(){if(_this.state.acao==='salvarERejeitar'){// para exibir o botao salvar quando fechar o modal
_this.setState({acao:'novo',showRejeicaoRequerimentoModal:!_this.state.showRejeicaoRequerimentoModal});}else{_this.setState({rejeitar:false,showRejeicaoRequerimentoModal:!_this.state.showRejeicaoRequerimentoModal});}};_this.onClickRejeitarRequerimento=function(){/**
    * Trata o click no botão de rejeitar requerimento
    */// this.setState({ acao:'rejeitar', showRejeicaoRequerimentoModal: !this.state.showRejeicaoRequerimentoModal });  
_this.setState({rejeitar:true,showRejeicaoRequerimentoModal:!_this.state.showRejeicaoRequerimentoModal});};_this.onClickSalvarERejeitarRequerimento=function(){var requerimento=Object.assign({},_this.state.requerimento);if(_this.isSolicitanteRGPS()){requerimento.solicitante='01000';}_this.setState({acao:'salvarERejeitar',requerimento:Object.assign({},requerimento),showRejeicaoRequerimentoModal:!_this.state.showRejeicaoRequerimentoModal});};_this.handleRejeicaoRequerimentoSent=function(){var mensagemSucesso=['Requerimento Rejeitado.'];Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);_this.setState({},function(){return _this.handleModalRejeicaoRequerimento();});_this.props.history.goBack();};_this.exibirBotaoRejeicao=function(){var _this$state$requerime18=Object.assign({},_this.state.requerimento),solicitante=_this$state$requerime18.solicitante;var _this$state102=Object.assign({},_this.state),requerimento=_this$state102.requerimento;var cnpjUsuarioLogado=__WEBPACK_IMPORTED_MODULE_23__domain_User__["a" /* default */].logged().cnpjDoPapel();var cnpjSolicitante=solicitante?solicitante.cnpj:null;var codigoSolicitante=solicitante?solicitante.codigo:null;var ehUsuarioRGPS=__WEBPACK_IMPORTED_MODULE_23__domain_User__["a" /* default */].logged().isUsuarioRGPS();var retorno=null;if([1,3,6,7,8,9,10,11,12,13,14,15,16,17].includes(requerimento.estado)){retorno=false;}else{retorno=requerimento!==undefined&&solicitante!==undefined&&(['consulta','cumprir-exigencia'].includes(_this.state.acao)&&[2,4,5,18].includes(requerimento.estado)&&cnpjSolicitante===cnpjUsuarioLogado||codigoSolicitante==='01000'&&ehUsuarioRGPS)||_this.state.rejeitar;}return retorno;};_this.alteraListaArquivos=function(arquivos){_this.handleChange({value:arquivos,isValid:arquivos.length>0},'arquivos');};_this.addArquivo=function(arquivo){var retorno={};if(arquivo){var _this$state103=Object.assign({},_this.state),requerimento=_this$state103.requerimento;var _this$state104=Object.assign({},_this.state),tipoDocumento=_this$state104.tipoDocumento;retorno={documento:arquivo,protocolo:requerimento.protocolo,tipoDocumento:tipoDocumento};}return retorno;};_this.handleChangeTipoDocumento=function(e,name){_this.setState(_defineProperty({},name,e.value));};_this.deleteArquivo=function(arquivoRemover){var _this$state105=Object.assign({},_this.state),arquivos=_this$state105.arquivos;var novaLista=arquivos.filter(function(arquivo){return arquivo!==arquivoRemover;});_this.alteraListaArquivos(novaLista);};_this.handleChangeFile=function(arquivo){if(!arquivo){_this.alteraListaArquivos([],null);return;}var tamanhoDocumentoUpload=arquivo.size;// inclusão
if(tamanhoDocumentoUpload>__WEBPACK_IMPORTED_MODULE_20__utils_constants__["z" /* tamanhoMaximoArquivoUpload */]){Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["L" /* trataMensagensErro */])(['Certifique-se de que o documento '+arquivo.name+' possui tamanho inferior a 3 mb.']);}else{var novoArquivo=_this.addArquivo(arquivo);_this.alteraListaArquivos([novoArquivo],null);}};_this.tabVinculosRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();_this.clickVinculosTab=_this.clickVinculosTab.bind(_this);_this.state=_this.getInitialState();return _this;}_createClass(RequerimentoAposentadoria,[{key:'componentDidMount',value:function componentDidMount(){this.montaFormulario();}},{key:'clickVinculosTab',value:function clickVinculosTab(){this.tabVinculosRef.current.click();}/** Se URL possuir protocolo, requerimento deve ser buscado.
   *  Se URL possuir acao, atualizar state com acao indicada,
   *  senao assume-se que o usuario apenas consulta o requerimento quando protocolo for informado
   *  Protocolo deve ser numerico;
   *  Acao deve ser cumprir-exigencia, realizar-analise ou emitir-parecer-medico.
   * */},{key:'buscaRequerimentoAposRejeitar',value:function buscaRequerimentoAposRejeitar(response){var url='requerimentos-compensacao-aposentadoria/'+response.data.protocolo;Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["e" /* doGet */])(url,this.handleSuccessBuscaRequerimentoAposSalvarERejeitar,this.handleErrorBuscaRequerimento);}},{key:'buscaRequerimentoAposAlteracaoPeriodo',value:function buscaRequerimentoAposAlteracaoPeriodo(){var url='requerimentos-compensacao-aposentadoria/'+this.state.requerimento.protocolo;Object(__WEBPACK_IMPORTED_MODULE_10__utils_requests__["e" /* doGet */])(url,this.handleSuccessBuscaRequerimento,this.handleErrorBuscaRequerimento);}/**
   * Verifica se ha campos a serem alterados na lista de exigencia
   * se requerimento estiver no estado Em-Exigencia (2)
   * Quando estado diferente de Em-exigencia:
   *  todos os campos que nao possuirem exigencias associadas serao considerados validos
   *//**
   * Trata erros na busca pelo requerimento, mostrando tela default para
   * falta de conteúdo.
   *//*
   * Verifica a existencia de um determinado tipo de documento carregado em requerimentos
   * neste caso estamos especifico estamos verificando o tipoDocumento = 2  (Homologação Tribunal)
   * se econtrar retorna verdadeiro.
   * @param {*} tipoEmDocumentosProbatorios
   * @returns
   */// isDataHomologacaoTribunalContasValid = (tipoEmDocumentosProbatorios, dateAberturaRequerimentoParam) => {
// const isValid = ((props.estadoFormulario.dataHomologacaoTribunalContas === null || props.estadoFormulario.dataHomologacaoTribunalContas === undefined) &&
// (props.estadoFormulario.requerimento.dataAberturaRequerimento !== null || props.estadoFormulario.requerimento.dataAberturaRequerimento !== undefined));
// if (isValid) {
//   if ((!existeTipoDocumentoCarregadoNoRequerimento(tipoEmDocumentosProbatorios) &&
//   dateAberturaRequerimentoParam <= dateAberturaRequerimentoObject) ||
//   (dateAberturaRequerimentoParam > dateAberturaRequerimentoObject)) {
//     return isValid;
//   }
// }
// return !isValid;
// };
/**
   * Para o Formulario estar pronto para envio, deve:
   *  - Ser criacao (acao=novo) e ter todos seus campos validos;
   *  - Ser criacao:
   *     - ter sido enviado com falha em regra de negocio e;
   *     - pelo menos um campo alterado para valido.
   *  - Ser cumprimento de exigencia (acao=cumprir-exigencia) e ter pelo menos uma alteracao;
   *  - Ser Analise (acao=realizar-analise) e ter a analise realizada;
   *  - Ser Analise do Medico Perito (acao=emitir-parecer-medico) e ter a parecer realizado;
   *///nome !== undefined && 
// IB444230
// IB444230
},{key:'verificarSeExigenciaFoiCumpridaAnteriormente',// IB444230
// Verifica se existe uma exigência já atendida associada ao campo.
// Caso exista, compara o valor atual com o valor original.
// Para 'requerimentoPeriodos', a comparação utiliza a validação específica da coleção.
// Se o valor tiver retornado ao original, a exigência deverá ser resetada
// para o estado de não atendida pelo código chamador.
value:function verificarSeExigenciaFoiCumpridaAnteriormente(campo){var _state=Object.assign({},this.state),requerimento=_state.requerimento;var _state2=Object.assign({},this.state),requerimentoVindoDoRequest=_state2.requerimentoVindoDoRequest;var _state3=Object.assign({},this.state),listaExigenciasAtendidas=_state3.listaExigenciasAtendidas;var exigencia=null;var valorVoltouAoOriginal=false;var tipoExigencia=campo&&campo.tipo?campo.tipo:null;var atributoCampo=campo.atributo?campo.atributo:campo;for(var i=0;i<listaExigenciasAtendidas.length;i++){var exigenciaAtual=listaExigenciasAtendidas[i];var ehMesmaExigenciaPorTipo=tipoExigencia!==null&&exigenciaAtual.tipo===tipoExigencia;var ehMesmoCampoAlterado=tipoExigencia===null&&exigenciaAtual.atributo===atributoCampo;if(ehMesmaExigenciaPorTipo||ehMesmoCampoAlterado){exigencia=exigenciaAtual;break;}}if(exigencia){// testar se o valor mudou
if(atributoCampo==='requerimentoPeriodos'){var _state4=Object.assign({},this.state),periodosOriginais=_state4.periodosOriginais;var campoRequerimentoVindoDoRequest=periodosOriginais;var deveValidarTempoDescontado=exigencia.tipo===EXIGENCIA_PERIODOS_ORIGEM;var houveAlteracao=this.verificarMudancaNaColecaoDePeriodos(campoRequerimentoVindoDoRequest,requerimento[atributoCampo],deveValidarTempoDescontado);if(!houveAlteracao){valorVoltouAoOriginal=true;}}else{if(requerimento[atributoCampo]===requerimentoVindoDoRequest[atributoCampo]){valorVoltouAoOriginal=true;}}}return{deveResetar:valorVoltouAoOriginal,exigencia:exigencia};}/**
   * Verifica se analise foi preenchida corretamente
   *//**
   * Trata o estado do formulario e alteracoes de campos.
   * Formulario deve ser considerado:
   *  - Inicial quando ainda nao enviado para validacao de regras no servico;
   *  - Alterado quando formulario montado com dados do servico e ao menos um campo foi alterado.
   *  - Enviado quando o formulario foi enviado para validacao no servico.
   *//**
   * Trata o click no botão de busca por CPF no CNIS.
   */// IB422810 - INICIO SUBPERIODOS
// IB422810 - FIM SUBPERIODOS
/**
   * Trata o click no botão de busca por NIT Elados
   *//**
  * Trata o click no botão de alteração da data de cessação
  *//**
  * Trata o click no botão de alteração da data de cessação
  *//**
  * Trata o click no botão de alteração da data de cessação e motivo juntos
  *//**
   * Trata o fechamento do modal de NIT Elados
   *//**
   * Trata o click no botão de busca por NB no BenMigrado. CentralService
   *//**
    * Trata o click no botão de alteração do tipo de segregação
    *//**
   * Trata o click do botao de submissao do formulario
   * Se analise estiver indeferindo, exibir alerta de confirmacao
   *//**
   * Trata envio dos dados
   *//**
   * Trata as acoes dos botoes principais "Criar Requerimento", "Emitir Parecer" etc..
   *//**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   *//**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   *//**
   * Trata os erros nas requisicoes (busca e submissao de formulario)
   *//**
   * Funcao executada quando botao "Novo Requerimento" é clicado
   */// competencias = regime => regime.remuneracoes.map(c => ({ ano: c.ano, mes: c.mes }));
},{key:'isDestinatarioRPPS',value:function isDestinatarioRPPS(){if(['novo','realizar-analise'].includes(this.state.acao)){return this.state.requerimento.destinatario&&this.state.requerimento.destinatario.codigo!=='01000'&&this.state.requerimento.destinatario.codigo!==null;}return this.state.requerimento.destinatario&&this.state.requerimento.destinatario.codigo!=='01000';}},{key:'obterMensagens',value:function obterMensagens(dataAbertura){var mensagem=[];mensagem.push({descricao:'A Data de Cria\xE7\xE3o do Requerimento em '+dataAbertura+' n\xE3o ser\xE1 alterada.'});if(this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps'])){mensagem=mensagem.concat(__WEBPACK_IMPORTED_MODULE_20__utils_constants__["b" /* alertaPesquisarDadosPessoais */],__WEBPACK_IMPORTED_MODULE_20__utils_constants__["a" /* alertaPesquisarDadosBeneficio */]);}if(this.props.auth.checkPermission(['analisar-compensacao-rpps','requerer-compensacao-rpps'])){mensagem=mensagem.concat(__WEBPACK_IMPORTED_MODULE_20__utils_constants__["b" /* alertaPesquisarDadosPessoais */]);}return mensagem;}/**
  * Exclui um arquivo da lista
  */// deleteArquivo = (row) => {
//   const { arquivos } = { ...this.state };
//   arquivos.splice(row, 1);
//   this.alteraListaArquivos(arquivos);
// }
},{key:'render',value:function render(){var _this3=this;if(this.state.reset){return null;}if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}var listaAlertas=void 0;var listaExigencias=void 0;var botaoAcaoPrincipal=void 0;var botaoAcaoVoltar=void 0;var botaoAcaoConfirmarIndeferimento=void 0;var botaoRejeitar=void 0;var botaoSalvarERejeitar=void 0;var botaoComplementarAposentadoria=void 0;var configBotaoPrincipal={onClick:this.handleSaveButton};var configBotaoConfirmarIndeferimento={onClick:this.handleSaveButtonConfirmarIndeferimento};var configBotaoSalvarERejeitar={onClick:this.onClickSalvarERejeitarRequerimento};var configBotaoComplementarAposentadoria={onClick:this.handleSaveButton};if(this.state.acao==='cumprir-exigencia'){listaExigencias=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ListaExigencias__["a" /* default */],{exigencias:this.state.requerimento.exigencias});configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Salvar';configBotaoPrincipal.hint='Salvar alterações no requerimento e encerrar exigências atendidas';}if(this.state.acao==='realizar-analise'){configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-compensacao-rgps','analisar-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Finalizar Análise';configBotaoPrincipal.hint='Finalizar a análise do requerimento';listaAlertas=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ListaAlertas__["a" /* default */],{alertas:this.state.requerimento.alertas,open:true});configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];}if(this.state.acao==='emitir-parecer-medico'){configBotaoPrincipal.permissoes=['fornecer-parecer-medico-rpps'];configBotaoPrincipal.titulo='Emitir parecer';configBotaoPrincipal.hint='Emitir parecer do médico perito';}if(this.state.acao==='qualificar'){configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Qualificar';configBotaoPrincipal.hint='Qualificar requerimento';}if(this.state.acao==='indeferidos'){listaAlertas=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ListaAlertas__["a" /* default */],{alertas:this.obterMensagens(this.state.requerimento.dataAberturaRequerimento),open:true});configBotaoPrincipal.permissoes=['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rpps'];configBotaoPrincipal.titulo='Reabrir requerimento';configBotaoPrincipal.hint='Reabrir requerimento';configBotaoConfirmarIndeferimento.permissoes=['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rpps'];configBotaoConfirmarIndeferimento.titulo='Confirmar Indeferimento';configBotaoConfirmarIndeferimento.hint='Confirmar Indeferimento do requerimento';}if(this.state.acao==='novo'){if(this.state.estadoFormulario==='criado'){configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Novo';configBotaoPrincipal.hint='Criar novo requerimento';configBotaoPrincipal.onClick=this.handleNewButton;}else{configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Salvar';configBotaoPrincipal.hint='Salvar requerimento';configBotaoSalvarERejeitar.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps'];configBotaoSalvarERejeitar.titulo='Salvar e rejeitar';configBotaoSalvarERejeitar.hint='Salvar o requerimento e rejeitar';}}else{if((this.state.acao==='consulta'||this.state.acao==='rejeitar')&&this.state.exibirUploadArquivosNaConsulta&&!this.props.temBloqueioAtivoContratoDtp){configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Carregar documento';configBotaoPrincipal.hint='Carregar documento';}if(this.state.acao==='salvarERejeitar'){configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Salvar';configBotaoPrincipal.hint='Salvar requerimento';configBotaoSalvarERejeitar.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps'];configBotaoSalvarERejeitar.titulo='Salvar e rejeitar';configBotaoSalvarERejeitar.hint='Salvar o requerimento e rejeitar';}}if(this.state.acao==='complementar-aposentadoria'){configBotaoComplementarAposentadoria.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps'];configBotaoComplementarAposentadoria.titulo='Complementar';configBotaoComplementarAposentadoria.hint='Complementar requerimento';}botaoAcaoVoltar=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_index__["a" /* Button */],{className:'left',onClick:this.props.history.goBack,title:'Voltar',hint:'Voltar para tela anterior'});if(configBotaoPrincipal.titulo){if(this.state.acao==='salvarERejeitar'||this.state.acao!=='qualificar'&&this.state.acao!=='consulta'||this.state.acao==='qualificar'&&this.props.qualificacaoHabilitada||this.state.acao==='consulta'&&this.state.exibirUploadArquivosNaConsulta){botaoAcaoPrincipal=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:configBotaoPrincipal.permissoes},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:configBotaoPrincipal.titulo,onClick:configBotaoPrincipal.onClick,hint:configBotaoPrincipal.hint}));}}if(configBotaoSalvarERejeitar.titulo){if(this.state.acao==='novo'||this.state.acao==='salvarERejeitar'){botaoSalvarERejeitar=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:configBotaoSalvarERejeitar.permissoes},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:configBotaoSalvarERejeitar.titulo,onClick:configBotaoSalvarERejeitar.onClick,hint:configBotaoSalvarERejeitar.hint}));}}if(this.exibirBotaoRejeicao()){botaoRejeitar=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_index__["a" /* Button */],{className:'dtp-primary right',title:'Rejeitar requerimento',onClick:this.onClickRejeitarRequerimento,hint:'Rejeitar'});}if(configBotaoConfirmarIndeferimento.titulo&&this.state.acao==='indeferidos'){botaoAcaoConfirmarIndeferimento=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:configBotaoPrincipal.permissoes},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_index__["a" /* Button */],{className:'dtp-btn right',title:configBotaoConfirmarIndeferimento.titulo,onClick:configBotaoConfirmarIndeferimento.onClick,hint:configBotaoConfirmarIndeferimento.hint}));}if(configBotaoComplementarAposentadoria.titulo&&this.state.acao==='complementar-aposentadoria'){botaoComplementarAposentadoria=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:configBotaoComplementarAposentadoria.permissoes},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:configBotaoComplementarAposentadoria.titulo,onClick:configBotaoComplementarAposentadoria.onClick,hint:configBotaoComplementarAposentadoria.hint}));}var modalAlerta=void 0;if(this.state.showModalAlerta){modalAlerta=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.confirmSendData,handleModal:this.handleFechamentoModalAlerta,showModal:true});}var modalAlertaRequerimentosPeriodos=void 0;if(this.state.showModalAlertaRequerimentosPeriodos){modalAlertaRequerimentosPeriodos=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.substituirRequerimentosPeriodos,handleModal:this.handleFechamentoModalAlertaRequerimentosPeriodos,labelTitulo:'substituir per\xEDodos do requerimento',labelBotaoConfirmarAcao:'sim',labelBotaoCancelarAcao:'n\xE3o',showModal:true});}var modalAlertaRequerPerConcomitancia=void 0;if(this.state.showModalAlertaRequerPerConcomitancia){modalAlertaRequerPerConcomitancia=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.handleSaveButton,handleModal:this.handleFechamentoModalAlertaRequerPerConcomitancia,labelTitulo:'Salvar requerimento com conflitos de per\xEDodos ?',labelBotaoConfirmarAcao:'sim',labelBotaoCancelarAcao:'n\xE3o',showModal:true});}var modalRejeicaoRequerimento=void 0;if(this.state.showRejeicaoRequerimentoModal){modalRejeicaoRequerimento=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__consultas_Exigencia_ModalRejeicaoRequerimento__["a" /* default */],{acao:this.state.acao,protocolo:this.state.requerimento.protocolo,requerimento:this.state.requerimento,handleModal:function handleModal(){return _this3.handleModalRejeicaoRequerimento();},showModal:true,tipoRequerimento:this.state.tipoRequerimento,handleRejeicaoRequerimentoSent:this.handleRejeicaoRequerimentoSent,handleSalvarERejeitar:this.atualizarMotivoRejeicao,rejeitar:this.state.rejeitar});}var modalAlertaCtcNaoEncontrada=void 0;if(this.state.showModalAlertaCtcNaoEncontrada){modalAlertaCtcNaoEncontrada=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ModalAlerta__["a" /* default */],{alertas:[{descricao:__WEBPACK_IMPORTED_MODULE_20__utils_constants__["h" /* msgCtcNaoEncontrada */].descricao}],aceitar:this.handleFechamentoModalCtcNaoEncontrada,handleModal:this.handleFechamentoModalCtcNaoEncontrada,labelTitulo:'CTC n\xE3o encontrada.',labelBotaoConfirmarAcao:'ok',esconderBotaoCancelar:true,showModal:true});}var modalAlertaReqAprovadoSemDataIngresso=void 0;if(this.state.showModalAlertaReqAprovadoSemDataIngresso){modalAlertaReqAprovadoSemDataIngresso=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ModalAlerta__["a" /* default */],{alertas:[{descricao:''+__WEBPACK_IMPORTED_MODULE_20__utils_constants__["j" /* msgReqAprovadoSemDataIngresso */].descricao1.texto1+__WEBPACK_IMPORTED_MODULE_20__utils_constants__["j" /* msgReqAprovadoSemDataIngresso */].descricao2.texto2}],aceitar:this.handleFechamentoModalAlertaReqAprovadoSemData,handleModal:this.handleFechamentoModalAlertaReqAprovadoSemData,labelTitulo:'Requerimento existente.',labelBotaoConfirmarAcao:'ok',esconderBotaoCancelar:true,showModal:true});}var modalRecalcularTempoRO=void 0;if(this.state.showModalRecalcularTempoRO){modalRecalcularTempoRO=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__ModalTempoRO__["a" /* default */],{alertas:[{descricao:this.state.requerimento.requerimentoPeriodos.length>0?__WEBPACK_IMPORTED_MODULE_20__utils_constants__["i" /* msgRecalcularTempoRO */].descricaoComPeriodos.descricao:__WEBPACK_IMPORTED_MODULE_20__utils_constants__["i" /* msgRecalcularTempoRO */].descricaoSemPeriodos.descricao}],aceitar:this.recalcularTempoRO,handleModal:this.handleModalRecalcularTempoRO,labelTitulo:'Substituir tempo Contribui\xE7\xE3o no Regime de Origem (dias).'//labelBotaoConfirmarAcao="Aceitar"
//labelBotaoCancelarAcao="Cancelar"
,showModal:true});}var retorno=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_dtp_react_components__["j" /* DtpContentContainer */],null,listaAlertas,listaExigencias,this.montaCorpoRequerimento(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},this.state.exibirBotaoVoltar?botaoAcaoVoltar:'',botaoAcaoPrincipal,botaoSalvarERejeitar,botaoRejeitar,botaoAcaoConfirmarIndeferimento,botaoComplementarAposentadoria),modalAlerta,modalRejeicaoRequerimento,modalAlertaRequerimentosPeriodos,modalAlertaRequerPerConcomitancia,modalAlertaCtcNaoEncontrada,modalAlertaReqAprovadoSemDataIngresso,modalRecalcularTempoRO);return retorno;}}]);return RequerimentoAposentadoria;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);RequerimentoAposentadoria.propTypes={match:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.function}).isRequired,tiposDocumentos:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string})),arquivos:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string})),auth:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func}),destinatarios:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf({label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,tipoRegimeProprio:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number}).isRequired,qualificacaoHabilitada:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,temBloqueioAtivoContratoDtp:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,// motivosCessacaoRequerimentoAposentadoria: PropTypes.arrayOf(PropTypes.shape({
//   value: PropTypes.string,
//   label: PropTypes.string,
// })),
motivosCessacao:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string}))};RequerimentoAposentadoria.defaultProps={match:null,tiposDocumentos:[],auth:null,arquivos:null,// motivosCessacaoRequerimentoAposentadoria: null,
motivosCessacao:null};var mapStateToProps=function mapStateToProps(state){return{tiposDocumentos:state.base.tiposDocumentos,destinatarios:state.base.destinatarios,qualificacaoHabilitada:state.base.configuracoesFrontend.habilitarQualificacao,temBloqueioAtivoContratoDtp:state.base.configuracoesFrontend.temBloqueioAtivoContratoDtp,requerimentoPeriodos:state.base.requerimentoPeriodos,// motivosCessacaoRequerimentoAposentadoria: state.base.motivosCessacaoRequerimentoAposentadoria,
motivosCessacao:state.base.motivosCessacao};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(RequerimentoAposentadoria));

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(500);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 500 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
Object.defineProperty(exports, "__esModule", { value: true });
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */
    return typeof obj === 'object' && !('toString' in obj) ?
        Object.prototype.toString.call(obj).slice(8, -1) :
        obj;
}
var isProduction = typeof process === 'object' && "production" === 'production';
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */
        if (isProduction) {
            throw new Error('Invariant failed');
        }
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ (function (target, source) {
    getAllKeys(source).forEach(function (key) {
        if (hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    });
    return target;
});
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function'
    ? function (obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)); }
    /* istanbul ignore next */
    : function (obj) { return Object.keys(obj); };
function copy(object) {
    return Array.isArray(object)
        ? assign(object.constructor(object.length), object)
        : (type(object) === 'Map')
            ? new Map(object)
            : (type(object) === 'Set')
                ? new Set(object)
                : (object && typeof object === 'object')
                    ? assign(Object.create(Object.getPrototypeOf(object)), object)
                    /* istanbul ignore next */
                    : object;
}
var Context = /** @class */ (function () {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function (x, y) { return x === y; };
        this.update.newContext = function () { return new Context().update; };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function () {
            return this.update.isEquals;
        },
        set: function (value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function (directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function (object, $spec) {
        var _this = this;
        var spec = (typeof $spec === 'function') ? { $apply: $spec } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) {
            invariant(!Array.isArray(spec), function () { return "update(): You provided an invalid spec to update(). The spec may " +
                "not contain an array except as the value of $set, $push, $unshift, " +
                "$splice or any custom command allowing an array value."; });
        }
        invariant(typeof spec === 'object' && spec !== null, function () { return "update(): You provided an invalid spec to update(). The spec and " +
            "every included key path must be plain objects containing one of the " +
            ("following commands: " + Object.keys(_this.commands).join(', ') + "."); });
        var nextObject = object;
        getAllKeys(spec).forEach(function (key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) {
                    nextObject = object;
                }
            }
            else {
                var nextValueForKey = type(object) === 'Map'
                    ? _this.update(object.get(key), spec[key])
                    : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map'
                    ? nextObject.get(key)
                    : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue)
                    || typeof nextValueForKey === 'undefined'
                        && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) {
                        nextObject = copy(object);
                    }
                    if (type(nextObject) === 'Map') {
                        nextObject.set(key, nextValueForKey);
                    }
                    else {
                        nextObject[key] = nextValueForKey;
                    }
                }
            }
        });
        return nextObject;
    };
    return Context;
}());
exports.Context = Context;
var defaultCommands = {
    $push: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function (value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function (args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) {
                nextObject = copy(originalObject);
            }
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function (value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function (targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function (target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function (value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function (key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function (values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') {
            values.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (nextObject === originalObject && nextObject.get(key) !== value) {
                    nextObject = copy(originalObject);
                }
                nextObject.set(key, value);
            });
        }
        else {
            values.forEach(function (value) {
                if (nextObject === originalObject && !nextObject.has(value)) {
                    nextObject = copy(originalObject);
                }
                nextObject.add(value);
            });
        }
        return nextObject;
    },
    $remove: function (value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function (key) {
            if (nextObject === originalObject && nextObject.has(key)) {
                nextObject = copy(originalObject);
            }
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function (value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function (key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function (value, original) {
        invariantApply(value);
        return value(original);
    },
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function () { return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + "."; });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function () { return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " +
        "Did you forget to wrap your parameter in an array?"; });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function () { return "Expected $splice target to be an array; got " + stringifiable(value); });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function () { return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " +
        "Did you forget to wrap your parameters in an array?"; });
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', function () { return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + "."; });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function () { return "Cannot have more than one key in an object with $set"; });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === 'object', function () { return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue); });
    invariant(target && typeof target === 'object', function () { return "update(): $merge expects a target of type 'object'; got " + stringifiable(target); });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', function () { return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget); });
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191)))

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = promiseMiddleware;

var _isPromise = _interopRequireDefault(__webpack_require__(503));

var _fluxStandardAction = __webpack_require__(504);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function promiseMiddleware(_ref) {
  var dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (!(0, _fluxStandardAction.isFSA)(action)) {
        return (0, _isPromise.default)(action) ? action.then(dispatch) : next(action);
      }

      return (0, _isPromise.default)(action.payload) ? action.payload.then(function (result) {
        return dispatch(_objectSpread({}, action, {
          payload: result
        }));
      }).catch(function (error) {
        dispatch(_objectSpread({}, action, {
          payload: error,
          error: true
        }));
        return Promise.reject(error);
      }) : next(action);
    };
  };
}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isString2 = __webpack_require__(505);

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = __webpack_require__(511);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFSA(action) {
  return (0, _isPlainObject3.default)(action) && (0, _isString3.default)(action.type) && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return isFSA(action) && action.error === true;
}

function isValidKey(key) {
  return ['type', 'payload', 'error', 'meta'].indexOf(key) > -1;
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(192),
    isArray = __webpack_require__(510),
    isObjectLike = __webpack_require__(194);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(507);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(193);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 509 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 510 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(192),
    getPrototype = __webpack_require__(512),
    isObjectLike = __webpack_require__(194);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(513);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 513 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var INITIAL_STATE={showLoading:false,destinatarios:[],tiposDocumentos:[],exigencias:[],motivosIndeferimento:[],motivosSuspensao:[],motivosCessacao:[],motivosNaoCumprimento:[],motivosRejeicao:[],valoresMediosBeneficios:[],motivosCessacaoRequerimentoAposentadoria:[],motivosCessacaoRequerimentoPensao:[],motivosCessacaoDependente:[],periodosVigencia:[],relEntidadesUoInss:[],competenciaAberta:null,entesControlados:[],enteDoUsuario:null,solicitanteRequerimento:null,orgaosCentralizados:[],listaMensagens:[],abrangenciasEntidadeParticipanteRPPS:[],filtroBloqueio:null,complementoTitulo:null,motivosIndeferimentoRelatorio:[],motivosSuspensaoRelatorio:[],motivosCessacaoRelatorio:[],exigenciasRelatorio:[],estadosSimulacaoCompensacao:[],configuracoesFrontend:null};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case'SHOW_LOADING':return Object.assign({},state,{showLoading:action.payload});case'SALVA_DESTINATARIOS':return Object.assign({},state,{destinatarios:action.payload});case'SALVA_TIPOS_DOCUMENTOS':return Object.assign({},state,{tiposDocumentos:action.payload});case'SALVA_EXIGENCIAS':return Object.assign({},state,{exigencias:action.payload});case'SALVA_MOTIVOS_INDEFERIMENTO':return Object.assign({},state,{motivosIndeferimento:action.payload});case'SALVA_MOTIVOS_SUSPENSAO':return Object.assign({},state,{motivosSuspensao:action.payload});case'SALVA_MOTIVOS_REJEICAO':return Object.assign({},state,{motivosRejeicao:action.payload});case'SALVA_MOTIVOS_CESSACAO':return Object.assign({},state,{motivosCessacao:action.payload});case'SALVA_MOTIVOS_NAO_CUMPRIMENTO':return Object.assign({},state,{motivosNaoCumprimento:action.payload});case'SALVA_VALORES_MEDIOS_BENEFICIOS':return Object.assign({},state,{valoresMediosBeneficios:action.payload});case'SALVA_MOTIVOS_CESSACAO_REQUERIMENTO_APOSENTADORIA':return Object.assign({},state,{motivosCessacaoRequerimentoAposentadoria:action.payload});case'SALVA_MOTIVOS_CESSACAO_REQUERIMENTO_PENSAO':return Object.assign({},state,{motivosCessacaoRequerimentoPensao:action.payload});case'SALVA_MOTIVOS_CESSACAO_DEPENDENTE':return Object.assign({},state,{motivosCessacaoDependente:action.payload});case'SALVA_PERIODOS_VIGENCIA':return Object.assign({},state,{periodosVigencia:action.payload});case'APAGA_PERIODOS_VIGENCIA':return Object.assign({},state,{periodosVigencia:action.payload});case'SALVA_COMPETENCIA_ABERTA':return Object.assign({},state,{competenciaAberta:action.payload});case'SALVA_ENTES_CONTROLADOS':return Object.assign({},state,{entesControlados:action.payload.centralizados?action.payload.centralizados:[],enteDoUsuario:{codigo:action.payload.codigo,nome:action.payload.nome}});case'ALTERA_SOLICITANTE_REQUERIMENTO':return Object.assign({},state,{solicitanteRequerimento:action.payload});case'SALVA_ORGAOS_CENTRALIZADOS':return Object.assign({},state,{orgaosCentralizados:action.payload});case'SALVA_CONFIGURACOES_DE_FRONTEND':return Object.assign({},state,{configuracoesFrontend:action.payload,listaMensagens:action.payload.listaMensagens});case'SALVA_ABRANGENCIAS_ENT_PARTIC_RPPS':return Object.assign({},state,{abrangenciasEntidadeParticipanteRPPS:action.payload});case'APAGA_ABRANGENCIAS_ENT_PARTIC_RPPS':return Object.assign({},state,{abrangenciasEntidadeParticipanteRPPS:action.payload});case'SALVAR_LISTA_MENSAGENS':return Object.assign({},state,{listaMensagens:action.payload});case'SALVA_FILTRO_BLOQUEIO':return Object.assign({},state,{filtroBloqueio:action.payload});case'APAGA_FILTRO_BLOQUEIO':return Object.assign({},state,{filtroBloqueio:action.payload});case'SALVA_COMPLEMENTO_TITULO':return Object.assign({},state,{complementoTitulo:action.payload});case'APAGA_COMPLEMENTO_TITULO':return Object.assign({},state,{complementoTitulo:action.payload});case'SALVA_MOTIVOS_INDEFERIMENTO_RELATORIO':return Object.assign({},state,{motivosIndeferimentoRelatorio:action.payload});case'SALVA_MOTIVOS_SUSPENSAO_RELATORIO':return Object.assign({},state,{motivosSuspensaoRelatorio:action.payload});case'SALVA_MOTIVOS_CESSACAO_RELATORIO':return Object.assign({},state,{motivosCessacaoRelatorio:action.payload});case'SALVA_EXIGENCIAS_RELATORIO':return Object.assign({},state,{exigenciasRelatorio:action.payload});case'SALVA_ESTADOS_SIMULACAO_COMPENSACAO':return Object.assign({},state,{estadosSimulacaoCompensacao:action.payload});default:return state;}});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var INITIAL_STATE={listaGlosas:[]};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case'GLOSA_RECEBER_GOLSAS_DE_ENTE':return Object.assign({},state,{listaGlosas:action.payload});case'GLOSA_RECEBER_GOLSA':return Object.assign({},state,{glosa:action.payload});default:return state;}});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComponentesAutenticacao_utils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_User__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var appInfo={firstName:'Comprev',lastName:null,owner:'Compensação Previdenciária'};var naoPossuiLotacao='Lotação não informada';var Header=function(_Component){_inherits(Header,_Component);function Header(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Header);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Header.__proto__||Object.getPrototypeOf(Header)).call.apply(_ref,[this].concat(args))),_this),_this.getPapel=function(role){var array='';if(role.indexOf('|PA|')!==-1){array=role.split('|');}var papel='';for(var i=0,tam=array.length;i<tam;i+=1){if(array[i]==='PA'){papel=array[i+1];break;}}return papel;},_this.getLotacao=function(roles){var array='';var lotacao=[];roles.forEach(function(role){var eNovo=role.match(/TD/g);var temPA=role.indexOf('|PA|')!==-1;if(temPA&&eNovo){array=role.split('|');for(var i=0,tam=array.length;i<tam;i+=1){if(array[i]==='TD'){lotacao.push(array[i+3]);break;}}}});return lotacao;},_this.getPapeis=function(roles){var array='';var papeis=[];roles.forEach(function(role){var temPA=role.indexOf('|PA|')!==-1;if(temPA){array=role.split('|');for(var i=0,tam=array.length;i<tam;i+=1){if(array[i]==='PA'){papeis.push(array[i+1]);break;}}}});return papeis;},_this.getUserDataForHeader=function(){if(_this.props.userData){var papelUsuario='';var lotacaoUsuario='';var papeisUsuarios='';var infoUsuario='';if(_this.props.userData.roles){papeisUsuarios=_this.getPapeis(_this.props.userData.roles);lotacaoUsuario=_this.getLotacao(_this.props.userData.roles);if(papeisUsuarios.length>0){for(var i=0,tam=papeisUsuarios.length;i<tam;i+=1){papelUsuario=papelUsuario+'\n'+papeisUsuarios[i];}}var primParte=[];var segParte=[];if(lotacaoUsuario.length>0){if(lotacaoUsuario[0].indexOf('#')!==-1){var arrayLotacao=lotacaoUsuario[0].split('#');primParte.push(arrayLotacao[0]);segParte.push(arrayLotacao[1]);lotacaoUsuario=primParte[0]+'\n'+segParte[0];}}else{lotacaoUsuario=naoPossuiLotacao;}infoUsuario=(papelUsuario+'\n'+lotacaoUsuario).trim();if(infoUsuario.length>36){var primParteInfo=[];var segParteInfo=[];if(infoUsuario.indexOf('@')!==-1){var array=infoUsuario.split('@');primParteInfo.push(array[0]);primParteInfo=primParteInfo+'@';segParteInfo.push(array[1]);}var texto=primParteInfo+'\n'+segParteInfo;infoUsuario=texto.trim();}}if(_this.props.userData.lotacoes.length===0){_this.props.userData.lotacoes.push('naoUsada');}return{firstName:_this.props.userData.givenName,document:{label:'CPF',number:_this.props.userData.prevCpf},information:infoUsuario};}return null;},_this.doLogout=function(){__WEBPACK_IMPORTED_MODULE_5__ComponentesAutenticacao_utils__["d" /* logout */]();var _window$comprevConfig=window.comprevConfig,comprevCasUrl=_window$comprevConfig.comprevCasUrl,comprevBaseUrl=_window$comprevConfig.comprevBaseUrl;window.open(comprevCasUrl+'/logout?url='+comprevBaseUrl,'_self');},_this.doLogin=function(){var _window$comprevConfig2=window.comprevConfig,comprevCasUrl=_window$comprevConfig2.comprevCasUrl,comprevBaseUrl=_window$comprevConfig2.comprevBaseUrl;var casClientId=window.comprevConfig.casClientId;if(sessionStorage.getItem('comprevConfigLogotipo')){var logotipoJson={exibirLogo:0};window.comprevConfigLogotipo=logotipoJson;sessionStorage.setItem('comprevConfigLogotipo',JSON.stringify(logotipoJson));}window.open(comprevCasUrl+'/oauth2.0/authorize?client_id='+casClientId+'&response_type=token&redirect_uri='+comprevBaseUrl,'_self');},_this.handleMenu=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["t" /* DtpMenu */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'In\xEDcio',key:1,active:_this.isFirstPage(),path:'/'}),__WEBPACK_IMPORTED_MODULE_6__domain_User__["a" /* default */].logged()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.estaComBloqueioAtivoContratoDtp()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["u" /* DtpMenuDropdown */],{label:'Requerimento',key:2,active:_this.isMenuItemActive('requerimento')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Aposentadoria',key:2.1,active:_this.isMenuItemActive('requerimento/aposentadoria/novo'),path:'/requerimento/aposentadoria/novo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Pens\xE3o',key:2.2,active:_this.isMenuItemActive('requerimento/pensao/novo'),path:'/requerimento/pensao/novo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['requerer-compensacao-rpps','analisar-compensacao-rpps']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Complementa\xE7\xE3o',key:2.3,active:_this.isMenuItemActive('/consulta/complementar-aposentadoria/rpps',true),path:'/consulta/complementar-aposentadoria/rpps'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['requerer-compensacao-rgps','gerenciar-negocio-dcomp']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["u" /* DtpMenuDropdown */],{label:'Exig\xEAncia',key:3,active:_this.isMenuItemActive('exigencia')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Prazo',key:3.1,active:_this.isMenuItemActive('/consulta/exigencia/rgps',true),path:'/consulta/exigencia/rgps'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Prescri\xE7\xE3o',key:3.2,active:_this.isMenuItemActive('/consulta/prescricao-exigencia/rgps',true),path:'/consulta/prescricao-exigencia/rgps'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Indeferido',key:3.3,active:_this.isMenuItemActive('exigencia',true),path:'/exigencia/indeferidos/rgps'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['requerer-compensacao-rpps']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["u" /* DtpMenuDropdown */],{label:'Exig\xEAncia',key:3,active:_this.isMenuItemActive('exigencia')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Prazo',key:3.1,active:_this.isMenuItemActive('/consulta/exigencia/rpps',true),path:'/consulta/exigencia/rpps'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Prescri\xE7\xE3o',key:3.2,active:_this.isMenuItemActive('/consulta/prescricao-exigencia/rpps',true),path:'/consulta/prescricao-exigencia/rpps'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Indeferido',key:3.3,active:_this.isMenuItemActive('exigencia',true),path:'/exigencia/indeferidos/rpps'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-compensacao-rgps']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'An\xE1lise',key:4,active:_this.isMenuItemActive('/consulta/analise',true),path:'/consulta/analise/rgps'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['requerer-compensacao-rpps','gerenciar-negocio-dcomp']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["u" /* DtpMenuDropdown */],{label:'An\xE1lise',key:4,active:_this.isMenuItemActive('/consulta/analise',true)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'RGPS',key:4.1,active:_this.isMenuItemActive('/consulta/analise/rgps',true),path:'/consulta/analise/rgps'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'RPPS',key:4.2,active:_this.isMenuItemActive('/consulta/analise/rpps',true),path:'/consulta/analise/rpps'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['fornecer-parecer-medico-rpps']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Parecer M\xE9dico',key:5,active:_this.isMenuItemActive('/consulta/parecer-medico',true),path:'/consulta/parecer-medico/rpps'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','auditar-comprev','analisar-negocio-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Consulta',key:6,active:_this.isMenuItemActive('/consulta/rgps',true),path:'/consulta/rgps'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-compensacao-rpps','consultar-compensacao-rpps']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Consulta',key:6,active:_this.isMenuItemActive('/consulta/rpps',true),path:'/consulta/rpps'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-negocio-sprev','requerer-compensacao-rpps','analisar-compensacao-rpps','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','auditar-comprev','analisar-negocio-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["u" /* DtpMenuDropdown */],{label:'Cadastro',key:7,active:_this.isMenuItemActive('cadastros')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'M\xE9dia RGPS',key:7.1,active:_this.isMenuItemActive('/cadastros/valoresMediosBeneficios/novo'),path:'/cadastros/valoresMediosBeneficios/novo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Regime Pr\xF3prio de Previd\xEAncia (RPPS)',key:7.2,active:_this.isMenuItemActive('/consultaEnteFederativo/consulta-rpps'),path:'/consultaEnteFederativo/consulta-rpps'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-negocio-sprev','analisar-negocio-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Org\xE3os Vinculados da Uni\xE3o',key:7.3,active:_this.isMenuItemActive('/cadastros/OrgaosVinculadosUniao'),path:'/cadastros/OrgaosVinculadosUniao'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Per\xEDodos RPPS da Uni\xE3o',key:7.4,active:_this.isMenuItemActive('/cadastros/PeriodosRppsUniao'),path:'/cadastros/PeriodosRppsUniao'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['requerer-compensacao-rgps','analisar-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','analisar-contrato-dtpv','analisar-negocio-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["u" /* DtpMenuDropdown */],{label:'Pagamento',key:8,active:_this.isMenuItemActive('pagamento')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['requerer-compensacao-rgps','analisar-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Cessa\xE7\xE3o Manual',key:8.1,active:_this.isMenuItemActive('/consultaCessacaoRequerimento/cessacao-requerimento'),path:'/consultaCessacaoRequerimento/cessacao-requerimento'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['gerenciar-negocio-dcomp','analisar-negocio-sprev','analisar-contrato-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Bloqueio e Desbloqueio de Entes Federativos',key:8.2,active:_this.isMenuItemActive('/consultaBloqueio/bloqueio'),path:'/consultaBloqueio/bloqueio'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['gerenciar-negocio-dcomp']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Glosa de Da\xE7\xE3o',key:8.3,active:_this.isMenuItemActive('/consultaGlosaDeDacao/consulta-glosa'),path:'/consultaGlosaDeDacao/consulta-glosa'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['gerenciar-negocio-dcomp']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Fechamento de Pagamentos',key:8.4,active:_this.isMenuItemActive('/consulta/consultaPagamentos',true),path:'/consulta/consultaPagamentos'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['gerenciar-negocio-dcomp','requerer-compensacao-rpps','analisar-compensacao-rpps','auditar-comprev','analisar-negocio-sprev','analisar-negocio-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Controle de Pagamentos',key:8.5,active:_this.isMenuItemActive('/controledepagamentos/home/controle-pagamentos',true),path:'/controledepagamentos/home/controle-pagamentos'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-negocio-sprev']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Cronograma de Pagamento',key:8.6,active:_this.isMenuItemActive('/cadastros/cronogramaPagamento',true),path:'/cadastros/cronogramaPagamento'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['gerenciar-negocio-dcomp','requerer-compensacao-rpps','analisar-compensacao-rpps','auditar-comprev','analisar-negocio-sprev','analisar-negocio-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Controle de D\xE9bitos Carregados RGPS',key:8.7,active:_this.isMenuItemActive('/controledepagamentos/home/controle-debitos-pendentes',true),path:'/controledepagamentos/home/controle-debitos-pendentes'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['gerenciar-negocio-dcomp','requerer-compensacao-rpps','analisar-compensacao-rpps','auditar-comprev','analisar-negocio-sprev','analisar-negocio-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Pend\xEAncias',key:8.8,active:_this.isMenuItemActive('/controledepagamentos/home/pendencias',true),path:'/controledepagamentos/home/pendencias'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-compensacao-rgps','analisar-negocio-sprev','gerenciar-negocio-dcomp','auditar-comprev','analisar-negocio-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["u" /* DtpMenuDropdown */],{label:'Gerencial',key:9,active:_this.isMenuItemActive('gerencial')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-compensacao-rgps','gerenciar-negocio-dcomp','analisar-negocio-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Consulta Fila Migra\xE7\xE3o do PRISMA',key:9.1,active:_this.isMenuItemActive('/consultaPrisma/consulta-prisma'),path:'/consultaPrisma/consulta-prisma'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-negocio-sprev','gerenciar-negocio-dcomp','auditar-comprev','analisar-negocio-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Consulta por Tipo de Auditoria',key:9.2,active:_this.isMenuItemActive('/consultaAuditoria/auditoria',true),path:'/consultaAuditoria/auditoria'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-negocio-dtpv','analisar-compensacao-rgps','gerenciar-negocio-dcomp','analisar-negocio-sprev']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Consulta Fila do GET',key:9.3,active:_this.isMenuItemActive('/consultaPrisma/consulta-prisma'),path:'/consultaFilaGet/consulta-filaget'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-negocio-dtpv','analisar-compensacao-rgps','gerenciar-negocio-dcomp']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Consulta Opera\xE7\xF5es com o GET',key:9.4,active:_this.isMenuItemActive('/consultaOperacoesGet/consulta-operacoes-get'),path:'/consultaOperacoesGet/consulta-operacoes-get'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-negocio-dtpv','analisar-negocio-sprev']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Mensagens',key:9.4,active:_this.isMenuItemActive('/mensagens/novo'),path:'/mensagens/novo'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','auditar-comprev','analisar-negocio-dtpv']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["u" /* DtpMenuDropdown */],{label:'Relat\xF3rios',key:10,id:'Relatorios'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Pagamentos',key:10.1,active:_this.isMenuItemActive('/relatorios/pagamentos',true),path:'/relatorios/pagamentos'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Requerimentos (Totalizadores por Estados)',key:10.2,active:_this.isMenuItemActive('/relatorios/totalizador/estados',true),path:'/relatorios/totalizador/estados'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Requerimentos (Anal\xEDtico)',key:10.3,active:_this.isMenuItemActive('/relatorios/estado/tipo',true),path:'/relatorios/estado/tipo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Exig\xEAncias',key:10.4,active:_this.isMenuItemActive('/relatorios/estado/exigencias',true),path:'/relatorios/estado/exigencias'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Exig\xEAncias (Anal\xEDtico)',key:10.5,active:_this.isMenuItemActive('/relatorios/estado/exigencias',true),path:'/relatorios/estado/exigencias/analitico'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-negocio-sprev','analisar-negocio-dtpv','gerenciar-negocio-dcomp','analisar-compensacao-rpps','consultar-compensacao-rpps']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Simula\xE7\xE3o de Compensa\xE7\xE3o',key:10.6,active:_this.isMenuItemActive('/relatorios/simulacaocompensacao',true),path:'/relatorios/simulacaocompensacao'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Conflitos de Per\xEDodos',key:10.7,active:_this.isMenuItemActive('/relatorios/conflito-periodos',true),path:'/relatorios/conflito-periodos'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp','consultar-compensacao-rgps','consultar-compensacao-rpps','auditar-comprev','analisar-negocio-dtpv','analisar-contrato-dtpv','fornecer-parecer-medico-rpps']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["u" /* DtpMenuDropdown */],{label:'Ferramentas',key:11,id:'Ferramentas'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Acr\xE9scimos Legais',key:11.1,active:_this.isMenuItemActive('/calculadora/acrescimos-legais',true),path:'/calculadora/acrescimos-legais'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Requerimentos por CPF',key:11.2,active:_this.isMenuItemActive('/consulta-cpf/consultacpf',true),path:'/consulta-cpf/consultacpf'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Conversor ano mes dia para dia',key:11.3,active:_this.isMenuItemActive('/conversor-amd/conversor',true),path:'/conversor-amd/conversor'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["v" /* DtpMenuItem */],{label:'Calculadora de Per\xEDodos',key:11.5,active:_this.isMenuItemActive('/calculadora-periodos/calculadoraperiodos',true),path:'/calculadora-periodos/calculadoraperiodos'})))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Header,[{key:'isMenuItemActive',value:function isMenuItemActive(key,isMenuConsulta){if(isMenuConsulta){return this.props.location.pathname===key;}return this.props.location.pathname.search(key)!==-1;}},{key:'isFirstPage',value:function isFirstPage(){var cleanPath=this.props.location.pathname.replace('/','');return cleanPath.length===0;}},{key:'estaComBloqueioAtivoContratoDtp',value:function estaComBloqueioAtivoContratoDtp(){return this.props.configuracoesFrontend&&!this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp;}},{key:'render',value:function render(){var menu=this.handleMenu();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["r" /* DtpHeader */],{appInfo:appInfo,showInfoBarBtn:false,userData:this.getUserDataForHeader(),doLogout:this.doLogout,doLogin:this.doLogin,showUserInfo:true},menu);}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Header.defaultProps={userData:null,configuracoesFrontend:null};Header.propTypes={configuracoesFrontend:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string),// logout: PropType.func.isRequired,
location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string}).isRequired,userData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()};var mapStateToProps=function mapStateToProps(state){return{configuracoesFrontend:state.base.configuracoesFrontend};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(Header));

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var ProtectedItem=function ProtectedItem(props){if(props.auth.checkPermission(props.allowedPermissions)){return props.children;}return null;};/* harmony default export */ __webpack_exports__["a"] = (ProtectedItem);ProtectedItem.defaultProps={allowedPermissions:[]};ProtectedItem.propTypes={allowedPermissions:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string)};

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var recuperarVersaoAtual=function recuperarVersaoAtual(){var versaoAtual=window.comprevConfigVersao.versaoAtual;return versaoAtual;};var footer=function footer(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["n" /* DtpFooter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left text-aviso-padding'},props.mensagem),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right text-versao-padding'},'vers\xE3o ',recuperarVersaoAtual()));};footer.propTypes={mensagem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (footer);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
var Select=function Select(props){var handleChange=function handleChange(e){if(props.onChange){props.onChange(e);}if(props.onBlur){props.onBlur(e);}};// const renderSelectItem = item => ({
//   value: item.value,
//   label: item.label,
// });
// const placeholder = props.placeholder ? ([{
//   value: null,
//   label: props.placeholder,
// }]) : [];
// const listRendered = props.itemList.map(item => renderSelectItem(item));
// placeholder.push(...listRendered);
// const lista = placeholder;
var options=props.itemList.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:item.value},item.label);});if(props.custom){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:props.value!==undefined&&props.value!==null?props.value:'',disabled:props.disabled||props.itemList.length===0,className:'form-control',onChange:function onChange(e){return handleChange(e.target.value);},style:{backgroundColor:'#ffffff',border:'none',borderBottomStyle:'none',borderBottomWidth:'medium',borderBottom:'2px solid #b7c4cb',borderBottomColor:props.value?'#27ae60':'#b7c4cb',borderRadius:'0',boxShadow:'none',color:'#78909c',fontSize:'1.6rem',WebkitAppearance:'none',MozAppearance:'none',textIndent:'1px',textOverflow:'','&::after':{boxShadow:'none',color:'#78909c',borderBottomColor:'#27ae60',borderBottom:'2px solid #27ae60',cursor:'pointer',fontSize:'3rem',fontFamily:'libicons',position:'absolute',WebkitAppearance:'none',MozAppearance:'none',top:'30%',right:'.5rem',content:'"\\E921"',zIndex:'98'}}},!props.disabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},props.placeholder):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),options);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["B" /* DtpSelect */],{custom:props.custom,onSelect:handleChange,placeholder:props.placeholder,value:props.value!==undefined&&props.value!==null?props.value:'',disabled:props.disabled||props.itemList.length===0,items:props.itemList});};Select.defaultProps={custom:false,disabled:false,onBlur:null,placeholder:null,value:null};Select.propTypes={custom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,/** Lista de itens a serem disponibilizados */itemList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired,/** Configura a function a ser chamada ao retirar o foco do input */onBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/** Configura a function a ser chamada para mudanca de valor */onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,/** Label a ser colocado na posicao zero */placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,/** Configura o valor selecionado */value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),// Desativar input
disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.createNumberMask=t():e.createNumberMask=t()}(this,function(){return function(e){function t(n){if(o[n])return o[n].exports;var i=o[n]={exports:{},id:n,loaded:!1};return e[n].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){e.exports=o(2)},,function(e,t){"use strict";function o(){function e(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:l,t=e.length;if(e===l||e[0]===y[0]&&1===t)return y.split(l).concat([v]).concat(g.split(l));if(e===k&&M)return y.split(l).concat(["0",k,v]).concat(g.split(l));var o=e[0]===s&&q;o&&(e=e.toString().substr(1));var c=e.lastIndexOf(k),u=c!==-1,a=void 0,b=void 0,h=void 0;if(e.slice(T*-1)===g&&(e=e.slice(0,T*-1)),u&&(M||$)?(a=e.slice(e.slice(0,R)===y?R:0,c),b=e.slice(c+1,t),b=n(b.replace(f,l))):a=e.slice(0,R)===y?e.slice(R):e,P&&("undefined"==typeof P?"undefined":r(P))===p){var S="."===j?"[.]":""+j,w=(a.match(new RegExp(S,"g"))||[]).length;a=a.slice(0,P+w*Z)}return a=a.replace(f,l),E||(a=a.replace(/^0+(0$|[^0])/,"$1")),a=x?i(a,j):a,h=n(a),(u&&M||$===!0)&&(e[c-1]!==k&&h.push(m),h.push(k,m),b&&(("undefined"==typeof L?"undefined":r(L))===p&&(b=b.slice(0,L)),h=h.concat(b)),$===!0&&e[c-1]===k&&h.push(v)),R>0&&(h=y.split(l).concat(h)),o&&(h.length===R&&h.push(v),h=[d].concat(h)),g.length>0&&(h=h.concat(g.split(l))),h}var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},o=t.prefix,y=void 0===o?c:o,b=t.suffix,g=void 0===b?l:b,h=t.includeThousandsSeparator,x=void 0===h||h,S=t.thousandsSeparatorSymbol,j=void 0===S?u:S,w=t.allowDecimal,M=void 0!==w&&w,N=t.decimalSymbol,k=void 0===N?a:N,D=t.decimalLimit,L=void 0===D?2:D,O=t.requireDecimal,$=void 0!==O&&O,_=t.allowNegative,q=void 0!==_&&_,B=t.allowLeadingZeroes,E=void 0!==B&&B,I=t.integerLimit,P=void 0===I?null:I,R=y&&y.length||0,T=g&&g.length||0,Z=j&&j.length||0;return e.instanceOf="createNumberMask",e}function n(e){return e.split(l).map(function(e){return v.test(e)?v:e})}function i(e,t){return e.replace(/\B(?=(\d{3})+(?!\d))/g,t)}Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var c="$",l="",u=",",a=".",s="-",d=/-/,f=/\D+/g,p="number",v=/\d/,m="[]"}])});

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.createAutoCorrectedDatePipe=t():e.createAutoCorrectedDatePipe=t()}(this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){e.exports=r(1)},function(e,t){"use strict";function r(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"mm dd yyyy",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minYear,i=void 0===r?1:r,d=t.maxYear,u=void 0===d?9999:d,s=e.split(/[^dmyHMS]+/).sort(function(e,t){return o.indexOf(e)-o.indexOf(t)});return function(t){var r=[],o={dd:31,mm:12,yy:99,yyyy:u,HH:23,MM:59,SS:59},d={dd:1,mm:1,yy:0,yyyy:i,HH:0,MM:0,SS:0},a=t.split("");s.forEach(function(t){var n=e.indexOf(t),i=parseInt(o[t].toString().substr(0,1),10);parseInt(a[n],10)>i&&(a[n+1]=a[n],a[n]=0,r.push(n))});var y=0,f=s.some(function(r){var s=e.indexOf(r),a=r.length,f=t.substr(s,a).replace(/\D/g,""),p=parseInt(f,10);"mm"===r&&(y=p||0);var c="dd"===r?n[y]:o[r];if("yyyy"===r&&(1!==i||9999!==u)){var l=parseInt(o[r].toString().substring(0,f.length),10),m=parseInt(d[r].toString().substring(0,f.length),10);return p<m||p>l}return p>c||f.length===a&&p<d[r]});return!f&&{value:a.join(""),indexesOfPipedChars:r}}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[31,31,29,31,30,31,30,31,31,30,31,30,31],o=["yyyy","yy","mm","dd","HH","MM","SS"]}])});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var InputText=function InputText(props){if(props.type==='textarea'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',props);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["o" /* DtpFormControl */],props);};InputText.propTypes={// Boolean para ativar a animação no campo
animate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,// Desativar input
disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,// Label que descreve o campo
label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,// Recebe função para o evento de perda de foco (onBlur)
onBlur:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,// Recebe função para o evento de mudança de caracteres no campo
onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,// Tipo de conteúdo a ser inserido no campo
type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,// Boolean para tornar o campo obrigatório ou não
required:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,// Estado de validacao
validationState:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,// Valor do input
value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};InputText.defaultProps={required:false,type:'text',onBlur:null,onChange:null,animate:false,disabled:false,validationState:'null',value:''};/* harmony default export */ __webpack_exports__["a"] = (InputText);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DatePicker__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validacoes__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Checkbox__ = __webpack_require__(196);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Input=function(_Component){_inherits(Input,_Component);function Input(props){_classCallCheck(this,Input);var _this=_possibleConstructorReturn(this,(Input.__proto__||Object.getPrototypeOf(Input)).call(this,props));_initialiseProps.call(_this);var value=_this.props.value;var validation=_this.checkValidity(value);_this.state={error:!validation.isValid,touched:false};// , validated: validation.validated };
return _this;}_createClass(Input,[{key:'render',value:function render(){var Element=this.pickComponentType();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["q" /* DtpFormGroup */],{className:this.props.required?'required':'',validationState:this.props.validationState?this.props.validationState:this.handleValidationState()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["k" /* DtpControlLabel */],{animate:this.props.animate,label:this.props.check?null:this.props.label}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["p" /* DtpFormControlFeedback */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Element,Object.assign({},this.props,{disabled:this.props.disabled,onBlur:this.handleBlur,onChange:this.handleChange,onKeyUp:this.props.onKeyUp,onKeyDown:this.props.onKeyDown,onFocus:this.props.onFocus,required:this.props.required,type:this.props.type,value:this.handleValueReceived(this.props.value)})),this.props.exibirBotao&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.value?'botao-lapis-segregacao-massa-verde':'botao-lapis-segregacao-massa-cinza'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* Button */],{onClick:this.props.onClickDoBotao,hint:this.props.hintDoBotao,mini:true,icon:this.props.iconeDoBotao,disabled:this.props.disabledBotao,className:this.props.classe?this.props.classe:''})));}}]);return Input;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.getValueInJsonFormat=function(inputValue){var retorno=_this2.props.itemList||_this2.props.date?inputValue:inputValue.target.value;var regexCaracteresEspeciais=new RegExp('[<>!=()*\'\\\\"]','g');if(_this2.props.date){retorno=__WEBPACK_IMPORTED_MODULE_2_moment___default()(inputValue).format('DD/MM/YYYY');}if(_this2.props.integer){retorno=retorno.replace(/\D/g,'');}if(_this2.props.nitElado){var regex=new RegExp('[^0-9,]','g');retorno=retorno.replace(regex,'');}if(_this2.props.currency){var _regex=new RegExp('[^0-9.,]','g');retorno=retorno.replace(_regex,'');if(retorno===','){retorno=retorno.toString().replace(',','');}if(retorno==='.'){retorno=retorno.toString().replace('.','');}retorno=retorno.toLocaleString('pt-BR',{currency:'BRL'});}if(_this2.props.itemList){// se vier a sigla da UF ('RJ','SP')
if(Number.isNaN(parseFloat(retorno))){return retorno;}// se o id da uf iniciar por zero ('02000')
// Estava transformando para numero e perdendo o zero a esquerda
// e então o valor da combobox não ficava marcado.
if(!Number.isInteger(retorno)){if(retorno.substr(0,1)==='0'){return retorno;}}}if(_this2.props.dadosBancarios){retorno=retorno.replace(/\D/g,'');}if(_this2.props.number){if(retorno===''){retorno='';}else{retorno=Number(retorno);}}if(_this2.props.filtroExigencia){retorno=retorno.replace(/\W/g,'');}if(_this2.props.textarea||_this2.props.consultaFilaGet){if(retorno.match(regexCaracteresEspeciais)){retorno=retorno.replace(regexCaracteresEspeciais,'');}}return retorno;};this.getValueFromJsonFormat=function(jsonValue){var retorno=jsonValue;if(_this2.props.date&&!_this2.props.disabled){if(retorno){retorno=__WEBPACK_IMPORTED_MODULE_2_moment___default()(jsonValue,'DD/MM/YYYY').toDate();}else{retorno=undefined;}}if(retorno&&_this2.props.currency){if(typeof jsonValue==='number'){retorno=jsonValue.toFixed(2);}retorno=retorno.toString().replace(/\D/g,'');retorno=retorno.toString().replace(/(\d)(\d{11})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{8})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{5})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{2})$/,'$1,$2');retorno=retorno.toLocaleString('pt-BR',{currency:'BRL'});}if(retorno&&_this2.props.participation){retorno=retorno.toFixed(8).toString().replace(/\./g,',');}return retorno;};this.checkValidity=function(value){var isValid=true;var validated=false;if(_this2.props.required){isValid=Boolean(value)&&value!==null&&(''+value).trim()!==''&&isValid;validated=true;}if(_this2.props.minLength){isValid=Boolean(value)&&value.length>=_this2.props.minLength&&isValid;validated=true;}if(_this2.props.cpf){isValid=Object(__WEBPACK_IMPORTED_MODULE_6__validacoes__["a" /* default */])(value);validated=true;}if(_this2.props.nit){isValid=Boolean(value)&&value.length===11&&isValid;validated=true;}if(_this2.props.currency){isValid=value!==0&&isValid;validated=true;}return{isValid:isValid,validated:validated};};this.handleChange=function(e){var value=null;var validation=true;if(_this2.props.type==='file'){var _e$target$files=_slicedToArray(e.target.files,1);value=_e$target$files[0];}if(_this2.props.check){value=e.target.checked;}else{value=e!==undefined&&e!==null?_this2.getValueInJsonFormat(e):null;validation=_this2.checkValidity(value);}_this2.setState({error:!validation.isValid});if(_this2.props.onChange){_this2.props.onChange({value:value,isValid:validation.isValid});}};this.handleBlur=function(e){var value=e?_this2.getValueInJsonFormat(e):null;var validation=_this2.checkValidity(value);var retorno=value;if(_this2.props.onBlur){_this2.setState({touched:true,error:!validation.isValid},function(){return _this2.props.onBlur(e);});}else{_this2.setState({touched:true,error:!validation.isValid});}if(retorno&&_this2.props.currency){// retorno = retorno.replace(/\./g, '').replace(/,/g, '.');
// retorno = Number(retorno);
_this2.setState({touched:true,error:!validation.isValid},function(){return _this2.props.onChange({value:retorno,isValid:validation.isValid});});}};this.handleValueReceived=function(value){return _this2.getValueFromJsonFormat(value);};this.handleValidationState=function(){if(_this2.props.exibirBotao){return'null';}if(!_this2.state.touched&&!_this2.props.touched){return'null';}if(!_this2.props.error){return'success';}if(_this2.props.error||_this2.state.error){return'error';}return'success';};this.pickComponentType=function(){if(_this2.props.radio){return __WEBPACK_IMPORTED_MODULE_4__index__["o" /* Radio */];}if(_this2.props.itemList){return __WEBPACK_IMPORTED_MODULE_4__index__["r" /* Select */];}if(_this2.props.mask){return __WEBPACK_IMPORTED_MODULE_4__index__["m" /* MaskedInput */];}if(_this2.props.date){return __WEBPACK_IMPORTED_MODULE_5__DatePicker__["a" /* default */];}if(_this2.props.check){return __WEBPACK_IMPORTED_MODULE_7__Checkbox__["a" /* default */];}return __WEBPACK_IMPORTED_MODULE_4__index__["v" /* TextInput */];};};Input.propTypes={// Boolean para ativar a animação no campo
animate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Boolean que indica validacao para regras de cpf
cpf:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Boolean que indica formato financeiro
check:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,currency:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Desativar input
disabled:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Propriedade que indica erro na validacao do campo
error:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Lista para ser renderizada e utilizada para selecionar o tipo de input para select ou radio
itemList:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string})),// Indica que input deve retornar valor inteiro (sem mascara)
integer:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Label que descreve o campo
label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,// Mascara para o input
mask:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string),// Valida input em relacao ao seu tamanho maximo permitido
maxLength:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,// Valida input em relacao ao seu tamanho minimo exigido
minLength:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,// Indica que input deve ser validado com as regras de nit
nit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Indica que input deve ser validado com as regras de nit
nitElado:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Indica que o formato do input no json deve ser numerico
number:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Recebe função para o evento de perda de foco (onBlur)
onBlur:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,// Recebe função para o evento de mudança de caracteres no campo
participation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Boolean para sinalizar se o tipo é radio
radio:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Boolean para sinalizar se o campo é obrigatório ou não
required:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Propriedade utilizada para sinalizar que o input foi utilizado
touched:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Tipo de conteúdo a ser inserido no campo
type:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,// Data
date:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,// Estado de validacao
validationState:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,// Valor do input
value:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,dadosBancarios:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onKeyUp:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onKeyDown:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onFocus:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,exibirBotao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,hintDoBotao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,iconeDoBotao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,onClickDoBotao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,disabledBotao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,classe:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};Input.defaultProps={animate:false,cpf:false,currency:false,disabled:false,error:false,integer:false,itemList:null,mask:null,maxLength:null,minLength:null,nit:false,nitElado:false,number:false,participation:false,radio:false,required:false,touched:false,type:'text',validationState:null,value:'',date:false,dadosBancarios:false,onBlur:null,onChange:null,onKeyDown:null,onKeyUp:null,onFocus:null,exibirBotao:false,disabledBotao:false,hintDoBotao:null,iconeDoBotao:null,onClickDoBotao:null,classe:''};/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MaskedInput__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masks__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DatePicker=function(_Component){_inherits(DatePicker,_Component);function DatePicker(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DatePicker);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DatePicker.__proto__||Object.getPrototypeOf(DatePicker)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(e){_this.props.onChange(e);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DatePicker,[{key:'shouldComponentUpdate',// Metodo para prevenir updates desnecessarios como quando o DtpDatepicker
// chama o handleFocus do DtpForm e desencadeia a renderizacao do componente
// TODO Aprimorar sempre que percebermos um atributo que pode ser alterado via props.
value:function shouldComponentUpdate(nextProps){return this.props.value!==nextProps.value;}},{key:'render',value:function render(){if(this.props.disabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MaskedInput__["a" /* default */],{disabled:true,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,placeholder:'dd/mm/aaaa',value:this.props.value});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["l" /* DtpDatepicker */],{animated:true,date:this.props.value,onChange:this.handleChange});}}]);return DatePicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DatePicker.propTypes={value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date),onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (DatePicker);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(cpfParam){if(!cpfParam){return false;}var cpf=cpfParam.replace(/[^\d]+/g,'');if(cpf===''||cpf.length!==11)return false;// Valida 1o digito
var add=0;for(var i=0;i<9;i+=1){add+=parseInt(cpf.charAt(i),10)*(10-i);}var rev=11-add%11;if(rev===10||rev===11){rev=0;}if(rev!==parseInt(cpf.charAt(9),10)){return false;}// Valida 2o digito
add=0;for(var _i=0;_i<10;_i+=1){add+=parseInt(cpf.charAt(_i),10)*(11-_i);}rev=11-add%11;if(rev===10||rev===11){rev=0;}if(rev!==parseInt(cpf.charAt(10),10)){return false;}return true;});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
var Button=function Button(props){var pickButton=function pickButton(){if(props.icon){if(props.mini){return __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["e" /* DtpButtonFabMini */];}return __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["d" /* DtpButtonFab */];}if(props.flat){return __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["f" /* DtpButtonFlat */];}if(props.many){return __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["C" /* DtpSelectManyButton */];}return __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["c" /* DtpButton */];};var Component=pickButton();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props);};Button.defaultProps={icon:null,mini:false,flat:false,many:false};Button.propTypes={icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mini:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,flat:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,many:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var DataGrid=function DataGrid(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'dtp-datagrid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'dtp-datagrid-header'},props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dtp-datagrid-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dtp-datagrid-icon-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'dtp-datagrid-icon '+props.icon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dtp-datagrid-items-box'},props.children)));};DataGrid.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (DataGrid);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var Table=function Table(props){var tableHeader=props.listaTableHeader.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["I" /* DtpTableHeader */],{dataField:item.id,dataAlign:item.dataAlign?item.dataAlign:'center',width:item.width?item.width:'',isKey:i===0,header:item.label,dataFormat:item.dataFormat// width={i === 0 ? 200 : 120}
});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["H" /* DtpTable */],props,tableHeader);};Table.propTypes={/** Lista contendo ids e nome dos atributos a serem mostrados na tabela */listaTableHeader:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
var Modal=function Modal(props){var modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["w" /* DtpModal */].DtpModalContent,null,props.conteudomodal);var modalFooter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["w" /* DtpModal */].DtpModalFooter,null,props.conteudofooter);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["w" /* DtpModal */],Object.assign({},props,{show:props.showModal}),modalContent,props.conteudofooter&&modalFooter);};Modal.propTypes={// Conteúdo exibido no corpo do modal
conteudomodal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,// Conteúdo exibido na rodapé do modal
conteudofooter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,// Altera o tamanho do modal [Pequeno -> 'sm', Médio -> 'md', Grande -> 'lg']
size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,// Exibe o modal
showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};Modal.defaultProps={size:'lg'};/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
var ListaEncerramentoExigencias=function ListaEncerramentoExigencias(props){if(!props.exigencias||props.exigencias.length===0){return null;}var trataAlteracaoNaExigencia=function trataAlteracaoNaExigencia(e,atributo,tipoExigencia,codigoDependente){props.handlePositionalChange(e,atributo,tipoExigencia,codigoDependente);};var motivosNaoCumprimento=props.motivosNaoCumprimento.map(function(motivo){return motivo;});var montaExigencia=function montaExigencia(exigencia,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,index+1,' - ',exigencia.acao)),exigencia.comentario?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Coment\xE1rio:'),' ',exigencia.comentario):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{number:true,itemList:motivosNaoCumprimento,label:'Motivo de n\xE3o cumprimento'// label={`Motivo de não cumprimento - ${exigencia.codigoDependente}`}
,onChange:function onChange(e){return trataAlteracaoNaExigencia(e,'motivoNaoAtendimento',exigencia.tipo,exigencia.codigoDependente);},placeholder:'Selecione o Motivo',value:exigencia.motivoNaoAtendimento,custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{cols:'74',componentClass:'textarea',label:'Coment\xE1rio para n\xE3o cumprimento'// label={`Comentário para não cumprimento - ${exigencia.codigoDependente}`}
,maxlength:'610',onChange:function onChange(e){return trataAlteracaoNaExigencia(e,'comentarioNaoAtendimento',exigencia.tipo,exigencia.codigoDependente);},rows:'5',value:exigencia.comentarioNaoAtendimento,textarea:true}))));};// Vinicius
var listaExigencias=props.exigencias.map(function(exigencia,index){return montaExigencia(exigencia,index);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,listaExigencias);};ListaEncerramentoExigencias.propTypes={exigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handlePositionalChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,motivosNaoCumprimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ListaEncerramentoExigencias);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
var Title=function Title(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["J" /* DtpTitle */],{title:props.title,type:props.type,fontWeight:props.fontWeight});};Title.propTypes={/** String contendo o texto a ser exibido no título */title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,/** Atributo que define o tipo do título */type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page','section']),/** Espessura da fonte do título */fontWeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['light-34','light-48','light-56','light-72','light-120','semibold-12','semibold-14','semibold-15','semibold-18','semibold-20','semibold-42','regular-10','regular-12','regular-16','regular-28'])};Title.defaultProps={type:'page',fontWeight:'regular-16'};/* harmony default export */ __webpack_exports__["a"] = (Title);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentControlItem__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(2);
var DocumentControl=function DocumentControl(props){/*
   Organiza a lista de documentos */var handleItens=function handleItens(){var mappedDocuments=props.documents;var documents=[];var _props=Object.assign({},props),protocolo=_props.protocolo,acao=_props.acao,requerimento=_props.requerimento;if(mappedDocuments){var requerimentoProps=requerimento;mappedDocuments.forEach(function(element){if(element.documentType!==3){documents.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DocumentControlItem__["a" /* default */],{tiposDocumentos:props.tiposDocumentos,document:element,protocolo:protocolo,auth:props.auth,acao:acao,requerimento:requerimentoProps,atualizarDocumentosProbatorios:props.atualizarDocumentosProbatorios,tipoRequerimento:props.tipoRequerimento}));}else{// eslint-disable-next-line
if(props.auth.checkPermission(['fornecer-parecer-medico-rpps'])){documents.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DocumentControlItem__["a" /* default */],{tiposDocumentos:props.tiposDocumentos,document:element,protocolo:protocolo,auth:props.auth,acao:acao,requerimento:requerimentoProps,atualizarDocumentosProbatorios:props.atualizarDocumentosProbatorios,tipoRequerimento:props.tipoRequerimento}));}}});}return documents;};return props.documents.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__index__["e" /* DataGrid */],{title:'Documentos Probat\xF3rios',icon:'ico-docs'},handleItens()):null;};DocumentControl.propTypes={documents:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({codigo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoDocumento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number})).isRequired,tiposDocumentos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,atualizarDocumentosProbatorios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DocumentControl);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_requerimentos_ModalTipoDocumento__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_requerimentos_ModalAlerta__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_User__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DocumentControlItem=function(_Component){_inherits(DocumentControlItem,_Component);function DocumentControlItem(){_classCallCheck(this,DocumentControlItem);var _this=_possibleConstructorReturn(this,(DocumentControlItem.__proto__||Object.getPrototypeOf(DocumentControlItem)).call(this));_this.handleModal=function(modal){_this.setState(_defineProperty({},modal,!_this.state[modal]));};_this.handleClose=function(){_this.setState({document:null},_this.handleModal('showTipoDocumentoModal'));};_this.downloadDocument=function(filename){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["g" /* doGetFile */])(_this.props.document.key,filename);};_this.confirmaExclusaoArquivo=function(){var idArquivo=_this.props.document.key;Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["c" /* doDelete */])('documentos/excluirDocumento',idArquivo,_this.trataSucessoResponseExclusaoArquivo,_this.trataErrosResponse,'');_this.setState(function(){return _this.handleFechamentoModalAlerta();});};_this.trataSucessoResponseExclusaoArquivo=function(){var mensagemSucesso=['Documento excluído com sucesso.'];Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);_this.props.atualizarDocumentosProbatorios();};_this.trataErrosResponseExclusaoArquivo=function(){var mensagemErro=['Não foi possível excluir o arquivo.'];Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(mensagemErro);};_this.handleFechamentoModalAlerta=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta});};_this.trataSucessoResponseEnvio=function(){_this.handleModal('showTipoDocumentoModal');if(_this.props.acao==='indeferidos'){var mensagemSucesso=['Documento alterado com sucesso.'];Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);}_this.props.atualizarDocumentosProbatorios();};_this.trataErrosResponse=function(){if(_this.props.acao==='indeferidos'){var mensagemErro=['Não foi possível alterar o documento.'];Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(mensagemErro);}};_this.alterarTipoDocumento=function(paramTipoDocumento){var tipoDocumento={protocolo:_this.props.requerimento.protocolo,codigo:paramTipoDocumento};Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["n" /* doPut */])('documentos/'+_this.props.document.key,tipoDocumento,_this.trataSucessoResponseEnvio,_this.trataErrosResponse);};_this.state={showTipoDocumentoModal:null,showModalAlerta:false,exclusaoDocumento:null};return _this;}/**
 * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
 */_createClass(DocumentControlItem,[{key:'render',value:function render(){var _this2=this;var documentType='Carregando...';if(this.props.tiposDocumentos){documentType=Object(__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["n" /* getObject */])(this.props.tiposDocumentos,this.props.document.documentType);}if(this.props.document.key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["i" /* Grid */],{cols:'7 7 7 7'},this.props.auth.checkPermission(['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-negocio-sprev','analisar-compensacao-rgps','analisar-compensacao-rpps','fornecer-parecer-medico-rpps','gerenciar-negocio-dcomp'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* Button */],{hint:documentType.label,icon:'ico-download',onClick:function onClick(){return _this2.downloadDocument(documentType.label);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* Button */],{hint:documentType.label,icon:'ico-cancel-circle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,documentType.label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["i" /* Grid */],{cols:'3 3 3 3'},this.props.requerimento.estado===15&&this.props.acao==='indeferidos'||this.props.requerimento.estado===2&&this.props.acao==='cumprir-exigencia'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* Button */],{hint:'Alterar o tipo do documento',icon:'ico-pencil',className:'icone',onClick:function onClick(){return _this2.handleModal('showTipoDocumentoModal');}}):'',(this.props.requerimento.solicitante.cnpj===__WEBPACK_IMPORTED_MODULE_8__domain_User__["a" /* default */].logged().cnpjDoPapel()||__WEBPACK_IMPORTED_MODULE_8__domain_User__["a" /* default */].logged().isRGPS()&&this.props.requerimento.solicitante.codigo==='01000')&&(this.props.requerimento.estado===4&&this.props.acao==='consulta'||this.props.requerimento.estado===5&&this.props.acao==='consulta'||this.props.requerimento.estado===2&&this.props.acao==='cumprir-exigencia')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* Button */],{hint:'Excluir documento',icon:'ico-trash-can',className:'icone',onClick:function onClick(){return _this2.handleModal('showModalAlerta');}}):''),this.state.showTipoDocumentoModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__pages_requerimentos_ModalTipoDocumento__["a" /* default */],Object.assign({},this.props,{requerimento:this.props.requerimento,alterarTipoDocumento:this.alterarTipoDocumento,handleModal:function handleModal(){return _this2.handleModal('showTipoDocumentoModal');},showModal:this.state.showTipoDocumentoModal,tiposDocumentos:this.props.tiposDocumentos})):'',this.state.showModalAlerta?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__pages_requerimentos_ModalAlerta__["a" /* default */],{alertas:[__WEBPACK_IMPORTED_MODULE_6__utils_constants__["q" /* msgsConfirmacaoExclusaoDocumentoRequerimento */].exclusao],aceitar:this.confirmaExclusaoArquivo,handleModal:this.handleFechamentoModalAlerta,showModal:this.state.showModalAlerta}):'');}return'';}}]);return DocumentControlItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DocumentControlItem.propTypes={document:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({key:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,documentType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,tiposDocumentos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,estado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,atualizarDocumentosProbatorios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DocumentControlItem);

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(535);

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);
var bind = __webpack_require__(198);
var Axios = __webpack_require__(537);
var defaults = __webpack_require__(115);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(202);
axios.CancelToken = __webpack_require__(551);
axios.isCancel = __webpack_require__(201);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(552);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 536 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(115);
var utils = __webpack_require__(22);
var InterceptorManager = __webpack_require__(546);
var dispatchRequest = __webpack_require__(547);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(200);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);
var transformData = __webpack_require__(548);
var isCancel = __webpack_require__(201);
var defaults = __webpack_require__(115);
var isAbsoluteURL = __webpack_require__(549);
var combineURLs = __webpack_require__(550);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(202);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return showLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return salvaDestinatarios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return salvaTiposDocumentos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return salvaExigencias; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return salvaMotivosIndeferimento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return salvaMotivosSuspensao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return salvaMotivosCessacao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return salvaMotivosNaoCumprimento; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return salvaMotivosRejeicao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return salvaValoresMediosBeneficios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return salvaMotivosCessacaoRequerimentoAposentadoria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return salvaMotivosCessacaoRequerimentoPensao; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return salvaMotivosCessacaoDependente; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return salvaPeriodosVigencia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return apagaPeriodosVigencia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return salvaCompetenciaAberta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return salvaOrgaosCentralizados; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return salvaConfiguracoesDeFrontend; });
/* unused harmony export salvaSolicitarPendenciasPorEnteLogado */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return salvaAbrangenciasEntPartRPPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apagaAbrangenciasEntidadeParticipanteRPPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return salvarListaMensagens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return salvaFiltroBloqueio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return apagaFiltroBloqueio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return salvaComplementoTitulo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apagaComplementoTitulo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return salvaMotivosIndeferimentoRelatorio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return salvaMotivosSuspensaoRelatorio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return salvaMotivosCessacaoRelatorio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return salvaExigenciasRelatorio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return salvaEstadosSimulacaoCompensacaoSuccess; });
var showLoading=function showLoading(value){return{type:'SHOW_LOADING',payload:value};};var salvaDestinatarios=function salvaDestinatarios(value){return{type:'SALVA_DESTINATARIOS',payload:value};};var salvaTiposDocumentos=function salvaTiposDocumentos(value){return{type:'SALVA_TIPOS_DOCUMENTOS',payload:value};};var salvaExigencias=function salvaExigencias(value){return{type:'SALVA_EXIGENCIAS',payload:value};};var salvaMotivosIndeferimento=function salvaMotivosIndeferimento(value){return{type:'SALVA_MOTIVOS_INDEFERIMENTO',payload:value};};var salvaMotivosSuspensao=function salvaMotivosSuspensao(value){return{type:'SALVA_MOTIVOS_SUSPENSAO',payload:value};};var salvaMotivosCessacao=function salvaMotivosCessacao(value){return{type:'SALVA_MOTIVOS_CESSACAO',payload:value};};var salvaMotivosNaoCumprimento=function salvaMotivosNaoCumprimento(value){return{type:'SALVA_MOTIVOS_NAO_CUMPRIMENTO',payload:value};};var salvaMotivosRejeicao=function salvaMotivosRejeicao(value){return{type:'SALVA_MOTIVOS_REJEICAO',payload:value};};var salvaValoresMediosBeneficios=function salvaValoresMediosBeneficios(value){return{type:'SALVA_VALORES_MEDIOS_BENEFICIOS',payload:value};};var salvaMotivosCessacaoRequerimentoAposentadoria=function salvaMotivosCessacaoRequerimentoAposentadoria(value){return{type:'SALVA_MOTIVOS_CESSACAO_REQUERIMENTO_APOSENTADORIA',payload:value};};var salvaMotivosCessacaoRequerimentoPensao=function salvaMotivosCessacaoRequerimentoPensao(value){return{type:'SALVA_MOTIVOS_CESSACAO_REQUERIMENTO_PENSAO',payload:value};};var salvaMotivosCessacaoDependente=function salvaMotivosCessacaoDependente(value){return{type:'SALVA_MOTIVOS_CESSACAO_DEPENDENTE',payload:value};};var salvaPeriodosVigencia=function salvaPeriodosVigencia(value){return{type:'SALVA_PERIODOS_VIGENCIA',payload:value};};var apagaPeriodosVigencia=function apagaPeriodosVigencia(value){return{type:'APAGA_PERIODOS_VIGENCIA',payload:value};};var salvaCompetenciaAberta=function salvaCompetenciaAberta(value){return{type:'SALVA_COMPETENCIA_ABERTA',payload:value};};var salvaOrgaosCentralizados=function salvaOrgaosCentralizados(value){return{type:'SALVA_ORGAOS_CENTRALIZADOS',payload:value};};var salvaConfiguracoesDeFrontend=function salvaConfiguracoesDeFrontend(value){return{type:'SALVA_CONFIGURACOES_DE_FRONTEND',payload:value};};var salvaSolicitarPendenciasPorEnteLogado=function salvaSolicitarPendenciasPorEnteLogado(value){return{type:'SALVA_SOLICITAR_PENDENCIAS_POR_ENTE_FRONTEND',payload:value};};var salvaAbrangenciasEntPartRPPS=function salvaAbrangenciasEntPartRPPS(value){return{type:'SALVA_ABRANGENCIAS_ENT_PARTIC_RPPS',payload:value};};var apagaAbrangenciasEntidadeParticipanteRPPS=function apagaAbrangenciasEntidadeParticipanteRPPS(value){return{type:'APAGA_ABRANGENCIAS_ENT_PARTIC_RPPS',payload:value};};var salvarListaMensagens=function salvarListaMensagens(value){return{type:'SALVAR_LISTA_MENSAGENS',payload:value};};var salvaFiltroBloqueio=function salvaFiltroBloqueio(value){return{type:'SALVA_FILTRO_BLOQUEIO',payload:value};};var apagaFiltroBloqueio=function apagaFiltroBloqueio(value){return{type:'APAGA_FILTRO_BLOQUEIO',payload:value};};var salvaComplementoTitulo=function salvaComplementoTitulo(value){return{type:'SALVA_COMPLEMENTO_TITULO',payload:value};};var apagaComplementoTitulo=function apagaComplementoTitulo(value){return{type:'APAGA_COMPLEMENTO_TITULO',payload:value};};var salvaMotivosIndeferimentoRelatorio=function salvaMotivosIndeferimentoRelatorio(value){return{type:'SALVA_MOTIVOS_INDEFERIMENTO_RELATORIO',payload:value};};var salvaMotivosSuspensaoRelatorio=function salvaMotivosSuspensaoRelatorio(value){return{type:'SALVA_MOTIVOS_SUSPENSAO_RELATORIO',payload:value};};var salvaMotivosCessacaoRelatorio=function salvaMotivosCessacaoRelatorio(value){return{type:'SALVA_MOTIVOS_CESSACAO_RELATORIO',payload:value};};var salvaExigenciasRelatorio=function salvaExigenciasRelatorio(value){return{type:'SALVA_EXIGENCIAS_RELATORIO',payload:value};};var salvaEstadosSimulacaoCompensacaoSuccess=function salvaEstadosSimulacaoCompensacaoSuccess(value){return{type:'SALVA_ESTADOS_SIMULACAO_COMPENSACAO',payload:value};};

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_User__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalTipoDocumento=function(_Component){_inherits(ModalTipoDocumento,_Component);function ModalTipoDocumento(){_classCallCheck(this,ModalTipoDocumento);var _this=_possibleConstructorReturn(this,(ModalTipoDocumento.__proto__||Object.getPrototypeOf(ModalTipoDocumento)).call(this));_this.montarListaDocumentosAdicionais=function(paramLista){var lista=paramLista;var tiposDocumentos=_this.props.tiposDocumentos?_this.props.tiposDocumentos:[];var inss='01000';var destinatarioOuSolicitanteRGPS=__WEBPACK_IMPORTED_MODULE_3__domain_User__["a" /* default */].logged().isRGPS()||_this.props.requerimento.destinatario===inss;var acordos=destinatarioOuSolicitanteRGPS?[1,3]:[2,3];var regimes=__WEBPACK_IMPORTED_MODULE_3__domain_User__["a" /* default */].logged().isRGPS()?[1,3]:[2,3];lista=tiposDocumentos.filter(function(doc){return(// 1: Aposentadoria
// 2: Pensao
// Nulo: Ambos (Não havia sido acordado se "3" seria para ambos.
// Por enquanto "null" no banco significa ambos)
(doc.abrangenciaAplicavel===_this.props.tipoRequerimento||doc.abrangenciaAplicavel==null)&&acordos.includes(doc.acordoAplicavel)&&regimes.includes(doc.regimeAplicavel));});return lista;};_this.montaListaDocumentosDisponiveis=function(){var lista=_this.montarListaDocumentosAdicionais(_this.props.requerimento);_this.setState({tiposDisponiveis:lista});};_this.checkIfFileCanBeSent=function(){return _this.state.tipoDocumento;};_this.alterarTipoDocumento=function(){var tipoDocumentoCarregado=_this.state.tipoDocumento;_this.props.alterarTipoDocumento(tipoDocumentoCarregado);};_this.modalTipoDocumentoContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Tipo de documento',number:true,placeholder:'Selecione o tipo de documento',onChange:function onChange(e){return _this.handleChange(e,'tipoDocumento');},value:_this.state.tipoDocumento,itemList:_this.state.tiposDisponiveis,required:true,custom:true}))));};_this.modalTipoDocumentoFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!_this.checkIfFileCanBeSent(),hint:'Alterar tipo de documento',onClick:_this.alterarTipoDocumento,title:'Salvar'})));};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value));};_this.handleClose=function(){_this.setState({tipoDocumento:null},_this.props.handleModal('showDocumentUploadModal'));};_this.state={tipoDocumento:null};return _this;}_createClass(ModalTipoDocumento,[{key:'componentDidMount',value:function componentDidMount(){this.montaListaDocumentosDisponiveis();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalTipoDocumentoFooter(),conteudomodal:this.modalTipoDocumentoContent(),onHide:this.handleClose,size:'md',showModal:this.props.showModal,title:'Alterar Tipo de documento'}));}}]);return ModalTipoDocumento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalTipoDocumento.propTypes={estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,pagamento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleDocumentSent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalTipoDocumento);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var ProgressBar=function ProgressBar(props){return props.children?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dtp-progress-bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,props.children)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dtp-progress-bar'}));};ProgressBar.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element};ProgressBar.defaultProps={children:null};/* unused harmony default export */ var _unused_webpack_default_export = (ProgressBar);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dtp_react_components__ = __webpack_require__(4);
var Spinner=function Spinner(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["E" /* DtpSpinner */],props);};/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
var Radio=function Radio(props){var renderSelectItem=function renderSelectItem(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["z" /* DtpRadio */],{value:item.value,label:item.label,disabled:props.disabled});};var optionsButtonList=props.itemList.map(function(item){return renderSelectItem(item);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["A" /* DtpRadioGroup */],Object.assign({name:props.name,selectedValue:props.value},props),optionsButtonList);};Radio.defaultProps={value:null,name:null,disabled:false};Radio.propTypes={value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,itemList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dtp_react_components__ = __webpack_require__(4);
var FileUpload=function FileUpload(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["m" /* DtpFileUpload */],props);};/* unused harmony default export */ var _unused_webpack_default_export = (FileUpload);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PeriodoVigenciaItem__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(2);
var PeriodosVigenciaControl=function PeriodosVigenciaControl(props){// const pesquisarCadprev = (
//   <Button
//     title="Atualizar períodos CADPREV"
//     onClick={() => props.handleSearchPesquisaCadPrevButton()}
//     hint="Atualizar períodos CADPREV"
//   />
// );
var handleItens=function handleItens(){var mappedPeriodos=props.periodosVigencia;var periodos=[];if(mappedPeriodos){mappedPeriodos.forEach(function(item){periodos.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PeriodoVigenciaItem__["a" /* default */],{periodo:item}));});}return periodos;};return props.periodosVigencia.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__index__["e" /* DataGrid */],{title:'Per\xEDodos de RPPS',icon:'ico-doc-book'},handleItens()):null;};PeriodosVigenciaControl.propTypes={// handleSearchPesquisaCadPrevButton: PropTypes.func.isRequired,
periodosVigencia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({cnpj:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataCriacaoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataEncerramentoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (PeriodosVigenciaControl);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PeriodoVigenciaItem=function(_Component){_inherits(PeriodoVigenciaItem,_Component);function PeriodoVigenciaItem(){_classCallCheck(this,PeriodoVigenciaItem);var _this=_possibleConstructorReturn(this,(PeriodoVigenciaItem.__proto__||Object.getPrototypeOf(PeriodoVigenciaItem)).call(this));_this.state={};return _this;}_createClass(PeriodoVigenciaItem,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["i" /* Grid */],{cols:'5 5 5 5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["k" /* Input */],{disabled:true,value:this.props.periodo.dataCriacaoRpps})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["k" /* Input */],{disabled:true,value:'a',style:{borderBottom:'none','text-align':'center'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["k" /* Input */],{disabled:true,value:this.props.periodo.dataEncerramentoRpps})));}}]);return PeriodoVigenciaItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PeriodoVigenciaItem.propTypes={periodo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({cnpj:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataCriacaoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataEncerramentoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (PeriodoVigenciaItem);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(2);
// import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
// import ListaUoItem from './ListaUoItem';
var ListaUos=function ListaUos(props){var linhasPorPagina=10;var options={noDataText:'Nenhuma orgão local encontrado para o ente federativo',hideSizePerPage:true,sizePerPage:10};var tableHeader=[{id:'idUoInss0',label:''},{id:'idUoInss1',label:''},{id:'idUoInss2',label:''}];var montaListaFormatadaUos=function montaListaFormatadaUos(){var colunasPorPagina=3;var pagina=0;var linha=0;var coluna=0;var listaFormatada=[];listaFormatada[0]={};if(props.listaUosInss===undefined){listaFormatada.length=0;}else{props.listaUosInss.forEach(function(uo,index){listaFormatada[linha]['idUoInss'+coluna]=uo.idUoInss;if((index+1)%linhasPorPagina===0){if((index+1)%(linhasPorPagina*colunasPorPagina)===0){pagina+=1;linha=pagina*linhasPorPagina;coluna=0;if(listaFormatada[linha]===undefined){listaFormatada[linha]={};}}else{linha=pagina*linhasPorPagina;coluna+=1;if(coluna%colunasPorPagina===0){coluna=0;}}}else{linha+=1;if(listaFormatada[linha]===undefined){listaFormatada[linha]={};}}});}return listaFormatada;};return props.listaUosInss.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["u" /* Table */],{bordered:true,data:montaListaFormatadaUos(),options:options,listaTableHeader:tableHeader,pagination:true,scrollTop:'Top'}):null;};ListaUos.propTypes={listaUosInss:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({idParticipante:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,idUoInss:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired};/* unused harmony default export */ var _unused_webpack_default_export = (ListaUos);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(7);
// import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
var ListaAbrangencia=function ListaAbrangencia(props){var options={noDataText:'Nenhuma orgão vinculado ao ente federativo',hideSizePerPage:true,sizePerPage:10};var tableHeader=[{id:'cnpj',label:'CNPJ'},{id:'nomeOrgaoVinculado',label:'Orgão',dataAlign:'justify',width:'60%',style:'text-align: center'}];var listaFormatada=props.listaAbrangenciaRPPS.map(function(item){var itemIndexado=item;if(itemIndexado.cnpj){itemIndexado.cnpj=Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["d" /* formatarCnpj */])(itemIndexado.cnpj);}return itemIndexado;});return props.listaAbrangenciaRPPS.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["u" /* Table */],{bordered:true,data:listaFormatada,options:options,listaTableHeader:tableHeader,pagination:true,scrollTop:'Top'}):null;};ListaAbrangencia.propTypes={listaAbrangenciaRPPS:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({cnpj:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,idParticipante:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nomeOrgaoVinculado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired};/* unused harmony default export */ var _unused_webpack_default_export = (ListaAbrangencia);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrgaosCentralizadosItem__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(2);
var OrgaosCentralizadosControl=function OrgaosCentralizadosControl(props){var handleItens=function handleItens(){var mappedOrgaos=props.orgaosCentralizados;var orgaos=[];if(mappedOrgaos){mappedOrgaos.forEach(function(item){orgaos.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OrgaosCentralizadosItem__["a" /* default */],{orgao:item,buscaParticipanteRpps:props.buscaParticipanteRpps// handleSuccessBuscaDadosParticipanteRpps={props.handleSuccessBuscaDadosParticipanteRpps}
// handleErrorBusca={props.handleErrorBusca}
}));});}return orgaos;};return props.orgaosCentralizados.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__index__["e" /* DataGrid */],{title:'Org\xE3os Centralizados',icon:'ico-doc-book'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__index__["i" /* Grid */],{cols:'12 12 12 12',style:{height:'200px',overflowX:'hidden',overflowY:'scroll'}},handleItens()))):null;};OrgaosCentralizadosControl.propTypes={// handleSearchPesquisaCadPrevButton: PropTypes.func.isRequired,
orgaosCentralizados:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({codigo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired,buscaParticipanteRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,// handleSuccessBuscaDadosParticipanteRpps: PropTypes.func.isRequired,
// handleErrorBusca: PropTypes.func.isRequired,
history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (OrgaosCentralizadosControl);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var OrgaoCentralizadoItem=function(_Component){_inherits(OrgaoCentralizadoItem,_Component);function OrgaoCentralizadoItem(){_classCallCheck(this,OrgaoCentralizadoItem);var _this=_possibleConstructorReturn(this,(OrgaoCentralizadoItem.__proto__||Object.getPrototypeOf(OrgaoCentralizadoItem)).call(this));_this.buscaParticipanteRpps=function(){};_this.state={};return _this;}_createClass(OrgaoCentralizadoItem,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{padding:'0',margin:'10px'},href:'#',onClick:function onClick(){return _this2.props.buscaParticipanteRpps(_this2.props.orgao.codigo);}},this.props.orgao.codigo+' - '+this.props.orgao.nome+' - '+(this.props.orgao.extinto===1?'Extinto':'Ativo'))));}}]);return OrgaoCentralizadoItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrgaoCentralizadoItem.propTypes={orgao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({codigo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,buscaParticipanteRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OrgaoCentralizadoItem);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadItem=function(_Component){_inherits(DownloadItem,_Component);function DownloadItem(){_classCallCheck(this,DownloadItem);var _this=_possibleConstructorReturn(this,(DownloadItem.__proto__||Object.getPrototypeOf(DownloadItem)).call(this));_this.downloadDocument=function(){Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["f" /* doGetDocumentoComUrlDinamica */])(_this.props.arquivo.id,'comprovante',_this.props.caminho);};_this.state={};return _this;}_createClass(DownloadItem,[{key:'render',value:function render(){var _this2=this;if(this.props.arquivo.id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["i" /* Grid */],{cols:'12 12 12 12'},this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rpps'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* Button */],{hint:this.props.arquivo.nome,icon:'ico-download',onClick:function onClick(){return _this2.downloadDocument();}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* Button */],{hint:this.props.arquivo.nome,icon:'ico-cancel-circle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.arquivo.nome)));}return'';}}]);return DownloadItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DownloadItem.propTypes={auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,arquivo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired,caminho:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* unused harmony default export */ var _unused_webpack_default_export = (DownloadItem);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelecaoMultipla=function(_Component){_inherits(SelecaoMultipla,_Component);function SelecaoMultipla(){_classCallCheck(this,SelecaoMultipla);var _this=_possibleConstructorReturn(this,(SelecaoMultipla.__proto__||Object.getPrototypeOf(SelecaoMultipla)).call(this));_this.getInitialState=function(){return{// item: null,
lista:[],desabilitarBotaoInclusao:true};};_this.deleteItem=function(row){var _this$props=Object.assign({},_this.props),lista=_this$props.lista;lista.splice(row,1);_this.alteraLista(lista);_this.verificarHabilitacaoBotaoIncluir();};_this.buscaDadosDeDominio=function(){if(_this.props.exigencias.length===0){Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["t" /* requestExigenciasRelatorio */])(_this.tratarErro);}if(_this.props.motivosIndeferimento.length===0||_this.props.motivosSuspensao.length===0||_this.props.motivosCessacao.length===0){Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["y" /* requestMotivosRelatorio */])(_this.tratarErro);}return null;};_this.createActionColumn=function(indice){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* Button */],{className:'dtp-inverse',hint:'Excluir do filtro',icon:'ico-doc-minus',mini:true,onClick:function onClick(){return _this.deleteItem(indice);}}));};_this.colunasDefault=[{id:'label',label:'Estado'},{id:'codigo',label:'Código'},{id:'acoes',label:'Excluir',dataFormat:_this.createActionColumn}];_this.colunasMultiplosEstados=[{id:'label',label:'Opção'},{id:'value',label:'Código'},{id:'acoes',label:'Excluir',dataFormat:_this.createActionColumn}];_this.options={hideSizePerPage:true,noDataText:'Nenhum item foi adicionado à lista',sizePerPage:5};_this.fetchInfo={};_this.handleChange=function(changeObj,name){_this.props.handleChange(changeObj,name,_this.addItem);};_this.handleChangeEstadoMultiplo=function(changeObj,name){_this.props.handleChange(changeObj,name,_this.verificarHabilitacaoBotaoIncluir);};_this.handleChangeMultiplo=function(changeObj,name){_this.props.handleChange(changeObj,name);_this.setState({desabilitarBotaoInclusao:false});};_this.alteraLista=function(lista){_this.props.handleChange({value:lista,isValid:lista.length>0});};_this.verificarHabilitacaoBotaoIncluir=function(){if(_this.props.valorComboSelecaoMultipla!==null){_this.setState({desabilitarBotaoInclusao:false});}else{_this.setState({desabilitarBotaoInclusao:true});}};_this.verificarItemInseridoNaLista=function(){var retorno=false;var index=_this.props.lista.findIndex(function(item){return item.value===_this.props.valorComboSelecaoMultipla;});if(index!==-1){retorno=true;}return retorno;};_this.retornarListaPorEstado=function(estado){var listaPorEstado=void 0;switch(estado){case'2':listaPorEstado=_this.props.exigencias;break;case'9':listaPorEstado=_this.props.motivosIndeferimento;break;case'10':listaPorEstado=_this.props.motivosSuspensao;break;case'12':listaPorEstado=_this.props.motivosCessacao;break;default:listaPorEstado=[];break;}return listaPorEstado;};_this.addItemMultiplo=function(){if(_this.props.valorComboSelecaoMultipla){var _this$props2=Object.assign({},_this.props),lista=_this$props2.lista;var existeNaLista=_this.verificarItemInseridoNaLista();var labelItem='';if(existeNaLista){Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["L" /* trataMensagensErro */])(['O item já existe na lista']);}else{if(_this.props.configuracao.origem==='filtroSimulacaoCompensacao'){var index=_this.props.estadosSimulacaoCompensacao.findIndex(function(i){return i.value===_this.props.valorComboSelecaoMultipla;});if(index!==-1){labelItem=_this.props.estadosSimulacaoCompensacao[index].label;}}else{var listaPorEstado=_this.retornarListaPorEstado(_this.props.estado);var _index=listaPorEstado.findIndex(function(i){return i.value===_this.props.valorComboSelecaoMultipla;});if(_index!==-1){labelItem=listaPorEstado[_index].label;}}var item={label:labelItem,value:_this.props.valorComboSelecaoMultipla,codigo:_this.props.valorComboSelecaoMultipla};lista.push(item);_this.alteraLista(lista);_this.setState(function(){return _this.verificarHabilitacaoBotaoIncluir();});}}};_this.addItem=function(){if(_this.props.valorComboSelecaoMultipla){var _this$props3=Object.assign({},_this.props),lista=_this$props3.lista;var item=null;var titulo='';if(_this.props.configuracao.origem==='filtroSimulacaoCompensacao'){var index=_this.props.estadosSimulacaoCompensacao.findIndex(function(i){return i.value===Number(_this.props.valorComboSelecaoMultipla);});if(index!==-1){titulo=_this.props.estadosSimulacaoCompensacao[index].label;}}else{var listaPorEstado=_this.retornarListaPorEstado(_this.props.estado);var _index2=listaPorEstado.findIndex(function(i){return i.value===Number(_this.props.valorComboSelecaoMultipla);});if(_index2!==-1){titulo=listaPorEstado[_index2].label;}}item={label:titulo,value:_this.props.valorComboSelecaoMultipla};lista.push(item);_this.alteraLista(lista);}else if(_this.props.valorComboSelecaoMultipla===''){var _this$props4=Object.assign({},_this.props),_lista=_this$props4.lista;if(_lista.length>0){_lista=[];_this.alteraLista(_lista);}}};_this.verificarSeEstadoPossuiSelecaoMultipla=function(){var ehSelecaoMultipla=false;var estadoSelecionado=_this.props.estado;if(estadoSelecionado){ehSelecaoMultipla=_this.props.listaEstadosComSelecaoMultipla.includes(Number(estadoSelecionado));}else if(_this.props.configuracao.origem==='filtroSimulacaoCompensacao'){ehSelecaoMultipla=true;}return ehSelecaoMultipla;};_this.recuperarListaPorOrigem=function(){var retorno=[];if(_this.props.configuracao.origem==='filtroSimulacaoCompensacao'){retorno=_this.props.estadosSimulacaoCompensacao;}else{retorno=_this.retornarListaPorEstado(_this.props.estado);}return retorno;};var initialState=_this.getInitialState();_this.state=initialState;return _this;}_createClass(SelecaoMultipla,[{key:'componentDidMount',value:function componentDidMount(){// if (this.props.configuracao && this.props.configuracao.origem !== 'filtroSimulacaoCompensacao') {
//   this.buscaDadosDeDominio();
// }
if(!this.props.configuracao||this.props.configuracao&&this.props.configuracao.origem!=='filtroSimulacaoCompensacao'){this.buscaDadosDeDominio();}}},{key:'render',value:function render(){var _this2=this;var listaIndexada=this.props.lista.map(function(item,i){var itemIndexado=item;itemIndexado.acoes=i;return itemIndexado;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.estado!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["f" /* DataGridCustom */],{title:this.props.configuracao.titulo,retirarLinhaSeparadora:this.props.configuracao.retirarLinhaSeparadora},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["i" /* Grid */],{cols:'6 6 6 6'},this.props.configuracao.exibirComboBox&&this.props.configuracao.origem==='filtroSimulacaoCompensacao'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["k" /* Input */],{label:this.props.configuracao.labelCombobox,onChange:function onChange(e){return _this2.handleChangeMultiplo(e,'valorComboSelecaoMultipla');},placeholder:'Todos',value:this.props.valorComboSelecaoMultipla,itemList:this.recuperarListaPorOrigem(),custom:true,number:true,integer:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["k" /* Input */],{label:this.props.configuracao.labelCombobox,onChange:this.verificarSeEstadoPossuiSelecaoMultipla()?function(e){return _this2.handleChangeEstadoMultiplo(e,'valorComboSelecaoMultipla');}:function(e){return _this2.handleChange(e,'valorComboSelecaoMultipla');},placeholder:'Todos',value:this.props.valorComboSelecaoMultipla,itemList:this.recuperarListaPorOrigem(),custom:true,number:true,integer:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["i" /* Grid */],{cols:'6 6 6 6'},this.props.configuracao.exibirBotaoIncluir?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* Button */],{hint:'incluir '+this.props.hint+' ao filtro',icon:'ico-plus',mini:true,disabled:this.state.desabilitarBotaoInclusao,onClick:this.verificarSeEstadoPossuiSelecaoMultipla()?function(){return _this2.addItemMultiplo();}:function(){return _this2.addItem();}}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["i" /* Grid */],{cols:'12 12 12 12'},this.props.configuracao.exibirTabelaItens?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["u" /* Table */],{bordered:true,data:listaIndexada,options:this.options,listaTableHeader:this.props.configuracao.origem==='filtroSimulacaoCompensacao'?this.colunasDefault:this.colunasMultiplosEstados,pagination:true,fetchInfo:this.fetchInfo}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)))):'');}}]);return SelecaoMultipla;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelecaoMultipla.propTypes={handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,configuracao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({origem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,labelCombobox:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,titulo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,exibirBotaoIncluir:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,exibirTabelaItens:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,retirarLinhaSeparadora:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,exibirComboBox:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}).isRequired,estado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,hint:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,valorComboSelecaoMultipla:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,listaEstadosComSelecaoMultipla:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number})).isRequired,lista:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})).isRequired,exigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),motivosIndeferimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),motivosSuspensao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),motivosCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),estadosSimulacaoCompensacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};SelecaoMultipla.defaultProps={exigencias:[],motivosIndeferimento:[],motivosSuspensao:[],motivosCessacao:[],estadosSimulacaoCompensacao:[]};// eslint-disable-next-line
var mapStateToProps=function mapStateToProps(state){return{exigencias:state.base.exigenciasRelatorio,motivosIndeferimento:state.base.motivosIndeferimentoRelatorio,motivosSuspensao:state.base.motivosSuspensaoRelatorio,motivosCessacao:state.base.motivosCessacaoRelatorio,estadosSimulacaoCompensacao:state.base.estadosSimulacaoCompensacao};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(SelecaoMultipla));

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Grid=function Grid(props){var toCssClasses=function toCssClasses(numbers){var cols=numbers?numbers.split(' '):[];var classes='';if(cols[0])classes+='col-xs-'+cols[0];if(cols[1])classes+=' col-sm-'+cols[1];if(cols[2])classes+=' col-md-'+cols[2];if(cols[3])classes+=' col-lg-'+cols[3];return classes;};var gridClasses=toCssClasses(props.cols||12);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:gridClasses,style:props.style},props.children);};Grid.defaultProps={style:null};// Propriedade estatica
Grid.propTypes={style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),cols:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* eslint-disable jsx-a11y/anchor-is-valid */var retornaCss=function retornaCss(props){var retorno='dtp-datagrid-header';if(props&&props.cssLinha){retorno=props.cssLinha;}return retorno;};var DataGridCustom=function DataGridCustom(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'dtp-datagrid'},!props.retirarLinhaSeparadora?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:props.retirarLinhaSeparadora?'header-sem-linha':retornaCss(props)},props.title):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dtp-datagrid-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dtp-datagrid-items-box'},props.children)));};DataGridCustom.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,retirarLinhaSeparadora:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,cssLinha:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (DataGridCustom);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
var Radio=function Radio(props){var renderSelectItemHorizontal=function renderSelectItemHorizontal(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["z" /* DtpRadio */],{value:item.value,label:item.label,disabled:props.disabled});};var renderSelectItemVertical=function renderSelectItemVertical(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["z" /* DtpRadio */],{value:item.value,label:item.label,disabled:props.disabled}));};var optionsButtonListHorizontal=props.itemList.map(function(item){return renderSelectItemHorizontal(item);});var optionsButtonListVertical=props.itemList.map(function(item){return renderSelectItemVertical(item);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["q" /* DtpFormGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["k" /* DtpControlLabel */],{animate:props.animate,label:props.label}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["A" /* DtpRadioGroup */],Object.assign({name:props.name,selectedValue:props.value},props),props.disposicao===''||props.disposicao==='horizontal'?optionsButtonListHorizontal:optionsButtonListVertical));};Radio.defaultProps={value:null,name:null,disabled:false,label:null,animate:false,className:null,disposicao:null};Radio.propTypes={value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,animate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,disposicao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,itemList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalAlteracaoDataEMotivoCessacao__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CalculoCompensacao__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ResultadoAnalise__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SelecaoDestinatario__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Destinacao__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DestinacaoExigencia__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CumprimentoExigencia__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SolicitanteDestinatario__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__UploadArquivos__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalCadeiaDeNit__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ModalAlteracaoDataCessacao__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ProtocoloCertidao__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__MultiplosPeriodos__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SegregacaoDeMassa__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ModalAlteracaoSegregacaoMassa__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ModalAlteracaoMotivoCessacao__ = __webpack_require__(583);
var _this=this;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var APOSENTADORIA_POR_INVALIDEZ=3;var MOTIVO_REVERSAO=75;var MOTIVO_CAPACIDADE_SEGURADO=24;var camposDesabilitadosAlteracaoRequerimento=['cpf'];/* const camposHabilitadosParaAlteracaoNaAnalise = ['dataDesvinculacao',
  'dataIngresso', 'dataHomologacaoTribunalContas']; */var camposHabilitadosParaAlteracaoNaAnalise=['dataHomologacaoTribunalContas'];var DadosRequerimentoAposentadoria=function DadosRequerimentoAposentadoria(props){// O campo "destinatario" é diferente se for um requerimento novo ou um já existente
var isDestinatarioRPPS=function isDestinatarioRPPS(){if(props.estadoFormulario.acao==='realizar-analise'||props.estadoFormulario.acao==='cumprir-exigencia'||props.estadoFormulario.acao==='consulta'){return props.estadoFormulario.requerimento.destinatario&&props.estadoFormulario.requerimento.destinatario.codigo!=='01000'&&props.estadoFormulario.requerimento.destinatario.codigo!==null;}else if(props.estadoFormulario.acao==='novo'){return props.estadoFormulario.requerimento.destinatario!=='01000'&&props.estadoFormulario.requerimento.destinatario!==null;}return props.estadoFormulario.requerimento.destinatario&&props.estadoFormulario.requerimento.destinatario.codigo!=='01000';};var isSolicitanteRPPS=function isSolicitanteRPPS(){if(props.estadoFormulario.acao==='realizar-analise'||props.estadoFormulario.acao==='cumprir-exigencia'||props.estadoFormulario.acao==='consulta'||props.estadoFormulario.acao==='indeferidos'||props.estadoFormulario.acao==='complementar-aposentadoria'){return props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.requerimento.solicitante.codigo!=='01000';}else if(props.estadoFormulario.acao==='novo'){return __WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().isRPPS();}return false;};var isExibirCtcEspecifica=function isExibirCtcEspecifica(){var retorno=false;var destinatario=void 0;var solicitante=void 0;if(props.estadoFormulario.acao==='novo'){destinatario=props.estadoFormulario.requerimento.destinatario==='01000';}else{destinatario=props.estadoFormulario.requerimento.destinatario&&(props.estadoFormulario.requerimento.destinatario.codigo==='01000'||props.estadoFormulario.requerimento.destinatario==='01000');}if(props.estadoFormulario.acao==='realizar-analise'||props.estadoFormulario.acao==='cumprir-exigencia'||props.estadoFormulario.acao==='consulta'||props.estadoFormulario.acao==='indeferidos'||props.estadoFormulario.acao==='complementar-aposentadoria'){solicitante=props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.requerimento.solicitante.codigo!=='01000'&&props.estadoFormulario.requerimento.solicitante!=='01000'&&props.estadoFormulario.requerimento.solicitante.codigo!==null;}else if(props.estadoFormulario.acao==='novo'){solicitante=__WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().isRPPS();}if(destinatario&&solicitante){retorno=true;}else if(props.estadoFormulario.requerimento.ctcEspecifica!==0){var changeObj={value:0};props.handleChangeCtcEspecifica(changeObj);}return retorno;};var isDestinatarioPreenchido=function isDestinatarioPreenchido(){return props.estadoFormulario.requerimento.destinatario!==null;};var getLabelParecerMedico=function getLabelParecerMedico(){if(props.estadoFormulario.requerimento.destinatario){return props.estadoFormulario.requerimento.destinatario.codigo==='01000'?'Enquadramento no artigo 151 da lei 8213/91':'A aposentadoria por invalidez é em decorrência de acidente de serviço, moléstia profissional ou doença grave, contagiosa ou incurável, nos termos da Legislação do Ente?';}return'';};/**
   * Teste as condicoes para definir dentre os campos alternativos Matricula e Numero de Beneficio
   * qual deve ser exibido.
   */var controleCampoAlternativos=function controleCampoAlternativos(campo){switch(campo){case'numeroBeneficio':if(!['novo','cumprir-exigencia'].includes(props.estadoFormulario.acao)){// Se formulario estiver alterando requerimento, campo deve ser exibido quando preenchido
if(props.estadoFormulario.requerimento.numeroBeneficio){return Object.keys(__WEBPACK_IMPORTED_MODULE_12__utils_constants__["y" /* rolesCadastradas */]);}return[];}// Quando for criacao de requerimento, apenas RGPS deve possuir campo Numero de Beneficio
return['requerer-compensacao-rgps','gerenciar-negocio-dcomp'];case'dataIngresso':if(props.estadoFormulario.acao!=='novo'){// Se formulario estiver alterando requerimento, campo deve ser exibido quando preenchido
if(props.estadoFormulario.requerimento.dataIngresso){return Object.keys(__WEBPACK_IMPORTED_MODULE_12__utils_constants__["y" /* rolesCadastradas */]);}return[];}// Quando for criacao de requerimento, apenas RGPS deve possuir campo Data de Ingresso
return['requerer-compensacao-rgps','gerenciar-negocio-dcomp'];case'dataHomologacaoTribunalContas':if(!['novo','cumprir-exigencia'].includes(props.estadoFormulario.acao)){// Se formulario estiver diferente de em exigencia ou novo,
// mostrar data de homologacao quando solicitante for RPPS
if(props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.requerimento.solicitante.codigo!=='01000'){return Object.keys(__WEBPACK_IMPORTED_MODULE_12__utils_constants__["y" /* rolesCadastradas */]);}return[];}// Quando for criacao ou exigencia de requerimento, apenas RPPS deve ver campo
return['requerer-compensacao-rpps'];case'dataCreditoPagamento':if(!['novo','cumprir-exigencia'].includes(props.estadoFormulario.acao)){// Se formulario estiver diferente de em exigencia ou novo,
// mostrar data de homologacao quando solicitante for RGPS
if(props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.requerimento.solicitante.codigo==='01000'){return Object.keys(__WEBPACK_IMPORTED_MODULE_12__utils_constants__["y" /* rolesCadastradas */]);}return[];}// Quando for criacao ou exigencia de requerimento, apenas RGPS deve ver campo
return['requerer-compensacao-rgps','gerenciar-negocio-dcomp'];case'idUOMantenedora':if(!['novo','cumprir-exigencia','realizar-analise'].includes(props.estadoFormulario.acao)){// Se formulario estiver diferente de em exigencia ou novo,
// mostrar idUOMantenedora quando solicitante for RGPS
if(props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.requerimento.solicitante.codigo==='01000'){return Object.keys(__WEBPACK_IMPORTED_MODULE_12__utils_constants__["y" /* rolesCadastradas */]);}return[];}// Quando for criacao ou exigencia de requerimento, apenas RGPS deve ver campo
return['requerer-compensacao-rgps','gerenciar-negocio-dcomp'];default:return[];}};/*
   * Verifica a existencia de um determinado tipo de documento carregado em requerimentos
   * neste caso estamos especifico estamos verificando o tipoDocumento = 2  (Homologação Tribunal)
   * se econtrar retorna verdadeiro.
   * @param {*} tipoEmDocumentosProbatorios
   * @returns
   */// const existeTipoDocumentoCarregadoNoRequerimento = (tipoEmDocumentosProbatorios) => {
//   const existeTipoDocumento = props.estadoFormulario.requerimento.documentosProbatorios.some(documento => documento.tipoDocumento === tipoEmDocumentosProbatorios);
//   return existeTipoDocumento;
// };
/**
   * Converter uma string em data
   * formato dd/mm/yyyy
   */// const convertStringToDate = (dateString) => {
//   const [day, month, year] = dateString.split('/').map(part => parseInt(part, 10));
//   // Mês é 0-indexado em JavaScript, então subtraímos 1 do mês
//   const StringDateConvObjeto = new Date(year, month - 1, day);
//   // Formatar a data para 'dd/mm/yyyy'
//   const formattedDate = `${StringDateConvObjeto.getDate().toString().padStart(2, '0')}/${
//     (StringDateConvObjeto.getMonth() + 1).toString().padStart(2, '0')}/${
//     StringDateConvObjeto.getFullYear().toString()}`;
//     // retorna data formatada como 'dd/mm/yyyy'
//   return formattedDate;
// };
// const dateAberturaRequerimentoObject = convertStringToDate(DATESTRING);
// const isDataHomologacaoTribunalContasValid = (tipoEmDocumentosProbatorios, dateAberturaRequerimentoParam) => {
//   const isValid = ((props.estadoFormulario.dataHomologacaoTribunalContas === null || props.estadoFormulario.dataHomologacaoTribunalContas === undefined) &&
//   (props.estadoFormulario.requerimento.dataAberturaRequerimento !== null || props.estadoFormulario.requerimento.dataAberturaRequerimento !== undefined));
//   if (isValid) {
//     if ((!existeTipoDocumentoCarregadoNoRequerimento(tipoEmDocumentosProbatorios) &&
//     dateAberturaRequerimentoParam <= dateAberturaRequerimentoObject) ||
//     (dateAberturaRequerimentoParam > dateAberturaRequerimentoObject)) {
//       return isValid;
//     }
//   }
//   return !isValid;
// };
var verificaSeCampoDesabilitado=function verificaSeCampoDesabilitado(name){var _props=Object.assign({},props),acao=_props.acao;var _props$estadoFormular=Object.assign({},props.estadoFormulario),isObtidoPelaRFB=_props$estadoFormular.isObtidoPelaRFB;// const tipoEmDocumentosProbatorios = 2;
if(!['cumprir-exigencia','novo','realizar-analise','qualificar','indeferidos'].includes(acao)){if(acao==='complementar-aposentadoria'){if((name==='dataIngresso'||name==='dataDesvinculacao')&&props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps'])){return true;}if(name==='tempoContribuicaoRegimeOrigemDias'&&props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps'])){if(props.estadoFormulario.requerimento.alteracaoTempoRO){return false;}return true;}if(name==='dataHomologacaoTribunalContas'&&props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps'])){// if (isDataHomologacaoTribunalContasValid(tipoEmDocumentosProbatorios, dateAberturaRequerimentoObject)) {
return false;// }
}if(name==='alteracaoManualTempoRo'&&props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps'])){return false;}if(name==='ctcEspecifica'&&props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps'])){return false;}}return true;}if(acao==='qualificar'){if((name==='sexo'||name==='nit')&&isObtidoPelaRFB===true&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp','requerer-compensacao-rpps','analisar-compensacao-rpps'])){return false;}return name!=='cpf';}if(acao==='indeferidos'){var _props$estadoFormular2=Object.assign({},props.estadoFormulario),isRmiZerada=_props$estadoFormular2.isRmiZerada;if((name==='sexo'||name==='nit')&&isObtidoPelaRFB===true&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp','requerer-compensacao-rpps','analisar-compensacao-rpps'])){return false;}if(['matricula'].includes(name)&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps'])||isRmiZerada&&name==='rendaMensalInicial'&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps'])){return false;}if(['matricula','tipoAposentadoria','dataInicioBeneficio','dataInicioPagamentoBeneficio','dataCessacaoBeneficio','tempoContribuicaoTotalDias','rendaMensalInicial','dataHomologacaoTribunalContas'].includes(name)&&props.auth.checkPermission(['analisar-compensacao-rpps','requerer-compensacao-rpps'])){return false;}if(name==='tempoContribuicaoTotalDias'&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){return false;}if(name==='tempoContribuicaoRegimeOrigemDias'&&props.auth.checkPermission(['analisar-compensacao-rpps','requerer-compensacao-rpps','requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){if(props.estadoFormulario.requerimento.alteracaoTempoRO){return false;}return true;}if(name==='alteracaoManualTempoRo'&&props.auth.checkPermission(['analisar-compensacao-rpps','requerer-compensacao-rpps','requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){return false;}if(name==='ctcEspecifica'&&props.auth.checkPermission(['analisar-compensacao-rpps','requerer-compensacao-rpps','requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){return false;}if((name==='dataIngresso'||name==='dataDesvinculacao')&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rpps','gerenciar-negocio-dcomp'])){return true;}if(name==='motivoCessacaoManual'){var _r=props.estadoFormulario.requerimento;var cnpjUsuarioLogado=__WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().cnpjDoPapel();var cnpjSolicitante=_r.solicitante?_r.solicitante.cnpj:null;var isRGPS=__WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().isRGPS();if(cnpjUsuarioLogado===cnpjSolicitante||_r.solicitante&&_r.solicitante.codigo==='01000'&&isRGPS){return false;}return true;}return true;}if(acao==='realizar-analise'){if(props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){if(props.estadoFormulario.requerimento.dataMigracao!==null){return!camposHabilitadosParaAlteracaoNaAnalise.includes(name);}var _props$estadoFormular3=Object.assign({},props.estadoFormulario),habilitarCamposParaAlteracaoNaAnalise=_props$estadoFormular3.habilitarCamposParaAlteracaoNaAnalise;if(camposHabilitadosParaAlteracaoNaAnalise.includes(name)&&habilitarCamposParaAlteracaoNaAnalise){return false;}}return true;}if(acao==='cumprir-exigencia'){if((name==='sexo'||name==='nit')&&isObtidoPelaRFB===true&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp','requerer-compensacao-rpps','analisar-compensacao-rpps'])){return false;}if(name==='tempoContribuicaoTotalDias'&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){return false;}if(name==='rendaMensalInicial'&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp','requerer-compensacao-rpps','analisar-compensacao-rpps'])){var _props$estadoFormular4=Object.assign({},props.estadoFormulario),_isRmiZerada=_props$estadoFormular4.isRmiZerada,rendaMensalInicialRequest=_props$estadoFormular4.rendaMensalInicialRequest;if(_isRmiZerada===true||rendaMensalInicialRequest!==null&&rendaMensalInicialRequest===0){return false;}}if((name==='dataIngresso'||name==='dataDesvinculacao')&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rpps','gerenciar-negocio-dcomp'])){return true;}if(name==='tempoContribuicaoRegimeOrigemDias'&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rpps','gerenciar-negocio-dcomp'])){if(props.estadoFormulario.requerimento.alteracaoTempoRO){return false;}return true;}if(name==='motivoCessacaoManual'){var req=props.estadoFormulario.requerimento;var _isRGPS=__WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().isRGPS();if(_isRGPS){if(req&&req.tipoAposentadoria===null){return true;}}return false;}return camposDesabilitadosAlteracaoRequerimento.includes(name)||props.camposCnis.includes(name)||props.camposCentralService.includes(name)&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp']);}if(acao==='novo'){if((name==='sexo'||name==='nit')&&isObtidoPelaRFB===true&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp','requerer-compensacao-rpps','analisar-compensacao-rpps'])){return false;}if(name==='tempoContribuicaoTotalDias'&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){return false;}if(name==='rendaMensalInicial'&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){var _props$estadoFormular5=Object.assign({},props.estadoFormulario),_isRmiZerada2=_props$estadoFormular5.isRmiZerada,_rendaMensalInicialRequest=_props$estadoFormular5.rendaMensalInicialRequest;if(_isRmiZerada2===true||_rendaMensalInicialRequest!==null&&_rendaMensalInicialRequest===0){return false;}}if((name==='dataIngresso'||name==='dataDesvinculacao')&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rpps','gerenciar-negocio-dcomp'])){return true;}if(name==='tempoContribuicaoRegimeOrigemDias'&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rpps','gerenciar-negocio-dcomp'])){if(props.estadoFormulario.requerimento.alteracaoTempoRO){return false;}return true;}if(name==='motivoCessacaoManual'){var _req=props.estadoFormulario.requerimento;var _isRGPS2=__WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().isRGPS();if(_isRGPS2){// habilita mesmo se a data de cessacao nao estiver preenchida pois ela pode vir vazia do central service
if(_req&&_req.tipoAposentadoria===null){return true;}}return false;}return props.camposCnis.includes(name)||props.camposCentralService.includes(name)&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp']);}return false;};var handleDocuments=function handleDocuments(){var documentos=[];if(props.estadoFormulario.requerimento.documentosProbatorios&&props.estadoFormulario.requerimento.documentosProbatorios.length>0){documentos=props.estadoFormulario.requerimento.documentosProbatorios.map(function(docs){return{key:docs.codigo,documentType:docs.tipoDocumento};});}return documentos;};var acao={MARCAR:'marcar',DESMARCAR:'desmarcar'};var checkedTempoRO=props.estadoFormulario.requerimento.alteracaoTempoRO===1;var checkedCtcEspecifica=props.estadoFormulario.requerimento.ctcEspecifica===1;var clicouTempoRO=checkedTempoRO?acao.DESMARCAR:acao.MARCAR;var clicouCtcEspecifica=checkedCtcEspecifica?acao.DESMARCAR:acao.MARCAR;var r=props.estadoFormulario.requerimento;var temMotivo=r&&r.motivoCessacaoManual!=null;var temData=r&&r.dataCessacaoBeneficio!=null;var estadosAnalise=[4,5,10];// Aguardando Análise, Médico, Suspensa
var estadosFinalizados=[8,11,12];// Deferido, Em Compensação, Compensado
var estadosPermitidos=[4,5,8,10,11,12];var ambosVazios=!temData&&!temMotivo;var exibirLapisDataCessacao=r&&r.solicitante&&props.estadoFormulario.acao==='consulta'&&// pode só incluir data (não alterar)
estadosAnalise.includes(r.estado)&&!temData&&(r.solicitante.cnpj===__WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().cnpjDoPapel()||r.solicitante.codigo==='01000'&&__WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().isRGPS());// se ele ja tiver mexido em motivo de cessação e estiver nos estados previstos (em compensacao, compensado, deferido), nao deixa editar
// O motivo de cessação automática por óbito (CNIS) não poderá ser alterado pelo usuário para os estados permitidos. 12 é o codigo de cessacao pelo CNIS
var hasHistoricoBloqueante=function hasHistoricoBloqueante(){return[8,11,12].includes(r.estado)&&(!r.dataCessacaoBeneficio||(r.historicoAuditorias||[]).some(function(a){return a.codigo===36;}))||estadosPermitidos.includes(r.estado)&&(r.historicoAuditorias||[]).some(function(a){return a.codigo===17;})&&props.estadoFormulario&&props.estadoFormulario.requerimento&&props.estadoFormulario.requerimento.motivoCessacaoManual===12;};var exibirLapisMotivo=r&&r.solicitante&&props.estadoFormulario.acao==='consulta'&&(//  ambos vazios, exibe o lapis para permitir edição dos dois ao mesmo tempo
estadosPermitidos.includes(r.estado)&&ambosVazios&&!hasHistoricoBloqueante()||//  REGRA 2: só incluir motivo (não pode alterar)
estadosAnalise.includes(r.estado)&&temData&&!temMotivo||// REGRA 4: incluir/alterar uma única vez (controlado por histórico)
estadosFinalizados.includes(r.estado)&&temData&&!hasHistoricoBloqueante())&&(r.solicitante.cnpj===__WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().cnpjDoPapel()||r.solicitante.codigo==='01000'&&__WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().isRGPS());var toggleCheckbox=function toggleCheckbox(acaoToggle,nome){var changeObj={};var historyCheckTempoRO=void 0;if(acaoToggle===acao.DESMARCAR){changeObj.value=0;historyCheckTempoRO=1;}else{changeObj.value=1;historyCheckTempoRO=0;}if(nome==='alteracaoManualTempoRo'){if(changeObj.value===0){if(props.estadoFormulario.acao==='novo'){props.atualizarTempoRO(props.estadoFormulario.historyTempoRO);}else{props.handleModalTempoRO();}}props.handleChangeTempoROManual(changeObj,historyCheckTempoRO);}else{props.handleChangeCtcEspecifica(changeObj);}};var verificaAcaoExibicaoBotaoPesquisarCTC=function verificaAcaoExibicaoBotaoPesquisarCTC(){// return !['consulta', 'realizar-analise','qualificar'].includes(props.estadoFormulario.acao);
switch(props.estadoFormulario.acao){case'realizar-analise':return false;case'consulta':return false;case'emitir-parecer-medico':return false;default:break;}return props.estadoFormulario.requerimento.destinatario&&props.estadoFormulario.requerimento.destinatario==='01000'||props.estadoFormulario.requerimento.destinatario&&props.estadoFormulario.requerimento.destinatario.codigo==='01000';};var verificarTamanhoInput=function verificarTamanhoInput(){var retorno='4 4 4 4';if(verificaAcaoExibicaoBotaoPesquisarCTC()){retorno='3 3 3 3';}return retorno;};var pesquisar=void 0;var exibirElosNIT=void 0;var pesquisarNB=void 0;var checkExigirQualificacaoCPF=void 0;var botaoAlterarDataCessacao=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["g" /* DtpButtonIcon */],{icon:'ico-pencil',className:'icone',accessibilityName:'Alterar data de cessa\xE7\xE3o',onClick:function onClick(){if(!temData&&!temMotivo){props.handleModalAlteraDataEMotivoCessacao();}else{props.handleModalAlteraDataCessacao('dataCessacao');}},hint:props.estadoFormulario.requerimento.dataCessacaoBeneficio!=null?'Alterar data de cessação':'Incluir data de cessação'});var botaoAlterarMotivoCessacao=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["g" /* DtpButtonIcon */],{icon:'ico-pencil',className:'icone',accessibilityName:'Alterar motivo de cessa\xE7\xE3o',onClick:function onClick(){if(!temData&&!temMotivo){props.handleModalAlteraDataEMotivoCessacao();}else{props.handleModalAlteraMotivoCessacao('motivoCessacao');}},hint:props.estadoFormulario.requerimento.motivoCessacaoManual!=null?'Alterar motivo de cessação':'Incluir motivo de cessação'});if(['novo','cumprir-exigencia','qualificar','indeferidos'].includes(props.estadoFormulario.acao)){pesquisar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["a" /* Button */],{title:'Pesquisar',onClick:function onClick(){return props.handleSearchButton();},hint:'Pesquisar dados pessoais'});pesquisarNB=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["a" /* Button */],{title:'Pesquisar benef\xEDcio',onClick:function onClick(){return props.handleSearchNBButton();},hint:'Pesquisar benef\xEDcio'});}if(['novo','realizar-analise','consulta','indeferidos','cumprir-exigencia'].includes(props.estadoFormulario.acao)){exibirElosNIT=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["g" /* DtpButtonIcon */],{icon:'ico-link',accessibilityName:'Exibir NIT\'s elados',onClick:function onClick(){return props.handlePesquisaBotaoEloNit();},hint:'Exibir NIT\'s elados'}));}if(props.estadoFormulario.acao==='indeferidos'){checkExigirQualificacaoCPF=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{id:'checkExigirQualificacaoCPF',label:'Necess\xE1ria altera\xE7\xE3o do CPF via qualifica\xE7\xE3o',name:'checkExigirQualificacaoCPF',onChange:function onChange(e){return props.handleChangeExigirQualificacao(e);},check:true,value:props.estadoFormulario.checkExigirQualificacao});}var resultadoAnalise=void 0;if(props.estadoFormulario.acao==='realizar-analise'){resultadoAnalise=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-compensacao-rgps','analisar-compensacao-rpps','gerenciar-negocio-dcomp']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ResultadoAnalise__["a" /* default */],{alteraEstado:props.alteraEstadoRequerimento,handleChange:props.handleChange,requerimento:props.estadoFormulario.requerimento,userData:props.auth.userData,vinculosConcomitantesConfirmado:props.vinculosConcomitantesConfirmado,possuiVinculosConcomitantes:props.possuiVinculosConcomitantes,clickVinculosTab:props.clickVinculosTab,tipoRequerimento:props.estadoFormulario.tipoRequerimento,inIndefericaoAnalise:props.estadoFormulario.inIndefericaoAnalise,atualizarDocumentosProbatorios:props.atualizarDocumentosProbatorios,motivosIndeferimentoControle:props.estadoFormulario.motivosIndeferimentoControle,validacaoDeVinculosConcomitantes:props.validacaoDeVinculosConcomitantes,atualizarVinculosConcomitantesConfirmado:props.atualizarVinculosConcomitantesConfirmado,handleChangeFile:props.handleChangeFile,handleChangeTipoDocumento:props.handleChangeTipoDocumento,tipoDocumento:props.estadoFormulario.tipoDocumento}));}if(props.estadoFormulario.acao==='emitir-parecer-medico'){resultadoAnalise=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['fornecer-parecer-medico-rpps']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["e" /* DataGrid */],{title:'An\xE1lise',icon:'ico-process-check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{label:'Invalidez acident\xE1ria',itemList:__WEBPACK_IMPORTED_MODULE_11__utils_listsSelect__["t" /* parecerMedico */],placeholder:'Selecione a op\xE7\xE3o',value:props.estadoFormulario.requerimento.invalidezAcidentaria,onChange:function onChange(e){return props.handleChange(e,'invalidezAcidentaria');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{label:getLabelParecerMedico(),itemList:__WEBPACK_IMPORTED_MODULE_11__utils_listsSelect__["t" /* parecerMedico */],placeholder:'Selecione a op\xE7\xE3o',value:props.estadoFormulario.requerimento.enquadraArtigo151Lei8213,onChange:function onChange(e){return props.handleChange(e,'enquadraArtigo151Lei8213');}})))));}var cumprimentoExigencia=void 0;if(_this.props&&_this.props.estadoFormulario.requerimento.estadoAtual===2){cumprimentoExigencia=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__CumprimentoExigencia__["a" /* default */],{handleChange:_this.props.handleChange,requerimento:_this.props.estadoFormulario.requerimento});}var documentosProbatorios=void 0;if(props.tiposDocumentos.length>0){documentosProbatorios=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["b" /* ControleDocumentos */],{tiposDocumentos:props.tiposDocumentos,documents:handleDocuments(),protocolo:props.match.params.protocolo,auth:props.auth,acao:props.acao,requerimento:props.estadoFormulario.requerimento,atualizarDocumentosProbatorios:props.atualizarDocumentosProbatorios,tipoRequerimento:props.estadoFormulario.tipoRequerimento});}var calculoCompensacao=void 0;if(props.estadoFormulario.acao==='consulta'){calculoCompensacao=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CalculoCompensacao__["a" /* default */],{handleChange:props.handleChange,requerimento:props.estadoFormulario.requerimento});}var filterMotivos=function filterMotivos(lista,requerimento,tipo){var motivosCessacaoFiltrado=[];var codigoTipo=tipo==='aposentadoria'?1:2;var inss='01000';var destinatarioOuSolicitanteRGPS=false;var regimes=[2,3];var isRGPS=__WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().isRGPS();if(requerimento.solicitante&&requerimento.destinatario){destinatarioOuSolicitanteRGPS=[requerimento.solicitante.codigo,requerimento.destinatario.codigo].includes(inss);if(requerimento.solicitante.codigo===inss){regimes=[1,3];}}else if(!requerimento.solicitante){if(props.estadoFormulario.acao==='novo'&&isRGPS){destinatarioOuSolicitanteRGPS=true;regimes=[1,3];}}var acordos=destinatarioOuSolicitanteRGPS?[1,3]:[2,3];motivosCessacaoFiltrado=lista.filter(function(motivo){return motivo.abrangenciaAplicavel===codigoTipo&&regimes.includes(motivo.regimeAplicavel)&&acordos.includes(motivo.acordoAplicavel);});motivosCessacaoFiltrado=motivosCessacaoFiltrado.filter(function(motivo){return motivo.value!==MOTIVO_CAPACIDADE_SEGURADO;});if(isRGPS&&requerimento.tipoAposentadoria!==APOSENTADORIA_POR_INVALIDEZ){motivosCessacaoFiltrado=motivosCessacaoFiltrado.filter(function(motivo){return motivo.value!==MOTIVO_REVERSAO;});}var motivoAtual=requerimento.motivoCessacaoManual;var motivoValido=motivosCessacaoFiltrado.some(function(m){return m.value===motivoAtual;});if(motivoAtual!=null&&!motivoValido){/* eslint-disable no-param-reassign */requerimento.motivoCessacaoManual=null;}return motivosCessacaoFiltrado;};var isMotivoCessacaoManualPreenchido=function isMotivoCessacaoManualPreenchido(){return props.estadoFormulario.requerimento.motivoCessacaoManual!==null&&props.estadoFormulario.requerimento.motivoCessacaoManual!==''&&props.estadoFormulario.requerimento.motivoCessacaoManual!==undefined;};var motivo=props.estadoFormulario.requerimento.motivoCessacaoManual;var data=props.estadoFormulario.requerimento.dataCessacaoBeneficio;var temData1=data!==null&&data!==undefined&&data!=='';var temMotivo1=motivo!==null&&motivo!==undefined&&motivo!=='';// IB499614
var exibirComboBox=function exibirComboBox(nomeCombobox){var retorno=false;var listaAcoes=['realizar-analise','novo','cumprir-exigencia','indeferidos','consulta'];switch(nomeCombobox){case'motivoCessacaoManual'://  para casos de novo requerimento, reabertura e alteracao
if(listaAcoes.includes(props.estadoFormulario.acao)){retorno=true;}break;default:break;}return retorno;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.acao!=='indeferidos'&&props.acao!=='cumprir-exigencia'&&props.acao!=='novo'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SolicitanteDestinatario__["a" /* default */],{requerimento:props.estadoFormulario.requerimento}),props.estadoFormulario.requerimento.solicitanteOrigem&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["e" /* DataGrid */],{title:'Detalhes do Solicitante',icon:'ico-user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:true,label:'Solicitante de Origem',value:props.estadoFormulario.requerimento.solicitanteOrigem.nome,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:true,label:'C\xF3digo do Solicitante',value:props.estadoFormulario.requerimento.solicitanteOrigem.codigo,required:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["e" /* DataGrid */],{title:'Dados Pessoais',icon:'ico-user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{cpf:true,disabled:verificaSeCampoDesabilitado('cpf'),integer:true,error:!props.estadoFormulario.validadeCampos.cpf,touched:props.estadoFormulario.touched||props.estadoFormulario.cpfTouched,label:'CPF',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].cpf,value:props.estadoFormulario.requerimento.cpf,onChange:function onChange(e){return props.handleChange(e,'cpf');},showMask:true,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'2 2 2 2'},pesquisar),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-tooltip':'Ao selecionar esta op\xE7\xE3o, o requerimento ser\xE1 enviado para exig\xEAncia / prazo para alterar o CPF.','data-tooltip-position':'bottom'},checkExigirQualificacaoCPF)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('nome'),error:!props.estadoFormulario.validadeCampos.nome,label:'Nome',maxLength:'100',onChange:function onChange(e){return props.handleChange(e,'nome');},value:props.estadoFormulario.requerimento.nome})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('nit'),error:!props.estadoFormulario.validadeCampos.nit,integer:true,label:'NIT',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].nit,nit:true,onChange:function onChange(e){return props.handleChange(e,'nit');},showMask:true,touched:props.estadoFormulario.touched,value:props.estadoFormulario.requerimento.nit,required:props.estadoFormulario.isObtidoPelaRFB}),['novo','realizar-analise','consulta','indeferidos','cumprir-exigencia'].includes(props.estadoFormulario.acao)&&props.estadoFormulario.requerimento.nit!==null&&props.estadoFormulario.requerimento.elos&&props.estadoFormulario.requerimento.elos.length!==0?exibirElosNIT:' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataNascimento'),error:!props.estadoFormulario.validadeCampos.dataNascimento,touched:props.estadoFormulario.touched,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,label:'Data de Nascimento',value:props.estadoFormulario.requerimento.dataNascimento,onChange:function onChange(e){return props.handleChange(e,'dataNascimento');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('sexo'),error:!props.estadoFormulario.validadeCampos.sexo,number:true,itemList:__WEBPACK_IMPORTED_MODULE_11__utils_listsSelect__["z" /* sexo */],label:'Sexo',onChange:function onChange(e){return props.handleChange(e,'sexo');},placeholder:'Selecione o sexo',touched:props.estadoFormulario.touched,value:props.estadoFormulario.requerimento.sexo,custom:true,required:props.estadoFormulario.isObtidoPelaRFB})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('nomeMae'),error:!props.estadoFormulario.validadeCampos.nomeMae,label:'Nome da M\xE3e',maxLength:'100',onChange:function onChange(e){return props.handleChange(e,'nomeMae');},value:props.estadoFormulario.requerimento.nomeMae})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},isSolicitanteRPPS()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('matricula')// error={props.estadoFormulario.validadeCampos.matricula}
,error:'matricula'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.matricula:false,label:'Matr\xEDcula Regime Instituidor',maxLength:'11',onChange:function onChange(e){return props.handleChange(e,'matricula');},touched:props.estadoFormulario.touched,value:props.estadoFormulario.requerimento.matricula,integer:true,required:true})))),props.entesControlados.length>0&&props.enteDoUsuario&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["e" /* DataGrid */],{title:'Detalhes do Solicitante',icon:'ico-user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{label:'Solicitante de Origem',touched:props.estadoFormulario.touched,placeholder:'Selecione o solicitante',itemList:[{codigo:props.enteDoUsuario.codigo,nome:props.enteDoUsuario.nome,cnpj:__WEBPACK_IMPORTED_MODULE_19__domain_User__["a" /* default */].logged().cnpjDoPapel()}].concat(props.entesControlados).map(function(e){return{value:e.codigo,label:e.nome+' (CNPJ: '+e.cnpj+')'};}),required:true,custom:true,value:props.solicitanteRequerimento,onChange:function onChange(e){if(props.enteDoUsuario.codigo===e.value){props.handleChange({isValid:true,value:null},'solicitanteOrigem');}else{props.handleChange(e,'solicitanteOrigem');}__WEBPACK_IMPORTED_MODULE_7__reducers__["a" /* default */].dispatch({type:'ALTERA_SOLICITANTE_REQUERIMENTO',payload:e.value});}})))),props.acao==='indeferidos'&&props.estadoFormulario.requerimento.solicitante&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Destinacao__["a" /* default */],{requerimento:props.estadoFormulario.requerimento,tipoRequerimento:props.estadoFormulario.tipoRequerimento,handleChange:props.handleChange,calcularTempoRO:props.calcularTempoRO}),props.acao==='cumprir-exigencia'&&props.estadoFormulario.requerimento.solicitante&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DestinacaoExigencia__["a" /* default */],{requerimento:props.estadoFormulario.requerimento,handleChange:props.handleChange,calcularTempoRO:props.calcularTempoRO}),(props.acao==='novo'||props.acao==='salvarERejeitar')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__SelecaoDestinatario__["a" /* default */],{acao:props.estadoFormulario.acao,destinatario:props.estadoFormulario.requerimento.destinatario?props.estadoFormulario.requerimento.destinatario:null,handleChange:props.handleChange,touched:props.estadoFormulario.touched,apagaRegraDeCalculo:props.apagaRegraDeCalculo,calcularTempoRO:props.calcularTempoRO,isRgpsSelecionando:props.auth.checkPermission(['requerer-compensacao-rgps','gerenciar-negocio-dcomp'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["e" /* DataGrid */],{title:'Dados de Benef\xEDcio',icon:'ico-money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:controleCampoAlternativos('numeroBeneficio')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('numeroBeneficio'),error:'numeroBeneficio'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.numeroBeneficio:false,touched:props.estadoFormulario.touched,label:'N\xFAmero de benef\xEDcio',maxLength:'11',integer:true,value:props.estadoFormulario.requerimento.numeroBeneficio,onChange:function onChange(e){return props.handleChange(e,'numeroBeneficio');},required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},pesquisarNB))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('tipoAposentadoria')||!isDestinatarioPreenchido(),label:'Tipo de Aposentadoria',number:true,error:!props.estadoFormulario.validadeCampos.tipoAposentadoria,touched:props.estadoFormulario.touched,placeholder:'Selecione o tipo de Aposentadoria',onChange:function onChange(e){return props.handleChange(e,'tipoAposentadoria');},value:props.estadoFormulario.requerimento.tipoAposentadoria,itemList:isDestinatarioRPPS()?__WEBPACK_IMPORTED_MODULE_11__utils_listsSelect__["C" /* tipoAposentadoriaRPPS */]:__WEBPACK_IMPORTED_MODULE_11__utils_listsSelect__["B" /* tipoAposentadoriaRGPS */],required:true,custom:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:exibirLapisMotivo?'7 7 7 7':'8 8 8 8'},exibirComboBox('motivoCessacaoManual')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('motivoCessacaoManual'),label:'Motivo Cessa\xE7\xE3o',number:true,error:'motivoCessacaoManual'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.motivoCessacaoManual:false,touched:props.estadoFormulario.touched,placeholder:'Selecione o Motivo da Cessa\xE7\xE3o',onChange:function onChange(e){return props.handleChange(e,'motivoCessacaoManual');},value:props.estadoFormulario.requerimento.motivoCessacaoManual,itemList:filterMotivos(props.motivosCessacao,props.estadoFormulario.requerimento,'aposentadoria'),required:temData1,custom:true})),exibirLapisMotivo&&props.acao==='consulta'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:isMotivoCessacaoManualPreenchido?'botao-lapis-motivo-cessacao-verde':'botao-lapis-motivo-cessacao-cinza'},botaoAlterarMotivoCessacao))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataInicioBeneficio'),error:'dataInicioBeneficio'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.dataInicioBeneficio:false,label:'Data de In\xEDcio de Benef\xEDcio',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,value:props.estadoFormulario.requerimento.dataInicioBeneficio,onChange:function onChange(e){return props.handleChange(e,'dataInicioBeneficio');},touched:props.estadoFormulario.touched,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataInicioPagamentoBeneficio'),error:'dataInicioPagamentoBeneficio'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.dataInicioPagamentoBeneficio:false,label:'Data de In\xEDcio de Pagamento',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,value:props.estadoFormulario.requerimento.dataInicioPagamentoBeneficio,onChange:function onChange(e){return props.handleChange(e,'dataInicioPagamentoBeneficio');},touched:props.estadoFormulario.touched})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:exibirLapisDataCessacao?'3 3 3 3':'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataCessacaoBeneficio'),error:'dataCessacaoBeneficio'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.dataCessacaoBeneficio:false,label:'Data de Cessa\xE7\xE3o',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,value:props.estadoFormulario.requerimento.dataCessacaoBeneficio,onChange:function onChange(e){return props.handleChange(e,'dataCessacaoBeneficio');},required:temMotivo1,touched:props.estadoFormulario.touched})),exibirLapisDataCessacao?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'botao-lapis'},botaoAlterarDataCessacao)):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('tempoContribuicaoTotalDias'),error:!props.estadoFormulario.validadeCampos.tempoContribuicaoTotalDias,guide:false,integer:true,label:'Tempo de Contribui\xE7\xE3o Total (dias)',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].integer,maxLength:'6',number:true,onChange:function onChange(e){return props.handleChange(e,'tempoContribuicaoTotalDias');},required:true,touched:props.estadoFormulario.touched,value:props.estadoFormulario.requerimento.tempoContribuicaoTotalDias})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('tempoContribuicaoRegimeOrigemDias'),number:true,integer:true,error:props.estadoFormulario.exigenciasInvalidas.tempoContribuicaoRegimeOrigemDias,touched:props.estadoFormulario.touched,label:'Tempo de Contribui\xE7\xE3o no Reg. de Origem (dias)',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].integer,maxLength:'6',guide:false,value:props.estadoFormulario.requerimento.tempoContribuicaoRegimeOrigemDias,onChange:function onChange(e){return props.handleChange(e,'tempoContribuicaoRegimeOrigemDias');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{currency:true,showMask:false,disabled:verificaSeCampoDesabilitado('rendaMensalInicial'),label:'Renda Mensal Inicial',error:!props.estadoFormulario.validadeCampos.rendaMensalInicial,touched:props.estadoFormulario.touched,maxLength:'16',value:props.estadoFormulario.requerimento.rendaMensalInicial,required:true,onChange:function onChange(e){return props.handleChange(e,'rendaMensalInicial');},onKeyUp:function onKeyUp(e){return props.handleKeyUp(e,'rendaMensalInicial');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataIngresso')// required={!props.estadoFormulario.habilitarCamposParaAlteracaoNaAnalise}
,error:props.estadoFormulario.exigenciasInvalidas.dataIngresso,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,label:'Data de ingresso no regime de origem',onChange:function onChange(e){return props.handleChange(e,'dataIngresso');},value:props.estadoFormulario.requerimento.dataIngresso,touched:props.estadoFormulario.touched})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataDesvinculacao')// required={!props.estadoFormulario.habilitarCamposParaAlteracaoNaAnalise}
,error:props.estadoFormulario.exigenciasInvalidas.dataDesvinculacao,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,label:'Data de desvincula\xE7\xE3o no regime de origem',onChange:function onChange(e){return props.handleChange(e,'dataDesvinculacao');},value:props.estadoFormulario.requerimento.dataDesvinculacao,touched:props.estadoFormulario.touched})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:controleCampoAlternativos('dataCreditoPagamento')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataCreditoPagamento'),error:'dataCreditoPagamento'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.dataCreditoPagamento:false,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,label:'Data de Cr\xE9dito do Pagamento',onChange:function onChange(e){return props.handleChange(e,'dataCreditoPagamento');},value:props.estadoFormulario.requerimento.dataCreditoPagamento,touched:props.estadoFormulario.touched})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:controleCampoAlternativos('dataHomologacaoTribunalContas')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataHomologacaoTribunalContas'),error:'dataHomologacaoTribunalContas'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.dataHomologacaoTribunalContas:false,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,label:'Data de Homologa\xE7\xE3o no Tribunal de Contas',onChange:function onChange(e){return props.handleChange(e,'dataHomologacaoTribunalContas');},value:props.estadoFormulario.requerimento.dataHomologacaoTribunalContas,touched:props.estadoFormulario.touched})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},props.estadoFormulario.exibirCampoUoInss?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:true,label:'UO INSS',value:props.estadoFormulario.requerimento.idUOMantenedora,touched:props.estadoFormulario.touched,required:true})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:controleCampoAlternativos('idUOMantenedora')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:true,label:'UO INSS',value:props.estadoFormulario.requerimento.idUOMantenedora,touched:props.estadoFormulario.touched,required:true}))),isDestinatarioRPPS()&&isSolicitanteRPPS()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* Input */],{disabled:['realizar-analise','consulta'].includes(props.estadoFormulario.acao),error:'regraDeCalculo'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.regraDeCalculo:false,label:'Regra de C\xE1lculo',itemList:__WEBPACK_IMPORTED_MODULE_11__utils_listsSelect__["x" /* regrasDeCalculo */],onChange:function onChange(e){return props.handleChange(e,'regraDeCalculo');},value:props.estadoFormulario.requerimento.regraDeCalculo,touched:props.estadoFormulario.touched,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__SegregacaoDeMassa__["a" /* default */],{estadoFormulario:props.estadoFormulario,handleChange:props.handleChange,handleModalAlteraSegregacaoMassa:props.handleModalAlteraSegregacaoMassa,tipoSegregacaoDestinatario:props.estadoFormulario.requerimento.tipoSegregacaoDestinatario,tipoSegregacaoSolicitante:props.estadoFormulario.requerimento.tipoSegregacaoSolicitante})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ProtocoloCertidao__["a" /* default */],{estadoFormulario:props.estadoFormulario,handleChange:props.handleChange,handleChangeProtocoloNaoConstaOuIlegivel:props.handleChangeProtocoloNaoConstaOuIlegivel,handleSearchPeriodos:props.handleSearchPeriodos,verificaAcaoExibicaoBotaoPesquisarCTC:verificaAcaoExibicaoBotaoPesquisarCTC}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:verificarTamanhoInput()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:props.estadoFormulario.requerimento.alteracaoTempoRO,key:'alteracaoManualTempoRo',label:'Altera\xE7\xE3o manual de tempo RO',type:'checkbox',checked:checkedTempoRO,onClick:function onClick(){return toggleCheckbox(clicouTempoRO,'alteracaoManualTempoRo');},style:{paddingLeft:'5px',position:'relative',top:'20px'},disabled:verificaSeCampoDesabilitado('alteracaoManualTempoRo')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingLeft:'5px',position:'relative',top:'19px'}},'Altera\xE7\xE3o manual de tempo RO')),isExibirCtcEspecifica()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:props.estadoFormulario.requerimento.ctcEspecifica,key:'ctcEspecifica',label:'CTC Espec\xEDfica',type:'checkbox',checked:checkedCtcEspecifica,onClick:function onClick(){return toggleCheckbox(clicouCtcEspecifica,'ctcEspecifica');},style:{paddingLeft:'5px',position:'relative',top:'20px'},disabled:verificaSeCampoDesabilitado('ctcEspecifica')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingLeft:'5px',position:'relative',top:'19px'}},'CTC Espec\xEDfica')):'')),props.estadoFormulario.exibirMultiplosPeriodos&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__MultiplosPeriodos__["a" /* default */],{estadoFormulario:props.estadoFormulario,handleChange:props.handleChange,atualizarDataIngressoDesvinculacaoETempo:props.atualizarDataIngressoDesvinculacaoETempo,ordenarListaPeriodos:props.ordenarListaPeriodos,determinarConcomitancias:props.determinarConcomitancias,calcularPeriodoRgps:props.calcularPeriodoRgps,calcularPeriodoRpps:props.calcularPeriodoRpps}),['novo','criado','indeferidos','cumprir-exigencia'].includes(props.estadoFormulario.acao)||props.exibirUploadArquivosNaConsulta?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__UploadArquivos__["a" /* default */],{acao:props.estadoFormulario.acao,arquivos:props.estadoFormulario.requerimento.arquivos?[].concat(_toConsumableArray(props.estadoFormulario.requerimento.arquivos)):[],estadoFormulario:props.estadoFormulario.estadoFormulario,handleChange:function handleChange(e){return props.handleChange(e,'arquivos');},auth:props.auth,tipoRequerimento:props.estadoFormulario.tipoRequerimento,tiposDocumentos:props.tiposDocumentos,requerimento:props.estadoFormulario.requerimento,listaExigencias:props.estadoFormulario.exigenciasOriginais?props.estadoFormulario.exigenciasOriginais:[],temBloqueioAtivoContratoDtp:props.temBloqueioAtivoContratoDtp}):'',props.estadoFormulario.acao==='novo'||props.estadoFormulario.acao==='criado'||props.estadoFormulario.acao==='indeferidos'||props.exibirModalCadeiaDeNit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__ModalCadeiaDeNit__["a" /* default */],{acao:props.estadoFormulario.acao,estadoFormulario:props.estadoFormulario.estadoFormulario,nit:props.estadoFormulario.requerimento.nit,elos:props.estadoFormulario.requerimento.elos,handleModal:function handleModal(){return props.handleModalCadeiaDeNitModal();},showModal:props.exibirModalCadeiaDeNit,dataMigracao:props.estadoFormulario.requerimento.dataMigracao}):'',props.exibirModalDataCessacao?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ModalAlteracaoDataCessacao__["a" /* default */],{acao:props.estadoFormulario.acao,protocolo:props.estadoFormulario.requerimento.protocolo,dataCessacaoBeneficio:props.estadoFormulario.requerimento.dataCessacaoBeneficio,handleModal:function handleModal(){return props.handleModalAlteraDataCessacao();},showModal:props.exibirModalDataCessacao,tipoRequerimento:props.estadoFormulario.tipoRequerimento,atualizarDataCessacao:props.atualizarDataCessacao,atualizarMotivoCessacao:props.atualizarMotivoCessacao,estadoFormulario:props.estadoFormulario}):'',props.exibirModalMotivoCessacao?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__ModalAlteracaoMotivoCessacao__["a" /* default */],{acao:props.estadoFormulario.acao,protocolo:props.estadoFormulario.requerimento.protocolo,motivoCessacaoManual:props.estadoFormulario.requerimento.motivoCessacaoManual,handleModal:function handleModal(){return props.handleModalAlteraMotivoCessacao();},showModal:props.exibirModalMotivoCessacao,atualizarMotivoCessacao:props.atualizarMotivoCessacao,atualizarHistoricoAuditorias:props.atualizarHistoricoAuditorias,estadoFormulario:props.estadoFormulario,handleChange:props.handleChange}):'',props.exibirModalDataEMotivoCessacao?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModalAlteracaoDataEMotivoCessacao__["a" /* default */],{acao:props.estadoFormulario.acao,protocolo:props.estadoFormulario.requerimento.protocolo,motivoCessacaoManual:props.estadoFormulario.requerimento.motivoCessacaoManual,dataCessacaoBeneficio:props.estadoFormulario.requerimento.dataCessacaoBeneficio,handleChange:props.handleChange,showModal:props.exibirModalDataEMotivoCessacao,estadoFormulario:props.estadoFormulario,atualizarMotivoCessacao:props.atualizarMotivoCessacao,atualizarDataCessacao:props.atualizarDataCessacao,atualizarHistoricoAuditorias:props.atualizarHistoricoAuditorias,handleModal:function handleModal(){return props.handleModalAlteraDataEMotivoCessacao();}}):'',props.exibirModalSegregacaoMassa?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__ModalAlteracaoSegregacaoMassa__["a" /* default */],{acao:props.estadoFormulario.acao,protocolo:props.estadoFormulario.requerimento.protocolo,tipoSegregacaoDestinatario:props.estadoFormulario.requerimento.tipoSegregacaoDestinatario,tipoSegregacaoSolicitante:props.estadoFormulario.requerimento.tipoSegregacaoSolicitante,handleModal:function handleModal(){return props.handleModalAlteraSegregacaoMassa();},showModal:props.exibirModalSegregacaoMassa,tipoRequerimento:props.estadoFormulario.tipoRequerimento,atualizarTipoSegregacaoMassaDestinatario:props.atualizarTipoSegregacaoMassaDestinatario,atualizarTipoSegregacaoMassaSolicitante:props.atualizarTipoSegregacaoMassaSolicitante,origem:props.estadoFormulario.origemModalSegregacaoMassa}):'',calculoCompensacao,documentosProbatorios,resultadoAnalise,cumprimentoExigencia);};DadosRequerimentoAposentadoria.propTypes={entesControlados:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object).isRequired,enteDoUsuario:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string).isRequired,solicitanteRequerimento:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,acao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,alteraEstadoRequerimento:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,auth:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object).isRequired,camposCnis:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string).isRequired,camposCentralService:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string).isRequired,estadoFormulario:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleChangeExigirQualificacao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleChangeTempoROManual:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleChangeCtcEspecifica:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleChangeProtocoloNaoConstaOuIlegivel:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleKeyUp:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleSearchButton:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handlePesquisaBotaoEloNit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleModalCadeiaDeNitModal:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleModalAlteraDataCessacao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleModalAlteraDataEMotivoCessacao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleModalAlteraMotivoCessacao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleModalAlteraSegregacaoMassa:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleSearchNBButton:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,apagaRegraDeCalculo:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,vinculosConcomitantesConfirmado:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,possuiVinculosConcomitantes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,clickVinculosTab:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,exibirUploadArquivosNaConsulta:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,exibirModalCadeiaDeNit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,exibirModalDataCessacao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,exibirModalMotivoCessacao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,exibirModalDataEMotivoCessacao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,exibirModalSegregacaoMassa:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,atualizarDataCessacao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,atualizarMotivoCessacao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,atualizarHistoricoAuditorias:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,atualizarTipoSegregacaoMassaDestinatario:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,atualizarTipoSegregacaoMassaSolicitante:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleSearchPeriodos:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,atualizarDataIngressoDesvinculacaoETempo:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,determinarConcomitancias:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,ordenarListaPeriodos:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,calcularPeriodoRgps:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,calcularPeriodoRpps:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,calcularTempoRO:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,atualizarTempoRO:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleModalTempoRO:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,validacaoDeVinculosConcomitantes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,atualizarVinculosConcomitantesConfirmado:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,match:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string})}),tiposDocumentos:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string})),atualizarDocumentosProbatorios:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,temBloqueioAtivoContratoDtp:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,handleChangeFile:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,handleChangeTipoDocumento:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,motivosCessacao:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string}))};DadosRequerimentoAposentadoria.defaultProps={match:null,tiposDocumentos:[],motivosCessacao:null};var mapStateToProps=function mapStateToProps(state){return{entesControlados:state.base.entesControlados,enteDoUsuario:state.base.enteDoUsuario,solicitanteRequerimento:state.base.solicitanteRequerimento,motivosCessacao:state.base.motivosCessacao};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(DadosRequerimentoAposentadoria));

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAlteracaoDataEMotivoCessacao=function(_Component){_inherits(ModalAlteracaoDataEMotivoCessacao,_Component);function ModalAlteracaoDataEMotivoCessacao(props,context){_classCallCheck(this,ModalAlteracaoDataEMotivoCessacao);var _this=_possibleConstructorReturn(this,(ModalAlteracaoDataEMotivoCessacao.__proto__||Object.getPrototypeOf(ModalAlteracaoDataEMotivoCessacao)).call(this,props,context));_this.getInitialState=function(){return{motivoCessacaoManual:_this.props.motivoCessacaoManual,dataCessacaoBeneficio:_this.props.dataCessacaoBeneficio,touched:false};};_this.checkIfFileCanBeSent=function(){return _this.state.dataCessacaoBeneficio&&(_this.state.motivoCessacaoManual||_this.state.motivoCessacaoManual==='');};_this.diffRequerimento=function(){var _this$props=Object.assign({},_this.props),tipoRequerimento=_this$props.tipoRequerimento;if(tipoRequerimento===2){return'pensao';}return'aposentadoria';};_this.handleSave=function(){var tipo=_this.diffRequerimento();var url='alterar-data-cessacao-requerimento-'+tipo;var _this$props2=Object.assign({},_this.props),protocolo=_this$props2.protocolo;var _this$state=Object.assign({},_this.state),dataCessacaoBeneficio=_this$state.dataCessacaoBeneficio;var _this$state2=Object.assign({},_this.state),motivoCessacaoManual=_this$state2.motivoCessacaoManual;var objProtocolo=protocolo;var objMotivoCessacaoManual=motivoCessacaoManual;if(objMotivoCessacaoManual===''){objMotivoCessacaoManual=null;}var objAlteracao={protocolo:objProtocolo,motivoCessacaoManual:objMotivoCessacaoManual,dataCessacao:dataCessacaoBeneficio};var options=void 0;if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["n" /* doPut */])(url,objAlteracao,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,options);};_this.trataSucessoResponseEnvio=function(){_this.handleClose();_this.props.atualizarDataCessacao(_this.state.dataCessacaoBeneficio);_this.props.atualizarMotivoCessacao(_this.state.motivoCessacaoManual);// Adiciona o histórico para bloquear o lápis
var novoHistorico={descricao:'Informação de data e motivo de cessação'};_this.props.atualizarHistoricoAuditorias(novoHistorico);Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["J" /* trataMensagemSucesso */])(['Data e motivo de cessação do benefício alterados']);};_this.filterMotivos=function(lista,requerimento,tipo){var motivosCessacaoFiltrado=[];var codigoTipo=tipo==='aposentadoria'?1:2;var inss='01000';var destinatarioOuSolicitanteRGPS=false;var regimes=[2,3];if(requerimento.solicitante){destinatarioOuSolicitanteRGPS=[requerimento.solicitante.codigo,requerimento.destinatario.codigo].includes(inss);if(requerimento.solicitante.codigo===inss){regimes=[1,3];}}var acordos=destinatarioOuSolicitanteRGPS?[1,3]:[2,3];motivosCessacaoFiltrado=lista.filter(function(motivo){return motivo.abrangenciaAplicavel===codigoTipo&&regimes.includes(motivo.regimeAplicavel)&&acordos.includes(motivo.acordoAplicavel);});return motivosCessacaoFiltrado;};_this.modalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["i" /* Grid */],{cols:'6 6 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["k" /* Input */],{label:'Data de Cessa\xE7\xE3o',mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,value:_this.state.dataCessacaoBeneficio,onChange:function onChange(e){return _this.handleChange(e,'dataCessacaoBeneficio');},touched:_this.state.touched}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["k" /* Input */],{label:'Motivo Cessa\xE7\xE3o',number:true,placeholder:'Selecione o Motivo da Cessa\xE7\xE3o',onChange:function onChange(e){return _this.handleChange(e,'motivoCessacaoManual');},value:_this.state.motivoCessacaoManual,itemList:_this.filterMotivos(_this.props.motivosCessacao,_this.props.estadoFormulario.requerimento,'aposentadoria'),required:true,custom:true}))));};_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!_this.checkIfFileCanBeSent(),hint:'Salvar',onClick:_this.handleSave,title:'Salvar'})));};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value));};_this.handleClose=function(){_this.props.handleModal('exibirModalDataEMotivoCessacao');};_this.state=_this.getInitialState();return _this;}_createClass(ModalAlteracaoDataEMotivoCessacao,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalFooter(),conteudomodal:this.modalContent(),onHide:this.handleClose,size:'md',showModal:this.props.showModal,title:'Alterar data e motivo de cessa\xE7\xE3o'}));}}]);return ModalAlteracaoDataEMotivoCessacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalAlteracaoDataEMotivoCessacao.propTypes={tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,dataCessacaoBeneficio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,atualizarDataCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,atualizarMotivoCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,atualizarHistoricoCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func// NOVA PROP
}.isRequired;var mapStateToProps=function mapStateToProps(state){return{motivosCessacao:state.base.motivosCessacao};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ModalAlteracaoDataEMotivoCessacao));

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ComponentesBasicos_UploadDragDrop__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var Motivo=function(_Component){_inherits(Motivo,_Component);function Motivo(props){_classCallCheck(this,Motivo);var _this=_possibleConstructorReturn(this,(Motivo.__proto__||Object.getPrototypeOf(Motivo)).call(this,props));_initialiseProps.call(_this);var estadoInicial=void 0;var motivoFiltrado=_this.filtragemMotivo(props);if(props.motivo){var motivoSelecionado=Object.assign({},props.motivo);estadoInicial={motivoFiltrado:motivoFiltrado,motivoSelecionado:motivoSelecionado,touched:true,arquivo:null,nomeArquivo:null,validadeCampos:{motivo:true},listaArquivos:[]};}else{estadoInicial={motivoFiltrado:motivoFiltrado,motivoSelecionado:{abrangenciaAplicavel:null,acao:null,motivo:null,justificativaIndeferimento:null,comentario:null,index:null,arquivo:null,nomeArquivo:null},touched:false,validadeCampos:{motivo:false}};}_this.state=estadoInicial;return _this;}_createClass(Motivo,[{key:'componentDidMount',value:function componentDidMount(){this.montaListaArquivo();}},{key:'render',value:function render(){var _this2=this;var modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{itemList:this.state.motivoFiltrado,label:'Motivo para o Indeferimento',onChange:function onChange(e){return _this2.handleChange(e,'motivo');},placeholder:'Selecione o motivo',value:this.state.motivoSelecionado.motivo})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{cols:'80',componentClass:'textarea',label:'Justificativa',maxlength:'400',onChange:function onChange(e){return _this2.handleChange(e,'justificativaIndeferimento');},rows:'3',value:this.state.motivoSelecionado.justificativaIndeferimento,textarea:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ComponentesBasicos_UploadDragDrop__["a" /* default */],{files:this.state.listaArquivos,onChange:function onChange(listaArquivos){return _this2.setState({listaArquivos:listaArquivos});},onSelect:this.handleChangeFile,multiple:false,accept:'application/pdf,.pdf',minHeight:70,titulo:'Arraste o arquivo PDF aqui',subtitulo:'ou clique para selecionar'})),this.state.listaArquivos&&this.state.listaArquivos.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["u" /* Table */],{bordered:true,data:this.state.listaArquivos,listaTableHeader:this.arquivoTableHeader})):''));var modalFooter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{title:'Cancelar',onClick:this.props.onHide,hint:'Cancelar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!this.motivoValido(),title:this.props.motivo?'Salvar':'Adicionar',onClick:this.handleButton,hint:this.props.motivo?'Salvar motivo':'Adicionar motivo'})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:modalContent,conteudofooter:modalFooter,onHide:this.props.onHide,size:this.props.size}));}}]);return Motivo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.montaListaArquivo=function(){var _state=Object.assign({},_this3.state),motivoSelecionado=_state.motivoSelecionado;if(motivoSelecionado.arquivo){var lista=[];lista.push(motivoSelecionado.arquivo);_this3.setState({listaArquivos:lista});}};this.motivoValido=function(){var validadeCampos=Object.assign({},_this3.state.validadeCampos);return Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["M" /* validateObject */])(validadeCampos);};this.filtragemMotivo=function(props){var motivosIndeferimentoFiltrado=[];var isSolicitanteRGPS=props.solicitante.codigo==='01000';var isDestinatarioRGPS=props.destinatario.codigo==='01000';var reqParticipantes=isSolicitanteRGPS||isDestinatarioRGPS?1:2;var reqRegimeAplicado=isSolicitanteRGPS?1:2;var reqTipoRequerimento=props.tipoRequerimento;motivosIndeferimentoFiltrado=props.motivos.filter(function(motivo){return(motivo.regimeAplicavel===reqRegimeAplicado||motivo.regimeAplicavel===3)&&(reqParticipantes===motivo.acordoAplicavel||motivo.acordoAplicavel===3)&&(reqTipoRequerimento===motivo.abrangenciaAplicavel||reqTipoRequerimento===2&&motivo.abrangenciaAplicavel===3);});return motivosIndeferimentoFiltrado;};this.handleButton=function(){var touched=true;_this3.setState(Object.assign({},_this3.state,{touched:touched}),_this3.handleAdicionarMotivo);};this.handleAdicionarMotivo=function(){if(_this3.motivoValido()){_this3.props.salvaMotivo(_this3.state.motivoSelecionado);}};this.validateChange=function(changeObj,name){var _state2=Object.assign({},_this3.state),motivoSelecionado=_state2.motivoSelecionado;var abrangenciaAplicavel=null;var acao=null;if(name==='motivo'){motivoSelecionado=changeObj.value?__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */](_this3.props.motivos,changeObj.value):null;// eslint-disable-next-line prefer-destructuring
abrangenciaAplicavel=motivoSelecionado.abrangenciaAplicavel;acao=motivoSelecionado.label;}else{if(motivoSelecionado.abrangenciaAplicavel){// eslint-disable-next-line prefer-destructuring
abrangenciaAplicavel=motivoSelecionado.abrangenciaAplicavel;}// eslint-disable-next-line prefer-destructuring
acao=motivoSelecionado.acao;}return{abrangenciaAplicavel:abrangenciaAplicavel,acao:acao};};this.handleChange=function(changeObj,name){var motivoValidado=_this3.validateChange(changeObj,name);_this3.setState({motivoSelecionado:Object.assign({},_this3.state.motivoSelecionado,_defineProperty({abrangenciaAplicavel:motivoValidado.abrangenciaAplicavel,acao:motivoValidado.acao},name,changeObj.value)),validadeCampos:Object.assign({},_this3.state.validadeCampos,_defineProperty({},name,changeObj.isValid))});};this.handleChangeFile=function(file){_this3.setState({motivoSelecionado:Object.assign({},_this3.state.motivoSelecionado,{arquivo:file})});};this.arquivoTableHeader=[{id:'name',label:'Arquivo'}];};Motivo.propTypes={salvaMotivo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onHide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (Motivo);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var destinoRGPS='01000';var SelecaoDestinatario=function(_Component){_inherits(SelecaoDestinatario,_Component);function SelecaoDestinatario(props,context){_classCallCheck(this,SelecaoDestinatario);var _this=_possibleConstructorReturn(this,(SelecaoDestinatario.__proto__||Object.getPrototypeOf(SelecaoDestinatario)).call(this,props,context));_this.getInitialState=function(){return{tipoRegime:null,tipoEntidade:null,uf:null,destinatario:null,destinatarioOrigem:null};};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.trataFormulario=function(campoAlterado){if(campoAlterado==='tipoRegime'){_this.trataTipoRegime();_this.props.apagaRegraDeCalculo();}if(campoAlterado==='tipoEntidade'){_this.trataTipoEntidade();}if(campoAlterado==='uf'){_this.trataUf();}if(campoAlterado==='destinatario'){_this.trataDestinatario();}};_this.trataUf=function(){_this.setState({destinatario:null},function(){_this.props.handleChange({value:null,isValid:false},'destinatario');});};_this.trataDestinatario=function(){_this.props.handleChange({value:_this.state.destinatario,isValid:true},'destinatario');_this.props.calcularTempoRO(_this.state.destinatario,false);};_this.trataDestinatarioOrigem=function(orgaoCentralizador){_this.props.handleChange({value:orgaoCentralizador,isValid:true},'destinatarioOrigem');};_this.trataTipoEntidade=function(){_this.setState({destinatario:null,uf:null},function(){_this.props.handleChange({value:null,isValid:false},'destinatario');});};_this.trataTipoRegime=function(){var tipoEntidadeAposAlteracao=null;var destinatarioAposAlteracao=null;if(_this.state.tipoRegime===1){destinatarioAposAlteracao=destinoRGPS;}_this.setState({tipoEntidade:tipoEntidadeAposAlteracao,destinatario:destinatarioAposAlteracao},function(){_this.props.handleChange({value:destinatarioAposAlteracao,isValid:destinatarioAposAlteracao!==null},'destinatario');},_this.props.calcularTempoRO(destinatarioAposAlteracao,false));};_this.verificaCampoBloqueado=function(){if(_this.props.acao==='novo'){return false;}return true;};_this.listaFiltradaDestinatarios=function(){var listaParticipantes=_this.props.destinatarios.filter(function(item){if(item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)){return item;}return null;});return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.buscaDestinatarios=function(){if(_this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["a" /* buscaDestinatarios */])(_this.buscaDestinatariosFail);}};_this.buscaDestinatariosFail=function(){_this.setState({tipoRegime:null});};_this.montaValorTipoEntidade=function(){if(_this.state.destinatario&&_this.state.destinatario!==destinoRGPS&&!_this.state.tipoEntidade){var objDestinatario=_this.props.destinatarios.find(function(dest){return dest.value===_this.state.destinatario;});return objDestinatario.tipoRegimeProprio;}return _this.state.tipoEntidade;};_this.state=_this.getInitialState();return _this;}// Encaminha para as funcoes que tratam alteracoes em cada campo
// Campos podem ser alterados apenas quando requerimento for novo
/**
   * Tipo de entidade deve ser carregado dinamicamente se:
   * - Destinatario estiver escolhido;
   * - For diferente de RGPS;
   * - Tipo de entidade estiver em branco
   */_createClass(SelecaoDestinatario,[{key:'render',value:function render(){var _this2=this;var listaTipoRegimes=__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */];if(this.props.acao!=='novo'){return null;}var selecaoDestinacao=void 0;var labelAviso=void 0;if(this.state.tipoRegime===2){this.buscaDestinatarios();selecaoDestinacao=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:this.verificaCampoBloqueado(),label:'Entidade',onChange:function onChange(e){return _this2.handleChange(e,'tipoEntidade');},placeholder:'Selecione a entidade',value:this.montaValorTipoEntidade(),itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["E" /* tipoEntidade */],custom:true,number:true})),this.state.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:this.verificaCampoBloqueado(),label:'UF',onChange:function onChange(e){return _this2.handleChange(e,'uf');},placeholder:'Selecione a UF',value:this.state.uf,itemList:this.carregaUfDosMunicipios(),custom:true})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:this.verificaCampoBloqueado(),label:'Destinat\xE1rio',onChange:function onChange(e){return _this2.handleChange(e,'destinatario');},placeholder:'Selecione o destinat\xE1rio',value:this.state.destinatario,itemList:this.listaFiltradaDestinatarios(),custom:true})));}if(this.props.isRgpsSelecionando){listaTipoRegimes=listaTipoRegimes.filter(function(item){return item.label!=='RGPS';});}if(this.state.tipoEntidade===1&&this.state.destinatario){var orgaoCentralizador='';var orgao=this.props.destinatarios.find(function(itemLista){return itemLista.value===_this2.state.destinatario;});if(orgao.codigoOrgaoCentralizador){orgaoCentralizador=this.props.destinatarios.find(function(item){return item.value===orgao.codigoOrgaoCentralizador;});labelAviso='Este requerimento ser\xE1 destinado a '+orgaoCentralizador.label+'\n        que '+(orgao.inOrgaoExtinto?'Sucede':'Centraliza')+' : '+orgao.label;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["e" /* DataGrid */],{title:'Destina\xE7\xE3o',icon:'ico-route'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:this.verificaCampoBloqueado(),label:'Tipo de Regime de Origem',number:true,touched:this.props.touched,onChange:function onChange(e){return _this2.handleChange(e,'tipoRegime');},placeholder:'Selecione o tipo de regime origem',value:this.state.tipoRegime,itemList:listaTipoRegimes,required:true,custom:true}))),selecaoDestinacao,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 12 12',style:{color:'#27AE60'}},labelAviso)));}}]);return SelecaoDestinatario;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelecaoDestinatario.propTypes={acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,// destinatario: PropTypes.number,
destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tipoRegimeProprio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,apagaRegraDeCalculo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,touched:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isRgpsSelecionando:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,calcularTempoRO:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(SelecaoDestinatario));

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var destinoRGPS='01000';var DestinacaoExigencia=function(_Component){_inherits(DestinacaoExigencia,_Component);function DestinacaoExigencia(props){_classCallCheck(this,DestinacaoExigencia);var _this=_possibleConstructorReturn(this,(DestinacaoExigencia.__proto__||Object.getPrototypeOf(DestinacaoExigencia)).call(this,props));_this.getInitialState=function(){return{tipoRegime:null,tipoEntidade:null,uf:null,destinatario:null,destinatarioOrigem:null,carregamentoExterno:false};};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.trataFormulario=function(campoAlterado){if(campoAlterado==='tipoRegime'){_this.trataTipoRegime();_this.props.apagaRegraDeCalculo();}if(campoAlterado==='tipoEntidade'){_this.trataTipoEntidade();}if(campoAlterado==='uf'){_this.trataUf();}if(campoAlterado==='destinatario'){_this.trataDestinatario();}};_this.trataUf=function(){_this.setState({destinatario:null},function(){_this.props.handleChange({value:null,isValid:false},'destinatario');});};_this.trataDestinatario=function(){_this.props.handleChange({value:_this.state.destinatario,isValid:true},'destinatario');_this.props.calcularTempoRO(_this.state.destinatario,false);};_this.trataDestinatarioOrigem=function(orgaoCentralizador){_this.props.handleChange({value:orgaoCentralizador,isValid:true},'destinatarioOrigem');};_this.trataTipoEntidade=function(){_this.setState({destinatario:null,uf:null},function(){_this.props.handleChange({value:null,isValid:false},'destinatario');});};_this.trataTipoRegime=function(){var tipoEntidadeAposAlteracao=null;var destinatarioAposAlteracao=null;if(_this.state.tipoRegime===1){destinatarioAposAlteracao=destinoRGPS;}_this.setState({tipoEntidade:tipoEntidadeAposAlteracao,destinatario:destinatarioAposAlteracao},function(){_this.props.handleChange({value:destinatarioAposAlteracao,isValid:destinatarioAposAlteracao!==null},'destinatario');},_this.props.calcularTempoRO(destinatarioAposAlteracao,false));};_this.listaFiltradaDestinatarios=function(){var listaParticipantes=_this.props.destinatarios.filter(function(item){if(item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)&&item.value!==_this.props.requerimento.solicitante.codigo){return item;}return null;});return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.buscaDestinatariosFail=function(){_this.setState({tipoRegime:null});};_this.obterValorEntidade=function(){if(_this.props.destinatarios.length>0&&_this.props.requerimento.destinatario&&_this.props.requerimento.destinatario.codigo){var objDestinatario=_this.props.destinatarios.find(function(d){return d.value===_this.props.requerimento.destinatario.codigo;});return objDestinatario.tipoRegimeProprio;}return _this.state.tipoEntidade;};_this.state=_this.getInitialState();return _this;}_createClass(DestinacaoExigencia,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["a" /* buscaDestinatarios */])(this.buscaDestinatariosFail);}}},{key:'carregarDestinaratio',value:function carregarDestinaratio(dest){var _this2=this;var objDestinatario=null;if(!this.state.tipoEntidade&&this.props.requerimento.destinatario){objDestinatario=this.props.destinatarios.find(function(d){return d.value===_this2.props.requerimento.destinatario.codigo;});this.setState({tipoRegime:dest.codigo==='01000'?1:2,tipoEntidade:objDestinatario.tipoRegimeProprio,uf:dest.uf,destinatario:dest.codigo,carregamentoExterno:true});}}// Encaminha para as funcoes que tratam alteracoes em cada campo
},{key:'render',value:function render(){var _this3=this;if(!this.state.carregamentoExterno&&this.props.destinatarios.length>0){this.carregarDestinaratio(this.props.requerimento.destinatario);}var labelAviso=void 0;if(this.state.tipoEntidade===1&&this.state.destinatario){var orgao=this.props.destinatarios.find(function(itemLista){return itemLista.value===_this3.state.destinatario;});var orgaoCentralizador='';if(orgao.codigoOrgaoCentralizador){orgaoCentralizador=this.props.destinatarios.find(function(item){return item.value===orgao.codigoOrgaoCentralizador;});labelAviso='Este requerimento ser\xE1 destinado a '+orgaoCentralizador.label+'\n        que '+(orgao.inOrgaoExtinto?'Sucede':'Centraliza')+' : '+orgao.label;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["e" /* DataGrid */],{title:'Destina\xE7\xE3o',icon:'ico-route'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:true,label:'Solicitante',value:this.props.requerimento.solicitante.nome}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Entidade',onChange:function onChange(e){return _this3.handleChange(e,'tipoEntidade');},placeholder:'Selecione a entidade',value:this.obterValorEntidade(),itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["E" /* tipoEntidade */],custom:true,number:true})),this.state.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'UF',onChange:function onChange(e){return _this3.handleChange(e,'uf');},placeholder:'Selecione a UF',value:this.state.uf,itemList:this.carregaUfDosMunicipios(),custom:true})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Destinat\xE1rio',onChange:function onChange(e){return _this3.handleChange(e,'destinatario');},placeholder:'Selecione o destinat\xE1rio',value:this.state.destinatario,itemList:this.listaFiltradaDestinatarios(),custom:true})))),this.props.requerimento.destinatarioOrigem&&this.props.requerimento.destinatarioOrigem.nome&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:true,label:'Destinat\xE1rio Origem',value:this.props.requerimento.destinatarioOrigem.nome}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 12 12',style:{color:'#27AE60'}},labelAviso)));}}]);return DestinacaoExigencia;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DestinacaoExigencia.propTypes={requerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tipoRegimeProprio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,apagaRegraDeCalculo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,calcularTempoRO:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(DestinacaoExigencia));

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Exigencia__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CumprimentoExigencia=function(_Component){_inherits(CumprimentoExigencia,_Component);function CumprimentoExigencia(props){_classCallCheck(this,CumprimentoExigencia);var _this=_possibleConstructorReturn(this,(CumprimentoExigencia.__proto__||Object.getPrototypeOf(CumprimentoExigencia)).call(this,props));_this.failCallback=function(){_this.alteraEstado(6);};_this.handleModal=function(callback){if(callback){_this.setState({showModal:!_this.state.showModal},callback);}else{_this.setState({showModal:!_this.state.showModal});}};_this.mostraModal=function(e,acaoModal){_this.setState({acaoModal:acaoModal,exigenciaSelecionada:null},_this.handleModal);};_this.escondeModal=function(){_this.handleModal();};_this.alteraExigencia=function(exigencia,title){_this.setState({acaoModal:title,exigenciaSelecionada:exigencia},_this.handleModal);};_this.salvaExigencia=function(exigencia){var _this$props$requerime=Object.assign({},_this.props.requerimento),exigencias=_this$props$requerime.exigencias;exigencias[exigencia.index]=exigencia;_this.handleModal(_this.props.handleChange({value:exigencias,isValid:true},'exigencias'));};_this.deleteExigencia=function(index){var _this$props$requerime2=Object.assign({},_this.props.requerimento),exigencias=_this$props$requerime2.exigencias;exigencias.splice(index,1);_this.props.handleChange({value:exigencias,isValid:true},'exigencias');};_this.createActionColumn=function(index,exigencia){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:'Cumprir exig\xEAncia',icon:'ico-pencil',mini:true,onClick:function onClick(){return _this.alteraExigencia(exigencia,'Cumprir exigência');}}));};_this.addDependenteLabel=function(dependenteSelecionado){if(dependenteSelecionado){var dependentesFormatados=_this.props.requerimento.dependentes.map(function(dependente){return{label:dependente.nome,value:dependente.codigo};});return __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](dependentesFormatados,dependenteSelecionado).label;}return null;};_this.doRequest=function(typeRequest){switch(typeRequest){case'exigencia':if(_this.props.exigencias.length===0){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["r" /* requestExigencias */])(_this.failCallback);}break;case'motivo':if(_this.props.motivosIndeferimento.length===0||_this.props.motivosSuspensao.length===0||_this.props.motivosNaoCumprimento.length===0){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["u" /* requestMotivos */])(_this.failCallback);}break;default:break;}};_this.diffTipoRequerimento=function(){return _this.props.requerimento.tipoAposentadoria;};_this.exigenciasTableHeaderAposentadoria=[{id:'acao',label:'Ação Exigida'},{id:'comentario',label:'Comentário'},{id:'index',label:null,dataFormat:_this.createActionColumn}];_this.exigenciasTableHeaderPensao=[{id:'acao',label:'Ação Exigida'},{id:'codigoDependente',label:'Dependente',dataFormat:_this.addDependenteLabel},{id:'comentario',label:'Comentário'},{id:'index',label:null,dataFormat:_this.createActionColumn}];_this.state={acaoModal:'Inclusão de Exigência',exigenciaSelecionada:null,showModal:false};return _this;}_createClass(CumprimentoExigencia,[{key:'render',value:function render(){var modal=void 0;var options={noDataText:'Nenhuma exigência para o requerimento'};var _props$requerimento=Object.assign({},this.props.requerimento),exigencias=_props$requerimento.exigencias;var listaExigenciasIndexada=exigencias.map(function(item,i){var itemIndexado=item;itemIndexado.index=i;return itemIndexado;});if(this.state.showModal){modal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Exigencia__["a" /* default */],{cumprimentoExigencia:true,exigencias:this.props.exigencias,dependentes:this.props.requerimento.dependentes,tipoRequerimento:this.diffTipoRequerimento()?'aposentadoria':'pensao',salvaExigencia:this.salvaExigencia,exigencia:this.state.exigenciaSelecionada,onHide:this.escondeModal,title:this.state.acaoModal,showModal:true,size:'md',userData:this.props.userData,motivosNaoCumprimento:this.props.motivosNaoCumprimento});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["e" /* DataGrid */],{title:'Cumprimento de exig\xEAncias',icon:'ico-process-check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{bordered:true,data:listaExigenciasIndexada,insertRow:true,options:options,listaTableHeader:this.diffTipoRequerimento()?this.exigenciasTableHeaderAposentadoria:this.exigenciasTableHeaderPensao})))),modal);}}]);return CumprimentoExigencia;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CumprimentoExigencia.propTypes={handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,requerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({estado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,exigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({tipo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,comentario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),tipoAposentadoria:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,motivo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,dependentes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array}).isRequired,exigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),motivosIndeferimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),motivosNaoCumprimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),motivosSuspensao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object)};CumprimentoExigencia.defaultProps={motivosIndeferimento:null,motivosSuspensao:null,motivosNaoCumprimento:null,exigencias:null,userData:null};var mapStateToProps=function mapStateToProps(state){return{exigencias:state.base.exigencias,motivosIndeferimento:state.base.motivosIndeferimento,motivosSuspensao:state.base.motivosSuspensao,motivosNaoCumprimento:state.base.motivosNaoCumprimento};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(CumprimentoExigencia));

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ComponentesBasicos_UploadDragDrop__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalUploadDocumento=function(_Component){_inherits(ModalUploadDocumento,_Component);function ModalUploadDocumento(){_classCallCheck(this,ModalUploadDocumento);var _this=_possibleConstructorReturn(this,(ModalUploadDocumento.__proto__||Object.getPrototypeOf(ModalUploadDocumento)).call(this));_this.isConsultaExigencia=function(){return _this.props.acao==='consulta'&&_this.props.requerimento.estado===2;};_this.montarListaDocumentosAdicionais=function(paramLista){var lista=paramLista;var tiposDocumentos=_this.props.tiposDocumentos||[];var inss='01000';var destinatarioOuSolicitanteRGPS=__WEBPACK_IMPORTED_MODULE_3__domain_User__["a" /* default */].logged().isRGPS()||_this.props.requerimento.destinatario===inss;var acordos=destinatarioOuSolicitanteRGPS?[1,3]:[2,3];var regimes=__WEBPACK_IMPORTED_MODULE_3__domain_User__["a" /* default */].logged().isRGPS()?[1,3]:[2,3];lista=tiposDocumentos.filter(function(doc){return doc.value!==19&&doc.value!==20&&doc.categoria===1;});lista=lista.filter(function(doc){return(doc.abrangenciaAplicavel===_this.props.tipoRequerimento||doc.abrangenciaAplicavel==null)&&acordos.includes(doc.acordoAplicavel)&&regimes.includes(doc.regimeAplicavel);});return lista;};_this.montaListaDocumentosDisponiveis=function(){var lista=[];if(_this.isConsultaExigencia()){if(_this.props.possuiExigenciaDocumento){if(_this.props.requerimento&&_this.props.listaExigencias){_this.props.listaExigencias.forEach(function(exigencia){if(exigencia.tipoDocumento&&!exigencia.atributo){var acaoFormatada=exigencia.acao;if(exigencia.tipoDocumento===13&&exigencia.comentario){acaoFormatada=exigencia.acao+' - '+exigencia.comentario;}lista.push({value:exigencia.codigoDependente?''+exigencia.tipoDocumento+exigencia.codigoDependente:exigencia.tipoDocumento,label:acaoFormatada,dependente:exigencia.codigoDependente});}});}}else{lista=_this.montarListaDocumentosAdicionais(lista);}}else{lista=_this.montarListaDocumentosAdicionais(lista);}_this.setState({tiposDisponiveis:lista});};_this.handleChangeExigencia=function(changeObj,name){var paramExibirNomeDependente=false;var listaDependentes=_this.props.requerimento.dependentes;var listaExigencias=_this.props.requerimento.exigencias;var paramNomeDependente='';var dependente='';var valor='';var codigoDependente='';if(listaExigencias&&listaExigencias.length>0){for(var i=0;i<listaExigencias.length;i+=1){var exigencia=listaExigencias[i];if(exigencia.tipoDocumento&&exigencia.codigoDependente){valor=''+exigencia.tipoDocumento+exigencia.codigoDependente;if(Number(valor)===changeObj.value){dependente=valor.match(exigencia.codigoDependente);break;}}}if(dependente!==''){codigoDependente=Number(dependente[0]);var indexDep=listaDependentes.findIndex(function(depDisp){return depDisp.codigo===codigoDependente;});paramNomeDependente=listaDependentes[indexDep].nome;if(paramNomeDependente!==''){paramExibirNomeDependente=true;}_this.setState({nomeDependente:paramNomeDependente,exibirNomeDependente:paramExibirNomeDependente});}}if(changeObj.value===''){_this.setState({nomeDependente:'',exibirNomeDependente:false});}_this.setState(_defineProperty({},name,changeObj.value));};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value));};_this.checkIfFileCanBeSent=function(){return _this.state.documents.length>0&&_this.state.tipoDocumento;};_this.addArquivo=function(){var documents=_this.state.documents;if(!documents||documents.length===0){return;}var arquivosAdicionados=[];documents.forEach(function(documentoAtual){var arquivo={};if(_this.isConsultaExigencia()){var tamanhoDocumentoUpload=documentoAtual.size;var tipoDoc='';var valor='';var nomeDependenteExigencia='';var codigoDependenteExigencia='';if(tamanhoDocumentoUpload<__WEBPACK_IMPORTED_MODULE_4__utils_constants__["z" /* tamanhoMaximoArquivoUpload */]){var listaExigencias=_this.props.requerimento.exigencias;var listaDependentes=_this.props.requerimento.dependentes;if(listaDependentes&&listaDependentes.length>0){for(var i=0;i<listaExigencias.length;i+=1){var exigencia=listaExigencias[i];if(exigencia.tipoDocumento&&exigencia.codigoDependente){valor=''+exigencia.tipoDocumento+exigencia.codigoDependente;if(Number(valor)===_this.state.tipoDocumento){tipoDoc=valor.match(exigencia.tipoDocumento);tipoDoc=Number(tipoDoc[0]);codigoDependenteExigencia=exigencia.codigoDependente;break;}}else if(exigencia.tipoDocumento&&!exigencia.codigoDependente){tipoDoc=exigencia.tipoDocumento;break;}else if(!exigencia.tipoDocumento&&!exigencia.codigoDependente){tipoDoc=_this.state.tipoDocumento;break;}}if(codigoDependenteExigencia&&codigoDependenteExigencia!==''){var indexDep=listaDependentes.findIndex(function(exi){return exi.codigo===codigoDependenteExigencia;});nomeDependenteExigencia=listaDependentes[indexDep].nome;}arquivo={documento:documentoAtual,tipoDocumento:tipoDoc,nomeDependente:nomeDependenteExigencia,codigoDependente:codigoDependenteExigencia};var indexExigencia=_this.props.listaExigencias.findIndex(function(exi){return exi.tipoDocumento===tipoDoc&&exi.codigoDependente===codigoDependenteExigencia;});if(indexExigencia!==-1){_this.props.listaExigencias.splice(indexExigencia,1);}}else{var _indexExigencia=_this.props.listaExigencias.findIndex(function(exi){return exi.tipoDocumento===_this.state.tipoDocumento;});if(_indexExigencia!==-1){_this.props.listaExigencias.splice(_indexExigencia,1);}arquivo={documento:documentoAtual,tipoDocumento:_this.state.tipoDocumento};}}else{arquivo={documento:documentoAtual,tipoDocumento:_this.state.tipoDocumento};}}else{arquivo={documento:documentoAtual,tipoDocumento:_this.state.tipoDocumento};}arquivosAdicionados.push(arquivo);});_this.props.addArquivo(arquivosAdicionados,_this.props.arquivo);};_this.handleDocumentSent=function(response){var tipoDocumentoCarregado=_this.state.tipoDocumento;_this.setState({documents:[],tipoDocumento:null,tiposDisponiveis:[]},function(){return _this.props.handleDocumentSent(response.headers.location,tipoDocumentoCarregado);});};_this.handleClose=function(){_this.setState({documents:[]},_this.props.handleModal('showDocumentUploadModal'));};_this.exibirModalConsultaExigencia=function(){var retorno=false;if(_this.isConsultaExigencia()){retorno=true;}return retorno;};_this.modalDocumentUploadContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Tipo de documento',number:true,placeholder:'Selecione o tipo de documento',onChange:function onChange(e){return _this.handleChange(e,'tipoDocumento');},value:_this.state.tipoDocumento,itemList:_this.state.tiposDisponiveis,required:true,custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ComponentesBasicos_UploadDragDrop__["a" /* default */],{files:_this.state.documents,onChange:function onChange(documents){return _this.setState({documents:documents});},multiple:false,accept:'application/pdf,.pdf',minHeight:70,titulo:'Arraste o arquivo PDF aqui',subtitulo:'ou clique para selecionar'}));};_this.modalExigenciaUploadContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.state.exibirNomeDependente?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Dependente',value:_this.state.nomeDependente,disabled:true}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Tipo de documento',number:true,placeholder:'Selecione o tipo de documento',onChange:function onChange(e){return _this.handleChangeExigencia(e,'tipoDocumento');},value:_this.state.tipoDocumento,itemList:_this.state.tiposDisponiveis,required:true,custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ComponentesBasicos_UploadDragDrop__["a" /* default */],{files:_this.state.documents,onChange:function onChange(documents){return _this.setState({documents:documents});},multiple:false,accept:'application/pdf,.pdf',minHeight:70,titulo:'Arraste o arquivo PDF aqui',subtitulo:'ou clique para selecionar'}));};_this.modalDocumentUploadFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!_this.checkIfFileCanBeSent(),hint:'Anexar documento',onClick:_this.addArquivo,title:'Anexar'})));};_this.state={documents:[],tipoDocumento:null,tiposDisponiveis:[],nomeDependente:null,exibirNomeDependente:false};return _this;}_createClass(ModalUploadDocumento,[{key:'componentDidMount',value:function componentDidMount(){this.montaListaDocumentosDisponiveis();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalDocumentUploadFooter(),conteudomodal:this.exibirModalConsultaExigencia()?this.modalExigenciaUploadContent():this.modalDocumentUploadContent(),onHide:this.handleClose,size:'md',showModal:this.props.showModal,title:'Incluir documento ao requerimento'}));}}]);return ModalUploadDocumento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalUploadDocumento.propTypes={addArquivo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleDocumentSent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalUploadDocumento);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var linhasPorPagina=20;var marcadorNaoPertenceCPF='Não associado ao CPF';var ModalCadeiaDeNit=function(_Component){_inherits(ModalCadeiaDeNit,_Component);function ModalCadeiaDeNit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalCadeiaDeNit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalCadeiaDeNit.__proto__||Object.getPrototypeOf(ModalCadeiaDeNit)).call.apply(_ref,[this].concat(args))),_this),_this.montaElosTableHeader=function(){return[{id:_this.props.acao==='novo'||_this.props.acao==='indeferidos'||_this.props.acao==='cumprir-exigencia'?'nit0':'idNit0',label:''}];},_this.montaColunas=function(){var bloqueiosTableHeader=_this.montaEloNitTableHeader.slice();return bloqueiosTableHeader;},_this.formatar=function(nit,tipoNit){var nitFormatado='';var retorno='';if(nit){nitFormatado=nit.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/,'$1.$2.$3.$4-$5');}retorno=nitFormatado;if(_this.props.acao!=='novo'&&tipoNit!==null&&tipoNit===3){retorno=retorno+' '+marcadorNaoPertenceCPF;}// if ((this.props.acao === 'novo' && this.state.incluirMarcadorParaNit === nit)) {
//   retorno = `${retorno} ${marcadorNaoPertenceCPF}`;
// }
return retorno;},_this.exibirMensagemCPF=function(tipoNit){if(_this.props.acao!=='novo'&&tipoNit!==null&&tipoNit===3){// retorno = `${retorno} ${marcadorNaoPertenceCPF}`;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'estadoNaoPago'},'N\xE3o associado ao CPF'));}return'';},_this.montaListaElos=function(){var colunasPorPagina=1;var pagina=0;var linha=0;var coluna=0;var listaFormatada=[];listaFormatada[0]={};if(_this.props.elos===undefined||_this.props.elos.length===0){listaFormatada.length=0;}else{var listaNits=_this.props.elos;if(_this.props.acao==='novo'||_this.props.acao==='indeferidos'||_this.props.acao==='cumprir-exigencia'){var indexNit=listaNits.findIndex(function(nit){return nit===_this.props.nit;});if(indexNit===-1&&_this.props.nit!==null&&_this.props.nit!==undefined){listaNits.unshift(_this.props.nit);// if (this.props.dataMigracao !== null) {
// this.setState({
//   incluirMarcadorParaNit: this.props.nit,
// });
// }
}listaNits.forEach(function(nit,index){var numeroNit=nit&&nit.idNit?nit.idNit.toString():nit;listaFormatada[linha]['nit'+coluna]=''+_this.formatar(numeroNit,null);if((index+1)%linhasPorPagina===0){if((index+1)%(linhasPorPagina*colunasPorPagina)===0){pagina+=1;linha=pagina*linhasPorPagina;coluna=0;if(listaFormatada[linha]===undefined){listaFormatada[linha]={};}}else{linha=pagina*linhasPorPagina;coluna+=1;if(coluna%colunasPorPagina===0){coluna=0;}}}else{linha+=1;if(listaFormatada[linha]===undefined){listaFormatada[linha]={};}}});}else{listaNits.forEach(function(item,index){var nit=item.idNit.toString();var paramTipoNit=item.tipoNit;listaFormatada[linha]['idNit'+coluna]=_this.formatar(nit,paramTipoNit);if((index+1)%linhasPorPagina===0){if((index+1)%(linhasPorPagina*colunasPorPagina)===0){pagina+=1;linha=pagina*linhasPorPagina;coluna=0;if(listaFormatada[linha]===undefined){listaFormatada[linha]={};}}else{linha=pagina*linhasPorPagina;coluna+=1;if(coluna%colunasPorPagina===0){coluna=0;}}}else{linha+=1;if(listaFormatada[linha]===undefined){listaFormatada[linha]={};}}});}}return listaFormatada;},_this.options={noDataText:'Não existem NITs relacionados',hideSizePerPage:true,sizePerPage:linhasPorPagina},_this.handleClose=function(){_this.props.handleModal('handleModalCadeiaDeNitModal');},_this.modalCadeiaDeNitContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["u" /* Table */],{bordered:true,data:_this.montaListaElos(),options:_this.options,listaTableHeader:_this.montaElosTableHeader(),pagination:true,scrollTop:'Top'})));},_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalCadeiaDeNit,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:this.modalCadeiaDeNitContent(),conteudofooter:this.modalFooter(),onHide:this.handleClose,size:'md',showModal:this.props.showModal,title:'NITS'}));}}]);return ModalCadeiaDeNit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalCadeiaDeNit.propTypes={acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,elos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired,nit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,dataMigracao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleDocumentSent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalCadeiaDeNit);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* eslint-disable */var ProtocoloCertidao=function ProtocoloCertidao(props){var handleButton=function handleButton(){props.handleSearchPeriodos();};function verificarTamanhoInput(){var retorno='4 4 4 4';if(props.verificaAcaoExibicaoBotaoPesquisarCTC()){retorno='5 5 5 5';}return retorno;}function verificaDesabilitarEntradaProtocoloDaCertidao(){return!['novo','cumprir-exigencia','indeferidos'].includes(props.estadoFormulario.acao);}function verificaDesabilitarBotaoPesquisar(){return!props.estadoFormulario.requerimento.cpf;}var manterProtocoloCertidao=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:verificarTamanhoInput()},props.verificaAcaoExibicaoBotaoPesquisarCTC()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'left-sem-margem-esquerda',title:'pesquisar ctc',onClick:handleButton,hint:'Pesquisar a CTC',disabled:verificaDesabilitarBotaoPesquisar()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Protocolo da Certid\xE3o',maxlength:'23',onChange:function onChange(e){return props.handleChange(e,'protocoloCertidao');},value:props.estadoFormulario.requerimento.protocoloCertidao,disabled:verificaDesabilitarEntradaProtocoloDaCertidao(),integer:true})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,manterProtocoloCertidao);};ProtocoloCertidao.propTypes={estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChangeProtocoloNaoConstaOuIlegivel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleSearchPeriodos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,verificaAcaoExibicaoBotaoPesquisarCTC:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ProtocoloCertidao);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalPeriodo__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalCalculadoraPeriodo__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var avisoDuplaDestinacao={textAlign:'left',fontWeight:'600',padding:'12px 10px 12px 10px',fontSize:'15px',marginLeft:'10px',flexGrow:'0',borderRadius:'5px',backgroundColor:'#e29402',color:'white',height:'95px',verticalAlign:'middle',marginBottom:'6px'};var avisoTempoRoRGPS={textAlign:'center',fontWeight:'500',padding:'10px 22px',fontSize:'15px',width:'calc(100vw - 260px)',maxWidth:'750px',borderRadius:'6px',backgroundColor:'rgb(223, 229, 232)',color:'rgb(84, 110, 122)',margin:'0',boxSizing:'border-box',lineHeight:'20px'};var MultiplosPeriodos=function(_Component){_inherits(MultiplosPeriodos,_Component);function MultiplosPeriodos(){_classCallCheck(this,MultiplosPeriodos);var _this=_possibleConstructorReturn(this,(MultiplosPeriodos.__proto__||Object.getPrototypeOf(MultiplosPeriodos)).call(this));_this.getInitialState=function(){return{periodo:{dataInicio:null,dataFim:null,qtdDiasContribuicaoBruto:null,qtdDiasDesconto:0,qtdDiasContribuicaoLiquido:null,operacao:0},lista:[],showModal:false,showModalCalculadoraPeriodo:false};};_this.mensagemDuplaDestinacao=function(){var mensagem1=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'CTC encontrada possui dois destinat\xE1rios.');var mensagem2=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\xC9 necess\xE1rio o ajuste somente no(s) per\xEDodo(s) destinado(s) e aproveitado(s) no RPPS Solicitante, devendo excluir o(s) per\xEDodo(s) destinado(s) ao outro Ente Federativo/RPPS.');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,mensagem1,mensagem2);};_this.msgExplicativaTempoRoRGPS=function(){var mensagem1=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:avisoTempoRoRGPS},'Na rela\xE7\xE3o entre RGPS e RPPS, aplica-se a f\xF3rmula de c\xE1lculo utilizada pelo RGPS.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Caso deseje confirmar, utilize o bot\xE3o da calculadora para confer\xEAncia do tempo RO.');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,mensagem1);};_this.showModal=function(){var _this$props$estadoFor=Object.assign({},_this.props.estadoFormulario),requerimento=_this$props$estadoFor.requerimento;if(requerimento.destinatario&&requerimento.destinatario!==null&&requerimento.destinatario!==''){var periodoNew={dataInicio:null,dataFim:null,qtdDiasContribuicaoBruto:null,qtdDiasDesconto:0,qtdDiasContribuicaoLiquido:null,operacao:1};_this.setState({periodo:periodoNew,showModal:!_this.state.showModal});}else{Object(__WEBPACK_IMPORTED_MODULE_7__utils_requests__["L" /* trataMensagensErro */])(['Destinat\xE1rio da compensa\xE7\xE3o n\xE3o informado. Informe o destinat\xE1rio.']);}};_this.showModalAlterar=function(){var _this$props$estadoFor2=Object.assign({},_this.props.estadoFormulario),requerimento=_this$props$estadoFor2.requerimento;if(requerimento.destinatario&&requerimento.destinatario!==null&&requerimento.destinatario!==''){_this.setState({showModal:!_this.state.showModal});}else{Object(__WEBPACK_IMPORTED_MODULE_7__utils_requests__["L" /* trataMensagensErro */])(['Destinat\xE1rio da compensa\xE7\xE3o n\xE3o informado. Informe o destinat\xE1rio.']);}};_this.showModalCalculadoraPeriodo=function(){_this.setState({showModalCalculadoraPeriodo:!_this.state.showModalCalculadoraPeriodo});};_this.deleteItem=function(row){var _this$props$estadoFor3=Object.assign({},_this.props.estadoFormulario.requerimento),requerimentoPeriodos=_this$props$estadoFor3.requerimentoPeriodos;var _this$props$estadoFor4=Object.assign({},_this.props.estadoFormulario.requerimento),requerimentoPeriodosExcluidos=_this$props$estadoFor4.requerimentoPeriodosExcluidos;var periodoExcluir={idPeriodo:requerimentoPeriodos[row]?requerimentoPeriodos[row].idPeriodo:null,dataInicio:requerimentoPeriodos[row]?requerimentoPeriodos[row].dataInicio:null,dataFim:requerimentoPeriodos[row]?requerimentoPeriodos[row].dataFim:null,qtdDiasContribuicaoBruto:requerimentoPeriodos[row]?requerimentoPeriodos[row].qtdDiasContribuicaoBruto:null,qtdDiasDesconto:requerimentoPeriodos[row]?requerimentoPeriodos[row].qtdDiasDesconto:null,qtdDiasContribuicaoLiquido:requerimentoPeriodos[row]?requerimentoPeriodos[row].qtdDiasContribuicaoLiquido:null,indice:requerimentoPeriodos[row]?requerimentoPeriodos[row].indice:null,operacao:3};if(requerimentoPeriodos[row].idPeriodo){requerimentoPeriodosExcluidos.push(periodoExcluir);}_this.setState({periodo:periodoExcluir});requerimentoPeriodos.splice(row,1);_this.alteraListaAposExclusao(requerimentoPeriodos,requerimentoPeriodosExcluidos,3);};_this.verificarOperacao=function(periodo){var _this$props$estadoFor5=Object.assign({},_this.props.estadoFormulario),acao=_this$props$estadoFor5.acao;return['cumprir-exigencia','indeferidos'].includes(acao)&&!periodo.idPeriodo||['complementar-aposentadoria'].includes(acao)&&!periodo.idPeriodo||['novo'].includes(acao)&&!periodo.idPeriodo;};_this.alterarItem=function(row){var _this$props$estadoFor6=Object.assign({},_this.props.estadoFormulario.requerimento),requerimentoPeriodos=_this$props$estadoFor6.requerimentoPeriodos;var periodoAlterar={idPeriodo:requerimentoPeriodos[row]?requerimentoPeriodos[row].idPeriodo:null,dataInicio:requerimentoPeriodos[row]?requerimentoPeriodos[row].dataInicio:null,dataFim:requerimentoPeriodos[row]?requerimentoPeriodos[row].dataFim:null,qtdDiasContribuicaoBruto:requerimentoPeriodos[row]?requerimentoPeriodos[row].qtdDiasContribuicaoBruto:null,qtdDiasDesconto:requerimentoPeriodos[row]?requerimentoPeriodos[row].qtdDiasDesconto:null,qtdDiasContribuicaoLiquido:requerimentoPeriodos[row]?requerimentoPeriodos[row].qtdDiasContribuicaoLiquido:null,indice:requerimentoPeriodos[row]?requerimentoPeriodos[row].indice:null,// operacao: this.verificarOperacao(requerimentoPeriodos[row]) ? 2 : null,
operacao:2};_this.setState({periodo:periodoAlterar});_this.showModalAlterar();};_this.createActionColumn=function(index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.exibirBotaoAlterar()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:'Alterar',icon:'ico-pencil',mini:true,onClick:function onClick(){return _this.alterarItem(index);}}),_this.exibirBotoesPadrao()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{className:'dtp-inverse',hint:'Excluir',icon:'ico-hourglass-minus',mini:true,onClick:function onClick(){return _this.deleteItem(index);}}));};_this.createCustomInsertButton=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-botoes-periodo'},!['realizar-analise','consulta','qualificar'].includes(_this.props.estadoFormulario.acao)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{onClick:function onClick(){return _this.showModal();},hint:'incluir per\xEDodo',icon:'ico-hourglass-plus'}),_this.verificaRgpsNaRelacao()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{onClick:function onClick(){return _this.showModalCalculadoraPeriodo();},hint:'calculadora de per\xEDodos',icon:'ico-calc'}):'',_this.verificaRgpsNaRelacao()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mensagem-rgps'},_this.msgExplicativaTempoRoRGPS()));};_this.options={hideSizePerPage:true,insertBtn:_this.createCustomInsertButton,noDataText:'Nenhum período foi adicionado à lista',sizePerPage:5};_this.fetchInfo={};_this.handleChange=function(changeObj,name){var _this$state=Object.assign({},_this.state),periodo=_this$state.periodo;var valor=changeObj.value;if(name==='qtdDiasDesconto'&&valor===''){valor=0;}_this.setState({periodo:Object.assign({},periodo,_defineProperty({},name,valor))});};_this.atualizarTempos=function(tempoBruto,tempoLiquido){var _this$state2=Object.assign({},_this.state),periodo=_this$state2.periodo;_this.setState({periodo:Object.assign({},periodo,{qtdDiasContribuicaoBruto:tempoBruto,qtdDiasContribuicaoLiquido:tempoLiquido})});};_this.atualizarTempoContribuicaoLiquido=function(tempoLiquido){var _this$state3=Object.assign({},_this.state),periodo=_this$state3.periodo;_this.setState({periodo:Object.assign({},periodo,{qtdDiasContribuicaoLiquido:tempoLiquido})});};_this.alteraListaAposExclusao=function(listaPeriodos,listaPeriodosExclusao,origem){_this.props.handleChange({value:listaPeriodos,isValid:listaPeriodos.length>0},'requerimentoPeriodos');_this.props.handleChange({value:listaPeriodosExclusao,isValid:listaPeriodosExclusao.length>0},'requerimentoPeriodosExcluidos');_this.props.atualizarDataIngressoDesvinculacaoETempo(listaPeriodos,origem);};_this.montaTableHeader=function(){var tableHeader=[{id:'dataInicio',label:'Data de Início'},{id:'dataFim',label:'Data de Término'},{id:'qtdDiasContribuicaoBruto',label:'Tempo de Contribuição Bruto'},{id:'qtdDiasDesconto',label:'Tempo Descontado'},{id:'qtdDiasContribuicaoLiquido',label:'Tempo de Contribuição Líquido'}];if(!['realizar-analise','consulta','qualificar'].includes(_this.props.estadoFormulario.acao)){tableHeader.push({id:'indice',label:'Ação',dataFormat:_this.createActionColumn});}return tableHeader;};_this.exibirBotaoAlterar=function(){return _this.props.estadoFormulario!=='criado'&&['novo','cumprir-exigencia','indeferidos','complementar-aposentadoria'].includes(_this.props.estadoFormulario.acao);};_this.exibirBotoesPadrao=function(){return _this.props.estadoFormulario!=='criado'&&['novo','cumprir-exigencia','indeferidos','complementar-aposentadoria'].includes(_this.props.estadoFormulario.acao);};_this.exibirBotoesTableHeader=function(){var retorno=false;if(_this.props.estadoFormulario!=='criado'&&['novo','cumprir-exigencia','indeferidos','complementar-aposentadoria'].includes(_this.props.estadoFormulario.acao)){retorno=true;}else if(['realizar-analise','consulta'].includes(_this.props.estadoFormulario.acao)&&_this.verificaRgpsNaRelacao()){retorno=true;}return retorno;};_this.calcularTempoDeContribuicaoBruto=function(periodo){var _this$props=Object.assign({},_this.props),estadoFormulario=_this$props.estadoFormulario;if(periodo){if(periodo.dataInicio&&periodo.dataInicio.indexOf('_')===-1&&periodo.dataFim&&periodo.dataFim.indexOf('_')===-1){if(estadoFormulario.requerimento.destinatario&&estadoFormulario.requerimento.destinatario==='01000'||_this.props.estadoFormulario.requerimento.destinatario&&_this.props.estadoFormulario.requerimento.destinatario.codigo==='01000'||__WEBPACK_IMPORTED_MODULE_6__domain_User__["a" /* default */].logged().isRGPS()||_this.props.estadoFormulario.requerimento.solicitante&&_this.props.estadoFormulario.requerimento.solicitante.codigo==='01000'){return _this.props.calcularPeriodoRgps(periodo,false);}else{return _this.props.calcularPeriodoRpps(periodo);}}}return 0;};_this.calcularTempoDeContribuicaoLiquido=function(periodo){if(periodo){var qtdDiasDesconto=periodo.qtdDiasDesconto?Number(periodo.qtdDiasDesconto):0;var tempoBruto=periodo.qtdDiasContribuicaoBruto?Number(periodo.qtdDiasContribuicaoBruto):0;var retorno=Math.trunc(tempoBruto-qtdDiasDesconto);return retorno;}return 0;};_this.verificaRgpsNaRelacao=function(){var _this$props2=Object.assign({},_this.props),estadoFormulario=_this$props2.estadoFormulario;if(estadoFormulario.requerimento.destinatario&&estadoFormulario.requerimento.destinatario==='01000'||_this.props.estadoFormulario.requerimento.destinatario&&_this.props.estadoFormulario.requerimento.destinatario.codigo==='01000'||__WEBPACK_IMPORTED_MODULE_6__domain_User__["a" /* default */].logged().isRGPS()||_this.props.estadoFormulario.requerimento.solicitante&&_this.props.estadoFormulario.requerimento.solicitante.codigo==='01000'){return true;}return false;};var initialState=_this.getInitialState();_this.state=initialState;return _this;}// alteraListaAposExclusao = (listaPeriodos, origem) => {
_createClass(MultiplosPeriodos,[{key:'render',value:function render(){var _this2=this;var lista=[];if(this.props.estadoFormulario.requerimento.requerimentoPeriodos){lista=this.props.estadoFormulario.requerimento.requerimentoPeriodos;}var listaIndexada=lista.map(function(item,i){var itemIndexado=item;itemIndexado.indice=i;itemIndexado.qtdDiasContribuicaoBruto=_this2.calcularTempoDeContribuicaoBruto(itemIndexado);itemIndexado.qtdDiasContribuicaoLiquido=_this2.calcularTempoDeContribuicaoLiquido(itemIndexado);itemIndexado.qtdDiasDesconto=itemIndexado.qtdDiasDesconto?itemIndexado.qtdDiasDesconto:0;return itemIndexado;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["e" /* DataGrid */],{title:'Per\xEDodos',icon:'ico-hourglass'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},this.props.estadoFormulario.duplaDestinacao&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:avisoDuplaDestinacao},this.mensagemDuplaDestinacao()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{bordered:true,data:this.props.ordenarListaPeriodos(listaIndexada),insertRow:this.exibirBotoesTableHeader(),options:this.options,listaTableHeader:this.montaTableHeader(),pagination:true,fetchInfo:this.fetchInfo})))),this.state.showModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModalPeriodo__["a" /* default */],Object.assign({},this.props,{periodo:this.state.periodo,handleModal:function handleModal(){return _this2.showModal('showModal');},handleChangePeriodos:this.handleChange,handleChange:this.props.handleChange,showModal:this.state.showModal,atualizarDataIngressoDesvinculacaoETempo:this.props.atualizarDataIngressoDesvinculacaoETempo,atualizarTempos:this.atualizarTempos,atualizarTempoContribuicaoLiquido:this.atualizarTempoContribuicaoLiquido,determinarConcomitancias:this.props.determinarConcomitancias,ordenarListaPeriodos:this.props.ordenarListaPeriodos,calcularPeriodoRgps:this.props.calcularPeriodoRgps,calcularPeriodoRpps:this.props.calcularPeriodoRpps})):'',this.state.showModalCalculadoraPeriodo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModalCalculadoraPeriodo__["a" /* default */],Object.assign({},this.props,{handleModal:function handleModal(){return _this2.showModalCalculadoraPeriodo('showModalCalculadoraPeriodo');},showModal:this.state.showModalCalculadoraPeriodo,estadoFormulario:this.props.estadoFormulario})):'');}}]);return MultiplosPeriodos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MultiplosPeriodos.propTypes={handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,atualizarDataIngressoDesvinculacaoETempo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,determinarConcomitancias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,ordenarListaPeriodos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,calcularPeriodoRgps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,calcularPeriodoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (MultiplosPeriodos);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__domain_User__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var jssPainelMensagemCampoRGPS={display:'flex',padding:'22x',borderRadius:'5px',backgroundColor:'#e29402',color:'white',height:'50px',verticalAlign:'middle',marginBottom:'20px'};var jssPainelMensagemCampoRPPS={display:'flex',padding:'22x',borderRadius:'5px',backgroundColor:'#e29402',color:'white',height:'80px',verticalAlign:'middle',marginBottom:'20px'};var jssMensagemDescricao={display:'inline-block',textAlign:'left',verticalAlign:'middle',fontWeight:'600',paddingTop:'12px',fontSize:'15px',marginLeft:'10px',flexGrow:'0'};var ModalPeriodo=function(_Component){_inherits(ModalPeriodo,_Component);function ModalPeriodo(props,context){_classCallCheck(this,ModalPeriodo);var _this=_possibleConstructorReturn(this,(ModalPeriodo.__proto__||Object.getPrototypeOf(ModalPeriodo)).call(this,props,context));_this.getInitialState=function(){return{touched:false,periodoValido:false,mostraPainelMensagemCampo:false};};_this.checkIfCanBeSent=function(){return _this.state.periodoValido&&_this.props.periodo.dataInicio&&_this.props.periodo.dataInicio.indexOf('_')===-1&&_this.props.periodo.dataFim&&_this.props.periodo.dataFim.indexOf('_')===-1&&_this.state.mostraPainelMensagemCampo===false;};_this.verificaSeCampoDesabilitado=function(name){if(name==='qtdDiasDesconto'&&_this.props.periodo.dataInicio&&_this.props.periodo.dataInicio.indexOf('_')===-1&&_this.props.periodo.dataFim&&_this.props.periodo.dataFim.indexOf('_')===-1){return false;}return true;};_this.trataSucessoResponseEnvio=function(){_this.handleClose();Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["J" /* trataMensagemSucesso */])(['Período alterado com sucesso.']);};_this.compararDatasInicio=function(a,b){if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.dataInicio,'DD/MM/YYYY').toDate()<__WEBPACK_IMPORTED_MODULE_2_moment___default()(b.dataInicio,'DD/MM/YYYY').toDate()){return-1;}if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.dataInicio,'DD/MM/YYYY').toDate()>__WEBPACK_IMPORTED_MODULE_2_moment___default()(b.dataInicio,'DD/MM/YYYY').toDate()){return 1;}return 0;};_this.ordenarListaPeriodos=function(lista){lista.sort(_this.compararDatasInicio);return lista;};_this.alteraLista=function(listaPeriodosCtc,origem){_this.props.handleChange({value:listaPeriodosCtc,isValid:listaPeriodosCtc.length>0},'requerimentoPeriodos');_this.props.atualizarDataIngressoDesvinculacaoETempo(listaPeriodosCtc,origem);_this.handleClose();};_this.calcularTempoDeContribuicaoBruto=function(){var _this$props=Object.assign({},_this.props),periodo=_this$props.periodo,estadoFormulario=_this$props.estadoFormulario;if(periodo){if(periodo.dataInicio&&periodo.dataInicio.indexOf('_')===-1&&periodo.dataFim&&periodo.dataFim.indexOf('_')===-1){var mesFev=2;var ultimoDiaFevBissexto=29;var qtdDiasContribuicaoBruto=0;var tempoContribLiquidoProvisorio=0;var mensagemBissexto=0;var diaInicio=Number(periodo.dataInicio.split('/')[0]);var mesInicio=Number(periodo.dataInicio.split('/')[1]);var anoInicioBissexto=__WEBPACK_IMPORTED_MODULE_2_moment___default()(periodo.dataInicio,'DD/MM/YYYY').isLeapYear();var diaFim=Number(periodo.dataFim.split('/')[0]);var mesFim=Number(periodo.dataFim.split('/')[1]);var anoFimBissexto=__WEBPACK_IMPORTED_MODULE_2_moment___default()(periodo.dataFim,'DD/MM/YYYY').isLeapYear();if(!anoInicioBissexto&&mesInicio===mesFev&&diaInicio===ultimoDiaFevBissexto||!anoFimBissexto&&mesFim===mesFev&&diaFim===ultimoDiaFevBissexto){mensagemBissexto=1;}else{if(estadoFormulario.requerimento.destinatario&&estadoFormulario.requerimento.destinatario==='01000'||_this.props.estadoFormulario.requerimento.destinatario&&_this.props.estadoFormulario.requerimento.destinatario.codigo==='01000'||__WEBPACK_IMPORTED_MODULE_6__domain_User__["a" /* default */].logged().isRGPS()||_this.props.estadoFormulario.requerimento.solicitante&&_this.props.estadoFormulario.requerimento.solicitante.codigo==='01000'){qtdDiasContribuicaoBruto=_this.props.calcularPeriodoRgps(periodo,false);}else{qtdDiasContribuicaoBruto=_this.props.calcularPeriodoRpps(periodo);}tempoContribLiquidoProvisorio=qtdDiasContribuicaoBruto-Number(periodo.qtdDiasDesconto);}_this.props.atualizarTempos(qtdDiasContribuicaoBruto,tempoContribLiquidoProvisorio);_this.validarPeriodo(qtdDiasContribuicaoBruto,mensagemBissexto);}}return 0;};_this.calcularTempoDeContribuicaoLiquido=function(){var _this$props2=Object.assign({},_this.props),periodo=_this$props2.periodo;var mensagemTempoDescontado=0;if(periodo){var qtdDiasDesconto=periodo.qtdDiasDesconto?Number(periodo.qtdDiasDesconto):0;var tempoBruto=periodo.qtdDiasContribuicaoBruto?Number(periodo.qtdDiasContribuicaoBruto):0;var qtdDiasContribuicaoLiquido=Math.trunc(tempoBruto-qtdDiasDesconto);if(qtdDiasContribuicaoLiquido<=0){mensagemTempoDescontado=2;}_this.props.atualizarTempoContribuicaoLiquido(qtdDiasContribuicaoLiquido);_this.validarPeriodo(qtdDiasContribuicaoLiquido,mensagemTempoDescontado);_this.esconderPainelMensagemCampo();}return 0;};_this.handleAdicionarPeriodo=function(){var _this$props3=Object.assign({},_this.props),periodo=_this$props3.periodo;var _this$props$estadoFor=Object.assign({},_this.props.estadoFormulario.requerimento),requerimentoPeriodos=_this$props$estadoFor.requerimentoPeriodos;if(periodo){if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(periodo.dataInicio,'DD/MM/YYYY').toDate()<=__WEBPACK_IMPORTED_MODULE_2_moment___default()(periodo.dataFim,'DD/MM/YYYY').toDate()){requerimentoPeriodos.push(periodo);var temConcomitancia=_this.props.determinarConcomitancias(requerimentoPeriodos,requerimentoPeriodos.length-1);requerimentoPeriodos=_this.props.ordenarListaPeriodos(requerimentoPeriodos);if(temConcomitancia){var index=requerimentoPeriodos.findIndex(function(periodo){return periodo.indice===undefined;});if(index!==-1){requerimentoPeriodos.splice(index,1);}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['O Per\xEDodo de '+_this.props.periodo.dataInicio+' at\xE9 '+_this.props.periodo.dataFim+' \xE9 concomitante com outros per\xEDodos existentes na lista.']);}else{_this.alteraLista(requerimentoPeriodos,1);}}else{Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['O Per\xEDodo de '+_this.props.periodo.dataInicio+' at\xE9 '+_this.props.periodo.dataFim+' \xE9 inv\xE1lido.']);}}};_this.handleAlterarPeriodo=function(){var _this$props4=Object.assign({},_this.props),periodo=_this$props4.periodo;var _this$props$estadoFor2=Object.assign({},_this.props.estadoFormulario.requerimento),requerimentoPeriodos=_this$props$estadoFor2.requerimentoPeriodos;if(periodo){var periodoCopia=requerimentoPeriodos[periodo.indice];requerimentoPeriodos[periodo.indice]=periodo;var temConcomitancia=_this.props.determinarConcomitancias(requerimentoPeriodos,periodo.indice);if(temConcomitancia){requerimentoPeriodos[periodo.indice]=periodoCopia;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['O Per\xEDodo '+_this.props.periodo.dataInicio+' at\xE9 '+_this.props.periodo.dataFim+' \xE9 concomitante com outros per\xEDodos existentes na lista.']);}else{requerimentoPeriodos=_this.props.ordenarListaPeriodos(requerimentoPeriodos,periodo.indice);var index=requerimentoPeriodos.findIndex(function(p){return p.indice===periodo.indice;});if(index!==-1){if(requerimentoPeriodos[index].dataInicio!==periodo.dataInicio){requerimentoPeriodos[index].dataInicio=periodo.dataInicio;}if(requerimentoPeriodos[index].dataFim!==periodo.dataFim){requerimentoPeriodos[index].dataFim=periodo.dataFim;}if(requerimentoPeriodos[index].qtdDiasDesconto!==periodo.qtdDiasDesconto){requerimentoPeriodos[index].qtdDiasDesconto=periodo.qtdDiasDesconto;}if(requerimentoPeriodos[index].qtdDiasContribuicaoBruto!==periodo.qtdDiasContribuicaoBruto){requerimentoPeriodos[index].qtdDiasContribuicaoBruto=periodo.qtdDiasContribuicaoBruto;}if(requerimentoPeriodos[index].qtdDiasContribuicaoLiquido!==periodo.qtdDiasContribuicaoLiquido){requerimentoPeriodos[index].qtdDiasContribuicaoLiquido=periodo.qtdDiasContribuicaoLiquido;}if(periodo.idPeriodo){requerimentoPeriodos[index].operacao=periodo.operacao;}else{requerimentoPeriodos[index].operacao=1;}}_this.alteraLista(requerimentoPeriodos,2);}}};_this.mostraPainelMensagemCampo=function(){_this.setState({mostraPainelMensagemCampo:true});};_this.esconderPainelMensagemCampo=function(){_this.setState({mostraPainelMensagemCampo:false});};_this.painelMensagemCampo=function(){if(__WEBPACK_IMPORTED_MODULE_6__domain_User__["a" /* default */].logged().isRGPS()){var mensagemCampoParagrafo1RGPS=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'O campo \'Tempo Descontado\' deve ser utilizado para ajustar o tempo certificado e efetivamente utilizado no per\xEDodo acima.');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,mensagemCampoParagrafo1RGPS);}else{var mensagemCampoParagrafo1RPPS=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'O campo \'Tempo Descontado\' deve ser utilizado para ajustar o tempo certificado e efetivamente utilizado no per\xEDodo acima.');var mensagemCampoParagrafo2RPPS=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Se necess\xE1rio, fracione os per\xEDodos que contenham dedu\xE7\xF5es (faltas acima de 30 dias consecutivos; licen\xE7as; etc.).');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,mensagemCampoParagrafo1RPPS,mensagemCampoParagrafo2RPPS);}};_this.modalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{label:'Data de in\xEDcio',onChange:function onChange(e){return _this.props.handleChangePeriodos(e,'dataInicio');},value:_this.props.periodo.dataInicio,onBlur:function onBlur(e){return _this.calcularTempoDeContribuicaoBruto();},mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{label:'Data de t\xE9rmino',onChange:function onChange(e){return _this.props.handleChangePeriodos(e,'dataFim');},onBlur:function onBlur(e){return _this.calcularTempoDeContribuicaoBruto();},value:_this.props.periodo.dataFim,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{label:'Tempo de contribui\xE7\xE3o bruto',value:_this.props.periodo.qtdDiasContribuicaoBruto>0?_this.props.periodo.qtdDiasContribuicaoBruto:'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{label:'Tempo descontado',value:_this.props.periodo.qtdDiasDesconto,disabled:_this.verificaSeCampoDesabilitado('qtdDiasDesconto'),onBlur:function onBlur(e){return _this.calcularTempoDeContribuicaoLiquido();},onFocus:function onFocus(e){return _this.mostraPainelMensagemCampo();},onChange:function onChange(e){return _this.props.handleChangePeriodos(e,'qtdDiasDesconto');},integer:true,number:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{label:'Tempo de contribui\xE7\xE3o liquido',value:_this.props.periodo.qtdDiasContribuicaoLiquido>0?_this.props.periodo.qtdDiasContribuicaoLiquido:'',disabled:true}))),_this.state.mostraPainelMensagemCampo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6__domain_User__["a" /* default */].logged()&&__WEBPACK_IMPORTED_MODULE_6__domain_User__["a" /* default */].logged().isRGPS()?jssPainelMensagemCampoRGPS:jssPainelMensagemCampoRPPS},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssMensagemDescricao},_this.painelMensagemCampo())));};_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!_this.checkIfCanBeSent(),hint:'Adicionar per\xEDodo',onClick:_this.props.periodo.operacao&&_this.props.periodo.operacao===2?_this.handleAlterarPeriodo:_this.handleAdicionarPeriodo,title:_this.props.periodo.operacao&&_this.props.periodo.operacao===2?"Alterar":"Adicionar"})));};_this.handleChange=function(changeObj,name){var _this$state=Object.assign({},_this.state),periodo=_this$state.periodo;_this.setState({periodo:Object.assign({},periodo,_defineProperty({},name,changeObj.value))});};_this.handleClose=function(){_this.setState(_this.props.handleModal('showModal'));};_this.state=_this.getInitialState();;return _this;}_createClass(ModalPeriodo,[{key:'validarPeriodo',value:function validarPeriodo(tempo,mensagem){var retorno=false;if(tempo>0){retorno=true;}else{if(mensagem===1){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['A data de início ou a data de término não corresponde a ano bissexto.']);}else{if(mensagem===2){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['O tempo descontado deve ser menor que o tempo de contribuição bruto.']);}else{Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['O período é inválido. A data de início deve ser menor que a data de término.']);}}}this.setState({periodoValido:retorno});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalFooter(),conteudomodal:this.modalContent(),onHide:this.handleClose,size:'lg',showModal:this.props.showModal,title:this.props.periodo.operacao&&this.props.periodo.operacao===2?'alterar Período':'adicionar Período',hint:this.props.periodo.operacao&&this.props.periodo.operacao===2?'alterar Período':'adicionar Período'}));}}]);return ModalPeriodo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalPeriodo.propTypes={periodo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChangePeriodos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,atualizarDataIngressoDesvinculacaoETempo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,atualizarTempos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,atualizarTempoContribuicaoLiquido:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,determinarConcomitancias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,ordenarListaPeriodos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,calcularPeriodoRgps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,calcularPeriodoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalPeriodo);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__calculadora_periodos_Periodo__ = __webpack_require__(211);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable*/var ModalCalculadoraPeriodo=function(_Component){_inherits(ModalCalculadoraPeriodo,_Component);function ModalCalculadoraPeriodo(props){_classCallCheck(this,ModalCalculadoraPeriodo);var _this=_possibleConstructorReturn(this,(ModalCalculadoraPeriodo.__proto__||Object.getPrototypeOf(ModalCalculadoraPeriodo)).call(this,props));_this.montaFormulario=function(){var _this$state=Object.assign({},_this.state),listaPeriodos=_this$state.listaPeriodos;listaPeriodos=_this.handleCriarPeriodoApartirDeRequerimentos();if(listaPeriodos.length===0){var periodo={};periodo.index=0;periodo['dataInicio-0']='';periodo['dataFim-0']='';periodo.totalAno='';periodo.totalMes='';periodo.totalDia='';listaPeriodos.push(periodo);}listaPeriodos=_this.reorganizarIndiceLista(_this.ordenarListaPeriodos(listaPeriodos));_this.setState({listaPeriodos:listaPeriodos});};_this.validarRegrasPeriodo=function(){var _this$state2=Object.assign({},_this.state),listaPeriodos=_this$state2.listaPeriodos;listaPeriodos.forEach(function(periodo){periodo=_this.handleCalcularAmd(periodo);_this.handleCalcularRgps();});_this.setState({listaPeriodos:listaPeriodos});};_this.compararDatasInicio=function(a,b){if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a['dataInicio-'+a.index],'DD/MM/YYYY').toDate()<__WEBPACK_IMPORTED_MODULE_2_moment___default()(b['dataInicio-'+b.index],'DD/MM/YYYY').toDate()){return-1;}if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a['dataInicio-'+a.index],'DD/MM/YYYY').toDate()>__WEBPACK_IMPORTED_MODULE_2_moment___default()(b['dataInicio-'+b.index],'DD/MM/YYYY').toDate()){return 1;}return 0;};_this.ordenarListaPeriodos=function(lista){return lista.sort(_this.compararDatasInicio);};_this.reorganizarIndiceLista=function(){var _this$state3=Object.assign({},_this.state),listaPeriodos=_this$state3.listaPeriodos;var listaIndiceCorrigido=[];listaPeriodos.forEach(function(periodo,arrayIndex){var retorno={};if(periodo.index===arrayIndex){retorno.index=periodo.index;retorno['dataInicio-'+arrayIndex]=periodo['dataInicio-'+arrayIndex];retorno['dataFim-'+arrayIndex]=periodo['dataFim-'+arrayIndex];retorno.totalAno=periodo.totalAno;retorno.totalMes=periodo.totalMes;retorno.totalDia=periodo.totalDia;}else{retorno.index=arrayIndex;retorno['dataInicio-'+arrayIndex]=periodo['dataInicio-'+periodo.index];retorno['dataFim-'+arrayIndex]=periodo['dataFim-'+periodo.index];retorno.totalAno=periodo.totalAno;retorno.totalMes=periodo.totalMes;retorno.totalDia=periodo.totalDia;}listaIndiceCorrigido.push(retorno);});return listaIndiceCorrigido;};_this.handleCriarPeriodoApartirDeRequerimentos=function(){var _this$state4=Object.assign({},_this.state),listaPeriodos=_this$state4.listaPeriodos,totalTempoDescontado=_this$state4.totalTempoDescontado;var _this$props$estadoFor=Object.assign({},_this.props.estadoFormulario.requerimento),requerimentoPeriodos=_this$props$estadoFor.requerimentoPeriodos;requerimentoPeriodos.forEach(function(periodo){var periodoAux={};periodoAux.index=periodo.indice;periodoAux['dataInicio-'+periodoAux.index]=periodo.dataInicio;periodoAux['dataFim-'+periodoAux.index]=periodo.dataFim;periodoAux.totalAno='';periodoAux.totalMes='';periodoAux.totalDia='';listaPeriodos.push(periodoAux);});_this.validarRegrasPeriodo();totalTempoDescontado=_this.handleCalcularDiasDescontados();_this.handleCalcularTempoLiquido(totalTempoDescontado);return listaPeriodos;};_this.handleCalcularAmd=function(periodo){var acrescentarDia=1;var acrescentarMesDias=30;var trintaUm=31;var qtdDiasMes=30;var qtdMesesAno=12;var acrescentarAno=12;var reduzirMes=1;var reduzirAno=1;var mesFev=2;var ultimoDiaFevBissexto=29;var ultimoDiaFevNaoBissexto=28;var resultadoDia=0;var resultadoMes=0;var resultadoAno=0;var resultadoQtdMeses=0;var restoDivisaoDia=0;var resultadoQtdAnos=0;var restoDivisaoMes=0;var diaInicio=periodo['dataInicio-'+periodo.index].split('/')[0];var mesInicio=periodo['dataInicio-'+periodo.index].split('/')[1];var anoInicio=periodo['dataInicio-'+periodo.index].split('/')[2];var diaFim=periodo['dataFim-'+periodo.index].split('/')[0];var mesFim=periodo['dataFim-'+periodo.index].split('/')[1];var anoFim=periodo['dataFim-'+periodo.index].split('/')[2];if(__WEBPACK_IMPORTED_MODULE_2_moment___default()([anoFim]).isLeapYear()){if(Number(mesFim)===mesFev&&Number(diaFim)===ultimoDiaFevBissexto){diaFim=Number(diaFim)+1;}}else{if(Number(mesFim)===mesFev&&Number(diaFim)===ultimoDiaFevNaoBissexto){diaFim=Number(diaFim)+2;}}if(Number(diaFim)<trintaUm){diaFim=Number(diaFim)+acrescentarDia;if(Number(diaInicio>diaFim)){diaFim=Number(diaFim)+acrescentarMesDias;mesFim=Number(mesFim)-reduzirMes;}}resultadoDia=Number(diaFim-diaInicio);resultadoQtdMeses=Math.trunc(resultadoDia/qtdDiasMes);restoDivisaoDia=resultadoDia%qtdDiasMes;resultadoDia=restoDivisaoDia;if(Number(mesFim<mesInicio)){mesFim=Number(mesFim)+acrescentarAno;anoFim=Number(anoFim)-reduzirAno;}resultadoMes=Number(mesFim-mesInicio);resultadoMes+=resultadoQtdMeses;resultadoQtdAnos=Math.trunc(resultadoMes/qtdMesesAno);restoDivisaoMes=resultadoMes%qtdMesesAno;resultadoMes=restoDivisaoMes;resultadoAno=Number(anoFim-anoInicio);resultadoAno+=resultadoQtdAnos;periodo.totalAno=Math.trunc(Number(resultadoAno));periodo.totalMes=Math.trunc(Number(resultadoMes));periodo.totalDia=Math.trunc(Number(resultadoDia));return periodo;};_this.handleCalcularRgps=function(){var _this$state5=Object.assign({},_this.state),periodosRgps=_this$state5.periodosRgps;var _this$state6=Object.assign({},_this.state),listaPeriodos=_this$state6.listaPeriodos;var resultadoDia=0;var resultadoMes=0;var resultadoAno=0;var resultadoQtdMeses=0;var restoDivisaoDia=0;var resultadoQtdAnos=0;var restoDivisaoMes=0;var acrescentarMesDias=30;var qtdDiasMes=30;var qtdMesesAno=12;var acrescentarAnoDias=365;listaPeriodos.forEach(function(periodo){if(periodo.totalDia!==''&&periodo.totalMes!==''&&periodo.totalAno!==''){resultadoDia+=periodo.totalDia;resultadoQtdMeses=Math.trunc(resultadoDia/qtdDiasMes);restoDivisaoDia=resultadoDia%qtdDiasMes;resultadoDia=restoDivisaoDia;resultadoMes+=periodo.totalMes+resultadoQtdMeses;resultadoQtdAnos=Math.trunc(resultadoMes/qtdMesesAno);restoDivisaoMes=resultadoMes%qtdMesesAno;resultadoMes=restoDivisaoMes;resultadoAno+=periodo.totalAno+resultadoQtdAnos;}});periodosRgps.totalDia=resultadoDia;periodosRgps.totalMes=resultadoMes;periodosRgps.totalAno=resultadoAno;periodosRgps.qtdTotalDias=Number(resultadoAno*acrescentarAnoDias+resultadoMes*acrescentarMesDias+resultadoDia);_this.setState({periodosRgps:Object.assign({},_this.state.periodosRgps,{periodosRgps:periodosRgps})});};_this.handleCalcularDiasDescontados=function(){var _this$props$estadoFor2=Object.assign({},_this.props.estadoFormulario.requerimento),requerimentoPeriodos=_this$props$estadoFor2.requerimentoPeriodos;var _this$state7=Object.assign({},_this.state),totalTempoDescontado=_this$state7.totalTempoDescontado;requerimentoPeriodos.forEach(function(periodo){totalTempoDescontado+=periodo.qtdDiasDesconto;});_this.setState({totalTempoDescontado:totalTempoDescontado});return totalTempoDescontado;};_this.handleCalcularTempoLiquido=function(tempoDescontado){var _this$state8=Object.assign({},_this.state),periodosRgps=_this$state8.periodosRgps,totalTempoContribuicaoLiquido=_this$state8.totalTempoContribuicaoLiquido;totalTempoContribuicaoLiquido=periodosRgps.qtdTotalDias-tempoDescontado;_this.setState({totalTempoContribuicaoLiquido:totalTempoContribuicaoLiquido});};_this.modalContent=function(){var _this$state9=Object.assign({},_this.state),listaPeriodos=_this$state9.listaPeriodos;var colecao=[];listaPeriodos.forEach(function(periodo){colecao.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__calculadora_periodos_Periodo__["a" /* default */],{state:_this.state,periodo:periodo,listaPeriodos:_this.state.listaPeriodos,validarRegras:_this.validarRegrasPeriodo,displayButton:false,disabledInputDate:true})));return colecao;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxHeight:'200px','overflow-y':'auto','overflow-x':'hidden'}},colecao),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'F\xF3rmula do RGPS:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{showMask:false,label:'Anos',integer:true,disabled:true,value:_this.state.periodosRgps.totalAno})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{showMask:false,label:'Meses',integer:true,disabled:true,value:_this.state.periodosRgps.totalMes})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{showMask:false,label:'Dia',integer:true,disabled:true,value:_this.state.periodosRgps.totalDia})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:true,value:'|',style:{borderBottom:'none','text-align':'center'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{showMask:false,label:'Dias',disabled:true,value:_this.state.periodosRgps.qtdTotalDias})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{showMask:false,label:'Total Tempo Descontado',disabled:true,value:_this.state.totalTempoDescontado})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{showMask:false,label:'Tempo Contribui\xE7\xE3o L\xEDquido',disabled:true,value:_this.state.totalTempoContribuicaoLiquido!==0?_this.state.totalTempoContribuicaoLiquido:''}))))));};_this.handleClose=function(){_this.setState(_this.props.handleModal('showModalCalculadoraPeriodo'));};_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{title:'Cancelar',onClick:_this.handleClose,hint:'Cancelar'})));};_this.state={periodosRgps:{totalAno:'',totalMes:'',totalDia:'',qtdTotalDias:''},listaPeriodos:[],periodo:{index:0,dataInicio:'',dataFim:'',totalAno:'',totalMes:'',totalDia:''},totalTempoDescontado:0,totalTempoContribuicaoLiquido:0};return _this;}_createClass(ModalCalculadoraPeriodo,[{key:'componentDidMount',value:function componentDidMount(){this.montaFormulario();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:this.modalContent(),conteudofooter:this.modalFooter(),onHide:this.handleClose,showModal:this.props.showModal,size:'lg',title:'Calculadora de Per\xEDodos',hint:'Calculadora de Per\xEDodos'}));}}]);return ModalCalculadoraPeriodo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalCalculadoraPeriodo.propTypes={handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ModalCalculadoraPeriodo);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PLACEHOLDER='Selecione o tipo de segregação de massa';var LABEL='Segregação de massa do ';var ModalAlteracaoSegregacaoMassa=function(_Component){_inherits(ModalAlteracaoSegregacaoMassa,_Component);function ModalAlteracaoSegregacaoMassa(props,context){_classCallCheck(this,ModalAlteracaoSegregacaoMassa);var _this=_possibleConstructorReturn(this,(ModalAlteracaoSegregacaoMassa.__proto__||Object.getPrototypeOf(ModalAlteracaoSegregacaoMassa)).call(this,props,context));_this.getInitialState=function(){return{tipoSegregacaoDestinatario:_this.props.tipoSegregacaoDestinatario,tipoSegregacaoSolicitante:_this.props.tipoSegregacaoSolicitante,touched:false};};_this.checkIfFileCanBeSent=function(){return _this.state.tipoSegregacaoDestinatario||_this.state.tipoSegregacaoDestinatario===''||_this.state.tipoSegregacaoSolicitante||_this.state.tipoSegregacaoSolicitante==='';};_this.handleSave=function(){// const tipo = this.diffRequerimento();
var url='alterar-tipo-segregacao-massa';var _this$props=Object.assign({},_this.props),protocolo=_this$props.protocolo;var _this$state=Object.assign({},_this.state),tipoSegregacaoDestinatario=_this$state.tipoSegregacaoDestinatario;var _this$state2=Object.assign({},_this.state),tipoSegregacaoSolicitante=_this$state2.tipoSegregacaoSolicitante;var tipo=null;var parametroProtocolo=protocolo;var objAlteracao={protocolo:parametroProtocolo};if(tipoSegregacaoDestinatario&&tipoSegregacaoDestinatario!==null){tipo=Number(tipoSegregacaoDestinatario);objAlteracao.tipoSegregacaoDestinatario=tipo;}if(tipoSegregacaoSolicitante&&tipoSegregacaoSolicitante!==null){tipo=Number(tipoSegregacaoSolicitante);objAlteracao.tipoSegregacaoSolicitante=tipo;}var options=void 0;if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["n" /* doPut */])(url,objAlteracao,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,options);};_this.trataSucessoResponseEnvio=function(){_this.handleClose();_this.props.atualizarTipoSegregacaoMassaDestinatario(_this.state.tipoSegregacaoDestinatario);_this.props.atualizarTipoSegregacaoMassaSolicitante(_this.state.tipoSegregacaoSolicitante);Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["J" /* trataMensagemSucesso */])(['Tipo de segregação de massa alterada']);};_this.modalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},_this.props.origem==='destinatario'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{placeholder:PLACEHOLDER,label:LABEL,itemList:__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["V" /* tiposSegregacoesDeMassa */],onChange:function onChange(e){return _this.handleChange(e,'tipoSegregacaoDestinatario');},value:_this.state.tipoSegregacaoDestinatario,touched:_this.state.touched,custom:true})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{placeholder:PLACEHOLDER,label:LABEL,itemList:__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["V" /* tiposSegregacoesDeMassa */],onChange:function onChange(e){return _this.handleChange(e,'tipoSegregacaoSolicitante');},value:_this.state.tipoSegregacaoSolicitante,touched:_this.state.touched,custom:true}))));};_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!_this.checkIfFileCanBeSent(),hint:'Salvar',onClick:_this.handleSave,title:'Salvar'})));};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value));};_this.handleClose=function(){_this.setState({tipoSegregacaoDestinatario:null},_this.props.handleModal('exibirModalSegregacaoMassa'));};_this.state=_this.getInitialState();return _this;}_createClass(ModalAlteracaoSegregacaoMassa,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalFooter(),conteudomodal:this.modalContent(),onHide:this.handleClose,size:'md',showModal:this.props.showModal,title:'Alterar o tipo de segrega\xE7\xE3o de massa'}));}}]);return ModalAlteracaoSegregacaoMassa;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalAlteracaoSegregacaoMassa.propTypes={tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,tipoSegregacaoDestinatario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,tipoSegregacaoSolicitante:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,atualizarTipoSegregacaoMassaDestinatario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,atualizarTipoSegregacaoMassaSolicitante:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalAlteracaoSegregacaoMassa);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAlteracaoMotivoCessacao=function(_Component){_inherits(ModalAlteracaoMotivoCessacao,_Component);function ModalAlteracaoMotivoCessacao(props,context){_classCallCheck(this,ModalAlteracaoMotivoCessacao);var _this=_possibleConstructorReturn(this,(ModalAlteracaoMotivoCessacao.__proto__||Object.getPrototypeOf(ModalAlteracaoMotivoCessacao)).call(this,props,context));_this.getInitialState=function(){return{motivoCessacaoManual:_this.props.motivoCessacaoManual,touched:false};};_this.checkIfFileCanBeSent=function(){return _this.state.motivoCessacaoManual||_this.state.motivoCessacaoManual==='';};_this.diffRequerimento=function(){var _this$props=Object.assign({},_this.props),tipoRequerimento=_this$props.tipoRequerimento;if(tipoRequerimento===2){return'pensao';}return'aposentadoria';};_this.handleSave=function(){var tipo=_this.diffRequerimento();var url='alterar-data-cessacao-requerimento-'+tipo;var _this$props2=Object.assign({},_this.props),protocolo=_this$props2.protocolo;var _this$props3=Object.assign({},_this.props),estadoFormulario=_this$props3.estadoFormulario;var _this$state=Object.assign({},_this.state),motivoCessacaoManual=_this$state.motivoCessacaoManual;var objProtocolo=protocolo;var objDataCessacaoBeneficio=estadoFormulario.requerimento.dataCessacaoBeneficio;// const objDataCessacaoBeneficio = '19/02/2026';
var objMotivoCessacaoManual=motivoCessacaoManual;if(objMotivoCessacaoManual===''){objMotivoCessacaoManual=null;}var objAlteracao={protocolo:objProtocolo,motivoCessacaoManual:objMotivoCessacaoManual,dataCessacao:objDataCessacaoBeneficio};var options=void 0;if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["n" /* doPut */])(url,objAlteracao,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,options);};_this.trataSucessoResponseEnvio=function(response){_this.handleClose();_this.props.atualizarMotivoCessacao(_this.state.motivoCessacaoManual);// Adiciona o histórico para bloquear o lápis
// const novoHistorico = {
//   descricao: 'Informação de data e motivo de cessação',
// };
// console.log(response.data);
var retorno=response&&response.data?response.data:[];_this.props.atualizarHistoricoAuditorias(retorno);Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["J" /* trataMensagemSucesso */])(['Motivo de cessação do benefício alterado']);};_this.filterMotivos=function(lista,requerimento,tipo){var motivosCessacaoFiltrado=[];var codigoTipo=tipo==='aposentadoria'?1:2;var inss='01000';var destinatarioOuSolicitanteRGPS=false;var regimes=[2,3];if(requerimento.solicitante){destinatarioOuSolicitanteRGPS=[requerimento.solicitante.codigo,requerimento.destinatario.codigo].includes(inss);if(requerimento.solicitante.codigo===inss){regimes=[1,3];}}var acordos=destinatarioOuSolicitanteRGPS?[1,3]:[2,3];motivosCessacaoFiltrado=lista.filter(function(motivo){return motivo.abrangenciaAplicavel===codigoTipo&&regimes.includes(motivo.regimeAplicavel)&&acordos.includes(motivo.acordoAplicavel);});return motivosCessacaoFiltrado;};_this.modalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{label:'Motivo Cessac\xE3o',number:true,touched:_this.props.estadoFormulario.touched,placeholder:'Selecione o Motivo da Cessac\xE3o',onChange:function onChange(e){return _this.handleChange(e,'motivoCessacaoManual');},value:_this.state.motivoCessacaoManual,itemList:_this.filterMotivos(_this.props.motivosCessacao,_this.props.estadoFormulario.requerimento,'aposentadoria'),required:_this.props.estadoFormulario.requerimento.dataCessacaoBeneficio!==null,custom:true}))));};_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!_this.checkIfFileCanBeSent(),hint:'Salvar',onClick:_this.handleSave,title:'Salvar'})));};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value));};_this.handleClose=function(){_this.setState({motivoCessacaoManual:null},_this.props.handleModal('exibirModalMotivoCessacao'));};_this.state=_this.getInitialState();return _this;}_createClass(ModalAlteracaoMotivoCessacao,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalFooter(),conteudomodal:this.modalContent(),onHide:this.handleClose,size:'md',showModal:this.props.showModal,title:'Alterar o motivo de cessa\xE7\xE3o do requerimento'}));}}]);return ModalAlteracaoMotivoCessacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalAlteracaoMotivoCessacao.propTypes={tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,motivoCessacaoManual:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,atualizarMotivoCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired}.isRequired;var mapStateToProps=function mapStateToProps(state){return{motivosCessacao:state.base.motivosCessacao};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ModalAlteracaoMotivoCessacao));

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DadosHistoricoPrescricao_css__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DadosHistoricoPrescricao_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DadosHistoricoPrescricao_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var DadosHistoricoPrescricao=function(_Component){_inherits(DadosHistoricoPrescricao,_Component);function DadosHistoricoPrescricao(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DadosHistoricoPrescricao);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DadosHistoricoPrescricao.__proto__||Object.getPrototypeOf(DadosHistoricoPrescricao)).call.apply(_ref,[this].concat(args))),_this),_this.obterPrescricao=function(){return _this.props.estadoFormulario.requerimento.prescricao||{};},_this.obterNumero=function(valor){if(!valor)return 0;if(typeof valor==='number')return valor;return Number(String(valor).replace(/\./g,'').replace(',','.'));},_this.renderCard=function(titulo,valor,cor){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prescricao-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prescricao-card-faixa',style:{background:cor}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prescricao-card-titulo'},titulo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prescricao-card-valor'},Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["e" /* formatarValor */])(valor)));},_this.renderDashboard=function(){var p=_this.obterPrescricao();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["f" /* DataGridCustom */],{title:'Resumo Financeiro da Prescri\xE7\xE3o',retirarLinhaSeparadora:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-prescricao'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-linha-titulo'},'Valor Total Prescrito'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-total-valor'},Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["e" /* formatarValor */])(p.vlTotalPrescricao))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dashboard-cards'},_this.renderCard("Estoque",p.vlEstoquePrescricao,"#FF9800"),_this.renderCard("Fluxo",p.vlPassivoPrescricao,"#00A651"),_this.renderCard("Pró-rata",p.vlProRataPrescricao,"#1565C0"))));},_this.renderDetalhes=function(){var p=_this.obterPrescricao();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["f" /* DataGridCustom */],{title:'Detalhamento',retirarLinhaSeparadora:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhes-grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhe-item detalhe-laranja'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Estoque'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["e" /* formatarValor */])(p.vlEstoquePrescricao))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhe-item detalhe-verde'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Fluxo acumulado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["e" /* formatarValor */])(p.vlPassivoPrescricao))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhe-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Valor total prescrito'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["e" /* formatarValor */])(p.vlTotalPrescricao))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhe-item detalhe-laranja'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'In\xEDcio do estoque'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,p.dtIniPeriodoEstoquePrescricao)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhe-item detalhe-verde'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'In\xEDcio do fluxo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,p.dtIniPeriodoPassivoPrescricao)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhe-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Pr\xF3-rata do 1\xBA pagamento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["e" /* formatarValor */])(p.vlProRataPrescricao))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhe-item detalhe-laranja'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Fim do estoque'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,p.dtFimPeriodoEstoquePrescricao)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhe-item detalhe-verde'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Fim do fluxo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,p.dtFimPeriodoPassivoPrescricao)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhe-item detalhe-vermelho'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Quantidade de dias prescritos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,p.qtdeDiasPrescritos)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhe-item detalhe-laranja'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'13\xBA do estoque'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["e" /* formatarValor */])(p.vl13EstoquePrescricao))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detalhe-item detalhe-verde'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'13\xBA do fluxo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["e" /* formatarValor */])(p.vl13PassivoPrescricao)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:20,display:'flex',gap:20}},[{c:'#FF9800',l:'Estoque'},{c:'#00A651',l:'Fluxo'},{c:'#1565C0',l:'Prescrição'}].map(function(leg){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:leg.l,style:{display:'flex',alignItems:'center',gap:6}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:12,height:12,background:leg.c}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:12}},leg.l));})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DadosHistoricoPrescricao,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderDashboard(),this.renderDetalhes());}}]);return DadosHistoricoPrescricao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DadosHistoricoPrescricao);// /* eslint-disable */
// import React, { Component } from 'react';
// import PropTypes from 'prop-types';
// import { Title, Grid, SimpleGrid, DataGridCustom } from '../../components/index';
// import { formatarValor, formatarCnpj } from '../../utils/helpers';
// /* Grid, Input, Modal, Title */
// class DadosHistoricoPrescricao extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       // prescricoes: [],
//     };
//   }
//   formatarMoeda = (valor) => {
//     if (valor == null) return '0,00';
//     const numero = typeof valor === 'string'
//       ? parseFloat(valor.replace(/\./g, '').replace(',', '.'))
//       : Number(valor);
//     if (Number.isNaN(numero)) return '0,00';
//     return numero.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//   }
//   textoDestaque = texto => (
//     (<span style={{ fontWeight: '600' }}>{texto}</span>)
//   )
//   montaDadosPrescricao = () => {
//     const rowStyle = { marginBottom: '10px', fontSize: '16px' };
//     return (
//       <React.Fragment>
//         <DataGridCustom title="Prescrição" retirarLinhaSeparadora={false}>
//           <div className="row" style={rowStyle}>
//             <SimpleGrid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Pró-rata no 1º pagamento: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vlProRataPrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Valor Total Prescrito: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vlTotalPrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Qtde de Dias Prescritos: ')}
//                   {this.props.estadoFormulario.requerimento.prescricao.qtdeDiasPrescritos}
//                 </span>
//               </Grid>
//             </SimpleGrid>
//           </div>
//         </DataGridCustom>
//         <DataGridCustom title="Estoque" retirarLinhaSeparadora={false}>
//           <div className="row" style={rowStyle}>
//             <SimpleGrid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Estoque: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vlEstoquePrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('13º de estoque: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vl13EstoquePrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Início da prescrição do estoque: ')}
//                   {this.props.estadoFormulario.requerimento.prescricao.dtIniPeriodoEstoquePrescricao}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Fim da prescrição do estoque: ')}
//                   {this.props.estadoFormulario.requerimento.prescricao.dtFimPeriodoEstoquePrescricao}
//                 </span>
//               </Grid>
//             </SimpleGrid>
//           </div>
//         </DataGridCustom>
//         <DataGridCustom title="Fluxo" retirarLinhaSeparadora={false}>
//           <div className="row" style={rowStyle}>
//             <SimpleGrid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Fluxo acumulado: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vlPassivoPrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('13º de fluxo acumulado: ')}
//                   {formatarValor(this.props.estadoFormulario.requerimento.prescricao.vl13PassivoPrescricao)}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Início da prescrição do fluxo: ')}
//                   {this.props.estadoFormulario.requerimento.prescricao.dtIniPeriodoPassivoPrescricao}
//                 </span>
//               </Grid>
//               <Grid cols="3 3 3 3">
//                 <span>{this.textoDestaque('Fim da prescrição do fluxo: ')}
//                   {this.props.estadoFormulario.requerimento.prescricao.dtFimPeriodoPassivoPrescricao}
//                 </span>
//               </Grid>
//             </SimpleGrid>
//           </div>
//         </DataGridCustom>
//       </React.Fragment>
//     );
//   }
//   render() {
//     return (
//       <React.Fragment>
//         {this.montaDadosPrescricao()}
//       </React.Fragment>
//     );
//   }
// }
// export default DadosHistoricoPrescricao;

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var linhasPorPagina=8;var acao={MARCAR:'marcar',DESMARCAR:'desmacar'};var avisoVinculosConcomitantes={padding:'10px',color:'rgb(84, 110, 122)'};function Vinculo(props){var titulo=function titulo(r){var inicioPeriodo=' | '+r.dataInicio;var fimPeriodo=r.dataFim?' - '+r.dataFim:'';var tipoRelacaoPrevi=r.tipoRelacaoPrevidenciaria?'Filia\xE7\xE3o: '+r.tipoRelacaoPrevidenciaria:'';var cnpj=r.cnpj?' | CNPJ: '+Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["d" /* formatarCnpj */])(r.cnpj):'';var nome=r.nome?' | '+r.nome:'';return''+tipoRelacaoPrevi+cnpj+nome+inicioPeriodo+fimPeriodo;};var relacaoPrevidenciaria=props.relacaoPrevidenciaria;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["w" /* Title */],{title:titulo(relacaoPrevidenciaria),type:'section',fontWeight:'regular-16'}),relacaoPrevidenciaria.regimePrevidenciario.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Regime,{regime:e,visualizaRegime:props.visualizaRegime,marcarRegime:props.marcarRegime,desmarcarRegime:props.desmarcarRegime,acao:props.acao,tamanhoLista:props.tamanhoLista});})));}function Regime(props){var titulo=function titulo(r){var dataInicio=''+r.dataInicio;var dataFim=r.dataFim?' - '+r.dataFim:'';var tipoRegime=r.tipoRegimePrevidenciario?' - '+r.tipoRegimePrevidenciario:'';return''+dataInicio+dataFim+tipoRegime;};// Marca o vinculo informado e todos os compativeis. Desmarca todos os demais vinculos que colidam.
var toggleRegime=function toggleRegime(regime,acaoToggle){if(acaoToggle===acao.DESMARCAR){props.desmarcarRegime(regime);}else{props.marcarRegime(regime);}};var checked=props.regime.tipoConcomitanteDescartado===0||props.regime.tipoConcomitanteDescartado===null||props.regime.tipoConcomitanteDescartado===undefined;var acaoAoClicar=checked?acao.DESMARCAR:acao.MARCAR;// 8) Deferido; 11) Em Compensação; 12) Compensado
var exibeCheckbox=__WEBPACK_IMPORTED_MODULE_4__domain_User__["a" /* default */].logged().isRPPS()&&![8,11,12].includes(props.estado);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,exibeCheckbox&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{key:'vinculo-'+props.key+'-checkbox',type:'checkbox',checked:checked,onClick:function onClick(){return toggleRegime(props.regime,acaoAoClicar);},style:{transform:'scale(1.5)',position:'relative',top:'5px'},disabled:props.acao==='consulta'||props.tamanhoLista===1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:props.regime.tipoRegimePrevidenciario,icon:'ico-money',mini:true,onClick:function onClick(){return props.visualizaRegime(props.regime);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,titulo(props.regime)));}var DadosRelacoesPrevidenciarias=function(_Component){_inherits(DadosRelacoesPrevidenciarias,_Component);function DadosRelacoesPrevidenciarias(props,context){_classCallCheck(this,DadosRelacoesPrevidenciarias);var _this=_possibleConstructorReturn(this,(DadosRelacoesPrevidenciarias.__proto__||Object.getPrototypeOf(DadosRelacoesPrevidenciarias)).call(this,props,context));_this.getInitialState=function(){return{regime:null,showModal:false};};_this.visualizaRegime=function(regime){_this.setState({regime:regime,showModal:!_this.state.showModal});};_this.algumVinculoSelecionado=function(){var tiposConcomitantes=_this.props.relacoesPrevidenciarias.map(function(e){return e.regimePrevidenciario;}).flat().map(function(e){return e.tipoConcomitanteDescartado;});return tiposConcomitantes.includes(0);};_this.verificaVinculosConcomitantes=function(){var resultado=_this.props.validacaoConcomitancia();return resultado.existeConcomitancia;};_this.createActionColumn=function(indice,regime){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:'Visualizar remunera\xE7\xF5es',icon:'ico-money',mini:true,onClick:function onClick(){return _this.visualizaRegime(indice,regime);}});};_this.montaRegimesTableHeader=function(){return[{id:'competencia0',label:'Competência'},{id:'valor0',label:'Valor'},{id:'competencia1',label:'Competência'},{id:'valor1',label:'Valor'},{id:'competencia2',label:'Competência'},{id:'valor2',label:'Valor'}];};_this.handleModal=function(){_this.setState({showModal:!_this.state.showModal});};_this.montaListaRemuneracoes=function(){var colunasPorPagina=3;var pagina=0;var linha=0;var coluna=0;var listaFormatada=[];listaFormatada[0]={};if(_this.state.regime.remuneracoes===undefined){listaFormatada.length=0;}else{_this.state.regime.remuneracoes.forEach(function(remuneracao,index){listaFormatada[linha]['competencia'+coluna]=('0'+remuneracao.mes).slice(-2)+'/'+remuneracao.ano;listaFormatada[linha]['valor'+coluna]=remuneracao.valor.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3});if((index+1)%linhasPorPagina===0){if((index+1)%(linhasPorPagina*colunasPorPagina)===0){pagina+=1;linha=pagina*linhasPorPagina;coluna=0;if(listaFormatada[linha]===undefined){listaFormatada[linha]={};}}else{linha=pagina*linhasPorPagina;coluna+=1;if(coluna%colunasPorPagina===0){coluna=0;}}}else{linha+=1;if(listaFormatada[linha]===undefined){listaFormatada[linha]={};}}});}return listaFormatada;};_this.options={noDataText:'Não existe remuneração para o período selecionado.',hideSizePerPage:true,sizePerPage:linhasPorPagina};_this.montaModalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'350px','overflow-y':'auto','overflow-x':'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Tipo de regime previdenci\xE1rio',value:_this.state.regime.tipoRegimePrevidenciario})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Data de in\xEDcio do regime',value:_this.state.regime.dataInicio})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Data de fim do regime',value:_this.state.regime.dataFim}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{bordered:true,className:'tabela-remuneracoes-regime',data:_this.montaListaRemuneracoes(),options:_this.options,listaTableHeader:_this.montaRegimesTableHeader(),pagination:true,scrollTop:'Top'}))));};_this.modalFooter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:'Fechar',onClick:_this.handleModal,title:'Fechar'}));_this.state=_this.getInitialState();return _this;}_createClass(DadosRelacoesPrevidenciarias,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var _this2=this;var modal=void 0;var complemento=void 0;if(!__WEBPACK_IMPORTED_MODULE_4__domain_User__["a" /* default */].logged().isRGPS()&&this.props.estadoDoFormulario.requerimento.estado===8&&this.verificaVinculosConcomitantes()){complemento=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{style:avisoVinculosConcomitantes},'V\xEDnculos concomitantes encontrados.');}if(this.state.showModal){modal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12',style:{height:'400px',overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:this.montaModalContent(),conteudofooter:this.modalFooter,onHide:this.handleModal,showTitle:true,size:'lg',title:'Detalhes do regime selecionado',showModal:true}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["e" /* DataGrid */],{title:'Dados de Benef\xEDcio',icon:'ico-money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,mask:__WEBPACK_IMPORTED_MODULE_6__utils_masks__["a" /* default */].date,label:'Data de ingresso no regime de origem',value:this.props.estadoDoFormulario.requerimento.dataIngresso})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,mask:__WEBPACK_IMPORTED_MODULE_6__utils_masks__["a" /* default */].date,label:'Data de desvincula\xE7\xE3o no regime de origem',value:this.props.estadoDoFormulario.requerimento.dataDesvinculacao})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},!this.props.rgpsEnvolvido&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Regra de C\xE1lculo',itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["x" /* regrasDeCalculo */],value:this.props.estadoDoFormulario.requerimento.regraDeCalculo})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,this.props.relacoesPrevidenciarias.map(function(rel,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Vinculo,{key:'vinculo-'+index,relacaoPrevidenciaria:rel,vinculosSelecionados:_this2.state.vinculosSelecionados,visualizaRegime:_this2.visualizaRegime,marcarRegime:_this2.props.marcarRegime,desmarcarRegime:_this2.props.desmarcarRegime,acao:_this2.props.acao,tamanhoLista:_this2.props.relacoesPrevidenciarias.length});})),modal,!__WEBPACK_IMPORTED_MODULE_4__domain_User__["a" /* default */].logged().isRGPS()&&this.props.relacoesPrevidenciarias.map(function(e){return e.regimePrevidenciario;}).flat().length>1&&this.props.acao!=='consulta'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:'Confirmar Sele\xE7\xE3o',title:this.props.confirmado?"Confirmado":"Confirmar Seleção",onClick:function onClick(){return _this2.props.confirmar();},disabled:this.props.confirmado||!this.algumVinculoSelecionado()||this.verificaVinculosConcomitantes()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},complemento)));}}]);return DadosRelacoesPrevidenciarias;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DadosRelacoesPrevidenciarias.propTypes={relacoesPrevidenciarias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (DadosRelacoesPrevidenciarias);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
// const linhasPorPagina = 6;
var options={noDataText:'Nenhuma exigência para o requerimento',hideSizePerPage:true,sizePerPage:12};var tableHeaderAnual=[{id:'ano',label:'Ano'},{id:'valorReajustado',label:'Valor Reajustado'},{id:'indiceReajuste',label:'Índice reajuste'},{id:'valorTotal',label:'valor Total'}];var DadosResultadoSimulacao=function DadosResultadoSimulacao(props){var formatarLista=function formatarLista(){var listaFormatada=[];props.resultadoSimulacao.forEach(function(resultado){var resultFormatado=resultado;resultFormatado.valorReajustado=resultFormatado.valorReajustado.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3});listaFormatada.push(resultFormatado);});return listaFormatada;};var montaResultadoAnual=function montaResultadoAnual(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["u" /* Table */],{bordered:true,data:formatarLista(),options:options,listaTableHeader:tableHeaderAnual,pagination:true,scrollTop:'Top'});};var tableHeader=[{id:'ano',label:'Ano'},{id:'mes',label:'Mês'},{id:'valorReajustado',label:'Valor Reajustado'},{id:'indiceReajuste',label:'Índice reajuste'},{id:'tipoAtividade',label:'Tipo de Atividade'},{id:'indicadorTeto',label:'Indicador de teto'},{id:'considerado',label:'Considerado'}];var montaResultadoMensal=function montaResultadoMensal(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["u" /* Table */],{bordered:true,data:formatarLista(),options:options,listaTableHeader:tableHeader,pagination:true,scrollTop:'Top'});};var defineVisao=function defineVisao(){if(props.resultadoSimulacao[0].mes){return montaResultadoMensal();}return montaResultadoAnual();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,defineVisao());};DadosResultadoSimulacao.propTypes={resultadoSimulacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf().isRequired};/* harmony default export */ __webpack_exports__["a"] = (DadosResultadoSimulacao);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */// const ModalTempoRO = (props) => {
var ModalTempoRO=function(_Component){_inherits(ModalTempoRO,_Component);function ModalTempoRO(){_classCallCheck(this,ModalTempoRO);var _this=_possibleConstructorReturn(this,(ModalTempoRO.__proto__||Object.getPrototypeOf(ModalTempoRO)).call(this));_this.montaAlerta=function(alerta){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{'text-align':'justify','font-weight':'300'}},alerta.descricao);};_this.montaListaAlertas=function(){var listaRelacoes=[];_this.props.alertas.forEach(function(alerta){listaRelacoes.push(_this.montaAlerta(alerta));});return listaRelacoes;};_this.montaModalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.montaListaAlertas());};_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{title:'Cancelar',onClick:_this.props.handleModal,hint:'Cancelar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',title:'Aceitar',onClick:_this.props.aceitar})));};_this.handleClose=function(){_this.setState(_this.props.handleModal);};_this.state={};return _this;}_createClass(ModalTempoRO,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{alert:true,alertType:'warning',conteudomodal:this.montaModalContent(),conteudofooter:this.modalFooter(),onHide:this.handleClose,showTitle:true,size:this.props.tamanho?this.props.tamanho:'lg',title:this.props.labelTitulo?this.props.labelTitulo:'Confirma a ação?',showModal:true}));}}]);return ModalTempoRO;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalTempoRO.propTypes={handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,aceitar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,alertas:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({descricao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired,labelTitulo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,esconderBotaoCancelar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,tamanho:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ModalTempoRO);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DadosConflitosPeriodos__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var ListaConflitosPeriodos=function(_Component){_inherits(ListaConflitosPeriodos,_Component);function ListaConflitosPeriodos(props){_classCallCheck(this,ListaConflitosPeriodos);var _this=_possibleConstructorReturn(this,(ListaConflitosPeriodos.__proto__||Object.getPrototypeOf(ListaConflitosPeriodos)).call(this,props));_this.buscarConflitos=function(){var lista=_this.props.lista;if(!lista||lista.length===0){return;}// this.buscaConflitosPeriodos(lista);
_this.montarConflitosPeriodos(lista);};_this.atualizarConflitosPeriodos=function(conflitoAtualizado){_this.setState(function(prevState){var novaLista=prevState.listaRequerimentosConflitos.map(function(c){if(c.idConflito===conflitoAtualizado.idConflito){return Object.assign({},c,{requerimentoCorrente:Object.assign({},c.requerimentoCorrente,{nomeAprovador:conflitoAtualizado.nomeAprovador!=undefined?conflitoAtualizado.nomeAprovador:c.requerimentoCorrente.nomeAprovador,dataAprovacao:conflitoAtualizado.dataAprovacao!=undefined?conflitoAtualizado.dataAprovacao:c.requerimentoCorrente.dataAprovacao,cpfAprovador:conflitoAtualizado.cpfAprovador!=undefined?conflitoAtualizado.cpfAprovador:c.requerimentoCorrente.cpfAprovador,inAprovacao:conflitoAtualizado.inAprovacao!=undefined?conflitoAtualizado.inAprovacao:c.requerimentoCorrente.inAprovacao})});}return c;});_this.props.atualizarConflitosPeriodos(novaLista);return{listaRequerimentosConflitos:novaLista};});};_this.handleChangeConflitoPeriodos=function(changeObj){_this.setState({reconhecimentoConflito:changeObj.value});};_this.extrairValoresParaPesquisar=function(lista){var retorno=[];var valor=void 0;if(lista.length>0){lista.forEach(function(item){if(item.idConflito){retorno.push(Number(item.idConflito));}});}return retorno;};_this.buscaConflitosPeriodos=function(lista){var url='requerimentos-compensacao-aposentadoria/conflito-periodos/conflitos';var listaPesquisa=_this.extrairValoresParaPesquisar(lista);var parametro={lista:listaPesquisa,protocolo:_this.props.protocolo};Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["l" /* doPost */])(url,parametro,function(response){return _this.handleSuccessBuscaConflitosPeriodos(response);},_this.handleErrorBuscaconflitosPeriodos);};_this.montarConflitosPeriodos=function(lista){_this.handleSuccessBuscaConflitosPeriodos(lista);};_this.handleSuccessBuscaConflitosPeriodos=function(lista){if(!lista||!Array.isArray(lista)){return;}var contador=_this.state.listaRequerimentosConflitos.length+1;var novosConflitos=lista.map(function(dados){return{contadorConflito:contador++,idConflito:dados.idConflito,dataCriacaoConflito:dados.dataCriacaoConflito,dataResolucao:dados.dataResolucao,estadoConflito:dados.estadoConflito,cpfResolvedor:dados.cpfResolvedor||'',nomeResolvedor:dados.nomeResolvedor||'',requerimentoCorrente:{protocolo:dados.protocoloCorrente,nomeAprovador:dados.nomeAprovadorCorrente,dataAprovacao:dados.dataAprovacaoCorrente,cpf:dados.cpfCorrente,cpfAprovador:dados.cpfAprovadorCorrente,inAprovacao:dados.inAprovacaoCorrente,beneficiario:dados.beneficiarioCorrente,matricula:dados.matriculaCorrente,codigoSolicitante:dados.codigoSolicitanteCorrente,cnpjDestinatario:dados.cnpjDestinatario,nomeSolicitante:dados.nomeSolicitanteCorrente,codigoDestinatario:dados.codigoDestinatarioCorrente,nomeDestinatario:dados.nomeDestinatarioCorrente,estado:dados.estadoCorrente,estadoConflito:dados.estadoConflito,dataInicioBeneficio:dados.dataInicioBeneficioCorrente,dataIngresso:dados.dataIngressoCorrente,dataDesvinculacao:dados.dataDesvinculacaoCorrente,nuTempoContribRo:dados.nuTempoContribRoCorrente,dataCessacao:dados.dataCessacaoBeneficioCorrente,motivoCessacao:dados.idMotivoRequerimentoCorrente,nomeMotivoRequerimento:dados.nomeMotivoRequerimentoCorrente,veioPreenchidoDoBanco:!!dados.nomeAprovadorCorrente&&!!dados.dataAprovacaoCorrente},requerimentoConflitante:{protocolo:dados.protocoloConflito,nomeAprovador:dados.nomeAprovadorConflito,dataAprovacao:dados.dataAprovacaoConflito,cpf:dados.cpfConflito,beneficiario:dados.beneficiarioConflito,matricula:dados.matriculaConflito,codigoSolicitante:dados.codigoSolicitanteConflito,cnpjSolicitante:dados.cnpjSolicitante,nomeSolicitante:dados.nomeSolicitanteConflito,codigoDestinatario:dados.codigoDestinatarioConflito,nomeDestinatario:dados.nomeDestinatarioConflito,estado:dados.estadoConflitoConflitante,estadoConflito:dados.estadoConflito,dataInicioBeneficio:dados.dataInicioBeneficioConflito,dataIngresso:dados.dataIngressoConflito,dataDesvinculacao:dados.dataDesvinculacaoConflito,nuTempoContribRo:dados.nuTempoContribRoConflito,dataCessacao:dados.dataCessacaoBeneficioConflito,motivoCessacao:dados.idMotivoRequerimentoConflito,nomeMotivoRequerimento:dados.nomeMotivoRequerimentoConflito,veioPreenchidoDoBanco:!!dados.nomeAprovadorConflito&&!!dados.dataAprovacaoConflito},conflitosPeriodos:_this.montarListaConflitos(dados.requerimentosPeriodosConflitantes)};});_this.setState(function(prevState){var novaLista=[].concat(_toConsumableArray(prevState.listaRequerimentosConflitos),_toConsumableArray(novosConflitos));_this.props.atualizarConflitosPeriodos(novaLista);return{listaRequerimentosConflitos:novaLista};});};_this.montarListaConflitos=function(){var lista=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return lista.map(function(periodo){return{idPeriodoCorrente:_this.verificarIdVazio(periodo.idPeriodoCorrente),periodoReqCorrente:_this.verificarDataVazia(periodo.dataInicioPeriodoCorrente)+' - '+_this.verificarDataVazia(periodo.dataFimPeriodoCorrente),idPeriodoConflito:_this.verificarIdVazio(periodo.idPeriodoConflito),periodoReqConflito:_this.verificarDataVazia(periodo.dataInicioPeriodoConflito)+' - '+_this.verificarDataVazia(periodo.dataFimPeriodoConflito),periodoConflito:_this.verificarDataVazia(periodo.dataInicioConflito)+' - '+_this.verificarDataVazia(periodo.dataFimConflito)};});};_this.verificarIdVazio=function(id){return id!=null&&id!==undefined&&id!=''?id:'';};_this.verificarDataVazia=function(data){return data!=null&&data!==undefined&&data!=''?data:'__/__/____';};_this.handleErrorBuscaconflitosPeriodos=function(error){var mensagemPrimaria='Não foi possível consultar os conflitos de períodos.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.state={listaRequerimentosConflitos:[],reconhecimentoConflito:null,showNoContent:false,noContentPrimaryMessage:'',noContentSecondaryMessage:''};return _this;}_createClass(ListaConflitosPeriodos,[{key:'componentDidMount',value:function componentDidMount(){this.buscarConflitos();}},{key:'render',value:function render(){var _this2=this;var listaRequerimentosConflitos=this.state.listaRequerimentosConflitos;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,listaRequerimentosConflitos.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{key:item.contadorConflito+'-'+index,headingId:'conflito',panelId:item.contadorConflito+'-'+index,icon:'ico-alert',title:'Conflito '+item.contadorConflito+' |\n            Solicitante '+item.requerimentoConflitante.nomeSolicitante+' - '+item.requerimentoConflitante.codigoSolicitante+' |\n            Destinat\xE1rio '+item.requerimentoConflitante.nomeDestinatario+' - '+item.requerimentoConflitante.codigoDestinatario+'\n            '+(item.requerimentoConflitante.codigoSolicitante!=='01000'?' | Matr\xEDcula '+item.requerimentoConflitante.matricula:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DadosConflitosPeriodos__["a" /* default */],{conflitoPeriodos:item,handleChange:_this2.handleChangeConflitoPeriodos,atualizarConflitosPeriodos:_this2.atualizarConflitosPeriodos,acao:_this2.props.acao}));}));}}]);return ListaConflitosPeriodos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ListaConflitosPeriodos.propTypes={lista:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,atualizarConflitosPeriodos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ListaConflitosPeriodos);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RequerimentosConflitosPeriodos__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VisualizacaoPeriodos__ = __webpack_require__(592);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VAZIO='';var DadosConflitosPeriodos=function(_Component){_inherits(DadosConflitosPeriodos,_Component);function DadosConflitosPeriodos(props){_classCallCheck(this,DadosConflitosPeriodos);var _this=_possibleConstructorReturn(this,(DadosConflitosPeriodos.__proto__||Object.getPrototypeOf(DadosConflitosPeriodos)).call(this,props));_this.addTipoEstadoLabel=function(tipo){if(tipo===undefined||tipo===null){return'';}return __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["d" /* estadoConflito */],tipo).label;};_this.createColunaConflitoPeriodos=function(cell,row){var temPeriodoConflito=row.periodoConflito!==null&&row.periodoConflito!==VAZIO;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,temPeriodoConflito&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'red'}},row.periodoConflito)));};_this.showGrafico=function(row){var grafico={periodoReqCorrente:row.periodoReqCorrente,periodoReqConflito:row.periodoReqConflito,periodoConflito:row.periodoConflito,protocoloCorrente:_this.props.conflitoPeriodos.requerimentoCorrente.protocolo,protocoloConflito:_this.props.conflitoPeriodos.requerimentoConflitante.protocolo,solicitanteCorrente:_this.props.conflitoPeriodos.requerimentoCorrente.nomeSolicitante+' - '+_this.props.conflitoPeriodos.requerimentoCorrente.codigoSolicitante,destinatarioCorrente:_this.props.conflitoPeriodos.requerimentoCorrente.nomeDestinatario+' - '+_this.props.conflitoPeriodos.requerimentoCorrente.codigoDestinatario,solicitanteConflito:_this.props.conflitoPeriodos.requerimentoConflitante.nomeSolicitante+' - '+_this.props.conflitoPeriodos.requerimentoConflitante.codigoSolicitante,destinatarioConflito:_this.props.conflitoPeriodos.requerimentoConflitante.nomeDestinatario+' - '+_this.props.conflitoPeriodos.requerimentoConflitante.codigoDestinatario};_this.setState({exibirGrafico:true,parametrosGrafico:grafico,idLinhaExpandida:row.idPeriodoCorrente});};_this.fecharGrafico=function(){_this.setState({exibirGrafico:false,idLinhaExpandida:null});};_this.montaAcaoGrafico=function(row){var aberta=_this.state.idLinhaExpandida===row.idPeriodoCorrente;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{hint:aberta?'Fechar gráfico do conflito de períodos':'Exibir gráfico do conflito de períodos',icon:aberta?'ico-cancel':'ico-magnifier',mini:true,onClick:aberta?function(){return _this.fecharGrafico();}:function(){return _this.showGrafico(row);},className:aberta?'dtp-inverse':VAZIO}));};_this.createColunaGrafico=function(cell,row){return _this.montaAcaoGrafico(row);};_this.tableHeader=[{id:'idPeriodoCorrente',label:'Sequencial do Período'},{id:'periodoReqCorrente',label:'Período Original Requerimento Corrente'},{id:'periodoReqConflito',label:'Período Original Requerimento Conflitante'},{id:'periodoConflito',label:'Período Conflitante',dataFormat:_this.createColunaConflitoPeriodos},{id:'grafico',label:'Painel de Períodos',dataFormat:_this.createColunaGrafico}];_this.verificarTamanhoInput=function(value){if(value===undefined||value===null){return'';}var qtdMaxCharacterInput=42;return value.length>qtdMaxCharacterInput?value:'';};_this.state={exibirGrafico:false,idLinhaExpandida:null,parametrosGrafico:{periodoReqCorrente:null,periodoReqConflito:null,periodoConflito:null,protocoloCorrente:null,protocoloConflito:null,solicitanteCorrente:null,destinatarioCorrente:null,solicitanteConflito:null,destinatarioConflito:null}};return _this;}_createClass(DadosConflitosPeriodos,[{key:'getTagStatus',value:function getTagStatus(){var listaEstados=__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["e" /* estadoConflitoSimplificado */];if(this.props.conflitoPeriodos.idConflito){var estadoCss='';switch(this.props.conflitoPeriodos.estadoConflito){case 0:estadoCss='estadoNaoResolvido';break;case 1:case 2:case 3:case 4:case 5:case 6:estadoCss='estadoResolvido';break;default:estadoCss='';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:estadoCss,style:{textAlign:'center',fontSize:'12px',maxWidth:'inherit',padding:'5px 7px 5px 7px',minHeight:'inherit'}},__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */](listaEstados,this.props.conflitoPeriodos.estadoConflito).label);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'.');}},{key:'render',value:function render(){var acao=this.props.acao;var exibirCheckbox=acao==='realizar-analise';var listaIndexada=this.props.conflitoPeriodos.conflitosPeriodos?this.props.conflitoPeriodos.conflitosPeriodos.map(function(item,i){var itemIndexado=item;itemIndexado.acoes=i;return itemIndexado;}):null;var options={hideSizePerPage:true,noDataText:'Nenhum período adicionado à lista',sizePerPage:10};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right'}},this.getTagStatus()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["f" /* DataGridCustom */],{title:'Dados do Conflito'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Estado do conflito',value:this.addTipoEstadoLabel(this.props.conflitoPeriodos.estadoConflito),title:this.verificarTamanhoInput(this.addTipoEstadoLabel(this.props.conflitoPeriodos.estadoConflito))}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Sequencial do conflito',value:this.props.conflitoPeriodos.idConflito})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Data de cria\xE7\xE3o',value:this.props.conflitoPeriodos.dataCriacaoConflito}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Data de resolu\xE7\xE3o',value:this.props.conflitoPeriodos.dataResolucao})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Resolvido por',value:this.props.conflitoPeriodos.nomeResolvedor!==''?''+this.props.conflitoPeriodos.nomeResolvedor:''})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RequerimentosConflitosPeriodos__["a" /* default */],{requerimentoConflito:this.props.conflitoPeriodos.requerimentoCorrente,titulo:'Dados do Requerimento Corrente',handleChange:this.props.handleChange,exibirCheckbox:exibirCheckbox,idConflito:this.props.conflitoPeriodos.idConflito,status:this.props.conflitoPeriodos.estadoConflito,onUpdateConflito:this.props.atualizarConflitosPeriodos}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RequerimentosConflitosPeriodos__["a" /* default */],{requerimentoConflito:this.props.conflitoPeriodos.requerimentoConflitante,titulo:'Dados do Requerimento Conflitante',handleChange:this.props.handleChange,exibirCheckbox:false,status:this.props.conflitoPeriodos.estadoConflito,onUpdateConflito:this.props.atualizarConflitosPeriodos}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["u" /* Table */],{bordered:true,insertRow:false,data:listaIndexada,options:options,listaTableHeader:this.tableHeader,pagination:true,fetchInfo:this.fetchInfo})),this.state.exibirGrafico&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__VisualizacaoPeriodos__["a" /* default */],{parametros:this.state.parametrosGrafico})));}}]);return DadosConflitosPeriodos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DadosConflitosPeriodos.propTypes={conflitoPeriodos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,atualizarConflitosPeriodos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DadosConflitosPeriodos);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RequerimentosConflitosPeriodos=function(_Component){_inherits(RequerimentosConflitosPeriodos,_Component);function RequerimentosConflitosPeriodos(props){_classCallCheck(this,RequerimentosConflitosPeriodos);var _this=_possibleConstructorReturn(this,(RequerimentosConflitosPeriodos.__proto__||Object.getPrototypeOf(RequerimentosConflitosPeriodos)).call(this,props));_this.verificarCheck=function(){if(_this.props.requerimentoConflito&&_this.props.requerimentoConflito.veioPreenchidoDoBanco){_this.setState({checked:true});}};_this.toggleCheckbox=function(){var usuarioLogado=__WEBPACK_IMPORTED_MODULE_4__domain_User__["a" /* default */].logged();if(_this.state.checked){_this.setState({checked:false,nomeAprovador:'',dataAprovacao:''});_this.props.onUpdateConflito({idConflito:_this.props.idConflito,nomeAprovador:'',dataAprovacao:'',cpfAprovador:null,inAprovacao:0});}else{var nome=usuarioLogado.nome();var data=new Date().toLocaleDateString('pt-BR');_this.setState({checked:true,nomeAprovador:nome,dataAprovacao:data});_this.props.onUpdateConflito({idConflito:_this.props.idConflito,nomeAprovador:nome,dataAprovacao:data,cpfAprovador:usuarioLogado.cpf(),inAprovacao:1});}};_this.addTipoEstadoLabel=function(tipo){if(tipo===15){return'Exigência/indeferido';}if(tipo===16){return'Indeferimento ratificado';}if(tipo===undefined||tipo===null){return'';}return __WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};_this.verificarTamanhoInput=function(value){if(value===undefined||value===null){return'';}var qtdMaxCharacterInput=42;return value.length>qtdMaxCharacterInput?value:'';};_this.formatarCpf=function(cpf){var retorno='';if(cpf){retorno=cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}return retorno;};_this.state={checked:false,nomeAprovador:'',dataAprovacao:''};return _this;}_createClass(RequerimentosConflitosPeriodos,[{key:'componentDidMount',value:function componentDidMount(){this.verificarCheck();}},{key:'render',value:function render(){var _props=this.props,titulo=_props.titulo,requerimentoConflito=_props.requerimentoConflito,exibirCheckbox=_props.exibirCheckbox,status=_props.status;var _state=this.state,checked=_state.checked,nomeAprovador=_state.nomeAprovador,dataAprovacao=_state.dataAprovacao;var usuarioLogado=__WEBPACK_IMPORTED_MODULE_4__domain_User__["a" /* default */].logged();var STATUS={NAO_RESOLVIDO:0,RESOLVIDO:1};var mostrarCheckbox=exibirCheckbox&&status===STATUS.NAO_RESOLVIDO&&!requerimentoConflito.veioPreenchidoDoBanco&&(usuarioLogado.isRPPS()&&usuarioLogado.cnpjDoPapel()===requerimentoConflito.cnpjDestinatario||usuarioLogado.isRGPS()&&(!requerimentoConflito.cnpjDestinatario||requerimentoConflito.cnpjDestinatario.trim()===''));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["f" /* DataGridCustom */],{title:titulo+' - '+requerimentoConflito.protocolo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'CPF',value:this.formatarCpf(requerimentoConflito.cpf)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Nome',value:requerimentoConflito.beneficiario,title:this.verificarTamanhoInput(requerimentoConflito.beneficiario)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Matr\xEDcula',value:requerimentoConflito.matricula}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Solicitante',value:requerimentoConflito.nomeSolicitante+' - '+requerimentoConflito.codigoSolicitante})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Destinat\xE1rio',value:requerimentoConflito.nomeDestinatario+' - '+requerimentoConflito.codigoDestinatario})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Estado do requerimento',value:this.addTipoEstadoLabel(requerimentoConflito.estado)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Data in\xEDcio benef\xEDcio',value:requerimentoConflito.dataInicioBeneficio})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Data de ingresso',value:requerimentoConflito.dataIngresso})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Data de desvincula\xE7\xE3o',value:requerimentoConflito.dataDesvinculacao}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Tempo de Contribui\xE7\xE3o no Regime Origem',value:requerimentoConflito.nuTempoContribRo})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Data de Cessa\xE7\xE3o',value:requerimentoConflito.dataCessacao})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Motivo da Cessac\xE3o',value:requerimentoConflito.nomeMotivoRequerimento,title:this.verificarTamanhoInput(requerimentoConflito.nomeMotivoRequerimento)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:checked,onClick:this.toggleCheckbox,style:{paddingLeft:'5px',position:'relative',top:'-2px'},disabled:!mostrarCheckbox}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingLeft:'5px',position:'relative',top:'-2px'}},__WEBPACK_IMPORTED_MODULE_5__utils_constants__["g" /* msgConflitosPeriodos */].reconhecimentoRequerimentoDeferidoComConflito.descricao))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Aprovado por',value:mostrarCheckbox?nomeAprovador:requerimentoConflito.nomeAprovador||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Data da aprova\xE7\xE3o',value:mostrarCheckbox?dataAprovacao:requerimentoConflito.dataAprovacao||''})))));}}]);return RequerimentosConflitosPeriodos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RequerimentosConflitosPeriodos.propTypes={idConflito:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,titulo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,requerimentoConflito:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf.isRequired,exibirCheckbox:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,onUpdateConflito:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (RequerimentosConflitosPeriodos);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var containerStyle={border:'1px solid #ccc',padding:20,boxShadow:'0 0.1rem 0.2rem rgba(69, 90, 100, 0.12), 0 0.05rem 0.25rem rgba(69, 90, 100, 0.24)',background:'#fff',borderRadius:0};var barContainer={position:'relative',height:15,background:'#dddddd',borderRadius:13,overflow:'hidden'};var periodText={fontSize:12,marginTop:5,color:'#555'};var DezAnos=10;var timeDataInicioVazio=-2208977612000;// ano de 1900
var timeDataFimVazio=10413802800000;// ano de 2300
var VisualizacaoPeriodos=function(_Component){_inherits(VisualizacaoPeriodos,_Component);function VisualizacaoPeriodos(props,context){_classCallCheck(this,VisualizacaoPeriodos);/**
     * Inicializa o estado do componente
     */var _this=_possibleConstructorReturn(this,(VisualizacaoPeriodos.__proto__||Object.getPrototypeOf(VisualizacaoPeriodos)).call(this,props,context));_this.getInitialState=function(){return{markers:[],minTime:0,maxTime:0,tooltip:{visible:false,content:'',x:0,y:0,background:'#000'}};};_this.getIntersecao=function(a,b){var inicio=Math.max(a.start,b.start);var fim=Math.min(a.end,b.end);if(inicio>fim){return null;}return{inicio:inicio,fim:fim};};_this.parsePeriodoDateInicio=function(data1,data2){if(!data1||data1==='__/__/____'){// se não houver referência, fallback
if(!data2||data2==='__/__/____'){return _this.parseDate('01/01/1900').getTime();}var dataOriginal=_this.parseDate(data2);var dataReferencia=new Date(dataOriginal.getFullYear()-DezAnos,0,// Janeiro
1);return dataReferencia.getTime();}return _this.parseDate(data1).getTime();};_this.parsePeriodoDateFim=function(data1,data2){if(!data1||data1==='__/__/____'){// fallback caso também não exista referência
if(!data2||data2==='__/__/____'){return _this.parseDate('01/01/2300').getTime();}var dataOriginal=_this.parseDate(data2);var dataReferencia=new Date(dataOriginal.getFullYear()+DezAnos,11,// Dezembro
31);return dataReferencia.getTime();}return _this.parseDate(data1).getTime();};_this.parseDate=function(dateStr){var _dateStr$split=dateStr.split('/'),_dateStr$split2=_slicedToArray(_dateStr$split,3),day=_dateStr$split2[0],month=_dateStr$split2[1],year=_dateStr$split2[2];return new Date(year,month-1,day);};_this.montarItems=function(){var _this$props$parametro=_this.props.parametros,periodoReqConflito=_this$props$parametro.periodoReqConflito,periodoReqCorrente=_this$props$parametro.periodoReqCorrente,protocoloCorrente=_this$props$parametro.protocoloCorrente,protocoloConflito=_this$props$parametro.protocoloConflito,solicitanteCorrente=_this$props$parametro.solicitanteCorrente,destinatarioCorrente=_this$props$parametro.destinatarioCorrente,solicitanteConflito=_this$props$parametro.solicitanteConflito,destinatarioConflito=_this$props$parametro.destinatarioConflito;/**
     * Extrai datas de uma string "data - data"
     */var extrair=function extrair(periodo1,periodo2){var _periodo1$split=periodo1.split(' - '),_periodo1$split2=_slicedToArray(_periodo1$split,2),inicio=_periodo1$split2[0],fim=_periodo1$split2[1];var _periodo2$split=periodo2.split(' - '),_periodo2$split2=_slicedToArray(_periodo2$split,2),inicio2=_periodo2$split2[0],fim2=_periodo2$split2[1];var start=_this.parsePeriodoDateInicio(inicio,inicio2);var end=_this.parsePeriodoDateFim(fim,fim2);return{start:start,end:end,startDate:inicio,endDate:fim};};var req1=extrair(periodoReqCorrente,periodoReqConflito);var req2=extrair(periodoReqConflito,periodoReqCorrente);return[Object.assign({label:'Requerimento Corrente'},req1,{protocolo:protocoloCorrente,solicitante:solicitanteCorrente,destinatario:destinatarioCorrente,color:'#2563eb'}),Object.assign({label:'Requerimento Conflitante'},req2,{protocolo:protocoloConflito,solicitante:solicitanteConflito,destinatario:destinatarioConflito,color:'#16a34a'})];};_this.handleMouseEnter=function(event,item){var rect=event.currentTarget.getBoundingClientRect();// Calcula duração do período em dias
// const dias = Math.ceil((item.end - item.start) / (1000 * 60 * 60 * 24));
// const content = `${item.label}\nPeríodo: ${item.startDate} - ${item.endDate}`
//  + `\nDuração: ${dias} dias${item.protocolo ? `\nProtocolo: ${item.protocolo}` : ''}`;
var content=item.label+'\nPer\xEDodo: '+item.startDate+' - '+item.endDate+(''+(item.protocolo?'\nProtocolo: '+item.protocolo:''));_this.setState({tooltip:{visible:true,content:content,x:rect.left+rect.width/2,y:rect.top,background:item.color}});};_this.handleMouseLeave=function(){_this.setState({tooltip:{visible:false,content:'',x:0,y:0,background:'#000'}});};_this.montarGrafico=function(){var items=_this.montarItems();// Descobre limites do período
var starts=items.map(function(i){return i.start;}).filter(Number.isFinite);var ends=items.map(function(i){return i.end;}).filter(Number.isFinite);var rawMin=Math.min.apply(Math,_toConsumableArray(starts));var rawMax=Math.max.apply(Math,_toConsumableArray(ends));var startYear=new Date(rawMin).getFullYear();var endYear=new Date(rawMax).getFullYear();var minTime=new Date(startYear,0,1).getTime();var maxTime=rawMax;// Coleta anos únicos
var yearsSet=new Set();items.forEach(function(item){yearsSet.add(new Date(item.start).getFullYear());yearsSet.add(new Date(item.end).getFullYear());});/**
     * Cria marcadores de ano
     */var markersList=Array.from(yearsSet).map(function(y){return{time:new Date(y,0,1).getTime(),label:String(y),isConflict:false,isLastYear:y===endYear};});/**
     * Adiciona marcadores de conflito (início e fim)
     *//* const conflito = items.length === 2 ? this.getIntersecao(items[0], items[1]) : null;

    if (conflito) {
      const fmt = d => new Date(d).toLocaleDateString('pt-BR');

      markersList.push({
        time: conflito.inicio,
        label: fmt(conflito.inicio),
        isConflict: true,
        isStart: true,
      });

      markersList.push({
        time: conflito.fim,
        label: fmt(conflito.fim),
        isConflict: true,
        isEnd: true,
      });
    } */// Ordena cronologicamente
markersList.sort(function(a,b){return a.time-b.time;});_this.setState({// markers: markersList,
minTime:minTime,maxTime:maxTime});};_this.calcPos=function(time){var _this$state=_this.state,minTime=_this$state.minTime,maxTime=_this$state.maxTime;return(time-minTime)/(maxTime-minTime)*100;};_this.state=_this.getInitialState();return _this;}/**
   * Estado inicial:
   * - markers: marcações da timeline (anos + conflito)
   * - minTime/maxTime: escala do gráfico
   * - tooltip: controle do hover
   */_createClass(VisualizacaoPeriodos,[{key:'componentDidMount',/**
   * Lifecycle: monta o gráfico ao iniciar
   */value:function componentDidMount(){this.montarGrafico();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.parametros&&this.props.parametros!==prevProps.parametros){this.montarGrafico();}}/**
   * Calcula interseção entre dois períodos
   * Retorna null se não houver sobreposição
   *//**
   * Converte string "dd/mm/yyyy" para Date
   *//**
   * Monta os períodos que serão exibidos como barras
   *//**
   * Exibe tooltip ao passar o mouse sobre uma barra
   *//**
   * Esconde tooltip
   *//**
   * Monta toda a lógica do gráfico:
   * - calcula escala
   * - define anos
   * - adiciona conflito
   *//**
   * Converte tempo em posição percentual no gráfico (0 a 100%)
   */},{key:'render',value:function render(){var _this2=this;var items=this.montarItems();/**
     * Calcula conflito novamente para uso no render
     */var conflito=items.length===2?this.getIntersecao(items[0],items[1]):null;var tooltip=this.state.tooltip;var larguraConflito=conflito?Math.max(0.8,this.calcPos(conflito.fim)-this.calcPos(conflito.inicio)):0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["f" /* DataGridCustom */],{title:'Painel de Per\xEDodos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:containerStyle},items.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:item.label,style:{marginBottom:25}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:5}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{style:{color:'#546e7a'}},item.label,item.protocolo&&' | '+item.protocolo,item.solicitante&&' | Solicitante: '+item.solicitante,item.destinatario&&item.destinatario!==item.solicitante&&' | Destinat\xE1rio: '+item.destinatario)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:barContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onMouseEnter:function onMouseEnter(e){return _this2.handleMouseEnter(e,item);},onMouseLeave:_this2.handleMouseLeave,style:{position:'absolute',left:_this2.calcPos(item.start)+'%',width:Math.max(0,_this2.calcPos(item.end)-_this2.calcPos(item.start))+'%',height:'100%',background:item.color,borderRadius:10,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:periodText},item.startDate,' - ',item.endDate));}),conflito&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:25}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:5}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{style:{color:'#546e7a'}},'Per\xEDodo Conflitante')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:barContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onMouseEnter:function onMouseEnter(e){return _this2.handleMouseEnter(e,{label:'Período Conflitante',start:conflito.inicio,end:conflito.fim,startDate:conflito.inicio!==timeDataInicioVazio?new Date(conflito.inicio).toLocaleDateString():'__/__/____',endDate:conflito.fim!==timeDataFimVazio?new Date(conflito.fim).toLocaleDateString():'__/__/____',color:'#dc2626'});},onMouseLeave:this.handleMouseLeave,style:{position:'absolute',left:this.calcPos(conflito.inicio)+'%',width:larguraConflito+'%',height:'100%',background:'#dc2626',borderRadius:10,cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:periodText},conflito.inicio!==timeDataInicioVazio?new Date(conflito.inicio).toLocaleDateString():'__/__/____',' - ',conflito.fim!==timeDataFimVazio?new Date(conflito.fim).toLocaleDateString():'__/__/____')),tooltip.visible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'fixed',top:tooltip.y-10,left:tooltip.x,transform:'translate(-50%, -100%)',background:tooltip.background,color:'#fff',padding:'8px 12px',borderRadius:6,fontSize:12,whiteSpace:'pre-line',wordBreak:'keep-all',minWidth:220,zIndex:9999,pointerEvents:'none'}},tooltip.content)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:20,display:'flex',gap:20}},[{c:'#2563eb',l:'Requerimento Corrente'},{c:'#16a34a',l:'Requerimento Conflitante'},{c:'#dc2626',l:'Período Conflitante'}].map(function(leg){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:leg.l,style:{display:'flex',alignItems:'center',gap:6}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:12,height:12,background:leg.c}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:12}},leg.l));}))));}}]);return VisualizacaoPeriodos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VisualizacaoPeriodos.propTypes={parametros:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).isRequired};/* harmony default export */ __webpack_exports__["a"] = (VisualizacaoPeriodos);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DadosRequerimentoPensao__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ListaExigencias__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DadosHistoricoRequerimento__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ListaAlertas__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ModalAlerta__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__consultas_Exigencia_ModalRejeicaoRequerimento__ = __webpack_require__(116);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var camposPreenchidosPorServico={cnis:['isObtidoPelaRFB'],centralService:['dataInicioBeneficio','dataCessacaoBeneficio','dataInicioPagamentoBeneficio','rendaMensalInicial','dataCreditoPagamento','idUOMantenedora']};var camposCnis=['nome'];var RequerimentoPensao=function(_Component){_inherits(RequerimentoPensao,_Component);function RequerimentoPensao(){var _this2=this;_classCallCheck(this,RequerimentoPensao);var _this=_possibleConstructorReturn(this,(RequerimentoPensao.__proto__||Object.getPrototypeOf(RequerimentoPensao)).call(this));_this.getInitialState=function(){return{acao:'novo',requerimento:{cpf:null,nome:null,estado:null,matricula:null,destinatario:null,solicitanteOrigem:null,numeroBeneficio:null,numeroBeneficioAposentadoria:null,dataInicioBeneficio:null,dataInicioPagamentoBeneficio:null,dataCessacaoBeneficio:null,rendaMensalInicial:null,dependentes:[],exigencias:[],documentosProbatorios:[],idUOMantenedora:null,arquivos:[],listaMotivosIndeferimento:[],tipoSegregacaoSolicitante:null,tipoSegregacaoDestinatario:null},matriculaLabel:{},destinatarioLabel:[],touched:false,cpfTouched:false,isObtidoPelaRFB:false,validadeCampos:{cpf:false,destinatario:false,dataInicioBeneficio:false,rendaMensalInicial:false,dependentes:false,idUOMantenedora:false},tipoRequerimento:2,sucessoUpload:false,mostraPaginaSemConteudo:false,mensagemPrincipalSemConteudo:'Requerimento não encontrado para o protocolo informado.',mensagemSecundariaSemConteudo:'Informe um protocolo válido.',requestPesquisa:false,estadoFormulario:'inicial',camposDependentesInvalidos:null,isFetchExigencias:false,// Vinicius
dependentesOrigem:[],showModalAlerta:false,chaveConfirmacao:null,isRmiZerada:false,rendaMensalInicialRequest:null,requerimentoVindoDoRequest:null,houveAlteracaoDependente:null,cumpriuAlgumaExigencia:null,exibirCampoUoInss:false,exibirUploadArquivosNaConsulta:false,habilitarBotaoCarregarDocumento:false,exigenciasOriginais:[],validadeBotoesIndeferidos:{pesquisarDadosPessoais:false,pesquisarDadosBeneficio:false},nomeVindoDaRFB:null,exibirModalDataCessacao:false,inIndefericaoAnalise:false,motivosIndeferimentoControle:[],rejeitar:false,destinatariosAposentadoria:[],tipoDocumento:null};};_this.getLotacao=function(roles){var array='';var lotacao=[];roles.forEach(function(role){var eNovo=role.match(/TD/g);var temPA=role.indexOf('|PA|')!==-1;if(temPA&&eNovo){array=role.split('|');for(var i=0,tam=array.length;i<tam;i+=1){if(array[i]==='TD'){lotacao.push(array[i+3]);break;}}}});return lotacao;};_this.montaFormulario=function(){if(_this.props.match.params.protocolo){if(_this.props.destinatarios.length>0&&_this.props.tiposDocumentos.length>0){var acao=_this.props.match.params.acao?_this.props.match.params.acao:'consulta';_this.setState({acao:acao},_this.buscaRequerimento);}}else{Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["g" /* manterApenasFiltro */])('');if(_this.props.auth.checkPermission(['requerer-compensacao-rgps','gerenciar-negocio-dcomp'])){_this.setState({validadeCampos:Object.assign({},_this.state.validadeCampos,{numeroBeneficio:false})},_this.buscarTiposDocumentosUpload);}if(_this.props.auth.checkPermission(['requerer-compensacao-rpps'])){_this.setState(_this.buscaParticipantePeloCnpjLogado());_this.setState({validadeCampos:Object.assign({},_this.state.validadeCampos,{matricula:false})});_this.setState({validadeCampos:Object.assign({},_this.state.validadeCampos,{matricula:false})},_this.buscarTiposDocumentosUpload);}}};_this.handleSuccessBuscaParticipantePeloCnpjLogado=function(response){var _this$state=Object.assign({},_this.state),requerimento=_this$state.requerimento;requerimento.idUOMantenedora=response.data.idUOInssConvenio;_this.setState({requerimento:Object.assign({},_this.state.requerimento,{requerimento:requerimento})});};_this.handleErrorBuscaParticipantePeloCnpjLogado=function(){var mensagemPrimaria='Não foi possível consultar o ente participante.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.handleErrorBuscaDocumentosUpload=function(){var mensagemPrimaria='Não foi possível consultar os documentos para upload.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.buscarTiposDocumentosUpload=function(){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["D" /* requestTiposDocumentos */])(_this.handleErrorBuscaDocumentosUpload);};_this.buscarTiposDocumentos=function(){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["D" /* requestTiposDocumentos */])(_this.handleErrorBusca);};_this.buscaParticipantePeloCnpjLogado=function(){var metodoSucesso=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.handleSuccessBuscaParticipantePeloCnpjLogado;var lotacaoUsuario=_this.getLotacao(_this.props.auth.userData.roles);if(lotacaoUsuario.length>0){var primParte=[];var segParte=[];if(lotacaoUsuario[0].indexOf('#')!==-1){var arrayLotacao=lotacaoUsuario[0].split('#');primParte.push(arrayLotacao[0]);segParte.push(arrayLotacao[1]);}var url='participantes-compensacao/'+segParte;Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])(url,metodoSucesso,_this.handleErrorBuscaParticipantePeloCnpjLogado);}};_this.validacaoErrosDependentes=function(errosDependente){var isDelete=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var camposInvalidos=null;if(isDelete){camposInvalidos=errosDependente;}else{camposInvalidos=_this.state.camposDependentesInvalidos.filter(function(erro){return errosDependente.includes(erro)?null:erro;});}_this.setState({camposDependentesInvalidos:camposInvalidos});};_this.montaValidadeCampos=function(requerimento){var _this$state2=Object.assign({},_this.state),validadeCampos=_this$state2.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});if(_this.state.acao==='cumprir-exigencia'&&requerimento.estado===2&&requerimento.exigencias){var exigenciaComAtributo=[];requerimento.exigencias.forEach(function(exigencia){if(exigencia.atributo){if(exigencia.codigoDependente){validadeCampos.dependentes=false;}else{exigenciaComAtributo.push(exigencia);}}if(exigencia.tipo===10||exigencia.tipo===11){validadeCampos.dependentes=false;}});exigenciaComAtributo.forEach(function(exigencia){validadeCampos[exigencia.atributo]=false;});}return validadeCampos;};_this.isConsultaExigencia=function(){return _this.state.acao==='consulta'&&_this.state.requerimento.estado===2;};_this.verificaIndefericaoAnalise=function(){var _this$state$requerime=Object.assign({},_this.state.requerimento),estados=_this$state$requerime.estados;var _this$state3=Object.assign({},_this.state),motivosIndeferimentoControle=_this$state3.motivosIndeferimentoControle;if(estados&&estados.length>0){if(estados[0].motivos&&estados[0].motivos.length>0){motivosIndeferimentoControle=estados[0].motivos;_this.setState({motivosIndeferimentoControle:motivosIndeferimentoControle,inIndefericaoAnalise:true});var changeObj={value:9};_this.alteraEstadoRequerimento(changeObj);Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["u" /* requestMotivos */])();}}};_this.handleSuccessBuscaRequerimento=function(response){var validadeCampos=_this.montaValidadeCampos(response.data);var _this$state4=Object.assign({},_this.state),exibirCampoUoInss=_this$state4.exibirCampoUoInss;if(response.data){var requerimentoVindoDoRequest=response.data;var solicitanteRGPS=requerimentoVindoDoRequest.solicitante&&requerimentoVindoDoRequest.solicitante.codigo==='01000';var destinatarioRGPS=requerimentoVindoDoRequest.destinatario&&requerimentoVindoDoRequest.destinatario.codigo==='01000';if(response.data.estado===2){// em exigência mas pode nao ser consulta
_this.setState({requerimentoVindoDoRequest:requerimentoVindoDoRequest});// IB 282195
if(_this.state.acao==='consulta'){var _this$state5=Object.assign({},_this.state),exigenciasOriginais=_this$state5.exigenciasOriginais;var _this$state6=Object.assign({},_this.state),exibirUploadArquivosNaConsulta=_this$state6.exibirUploadArquivosNaConsulta;requerimentoVindoDoRequest.exigencias.forEach(function(exigencia){exigenciasOriginais.push(exigencia);});var usuario=__WEBPACK_IMPORTED_MODULE_16__domain_User__["a" /* default */].logged();var isCpfLogadoIgualCpfUsuarioResponsavel=usuario.data.prevCpf===requerimentoVindoDoRequest.cpfUsuarioResponsavel;// isCpfLogadoIgualCpfUsuarioResponsavel é o cpf de quem pegou o requerimento para analisar no GET
if(!solicitanteRGPS){exibirUploadArquivosNaConsulta=true;}else if(isCpfLogadoIgualCpfUsuarioResponsavel&&solicitanteRGPS){exibirUploadArquivosNaConsulta=true;}_this.setState({exigenciasOriginais:exigenciasOriginais,exibirUploadArquivosNaConsulta:exibirUploadArquivosNaConsulta});}}// IB 282195
if(_this.state.acao==='consulta'&&response.data.estado!==2){var paramUploadArquivosNaConsulta=Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["f" /* habilitarUploadNaConsultaDoRequerimento */])(requerimentoVindoDoRequest,_this.state.acao,null);_this.setState({exibirUploadArquivosNaConsulta:paramUploadArquivosNaConsulta});}if(_this.state.acao==='indeferidos'){validadeCampos.solicitanteOrigem=true;}if(solicitanteRGPS||destinatarioRGPS){exibirCampoUoInss=true;_this.setState({exibirCampoUoInss:exibirCampoUoInss});}}var matriculaLabel={};matriculaLabel[response.data.destinatario.codigo]=[{label:response.data.matricula,value:response.data.matricula}];var destinatarioLabel=Object.keys(matriculaLabel).map(function(item){return{label:Object(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */])(_this.props.destinatarios,item).label,value:item};});var dependentes=[];if(response.data.dependentes){dependentes=response.data.dependentes.map(function(dependente){return Object.assign({},dependente);});}_this.setState({requerimento:Object.assign({},_this.state.requerimento,response.data),touched:true,validadeCampos:validadeCampos,matriculaLabel:matriculaLabel,destinatarioLabel:destinatarioLabel,// Vinicius
dependentesOrigem:dependentes},_this.buscarTiposDocumentos);if(_this.state.requerimento.estado===6){_this.verificaIndefericaoAnalise();}};_this.handleSuccessBuscaRequerimentoAposSalvarERejeitar=function(response){_this.setState({requerimento:Object.assign({},_this.state.requerimento,response.data)});};_this.handleSuccessBuscaRequerimentoAtualizacao=function(response){var validadeCampos=_this.montaValidadeCampos(response.data);if(response.data){if(response.data.estado===2){var requerimentoVindoDoRequest=response.data;_this.setState({requerimentoVindoDoRequest:requerimentoVindoDoRequest});_this.setState({houveAlteracaoDependente:false});}}_this.setState({requerimento:response.data,touched:true,isFetchExigencias:false,validadeCampos:validadeCampos},_this.validaVoltaPagina);};_this.validaVoltaPagina=function(){if(!_this.state.requerimento.exigencias||_this.state.requerimento.exigencias.filter(function(exigencia){return exigencia.tipoDocumento;}).length===_this.state.requerimento.exigencias.length){_this.props.history.goBack();}};_this.handleErrorBuscaRequerimento=function(error){var mensagemPrimaria='Não foi possível consultar o requerimento.';var mensagemSecundaria='Contate o administrador do sistema.';if(error){if(error.status){if(error.status===404){mensagemPrimaria='Requerimento não encontrado para o protocolo informado.';mensagemSecundaria='Informe um protocolo válido.';}}}_this.setState({mostraPaginaSemConteudo:true,mensagemPrincipalSemConteudo:mensagemPrimaria,mensagemSecundariaSemConteudo:mensagemSecundaria});};_this.handleErrorBusca=function(){var mensagemPrimaria='Não foi possível realizar a consulta.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({mostraPaginaSemConteudo:true,mensagemPrincipalSemConteudo:mensagemPrimaria,mensagemSecundariaSemConteudo:mensagemSecundaria});};_this.buscaPorNomeNaLista=function(dependenteAlterado,dependentes){var dependente=dependentes.filter(function(dep){return dep.nome&&dep.nome===dependenteAlterado.nome;});return dependente;};_this.isDestinatarioRGPS=function(changeObj){return changeObj&&changeObj.value==='01000';};_this.isSolicitanteRGPS=function(){return __WEBPACK_IMPORTED_MODULE_16__domain_User__["a" /* default */].logged().isRGPS();};_this.alteraListaArquivos=function(arquivos){_this.handleChange({value:arquivos,isValid:arquivos.length>0},'arquivos');};_this.addArquivo=function(arquivo){var retorno={};if(arquivo){var _this$state7=Object.assign({},_this.state),requerimento=_this$state7.requerimento;var _this$state8=Object.assign({},_this.state),tipoDocumento=_this$state8.tipoDocumento;retorno={documento:arquivo,protocolo:requerimento.protocolo,tipoDocumento:tipoDocumento};}return retorno;};_this.handleChangeTipoDocumento=function(e,name){_this.setState(_defineProperty({},name,e.value));};_this.handleChangeFile=function(arquivo){if(!arquivo){_this.alteraListaArquivos([],null);return;}var tamanhoDocumentoUpload=arquivo.size;// inclusão
if(tamanhoDocumentoUpload>__WEBPACK_IMPORTED_MODULE_14__utils_constants__["z" /* tamanhoMaximoArquivoUpload */]){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Certifique-se de que o documento '+arquivo.name+' possui tamanho inferior a 3 mb.']);}else{var novoArquivo=_this.addArquivo(arquivo);_this.alteraListaArquivos([novoArquivo],null);}};_this.handleChange=function(changeObj,name){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var _this$state9=Object.assign({},_this.state),estadoFormulario=_this$state9.estadoFormulario;var _this$state10=Object.assign({},_this.state),requerimento=_this$state10.requerimento;var valido=changeObj.isValid;var destinatarioIndeferido={};if(_this.state.acao==='cumprir-exigencia'){estadoFormulario='alterado';var _this$state11=Object.assign({},_this.state),requestPesquisa=_this$state11.requestPesquisa;if(requestPesquisa){_this.setState({requestPesquisa:false});}requerimento.exigencias.forEach(function(exigencia){if(exigencia.atributo===name){// eslint-disable-next-line
exigencia.atendida=1;}if(name==='dependentes'&&_this.testaSeCumpriuExigenciaEmDependentes(exigencia,changeObj.value)){// eslint-disable-next-line
exigencia.atendida=1;}else if(name==='dependentes'&&!_this.testaSeCumpriuExigenciaEmDependentes(exigencia,changeObj.value)){_this.setState({houveAlteracaoDependente:true});}});}else if(_this.state.acao==='novo'&&estadoFormulario==='erro-regra'){estadoFormulario='alterado';}if(name==='arquivos'&&_this.state.acao!=='consulta'){valido=true;}else if(name==='arquivos'&&_this.state.acao==='consulta'){if(valido){_this.setState({habilitarBotaoCarregarDocumento:true});}else{_this.setState({habilitarBotaoCarregarDocumento:false});}}if(name==='destinatario'){var _this$state12=Object.assign({},_this.state),validadeCampos=_this$state12.validadeCampos;validadeCampos.solicitanteOrigem=true;var _this$state13=Object.assign({},_this.state),exibirCampoUoInss=_this$state13.exibirCampoUoInss;if(_this.isDestinatarioRGPS(changeObj)||_this.isSolicitanteRGPS(changeObj)){exibirCampoUoInss=true;}else{exibirCampoUoInss=false;}_this.setState({exibirCampoUoInss:exibirCampoUoInss});requerimento.tipoSegregacaoSolicitante=null;requerimento.tipoSegregacaoDestinatario=null;}if(name==='destinatario'&&_this.state.acao==='indeferidos'){destinatarioIndeferido={codigo:changeObj.value};}if(name==='rendaMensalInicial'){if(changeObj.value===''){valido=false;}}if(name==='matricula'){var _this$state14=Object.assign({},_this.state),destinatariosAposentadoria=_this$state14.destinatariosAposentadoria;var indexDestinatarioAposentadoria=destinatariosAposentadoria.findIndex(function(dest){return dest.matricula===changeObj.value&&dest.destinatario===requerimento.destinatario;});var existeIndex=indexDestinatarioAposentadoria!==-1;if(existeIndex){var existeSegregacaoSolicitante=destinatariosAposentadoria[indexDestinatarioAposentadoria].tipoSegregacaoSolicitante!==undefined;var existeSegregacaoDestinatario=destinatariosAposentadoria[indexDestinatarioAposentadoria].tipoSegregacaoDestinatario!==undefined;if(existeSegregacaoSolicitante){requerimento.tipoSegregacaoSolicitante=destinatariosAposentadoria[indexDestinatarioAposentadoria].tipoSegregacaoSolicitante;}else{requerimento.tipoSegregacaoSolicitante=null;}if(existeSegregacaoDestinatario){requerimento.tipoSegregacaoDestinatario=destinatariosAposentadoria[indexDestinatarioAposentadoria].tipoSegregacaoDestinatario;}else{requerimento.tipoSegregacaoDestinatario=null;}}}_this.setState({requerimento:Object.assign({},requerimento,_defineProperty({},name,destinatarioIndeferido.codigo?destinatarioIndeferido:changeObj.value)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,valido)),estadoFormulario:estadoFormulario},callback);};_this.handleChangeDestinatario=function(changeObj,name){var _this$state15=Object.assign({},_this.state),requerimento=_this$state15.requerimento;var arrayMatricula=_this.state.matriculaLabel;arrayMatricula.forEach(function(item){if(item.value===changeObj.value){requerimento.matricula=item.label;}});_this.setState({requerimento:Object.assign({},requerimento,_defineProperty({},name,changeObj.value)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))});};_this.handleKeyUp=function(e){var retorno=e.target.value;if(retorno.indexOf('_')!==-1){retorno=retorno.toString().replace('_','');}retorno=retorno.toString().replace(/\D/g,'');retorno=retorno.toString().replace(/(\d)(\d{11})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{8})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{5})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{2})$/,'$1,$2');e.target.value=retorno;return retorno;};_this.cumpreExigenciasEmAtributosDeServico=function(reqResponse){// camposPreenchidosPorServico
// cnis
// benMigrado - centralService
var _reqResponse=Object.assign({},reqResponse),data=_reqResponse.data;var _this$state16=Object.assign({},_this.state),requerimento=_this$state16.requerimento;var _requerimento=Object.assign({},requerimento),exigencias=_requerimento.exigencias;if(_this.state.acao==='cumprir-exigencia'&&exigencias){requerimento.exigencias.forEach(function(exigencia){if(data[exigencia.atributo]&&data[exigencia.atributo]!==requerimento[exigencia.atributo]){// eslint-disable-next-line
exigencia.atendida=1;}});}return requerimento;};_this.trataSucessoResponsePesquisa=function(response){var _this$state17=Object.assign({},_this.state),validadeCampos=_this$state17.validadeCampos;// const requerimentoAtual = this.state.requerimento;
var requerimento=_this.cumpreExigenciasEmAtributosDeServico(response);camposPreenchidosPorServico[_this.state.requestPesquisa].forEach(function(key){validadeCampos[key]=true;});// Apaga campos quando nao vierem do serviço
if(!response.data.dataInicioBeneficio){requerimento.dataInicioBeneficio=null;validadeCampos.dataInicioBeneficio=false;}if(!response.data.dataCessacaoBeneficio){requerimento.dataCessacaoBeneficio=null;}if(!response.data.rendaMensalInicial){if(response.data.rendaMensalInicial===0){if(requerimento.rendaMensalInicial!==null){requerimento.rendaMensalInicial='';}response.data.rendaMensalInicial=null;validadeCampos.rendaMensalInicial=false;_this.setState({isRmiZerada:true,rendaMensalInicialRequest:null});}}else if(_this.state.isRmiZerada){_this.setState({isRmiZerada:false});}if(!response.data.dataCreditoPagamento){requerimento.dataCreditoPagamento=null;// validadeCampos.dataCreditoPagamento = false;
}if(!response.data.idUOMantenedora){requerimento.idUOMantenedora=null;validadeCampos.idUOMantenedora=false;}if(_this.state.acao==='indeferidos'){var _this$state18=Object.assign({},_this.state),validadeBotoesIndeferidos=_this$state18.validadeBotoesIndeferidos;if(validadeBotoesIndeferidos.pesquisarDadosBeneficio===false){validadeBotoesIndeferidos.pesquisarDadosBeneficio=true;}_this.setState({validadeBotoesIndeferidos:validadeBotoesIndeferidos});}_this.setState({requerimento:Object.assign({},requerimento,response.data),requestPesquisa:null,validadeCampos:validadeCampos});};_this.handleNBSearch=function(){if(_this.state.requerimento.numeroBeneficio){var _this$state$requerime2=Object.assign({},_this.state.requerimento),numeroBeneficio=_this$state$requerime2.numeroBeneficio;_this.setState({requestPesquisa:'centralService'},Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('/beneficio-rgps-pensao/'+numeroBeneficio,_this.trataSucessoResponsePesquisa,_this.trataErrosResponse));}};_this.handleSearchNBButton=function(){var numeroBeneficioTouched=true;_this.setState(Object.assign({},_this.state,{numeroBeneficioTouched:numeroBeneficioTouched}),_this.handleNBSearch);};_this.testaSeCumpriuExigenciaEmDependentes=function(exigencia,dependentes){// Se exigencia de inclusao ou exclusao, verificar tamanho do array
if(exigencia.tipo===10&&dependentes.length>_this.state.requerimento.dependentes.length){return true;}if(exigencia.tipo===11&&dependentes.length<_this.state.requerimento.dependentes.length){return true;}if(exigencia.codigoDependente){var novoDependente=_this.buscaDependenteNaLista(exigencia,dependentes);var estadoDependente=_this.buscaDependenteNaLista(exigencia,_this.state.requerimento.dependentes);if(Object.keys(novoDependente).length!==0&&Object.keys(estadoDependente).length!==0&&novoDependente[exigencia.atributo]!==estadoDependente[exigencia.atributo]){return true;}}return false;};_this.buscaDependenteNaLista=function(exigencia,dependentes){var dependente=dependentes.filter(function(dep){return dep.codigo&&dep.codigo===exigencia.codigoDependente;});if(dependente&&dependente.length>0){return dependente[0];}return{};};_this.alteraEstadoRequerimento=function(changeObj){if(changeObj.value!==9&&_this.state.motivosIndeferimentoControle&&_this.state.motivosIndeferimentoControle.length>0){_this.setState({inIndefericaoAnalise:false});}_this.setState({requerimento:Object.assign({},_this.state.requerimento,{exigencias:[],motivo:null,justificativaIndeferimento:null})},function(){return _this.handleChange(changeObj,'estado');});};_this.verificaCumprimentoExigencia=function(){var exigenciaCumprida=false;var houveAlteracaoNoRequerimento=false;if(_this.state.requerimento.exigencias){_this.state.requerimento.exigencias.forEach(function(item){if(item.atributo){if(item.atributo in _this.state.validadeCampos&&_this.state.validadeCampos[item.atributo]){exigenciaCumprida=true;}if(item.codigoDependente&&_this.state.validadeCampos.dependentes){exigenciaCumprida=true;}}// Vinicius
if(item.tipo===10){_this.state.requerimento.dependentes.forEach(function(dependente){var encontrei=false;_this.state.dependentesOrigem.forEach(function(dependenteOrigem){if(dependente.nome===dependenteOrigem.nome&&dependente.dataNascimento===dependenteOrigem.dataNascimento){encontrei=true;}});if(!encontrei){exigenciaCumprida=true;}});}if(item.tipo===11){_this.state.dependentesOrigem.forEach(function(dependenteOrigem){var encontrei=false;_this.state.requerimento.dependentes.forEach(function(dependente){if(dependente.nome===dependenteOrigem.nome&&dependente.dataNascimento===dependenteOrigem.dataNascimento){encontrei=true;}});if(!encontrei){exigenciaCumprida=true;}});}if(item.tipo===12){_this.state.dependentesOrigem.forEach(function(dependenteOrigem){_this.state.requerimento.dependentes.forEach(function(dependente){if(dependente.codigo===dependenteOrigem.codigo&&dependente.cpfDependente!==''){exigenciaCumprida=true;}});});_this.state.requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo in _this.state.validadeCampos&&exigenciaCumprida){_this.state.validadeCampos[paramAtributo]=true;}});}});}if(exigenciaCumprida){_this.state.requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo&&exigencia.atendida===1){if(paramAtributo in _this.state.validadeCampos){_this.state.validadeCampos[paramAtributo]=true;}}});var valido=Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);_this.state.requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo&&exigencia.atendida===0){if(paramAtributo in _this.state.validadeCampos){_this.state.validadeCampos[paramAtributo]=false;}}});if(!valido){houveAlteracaoNoRequerimento=valido;}else{houveAlteracaoNoRequerimento=exigenciaCumprida;}}else{houveAlteracaoNoRequerimento=_this.verificaAlteracaoCamposEstadoExigencia();var _this$state19=Object.assign({},_this.state),requestPesquisa=_this$state19.requestPesquisa;var alterouPeloBotaoPesquisar=requestPesquisa;if(alterouPeloBotaoPesquisar){return true;}if(houveAlteracaoNoRequerimento&&!_this.state.houveAlteracaoDependente){_this.state.requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo&&exigencia.atendida===0){if(paramAtributo in _this.state.validadeCampos){_this.state.validadeCampos[paramAtributo]=true;}}//provisorio
_this.state.validadeCampos.dependentes=true;});houveAlteracaoNoRequerimento=Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);_this.state.requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo&&exigencia.atendida===0){if(paramAtributo in _this.state.validadeCampos){_this.state.validadeCampos[paramAtributo]=false;}}});}else{var _this$state20=Object.assign({},_this.state),houveAlteracaoDependente=_this$state20.houveAlteracaoDependente;if(houveAlteracaoDependente){return true;}}}return houveAlteracaoNoRequerimento;};_this.formularioProntoParaEnvio=function(){var _this$state21=Object.assign({},_this.state),acao=_this$state21.acao;var _this$state22=Object.assign({},_this.state),estadoFormulario=_this$state22.estadoFormulario;var _this$state23=Object.assign({},_this.state),requerimento=_this$state23.requerimento;switch(acao){case'novo':{if(estadoFormulario==='inicial'){_this.state.validadeCampos.idUOMantenedora=true;return Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);}if(estadoFormulario==='criado'){return true;}if(estadoFormulario==='alterado'){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);}}case'cumprir-exigencia':return _this.verificaCumprimentoExigencia();case'realizar-analise':return _this.verificaSeAnaliseCompleta();case'emitir-parecer-medico':return _this.verificaSeAnaliseMedicoCompleta();case'consulta':return Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["f" /* habilitarUploadNaConsultaDoRequerimento */])(requerimento,acao,null)&&_this.state.habilitarBotaoCarregarDocumento;case'indeferidos':{if(_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps'])){return _this.verificaIndeferidos('rgps');}if(_this.props.auth.checkPermission(['analisar-compensacao-rpps','requerer-compensacao-rpps'])){return _this.verificaIndeferidos('rpps');}}case'salvarERejeitar':return Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);default:return false;}};_this.verificaIndeferidos=function(regime){var retorno=true;if(regime==='rgps'){var camposValidosRMIZerada=true;if(_this.state.isRmiZerada){camposValidosRMIZerada=_this.state.isRmiZerada&&_this.state.validadeCampos.rendaMensalInicial;}retorno=_this.state.validadeBotoesIndeferidos.pesquisarDadosBeneficio&&camposValidosRMIZerada;}else{retorno=_this.state.validadeCampos.dataInicioBeneficio&&_this.state.validadeCampos.rendaMensalInicial;}return retorno;};_this.verificaAlteracaoCamposEstadoExigencia=function(){var _this$state24=Object.assign({},_this.state),requerimento=_this$state24.requerimento;var _this$state25=Object.assign({},_this.state),requerimentoVindoDoRequest=_this$state25.requerimentoVindoDoRequest;var reqOriginal=requerimentoVindoDoRequest;var reqAtual=requerimento;var houveAlteracao=false;if(reqOriginal!==null){if(reqAtual.idUOMantenedora!==undefined){if(reqOriginal.idUOMantenedora&&reqOriginal.idUOMantenedora!==reqAtual.idUOMantenedora&&reqAtual.idUOMantenedora!==null){houveAlteracao=true;}}if(reqAtual.nome!==undefined){if(reqOriginal.nome&&reqOriginal.nome!==reqAtual.nome&&reqAtual.nome!==null){houveAlteracao=true;}}if(reqAtual.dataNascimento!==undefined){if(reqOriginal.dataNascimento&&reqOriginal.dataNascimento!==reqAtual.dataNascimento&&reqAtual.dataNascimento!==null){houveAlteracao=true;}}if(reqAtual.nomeMae!==undefined){if(reqOriginal.nomeMae&&reqOriginal.nomeMae!==reqAtual.nomeMae&&reqAtual.nomeMae!==null){houveAlteracao=true;}}if(reqAtual.dataInicioBeneficio!==undefined){if(reqOriginal.dataInicioBeneficio&&reqOriginal.dataInicioBeneficio!==reqAtual.dataInicioBeneficio&&reqAtual.dataInicioBeneficio!==null){houveAlteracao=true;}}if(reqAtual.dataInicioPagamentoBeneficio!==undefined){if(reqOriginal.dataInicioPagamentoBeneficio===undefined&&reqAtual.dataInicioPagamentoBeneficio!==null||reqOriginal.dataInicioPagamentoBeneficio!==reqAtual.dataInicioPagamentoBeneficio&&reqAtual.dataInicioPagamentoBeneficio!==null){houveAlteracao=true;}}if(reqAtual.dataCessacaoBeneficio!==undefined){if(reqOriginal.dataCessacaoBeneficio===undefined&&reqAtual.dataCessacaoBeneficio!==null||reqOriginal.dataCessacaoBeneficio!==reqAtual.dataCessacaoBeneficio&&reqAtual.dataCessacaoBeneficio!==null){houveAlteracao=true;}}if(reqAtual.rendaMensalInicial!==undefined){if(reqOriginal.rendaMensalInicial&&reqOriginal.rendaMensalInicial!==reqAtual.rendaMensalInicial&&reqAtual.rendaMensalInicial!==null){houveAlteracao=true;}}if(_this.props.auth.checkPermission(['requerer-compensacao-rpps'])){if(reqAtual.dataHomologacaoTribunalContas!==undefined){if(reqOriginal.dataHomologacaoTribunalContas===undefined&&reqAtual.dataHomologacaoTribunalContas!==null||reqOriginal.dataHomologacaoTribunalContas!==reqAtual.dataHomologacaoTribunalContas&&reqAtual.dataHomologacaoTribunalContas!==null){houveAlteracao=true;}}}else if(_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){if(reqAtual.dataCreditoPagamento!==undefined){if(reqOriginal.dataCreditoPagamento===undefined&&reqAtual.dataCreditoPagamento!==null||reqOriginal.dataCreditoPagamento!==reqAtual.dataCreditoPagamento&&reqAtual.dataCreditoPagamento!==null){houveAlteracao=true;}}}}return houveAlteracao;};_this.verificaAlteracaoCamposDependente=function(depAtual,depOriginal){var houveAlteracao=false;if(depOriginal!==null){if(depAtual.cpfDependente!==undefined){if(depOriginal.cpfDependente===undefined&&depAtual.cpfDependente!==null||depOriginal.cpfDependente!==depAtual.cpfDependente){houveAlteracao=true;}}if(depAtual.nome!==undefined){if(depOriginal.nome&&depOriginal.nome!==depAtual.nome){houveAlteracao=true;}}if(depAtual.nomeMae!==undefined){if(depOriginal.nomeMae&&depOriginal.nomeMae!==depAtual.nomeMae){houveAlteracao=true;}}if(depAtual.dataNascimento!==undefined){if(depOriginal.dataNascimento&&depOriginal.dataNascimento!==depAtual.dataNascimento){houveAlteracao=true;}}if(depAtual.sexo!==undefined){if(depOriginal.sexo&&depOriginal.sexo!==depAtual.sexo){houveAlteracao=true;}}if(depAtual.estadoCivil!==undefined){if(depOriginal.estadoCivil&&depOriginal.estadoCivil!==depAtual.estadoCivil){houveAlteracao=true;}}if(depAtual.vinculo!==undefined){if(depOriginal.vinculo&&depOriginal.vinculo!==depAtual.vinculo){houveAlteracao=true;}}if(depAtual.capacidade!==undefined){if(depOriginal.capacidade&&depOriginal.capacidade!==depAtual.capacidade){houveAlteracao=true;}}if(depAtual.motivoInclusao!==undefined){if(depOriginal.motivoInclusao===undefined&&depAtual.motivoInclusao!==null||depOriginal.motivoInclusao!==depAtual.motivoInclusao){houveAlteracao=true;}}}return houveAlteracao;};_this.verificaSeAnaliseCompleta=function(){switch(_this.state.requerimento.estado){case 2:return _this.state.requerimento.exigencias.length>0;case 8:return true;case 9:return _this.state.motivosIndeferimentoControle.length>0;case 10:return typeof _this.state.requerimento.motivo==='number';default:return false;}};_this.verificaSeAnaliseMedicoCompleta=function(){var dependentesAnaliseMedico=_this.state.requerimento.dependentes.filter(function(item){return item.capacidade===3||item.capacidade===5;});return dependentesAnaliseMedico.every(function(item){return'invalidezDeAcordoMedico'in item;});};_this.handleSearchButton=function(){var cpfTouched=true;_this.setState(Object.assign({},_this.state,{cpfTouched:cpfTouched}),_this.handleSearch);};_this.handleSearch=function(){if(_this.state.requerimento.cpf){var _this$state$requerime3=Object.assign({},_this.state.requerimento),cpf=_this$state$requerime3.cpf;_this.setState({requestPesquisa:true},Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('requerimentos-compensacao',_this.buscaPeloCpfSucesso,_this.callbackFalhaBuscaCpf,{cpf:cpf,'tipo-requerimento':1,participacao:1}));}};_this.handleModalAlteraDataCessacao=function(){_this.setState({exibirModalDataCessacao:!_this.state.exibirModalDataCessacao});};_this.handleFechamentoModalAlerta=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta});};_this.buscaPeloCpfSucesso=function(response){try{if(response.data){_this.setState({destinatariosAposentadoria:response.data});if(response.data[0].solicitante!=='01000'){_this.trataBuscaPeloCpfRPPS(response);}else{_this.trataBuscaPeloCpfRGPS(response);}}else{_this.setState(Object.assign({},_this.state,{matriculaLabel:{},destinatarioLabel:[],requerimento:Object.assign({},_this.state.requerimento,{nome:'',matricula:null,destinatario:null})}),Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Não foram encontrados requerimentos de compensação de aposentadoria associados ao CPF informado.']));}}catch(err){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.']);}};_this.callbackFalhaBuscaCpf=function(error){_this.setState(Object.assign({},_this.state,{matriculaLabel:{},destinatarioLabel:[],requerimento:Object.assign({},_this.state.requerimento,{nome:'',matricula:null,destinatario:null})}),function(){return _this.trataErrosResponse(error);});};_this.trataBuscaPeloCpfRPPS=function(response){var matriculaLabel={};response.data.forEach(function(item){if(item.estado!==9&&item.estado!==14&&item.estado!==16){if(item.destinatario in matriculaLabel){matriculaLabel[item.destinatario].push({label:item.matricula,value:item.matricula});}else{matriculaLabel[item.destinatario]=[{label:item.matricula,value:item.matricula}];}}});var destinatarioLabel=Object.keys(matriculaLabel).map(function(item){return{label:Object(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */])(_this.props.destinatarios,item).label,value:item};});// IB372216 - Alteração da pesquisa de CPF do requerimento de pensão
var cpf=response.data[0].cpf;//const nome = response.data[0] ? response.data[0].nome : '';
_this.setState(Object.assign({},_this.state,{matriculaLabel:matriculaLabel,destinatarioLabel:destinatarioLabel// requerimento: {
//   ...this.state.requerimento,
//   nome,
// },
}),_this.pesquisarNomeNaRFB(cpf));};_this.trataSucessoResponsePesquisaCpfPensao=function(response){_this.setState({requerimento:Object.assign({},_this.state.requerimento,{nome:response.data.nome})});};_this.trataBuscaPeloCpfRGPS=function(response){var destinatarioLabel=[];var matriculaLabel=[];var _this$state26=Object.assign({},_this.state),requerimento=_this$state26.requerimento;response.data.forEach(function(item){if(item.estado!==9&&item.estado!==14&&item.estado!==16){destinatarioLabel.push({label:Object(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */])(_this.props.destinatarios,item.destinatario).label,value:item.destinatario});if(item.matricula){matriculaLabel.push({label:item.matricula,value:item.destinatario});}}});requerimento.numeroBeneficioAposentadoria=response.data[0].numeroBeneficio;var cpf=response.data[0].cpf;// const nome = response.data[0] ? response.data[0].nome : '';
// const nome = (this.state.nomeVindoDaRFB !== null) ? this.state.nomeVindoDaRFB : '';
_this.setState(Object.assign({},_this.state,{destinatarioLabel:destinatarioLabel,matriculaLabel:matriculaLabel// requerimento: {
//   ...this.state.requerimento,
//   nome,
// },
}),_this.pesquisarNomeNaRFB(cpf));};_this.trataErrosResponse=function(error){var _this$state27=Object.assign({},_this.state),validadeCampos=_this$state27.validadeCampos;var _this$state28=Object.assign({},_this.state),requerimento=_this$state28.requerimento;if(error&&error.tipo===2){var _error=Object.assign({},error),data=_error.data;_this.setState({chaveConfirmacao:data.chaveConfirmacao,alertas:data.alertas,showModalAlerta:!_this.state.showModalAlerta});}else{if(_this.state.requestPesquisa){if(typeof _this.state.requestPesquisa!=='boolean'){camposPreenchidosPorServico[_this.state.requestPesquisa].forEach(function(key){validadeCampos[key]=false;requerimento[key]='';});_this.setState({requerimento:Object.assign({},_this.state.requerimento,{requerimento:requerimento}),validadeCampos:validadeCampos});}}if(error){var _error2=Object.assign({},error),_data=_error2.data;if(error.status===400){var camposDependentesInvalidos=[];if(_data.erros&&_data.erros.length>=1){_data.erros.forEach(function(erro){if(erro.atributo in _this.state.validadeCampos){validadeCampos[[erro.atributo]]=false;}// Olhar isso depois
// eslint-disable-next-line
if(erro.hasOwnProperty('indiceLista')){camposDependentesInvalidos.push(erro);validadeCampos.dependentes=false;}if(_this.state.acao==='cumprir-exigencia'&&requerimento.estado===2&&requerimento.exigencias){var exigenciaComAtributo=requerimento.exigencias.filter(function(item){return item.atributo;});exigenciaComAtributo.forEach(function(exigencia){validadeCampos[exigencia.atributo]=false;});}});_this.setState(Object.assign({},_this.state,{validadeCampos:validadeCampos,camposDependentesInvalidos:camposDependentesInvalidos,estadoFormulario:'erro-regra'}));}var _this$state29=Object.assign({},_this.state),acao=_this$state29.acao;if(acao==='cumprir-exigencia'&&requerimento.estado===2&&requerimento.exigencias){var exigenciaComAtributo=requerimento.exigencias.filter(function(item){return item.atributo;});exigenciaComAtributo.forEach(function(exigencia){validadeCampos[exigencia.atributo]=false;});}_this.setState(Object.assign({},_this.state,{validadeCampos:validadeCampos,camposDependentesInvalidos:camposDependentesInvalidos,estadoFormulario:'erro-regra'}));var _this$state30=Object.assign({},_this.state),validadeBotoesIndeferidos=_this$state30.validadeBotoesIndeferidos;if(_this.state.requestPesquisa==='centralService'&&validadeBotoesIndeferidos.pesquisarDadosBeneficio===true){validadeBotoesIndeferidos.pesquisarDadosBeneficio=false;_this.setState({validadeBotoesIndeferidos:validadeBotoesIndeferidos});}// if (this.state.requestPesquisa === 'cnis' && validadeBotoesIndeferidos.pesquisarDadosPessoais === true) {
//     validadeBotoesIndeferidos.pesquisarDadosPessoais = false;
//     this.setState({ validadeBotoesIndeferidos });
// }
}}}};_this.extrairMotivosParaSalvar=function(){var _this$state31=Object.assign({},_this.state),motivosIndeferimentoControle=_this$state31.motivosIndeferimentoControle;if(motivosIndeferimentoControle.length>0){var _this$state32=Object.assign({},_this.state),requerimento=_this$state32.requerimento;var lista=[];motivosIndeferimentoControle.forEach(function(item){lista.push(item.motivo);});requerimento.listaMotivosIndeferimento=lista;_this.setState(Object.assign({},requerimento));}};_this.handleSaveButton=function(){if(_this.state.acao==='consulta'){_this.uploadFileAvulso();}else{if(_this.state.requerimento.estado===9){_this.extrairMotivosParaSalvar();_this.setState({alertas:[__WEBPACK_IMPORTED_MODULE_14__utils_constants__["m" /* msgsConfirmacao */].indeferimento],showModalAlerta:!_this.state.showModalAlerta});}else if(_this.state.acao==='cumprir-exigencia'){var alteracaoDep=false;_this.state.requerimento.dependentes.forEach(function(dependente){_this.state.dependentesOrigem.forEach(function(dependenteOrigem){if(alteracaoDep){return;}if(_this.verificaAlteracaoCamposDependente(dependente,dependenteOrigem)===true){alteracaoDep=true;return;}});});// caso ele tenha dependentes anteriores e tenha excluido os dependentes
if(_this.state.requerimento.dependentes.length!=_this.state.dependentesOrigem.length){alteracaoDep=true;}if(!_this.verificaAlteracaoCamposEstadoExigencia()&&!alteracaoDep){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Não foram identificadas modificações no requerimento.']);}else{_this.confirmSendData();}}else if(_this.state.acao==='indeferidos'){var _this$state33=Object.assign({},_this.state),requerimento=_this$state33.requerimento;requerimento.estado=3;var mensagemConfirmacao='';mensagemConfirmacao=__WEBPACK_IMPORTED_MODULE_14__utils_constants__["r" /* msgsConfirmacaoIndeferimento */].reaberturaIndeferimento;_this.setState({requerimento:Object.assign({},requerimento),alertas:[mensagemConfirmacao],showModalAlerta:!_this.state.showModalAlerta});}else{_this.confirmSendData();}}};_this.handleSaveButtonConfirmarIndeferimento=function(){// this.setState({ requerimento: { ...this.state.requerimento, estado: 16 }});
// this.confirmSendData();
var _this$state34=Object.assign({},_this.state),requerimento=_this$state34.requerimento;requerimento.estado=16;var mensagemConfirmacao='';mensagemConfirmacao=__WEBPACK_IMPORTED_MODULE_14__utils_constants__["r" /* msgsConfirmacaoIndeferimento */].indeferimento;_this.setState({requerimento:Object.assign({},requerimento),alertas:[mensagemConfirmacao],showModalAlerta:!_this.state.showModalAlerta});};_this.onClickSalvarERejeitarRequerimento=function(){var requerimento=Object.assign({},_this.state.requerimento);if(_this.isSolicitanteRGPS()){requerimento.solicitante='01000';}_this.setState({acao:'salvarERejeitar',requerimento:Object.assign({},requerimento),showRejeicaoRequerimentoModal:!_this.state.showRejeicaoRequerimentoModal});};_this.atualizarMotivoRejeicao=function(paramMotivo,paramJustificativa){var requerimento=Object.assign({},_this.state.requerimento);requerimento.motivo=paramMotivo;requerimento.justificativaRejeicao=paramJustificativa;_this.setState({requerimento:Object.assign({},requerimento)},function(){return _this.confirmSendData();});;};_this.confirmSendData=function(){var touched=true;var url='requerimentos-compensacao-pensao';if(_this.state.acao!=='novo'){if(_this.state.acao==='salvarERejeitar'){url='requerimentos-compensacao-pensao/solicitar-e-rejeitar';}else{url='requerimentos-compensacao-pensao/'+_this.state.requerimento.protocolo;}}// Alteração para transformar o valor do campo rendaMensalInicial
// para numero antes de persistir na tabela.
if(typeof _this.state.requerimento.rendaMensalInicial!=='number'){var renda=_this.state.requerimento.rendaMensalInicial;renda=renda.replace(/\./g,'').replace(/,/g,'.');//this.state.requerimento.rendaMensalInicial = Number(renda);
_this.setState({requerimento:Object.assign({},_this.state.requerimento,{rendaMensalInicial:Number(renda)})});}// Vinicius
var _this$state35=Object.assign({},_this.state),validadeCampos=_this$state35.validadeCampos;var camposDependentesInvalidos=[];Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});_this.setState({touched:touched,validadeCampos:validadeCampos,camposDependentesInvalidos:camposDependentesInvalidos,requestPesquisa:false},function(){return _this.handleSave(url);});};_this.handleSave=function(url){if(_this.formularioProntoParaEnvio()||_this.state.requerimento.estado===16){var options=void 0;if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}var _this$state36=Object.assign({},_this.state),requerimento=_this$state36.requerimento;if(_this.state.acao==='novo'||_this.state.acao==='salvarERejeitar'){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["l" /* doPost */])(url,requerimento,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,options);}else{Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["n" /* doPut */])(url,requerimento,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,{codigo:3009,mensagem:'Esta solicitação já foi atendida por outro usuário.'},options);}}else if(!_this.state.validadeCampos.dependentes&&_this.state.acao==='novo'){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Informe o dependente do requerimento de compensação de pensão.']);}else{Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Informe corretamente os atributos indicados na tela.']);}};_this.handleDocumentSent=function(){_this.setState({sucessoUpload:true});};_this.handleFailDocumentSent=function(){};_this.uploadFile=function(response){var _this$state37=Object.assign({},_this.state),requerimento=_this$state37.requerimento;if(_this.state.acao==='novo'){requerimento.protocolo=response.headers.location.substring(response.headers.location.lastIndexOf('/')+1,response.headers.location.length);}var url='documentos';var documentos=requerimento.arquivos;if(documentos.length>0){for(var i=0,docs=documentos.length;i<docs;i+=1){var body={protocolo:requerimento.protocolo,tipoDocumento:documentos[i].tipoDocumento,documento:documentos[i].documento};Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["j" /* doMultipartFormPost */])(url,body,_this.handleDocumentSent,_this.handleFailDocumentSent);}}};_this.trataSucessoUploadAvulso=function(){var _this$state38=Object.assign({},_this.state),requerimento=_this$state38.requerimento;_this.setState({sucessoUpload:true});if(_this.state.sucessoUpload){var mensagemSucesso=['Documentos anexados ao requerimento com sucesso.'];// if (this.isConsultaExigencia()) {
//   mensagemSucesso = 'Documento(s) anexado(s) ao requerimento com sucesso.';
// }
requerimento.arquivos=[];_this.setState({habilitarBotaoCarregarDocumento:false,requerimento:requerimento},_this.atualizarDocumentosProbatorios);Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);}};_this.handleFailUploadAvulso=function(){var mensagemErro=['Falha ao anexar documento(s) ao requerimento.'];Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(mensagemErro);};_this.trataSucessoResponseDocs=function(response){var _this$state39=Object.assign({},_this.state),requerimento=_this$state39.requerimento;var listaDocs=response.data;_this.setState({requerimento:Object.assign({},requerimento,{documentosProbatorios:listaDocs})});};_this.uploadFileAvulso=function(){var _this$state40=Object.assign({},_this.state),requerimento=_this$state40.requerimento;var url='documentos';if(requerimento.estado===2){var documentos=requerimento.arquivos;if(documentos.length>0){var listaExigencias=requerimento.exigencias;var listaDependentes=requerimento.dependentes;var tipoDocumentoUpload='';var documentoUpload='';var body='';if(listaDependentes&&listaDependentes.length>0&&listaExigencias&&listaExigencias.length>0){for(var i=0,tam=listaDependentes.length;i<tam;i+=1){for(var j=0,exi=listaExigencias.length;j<exi;j+=1){for(var k=0,arq=documentos.length;k<arq;k+=1){var dependenteUpload=listaDependentes[i];var exigencia=listaExigencias[j];var arquivo=documentos[k];if(dependenteUpload.codigo===exigencia.codigoDependente&&arquivo.tipoDocumento===exigencia.tipoDocumento){tipoDocumentoUpload=exigencia.tipoDocumento;documentoUpload=arquivo;documentos[k].carregar=true;documentos[k].dependente=dependenteUpload;documentos[k].tipoDocumento=tipoDocumentoUpload;}else{// tipoDocumentoUpload = exigencia.tipoDocumento !== undefined ? exigencia.tipoDocumento : arquivo.tipoDocumento;
documentoUpload=arquivo;documentos[k].carregar=true;documentos[k].tipoDocumento=exigencia.tipoDocumento!==undefined?exigencia.tipoDocumento:arquivo.tipoDocumento;}}}}}documentos.forEach(function(documento){if(documento.carregar){body={protocolo:requerimento.protocolo,documento:documento.documento,tipoDocumento:documento.tipoDocumento};Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["k" /* doMultipartFormPostExigencias */])(url,body,_this.trataSucessoUploadAvulso,_this.handleFailUploadAvulso);}});}}else{// const url = 'documentos';
var _documentos=requerimento.arquivos;if(_documentos.length>0){for(var _i=0,docs=_documentos.length;_i<docs;_i+=1){var _body={protocolo:requerimento.protocolo,tipoDocumento:_documentos[_i].tipoDocumento,documento:_documentos[_i].documento};Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["j" /* doMultipartFormPost */])(url,_body,_this.trataSucessoUploadAvulso,_this.handleFailUploadAvulso);}}}};_this.atualizarDocumentosProbatorios=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.sleep(1000);case 2:// }
Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('/requerimentos-compensacao-pensao/documentos-probatorios/'+_this.state.requerimento.protocolo,_this.trataSucessoResponseDocs,_this.trataErrosResponse);case 3:case'end':return _context.stop();}}},_callee,_this2);}));_this.sleep=function(time){return new Promise(function(resolve){return setTimeout(resolve,time);});};_this.trataSucessoResponseEnvio=function(response){if(_this.state.acao==='novo'||_this.state.acao==='indeferidos'){_this.uploadFile(response);if(_this.state.sucessoUpload){var mensagemSucesso=['Documentos anexados ao requerimento com sucesso.'];Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);}}if(_this.state.acao==='salvarERejeitar'){_this.buscaRequerimentoAposRejeitar(response);}// if (this.state.acao === 'realizar-analise') {
//   const { requerimento } = { ...this.state };
//   const { motivosIndeferimentoControle } = { ...this.state };
//   if (requerimento.estado !== 9 && 
//     (motivosIndeferimentoControle && motivosIndeferimentoControle.length > 0)) {
//     motivosIndeferimentoControle.forEach((motivo) => {
//         this.deleteMotivos(motivo);
//     });
//   }
// } 
if(_this.state.chaveConfirmacao){_this.setState({chaveConfirmacao:null,alertas:[]},_this.trataSucesso);}else{_this.trataSucesso();}};_this.trataSucesso=function(){var mensagemSucesso='Requerimento aberto.';var houveAlteracao=_this.verificaAlteracaoCamposEstadoExigencia();var cumpriuExigencia=false;var _this$state41=Object.assign({},_this.state),houveAlteracaoDependente=_this$state41.houveAlteracaoDependente;switch(_this.state.acao){case'novo':{_this.setState({estadoFormulario:'criado'});break;}case'cumprir-exigencia':mensagemSucesso='Requerimento atualizado.';houveAlteracao=_this.verificaAlteracaoCamposEstadoExigencia();// mensagemSucesso = 'Requerimento atualizado e exigência encerrada.';
_this.state.requerimento.exigencias.forEach(function(exigencia){if(exigencia.atendida){cumpriuExigencia=true;}});if(houveAlteracao&&cumpriuExigencia){mensagemSucesso='Requerimento atualizado e exigência encerrada.';}else if(houveAlteracao&&!cumpriuExigencia||houveAlteracaoDependente&&!houveAlteracao&&!cumpriuExigencia){mensagemSucesso='Requerimento atualizado.';}_this.buscaRequerimento(_this.handleSuccessBuscaRequerimentoAtualizacao);break;case'realizar-analise':mensagemSucesso='Requerimento analisado.';_this.props.history.goBack();break;case'emitir-parecer-medico':mensagemSucesso='Requerimento atualizado com o parecer do médico.';_this.props.history.goBack();break;// default: mensagemSucesso = 'Requerimento atualizado e exigência encerrada.';
case'indeferidos':{mensagemSucesso='Requerimento atualizado com sucesso.';_this.props.history.goBack();break;}case'salvarERejeitar':{mensagemSucesso='Requerimento criado no estado rejeitado.';_this.handleModalRejeicaoRequerimento();_this.setState({acao:'novo',estadoFormulario:'criado'});break;}default:mensagemSucesso='Requerimento atualizado.';}Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["J" /* trataMensagemSucesso */])([mensagemSucesso]);};_this.handleNewButton=function(){if(_this.props.auth.checkPermission(['requerer-compensacao-rpps'])){_this.setState(_this.buscaParticipantePeloCnpjLogado());}_this.setState(Object.assign({},_this.getInitialState(),{reset:true}),function(){return _this.setState({reset:false},function(){return window.scrollTo(0,0);});});};_this.checkIsFetchExigencias=function(){_this.setState({isFetchExigencias:!_this.state.isFetchExigencias});};_this.formularioRequerimento=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DadosRequerimentoPensao__["a" /* default */],{acao:_this.state.acao,alteraEstadoRequerimento:_this.alteraEstadoRequerimento,auth:_this.props.auth,camposCnis:camposCnis,estadoFormulario:_this.state,match:_this.props.match,handleChange:_this.handleChange,handleChangeDestinatario:_this.handleChangeDestinatario,handleKeyUp:_this.handleKeyUp,handleSearchButton:_this.handleSearchButton,tiposDocumentos:_this.props.tiposDocumentos,checkIsFetchExigencias:_this.checkIsFetchExigencias,validacaoErrosDependentes:_this.validacaoErrosDependentes,handleSearchNBButton:_this.handleSearchNBButton,arquivos:_this.props.arquivos,camposCentralService:camposPreenchidosPorServico.centralService,listaExigencias:_this.state.exigenciasOriginais,atualizarDocumentosProbatorios:_this.atualizarDocumentosProbatorios,temBloqueioAtivoContratoDtp:_this.props.temBloqueioAtivoContratoDtp,handleModalAlteraDataCessacao:_this.handleModalAlteraDataCessacao,exibirModalDataCessacao:_this.state.exibirModalDataCessacao,atualizarDataCessacao:_this.atualizarDataCessacao,handleChangeTipoDocumento:_this.handleChangeTipoDocumento,handleChangeFile:_this.handleChangeFile});};_this.montaCorpoRequerimento=function(){var corpoRequerimento=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["G" /* DtpTabGroup */],{className:'dtp-default'},_this.montaTabs());return corpoRequerimento;};_this.tabRequerimento=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["F" /* DtpTab */],{id:'item1',className:'active',title:'Requerimento'},_this.formularioRequerimento());};_this.tabHistorico=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["F" /* DtpTab */],{id:'item2',title:'Estados'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__DadosHistoricoRequerimento__["a" /* default */],{historicoEstados:_this.state.requerimento.estados,auth:_this.props.auth}));};_this.montaTabs=function(){var listaTabs=[];listaTabs.push(_this.tabRequerimento());if(_this.state.requerimento.estados){listaTabs.push(_this.tabHistorico());}return listaTabs;};_this.atualizarDataCessacao=function(dataCessacao){var requerimento=Object.assign({},_this.state.requerimento);requerimento.dataCessacaoBeneficio=dataCessacao;_this.setState({requerimento:requerimento});};_this.onClickRejeitarRequerimento=function(){/**
  * Trata o click no botão de rejeitar requerimento
  */_this.setState({rejeitar:true,showRejeicaoRequerimentoModal:!_this.state.showRejeicaoRequerimentoModal});};_this.handleModalRejeicaoRequerimento=function(){if(_this.state.acao==='salvarERejeitar'){_this.setState({acao:'novo',showRejeicaoRequerimentoModal:!_this.state.showRejeicaoRequerimentoModal});}else{_this.setState({rejeitar:false,showRejeicaoRequerimentoModal:!_this.state.showRejeicaoRequerimentoModal});}};_this.handleRejeicaoRequerimentoSent=function(){var mensagemSucesso=['Requerimento Rejeitado.'];Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);_this.setState({},function(){return _this.handleModalRejeicaoRequerimento();});_this.props.history.goBack();};_this.exibirBotaoRejeicao=function(){var _this$state$requerime4=Object.assign({},_this.state.requerimento),solicitante=_this$state$requerime4.solicitante;var _this$state42=Object.assign({},_this.state),requerimento=_this$state42.requerimento;var cnpjUsuarioLogado=__WEBPACK_IMPORTED_MODULE_16__domain_User__["a" /* default */].logged().cnpjDoPapel();var cnpjSolicitante=solicitante?solicitante.cnpj:null;var codigoSolicitante=solicitante?solicitante.codigo:null;var ehUsuarioRGPS=__WEBPACK_IMPORTED_MODULE_16__domain_User__["a" /* default */].logged().isUsuarioRGPS();var retorno=null;if([1,3,6,7,8,9,10,11,12,14,15,16,17].includes(requerimento.estado)){retorno=false;}else{retorno=requerimento!==undefined&&solicitante!==undefined&&(['consulta','cumprir-exigencia'].includes(_this.state.acao)&&[2,4,5,13,18].includes(requerimento.estado)&&cnpjSolicitante===cnpjUsuarioLogado||codigoSolicitante==='01000'&&ehUsuarioRGPS)||_this.state.rejeitar;}return retorno;};var initialState=_this.getInitialState();_this.state=initialState;return _this;}_createClass(RequerimentoPensao,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["a" /* buscaDestinatarios */])(this.handleErrorBusca);}if(this.props.tiposDocumentos.length===0){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["D" /* requestTiposDocumentos */])(this.handleErrorBusca);}this.montaFormulario();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.destinatarios.length!==prevProps.destinatarios.length||this.props.tiposDocumentos.length!==prevProps.tiposDocumentos.length){if(this.props.destinatarios.length>0&&this.props.tiposDocumentos.length>0){this.montaFormulario();}}}/**
   *  Se URL possuir protocolo, requerimento deve ser buscado.
   *  Se URL possuir acao, atualizar state com acao indicada,
   *  senao assume-se que o usuario apenas consulta o requerimento quando protocolo for informado
   *  Protocolo deve ser numerico;
   *  Acao deve ser cumprir-exigencia, realizar-analise ou emitir-parecer-medico.
   */},{key:'buscaRequerimento',/**
   * Busca o requerimento de pensao
   */value:function buscaRequerimento(){var metodoSucesso=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.handleSuccessBuscaRequerimento;if(this.state.acao!=='novo'){var url='requerimentos-compensacao-pensao/'+this.props.match.params.protocolo;Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])(url,metodoSucesso,this.handleErrorBuscaRequerimento);}}},{key:'buscaRequerimentoAposRejeitar',value:function buscaRequerimentoAposRejeitar(response){var url='requerimentos-compensacao-pensao/'+response.data.protocolo;Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])(url,this.handleSuccessBuscaRequerimentoAposSalvarERejeitar,this.handleErrorBuscaRequerimento);}/**
   * Trata o estado do formulario e alteracoes de campos.
   * Formulario deve ser considerado:
   *  - Inicial quando ainda nao enviado para validacao de regras no servico;
   *  - Alterado quando formulario montado com dados do servico e ao menos um campo foi alterado.
   *  - Enviado quando o formulario foi enviado para validacao no servico.
   *//**
   * Trata o click no botão de busca por NB no BenMigrado. - centralService
   *//**
   * Controla a alteracao do estado do requerimento resultado da analise
   */// Busca requerimentos de aposentadoria por CPF
/**
  * Trata o click no botão de alteração da data de cessação
  *//**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */// Trata o retorno quando busca de requerimentos de aposentadoria
// por cpf quando solicitante for RPPS
},{key:'pesquisarNomeNaRFB',// IB372216 - Alteração da pesquisa de CPF do requerimento de pensão
value:function pesquisarNomeNaRFB(cpf){this.setState({requestPesquisa:false},Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('pessoas-fisicas/'+cpf,this.trataSucessoResponsePesquisaCpfPensao,this.trataErrosResponse));}// Trata o retorno quando busca de requerimentos de aposentadoria
// por cpf quando solicitante for RGPS
// Trata o retorno quando busca de requerimentos de aposentadoria
// por cpf quando solicitante for RGPS
// trataBuscaPeloCpfRGPS = (response) => {
//   const { requerimento } = { ...this.state };
//   const destinatarioLabel = [];
//   const matriculaLabel = [];
//   response.data.forEach((item) => {
//     destinatarioLabel.push({
//       label: getObject(this.props.destinatarios, item.destinatario).label,
//       value: item.destinatario,
//     });
//   });
//   requerimento.numeroBeneficioAposentadoria = response.data[0].numeroBeneficio;
//   requerimento.matricula = response.data[0].matricula;
//   const nome = response.data[0] ? response.data[0].nome : '';
//   this.setState({
//     ...this.state,
//     destinatarioLabel,
//     matriculaLabel,
//     requerimento: {
//       ...this.state.requerimento,
//       nome,
//     },
//   });
// }
// deleteMotivos = (motivo) => {
//   const url = `requerimentos-compensacao/motivos/${motivo.protocolo}/${requerimento.estado}/${motivo.dataInicio}/${motivo.motivo}`;
//   doDeleteMotivo(url,'','','');
// }
/**
   * Trata o click do botao de submissao do formulario
   * Se analise estiver indeferindo, exibir alerta de confirmacao
   *//**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   *//**
   * Trata a mensagem de sucesso ao criar/editar requerimento e redireciona para
   * consulta se nao for novo requerimento.
   */// Trata o clique no botao de "Novo Requerimento"
},{key:'obterMensagens',value:function obterMensagens(dataAbertura){var mensagem=[];mensagem.push({descricao:'A Data de Cria\xE7\xE3o do Requerimento em '+dataAbertura+' n\xE3o ser\xE1 alterada.'});if(this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps'])){mensagem=mensagem.concat(__WEBPACK_IMPORTED_MODULE_14__utils_constants__["a" /* alertaPesquisarDadosBeneficio */]);}return mensagem;}/**
  * Trata o click no botão de rejeitar o requerimento
  */},{key:'render',value:function render(){var _this3=this;if(this.state.reset){return null;}if(this.state.mostraPaginaSemConteudo){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.mensagemPrincipalSemConteudo,secondaryText:this.state.mensagemSecundariaSemConteudo,show:this.state.mostraPaginaSemConteudo});}var listaAlertas=void 0;var listaExigencias=void 0;var botaoAcaoPrincipal=void 0;var botaoAcaoVoltar=void 0;var botaoAcaoConfirmarIndeferimento=void 0;var botaoRejeitar=void 0;var botaoSalvarERejeitar=void 0;var configBotaoPrincipal={onClick:this.handleSaveButton};var configBotaoConfirmarIndeferimento={onClick:this.handleSaveButtonConfirmarIndeferimento};var configBotaoSalvarERejeitar={onClick:this.onClickSalvarERejeitarRequerimento};if(this.state.acao==='cumprir-exigencia'){listaExigencias=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ListaExigencias__["a" /* default */],{exigencias:this.state.requerimento.exigencias});configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Salvar';configBotaoPrincipal.hint='Salvar alterações no requerimento e encerrar exigências atendidas';}if(this.state.acao==='realizar-analise'){configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Finalizar Análise';configBotaoPrincipal.hint='Finalizar a análise do requerimento';}if(this.state.acao==='emitir-parecer-medico'){configBotaoPrincipal.permissoes=['fornecer-parecer-medico-rpps'];configBotaoPrincipal.titulo='Emitir parecer';configBotaoPrincipal.hint='Emitir parecer do médico perito';}if(this.state.acao==='indeferidos'){listaAlertas=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ListaAlertas__["a" /* default */],{alertas:this.obterMensagens(this.state.requerimento.dataAberturaRequerimento),open:true});configBotaoPrincipal.permissoes=['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rpps'];configBotaoPrincipal.titulo='Reabrir requerimento';configBotaoPrincipal.hint='Reabrir requerimento';configBotaoConfirmarIndeferimento.permissoes=['requerer-compensacao-rgps','analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rpps'];configBotaoConfirmarIndeferimento.titulo='Confirmar Indeferimento';configBotaoConfirmarIndeferimento.hint='Confirmar Indeferimento do requerimento';}if(this.state.acao==='novo'){if(this.state.estadoFormulario==='criado'){configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Novo';configBotaoPrincipal.hint='Criar novo requerimento';configBotaoPrincipal.onClick=this.handleNewButton;}else{configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Salvar';configBotaoPrincipal.hint='Salvar requerimento';configBotaoSalvarERejeitar.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps'];configBotaoSalvarERejeitar.titulo='Salvar e rejeitar';configBotaoSalvarERejeitar.hint='Salvar o requerimento e rejeitar';}}else{if(this.state.acao==='consulta'&&Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["f" /* habilitarUploadNaConsultaDoRequerimento */])(this.state.requerimento,this.state.acao,null)&&!this.props.temBloqueioAtivoContratoDtp||this.state.acao==='rejeitar'){configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Carregar documento';configBotaoPrincipal.hint='Carregar documento';}if(this.state.acao==='salvarERejeitar'){configBotaoPrincipal.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];configBotaoPrincipal.titulo='Salvar';configBotaoPrincipal.hint='Salvar requerimento';configBotaoSalvarERejeitar.permissoes=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps'];configBotaoSalvarERejeitar.titulo='Salvar e rejeitar';configBotaoSalvarERejeitar.hint='Salvar o requerimento e rejeitar';}}botaoAcaoVoltar=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{className:'left',onClick:this.props.history.goBack,title:'Voltar',hint:'Voltar para tela anterior'});if(this.exibirBotaoRejeicao()){botaoRejeitar=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{className:'dtp-primary right',title:'Rejeitar o requerimento',onClick:this.onClickRejeitarRequerimento,hint:'Rejeitar'});}if(configBotaoPrincipal.titulo){if(this.state.acao==='salvarERejeitar'||this.state.acao!=='consulta'||this.state.acao==='consulta'&&Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["f" /* habilitarUploadNaConsultaDoRequerimento */])(this.state.requerimento,this.state.acao,null)){botaoAcaoPrincipal=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:configBotaoPrincipal.permissoes},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:configBotaoPrincipal.titulo,onClick:configBotaoPrincipal.onClick,hint:configBotaoPrincipal.hint}));}}if(configBotaoSalvarERejeitar.titulo){if(this.state.acao==='novo'||this.state.acao==='salvarERejeitar'){botaoSalvarERejeitar=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:configBotaoSalvarERejeitar.permissoes},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:configBotaoSalvarERejeitar.titulo,onClick:configBotaoSalvarERejeitar.onClick,hint:configBotaoSalvarERejeitar.hint}));}}if(configBotaoConfirmarIndeferimento.titulo&&this.state.acao==='indeferidos'){botaoAcaoConfirmarIndeferimento=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:configBotaoPrincipal.permissoes},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{className:'dtp-btn right',title:configBotaoConfirmarIndeferimento.titulo,onClick:configBotaoConfirmarIndeferimento.onClick,hint:configBotaoConfirmarIndeferimento.hint}));}var modalAlerta=void 0;if(this.state.showModalAlerta){modalAlerta=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.confirmSendData,handleModal:this.handleFechamentoModalAlerta,showModal:true});}var modalRejeicaoRequerimento=void 0;if(this.state.showRejeicaoRequerimentoModal){modalRejeicaoRequerimento=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__consultas_Exigencia_ModalRejeicaoRequerimento__["a" /* default */],{acao:this.state.acao,protocolo:this.state.requerimento.protocolo,requerimento:this.state.requerimento,handleModal:function handleModal(){return _this3.handleModalRejeicaoRequerimento();},showModal:true,tipoRequerimento:this.state.tipoRequerimento,handleRejeicaoRequerimentoSent:this.handleRejeicaoRequerimentoSent,handleSalvarERejeitar:this.atualizarMotivoRejeicao,rejeitar:this.state.rejeitar});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["j" /* DtpContentContainer */],null,listaAlertas,listaExigencias,this.montaCorpoRequerimento(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},botaoAcaoVoltar,botaoAcaoPrincipal,botaoSalvarERejeitar,botaoRejeitar,botaoAcaoConfirmarIndeferimento),modalAlerta,modalRejeicaoRequerimento);}}]);return RequerimentoPensao;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);RequerimentoPensao.propTypes={destinatarios:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf({label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,tipoRegimeProprio:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number}).isRequired,history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func}).isRequired,match:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string})}),tiposDocumentos:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string})),arquivos:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string})),auth:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func}),temBloqueioAtivoContratoDtp:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired};RequerimentoPensao.defaultProps={match:null,tiposDocumentos:[],auth:null,arquivos:null};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios,tiposDocumentos:state.base.tiposDocumentos,temBloqueioAtivoContratoDtp:state.base.configuracoesFrontend.temBloqueioAtivoContratoDtp};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(RequerimentoPensao));

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dependentes__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResultadoAnalise__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Aposentadoria_CalculoCompensacao__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SolicitanteDestinatario__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Destinacao__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UploadArquivos__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SegregacaoDeMassa__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModalAlteracaoDataCessacao__ = __webpack_require__(210);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var camposDesabilitadosAlteracaoRequerimento=['cpf','nome','destinatario','matricula'];var DadosRequerimentoPensao=function DadosRequerimentoPensao(props){// Torna a lista de documentos adequada ao formato do componente de documentos
var handleDocuments=function handleDocuments(){var documentos=[];if(props.estadoFormulario.requerimento.documentosProbatorios&&props.estadoFormulario.requerimento.documentosProbatorios.length>0){documentos=props.estadoFormulario.requerimento.documentosProbatorios.map(function(docs){return{key:docs.codigo,documentType:docs.tipoDocumento};});}return documentos;};/**
   * Campos devem estar desabilitados sempre que:
   *  - Acao diferente de novo e cumprir-exigencia
   *  - Se em estado cumprir-exigencia, for considerado chave ou nao for validado no CNIS
   *  - Se em estado novo, for buscado no CNIS
   */var verificaSeCampoDesabilitado=function verificaSeCampoDesabilitado(name){var _props$estadoFormular=Object.assign({},props.estadoFormulario),acao=_props$estadoFormular.acao;if(!['cumprir-exigencia','novo','indeferidos'].includes(acao)){return true;}if(acao==='cumprir-exigencia'){if(name==='rendaMensalInicial'&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){var _props$estadoFormular2=Object.assign({},props.estadoFormulario),isRmiZerada=_props$estadoFormular2.isRmiZerada,rendaMensalInicialRequest=_props$estadoFormular2.rendaMensalInicialRequest;if(isRmiZerada===true||rendaMensalInicialRequest!==null&&rendaMensalInicialRequest===0){return false;}}return camposDesabilitadosAlteracaoRequerimento.includes(name)||props.camposCnis.includes(name)||props.camposCentralService.includes(name)&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp']);// return camposDesabilitadosAlteracaoRequerimento.includes(name);
}if(acao==='novo'){if(name==='rendaMensalInicial'&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){var _props$estadoFormular3=Object.assign({},props.estadoFormulario),_isRmiZerada=_props$estadoFormular3.isRmiZerada,_rendaMensalInicialRequest=_props$estadoFormular3.rendaMensalInicialRequest;if(_isRmiZerada===true||_rendaMensalInicialRequest!==null&&_rendaMensalInicialRequest===0){return false;}}return props.camposCnis.includes(name)||props.camposCentralService.includes(name)&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp']);// return props.camposCnis.includes(name);
}if(acao==='indeferidos'){var _props$estadoFormular4=Object.assign({},props.estadoFormulario),_isRmiZerada2=_props$estadoFormular4.isRmiZerada;if(['numeroBeneficio'].includes(name)&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps'])||_isRmiZerada2&&name==='rendaMensalInicial'&&props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps'])){return false;}if(['dataInicioBeneficio','dataInicioPagamentoBeneficio','dataCessacaoBeneficio','rendaMensalInicial','dataHomologacaoTribunalContas'].includes(name)&&props.auth.checkPermission(['analisar-compensacao-rpps','requerer-compensacao-rpps'])){return false;}return true;}return false;};var pesquisarNB=void 0;if(['novo','cumprir-exigencia','indeferidos'].includes(props.estadoFormulario.acao)){pesquisarNB=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{title:'Pesquisar benef\xEDcio',onClick:function onClick(){return props.handleSearchNBButton();},hint:'Pesquisar benef\xEDcio'});}/**
   * Teste as condicoes para definir dentre os campos alternativos Matricula e Numero de Beneficio
   * qual deve ser exibido.
   */var controleCampoAlternativos=function controleCampoAlternativos(campo){switch(campo){case'matricula':if(props.estadoFormulario.acao!=='novo'){// Se formulario estiver alterando requerimento, campo deve ser exibido quando preenchido
if(props.estadoFormulario.requerimento.matricula){return Object.keys(__WEBPACK_IMPORTED_MODULE_9__utils_constants__["y" /* rolesCadastradas */]);}return[];}// Quando for criacao de requerimento, apenas RPPS deve possuir campo Matricula
return['requerer-compensacao-rpps'];case'numeroBeneficio':if(!['novo','cumprir-exigencia'].includes(props.estadoFormulario.acao)){// Se formulario estiver alterando requerimento, campo deve ser exibido quando preenchido
if(props.estadoFormulario.requerimento.numeroBeneficio){return Object.keys(__WEBPACK_IMPORTED_MODULE_9__utils_constants__["y" /* rolesCadastradas */]);}return[];}// Quando for criacao de requerimento, apenas RGPS deve possuir campo Numero de Beneficio
return['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'];case'dataHomologacaoTribunalContas':if(!['novo','cumprir-exigencia'].includes(props.estadoFormulario.acao)){// Se formulario estiver diferente de em exigencia ou novo,
// mostrar data de homologacao quando solicitante for RPPS
if(props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.requerimento.solicitante.codigo!=='01000'){return Object.keys(__WEBPACK_IMPORTED_MODULE_9__utils_constants__["y" /* rolesCadastradas */]);}return[];}// Quando for criacao ou exigencia de requerimento, apenas RPPS deve ver campo
return['requerer-compensacao-rpps'];case'dataCreditoPagamento':if(!['novo','cumprir-exigencia'].includes(props.estadoFormulario.acao)){// Se formulario estiver diferente de em exigencia ou novo,
// mostrar data de homologacao quando solicitante for RGPS
if(props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.requerimento.solicitante.codigo==='01000'){return Object.keys(__WEBPACK_IMPORTED_MODULE_9__utils_constants__["y" /* rolesCadastradas */]);}return[];}// Quando for criacao ou exigencia de requerimento, apenas RGPS deve ver campo
return['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'];case'numeroBeneficioAposentadoria':if(!['novo','cumprir-exigencia'].includes(props.estadoFormulario.acao)){// Se formulario estiver diferente de em exigencia ou novo,
// mostrar o numero do beneficio de aposentaria quando o solicitante for RGPS
if(props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.requerimento.solicitante.codigo==='01000'){return['requerer-compensacao-rpps','requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'];}return[];}// Quando for criacao ou exigencia de requerimento, apenas RGPS e DCOMP devem ver campo
return['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'];case'idUOMantenedora':if(!['novo','cumprir-exigencia','realizar-analise'].includes(props.estadoFormulario.acao)){// Se formulario estiver diferente de em exigencia ou novo,
// mostrar idUOMantenedora quando solicitante for RGPS
if(props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.requerimento.solicitante.codigo==='01000'){return Object.keys(__WEBPACK_IMPORTED_MODULE_9__utils_constants__["y" /* rolesCadastradas */]);}return[];}// Quando for criacao ou exigencia de requerimento, apenas RGPS deve ver campo
return['requerer-compensacao-rgps','gerenciar-negocio-dcomp'];default:return[];}};var resultadoAnalise=void 0;if(props.estadoFormulario.acao==='realizar-analise'){resultadoAnalise=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-compensacao-rgps','analisar-compensacao-rpps','gerenciar-negocio-dcomp']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ResultadoAnalise__["a" /* default */],{alteraEstado:props.alteraEstadoRequerimento,handleChange:props.handleChange,requerimento:props.estadoFormulario.requerimento,userData:props.auth.userData,tipoRequerimento:props.estadoFormulario.tipoRequerimento,inIndefericaoAnalise:props.estadoFormulario.inIndefericaoAnalise,atualizarDocumentosProbatorios:props.atualizarDocumentosProbatorios,motivosIndeferimentoControle:props.estadoFormulario.motivosIndeferimentoControle,handleChangeTipoDocumento:props.handleChangeTipoDocumento,tipoDocumento:props.estadoFormulario.tipoDocumento,handleChangeFile:props.handleChangeFile}));}var documentosProbatorios=void 0;if(props.tiposDocumentos.length>0){documentosProbatorios=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["b" /* ControleDocumentos */],{tiposDocumentos:props.tiposDocumentos,documents:handleDocuments(),protocolo:props.match.params.protocolo,auth:props.auth,acao:props.acao,requerimento:props.estadoFormulario.requerimento,atualizarDocumentosProbatorios:props.atualizarDocumentosProbatorios,tipoRequerimento:props.estadoFormulario.tipoRequerimento});}var calculoCompensacao=void 0;if(props.estadoFormulario.acao==='consulta'){calculoCompensacao=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Aposentadoria_CalculoCompensacao__["a" /* default */],{handleChange:props.handleChange,requerimento:props.estadoFormulario.requerimento});}var _props$estadoFormular5=Object.assign({},props.estadoFormulario.requerimento),destinatario=_props$estadoFormular5.destinatario;if(destinatario){if((typeof destinatario==='undefined'?'undefined':_typeof(destinatario))==='object'){destinatario=destinatario.codigo;}}var opcoesDestinatario=null;if(props.estadoFormulario.destinatarioLabel.length>0){opcoesDestinatario=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{required:true,disabled:verificaSeCampoDesabilitado('destinatario'),itemList:props.estadoFormulario.destinatarioLabel,touched:props.estadoFormulario.touched,label:'Destinat\xE1rio',onChange:props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps'])&&Object.keys(props.estadoFormulario.matriculaLabel).length!==0?function(e){return props.handleChangeDestinatario(e,'destinatario');}:function(e){return props.handleChange(e,'destinatario');},placeholder:'Selecione o destinat\xE1rio',value:destinatario,error:!props.estadoFormulario.validadeCampos.destinatario,custom:true}));}var opcoesMatricula=null;if(props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps'])&&Object.keys(props.estadoFormulario.matriculaLabel).length!==0){opcoesMatricula=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:true,label:'Matricula',integer:true,value:props.estadoFormulario.requerimento.matricula,touched:props.estadoFormulario.touched}));}else if(Object.keys(props.estadoFormulario.matriculaLabel).length!==0&&props.estadoFormulario.matriculaLabel.constructor===Object){opcoesMatricula=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:controleCampoAlternativos('matricula')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('matricula'),itemList:props.estadoFormulario.requerimento.destinatario?props.estadoFormulario.matriculaLabel[props.estadoFormulario.requerimento.destinatario]:[],touched:props.estadoFormulario.touched,label:'Matr\xEDcula Regime Instituidor',onChange:function onChange(e){return props.handleChange(e,'matricula');},placeholder:'Selecione a matr\xEDcula',value:props.estadoFormulario.requerimento.matricula,error:'matricula'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.matricula:false,required:true,custom:true})));}var botaoAlterarDataCessacao=void 0;if(props.estadoFormulario.requerimento&&props.estadoFormulario.requerimento.solicitante&&props.estadoFormulario.acao==='consulta'&&[4,5,13].includes(props.estadoFormulario.requerimento.estado)&&(props.estadoFormulario.requerimento.solicitante.cnpj===__WEBPACK_IMPORTED_MODULE_15__domain_User__["a" /* default */].logged().cnpjDoPapel()||props.estadoFormulario.requerimento.solicitante.codigo==='01000'&&__WEBPACK_IMPORTED_MODULE_15__domain_User__["a" /* default */].logged().isRGPS())){botaoAlterarDataCessacao=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["g" /* DtpButtonIcon */],{icon:'ico-pencil',className:'icone',accessibilityName:'Alterar data de cessa\xE7\xE3o',onClick:function onClick(){return props.handleModalAlteraDataCessacao();},hint:'Alterar data de cessa\xE7\xE3o'});}var pesquisar=void 0;if(['novo','cumprir-exigencia'].includes(props.estadoFormulario.acao)){pesquisar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{title:'Pesquisar',onClick:function onClick(){return props.handleSearchButton();},hint:'Pesquisar dados pessoais'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.acao!=='indeferidos'&&props.acao!=='novo'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SolicitanteDestinatario__["a" /* default */],{requerimento:props.estadoFormulario.requerimento}),props.estadoFormulario.requerimento.solicitanteOrigem&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["e" /* DataGrid */],{title:'Detalhes do Solicitante',icon:'ico-user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:true,label:'Solicitante de Origem',value:props.estadoFormulario.requerimento.solicitanteOrigem.nome,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:true,label:'C\xF3digo do Solicitante',value:props.estadoFormulario.requerimento.solicitanteOrigem.codigo,required:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["e" /* DataGrid */],{title:'Dados do Requerimento de Aposentadoria',icon:'ico-user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('cpf'),cpf:true,error:!props.estadoFormulario.validadeCampos.cpf,integer:true,label:'CPF',mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].cpf,onChange:function onChange(e){return props.handleChange(e,'cpf');},required:true,showMask:true,touched:props.estadoFormulario.touched||props.estadoFormulario.cpfTouched,value:props.estadoFormulario.requerimento.cpf})),pesquisar),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:controleCampoAlternativos('numeroBeneficioAposentadoria')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:true,label:'N\xFAmero do Benef\xEDcio de Aposentadoria',integer:true,value:props.estadoFormulario.requerimento.numeroBeneficioAposentadoria,touched:props.estadoFormulario.touched})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('nome'),label:'Nome',onChange:function onChange(e){return props.handleChange(e,'nome');},value:props.estadoFormulario.requerimento.nome})),opcoesDestinatario,opcoesMatricula),props.estadoFormulario.destinatarioLabel.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SegregacaoDeMassa__["a" /* default */],{estadoFormulario:props.estadoFormulario}))),props.acao==='indeferidos'&&props.estadoFormulario.requerimento.solicitante&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Destinacao__["a" /* default */],{requerimento:props.estadoFormulario.requerimento,tipoRequerimento:props.estadoFormulario.tipoRequerimento,handleChange:props.handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["e" /* DataGrid */],{title:'Dados de Benef\xEDcio de Pens\xE3o',icon:'ico-money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:controleCampoAlternativos('numeroBeneficio')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('numeroBeneficio'),error:'numeroBeneficio'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.numeroBeneficio:false,touched:props.estadoFormulario.touched,label:'N\xFAmero do Benef\xEDcio de Pens\xE3o',maxLength:'11',integer:true,value:props.estadoFormulario.requerimento.numeroBeneficio,onChange:function onChange(e){return props.handleChange(e,'numeroBeneficio');},required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},pesquisarNB))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataInicioBeneficio'),label:'Data de In\xEDcio de Benef\xEDcio',mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,required:true,value:props.estadoFormulario.requerimento.dataInicioBeneficio,onChange:function onChange(e){return props.handleChange(e,'dataInicioBeneficio');},touched:props.estadoFormulario.touched,error:!props.estadoFormulario.validadeCampos.dataInicioBeneficio})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataInicioPagamentoBeneficio'),label:'Data de In\xEDcio de Pagamento',onChange:function onChange(e){return props.handleChange(e,'dataInicioPagamentoBeneficio');},mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,value:props.estadoFormulario.requerimento.dataInicioPagamentoBeneficio,error:'dataInicioPagamentoBeneficio'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.dataInicioPagamentoBeneficio:false,touched:props.estadoFormulario.touched})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataCessacaoBeneficio'),error:'dataCessacaoBeneficio'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.dataCessacaoBeneficio:false,label:'Data de Cessa\xE7\xE3o',mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,value:props.estadoFormulario.requerimento.dataCessacaoBeneficio,onChange:function onChange(e){return props.handleChange(e,'dataCessacaoBeneficio');},touched:props.estadoFormulario.touched})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'1 1 1 1'},botaoAlterarDataCessacao),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{currency:true,showMask:false,disabled:verificaSeCampoDesabilitado('rendaMensalInicial'),label:'Renda Mensal Inicial'// mask={Masks.currency}
,maxLength:'16',onChange:function onChange(e){return props.handleChange(e,'rendaMensalInicial');},onKeyUp:function onKeyUp(e){return props.handleKeyUp(e,'rendaMensalInicial');},touched:props.estadoFormulario.touched,value:props.estadoFormulario.requerimento.rendaMensalInicial,required:true,error:!props.estadoFormulario.validadeCampos.rendaMensalInicial})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:controleCampoAlternativos('dataCreditoPagamento')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataCreditoPagamento'),error:'dataCreditoPagamento'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.dataCreditoPagamento:false,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:'Data de Cr\xE9dito do Pagamento',onChange:function onChange(e){return props.handleChange(e,'dataCreditoPagamento');},value:props.estadoFormulario.requerimento.dataCreditoPagamento,touched:props.estadoFormulario.touched})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:controleCampoAlternativos('dataHomologacaoTribunalContas')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataHomologacaoTribunalContas'),error:'dataHomologacaoTribunalContas'in props.estadoFormulario.validadeCampos?!props.estadoFormulario.validadeCampos.dataHomologacaoTribunalContas:false,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:'Data de Homologa\xE7\xE3o no Tribunal de Contas',onChange:function onChange(e){return props.handleChange(e,'dataHomologacaoTribunalContas');},value:props.estadoFormulario.requerimento.dataHomologacaoTribunalContas,touched:props.estadoFormulario.touched}))),props.estadoFormulario.exibirCampoUoInss?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:true,label:'UO INSS',value:props.estadoFormulario.requerimento.idUOMantenedora,touched:props.estadoFormulario.touched,required:true})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:controleCampoAlternativos('idUOMantenedora')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{disabled:true,label:'UO INSS',value:props.estadoFormulario.requerimento.idUOMantenedora,touched:props.estadoFormulario.touched,required:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Dependentes__["a" /* default */],{acao:props.estadoFormulario.acao,dependentes:[].concat(_toConsumableArray(props.estadoFormulario.requerimento.dependentes)),exigencias:props.estadoFormulario.requerimento.exigencias,estadoFormulario:props.estadoFormulario.estadoFormulario,handleChange:function handleChange(e){return props.handleChange(e,'dependentes');},isFetchExigencias:props.estadoFormulario.isFetchExigencias,checkIsFetchExigencias:props.checkIsFetchExigencias,errosDependentes:props.estadoFormulario.camposDependentesInvalidos,validacaoErrosDependentes:props.validacaoErrosDependentes,solicitante:props.estadoFormulario.requerimento.solicitante,auth:props.auth}),props.estadoFormulario.acao==='novo'||props.estadoFormulario.acao==='indeferidos'||props.estadoFormulario.acao==='criado'||Object(__WEBPACK_IMPORTED_MODULE_13__utils_helpers__["f" /* habilitarUploadNaConsultaDoRequerimento */])(props.estadoFormulario.requerimento,props.estadoFormulario.acao,null)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__UploadArquivos__["a" /* default */],{acao:props.estadoFormulario.acao,arquivos:[].concat(_toConsumableArray(props.estadoFormulario.requerimento.arquivos)),estadoFormulario:props.estadoFormulario.estadoFormulario,handleChange:function handleChange(e){return props.handleChange(e,'arquivos');},auth:props.auth,tipoRequerimento:props.estadoFormulario.tipoRequerimento,tiposDocumentos:props.tiposDocumentos,requerimento:props.estadoFormulario.requerimento,listaExigencias:props.estadoFormulario.exigenciasOriginais?props.estadoFormulario.exigenciasOriginais:[],temBloqueioAtivoContratoDtp:props.temBloqueioAtivoContratoDtp}):'',props.exibirModalDataCessacao?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ModalAlteracaoDataCessacao__["a" /* default */],{acao:props.estadoFormulario.acao,protocolo:props.estadoFormulario.requerimento.protocolo,dataCessacaoBeneficio:props.estadoFormulario.requerimento.dataCessacaoBeneficio,handleModal:function handleModal(){return props.handleModalAlteraDataCessacao();},showModal:props.exibirModalDataCessacao,tipoRequerimento:props.estadoFormulario.tipoRequerimento,atualizarDataCessacao:props.atualizarDataCessacao,estadoFormulario:props.estadoFormulario}):'',calculoCompensacao,documentosProbatorios,resultadoAnalise);};DadosRequerimentoPensao.propTypes={acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,alteraEstadoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,camposCnis:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,camposCentralService:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleKeyUp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleSearchButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleSearchNBButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChangeDestinatario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleModalAlteraDataCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,exibirModalDataCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,atualizarDataCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),tiposDocumentos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),validacaoErrosDependentes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,checkIsFetchExigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,atualizarDocumentosProbatorios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,temBloqueioAtivoContratoDtp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,handleChangeTipoDocumento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChangeFile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};DadosRequerimentoPensao.defaultProps={match:null,tiposDocumentos:[]};/* harmony default export */ __webpack_exports__["a"] = (DadosRequerimentoPensao);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dependente__ = __webpack_require__(596);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Dependentes=function(_Component){_inherits(Dependentes,_Component);function Dependentes(){_classCallCheck(this,Dependentes);var _this=_possibleConstructorReturn(this,(Dependentes.__proto__||Object.getPrototypeOf(Dependentes)).call(this));_this.getInitialState=function(){return{acaoModal:'criacao',showModal:false,errosDependenteSelecionado:null,exigenciasDependentes:null,dependenteSelecionado:null};};_this.handleModal=function(){var acaoModal=void 0;switch(_this.props.acao){// Caso em analise do medico perito
case'emitir-parecer-medico':if(_this.alterarDependenteMedico(_this.state.dependenteSelecionado)){acaoModal='pericia-medica';}else{acaoModal='em-analise';}break;// Caso em Analise
case'realizar-analise':acaoModal='em-analise';break;// Caso em exigencia
case'cumprir-exigencia':if(_this.verificarSeDependenteVeioDoRequest()){acaoModal='edicao';}else{acaoModal='criacao';}break;// Em caso de criacao de requerimento
case'novo':if(_this.props.estadoFormulario!=='criado'){acaoModal='criacao';}else{acaoModal='em-analise';}break;case'indeferidos':acaoModal='indeferidos';break;default:acaoModal='em-analise';}if(_this.props.exigencias&&!_this.props.isFetchExigencias){var exigenciasDependentes=_this.props.exigencias.filter(function(exigencia){return exigencia.codigoDependente;});_this.setState({showModal:!_this.state.showModal,acaoModal:acaoModal,exigenciasDependentes:exigenciasDependentes},function(){return _this.props.checkIsFetchExigencias();});}else{_this.setState({showModal:!_this.state.showModal,acaoModal:acaoModal});}};_this.createCustomInsertButton=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:_this.dependentePossuiExigenciaInclusao()?'dtp-inverse':null,onClick:_this.handleModal,hint:'Adicionar dependente',icon:'ico-user-plus'});};_this.addVinculoLabel=function(vinculoSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["W" /* vinculo */],vinculoSelecionado);if(obj===undefined||obj===null){return'';}return obj.label;};_this.alterarDependenteMedico=function(dependenteSelecionado){if(_this.props.acao==='emitir-parecer-medico'){if(dependenteSelecionado.capacidade===3||dependenteSelecionado.capacidade===5){return true;}return false;}return false;};_this.validacaoExigenciaDependente=function(exigenciasDependenteSelecionado){var exigenciasNovas=_this.state.exigenciasDependentes.filter(function(item){return exigenciasDependenteSelecionado.includes(item)?null:item;});_this.setState({exigenciasDependentes:exigenciasNovas});};_this.createActionColumn=function(indice,dependente){var hint=void 0;var icon=void 0;if(_this.props.estadoFormulario!=='criado'&&(['novo','cumprir-exigencia'].includes(_this.props.acao)||_this.alterarDependenteMedico(dependente))){hint='Editar dependente';icon='ico-pencil';}else{hint='Visualizar Dependente';icon='ico-user-magnifier';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:_this.dependentePossuiExigencia(indice,dependente)||_this.alterarDependenteMedico(dependente)?'dtp-inverse':null,hint:hint,icon:icon,mini:true,onClick:function onClick(){return _this.editDependente(indice,dependente);}}),_this.props.estadoFormulario!=='criado'&&['novo','cumprir-exigencia','indeferidos'].includes(_this.props.acao)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:_this.dependentePossuiExigenciaExclusao(dependente)?'dtp-inverse':null,hint:'Excluir dependente',icon:'ico-user-minus',mini:true,onClick:function onClick(){return _this.deleteDependente(indice,dependente);}}):'');};_this.dependentePossuiExigencia=function(indice,dependente){// Vinicius
if(['cumprir-exigencia'].includes(_this.props.acao)){if(_this.props.exigencias){return _this.props.exigencias.filter(function(exigencia){if(dependente.codigo){return exigencia.tipo!==11&&exigencia.codigoDependente===dependente.codigo;}return false;}).length>0||(// Vinicius
// }).length > 0 && this.props.acao !== 'realizar-analise') ||
_this.props.errosDependentes?_this.props.errosDependentes.some(function(erro){return erro.indiceLista===indice;}):false);}}return false;};_this.dependentePossuiExigenciaExclusao=function(dependente){// Vinicius
if(['cumprir-exigencia'].includes(_this.props.acao)){if(_this.props.exigencias){return _this.props.exigencias.filter(function(exigencia){return exigencia.tipo===11&&exigencia.codigoDependente===dependente.codigo;}).length>0&&_this.props.acao!=='realizar-analise';}}return false;};_this.dependentePossuiExigenciaInclusao=function(){// Vinicius
if(['cumprir-exigencia'].includes(_this.props.acao)){if(_this.props.exigencias){return _this.props.exigencias.filter(function(exigencia){return exigencia.tipo===10;}).length>0;}}return false;};_this.montaDependentesTableHeader=function(){var tableHeader=[{id:'nome',label:'Nome'},{id:'vinculo',label:'Vínculo',dataFormat:_this.addVinculoLabel}];if(['realizar-analise','cumprir-exigencia','consulta'].includes(_this.props.acao)){if(_this.props.solicitante&&_this.props.solicitante.codigo==='01000'){tableHeader.push({id:'numeroBeneficioPensao',label:'Número do Benefício'});}}else if(['novo'].includes(_this.props.acao)){if(_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp'])){tableHeader.push({id:'numeroBeneficioPensao',label:'Número do Benefício'});}}tableHeader.push({id:'dataCessacao',label:'Data de Cessação'});if(_this.props.acao!=='novo'){tableHeader.push({id:'invalidezDeAcordoMedico',label:'Resultado do Parecer Médico',dataFormat:_this.formatResultadoPericia});}tableHeader.push({id:'acoes',label:null,dataFormat:_this.createActionColumn});return tableHeader;};_this.options={insertBtn:_this.createCustomInsertButton,noDataText:'Nenhum dependente foi adicionado à lista'};_this.addDependente=function(dependente,edit){var _this$props=Object.assign({},_this.props),dependentes=_this$props.dependentes;if(edit){dependentes[_this.state.cell]=Object.assign({},dependente);}else{dependentes.push(dependente);}_this.alteraListaDependentes(dependentes,null);};_this.editDependente=function(indice,dependenteSelecionado){var exigenciasDependenteSelecionado=[];var errosDependenteSelecionado=null;if(_this.props.exigencias&&!_this.props.isFetchExigencias){_this.props.exigencias.forEach(function(exigencia){if(exigencia.codigoDependente===dependenteSelecionado.codigo){exigenciasDependenteSelecionado.push(exigencia);}});}if(_this.state.exigenciasDependentes){_this.state.exigenciasDependentes.forEach(function(exigencia){if(exigencia.codigoDependente===dependenteSelecionado.codigo){exigenciasDependenteSelecionado.push(exigencia);}});}if(_this.props.errosDependentes){errosDependenteSelecionado=_this.props.errosDependentes.filter(function(erro){return erro.indiceLista===indice;});}_this.setState({cell:indice,dependenteSelecionado:dependenteSelecionado,exigenciasDependenteSelecionado:exigenciasDependenteSelecionado,errosDependenteSelecionado:errosDependenteSelecionado},_this.handleModal);};_this.deleteDependente=function(row,dependenteSelecionado){var _this$props2=Object.assign({},_this.props),dependentes=_this$props2.dependentes;var errosDependente=null;if(_this.props.errosDependentes){errosDependente=_this.props.errosDependentes.filter(function(erro){return erro.indiceLista!==row;});}_this.props.exigencias.forEach(function(exigencia){if(exigencia.codigoDependente===dependenteSelecionado.codigo&&(exigencia.tipo===12||exigencia.tipo===13||exigencia.tipo===14||exigencia.tipo===15||exigencia.tipo===16||exigencia.tipo===17)){// eslint-disable-next-line
exigencia.atendida=1;}});dependentes.splice(row,1);_this.alteraListaDependentes(dependentes,errosDependente);};_this.alteraListaDependentes=function(listaDependentes,errosDependente){if(errosDependente){_this.props.validacaoErrosDependentes(errosDependente,true);}_this.props.handleChange({value:listaDependentes,isValid:listaDependentes.length>0});};_this.verificarSeDependenteVeioDoRequest=function(){return _this.state.dependenteSelecionado?_this.state.dependenteSelecionado.codigo!==null&&_this.state.dependenteSelecionado.codigo!==undefined:false;};_this.resetDependenteSelecionado=function(){_this.setState({dependenteSelecionado:null,acaoModal:null,errosDependenteSelecionado:null});};_this.formatResultadoPericia=function(invalidezDeAcordoMedico){if(invalidezDeAcordoMedico===true){return'Inválido';}if(invalidezDeAcordoMedico===false){return'Válido';}return'';};var initialState=_this.getInitialState();_this.state=initialState;return _this;}/**
   * Identifica dependentes a ter parecer emitido:
   *  - capacidades: INVALIDO_INCAPAZ, INVALIDO_CAPAZ
   *//**
   * Determina a acao que estara disponivel para cada dependente:
   * - Usuario esta criando um requerimento ou cumprindo exigencias, dependente pode ser alterado;
   * - Usuario esta emitindo parecer, dependente pode ser alterado se tiver a Capacidade adequada;
   * - Em outras situacoes, o dependente pode apenas ser visualizado.
   *//**
   * Determina quais colunas devem ser exibidas na tabela de dependentes
   *//**
   * Adiciona dependente a lista
   *//**
   * Altera um dependente da lista
   *//**
   * Exclui um dependente da lista
   *//**
   * Verifica se dependente original do requerimento
   *//**
   * Remove a selecao do dependente
   */// Formata indicador da pericia realizada
_createClass(Dependentes,[{key:'render',value:function render(){var listaDependentesIndexada=this.props.dependentes.map(function(item,i){var itemIndexado=item;itemIndexado.acoes=i;return itemIndexado;});var modalDependente=this.state.showModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Dependente__["a" /* default */],{acaoModal:this.state.acaoModal,acao:this.props.acao,addDependente:this.addDependente,dependente:this.state.dependenteSelecionado,errosDependente:this.state.errosDependenteSelecionado,exigencias:this.state.exigenciasDependenteSelecionado,validacaoErrosDependentes:this.props.validacaoErrosDependentes,validacaoExigenciaDependente:this.validacaoExigenciaDependente,onHide:this.handleModal,resetDependente:this.resetDependenteSelecionado,showModal:true}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["e" /* DataGrid */],{title:'Dependentes',icon:'ico-users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["u" /* Table */],{bordered:true,data:listaDependentesIndexada,insertRow:this.props.estadoFormulario!=='criado'&&['novo','cumprir-exigencia','indeferidos'].includes(this.props.acao),options:this.options,listaTableHeader:this.montaDependentesTableHeader()}),modalDependente);}}]);return Dependentes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Dependentes.propTypes={acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,dependentes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({codigo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,cpfDependente:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nomeMae:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataNascimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.date,sexo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,estadoCivil:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,vinculo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,capacidade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,motivoInclusao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,invalidezDeAcordoMedico:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,numeroBeneficioPensao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,dataCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,solicitante:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,exigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({codigo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,comentario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,atributo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoDocumento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,codigoDependente:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,errosDependentes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,validacaoErrosDependentes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isFetchExigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,checkIsFetchExigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Dependentes);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var camposCnis=['nome','dataNascimento','sexo','nomeMae'];var Dependente=function(_Component){_inherits(Dependente,_Component);_createClass(Dependente,null,[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){var _state=Object.assign({},state),validadeCampos=_state.validadeCampos;if(props.dependente&&!state.didProps){if(props.acao==='cumprir-exigencia'&&props.exigencias){if(props.exigencias.some(function(exigencia){return exigencia.tipo!==11;})){props.exigencias.forEach(function(item){validadeCampos[item.atributo]=false;});return{dependente:Object.assign({},props.dependente),touched:true,validadeCampos:validadeCampos,didProps:true,exigenciasDependente:props.exigencias};}}if(props.errosDependente){props.errosDependente.forEach(function(item){if(item.atributo){validadeCampos[item.atributo]=false;}});return{dependente:Object.assign({},props.dependente),validadeCampos:validadeCampos,errosDependente:props.errosDependente,touched:true,didProps:true};}return{dependente:Object.assign({},props.dependente),dependenteVindoDoProps:Object.assign({},props.dependente),touched:true,didProps:true};}return null;}}]);function Dependente(props){_classCallCheck(this,Dependente);var _this=_possibleConstructorReturn(this,(Dependente.__proto__||Object.getPrototypeOf(Dependente)).call(this));_this.getInitialState=function(){var initialState={dependente:{cpfDependente:null,nome:null,nomeMae:null,dataNascimento:null,sexo:null,estadoCivil:null,vinculo:null,capacidade:null,motivoInclusao:null,invalidezDeAcordoMedico:null},touched:false,validadeCampos:{cpfDependente:false,nome:false,nomeMae:false,dataNascimento:false,sexo:false,estadoCivil:false,vinculo:false,capacidade:false},didUpdate:false,didProps:false,exigenciasDependente:null,errosDependente:null,estadoFormulario:'inicial',dependenteVindoDoProps:null};return initialState;};_this.verificaCumprimentoExigencia=function(){if(_this.state.exigenciasDependente){var exigenciaCumprida=false;var houveAlteracao=false;_this.state.exigenciasDependente.forEach(function(item){if(item.atributo){if(item.atributo in _this.state.validadeCampos&&_this.state.validadeCampos[item.atributo]){exigenciaCumprida=true;}}});if(exigenciaCumprida){houveAlteracao=exigenciaCumprida;}else{houveAlteracao=_this.verificaAlteracaoCamposDependente();var _this$state=Object.assign({},_this.state),requestPesquisa=_this$state.requestPesquisa;var alterouPeloBotaoPesquisar=requestPesquisa;if(alterouPeloBotaoPesquisar){return true;}if(houveAlteracao){_this.state.requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo&&exigencia.atendida===0){if(paramAtributo in _this.state.validadeCampos){_this.state.validadeCampos[paramAtributo]=!_this.state.validadeCampos[paramAtributo];}}});houveAlteracao=Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);_this.state.requerimento.exigencias.forEach(function(exigencia){var paramAtributo=exigencia.atributo;if(paramAtributo&&exigencia.atendida===0){if(paramAtributo in _this.state.validadeCampos){_this.state.validadeCampos[paramAtributo]=!_this.state.validadeCampos[paramAtributo];}}});}}return houveAlteracao;}return Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);};_this.formularioProntoParaEnvio=function(){var _this$props=Object.assign({},_this.props),acao=_this$props.acao;var _this$state2=Object.assign({},_this.state),estadoFormulario=_this$state2.estadoFormulario;switch(acao){case'novo':{if(estadoFormulario==='inicial'){return Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);}return estadoFormulario==='alterado';}case'cumprir-exigencia':return _this.verificaCumprimentoExigencia();case'realizar-analise':return false;case'indeferidos':return Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);case'emitir-parecer-medico':return Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);default:return false;}};_this.resetState=function(){_this.setState(_this.getInitialState());_this.props.onHide();_this.props.resetDependente();};_this.handleButton=function(){var touched=true;_this.setState(Object.assign({},_this.state,{touched:touched}),_this.handleEnviar);};_this.handleEnviar=function(){_this.props.addDependente(_this.state.dependente,_this.props.dependente);if(_this.state.exigenciasDependente){_this.props.validacaoExigenciaDependente(_this.state.exigenciasDependente);}if(_this.state.errosDependente){_this.props.validacaoErrosDependentes(_this.state.errosDependente);}_this.resetState();};_this.handleChange=function(changeObj,name){var _this$props2=Object.assign({},_this.props),acao=_this$props2.acao;var _this$state3=Object.assign({},_this.state),estadoFormulario=_this$state3.estadoFormulario;if(acao==='cumprir-exigencia'){estadoFormulario='alterado';}else if(acao==='novo'&&_this.state.errosDependente&&_this.state.errosDependente.length>=1){estadoFormulario='alterado';}_this.setState({dependente:Object.assign({},_this.state.dependente,_defineProperty({},name,changeObj.value)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid)),estadoFormulario:estadoFormulario});};_this.trataSucessoResponsePesquisa=function(response){var _this$state4=Object.assign({},_this.state),validadeCampos=_this$state4.validadeCampos;delete response.data.nit;camposCnis.forEach(function(key){validadeCampos[key]=true;});_this.setState({dependente:Object.assign({},_this.state.dependente,response.data),validadeCampos:validadeCampos,touched:true});};_this.trataErrosResponse=function(){var _this$state5=Object.assign({},_this.state),validadeCampos=_this$state5.validadeCampos;var _this$state6=Object.assign({},_this.state),dependente=_this$state6.dependente;camposCnis.forEach(function(key){validadeCampos[key]=false;dependente[key]='';});_this.setState({dependente:Object.assign({},_this.state.dependente,{dependente:dependente}),validadeCampos:validadeCampos});};_this.handleSearch=function(){if(_this.state.validadeCampos.cpfDependente){var _this$state$dependent=Object.assign({},_this.state.dependente),cpfDependente=_this$state$dependent.cpfDependente;_this.setState({requestPesquisa:true},Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["e" /* doGet */])('pessoas-fisicas/'+cpfDependente,_this.trataSucessoResponsePesquisa,_this.trataErrosResponse));}};_this.desabilitaInput=function(listaAcoesEditaveis){if(_this.props.consulta){return true;}return!listaAcoesEditaveis.includes(_this.props.acaoModal);};_this.determinaTitulo=function(){var titulo=void 0;switch(_this.props.acaoModal){case'pericia-medica':titulo='Parecer médico para o dependente';break;case'em-analise':titulo='Dependente';break;case'edicao':titulo='Edição de dependente';break;default:titulo='Inclusão de Dependente';}return titulo;};_this.verificaAlteracaoCamposDependente=function(){var _this$state7=Object.assign({},_this.state),dependente=_this$state7.dependente;var _this$state8=Object.assign({},_this.state),dependenteVindoDoProps=_this$state8.dependenteVindoDoProps;var depOriginal=dependenteVindoDoProps;var depAtual=dependente;var houveAlteracao=false;if(depOriginal!==null){if(depAtual.cpfDependente!==undefined){if(depOriginal.cpfDependente===undefined&&depAtual.cpfDependente!==null||depOriginal.cpfDependente!==depAtual.cpfDependente){houveAlteracao=true;}}if(depAtual.nome!==undefined){if(depOriginal.nome&&depOriginal.nome!==depAtual.nome&&depAtual.nome!==null){houveAlteracao=true;}}if(depAtual.nomeMae!==undefined){if(depOriginal.nomeMae&&depOriginal.nomeMae!==depAtual.nomeMae&&depAtual.nome!==null){houveAlteracao=true;}}if(depAtual.dataNascimento!==undefined){if(depOriginal.dataNascimento&&depOriginal.dataNascimento!==depAtual.dataNascimento&&depAtual.dataNascimento!==null){houveAlteracao=true;}}if(depAtual.sexo!==undefined){if(depOriginal.sexo&&depOriginal.sexo!==depAtual.sexo&&depAtual.sexo!==null){houveAlteracao=true;}}if(depAtual.estadoCivil!==undefined){if(depOriginal.estadoCivil&&depOriginal.estadoCivil!==depAtual.estadoCivil&&depAtual.estadoCivil!==null){houveAlteracao=true;}}if(depAtual.vinculo!==undefined){if(depOriginal.vinculo&&depOriginal.vinculo!==depAtual.vinculo&&depAtual.vinculo!==null){houveAlteracao=true;}}if(depAtual.capacidade!==undefined){if(depOriginal.capacidade&&depOriginal.capacidade!==depAtual.capacidade&&depAtual.capacidade!==null){houveAlteracao=true;}}if(depAtual.motivoInclusao!==undefined){if(depOriginal.motivoInclusao===undefined&&depAtual.motivoInclusao!==null||depOriginal.motivoInclusao!==depAtual.motivoInclusao){houveAlteracao=true;}}}return houveAlteracao;};var state=_this.getInitialState();if(props.dependente){var _state2=Object.assign({},state),validadeCampos=_state2.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});state.validadeCampos=validadeCampos;}_this.state=state;return _this;}// Para cada Input, sinalizar as acoes em que o mesmo pode ser alterado
// Escolhe o titulo do modal baseado na acao
_createClass(Dependente,[{key:'render',value:function render(){var _this2=this;var inputInvalidezMedico=void 0;var modalFooter=void 0;var pesquisar=void 0;// let consulta;
if(this.props.acaoModal==='pericia-medica'){inputInvalidezMedico=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['fornecer-parecer-medico-rpps']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'\xC9 dependente inv\xE1lido na data da concess\xE3o do benef\xEDcio?',value:this.state.dependente.invalidezDeAcordoMedico,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["t" /* parecerMedico */],onChange:function onChange(e){return _this2.handleChange(e,'invalidezDeAcordoMedico');},placeholder:'Selecione a op\xE7\xE3o'}))));}if((this.props.acaoModal==='criacao'||this.props.acaoModal==='edicao'||this.props.acaoModal==='indeferidos')&&!this.props.consulta){pesquisar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{title:'Pesquisar',onClick:function onClick(){return _this2.handleSearch();},hint:'Pesquisar dados pessoais'});}var modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'370px','overflow-y':'auto','overflow-x':'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.desabilitaInput(['criacao','edicao','indeferidos']),error:!this.state.validadeCampos.cpfDependente,cpf:true,integer:true,label:'CPF',onChange:function onChange(e){return _this2.handleChange(e,'cpfDependente');},required:true,mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].cpf,showMask:true,touched:this.state.touched,value:this.state.dependente.cpfDependente})),pesquisar,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.desabilitaInput(['criacao']),label:'Nome',maxLength:'60',error:!this.state.validadeCampos.nome,value:this.state.dependente.nome,onChange:function onChange(e){return _this2.handleChange(e,'nome');},touched:this.state.touched,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.desabilitaInput(['criacao','edicao','indeferidos']),label:'Nome da M\xE3e',maxLength:'60',error:!this.state.validadeCampos.nomeMae,value:this.state.dependente.nomeMae,onChange:function onChange(e){return _this2.handleChange(e,'nomeMae');},touched:this.state.touched,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.desabilitaInput(['criacao']),label:'Data de Nascimento',mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].date,error:!this.state.validadeCampos.dataNascimento,value:this.state.dependente.dataNascimento,onChange:function onChange(e){return _this2.handleChange(e,'dataNascimento');},touched:this.state.touched,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.desabilitaInput(['criacao','edicao','indeferidos']),label:'Sexo',error:!this.state.validadeCampos.sexo,value:this.state.dependente.sexo,number:true,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["z" /* sexo */],onChange:function onChange(e){return _this2.handleChange(e,'sexo');},touched:this.state.touched,placeholder:'Selecione o sexo',required:true,custom:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.desabilitaInput(['criacao','edicao','indeferidos']),label:'Estado Civil',error:!this.state.validadeCampos.estadoCivil,value:this.state.dependente.estadoCivil,number:true,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["c" /* estadoCivil */],onChange:function onChange(e){return _this2.handleChange(e,'estadoCivil');},touched:this.state.touched,placeholder:'Selecione o estado civil',required:true,custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.desabilitaInput(['criacao','edicao','indeferidos']),label:'V\xEDnculo',error:!this.state.validadeCampos.vinculo,value:this.state.dependente.vinculo,number:true,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["W" /* vinculo */],onChange:function onChange(e){return _this2.handleChange(e,'vinculo');},touched:this.state.touched,placeholder:'Selecione o v\xEDnculo',required:true,custom:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.desabilitaInput(['criacao','edicao','indeferidos']),label:'Capacidade',error:!this.state.validadeCampos.capacidade,value:this.state.dependente.capacidade,number:true,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["a" /* capacidade */],onChange:function onChange(e){return _this2.handleChange(e,'capacidade');},touched:this.state.touched,placeholder:'Selecione a capacidade',required:true,custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.desabilitaInput(['criacao','edicao','indeferidos']),label:'Motivo de Inclus\xE3o',value:this.state.dependente.motivoInclusao,number:true,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["p" /* motivoInclusao */],onChange:function onChange(e){return _this2.handleChange(e,'motivoInclusao');},placeholder:'Selecione o motivo de inclus\xE3o',custom:true}))),inputInvalidezMedico));// Existe footer sempre que a acao do modal nao for analisar
if(!['em-analise'].includes(this.props.acaoModal)&&!this.props.consulta){modalFooter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{title:'Cancelar',onClick:this.resetState,hint:'Cancelar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!this.formularioProntoParaEnvio(),title:this.props.dependente?'Salvar':'Adicionar',onClick:this.handleButton,hint:this.props.dependente?'Salvar dependente':'Adicionar dependente'})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:modalContent,conteudofooter:modalFooter,onHide:this.resetState,showTitle:true,size:'lg',title:this.determinaTitulo()}));}}]);return Dependente;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Dependente.propTypes={acaoModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['criacao','edicao','em-analise','pericia-medica']),onHide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,consulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (Dependente);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DadosCessacaoAposentadoria__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DadosCessacaoPensao__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__requerimentos_ModalAlerta__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RequerimentoCessacao=function(_Component){_inherits(RequerimentoCessacao,_Component);function RequerimentoCessacao(props,context){_classCallCheck(this,RequerimentoCessacao);var _this=_possibleConstructorReturn(this,(RequerimentoCessacao.__proto__||Object.getPrototypeOf(RequerimentoCessacao)).call(this,props,context));_this.getInitialState=function(){return{requerimento:{numeroBeneficio:null,matricula:null,nome:null,dataCessacaoBeneficio:null,descricaoMotivoCessacao:null,dataInicioBeneficio:null,motivoCessacao:null,fonteCessacao:null,dependentes:[],tipoRequerimento:null},touched:false,listaMotivosCessacao:[],listaDependentesCessando:[],listaMotivosPensaoInativa:[{value:22,label:'Pensão sem dependentes ativos'}],validadeCampos:{motivoCessacao:false,dataCessacaoBeneficio:false,descricaoMotivoCessacao:false},acao:'cessar-requerimento',estadoFormulario:'inicial',showNoContent:false,noContentPrimaryMessage:'Requerimento não encontrado para o protocolo informado.',noContentSecondaryMessage:'Informe um protocolo válido.',requestPesquisa:null,showModalAlerta:false,chaveConfirmacao:null};};_this.montaListaMotivosDisponiveis=function(){var listaMotivos=[];_this.props.motivosCessacaoRequerimentoAposentadoria.forEach(function(motivo){if(_this.state.requerimento.tipoAposentadoria!==3){if(motivo.value!==24){listaMotivos.push({value:motivo.value,label:motivo.label});}}else{listaMotivos=_this.props.motivosCessacaoRequerimento;}});_this.setState({listaMotivosCessacao:listaMotivos});};_this.handleErrorBusca=function(){var mensagemPrimaria='Não foi possível consultar o motivo da cessação da aposentadoria.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({mostraPaginaSemConteudo:true,mensagemPrincipalSemConteudo:mensagemPrimaria,mensagemSecundariaSemConteudo:mensagemSecundaria});};_this.buscaMotivosCessacaoRequerimentoAposentadoria=function(tipo,tipoMotivo,tipoBeneficio){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["w" /* requestMotivosCessacaoRequerimentoAposentadoria */])(_this.handleErrorBusca,tipo,tipoMotivo,tipoBeneficio);};_this.buscaMotivosCessacaoRequerimentoPensao=function(tipo,tipoMotivo){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["x" /* requestMotivosCessacaoRequerimentoPensao */])(_this.handleErrorBusca,tipo,tipoMotivo);};_this.montaFormulario=function(){var paramAcao=_this.props.match.params.acao;_this.setState({paramAcao:paramAcao},_this.buscaRequerimento);};_this.handleSuccessBuscaRequerimento=function(response){// 3 é o TE_MOTIVO_REQUERIMENTO da tabela MOTIVOS_REQUERIMENTO
// que equivale ao tipo do motivo (tipoMotivo)
var tipoMotivo=3;var aplicacao=Number(_this.props.match.params.tipoRequerimento);_this.setState({requerimento:Object.assign({},_this.state.requerimento,response.data)});var paramTipoBeneficio=_this.state.requerimento.tipoBeneficio;var _this$state=Object.assign({},_this.state),validadeCampos=_this$state.validadeCampos;if(_this.state.requerimento.dataCessacaoBeneficio){validadeCampos.dataCessacaoBeneficio=true;}if(Number(_this.props.match.params.tipoRequerimento)===1){_this.setState(_this.buscaMotivosCessacaoRequerimentoAposentadoria(aplicacao,tipoMotivo,paramTipoBeneficio));_this.montaListaMotivosDisponiveis();}else{_this.setState(_this.buscaMotivosCessacaoRequerimentoPensao(aplicacao,tipoMotivo));}};_this.buscaRequerimento=function(){var metodoSucesso=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.handleSuccessBuscaRequerimento;var tipo='pensao';if(Number(_this.props.match.params.tipoRequerimento)===1){tipo='aposentadoria';}var url='requerimentos-cessacao-'+tipo+'/'+_this.props.match.params.protocolo;Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])(url,metodoSucesso,_this.handleErrorBuscaRequerimento);};_this.handleErrorBuscaRequerimento=function(error){var mensagemPrimaria='Não foi possível consultar o requerimento.';var mensagemSecundaria='Contate o administrador do sistema.';if(error){if(error.status){if(error.status===404){mensagemPrimaria='Requerimento não encontrado para o protocolo informado.';mensagemSecundaria='Informe um protocolo válido.';}}}_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.trataSucessoResponsePesquisa=function(response){_this.setState({requerimento:Object.assign({},response.data),requestPesquisa:null});};_this.verificaNumDepACessar=function(dependentes){var contador=0;if(dependentes){dependentes.forEach(function(dependente){if(dependente.cessando){contador+=1;}});}return contador;};_this.verificaUltimo=function(dependentes){var contador=0;if(dependentes){dependentes.forEach(function(dependente){if(dependente.cessando||dependente.foiCessado){contador+=1;}});}return contador;};_this.addSemDepAtivosLabel=function(motivo){var obj=Object(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["v" /* pensaoSemDependentesAtivos */],motivo);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};_this.formularioProntoParaEnvio=function(tipoRequerimento){if(Number(tipoRequerimento)===2){var _this$state2=Object.assign({},_this.state),requerimento=_this$state2.requerimento;var numeroDependentesCessando=_this.verificaNumDepACessar(requerimento.dependentes);if(numeroDependentesCessando===0){_this.state.validadeCampos.dependentes=true;}else if(requerimento.dataCessacaoBeneficio===null&&requerimento.motivoCessacao===null){_this.state.validadeCampos.motivoCessacao=true;_this.state.validadeCampos.dataCessacaoBeneficio=true;_this.state.validadeCampos.descricaoMotivoCessacao=true;}else if(requerimento.dataCessacaoBeneficio===''&&requerimento.motivoCessacao===''){_this.state.validadeCampos.motivoCessacao=true;_this.state.validadeCampos.dataCessacaoBeneficio=true;_this.state.validadeCampos.descricaoMotivoCessacao=true;}if(requerimento.motivoCessacao===22){_this.state.validadeCampos.descricaoMotivoCessacao=true;}}else{_this.state.validadeCampos.dependentes=true;}return Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);};_this.handleChangeDependentes=function(changeObj,name){var _this$state3=Object.assign({},_this.state),requerimento=_this$state3.requerimento;var touched=true;var totalDependentesACessar=_this.verificaNumDepACessar(requerimento.dependentes);// pesquisar na lista a maior ordem e pegar a data de cessacao do dependente
var ordem=0;if(changeObj.listaDependentesCessando){changeObj.listaDependentesCessando.forEach(function(dependente){if(dependente.ordemCessacao){ordem=dependente.ordemCessacao;}if(ordem<dependente.ordemCessacao){ordem=dependente.ordemCessacao;}});}var indexDep=changeObj.listaDependentesCessando.findIndex(function(dep){return dep.ordemCessacao===ordem;});if(indexDep===-1){totalDependentesACessar=null;}if(totalDependentesACessar===requerimento.dependentes.length){_this.state.validadeCampos.dataCessacaoBeneficio=true;_this.state.validadeCampos.motivoCessacao=true;requerimento.motivoCessacao=22;var maiorDataCessacao=null;var maiorDataCessacaoString=null;requerimento.dependentes.forEach(function(dependente){if(maiorDataCessacao!=null&&dependente.dataCessacao!=null){var dataCessacaoDependente=__WEBPACK_IMPORTED_MODULE_3_moment___default()(dependente.dataCessacao,'DD/MM/YYYY').toDate();if(dataCessacaoDependente>maiorDataCessacao){maiorDataCessacao=__WEBPACK_IMPORTED_MODULE_3_moment___default()(dependente.dataCessacao,'DD/MM/YYYY').toDate();maiorDataCessacaoString=dependente.dataCessacao;}}else{maiorDataCessacao=__WEBPACK_IMPORTED_MODULE_3_moment___default()(dependente.dataCessacao,'DD/MM/YYYY').toDate();maiorDataCessacaoString=dependente.dataCessacao;}});// requerimento.dataCessacaoBeneficio =
// changeObj.listaDependentesCessando[indexDep].dataCessacao;
requerimento.dataCessacaoBeneficio=maiorDataCessacaoString;totalDependentesACessar=0;}if(requerimento.dependentes.length!==totalDependentesACessar){if(requerimento.dependentes[indexDep].cessando===false){requerimento.motivoCessacao=null;requerimento.dataCessacaoBeneficio=null;totalDependentesACessar=undefined;touched=false;var depPesquisa=requerimento.dependentes[indexDep].nome;var indexDepCancelado=changeObj.listaDependentesCessando.findIndex(function(pesquisa){return pesquisa.nome===depPesquisa;});if(indexDepCancelado!==-1){if(changeObj.listaDependentesCessando[indexDepCancelado].cessando===false){changeObj.listaDependentesCessando.splice(indexDepCancelado,1);}}}else{// verificar se tem mais alguem cessando ou cessado
var ultimo=_this.verificaUltimo(requerimento.dependentes);if(requerimento.dependentes.length===ultimo){_this.state.validadeCampos.dataCessacaoBeneficio=true;_this.state.validadeCampos.motivoCessacao=true;requerimento.motivoCessacao=22;var maiorDataCessacao1=null;var maiorDataCessacaoString1=null;requerimento.dependentes.forEach(function(dependente){if(maiorDataCessacao1!=null&&dependente.dataCessacao!=null){var dataCessacaoDependente1=__WEBPACK_IMPORTED_MODULE_3_moment___default()(dependente.dataCessacao,'DD/MM/YYYY').toDate();if(dataCessacaoDependente1>maiorDataCessacao1){maiorDataCessacao1=__WEBPACK_IMPORTED_MODULE_3_moment___default()(dependente.dataCessacao,'DD/MM/YYYY').toDate();maiorDataCessacaoString1=dependente.dataCessacao;}}else{maiorDataCessacao1=__WEBPACK_IMPORTED_MODULE_3_moment___default()(dependente.dataCessacao,'DD/MM/YYYY').toDate();maiorDataCessacaoString1=dependente.dataCessacao;}});// requerimento.dataCessacaoBeneficio =
// changeObj.listaDependentesCessando[indexDep].dataCessacao;
requerimento.dataCessacaoBeneficio=maiorDataCessacaoString1;totalDependentesACessar=0;}}}_this.setState({touched:touched,requerimento:Object.assign({},requerimento,_defineProperty({},name,changeObj.value)),totalDependentesACessar:totalDependentesACessar,listaDependentesCessando:changeObj.listaDependentesCessando,validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))});};_this.handleChange=function(changeObj,name){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;// const { acao } = { ...this.state };
var _this$state4=Object.assign({},_this.state),estadoFormulario=_this$state4.estadoFormulario;var _this$state5=Object.assign({},_this.state),requerimento=_this$state5.requerimento;if(name==='dataCessacaoBeneficio'){if(_this.state.dataCessacaoBeneficio&&_this.state.validadeCampos.dependentes===false){estadoFormulario='cessacao-requerimento';}}if(name==='motivoCessacao'){var descricao=_this.state.descricaoMotivoCessacao;if((changeObj.value===33||changeObj.value===34||changeObj.value===35||changeObj.value===36)&&descricao===undefined){_this.state.validadeCampos.descricaoMotivoCessacao=false;}else{_this.state.validadeCampos.descricaoMotivoCessacao=true;}}_this.setState({requerimento:Object.assign({},requerimento,_defineProperty({},name,changeObj.value)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid)),estadoFormulario:estadoFormulario},callback);};_this.diffRequerimento=function(tipoRequerimento){if(tipoRequerimento===2){return'pensao';}return'aposentadoria';};_this.handleSaveButton=function(){var _this$state6=Object.assign({},_this.state),requerimento=_this$state6.requerimento;var tipo=Number(_this.props.match.params.tipoRequerimento);var mensagemConfirmacao='';if(tipo===1){mensagemConfirmacao=__WEBPACK_IMPORTED_MODULE_12__utils_constants__["o" /* msgsConfirmacaoCessacao */].cessacaoAposentadoria;_this.setState({alertas:[mensagemConfirmacao],showModalAlerta:!_this.state.showModalAlerta});}else{var numeroDependentesCessando=_this.verificaNumDepACessar(requerimento.dependentes);var todosDependentesCessados=false;var estaCessandoDependente=false;if(numeroDependentesCessando===requerimento.dependentes.length){todosDependentesCessados=true;}else if(numeroDependentesCessando!==0){estaCessandoDependente=true;// ver quem esta cessando
}// Quando cessa todos os dependentes, cessa o requerimento.
if(todosDependentesCessados){mensagemConfirmacao=__WEBPACK_IMPORTED_MODULE_12__utils_constants__["o" /* msgsConfirmacaoCessacao */].cessacaoPensao;}else if(estaCessandoDependente){mensagemConfirmacao=__WEBPACK_IMPORTED_MODULE_12__utils_constants__["o" /* msgsConfirmacaoCessacao */].cessacaoDependente;if(requerimento.dataCessacaoBeneficio!==null&&requerimento.dataCessacaoBeneficio!==''&&requerimento.motivoCessacao!==null&&requerimento.motivoCessacao!==''){mensagemConfirmacao=__WEBPACK_IMPORTED_MODULE_12__utils_constants__["o" /* msgsConfirmacaoCessacao */].cessacaoAmbos;}}else{mensagemConfirmacao=__WEBPACK_IMPORTED_MODULE_12__utils_constants__["o" /* msgsConfirmacaoCessacao */].cessacaoPensao;}_this.setState({alertas:[mensagemConfirmacao],showModalAlerta:!_this.state.showModalAlerta});}};_this.confirmSendDataAposentadoria=function(){var touched=true;var url='requerimentos-cessacao';var _this$state7=Object.assign({},_this.state),validadeCampos=_this$state7.validadeCampos;var _this$state8=Object.assign({},_this.state),requerimento=_this$state8.requerimento;/* Valida se o campo fonteCessacao esta nulo ou vazio */if(requerimento.fonteCessacao===null||requerimento.fonteCessacao===''){requerimento.fonteCessacao=0;}/* Valida se o campo fonteCessacao esta nulo ou vazio */if(requerimento.motivoCessacao===null||requerimento.motivoCessacao===''){requerimento.motivoCessacao=0;}Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});_this.setState({touched:touched,validadeCampos:validadeCampos,requerimento:requerimento},function(){return _this.handleSave(url,1);});};_this.confirmSendDataPensao=function(){var touched=true;var url='requerimentos-cessacao';var _this$state9=Object.assign({},_this.state),validadeCampos=_this$state9.validadeCampos;var _this$state10=Object.assign({},_this.state),requerimento=_this$state10.requerimento;/* Valida se o campo fonteCessacao esta nulo ou vazio */if(requerimento.fonteCessacao===null||requerimento.fonteCessacao===''){requerimento.fonteCessacao=0;}/* Valida se o campo fonteCessacao esta nulo ou vazio */if(requerimento.motivoCessacao===null||requerimento.motivoCessacao===''){requerimento.motivoCessacao=0;}Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});_this.setState({touched:touched,validadeCampos:validadeCampos,requerimento:Object.assign({},requerimento)},function(){return _this.handleSave(url,2);});};_this.handleSave=function(url,tipo){if(_this.formularioProntoParaEnvio(_this.props.match.params.tipoRequerimento)){// let options;
// if (this.state.chaveConfirmacao) {
//   options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
// }
var _this$state11=Object.assign({},_this.state),requerimento=_this$state11.requerimento;requerimento.tipoRequerimento=tipo;Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["n" /* doPut */])(url,requerimento,_this.trataSucessoResponseEnvio,_this.trataErrosResponse);}else{Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Informe corretamente os atributos indicados na tela.']);}};_this.trataSucessoResponseEnvio=function(){_this.trataSucesso();_this.props.history.goBack();};_this.trataSucesso=function(){var _this$state12=Object.assign({},_this.state),requerimento=_this$state12.requerimento;var mensagemSucesso='Requerimento Cessado.';var numeroDependentesCessando=_this.verificaNumDepACessar(requerimento.dependentes);var todosDependentesCessados=false;var estaCessandoDependente=false;if(numeroDependentesCessando===requerimento.dependentes.length){todosDependentesCessados=true;}else if(numeroDependentesCessando!==0){estaCessandoDependente=true;// ver quem esta cessando
}if(todosDependentesCessados){mensagemSucesso='Requerimento Cessado.';}else if(estaCessandoDependente){mensagemSucesso='Dependente Cessado';if(requerimento.dataCessacaoBeneficio!==null&&requerimento.dataCessacaoBeneficio!==''&&requerimento.motivoCessacao!==null&&requerimento.motivoCessacao!==''){mensagemSucesso='Requerimento Cessado.';}}else{mensagemSucesso='Requerimento Cessado.';}_this.setState({showCessacaoBeneficioModal:!_this.state.showCessacaoBeneficioModal});Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["J" /* trataMensagemSucesso */])([mensagemSucesso]);};_this.trataErrosResponse=function(error){if(error&&error.data){var _error=Object.assign({},error),data=_error.data;var _this$state13=Object.assign({},_this.state),requerimento=_this$state13.requerimento;var _this$state14=Object.assign({},_this.state),validadeCampos=_this$state14.validadeCampos;var touched=false;if(data.erros){var colecaoErro=data.erros;colecaoErro.forEach(function(erro){if(erro.codigo===1316||erro.codigo===1334||erro.codigo===1332||erro.codigo===1432){requerimento.dataCessacaoBeneficio=null;validadeCampos.dataCessacaoBeneficio=false;}if(requerimento.motivoCessacao===0||requerimento.motivoCessacao===22){requerimento.motivoCessacao=null;}});validadeCampos.dependentes=false;var listaDependentes=_this.state.requerimento.dependentes;if(listaDependentes){var listaDependentesAtualizada=listaDependentes.map(function(item,i){var itemIndexado=item;itemIndexado.acoes=i;if(itemIndexado.cessando){itemIndexado.foiCessado=false;itemIndexado.cessando=false;itemIndexado.dataCessacao=null;}return itemIndexado;});var totalDependentesACessar=undefined;requerimento.dependentes=listaDependentesAtualizada;_this.setState({requerimento:Object.assign({},requerimento),totalDependentesACessar:totalDependentesACessar,validadeCampos:Object.assign({},validadeCampos)});}}_this.setState({chaveConfirmacao:data.chaveConfirmacao,alertas:data.alertas,showModalAlerta:!_this.state.showModalAlerta,touched:touched});}};_this.formularioRequerimentoAposentadoria=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DadosCessacaoAposentadoria__["a" /* default */],{acao:_this.state.acao,auth:_this.props.auth,estadoFormulario:_this.state,handleChange:_this.handleChange,match:_this.props.match,motivosCessacaoRequerimento:_this.props.motivosCessacaoRequerimentoAposentadoria});};_this.formularioRequerimentoPensao=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DadosCessacaoPensao__["a" /* default */],{acao:_this.state.acao,auth:_this.props.auth,estadoFormulario:_this.state,handleChange:_this.handleChange,handleChangeDependentes:_this.handleChangeDependentes,match:_this.props.match,motivosCessacaoRequerimento:_this.props.motivosCessacaoRequerimentoPensao,dependentes:_this.state.requerimento.dependentes,addSemDepAtivosLabel:_this.addSemDepAtivosLabel});};_this.handleFechamentoModalAlerta=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta});};_this.state=_this.getInitialState();return _this;}_createClass(RequerimentoCessacao,[{key:'componentDidMount',value:function componentDidMount(){this.montaFormulario();}/**
   * Trata envio dos dados
   *//**
   * Trata as acoes dos botao Salvar "Criar Valor medio Beneficio"
   *//**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */},{key:'render',value:function render(){var modalAlerta=void 0;if(this.state.showModalAlerta){var tipo=Number(this.props.match.params.tipoRequerimento);if(tipo===1){modalAlerta=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__requerimentos_ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.confirmSendDataAposentadoria,handleModal:this.handleFechamentoModalAlerta,showModal:true});}else{modalAlerta=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__requerimentos_ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.confirmSendDataPensao,handleModal:this.handleFechamentoModalAlerta,showModal:true});}}var botaoAcaoVoltar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{className:'left',onClick:this.props.history.goBack,title:'Voltar',hint:'Voltar para tela anterior'});var botaoAcaoPrincipal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['requerer-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rgps','analisar-compensacao-rpps','analisar-negocio-sprev','gerenciar-negocio-dcomp']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(this.props.match.params.tipoRequerimento),title:'Salvar',onClick:this.handleSaveButton,hint:'Cessar requerimento'}));var retorno=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["j" /* DtpContentContainer */],null,this.props.match.params.tipoRequerimento==='1'?this.formularioRequerimentoAposentadoria():this.formularioRequerimentoPensao(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},botaoAcaoVoltar,botaoAcaoPrincipal),modalAlerta);return retorno;}}]);return RequerimentoCessacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RequerimentoCessacao.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.function}).isRequired,motivosCessacaoRequerimentoAposentadoria:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),motivosCessacaoRequerimentoPensao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;RequerimentoCessacao.defaultProps={match:null,auth:null,motivosCessacaoRequerimentoAposentadoria:null,motivosCessacaoRequerimentoPensao:null};var mapStateToProps=function mapStateToProps(state){return{motivosCessacaoRequerimentoAposentadoria:state.base.motivosCessacaoRequerimentoAposentadoria,motivosCessacaoRequerimentoPensao:state.base.motivosCessacaoRequerimentoPensao};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(RequerimentoCessacao));// export default RequerimentoCessacao;

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DependentesCessacao__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SolicitanteDestinatario__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DadosCessacaoAposentadoria__ = __webpack_require__(214);
var DadosCessacaoPensao=function DadosCessacaoPensao(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SolicitanteDestinatario__["a" /* default */],{requerimento:props.estadoFormulario.requerimento}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["e" /* DataGrid */],{title:'Dados do Requerimento de Pens\xE3o',icon:'ico-money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},props.estadoFormulario.requerimento.numeroBeneficio?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'NB',value:props.estadoFormulario.requerimento.numeroBeneficio})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Matr\xEDcula Regime Instituidor',value:props.estadoFormulario.requerimento.matricula}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Nome',value:props.estadoFormulario.requerimento.nome}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Data de In\xEDcio de Benef\xEDcio',value:props.estadoFormulario.requerimento.dataInicioBeneficio}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:props.estadoFormulario.desabilitarFormulario||props.estadoFormulario.totalDependentesACessar===0,label:'Motivo da Cessa\xE7\xE3o',error:!props.estadoFormulario.validadeCampos.motivoCessacao,touched:props.estadoFormulario.touched,placeholder:'Selecione o motivo da cessa\xE7\xE3o',onChange:function onChange(e){return props.handleChange(e,'motivoCessacao');},value:props.estadoFormulario.requerimento.motivoCessacao,itemList:props.estadoFormulario.totalDependentesACessar===0?props.estadoFormulario.listaMotivosPensaoInativa:Object(__WEBPACK_IMPORTED_MODULE_7__DadosCessacaoAposentadoria__["b" /* filterMotivos */])(props.motivosCessacaoRequerimento,props.estadoFormulario.requerimento,'pensão'),number:true,required:true,custom:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:props.estadoFormulario.desabilitarFormulario,label:'Fonte da Cessa\xE7\xE3o',touched:props.estadoFormulario.touched,placeholder:'Selecione a fonte da cessa\xE7\xE3o',onChange:function onChange(e){return props.handleChange(e,'fonteCessacao');},value:props.estadoFormulario.requerimento.fonteCessacao,itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["m" /* fonteCessacaoPensao */],number:true,custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:props.estadoFormulario.desabilitarFormulario||props.estadoFormulario.totalDependentesACessar===0,label:'Data da Cessa\xE7\xE3o',error:!props.estadoFormulario.validadeCampos.dataCessacaoBeneficio,touched:props.estadoFormulario.touched,mask:__WEBPACK_IMPORTED_MODULE_2__utils_masks__["a" /* default */].date,onChange:function onChange(e){return props.handleChange(e,'dataCessacaoBeneficio');},value:props.estadoFormulario.requerimento.dataCessacaoBeneficio,required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:props.estadoFormulario.desabilitarFormulario,cols:'74',componentClass:'textarea',label:'Descri\xE7\xE3o do motivo da Cessa\xE7\xE3o',maxlength:'200',onChange:function onChange(e){return props.handleChange(e,'descricaoMotivoCessacao');},rows:'3',required:[34,36].includes(props.estadoFormulario.requerimento.motivoCessacao),value:props.estadoFormulario.requerimento.descricaoMotivoCessacao,textarea:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DependentesCessacao__["a" /* default */],{acao:props.acao,match:props.match,dependentes:props.estadoFormulario.requerimento.dependentes,estadoFormulario:props.estadoFormulario.estadoFormulario,handleChangeDependentes:function handleChangeDependentes(e){return props.handleChangeDependentes(e,'dependentes');}}));};DadosCessacaoPensao.propTypes={acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,motivosCessacaoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),// addSemDepAtivosLabel: PropTypes.func.isRequired,
handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChangeDependentes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})})};DadosCessacaoPensao.defaultProps={match:null,motivosCessacaoRequerimento:null};/* harmony default export */ __webpack_exports__["a"] = (DadosCessacaoPensao);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DependenteCessacao__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DependentesCessacao=function(_Component){_inherits(DependentesCessacao,_Component);function DependentesCessacao(){_classCallCheck(this,DependentesCessacao);var _this=_possibleConstructorReturn(this,(DependentesCessacao.__proto__||Object.getPrototypeOf(DependentesCessacao)).call(this));_this.getInitialState=function(){return{acaoModal:null,showModal:false,errosDependenteSelecionado:null,exigenciasDependentes:null,dependenteSelecionado:null,listaDependentesCessando:[]};};_this.handleModal=function(){_this.setState({showModal:!_this.state.showModal,acaoModal:'cessar-dependente'});};_this.addVinculoLabel=function(vinculoSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["W" /* vinculo */],vinculoSelecionado);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};_this.addSexoLabel=function(sexoSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["z" /* sexo */],sexoSelecionado);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};_this.addEstadoCivilLabel=function(estadoCivilSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["c" /* estadoCivil */],estadoCivilSelecionado);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};_this.addCapacidadeLabel=function(capacidadeSelecionada){var obj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["a" /* capacidade */],capacidadeSelecionada);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};_this.buscaMotivosCessacaoDependente=function(tipo,tipoMotivo){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["v" /* requestMotivosCessacaoDependente */])(_this.handleErrorBusca,tipo,tipoMotivo);};_this.handleErrorBusca=function(){};_this.createActionColumn=function(indice,dependente){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{className:dependente.cessando?'dtp-inverse':'',hint:dependente.dataCessacao?'Visualizar dependente':'Cessar dependente',icon:dependente.dataCessacao?'ico-user-magnifier':'ico-pencil',mini:true,onClick:function onClick(){return _this.editDependente(dependente);}}));};_this.editDependente=function(dependenteSelecionado){var tipoMotivo=3;var aplicacao=3;_this.setState(_this.buscaMotivosCessacaoDependente(aplicacao,tipoMotivo));_this.setState({cell:dependenteSelecionado.acoes,dependenteSelecionado:dependenteSelecionado},_this.handleModal);};_this.options={noDataText:'Nenhum dependente cadastrado',hideSizePerPage:true,sizePerPage:10};_this.montaDependentesTableHeader=function(){var tableHeader=[{id:'cpf',label:'CPF'},{id:'nome',label:'Nome'},{id:'sexo',label:'Sexo',dataFormat:_this.addSexoLabel},{id:'estadoCivil',label:'Estado Civil',dataFormat:_this.addEstadoCivilLabel},{id:'capacidade',label:'Capacidade',dataFormat:_this.addCapacidadeLabel},{id:'vinculo',label:'Vínculo',dataFormat:_this.addVinculoLabel},{id:'dataNascimento',label:'Data de Nascimento'},{id:'dataCessacao',label:'Data de Cessação'}];tableHeader.push({id:'acao',label:'Ação',dataFormat:_this.createActionColumn});return tableHeader;};_this.resetDependenteSelecionado=function(){_this.setState({dependenteSelecionado:null,acaoModal:null});};_this.cancelarCessacaoDependente=function(dependente){var _this$props=Object.assign({},_this.props),dependentes=_this$props.dependentes;var _this$state=Object.assign({},_this.state),listaDependentesCessando=_this$state.listaDependentesCessando;var indexDepCancelando=listaDependentesCessando.findIndex(function(dep){return dep.nome===dependente.nome;});if(indexDepCancelando!==-1){if(dependentes[_this.state.cell].dataCessacao===dependente.dataCessacao||dependente.dataCessacao===''){dependentes[_this.state.cell]=dependente;dependentes[_this.state.cell].ordemCessacao=0;}}if(listaDependentesCessando.length>0&&indexDepCancelando!==-1){_this.props.handleChangeDependentes({value:dependentes,isValid:dependentes.length>0,listaDependentesCessando:listaDependentesCessando});}};_this.cessarDependente=function(dependente){var _this$props2=Object.assign({},_this.props),dependentes=_this$props2.dependentes;var _this$state2=Object.assign({},_this.state),listaDependentesCessando=_this$state2.listaDependentesCessando;dependentes[_this.state.cell]=dependente;if(listaDependentesCessando.length===0){// primeiro item da colecao
dependentes[_this.state.cell].ordemCessacao=1;listaDependentesCessando.push(dependentes[_this.state.cell]);}else{var objNome=dependentes[_this.state.cell].nome;var indexDep=listaDependentesCessando.findIndex(function(dep){return dep.nome===objNome;});if(indexDep===-1){dependentes[_this.state.cell].ordemCessacao=listaDependentesCessando.length+1;listaDependentesCessando.push(dependentes[_this.state.cell]);}else{var ordemAntiga=listaDependentesCessando[indexDep].ordemCessacao;listaDependentesCessando.splice(indexDep,1);dependentes[_this.state.cell].ordemCessacao=listaDependentesCessando.length+(ordemAntiga+1);listaDependentesCessando.push(dependentes[_this.state.cell]);}}_this.props.handleChangeDependentes({value:dependentes,isValid:dependentes.length>0,listaDependentesCessando:listaDependentesCessando});};var initialState=_this.getInitialState();_this.state=initialState;return _this;}/**
     * Determina a acao que estara disponivel para cada dependente:
     * - Usuario esta criando um requerimento ou cumprindo exigencias, dependente pode ser alterado;
     * - Usuario esta emitindo parecer, dependente pode ser alterado se tiver a Capacidade adequada;
     * - Em outras situacoes, o dependente pode apenas ser visualizado.
     *//**
     * Altera um dependente da lista
     *//**
  * Remove a selecao do dependente
  */_createClass(DependentesCessacao,[{key:'render',value:function render(){var listaDependentesIndexada=this.props.dependentes.map(function(item,i){var itemIndexado=item;itemIndexado.acoes=i;if(!itemIndexado.foiCessado&&itemIndexado.dataCessacao&&itemIndexado.motivoCessacao){itemIndexado.cessando=true;}return itemIndexado;});var modalDependente=this.state.showModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DependenteCessacao__["a" /* default */],{acaoModal:this.state.acaoModal,acao:this.props.acao,dependente:this.state.dependenteSelecionado,motivosCessacaoDependente:this.props.motivosCessacaoDependente,onHide:this.handleModal,resetDependente:this.resetDependenteSelecionado,showModal:true,cessarDependente:this.cessarDependente,cancelarCessacaoDependente:this.cancelarCessacaoDependente}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["e" /* DataGrid */],{title:'Dependentes',icon:'ico-users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{bordered:true,data:listaDependentesIndexada,options:this.options,listaTableHeader:this.montaDependentesTableHeader(),pagination:true,scrollTop:'Top'}),modalDependente);}}]);return DependentesCessacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DependentesCessacao.propTypes={acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,handleChangeDependentes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,dependentes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({codigo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,cpfDependente:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nomeMae:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataNascimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.date,sexo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,estadoCivil:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,vinculo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,capacidade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,motivoInclusao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,invalidezDeAcordoMedico:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,dataCessacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.date})).isRequired,motivosCessacaoDependente:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})})};DependentesCessacao.defaultProps={match:null,motivosCessacaoDependente:null};var mapStateToProps=function mapStateToProps(state){return{motivosCessacaoDependente:state.base.motivosCessacaoDependente};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(DependentesCessacao));

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_masks__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DependenteCessacao=function(_Component){_inherits(DependenteCessacao,_Component);_createClass(DependenteCessacao,null,[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){var _state=Object.assign({},state),validadeCampos=_state.validadeCampos;var touched=false;if(props.dependente&&!state.didProps){if(props.errosDependente){props.errosDependente.forEach(function(item){validadeCampos[item.atributo]=false;});return{dependente:Object.assign({},props.dependente),validadeCampos:validadeCampos,errosDependente:props.errosDependente,touched:true,didProps:true};}// Object.keys(validadeCampos).forEach((key) => {
if(props.dependente.dataCessacao!==undefined&&props.dependente.motivoCessacao!==null){validadeCampos.motivoCessacao=true;touched=true;}if(props.dependente.dataCessacao!==undefined&&props.dependente.dataCessacao!==''){validadeCampos.dataCessacao=true;touched=true;}// }
// });
return{dependente:Object.assign({},props.dependente),touched:touched,didProps:true};}return null;}}]);function DependenteCessacao(){_classCallCheck(this,DependenteCessacao);var _this=_possibleConstructorReturn(this,(DependenteCessacao.__proto__||Object.getPrototypeOf(DependenteCessacao)).call(this));_this.getInitialState=function(){var initialState={dependente:{cpfDependente:null,nome:null,nomeMae:null,dataNascimento:null,sexo:null,estadoCivil:null,vinculo:null,capacidade:null,motivoInclusao:null,invalidezDeAcordoMedico:null,dataCessacao:null,motivoCessacao:null,cessando:null,foiCessado:null,ordemCessacao:null},touched:false,validadeCampos:{dataCessacao:false,motivoCessacao:false},didUpdate:false,didProps:false,estadoFormulario:'inicial'};return initialState;};_this.formularioProntoParaEnvio=function(){var _this$state=Object.assign({},_this.state),estadoFormulario=_this$state.estadoFormulario;if(estadoFormulario==='cessacao-dependente'){return Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);}return false;};_this.handleCancelar=function(){if(_this.state.dependente.dataCessacao===''||_this.state.dependente.motivoCessacao===''){_this.state.dependente.cessando=false;}_this.props.cancelarCessacaoDependente(_this.state.dependente);_this.resetState();};_this.resetState=function(){_this.setState(_this.getInitialState());_this.props.onHide();_this.props.resetDependente();};_this.handleButton=function(){var touched=true;_this.setState(Object.assign({},_this.state,{touched:touched}),_this.handleEnviar);};_this.handleEnviar=function(){var _this$state2=Object.assign({},_this.state),estadoFormulario=_this$state2.estadoFormulario;if(estadoFormulario==='cessacao-dependente'&&_this.state.dependente.dataCessacao&&_this.state.dependente.motivoCessacao){_this.state.dependente.cessando=true;_this.state.didUpdate=true;}_this.props.cessarDependente(_this.state.dependente);_this.resetState();};_this.handleChange=function(changeObj,name){var _this$state3=Object.assign({},_this.state),estadoFormulario=_this$state3.estadoFormulario;estadoFormulario='cessacao-dependente';_this.setState({dependente:Object.assign({},_this.state.dependente,_defineProperty({},name,changeObj.value)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid)),estadoFormulario:estadoFormulario});};_this.addVinculoLabel=function(vinculoSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["W" /* vinculo */],vinculoSelecionado);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};_this.addSexoLabel=function(sexoSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["z" /* sexo */],sexoSelecionado);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};_this.addEstadoCivilLabel=function(estadoCivilSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["c" /* estadoCivil */],estadoCivilSelecionado);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};_this.addCapacidadeLabel=function(capacidadeSelecionada){var obj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["a" /* capacidade */],capacidadeSelecionada);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};_this.addMotivoInclusaoLabel=function(motivoInclusaoSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["p" /* motivoInclusao */],motivoInclusaoSelecionado);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};_this.addMotivoCessacaoLabel=function(motivoCessacaoSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */])(_this.props.motivosCessacaoDependente,motivoCessacaoSelecionado);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};var state=_this.getInitialState();_this.state=state;return _this;}_createClass(DependenteCessacao,[{key:'render',value:function render(){var _this2=this;var modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:'400px','overflow-y':'auto','overflow-x':'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,cpf:true,label:'CPF',mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].cpf,showMask:true,value:this.state.dependente.cpfDependente}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Nome',maxLength:'60',value:this.state.dependente.nome}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Nome da M\xE3e',maxLength:'60',value:this.state.dependente.nomeMae})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Data de Nascimento',mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].date,value:this.state.dependente.dataNascimento})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Sexo',value:this.addSexoLabel(this.state.dependente.sexo),number:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Estado Civil',value:this.addEstadoCivilLabel(this.state.dependente.estadoCivil)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'V\xEDnculo',value:this.addVinculoLabel(this.state.dependente.vinculo),number:true,custom:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Capacidade',value:this.addCapacidadeLabel(this.state.dependente.capacidade),number:true,custom:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Motivo de Inclus\xE3o',value:this.addMotivoInclusaoLabel(this.state.dependente.motivoInclusao),number:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},this.state.dependente.foiCessado?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Motivo da Cessa\xE7\xE3o',value:this.addMotivoCessacaoLabel(this.state.dependente.motivoCessacao),custom:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.state.dependente.foiCessado,label:'Motivo da Cessa\xE7\xE3o',error:!this.state.validadeCampos.motivoCessacao,touched:this.state.touched,placeholder:'Selecione o motivo da cessa\xE7\xE3o',onChange:function onChange(e){return _this2.handleChange(e,'motivoCessacao');},value:this.state.dependente.motivoCessacao,itemList:this.props.motivosCessacaoDependente,number:true,required:true,custom:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.state.dependente.foiCessado,mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].date,error:!this.state.validadeCampos.dataCessacao,label:'Data da Cessa\xE7\xE3o',onChange:function onChange(e){return _this2.handleChange(e,'dataCessacao');},value:this.state.dependente.dataCessacao,touched:this.state.touched,required:true})))));var modalFooter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{title:'Fechar',onClick:this.handleCancelar,hint:'Fechar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!this.formularioProntoParaEnvio(),title:'Salvar',onClick:this.handleButton,hint:'Cessar dependente'})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:modalContent,conteudofooter:modalFooter,onHide:this.handleCancelar,showTitle:true,size:'lg',title:'Cessa\xE7\xE3o de Dependente'}));}}]);return DependenteCessacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DependenteCessacao.propTypes={acaoModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onHide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,consulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,motivosCessacaoDependente:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (DependenteCessacao);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Exigencia_ModalUploadDocumento__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Exigencia_ModalEncerramentoExigencia__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Exigencia_ModalRejeicaoRequerimento__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FiltroPesquisa__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_requerimentos_ModalAlerta__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var ConsultaExigencia=function(_Component){_inherits(ConsultaExigencia,_Component);function ConsultaExigencia(props){_classCallCheck(this,ConsultaExigencia);var _this=_possibleConstructorReturn(this,(ConsultaExigencia.__proto__||Object.getPrototypeOf(ConsultaExigencia)).call(this,props));_this.getTipoConsulta=function(){return _this.props.match.params.tipoConsulta;};_this.buscarTiposDocumentos=function(){Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["D" /* requestTiposDocumentos */])(_this.handleErrorBusca);};_this.preparaNovaConsulta=function(){sessionStorage.removeItem('filtroPesquisa');var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta);};_this.lotacao=_this.props.auth.userData.lotacoes[0];_this.addTipoRequerimentoLabel=function(value){var tipo=__WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["M" /* tipoRequerimento */].find(function(item){return String(item.value)===String(value);});return tipo?tipo.label:value;};_this.colunasDefault=[{id:'cpf',label:'CPF'},{id:'nome',label:'Nome'},{id:'matricula',label:'Matrícula'},{id:'nomeSolicitante',label:'Solicitante'},{id:'nomeDestinatario',label:'Destinatário'},{id:'tipoRequerimento',label:'Tipo',dataFormat:_this.addTipoRequerimentoLabel}];_this.verificarSeFiltroPesquisaExiste=function(){return JSON.parse(sessionStorage.getItem('filtroPesquisa'))!==undefined&&JSON.parse(sessionStorage.getItem('filtroPesquisa'))!==null;};_this.realizaConsulta=function(filtrosPesquisa){var filtrosConsulta={};var existeFiltroPesquisaUtilizado=_this.verificarSeFiltroPesquisaExiste();if(!filtrosPesquisa&&existeFiltroPesquisaUtilizado){filtrosConsulta=_this.montaFiltros(JSON.parse(sessionStorage.getItem('filtroPesquisa')));}else if(filtrosPesquisa){filtrosConsulta=_this.montaFiltros(filtrosPesquisa);}var atributosConsulta=_this.verificaAtributosParaConsulta();if(atributosConsulta){if(filtrosConsulta.estado===undefined){filtrosConsulta.estado=atributosConsulta.estados;}filtrosConsulta.participacao=atributosConsulta.tipoParticipacao;filtrosConsulta['atributo-ordenacao']=atributosConsulta.campoOrdenacao;if(atributosConsulta.filtroTipoExigencias){filtrosConsulta['tipo-exigencia']=atributosConsulta.filtroTipoExigencias;}if(atributosConsulta.tipoRequerimento){filtrosConsulta['tipo-requerimento']=atributosConsulta.tipoRequerimento;}if(atributosConsulta.estado){filtrosConsulta.estado=atributosConsulta.estado;}filtrosConsulta['atributo-ordenacao']=atributosConsulta.campoOrdenacao;}// quando clicar em pesquisar, volta para primeira página
var novaPagina=filtrosPesquisa&&filtrosPesquisa.cliqueiNoBotao===1?1:_this.state.estadoTabela.paginaAtual;_this.setState(function(prevState){return{filtrosConsulta:filtrosConsulta,estadoTabela:Object.assign({},prevState.estadoTabela,{paginaAtual:novaPagina})};},_this.executaConsulta);};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length===0){_this.setState({listaRequerimentosIndexada:[],listaRequerimentosIndexadaAtualizada:true});return;}var _this$state$estadoTab=_this.state.estadoTabela,paginaAtual=_this$state$estadoTab.paginaAtual,resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(paginaAtual-1)*resultadosPorPagina;var paramsBase=Object.assign({},_this.state.filtrosConsulta,{'unidade-inss':_this.lotacao,'start-position':primeiroItem,'max-results':resultadosPorPagina});if(_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps'])){Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["e" /* doGet */])('requerimentos-compensacao',_this.tratarSucesso,_this.tratarErro,paramsBase);return;}var url='requerimentos-compensacao/destinatario-rpps';var params=Object.assign({},paramsBase);if(_this.props.match.params.tipoConsulta==='analise'||_this.props.match.params.tipoConsulta==='complementar-aposentadoria'){params=Object.assign({},params,{'participacao-solicitante':{rgps:1,rpps:2}[_this.props.match.params.regime]});}if(_this.props.match.params.tipoConsulta==='complementar-aposentadoria'){url='requerimentos-compensacao-aposentadoria/complementar-aposentadoria';}Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["e" /* doGet */])(url,_this.tratarSucesso,_this.tratarErro,params);};_this.montaFiltros=function(atributosPesquisa){var atributos={participacao:atributosPesquisa.participacao,'unidade-inss':_this.lotacao};if(atributosPesquisa.cpf){atributos=Object.assign({},atributos,{cpf:atributosPesquisa.cpf});}if(atributosPesquisa.tipoRequerimento){atributos=Object.assign({},atributos,{'tipo-requerimento':atributosPesquisa.tipoRequerimento});}if(atributosPesquisa['destinatario-rpps']){atributos=Object.assign({},atributos,{'destinatario-rpps':atributosPesquisa['destinatario-rpps']});}if(atributosPesquisa.estado){atributos=Object.assign({},atributos,{estado:atributosPesquisa.estado});}if(atributosPesquisa.motivo){atributos=Object.assign({},atributos,{motivo:atributosPesquisa.motivo});}return atributos;};_this.verificaAtributosParaConsulta=function(){if(_this.getTipoConsulta()){return __WEBPACK_IMPORTED_MODULE_10__utils_constants__["c" /* estadosParaConsulta */][_this.getTipoConsulta()];}return null;};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRequerimentosIndexada:[],listaRequerimentosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRequerimentosIndexada:[].concat(_toConsumableArray(response.data)),listaRequerimentosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarFiltroNaLista=function(listaRequerimentosFiltrada){_this.setState({listaRequerimentosFiltrada:listaRequerimentosFiltrada,listaRequerimentosIndexadaAtualizada:false});};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.setState({showNoContent:true,noContentPrimaryMessage:'Requerimento não encontrado para o protocolo informado.',noContentSecondaryMessage:'Informe um protocolo válido.'});}else{_this.setState({showNoContent:true,noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}}else{_this.setState({showNoContent:true,noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleChange=function(e,name){_this.setState(Object.assign({},_this.state,_defineProperty({},name,e)));};_this.handleModal=function(modal){_this.setState(_defineProperty({},modal,!_this.state[modal]));};_this.exibirModalAlerta=function(paramDescricao,requerimento,chaveConfirmacao){var alertas=[{descricao:paramDescricao}];_this.setState({showModalAlertaRequerPerConcomitancia:true,alertas:alertas,requerimento:requerimento,chaveConfirmacao:chaveConfirmacao});};_this.handleModalComposto=function(modal,descricao,requerimento,chaveConfirmacao){_this.setState(_defineProperty({},modal,!_this.state[modal]),_this.exibirModalAlerta(descricao,requerimento,chaveConfirmacao));};_this.handleResponseUploadDocumento=function(response){if(response.data.exigencias&&response.data.exigencias.length>0){var possuiExigenciaDocumento=response.data.exigencias.filter(function(exigencia){return exigencia.tipoDocumento;}).length>0;if(possuiExigenciaDocumento){_this.setState({requerimentoModalDocumento:response.data},function(){return _this.handleModal('showDocumentUploadModal');});}else{_this.realizaConsulta();Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["L" /* trataMensagensErro */])(['A exigência de documento aberta para este requerimento já foi atendida. A lista será atualizada.']);}}else{_this.realizaConsulta();Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["L" /* trataMensagensErro */])(['A exigência de documento aberta para este requerimento já foi atendida. A lista será atualizada.']);}};_this.showDocumentUploadModal=function(requerimento){_this.setState({// exigenciaModalDocumento: exigencia,
requerimentoModalDocumento:requerimento});var tipo='pensao';if(requerimento.tipoRequerimento===1){tipo='aposentadoria';}Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["e" /* doGet */])('requerimentos-compensacao-'+tipo+'/'+requerimento.protocolo,_this.handleResponseUploadDocumento,_this.handleErrorEncerramentoExigencia);};_this.showTratamentoExigenciaVerificacaoRequerimento=function(requerimento,acaoExigencia){var tipo='pensao';var metodoSucesso=_this.handleResponseCumprimentoExigencia;if(requerimento.tipoRequerimento===1){tipo='aposentadoria';}if(acaoExigencia==='encerrar'){metodoSucesso=_this.handleResponseEncerramentoExigencia;}if(acaoExigencia==='qualificar'){metodoSucesso=_this.handleResponseQualificacaoRequerimento;}Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["e" /* doGet */])('requerimentos-compensacao-'+tipo+'/'+requerimento.protocolo,metodoSucesso,_this.handleErrorEncerramentoExigencia);};_this.handleResponseQualificacaoRequerimento=function(response){var tipo='pensao';if(response.data.tipoAposentadoria){tipo='aposentadoria';}if(response.data.exigencias&&response.data.exigencias.length>0){var possuiExigenciaQualificacao=response.data.exigencias.filter(function(exigencia){return exigencia.tipo===72;}).length>0;if(possuiExigenciaQualificacao){_this.props.history.push('/requerimento/'+tipo+'/'+response.data.protocolo+'/qualificar');}else{_this.realizaConsulta();Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["L" /* trataMensagensErro */])(['A solicitação de qualificação aberta para este requerimento já foi atendida. A lista será atualizada.']);}}else{_this.realizaConsulta();Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["L" /* trataMensagensErro */])(['A solicitação de qualificação aberta para este requerimento já foi atendida. A lista será atualizada.']);}};_this.showRejeicaoRequerimento=function(requerimento){var tipo=_this.diffRequerimento(requerimento.tipoRequerimento);_this.setState({tipoRequerimento:requerimento.tipoRequerimento});Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["e" /* doGet */])('requerimentos-compensacao-'+tipo+'/'+requerimento.protocolo,_this.handleResponseRejeicaoRequerimento,_this.handleErrorEncerramentoExigencia);};_this.handleResponseCumprimentoExigencia=function(response){var tipo='pensao';if(response.data.tipoAposentadoria){tipo='aposentadoria';}if(response.data.exigencias&&response.data.exigencias.length>0){_this.props.history.push('/requerimento/'+tipo+'/'+response.data.protocolo+'/cumprir-exigencia');}else{_this.realizaConsulta();Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["L" /* trataMensagensErro */])(['As exigências de alteração abertas para este requerimento já foram atendidas. A lista será atualizada.']);}};_this.handleResponseEncerramentoExigencia=function(response){if(response.data.exigencias&&response.data.exigencias.length>0){var possuiExigenciaAtributo=response.data.exigencias.filter(function(exigencia){return!__WEBPACK_IMPORTED_MODULE_10__utils_constants__["A" /* tiposExigenciaSistema */].includes(exigencia.tipo);}).length>0;if(possuiExigenciaAtributo){_this.setState({requerimentoModalExigencia:response.data},function(){return _this.handleModal('showEncerramentoExigenciaModal');});}else{_this.realizaConsulta();Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["L" /* trataMensagensErro */])(['As exigências de alteração abertas para este requerimento já foram atendidas. A lista será atualizada.']);}}else{_this.realizaConsulta();Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["L" /* trataMensagensErro */])(['As exigências de alteração abertas para este requerimento já foram atendidas. A lista será atualizada.']);}};_this.handleResponseRejeicaoRequerimento=function(response){_this.setState({requerimentoModalExigencia:response.data},function(){return _this.handleModal('showRejeicaoRequerimentoModal');});};_this.handleErrorEncerramentoExigencia=function(){};_this.handleDocumentSent=function(location,tipoDocumento){var mensagemSucesso=['Documento anexado ao requerimento com sucesso. Exigência encerrada.'];Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);var _this$state2=Object.assign({},_this.state),listaRequerimentosIndexada=_this$state2.listaRequerimentosIndexada;var indexReq=listaRequerimentosIndexada.findIndex(function(req){return req.protocolo===_this.state.requerimentoModalDocumento.protocolo;});var indexExigencia=listaRequerimentosIndexada[indexReq].exigencias.findIndex(function(exi){return exi.tipoDocumento===tipoDocumento;});listaRequerimentosIndexada[indexReq].exigencias.splice(indexExigencia,1);if(listaRequerimentosIndexada[indexReq].exigencias.length===0){listaRequerimentosIndexada.splice(indexReq,1);}_this.realizaConsulta();_this.setState({listaRequerimentosIndexada:listaRequerimentosIndexada,listaRequerimentosIndexadaAtualizada:true},function(){return _this.handleModal('showDocumentUploadModal');});};_this.alteraListaArquivos=function(arquivos){_this.handleChange({value:arquivos,isValid:arquivos.length>0});};_this.deleteArquivo=function(row){var _this$state3=Object.assign({},_this.state),arquivos=_this$state3.arquivos;arquivos.splice(row,1);_this.alteraListaArquivos(arquivos);};_this.addArquivo=function(arquivo){if(arquivo){var _this$state4=Object.assign({},_this.state),arquivos=_this$state4.arquivos;var tamanhoDocumentoUpload=arquivo.documento.size;if(tamanhoDocumentoUpload>__WEBPACK_IMPORTED_MODULE_10__utils_constants__["z" /* tamanhoMaximoArquivoUpload */]){Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["L" /* trataMensagensErro */])(['Certifique-se de que o documento '+arquivo.documento.name+' possui tamanho inferior a 3 mb.']);}else{if(arquivos.length>0){_this.deleteArquivo(arquivos[0]);}arquivos.push(arquivo);}_this.alteraListaArquivos(arquivos,null);// this.setState(this.handleModal('showDocumentUploadModal'));
}};_this.trataSucessoUploadAvulso=function(){var _this$state5=Object.assign({},_this.state),arquivos=_this$state5.arquivos;_this.setState({sucessoUpload:true});var mensagemSucesso=['Documento anexado ao requerimento com sucesso.'];if(_this.state.sucessoUpload){arquivos=[];_this.setState({arquivos:arquivos});Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);}};_this.handleFailUploadAvulso=function(){var mensagemErro=['Falha ao anexar documento ao requerimento.'];Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["L" /* trataMensagensErro */])(mensagemErro);};_this.uploadFile=function(){var _this$state6=Object.assign({},_this.state),arquivos=_this$state6.arquivos;var url='documentos';var documentos=arquivos;if(documentos.length>0){for(var i=0,docs=documentos.length;i<docs;i+=1){var body={protocolo:documentos[i].protocolo,tipoDocumento:documentos[i].tipoDocumento,documento:documentos[i].documento};Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["j" /* doMultipartFormPost */])(url,body,_this.trataSucessoUploadAvulso,_this.handleFailUploadAvulso);}}};_this.handleEncerramentoExigenciaSent=function(){var mensagemSucesso=['Exigências não atendidas encerradas.'];Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);var _this$state7=Object.assign({},_this.state),listaRequerimentosIndexada=_this$state7.listaRequerimentosIndexada;var indexReq=listaRequerimentosIndexada.findIndex(function(req){return req.protocolo===_this.state.requerimentoModalExigencia.protocolo;});// fazer o upload do arquivo;
_this.uploadFile();listaRequerimentosIndexada.splice(indexReq,1);_this.setState({listaRequerimentosIndexada:listaRequerimentosIndexada,listaRequerimentosIndexadaAtualizada:true},function(){return _this.handleModal('showEncerramentoExigenciaModal');});};_this.handleRejeicaoRequerimentoSent=function(){var mensagemSucesso=['Requerimento Rejeitado.'];Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);var _this$state8=Object.assign({},_this.state),listaRequerimentosIndexada=_this$state8.listaRequerimentosIndexada;_this.realizaConsulta();_this.setState({listaRequerimentosIndexada:listaRequerimentosIndexada,listaRequerimentosIndexadaAtualizada:true},function(){return _this.handleModal('showRejeicaoRequerimentoModal');});};_this.montaAcoesExigencia=function(row){var _row=Object.assign({},row),exigencias=_row.exigencias;var acaoUploadDisponivel=false;var acaoEncerramentoDisponivel=false;var acaoRejeicaoDisponivel=false;var acaoQualificacaoDisponivel=false;var botoesDocumentos=null;if(exigencias){botoesDocumentos=exigencias.map(function(exigencia){if(!acaoEncerramentoDisponivel&&!__WEBPACK_IMPORTED_MODULE_10__utils_constants__["A" /* tiposExigenciaSistema */].includes(exigencia.tipo)){acaoEncerramentoDisponivel=true;}if(_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','requerer-compensacao-rpps','analisar-compensacao-rpps','gerenciar-negocio-dcomp'])&&!acaoRejeicaoDisponivel&&(row.tipoRequerimento===1||row.tipoRequerimento===2)){acaoRejeicaoDisponivel=true;}if(exigencia.tipoDocumento&&!exigencia.atributo){acaoUploadDisponivel=true;}if(exigencia.tipo===72){acaoQualificacaoDisponivel=true;}return'';});}var botaoUpload=acaoUploadDisponivel?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Carregar documento',icon:'ico-upload',mini:true,disabled:_this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp,onClick:function onClick(){return _this.showDocumentUploadModal(row);}}):'';var botaoAlterar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Alterar requerimento',icon:'ico-doc-pencil',mini:true,disabled:_this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp,onClick:function onClick(){return _this.showTratamentoExigenciaVerificacaoRequerimento(row,'cumprir');}});var botaoQualificar=acaoQualificacaoDisponivel&&_this.props.configuracoesFrontend&&_this.props.configuracoesFrontend.habilitarQualificacao?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Qualificar requerimento',icon:'ico-doc-refresh',mini:true,disabled:_this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp,onClick:function onClick(){return _this.showTratamentoExigenciaVerificacaoRequerimento(row,'qualificar');}}):'';var botaoEncerrarExigencia=acaoEncerramentoDisponivel?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Encerrar exig\xEAncias do requerimento',icon:'ico-doc-check',mini:true,disabled:_this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp,onClick:function onClick(){return _this.showTratamentoExigenciaVerificacaoRequerimento(row,'encerrar');}}):null;var botaoCancelarRequerimento=acaoRejeicaoDisponivel?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Rejeitar requerimento',icon:'ico-trash-can',mini:true,disabled:_this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp,onClick:function onClick(){return _this.showRejeicaoRequerimento(row,'cancelar');}}):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,botaoQualificar,botaoUpload,botoesDocumentos,botaoAlterar,botaoEncerrarExigencia,botaoCancelarRequerimento);};_this.pushNavegacao=function(tipo,row){if(!_this.getTipoConsulta()){_this.props.history.push('/requerimento/'+tipo+'/'+row.protocolo);}else{var atributosConsulta=_this.verificaAtributosParaConsulta();if(tipo&&row){_this.props.history.push('/requerimento/'+tipo+'/'+row.protocolo+'/'+atributosConsulta.acao);}else{_this.props.history.push('/requerimento/'+_this.state.tipoRequerimentoSelecionado+'/'+_this.state.requerimentoVindoDoRequest.protocolo+'/'+atributosConsulta.acao);}}};_this.handleClickNovoEstado=function(row,tipo){_this.setState({tipoRequerimentoSelecionado:tipo});if(row.estado===6||row.estado===7||!_this.getTipoConsulta()){_this.pushNavegacao(tipo,row);}else if(_this.getTipoConsulta()==='complementar-aposentadoria'&&row.estado===4){_this.pushNavegacao(tipo,row);}else{Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["e" /* doGet */])('requerimentos-compensacao-'+tipo+'/'+row.protocolo,_this.handleGetNovoEstadoSuccess,_this.handleClickNovoEstadoFail);}};_this.handleGetNovoEstadoSuccess=function(response){var requerimentoVindoDoRequest=response.data;_this.setState({requerimentoVindoDoRequest:requerimentoVindoDoRequest});if(requerimentoVindoDoRequest.estado!==4&&requerimentoVindoDoRequest.estado!==10&&requerimentoVindoDoRequest.estado!==5){_this.realizaConsulta();Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["L" /* trataMensagensErro */])(['Este requerimento já está sendo analisado por outro usuário. A lista será atualizada.']);}else{// Alteracao de estado para atualizacao de requerimento
if(requerimentoVindoDoRequest.estado===4||requerimentoVindoDoRequest.estado===10){requerimentoVindoDoRequest.estado=6;}else if(requerimentoVindoDoRequest.estado===5){requerimentoVindoDoRequest.estado=7;}// Request
Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["n" /* doPut */])('requerimentos-compensacao-'+_this.state.tipoRequerimentoSelecionado+'/'+requerimentoVindoDoRequest.protocolo,requerimentoVindoDoRequest,_this.handleClickNovoEstadoSuccess,_this.handleClickNovoEstadoFail,{codigo:3019,mensagem:'Este requerimento já está sendo analisado por outro usuário. A lista será atualizada.'});}};_this.handleClickNovoEstadoSuccess=function(){_this.pushNavegacao(_this.state.requerimentoVindoDoRequest);};_this.handleClickNovoEstadoFail=function(){_this.realizaConsulta();};_this.diffRequerimento=function(tipoRequerimento){if(tipoRequerimento===2){return'pensao';}return'aposentadoria';};_this.montaAcoesAnalise=function(row,tipo){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Analisar requerimento',icon:'ico-doc-magnifier',mini:true,disabled:_this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp,onClick:function onClick(){return _this.handleClickNovoEstado(row,tipo);}});};_this.montaAcoesConsulta=function(row,tipo){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Consultar requerimento',icon:'ico-doc-magnifier',mini:true,onClick:function onClick(){return _this.handleClickNovoEstado(row,tipo);}});};_this.montaAcoesComplementarAposentadoria=function(row,tipo){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Complementar aposentadoria',icon:'ico-doc-pencil',mini:true,onClick:function onClick(){return _this.handleClickNovoEstado(row,tipo);}});};_this.createActionColumn=function(cell,row){var tipo='pensao';if(row.tipoRequerimento===1){tipo='aposentadoria';}var acoes='';switch(_this.getTipoConsulta()){case'exigencia':acoes=_this.montaAcoesExigencia(row,tipo);break;case'prescricao-exigencia':acoes=_this.montaAcoesExigencia(row,tipo);break;case'analise':acoes=_this.montaAcoesAnalise(row,tipo);break;case'parecer-medico':acoes=_this.montaAcoesAnalise(row,tipo);break;default:if(_this.props.match.params.tipoConsulta==='complementar-aposentadoria'){acoes=_this.montaAcoesComplementarAposentadoria(row,tipo);}else{acoes=_this.montaAcoesConsulta(row,tipo);}break;}return acoes;};_this.addTipoEstadoLabel=function(tipo){if(tipo===15){return'Exigência/indeferido';}if(tipo===16){return'Indeferimento ratificado';}if(tipo===undefined||tipo===null){return'';}return __WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};_this.handleErrorBusca=function(){};_this.montaColunasEspecificas=function(){switch(_this.getTipoConsulta()){case'analise':if(_this.props.auth.checkPermission(['requerer-compensacao-rpps'])){return[{id:'qtdDiasEstadoAguardandoAnalise',label:'Dias no Estado'},{id:'estado',label:'Estado',dataFormat:_this.addTipoEstadoLabel}];}return[{id:'estado',label:'Estado',dataFormat:_this.addTipoEstadoLabel}];case'exigencia':return[{id:'prazoAtendimentoExigencias',label:'Prazo (em dias)'}];case'parecer-medico':return[{id:'estado',label:'Estado',dataFormat:_this.addTipoEstadoLabel}];case'prescricao-exigencia':return _this.montaColunasEspecificasExigencias();case'complementar-aposentadoria':if(_this.props.auth.checkPermission(['requerer-compensacao-rpps'])){return[{id:'qtdDiasEstadoAguardandoAnalise',label:'Dias no Estado'},{id:'estado',label:'Estado',dataFormat:_this.addTipoEstadoLabel}];}return[{id:'estado',label:'Estado',dataFormat:_this.addTipoEstadoLabel}];default:return[{id:'estado',label:'Estado',dataFormat:_this.addTipoEstadoLabel}];}};_this.montaColunasEspecificasExigencias=function(){if(_this.props.auth.checkPermission(['requerer-compensacao-rgps'])){return[{id:'dataCreditoPagamento',label:'Data de Crédito do Pagamento'}];}return[{id:'dataHomologacaoTribunalContas',label:'Data de Homologação no Tribunal de Contas'}];};_this.montaColunas=function(){var requerimentosExigenciaTableHeader=_this.colunasDefault.slice();// let requerimentosExigenciaTableHeader = this.getColunasDefault();
var colunasEspecificas=_this.montaColunasEspecificas();if(colunasEspecificas){requerimentosExigenciaTableHeader=requerimentosExigenciaTableHeader.concat(colunasEspecificas);}// if (!this.props.auth.checkPermission(['gerenciar-negocio-inss'])) {
requerimentosExigenciaTableHeader.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});// }
return requerimentosExigenciaTableHeader;};_this.montaTituloTabela=function(){switch(_this.getTipoConsulta()){case'analise':return'Requerimentos Aguardando Análise, Em Análise ou Com Análise Suspensa';case'exigencia':return'Requerimentos em Exigência';case'parecer-medico':return'Requerimentos Aguardando Parecer do Médico';case'prescricao-exigencia':return'Requerimentos em Exigência (Prescrição)';case'complementar-aposentadoria':return'Requerimentos em Análise a serem Complementados';default:return'Requerimentos';}};_this.defineListaParaTabela=function(){if(_this.state.listaRequerimentosFiltrada!==null){return _this.state.listaRequerimentosFiltrada;}return _this.state.listaRequerimentosIndexada;};_this.alterarPagina=function(pagina,resultadosPorPagina){_this.setState(function(prevState){return{estadoTabela:Object.assign({},prevState.estadoTabela,{paginaAtual:pagina===0?1:pagina,resultadosPorPagina:resultadosPorPagina||prevState.estadoTabela.resultadosPorPagina})};},_this.executaConsulta);};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state9=Object.assign({},_this.state),estadoTabela=_this$state9.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState({estadoTabela:estadoTabela},_this.realizaConsulta);};_this.trataSucessoResponseEnvio=function(){var mensagemSucesso=['Exigências não atendidas encerradas.'];Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);var _this$state10=Object.assign({},_this.state),listaRequerimentosIndexada=_this$state10.listaRequerimentosIndexada;var indexReq=listaRequerimentosIndexada.findIndex(function(req){return req.protocolo===_this.state.requerimentoModalExigencia.protocolo;});listaRequerimentosIndexada.splice(indexReq,1);_this.setState({listaRequerimentosIndexada:listaRequerimentosIndexada,listaRequerimentosIndexadaAtualizada:true},function(){return _this.handleModal('showModalAlertaRequerPerConcomitancia');});};_this.trataErrosResponse=function(error){// eslint-disable-next-line
console.log(error);// trataMensagensErro(['DEU RUIM.']);
_this.handleModal('showModalAlertaRequerPerConcomitancia');};_this.handleSaveEncerramentoExigencia=function(){var _this$state11=Object.assign({},_this.state),requerimento=_this$state11.requerimento;requerimento.estado=3;var url='requerimentos-compensacao-pensao/'+requerimento.protocolo;if(requerimento.tipoAposentadoria){url='requerimentos-compensacao-aposentadoria/'+requerimento.protocolo;}var options=void 0;if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["n" /* doPut */])(url,requerimento,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,{codigo:3019,mensagem:'Não foi possível alterar o estado do requerimento.'},options);};_this.state={listaRequerimentosFiltrada:null,listaRequerimentosIndexada:[],requerimentoModalDocumento:{},requerimentoVindoDoRequest:null,tipoRequerimentoSelecionado:null,requerimentoModalExigencia:[],showDocumentUploadModal:false,showEncerramentoExigenciaModal:false,showRejeicaoRequerimentoModal:false,showNoContent:false,listaRequerimentosIndexadaAtualizada:false,showModalAlertaRequerPerConcomitancia:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{},tipoRequerimento:null,requerimento:{},chaveConfirmacao:null,arquivos:[],sucessoUpload:false};return _this;}_createClass(ConsultaExigencia,[{key:'componentDidMount',value:function componentDidMount(){if(['analise','exigencia','prescricao-exigencia','complementar-aposentadoria','parecer-medico'].includes(this.props.match.params.tipoConsulta)&&!sessionStorage.getItem('filtroPesquisa')){this.realizaConsulta();}else{// eslint-disable-next-line
if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}}if(this.props.tiposDocumentos.length===0){Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["D" /* requestTiposDocumentos */])(this.handleErrorBusca);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// if (this.props.match.params.tipoConsulta === 'exigencia' ||
// this.props.match.params.tipoConsulta === 'prescricao-exigencia' ||
// this.props.match.params.tipoConsulta === 'analise') {
//   manterApenasFiltro('filtroPesquisa');
// }
// Apenas repete consulta se parametro da url for alterado
if(this.props.match.params.tipoConsulta!==prevProps.match.params.tipoConsulta||this.props.match.params.regime!==prevProps.match.params.regime){this.preparaNovaConsulta();}}// .split(',')[0].split('#')[1];
// addTipoRequerimentoLabel = tipo => (
//   listUtils.getObject(listUtils.tipoRequerimento, tipo).label
// )
/**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   *//**
   * Exclui um arquivo da lista
   */},{key:'render',value:function render(){var _this2=this;var options={noDataText:'Nenhum requerimento a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["o" /* linhasPorPagina */]// alwaysShowAllBtns: false,
};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var requerimentosExigenciaTableHeader=this.montaColunas();var modalEncerramentoExigencia='';if(this.state.showEncerramentoExigenciaModal){modalEncerramentoExigencia=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Exigencia_ModalEncerramentoExigencia__["a" /* default */],Object.assign({},this.props,{requerimento:this.state.requerimentoModalExigencia,handleEncerramentoExigenciaSent:this.handleEncerramentoExigenciaSent,handleModal:function handleModal(){return _this2.handleModal('showEncerramentoExigenciaModal');},handleModalComposto:this.handleModalComposto,addArquivo:this.addArquivo}));}var modalRejeicaoRequerimento='';if(this.state.showRejeicaoRequerimentoModal){modalRejeicaoRequerimento=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Exigencia_ModalRejeicaoRequerimento__["a" /* default */],Object.assign({},this.props,{requerimento:this.state.requerimentoModalExigencia,tipoRequerimento:this.state.tipoRequerimento,handleRejeicaoRequerimentoSent:this.handleRejeicaoRequerimentoSent,handleModal:function handleModal(){return _this2.handleModal('showRejeicaoRequerimentoModal');}}));}var modalAlertaRequerPerConcomitancia='';if(this.state.showModalAlertaRequerPerConcomitancia){modalAlertaRequerPerConcomitancia=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__pages_requerimentos_ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.handleSaveEncerramentoExigencia,handleModal:function handleModal(){return _this2.handleModal('showModalAlertaRequerPerConcomitancia');},labelTitulo:'Salvar requerimento com per\xEDodos concomitantes ?',labelBotaoConfirmarAcao:'sim',labelBotaoCancelarAcao:'n\xE3o',showModal:true});}return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__FiltroPesquisa__["a" /* default */],{handleSearchFilter:this.realizaConsulta,handleChangeList:this.tratarFiltroNaLista,destinatarios:this.props.destinatarios,list:this.state.listaRequerimentosIndexada,tipoConsulta:this.getTipoConsulta(),listaRequerimentosIndexadaAtualizada:this.state.listaRequerimentosIndexadaAtualizada,auth:this.props.auth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["u" /* Table */],{key:this.state.estadoTabela.paginaAtual+' - '+this.state.estadoTabela.quantidadeTotalResultados,legend:this.montaTituloTabela(),bordered:true,fetchInfo:fetchInfo,data:this.defineListaParaTabela(),options:options,listaTableHeader:requerimentosExigenciaTableHeader,pagination:true,remote:true}),this.state.showDocumentUploadModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Exigencia_ModalUploadDocumento__["a" /* default */],Object.assign({},this.props,{requerimento:this.state.requerimentoModalDocumento,handleDocumentSent:this.handleDocumentSent// handleFailDocumentSent={this.realizaConsulta}
,handleModal:function handleModal(){return _this2.handleModal('showDocumentUploadModal');},showModal:this.state.showDocumentUploadModal})):'',modalEncerramentoExigencia,modalRejeicaoRequerimento,modalAlertaRequerPerConcomitancia);}}]);return ConsultaExigencia;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaExigencia.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,regime:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,exigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),tiposDocumentos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),configuracoesFrontend:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired};ConsultaExigencia.defaultProps={destinatarios:[],match:null,exigencias:[],tiposDocumentos:[]};var mapStateToProps=function mapStateToProps(state){return{configuracoesFrontend:state.base.configuracoesFrontend,destinatarios:state.base.destinatarios,exigencias:state.base.exigencias,tiposDocumentos:state.base.tiposDocumentos};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ConsultaExigencia));

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ComponentesBasicos_UploadDragDrop__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalUploadDocumento=function(_Component){_inherits(ModalUploadDocumento,_Component);function ModalUploadDocumento(){_classCallCheck(this,ModalUploadDocumento);var _this=_possibleConstructorReturn(this,(ModalUploadDocumento.__proto__||Object.getPrototypeOf(ModalUploadDocumento)).call(this));_this.montaListaDocumentosDisponiveis=function(){var lista=[];if(_this.props.requerimento&&_this.props.requerimento.exigencias){_this.props.requerimento.exigencias.forEach(function(exigencia){if(exigencia.tipoDocumento&&!exigencia.atributo){var acaoFormatada=exigencia.acao;if(exigencia.tipoDocumento===13){if(exigencia.comentario){acaoFormatada=exigencia.acao+' - '+exigencia.comentario;}}lista.push({value:exigencia.codigoDependente?''+exigencia.tipoDocumento+exigencia.codigoDependente:exigencia.tipoDocumento,label:acaoFormatada,dependente:exigencia.codigoDependente});}});}_this.setState({tiposDisponiveis:lista});};_this.checkIfFileCanBeSent=function(){return _this.state.documents.length>0&&_this.state.tipoDocumento;};_this.modalDocumentUploadContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.state.exibirNomeDependente?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Dependente',value:_this.state.nomeDependente,disabled:true}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Tipo de documento',number:true,placeholder:'Selecione o tipo de documento',onChange:function onChange(e){return _this.handleChange(e,'tipoDocumento');},value:_this.state.tipoDocumento,itemList:_this.state.tiposDisponiveis,required:true,custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ComponentesBasicos_UploadDragDrop__["a" /* default */],{files:_this.state.documents,onChange:function onChange(documents){return _this.setState({documents:documents});},multiple:false,accept:'application/pdf,.pdf',minHeight:70,titulo:'Arraste o arquivo PDF aqui',subtitulo:'ou clique para selecionar'}));};_this.modalDocumentUploadFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!_this.checkIfFileCanBeSent(),hint:'Anexar documento',onClick:_this.uploadFile,title:'Anexar'})));};_this.handleChange=function(changeObj,name){// 15365899
var paramExibirNomeDependente=false;var listaDependentes=_this.props.requerimento.dependentes;var listaExigencias=_this.props.requerimento.exigencias;var paramNomeDependente='';var dependente='';var valor='';var codigoDependente='';if(listaExigencias&&listaExigencias.length>0){for(var i=0,tam=listaExigencias.length;i<tam;i+=1){var exigencia=listaExigencias[i];if(exigencia.tipoDocumento&&exigencia.codigoDependente){valor=''+exigencia.tipoDocumento+exigencia.codigoDependente;if(Number(valor)===changeObj.value){dependente=valor.match(exigencia.codigoDependente);break;}}}if(dependente!==''){codigoDependente=Number(dependente[0]);var indexDep=listaDependentes.findIndex(function(depDisp){return depDisp.codigo===codigoDependente;});paramNomeDependente=listaDependentes[indexDep].nome;if(paramNomeDependente!==''){paramExibirNomeDependente=true;}_this.setState({nomeDependente:paramNomeDependente,exibirNomeDependente:paramExibirNomeDependente});}}if(changeObj.value===''){paramNomeDependente='';paramExibirNomeDependente=false;_this.setState({nomeDependente:paramNomeDependente,exibirNomeDependente:paramExibirNomeDependente});}_this.setState(_defineProperty({},name,changeObj.value));};_this.handleChangeFile=function(file){_this.setState({document:file});};_this.uploadFile=function(){var documents=_this.state.documents;if(!documents||documents.length===0){return;}var documentoAtual=documents[0];if(documentoAtual){var listaExigencias=_this.props.requerimento.exigencias;var listaDependentes=_this.props.requerimento.dependentes;var _this$state=Object.assign({},_this.state),tipoDocumento=_this$state.tipoDocumento;var tipoDoc='';var valor='';var url='documentos';var body='';if(listaDependentes&&listaDependentes.length>0){for(var i=0,tam=listaExigencias.length;i<tam;i+=1){var exigencia=listaExigencias[i];if(exigencia.tipoDocumento&&exigencia.codigoDependente){valor=''+exigencia.tipoDocumento+exigencia.codigoDependente;if(Number(valor)===tipoDocumento){tipoDoc=valor.match(exigencia.tipoDocumento);tipoDoc=Number(tipoDoc[0]);break;}}else if(exigencia.tipoDocumento&&!exigencia.codigoDependente){tipoDoc=exigencia.tipoDocumento;break;}}body={protocolo:_this.props.requerimento.protocolo,documento:documentoAtual,tipoDocumento:tipoDoc};}else{body={protocolo:_this.props.requerimento.protocolo,documento:documentoAtual,tipoDocumento:_this.state.tipoDocumento};}Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["k" /* doMultipartFormPostExigencias */])(url,body,_this.handleDocumentSent,_this.props.handleFailDocumentSent);}_this.setState({documents:[]});};_this.handleDocumentSent=function(response){var tipoDocumentoCarregado=_this.state.tipoDocumento;_this.setState({document:null,tipoDocumento:null,tiposDisponiveis:[]},function(){return _this.props.handleDocumentSent(response.headers.location,tipoDocumentoCarregado);});};_this.handleClose=function(){_this.setState({document:null},_this.props.handleModal('showDocumentUploadModal'));};_this.state={documents:[],tipoDocumento:null,tiposDisponiveis:[],nomeDependente:null,exibirNomeDependente:false};return _this;}_createClass(ModalUploadDocumento,[{key:'componentDidMount',value:function componentDidMount(){this.montaListaDocumentosDisponiveis();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalDocumentUploadFooter(),conteudomodal:this.modalDocumentUploadContent(),onHide:this.handleClose,size:'md',showModal:this.props.showModal,title:'Incluir documento ao requerimento'}));}}]);return ModalUploadDocumento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalUploadDocumento.propTypes={exigencia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleDocumentSent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalUploadDocumento);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ComponentesBasicos_UploadDragDrop__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalEncerramentoExigencia=function(_Component){_inherits(ModalEncerramentoExigencia,_Component);function ModalEncerramentoExigencia(props){_classCallCheck(this,ModalEncerramentoExigencia);var _this=_possibleConstructorReturn(this,(ModalEncerramentoExigencia.__proto__||Object.getPrototypeOf(ModalEncerramentoExigencia)).call(this,props));_this.getInitialState=function(){var initialState={requerimento:{exigencias:[]},arquivo:{documento:null,protocolo:null,tipoDocumento:null},documents:[],document:null,tiposDisponiveis:[],tipoDocumento:null};return initialState;};_this.montaListaDocumentosDisponiveis=function(){var lista=_this.montarListaDocumentosAdicionais(_this.props.requerimento);_this.setState({tiposDisponiveis:lista});};_this.montarListaDocumentosAdicionais=function(paramLista){var lista=paramLista;var tiposDocumentos=_this.props.tiposDocumentos?_this.props.tiposDocumentos:[];var codigos=[22];lista=tiposDocumentos.filter(function(doc){return codigos.includes(doc.value);});return lista;};_this.atualizaRequerimento=function(){var _this$props=Object.assign({},_this.props),requerimento=_this$props.requerimento;_this.setState(Object.assign({},_this.state,{requerimento:requerimento}));};_this.trataSucessoResponseEnvio=function(){_this.props.handleEncerramentoExigenciaSent();};_this.trataErrosResponse=function(error){// eslint-disable-next-line
var _this$state=Object.assign({},_this.state),requerimento=_this$state.requerimento;if(error.data.codigo===4500){// const colecao = ['showEncerramentoExigenciaModal', 'showModalAlertaRequerPerConcomitancia'];
var chave=error.data.chaveConfirmacao;if(error.data.alertas&&error.data.alertas.length>0){error.data.alertas.forEach(function(item){if(item.codigo===4513){_this.props.handleModalComposto('showEncerramentoExigenciaModal',item.descricao,requerimento,chave);}});}}};_this.handleSave=function(){var _this$state2=Object.assign({},_this.state),requerimento=_this$state2.requerimento,tipoDocumento=_this$state2.tipoDocumento,document=_this$state2.document;requerimento.estado=3;var url='requerimentos-compensacao-pensao/'+requerimento.protocolo;if(requerimento.tipoAposentadoria){url='requerimentos-compensacao-aposentadoria/'+requerimento.protocolo;}if(tipoDocumento&&document){_this.addArquivo();}Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["n" /* doPut */])(url,requerimento,_this.trataSucessoResponseEnvio,_this.trataErrosResponse);};_this.filtraExigencias=function(){if(_this.props.requerimento.exigencias){return _this.props.requerimento.exigencias.filter(function(exigencia){return!__WEBPACK_IMPORTED_MODULE_5__utils_constants__["A" /* tiposExigenciaSistema */].includes(exigencia.tipo);});}return'';};_this.handlePositionalChange=function(changeObj,name,tipoExigencia,codigoDependente){// console.log(tipoExigencia);
var listaExigenciasModificada=_this.state.requerimento.exigencias.map(function(exigencia,index){if(tipoExigencia===exigencia.tipo&&codigoDependente===exigencia.codigoDependente){var exigenciaAlterada=_this.state.requerimento.exigencias[index];exigenciaAlterada[name]=changeObj.value;var atendida=0;if(exigenciaAlterada.motivoNaoAtendimento!==0||exigenciaAlterada.comentarioNaoAtendimento!==''){atendida=2;}exigenciaAlterada.atendida=atendida;return exigenciaAlterada;}return _this.state.requerimento.exigencias[index];});_this.setState({requerimento:Object.assign({},_this.state.requerimento,{exigencias:listaExigenciasModificada})});};_this.doRequest=function(typeRequest){switch(typeRequest){case'exigencia':if(_this.props.exigencias.length===0){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["r" /* requestExigencias */])(_this.failCallback);}break;case'motivo':if(_this.props.motivosNaoCumprimento.length===0){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["u" /* requestMotivos */])(_this.failCallback);}break;default:break;}};_this.buscaDadosDeDominio=function(){if(_this.props.motivosNaoCumprimento.length===0){_this.doRequest('motivo');return null;}return null;};_this.retornaTamanhoExigencias=function(){var colecao=[];if(_this.props.requerimento.exigencias){colecao=_this.props.requerimento.exigencias.filter(function(exigencia){return!__WEBPACK_IMPORTED_MODULE_5__utils_constants__["A" /* tiposExigenciaSistema */].includes(exigencia.tipo);});}return colecao.length;};_this.handleChange=function(e,name){_this.setState(_defineProperty({},name,e.value));};_this.handleChangeFile=function(file){_this.setState({document:file});};_this.addArquivo=function(){var documents=_this.state.documents;if(!documents||documents.length===0){return;}var arquivosAdicionados=[];var _this$state3=Object.assign({},_this.state),requerimento=_this$state3.requerimento;documents.forEach(function(documentoAtual){var arquivo={};arquivo={documento:_this.state.document,protocolo:requerimento.protocolo,tipoDocumento:_this.state.tipoDocumento};_this.state.arquivo.documento=documentoAtual;_this.state.arquivo.protocolo=arquivo.protocolo;_this.state.arquivo.tipoDocumento=arquivo.tipoDocumento;arquivosAdicionados.push(arquivo);_this.props.addArquivo(_this.state.arquivo,_this.props.arquivo);});};_this.modalEncerramentoExigenciaContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxHeight:'50vh',overflowY:'auto',overflowX:'hidden',paddingRight:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["l" /* ListaEncerramentoExigencias */],{exigencias:_this.filtraExigencias(),motivosNaoCumprimento:_this.props.motivosNaoCumprimento,handlePositionalChange:_this.handlePositionalChange,handleChangeFile:_this.handleChangeFile})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["f" /* DataGridCustom */],{title:'',retirarLinhaSeparadora:false,cssLinha:'header-com-linha-exigencia'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Se desejar, anexe um documento para justificar o encerramento.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{label:'Tipo de documento',number:true,placeholder:'Selecione o tipo de documento',onChange:function onChange(e){return _this.handleChange(e,'tipoDocumento');},value:_this.state.tipoDocumento,itemList:_this.state.tiposDisponiveis,custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ComponentesBasicos_UploadDragDrop__["a" /* default */],{files:_this.state.document?[_this.state.document]:[]// onChange={documents => this.setState({ documents })}
// files={this.state.document ? [this.state.document] : []}
,onChange:function onChange(documents){return _this.setState({documents:documents,document:documents[0]||null});},onSelect:function onSelect(document){return _this.handleChangeFile(document);},multiple:false,accept:'application/pdf,.pdf',minHeight:70,titulo:'Arraste o arquivo PDF aqui',subtitulo:'ou clique para selecionar',largura:'8',disabled:!_this.state.tipoDocumento}))));};_this.formularioProntoParaEnvio=function(){var possuiTipoDocumento=_this.state.tipoDocumento!==undefined&&_this.state.tipoDocumento!==null&&_this.state.tipoDocumento!=='';var possuiDocumentoUpload=_this.state.document!==null;if(possuiTipoDocumento&&possuiDocumentoUpload){return false;}else if(possuiTipoDocumento&&!possuiDocumentoUpload){return true;}else if(!possuiTipoDocumento&&possuiDocumentoUpload){return false;}return false;};_this.modalEncerramentoExigenciaFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{disabled:_this.formularioProntoParaEnvio(),className:'dtp-primary',hint:'Encerrar exig\xEAncias do requerimento',onClick:_this.handleSave,title:'Encerrar exig\xEAncias'})));};_this.handleClose=function(){_this.props.handleModal('showEncerramentoExigenciaModal');};var state=_this.getInitialState();if(props.requerimento){state.requerimento=props.requerimento;}_this.state=state;return _this;}_createClass(ModalEncerramentoExigencia,[{key:'componentDidMount',value:function componentDidMount(){this.buscaDadosDeDominio();this.montaListaDocumentosDisponiveis();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Preenche requerimento se requerimento for alterado
if(this.props.requerimento&&this.props.requerimento.protocolo!==prevProps.requerimento.protocolo){this.atualizaRequerimento();}}// modalEncerramentoExigenciaContent = () => (
//   <React.Fragment>
//     <div
//       style={{
//         maxHeight: '70vh',
//         overflowY: 'auto',
//         overflowX: 'hidden',
//         paddingRight: '10px',
//       }}
//     >
//       <div className="row">
//         <Grid cols="12 12 12 12">
//           <ListaEncerramentoExigencias
//             exigencias={this.filtraExigencias()}
//             motivosNaoCumprimento={this.props.motivosNaoCumprimento}
//             handlePositionalChange={this.handlePositionalChange}
//             handleChangeFile={this.handleChangeFile}
//           />
//         </Grid>
//       </div>
//       <DataGridCustom title="" retirarLinhaSeparadora={false} cssLinha="header-com-linha-exigencia" />
//       <ul>
//         <div className="row">
//           <p><b>Se desejar, anexe um documento para justificar o encerramento.</b></p>
//         </div>
//         <div className="row">
//           <Grid cols="8 8 8 8">
//             <Input
//               label="Tipo de documento"
//               number
//               placeholder="Selecione o tipo de documento"
//               onChange={e => this.handleChange(e, 'tipoDocumento')}
//               value={this.state.tipoDocumento}
//               itemList={this.state.tiposDisponiveis}
//               custom
//             />
//           </Grid>
//         </div>
//         <UploadDragDrop
//           files={this.state.documents}
//           onChange={documents => this.setState({ documents })}
//           multiple={false}
//           accept="application/pdf,.pdf"
//           minHeight={70}
//           titulo="Arraste o arquivo PDF aqui"
//           subtitulo="ou clique para selecionar"
//           largura="8"
//         />
//       </ul>
//     </div>
//   </React.Fragment>
// )
},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalEncerramentoExigenciaFooter(),conteudomodal:this.modalEncerramentoExigenciaContent(),onHide:this.handleClose,size:'lg',showModal:true,title:'Exig\xEAncias n\xE3o Atendidas'}));}}]);return ModalEncerramentoExigencia;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalEncerramentoExigencia.propTypes={requerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({exigencias:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array}),showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleEncerramentoExigenciaSent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModalComposto:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,motivosNaoCumprimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),addArquivo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;ModalEncerramentoExigencia.defaultProps={motivosNaoCumprimento:[],tiposDocumentos:[]};var mapStateToProps=function mapStateToProps(state){return{motivosNaoCumprimento:state.base.motivosNaoCumprimento,tiposDocumentos:state.base.tiposDocumentos};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ModalEncerramentoExigencia));

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__consultas_FiltroPesquisa__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_listsSelect__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Indeferido=function(_Component){_inherits(Indeferido,_Component);function Indeferido(props){_classCallCheck(this,Indeferido);var _this=_possibleConstructorReturn(this,(Indeferido.__proto__||Object.getPrototypeOf(Indeferido)).call(this,props));_this.realizarConsulta=function(filtrosPesquisa){var filtrosConsulta={};if(filtrosPesquisa){filtrosConsulta=_this.montarFiltros(filtrosPesquisa);}var atributosConsulta=__WEBPACK_IMPORTED_MODULE_6__utils_constants__["c" /* estadosParaConsulta */].indeferido;filtrosConsulta.estado=atributosConsulta.estados;filtrosConsulta.participacao=atributosConsulta.tipoParticipacao;_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta}),_this.executarConsulta);};_this.executarConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('requerimentos-compensacao',_this.tratarSucesso,_this.tratarErro,Object.assign({},_this.state.filtrosConsulta,{'unidade-inss':_this.lotacao,'start-position':primeiroItem,'max-results':resultadosPorPagina}));}else{_this.setState({listaRequerimentosIndexada:[],listaRequerimentosIndexadaAtualizada:true});}};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRequerimentosIndexada:[],listaRequerimentosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRequerimentosIndexada:response.data,listaRequerimentosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.setState({showNoContent:true,noContentPrimaryMessage:'Requerimento Indeferido não encontrado.',noContentSecondaryMessage:'Informe um protocolo válido.'});}else{_this.setState({showNoContent:true,noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}}else{_this.setState({showNoContent:true,noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.tratarFiltroNaLista=function(listaRequerimentosFiltrada){_this.setState({listaRequerimentosFiltrada:listaRequerimentosFiltrada,listaRequerimentosIndexadaAtualizada:false});};_this.paginarResultado=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.paginaAtual=pagina;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizarConsulta());};_this.montarFiltros=function(atributosPesquisa){var atributos={participacao:atributosPesquisa.participacao,'unidade-inss':_this.lotacao};if(atributosPesquisa.cpf){atributos=Object.assign({},atributos,{cpf:atributosPesquisa.cpf});}if(atributosPesquisa.tipoRequerimento){atributos=Object.assign({},atributos,{'tipo-requerimento':atributosPesquisa.tipoRequerimento});}if(atributosPesquisa.estado){atributos=Object.assign({},atributos,{estado:atributosPesquisa.estado});}var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;if(atributosPesquisa.cliqueiNoBotao===1){_this.state.estadoTabela.paginaAtual=1;}var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.recuperarColunas=function(){var cabecalhoTabela=[{id:'cpf',label:'CPF'},{id:'nome',label:'Nome'},{id:'matricula',label:'Matrícula'},{id:'nomeSolicitante',label:'Solicitante'},{id:'nomeDestinatario',label:'Destinatário'},{id:'tipoRequerimento',label:'Tipo',dataFormat:_this.addTipoRequerimentoLabel}];if(_this.props.auth.checkPermission(['requerer-compensacao-rgps'])){cabecalhoTabela.push({id:'dataCreditoPagamento',label:'Data de Crédito do Pagamento'});}else{cabecalhoTabela.push({id:'dataHomologacaoTribunalContas',label:'Data de Homologação no Tribunal de Contas'});}cabecalhoTabela.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});return cabecalhoTabela;};_this.addTipoRequerimentoLabel=function(tipo){return __WEBPACK_IMPORTED_MODULE_8__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_8__utils_listsSelect__["M" /* tipoRequerimento */],tipo).label;};_this.createActionColumn=function(cell,row){var botaoAcaoEditarRequerimentoIndeferido=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Alterar requerimento',icon:'ico-doc-pencil',mini:true,onClick:function onClick(){return _this.editarRequerimento(row);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,botaoAcaoEditarRequerimentoIndeferido);};_this.editarRequerimento=function(requerimento){var tipo='pensao';if(requerimento.tipoRequerimento===1){tipo='aposentadoria';}_this.props.history.push('/requerimento/'+tipo+'/'+requerimento.protocolo+'/indeferidos');};_this.state={listaRequerimentosFiltrada:null,listaRequerimentosIndexada:[],listaRequerimentosIndexadaAtualizada:false,showNoContent:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{}};return _this;}_createClass(Indeferido,[{key:'componentDidMount',value:function componentDidMount(){if(!sessionStorage.getItem('filtroPesquisa')){this.realizarConsulta();}}},{key:'render',value:function render(){var options={noDataText:'Nenhum requerimento a ser exibido',hideSizePerPage:false,onPageChange:this.paginarResultado,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_8__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var colunas=this.recuperarColunas();return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__consultas_FiltroPesquisa__["a" /* default */],{handleSearchFilter:this.realizarConsulta,handleChangeList:this.tratarFiltroNaLista,list:this.state.listaRequerimentosIndexada,tipoConsulta:'indeferido',listaRequerimentosIndexadaAtualizada:this.state.listaRequerimentosIndexadaAtualizada,auth:this.props.auth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["u" /* Table */],{bordered:true,pagination:true,remote:true,legend:'Requerimentos Indeferidos',data:this.state.listaRequerimentosFiltrada!==null?this.state.listaRequerimentosFiltrada:this.state.listaRequerimentosIndexada,options:options,fetchInfo:fetchInfo,listaTableHeader:colunas}));}}]);return Indeferido;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Indeferido.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])()(Indeferido));

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cadastros_cronograma_pagamentos_InfoCronogramaVisualCompetencia__ = __webpack_require__(215);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable*/var ConsultaCronogramaPagamento=function(_Component){_inherits(ConsultaCronogramaPagamento,_Component);function ConsultaCronogramaPagamento(props){_classCallCheck(this,ConsultaCronogramaPagamento);var _this=_possibleConstructorReturn(this,(ConsultaCronogramaPagamento.__proto__||Object.getPrototypeOf(ConsultaCronogramaPagamento)).call(this,props));_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.lotacao=_this.props.auth.userData.lotacoes[0];_this.executaConsulta=function(){// if (Object.entries(this.state.filtrosConsulta).length !== 0) {
var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('cronogramas-pagamento/lista-cronogramas',_this.tratarSucesso,_this.tratarErro,{'start-position':primeiroItem,'max-results':resultadosPorPagina});};_this.trataSucessoResponseEnvio=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta},_this.trataSucesso);};_this.trataErrosResponse=function(error){if(error&&error.data){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);}};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRegistrosIndexada:response.data,listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){_this.setState({noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}else{_this.setState({noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleChange=function(e,name){_this.setState(Object.assign({},_this.state,_defineProperty({},name,e)));};_this.formatarValorLabel=function(valor){var valorFormatado='';if(valor){valorFormatado=valor.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3});}return valorFormatado;};_this.detalharCronograma=function(row){_this.props.history.push('/cadastros/cronograma-pagamento/detalhe/'+row.mes+'/'+row.ano+'/detalhar');};_this.alterarCronograma=function(row){_this.props.history.push('/cadastros/cronograma-pagamento/detalhe/'+row.mes+'/'+row.ano+'/alterar');};_this.visualizarCronograma=function(row){var indice=row.indiceCronograma;var cronogramaEscolhido=_this.state.listaRegistrosIndexada[indice];var cronogramaPosterior=_this.state.listaRegistrosIndexada[indice-1];var cronogramaAnterior=_this.state.listaRegistrosIndexada[indice+1];var url='/cadastros/cronograma-pagamento/visualizar-cronogramas';_this.props.history.push(url+'/'+cronogramaEscolhido.mes+'/'+cronogramaEscolhido.ano+'/'+cronogramaPosterior.mes+'/'+cronogramaPosterior.ano+'/'+cronogramaAnterior.mes+'/'+cronogramaAnterior.ano);};_this.montaAcoes=function(row){var acaoDetalhar=true;var acaoVisualizar=true;var acaoAlterar=row.habilitarBotao;var botaoAlterar=acaoAlterar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Alterar',icon:'ico-doc-pencil',mini:true,onClick:function onClick(){return _this.alterarCronograma(row);}}):'';var botaoDetalhar=acaoDetalhar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Detalhar',icon:'ico-doc-magnifier',mini:true,onClick:function onClick(){return _this.detalharCronograma(row);}}):'';var botaoVisualizarCalendario=acaoVisualizar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Visualizar',icon:'ico-calendar',mini:true,onClick:function onClick(){return _this.visualizarCronograma(row);}}):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,botaoAlterar,botaoDetalhar,row.habilitarBotaoVisualizar===1?botaoVisualizarCalendario:''));};_this.createActionColumn=function(cell,row){return _this.montaAcoes(row);};_this.montaColunas=function(){var consultaPagamentoTableHeader=_this.colunasDefault.slice();var colunasEspecificas=[];if(colunasEspecificas){colunasEspecificas=colunasEspecificas.concat(consultaPagamentoTableHeader);}colunasEspecificas.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});return colunasEspecificas;};_this.colunasDefault=[{id:'competencia',label:'Competência'},{id:'dataConsultaPrevia',label:'Inicio Consulta Prévia'},{id:'dataEnvioBB',label:'Envio arquivo ao BB'},{id:'dataPrazoPagamento',label:'Prazo de Pagamento'},{id:'dataPrazoDefesa',label:'Marco Limite Defesa'},{id:'dataPrazoAnalise',label:'Marco Limite Análise'}];_this.defineListaParaTabela=function(){if(_this.state.listaRegistrosFiltrada!==null){return _this.state.listaRegistrosFiltrada;}return _this.state.listaRegistrosIndexada;};_this.alterarPagina=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state3=Object.assign({},_this.state),estadoTabela=_this$state3.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.trataSucesso=function(){_this.realizaConsulta(_this.state.filtrosConsulta);Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["J" /* trataMensagemSucesso */])(['Contestação de pagamento criada.']);_this.handleModalContestacao('showContestacaoModal');};_this.trataSucessoResponseEnvio=function(){_this.setState({chaveConfirmacao:null,alertas:[]},_this.trataSucesso);};_this.trataErrosResponse=function(error){if(error&&error.data){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);}};_this.newCadastroCronograma=function(){if(_this.state.listaRegistrosIndexada&&_this.state.listaRegistrosIndexada.length>0&&_this.state.listaRegistrosIndexada[0].ano!==null){var mes=_this.state.listaRegistrosIndexada[0].mes+1;var ano=_this.state.listaRegistrosIndexada[0].ano;if(mes==13){mes=1;ano=ano+1;};_this.props.history.push('/cadastros/cronograma-pagamento/'+mes+'/'+ano+'/novo');}else{var _mes='0';var _ano='0';_this.props.history.push('/cadastros/cronograma-pagamento/'+_mes+'/'+_ano+'/novo');}};_this.state={acao:null,listaRegistrosFiltrada:null,listaRegistrosIndexada:[],registroVindoDoRequest:null,showNoContent:false,listaRegistrosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{},showDocumentUploadModal:false,showContestacaoModal:false,showDadosBancariosModal:false,cronogramaPagamento:{ano:null,mes:null,dataCND:null,dataObitos:null,dataFechamentoPrevia:null,dataConsultaPrevia:null,dataFechamentoFolha:null,dataRelatoriosBG:null,dataRelatoriosBB:null,dataEnvioBB:null,dataPrazoPagamento:null,dataPrazoDefesa:null,dataPrazoAnalise:null}};return _this;}_createClass(ConsultaCronogramaPagamento,[{key:'componentDidMount',value:function componentDidMount(){this.executaConsulta();}/**
   * Trata filtros na lista que veio do servidor (Componente FiltroPagamentos)
   */},{key:'render',value:function render(){var _this2=this;var options={noDataText:'Nenhum Cronograma a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var consultaPagamentoTableHeader=this.montaColunas();return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["u" /* Table */],{legend:'Cronograma de Pagamento',bordered:true,fetchInfo:fetchInfo,data:this.defineListaParaTabela(),options:options,listaTableHeader:consultaPagamentoTableHeader,pagination:true,remote:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["c" /* DtpButton */]//disabled={this.verificaSeCampoDesabilitado()}
,{className:'dtp-primary right',title:'Adicionar Cronograma',accessibilityName:'Adicionar Cronograma',onClick:function onClick(){return _this2.newCadastroCronograma();}}));}}]);return ConsultaCronogramaPagamento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaCronogramaPagamento.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ano:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,participanteUm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,participanteDois:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired};ConsultaCronogramaPagamento.defaultProps={match:null};/* harmony default export */ __webpack_exports__["a"] = (ConsultaCronogramaPagamento);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Provider__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable react/no-unused-state */// import store from '../../reducers';
// import User from '../../domain/User';
var AuthenticationProvider=function(_Component){_inherits(AuthenticationProvider,_Component);function AuthenticationProvider(){_classCallCheck(this,AuthenticationProvider);var _this=_possibleConstructorReturn(this,(AuthenticationProvider.__proto__||Object.getPrototypeOf(AuthenticationProvider)).call(this));_initialiseProps.call(_this);var jwt=__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* getJwt */]();if(jwt){var time=new Date();time.setSeconds(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getParameterByName */]('expires_in'));var ttl=time;_this.state={ttl:ttl,userData:_this.setUserFromDataFromJwt(jwt),jwt:jwt,authVerified:true};return _possibleConstructorReturn(_this);}var token=__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* getParameterByName */]('access_token');_this.state=_this.getInitialState();if(token){_this.state.authVerified=false;_this.requestJwt(token,_this.handleUserDataChange,_this.handleErrorRequestJwt);var comprevBaseUrl=window.comprevConfig.comprevBaseUrl;window.history.replaceState(null,null,comprevBaseUrl);}return _this;}_createClass(AuthenticationProvider,[{key:'getInitialState',value:function getInitialState(){return{authVerified:true,ttl:null,jwt:null,userData:null,token:null,entesControlados:[],codigoParticipante:null};}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.state.authVerified&&this.state.userData&&new Date()>=this.state.userData.exp*1000){// eslint-disable-next-line no-alert
alert('Sessão expirada.');var comprevBaseUrl=window.comprevConfig.comprevBaseUrl;this.state=this.getInitialState();this.state.authVerified=false;__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* logout */]();window.open(''+comprevBaseUrl,'_self');}else if(this.state.authVerified&&this.state.userData&&new Date()<this.state.userData.exp*1000){if(sessionStorage.getItem('comprevConfigLogotipo')){var exibirLogo=JSON.parse(sessionStorage.getItem('comprevConfigLogotipo'));if(exibirLogo.exibirLogo===1){sessionStorage.setItem('comprevConfigLogotipo',JSON.stringify({exibirLogo:0}));window.comprevConfigLogotipo={exibirLogo:0};}}}}// handleCodigoDoParticipante = (r) => {
//  solicitarEntesControlados(r.data.codigo, this.handleEntesControlados);
// }
// handleEntesControlados = (e) => {
//  store.dispatch({ type: 'SALVA_ENTES_CONTROLADOS', payload: e.data });
// }
},{key:'render',value:function render(){if(this.state.authVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Provider__["a" /* default */].Provider,{value:{changeUser:this.handleUserDataChange,checkPermission:this.checkPermission,jwt:this.state.jwt,userData:this.state.userData}},this.props.children);}return null;}}]);return AuthenticationProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.setUserFromDataFromJwt=function(jwt){return JSON.parse(window.atob(jwt.split('.')[1]));};this.requestJwt=function(token,callback,failback){var comprevNewdooUrl=window.comprevConfig.comprevNewdooUrl;var parametrosGerid=[['access_token',token],['modulo','INSS'],['modulo','DATAPREV'],['modulo','MPS'],['modulo','CNPJ'],['includeGranterOu','true']].map(function(e){return e[0]+'='+e[1];}).join('&');var URL=comprevNewdooUrl+'/apis/cas/jwt?'+parametrosGerid;// eslint-disable-next-line no-console
Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])(URL,function(r){return callback(r.data);},failback);};this.handleUserDataChange=function(jwt){__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* storeJwt */](jwt);_this2.setState({authVerified:true,userData:_this2.setUserFromDataFromJwt(jwt)});// if (User.logged().isRPPS()) {
//  solicitarParticipante(User.logged().cnpjDoPapel(), this.handleCodigoDoParticipante);
// }
};this.handleErrorRequestJwt=function(){_this2.setState({authVerified:true});};this.checkPermission=function(allowedPermissions){var permissions=__WEBPACK_IMPORTED_MODULE_4__utils_constants__["e" /* getPermissions */](allowedPermissions);if(_this2.state.userData){var userPermissions=[];_this2.state.userData.roles.forEach(function(role){var roleMatch=role.match(/PA\|(.*?)\|/g);if(roleMatch){userPermissions.push(roleMatch.map(function(permission){return permission.split('|')[1];})[0]);}});return permissions.some(function(allowedPermission){return userPermissions.includes(allowedPermission);});}return false;};};AuthenticationProvider.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element),__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (AuthenticationProvider);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Provider__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrivateRouteWithAuth__ = __webpack_require__(608);
var PrivateRoute=function PrivateRoute(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Provider__["a" /* default */].Consumer,null,function(auth){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PrivateRouteWithAuth__["a" /* default */],Object.assign({auth:auth},props));});};PrivateRoute.defaultProps={permissionsAllowed:[]};PrivateRoute.propTypes={component:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,permissionsAllowed:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)};/* harmony default export */ __webpack_exports__["a"] = (PrivateRoute);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var PrivateRouteWithAuth=function PrivateRouteWithAuth(_ref){var Component=_ref.component,rest=_objectWithoutProperties(_ref,['component']);var auth=rest.auth;// console.log(`LOG === ${rest}`);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],Object.assign({},rest,{render:function render(props){return auth.checkPermission(rest.permissionsAllowed)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({},props,rest)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{to:{pathname:'/'}});}}));};PrivateRouteWithAuth.defaultProps={permissionsAllowed:[]};PrivateRouteWithAuth.propTypes={component:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,permissionsAllowed:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)};/* harmony default export */ __webpack_exports__["a"] = (PrivateRouteWithAuth);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalValorMedioBeneficio__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ValorMedioBeneficio=function(_Component){_inherits(ValorMedioBeneficio,_Component);function ValorMedioBeneficio(props,context){_classCallCheck(this,ValorMedioBeneficio);var _this=_possibleConstructorReturn(this,(ValorMedioBeneficio.__proto__||Object.getPrototypeOf(ValorMedioBeneficio)).call(this,props,context));_this.getInitialState=function(){return{valorMedioBeneficio:{dataCompetencia:null,valorMedioBeneficio:null},valorMedioBeneficioAlteracao:{dataCompetencia:null,valorMedioBeneficio:null},valorMedioBeneficioValidacao:{dataCompetencia:null,valorMedioBeneficio:null,ano:null,mes:null},validadeCampos:{// dataCompetencia: false,
valorMedioBeneficio:false},acaoModal:null,acao:'novo',estadoFormulario:'inicial',noContentPrimaryMessage:'Valor não encontrado para o período informado.',noContentSecondaryMessage:'Informe outro período.',showPeriodoModal:false,showValorMedioBeneficioModal:false};};_this.buscarValoresMediosBeneficios=function(dataCompetencia){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["E" /* requestValoresMediosBeneficios */])(_this.handleErrorBusca,dataCompetencia);};_this.montaFormulario=function(){var paramCompetencia='';if(_this.state.valorMedioBeneficio.dataCompetencia){paramCompetencia=_this.state.valorMedioBeneficio.dataCompetencia;}_this.setState(_this.buscarValoresMediosBeneficios(paramCompetencia));_this.setState({validadeCampos:Object.assign({},_this.state.validadeCampos,{dataCompetencia:false,valorMedioBeneficio:false})});};_this.montaValidadeCampos=function(valorMedioBeneficio){var _this$state=Object.assign({},_this.state),validadeCampos=_this$state.validadeCampos;Object.keys(valorMedioBeneficio).forEach(function(key){validadeCampos[key]=true;});return validadeCampos;};_this.handleErrorBusca=function(error){if(error){// const { data } = { ...error };
if(error.status===404){var competenciaInvalida=false;if(_this.state.validadeCampos.dataCompetencia){if(_this.state.valorMedioBeneficio.dataCompetencia.indexOf('_')!==-1){competenciaInvalida=true;}}if(!competenciaInvalida){_this.state.valorMedioBeneficioAlteracao.dataCompetencia=_this.state.valorMedioBeneficio.dataCompetencia;_this.setState({showValorMedioBeneficioModal:!_this.state.showValorMedioBeneficioModal,valorMedioBeneficioAlteracao:_this.state.valorMedioBeneficioAlteracao,acaoModal:'criar',acao:'novo'});}_this.setState({valorMedioBeneficio:{dataCompetencia:null},validadeCampos:{dataCompetencia:false}});}}};_this.formularioProntoParaEnvio=function(){var _this$state2=Object.assign({},_this.state),acao=_this$state2.acao;var _this$state3=Object.assign({},_this.state),estadoFormulario=_this$state3.estadoFormulario;switch(acao){case'novo':{if(estadoFormulario==='inicial'){return Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);}if(estadoFormulario==='criado'){return true;}return estadoFormulario==='alterado';}default:return false;}};_this.handleChange=function(changeObj,name){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var _this$state4=Object.assign({},_this.state),valorMedioBeneficio=_this$state4.valorMedioBeneficio;_this.setState({valorMedioBeneficio:Object.assign({},valorMedioBeneficio,_defineProperty({},name,changeObj.value)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))},callback);};_this.handleKeyUp=function(e){var retorno=e.target.value;if(retorno.indexOf('_')!==-1){retorno=retorno.toString().replace('_','');}retorno=retorno.toString().replace(/\D/g,'');retorno=retorno.toString().replace(/(\d)(\d{11})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{8})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{5})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{2})$/,'$1,$2');e.target.value=retorno;return retorno;};_this.handleSearchButton=function(){_this.setState(Object.assign({},_this.state),_this.handleSearch);};_this.handleSearch=function(){var paramCompetencia=_this.state.valorMedioBeneficio.dataCompetencia;if(_this.state.validadeCampos.dataCompetencia){var comp=paramCompetencia;if(comp.toString().length>6){if(comp==='__/____'){paramCompetencia='';_this.setState(_this.buscarValoresMediosBeneficios(paramCompetencia));}else{var competenciaComBarra=_this.state.valorMedioBeneficio.dataCompetencia;var competenciaPrimaParte=competenciaComBarra.substring(0,competenciaComBarra.indexOf('/'));var competenciaSeguParte=competenciaComBarra.substring(competenciaComBarra.indexOf('/')+1,competenciaComBarra.toString().length);paramCompetencia=competenciaPrimaParte+competenciaSeguParte;}_this.setState(_this.buscarValoresMediosBeneficios(paramCompetencia));}}else{paramCompetencia='';_this.setState(_this.buscarValoresMediosBeneficios(paramCompetencia));}};_this.handleModal=function(row,tipo){_this.state.valorMedioBeneficioAlteracao.dataCompetencia=row.competencia;_this.state.valorMedioBeneficioAlteracao.valorMedioBeneficio=row.valorMedioBeneficio;_this.setState({showValorMedioBeneficioModal:!_this.state.showValorMedioBeneficioModal,tipo:tipo,valorMedioBeneficioAlteracao:_this.state.valorMedioBeneficioAlteracao});};_this.pesquisar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{title:'Pesquisar',onClick:function onClick(){return _this.handleSearchButton();},hint:'Pesquisar valor da m\xE9dia pela compet\xEAncia'});_this.handleClickCarregarAlteracao=function(row,tipo){_this.setState({acaoModal:'alterar',acao:'alterar'});_this.handleModal(row,tipo);};_this.montaAcaoCargaAlteracao=function(row,tipo){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Alterar compet\xEAncia',icon:'ico-doc-pencil',mini:true,onClick:function onClick(){return _this.handleClickCarregarAlteracao(row,tipo);}});};_this.createActionColumn=function(cell,row){return(// Defeito 291695
// const acoes = this.montaAcaoCargaAlteracao(row, 'modo-alteracao');
// if (!row.exibirBotaoAlteracao) {
//   acoes = '';
// }
// return acoes;
_this.montaAcaoCargaAlteracao(row,'modo-alteracao'));};_this.options={noDataText:'Nenhuma competência cadastrada',hideSizePerPage:false,sizePerPage:10,sizePerPageList:__WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["o" /* linhasPorPagina */]};_this.montaColunas=function(){var valorMedioBeneficioTableHeader=_this.tableHeader.slice();if(_this.props.auth.checkPermission(['analisar-negocio-sprev'])){valorMedioBeneficioTableHeader.push({id:'acao',label:'Ação',dataFormat:_this.createActionColumn});}return valorMedioBeneficioTableHeader;};_this.tableHeader=[{id:'competencia',label:'Competência'},{id:'valorMedioBeneficio',label:'Valor da Média'}];_this.state=_this.getInitialState();return _this;}_createClass(ValorMedioBeneficio,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["g" /* manterApenasFiltro */])('');this.montaFormulario();}/**
   * Para o Formulario estar pronto para envio, deve:
   *  - Ser criacao (acao=novo) e ter todos seus campos validos;
   *  - Ser criacao:
   *     - ter sido enviado com falha em regra de negocio e;
   *     - pelo menos um campo alterado para valido.
   */// this.setState({
//   requerimento: {
//     ...requerimento,
//     [name]: changeObj.value,
//   },
//   validadeCampos: {
//     ...this.state.validadeCampos,
//     [name]: changeObj.isValid,
//   },
//   estadoFormulario,
// }, callback);
/**
   * Trata o click no botão de busca por competencia.
   */},{key:'render',value:function render(){var _this2=this;if(this.state.reset){return null;}if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}var valorMedioBeneficioTableHeader=this.montaColunas();var retorno=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["e" /* DataGrid */],{title:'Valor da M\xE9dia do Benef\xEDcio',icon:'ico-money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["k" /* Input */],{mask:__WEBPACK_IMPORTED_MODULE_6__utils_masks__["a" /* default */].competencia,label:'Compet\xEAncia',onChange:function onChange(e){return _this2.handleChange(e,'dataCompetencia');},value:this.state.valorMedioBeneficio.dataCompetencia})),this.pesquisar)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["u" /* Table */],{bordered:true,data:this.props.valoresMediosBeneficios,options:this.options,listaTableHeader:valorMedioBeneficioTableHeader,pagination:true,scrollTop:'Top'}),this.state.showValorMedioBeneficioModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ModalValorMedioBeneficio__["a" /* default */],{auth:this.props.auth,acao:this.state.acao,acaoModal:this.state.acaoModal,valorMedioBeneficioAlteracao:this.state.valorMedioBeneficioAlteracao,handleModal:function handleModal(){return _this2.handleModal('showValorMedioBeneficioModal');},showModal:this.state.showValorMedioBeneficioModal,estadoFormulario:this.state,handleChange:this.handleChange,handleKeyUp:this.handleKeyUp,handleBlur:this.handleBlur}):'');return retorno;}}]);return ValorMedioBeneficio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ValorMedioBeneficio.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.function}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}),valoresMediosBeneficios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({competencia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valorMedioBeneficio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};ValorMedioBeneficio.defaultProps={match:null,auth:null,valoresMediosBeneficios:null};var mapStateToProps=function mapStateToProps(state){return{valoresMediosBeneficios:state.base.valoresMediosBeneficios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ValorMedioBeneficio));

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalValorMedioBeneficio=function(_Component){_inherits(ModalValorMedioBeneficio,_Component);function ModalValorMedioBeneficio(props,context){_classCallCheck(this,ModalValorMedioBeneficio);var _this=_possibleConstructorReturn(this,(ModalValorMedioBeneficio.__proto__||Object.getPrototypeOf(ModalValorMedioBeneficio)).call(this,props,context));_this.getInitialState=function(){return{valorMedioBeneficio:{dataCompetencia:_this.props.valorMedioBeneficioAlteracao.dataCompetencia,valorMedioBeneficio:_this.props.valorMedioBeneficioAlteracao.valorMedioBeneficio},valorAlteracao:_this.props.valorMedioBeneficioAlteracao.valorMedioBeneficio,touched:false,validadeCampos:{dataCompetencia:true,valorMedioBeneficio:false},acao:'alterar',estadoFormulario:'alteracao',noContentPrimaryMessage:'Valor não encontrado para a competência informada.',noContentSecondaryMessage:'Informe outra competência.'};};_this.buscarValoresMediosBeneficios=function(){Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["E" /* requestValoresMediosBeneficios */])(_this.handleErrorBusca,'');};_this.handleErrorBusca=function(){var mensagemPrimaria='Não foi possível consultar o valor Médio do Beneficio.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({mostraPaginaSemConteudo:true,mensagemPrincipalSemConteudo:mensagemPrimaria,mensagemSecundariaSemConteudo:mensagemSecundaria});};_this.montaFormulario=function(){_this.setState({validadeCampos:Object.assign({},_this.state.validadeCampos,{dataCompetencia:true,valorMedioBeneficio:false})});};_this.formularioProntoParaEnvio=function(){var _this$state=Object.assign({},_this.state),estadoFormulario=_this$state.estadoFormulario;if(estadoFormulario==='alteracao'){return Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);}return false;};_this.handleSaveButton=function(){_this.confirmSendData();};_this.handleChange=function(changeObj,name){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var _this$state2=Object.assign({},_this.state),valorMedioBeneficio=_this$state2.valorMedioBeneficio;_this.setState({valorMedioBeneficio:Object.assign({},valorMedioBeneficio,_defineProperty({},name,changeObj.value)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))},callback);};_this.confirmSendData=function(){var url='valores-medios-beneficios';var touched=true;var competenciaComBarra=_this.state.valorMedioBeneficio.dataCompetencia;var competenciaPrimaParte=competenciaComBarra.substring(0,competenciaComBarra.indexOf('/'));var competenciaSeguParte=competenciaComBarra.substring(competenciaComBarra.indexOf('/')+1,competenciaComBarra.toString().length);var compFinal=competenciaPrimaParte+competenciaSeguParte;if(_this.props.acao!=='novo'){// url = `requerimentos-compensacao-aposentadoria/${this.state.requerimento.protocolo}`;
url='valores-medios-beneficios/'+compFinal;}// Alteração para transformar o valor do campo valorMedioBeneficio
// para numero antes de persistir na tabela.
if(typeof _this.state.valorMedioBeneficio.valorMedioBeneficio!=='number'){var valor=_this.state.valorMedioBeneficio.valorMedioBeneficio;valor=valor.replace(/\./g,'').replace(/,/g,'.');_this.state.valorMedioBeneficio.valorMedioBeneficio=Number(valor);}var _this$state3=Object.assign({},_this.state),validadeCampos=_this$state3.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});_this.setState({touched:touched,validadeCampos:validadeCampos,requestPesquisa:null},function(){return _this.handleSave(url);});};_this.handleSave=function(url){if(_this.formularioProntoParaEnvio()){var options=void 0;if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}var _this$state4=Object.assign({},_this.state),valorMedioBeneficio=_this$state4.valorMedioBeneficio;if(_this.props.acao==='novo'){Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["l" /* doPost */])(url,valorMedioBeneficio,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,options);}else{Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["n" /* doPut */])(url,valorMedioBeneficio,_this.trataSucessoResponseEnvio,_this.trataErrosResponse);}}else{Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["L" /* trataMensagensErro */])(['Informe corretamente os atributos indicados na tela.']);}};_this.trataSucessoResponseEnvio=function(){if(_this.state.chaveConfirmacao){_this.setState({chaveConfirmacao:null,alertas:[],showModal:!_this.state.showModal},_this.trataSucesso);}else{_this.trataSucesso();}};_this.trataSucesso=function(){var mensagemSucesso='';if(_this.props.acao==='novo'){mensagemSucesso='O valor da média foi criado.';}else{mensagemSucesso='O valor da média foi atualizado.';}_this.setState({showAlteracaoValorMedioBeneficioModal:!_this.state.showAlteracaoValorMedioBeneficioModal,valorMedioBeneficio:{dataCompetencia:null,valorMedioBeneficio:null}},_this.handleClose);_this.setState(_this.buscarValoresMediosBeneficios(''));Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["J" /* trataMensagemSucesso */])([mensagemSucesso]);};_this.trataErrosResponse=function(error){if(error&&error.data){var _error=Object.assign({},error),data=_error.data;_this.setState({chaveConfirmacao:data.chaveConfirmacao,alertas:data.alertas,showModalAlerta:!_this.state.showModalAlerta});}};_this.determinaTitulo=function(){var titulo=void 0;if(_this.props.acaoModal==='criar'){titulo='Incluir valor da média';}else{titulo='Alterar valor da média';}return titulo;};_this.modalValorMediaContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["g" /* DataGridSemHeader */],{title:'',icon:'ico-money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:'true',label:'Compet\xEAncia',value:_this.state.valorMedioBeneficio.dataCompetencia})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:!_this.props.auth.checkPermission(['analisar-negocio-sprev']),currency:true,showMask:false,label:'Valor da M\xE9dia',error:!_this.state.valorMedioBeneficio.valorMedioBeneficio,touched:_this.state.touched,maxLength:'16',value:_this.state.valorMedioBeneficio.valorMedioBeneficio,required:_this.props.auth.checkPermission(['analisar-negocio-sprev']),onChange:function onChange(e){return _this.handleChange(e,'valorMedioBeneficio');},onKeyUp:function onKeyUp(e){return _this.props.handleKeyUp(e,'valorMedioBeneficio');}})))));};_this.modalValorMediaFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},_this.props.auth.checkPermission(['gerenciar-negocio-dcomp','analisar-negocio-sprev'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!_this.formularioProntoParaEnvio(),hint:'Salvar',onClick:_this.handleSaveButton,title:'Salvar'}):''));};_this.handleClose=function(){_this.setState(_this.props.handleModal('showAlteracaoValorMedioBeneficioModal'));};_this.state=_this.getInitialState();return _this;}_createClass(ModalValorMedioBeneficio,[{key:'componentDidMount',value:function componentDidMount(){this.montaFormulario();}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.state.valorAlteracao!==this.state.valorMedioBeneficio.valorMedioBeneficio){this.buscarValoresMediosBeneficios('');}}/**
   * Trata envio dos dados
   *//**
   * Trata as acoes dos botao Salvar "Criar Valor medio Beneficio"
   *//**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */// Escolhe o titulo do modal baseado na acao
},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalValorMediaFooter(),conteudomodal:this.modalValorMediaContent(),onHide:this.handleClose,size:'lg',showModal:this.props.showModal,title:this.determinaTitulo()}));}}]);return ModalValorMedioBeneficio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalValorMedioBeneficio.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,valorMedioBeneficioAlteracao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalValorMedioBeneficio);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FiltroCessacao__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConsultaCessacaoBeneficio=function(_Component){_inherits(ConsultaCessacaoBeneficio,_Component);function ConsultaCessacaoBeneficio(props){_classCallCheck(this,ConsultaCessacaoBeneficio);var _this=_possibleConstructorReturn(this,(ConsultaCessacaoBeneficio.__proto__||Object.getPrototypeOf(ConsultaCessacaoBeneficio)).call(this,props));_this.getTipoConsulta=function(){return _this.props.match.params.tipoConsulta;};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.lotacao=_this.props.auth.userData.lotacoes[0];_this.realizaConsulta=function(filtrosPesquisa){// params estados[]: int , cpf : string,
// tipoRequerimento: 1 || 2, participacao: 1 || 2, atributoOrdenacao: string
var filtrosConsulta={};if(filtrosPesquisa){filtrosConsulta=_this.montaFiltros(filtrosPesquisa);}// Copiar atributos além do filtro
var atributosConsulta=_this.verificaAtributosParaConsulta();if(atributosConsulta){if(filtrosConsulta.estado===undefined){filtrosConsulta.estado=atributosConsulta.estados;}filtrosConsulta.participacao=atributosConsulta.tipoParticipacao;// filtrosConsulta['atributo-ordenacao'] = atributosConsulta.campoOrdenacao;
}_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta}),_this.executaConsulta);};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('requerimentos-cessacao',_this.tratarSucesso,_this.tratarErro,Object.assign({},_this.state.filtrosConsulta,{'unidade-inss':_this.lotacao,'start-position':primeiroItem,'max-results':resultadosPorPagina}));}else{_this.setState({listaRequerimentosIndexada:[],listaRequerimentosIndexadaAtualizada:true});}};_this.montaFiltros=function(atributosPesquisa){var atributos={participacao:atributosPesquisa.participacao,'unidade-inss':_this.lotacao};if(atributosPesquisa.cpf){atributos=Object.assign({},atributos,{cpf:atributosPesquisa.cpf});}if(atributosPesquisa.tipoRequerimento){atributos=Object.assign({},atributos,{'tipo-requerimento':atributosPesquisa.tipoRequerimento});}var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;if(atributosPesquisa.cliqueiNoBotao===1){_this.state.estadoTabela.paginaAtual=1;}var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.verificaAtributosParaConsulta=function(){if(_this.getTipoConsulta()){return __WEBPACK_IMPORTED_MODULE_7__utils_constants__["c" /* estadosParaConsulta */][_this.getTipoConsulta()];}return null;};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRequerimentosIndexada:[],listaRequerimentosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRequerimentosIndexada:response.data,listaRequerimentosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarFiltroNaLista=function(listaRequerimentosFiltrada){_this.setState({listaRequerimentosFiltrada:listaRequerimentosFiltrada,listaRequerimentosIndexadaAtualizada:false});};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.setState({showNoContent:true,noContentPrimaryMessage:'Requerimento não encontrado para o protocolo informado.',noContentSecondaryMessage:'Informe um protocolo válido.'});}else{_this.setState({showNoContent:true,noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}}else{_this.setState({showNoContent:true,noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleModal=function(modal){_this.setState(_defineProperty({},modal,!_this.state[modal]));};_this.pushNavegacao=function(tipo,row){if(!_this.getTipoConsulta()){_this.props.history.push('/requerimento/'+tipo+'/'+row.protocolo);}else{var atributosConsulta=_this.verificaAtributosParaConsulta();if(tipo&&row){_this.props.history.push('/requerimento/'+tipo+'/'+row.protocolo+'/'+atributosConsulta.acao);}else{_this.props.history.push('/requerimento/'+_this.state.tipoRequerimentoSelecionado+'/'+_this.state.requerimentoVindoDoRequest.protocolo+'/'+atributosConsulta.acao);}}};_this.diffRequerimento=function(tipoRequerimento){if(tipoRequerimento===2){return'pensao';}return'aposentadoria';};_this.showRequerimentoCessacao=function(requerimento){// let tipo = 'pensao';
// if (requerimento.tipoRequerimento === 1) {
//   tipo = 'aposentadoria';
// }
var tipo=requerimento.tipoRequerimento;_this.setState({tipoRequerimento:requerimento.tipoRequerimento});// doGet(
//   `requerimentos-cessacao-${tipo}/${requerimento.protocolo}`,
//   this.handleResponseCessacaoRequerimento,
// );
_this.props.history.push('/requerimento/cessacao/'+tipo+'/'+requerimento.protocolo+'/cessar-requerimento');};_this.montaAcoesCessacaoBeneficio=function(row,tipo){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:tipo,icon:'ico-doc-pencil',mini:true// onClick={() => this.showCessacaoBeneficioModal(row, tipo)}
,onClick:function onClick(){return _this.showRequerimentoCessacao(row);}});};_this.createActionColumn=function(cell,row){var tipo='pensao';if(row.tipoRequerimento===1){tipo='aposentadoria';}return _this.montaAcoesCessacaoBeneficio(row,tipo);};_this.addTipoRequerimentoLabel=function(tipo){return __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["M" /* tipoRequerimento */],tipo).label;};_this.addTipoEstadoLabel=function(tipo){if(tipo===15){return'Exigência/indeferido';}if(tipo===16){return'Indeferimento ratificado';}return __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};_this.colunasDefault=[{id:'cpf',label:'CPF'},{id:'nome',label:'Nome'},{id:'matricula',label:'Matrícula'},{id:'nomeSolicitante',label:'Solicitante'},{id:'nomeDestinatario',label:'Destinatário'},{id:'tipoRequerimento',label:'Tipo',dataFormat:_this.addTipoRequerimentoLabel},{id:'estado',label:'Estado',dataFormat:_this.addTipoEstadoLabel}];_this.montaColunas=function(){var requerimentosExigenciaTableHeader=_this.colunasDefault.slice();requerimentosExigenciaTableHeader.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});return requerimentosExigenciaTableHeader;};_this.defineListaParaTabela=function(){if(_this.state.listaRequerimentosFiltrada!==null){return _this.state.listaRequerimentosFiltrada;}return _this.state.listaRequerimentosIndexada;};_this.alterarPagina=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state3=Object.assign({},_this.state),estadoTabela=_this$state3.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.state={listaRequerimentosFiltrada:null,listaRequerimentosIndexada:[],requerimentoVindoDoRequest:null,tipoRequerimentoSelecionado:null,// showCessacaoBeneficioModal: false,
// requerimentoModalCessacao: {},
showNoContent:false,listaRequerimentosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},tipoRequerimento:null,filtrosPesquisa:{}};return _this;}_createClass(ConsultaCessacaoBeneficio,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["g" /* manterApenasFiltro */])('filtroCessacao');}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
// console.log(this.props.match.params.tipoConsulta !== prevProps.match.params.tipoConsulta);
if(this.props.match.params.tipoConsulta!==prevProps.match.params.tipoConsulta){this.preparaNovaConsulta();}}/**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */// handleResponseCessacaoRequerimento = (response) => {
//   // let tipo = 'pensao';
//   // if (response.data.tipoAposentadoria) {
//   //   tipo = 'aposentadoria';
//   // }
//   const tipo = this.state.tipoRequerimento
//   this.props.history.push(`/requerimento/
// cessacao/${tipo}/${response.data.protocolo}/cessar-requerimento`);
//   // /requerimento/${tipo}/${response.data.protocolo}/cessar-requerimento`
// }
},{key:'render',value:function render(){var options={noDataText:'Nenhum requerimento a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var requerimentosExigenciaTableHeader=this.montaColunas();return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FiltroCessacao__["a" /* default */],{handleSearchFilter:this.realizaConsulta,handleChangeList:this.tratarFiltroNaLista,destinatarios:this.props.destinatarios,list:this.state.listaRequerimentosIndexada,tipoConsulta:this.getTipoConsulta(),listaRequerimentosIndexadaAtualizada:this.state.listaRequerimentosIndexadaAtualizada}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["u" /* Table */],{legend:'Cessa\xE7\xE3o Manual de Requerimentos',bordered:true,fetchInfo:fetchInfo,data:this.defineListaParaTabela(),options:options,listaTableHeader:requerimentosExigenciaTableHeader,pagination:true,remote:true}));}}]);return ConsultaCessacaoBeneficio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaCessacaoBeneficio.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoRequerimento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func})};ConsultaCessacaoBeneficio.defaultProps={destinatarios:[],match:null,// exigencias: [],
auth:null};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios// exigencias: state.base.exigencias,
};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ConsultaCessacaoBeneficio));

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FiltroCessacao=function(_Component){_inherits(FiltroCessacao,_Component);function FiltroCessacao(){_classCallCheck(this,FiltroCessacao);var _this=_possibleConstructorReturn(this,(FiltroCessacao.__proto__||Object.getPrototypeOf(FiltroCessacao)).call(this));_this.preparaNovaConsulta=function(){var filtroCessacao={cpf:null,tipoRequerimento:null};filtroCessacao=JSON.stringify(filtroCessacao);sessionStorage.setItem('filtroCessacao',filtroCessacao);_this.setState({cpf:null,tipoRequerimento:null});};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value));};_this.handleSearchButton=function(){var filtroCessacao={cpf:_this.state.cpf,tipoRequerimento:_this.state.tipoRequerimento};filtroCessacao=JSON.stringify(filtroCessacao);sessionStorage.setItem('filtroCessacao',filtroCessacao);_this.setState({cliqueiNoBotao:1},function(){_this.handleChange({value:1,isValid:true},'cliqueiNoBotao');});_this.handleSearch();};_this.handleListFilter=function(){var listaFiltrada=_this.props.list;if(_this.state.filtraExigenciaHomologacao){listaFiltrada=listaFiltrada.filter(function(requerimento){var exigenciasDiferentesHomologacao=requerimento.exigencias.filter(function(exigencia){return exigencia.tipo!==(6||23);});if(exigenciasDiferentesHomologacao.length>0)return true;return false;});}_this.props.handleChangeList(listaFiltrada);};_this.handleSearch=function(){if(_this.state.cpf||_this.state.tipoRequerimento){_this.props.handleSearchFilter(_this.state);}else{Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Escolha pelo menos um filtro de CPF ou de Tipo de Requerimento para a consulta']);}};_this.filtroCessacao=JSON.parse(sessionStorage.getItem('filtroCessacao'));_this.state={cpf:_this.filtroCessacao&&_this.filtroCessacao.cpf?_this.filtroCessacao.cpf:null,tipoRequerimento:_this.filtroCessacao&&_this.filtroCessacao.tipoRequerimento?_this.filtroCessacao.tipoRequerimento:null,filtro:_this.filtroCessacao&&_this.filtroCessacao.filtro?_this.filtroCessacao.filtro:null};return _this;}_createClass(FiltroCessacao,[{key:'componentDidMount',value:function componentDidMount(){if(sessionStorage.getItem('filtroCessacao')){this.handleSearchButton();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.tipoConsulta!==prevProps.tipoConsulta){this.preparaNovaConsulta();}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'pesquisa',panelId:'filtro-pesquisa',icon:'ico-filter',title:'Filtro de Pesquisa'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{cpf:true,integer:true,label:'CPF',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].cpf,onChange:function onChange(e){return _this2.handleChange(e,'cpf');},showMask:true,value:this.state.cpf,validationState:'active'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Tipo de Requerimento',name:'tipoRequerimento',onChange:function onChange(e){return _this2.handleChange(e,'tipoRequerimento');},itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["N" /* tipoRequerimentoFilter */],radio:true,value:this.state.tipoRequerimento,validationState:'active',custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroCessacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroCessacao.propTypes={destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf().isRequired,handleChangeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroCessacao);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FiltroBloqueioDesbloqueio__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { manterApenasFiltro } from '../../utils/helpers';
var ConsultaBloqueio=function(_Component){_inherits(ConsultaBloqueio,_Component);function ConsultaBloqueio(props){_classCallCheck(this,ConsultaBloqueio);var _this=_possibleConstructorReturn(this,(ConsultaBloqueio.__proto__||Object.getPrototypeOf(ConsultaBloqueio)).call(this,props));_this.getTipoConsulta=function(){return _this.props.match.params.tipoConsulta;};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaBloqueiosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.lotacao=_this.props.auth.userData.lotacoes[0];_this.buscaDadosParticipanteSuccess=function(response){_this.setState({participante:Object.assign({},response.data)});};_this.handleErrorDadosParticipante=function(error){if(error){if(error.status){if(error.status===404){_this.state.participante.cnpj=null;_this.state.participante.uf=null;_this.setState({showNoContent:false,listaBloqueiosIndexada:[],listaBloqueiosIndexadaAtualizada:true,noContentPrimaryMessage:'Ente Federativo não encontrado para o cnpj informado.',noContentSecondaryMessage:'Informe um cnpj válido.'});}}}};_this.buscaDadosParticipante=function(codigo){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('participantes-compensacao/codigo/'+codigo,_this.buscaDadosParticipanteSuccess,_this.handleErrorDadosParticipante);};_this.buscaDadosCompetenciaPagamentoSuccess=function(response){var objCompetencia=response.data.competencia;if(objCompetencia.length!==7){objCompetencia='0'+objCompetencia;}_this.setState({competenciaAberta:objCompetencia});};_this.handleErrorDadosCompetenciaPagamento=function(){_this.setState({existeCompetenciaInicial:false});};_this.buscaCompetenciaPagamentoAberta=function(){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('fechamento-pagamentos/pagamento-aberto',_this.buscaDadosCompetenciaPagamentoSuccess,_this.handleErrorDadosCompetenciaPagamento);};_this.realizaConsulta=function(filtrosPesquisa){// params estados[]: int , cpf : string,
// tipoRequerimento: 1 || 2, participacao: 1 || 2, atributoOrdenacao: string
// let { participante } = { ...this.state.participante };
var filtrosConsulta={};if(filtrosPesquisa){filtrosConsulta=_this.montaFiltros(filtrosPesquisa);if(filtrosPesquisa['destinatario-rpps']!==null){_this.buscaDadosParticipante(filtrosPesquisa['destinatario-rpps']);}// if (filtrosPesquisa['destinatario-rpps'] === null) {
//   participante = null;
// }
}_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta}),_this.executaConsulta);};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('bloqueios',_this.tratarSucesso,_this.tratarErro,Object.assign({},_this.state.filtrosConsulta,{'start-position':primeiroItem,'max-results':resultadosPorPagina}));}else{_this.setState({listaBloqueiosIndexada:[],listaBloqueiosIndexadaAtualizada:true});}};_this.montaFiltros=function(atributosPesquisa){var atributos=[];if(atributosPesquisa['destinatario-rpps']){atributos=Object.assign({},atributos,{'destinatario-rpps':atributosPesquisa['destinatario-rpps']});}if(atributosPesquisa.competenciaAberta){atributos=Object.assign({},atributos,{competenciaAberta:atributosPesquisa.competenciaAberta});}var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;if(atributosPesquisa.cliqueiNoBotao===1){_this.state.estadoTabela.paginaAtual=1;}var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.verificaAtributosParaConsulta=function(){if(_this.getTipoConsulta()){return __WEBPACK_IMPORTED_MODULE_7__utils_constants__["c" /* estadosParaConsulta */][_this.getTipoConsulta()];}return null;};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaBloqueiosIndexada:[],listaBloqueiosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaBloqueiosIndexada:response.data,listaBloqueiosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarFiltroNaLista=function(listaBloqueiosFiltrada){_this.setState({listaBloqueiosFiltrada:listaBloqueiosFiltrada,listaBloqueiosIndexadaAtualizada:false});};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.setState({showNoContent:true,noContentPrimaryMessage:'Ente não encontrado para o cnpj informado.',noContentSecondaryMessage:'Informe um cnpj válido.'});}else{_this.setState({showNoContent:true,noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}}else{_this.setState({showNoContent:true,noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleModal=function(modal){_this.setState(_defineProperty({},modal,!_this.state[modal]));};_this.showBloqueioDesbloqueio=function(bloqueio){var data=bloqueio.dataInclusaoBloqueio;var dataSplit=data.split('/');var dia=dataSplit[0];var mes=dataSplit[1];var ano=dataSplit[2];var primeiraParte=_this.state.participante.codigo;if(_this.state.participante.codigo===null||_this.state.filtrosConsulta.competenciaAberta){primeiraParte=bloqueio.idParticipante;}var chave=''+primeiraParte+dia+mes+ano;_this.props.history.push('/cadastros/entesFederativos/bloqueio/desbloquear-ente/'+chave+'/'+bloqueio.mesInicioBloqueio+'/'+bloqueio.anoInicioBloqueio+'/'+bloqueio.tipoBloqueio);};_this.montaAcoes=function(row,tipo,possuiPermissaoDesbloqueio){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:tipo// icon={row.dataEncerramentoBloqueio ? 'ico-doc-magnifier' : 'ico-doc-pencil'}
,icon:!row.dataEncerramentoBloqueio&&possuiPermissaoDesbloqueio?'ico-doc-pencil':'ico-doc-magnifier',mini:true,onClick:function onClick(){return _this.showBloqueioDesbloqueio(row);}});};_this.verificarPermissaoDesbloqueio=function(row){var possuiPermissaoDesbloqueio=false;switch(row.tipoBloqueio){case 1:// CND
if(_this.props.auth.checkPermission(['gerenciar-negocio-dcomp'])){possuiPermissaoDesbloqueio=true;}break;case 2:// JUDICIAL
if(_this.props.auth.checkPermission(['gerenciar-negocio-dcomp','analisar-negocio-sprev'])){possuiPermissaoDesbloqueio=true;}break;case 3:// ALUGUEL
if(_this.props.auth.checkPermission(['gerenciar-negocio-dcomp'])){possuiPermissaoDesbloqueio=true;}break;case 4:// Contrato Dataprev
if(_this.props.auth.checkPermission(['analisar-contrato-dtpv'])){possuiPermissaoDesbloqueio=true;}break;case 5:// Inadimplência
if(_this.props.auth.checkPermission(['gerenciar-negocio-dcomp','analisar-negocio-sprev'])){possuiPermissaoDesbloqueio=true;}break;default:break;}return possuiPermissaoDesbloqueio;};_this.createActionColumn=function(cell,row){var possuiPermissaoDesbloqueio=_this.verificarPermissaoDesbloqueio(row);// let hint = 'Desbloquear o ente federativo';
var hint='';if(row.dataEncerramentoBloqueio||!possuiPermissaoDesbloqueio){hint='Visualizar o ente federativo';}if(!row.dataEncerramentoBloqueio&&possuiPermissaoDesbloqueio){hint='Desbloquear o ente federativo';}return _this.montaAcoes(row,hint,possuiPermissaoDesbloqueio);};_this.addMotivoBloqueioDesloqueioLabel=function(tipo){var valor='';if(tipo){valor=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["q" /* motivosBloqueio */],tipo).label;}return valor;};_this.formatarCompetencia=function(competenciaInicioBloqueio){var valor='';if(competenciaInicioBloqueio){if(competenciaInicioBloqueio.length===6){valor='0'+competenciaInicioBloqueio;}else{valor=competenciaInicioBloqueio;}}return valor;};_this.colunasDefault=[{id:'competenciaInicioBloqueio',label:'Competência Inicial',dataFormat:_this.formatarCompetencia},{id:'competenciaFimBloqueio',label:'Competência Final',dataFormat:_this.formatarCompetencia},{id:'tipoBloqueio',label:'Motivo do Bloqueio',dataFormat:_this.addMotivoBloqueioDesloqueioLabel},{id:'tipoDesbloqueio',label:'Motivo do Desbloqueio',dataFormat:_this.addMotivoBloqueioDesloqueioLabel}];_this.colunasDefaultCompetenciaAberta=[{id:'nomeParticipante',label:'Participante'},{id:'cnpj',label:'CNPJ'},{id:'competenciaInicioBloqueio',label:'Competência Inicial',dataFormat:_this.formatarCompetencia},{id:'competenciaFimBloqueio',label:'Competência Final',dataFormat:_this.formatarCompetencia},{id:'tipoBloqueio',label:'Motivo do Bloqueio',dataFormat:_this.addMotivoBloqueioDesloqueioLabel},{id:'tipoDesbloqueio',label:'Motivo do Desbloqueio',dataFormat:_this.addMotivoBloqueioDesloqueioLabel}];_this.montaColunas=function(){var bloqueiosTableHeader=_this.colunasDefault.slice();if(_this.state.filtrosConsulta){if(_this.state.filtrosConsulta.competenciaAberta&&!_this.state.filtrosConsulta['destinatario-rpps']){bloqueiosTableHeader=_this.colunasDefaultCompetenciaAberta.slice();}}bloqueiosTableHeader.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});return bloqueiosTableHeader;};_this.alterarPagina=function(pagina){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.paginaAtual=pagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state3=Object.assign({},_this.state),estadoTabela=_this$state3.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.newCadastroBloqueio=function(){// this.props.history.push('/cadastros/entesFederativos/bloqueio/novo');
var _this$props=Object.assign({},_this.props),filtroBloqueio=_this$props.filtroBloqueio;var paramFiltroBloqueio=filtroBloqueio;if(paramFiltroBloqueio!==null){paramFiltroBloqueio=JSON.parse(filtroBloqueio);var paramDestinatario=paramFiltroBloqueio['destinatario-rpps'];var paramTipoEntidade=paramFiltroBloqueio.tipoEntidade;var paramUf=paramFiltroBloqueio.uf;_this.props.history.push('/cadastros/entesFederativos/bloqueio/novo/\n        '+paramTipoEntidade+'/'+paramUf+'/'+paramDestinatario);}else{_this.props.history.push('/cadastros/entesFederativos/bloqueio/novo');}};_this.montaComplemento=function(){var _this$state4=Object.assign({},_this.state),participante=_this$state4.participante;var _this$state5=Object.assign({},_this.state),filtrosConsulta=_this$state5.filtrosConsulta;var _this$state6=Object.assign({},_this.state),competenciaAberta=_this$state6.competenciaAberta;var complemento='';if(filtrosConsulta){if(competenciaAberta&&filtrosConsulta['destinatario-rpps']){if(participante){var ufEnte='';var cnpjEnte='';if(participante.uf!==''){ufEnte='- '+participante.uf;}if(participante.cnpjEf!==undefined){cnpjEnte='- CNPJ: '+Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["d" /* formatarCnpj */])(participante.cnpjEf);}complemento=cnpjEnte+' '+ufEnte+' - '+participante.nome;return complemento;}}else{complemento='- at\xE9 a compet\xEAncia: '+competenciaAberta;return complemento;}}return complemento;};_this.verificaSeCampoDesabilitado=function(){var _this$state7=Object.assign({},_this.state),existeCompetenciaInicial=_this$state7.existeCompetenciaInicial;if(existeCompetenciaInicial===false){return true;}return false;};_this.state={listaBloqueiosFiltrada:null,listaBloqueiosIndexada:[],bloqueioVindoDoRequest:null,tipoBloqueioSelecionado:null,showNoContent:false,listaBloqueiosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},complemento:'',filtrosPesquisa:{},existeCompetenciaInicial:true,competenciaAberta:null,participante:{codigo:null,tipoRegime:null,nome:null,cnpj:null,cnpjEf:null,tipoRegimeProprio:null,uf:null}};return _this;}_createClass(ConsultaBloqueio,[{key:'componentDidMount',value:function componentDidMount(){// manterApenasFiltro('filtroBloqueio');
sessionStorage.removeItem('filtroBloqueio');if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}this.buscaCompetenciaPagamentoAberta();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.match.params.tipoConsulta!==prevProps.match.params.tipoConsulta){this.preparaNovaConsulta();}}/**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */// Motivos de Desbloqueio x Usuários
// Código Descrição         Usuário
// 1      CND               GESTOR_DCOMP
// 2      Aluguel           GESTOR_DCOMP
// 3      Judicial          GESTOR_DCOMP|ANALISTA_SPREV|ANALISTA_CONTRATO_DTP
// 4      Contrato Dataprev ANALISTA_CONTRATO_DTP
// 5      Inadimplência     GESTOR_DCOMP
// TABELA BLOQUEIOS
// Classificador para o tipo de bloqueio  CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
// CS_TIPO_BLOQUEIO Classificador para o tipo de bloqueio  CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
// Classificador  do tipo do desbloqueio CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
// CS_TIPO_DESBLOQUEIO Classificador  do tipo do desbloqueio CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
},{key:'render',value:function render(){var _this2=this;var options={noDataText:'Nenhum bloqueio a ser exibido',hideSizePerPage:true,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var bloqueiosTableHeader=this.montaColunas();return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FiltroBloqueioDesbloqueio__["a" /* default */],{handleSearchFilter:this.realizaConsulta,handleChangeList:this.tratarFiltroNaLista,destinatarios:this.props.destinatarios,list:this.state.listaBloqueiosIndexada,tipoConsulta:this.getTipoConsulta(),listaBloqueiosIndexadaAtualizada:this.state.listaBloqueiosIndexadaAtualizada,existeCompetenciaInicial:this.state.existeCompetenciaInicial,competenciaAberta:this.state.competenciaAberta}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["u" /* Table */],{legend:'Bloqueio / Desbloqueio do Ente Federativo '+this.montaComplemento(),bordered:true,fetchInfo:fetchInfo,data:this.state.listaBloqueiosIndexada,options:options,listaTableHeader:bloqueiosTableHeader,pagination:true,remote:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["c" /* DtpButton */],{disabled:this.verificaSeCampoDesabilitado(),className:'dtp-primary right',title:'Adicionar Bloqueio',accessibilityName:'Adicionar Bloqueio',onClick:function onClick(){return _this2.newCadastroBloqueio();}}));}}]);return ConsultaBloqueio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaBloqueio.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({chave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ano:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}),destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),filtroBloqueio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({'destinatario-rpps':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoEntidade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,uf:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,competenciaAberta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})};ConsultaBloqueio.defaultProps={match:null,auth:null,destinatarios:[],filtroBloqueio:null};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios,filtroBloqueio:state.base.filtroBloqueio};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ConsultaBloqueio));

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FiltroBloqueioDesbloqueio=function(_Component){_inherits(FiltroBloqueioDesbloqueio,_Component);function FiltroBloqueioDesbloqueio(){_classCallCheck(this,FiltroBloqueioDesbloqueio);var _this=_possibleConstructorReturn(this,(FiltroBloqueioDesbloqueio.__proto__||Object.getPrototypeOf(FiltroBloqueioDesbloqueio)).call(this));_this.controleFiltrosAlternativos=function(campo){switch(campo){case'destinatario-rpps':return['gerenciar-negocio-dcomp','analisar-negocio-sprev','analisar-contrato-dtpv'];default:return[];}};_this.preparaNovaConsulta=function(){var filtroBloqueio={'destinatario-rpps':null,tipoEntidade:null,uf:null};filtroBloqueio=JSON.stringify(filtroBloqueio);sessionStorage.setItem('filtroBloqueio',filtroBloqueio);_this.setState({'destinatario-rpps':null,tipoEntidade:null,uf:null});};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.trataFormulario=function(campoAlterado){if(campoAlterado==='tipoEntidade'){_this.trataTipoEntidade();}if(campoAlterado==='uf'){_this.trataUf();}if(campoAlterado==='destinatario-rpps'){var filtroBloqueio={'destinatario-rpps':_this.state['destinatario-rpps'],tipoEntidade:_this.state.tipoEntidade,uf:_this.state.uf,competenciaAberta:_this.props.competenciaAberta};filtroBloqueio=JSON.stringify(filtroBloqueio);Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["C" /* requestSalvaFiltroBloqueio */])(filtroBloqueio);}};_this.trataUf=function(){_this.setState({'destinatario-rpps':null});};_this.trataCombosEntidade=function(){_this.setState({tipoEntidade:null,'destinatario-rpps':null,uf:null});};_this.trataTipoEntidade=function(){_this.setState({'destinatario-rpps':null,uf:null});};_this.handleSearchButton=function(){var filtroBloqueio={'destinatario-rpps':_this.state['destinatario-rpps'],tipoEntidade:_this.state.tipoEntidade,uf:_this.state.uf,competenciaAberta:_this.props.competenciaAberta};filtroBloqueio=JSON.stringify(filtroBloqueio);sessionStorage.setItem('filtroBloqueio',filtroBloqueio);_this.setState({cliqueiNoBotao:1},function(){_this.handleChange({value:1,isValid:true},'cliqueiNoBotao');});_this.handleSearch();};_this.handleSearch=function(){if(_this.props.competenciaAberta!=null){_this.state.competenciaAberta=_this.props.competenciaAberta;}if(!_this.props.existeCompetenciaInicial){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Não existe competência de pagamento aberta.']);}else if(_this.state.tipoEntidade&&_this.props.existeCompetenciaInicial){if(_this.state.tipoEntidade===2&&!_this.state.uf&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha uma UF']);return;}if(_this.state.tipoEntidade&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha um filtro de destinatário para a consulta']);return;}if(_this.state.tipoEntidade&&_this.state.uf&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha um filtro de destinatário para a consulta']);return;}_this.props.handleSearchFilter(_this.state);}else if(!_this.state.tipoEntidade&&_this.props.existeCompetenciaInicial){_this.props.handleSearchFilter(_this.state);}else{Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha pelo menos um filtro de Ente federativo para a consulta.']);}};_this.listaFiltradaDestinatarios=function(){var listaParticipantes=_this.props.destinatarios.filter(function(item){if(item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)){return item;}return null;});return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.handleChangeTipoFiltro=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.verificaSeCampoDesabilitado=function(){if(_this.props.existeCompetenciaInicial===false){return true;}return false;};_this.montaFiltrosDefault=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Compet\xEAncia',onChange:function onChange(e){return _this.handleChange(e,'competenciaAberta');},value:_this.props.competenciaAberta,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:_this.verificaSeCampoDesabilitado(),label:'Tipo',onChange:function onChange(e){return _this.handleChange(e,'tipoEntidade');},placeholder:'Selecione a entidade',value:_this.state.tipoEntidade,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["E" /* tipoEntidade */],custom:true,number:true})),_this.state.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'UF',onChange:function onChange(e){return _this.handleChange(e,'uf');},placeholder:'Selecione a UF',value:_this.state.uf,itemList:_this.carregaUfDosMunicipios(),custom:true})):'',_this.state.tipoEntidade?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Nome',name:'destinatario-rpps',onChange:function onChange(e){return _this.handleChange(e,'destinatario-rpps');},placeholder:'Selecione o destinat\xE1rio',value:_this.state['destinatario-rpps'],itemList:_this.listaFiltradaDestinatarios(),custom:true})):''));};_this.montaFiltros=function(){if(_this.props.tipoConsulta){return _this.montaFiltrosDefault();}return null;};_this.filtroBloqueio=JSON.parse(sessionStorage.getItem('filtroBloqueio'));_this.state={'destinatario-rpps':_this.filtroBloqueio&&_this.filtroBloqueio['destinatario-rpps']?_this.filtroBloqueio['destinatario-rpps']:null,cliqueiNoBotao:_this.filtroBloqueio&&_this.filtroBloqueio.cliqueiNoBotao?_this.filtroBloqueio.cliqueiNoBotao:null,tipoEntidade:_this.filtroBloqueio&&_this.filtroBloqueio.tipoEntidade?_this.filtroBloqueio.tipoEntidade:null,uf:_this.filtroBloqueio&&_this.filtroBloqueio.uf?_this.filtroBloqueio.uf:null,competenciaAberta:_this.filtroBloqueio&&_this.filtroBloqueio.competenciaAberta?_this.filtroBloqueio.competenciaAberta:null,tipoFiltroBloqueio:_this.filtroBloqueio&&_this.filtroBloqueio.tipoFiltroBloqueio?_this.filtroBloqueio.tipoFiltroBloqueio:null};return _this;}_createClass(FiltroBloqueioDesbloqueio,[{key:'componentDidMount',value:function componentDidMount(){this.preparaNovaConsulta();// if (sessionStorage.getItem('filtroBloqueio')) {
//   this.handleSearchButton();
// }
// this.buscaCompetenciaPagamentoAberta();
}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.tipoConsulta!==prevProps.tipoConsulta){this.preparaNovaConsulta();}}/**
   * Encaminha para as funcoes que tratam alteracoes em cada campo
   */},{key:'render',value:function render(){var _this2=this;var filtrosPesquisa=this.montaFiltros();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'pesquisa',panelId:'filtro-pesquisa',icon:'ico-filter',title:'Filtro de Pesquisa'},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{disabled:this.verificaSeCampoDesabilitado(),className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroBloqueioDesbloqueio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroBloqueioDesbloqueio.propTypes={destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf().isRequired,handleChangeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,existeCompetenciaInicial:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,competenciaAberta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroBloqueioDesbloqueio);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DadosBloqueioDesbloqueio__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__requerimentos_ModalAlerta__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BloqueioDesbloqueioEnte=function(_Component){_inherits(BloqueioDesbloqueioEnte,_Component);function BloqueioDesbloqueioEnte(props,context){_classCallCheck(this,BloqueioDesbloqueioEnte);var _this=_possibleConstructorReturn(this,(BloqueioDesbloqueioEnte.__proto__||Object.getPrototypeOf(BloqueioDesbloqueioEnte)).call(this,props,context));_this.getInitialState=function(){return{bloqueio:{mesInicioBloqueio:null,anoInicioBloqueio:null,dataInclusaoBloqueio:null,mesFimBloqueio:null,anoFimBloqueio:null,dataEncerramentoBloqueio:null,idParticipante:null,tipoBloqueio:null,competenciaInicioBloqueio:null,competenciaFimBloqueio:null,motivoBloqueio:null,descricaoMotivo:null,tipoDesbloqueio:null},participante:{codigo:null,tipoRegime:null,nome:null,cnpj:null,cnpjEf:null,tipoRegimeProprio:null,uf:null},tipoEntidade:null,uf:null,bloqueioPesquisa:{mesInicioBloqueio:null,anoInicioBloqueio:null,idParticipante:null,tipoBloqueio:null,dataInclusaoBloqueio:null},existeCompetenciaInicial:true,touched:false,validadeCampos:{tipoBloqueio:false,tipoDesbloqueio:false},enteBloqueado:true,acao:'novo',estadoFormulario:'inicial',showNoContent:false,noContentPrimaryMessage:'Bloqueio não encontrado para o participante informado.',noContentSecondaryMessage:'Informe um cnpj válido.',requestPesquisa:null,showModalAlerta:false,chaveConfirmacao:null,listaMotivosBloqueio:[],listaMotivosDesbloqueio:[],usuarioPossuiPermissaoDesbloqueio:false};};_this.handleErrorBusca=function(){var mensagemPrimaria='Não foi possível consultar o participante.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({mostraPaginaSemConteudo:true,mensagemPrincipalSemConteudo:mensagemPrimaria,mensagemSecundariaSemConteudo:mensagemSecundaria});};_this.buscaDadosParticipanteSuccess=function(response){_this.setState({participante:Object.assign({},_this.state.participante,response.data)});};_this.handleErrorDadosParticipante=function(error){var mensagemPrimaria='Não foi possível consultar o ente federativo.';var mensagemSecundaria='Contate o administrador do sistema.';if(error){if(error.status){if(error.status===404){mensagemPrimaria='Ente Federativo não encontrado para o cnpj informado.';mensagemSecundaria='Informe um cnpj válido.';}}}_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.handleErrorDadosCompetenciaPagamento=function(error){var mensagemPrimaria='Não foi possível consultar a competência de início do bloqueio.';var mensagemSecundaria='Contate o administrador do sistema.';if(error){if(error.status){if(error.status===404){mensagemPrimaria='Competência de início do bloqueio não encontrada.';mensagemSecundaria='Informe um cnpj válido.';}}}_this.setState({existeCompetenciaInicial:false,showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.buscaDadosCompetenciaPagamentoSuccess=function(response){var _this$state=Object.assign({},_this.state),bloqueio=_this$state.bloqueio;var objCompetencia=response.data.competencia;if(objCompetencia.length!==7){objCompetencia='0'+objCompetencia;}bloqueio.competenciaInicioBloqueio=objCompetencia;_this.setState({bloqueio:Object.assign({},_this.state.bloqueio,bloqueio)});};_this.handleErrorBusca=function(){var mensagemPrimaria='Não foi possível consultar.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({mostraPaginaSemConteudo:true,mensagemPrincipalSemConteudo:mensagemPrimaria,mensagemSecundariaSemConteudo:mensagemSecundaria});};_this.buscaDadosParticipante=function(idParticipante){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('participantes-compensacao/codigo/'+idParticipante,_this.buscaDadosParticipanteSuccess,_this.handleErrorBusca);};_this.buscaCompetenciaPagamentoAberta=function(){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('fechamento-pagamentos/pagamento-aberto',_this.buscaDadosCompetenciaPagamentoSuccess,_this.handleErrorDadosCompetenciaPagamento);};_this.montarListaMotivosDesbloqueio=function(tipoBloqueio){var lista=[];if(tipoBloqueio!==2){lista.push({value:2,label:__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["q" /* motivosBloqueio */],2).label});}lista.push({value:tipoBloqueio,label:__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["q" /* motivosBloqueio */],tipoBloqueio).label});_this.setState({listaMotivosDesbloqueio:lista});};_this.montarListaMotivosBloqueio=function(){var lista=[];if(_this.props.auth.checkPermission(['gerenciar-negocio-dcomp'])){lista.push(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["q" /* motivosBloqueio */][0]);lista.push(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["q" /* motivosBloqueio */][1]);lista.push(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["q" /* motivosBloqueio */][2]);lista.push(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["q" /* motivosBloqueio */][4]);}if(_this.props.auth.checkPermission(['analisar-negocio-sprev'])){lista.push(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["q" /* motivosBloqueio */][1]);lista.push(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["q" /* motivosBloqueio */][4]);}if(_this.props.auth.checkPermission(['analisar-contrato-dtpv'])){lista.push(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["q" /* motivosBloqueio */][3]);}_this.setState({listaMotivosBloqueio:lista});};_this.montaFormulario=function(){// const cnpj = this.props.match.params.chave.substring(0, 14);
// this.setState(this.buscaDadosParticipante(cnpj));
if(_this.props.match.params.chave==='novo'){var _this$props=Object.assign({},_this.props),filtroBloqueio=_this$props.filtroBloqueio;var paramFiltroBloqueio=filtroBloqueio;if(paramFiltroBloqueio!==null){paramFiltroBloqueio=JSON.parse(filtroBloqueio);var paramDestinatario=paramFiltroBloqueio['destinatario-rpps'];var paramTipoEntidade=paramFiltroBloqueio.tipoEntidade;var paramUf=paramFiltroBloqueio.uf;_this.buscaDadosParticipante(paramDestinatario);_this.setState({tipoEntidade:paramTipoEntidade,uf:paramUf,bloqueio:{idParticipante:paramDestinatario}});}_this.montarListaMotivosBloqueio();_this.setState({validadeCampos:Object.assign({},_this.state.validadeCampos,{tipoDesbloqueio:true})},_this.buscaCompetenciaPagamentoAberta);}else{_this.setState({acao:_this.props.match.params.acao,validadeCampos:Object.assign({},_this.state.validadeCampos,{tipoBloqueio:true})},_this.buscaBloqueio);}};_this.trataSucessoResponsePesquisa=function(response){_this.setState({bloqueio:Object.assign({},response.data),requestPesquisa:null});};_this.verificarPermissaoDesbloqueio=function(tipoBloqueio){var possuiPermissaoDesbloqueio=false;switch(tipoBloqueio){case 1:// IB 520538
if(_this.props.auth.checkPermission(['gerenciar-negocio-dcomp','analisar-negocio-sprev'])){possuiPermissaoDesbloqueio=true;}break;case 2:if(_this.props.auth.checkPermission(['gerenciar-negocio-dcomp','analisar-negocio-sprev'])){possuiPermissaoDesbloqueio=true;}break;case 3:if(_this.props.auth.checkPermission(['gerenciar-negocio-dcomp'])){possuiPermissaoDesbloqueio=true;}break;case 4:if(_this.props.auth.checkPermission(['analisar-contrato-dtpv'])){possuiPermissaoDesbloqueio=true;}break;case 5:if(_this.props.auth.checkPermission(['gerenciar-negocio-dcomp','analisar-negocio-sprev'])){possuiPermissaoDesbloqueio=true;}break;default:break;}_this.setState({usuarioPossuiPermissaoDesbloqueio:possuiPermissaoDesbloqueio});};_this.handleSuccessBuscaBloqueio=function(response){var objBloqueio=response.data;var objCompetenciaInicio=objBloqueio.competenciaInicioBloqueio;var objCompetenciaFim=objBloqueio.competenciaFimBloqueio;if(objCompetenciaInicio.length!==7){objCompetenciaInicio='0'+objCompetenciaInicio;}objBloqueio.competenciaInicioBloqueio=objCompetenciaInicio;if(objCompetenciaFim.length!==7){objCompetenciaFim='0'+objCompetenciaFim;}objBloqueio.competenciaFimBloqueio=objCompetenciaFim;_this.buscaDadosParticipante(_this.state.bloqueioPesquisa.idParticipante);objBloqueio.idParticipante=_this.state.bloqueioPesquisa.idParticipante;_this.montarListaMotivosDesbloqueio(response.data.tipoBloqueio);_this.verificarPermissaoDesbloqueio(response.data.tipoBloqueio);_this.setState({bloqueio:Object.assign({},_this.state.bloqueio,objBloqueio)});};_this.buscaBloqueio=function(){var chaveBloqueio=_this.props.match.params.chave;var tamanhoChave=chaveBloqueio.length;var codigo=_this.props.match.params.chave.substring(0,5);var datainicio=_this.props.match.params.chave.substring(5,tamanhoChave);var url='bloqueio';_this.state.bloqueioPesquisa.mesInicioBloqueio=_this.props.match.params.mes;_this.state.bloqueioPesquisa.anoInicioBloqueio=_this.props.match.params.ano;_this.state.bloqueioPesquisa.tipoBloqueio=_this.props.match.params.tipo;_this.state.bloqueioPesquisa.idParticipante=codigo;_this.state.bloqueioPesquisa.dataInclusaoBloqueio=datainicio;Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])(url,_this.handleSuccessBuscaBloqueio,_this.handleErrorBuscaBloqueio,Object.assign({},_this.state.bloqueioPesquisa));};_this.handleErrorBuscaBloqueio=function(error){// let mensagemPrimaria = 'Não foi possível consultar o bloqueio.';
// let mensagemSecundaria = 'Contate o administrador do sistema.';
if(error){if(error.status){_this.setState({existeCompetenciaInicial:false,showNoContent:true});}}};_this.formularioProntoParaEnvio=function(){var _this$state2=Object.assign({},_this.state),acao=_this$state2.acao;if(acao==='novo'||acao==='desbloquear-ente'){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);}return false;};_this.handleChange=function(changeObj,name){var _this$setState;var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var _this$state3=Object.assign({},_this.state),bloqueio=_this$state3.bloqueio;if(changeObj.value===''&&name==='tipoEntidade'){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["q" /* requestApagaFiltroBloqueio */])();_this.setState({participante:{cnpjEf:changeObj.value},bloqueio:{idParticipante:changeObj.value},uf:'',tipoEntidade:''});}else if(changeObj.value!==''&&(name==='uf'||name==='tipoEntidade')){_this.setState({participante:{cnpjEf:''}});}_this.setState((_this$setState={},_defineProperty(_this$setState,name,changeObj.value),_defineProperty(_this$setState,'bloqueio',Object.assign({},bloqueio,_defineProperty({},name,changeObj.value))),_defineProperty(_this$setState,'validadeCampos',Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))),_this$setState),callback);};_this.handleChangeComboNome=function(changeObj,name){var _this$setState2;var _this$state4=Object.assign({},_this.state),bloqueio=_this$state4.bloqueio;_this.setState(_this.buscaDadosParticipante(changeObj.value));_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,changeObj.value),_defineProperty(_this$setState2,'bloqueio',Object.assign({},bloqueio,_defineProperty({},name,changeObj.value))),_defineProperty(_this$setState2,'validadeCampos',Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))),_this$setState2));};_this.addMotivoBloqueioLabel=function(tipo){var valor='';if(tipo){valor=__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["q" /* motivosBloqueio */],tipo).label;}return valor;};_this.handleSaveButton=function(){var mensagemConfirmacao='';if(_this.state.acao==='novo'){mensagemConfirmacao=__WEBPACK_IMPORTED_MODULE_11__utils_constants__["n" /* msgsConfirmacaoBloqueio */].bloqueio;}else{mensagemConfirmacao=__WEBPACK_IMPORTED_MODULE_11__utils_constants__["p" /* msgsConfirmacaoDesbloqueio */].desbloqueio;}_this.setState({alertas:[mensagemConfirmacao],showModalAlerta:!_this.state.showModalAlerta});// this.confirmSendData();
};_this.confirmSendData=function(){var touched=true;var url='bloqueio';var _this$state5=Object.assign({},_this.state),validadeCampos=_this$state5.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});_this.setState({touched:touched,validadeCampos:validadeCampos},function(){return _this.handleSave(url);});};_this.handleSave=function(url){if(_this.formularioProntoParaEnvio()){// let options;
// if (this.state.chaveConfirmacao) {
//   options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
// }
var _this$state6=Object.assign({},_this.state),bloqueio=_this$state6.bloqueio;if(bloqueio.motivoBloqueio){bloqueio.descricaoMotivo=_this.addMotivoBloqueioLabel(bloqueio.motivoBloqueio);}// se as duas competencias estiverem preenchidas,
// é necessario incluir um novo bloqueio para o ente na nova competencia.
if(bloqueio.competenciaInicioBloqueio&&bloqueio.competenciaFimBloqueio){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["n" /* doPut */])(url,bloqueio,_this.trataSucessoResponseEnvio,_this.trataErrosResponse);}else{sessionStorage.removeItem('filtroBloqueio');Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["l" /* doPost */])(url,bloqueio,_this.trataSucessoResponseEnvio,_this.trataErrosResponse);}}else{Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Informe corretamente os atributos indicados na tela.']);}};_this.trataSucessoResponseEnvio=function(){_this.trataSucesso();_this.props.history.goBack();};_this.addMotivoBloqueioDesloqueioLabel=function(tipo){var valor='';if(tipo){valor=__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["q" /* motivosBloqueio */],tipo).label;}return valor;};_this.trataSucesso=function(){var mensagemSucesso='O ente federativo  '+_this.state.participante.nome+'\n    '+(_this.state.participante.uf?'-':'')+_this.state.participante.uf+'\n    '+(_this.state.participante.cnpjEf?'com cnpj':'')+' '+Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["d" /* formatarCnpj */])(_this.state.participante.cnpjEf)+'\n    foi desbloqueado com sucesso pelo motivo\n    '+_this.addMotivoBloqueioDesloqueioLabel(_this.state.bloqueio.tipoDesbloqueio)+'\n    na compet\xEAncia '+_this.state.bloqueio.competenciaFimBloqueio+'.';if(_this.state.acao==='novo'){mensagemSucesso='O ente federativo  '+_this.state.participante.nome+'\n      '+(_this.state.participante.uf?'-':'')+_this.state.participante.uf+'\n      '+(_this.state.participante.cnpjEf?'com cnpj':'')+' '+Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["d" /* formatarCnpj */])(_this.state.participante.cnpjEf)+'\n      foi bloqueado com sucesso pelo motivo\n      '+_this.addMotivoBloqueioDesloqueioLabel(_this.state.bloqueio.tipoBloqueio)+'\n      na compet\xEAncia '+_this.state.bloqueio.competenciaInicioBloqueio+'.';}Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["K" /* trataMensagemSucessoBloqueioDesbloqueio */])([mensagemSucesso]);Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["q" /* requestApagaFiltroBloqueio */])();};_this.trataErrosResponse=function(error){if(error&&error.data){var _error=Object.assign({},error),data=_error.data;_this.setState({chaveConfirmacao:data.chaveConfirmacao,alertas:data.alertas,showModalAlerta:!_this.state.showModalAlerta});}};_this.listaFiltradaDestinatarios=function(){var listaParticipantes=_this.props.destinatarios.filter(function(item){if(item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)){return item;}return null;});return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.trataBotaoVoltar=function(){var _this$props2=Object.assign({},_this.props),filtroBloqueio=_this$props2.filtroBloqueio;if(filtroBloqueio!==null){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["q" /* requestApagaFiltroBloqueio */])();}else{_this.props.history.goBack();}};_this.formularioBloqueioEnte=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DadosBloqueioDesbloqueio__["a" /* default */],{acao:_this.state.acao,auth:_this.props.auth,estadoFormulario:_this.state,handleChange:_this.handleChange,handleChangeComboNome:_this.handleChangeComboNome,match:_this.props.match,listaFiltradaDestinatarios:_this.listaFiltradaDestinatarios,carregaUfDosMunicipios:_this.carregaUfDosMunicipios});};_this.handleFechamentoModalAlerta=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta});};_this.state=_this.getInitialState();return _this;}_createClass(BloqueioDesbloqueioEnte,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}this.montaFormulario();}// Motivos de Desbloqueio
// COMBO DE DESBLOQUEIO = (ORDEM JUDICIAL MAIS O  TIPODOBLOQUEIO)
// Indice 2 = 'Ordem Judicial'
// buscaCompetenciaAtual = () => {
//   doGet('bloqueio/novo-pagamento', this.buscaCompetenciaAtualSuccess, this.handleErrorBusca);
// }
// { value: 1, label: 'CND' },
// { value: 2, label: 'Ordem Judicial' },
// { value: 3, label: 'Aluguel' },
// { value: 4, label: 'Contrato Dataprev' },
// { value: 5, label: 'Inadimplência' },
// TABELA BLOQUEIOS
// Classificador para o tipo de bloqueio  CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
// CS_TIPO_BLOQUEIO Classificador para o tipo de bloqueio  CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
// Classificador  do tipo do desbloqueio CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
// CS_TIPO_DESBLOQUEIO Classificador  do tipo do desbloqueio CND = 1  JUDUCIAL = 2  ALUGUEL = 3 , 4 =  Contrato Dataprev,  5 =  Inadimplência
/**
   * Trata envio dos dados
   *//**
   * Trata as acoes dos botao Salvar
   *//**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */},{key:'render',value:function render(){var modalAlerta=void 0;if(this.state.showModalAlerta){modalAlerta=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__requerimentos_ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.confirmSendData,handleModal:this.handleFechamentoModalAlerta,showModal:true});}var botaoAcaoVoltar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{className:'left',onClick:this.props.filtroBloqueio!==null?this.trataBotaoVoltar():this.props.history.goBack// onClick={this.props.history.push('/consultaBloqueio/bloqueio')}
,title:'Voltar',hint:'Voltar para tela anterior'});var botaoAcaoPrincipal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['gerenciar-negocio-dcomp','analisar-negocio-sprev','analisar-contrato-dtpv']},!this.state.bloqueio.dataEncerramentoBloqueio?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:'Salvar',onClick:this.handleSaveButton,hint:'Salvar'}):'');var retorno=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,this.formularioBloqueioEnte(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},botaoAcaoVoltar,this.state.existeCompetenciaInicial&&this.state.acao!=='novo'&&this.state.usuarioPossuiPermissaoDesbloqueio||this.state.existeCompetenciaInicial&&this.state.acao==='novo'?botaoAcaoPrincipal:''),modalAlerta);return retorno;}}]);return BloqueioDesbloqueioEnte;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BloqueioDesbloqueioEnte.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({chave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ano:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.function}).isRequired,filtroBloqueio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({'destinatario-rpps':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoEntidade:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,uf:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,competenciaAberta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;BloqueioDesbloqueioEnte.defaultProps={match:null,auth:null,destinatarios:[],filtroBloqueio:null};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios,filtroBloqueio:state.base.filtroBloqueio};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(BloqueioDesbloqueioEnte));

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masks__ = __webpack_require__(10);
var DadosBloqueioDesbloqueio=function DadosBloqueioDesbloqueio(props){var addTipoBloqueioLabel=function addTipoBloqueioLabel(tipo){var obj=Object(__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["q" /* motivosBloqueio */],tipo);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};var verificaSeCampoDesabilitado=function verificaSeCampoDesabilitado(){var _props$estadoFormular=Object.assign({},props.estadoFormulario),existeCompetenciaInicial=_props$estadoFormular.existeCompetenciaInicial;var _props$estadoFormular2=Object.assign({},props.estadoFormulario),usuarioPossuiPermissaoDesbloqueio=_props$estadoFormular2.usuarioPossuiPermissaoDesbloqueio;var _props$estadoFormular3=Object.assign({},props.estadoFormulario),acao=_props$estadoFormular3.acao;if(acao!=='novo'&&(existeCompetenciaInicial===false||usuarioPossuiPermissaoDesbloqueio===false)){return true;}return false;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["e" /* DataGrid */],{title:'Dados do Ente Federativo',icon:'ico-users'},props.estadoFormulario.acao==='novo'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado(),label:'Tipo',onChange:function onChange(e){return props.handleChange(e,'tipoEntidade');},placeholder:'Selecione a entidade',value:props.estadoFormulario.tipoEntidade,itemList:__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["E" /* tipoEntidade */],custom:true,number:true})),props.estadoFormulario.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'UF',onChange:function onChange(e){return props.handleChange(e,'uf');},placeholder:'Selecione a UF',value:props.estadoFormulario.uf,itemList:props.carregaUfDosMunicipios(),custom:true})):'',props.estadoFormulario.tipoEntidade?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Nome',name:'idParticipante',onChange:function onChange(e){return props.handleChangeComboNome(e,'idParticipante');},placeholder:'Selecione o destinat\xE1rio',value:props.estadoFormulario.bloqueio.idParticipante,itemList:props.listaFiltradaDestinatarios(),custom:true})):''):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'CNPJ',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].cnpj,value:props.estadoFormulario.participante.cnpjEf}))),props.estadoFormulario.acao!=='novo'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'UF',value:props.estadoFormulario.participante.uf})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'10 10 10 10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,label:'Participante',value:props.estadoFormulario.participante.nome})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["e" /* DataGrid */],{title:'Dados do Bloqueio',icon:'ico-money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].competencia,label:'Compet\xEAncia do Bloqueio',value:props.estadoFormulario.bloqueio.competenciaInicioBloqueio})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},props.estadoFormulario.acao==='novo'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Motivo do Bloqueio',disabled:props.estadoFormulario.acao!=='novo'||verificaSeCampoDesabilitado(),error:!props.estadoFormulario.validadeCampos.tipoBloqueio,touched:props.estadoFormulario.touched,placeholder:'Selecione o motivo do bloqueio',onChange:function onChange(e){return props.handleChange(e,'tipoBloqueio');},value:props.estadoFormulario.bloqueio.tipoBloqueio// itemList={motivosBloqueio}
,itemList:props.estadoFormulario.listaMotivosBloqueio,number:true,custom:true,required:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Motivo do Bloqueio',disabled:true,value:addTipoBloqueioLabel(props.estadoFormulario.bloqueio.tipoBloqueio)}))),props.estadoFormulario.acao!=='novo'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].competencia,label:'Compet\xEAncia do Desbloqueio',value:props.estadoFormulario.bloqueio.competenciaFimBloqueio})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},!props.estadoFormulario.bloqueio.dataEncerramentoBloqueio?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Motivo do Desbloqueio',disabled:props.estadoFormulario.bloqueio.dataEncerramentoBloqueio||verificaSeCampoDesabilitado(),error:!props.estadoFormulario.validadeCampos.tipoDesbloqueio,touched:props.estadoFormulario.touched,placeholder:'Selecione o motivo do desbloqueio',onChange:function onChange(e){return props.handleChange(e,'tipoDesbloqueio');},value:props.estadoFormulario.bloqueio.tipoDesbloqueio// itemList={motivosBloqueio}
,itemList:props.estadoFormulario.listaMotivosDesbloqueio,number:true,custom:true,required:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Motivo do Desbloqueio',disabled:true,value:addTipoBloqueioLabel(props.estadoFormulario.bloqueio.tipoDesbloqueio)}))):'',props.estadoFormulario.acao!=='novo'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,label:'Data de Inclus\xE3o do Bloqueio',value:props.estadoFormulario.bloqueio.dataInclusaoBloqueio})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:true,mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,label:'Data de Encerramento do Bloqueio',value:props.estadoFormulario.bloqueio.dataEncerramentoBloqueio}))):''));};DadosBloqueioDesbloqueio.propTypes={// acao: PropTypes.string.isRequired,
// auth: PropTypes.objectOf(PropTypes.object).isRequired,
estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,listaFiltradaDestinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,carregaUfDosMunicipios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChangeComboNome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (DadosBloqueioDesbloqueio);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiltroPesquisa__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__exportacao_csv_RelatorioFilaPrisma__ = __webpack_require__(618);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConsultaPrisma=function(_Component){_inherits(ConsultaPrisma,_Component);function ConsultaPrisma(props){_classCallCheck(this,ConsultaPrisma);var _this=_possibleConstructorReturn(this,(ConsultaPrisma.__proto__||Object.getPrototypeOf(ConsultaPrisma)).call(this,props));_this.getTipoConsulta=function(){return _this.props.match.params.tipoConsulta;};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.lotacao=_this.props.auth.userData.lotacoes[0];_this.realizaConsulta=function(filtrosPesquisa){// params estados[]: int , cpf : string,
// tipoRequerimento: 1 || 2, participacao: 1 || 2, atributoOrdenacao: string
var filtrosConsulta={};if(filtrosPesquisa){filtrosConsulta=_this.montaFiltros(filtrosPesquisa);}filtrosConsulta['tipo-consulta']=_this.getTipoConsulta();// Copiar atributos além do filtro
var atributosConsulta=_this.verificaAtributosParaConsulta();if(atributosConsulta){if(filtrosConsulta.estado===undefined){filtrosConsulta.estado=atributosConsulta.estados;}filtrosConsulta.participacao=atributosConsulta.tipoParticipacao;filtrosConsulta['atributo-ordenacao']=atributosConsulta.campoOrdenacao;if(atributosConsulta.filtroTipoExigencias){filtrosConsulta['tipo-exigencia']=atributosConsulta.filtroTipoExigencias;}}_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta}),_this.executaConsulta);};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["e" /* doGet */])('beneficios-prisma',_this.tratarSucesso,_this.tratarErro,Object.assign({},_this.state.filtrosConsulta,{filtro:_this.state.filtrosConsulta.filtro,'start-position':primeiroItem,'max-results':resultadosPorPagina}));}else{_this.setState({listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true});}};_this.montaFiltros=function(atributosPesquisa){var atributos={};// filtro é a caixa de texto que pesquisa por cpf, nit e nb
var filtroValido=atributosPesquisa.filtro;if(filtroValido===null){filtroValido='';}atributos=Object.assign({},atributos,{filtro:filtroValido});if(atributosPesquisa.dtPrismaInicio){atributos=Object.assign({},atributos,{dtPrismaInicio:atributosPesquisa.dtPrismaInicio});}if(atributosPesquisa.dtPrismaFim){atributos=Object.assign({},atributos,{dtPrismaFim:atributosPesquisa.dtPrismaFim});}if(atributosPesquisa.dtComprevInicio){atributos=Object.assign({},atributos,{dtComprevInicio:atributosPesquisa.dtComprevInicio});}if(atributosPesquisa.dtComprevFim){atributos=Object.assign({},atributos,{dtComprevFim:atributosPesquisa.dtComprevFim});}if(atributosPesquisa.especieBeneficio){atributos=Object.assign({},atributos,{especieBeneficio:atributosPesquisa.especieBeneficio});}var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;if(atributosPesquisa.cliqueiNoBotao===1){_this.state.estadoTabela.paginaAtual=1;}var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.verificaAtributosParaConsulta=function(){if(_this.getTipoConsulta()){return __WEBPACK_IMPORTED_MODULE_6__utils_constants__["c" /* estadosParaConsulta */][_this.getTipoConsulta()];}return null;};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRegistrosIndexada:response.data,listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarFiltroNaLista=function(listaRegistrosFiltrada){_this.setState({listaRegistrosFiltrada:listaRegistrosFiltrada,listaRegistrosIndexadaAtualizada:false});};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.setState({showNoContent:true,noContentPrimaryMessage:'Requerimento não encontrado para o protocolo informado.',noContentSecondaryMessage:'Informe um protocolo válido.'});}else{_this.setState({showNoContent:true,noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}}else{_this.setState({showNoContent:true,noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleChange=function(e,name){_this.setState(Object.assign({},_this.state,_defineProperty({},name,e)));};_this.addTipoRequerimentoLabel=function(tipo){return __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["M" /* tipoRequerimento */],tipo).label;};_this.addTipoEstadoLabel=function(tipo){if(tipo===15){return'Exigência/indeferido';}if(tipo===16){return'Indeferimento ratificado';}return __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};_this.colunasDefault=[{id:'cpf',label:'CPF'},{id:'especie',label:'Espécie'},{id:'motivoPrisma',label:'motivo PRISMA'},{id:'dtRecibementoPrisma',label:'Data de Recebimento PRISMA'},{id:'dtEnvioComprev',label:'Data de Envio COMPREV'},{id:'nb',label:'Número do Benefício'},{id:'resultado',label:'Resultado'}];_this.montaColunas=function(){var requerimentosExigenciaTableHeader=_this.colunasDefault.slice();return requerimentosExigenciaTableHeader;};_this.defineListaParaTabela=function(){if(_this.state.listaRegistrosFiltrada!==null){return _this.state.listaRegistrosFiltrada;}return _this.state.listaRegistrosIndexada;};_this.alterarPagina=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state3=Object.assign({},_this.state),estadoTabela=_this$state3.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.state={listaRegistrosFiltrada:null,listaRegistrosIndexada:[],registroVindoDoRequest:null,showNoContent:false,listaRegistrosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{}};return _this;}_createClass(ConsultaPrisma,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["g" /* manterApenasFiltro */])('');}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.match.params.tipoConsulta!==prevProps.match.params.tipoConsulta){this.preparaNovaConsulta();}}/**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */},{key:'render',value:function render(){var options={noDataText:'Nenhum requerimento a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var requerimentosExigenciaTableHeader=this.montaColunas();return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FiltroPesquisa__["a" /* default */],{handleSearchFilter:this.realizaConsulta,handleChangeList:this.tratarFiltroNaLista,destinatarios:'',list:this.state.listaRegistrosIndexada,tipoConsulta:this.getTipoConsulta(),listaRegistrosIndexadaAtualizada:this.state.listaRegistrosIndexadaAtualizada}),this.state.listaRegistrosIndexada&&this.state.listaRegistrosIndexada.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__exportacao_csv_RelatorioFilaPrisma__["a" /* default */],{filtrosConsulta:this.state.filtrosConsulta}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{legend:this.state.estadoTabela.quantidadeTotalResultados===0?'Consulta PRISMA':'Consulta PRISMA -  '+this.state.estadoTabela.quantidadeTotalResultados+' registro(s) encontrado(s)',bordered:true,fetchInfo:fetchInfo,data:this.defineListaParaTabela(),options:options,listaTableHeader:requerimentosExigenciaTableHeader,pagination:true,remote:true}));}}]);return ConsultaPrisma;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaPrisma.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired};ConsultaPrisma.defaultProps={match:null};/* harmony default export */ __webpack_exports__["a"] = (ConsultaPrisma);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_export_to_csv__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RelatorioFilaPrisma=function(_Component){_inherits(RelatorioFilaPrisma,_Component);function RelatorioFilaPrisma(props){_classCallCheck(this,RelatorioFilaPrisma);var _this=_possibleConstructorReturn(this,(RelatorioFilaPrisma.__proto__||Object.getPrototypeOf(RelatorioFilaPrisma)).call(this,props));_this.tratarSucessoListaExportacao=function(response){if(response.data!==''){_this.setState({},_this.gerarCsv(response.data));}};_this.tratarErro=function(){// const mensagemPrimaria = 'Não foi possível consultar a fila do Prisma.';
// const mensagemSecundaria = 'Contate o administrador do sistema.';
_this.setState({});};_this.colunasExportacaoDefault=['CPF','Espécie','motivo PRISMA','Data de Recebimento PRISMA','Data de Envio COMPREV','Número do Benefício','Resultado'];_this.defineListaParaExportacao=function(lista){var listaOriginal=lista;var resultado=[];listaOriginal.forEach(function(item){resultado.push({cpf:item.cpf?item.cpf:'',especie:item.especie?item.especie:'',motivoPrisma:item.motivoPrisma?item.motivoPrisma:'',dtRecibementoPrisma:item.dtRecibementoPrisma?item.dtRecibementoPrisma:'',dtEnvioComprev:item.dtEnvioComprev?item.dtEnvioComprev:'',nb:item.nb?item.nb:'',resultado:item.resultado?item.resultado:''});});return resultado;};_this.exportar=function(){if(Object.entries(_this.props.filtrosConsulta).length!==0){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["e" /* doGet */])('beneficios-prisma/exportacao-csv',_this.tratarSucessoListaExportacao,_this.tratarErro,Object.assign({},_this.props.filtrosConsulta));}};_this.gerarCsv=function(lista){var dadosRelatorio=null;var legenda='Fila de migração do PRISMA';if(lista&&lista!==undefined&&lista.length>0){dadosRelatorio=_this.defineListaParaExportacao(lista);}else{dadosRelatorio=[];}if(dadosRelatorio&&dadosRelatorio!==undefined&&dadosRelatorio.length>0){var csvExporter=new __WEBPACK_IMPORTED_MODULE_2_export_to_csv__["ExportToCsv"]({filename:'Fila de migração do PRISMA',fieldSeparator:';',showTitle:true,title:legenda,showLabels:true,headers:_this.colunasExportacaoDefault});csvExporter.generateCsv(dadosRelatorio);}};_this.state={};return _this;}_createClass(RelatorioFilaPrisma,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:'Exportar para CSV',onClick:function onClick(){_this2.exportar();},icon:'ico-doc-sheet',mini:true})));}}]);return RelatorioFilaPrisma;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RelatorioFilaPrisma.propTypes={voltarAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,filtrosConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object}.isRequired;RelatorioFilaPrisma.defaultProps={voltarAction:function voltarAction(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (RelatorioFilaPrisma);

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CsvConfigConsts = (function () {
    function CsvConfigConsts() {
    }
    CsvConfigConsts.EOL = "\r\n";
    CsvConfigConsts.BOM = "\ufeff";
    CsvConfigConsts.DEFAULT_FIELD_SEPARATOR = ',';
    CsvConfigConsts.DEFAULT_DECIMAL_SEPARATOR = '.';
    CsvConfigConsts.DEFAULT_QUOTE = '"';
    CsvConfigConsts.DEFAULT_SHOW_TITLE = false;
    CsvConfigConsts.DEFAULT_TITLE = 'My Generated Report';
    CsvConfigConsts.DEFAULT_FILENAME = 'generated';
    CsvConfigConsts.DEFAULT_SHOW_LABELS = false;
    CsvConfigConsts.DEFAULT_USE_TEXT_FILE = false;
    CsvConfigConsts.DEFAULT_USE_BOM = true;
    CsvConfigConsts.DEFAULT_HEADER = [];
    CsvConfigConsts.DEFAULT_KEYS_AS_HEADERS = false;
    return CsvConfigConsts;
}());
exports.CsvConfigConsts = CsvConfigConsts;
exports.ConfigDefaults = {
    filename: CsvConfigConsts.DEFAULT_FILENAME,
    fieldSeparator: CsvConfigConsts.DEFAULT_FIELD_SEPARATOR,
    quoteStrings: CsvConfigConsts.DEFAULT_QUOTE,
    decimalSeparator: CsvConfigConsts.DEFAULT_DECIMAL_SEPARATOR,
    showLabels: CsvConfigConsts.DEFAULT_SHOW_LABELS,
    showTitle: CsvConfigConsts.DEFAULT_SHOW_TITLE,
    title: CsvConfigConsts.DEFAULT_TITLE,
    useTextFile: CsvConfigConsts.DEFAULT_USE_TEXT_FILE,
    useBom: CsvConfigConsts.DEFAULT_USE_BOM,
    headers: CsvConfigConsts.DEFAULT_HEADER,
    useKeysAsHeaders: CsvConfigConsts.DEFAULT_KEYS_AS_HEADERS,
};
var ExportToCsv = (function () {
    function ExportToCsv(options) {
        this._csv = "";
        var config = options || {};
        this._options = objectAssign({}, exports.ConfigDefaults, config);
        if (this._options.useKeysAsHeaders
            && this._options.headers
            && this._options.headers.length > 0) {
            console.warn('Option to use object keys as headers was set, but headers were still passed!');
        }
    }
    Object.defineProperty(ExportToCsv.prototype, "options", {
        get: function () {
            return this._options;
        },
        set: function (options) {
            this._options = objectAssign({}, exports.ConfigDefaults, options);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Generate and Download Csv
     */
    ExportToCsv.prototype.generateCsv = function (jsonData, shouldReturnCsv) {
        if (shouldReturnCsv === void 0) { shouldReturnCsv = false; }
        // Make sure to reset csv data on each run
        this._csv = '';
        this._parseData(jsonData);
        if (this._options.useBom) {
            this._csv += CsvConfigConsts.BOM;
        }
        if (this._options.showTitle) {
            this._csv += this._options.title + '\r\n\n';
        }
        this._getHeaders();
        this._getBody();
        if (this._csv == '') {
            console.log("Invalid data");
            return;
        }
        // When the consumer asks for the data, exit the function
        // by returning the CSV data built at this point
        if (shouldReturnCsv) {
            return this._csv;
        }
        // Create CSV blob to download if requesting in the browser and the
        // consumer doesn't set the shouldReturnCsv param
        var FileType = this._options.useTextFile ? 'plain' : 'csv';
        var fileExtension = this._options.useTextFile ? '.txt' : '.csv';
        var blob = new Blob([this._csv], { "type": "text/" + FileType + ";charset=utf8;" });
        if (navigator.msSaveBlob) {
            var filename = this._options.filename.replace(/ /g, "_") + fileExtension;
            navigator.msSaveBlob(blob, filename);
        }
        else {
            var attachmentType = this._options.useTextFile ? 'text' : 'csv';
            var uri = 'data:attachment/' + attachmentType + ';charset=utf-8,' + encodeURI(this._csv);
            var link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute('visibility', 'hidden');
            link.download = this._options.filename.replace(/ /g, "_") + fileExtension;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };
    /**
     * Create Headers
     */
    ExportToCsv.prototype._getHeaders = function () {
        if (!this._options.showLabels && !this._options.useKeysAsHeaders) {
            return;
        }
        var useKeysAsHeaders = this._options.useKeysAsHeaders;
        var headers = useKeysAsHeaders ? Object.keys(this._data[0]) : this._options.headers;
        if (headers.length > 0) {
            var row = "";
            for (var keyPos = 0; keyPos < headers.length; keyPos++) {
                row += headers[keyPos] + this._options.fieldSeparator;
            }
            row = row.slice(0, -1);
            this._csv += row + CsvConfigConsts.EOL;
        }
    };
    /**
     * Create Body
     */
    ExportToCsv.prototype._getBody = function () {
        var keys = Object.keys(this._data[0]);
        for (var i = 0; i < this._data.length; i++) {
            var row = "";
            for (var keyPos = 0; keyPos < keys.length; keyPos++) {
                var key = keys[keyPos];
                row += this._formatData(this._data[i][key]) + this._options.fieldSeparator;
            }
            row = row.slice(0, -1);
            this._csv += row + CsvConfigConsts.EOL;
        }
    };
    /**
     * Format Data
     * @param {any} data
     */
    ExportToCsv.prototype._formatData = function (data) {
        if (this._options.decimalSeparator === 'locale' && this._isFloat(data)) {
            return data.toLocaleString();
        }
        if (this._options.decimalSeparator !== '.' && this._isFloat(data)) {
            return data.toString().replace('.', this._options.decimalSeparator);
        }
        if (typeof data === 'string') {
            data = data.replace(/"/g, '""');
            if (this._options.quoteStrings || data.indexOf(',') > -1 || data.indexOf('\n') > -1 || data.indexOf('\r') > -1) {
                data = this._options.quoteStrings + data + this._options.quoteStrings;
            }
            return data;
        }
        if (typeof data === 'boolean') {
            return data ? 'TRUE' : 'FALSE';
        }
        return data;
    };
    /**
     * Check if is Float
     * @param {any} input
     */
    ExportToCsv.prototype._isFloat = function (input) {
        return +input === input && (!isFinite(input) || Boolean(input % 1));
    };
    /**
     * Parse the collection given to it
     *
     * @private
     * @param {*} jsonData
     * @returns {any[]}
     * @memberof ExportToCsv
     */
    ExportToCsv.prototype._parseData = function (jsonData) {
        this._data = typeof jsonData != 'object' ? JSON.parse(jsonData) : jsonData;
        return this._data;
    };
    return ExportToCsv;
}());
exports.ExportToCsv = ExportToCsv;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
/**
 * Convet to Object
 * @param {any} val
 */
function toObject(val) {
    if (val === null || val === undefined) {
        throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
}
/**
 * Assign data  to new Object
 * @param {any}   target
 * @param {any[]} ...source
 */
function objectAssign(target) {
    var source = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        source[_i - 1] = arguments[_i];
    }
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
            }
        }
        if (Object.getOwnPropertySymbols) {
            symbols = Object.getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                    to[symbols[i]] = from[symbols[i]];
                }
            }
        }
    }
    return to;
}
//# sourceMappingURL=export-to-csv.js.map

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FiltroEnteGlosa__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__requerimentos_ModalAlerta__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConsultaGlosaDeDacao=function(_Component){_inherits(ConsultaGlosaDeDacao,_Component);function ConsultaGlosaDeDacao(props){_classCallCheck(this,ConsultaGlosaDeDacao);var _this=_possibleConstructorReturn(this,(ConsultaGlosaDeDacao.__proto__||Object.getPrototypeOf(ConsultaGlosaDeDacao)).call(this,props));_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRegistrosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.realizaConsulta=function(filtrosPesquisa){if(filtrosPesquisa){_this.setState({idSolicitante:filtrosPesquisa['destinatario-rpps']});Object(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* solicitarGlosas */])(filtrosPesquisa['destinatario-rpps'],''+_this.props.competenciaAberta.ano+Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["j" /* pad */])(_this.props.competenciaAberta.mes,2));}};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.setState({showNoContent:true,noContentPrimaryMessage:'Não existe cnpj para o ente federativo escolhido.',noContentSecondaryMessage:'Informe um ente federativo válido.'});}else{_this.setState({showNoContent:true,noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}}else{_this.setState({showNoContent:true,noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleChange=function(e,name){_this.setState(Object.assign({},_this.state,_defineProperty({},name,e)));};_this.newCadastroGlosaDeDacao=function(){_this.props.history.push('/cadastros/glosaDeDacao/');};_this.editCadastroGlosaDeDacao=function(id){_this.props.history.push('/cadastros/glosaDeDacao/'+id);};_this.confirmDelete=function(){var _this$state=Object.assign({},_this.state),glosa=_this$state.glosa;Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["c" /* doDelete */])('glosa-manual',glosa.idGlosa,function(){Object(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* solicitarGlosas */])(glosa.idSolicitante,''+_this.props.competenciaAberta.ano+Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["j" /* pad */])(_this.props.competenciaAberta.mes,2));_this.setState({showModalAlerta:!_this.state.showModalAlerta});Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["J" /* trataMensagemSucesso */])(['Glosa excluída com sucesso.']);},'Não foi possível excluir a glosa.');};_this.deleteGlosaDeDacao=function(paramGlosa){// console.log(paramGlosa);
_this.setState({alertas:[__WEBPACK_IMPORTED_MODULE_11__utils_constants__["s" /* msgsGlosaDeDacaoManual */].removerGlosadeDacao],showModalAlerta:!_this.state.showModalAlerta,glosa:Object.assign({},paramGlosa)});};_this.buscaDadosCompetenciaPagamentoSuccess=function(response){var objCompetencia=response.data.competencia;if(objCompetencia.length!==7){objCompetencia='0'+objCompetencia;}_this.setState({competenciaAberta:objCompetencia});};_this.handleErrorDadosCompetenciaPagamento=function(){_this.setState({existeCompetenciaInicial:false});};_this.buscaCompetenciaPagamentoAberta=function(){Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["e" /* doGet */])('fechamento-pagamentos/pagamento-aberto',_this.buscaDadosCompetenciaPagamentoSuccess,_this.handleErrorDadosCompetenciaPagamento);};_this.createActionColumn=function(id,glosa){var mes=Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["j" /* pad */])(glosa.competencia.split('/')[0],2);var ano=glosa.competencia.split('/')[1];var competencia=''+ano+mes;var competenciaAberta='';if(_this.state.competenciaAberta){var mesAberto=Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["j" /* pad */])(_this.state.competenciaAberta.split('/')[0],2);var anoAberto=_this.state.competenciaAberta.split('/')[1];competenciaAberta=''+anoAberto+mesAberto;}if(parseInt(competenciaAberta,10)===parseInt(competencia,10)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* Button */],{hint:'Alterar glosa',icon:'ico-doc-pencil',mini:true,onClick:function onClick(){return _this.editCadastroGlosaDeDacao(id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* Button */],{hint:'Excluir glosa',icon:'ico-trash-can',mini:true,onClick:function onClick(){return _this.deleteGlosaDeDacao(glosa);}}));}return null;};_this.alterarPagina=function(pagina){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.paginaAtual=pagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.addSolicitanteLabel=function(id){var valor='';if(id){valor=__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */](_this.props.destinatarios,id).label;}return valor;};_this.handleFechamentoModalAlerta=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta});};_this.verificaSeCampoDesabilitado=function(){var _this$state3=Object.assign({},_this.state),existeCompetenciaInicial=_this$state3.existeCompetenciaInicial;if(existeCompetenciaInicial===false){return true;}return false;};_this.state={idSolicitante:null,listaRegistrosFiltrada:null,listaRegistrosIndexada:[],registroVindoDoRequest:null,showNoContent:false,listaRegistrosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{},filtrosPesquisaCnpj:{},showModalAlerta:false,existeCompetenciaInicial:true};return _this;}_createClass(ConsultaGlosaDeDacao,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["G" /* solicitarCompetenciaAberta */])();// console.log(this.props.competenciaAberta);
if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_8__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}this.realizaConsulta();this.buscaCompetenciaPagamentoAberta();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["g" /* manterApenasFiltro */])('filtroEnteFederativo');// Apenas repete consulta se parametro da url for alterado
if(this.props.match.params.tipoConsulta!==prevProps.match.params.tipoConsulta){this.preparaNovaConsulta();}}},{key:'render',value:function render(){var _this2=this;var modalAlerta=void 0;if(this.state.showModalAlerta){modalAlerta=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__requerimentos_ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.confirmDelete,handleModal:this.handleFechamentoModalAlerta,showModal:true});}var options={noDataText:'Nenhuma glosa a ser exibida',hideSizePerPage:true,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var colunasDefault=[{id:'idSolicitante',label:'Solicitante'},{id:'competencia',label:'Competência'},{id:'valor',label:'Valor'},{id:'observacoes',label:'Observações'},{id:'acoes',label:'Ações',dataFormat:this.createActionColumn}];var glosas=void 0;if(Array.isArray(this.props.listaGlosas)){glosas=this.props.listaGlosas.map(function(g){return{competencia:Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["j" /* pad */])(g.mesPagamentoGlosa,2)+'/'+g.anoPagamentoGlosa,idDestinatario:g.idDestinatario,idGlosa:g.idGlosa,idSolicitante:g.idSolicitante,observacoes:g.observacoes,tipoAplicacao:g.tipoAplicacao,tipoGlosa:g.tipoGlosa,valor:g.vlGlosa?'R$ '+g.vlGlosa.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3}):'',acoes:g.idGlosa};}).filter(function(g){return g.idSolicitante===_this2.state.idSolicitante;});}else{glosas=[];}return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FiltroEnteGlosa__["a" /* default */],{handleSearchFilter:this.realizaConsulta,destinatarios:this.props.destinatarios,tipoConsulta:this.props.match.params.tipoConsulta,competencia:this.props.competenciaAberta,existeCompetenciaInicial:this.state.existeCompetenciaInicial}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["u" /* Table */],{legend:'Glosas de Da\xE7\xE3o',bordered:true,fetchInfo:fetchInfo,data:glosas,options:options,listaTableHeader:colunasDefault,pagination:true,remote:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["c" /* DtpButton */],{className:'dtp-primary right',title:'Adicionar Glosa de Da\xE7\xE3o',accessibilityName:'Adicionar glosa de da\xE7\xE3o',onClick:function onClick(){return _this2.newCadastroGlosaDeDacao();},disabled:!this.props.competenciaAberta}),modalAlerta);}}]);return ConsultaGlosaDeDacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaGlosaDeDacao.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),listaGlosas:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),competenciaAberta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};ConsultaGlosaDeDacao.defaultProps={match:null,destinatarios:[],listaGlosas:[],competenciaAberta:null};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios,listaGlosas:state.glosa.listaGlosas,competenciaAberta:state.base.competenciaAberta};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ConsultaGlosaDeDacao));

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FiltroEnteGlosa=function(_Component){_inherits(FiltroEnteGlosa,_Component);function FiltroEnteGlosa(){_classCallCheck(this,FiltroEnteGlosa);var _this=_possibleConstructorReturn(this,(FiltroEnteGlosa.__proto__||Object.getPrototypeOf(FiltroEnteGlosa)).call(this));_this.controleFiltrosAlternativos=function(campo){switch(campo){case'destinatario-rpps':return['requerer-compensacao-rgps','gerenciar-negocio-dcomp'];default:return[];}};_this.preparaNovaConsulta=function(){var filtroEnteFederativo={'destinatario-rpps':null,tipoEntidade:null,uf:null};filtroEnteFederativo=JSON.stringify(filtroEnteFederativo);sessionStorage.setItem('filtroEnteFederativo',filtroEnteFederativo);_this.setState({'destinatario-rpps':null,tipoEntidade:null,uf:null});};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.trataFormulario=function(campoAlterado){if(campoAlterado==='tipoEntidade'){_this.trataTipoEntidade();}if(campoAlterado==='uf'){_this.trataUf();}};_this.trataUf=function(){_this.setState({'destinatario-rpps':null});};_this.trataCombosEntidade=function(){_this.setState({tipoEntidade:null,'destinatario-rpps':null,uf:null});};_this.trataTipoEntidade=function(){_this.setState({'destinatario-rpps':null,uf:null});};_this.handleSearchButton=function(){var filtroEnteFederativo={'destinatario-rpps':_this.state['destinatario-rpps'],tipoEntidade:_this.state.tipoEntidade,uf:_this.state.uf};filtroEnteFederativo=JSON.stringify(filtroEnteFederativo);sessionStorage.setItem('filtroEnteFederativo',filtroEnteFederativo);_this.setState({cliqueiNoBotao:1},function(){_this.handleChange({value:1,isValid:true},'cliqueiNoBotao');});_this.handleSearch();};_this.handleSearch=function(){if(!_this.props.existeCompetenciaInicial){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Não existe competência de pagamento aberta.']);}else if(_this.state.tipoEntidade&&_this.props.existeCompetenciaInicial){if(_this.state.tipoEntidade===2&&!_this.state.uf&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha uma UF']);return;}if(_this.state.tipoEntidade&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha um filtro de destinatário para a consulta']);return;}if(_this.state.tipoEntidade&&_this.state.uf&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha um filtro de destinatário para a consulta']);return;}_this.props.handleSearchFilter(_this.state);}else if(!_this.state.tipoEntidade&&_this.props.existeCompetenciaInicial){_this.props.handleSearchFilter(_this.state);}else{Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha pelo menos um filtro de Ente federativo para a consulta']);}};_this.listaFiltradaDestinatarios=function(){var listaParticipantes=_this.props.destinatarios.filter(function(item){if(item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)){return item;}return null;});return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.montaFiltrosDefault=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Compet\xEAncia',value:_this.props.competencia?Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["j" /* pad */])(_this.props.competencia.mes,2)+'/'+_this.props.competencia.ano:'',disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Tipo',onChange:function onChange(e){return _this.handleChange(e,'tipoEntidade');},placeholder:'Selecione a entidade',value:_this.state.tipoEntidade,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["E" /* tipoEntidade */],custom:true,number:true,disabled:!_this.props.competencia})),_this.state.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'UF',onChange:function onChange(e){return _this.handleChange(e,'uf');},placeholder:'Selecione a UF',value:_this.state.uf,itemList:_this.carregaUfDosMunicipios(),custom:true})):'',_this.state.tipoEntidade?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Nome',name:'destinatario-rpps',onChange:function onChange(e){return _this.handleChange(e,'destinatario-rpps');},placeholder:'Selecione o destinat\xE1rio',value:_this.state['destinatario-rpps'],itemList:_this.listaFiltradaDestinatarios(),custom:true})):''));};_this.montaFiltros=function(){if(_this.props.tipoConsulta){return _this.montaFiltrosDefault();}return null;};_this.filtroEnteFederativo=JSON.parse(sessionStorage.getItem('filtroEnteFederativo'));_this.state={'destinatario-rpps':_this.filtroEnteFederativo&&_this.filtroEnteFederativo['destinatario-rpps']?_this.filtroEnteFederativo['destinatario-rpps']:null,cliqueiNoBotao:_this.filtroEnteFederativo&&_this.filtroEnteFederativo.cliqueiNoBotao?_this.filtroEnteFederativo.cliqueiNoBotao:null,tipoEntidade:_this.filtroEnteFederativo&&_this.filtroEnteFederativo.tipoEntidade?_this.filtroEnteFederativo.tipoEntidade:null,uf:_this.filtroEnteFederativo&&_this.filtroEnteFederativo.uf?_this.filtroEnteFederativo.uf:null};return _this;}_createClass(FiltroEnteGlosa,[{key:'componentDidMount',value:function componentDidMount(){if(sessionStorage.getItem('filtroEnteFederativo')){this.handleSearchButton();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.tipoConsulta!==prevProps.tipoConsulta){this.preparaNovaConsulta();}}/**
     * Encaminha para as funcoes que tratam alteracoes em cada campo
     */},{key:'render',value:function render(){var _this2=this;var filtrosPesquisa=this.montaFiltros();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'pesquisa',panelId:'filtro-pesquisa',icon:'ico-filter',title:'Filtro de Pesquisa'},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado',disabled:!this.props.competencia}))));}}]);return FiltroEnteGlosa;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroEnteGlosa.propTypes={destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf().isRequired,handleChangeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,competencia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroEnteGlosa);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return solicitarGlosas; });
/* unused harmony export solicitarGlosa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers__ = __webpack_require__(57);
// const receberErro = () => console.log('receber erro');
var receberGlosas=function receberGlosas(retorno){__WEBPACK_IMPORTED_MODULE_1__reducers__["a" /* default */].dispatch({type:'GLOSA_RECEBER_GOLSAS_DE_ENTE',payload:retorno.data});};var receberGlosa=function receberGlosa(retorno){__WEBPACK_IMPORTED_MODULE_1__reducers__["a" /* default */].dispatch({type:'GLOSA_RECEBER_GOLSA',payload:retorno.data});};var solicitarGlosas=function solicitarGlosas(idEnte,competencia){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_requests__["e" /* doGet */])('glosa-manual/lista-glosas?idSolicitante='+idEnte+'&dataCompetencia='+competencia,receberGlosas);};var solicitarGlosa=function solicitarGlosa(idGlosa){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_requests__["e" /* doGet */])('glosa-manual?idGlosa='+idGlosa,receberGlosa);};

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__requerimentos_ModalAlerta__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { solicitarGlosa } from './actions';
var CadastroGlosaDeDacao=function(_Component){_inherits(CadastroGlosaDeDacao,_Component);function CadastroGlosaDeDacao(props){_classCallCheck(this,CadastroGlosaDeDacao);var _this=_possibleConstructorReturn(this,(CadastroGlosaDeDacao.__proto__||Object.getPrototypeOf(CadastroGlosaDeDacao)).call(this,props));_this.handleChange=function(obj,name){var _this$setState;var _this$state=Object.assign({},_this.state),glosa=_this$state.glosa;_this.setState((_this$setState={},_defineProperty(_this$setState,name,obj.value),_defineProperty(_this$setState,'glosa',Object.assign({},glosa,_defineProperty({},name,obj.value))),_defineProperty(_this$setState,'validadeCampos',Object.assign({},_this.state.validadeCampos,_defineProperty({},name,obj.isValid))),_this$setState));};_this.handleChangeEntidade=function(obj,name){var _this$setState2;var _this$state2=Object.assign({},_this.state),glosa=_this$state2.glosa;_this.setState(_this.buscaDadosParticipante(obj.value));_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,obj.value),_defineProperty(_this$setState2,'glosa',Object.assign({},glosa,_defineProperty({},name,obj.value))),_defineProperty(_this$setState2,'validadeCampos',Object.assign({},_this.state.validadeCampos,_defineProperty({},name,obj.isValid))),_this$setState2));};_this.buscaDadosParticipante=function(idParticipante){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('participantes-compensacao/codigo/'+idParticipante,_this.buscaDadosParticipanteSuccess,_this.handleErrorBusca);};_this.buscaDadosParticipanteSuccess=function(response){_this.setState({participante:Object.assign({},_this.state.participante,response.data)});};_this.handleErrorBusca=function(){var mensagemPrimaria='Não foi possível consultar.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({mostraPaginaSemConteudo:true,mensagemPrincipalSemConteudo:mensagemPrimaria,mensagemSecundariaSemConteudo:mensagemSecundaria});};_this.buscaCompetenciaAbertaPagamento=function(){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('fechamento-pagamentos/pagamento-aberto',function(a){_this.setState(function(prevState){return Object.assign({},prevState,{competenciaAberta:''+a.data.ano+Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["j" /* pad */])(a.data.mes,2),glosa:Object.assign({},prevState.glosa,{competencia:Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["j" /* pad */])(a.data.mes,2)+'/'+a.data.ano})});});});};_this.handleErrorBusca=function(error){var mensagemPrimaria='Não foi possível consultar o regime próprio.';var mensagemSecundaria='Contate o administrador do sistema.';if(error){if(error.status){if(error.status===404){mensagemPrimaria='Ente  Federativo não encontrado para o filtro informado.';mensagemSecundaria='Informe um filtro válido.';}}}_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.trataSucessoResponseEnvio=function(){if(_this.state.acao==='novo'){var mensagemSucesso=['Glosa cadastrada com sucesso.'];Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["J" /* trataMensagemSucesso */])(mensagemSucesso);_this.props.history.push('/consultaGlosaDeDacao/consulta-glosa/');}else if(_this.state.acao==='editar'){var _mensagemSucesso=['Glosa alterada com sucesso.'];Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["J" /* trataMensagemSucesso */])(_mensagemSucesso);_this.props.history.push('/consultaGlosaDeDacao/consulta-glosa/');}else{var mensagemErro=['Não foi possível cadastrar a glosa.'];Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(mensagemErro);}};_this.trataErrosResponse=function(error){if(error&&error.data){var _error=Object.assign({},error),data=_error.data;_this.setState({chaveConfirmacao:data.chaveConfirmacao,alertas:data.alertas,showModalAlerta:!_this.state.showModalAlerta});}};_this.listaFiltradaDestinatarios=function(){var listaParticipantes=_this.props.destinatarios.filter(function(item){if(item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)){return item;}return null;});return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.montaFiltrosDefault=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Tipo',onChange:function onChange(e){return _this.handleChange(e,'tipoEntidade');},placeholder:'Selecione a entidade',value:_this.state.tipoEntidade,itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["E" /* tipoEntidade */],custom:true,number:true,disabled:_this.state.acao!=='novo'})),_this.state.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'UF',onChange:function onChange(e){return _this.handleChange(e,'uf');},placeholder:'Selecione a UF',value:_this.state.uf,itemList:_this.carregaUfDosMunicipios(),custom:true,disabled:_this.state.acao!=='novo'})):'',_this.state.tipoEntidade?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{label:'Nome',name:'destinatario-rpps',onChange:function onChange(e){return _this.handleChangeEntidade(e,'idSolicitante');},placeholder:'Selecione o Solicitante',value:_this.state.glosa.idSolicitante,itemList:_this.listaFiltradaDestinatarios(),custom:true,disabled:_this.state.acao!=='novo'})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{disabled:true,label:'CNPJ',mask:__WEBPACK_IMPORTED_MODULE_7__utils_masks__["a" /* default */].cnpj,value:_this.state.participante?_this.state.participante.cnpj:''}))));};_this.formularioProntoParaEnvio=function(){var _this$state3=Object.assign({},_this.state),acao=_this$state3.acao;var _this$state4=Object.assign({},_this.state),estadoFormulario=_this$state4.estadoFormulario;switch(acao){case'novo':{if(estadoFormulario==='inicial'){return Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);}return estadoFormulario==='alterado';}case'editar':return true;default:return false;}};_this.handleSaveButton=function(){// FAZER AS VALIDACOES DE FRONTEND AQUI
var mensagem=_this.state.acao==='novo'?__WEBPACK_IMPORTED_MODULE_11__utils_constants__["s" /* msgsGlosaDeDacaoManual */].glosadeDacao:__WEBPACK_IMPORTED_MODULE_11__utils_constants__["s" /* msgsGlosaDeDacaoManual */].alterarGlosadeDacao;_this.setState({alertas:[mensagem],showModalAlerta:!_this.state.showModalAlerta});// this.confirmSendData();
};_this.confirmSendData=function(){var touched=true;var url='glosa-manual';// Alteração para transformar o valor do campo
// para numero antes de persistir na tabela.
if(typeof _this.state.glosa.vlGlosa!=='number'){var vlGlosa=_this.state.glosa.vlGlosa.replace(/\./g,'').replace(/,/g,'.');_this.state.glosa.vlGlosa=Number(vlGlosa);}var _this$state5=Object.assign({},_this.state),validadeCampos=_this$state5.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});_this.setState({touched:touched,validadeCampos:validadeCampos},function(){return _this.handleSave(url);});};_this.handleSave=function(url){var glosaParaBackend={idGlosa:_this.state.acao==='editar'?parseInt(_this.state.glosa.idGlosa,10):'',idDestinatario:'01000',// Quem dá o imóvel sempre é o INSS (RGPS)
idSolicitante:_this.state.glosa.idSolicitante,vlGlosa:_this.state.glosa.vlGlosa,mesPagamentoGlosa:Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["i" /* obterMesDaCompetencia */])(_this.state.glosa.competencia,'/'),anoPagamentoGlosa:Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["h" /* obterAnoDaCompetencia */])(_this.state.glosa.competencia,'/'),tipoGlosa:1,tipoAplicacao:1,observacoes:_this.state.glosa.observacoes};if(_this.formularioProntoParaEnvio()){var options=void 0;if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}if(_this.state.acao==='novo'){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["l" /* doPost */])(url,glosaParaBackend,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,options);}else{Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["n" /* doPut */])(url,glosaParaBackend,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,{codigo:3009,mensagem:'Esta solicitação já foi atendida por outro usuário.'},options);}}else{Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['Informe corretamente os atributos indicados na tela.']);}};_this.handleFechamentoModalAlerta=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta});};_this.state={validadeCampos:{idDestinatario:true,idSolicitante:false,competencia:true,vlGlosa:false,observacoes:false,tipoGlosa:true,tipoAplicacao:true},tipoEntidade:null,uf:null,glosa:{idDestinatario:'01000',idSolicitante:null,competencia:null,vlGlosa:null,observacoes:'',tipoGlosa:1,tipoAplicacao:1},showModalAlerta:false,acao:props.match.params.idglosa?'editar':'novo',estadoFormulario:'inicial',competenciaAberta:null};return _this;}_createClass(CadastroGlosaDeDacao,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(this.props.match.params.idglosa){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('glosa-manual?idGlosa='+this.props.match.params.idglosa,function(r){_this2.setState({glosa:r.data},function(){var soliciante=_this2.props.destinatarios.filter(function(d){return''+d.value===_this2.state.glosa.idSolicitante;})[0];_this2.setState({tipoEntidade:soliciante.tipoRegimeProprio,uf:soliciante.uf});// console.log(soliciante);
_this2.buscaDadosParticipante(soliciante.value);});var glosa=Object.assign({},_this2.state.glosa);glosa.competencia=Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["j" /* pad */])(r.data.mesPagamentoGlosa,2)+'/'+r.data.anoPagamentoGlosa;glosa.vlGlosa=Number(r.data.vlGlosa).toFixed(2).toLocaleString('pt-BR',{currency:'BRL'});_this2.setState({glosa:glosa});},this.handleErrorBusca());// solicitarGlosa(this.props.match.params.idglosa);
}if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}this.buscaCompetenciaAbertaPagamento();}},{key:'render',value:function render(){var _this3=this;var modalAlerta=void 0;if(this.state.showModalAlerta){modalAlerta=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__requerimentos_ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.confirmSendData,handleModal:this.handleFechamentoModalAlerta,showModal:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["e" /* DataGrid */],{title:'Dados do Ente Federativo',icon:'ico-users'},this.montaFiltrosDefault()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["e" /* DataGrid */],{title:'Dados da Glosa',icon:'ico-money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{mask:__WEBPACK_IMPORTED_MODULE_7__utils_masks__["a" /* default */].competencia,label:'Compet\xEAncia',onChange:function onChange(e){return _this3.handleChange(e,'competencia');},value:this.state.glosa.competencia,touched:true,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{currency:true,maxLength:'16',label:'Valor',onChange:function onChange(e){return _this3.handleChange(e,'vlGlosa');},value:this.state.glosa.vlGlosa,touched:this.state.acao==='editar'?true:this.state.validadeCampos.vlGlosa}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{componentClass:'textarea',label:'Observa\xE7\xE3o',onChange:function onChange(e){return _this3.handleChange(e,'observacoes');},value:this.state.glosa.observacoes,touched:this.state.acao==='editar'?true:this.state.validadeCampos.observacoes,maxLength:600,textarea:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['gerenciar-negocio-dcomp']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:'Salvar',onClick:function onClick(){return _this3.handleSaveButton();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* Button */],{className:'left',onClick:this.props.history.goBack,title:'Voltar',hint:'Voltar para tela anterior'}),modalAlerta);}}]);return CadastroGlosaDeDacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CadastroGlosaDeDacao.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,idglosa:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number})}),destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),glosa:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({idGlosa:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,idSolicitante:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,idDestinatario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mesPagamentoGlosa:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,anoPagamentoGlosa:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tipoGlosa:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tipoAplicacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,vlGlosa:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,observacoes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.function,push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired};CadastroGlosaDeDacao.defaultProps={destinatarios:[],match:null,glosa:null};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios,glosa:state.glosa.glosa};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(CadastroGlosaDeDacao));

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DadosRegimeProprio__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrgaosVinculados__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_validator_cnpjValidator__ = __webpack_require__(118);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var camposPreenchidosPorServicoCep={enderecoRpps:['municipio','endereco','ufRpps','bairro']};var RegimeProprio=function(_Component){_inherits(RegimeProprio,_Component);function RegimeProprio(props,context){_classCallCheck(this,RegimeProprio);var _this=_possibleConstructorReturn(this,(RegimeProprio.__proto__||Object.getPrototypeOf(RegimeProprio)).call(this,props,context));_this.getInitialState=function(){return{regimeProprio:{cnpjEf:null,nomeEf:null,ufEf:null,idParticipante:null,convenioTribunalContas:0,tipoRegimeProprio:null,convenioComprev:0,dataConvenio:null,cnpj:null,nomeRpps:null,sigla:null,telefone:null,enderecoEletronico:null,numeroBanco:null,numeroAgencia:null,dvAgencia:null,numeroContaCorrente:null,dvContaCorrente:null,cep:null,endereco:null,bairro:null,municipio:null,ufRpps:null,orgaosVinculados:[],idUOInssConvenio:null},validadeCampos:{// enderecoEletronico: false,
numeroBanco:false,numeroContaCorrente:false,orgaosVinculados:false,idUOInssConvenio:false,dataConvenio:false},isTelefoneMovel:true,indicadorPesquisaComprev:false,exibirDataConvenio:false,touched:false,bancoTouched:false,nomeBanco:null,idUOInssConvenioTouched:false,nomeUOInssConvenio:null,emailTouched:false,acao:'novo',estadoFormulario:'inicial',camposOrgaosVinculadosInvalidos:null,showNoContent:false,noContentPrimaryMessage:'Regime Próprio não encontrado para o cnpj informado.',noContentSecondaryMessage:'Informe um protocolo válido.',requestPesquisa:null,showModalAlerta:false,chaveConfirmacao:null,situacao:null,listaOrgaosCentralizados:[],orgaoCentralizador:{codigo:null,nome:null,sigla:null}};};_this.handleErrorBusca=function(error){var mensagemPrimaria='Não foi possível consultar o regime próprio.';var mensagemSecundaria='Contate o administrador do sistema.';if(error){if(error.status){if(error.status===404){mensagemPrimaria='Ente  Federativo não encontrado para o filtro informado.';mensagemSecundaria='Informe um filtro válido.';}}}_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.handleErrorBuscaOrgaosCentralizados=function(error){var mensagemPrimaria='Não foi possível consultar os orgãos centralizados.';var mensagemSecundaria='Contate o administrador do sistema.';if(error){if(error.status){if(error.status===404){mensagemPrimaria='Ente  Federativo não encontrado para o filtro informado.';mensagemSecundaria='Informe um filtro válido.';}}}_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.formularioProntoParaEnvio=function(){return Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);};_this.buscaParticipanteRppsParaInclusao=function(){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('participantes-rpps',_this.handleSuccessBuscaDadosParticipanteRpps,_this.handleErrorBusca,{idParticipante:_this.props.match.params.codigo});};_this.buscaParticipanteRppsLink=function(codigo){var url='participantes-rpps/codigo/'+codigo;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])(url,_this.handleSuccessBuscaDadosParticipanteRpps,_this.handleErrorBusca);};_this.buscaParticipanteRpps=function(){var url='participantes-rpps/codigo/'+_this.props.match.params.idParticipante;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])(url,_this.handleSuccessBuscaDadosParticipanteRpps,_this.handleErrorBusca);};_this.buscarOrgaosCentralizados=function(codigo){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["z" /* requestOrgaosCentralizados */])(_this.handleErrorBuscaOrgaosCentralizados,codigo);};_this.buscarPeriodosVigenciaRegimesProprios=function(codigo){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["A" /* requestPeriodosVigencia */])(_this.handleErrorBusca,codigo);};_this.buscarAbrangenciasEntidadeParticipanteRPPS=function(codigo){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["o" /* requestAbrangenciasEntidadeParticipanteRPPS */])(_this.handleErrorBusca,codigo);};_this.montaSituacao=function(regimeProprio){var situacao='';if(!regimeProprio.inExtinto&&!regimeProprio.inOrgaoCentralizado&&!regimeProprio.inOrgaoCentralizador){situacao=__WEBPACK_IMPORTED_MODULE_9__utils_constants__["u" /* orgaoAtivo */];}else if(regimeProprio.inOrgaoCentralizador&&regimeProprio.inOrgaoCentralizador===1){situacao=__WEBPACK_IMPORTED_MODULE_9__utils_constants__["w" /* orgaoCentralizador */];}else if(regimeProprio.inExtinto&&regimeProprio.inExtinto===1){situacao=__WEBPACK_IMPORTED_MODULE_9__utils_constants__["x" /* orgaoExtinto */];}else{situacao=__WEBPACK_IMPORTED_MODULE_9__utils_constants__["v" /* orgaoAtivoCentralizado */];}return situacao;};_this.handleSuccessBuscaDadosParticipanteRpps=function(response){var _this$state=Object.assign({},_this.state),orgaoCentralizador=_this$state.orgaoCentralizador;var paramOrgaoCentralizador=orgaoCentralizador;var validadeCampos=_this.montaValidadeCampos(response.data);var paramExibirDataConvenio=false;if(response.data.convenioComprev===1){paramExibirDataConvenio=true;}_this.state.regimeProprio.idParticipante=response.data.codigo;_this.state.regimeProprio.nomeEf=response.data.nome;_this.state.regimeProprio.ufEf=response.data.uf;_this.state.situacao=_this.montaSituacao(response.data);if(_this.state.situacao===__WEBPACK_IMPORTED_MODULE_9__utils_constants__["w" /* orgaoCentralizador */]||_this.state.situacao===__WEBPACK_IMPORTED_MODULE_9__utils_constants__["u" /* orgaoAtivo */]){_this.buscarOrgaosCentralizados(response.data.idParticipante);}if(response.data.participanteCompensacaoCentralizador){if(_this.state.situacao===__WEBPACK_IMPORTED_MODULE_9__utils_constants__["v" /* orgaoAtivoCentralizado */]||_this.state.situacao===__WEBPACK_IMPORTED_MODULE_9__utils_constants__["x" /* orgaoExtinto */]){paramOrgaoCentralizador.codigo=response.data.participanteCompensacaoCentralizador.codigo;paramOrgaoCentralizador.nome=response.data.participanteCompensacaoCentralizador.nome;paramOrgaoCentralizador.sigla=response.data.participanteCompensacaoCentralizador.sigla;}}_this.setState({regimeProprio:Object.assign({},_this.state.regimeProprio,response.data),exibirDataConvenio:paramExibirDataConvenio,orgaoCentralizador:paramOrgaoCentralizador,validadeCampos:validadeCampos},_this.buscarAbrangenciasEntidadeParticipanteRPPS(response.data.idParticipante),_this.buscarPeriodosVigenciaRegimesProprios(response.data.idParticipante));var _this$state2=Object.assign({},_this.state),regimeProprio=_this$state2.regimeProprio;var bancoTouched=true;if(regimeProprio.numeroBanco&&regimeProprio.numeroBanco!==null){_this.setState(Object.assign({},_this.state,{bancoTouched:bancoTouched}),_this.handleInstituicaoBancariaSemCriticas);}var idUOInssConvenioTouched=true;if(regimeProprio.inOrgaoUniao!==1&&regimeProprio.idUOInssConvenio&&regimeProprio.idUOInssConvenio!==null){_this.setState(Object.assign({},_this.state,{idUOInssConvenioTouched:idUOInssConvenioTouched}),_this.handleIdUOInssConvenioSearch);}var emailTouched=false;if(regimeProprio.enderecoEletronico&&regimeProprio.enderecoEletronico!==null){emailTouched=true;_this.setState(Object.assign({},_this.state,{emailTouched:emailTouched}));}var touched=true;if(regimeProprio.convenioComprev&&regimeProprio.convenioComprev!==0){touched=true;_this.setState(Object.assign({},_this.state,{touched:touched}));}_this.verificarFormatacaoTelefone(regimeProprio);touched=false;bancoTouched=false;idUOInssConvenioTouched=false;_this.setState({bancoTouched:bancoTouched,idUOInssConvenioTouched:idUOInssConvenioTouched,touched:touched,emailTouched:emailTouched});};_this.montaFormulario=function(){_this.setState({acao:_this.props.match.params.acao},_this.buscaParticipanteRpps());};_this.montaValidadeCampos=function(){var _this$state3=Object.assign({},_this.state),validadeCampos=_this$state3.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});return validadeCampos;};_this.handleChangeAptoConvenio=function(changeObj,name){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var _this$state4=Object.assign({},_this.state),regimeProprio=_this$state4.regimeProprio;var _this$state5=Object.assign({},_this.state),validadeCampos=_this$state5.validadeCampos;var valor=0;var paramExibirDataConvenio=false;if(changeObj.value===1){valor=1;paramExibirDataConvenio=true;}else{Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});}if(valor===0&&regimeProprio.dataConvenio!==''){validadeCampos.dataConvenio=true;}if(valor===1){if(regimeProprio.dataConvenio===''||regimeProprio.dataConvenio===null){validadeCampos.dataConvenio=false;}if((regimeProprio.numeroBanco===''||regimeProprio.numeroBanco===null)&&regimeProprio.inOrgaoUniao==='0'){validadeCampos.numeroBanco=false;}if(regimeProprio.numeroContaCorrente===''||regimeProprio.numeroContaCorrente===null){validadeCampos.numeroContaCorrente=false;}if(regimeProprio.idUOInssConvenio===''||regimeProprio.idUOInssConvenio===null){validadeCampos.idUOInssConvenio=false;}}_this.setState({exibirDataConvenio:paramExibirDataConvenio,regimeProprio:Object.assign({},regimeProprio,_defineProperty({},name,valor)),validadeCampos:Object.assign({},_this.state.validadeCampos)},callback);};_this.handleChange=function(changeObj,name){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var _this$state6=Object.assign({},_this.state),regimeProprio=_this$state6.regimeProprio;if(name==='numeroBanco'||name==='numeroContaCorrente'||name==='orgaosVinculados'||name==='idUOInssConvenio'||name==='dataConvenio'){_this.setState({validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))});}if(name==='idUOInssConvenio'&&changeObj.value===''){_this.setState({nomeUOInssConvenio:''});}_this.setState({regimeProprio:Object.assign({},regimeProprio,_defineProperty({},name,changeObj.value))},callback);};_this.handleChangeOrgaosVinculados=function(changeObj,name){var _this$state7=Object.assign({},_this.state),regimeProprio=_this$state7.regimeProprio;_this.setState({regimeProprio:Object.assign({},regimeProprio,_defineProperty({},name,changeObj))});};_this.trataSucessoResponseInstBancariaPesquisa=function(response){var _this$state8=Object.assign({},_this.state),validadeCampos=_this$state8.validadeCampos;var regimeProprioAtual=_this.state.regimeProprio;if(regimeProprioAtual.numeroBanco){if(regimeProprioAtual.numeroBanco.length===1){regimeProprioAtual.numeroBanco='00'+regimeProprioAtual.numeroBanco;}}_this.setState({regimeProprio:Object.assign({},regimeProprioAtual),nomeBanco:response.data.nomeBanco,requestPesquisa:null,validadeCampos:validadeCampos});};_this.handleInstituicaoBancariaSearch=function(){if(_this.state.bancoTouched){var _this$state$regimePro=Object.assign({},_this.state.regimeProprio),numeroBanco=_this$state$regimePro.numeroBanco;var _this$state$regimePro2=Object.assign({},_this.state.regimeProprio),inOrgaoUniao=_this$state$regimePro2.inOrgaoUniao;if(inOrgaoUniao===1&&(numeroBanco===null||numeroBanco==='000'||numeroBanco==='0'||numeroBanco==='00')){var regimeProprioAtual=_this.state.regimeProprio;if(regimeProprioAtual.numeroBanco){if(regimeProprioAtual.numeroBanco.length<3){regimeProprioAtual.numeroBanco='000';}}regimeProprioAtual.numeroAgencia='0';regimeProprioAtual.dvAgencia='0';regimeProprioAtual.numeroContaCorrente='0';regimeProprioAtual.dvContaCorrente='0';regimeProprioAtual.nomeBanco='';_this.setState({regimeProprio:Object.assign({},regimeProprioAtual),nomeBanco:'',requestPesquisa:null});}else{_this.setState({requestPesquisa:'instituicaoBancaria'},Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('instituicao-bancaria/'+numeroBanco,_this.trataSucessoResponseInstBancariaPesquisa,_this.trataErrosResponse));}}};_this.handleInstituicaoBancariaSemCriticas=function(){if(_this.state.bancoTouched){var _this$state$regimePro3=Object.assign({},_this.state.regimeProprio),numeroBanco=_this$state$regimePro3.numeroBanco;var _this$state$regimePro4=Object.assign({},_this.state.regimeProprio),inOrgaoUniao=_this$state$regimePro4.inOrgaoUniao;if(inOrgaoUniao===1&&(numeroBanco===null||numeroBanco==='000'||numeroBanco==='0'||numeroBanco==='00')){_this.state.regimeProprio.numeroBanco='000';_this.state.regimeProprio.nomeBanco='';}else{_this.setState({requestPesquisa:'instituicaoBancaria'},Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('instituicao-bancaria/'+numeroBanco,_this.trataSucessoResponseInstBancariaPesquisa));}}};_this.trataSucessoResponseIdUOInssConvenio=function(response){var _this$state9=Object.assign({},_this.state),validadeCampos=_this$state9.validadeCampos;var regimeProprioAtual=_this.state.regimeProprio;validadeCampos.idUOInssConvenio=true;_this.setState({regimeProprio:Object.assign({},regimeProprioAtual),nomeUOInssConvenio:response.data.nomeUnidade,requestPesquisa:null,validadeCampos:validadeCampos});};_this.handleIdUOInssConvenioSearch=function(){if(_this.state.idUOInssConvenioTouched){var _this$state$regimePro5=Object.assign({},_this.state.regimeProprio),idUOInssConvenio=_this$state$regimePro5.idUOInssConvenio;_this.setState({requestPesquisa:'idUOInssConvenio'},Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('uo-inss/'+idUOInssConvenio,_this.trataSucessoResponseIdUOInssConvenio,_this.trataErrosResponse));}};_this.handleBlur=function(){var _this$state10=Object.assign({},_this.state),regimeProprio=_this$state10.regimeProprio;var _this$state11=Object.assign({},_this.state),validadeCampos=_this$state11.validadeCampos;var bancoTouched=false;if(regimeProprio.dvAgencia){var paramDvAgencia=regimeProprio.dvAgencia.toUpperCase();regimeProprio.dvAgencia=paramDvAgencia;}if(regimeProprio.dvContaCorrente){var paramDvContaCorrente=regimeProprio.dvContaCorrente.toUpperCase();regimeProprio.dvContaCorrente=paramDvContaCorrente;}_this.setState({regimeProprio:Object.assign({},regimeProprio),validadeCampos:Object.assign({},validadeCampos)});if(regimeProprio.numeroBanco){if(regimeProprio.numeroBanco.length<4){bancoTouched=true;_this.setState(Object.assign({},_this.state,{bancoTouched:bancoTouched}),_this.handleInstituicaoBancariaSearch);}}};_this.handleBlurIdUOInssConvenio=function(){var _this$state12=Object.assign({},_this.state),regimeProprio=_this$state12.regimeProprio;var idUOInssConvenioTouched=false;if(regimeProprio.idUOInssConvenio){idUOInssConvenioTouched=true;_this.setState(Object.assign({},_this.state,{idUOInssConvenioTouched:idUOInssConvenioTouched}),_this.handleIdUOInssConvenioSearch);}};_this.verificarFormatacaoTelefone=function(regimeProprio){var _this$state13=Object.assign({},_this.state),isTelefoneMovel=_this$state13.isTelefoneMovel;if(regimeProprio.telefone&&regimeProprio.telefone!==''&&regimeProprio.telefone!==null){var tel=regimeProprio.telefone.trim();var telaux='';telaux=tel.replace(/[^0-9,]*/g,'');if(telaux.length===10){// é fixo
var paramIsTelefoneMovel=false;isTelefoneMovel=paramIsTelefoneMovel;}else{isTelefoneMovel=true;}}_this.setState(Object.assign({},_this.state,{isTelefoneMovel:isTelefoneMovel}));};_this.handleBlurTelefone=function(){var _this$state14=Object.assign({},_this.state),regimeProprio=_this$state14.regimeProprio;var _this$state15=Object.assign({},_this.state),isTelefoneMovel=_this$state15.isTelefoneMovel;if(regimeProprio.telefone&&regimeProprio.telefone!==''&&regimeProprio.telefone!==null){if(regimeProprio.telefone.length===10){// é movel
var paramIsTelefoneMovel=false;isTelefoneMovel=paramIsTelefoneMovel;}else{isTelefoneMovel=true;}}_this.setState(Object.assign({},_this.state,{isTelefoneMovel:isTelefoneMovel}));};_this.handleBlurDigitoVerificador=function(){var _this$state16=Object.assign({},_this.state),regimeProprio=_this$state16.regimeProprio;var _this$state17=Object.assign({},_this.state),validadeCampos=_this$state17.validadeCampos;if(regimeProprio.dvAgencia){var dvAgencia=regimeProprio.dvAgencia.toUpperCase();regimeProprio.dvAgencia=dvAgencia;}if(regimeProprio.dvContaCorrente){var dvContaCorrente=regimeProprio.dvContaCorrente.toUpperCase();regimeProprio.dvContaCorrente=dvContaCorrente;}_this.setState({regimeProprio:Object.assign({},regimeProprio),validadeCampos:Object.assign({},validadeCampos)});};_this.validacaoErrosOrgaoVinculado=function(errosOrgaoVinculado){var camposInvalidos=null;// if (isDelete) {
//   camposInvalidos = errosOrgaoVinculado;
// } else {
camposInvalidos=_this.state.camposOrgaosVinculadosInvalidos.filter(function(erro){return errosOrgaoVinculado.includes(erro)?null:erro;});// }
_this.setState({camposOrgaosVinculadosInvalidos:camposInvalidos});};_this.handleCadPrevSearch=function(){var _this$state$regimePro6=Object.assign({},_this.state.regimeProprio),cnpjEf=_this$state$regimePro6.cnpjEf;_this.setState({requestPesquisa:'cadprev'},Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('cadprev/'+cnpjEf,_this.trataSucessoResponseCadPrevPesquisa,_this.trataErrosResponse));};_this.handleSearchCadPrevButton=function(){_this.setState(_this.handleCadPrevSearch);};_this.handleSearchCepButton=function(){var cepTouched=true;_this.setState(Object.assign({},_this.state,{cepTouched:cepTouched}),_this.handleCepSearch);};_this.handleCepSearch=function(){if(_this.state.validadeCampos.cep){var _this$state$regimePro7=Object.assign({},_this.state.regimeProprio),cep=_this$state$regimePro7.cep;_this.setState({requestPesquisa:'enderecoRpps'},Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('cep/'+cep,_this.trataSucessoResponseCepPesquisa,_this.trataErrosResponse));}};_this.trataSucessoResponseCepPesquisa=function(response){var _this$state18=Object.assign({},_this.state),validadeCampos=_this$state18.validadeCampos;var regimeProprioAtual=_this.state.regimeProprio;camposPreenchidosPorServicoCep[_this.state.requestPesquisa].forEach(function(key){validadeCampos[key]=true;});regimeProprioAtual.endereco=response.data.tipoLogradouro+'. '+response.data.descricao;regimeProprioAtual.municipio=response.data.codigoMunicipioPrev;regimeProprioAtual.bairro=response.data.nomeBairro;regimeProprioAtual.ufRpps=response.data.siglaUf;_this.setState({regimeProprio:Object.assign({},regimeProprioAtual),requestPesquisa:null,validadeCampos:validadeCampos});};_this.trataErrosResponse=function(error){var _this$state19=Object.assign({},_this.state),validadeCampos=_this$state19.validadeCampos;var _this$state20=Object.assign({},_this.state),regimeProprio=_this$state20.regimeProprio;if(error&&error.data&&error.data.tipo===2){var _error=Object.assign({},error),data=_error.data;_this.setState({chaveConfirmacao:data.chaveConfirmacao,alertas:data.alertas,showModalAlerta:!_this.state.showModalAlerta});}else{if(_this.state.requestPesquisa){switch(_this.state.requestPesquisa){case'enderecoRpps':camposPreenchidosPorServicoCep[_this.state.requestPesquisa].forEach(function(key){validadeCampos[key]=false;regimeProprio[key]='';});Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['CEP inválido. Informe um CEP válido.']);break;case'instituicaoBancaria':_this.setState({nomeBanco:''});Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Código do banco inválido. Informe um código de banco válido.']);break;case'idUOInssConvenio':_this.setState({nomeUOInssConvenio:''});Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Código da UO inválido. Informe um código de UO válido.']);break;case'cadprev':Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Não foi possível se comunicar com o serviço CADPREV.']);break;default:Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);}}if(error){var _error2=Object.assign({},error),_data=_error2.data;if(error.status===400){var camposOrgaosVinculadosInvalidos=[];if(_data.erros&&_data.erros.length>=1){_data.erros.forEach(function(erro){if(erro.atributo in validadeCampos){validadeCampos[[erro.atributo]]=false;}// eslint-disable-next-line
if(erro.hasOwnProperty('indiceLista')){camposOrgaosVinculadosInvalidos.push(erro);validadeCampos.orgaosVinculados=false;}});_this.setState(Object.assign({},_this.state,{validadeCampos:validadeCampos,camposOrgaosVinculadosInvalidos:camposOrgaosVinculadosInvalidos,estadoFormulario:'erro-regra'}));}}}}};_this.formularioRegimeProprio=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DadosRegimeProprio__["a" /* default */],{acao:_this.state.acao,estadoFormulario:_this.state,handleChange:_this.handleChange,handleChangeAptoConvenio:_this.handleChangeAptoConvenio,handleKeyUp:_this.handleKeyUp,handleBlur:_this.handleBlur,handleBlurDigitoVerificador:_this.handleBlurDigitoVerificador,handleBlurIdUOInssConvenio:_this.handleBlurIdUOInssConvenio,match:_this.props.match,periodosVigencia:_this.props.periodosVigencia,orgaosCentralizados:_this.props.orgaosCentralizados,handleCadPrevSearch:_this.handleCadPrevSearch,auth:_this.props.auth// handleSearchCepButton={this.handleSearchCepButton}
// handleBlurTelefone={this.handleBlurTelefone}
,abrangenciasEntidadeParticipanteRPPS:_this.props.abrangenciasEntidadeParticipanteRPPS,buscaParticipanteRpps:_this.buscaParticipanteRppsLink,handleSuccessBuscaDadosParticipanteRpps:_this.handleSuccessBuscaDadosParticipanteRpps,handleErrorBusca:_this.handleErrorBusca});};_this.montaCorpoCadastro=function(){var corpoRequerimento=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["G" /* DtpTabGroup */],{className:'dtp-default'},_this.montaTabs());return corpoRequerimento;};_this.tabFormulario=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["F" /* DtpTab */],{id:'item1',className:'active',title:'Dados b\xE1sicos'},_this.formularioRegimeProprio());};_this.tabListaOrgaosVinculados=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["F" /* DtpTab */],{id:'item2',title:'Org\xE3os Vinculados'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__OrgaosVinculados__["a" /* default */],{acao:_this.state.acao,estadoFormulario:_this.state,orgaosVinculados:[].concat(_toConsumableArray(_this.state.regimeProprio.orgaosVinculados))// orgaosVinculados={[...this.props.abrangenciasEntidadeParticipanteRPPS]}
,handleChange:_this.handleChange,handleChangeOrgaosVinculados:_this.handleChangeOrgaosVinculados,auth:_this.props.auth}));};_this.montaTabs=function(){var listaTabs=[];listaTabs.push(_this.tabFormulario());// if (this.state.regimeProprio.orgaosVinculados &&
//   this.state.regimeProprio.orgaosVinculados.length > 0) {
if(_this.state.regimeProprio.inOrgaoUniao===undefined||_this.state.regimeProprio.inOrgaoUniao!==undefined&&_this.state.regimeProprio.inOrgaoUniao===0){listaTabs.push(_this.tabListaOrgaosVinculados());}return listaTabs;};_this.handleSaveButton=function(){_this.confirmSendData();};_this.confirmSendData=function(){var cnpjValido=Object(__WEBPACK_IMPORTED_MODULE_10__utils_validator_cnpjValidator__["a" /* default */])(_this.state.regimeProprio.cnpj);if(!cnpjValido){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['CNPJ Inválido. Informe um CNPJ válido.']);return;}var touched=true;var url='participantes-compensacao';var _this$state21=Object.assign({},_this.state),validadeCampos=_this$state21.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});_this.setState({touched:touched,validadeCampos:validadeCampos,requestPesquisa:null},function(){return _this.handleSave(url);});};_this.handleSave=function(url){if(_this.formularioProntoParaEnvio()){var options=void 0;if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}var _this$state22=Object.assign({},_this.state),regimeProprio=_this$state22.regimeProprio;regimeProprio.periodosVigencia=_this.props.periodosVigencia;// Alteração necessária para apagar a data do
// convênio somente quando for salvar os dados do participante
if(regimeProprio.convenioComprev===0){regimeProprio.dataConvenio='';}if(regimeProprio.orgaosVinculados&&regimeProprio.orgaosVinculados.length>0){var colecao=[];regimeProprio.orgaosVinculados.forEach(function(orgao){if(orgao.flagOperacao){colecao.push(orgao);}});if(colecao.length>0){regimeProprio.orgaosVinculados=colecao;}else{// não alterou e nem incluiu orgao vinculado
var listaOrgaosVinculadosAux=[];regimeProprio.orgaosVinculados.map(function(item,i){var itemIndexado=item;itemIndexado.contador=i;if(i<=5){listaOrgaosVinculadosAux.push(itemIndexado);}return listaOrgaosVinculadosAux;});regimeProprio.orgaosVinculados=[];regimeProprio.orgaosVinculados=listaOrgaosVinculadosAux;}}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["n" /* doPut */])(url,regimeProprio,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,options);}else{Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Informe corretamente os atributos indicados na tela.']);}};_this.trataSucesso=function(){var mensagemSucesso='Ente Federativo atualizado.';// this.props.history.goBack();
_this.montaFormulario();_this.setState({estadoFormulario:'criado'});Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["J" /* trataMensagemSucesso */])([mensagemSucesso]);};_this.trataSucessoResponseEnvio=function(){if(_this.state.chaveConfirmacao){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta},_this.trataSucesso);}else{_this.trataSucesso();}};_this.state=_this.getInitialState();return _this;}_createClass(RegimeProprio,[{key:'componentDidMount',value:function componentDidMount(){this.montaFormulario();}// necessario porque o banco de dados nao grava o nome da inst bancaria
// e isso é carregado ao renderizar a pag,
// nao deve haver criticas caso seja um orgao da uniao (pois pode existir banco zerado),
// porem permitir buscar do sdc mesmo sendo orgao da uniao
/**
   * Trata o click no botão de busca por CPF no CNIS.
   *//**
   * Trata os erros nas requisicoes (busca e submissao de formulario)
   *//**
  * Trata o click do botao de submissao do formulario
  * Se analise estiver indeferindo, exibir alerta de confirmacao
  *//**
  * Trata envio dos dados
  *//**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */},{key:'render',value:function render(){if(this.state.reset){return null;}if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}var botaoAcaoPrincipal=void 0;var configBotaoPrincipal={onClick:this.handleSaveButton};configBotaoPrincipal.permissoes=['analisar-negocio-sprev'];configBotaoPrincipal.titulo='Salvar';configBotaoPrincipal.hint='Salvar Regime Próprio';var botaoAcaoVoltar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{className:'left',onClick:this.props.history.goBack,title:'Voltar',hint:'Voltar para tela anterior'});if(configBotaoPrincipal.titulo){botaoAcaoPrincipal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:configBotaoPrincipal.permissoes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:configBotaoPrincipal.titulo,onClick:configBotaoPrincipal.onClick,hint:configBotaoPrincipal.hint}));}var retorno=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,this.montaCorpoCadastro(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},botaoAcaoVoltar,botaoAcaoPrincipal));return retorno;}}]);return RegimeProprio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RegimeProprio.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({idParticipante:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,codigo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.function}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}),periodosVigencia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({cnpj:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataCriacaoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataEncerramentoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),orgaosCentralizados:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({codigo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),abrangenciasEntidadeParticipanteRPPS:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({cnpj:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,idParticipante:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nomeOrgaoVinculado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,situacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};RegimeProprio.defaultProps={match:null,auth:null,periodosVigencia:[],orgaosCentralizados:[],abrangenciasEntidadeParticipanteRPPS:[]};var mapStateToProps=function mapStateToProps(state){return{periodosVigencia:state.base.periodosVigencia,orgaosCentralizados:state.base.orgaosCentralizados,abrangenciasEntidadeParticipanteRPPS:state.base.abrangenciasEntidadeParticipanteRPPS};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(RegimeProprio));

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_constants__ = __webpack_require__(9);
/* eslint-disable jsx-a11y/anchor-is-valid */var DadosRegimeProprio=function DadosRegimeProprio(props){var addTipoEntidadeLabel=function addTipoEntidadeLabel(tipo){var obj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["E" /* tipoEntidade */],tipo);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;};var listaPeriodosIndexada=props.periodosVigencia.map(function(item,i){var itemIndexado=item;itemIndexado.index=i;if(itemIndexado.origemCadprev){itemIndexado.processado=true;}return itemIndexado;});var periodosVigencia=void 0;if(props.periodosVigencia.length>0){periodosVigencia=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["d" /* ControlePeriodosVigencia */],{periodosVigencia:listaPeriodosIndexada// handleSearchPesquisaCadPrevButton={handleSearchCadPrevButton}
});}var listaOrgaosCentralizados=props.orgaosCentralizados.map(function(item,i){var itemIndexado=item;itemIndexado.index=i;return itemIndexado;});var orgaosCentralizados=void 0;if(props.orgaosCentralizados.length>0){orgaosCentralizados=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["c" /* ControleOrgaosCentralizados */],{orgaosCentralizados:listaOrgaosCentralizados,buscaParticipanteRpps:props.buscaParticipanteRpps// handleSuccessBuscaDadosParticipanteRpps={props.handleSuccessBuscaDadosParticipanteRpps}
// handleErrorBusca={props.handleErrorBusca}
});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["e" /* DataGrid */],{title:'Dados do Ente Federativo',icon:'ico-user-plus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'CNPJ do Ente Federativo',mask:__WEBPACK_IMPORTED_MODULE_2__utils_masks__["a" /* default */].cnpj,showMask:true,value:props.estadoFormulario.regimeProprio.cnpjEf})),props.estadoFormulario.regimeProprio.inOrgaoUniao!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Nome do Ente Federativo',value:props.estadoFormulario.regimeProprio.nomeEf})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Nome do Ente Federativo',value:props.estadoFormulario.regimeProprio.nomeEf})),props.estadoFormulario.regimeProprio.inOrgaoUniao!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'UF',value:props.estadoFormulario.regimeProprio.ufEf})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Tipo da Entidade',value:addTipoEntidadeLabel(props.estadoFormulario.regimeProprio.tipoRegimeProprio),custom:true,onChange:function onChange(e){return props.handleChange(e,'tipoRegimeProprio');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,integer:true,label:'C\xF3digo',value:props.estadoFormulario.regimeProprio.idParticipante}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},props.estadoFormulario.regimeProprio.inOrgaoUniao===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Situa\xE7\xE3o',value:props.estadoFormulario.situacao}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},props.estadoFormulario.acao==='novo'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{number:true,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["b" /* convenioComprev */],label:'Conveniado',onChange:function onChange(e){return props.handleChangeAptoConvenio(e,'convenioComprev');},touched:props.estadoFormulario.touched,value:props.estadoFormulario.regimeProprio.convenioComprev,placeholder:'Selecione a op\xE7\xE3o',custom:true}):'',props.estadoFormulario.acao==='atualizar-rpps'&&props.auth.checkPermission(['analisar-negocio-sprev'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{number:true,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["b" /* convenioComprev */],label:'Conveniado',onChange:function onChange(e){return props.handleChangeAptoConvenio(e,'convenioComprev');},touched:props.estadoFormulario.touched,value:props.estadoFormulario.regimeProprio.convenioComprev,placeholder:'Selecione a op\xE7\xE3o',custom:true}):'',!props.auth.checkPermission(['analisar-negocio-sprev'])&&props.estadoFormulario.regimeProprio.convenioComprev===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{id:'conveniadoSim',label:'',value:'Conveniado',disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),onChange:function onChange(e){return props.handleChange(e,'convenioComprev');}}):''),props.estadoFormulario.exibirDataConvenio?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),label:'Data do Conv\xEAnio',onChange:function onChange(e){return props.handleChange(e,'dataConvenio');},showMask:true,value:props.estadoFormulario.regimeProprio.dataConvenio,mask:__WEBPACK_IMPORTED_MODULE_2__utils_masks__["a" /* default */].date,touched:props.estadoFormulario.touched,required:true})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),label:'Email',maxLength:'100',onChange:function onChange(e){return props.handleChange(e,'enderecoEletronico');},value:props.estadoFormulario.regimeProprio.enderecoEletronico,touched:props.estadoFormulario.emailTouched}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'1 1 1 1'},props.estadoFormulario.regimeProprio.convenioComprev===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,error:!props.estadoFormulario.validadeCampos.numeroBanco,maxLength:'3',label:'Banco',onChange:function onChange(e){return props.handleChange(e,'numeroBanco');},onBlur:function onBlur(e){return props.handleBlur(e,'numeroBanco');},value:props.estadoFormulario.regimeProprio.numeroBanco,dadosBancarios:true,touched:props.estadoFormulario.touched||props.estadoFormulario.bancoTouched}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),error:!props.estadoFormulario.validadeCampos.numeroBanco,maxLength:'3',label:'Banco',onChange:function onChange(e){return props.handleChange(e,'numeroBanco');},onBlur:function onBlur(e){return props.handleBlur(e,'numeroBanco');},value:props.estadoFormulario.regimeProprio.numeroBanco,dadosBancarios:true,touched:props.estadoFormulario.touched||props.estadoFormulario.bancoTouched,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev'])||props.estadoFormulario.regimeProprio.convenioComprev===0,value:props.estadoFormulario.nomeBanco,onChange:function onChange(e){return props.handleChange(e,'nomeBanco');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'2 2 2 2'},props.estadoFormulario.regimeProprio.convenioComprev===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,label:'Ag\xEAncia',maxLength:'4',value:props.estadoFormulario.regimeProprio.numeroAgencia,onChange:function onChange(e){return props.handleChange(e,'numeroAgencia');},dadosBancarios:true,touched:props.estadoFormulario.touched}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),label:'Ag\xEAncia',maxLength:'4',value:props.estadoFormulario.regimeProprio.numeroAgencia,onChange:function onChange(e){return props.handleChange(e,'numeroAgencia');},dadosBancarios:true,touched:props.estadoFormulario.touched,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,value:'-',style:{borderBottom:'none','text-align':'center'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev'])||props.estadoFormulario.regimeProprio.convenioComprev===0,label:'DV',maxLength:'1',value:props.estadoFormulario.regimeProprio.dvAgencia,onChange:function onChange(e){return props.handleChange(e,'dvAgencia');},onBlur:function onBlur(e){return props.handleBlurDigitoVerificador(e,'dvAgencia');},touched:props.estadoFormulario.touched})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'2 2 2 2'},props.estadoFormulario.regimeProprio.convenioComprev===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,error:!props.estadoFormulario.validadeCampos.numeroContaCorrente,label:'Conta Corrente',maxLength:'12',value:props.estadoFormulario.regimeProprio.numeroContaCorrente,onChange:function onChange(e){return props.handleChange(e,'numeroContaCorrente');},dadosBancarios:true,touched:props.estadoFormulario.touched}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),error:!props.estadoFormulario.validadeCampos.numeroContaCorrente,label:'Conta Corrente',maxLength:'12',value:props.estadoFormulario.regimeProprio.numeroContaCorrente,onChange:function onChange(e){return props.handleChange(e,'numeroContaCorrente');},dadosBancarios:true,touched:props.estadoFormulario.touched,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:true,value:'-',style:{borderBottom:'none','text-align':'center'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev'])||props.estadoFormulario.regimeProprio.convenioComprev===0,maxlength:'1',label:'DV',value:props.estadoFormulario.regimeProprio.dvContaCorrente,onChange:function onChange(e){return props.handleChange(e,'dvContaCorrente');},onBlur:function onBlur(e){return props.handleBlurDigitoVerificador(e,'dvContaCorrente');},touched:props.estadoFormulario.touched}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'5 5 5 5'},props.estadoFormulario.regimeProprio.inOrgaoUniao!==1&&props.estadoFormulario.regimeProprio.convenioComprev===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),error:!props.estadoFormulario.validadeCampos.idUOInssConvenio,label:'UO INSS',onChange:function onChange(e){return props.handleChange(e,'idUOInssConvenio');},onBlur:function onBlur(e){return props.handleBlurIdUOInssConvenio(e,'idUOInssConvenio');},value:props.estadoFormulario.regimeProprio.idUOInssConvenio,dadosBancarios:true,maxlength:'11',touched:props.estadoFormulario.touched||props.estadoFormulario.idUOInssConvenio}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),error:!props.estadoFormulario.validadeCampos.idUOInssConvenio,label:'UO INSS',onChange:function onChange(e){return props.handleChange(e,'idUOInssConvenio');},onBlur:function onBlur(e){return props.handleBlurIdUOInssConvenio(e,'idUOInssConvenio');},value:props.estadoFormulario.regimeProprio.idUOInssConvenio,dadosBancarios:true,maxlength:'11',touched:props.estadoFormulario.touched||props.estadoFormulario.idUOInssConvenio,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'7 7 7 7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),value:props.estadoFormulario.nomeUOInssConvenio,onChange:function onChange(e){return props.handleChange(e,'nomeUOInssConvenio');}})))),props.estadoFormulario.regimeProprio.inOrgaoUniao===1&&(props.estadoFormulario.situacao===__WEBPACK_IMPORTED_MODULE_5__utils_constants__["v" /* orgaoAtivoCentralizado */]||props.estadoFormulario.situacao===__WEBPACK_IMPORTED_MODULE_5__utils_constants__["x" /* orgaoExtinto */])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["e" /* DataGrid */],{title:props.estadoFormulario.situacao===__WEBPACK_IMPORTED_MODULE_5__utils_constants__["x" /* orgaoExtinto */]?'Orgão Sucessor':'Orgão Controlador',icon:'ico-doc-book'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'row',href:'#'// eslint-disable-next-line
,onClick:function onClick(){return props.buscaParticipanteRpps(props.estadoFormulario.orgaoCentralizador.codigo);}},props.estadoFormulario.orgaoCentralizador.codigo+' -\n                '+props.estadoFormulario.orgaoCentralizador.nome+' -\n                '+props.estadoFormulario.orgaoCentralizador.sigla)))):'',props.estadoFormulario.situacao===__WEBPACK_IMPORTED_MODULE_5__utils_constants__["w" /* orgaoCentralizador */]||props.estadoFormulario.situacao===__WEBPACK_IMPORTED_MODULE_5__utils_constants__["u" /* orgaoAtivo */]?orgaosCentralizados:'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["e" /* DataGrid */],{title:'Dados do Regime Pr\xF3prio Vigente',icon:'ico-user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),label:'CNPJ do RPPS',mask:__WEBPACK_IMPORTED_MODULE_2__utils_masks__["a" /* default */].cnpj,showMask:true,value:props.estadoFormulario.regimeProprio.cnpj,onChange:function onChange(e){return props.handleChange(e,'cnpj');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),label:'Nome',maxLength:'100',value:props.estadoFormulario.regimeProprio.nomeRpps,onChange:function onChange(e){return props.handleChange(e,'nomeRpps');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),maxLength:'20',label:'Sigla',value:props.estadoFormulario.regimeProprio.sigla,onChange:function onChange(e){return props.handleChange(e,'sigla');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),label:'Telefone',onChange:function onChange(e){// console.log(e);
var cleanPhone={value:e.value.replace(/[^\d \-()]/g,''),isValid:true};props.handleChange(cleanPhone,'telefone');},maxLength:'14',value:props.estadoFormulario.regimeProprio.telefone}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),label:'CEP',value:props.estadoFormulario.regimeProprio.cep,mask:__WEBPACK_IMPORTED_MODULE_2__utils_masks__["a" /* default */].cep,integer:true,showMask:true,onChange:function onChange(e){return props.handleChange(e,'cep');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),label:'Endere\xE7o',value:props.estadoFormulario.regimeProprio.endereco,onChange:function onChange(e){return props.handleChange(e,'endereco');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),label:'Bairro',value:props.estadoFormulario.regimeProprio.bairro,onChange:function onChange(e){return props.handleChange(e,'bairro');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),label:'Codigo do munic\xEDpio',integer:true,maxlength:'5',value:props.estadoFormulario.regimeProprio.municipio,onChange:function onChange(e){return props.handleChange(e,'municipio');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{disabled:!props.auth.checkPermission(['analisar-negocio-sprev']),label:'UF',value:props.estadoFormulario.regimeProprio.ufRpps,onChange:function onChange(e){return props.handleChange(e,'ufRpps');}})))),periodosVigencia);};DadosRegimeProprio.propTypes={acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleBlur:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleBlurDigitoVerificador:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleBlurIdUOInssConvenio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleChangeAptoConvenio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),periodosVigencia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({cnpj:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataCriacaoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataEncerramentoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),orgaosCentralizados:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({codigo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,buscaParticipanteRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired// handleSuccessBuscaDadosParticipanteRpps: PropTypes.func.isRequired,
// handleErrorBusca: PropTypes.func.isRequired,
};DadosRegimeProprio.defaultProps={match:null,periodosVigencia:[],orgaosCentralizados:[]};/* harmony default export */ __webpack_exports__["a"] = (DadosRegimeProprio);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OrgaoVinculado__ = __webpack_require__(216);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrgaoVinculados=function(_Component){_inherits(OrgaoVinculados,_Component);function OrgaoVinculados(){_classCallCheck(this,OrgaoVinculados);var _this=_possibleConstructorReturn(this,(OrgaoVinculados.__proto__||Object.getPrototypeOf(OrgaoVinculados)).call(this));_this.getInitialState=function(){return{acaoModal:'criacao',showModal:false,cnpjOrgao:null,nomeOrgao:null,errosOrgaoVinculadoSelecionado:null,orgaoVinculadoSelecionado:null};};_this.handleModal=function(){_this.setState({showModal:!_this.state.showModal,acaoModal:_this.state.acaoModal});};_this.handleSearchButton=function(){_this.handleSearch();};_this.handleSearch=function(){var paramCnpj='';var paramNome='';if(_this.state.cnpjOrgao){paramCnpj=_this.state.cnpjOrgao.toUpperCase();if(_this.state.cnpjOrgao.indexOf('_')!==-1){paramCnpj=_this.state.cnpjOrgao.toString().replace(/_/g,'');}}if(_this.state.nomeOrgao){paramNome=_this.state.nomeOrgao.toUpperCase();}_this.state.cnpjOrgao=paramCnpj;_this.state.nomeOrgao=paramNome;var parametros={codigo:_this.props.estadoFormulario.regimeProprio.idParticipante,cnpjFiltro:paramCnpj,nomeFiltro:paramNome};_this.buscarCNPJNomeOrgao(parametros);};_this.buscarCNPJNomeOrgao=function(parametros){var url='participantes-rpps/codigo/';Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["l" /* doPost */])(url,parametros,_this.handleSucessBuscarCNPJNomeOrgao,_this.handleErrorBusca);};_this.preparaRequest=function(urlRelatorio,parametros,callback){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["l" /* doPost */])(urlRelatorio,parametros,callback,_this.tratarErro);};_this.handleSucessBuscarCNPJNomeOrgao=function(response){var listaOrgaosVinculados=[];if(response.data.orgaosVinculados.length>0){listaOrgaosVinculados=response.data.orgaosVinculados.map(function(item){return{cnpj:item.cnpj,nomeOrgaoVinculado:item.nomeOrgaoVinculado,situacao:item.situacao};});}_this.props.handleChangeOrgaosVinculados(listaOrgaosVinculados,'orgaosVinculados');};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value));};_this.createCustomInsertButton=function(orgao){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.props.auth.checkPermission(['analisar-negocio-sprev'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:'Adicionar Org\xE3o Vinculado',icon:'ico-user-plus',onClick:function onClick(){return _this.incluirOrgaoVinculado(orgao);}}):'');};_this.createActionColumn=function(indice,orgao){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.props.auth.checkPermission(['analisar-negocio-sprev'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:'Editar Org\xE3o Vinculado',icon:'ico-pencil',mini:true,onClick:function onClick(){return _this.editOrgaoVinculado(indice,orgao);}}):'');};_this.addSituacaoLabel=function(situacaoSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["A" /* situacaoOrgaoVinculado */],situacaoSelecionado);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;// const obj = getObject(situacao, situacaoSelecionado);
// return obj.label;
};_this.montaOrgaoVinculadoTableHeader=function(){var tableHeader=[{id:'cnpj',label:'CNPJ'},{id:'nomeOrgaoVinculado',label:'Orgão'},{id:'situacao',label:'Situação',dataFormat:_this.addSituacaoLabel}];if(_this.props.auth.checkPermission(['analisar-negocio-sprev'])){tableHeader.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});}return tableHeader;};_this.options={hideSizePerPage:true,insertBtn:_this.createCustomInsertButton,noDataText:'Nenhum Orgão foi adicionado à lista',sizePerPage:5};_this.addOrgaoVinculado=function(orgao,edit){var _this$props=Object.assign({},_this.props),orgaosVinculados=_this$props.orgaosVinculados;if(edit){var orgaoVinculado=Object.assign({},orgao);if(orgaoVinculado.situacao===''){orgaoVinculado.situacao=0;orgaoVinculado.flagOperacao=2;}else{orgaoVinculado.flagOperacao=2;}orgaosVinculados[_this.state.cell]=orgaoVinculado;}else{var orgaoExisteNaLista=false;// const cnpjNovoOrgao = orgao.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
var cnpjNovoOrgao=orgao.cnpj.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/,'$1.$2.$3/$4-$5');orgaosVinculados.forEach(function(orgaoExistente){var orgaoAux=orgaoExistente;orgaoAux.cnpj=orgaoExistente.cnpj;if(orgaoAux.cnpj===cnpjNovoOrgao){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['O orgão já foi cadastrado anteriormente.']);orgaoExisteNaLista=true;}});if(orgaoExisteNaLista===false){var orgaoInclusao=orgao;orgaoInclusao.flagOperacao=1;// orgaoInclusao.idParticipante = null;
orgaosVinculados.unshift(orgaoInclusao);}}_this.alteraListaOrgaosVinculados(orgaosVinculados,null);};_this.editOrgaoVinculado=function(indice,orgaoVinculadoSelecionado){var errosOrgaoVinculadoSelecionado=null;if(_this.props.errosOrgaoVinculado){errosOrgaoVinculadoSelecionado=_this.props.errosOrgaoVinculado.filter(function(erro){return erro.indiceLista===indice;});}_this.setState({cell:indice,acaoModal:'edicao',orgaoVinculadoSelecionado:orgaoVinculadoSelecionado,errosOrgaoVinculadoSelecionado:errosOrgaoVinculadoSelecionado},_this.handleModal);};_this.incluirOrgaoVinculado=function(){// orgaoVinculado.idParticipante = this.props.estadoFormulario.regimeProprio.idParticipante;
// const paramOrgao = orgaoVinculado;
// paramOrgao.idParticipante = this.props.estadoFormulario.regimeProprio.idParticipante;
_this.setState({// orgaoVinculadoSelecionado: paramOrgao,
acaoModal:'criacao'},_this.handleModal);};_this.alteraListaOrgaosVinculados=function(listaOrgaosVinculados,errosOrgaosVinculados){if(errosOrgaosVinculados){_this.props.validacaoErrosOrgaoVinculado(errosOrgaosVinculados,true);}_this.props.handleChangeOrgaosVinculados(listaOrgaosVinculados,'orgaosVinculados');};_this.resetOrgaoVinculadoSelecionado=function(){_this.setState({orgaoVinculadoSelecionado:null,acaoModal:null,errosOrgaoVinculadoSelecionado:null});};var initialState=_this.getInitialState();_this.state=initialState;return _this;}/**
   * Determina quais colunas devem ser exibidas na tabela de dependentes
   *//**
   * Adiciona Orgao Vinculado a lista
   * FLAG OPERACAO = 1 - INCLUSAO
   * FLAG OPERACAO = 2 - ALTERACAO
   *//**
   * Altera um orgao da lista
   *//**
   * inclui um orgao da lista
   *//**
   * Remove a selecao do dependente
   */_createClass(OrgaoVinculados,[{key:'render',value:function render(){var _this2=this;var listaOrgaosVinculadosIndexada=this.props.orgaosVinculados.map(function(item,i){var itemIndexado=item;itemIndexado.acoes=i;// itemIndexado.cnpj = itemIndexado.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
itemIndexado.cnpj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["d" /* formatarCnpj */])(itemIndexado.cnpj);return itemIndexado;});var modalOrgaoVinculado=this.state.showModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__OrgaoVinculado__["a" /* default */],{acaoModal:this.state.acaoModal,acao:this.props.acao,addOrgaoVinculado:this.addOrgaoVinculado,orgaoVinculado:this.state.orgaoVinculadoSelecionado,errosOrgaoVinculado:this.state.errosOrgaoVinculadoSelecionado,validacaoErrosOrgaoVinculado:this.props.validacaoErrosOrgaoVinculado,onHide:this.handleModal,resetOrgaoVinculado:this.resetOrgaoVinculadoSelecionado,showModal:true}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["e" /* DataGrid */],{title:'Dados dos Org\xE3os Vinculados',icon:'ico-users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */]// cnpjOrgao
// integer
,{label:'CNPJ do Org\xE3o Vinculado',mask:__WEBPACK_IMPORTED_MODULE_2__utils_masks__["a" /* default */].cnpj,value:this.state.cnpjOrgao,onChange:function onChange(e){return _this2.handleChange(e,'cnpjOrgao');},showMask:true,validationState:'active'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* Input */],{nomeOrgao:true,label:'Nome do Org\xE3o Vinculado',value:this.state.nomeOrgao,onChange:function onChange(e){return _this2.handleChange(e,'nomeOrgao');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{bordered:true,data:listaOrgaosVinculadosIndexada,insertRow:'true',options:this.options,listaTableHeader:this.montaOrgaoVinculadoTableHeader(),pagination:true,fetchInfo:this.fetchInfo}),modalOrgaoVinculado);}}]);return OrgaoVinculados;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OrgaoVinculados.propTypes={acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handleChangeOrgaosVinculados:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,errosOrgaoVinculado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,validacaoErrosOrgaoVinculado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,orgaosVinculados:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({cnpj:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,situacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (OrgaoVinculados);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiltroPesquisaEnteFederativo__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__requerimentos_ModalAlerta__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { msgsConfirmacaoEnte } from '../../utils/constants';
var ConsultaEnteFederativo=function(_Component){_inherits(ConsultaEnteFederativo,_Component);function ConsultaEnteFederativo(props){_classCallCheck(this,ConsultaEnteFederativo);var _this=_possibleConstructorReturn(this,(ConsultaEnteFederativo.__proto__||Object.getPrototypeOf(ConsultaEnteFederativo)).call(this,props));_this.getTipoConsulta=function(){return _this.props.match.params.tipoConsulta;};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRegistrosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.realizaConsulta=function(filtrosPesquisa){var filtrosConsulta={};if(filtrosPesquisa){filtrosConsulta=_this.montaFiltros(filtrosPesquisa);}_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta}),_this.executaConsulta);};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('participantes-rpps',_this.tratarSucesso,_this.tratarErro,Object.assign({},_this.state.filtrosConsulta,{'start-position':primeiroItem,'max-results':resultadosPorPagina}));_this.setState({filtrosPesquisaCnpj:_this.state.filtrosConsulta});_this.setState({filtrosPesquisa:_this.state.filtrosConsulta});}else{_this.setState({listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true});}};_this.montaFiltros=function(atributosPesquisa){var atributos={};if(atributosPesquisa['destinatario-rpps']){atributos=Object.assign({},atributos,{'destinatario-rpps':atributosPesquisa['destinatario-rpps']});}var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;if(atributosPesquisa.cliqueiNoBotao===1){_this.state.estadoTabela.paginaAtual=1;}var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRegistrosIndexada:response.data,listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarFiltroNaLista=function(listaRegistrosFiltrada){_this.setState({listaRegistrosFiltrada:listaRegistrosFiltrada,listaRegistrosIndexadaAtualizada:false});};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.setState({showNoContent:true,noContentPrimaryMessage:'Não existe cnpj para o ente federativo escolhido.',noContentSecondaryMessage:'Informe um ente federativo válido.'});}else{_this.setState({showNoContent:true,noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}}else{_this.setState({showNoContent:true,noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleChange=function(e,name){_this.setState(Object.assign({},_this.state,_defineProperty({},name,e)));};_this.addTipoEstadoLabel=function(tipo){if(tipo===15){return'Exigência/indeferido';}if(tipo===16){return'Indeferimento ratificado';}return __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};_this.colunasDefault=[{id:'cnpjFormatado',label:'CNPJ do RPPS'},{id:'dataConvenio',label:'Data do Convênio'},{id:'numeroBancoFormatado',label:'Banco'},{id:'numeroAgenciaFormatado',label:'Agência'},{id:'numeroContaCorrenteFormatado',label:'Conta Corrente'}];_this.showCadastroRppsAtualizacao=function(participante){_this.props.history.push('/cadastros/entesFederativos/rpps/'+participante.idParticipante+'/atualizar-rpps');};_this.showCadastroNovoRpps=function(){var codigoEnte=_this.state.filtrosPesquisaCnpj['destinatario-rpps'];_this.setState(_this.apagarPeriodosVigenciaRegimesProprios(),_this.apagarListaUosInss());_this.props.history.push('/cadastros/entesFederativos/rpps/novo/'+codigoEnte);};_this.realizaConsultaCnpj=function(){var codigoEnte=_this.state.filtrosPesquisaCnpj['destinatario-rpps'];_this.setState(_this.recuperarCnpjDoEnte(codigoEnte));};_this.recuperarCnpjDoEnte=function(paramCodigoEnte){if(Object.entries(_this.state.filtrosConsulta).length!==0){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('participantes-rpps',_this.tratarSucesso,_this.tratarErro,{codigo:paramCodigoEnte});}};_this.montaAcaoCadastroRpps=function(row,hint){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:hint,icon:'ico-doc-pencil',mini:true,onClick:function onClick(){return _this.showCadastroRppsAtualizacao(row);}});};_this.createActionColumn=function(cell,row){var hint='Alterar regime próprio';return _this.montaAcaoCadastroRpps(row,hint);};_this.montaColunas=function(){var participanteTableHeader=_this.colunasDefault.slice();participanteTableHeader.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});return participanteTableHeader;};_this.defineListaParaTabela=function(){if(_this.state.listaRegistrosFiltrada!==null){return _this.state.listaRegistrosFiltrada;}return _this.state.listaRegistrosIndexada;};_this.alterarPagina=function(pagina){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.paginaAtual=pagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state3=Object.assign({},_this.state),estadoTabela=_this$state3.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.handleFechamentoModalAlerta=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta});};_this.state={listaRegistrosFiltrada:null,listaRegistrosIndexada:[],registroVindoDoRequest:null,showNoContent:false,listaRegistrosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{},filtrosPesquisaCnpj:{},showModalAlerta:false};return _this;}_createClass(ConsultaEnteFederativo,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["g" /* manterApenasFiltro */])('filtroEnteFederativo');if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}// this.realizaConsulta();
}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.match.params.tipoConsulta!==prevProps.match.params.tipoConsulta){this.preparaNovaConsulta();}}/**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */},{key:'render',value:function render(){var listaRegistrosIndexada=this.state.listaRegistrosIndexada.map(function(item,i){var itemIndexado=item;itemIndexado.acoes=i;if(itemIndexado.cnpj){itemIndexado.cnpjFormatado=Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["d" /* formatarCnpj */])(itemIndexado.cnpj);}if(itemIndexado.numeroAgencia){var dvAg=itemIndexado.dvAgencia;if(dvAg===undefined){dvAg='';}itemIndexado.numeroAgenciaFormatado=''+itemIndexado.numeroAgencia+(dvAg?'-'+dvAg:'');}if(itemIndexado.numeroContaCorrente){var dvConta=itemIndexado.dvContaCorrente;if(dvConta===undefined){dvConta='';}itemIndexado.numeroContaCorrenteFormatado=''+itemIndexado.numeroContaCorrente+(dvConta?'-'+dvConta:'');}if(itemIndexado.numeroBanco){var codBanco=itemIndexado.numeroBanco;if(codBanco===undefined){codBanco='';}if(codBanco.length===1){codBanco='00'+itemIndexado.numeroBanco;}var nome=itemIndexado.nomeBanco;if(nome===undefined){nome='';}itemIndexado.numeroBancoFormatado=''+codBanco+(nome?'-'+nome:'');}return itemIndexado;});var modalAlerta=void 0;if(this.state.showModalAlerta){modalAlerta=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__requerimentos_ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.showCadastroNovoRpps,handleModal:this.handleFechamentoModalAlerta,showModal:true});}var options={noDataText:'Nenhum regime próprio a ser exibido',hideSizePerPage:true,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var participanteTableHeader=this.montaColunas();return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FiltroPesquisaEnteFederativo__["a" /* default */],{handleSearchFilter:this.realizaConsulta,handleChangeList:this.tratarFiltroNaLista,destinatarios:this.props.destinatarios,list:listaRegistrosIndexada,tipoConsulta:this.getTipoConsulta(),listaRegistrosIndexadaAtualizada:this.state.listaRegistrosIndexadaAtualizada}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["u" /* Table */],{legend:'Participante da compensa\xE7\xE3o',bordered:true,fetchInfo:fetchInfo,data:this.defineListaParaTabela(),options:options,listaTableHeader:participanteTableHeader,pagination:true,remote:true}),modalAlerta);}}]);return ConsultaEnteFederativo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaEnteFederativo.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};ConsultaEnteFederativo.defaultProps={match:null,destinatarios:[]};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ConsultaEnteFederativo));

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// const destinoRGPS = '01000';
// const mascara = '';
var FiltroPesquisaEnteFederativo=function(_Component){_inherits(FiltroPesquisaEnteFederativo,_Component);function FiltroPesquisaEnteFederativo(){_classCallCheck(this,FiltroPesquisaEnteFederativo);var _this=_possibleConstructorReturn(this,(FiltroPesquisaEnteFederativo.__proto__||Object.getPrototypeOf(FiltroPesquisaEnteFederativo)).call(this));_this.controleFiltrosAlternativos=function(campo){switch(campo){case'destinatario-rpps':return['requerer-compensacao-rgps','gerenciar-negocio-dcomp'];default:return[];}};_this.preparaNovaConsulta=function(){var filtroEnteFederativo={'destinatario-rpps':null,tipoEntidade:null,uf:null};filtroEnteFederativo=JSON.stringify(filtroEnteFederativo);sessionStorage.setItem('filtroEnteFederativo',filtroEnteFederativo);_this.setState({'destinatario-rpps':null,tipoEntidade:null,uf:null});};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.trataFormulario=function(campoAlterado){if(campoAlterado==='tipoEntidade'){_this.trataTipoEntidade();}if(campoAlterado==='uf'){_this.trataUf();}};_this.trataUf=function(){_this.setState({'destinatario-rpps':null});};_this.trataCombosEntidade=function(){_this.setState({tipoEntidade:null,'destinatario-rpps':null,uf:null});};_this.trataTipoEntidade=function(){_this.setState({'destinatario-rpps':null,uf:null});};_this.handleSearchButton=function(){var filtroEnteFederativo={'destinatario-rpps':_this.state['destinatario-rpps'],tipoEntidade:_this.state.tipoEntidade,uf:_this.state.uf};filtroEnteFederativo=JSON.stringify(filtroEnteFederativo);sessionStorage.setItem('filtroEnteFederativo',filtroEnteFederativo);_this.setState({cliqueiNoBotao:1},function(){_this.handleChange({value:1,isValid:true},'cliqueiNoBotao');});_this.handleSearch();};_this.handleSearch=function(){if(_this.state.tipoEntidade){if(_this.state.tipoEntidade===2&&!_this.state.uf&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha uma UF']);return;}if(_this.state.tipoEntidade&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha um filtro de destinatário para a consulta']);return;}if(_this.state.tipoEntidade&&_this.state.uf&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha um filtro de destinatário para a consulta']);return;}_this.props.handleSearchFilter(_this.state);}else{Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha pelo menos um filtro de Ente federativo para a consulta']);}};_this.listaFiltradaDestinatarios=function(){var listaParticipantes=_this.props.destinatarios.filter(function(item){if(item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)){return item;}return null;});return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.montaFiltrosDefault=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Tipo',onChange:function onChange(e){return _this.handleChange(e,'tipoEntidade');},placeholder:'Selecione a entidade',value:_this.state.tipoEntidade,itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["E" /* tipoEntidade */],custom:true,number:true})),_this.state.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'UF',onChange:function onChange(e){return _this.handleChange(e,'uf');},placeholder:'Selecione a UF',value:_this.state.uf,itemList:_this.carregaUfDosMunicipios(),custom:true})):'',_this.state.tipoEntidade?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Nome',name:'destinatario-rpps',onChange:function onChange(e){return _this.handleChange(e,'destinatario-rpps');},placeholder:'Selecione o destinat\xE1rio',value:_this.state['destinatario-rpps'],itemList:_this.listaFiltradaDestinatarios(),custom:true})):''));};_this.montaFiltros=function(){if(_this.props.tipoConsulta){return _this.montaFiltrosDefault();}return null;};_this.filtroEnteFederativo=JSON.parse(sessionStorage.getItem('filtroEnteFederativo'));_this.state={'destinatario-rpps':_this.filtroEnteFederativo&&_this.filtroEnteFederativo['destinatario-rpps']?_this.filtroEnteFederativo['destinatario-rpps']:null,cliqueiNoBotao:_this.filtroEnteFederativo&&_this.filtroEnteFederativo.cliqueiNoBotao?_this.filtroEnteFederativo.cliqueiNoBotao:null,tipoEntidade:_this.filtroEnteFederativo&&_this.filtroEnteFederativo.tipoEntidade?_this.filtroEnteFederativo.tipoEntidade:null,uf:_this.filtroEnteFederativo&&_this.filtroEnteFederativo.uf?_this.filtroEnteFederativo.uf:null};// this.state = {
//   'destinatario-rpps': null,
//   cliqueiNoBotao: 0,
//   tipoEntidade: null,
// };
return _this;}_createClass(FiltroPesquisaEnteFederativo,[{key:'componentDidMount',value:function componentDidMount(){if(sessionStorage.getItem('filtroEnteFederativo')){this.handleSearchButton();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.tipoConsulta!==prevProps.tipoConsulta){this.preparaNovaConsulta();}}/**
   * Encaminha para as funcoes que tratam alteracoes em cada campo
   */},{key:'render',value:function render(){var _this2=this;var filtrosPesquisa=this.montaFiltros();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'pesquisa',panelId:'filtro-pesquisa',icon:'ico-filter',title:'Filtro de Pesquisa'},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroPesquisaEnteFederativo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroPesquisaEnteFederativo.propTypes={destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf().isRequired,handleChangeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroPesquisaEnteFederativo);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__requerimentos_ModalAlerta__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import * as constantes from '../../utils/constants';
var ConsultaPagamentos=function(_Component){_inherits(ConsultaPagamentos,_Component);function ConsultaPagamentos(props){_classCallCheck(this,ConsultaPagamentos);var _this=_possibleConstructorReturn(this,(ConsultaPagamentos.__proto__||Object.getPrototypeOf(ConsultaPagamentos)).call(this,props));_this.getTipoConsulta=function(){return _this.props.match.params.tipoConsulta;};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.lotacao=_this.props.auth.userData.lotacoes[0];_this.realizaConsulta=function(filtrosPesquisa){var filtrosConsulta={};if(filtrosPesquisa){filtrosConsulta=_this.montaFiltros(filtrosPesquisa);}// Copiar atributos além do filtro
// const atributosConsulta = this.verificaAtributosParaConsulta();
// if (atributosConsulta) {
//   if (filtrosConsulta.estado === undefined) {
//     filtrosConsulta.estado = atributosConsulta.estados;
//   }
//   filtrosConsulta.participacao = atributosConsulta.tipoParticipacao;
//   filtrosConsulta['atributo-ordenacao'] = atributosConsulta.campoOrdenacao;
//   if (atributosConsulta.filtroTipoExigencias) {
//     filtrosConsulta['tipo-exigencia'] = atributosConsulta.filtroTipoExigencias;
//   }
// }
_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta}),_this.executaConsulta);};_this.executaConsulta=function(){// if (Object.entries(this.state.filtrosConsulta).length !== 0) {
var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["e" /* doGet */])('fechamento-pagamentos',_this.tratarSucesso,_this.tratarErro,{// ...this.state.filtrosConsulta,
'start-position':primeiroItem,'max-results':resultadosPorPagina});// } else {
//   this.setState({ listaRegistrosIndexada: [], listaRegistrosIndexadaAtualizada: true });
// }
};_this.montaFiltros=function(atributosPesquisa){var atributos={};// atributos = { ...atributos, filtro: filtroValido };
// if (atributosPesquisa.competencia) {
//   atributos = { ...atributos, competencia: atributosPesquisa.competencia };
// }
var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;if(atributosPesquisa.cliqueiNoBotao===1){_this.state.estadoTabela.paginaAtual=1;}var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRegistrosIndexada:response.data,listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarFiltroNaLista=function(listaRegistrosFiltrada){_this.setState({listaRegistrosFiltrada:listaRegistrosFiltrada,listaRegistrosIndexadaAtualizada:false});};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.setState({showNoContent:true,noContentPrimaryMessage:'Requerimento não encontrado para o protocolo informado.',noContentSecondaryMessage:'Informe um protocolo válido.'});}else{_this.setState({showNoContent:true,noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}}else{_this.setState({showNoContent:true,noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleChange=function(e,name){_this.setState(Object.assign({},_this.state,_defineProperty({},name,e)));};_this.addTipoRequerimentoLabel=function(tipo){return __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["M" /* tipoRequerimento */],tipo).label;};_this.addTipoEstadoLabel=function(tipo){if(tipo===15){return'Exigência/indeferido';}if(tipo===16){return'Indeferimento ratificado';}return __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};_this.formatarCompetencia=function(competencia){var valor='';if(competencia){if(competencia.length===6){valor='0'+competencia;}else{valor=competencia;}}return valor;};_this.showFechamentoAtualizacao=function(row){_this.setState({alertas:[__WEBPACK_IMPORTED_MODULE_6__utils_constants__["t" /* msgsconfirmacaoFechamentoPagamento */].confirmacaoFechamentoPagamento],showModalAlerta:!_this.state.showModalAlerta,fechamentoPagamento:row});};_this.montaAcaoFechamento=function(row,hint){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.props.auth.checkPermission(['gerenciar-negocio-dcomp'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{hint:hint,icon:'ico-pencil',mini:true,onClick:function onClick(){return _this.showFechamentoAtualizacao(row);}}):'');};_this.createActionColumn=function(cell,row){if(row.dataEncerramentoFolha===undefined){var hint='Fechar Pagamento';return _this.montaAcaoFechamento(row,hint);}return'';};_this.montaColunas=function(){var consultaPagamentoTableHeader=_this.colunasDefault.slice();consultaPagamentoTableHeader.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});return consultaPagamentoTableHeader;};_this.colunasDefault=[{id:'competencia',label:'Competência',dataFormat:_this.formatarCompetencia},{id:'dataEncerramentoFolha',label:'Data Encerramento Folha'},{id:'dataEncerramentoPrevia',label:'Data Encerramento Prévia'},{id:'nomeUsuario',label:'Nome do Servidor'},{id:'situacao',label:'Situação'}];_this.defineListaParaTabela=function(){if(_this.state.listaRegistrosFiltrada!==null){return _this.state.listaRegistrosFiltrada;}return _this.state.listaRegistrosIndexada;};_this.alterarPagina=function(pagina){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.paginaAtual=pagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state3=Object.assign({},_this.state),estadoTabela=_this$state3.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.trataSucesso=function(){_this.realizaConsulta();Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["J" /* trataMensagemSucesso */])(['Prévia de pagamento inserida.']);};_this.trataSucessoResponseEnvio=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta},_this.trataSucesso);};_this.showInclusaoFechamentoPagamento=function(){var options=void 0;if(_this.state.chaveConfirmacao){options={'Chave-Confirmacao':_this.state.chaveConfirmacao};}var _this$state4=Object.assign({},_this.state),fechamentoPagamento=_this$state4.fechamentoPagamento;Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["n" /* doPut */])('fechamento-pagamentos',fechamentoPagamento,_this.trataSucessoResponseEnvio,_this.trataErrosResponse,options);};_this.trataErrosResponse=function(error){if(error&&error.data){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);}};_this.handleFechamentoModalAlerta=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta});};_this.state={listaRegistrosFiltrada:null,listaRegistrosIndexada:[],registroVindoDoRequest:null,showNoContent:false,listaRegistrosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{},showModalAlerta:false,fechamentoPagamento:{ano:null,mes:null}};return _this;}_createClass(ConsultaPagamentos,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["g" /* manterApenasFiltro */])('');this.realizaConsulta();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.match.params.tipoConsulta!==prevProps.match.params.tipoConsulta){this.preparaNovaConsulta();}}/**
   * Trata filtros na lista que veio do servidor (Componente FiltroPagamentos)
   */},{key:'render',value:function render(){var modalAlerta=void 0;if(this.state.showModalAlerta){modalAlerta=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__requerimentos_ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.showInclusaoFechamentoPagamento,handleModal:this.handleFechamentoModalAlerta,showModal:true});}var options={noDataText:'Nenhum pagamento a ser exibido',hideSizePerPage:true,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var consultaPagamentoTableHeader=this.montaColunas();return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{legend:'Fechamento de Pagamentos',bordered:true,fetchInfo:fetchInfo,data:this.defineListaParaTabela(),options:options,listaTableHeader:consultaPagamentoTableHeader,pagination:true,remote:true}),modalAlerta);}}]);return ConsultaPagamentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaPagamentos.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired};ConsultaPagamentos.defaultProps={match:null};/* harmony default export */ __webpack_exports__["a"] = (ConsultaPagamentos);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiltroAuditoria__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConsultaAuditoria=function(_Component){_inherits(ConsultaAuditoria,_Component);function ConsultaAuditoria(props){_classCallCheck(this,ConsultaAuditoria);var _this=_possibleConstructorReturn(this,(ConsultaAuditoria.__proto__||Object.getPrototypeOf(ConsultaAuditoria)).call(this,props));_this.getTipoConsulta=function(){return _this.props.match.params.tipoConsulta;};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRegistrosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.lotacao=_this.props.auth.userData.lotacoes[0];_this.montaFiltros=function(atributosPesquisa){var atributos={};if(atributosPesquisa.tipoAuditoria){atributos=Object.assign({},atributos,{tipoAuditoria:atributosPesquisa.tipoAuditoria});}var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;if(atributosPesquisa.cliqueiNoBotao===1){_this.state.estadoTabela.paginaAtual=1;}var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.realizaConsulta=function(filtrosPesquisa){var filtrosConsulta={};if(filtrosPesquisa){filtrosConsulta=_this.montaFiltros(filtrosPesquisa);}_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta}),_this.executaConsulta);};_this.executaConsulta=function(){var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;if(_this.state.filtrosConsulta&&_this.state.filtrosConsulta.tipoAuditoria){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["e" /* doGet */])('auditoria-compartilhada',_this.tratarSucesso,_this.tratarErro,Object.assign({},_this.state.filtrosConsulta,{tipoAuditoria:_this.state.filtrosConsulta.tipoAuditoria,'start-position':primeiroItem,'max-results':resultadosPorPagina}));}};_this.verificaAtributosParaConsulta=function(){if(_this.getTipoConsulta()){return __WEBPACK_IMPORTED_MODULE_6__utils_constants__["c" /* estadosParaConsulta */][_this.getTipoConsulta()];}return null;};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRegistrosIndexada:response.data,listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarFiltroNaLista=function(listaRegistrosFiltrada){_this.setState({listaRegistrosFiltrada:listaRegistrosFiltrada,listaRegistrosIndexadaAtualizada:false});};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.setState({showNoContent:true,noContentPrimaryMessage:'Tipo de auditoria não encontrado.'// noContentSecondaryMessage: 'Informe um protocolo válido.',
});}else{_this.setState({showNoContent:true,noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}}else{_this.setState({showNoContent:true,noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleModal=function(modal){_this.setState(_defineProperty({},modal,!_this.state[modal]));};_this.addTipoAuditoriaLabel=function(tipo){return __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["P" /* tiposAuditoria */],tipo).label;};_this.colunasDefault=[{id:'cpfUsuario',label:'CPF'},{id:'nomeUsuario',label:'Usuário'},{id:'dataOperacao',label:'Data Operação'},{id:'comentarioAuditoria',label:'Comentário'}];_this.montaColunas=function(){var auditoriasTableHeader=_this.colunasDefault.slice();return auditoriasTableHeader;};_this.alterarPagina=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state3=Object.assign({},_this.state),estadoTabela=_this$state3.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.state={listaRegistrosFiltrada:null,listaRegistrosIndexada:[],registroVindoDoRequest:null,showNoContent:false,listaRegistrosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{}};return _this;}_createClass(ConsultaAuditoria,[{key:'componentDidMount',value:function componentDidMount(){// this.realizaConsulta();
Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["g" /* manterApenasFiltro */])('');}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.match.params.tipoConsulta!==prevProps.match.params.tipoConsulta){this.preparaNovaConsulta();}}/**
   * Trata filtros na lista que veio do servidor (Componente FiltroAuditoria)
   */},{key:'render',value:function render(){var options={noDataText:'Nenhuma auditoria a ser exibida',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var auditoriasTableHeader=this.montaColunas();return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FiltroAuditoria__["a" /* default */],{handleSearchFilter:this.realizaConsulta,handleChangeList:this.tratarFiltroNaLista,list:this.state.listaRegistrosIndexada,tipoConsulta:this.getTipoConsulta(),listaRegistrosIndexadaAtualizada:this.state.listaRegistrosIndexadaAtualizada}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{legend:'Consulta por Tipo de Auditoria',bordered:true,fetchInfo:fetchInfo,data:this.state.listaRegistrosIndexada,options:options,listaTableHeader:auditoriasTableHeader,pagination:true,remote:true}));}}]);return ConsultaAuditoria;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaAuditoria.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({chave:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ano:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func})};ConsultaAuditoria.defaultProps={match:null,auth:null};/* harmony default export */ __webpack_exports__["a"] = (ConsultaAuditoria);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FiltroPagamentos=function(_Component){_inherits(FiltroPagamentos,_Component);function FiltroPagamentos(){_classCallCheck(this,FiltroPagamentos);var _this=_possibleConstructorReturn(this,(FiltroPagamentos.__proto__||Object.getPrototypeOf(FiltroPagamentos)).call(this));_this.preparaNovaConsulta=function(){_this.setState({tipoAuditoria:null});};_this.handleChange=function(changeObj,name){var _this$setState;var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;_this.setState((_this$setState={},_defineProperty(_this$setState,name,changeObj.value),_defineProperty(_this$setState,'validadeCampos',Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))),_this$setState),callback);};_this.handleSearchButton=function(){_this.setState({cliqueiNoBotao:1},function(){_this.handleChange({value:1,isValid:true},'cliqueiNoBotao');});_this.handleSearch();};_this.handleSearch=function(){if(_this.state.tipoAuditoria){_this.props.handleSearchFilter(_this.state);}else{Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(['Escolha um tipo de auditoria antes de efetuar a pesquisa.']);}};_this.state={competencia:null,cliqueiNoBotao:0};return _this;}_createClass(FiltroPagamentos,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.tipoConsulta!==prevProps.tipoConsulta){this.preparaNovaConsulta();}}},{key:'montaFiltros',value:function montaFiltros(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'5 5 5 5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Tipo de Auditoria',name:'tipoAuditoria',onChange:function onChange(e){return _this2.handleChange(e,'tipoAuditoria');},itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["P" /* tiposAuditoria */],value:this.state.tipoAuditoria,validationState:'active',custom:true}))));}},{key:'render',value:function render(){var _this3=this;var filtrosPesquisa=this.montaFiltros();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'pesquisa',panelId:'filtro-pesquisa',icon:'ico-filter',title:'Filtro de Pesquisa'},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this3.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroPagamentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroPagamentos.propTypes={destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf().isRequired,handleChangeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroPagamentos);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiltroPesquisa__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_ConsultaFilaGet_css__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_ConsultaFilaGet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_ConsultaFilaGet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ModalRetornoFilaGet__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__exportacao_csv_RelatorioFilaGet__ = __webpack_require__(635);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var ConsultaFilaGet=function(_Component){_inherits(ConsultaFilaGet,_Component);function ConsultaFilaGet(props){_classCallCheck(this,ConsultaFilaGet);var _this=_possibleConstructorReturn(this,(ConsultaFilaGet.__proto__||Object.getPrototypeOf(ConsultaFilaGet)).call(this,props));_this.getTipoConsulta=function(){return _this.props.match.params.tipoConsulta;};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.lotacao=_this.props.auth.userData.lotacoes[0];_this.realizaConsulta=function(filtrosPesquisa){var filtrosConsulta={};if(filtrosPesquisa){filtrosConsulta=_this.montaFiltros(filtrosPesquisa);}filtrosConsulta['tipo-consulta']=_this.getTipoConsulta();// Copiar atributos além do filtro
var atributosConsulta=_this.verificaAtributosParaConsulta();if(atributosConsulta){if(filtrosConsulta.estado===undefined){filtrosConsulta.estado=atributosConsulta.estados;}filtrosConsulta.participacao=atributosConsulta.tipoParticipacao;filtrosConsulta['atributo-ordenacao']=atributosConsulta.campoOrdenacao;if(atributosConsulta.filtroTipoExigencias){filtrosConsulta['tipo-exigencia']=atributosConsulta.filtroTipoExigencias;}}_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta}),_this.executaConsulta);};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["e" /* doGet */])('fila-do-get',_this.tratarSucesso,_this.tratarErro,Object.assign({},_this.state.filtrosConsulta,{'start-position':primeiroItem,'max-results':resultadosPorPagina}));}else{_this.setState({listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true});}};_this.undefinedToVazio=function(valor){var retorno='';if(valor===undefined){return retorno;}return valor;};_this.montaFiltros=function(atributosPesquisa){var atributos={};// filtro é a caixa de texto que pesquisa por cpf, nit e nb
var filtroValido=atributosPesquisa.filtro;if(filtroValido===null){filtroValido='';}atributos=Object.assign({},atributos,{filtro:filtroValido});if(atributosPesquisa.idProtocolo){var valor=_this.undefinedToVazio(atributosPesquisa.idProtocolo);var valorFinal='';if(valor===''){atributos=Object.assign({},atributos,{idProtocolo:valor});}else{valorFinal=atributosPesquisa.idProtocolo.trim();atributos=Object.assign({},atributos,{idProtocolo:valorFinal});}}if(atributosPesquisa.pendenteEnvio){atributos=Object.assign({},atributos,{pendenteEnvio:atributosPesquisa.pendenteEnvio});}if(atributosPesquisa.mensagemRetorno){var _valor=_this.undefinedToVazio(atributosPesquisa.mensagemRetorno);var _valorFinal='';if(_valor===''){atributos=Object.assign({},atributos,{mensagemRetorno:_valor});}else{_valorFinal=atributosPesquisa.mensagemRetorno.trim();atributos=Object.assign({},atributos,{mensagemRetorno:_valorFinal});}}if(atributosPesquisa.bodyEnvio){var _valor2=_this.undefinedToVazio(atributosPesquisa.bodyEnvio);var _valorFinal2='';if(_valor2===''){atributos=Object.assign({},atributos,{bodyEnvio:_valor2});}else{_valorFinal2=atributosPesquisa.bodyEnvio.trim();atributos=Object.assign({},atributos,{bodyEnvio:_valorFinal2});}}var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;if(atributosPesquisa.cliqueiNoBotao===1){_this.state.estadoTabela.paginaAtual=1;}var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.verificaAtributosParaConsulta=function(){if(_this.getTipoConsulta()){return __WEBPACK_IMPORTED_MODULE_6__utils_constants__["c" /* estadosParaConsulta */][_this.getTipoConsulta()];}return null;};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRegistrosIndexada:response.data,listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarFiltroNaLista=function(listaRegistrosFiltrada){_this.setState({listaRegistrosFiltrada:listaRegistrosFiltrada,listaRegistrosIndexadaAtualizada:false});};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.setState({showNoContent:true,noContentPrimaryMessage:'Requerimento não encontrado para o protocolo informado.',noContentSecondaryMessage:'Informe um protocolo válido.'});}else{_this.setState({showNoContent:true,noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}}else{_this.setState({showNoContent:true,noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleChange=function(e,name){_this.setState(Object.assign({},_this.state,_defineProperty({},name,e)));};_this.addTipoRequerimentoLabel=function(valor){return valor!==undefined?valor.substring(0,80):valor;};_this.showDadosRetornoModal=function(row){_this.setState({showDadosRetornoModal:!_this.state.showDadosRetornoModal,retorno:row});};_this.handleModalDadosRetorno=function(){_this.setState({showDadosRetornoModal:!_this.state.showDadosRetornoModal});};_this.addLinkRetorno=function(valor,row){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,valor!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:function onClick(){return _this.showDadosRetornoModal(row);}},valor.substring(0,80)):valor);};_this.addTipoEstadoLabel=function(tipo){if(tipo===15){return'Exigência/indeferido';}if(tipo===16){return'Indeferimento ratificado';}return __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};_this.colunasDefault=[{id:'idProtocolo',label:'Protocolo'},{id:'dataEnvioGet',label:'Data Envio'},{id:'dataRetornoComprev',label:'Data Retorno'},{id:'url',label:'URL',dataFormat:_this.addLinkRetorno},{id:'bodyEnvio',label:'Body envio',dataFormat:_this.addLinkRetorno},{id:'retorno',label:'Retorno ',dataFormat:_this.addLinkRetorno},{id:'pendente',label:'Pendente Envio GET',dataFormat:_this.addTipoRequerimentoLabel}];_this.montaColunas=function(){var requerimentosExigenciaTableHeader=_this.colunasDefault.slice();return requerimentosExigenciaTableHeader;};_this.defineListaParaTabela=function(){if(_this.state.listaRegistrosFiltrada!==null){return _this.state.listaRegistrosFiltrada;}return _this.state.listaRegistrosIndexada;};_this.alterarPagina=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state3=Object.assign({},_this.state),estadoTabela=_this$state3.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.state={listaRegistrosFiltrada:null,listaRegistrosIndexada:[],registroVindoDoRequest:null,showNoContent:false,listaRegistrosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{},showDadosRetornoModal:false};return _this;}_createClass(ConsultaFilaGet,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["g" /* manterApenasFiltro */])('');}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.match.params.tipoConsulta!==prevProps.match.params.tipoConsulta){this.preparaNovaConsulta();}}/**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */},{key:'render',value:function render(){var _this2=this;var options={noDataText:'Nenhum elemento da Fila Get a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var requerimentosExigenciaTableHeader=this.montaColunas();return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FiltroPesquisa__["a" /* default */],{handleSearchFilter:this.realizaConsulta,handleChangeList:this.tratarFiltroNaLista,destinatarios:'',list:this.state.listaRegistrosIndexada,tipoConsulta:this.getTipoConsulta(),listaRegistrosIndexadaAtualizada:this.state.listaRegistrosIndexadaAtualizada}),this.state.listaRegistrosIndexada&&this.state.listaRegistrosIndexada.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__exportacao_csv_RelatorioFilaGet__["a" /* default */],{filtrosConsulta:this.state.filtrosConsulta}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{legend:this.state.estadoTabela.quantidadeTotalResultados===0?'Consulta Fila de Envios ao GET':'Consulta Fila de Envios Get -  '+this.state.estadoTabela.quantidadeTotalResultados+' registro(s) encontrado(s)',bordered:true,fetchInfo:fetchInfo,data:this.defineListaParaTabela(),options:options,listaTableHeader:requerimentosExigenciaTableHeader,pagination:true,remote:true}),this.state.showDadosRetornoModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ModalRetornoFilaGet__["a" /* default */],Object.assign({},this.props,{estadoFormulario:this.state,retornoFilaGet:this.state.retorno,handleModal:function handleModal(){return _this2.handleModalDadosRetorno('showDadosRetornoModal');},showModal:this.state.showDadosRetornoModal})):'');}}]);return ConsultaFilaGet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaFilaGet.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({idProtocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired};ConsultaFilaGet.defaultProps={match:null};/* harmony default export */ __webpack_exports__["a"] = (ConsultaFilaGet);

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_index__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalRetornoFilaGet=function(_Component){_inherits(ModalRetornoFilaGet,_Component);function ModalRetornoFilaGet(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalRetornoFilaGet);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalRetornoFilaGet.__proto__||Object.getPrototypeOf(ModalRetornoFilaGet)).call.apply(_ref,[this].concat(args))),_this),_this.modalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["k" /* Input */],{style:{color:'#00314d'},disabled:true,cols:'80',componentClass:'textarea',label:'URL',maxlength:'200',rows:'2',value:_this.props.retornoFilaGet.url,textarea:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["k" /* Input */],{style:{color:'#00314d'},disabled:true,cols:'80',componentClass:'textarea',label:'Body Envio',maxlength:'200',rows:'6',value:_this.props.retornoFilaGet.bodyEnvio,textarea:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["k" /* Input */],{style:{color:'#00314d'},disabled:true,cols:'80',componentClass:'textarea',label:'Retorno',maxlength:'200',rows:'6',value:_this.props.retornoFilaGet.retorno,textarea:true}))));},_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["a" /* Button */],{title:'Fechar',onClick:_this.handleClose,hint:'Fechar'})));},_this.handleClose=function(){_this.setState(_this.props.handleModal('showAlteracaoValorMedioBeneficioModal'));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalRetornoFilaGet,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalFooter(),conteudomodal:this.modalContent(),onHide:this.handleClose,size:'lg',showModal:this.props.showModal,title:'Detalhes do registro'}));}}]);return ModalRetornoFilaGet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalRetornoFilaGet.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,retornoFilaGet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalRetornoFilaGet);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_export_to_csv__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RelatorioControlePagamentos=function(_Component){_inherits(RelatorioControlePagamentos,_Component);function RelatorioControlePagamentos(props){_classCallCheck(this,RelatorioControlePagamentos);var _this=_possibleConstructorReturn(this,(RelatorioControlePagamentos.__proto__||Object.getPrototypeOf(RelatorioControlePagamentos)).call(this,props));_this.tratarSucessoListaExportacao=function(response){if(response.data!==''){_this.setState({},_this.gerarCsv(response.data));}};_this.tratarErro=function(){var mensagemPrimaria='Não foi possível consultar os envios ao GET.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.colunasExportacaoDefault=['idProtocolo','dataEntradaFila','dataEnvioGet','dataRetornoComprev','url','bodyEnvio','retorno','pendente'];_this.formatarProtocolo=function(protocolo){var protocoloFormatado='';if(protocolo){protocoloFormatado='{"'+protocolo+'"}';protocoloFormatado=''+protocoloFormatado;}return protocoloFormatado;};_this.defineListaParaExportacao=function(lista){var listaOriginal=lista;var resultado=[];listaOriginal.forEach(function(envio){resultado.push({idProtocolo:envio.idProtocolo?_this.formatarProtocolo(envio.idProtocolo):'',dataEntradaFila:envio.dataEntradaFila,dataEnvioGet:envio.dataEnvioGet!==undefined?envio.dataEnvioGet:'',dataRetornoComprev:envio.dataRetornoComprev!==undefined?envio.dataRetornoComprev:'',url:envio.url,bodyEnvio:envio.bodyEnvio,retorno:envio.retorno,pendente:envio.pendente});});return resultado;};_this.exportar=function(){if(Object.entries(_this.props.filtrosConsulta).length!==0){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('fila-do-get/exportacao-csv',_this.tratarSucessoListaExportacao,_this.tratarErro,Object.assign({},_this.props.filtrosConsulta));}};_this.gerarCsv=function(lista){var dadosRelatorio=null;var legenda='Fila de envios ao GET';if(lista&&lista!==undefined&&lista.length>0){dadosRelatorio=_this.defineListaParaExportacao(lista);}else{dadosRelatorio=[];}if(dadosRelatorio&&dadosRelatorio!==undefined&&dadosRelatorio.length>0){var csvExporter=new __WEBPACK_IMPORTED_MODULE_2_export_to_csv__["ExportToCsv"]({filename:'Fila de envios ao GET',fieldSeparator:';',showTitle:true,title:legenda,showLabels:true,headers:_this.colunasExportacaoDefault});csvExporter.generateCsv(dadosRelatorio);}};_this.state={showNoContent:false,noContentPrimaryMessage:null,noContentSecondaryMessage:null};return _this;}_createClass(RelatorioControlePagamentos,[{key:'render',value:function render(){var _this2=this;if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Exportar para CSV',onClick:function onClick(){_this2.exportar();},icon:'ico-doc-sheet',mini:true})));}}]);return RelatorioControlePagamentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RelatorioControlePagamentos.propTypes={voltarAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,filtrosConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object}.isRequired;RelatorioControlePagamentos.defaultProps={voltarAction:function voltarAction(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (RelatorioControlePagamentos);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiltroPesquisaOperacoesGet__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_ConsultaOperacoesGet_css__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_ConsultaOperacoesGet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_ConsultaOperacoesGet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__exportacao_csv_RelatorioOperacoesGet__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalRetornoOperacoesGet__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ModalRetornoIntegracaoGet__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__requerimentos_ModalAlerta__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var ConsultaOperacoesGet=function(_Component){_inherits(ConsultaOperacoesGet,_Component);function ConsultaOperacoesGet(props){_classCallCheck(this,ConsultaOperacoesGet);var _this=_possibleConstructorReturn(this,(ConsultaOperacoesGet.__proto__||Object.getPrototypeOf(ConsultaOperacoesGet)).call(this,props));_this.addLinkIdTarefaGet=function(valor,row){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,valor!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:function onClick(){return _this.buscaDetalhesDataIntegracaoGet(row.idTarefaGet);}},valor):valor);};_this.definePapelFiltro=function(){var retorno='';var isRgps=_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','consultar-compensacao-rgps']);var isAnalistaDtp=_this.props.auth.checkPermission(['analisar-negocio-dtpv']);var isAnalistaDcomp=_this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);if(isRgps){retorno='analista-rgps';}if(isAnalistaDtp){retorno='analista-dtp';}if(isAnalistaDcomp){retorno='analista-rgps';}_this.setState({papelUsuarioLogado:retorno});};_this.realizaConsulta=function(filtrosPesquisa){var filtrosConsulta={};if(filtrosPesquisa){filtrosConsulta=_this.montaFiltros(filtrosPesquisa);}_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta,filtrosAtuais:filtrosPesquisa}),_this.executaConsulta);};_this.defineNivelFiltro=function(){if(_this.state.filtrosConsulta.aps){return 3;}else if(_this.state.filtrosConsulta.gex){return 2;}else if(_this.state.filtrosConsulta.superintendencia){return 1;}return 0;};_this.definirValorUo=function(nivel){if(nivel===3){return _this.state.filtrosConsulta.aps;}else if(nivel===2){return _this.state.filtrosConsulta.gex;}else if(nivel===1){return _this.state.filtrosConsulta.superintendencia;}return 0;};_this.converterValoresParaTipoNumerico=function(valor){var retorno=null;if(valor){retorno=Number(valor);}return retorno;};_this.validar=function(valor){var retorno=null;if(valor){retorno=Number(valor);}return retorno;};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;var nivel=_this.defineNivelFiltro();var parametros={'start-position':primeiroItem,'max-results':resultadosPorPagina};if(_this.state.filtrosConsulta.protocoloComprev){parametros.protocoloComprev=_this.state.filtrosConsulta.protocoloComprev;}if(_this.state.filtrosConsulta.protocoloTarefaGet){parametros.protocoloTarefaGet=_this.converterValoresParaTipoNumerico(_this.state.filtrosConsulta.protocoloTarefaGet);}if(_this.state.filtrosConsulta.cpf){parametros.cpf=_this.state.filtrosConsulta.cpf;}if(_this.state.filtrosConsulta.mensagem){parametros.mensagem=_this.state.filtrosConsulta.mensagem;}if(_this.state.filtrosConsulta.status){parametros.status=_this.converterValoresParaTipoNumerico(_this.state.filtrosConsulta.status);}if(nivel!==0){parametros.nivelUo=nivel;}if(nivel!==0){parametros.idUo=_this.definirValorUo(nivel);}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["l" /* doPost */])('operacoes-get',parametros,_this.tratarSucesso,_this.tratarErro);}else{_this.setState({listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true});}};_this.undefinedToVazio=function(valor){var retorno='';if(valor===undefined){return retorno;}return valor;};_this.montaFiltros=function(atributosPesquisa){var atributos={};atributos=Object.assign({},atributos);if(atributosPesquisa.protocoloComprev){var valor=_this.undefinedToVazio(atributosPesquisa.protocoloComprev);var valorFinal='';if(valor===''){atributos=Object.assign({},atributos,{protocoloComprev:valor});}else{valorFinal=atributosPesquisa.protocoloComprev.trim();atributos=Object.assign({},atributos,{protocoloComprev:valorFinal});}}if(atributosPesquisa.protocoloTarefaGet){var _valor=_this.undefinedToVazio(atributosPesquisa.protocoloTarefaGet);var _valorFinal='';if(_valor===''){atributos=Object.assign({},atributos,{protocoloTarefaGet:_valor});}else{_valorFinal=atributosPesquisa.protocoloTarefaGet.trim();atributos=Object.assign({},atributos,{protocoloTarefaGet:_valorFinal});}}if(atributosPesquisa.cpf){var _valor2=_this.undefinedToVazio(atributosPesquisa.cpf);var _valorFinal2='';if(_valor2===''){atributos=Object.assign({},atributos,{cpf:_valor2});}else{_valorFinal2=atributosPesquisa.cpf.trim();atributos=Object.assign({},atributos,{cpf:_valorFinal2});}}if(atributosPesquisa.mensagem){var _valor3=_this.undefinedToVazio(atributosPesquisa.mensagem);var _valorFinal3='';if(_valor3===''){atributos=Object.assign({},atributos,{mensagem:_valor3});}else{_valorFinal3=atributosPesquisa.mensagem.trim();atributos=Object.assign({},atributos,{mensagem:_valorFinal3});}}if(atributosPesquisa.status){var _valor4=_this.undefinedToVazio(atributosPesquisa.status);var _valorFinal4='';if(_valor4===''){atributos=Object.assign({},atributos,{status:_valor4});}else{_valorFinal4=atributosPesquisa.status.trim();atributos=Object.assign({},atributos,{status:_valorFinal4});}}if(atributosPesquisa.superintendencia){atributos=Object.assign({},atributos,{superintendencia:atributosPesquisa.superintendencia});}if(atributosPesquisa.gex){atributos=Object.assign({},atributos,{gex:atributosPesquisa.gex});}if(atributosPesquisa.aps){atributos=Object.assign({},atributos,{aps:atributosPesquisa.aps});}var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.tratarSucessoIdTarefaGetEnvio=function(response){if(response.data===''){_this.setState({dataCriacao:null,nomeServico:null,statusTarefa:null,sigla:null});}else{var _this$state=Object.assign({},_this.state),conteudoModalIntegracaoGet=_this$state.conteudoModalIntegracaoGet;conteudoModalIntegracaoGet.dataCriacao=response.data.dataCriacao;conteudoModalIntegracaoGet.nomeServico=response.data.nomeServico;conteudoModalIntegracaoGet.statusTarefa=response.data.status;conteudoModalIntegracaoGet.sigla=response.data.sigla;_this.setState({showNoContent:false,conteudoModalIntegracaoGet:conteudoModalIntegracaoGet},_this.handleModalDadosGetRetorno('showDadosRetornoGetModal'));}};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRegistrosIndexada:response.data,listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarFiltroNaLista=function(listaRegistrosFiltrada){_this.setState({listaRegistrosFiltrada:listaRegistrosFiltrada,listaRegistrosIndexadaAtualizada:false});};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.handleChange=function(e,name){_this.setState(Object.assign({},_this.state,_defineProperty({},name,e)));};_this.showDadosRetornoModal=function(row){_this.setState({showDadosRetornoModal:!_this.state.showDadosRetornoModal,retorno:row});};_this.showDadosRetornoGetModal=function(row){_this.setState({showDadosRetornoGetModal:!_this.state.showDadosRetornoGetModal,retorno:row});};_this.handleModalDadosRetorno=function(){_this.setState({showDadosRetornoModal:!_this.state.showDadosRetornoModal});};_this.handleModalDadosGetRetorno=function(){_this.setState({showDadosRetornoGetModal:!_this.state.showDadosRetornoGetModal});};_this.handleModalStatusGetRetorno=function(){_this.setState({showStatusRetornoGetModal:!_this.state.showStatusRetornoGetModal});};_this.addDataEnvioLabel=function(data){var valor='';if(data){valor=__WEBPACK_IMPORTED_MODULE_2_moment___default()(data).format('DD/MM/YYYY HH:mm:ss');}return valor;};_this.colunasDefault=[{id:'idProtocolo',label:'Protocolo Comprev'},{id:'idTarefaGet',label:'Protocolo Tarefa GET',dataFormat:_this.addLinkIdTarefaGet},{id:'dataEnvio',label:'Data de Envio',dataFormat:_this.addDataEnvioLabel},{id:'status',label:'Status Operação'}];_this.addDataEnvioLabel=function(data){var valor='';if(data){valor=__WEBPACK_IMPORTED_MODULE_2_moment___default()(data).format('DD/MM/YYYY HH:mm:ss');}return valor;};_this.montaColunas=function(){var operacoesGetTableHeader=_this.colunasDefault.slice();var colunasEspecificas=[];if(colunasEspecificas){colunasEspecificas=colunasEspecificas.concat(operacoesGetTableHeader);}colunasEspecificas.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});return colunasEspecificas;};_this.defineListaParaTabela=function(){if(_this.state.listaRegistrosFiltrada!==null){return _this.state.listaRegistrosFiltrada;}return _this.state.listaRegistrosIndexada;};_this.alterarPagina=function(pagina,page){var _this$state3=Object.assign({},_this.state),estadoTabela=_this$state3.estadoTabela;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.trataErrosResponse=function(error){if(error&&error.data){var _error2=Object.assign({},error),data=_error2.data;_this.setState({chaveConfirmacao:data.chaveConfirmacao,alertas:data.alertas,showModalAlerta:!_this.state.showModalAlerta});}};_this.trataSucessoResponseEnvio=function(){var _this$state4=Object.assign({},_this.state),estadoTabela=_this$state4.estadoTabela;estadoTabela.quantidadeTotalResultados=0;_this.setState({showModalAlerta:!_this.state.showModalAlerta,estadoTabela:estadoTabela});var mensagemSucesso=['Operação Adicionada com Sucesso à Lista de Reprocessamento do GET.'];Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["J" /* trataMensagemSucesso */])([mensagemSucesso]);_this.realizaConsulta();};_this.confirmSendData=function(){var _this$state5=Object.assign({},_this.state),idOperacoesGet=_this$state5.idOperacoesGet;var url='operacoes-get/'+idOperacoesGet;_this.setState(function(){return _this.handleSave(url);});};_this.handleSave=function(url){var _this$state6=Object.assign({},_this.state),idOperacoesGet=_this$state6.idOperacoesGet;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["n" /* doPut */])(url,idOperacoesGet,_this.trataSucessoResponseEnvio,_this.trataErrosResponse);};_this.buscaDetalhesDataIntegracaoGet=function(valor){var _this$state7=Object.assign({},_this.state),conteudoModalIntegracaoGet=_this$state7.conteudoModalIntegracaoGet;conteudoModalIntegracaoGet.idTarefaGet=valor;var url='integracao-get/'+valor;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])(url,_this.tratarSucessoIdTarefaGetEnvio,_this.tratarErro,valor);};_this.submeterOperacaoGet=function(row){_this.setState({idOperacoesGet:row.idOperacoesGet,alertas:[__WEBPACK_IMPORTED_MODULE_14__utils_constants__["k" /* msgSubmeterReprocessamentoGet */]],showModalAlerta:!_this.state.showModalAlerta});};_this.montaAcoes=function(row){var acaoDetalharOperacaoGet=true;var acaoSubmeterOperacaoGet=row.codigoStatus===3;var botaoSubmeterOperacaoGet=acaoSubmeterOperacaoGet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Enviar o Registro da Opera\xE7\xE3o para o Reprocessamento no GET',icon:'ico-traffic-light',mini:true,onClick:function onClick(){return _this.submeterOperacaoGet(row);}}):'';var botaoDetalharOperacaoGet=acaoDetalharOperacaoGet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Detalhar o Registro da Opera\xE7\xE3o',icon:'ico-doc-magnifier',mini:true,onClick:function onClick(){return _this.showDadosRetornoModal(row);}}):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,botaoDetalharOperacaoGet,botaoSubmeterOperacaoGet));};_this.createActionColumn=function(cell,row){return _this.montaAcoes(row);};_this.montarLegendaNomeRelatorioPorFiltroSelecionado=function(){var textoFinal='';var titulo='Registro de Operações GET filtrado em ';var dataAtual=''+__WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date()).format('DD/MM/YYYY HH:mm:ss');textoFinal=titulo+' '+_this.exibirComplementoPorNivelSuperintendencia()+' '+dataAtual;return textoFinal;};_this.exibirComplementoPorNivelSuperintendencia=function(){var nivel=_this.defineNivelFiltro();var retorno='';var nome='';switch(nivel){case 1:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaSuperintendencias,_this.state.filtrosConsulta.superintendencia);retorno='SUPERINTEND\xCANCIA: '+_this.state.filtrosConsulta.superintendencia+' - '+nome;break;case 2:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaGexs,_this.state.filtrosEscolhidos.gex);retorno='GEX: '+_this.state.filtrosEscolhidos.gex+' - '+nome;break;case 3:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaAps,_this.state.filtrosEscolhidos.aps);retorno='APS: '+_this.state.filtrosEscolhidos.aps+' - '+nome;break;default:break;}return retorno.toUpperCase();};_this.recuperarTituloPorId=function(lista,id){var retorno='';var index=lista.findIndex(function(item){return item.value===id;});if(index!==-1){retorno=lista[index].label;}return retorno;};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state8=Object.assign({},_this.state),estadoTabela=_this$state8.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.handleFechamentoModalAlerta=function(){_this.setState({showModalAlerta:!_this.state.showModalAlerta});};_this.state={listaRegistrosFiltrada:null,listaRegistrosIndexada:[],showNoContent:false,listaRegistrosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{},filtrosConsulta:{},showDadosRetornoModal:false,showDadosRetornoGetModal:false,showModalAlerta:false,idOperacoesGet:null,papelUsuarioLogado:null,protocoloTarefaGet:null,conteudoModalIntegracaoGet:{idTarefaGet:null,dataCriacao:null,nomeServico:null,statusTarefa:null,sigla:null}};return _this;}_createClass(ConsultaOperacoesGet,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["g" /* manterApenasFiltro */])('');this.definePapelFiltro();}/**
   * Busca as informações do registro de operação na situação atual GET
   *//**
   * Papéis habilitados a acessar as informações da tabela das operações GET
   *//**
   * Trata envio dos dados
   *//**
   * Trata as acoes dos botao Salvar
   *//**
   * Trata o envio de parametros para a consulta de integracao GET
   */},{key:'render',value:function render(){var _this2=this;var options={noDataText:'Nenhum elemento de Operação do Get a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var operacoesGetTableHeader=this.montaColunas();var modalAlerta=void 0;if(this.state.showModalAlerta){modalAlerta=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__requerimentos_ModalAlerta__["a" /* default */],{alertas:this.state.alertas,aceitar:this.confirmSendData,handleModal:this.handleFechamentoModalAlerta,showModal:true});}return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FiltroPesquisaOperacoesGet__["a" /* default */],{handleSearchFilter:this.realizaConsulta,handleChangeList:this.tratarFiltroNaLista,list:this.state.listaRegistrosIndexada,listaRegistrosIndexadaAtualizada:this.state.listaRegistrosIndexadaAtualizada}),this.state.listaRegistrosIndexada&&this.state.listaRegistrosIndexada.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__exportacao_csv_RelatorioOperacoesGet__["a" /* default */],{filtrosConsulta:this.state.filtrosConsulta,papelUsuarioLogado:this.state.papelUsuarioLogado,converterValoresParaTipoNumerico:this.converterValoresParaTipoNumerico,defineNivelFiltro:this.defineNivelFiltro,definirValorUo:this.definirValorUo}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["u" /* Table */]//  legend={this.montarLegendaNomeRelatorioPorFiltroSelecionado()}
,{style:{color:'#00314d'},legend:this.state.estadoTabela.quantidadeTotalResultados===0?'Consulta Operações de Envio de Registros ao GET':'Consulta Opera\xE7\xF5es de Envios de Registros ao GET -  '+this.state.estadoTabela.quantidadeTotalResultados+' registro(s) encontrado(s)',bordered:true,fetchInfo:fetchInfo,data:this.defineListaParaTabela(),options:options,listaTableHeader:operacoesGetTableHeader,pagination:true,remote:true}),this.state.showDadosRetornoModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalRetornoOperacoesGet__["a" /* default */],Object.assign({},this.props,{estadoFormulario:this.state,handleModal:function handleModal(){return _this2.handleModalDadosRetorno('showDadosRetornoModal');},showModal:this.state.showDadosRetornoModal})):'',this.state.showDadosRetornoGetModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ModalRetornoIntegracaoGet__["a" /* default */],Object.assign({},this.props,{estadoFormulario:this.state,handleModal:function handleModal(){return _this2.handleModalDadosGetRetorno('showDadosRetornoGetModal');},showModal:this.state.showDadosRetornoGetModal})):'',modalAlerta);}}]);return ConsultaOperacoesGet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaOperacoesGet.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({idProtocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,protocoloComprev:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,protocoloTarefaGet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.inteiro,cpf:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mensagem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,idUo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,idNivel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired};ConsultaOperacoesGet.defaultProps={match:null};/* harmony default export */ __webpack_exports__["a"] = (ConsultaOperacoesGet);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FiltroPesquisaOperacoesGet=function(_Component){_inherits(FiltroPesquisaOperacoesGet,_Component);function FiltroPesquisaOperacoesGet(){_classCallCheck(this,FiltroPesquisaOperacoesGet);var _this=_possibleConstructorReturn(this,(FiltroPesquisaOperacoesGet.__proto__||Object.getPrototypeOf(FiltroPesquisaOperacoesGet)).call(this));_this.carregaUnidadesOrganicas=function(categoria,codigoSuperior,sucesso){var parametros={};if(codigoSuperior){parametros.codigoSuperior=codigoSuperior;}if(categoria){parametros.categoria=categoria;}Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('unidades-organicas',sucesso,_this.tratarErro,parametros);};_this.carregaSuperintendencias=function(response){var superintendencias=[];response.data.forEach(function(item){superintendencias.push({//    label: item.nomeUnidade,
label:item.codigoUnidade.concat(' - ',item.nomeUnidade),value:item.codigoUnidade});});_this.setState({listaSuperintendencias:superintendencias});};_this.carregaGexs=function(response){var gexs=[];response.data.forEach(function(item){gexs.push({label:item.codigoUnidade.concat(' - ',item.nomeUnidade),value:item.codigoUnidade});});_this.setState({listaGexs:gexs});};_this.carregaAps=function(response){var aps=[];response.data.forEach(function(item){aps.push({label:item.codigoUnidade.concat(' - ',item.nomeUnidade),value:item.codigoUnidade});});_this.setState({listaAps:aps});};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.handleKeyDown=function(e){var retorno=null;if(e.keyCode===13){retorno=_this.handleSeParchButton();}return retorno;};_this.handleChangeMascaraFiltro=function(changeObj,name){var _this$setState2;var mascaraAtual='';switch(changeObj.value){case 1:mascaraAtual='cpf';break;default:mascaraAtual='cpf';break;}_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,changeObj.value),_defineProperty(_this$setState2,'mascara',mascaraAtual),_this$setState2),function(){return _this.trataFormulario(name);});};_this.trataFormulario=function(campoAlterado){if(campoAlterado==='superintendencia'){_this.setState({gex:null,aps:null,ente:null});if(_this.state.superintendencia){_this.carregaUnidadesOrganicas(3,_this.state.superintendencia,_this.carregaGexs);}}if(campoAlterado==='gex'){_this.setState({aps:null,ente:null});if(_this.state.gex){_this.carregaUnidadesOrganicas(4,_this.state.gex,_this.carregaAps);}}};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.handleSearchButton=function(){var filtroPesquisaOperacoesGet={cpf:_this.state.cpf,cliqueiNoBotao:_this.state.cliqueiNoBotao,//     filtro: this.state.filtro,
mascara:_this.state.mascara,protocoloComprev:_this.state.protocoloComprev,mensagem:_this.state.mensagem,protocoloTarefaGet:_this.state.protocoloTarefaGet,status:_this.state.status};filtroPesquisaOperacoesGet=JSON.stringify(filtroPesquisaOperacoesGet);sessionStorage.setItem('filtroPesquisaOperacoesGet',filtroPesquisaOperacoesGet);_this.handleSearchOperacoesGet();};_this.handleSearchOperacoesGet=function(){var superintendenciaSelecionada=_this.state.superintendencia;var statusSelecionado=_this.state.status;var protocoloPreenchido=_this.state.protocoloComprev;var protocoloTarefaGetPrenchido=_this.state.protocoloTarefaGet;var cpfPreenchido=_this.state.cpf;var valido=false;if(protocoloTarefaGetPrenchido||protocoloPreenchido||cpfPreenchido){valido=true;}if(!valido&&superintendenciaSelecionada&&statusSelecionado){valido=true;}if(valido){_this.props.handleSearchFilter(_this.state);}else{_this.addMessage('É obrigatório o preenchimento de [CPF ou protocolo ou protocolo tarefa GET] e/ou [Alguma Unidade Orgânica e Status da Operação]');}};_this.montaFiltrosOperacoesGet=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["f" /* DataGridCustom */],{title:'UO de Cria\xE7\xE3o da Tarefa GET'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Superintend\xEAncia',onChange:function onChange(e){return _this.handleChange(e,'superintendencia');},placeholder:'Todas',value:_this.state.superintendencia,itemList:_this.state.listaSuperintendencias,custom:true})),_this.state.superintendencia?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'GEX',onChange:function onChange(e){return _this.handleChange(e,'gex');},placeholder:'Todas',value:_this.state.gex,itemList:_this.state.listaGexs,custom:true})):'',_this.state.gex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'8 8 8 8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'APS',onChange:function onChange(e){return _this.handleChange(e,'aps');},placeholder:'Todas',value:_this.state.aps,itemList:_this.state.listaAps,custom:true})):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["f" /* DataGridCustom */],{title:'Informa\xE7\xF5es das Opera\xE7\xF5es GET'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Protocolo Comprev',onChange:function onChange(e){return _this.handleChange(e,'protocoloComprev');},value:_this.state.protocoloComprev,validationState:'active',consultaOperacoesGet:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Protocolo Tarefa GET',onChange:function onChange(e){return _this.handleChange(e,'protocoloTarefaGet');},value:_this.state.protocoloTarefaGet,validationState:'active',consultaOperacoesGet:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{cpf:true,integer:true,label:'CPF',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].cpf,onChange:function onChange(e){return _this.handleChange(e,'cpf');},onKeyDown:function onKeyDown(e){return _this.handleKeyDown(e,'cpf');},showMask:true,value:_this.state.cpf,validationState:'active'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Status Opera\xE7\xE3o',name:'status',itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["s" /* operacoesStatusGet */],onChange:function onChange(e){return _this.handleChange(e,'status');},value:_this.state.status,validationState:'active',custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Mensagem Retorno',onChange:function onChange(e){return _this.handleChange(e,'mensagem');},value:_this.state.mensagem,validationState:'active',consultaOperacoesGet:true})))));};_this.filtroPesquisaOperacoesGet=JSON.parse(sessionStorage.getItem('filtroPesquisaOperacoesGet'));_this.state={cpf:_this.filtroPesquisaOperacoesGet&&_this.filtroPesquisaOperacoesGet.cpf?_this.filtroPesquisaOperacoesGet.cpf:null,protocoloComprev:_this.filtroPesquisaOperacoesGet&&_this.filtroPesquisaOperacoesGet.protocoloComprev?_this.filtroPesquisaOperacoesGet.bodyEnvio:null,protocoloTarefaGet:_this.filtroPesquisaOperacoesGet&&_this.filtroPesquisaOperacoesGet.protocoloTarefaGet?_this.filtroPesquisaOperacoesGet.protocoloTarefaGet:null,mensagem:_this.filtroPesquisaOperacoesGet&&_this.filtroPesquisaOperacoesGet.mensagem?_this.filtroPesquisaOperacoesGet.mensagem:null,nivelUo:_this.filtroPesquisaOperacoesGet&&_this.filtroPesquisaOperacoesGet.nivelUo?_this.filtroPesquisaOperacoesGet.nivelUo:null,idUo:_this.filtroPesquisaOperacoesGet&&_this.filtroPesquisaOperacoesGet.idUo?_this.filtroPesquisaOperacoesGet.idUo:null,status:_this.filtroPesquisaOperacoesGet&&_this.filtroPesquisaOperacoesGet.status?_this.filtroPesquisaOperacoesGet.status:null,superintendencia:_this.filtroPesquisaOperacoesGet&&_this.filtroPesquisaOperacoesGet.superintendencia?_this.filtroPesquisaOperacoesGet.superintendencia:null,gex:_this.filtroPesquisaOperacoesGet&&_this.filtroPesquisaOperacoesGet.gex?_this.filtroPesquisaOperacoesGet.gex:null,aps:_this.filtroPesquisaOperacoesGet&&_this.filtroPesquisaOperacoesGet.aps?_this.filtroPesquisaOperacoesGet.aps:null,listaSuperintendencias:[],listaGexs:[],listaAps:[]};return _this;}_createClass(FiltroPesquisaOperacoesGet,[{key:'componentDidMount',value:function componentDidMount(){if(sessionStorage.getItem('filtroPesquisaOperacoesGet')){this.handleSearchButton();}this.carregaUnidadesOrganicas(24,null,this.carregaSuperintendencias);}},{key:'render',value:function render(){var _this2=this;var filtrosPesquisa=this.montaFiltrosOperacoesGet();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'pesquisa',panelId:'filtro-pesquisa',icon:'ico-filter',title:'Filtro de Pesquisa'},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroPesquisaOperacoesGet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroPesquisaOperacoesGet.propTypes={handleChangeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroPesquisaOperacoesGet);

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalStatusIntegracaoGet__ = __webpack_require__(640);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ModalStatusIntegracaoGet from '../ModalStatusIntegracaoGet';
var RelatorioOperacoesGet=function(_Component){_inherits(RelatorioOperacoesGet,_Component);function RelatorioOperacoesGet(props){_classCallCheck(this,RelatorioOperacoesGet);var _this=_possibleConstructorReturn(this,(RelatorioOperacoesGet.__proto__||Object.getPrototypeOf(RelatorioOperacoesGet)).call(this,props));_this.tratarSucessoListaExportacao=function(response){if(response.data!==''){_this.setState({},_this.gerarCsv(response.data));}};_this.tratarErro=function(){var mensagemPrimaria='Não foi possível consultar a operações de envio ao GET.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.colunasExportacaoDefault=['UO de Criação da Tarefa GET','Protocolo Comprev','Protocolo Tarefa GET','Data de Inclusão','Data de Envio','Quantidade de Tentativas','Status Operação','Operação','Origem','Mensagem','Retorno','Observação','Body'];_this.colunasExportacaoAlternativo=['UO de Criação da Tarefa GET','Protocolo Comprev','Protocolo Tarefa GET','Data de Inclusão','Data de Envio','Operação','Status Operação','Mensagem'];_this.formatarProtocolo=function(protocolo){var protocoloFormatado='';if(protocolo){protocoloFormatado='\''+protocolo;protocoloFormatado=''+protocoloFormatado;}return protocoloFormatado;};_this.defineListaParaExportacao=function(lista){var listaOriginal=lista;var resultado=[];if(_this.props.papelUsuarioLogado==='analista-dtp'){listaOriginal.forEach(function(envio){resultado.push({idUnidadeOrganica:envio.idUnidadeOrganica!==undefined?envio.idUnidadeOrganica:'',idProtocolo:envio.idProtocolo?_this.formatarProtocolo(envio.idProtocolo):'',idTarefaGet:envio.idTarefaGet!==undefined?envio.idTarefaGet:'',dataInclusao:envio.dataInclusao!==undefined?__WEBPACK_IMPORTED_MODULE_2_moment___default()(envio.dataInclusao).format('DD/MM/YYYY HH:mm:ss'):'',dataEnvio:envio.dataEnvio!==undefined?__WEBPACK_IMPORTED_MODULE_2_moment___default()(envio.dataEnvio).format('DD/MM/YYYY HH:mm:ss'):'',quantidadeTentativas:envio.quantidadeTentativas!==undefined?envio.quantidadeTentativas:'',status:envio.status!==undefined?envio.status:'',operacao:envio.operacao!==undefined?envio.operacao:'',origem:envio.origem!==undefined?envio.origem:'',mensagem:envio.mensagem!==undefined?envio.mensagem:'',retorno:envio.retorno!==undefined?envio.retorno:'',observacao:envio.observacao!==undefined?envio.observacao:'',body:envio.body!==undefined?envio.body:''});});}else{listaOriginal.forEach(function(envio){resultado.push({idUnidadeOrganica:envio.idUnidadeOrganica!==undefined?envio.idUnidadeOrganica:'',idProtocolo:envio.idProtocolo?_this.formatarProtocolo(envio.idProtocolo):'',idTarefaGet:envio.idTarefaGet!==undefined?envio.idTarefaGet:'',dataInclusao:envio.dataInclusao!==undefined?__WEBPACK_IMPORTED_MODULE_2_moment___default()(envio.dataInclusao).format('DD/MM/YYYY HH:mm:ss'):'',dataEnvio:envio.dataEnvio!==undefined?__WEBPACK_IMPORTED_MODULE_2_moment___default()(envio.dataEnvio).format('DD/MM/YYYY HH:mm:ss'):'',operacao:envio.operacao!==undefined?envio.operacao:'',status:envio.status!==undefined?envio.status:'',mensagem:envio.mensagem!==undefined?envio.mensagem:''});});}return resultado;};_this.exportar=function(){if(Object.entries(_this.props.filtrosConsulta).length!==0){var nivel=_this.props.defineNivelFiltro();var parametros={'start-position':0,'max-results':100000};if(_this.props.filtrosConsulta.protocoloTarefaGet){parametros.protocoloTarefaGet=_this.props.converterValoresParaTipoNumerico(_this.props.filtrosConsulta.protocoloTarefaGet);}if(_this.props.filtrosConsulta.status){parametros.status=_this.props.converterValoresParaTipoNumerico(_this.props.filtrosConsulta.status);}if(_this.props.filtrosConsulta.protocoloComprev){parametros.protocoloComprev=_this.props.filtrosConsulta.protocoloComprev;}if(_this.props.filtrosConsulta.cpf){parametros.cpf=_this.props.filtrosConsulta.cpf;}if(_this.props.filtrosConsulta.mensagem){parametros.mensagem=_this.props.filtrosConsulta.mensagem;}if(nivel!==0){parametros.nivelUo=nivel;}if(nivel!==0){parametros.idUo=_this.props.definirValorUo(nivel);}Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["l" /* doPost */])('operacoes-get/exportacoes',parametros,_this.tratarSucessoListaExportacao,_this.tratarErro);}};_this.handleModalStatusGetRetorno=function(){_this.setState({showStatusRetornoGetModal:!_this.state.showStatusRetornoGetModal});};_this.gerarCsv=function(lista){var dadosRelatorio=null;var legenda='Registro de Operações do GET';if(lista&&lista!==undefined&&lista.length>0){dadosRelatorio=_this.defineListaParaExportacao(lista);}else{dadosRelatorio=[];}if(dadosRelatorio&&dadosRelatorio!==undefined&&dadosRelatorio.length>0){var csvExporter=new __WEBPACK_IMPORTED_MODULE_3_export_to_csv__["ExportToCsv"]({filename:'RegistroOperacoesGET',fieldSeparator:';',showTitle:true,title:legenda,showLabels:true,headers:_this.props.papelUsuarioLogado==='analista-dtp'?_this.colunasExportacaoDefault:_this.colunasExportacaoAlternativo});csvExporter.generateCsv(dadosRelatorio);}};_this.state={showNoContent:false,noContentPrimaryMessage:null,noContentSecondaryMessage:null,showStatusRetornoGetModal:false};return _this;}_createClass(RelatorioOperacoesGet,[{key:'render',value:function render(){var _this2=this;if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{onClick:function onClick(){_this2.exportar();},hint:'Exporta Opera\xE7\xF5es para arquivo CSV com filtro escolhido',icon:'ico-doc-sheet',mini:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{hint:'Legenda para o Status da Opera\xE7\xE3o',icon:'ico-help-c',onClick:function onClick(){return _this2.handleModalStatusGetRetorno('showStatusRetornoGetModal');},mini:true})),this.state.showStatusRetornoGetModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ModalStatusIntegracaoGet__["a" /* default */],Object.assign({},this.props,{estadoFormulario:this.state,handleModal:function handleModal(){return _this2.handleModalStatusGetRetorno('showStatusRetornoGetModal');},showModal:this.state.showStatusRetornoGetModal})):'');}}]);return RelatorioOperacoesGet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RelatorioOperacoesGet.propTypes={voltarAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,filtrosConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,papelUsuarioLogado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,converterValoresParaTipoNumerico:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,defineNivelFiltro:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,definirValorUo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;RelatorioOperacoesGet.defaultProps={voltarAction:function voltarAction(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (RelatorioOperacoesGet);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_index__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalStatusIntegracaoGet=function(_Component){_inherits(ModalStatusIntegracaoGet,_Component);function ModalStatusIntegracaoGet(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalStatusIntegracaoGet);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalStatusIntegracaoGet.__proto__||Object.getPrototypeOf(ModalStatusIntegracaoGet)).call.apply(_ref,[this].concat(args))),_this),_this.modalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Conclu\xEDda'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'A opera\xE7\xE3o de comunica\xE7\xE3o do Comprev com o GET foi finalizada com sucesso.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Indisponibilidade ou falha t\xE9cnica'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'A opera\xE7\xE3o de comunica\xE7\xE3o do Comprev com o GET apresentou uma indisponibilidade moment\xE2nea ou uma falha t\xE9cnica.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'A natureza da falha pode exigir atua\xE7\xE3o da equipe de suporte da aplica\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Periodicidade de comunica\xE7\xE3o em at\xE9 10 minutos.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Falha de neg\xF3cio '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'A opera\xE7\xE3o de comunica\xE7\xE3o do Comprev com o GET apresentou falha de neg\xF3cio relacionado ao GET.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Veja o campo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Mensagem Retorno'),'  para mais informa\xE7\xF5es sobre \xE0 cr\xEDtica de neg\xF3cio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Periodicidade de comunica\xE7\xE3o \xE9 uma vez por dia no primeiro hor\xE1rio da madrugada ou, havendo ajuste da cr\xEDtica de neg\xF3cio, pode ser reprocessada em at\xE9 10 minutos clicando no bot\xE3o de a\xE7\xE3o da tabela de pesquisa.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Pronta para nova execu\xE7\xE3o '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'A opera\xE7\xE3o de comunica\xE7\xE3o do Comprev com o GET ser\xE1 reprocessada automaticamente pela aplica\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Periodicidade de comunica\xE7\xE3o em at\xE9 10 minutos.'))))));},_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["a" /* Button */],{title:'Fechar',onClick:_this.handleCloseStatusIntegracaoGet,hint:'Fechar'})));},_this.handleCloseStatusIntegracaoGet=function(){_this.setState(_this.props.handleModal('showStatusRetornoGetModal'));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalStatusIntegracaoGet,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalFooter(),conteudomodal:this.modalContent(),onHide:this.handleCloseStatusIntegracaoGet,size:'lg',showModal:this.props.showModal,title:'Legenda para o Status da Opera\xE7\xE3o'}));}}]);return ModalStatusIntegracaoGet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalStatusIntegracaoGet.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalStatusIntegracaoGet);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_index__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalRetornoOperacoesGet=function(_Component){_inherits(ModalRetornoOperacoesGet,_Component);function ModalRetornoOperacoesGet(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalRetornoOperacoesGet);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalRetornoOperacoesGet.__proto__||Object.getPrototypeOf(ModalRetornoOperacoesGet)).call.apply(_ref,[this].concat(args))),_this),_this.modalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:{height:_this.props.estadoFormulario.papelUsuarioLogado==='analista-dtp'?'700px':'400px','overflow-y':'auto','overflow-x':'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Protocolo Comprev',value:_this.props.estadoFormulario.retorno.idProtocolo,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Protocolo Tarefa GET',value:_this.props.estadoFormulario.retorno.idTarefaGet,disabled:true})),_this.props.estadoFormulario.retorno.idUnidadeOrganica!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'UO de Cria\xE7\xE3o da Tarefa GET',value:_this.props.estadoFormulario.retorno.idUnidadeOrganica,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Status Opera\xE7\xE3o',value:_this.props.estadoFormulario.retorno.status,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Opera\xE7\xE3o',value:_this.props.estadoFormulario.retorno.operacao,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Data de Inclus\xE3o',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.props.estadoFormulario.retorno.dataInclusao).format('DD/MM/YYYY HH:mm:ss'),disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Data de Envio',value:__WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.props.estadoFormulario.retorno.dataEnvio).format('DD/MM/YYYY HH:mm:ss'),disabled:true})),_this.props.estadoFormulario.papelUsuarioLogado==='analista-dtp'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Origem',value:_this.props.estadoFormulario.retorno.origem,disabled:true})),_this.props.estadoFormulario.papelUsuarioLogado==='analista-dtp'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Quantidade de Tentativas',value:_this.props.estadoFormulario.retorno.quantidadeTentativas,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Mensagem',value:_this.props.estadoFormulario.retorno.mensagem,disabled:true}))),_this.props.estadoFormulario.papelUsuarioLogado==='analista-dtp'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},disabled:true,cols:'50',componentClass:'textarea',label:'Body',maxlength:'200',rows:'6',value:_this.props.estadoFormulario.retorno.body,textarea:true}))),_this.props.estadoFormulario.papelUsuarioLogado==='analista-dtp'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},disabled:true,cols:'50',componentClass:'textarea',label:'Retorno',maxlength:'200',rows:'6',value:_this.props.estadoFormulario.retorno.retorno,textarea:true}))),_this.props.estadoFormulario.papelUsuarioLogado==='analista-dtp'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["k" /* Input */],{style:{color:'#00314d'},disabled:true,cols:'50',componentClass:'textarea',label:'Observa\xE7\xE3o:',maxlength:'200',rows:'4',value:_this.props.estadoFormulario.retorno.observacao,textarea:true})))));},_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["a" /* Button */],{title:'Fechar',onClick:_this.handleClose,hint:'Fechar'})));},_this.handleClose=function(){_this.setState(_this.props.handleModal('showDadosRetornoModal'));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalRetornoOperacoesGet,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__src_components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalFooter(),conteudomodal:this.modalContent(),onHide:this.handleClose,size:'lg',showModal:this.props.showModal,title:'Detalhes do Registro da Opera\xE7\xE3o'}));}}]);return ModalRetornoOperacoesGet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalRetornoOperacoesGet.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalRetornoOperacoesGet);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_index__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalRetornoIntegracaoGet=function(_Component){_inherits(ModalRetornoIntegracaoGet,_Component);function ModalRetornoIntegracaoGet(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalRetornoIntegracaoGet);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalRetornoIntegracaoGet.__proto__||Object.getPrototypeOf(ModalRetornoIntegracaoGet)).call.apply(_ref,[this].concat(args))),_this),_this.modalContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Protocolo Tarefa GET',value:_this.props.estadoFormulario.conteudoModalIntegracaoGet.idTarefaGet,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Sigla',value:_this.props.estadoFormulario.conteudoModalIntegracaoGet.sigla,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["i" /* Grid */],{cols:'9 9 9 9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Nome do Servi\xE7o',value:_this.props.estadoFormulario.conteudoModalIntegracaoGet.nomeServico,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Data da Cria\xE7\xE3o',value:_this.props.estadoFormulario.conteudoModalIntegracaoGet.dataCriacao,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["i" /* Grid */],{cols:'9 9 9 9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["k" /* Input */],{style:{color:'#00314d'},label:'Status',value:_this.props.estadoFormulario.conteudoModalIntegracaoGet.statusTarefa,disabled:true}))));},_this.modalFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["a" /* Button */],{title:'Fechar',onClick:_this.handleCloseIntegracaoGet,hint:'Fechar'})));},_this.handleCloseIntegracaoGet=function(){_this.setState(_this.props.handleModal('showDadosRetornoGetModal'));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalRetornoIntegracaoGet,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalFooter(),conteudomodal:this.modalContent(),onHide:this.handleCloseIntegracaoGet,size:'lg',showModal:this.props.showModal,title:'Status atual da Tarefa no GET'}));}}]);return ModalRetornoIntegracaoGet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalRetornoIntegracaoGet.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalRetornoIntegracaoGet);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__templates_FiltroControlePagamentos__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__templates_CalculadoraPagamento__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__templates_RelatorioControlePagamentos__ = __webpack_require__(645);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var ControlePagamentos=function(_Component){_inherits(ControlePagamentos,_Component);function ControlePagamentos(props){_classCallCheck(this,ControlePagamentos);var _this=_possibleConstructorReturn(this,(ControlePagamentos.__proto__||Object.getPrototypeOf(ControlePagamentos)).call(this,props));_this.limpaListaTabela=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRegistrosIndexada:[],estadoTabela:estadoTabela,titulo:''});};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.realizaConsulta=function(filtrosPesquisa){var filtros={};if(filtrosPesquisa){filtros=_this.montaFiltros(filtrosPesquisa);}_this.setState({filtrosConsulta:filtros},_this.executaConsulta);};_this.realizaConsultaPorRota=function(visaoRota){var filtros={};filtros=_this.montaFiltrosRota(visaoRota);_this.setState({filtrosConsulta:filtros},_this.executaConsulta);};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('controle-pagamentos',_this.tratarSucesso,_this.tratarErro,Object.assign({},_this.state.filtrosConsulta,{'start-position':primeiroItem,'max-results':resultadosPorPagina}));}else{_this.setState({listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true});}};_this.definePapelFiltro=function(){var retorno='';var isAnalistaDcomp=_this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);var isRpps=_this.props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps','consultar-compensacao-rpps']);var isAnalistaSprev=_this.props.auth.checkPermission(['analisar-negocio-sprev']);var isAnalistaDtp=_this.props.auth.checkPermission(['analisar-negocio-dtpv']);if(isAnalistaDcomp){retorno='analista-rgps';}if(isRpps){retorno='analista-rpps';}if(isAnalistaSprev){retorno='analista-sprev';}if(isAnalistaDtp){retorno='analista-dtp';}_this.setState({papelUsuarioLogado:retorno});};_this.montaFiltros=function(atributosPesquisa){var atributos=[];if(atributosPesquisa.participanteObservador){atributos=Object.assign({},atributos,{participanteObservador:atributosPesquisa.participanteObservador});}if(atributosPesquisa.competencia){atributos=Object.assign({},atributos,{competencia:atributosPesquisa.competencia});}if(atributosPesquisa.visaoControlePagamento){atributos=Object.assign({},atributos,{visaoControlePagamento:atributosPesquisa.visaoControlePagamento});}if(atributosPesquisa.estadoPagamento){atributos=Object.assign({},atributos,{estadoPagamento:atributosPesquisa.estadoPagamento});}if(atributosPesquisa.tipoEntidade){var tipoEntidadeString=atributosPesquisa.tipoEntidade;if(atributosPesquisa.tipoEntidade==='01000'){atributos=Object.assign({},atributos,{idParticipante:'01000'});}if(tipoEntidadeString.toString()==='98222'){atributos=Object.assign({},atributos,{idParticipante:'98222'});}if(tipoEntidadeString.toString()==='98026'){atributos=Object.assign({},atributos,{idParticipante:'98026'});}}if(atributosPesquisa['destinatario-rpps']){atributos=Object.assign({},atributos,{idParticipante:atributosPesquisa['destinatario-rpps']});}atributos=Object.assign({},atributos,{tipoControle:_this.props.match.params.tipoControle});var desconsiderar=0;if(atributosPesquisa.desconsiderarFluxosExtraordinarios){// checkbox marcado
desconsiderar=1;}atributos=Object.assign({},atributos,{desconsiderarFluxosExtraordinarios:desconsiderar});var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;if(atributosPesquisa.cliqueiNoBotao===1){_this.state.estadoTabela.paginaAtual=1;}var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.montaFiltrosRota=function(visaoRota){var atributos=[];atributos=Object.assign({},atributos,{tipoControle:_this.props.match.params.tipoControle,visaoControlePagamento:visaoRota});var _this$state$estadoTab3=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab3.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.trataSucessoResponseEnvio=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta},_this.trataSucesso);};_this.trataErrosResponse=function(error){if(error&&error.data){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);}};_this.tratarSucessoListaExportacao=function(response){if(response.data===''){_this.setState({listaRegistrosExportacao:[]});}else{_this.setState({listaRegistrosExportacao:response.data});}};_this.recuperarListaExportacaoCSV=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('controle-pagamentos/exportacao-csv',_this.tratarSucessoListaExportacao,_this.tratarErro,Object.assign({},_this.state.filtrosConsulta));}else{_this.setState({listaRegistrosExportacao:[]});}};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRegistrosIndexada:_this.props.match.params.tipoControle==='controle-pagamentos'||_this.props.match.params.tipoControle==='pendencias'?response.data:response.data.pagamentos,listaRegistrosIndexadaAtualizada:true,estadoTabela:estadoTabela},_this.montaParametrosTitulo(response.data.totalizador,response.data.entidadeFiltro));}};_this.tratarFiltroNaLista=function(listaRegistrosFiltrada){_this.setState({listaRegistrosFiltrada:listaRegistrosFiltrada,listaRegistrosIndexadaAtualizada:false});};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;var lista=void 0;if(error.status){if(error.data.erros){if(error.data.erros[0]){var codigoErro=error.data.erros[0].codigo;if(codigoErro===1587){lista=[];}}}_this.setState({noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao,listaRegistrosIndexada:lista});}else{_this.setState({noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleChange=function(e,name){_this.setState(Object.assign({},_this.state,_defineProperty({},name,e)));};_this.handleCloseModal=function(modalStateName){_this.setState(_defineProperty({},modalStateName,false));};_this.addCompetenciaLabel=function(p,row){var objCompetencia='';if(row&&row.mes!=='0'&&row.ano!=='0'){objCompetencia=row.mes+'/'+row.ano;if(objCompetencia.length!==7){objCompetencia='0'+objCompetencia;}}return objCompetencia;};_this.addTipoEstadoPagamentoLabel=function(tipo){var listaEstados=__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["g" /* estadosPagamento */];var estado=__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */](listaEstados,tipo).label;var estadoCss='';estadoCss=estado;switch(tipo){case 1:estadoCss='Aberto';break;case 2:estadoCss='EmProcessamento';break;case 3:estadoCss='Contestado';break;case 4:estadoCss='AguardandoAnaliseDefesa';break;case 5:estadoCss='Pago';break;case 6:estadoCss='Rejeitado';break;case 7:estadoCss='NaoPago';break;case 8:estadoCss='NaoMonitorado';break;case 9:estadoCss='EmAnaliseDefesaRegularidadePagamento';break;case 10:estadoCss='EmAnaliseDefesaGru';break;case 11:estadoCss='EmAnaliseDefesaExtraordinaria';break;case 12:estadoCss='ContestacaoExtraordinaria';break;default:estadoCss='';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'estado'+estadoCss},estado));};_this.formatarValorLabel=function(valorCompensacao){var valorFormatado='';if(valorCompensacao){valorFormatado=valorCompensacao.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3});}return valorFormatado;};_this.formatarCnpj=function(cnpj){if(!cnpj)return'';return cnpj.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/,'$1.$2.$3/$4-$5');};_this.gerarGru=function(row){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["m" /* doPostDocumentoComUrlDinamica */])('/controle-pagamentos/'+row.idControlePagamento+'/grus');};_this.gerarGruViaModalConfirmacao=function(row){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["m" /* doPostDocumentoComUrlDinamica */])('/controle-pagamentos/'+row.idControlePagamento+'/grus');_this.handleFechamentoModalAlertaGeracaoGRU();};_this.rejeitarPagamentoRGPS=function(){var urlRejeitarRGPS='mensagem-pagamento-participante/rgps-rejeitado/'+_this.state.rowSelecionada.idControlePagamento;Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["l" /* doPost */])(urlRejeitarRGPS,null,function(){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["J" /* trataMensagemSucesso */])(['pagamento rejeitado']);_this.handleCloseModal('showRejeicaoRGPSModal');_this.realizaConsulta(_this.state.filtrosConsulta);}//  () => { trataMensagensErro(['erro']); },
);};_this.showDetalhe=function(row){_this.props.history.push('/controledepagamentos/detalhe/'+row.idControlePagamento+'/'+_this.props.match.params.tipoControle);};_this.montaAcoes=function(row){// const analistaRGPSLogado = User.logged().isRGPS();
var acaoDetalhar=true;var acaoCalculadora=!Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["b" /* ehPapelObservadorPagamento */])(_this.state.papelUsuarioLogado)&&row.exibirBotaocalculadora;var acaoGRU=!Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["b" /* ehPapelObservadorPagamento */])(_this.state.papelUsuarioLogado)&&row.exibirBotaoAcaoGru;var acaoRegeitarRGPS=!Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["b" /* ehPapelObservadorPagamento */])(_this.state.papelUsuarioLogado)&&row.entidadePagadora==='01000'&&row.estado===8&&row.codigoParticipanteLogado==='01000';var exibirConfirmacaoGerarGRU=row.estado===9||row.estado===10;// const acaoDetalharGRU = true;
var botaoAcaoGRU=acaoGRU?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["a" /* Button */],{hint:'A\xE7\xE3o GRU',icon:'ico-print',id:'acao-gru',mini:true// onClick={() => this.gerarGru(row)
,onClick:exibirConfirmacaoGerarGRU?function(){return _this.showConfirmacaoGerarGRUModal(row);}:function(){return _this.gerarGru(row);}}):'';var botaoCalculadora=acaoCalculadora?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["a" /* Button */],{hint:'Calculadora',icon:'ico-calc',id:'calculadora',mini:true,onClick:function onClick(){return _this.showCalculadoraModal(row);}}):'';var botaoRejeitarRGPS=acaoRegeitarRGPS?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["a" /* Button */],{hint:'Informar rejei\xE7\xE3o de pagamento',icon:'ico-doc-thumb-down',id:'rejeitarRGPS',mini:true,onClick:function onClick(){return _this.showRejeicaoRGPSModal(row);}}):'';var botaoDetalhar=acaoDetalhar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["a" /* Button */],{hint:'Detalhar',icon:'ico-chat',id:'detalhar',mini:true,onClick:function onClick(e){return _this.showDetalhe(row,e);}}):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,botaoAcaoGRU,botaoCalculadora,botaoRejeitarRGPS,botaoDetalhar);};_this.createActionColumn=function(cell,row){return _this.montaAcoes(row);};_this.montaColunasEspecificasTipoEntidade=function(){var _this$state2=Object.assign({},_this.state),filtrosConsulta=_this$state2.filtrosConsulta;if(filtrosConsulta&&filtrosConsulta.visaoControlePagamento===1){return[{id:'nomeEntidadePagadora',label:'Participante'}];}return[{id:'nomeEntidadeRecebedora',label:'Participante'}];};_this.montaColunasEspecificasRPPS=function(){if(_this.state.papelUsuarioLogado==='analista-rgps'){return[{id:'dataCreditoPagamento',label:'Data de Crédito do Pagamento'}];}return[{id:'dataHomologacaoTribunalContas',label:'Data de Homologação no Tribunal de Contas'}];};_this.montaColunas=function(){var _this$state3=Object.assign({},_this.state),filtrosConsulta=_this$state3.filtrosConsulta;var _this$props$match$par=Object.assign({},_this.props.match.params),tipoControle=_this$props$match$par.tipoControle;var colunas=_this.montaColunasPeloTipoControle(_this.props.match.params.tipoControle);var consultaPagamentoTableHeader=colunas.slice();var colunasEspecificas=[];if(tipoControle==='controle-pagamentos'||tipoControle==='pendencias'){if(filtrosConsulta.visaoControlePagamento===1){// 'Valores a receber'
colunasEspecificas.push({id:'cnpjPagador',label:'CNPJ',dataFormat:__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["d" /* formatarCnpj */]});}else{colunasEspecificas.push({id:'cnpj',label:'CNPJ',dataFormat:__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["d" /* formatarCnpj */]});}colunasEspecificas=colunasEspecificas.concat(_this.montaColunasEspecificasTipoEntidade());}if(tipoControle==='controle-debitos-pendentes'&&(_this.state.papelUsuarioLogado==='analista-rgps'||filtrosConsulta.participanteObservador==='01000')){colunasEspecificas.push({id:'cnpjPagador',label:'CNPJ',dataFormat:__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["d" /* formatarCnpj */]});}if(colunasEspecificas){colunasEspecificas=colunasEspecificas.concat(consultaPagamentoTableHeader);if(_this.props.match.params.tipoControle==='controle-debitos-pendentes'&&(_this.state.papelUsuarioLogado==='analista-rgps'||_this.state.filtrosConsulta.participanteObservador==='01000')){colunasEspecificas=colunasEspecificas.concat(_this.colunasDebitosPendentes);}}colunasEspecificas.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});return colunasEspecificas;};_this.montaColunasPeloTipoControle=function(tipoControle){var colunasTabela='';switch(tipoControle){case'controle-pagamentos':colunasTabela=_this.colunasDefault;break;case'controle-debitos-pendentes':colunasTabela=_this.montaColunasEspecificasDebitosPendentes();break;case'pendencias':colunasTabela=_this.colunasEspecificasPendencias;break;default:colunasTabela='';}return colunasTabela;};_this.colunasDefault=[{id:'dataPrazo',label:'Prazo Resposta'},{id:'valorCompensacao',label:'Valor',dataFormat:_this.formatarValorLabel},{id:'estado',label:'Estado',dataFormat:_this.addTipoEstadoPagamentoLabel}];_this.montaColunasEspecificasDebitosPendentes=function(){if(_this.state.papelUsuarioLogado==='analista-rgps'||_this.state.filtrosConsulta.participanteObservador==='01000'){return[{id:'nomeEntidadePagadora',label:'Participante'}];}return _this.colunasDebitosPendentes;};_this.colunasDebitosPendentes=[{id:'competencia',label:'Competência',dataFormat:_this.addCompetenciaLabel},{id:'valorCompensacao',label:'Valor',dataFormat:_this.formatarValorLabel},{id:'dataVencimento',label:'Data de Vencimento'},{id:'estado',label:'Estado',dataFormat:_this.addTipoEstadoPagamentoLabel}];_this.colunasEspecificasPendencias=[{id:'competencia',label:'Competência',dataFormat:_this.addCompetenciaLabel},{id:'dataPrazo',label:'Prazo Resposta'},{id:'valorCompensacao',label:'Valor',dataFormat:_this.formatarValorLabel},{id:'dataVencimento',label:'Data de Vencimento'},{id:'estado',label:'Estado',dataFormat:_this.addTipoEstadoPagamentoLabel}];_this.defineListaParaTabela=function(){if(_this.state.listaRegistrosFiltrada!==null){return _this.state.listaRegistrosFiltrada;}return _this.state.listaRegistrosIndexada;};_this.alterarPagina=function(pagina,page){var _this$state4=Object.assign({},_this.state),estadoTabela=_this$state4.estadoTabela;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state5=Object.assign({},_this.state),estadoTabela=_this$state5.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.trataSucesso=function(){_this.realizaConsulta(_this.state.filtrosConsulta);Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["J" /* trataMensagemSucesso */])(['Contestação de pagamento criada.']);_this.handleModalContestacao('showContestacaoModal');};_this.trataSucessoResponseEnvio=function(){_this.setState({chaveConfirmacao:null,alertas:[]},_this.trataSucesso);};_this.showCalculadoraModal=function(row){_this.setState({showCalculadoraModal:!_this.state.showCalculadoraModal,rowSelecionada:row});};_this.showRejeicaoRGPSModal=function(row){_this.setState({showRejeicaoRGPSModal:!_this.state.showCalculadoraModal,rowSelecionada:row});};_this.showConfirmacaoGerarGRUModal=function(row){_this.setState({showConfirmacaoGerarGRUModal:!_this.state.showConfirmacaoGerarGRUModal,rowSelecionada:row});};_this.exibirComplementoTitulo=function(){var retorno='';var _this$props=Object.assign({},_this.props),complementoTitulo=_this$props.complementoTitulo;var paramComplementoTitulo='';if(complementoTitulo!==null){paramComplementoTitulo=JSON.parse(complementoTitulo);if(paramComplementoTitulo.complementoTitulo&&paramComplementoTitulo.complementoTitulo!==''){retorno=' - '+paramComplementoTitulo.complementoTitulo;}}// requestApagaComplementoTitulo();
return retorno;};_this.montaParametroVisaoDePendencias=function(visaoControlePagamento,participanteObservador){var retorno=void 0;if(_this.state.papelUsuarioLogado==='analista-rgps'||participanteObservador==='01000'){retorno='- valores a receber';}else if(visaoControlePagamento===1){retorno='- valores a receber';}else{retorno='- valores a pagar';}return retorno;};_this.montaParametrosTitulo=function(totalizador,entidadeFiltro){var _this$props$match$par2=Object.assign({},_this.props.match.params),tipoControle=_this$props$match$par2.tipoControle;var _this$state$filtrosCo=Object.assign({},_this.state.filtrosConsulta),participanteObservador=_this$state$filtrosCo.participanteObservador,visaoControlePagamento=_this$state$filtrosCo.visaoControlePagamento;var mensagem='';var dataAtual=''+__WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('DD/MM/YYYY HH:mm:ss');switch(tipoControle){case'controle-debitos-pendentes':{var primeiroParametro='';if(_this.state.papelUsuarioLogado==='analista-rgps'||participanteObservador==='01000'){var nomeParticipante=entidadeFiltro!==undefined?entidadeFiltro:'TODOS';primeiroParametro='- Valores a Receber do Participante - '+nomeParticipante;}else{primeiroParametro='- Valores a Pagar ao RGPS';}mensagem=primeiroParametro+' - R$ '+totalizador.toLocaleString('pt-BR')+'  - Data: '+dataAtual;break;}case'pendencias':{var primeitoParametro=_this.montaParametroVisaoDePendencias(visaoControlePagamento,participanteObservador);mensagem=primeitoParametro+' - Data: '+dataAtual;break;}default:mensagem='';}_this.setState({titulo:mensagem});};_this.montaLegendaTitulo=function(tipoControle){var retornoLegenda=void 0;switch(tipoControle){case'controle-pagamentos':retornoLegenda='Controle de Pagamentos '+_this.exibirComplementoTitulo();break;case'controle-debitos-pendentes':retornoLegenda='Controle de D\xE9bitos Carregados RGPS '+_this.state.titulo;break;case'pendencias':retornoLegenda='Pend\xEAncias de Controle de Pagamento '+_this.state.titulo;break;default:retornoLegenda='';}return retornoLegenda;};_this.handleFechamentoModalAlertaGeracaoGRU=function(){_this.setState({chaveConfirmacao:null,alertas:[],showConfirmacaoGerarGRUModal:!_this.state.showConfirmacaoGerarGRUModal});};_this.renderModalCalculadora=function(){var infoPagamento=null;if(_this.state.rowSelecionada){infoPagamento={idControlePagamento:null,nomeEntidadePagadora:'',nomeEntidadeRecebedora:'',codigoBanco:'',nomeBanco:'',numeroAgencia:'',dvAgencia:'',numeroContaCorrente:'',dvContaCorrente:'',cnpj:'',mes:'',ano:'',valorCompensacao:_this.state.rowSelecionada.valorCompensacao,dataVencimento:_this.state.rowSelecionada.dataVencimento,dataPagamentoAtraso:'',valorMulta:'',valorJuros:'',mensagens:[],estado:null,codigoParticipanteLogado:null,indicadorAtraso:null};}return infoPagamento!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__templates_CalculadoraPagamento__["a" /* default */],{valorParcial:null,infoPagamento:infoPagamento,mostrarCamposAdicionais:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'.');};_this.renderFooterModalConfirmarRejeicaoRGPS=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["a" /* Button */],{className:'dtp-primary right',title:'Confirmar Rejei\xE7\xE3o',id:'confirmarRejeicao',onClick:function onClick(){return _this.rejeitarPagamentoRGPS();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["a" /* Button */],{title:'Cancelar',id:'cancelarRejeicao',onClick:function onClick(){return _this.handleCloseModal('showRejeicaoRGPSModal');}})));};_this.renderFooterModalConfirmarGerarGRU=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["a" /* Button */],{className:'dtp-primary right',title:'Confirmar gera\xE7\xE3o GRU',id:'confirmarGeracaoGRU',onClick:function onClick(){return _this.gerarGruViaModalConfirmacao(_this.state.rowSelecionada);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["a" /* Button */],{title:'Cancelar',id:'cancelarGeracaoGRU',onClick:function onClick(){return _this.handleCloseModal('showConfirmacaoGerarGRUModal');}})));};_this.state={acao:null,listaRegistrosFiltrada:null,listaRegistrosIndexada:[],listaRegistrosExportacao:[],registroVindoDoRequest:null,showNoContent:false,rowSelecionada:null,listaRegistrosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosConsulta:{},showCalculadoraModal:false,showRejeicaoRGPSModal:false,competencia:null,papelUsuarioLogado:null,titulo:'',showConfirmacaoGerarGRUModal:false};return _this;}_createClass(ControlePagamentos,[{key:'componentDidMount',value:function componentDidMount(){// solicitarHabilitarQualificacao();
Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["g" /* manterApenasFiltro */])('filtroControlePagamento');if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}this.definePapelFiltro();if(sessionStorage.getItem('tipoControle')){if(sessionStorage.getItem('tipoControle')!==this.props.match.params.tipoControle||this.props.history.action!=='POP'){this.limpaListaTabela();}}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.match.params.tipoControle!==prevProps.match.params.tipoControle){this.limpaListaTabela();}}/**
   * Trata filtros na lista que veio do servidor (Componente FiltroPagamentos)
   */},{key:'render',value:function render(){var _this2=this;var options={noDataText:'Nenhum pagamento a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var consultaPagamentoTableHeader=this.montaColunas();var jssConfirmacaoRejeicaoRGPS={fontSize:'20px',marginBottom:'30px',textAlign:'center',fontFamily:'Open Sans'};return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__templates_FiltroControlePagamentos__["a" /* default */],{handleSearchFilter:this.realizaConsulta,handleChangeList:this.tratarFiltroNaLista,list:this.state.listaRegistrosIndexada,listaRegistrosIndexadaAtualizada:this.state.listaRegistrosIndexadaAtualizada,destinatarios:this.props.destinatarios,competencia:this.state.competencia,tipoControle:this.props.match.params.tipoControle,papelUsuarioLogado:this.state.papelUsuarioLogado,visaoRota:this.props.match.params.visaoRota,handleSearchPorRota:this.realizaConsultaPorRota,history:this.props.history}),this.state.listaRegistrosIndexada&&this.state.listaRegistrosIndexada.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__templates_RelatorioControlePagamentos__["a" /* default */],{filtrosConsulta:this.state.filtrosConsulta,tipoControle:this.props.match.params.tipoControle,papelUsuarioLogado:this.state.papelUsuarioLogado,tituloTabela:this.state.titulo}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["u" /* Table */],{legend:this.montaLegendaTitulo(this.props.match.params.tipoControle),bordered:true,fetchInfo:fetchInfo,data:this.defineListaParaTabela(),options:options,listaTableHeader:consultaPagamentoTableHeader,pagination:true,remote:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:this.renderModalCalculadora(),conteudofooter:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),size:'lg',showModal:this.state.showCalculadoraModal,title:'Calculadora',onHide:function onHide(){_this2.handleCloseModal('showCalculadoraModal');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssConfirmacaoRejeicaoRGPS},'Confirma a rejei\xE7\xE3o do pagamento?'),conteudofooter:this.renderFooterModalConfirmarRejeicaoRGPS(),size:'md',showModal:this.state.showRejeicaoRGPSModal,title:'Rejeitar Pagamento',onHide:function onHide(){_this2.handleCloseModal('showRejeicaoRGPSModal');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:jssConfirmacaoRejeicaoRGPS},'Existe uma an\xE1lise de defesa em andamento. Caso voc\xEA gere uma nova GRU, essa an\xE1lise ser\xE1 interrompida. Prosseguir com a gera\xE7\xE3o da GRU?'),conteudofooter:this.renderFooterModalConfirmarGerarGRU(),size:'md',showModal:this.state.showConfirmacaoGerarGRUModal,title:'Confirmar gera\xE7\xE3o de GRU',onHide:function onHide(){_this2.handleCloseModal('showConfirmacaoGerarGRUModal');}})));}}]);return ControlePagamentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ControlePagamentos.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ano:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,participanteUm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,participanteDois:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoControle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,visaoRota:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,action:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),complementoTitulo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,configuracoesFrontend:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)};ControlePagamentos.defaultProps={match:null,destinatarios:[],complementoTitulo:'',configuracoesFrontend:null};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios,complementoTitulo:state.base.complementoTitulo,configuracoesFrontend:state.base.configuracoesFrontend};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ControlePagamentos));

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__relatorios_SelecaoEntidade__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var participanteRGPS='01000';// const participanteINSSUniao = '98222';
// const participanteDECIPEX = '98026';
var rowStyle={width:'2px',paddingRigth:'10px'};var spanStyle={margin:'0px',position:'relative',color:'#44707B',top:'25px',padding:'5px'};var FiltroControlePagamentos=function(_Component){_inherits(FiltroControlePagamentos,_Component);function FiltroControlePagamentos(){_classCallCheck(this,FiltroControlePagamentos);var _this=_possibleConstructorReturn(this,(FiltroControlePagamentos.__proto__||Object.getPrototypeOf(FiltroControlePagamentos)).call(this));_this.preparaNovaConsulta=function(){var filtroControlePagamento={competencia:null,visaoControlePagamento:null,estadoPagamento:null,'destinatario-rpps':null,tipoEntidade:null,uf:null};if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["b" /* ehPapelObservadorPagamento */])(_this.props.papelUsuarioLogado)||_this.state.tipoRegimeObservador){filtroControlePagamento=Object.assign({},filtroControlePagamento,{tipoRegimeObservador:null,participanteObservador:null,tipoEntidadeObservador:null,uFObservador:null});_this.setState({tipoRegimeObservador:null,participanteObservador:null,tipoEntidadeObservador:null,uFObservador:null});}if(_this.state.exibirCampoNome===true){_this.setState({exibirCampoNome:false});}filtroControlePagamento=JSON.stringify(filtroControlePagamento);sessionStorage.setItem('filtroControlePagamento',filtroControlePagamento);_this.setState({competencia:null,visaoControlePagamento:null,estadoPagamento:null,'destinatario-rpps':null,tipoEntidade:null,uf:null,desconsiderarFluxosExtraordinarios:false});};_this.handleChange=function(changeObj,name){if(name==='visaoControlePagamento'){if(_this.props.tipoControle==='pendencias'){_this.setState({complementoTitulo:_this.montaComplementoTitulo(changeObj.value),estadoPagamento:null});}else{_this.setState({complementoTitulo:_this.montaComplementoTitulo(changeObj.value)});}}if(name==='tipoRegimeObservador'){if(changeObj.value===1){_this.setState({participanteObservador:participanteRGPS,tipoEntidadeObservador:null,uFObservador:null});}else{_this.setState({participanteObservador:null,tipoEntidadeObservador:null,uFObservador:null});if(_this.props.tipoControle==='controle-debitos-pendentes'){_this.setState({tipoEntidade:null,uf:null,'destinatario-rpps':null,exibirCampoNome:false});}}if(_this.props.tipoControle!=='controle-debitos-pendentes'){_this.alterarPreenchimentoDoTipoEntidade(changeObj.value,_this.state.tipoEntidade);_this.limparPreenchimentoDaVisao();}}// this.setState({tipoRegimeObservador: changeObj.value}, this.filtrarRegimes);
if(name==='tipoEntidadeObservador'){_this.setState({participanteObservador:null,uFObservador:null});}if(name==='tipoRegime'){if(changeObj.value===1){_this.setState({participante:participanteRGPS});}}_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.alterarPreenchimentoDoTipoEntidade=function(tipoDeRegimeObservador,tipoEntidade){if(_this.props.tipoControle==='controle-pagamentos'){if(tipoDeRegimeObservador===1&&tipoEntidade==='01000'){_this.setState({tipoEntidade:null});}}else if(_this.props.tipoControle==='pendencias'){if(tipoDeRegimeObservador===1&&(tipoEntidade===1||tipoEntidade==='01000')){_this.setState({tipoEntidade:null,'destinatario-rpps':null,exibirCampoNome:false});}}if(tipoDeRegimeObservador===''){_this.setState({tipoEntidade:null,uf:null,'destinatario-rpps':null,exibirCampoNome:false});}};_this.limparPreenchimentoDaVisao=function(){if(_this.props.tipoControle==='pendencias'){_this.setState({visaoControlePagamento:null});}};_this.handleKeyDown=function(e){var retorno=null;if(e.keyCode===13){retorno=_this.handleSearchButton();}return retorno;};_this.trataFormulario=function(campoAlterado){if(campoAlterado==='tipoEntidade'){_this.trataTipoEntidade();}if(campoAlterado==='uf'){_this.trataUf();}if(campoAlterado==='visaoControlePagamento'){var complementoTitulo={complementoTitulo:_this.state.complementoTitulo};complementoTitulo=JSON.stringify(complementoTitulo);Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["B" /* requestSalvaComplementoTitulo */])(complementoTitulo);}};_this.trataUf=function(){_this.setState({'destinatario-rpps':null,exibirCampoNome:true});};_this.trataTipoEntidade=function(){var paramTipoEntidade=_this.state.tipoEntidade;_this.setState({'destinatario-rpps':null,uf:null,exibirCampoNome:paramTipoEntidade===1||paramTipoEntidade===3});};_this.handleSearchButtonRota=function(visaoRota){var filtroControlePagamento={};var _this$props=Object.assign({},_this.props),tipoControle=_this$props.tipoControle;filtroControlePagamento={visaoControlePagamento:visaoRota};_this.setState({cliqueiNoBotao:1},function(){_this.handleChange({value:visaoRota,isValid:true},'visaoControlePagamento');});filtroControlePagamento=JSON.stringify(filtroControlePagamento);sessionStorage.setItem('filtroControlePagamento',filtroControlePagamento);sessionStorage.setItem('tipoControle',tipoControle);_this.handleSearch();};_this.handleSearchButton=function(){var filtroControlePagamento={};var _this$props2=Object.assign({},_this.props),tipoControle=_this$props2.tipoControle;if(_this.state.tipoEntidade===participanteRGPS){filtroControlePagamento={competencia:_this.state.competencia,visaoControlePagamento:_this.state.visaoControlePagamento,estadoPagamento:_this.state.estadoPagamento,'destinatario-rpps':participanteRGPS,tipoEntidade:participanteRGPS,desconsiderarFluxosExtraordinarios:_this.state.desconsiderarFluxosExtraordinarios};}else{filtroControlePagamento={competencia:_this.state.competencia,visaoControlePagamento:_this.state.visaoControlePagamento,estadoPagamento:_this.state.estadoPagamento,'destinatario-rpps':_this.state['destinatario-rpps'],tipoEntidade:_this.state.tipoEntidade,uf:_this.state.uf,desconsiderarFluxosExtraordinarios:_this.state.desconsiderarFluxosExtraordinarios};}if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["b" /* ehPapelObservadorPagamento */])(_this.props.papelUsuarioLogado)||_this.state.tipoRegimeObservador){filtroControlePagamento=Object.assign({},filtroControlePagamento,{tipoRegimeObservador:_this.state.tipoRegimeObservador,participanteObservador:_this.state.participanteObservador,tipoEntidadeObservador:_this.state.tipoEntidadeObservador,uFObservador:_this.state.uFObservador,desconsiderarFluxosExtraordinarios:_this.state.desconsiderarFluxosExtraordinarios});}_this.setState({cliqueiNoBotao:1},function(){_this.handleChange({value:1,isValid:true},'cliqueiNoBotao');});if(filtroControlePagamento.tipoEntidade&&_this.state.exibirCampoNome===false&&filtroControlePagamento.tipoEntidade===2&&filtroControlePagamento.uf){_this.setState({exibirCampoNome:true});}else if((filtroControlePagamento.tipoEntidade===1||filtroControlePagamento.tipoEntidade===3)&&_this.state.exibirCampoNome===false){_this.setState({exibirCampoNome:true});}filtroControlePagamento=JSON.stringify(filtroControlePagamento);sessionStorage.setItem('filtroControlePagamento',filtroControlePagamento);sessionStorage.setItem('tipoControle',tipoControle);_this.handleSearch();};_this.verificacaoTipoEntidade=function(){if(_this.state.tipoEntidade){if(_this.state.tipoEntidade===2&&!_this.state.uf&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha uma UF']);return;}if(_this.state.tipoEntidade!==participanteRGPS){if(_this.state.tipoEntidade&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha um filtro de destinatário para a consulta']);return;}if(_this.state.tipoEntidade&&_this.state.uf&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Escolha um filtro de destinatário para a consulta']);return;}}_this.props.handleSearchFilter(_this.state);}else{_this.props.handleSearchFilter(_this.state);}};_this.handleSearch=function(){if(_this.props.visaoRota!=null&&_this.state.visaoControlePagamento==null){_this.props.handleSearchPorRota(Number(_this.props.visaoRota));}else if(_this.props.visaoRota!==null&&_this.state.visaoControlePagamento!=null||_this.props.visaoRota===undefined&&_this.state.visaoControlePagamento===null){if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["b" /* ehPapelObservadorPagamento */])(_this.props.papelUsuarioLogado)&&!_this.state.tipoRegimeObservador){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Selecione o participante Observador.']);}else if(_this.state.tipoRegimeObservador&&(!_this.state.tipoEntidadeObservador&&!_this.state.participanteObservador||_this.state.tipoEntidadeObservador===2&&!_this.state.uFObservador||!_this.state.participanteObservador)){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Selecione uma opção de Visualização.']);}else{switch(_this.props.tipoControle){case'controle-pagamentos':if(_this.state.visaoControlePagamento&&_this.state.competencia){_this.verificacaoTipoEntidade();}else{Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['É necessario informar uma competência e a visão.']);}break;case'pendencias':if(_this.state.visaoControlePagamento){_this.verificacaoTipoEntidade();}else{Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['É necessario informar uma visão.']);}break;default:_this.verificacaoTipoEntidade();}}}};_this.listaFiltradaDestinatarios=function(){var listaOrgaosFederais=[];var listaParticipantes=_this.props.destinatarios.filter(function(item){// if (item.inOrgaoCentralizador === 1) {
//   listaOrgaosFederais.push(item);
// } else if (!(item.inOrgaoExtinto) &&
//   ((item.tipoRegimeProprio === this.state.tipoEntidade && ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)))) {
//   return item;
// }
// return null;
if(item.inOrgaoUniao&&(!item.inOrgaoExtinto&&item.inOrgaoCentralizador===1||!item.inOrgaoExtinto&&item.inOrgaoCentralizador===0)){listaOrgaosFederais.push(item);}else if(!item.inOrgaoExtinto&&item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)){return item;}return null;});if(listaOrgaosFederais.length>0&&_this.state.tipoEntidade===1){listaParticipantes=listaOrgaosFederais;}return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.montaComplementoTitulo=function(visao){var complemento='';if(visao&&visao!==''&&visao!==undefined){if(visao===1){complemento='Valores a receber';}else{complemento='Valores a pagar';}}return complemento;};_this.verificaTamanhoInputEstado=function(){var retorno='4 4 4 4';if(_this.state.estadoPagamento===9){retorno='6 6 6 6';}return retorno;};_this.itemListDoTipoEntidade=function(tipoControle,papelUsuarioLogado,tipoRegimeObservador){var listaTipoEntidade=void 0;switch(tipoControle){case'controle-pagamentos':if(papelUsuarioLogado==='analista-rgps'||tipoRegimeObservador===1){listaTipoEntidade=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["G" /* tipoEntidadeControlePagamentoRGPS */];}else{listaTipoEntidade=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["F" /* tipoEntidadeControlePagamento */];}break;case'controle-debitos-pendentes':listaTipoEntidade=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["H" /* tipoEntidadeDebitosPendentes */];break;case'pendencias':if(papelUsuarioLogado==='analista-rgps'||tipoRegimeObservador===1){listaTipoEntidade=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["H" /* tipoEntidadeDebitosPendentes */];}else{listaTipoEntidade=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["F" /* tipoEntidadeControlePagamento */];}break;default:listaTipoEntidade=[];break;}return listaTipoEntidade;};_this.itemListDoEstadoPagamento=function(tipoControle,papelUsuarioLogado,visao){var listaEstadoPagamento=void 0;switch(tipoControle){case'controle-pagamentos':listaEstadoPagamento=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["g" /* estadosPagamento */];break;case'controle-debitos-pendentes':listaEstadoPagamento=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["f" /* estadosDebitosPendentes */];break;case'pendencias':listaEstadoPagamento=_this.verificaPapelLogadoEvisaoDePendencias(papelUsuarioLogado,visao);break;default:listaEstadoPagamento=[];break;}return listaEstadoPagamento;};_this.verificaPapelLogadoEvisaoDePendencias=function(papelUsuarioLogado,visao){var listaEstadoPendencias=void 0;if(papelUsuarioLogado==='analista-rgps'||_this.state.tipoRegimeObservador===1){listaEstadoPendencias=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["h" /* estadosPendenciasRGPS */];}else if(visao&&(papelUsuarioLogado==='analista-rpps'||_this.state.tipoRegimeObservador===2)){if(visao===1){listaEstadoPendencias=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["j" /* estadosPendenciasRPPSaReceber */];}else{listaEstadoPendencias=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["i" /* estadosPendenciasRPPSaPagar */];}}else{listaEstadoPendencias=[];}return listaEstadoPendencias;};_this.itemListVisao=function(tipoControle,papelUsuarioLogado,tipoRegimeObservador){var listaVisao=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["X" /* visoesControlePagamento */];if(tipoControle==='pendencias'){if(papelUsuarioLogado==='analista-rgps'||Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["b" /* ehPapelObservadorPagamento */])(papelUsuarioLogado)&&tipoRegimeObservador===1){listaVisao=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["Y" /* visoesPendenciasRGPS */];}}return listaVisao;};_this.filtroControlePagamento=JSON.parse(sessionStorage.getItem('filtroControlePagamento'));_this.state={visaoControlePagamento:_this.filtroControlePagamento&&_this.filtroControlePagamento.visaoControlePagamento?_this.filtroControlePagamento.visaoControlePagamento:null,estadoPagamento:_this.filtroControlePagamento&&_this.filtroControlePagamento.estadoPagamento?_this.filtroControlePagamento.estadoPagamento:null,participanteLogado:_this.participanteLogado&&_this.filtroControlePagamento.participanteLogado?_this.filtroControlePagamento.participanteLogado:null,'destinatario-rpps':_this.filtroControlePagamento&&_this.filtroControlePagamento['destinatario-rpps']?_this.filtroControlePagamento['destinatario-rpps']:null,cliqueiNoBotao:_this.filtroControlePagamento&&_this.filtroControlePagamento.cliqueiNoBotao?_this.filtroControlePagamento.cliqueiNoBotao:null,tipoEntidade:_this.filtroControlePagamento&&_this.filtroControlePagamento.tipoEntidade?_this.filtroControlePagamento.tipoEntidade:null,uf:_this.filtroControlePagamento&&_this.filtroControlePagamento.uf?_this.filtroControlePagamento.uf:null,competencia:_this.filtroControlePagamento&&_this.filtroControlePagamento.competencia?_this.filtroControlePagamento.competencia:null,exibirCampoNome:_this.filtroControlePagamento&&_this.filtroControlePagamento.exibirCampoNome?_this.filtroControlePagamento.exibirCampoNome:false,complementoTitulo:_this.filtroControlePagamento&&_this.filtroControlePagamento.complementoTitulo?_this.filtroControlePagamento.complementoTitulo:'',tipoRegimeObservador:_this.filtroControlePagamento&&_this.filtroControlePagamento.tipoRegimeObservador?_this.filtroControlePagamento.tipoRegimeObservador:null,tipoEntidadeObservador:_this.filtroControlePagamento&&_this.filtroControlePagamento.tipoEntidadeObservador?_this.filtroControlePagamento.tipoEntidadeObservador:null,uFObservador:_this.filtroControlePagamento&&_this.filtroControlePagamento.uFObservador?_this.filtroControlePagamento.uFObservador:null,participanteObservador:_this.filtroControlePagamento&&_this.filtroControlePagamento.participanteObservador?_this.filtroControlePagamento.participanteObservador:null,desconsiderarFluxosExtraordinarios:_this.filtroControlePagamento&&_this.filtroControlePagamento.desconsiderarFluxosExtraordinarios?_this.filtroControlePagamento.desconsiderarFluxosExtraordinarios:null};return _this;}_createClass(FiltroControlePagamentos,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.visaoRota){this.handleSearchButtonRota(Number(this.props.visaoRota));}else{if(sessionStorage.getItem('tipoControle')){if(sessionStorage.getItem('tipoControle')!==this.props.tipoControle||this.props.history.action!=='POP'){this.preparaNovaConsulta();}}if(sessionStorage.getItem('filtroControlePagamento')){var itemSession=JSON.parse(sessionStorage.getItem('filtroControlePagamento'));if(itemSession.competencia!==null&&itemSession.visaoControlePagamento!==null||sessionStorage.getItem('tipoControle')===this.props.tipoControle&&this.props.history.action==='POP'){this.handleSearchButton();}}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["p" /* requestApagaComplementoTitulo */])();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.tipoConsulta!==prevProps.tipoConsulta){this.preparaNovaConsulta();}if(this.props.tipoControle!==prevProps.tipoControle){this.preparaNovaConsulta();}}/**
   * Encaminha para as funcoes que tratam alteracoes em cada campo
   */},{key:'montaFiltros',value:function montaFiltros(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["b" /* ehPapelObservadorPagamento */])(this.props.papelUsuarioLogado)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__relatorios_SelecaoEntidade__["a" /* default */],{handleChange:this.handleChange,destinatarios:this.props.destinatarios,papelUsuarioLogado:this.props.papelUsuarioLogado,titulo:'Visualizar como',retirarLinhaSeparadora:false,tipoRegime:this.state.tipoRegimeObservador,tipoEntidade:this.state.tipoEntidadeObservador,uf:this.state.uFObservador,participante:this.state.participanteObservador,nomeAtributoComboboxRegime:'tipoRegimeObservador',nomeAtributoComboboxParticipante:'participanteObservador',nomeAtributoComboboxTipoEntidade:'tipoEntidadeObservador',nomeAtributoComboboxUF:'uFObservador',listaTiposRegimes:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["L" /* tipoRegime */],labelComboboxParticipante:'Participante Observador'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{style:{border:'1px solid #DCDCDC'}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.tipoControle==='controle-pagamentos'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].competencia,label:'Compet\xEAncia',onChange:function onChange(e){return _this2.handleChange(e,'competencia');},onKeyDown:function onKeyDown(e){return _this2.handleKeyDown(e,'competencia');},value:this.state.competencia,required:true})),(this.props.tipoControle==='controle-pagamentos'||this.props.tipoControle==='pendencias')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Vis\xE3o',onChange:function onChange(e){return _this2.handleChange(e,'visaoControlePagamento');},value:this.state.visaoControlePagamento,itemList:this.itemListVisao(this.props.tipoControle,this.props.papelUsuarioLogado,this.state.tipoRegimeObservador),placeholder:'Selecione a vis\xE3o',number:true,custom:true,required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:this.props.tipoControle==='controle-pagamentos'?'4 4 4 4':this.verificaTamanhoInputEstado()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Estado do pagamento',onChange:function onChange(e){return _this2.handleChange(e,'estadoPagamento');},value:this.state.estadoPagamento,itemList:this.itemListDoEstadoPagamento(this.props.tipoControle,this.props.papelUsuarioLogado,this.state.visaoControlePagamento),placeholder:'Selecione o estado do pagamento',number:true,custom:true})))),(this.props.tipoControle!=='controle-debitos-pendentes'||this.props.tipoControle==='controle-debitos-pendentes'&&this.props.papelUsuarioLogado==='analista-rgps'||Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["b" /* ehPapelObservadorPagamento */])(this.props.papelUsuarioLogado)&&this.state.tipoRegimeObservador!==2)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Tipo',onChange:function onChange(e){return _this2.handleChange(e,'tipoEntidade');},placeholder:'Selecione a entidade',value:this.state.tipoEntidade,itemList:this.itemListDoTipoEntidade(this.props.tipoControle,this.props.papelUsuarioLogado,this.state.tipoRegimeObservador),custom:true,number:true})),this.state.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'UF',onChange:function onChange(e){return _this2.handleChange(e,'uf');},placeholder:'Selecione a UF',value:this.state.uf,itemList:this.carregaUfDosMunicipios(),custom:true})):'',this.state.exibirCampoNome?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Nome',name:'destinatario-rpps',onChange:function onChange(e){return _this2.handleChange(e,'destinatario-rpps');},placeholder:'Selecione o destinat\xE1rio',value:this.state['destinatario-rpps'],itemList:this.listaFiltradaDestinatarios(),custom:true})):''),(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["b" /* ehPapelObservadorPagamento */])(this.props.papelUsuarioLogado)&&this.props.tipoControle==='pendencias'||this.props.tipoControle==='pendencias')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'1 1 1 1',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{id:'desconsiderarFluxosExtraordinarios',onChange:function onChange(e){return _this2.handleChange(e,'desconsiderarFluxosExtraordinarios');},check:true,value:this.state.desconsiderarFluxosExtraordinarios}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:spanStyle},'Desconsiderar fluxos extraordin\xE1rios.')));}},{key:'render',value:function render(){var _this3=this;var filtrosPesquisa=this.montaFiltros();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["y" /* DtpPanel */],{icon:'ico-filter',title:'Filtro de Pesquisa'},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this3.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'})));}}]);return FiltroControlePagamentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroControlePagamentos.propTypes={destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf().isRequired,handleChangeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,competencia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoControle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,papelUsuarioLogado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,visaoRota:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({action:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroControlePagamentos);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_export_to_csv__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RelatorioControlePagamentos=function(_Component){_inherits(RelatorioControlePagamentos,_Component);function RelatorioControlePagamentos(props){_classCallCheck(this,RelatorioControlePagamentos);var _this=_possibleConstructorReturn(this,(RelatorioControlePagamentos.__proto__||Object.getPrototypeOf(RelatorioControlePagamentos)).call(this,props));_this.tratarSucessoListaExportacao=function(response){if(response.data!==''){_this.setState({},_this.gerarCsv(response.data,_this.props.tipoControle));}};_this.tratarErro=function(){var mensagemPrimaria='Não foi possível consultar os pagamentos.';var mensagemSecundaria='Contate o administrador do sistema.';_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.colunasExportacaoPagador=['CNPJ','Participante','Prazo Resposta','Valor','Estado','Banco','Número','Conta corrente','DV','Agência','DV'];_this.colunasExportacaoRecebedor=['CNPJ','Participante','Prazo Resposta','Valor','Estado'];_this.colunasExportacaoDebitosPendentes=['Competência','Valor','Data de Vencimento','Estado'];_this.colunasExportacaoPendencias=['CNPJ','Participante','Competência','Prazo Resposta','Valor','Data de Vencimento','Estado'];_this.defineHeaderParaExportacao=function(tipoControle){var retorno=[];switch(tipoControle){case'controle-pagamentos':retorno=_this.montaHeaderControlePagamentos();break;case'controle-debitos-pendentes':retorno=_this.montaHeaderDebitosPendentes();break;case'pendencias':retorno=_this.colunasExportacaoPendencias;break;default:retorno=[];}return retorno;};_this.montaHeaderControlePagamentos=function(){var retorno=[];if(_this.props.filtrosConsulta.visaoControlePagamento===2){retorno=_this.colunasExportacaoPagador;}else{retorno=_this.colunasExportacaoRecebedor;}return retorno;};_this.montaHeaderDebitosPendentes=function(){var retorno=[];if(_this.props.papelUsuarioLogado==='analista-rgps'||_this.props.filtrosConsulta.participanteObservador==='01000'){retorno.push('CNPJ','Participante');retorno=retorno.concat(_this.colunasExportacaoDebitosPendentes);}else{retorno=_this.colunasExportacaoDebitosPendentes;}return retorno;};_this.defineListaParaExportacao=function(lista,tipoControle){var listaOriginal=lista;var resultado=[];switch(tipoControle){case'controle-pagamentos':resultado=_this.montaColunasControlePagamentos(resultado,listaOriginal);break;case'controle-debitos-pendentes':resultado=_this.montaColunasDebitosPendentes(resultado,listaOriginal);break;case'pendencias':resultado=_this.montaColunasPendencias(resultado,listaOriginal);break;default:resultado=[];}return resultado;};_this.montaColunasControlePagamentos=function(resultado,listaOriginal){var visao=_this.props.filtrosConsulta?_this.props.filtrosConsulta.visaoControlePagamento:1;if(visao===2){listaOriginal.forEach(function(pagamento){resultado.push({cnpj:pagamento.cnpj?Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["d" /* formatarCnpj */])(pagamento.cnpj):'',participante:pagamento.nomeEntidadeRecebedora?pagamento.nomeEntidadeRecebedora:'',dataPrazo:pagamento.dataPrazo?pagamento.dataPrazo:'',valor:_this.formatarValorLabel(pagamento.valorCompensacao),estado:_this.addTipoEstadoPagamentoCSV(pagamento.estado),nomeBanco:pagamento.nomeBanco?pagamento.nomeBanco:'',numeroBanco:pagamento.codigoBanco?pagamento.codigoBanco:'',numeroContaCorrente:pagamento.numeroContaCorrente?pagamento.numeroContaCorrente:'',dvContaCorrente:pagamento.dvContaCorrente?pagamento.dvContaCorrente:'',numeroAgencia:pagamento.numeroAgencia?pagamento.numeroAgencia:'',dvAgencia:pagamento.dvAgencia?pagamento.dvAgencia:''});});}else{listaOriginal.forEach(function(pagamento){resultado.push({cnpj:pagamento.cnpjPagador?Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["d" /* formatarCnpj */])(pagamento.cnpjPagador):'',participante:pagamento.nomeEntidadePagadora?pagamento.nomeEntidadePagadora:'',dataPrazo:pagamento.dataPrazo?pagamento.dataPrazo:'',valor:_this.formatarValorLabel(pagamento.valorCompensacao),estado:_this.addTipoEstadoPagamentoCSV(pagamento.estado)});});}return resultado;};_this.montaColunasDebitosPendentes=function(resultado,listaOriginal){var colunas={};var resultadoColunas=resultado;listaOriginal.forEach(function(pagamento){if(_this.props.papelUsuarioLogado==='analista-rgps'||_this.props.filtrosConsulta.participanteObservador==='01000'){colunas={cnpj:pagamento.cnpjPagador?Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["d" /* formatarCnpj */])(pagamento.cnpjPagador):'',participante:pagamento.nomeEntidadePagadora?pagamento.nomeEntidadePagadora:''};}var colunasDefault={competencia:_this.formatarCompetencia(pagamento.mes,pagamento.ano),valor:_this.formatarValorLabel(pagamento.valorCompensacao),dataDeVencimento:pagamento.dataVencimento?pagamento.dataVencimento:'',estado:_this.addTipoEstadoPagamentoCSV(pagamento.estado)};colunas=Object.assign({},colunas,colunasDefault);resultadoColunas=resultadoColunas.concat(colunas);});return resultadoColunas;};_this.montaColunasPendencias=function(resultado,listaOriginal){var visao=_this.props.filtrosConsulta?_this.props.filtrosConsulta.visaoControlePagamento:'';var colunas={};var resultadoColunas=resultado;listaOriginal.forEach(function(pagamento){if(visao===1){colunas={cnpj:pagamento.cnpjPagador?Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["d" /* formatarCnpj */])(pagamento.cnpjPagador):''};}else{colunas={cnpj:pagamento.cnpj?Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["d" /* formatarCnpj */])(pagamento.cnpj):''};}var colunasDefault={participante:visao===1?pagamento.nomeEntidadePagadora:pagamento.nomeEntidadeRecebedora,competencia:_this.formatarCompetencia(pagamento.mes,pagamento.ano),dataPrazo:pagamento.dataPrazo?pagamento.dataPrazo:'',valor:_this.formatarValorLabel(pagamento.valorCompensacao),dataDeVencimento:pagamento.dataVencimento?pagamento.dataVencimento:'',estado:_this.addTipoEstadoPagamentoCSV(pagamento.estado)};colunas=Object.assign({},colunas,colunasDefault);resultadoColunas=resultadoColunas.concat(colunas);});return resultadoColunas;};_this.formatarCompetencia=function(mes,ano){var objCompetencia='';if(mes!=='0'&&ano!=='0'){objCompetencia=mes+'/'+ano;if(objCompetencia.length!==7){objCompetencia='0'+objCompetencia;}}return objCompetencia;};_this.formatarValorLabel=function(valorCompensacao){var valorFormatado='';if(valorCompensacao){valorFormatado=valorCompensacao.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3});}return valorFormatado;};_this.addTipoEstadoPagamentoCSV=function(tipo){return __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["g" /* estadosPagamento */],tipo).label;};_this.addVisaoCSV=function(tipo){return __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["X" /* visoesControlePagamento */],tipo).label;};_this.exportar=function(){if(Object.entries(_this.props.filtrosConsulta).length!==0){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('controle-pagamentos/exportacao-csv',_this.tratarSucessoListaExportacao,_this.tratarErro,Object.assign({},_this.props.filtrosConsulta));}};_this.gerarCsv=function(json,tipoControle){var dadosRelatorio=null;var legenda='';var retorno=[];switch(tipoControle){case'controle-pagamentos':legenda='Controle de pagamentos - '+_this.props.filtrosConsulta.competencia+' - '+_this.addVisaoCSV(_this.props.filtrosConsulta.visaoControlePagamento);retorno=json;break;case'controle-debitos-pendentes':legenda='Controle de d\xE9bitos carregados RGPS '+_this.props.tituloTabela;retorno=json.pagamentos;break;case'pendencias':legenda='Pendencias de controle de pagamentos '+_this.props.tituloTabela;retorno=json;break;default:legenda='';}if(retorno&&retorno!==undefined&&retorno.length>0){dadosRelatorio=_this.defineListaParaExportacao(retorno,tipoControle);}else{dadosRelatorio=[];}if(dadosRelatorio&&dadosRelatorio!==undefined&&dadosRelatorio.length>0){var csvExporter=new __WEBPACK_IMPORTED_MODULE_2_export_to_csv__["ExportToCsv"]({// filename: this.props.tipoControle === 'controle-pagamentos' ? 'Controle de Pagamentos' : 'Controle de Débitos Pendentes',
filename:_this.defineNomeArquivoExportacao(_this.props.tipoControle),fieldSeparator:';',showTitle:true,title:legenda,showLabels:true,headers:_this.defineHeaderParaExportacao(tipoControle)});csvExporter.generateCsv(dadosRelatorio);}};_this.defineNomeArquivoExportacao=function(tipoControle){var retorno='';switch(tipoControle){case'controle-pagamentos':retorno='Controle de Pagamentos';break;case'controle-debitos-pendentes':retorno='Controle de Débitos Carregados RGPS';break;case'pendencias':retorno='Pendências de Controle de Pagamento';break;default:retorno='';}return retorno;};_this.state={showNoContent:false,noContentPrimaryMessage:null,noContentSecondaryMessage:null};return _this;}_createClass(RelatorioControlePagamentos,[{key:'render',value:function render(){var _this2=this;if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Exportar para CSV',onClick:function onClick(){_this2.exportar();},icon:'ico-doc-sheet',mini:true})));}}]);return RelatorioControlePagamentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RelatorioControlePagamentos.propTypes={voltarAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,filtrosConsulta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,tipoControle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,papelUsuarioLogado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tituloTabela:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}.isRequired;RelatorioControlePagamentos.defaultProps={voltarAction:function voltarAction(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (RelatorioControlePagamentos);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiltroRelatorio__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Relatorio__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_User__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid *//* eslint-disable react/prop-types */var TelaRelatorioPagamentos=function(_Component){_inherits(TelaRelatorioPagamentos,_Component);function TelaRelatorioPagamentos(props){_classCallCheck(this,TelaRelatorioPagamentos);var _this=_possibleConstructorReturn(this,(TelaRelatorioPagamentos.__proto__||Object.getPrototypeOf(TelaRelatorioPagamentos)).call(this,props));_this.colunasRelatorioPagamento=['Ano','Mês','Participante 1 (*)','Participante 2 (*)','CNPJ do RPPS','Saldo Estoque','Part. Saldo Estoque a Receber','Valor Parcela Estoque','Valor Saldo Fluxo','Part. Saldo Fluxo','Valor Saldo Fluxo Acumulado','Part. Saldo Fluxo Acumulado','Valor Compensação','Part. Valor Compensação','Valor Total Bloqueado Competência Anterior (*)','Valor Total Desbloqueado Competência (*)','Valor a receber','Valor Bloqueado (*)','Valor Total Rejeitado Competência Anterior','Participante Rejeitado Competência Anterior'];_this.colunasRelatorioParticipantes=['Ano','Mês','Solicitante (*)','Destinatário (*)','CNPJ RPPS','Valor Estoque Bruto','Requerimentos de Estoque (*)','Valor Glosa Estoque (*)','Valor Estoque Liquido','Requerimentos Concedidos (*)','Valor Fluxo Acumulado Bruto','Valor 13º Fluxo Acumulado','Valor Glosa Fluxo Acumulado (*)','Valor Fluxo Acumulado Liquido','Requerimentos de Fluxo (*)','Valor Fluxo Bruto','Valor 13º Fluxo','Valor Glosa Fluxo (*)','Valor Fluxo Liquido','Bloqueado S/N','Valor Total Líquido'];_this.colunasRelatorioRequerimentosRGPS=['#','Protocolo','Mês','Ano','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matricula','Tipo Requerimento','Tipo Aposentadoria','Número Benefício','Nome Beneficiário','Valor Estoque','Valor 13º Estoque','Valor Fluxo','Valor 13º Fluxo','Valor Fluxo Acumulado','Valor 13º Fluxo Acumulado','Valor Pro Rata Mensal','Data Início Fluxo Acumulado','Data Fim Fluxo Acumulado','Data Início Estoque','Data Fim Estoque','Valor Total Estoque','Valor Total Fluxo','Valor Total Fluxo Acumulado','Tipo Segregação Destinatário'];_this.colunasRelatorioRequerimentos=['#','Protocolo','Mês','Ano','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matricula','Tipo Requerimento','Tipo Aposentadoria','Número Benefício','Nome Beneficiário','Valor Estoque','Valor 13º Estoque','Valor Fluxo','Valor 13º Fluxo','Valor Fluxo Acumulado','Valor 13º Fluxo Acumulado','Valor Pro Rata Mensal','Data Início Fluxo Acumulado','Data Fim Fluxo Acumulado','Data Início Estoque','Data Fim Estoque','Valor Total Estoque','Valor Total Fluxo','Valor Total Fluxo Acumulado','Tipo Segregação Solicitante','Tipo Segregação Destinatário'];_this.colunasRelatorioRequerimentosRPPU=['#','Protocolo','Mês','Ano','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matricula','Tipo Requerimento','Tipo Aposentadoria','Número Benefício','Nome Beneficiário','Valor Estoque','Valor 13º Estoque','Valor Fluxo','Valor 13º Fluxo','Valor Fluxo Acumulado','Valor 13º Fluxo Acumulado','Valor Pro Rata Mensal','Data Início Fluxo Acumulado','Data Fim Fluxo Acumulado','Data Início Estoque','Data Fim Estoque','Valor Total Estoque','Valor Total Fluxo','Valor Total Fluxo Acumulado','Orgão Origem Solicitante','Orgão Origem Destinatário','Tipo Segregação Solicitante','Tipo Segregação Destinatário'];_this.colunasRelatorioRequerimentosEstoque=['#','Protocolo','Mês','Ano','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matricula','Tipo Requerimento','Tipo Aposentadoria','Número Beneficio','Nome Beneficiário','Valor Estoque','Valor 13º Estoque','Valor Pro Rata Mensal','Data Início Estoque','Data Fim Estoque','Valor Total Estoque','Estado Pagamento Estoque'];_this.colunasRelatorioRequerimentosEstoqueRPPU=['#','Protocolo','Mês','Ano','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matricula','Tipo Requerimento','Tipo Aposentadoria','Número Beneficio','Nome Beneficiário','Valor Estoque','Valor 13º Estoque','Valor Pro Rata Mensal','Data Início Estoque','Data Fim Estoque','Valor Total Estoque','Estado Pagamento Estoque','Orgão Origem Solicitante','Orgão Origem Destinatário'];_this.colunasRelatorioRequerimentosConcedido=['#','Protocolo','Mês','Ano','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matricula','Tipo Requerimento','Tipo Aposentadoria','Número Beneficio','Nome Beneficiário','Valor Estoque','Valor 13º Estoque','Valor Fluxo','Valor 13º Fluxo','Valor Fluxo Acumulado','Valor 13º Fluxo Acumulado','Valor Pro Rata Mensal','Data Início Fluxo Acumulado','Data Fim Fluxo Acumulado','Valor Total Estoque','Valor Total Fluxo','Valor Total Fluxo Acumulado'];_this.colunasRelatorioRequerimentosConcedidoRPPU=['#','Protocolo','Mês','Ano','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matricula','Tipo Requerimento','Tipo Aposentadoria','Número Beneficio','Nome Beneficiário','Valor Estoque','Valor 13º Estoque','Valor Fluxo','Valor 13º Fluxo','Valor Fluxo Acumulado','Valor 13º Fluxo Acumulado','Valor Pro Rata Mensal','Data Início Fluxo Acumulado','Data Fim Fluxo Acumulado','Valor Total Estoque','Valor Total Fluxo','Valor Total Fluxo Acumulado','Orgão Origem Solicitante','Orgão Origem Destinatário'];_this.colunasRelatorioRequerimentosFluxo=['#','Protocolo','Mês','Ano','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matricula','Tipo Requerimento','Tipo Aposentadoria','Número Beneficio','Nome Beneficiário','Valor Fluxo','Valor 13º Fluxo','Valor Pro Rata Mensal','Valor Total Fluxo'];_this.colunasRelatorioRequerimentosFluxoRPPU=['#','Protocolo','Mês','Ano','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matricula','Tipo Requerimento','Tipo Aposentadoria','Número Beneficio','Nome Beneficiário','Valor Fluxo','Valor 13º Fluxo','Valor Pro Rata Mensal','Valor Total Fluxo','Orgão Origem Solicitante','Orgão Origem Destinatário'];_this.colunasRelatorioGlosaFluxo=['Protocolo','Ano','Mês','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matrícula','Tipo Requerimento','Tipo Aposentadoria','Número Benefício','Nome Beneficiário','Glosa Fluxo','Motivo Glosa','Data Início Glosa Fluxo','Data Fim Glosa Fluxo'];_this.colunasRelatorioGlosaPassivo=['Protocolo','Ano','Mês','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matrícula','Tipo Requerimento','Tipo Aposentadoria','Número Benefício','Nome Beneficiário','Glosa Fluxo Acumulado','Motivo Glosa'];_this.colunasRelatorioGlosaEstoque=['Protocolo','Ano','Mês','Solicitante','Destinatário','CNPJ RPPS','NIT','CPF','Matrícula','Tipo Requerimento','Tipo Aposentadoria','Número Benefício','Nome Beneficiário','Valor Glosa Estoque','Motivo Glosa','Glosas de Dação'];_this.colunasRelatorioGlosaDacao=['Solicitante','Destinatário','Ano Pagamento Glosa','Mês Pagamento Glosa','Tipo Glosa','Valor Glosa','Data Inclusão','Motivo Glosa','Observação'];_this.colunasRelatorioBloqueios=['Solicitante','Destinatário','Ano Pagamento','Mês Pagamento','Valor Bloqueado','Motivo','Ind. Pagamento','Competência Pagamento','Valor Reajustado'];_this.traduzirMotivoBloqueio=function(idMotivo){return __WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["q" /* motivosBloqueio */],idMotivo).label;};_this.handlePesquisar=function(valoresFiltro){var d1=valoresFiltro.competenciaInicial;var d2=valoresFiltro.competenciaFinal;if(d1.length!==6||d2.length!==6){_this.addMessage('Competências devem ser no formato MM-AAAA');return;}var d1Ano=parseInt(d1.substring(2,6),10);var d2Ano=parseInt(d2.substring(2,6),10);var d1Mes=parseInt(d1.substring(0,2),10);var d2Mes=parseInt(d2.substring(0,2),10);if(d1Mes>12){_this.addMessage('Competência inicial inválida.');return;}if(d2Mes>12){_this.addMessage('Competência final inválida.');return;}if(d2Ano<d1Ano||d2Ano===d1Ano&&d2Mes<d1Mes){_this.addMessage('Competência final deve ser maior ou igual a competência inicial');return;}var months=(d2Ano-d1Ano)*12;months-=d1Mes;months+=d2Mes;if(months>12||months<0){_this.addMessage('Competência final deve ser no máximo 12 meses maior que a competência inicial');return;}/* if (!valoresFiltro['destinatario-rpps']) {
      this.addMessage('Escolha um destinatário para a pesquisa.');
      return;
    } */_this.setState({filtrosAtuais:valoresFiltro},function(){return _this.executaConsulta(null,'ajuste-contas');});};_this.isRgps=function(){return _this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp']);};_this.isAuditor=function(){return _this.props.auth.checkPermission(['auditar-comprev']);};_this.isAnalistaDtp=function(){return _this.props.auth.checkPermission(['analisar-negocio-dtpv']);};_this.isAnalistaRgpsConsulta=function(){return _this.props.auth.checkPermission(['consultar-compensacao-rgps']);};_this.isAnalistaSprev=function(){return _this.props.auth.checkPermission(['analisar-negocio-sprev']);};_this.isPapelHabilitadoParaUso=function(){return _this.isRgps()||_this.isAuditor()||_this.isAnalistaDtp()||_this.isAnalistaRgpsConsulta()||_this.isAnalistaSprev();};_this.defineModalidadeRequerimento=function(tipo){if(tipo==='estoque'){return 1;}else if(tipo==='concedidos'){return 2;}else if(tipo==='fluxo'){return 3;}return null;};_this.defineModalidadeGlosa=function(tipo){if(tipo==='fluxo'||tipo==='dacao'){return 1;}else if(tipo==='estoque'){return 2;}else if(tipo==='passivo'){return 3;}return null;};_this.defineCompetenciaFiltro=function(row){var mes=row.mesCompetencia?row.mesCompetencia:row.mesCompetenciaPagamento;var ano=row.anoCompetencia?row.anoCompetencia:row.anoCompetenciaPagamento;mes=mes.toString().length===1?'0'+mes:mes;return ano.toString()+mes.toString();};_this.defineNivelFiltro=function(relatorio){// if (!this.isRgps()) {
if(!_this.isPapelHabilitadoParaUso()){return 4;}else if(relatorio==='ajuste-contas'){if(_this.state.filtrosAtuais['destinatario-rpps']){return 4;}else if(_this.state.filtrosAtuais.ente){return 4;}else if(_this.state.filtrosAtuais.aps){return 3;}else if(_this.state.filtrosAtuais.gex){return 2;}else if(_this.state.filtrosAtuais.superintendencia){return 1;}}else{return 4;}return 0;};_this.handleSuccessBuscaPeloCnpjLogado=function(response){if(response.data){_this.setState({isUsuarioLogadoOrgaoCentralizador:response.data.inOrgaoCentralizador});}};_this.handleErrorBuscaPeloCnpjLogado=function(){return'';};_this.buscarParticipantePeloCnpjLogado=function(){var usuarioLogado=new __WEBPACK_IMPORTED_MODULE_10__domain_User__["a" /* default */](localStorage.getItem('jwt'));var cnpj=usuarioLogado.cnpjDoPapel();if(cnpj){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('participantes-compensacao/centralizador/'+cnpj,_this.handleSuccessBuscaPeloCnpjLogado,_this.handleErrorBuscaPeloCnpjLogado);}};_this.recuperarCodigoParticipanteExibicao=function(nomeParticipante){var retorno='';if(nomeParticipante!==null&&nomeParticipante!==''){retorno=nomeParticipante.substring(nomeParticipante.lastIndexOf('-')+1,nomeParticipante.length);}return retorno;};_this.defineCodigoOutroParticipante=function(parametros,relatorio,row){var novosParametros=parametros;// if (!this.isRgps()) {
if(!_this.isPapelHabilitadoParaUso()){novosParametros.outroParticipante='01000';}else if(relatorio==='ajuste-contas'){if(_this.state.filtrosAtuais['destinatario-rpps']){novosParametros.outroParticipante=_this.state.filtrosAtuais['destinatario-rpps'];}else if(_this.state.filtrosAtuais.ente){novosParametros.outroParticipante=_this.state.filtrosAtuais.ente;}else if(_this.state.filtrosAtuais.aps){novosParametros.codigo=_this.state.filtrosAtuais.aps;}else if(_this.state.filtrosAtuais.gex){novosParametros.codigo=_this.state.filtrosAtuais.gex;}else if(_this.state.filtrosAtuais.superintendencia){novosParametros.codigo=_this.state.filtrosAtuais.superintendencia;}}else if(relatorio==='participantes'||relatorio==='bloqueios'){// const participante1 = row.participante1 === 'RGPS' ? '01000' : row.participante1.split('-')[1];
// novosParametros.outroParticipante = participante1 === '01000' ? row.participante2.split('-')[1] : participante1;
var participante1=row.participante1==='RGPS'?'01000':_this.recuperarCodigoParticipanteExibicao(row.participante1);novosParametros.outroParticipante=participante1==='01000'?_this.recuperarCodigoParticipanteExibicao(row.participante2):participante1;}else{// const solicitante = row.solicitante === 'RGPS' ? '01000' : row.solicitante.split('-')[1];
// novosParametros.outroParticipante = solicitante === '01000' ? row.destinatario.split('-')[1] : solicitante;
var solicitante=row.solicitante==='RGPS'?'01000':_this.recuperarCodigoParticipanteExibicao(row.solicitante);novosParametros.outroParticipante=solicitante==='01000'?_this.recuperarCodigoParticipanteExibicao(row.destinatario):solicitante;}// if ((relatorio === 'participantes') && !this.isRgps() && row.participante1 !== 'RGPS' && row.participante2 !== 'RGPS') {
if(relatorio==='participantes'&&!_this.isPapelHabilitadoParaUso()&&row.participante1!=='RGPS'&&row.participante2!=='RGPS'){// const solicitante = row.participante1.split('-')[1];
// const destinat = row.participante2.split('-')[1];
// novosParametros.codigo = row.participante1.substring((row.participante1.lastIndexOf('-') + 1), row.participante1.length);
// novosParametros.outroParticipante = row.participante2.substring((row.participante2.lastIndexOf('-') + 1), row.participante2.length);
novosParametros.codigo=_this.recuperarCodigoParticipanteExibicao(row.participante1);novosParametros.outroParticipante=_this.recuperarCodigoParticipanteExibicao(row.participante2);}// if ((relatorio === 'requerimentos' || relatorio === 'glosa') && !this.isRgps() && row.solicitante !== 'RGPS' && row.destinatario !== 'RGPS') {
if((relatorio==='requerimentos'||relatorio==='glosa')&&!_this.isPapelHabilitadoParaUso()&&row.solicitante!=='RGPS'&&row.destinatario!=='RGPS'){/* const solicitante = row.solicitante.split('-')[1];
      const dest = row.destinatario.split('-')[1];
      novosParametros.codigo = solicitante.substring(solicitante.length - 5, solicitante.length);
      novosParametros.outroParticipante = dest.substring(dest.length - 5, dest.length); */novosParametros.codigo=_this.recuperarCodigoParticipanteExibicao(row.solicitante);novosParametros.outroParticipante=_this.recuperarCodigoParticipanteExibicao(row.destinatario);}if(relatorio==='bloqueios'){if(row.participante1==='RGPS'){novosParametros.codigo='01000';// const dest = row.participante2.split('-')[1];
// novosParametros.outroParticipante = dest.substring(dest.length - 5, dest.length);
novosParametros.outroParticipante=_this.recuperarCodigoParticipanteExibicao(row.participante2);}else{// const solicitante = row.participante1.split('-')[1];
// const dest = row.participante2.split('-')[1];
// novosParametros.codigo = solicitante.substring(solicitante.length - 5, solicitante.length);
// novosParametros.outroParticipante = dest.substring(dest.length - 5, dest.length);
novosParametros.codigo=_this.recuperarCodigoParticipanteExibicao(row.participante1);novosParametros.outroParticipante=_this.recuperarCodigoParticipanteExibicao(row.participante2);}}return novosParametros;};_this.defineTipoBloqueio=function(relatorio){if(relatorio==='bloqueios'){return 1;}else if(relatorio==='desbloqueios'){return 2;}else if(relatorio==='bloqueios-anterior'){return 3;}return null;};_this.defineModalidadeRelacao=function(row){// if (this.isRgps()) {
if(_this.isPapelHabilitadoParaUso()){return row.solicitante==='RGPS'?'solicitante':'destinatario';}return row.destinatario==='RGPS'?'solicitante':'destinatario';};_this.executaConsulta=function(row,relatorio,filho){var urlRelatorio=null;var paginado=false;var parametros={competenciaInicial:row?_this.defineCompetenciaFiltro(row):_this.state.filtrosAtuais.competenciaInicial.substring(2,6)+_this.state.filtrosAtuais.competenciaInicial.substring(0,2),competenciaFinal:row?_this.defineCompetenciaFiltro(row):_this.state.filtrosAtuais.competenciaFinal.substring(2,6)+_this.state.filtrosAtuais.competenciaFinal.substring(0,2),nivel:_this.defineNivelFiltro(relatorio)};parametros=_this.defineCodigoOutroParticipante(parametros,relatorio,row);if(relatorio==='ajuste-contas'){urlRelatorio='filtro-ajuste-contas';}else if(relatorio==='participantes'){urlRelatorio='filtro-calculo-participante-pagamento';}else if(relatorio==='requerimentos'){var isUsuarioLogadoRGPS=__WEBPACK_IMPORTED_MODULE_10__domain_User__["a" /* default */].logged().isRGPS();paginado=true;parametros.modalidadeRelacao=_this.defineModalidadeRelacao(row);var _this$state=Object.assign({},_this.state),isUsuarioLogadoOrgaoCentralizador=_this$state.isUsuarioLogadoOrgaoCentralizador;parametros.usuarioOrgaoCentralizador=isUsuarioLogadoOrgaoCentralizador;parametros.usuarioLogadoRGPS=isUsuarioLogadoRGPS?1:0;urlRelatorio='filtro-calculo-requerimento-pagamento';if(filho){parametros.modalidadeTotalizador=_this.defineModalidadeRequerimento(filho);parametros.usuarioLogadoOrgaoCentralizador=_this.state.isUsuarioLogadoOrgaoCentralizador;urlRelatorio+='-totalizador';}}else if(relatorio==='glosa'){if(filho==='dacao'){// if (!this.isRgps() && row.solicitante !== 'RGPS' && row.destinatario !== 'RGPS') {
if(!_this.isPapelHabilitadoParaUso()&&row.solicitante!=='RGPS'&&row.destinatario!=='RGPS'){// const solicitante = // row.solicitante.split('-')[1];
// const dest = // row.destinatario.split('-')[1];
parametros.codigo=_this.recuperarCodigoParticipanteExibicao(row.solicitante);// solicitante.substring(solicitante.length - 5, solicitante.length);
parametros.outroParticipante=_this.recuperarCodigoParticipanteExibicao(row.destinatario);// dest.substring(dest.length - 5, dest.length);
parametros={codigo:parametros.codigo,competencia:parametros.competenciaInicial,outroParticipante:parametros.outroParticipante,modalidadeRelacao:_this.defineModalidadeRelacao(row),modalidadeGlosa:_this.defineModalidadeGlosa(filho)};}else{parametros={competencia:parametros.competenciaInicial,outroParticipante:parametros.outroParticipante,modalidadeRelacao:_this.defineModalidadeRelacao(row),modalidadeGlosa:_this.defineModalidadeGlosa(filho)};}urlRelatorio='filtro-glosas';}else{parametros.modalidadeRelacao=_this.defineModalidadeRelacao(row);parametros.modalidadeGlosa=_this.defineModalidadeGlosa(filho);urlRelatorio='filtro-glosa-requerimento-competencia';}}else if(relatorio==='bloqueios'){parametros={codigo:parametros.codigo,outroParticipante:parametros.outroParticipante,situacaoPagamento:filho==='desbloqueios'?1:0,tipoConsulta:_this.defineTipoBloqueio(filho),competPagBloqueados:_this.defineCompetenciaFiltro(row)};urlRelatorio='filtro-lista-valores-bloqueados';}_this.setState({dataHistory:[].concat(_toConsumableArray(_this.state.dataHistory),[_this.state.listaResultados]),nomeRelatorioHistory:[].concat(_toConsumableArray(_this.state.nomeRelatorioHistory),[_this.state.nomeRelatorio]),colunasHistory:[].concat(_toConsumableArray(_this.state.colunasHistory),[_this.state.colunasRelatorio]),dataFormatHistory:[].concat(_toConsumableArray(_this.state.dataFormatHistory),[_this.state.dataFormatOptions])},function(){return _this.preparaRequest(urlRelatorio,relatorio,filho,parametros,paginado);});};_this.preparaRequest=function(urlRelatorio,relatorio,filho,parametros,paginado){if(paginado){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["i" /* doGetPaginado */])('relatorios-pagamentos/'+urlRelatorio,_this.tratarSucesso(relatorio,filho),_this.tratarErro,parametros,10000);}else{Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('relatorios-pagamentos/'+urlRelatorio,_this.tratarSucesso(relatorio,filho),_this.tratarErro,parametros);}};_this.escolherHeaderRelatorioRequerimentos=function(){var retorno=_this.colunasRelatorioRequerimentos;if(__WEBPACK_IMPORTED_MODULE_10__domain_User__["a" /* default */].logged().isRGPS()){retorno=_this.colunasRelatorioRequerimentosRGPS;}return retorno;};_this.tratarSucesso=function(relatorio,filho){return function(response){if(response.data!==''){var _this$state2=Object.assign({},_this.state),isUsuarioLogadoOrgaoCentralizador=_this$state2.isUsuarioLogadoOrgaoCentralizador;var novoNome='';var novasColunas=[];var dataFormatOptions={};var colunasFormatar=[];if(relatorio==='ajuste-contas'){novoNome='Relatório de Ajuste de Contas';novasColunas=_this.colunasRelatorioPagamento;dataFormatOptions=_this.pagamentosDataFormatOptions;colunasFormatar=_this.pagamentosColunasFormatar;}else if(relatorio==='participantes'){novoNome='Relatório de Pagamentos por Participantes';novasColunas=_this.colunasRelatorioParticipantes;dataFormatOptions=_this.participantesDataFormatOptions;colunasFormatar=_this.participantesColunasFormatar;}else if(relatorio==='requerimentos'){response.data=response.data.map(function(row,i){return Object.assign({seq:i+1},row);});novoNome='Relatório de Pagamentos por Requerimentos';novasColunas=isUsuarioLogadoOrgaoCentralizador===1?_this.colunasRelatorioRequerimentosRPPU:_this.escolherHeaderRelatorioRequerimentos();dataFormatOptions=_this.requerimentosDataFormatOptions;colunasFormatar=_this.requerimentosColunasFormatar;if(filho==='estoque'){novoNome+=' de Estoque';// novasColunas = this.colunasRelatorioRequerimentosEstoque;
novasColunas=isUsuarioLogadoOrgaoCentralizador===1?_this.colunasRelatorioRequerimentosEstoqueRPPU:_this.colunasRelatorioRequerimentosEstoque;dataFormatOptions=_this.requerimentosEstoqueDataFormatOptions;colunasFormatar=_this.requerimentosEstoqueColunasFormatar;}else if(filho==='concedidos'){novoNome+=' Concedidos';// novasColunas = this.colunasRelatorioRequerimentosConcedido;
novasColunas=isUsuarioLogadoOrgaoCentralizador===1?_this.colunasRelatorioRequerimentosConcedidoRPPU:_this.colunasRelatorioRequerimentosConcedido;dataFormatOptions=_this.requerimentosConcedidosDataFormatOptions;colunasFormatar=_this.requerimentosConcedidosColunasFormatar;}else if(filho==='fluxo'){novoNome+=' de Fluxo';// novasColunas = this.colunasRelatorioRequerimentosFluxo;
novasColunas=isUsuarioLogadoOrgaoCentralizador===1?_this.colunasRelatorioRequerimentosFluxoRPPU:_this.colunasRelatorioRequerimentosFluxo;dataFormatOptions=_this.requerimentosFluxoDataFormatOptions;colunasFormatar=_this.requerimentosFluxoColunasFormatar;}}else if(relatorio==='glosa'){novoNome='Relatório de Glosas';if(filho==='fluxo'){novoNome+=' de Fluxo';novasColunas=_this.colunasRelatorioGlosaFluxo;dataFormatOptions=_this.glosaDataFormatOptions;colunasFormatar=_this.glosaColunasFormatar;}else if(filho==='passivo'){novoNome+=' de Fluxo Acumulado';novasColunas=_this.colunasRelatorioGlosaPassivo;dataFormatOptions=_this.glosaDataFormatOptions;colunasFormatar=_this.glosaColunasFormatar;}else if(filho==='estoque'){novoNome+=' de Estoque';novasColunas=_this.colunasRelatorioGlosaEstoque;dataFormatOptions=_this.glosaEstoqueDataFormatOptions;colunasFormatar=_this.glosaEstoqueColunasFormatar;}else if(filho==='dacao'){novoNome+=' de Dação';novasColunas=_this.colunasRelatorioGlosaDacao;dataFormatOptions=_this.glosaDacaoDataFormatOptions;colunasFormatar=_this.glosaDacaoColunasFormatar;}}else if(relatorio==='bloqueios'){novoNome='Relatório de Bloqueios';novasColunas=_this.colunasRelatorioBloqueios;dataFormatOptions=_this.bloqueiosDataFormatOptions;colunasFormatar=_this.bloqueiosColunasFormatar;}var dadosFormatados=_this.prepararColunas(response.data,colunasFormatar);var listaDadosFormatados=dadosFormatados.map(function(item){var itemFormatado=item;if(item.orgaoOrigemDestinatario===null||item.orgaoOrigemDestinatario===undefined){itemFormatado.orgaoOrigemDestinatario='';}if(item.orgaoOrigemSolicitante===undefined||item.orgaoOrigemSolicitante===null){itemFormatado.orgaoOrigemSolicitante='';}if(item.statusPagamentoEstoque===undefined||item.statusPagamentoEstoque===null){itemFormatado.statusPagamentoEstoque='';}if(item.ordem===1){itemFormatado.ordem='';}return itemFormatado;});_this.setState({listaResultados:response.data,listaResultadosFormatados:listaDadosFormatados,colunasRelatorio:novasColunas,nomeRelatorio:novoNome,dataFormatOptions:dataFormatOptions});}};};_this.prepararColunas=function(data,colunas){var dados=data.map(function(item){var linha=Object.assign({},item);colunas.forEach(function(c){var key=Object.keys(item)[c.index];var coluna=item[key];var colunaFormatada=_this.formatarColuna(coluna,c.tipo);linha[key]=colunaFormatada;});return linha;});return dados;};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.handleVoltar=function(){var data=_this.state.dataHistory.pop();_this.setState({listaResultados:data,listaResultadosFormatados:data,colunasRelatorio:_this.state.colunasHistory.pop(),nomeRelatorio:_this.state.nomeRelatorioHistory.pop(),dataFormatOptions:_this.state.dataFormatHistory.pop()});};_this.montaColuna=function(relatorio,filho,tipo){return function(cell,row){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='moeda'){valor=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).formatToParts(cell).map(function(_ref){var type=_ref.type,value=_ref.value;switch(type){case'currency':return'';default:return value;}}).reduce(function(string,part){return string+part;});}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='booleano'){valor=cell===1?'S':'N';}else if(tipo==='protocolo'){valor='\''+cell;}else if(tipo==='motivoBloqueio'){if(cell){valor=_this.traduzirMotivoBloqueio(cell);}else{valor='';}}// else if (tipo === 'tipoSegregacao') {
//   valor = this.verificaTipoSegregacao(valor);
// }
if(tipo==='botao'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_index__["a" /* Button */],{hint:'Glosas de Da\xE7\xE3o',onClick:function onClick(){return _this.executaConsulta(row,relatorio,filho);},icon:'ico-clipboard-list',mini:true}));}else if(relatorio){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,relatorio?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:function onClick(){return _this.executaConsulta(row,relatorio,filho);}},valor):valor);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,valor);};};_this.formatarColuna=function(cell,tipo){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='moeda'){valor=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).formatToParts(cell).map(function(_ref2){var type=_ref2.type,value=_ref2.value;switch(type){case'currency':return'';default:return value;}}).reduce(function(string,part){return string+part;});}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='booleano'){valor=cell===1?'S':'N';}else if(tipo==='protocolo'){valor='\''+cell;}else if(tipo==='motivoBloqueio'){if(cell){valor=_this.traduzirMotivoBloqueio(cell);}else{valor='';}}// else if (tipo === 'tipoSegregacao') {
//   valor = this.verificaTipoSegregacao(valor);
// }
return valor.trim();};_this.pagamentosColunasFormatar=[{index:4,tipo:'cnpj'},{index:5,tipo:'moeda'},{index:7,tipo:'moeda'},{index:8,tipo:'moeda'},{index:10,tipo:'moeda'},{index:12,tipo:'moeda'},{index:14,tipo:'moeda'},{index:15,tipo:'moeda'},{index:16,tipo:'moeda'},{index:17,tipo:'moeda'},{index:18,tipo:'moeda'}];_this.pagamentosDataFormatOptions={2:_this.montaColuna('participantes'),3:_this.montaColuna('participantes'),4:_this.montaColuna(null,null,'cnpj'),5:_this.montaColuna(null,null,'moeda'),7:_this.montaColuna(null,null,'moeda'),8:_this.montaColuna(null,null,'moeda'),10:_this.montaColuna(null,null,'moeda'),12:_this.montaColuna(null,null,'moeda'),14:_this.montaColuna('bloqueios','bloqueios-anterior','moeda'),15:_this.montaColuna('bloqueios','desbloqueios','moeda'),16:_this.montaColuna(null,null,'moeda'),17:_this.montaColuna('bloqueios','bloqueios','moeda'),18:_this.montaColuna(null,null,'moeda')};_this.participantesColunasFormatar=[{index:4,tipo:'cnpj'},{index:5,tipo:'moeda'},{index:6,tipo:'numero'},{index:7,tipo:'moeda'},{index:8,tipo:'moeda'},{index:9,tipo:'numero'},{index:10,tipo:'moeda'},{index:11,tipo:'moeda'},{index:12,tipo:'moeda'},{index:13,tipo:'moeda'},{index:14,tipo:'numero'},{index:15,tipo:'moeda'},{index:16,tipo:'moeda'},{index:17,tipo:'moeda'},{index:18,tipo:'moeda'},{index:19,tipo:'booleano'},{index:20,tipo:'moeda'}];_this.participantesDataFormatOptions={2:_this.montaColuna('requerimentos'),3:_this.montaColuna('requerimentos'),4:_this.montaColuna(null,null,'cnpj'),5:_this.montaColuna(null,null,'moeda'),6:_this.montaColuna('requerimentos','estoque','numero'),7:_this.montaColuna('glosa','estoque','moeda'),8:_this.montaColuna(null,null,'moeda'),9:_this.montaColuna('requerimentos','concedidos','numero'),10:_this.montaColuna(null,null,'moeda'),11:_this.montaColuna(null,null,'moeda'),12:_this.montaColuna('glosa','passivo','moeda'),13:_this.montaColuna(null,null,'moeda'),14:_this.montaColuna('requerimentos','fluxo','numero'),15:_this.montaColuna(null,null,'moeda'),16:_this.montaColuna(null,null,'moeda'),17:_this.montaColuna('glosa','fluxo','moeda'),18:_this.montaColuna(null,null,'moeda'),19:_this.montaColuna(null,null,'booleano'),20:_this.montaColuna(null,null,'moeda')};_this.requerimentosColunasFormatar=[{index:6,tipo:'cnpj'},{index:8,tipo:'cpf'},{index:14,tipo:'moeda'},{index:15,tipo:'moeda'},{index:16,tipo:'moeda'},{index:17,tipo:'moeda'},{index:18,tipo:'moeda'},{index:19,tipo:'moeda'},{index:20,tipo:'moeda'},{index:25,tipo:'moeda'},{index:26,tipo:'moeda'},{index:27,tipo:'moeda'}];_this.requerimentosDataFormatOptions={6:_this.montaColuna(null,null,'cnpj'),8:_this.montaColuna(null,null,'cpf'),14:_this.montaColuna(null,null,'moeda'),15:_this.montaColuna(null,null,'moeda'),16:_this.montaColuna(null,null,'moeda'),17:_this.montaColuna(null,null,'moeda'),18:_this.montaColuna(null,null,'moeda'),19:_this.montaColuna(null,null,'moeda'),20:_this.montaColuna(null,null,'moeda'),25:_this.montaColuna(null,null,'moeda'),26:_this.montaColuna(null,null,'moeda'),27:_this.montaColuna(null,null,'moeda')};_this.requerimentosEstoqueColunasFormatar=[{index:1,tipo:'protocolo'},{index:6,tipo:'cnpj'},{index:8,tipo:'cpf'},{index:14,tipo:'moeda'},{index:15,tipo:'moeda'},{index:16,tipo:'moeda'},{index:19,tipo:'moeda'}];_this.requerimentosEstoqueDataFormatOptions={6:_this.montaColuna(null,null,'cnpj'),8:_this.montaColuna(null,null,'cpf'),14:_this.montaColuna(null,null,'moeda'),15:_this.montaColuna(null,null,'moeda'),16:_this.montaColuna(null,null,'moeda'),19:_this.montaColuna(null,null,'moeda')};_this.requerimentosConcedidosColunasFormatar=[{index:1,tipo:'protocolo'},{index:6,tipo:'cnpj'},{index:8,tipo:'cpf'},{index:14,tipo:'moeda'},{index:15,tipo:'moeda'},{index:16,tipo:'moeda'},{index:17,tipo:'moeda'},{index:18,tipo:'moeda'},{index:19,tipo:'moeda'},{index:20,tipo:'moeda'},{index:23,tipo:'moeda'},{index:24,tipo:'moeda'},{index:25,tipo:'moeda'}];_this.requerimentosConcedidosDataFormatOptions={5:_this.montaColuna(null,null,'cnpj'),8:_this.montaColuna(null,null,'cpf'),14:_this.montaColuna(null,null,'moeda'),15:_this.montaColuna(null,null,'moeda'),16:_this.montaColuna(null,null,'moeda'),17:_this.montaColuna(null,null,'moeda'),18:_this.montaColuna(null,null,'moeda'),19:_this.montaColuna(null,null,'moeda'),20:_this.montaColuna(null,null,'moeda'),23:_this.montaColuna(null,null,'moeda'),24:_this.montaColuna(null,null,'moeda'),25:_this.montaColuna(null,null,'moeda')};_this.requerimentosFluxoColunasFormatar=[{index:1,tipo:'protocolo'},{index:6,tipo:'cnpj'},{index:8,tipo:'cpf'},{index:14,tipo:'moeda'},{index:15,tipo:'moeda'},{index:16,tipo:'moeda'},{index:17,tipo:'moeda'}];_this.requerimentosFluxoDataFormatOptions={6:_this.montaColuna(null,null,'cnpj'),8:_this.montaColuna(null,null,'cpf'),14:_this.montaColuna(null,null,'moeda'),15:_this.montaColuna(null,null,'moeda'),16:_this.montaColuna(null,null,'moeda'),17:_this.montaColuna(null,null,'moeda')};_this.glosaColunasFormatar=[{index:5,tipo:'cnpj'},{index:7,tipo:'cpf'},{index:13,tipo:'moeda'}];_this.glosaDataFormatOptions={5:_this.montaColuna(null,null,'cnpj'),7:_this.montaColuna(null,null,'cpf'),13:_this.montaColuna(null,null,'moeda')};_this.glosaEstoqueColunasFormatar=[{index:5,tipo:'cnpj'},{index:7,tipo:'cpf'},{index:13,tipo:'moeda'}];_this.glosaEstoqueDataFormatOptions={5:_this.montaColuna(null,null,'cnpj'),7:_this.montaColuna(null,null,'cpf'),13:_this.montaColuna(null,null,'moeda'),15:_this.montaColuna('glosa','dacao','botao')};_this.glosaDacaoColunasFormatar=[{index:5,tipo:'moeda'}];_this.glosaDacaoDataFormatOptions={5:_this.montaColuna(null,null,'moeda')};_this.bloqueiosColunasFormatar=[{index:4,tipo:'moeda'},{index:5,tipo:'motivoBloqueio'},{index:8,tipo:'moeda'}];_this.bloqueiosDataFormatOptions={4:_this.montaColuna(null,null,'moeda'),5:_this.montaColuna(null,null,'motivoBloqueio'),8:_this.montaColuna(null,null,'moeda')};_this.defineContainerStyle=function(){var width=_this.state.colunasRelatorio.length*130;if(width<1140){width=1140;}return{width:width+'px'};};_this.state={listaResultados:[],listaResultadosFormatados:[],colunasRelatorio:[],nomeRelatorio:'',filtrosAtuais:{},dataFormatOptions:{},dataHistory:[],nomeRelatorioHistory:[],colunasHistory:[],dataFormatHistory:[],isUsuarioLogadoOrgaoCentralizador:0};return _this;}_createClass(TelaRelatorioPagamentos,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["g" /* manterApenasFiltro */])('');// if (this.props.destinatarios.length === 0 && this.isRgps()) {
if(this.props.destinatarios.length===0&&this.isPapelHabilitadoParaUso()){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}if(!this.isPapelHabilitadoParaUso()){this.buscarParticipantePeloCnpjLogado();}}// verificaTipoSegregacao = (valor) => {
//   let retorno = '';
//   if (valor && valor !== '' && valor !== null) {
//     if (valor === 1) {
//       retorno = 'Fundo Financeiro (Repartição)';
//     }
//     if (valor === 2) {
//       retorno = 'Fundo Previdenciário (Capitalização)';
//     }
//   }
//   return retorno;
// }
},{key:'render',value:function render(){var options={noDataText:'Nenhum resultado a ser exibido',hideSizePerPage:true};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FiltroRelatorio__["a" /* default */],{handleSearchFilter:this.handlePesquisar,destinatarios:this.props.destinatarios,filtroModalidade:false// rgps={this.isRgps()}
,rgps:this.isPapelHabilitadoParaUso(),tipo:'pagamentos'}),this.state.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Relatorio__["a" /* default */],{legend:this.state.nomeRelatorio,bordered:true,headers:this.state.colunasRelatorio,data:this.state.listaResultados,options:options,pagination:true,dataFormatOptions:this.state.dataFormatOptions,landscape:true,voltarAction:this.handleVoltar,containerStyle:this.defineContainerStyle(),exportacao:this.state.listaResultadosFormatados}):null);}}]);return TelaRelatorioPagamentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// eslint-disable-next-line react/prop-types
TelaRelatorioPagamentos.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};TelaRelatorioPagamentos.defaultProps={destinatarios:[]};// eslint-disable-next-line
var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(TelaRelatorioPagamentos));

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiltroRelatorio__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Relatorio__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var TelaRelatorioRequerimentos=function(_Component){_inherits(TelaRelatorioRequerimentos,_Component);function TelaRelatorioRequerimentos(props){_classCallCheck(this,TelaRelatorioRequerimentos);var _this=_possibleConstructorReturn(this,(TelaRelatorioRequerimentos.__proto__||Object.getPrototypeOf(TelaRelatorioRequerimentos)).call(this,props));_this.colunasRelatorioRequerimentos=['Competência','Solicitante','Destinatário','Aguardando Análise','Aguardando An. Médica','Aguardando Compensação Aposentadoria','Análise Suspensa','Compensado','Criado','Deferido','Em Análise','Em Compensação','Em Exigência','Indeferido','Em Análise Perito Médico','Alterado','Exigência / Indeferido','Indeferido Ratificado'];_this.colunasRelatorioAnaliticoGeral=['NIT','CPF','Matrícula','Protocolo','Tipo Requerimento','Tipo Aposentadoria','Nome Beneficiario','Dt. Criação Requerimento','Dt. Situação','Dias na Situação','Migrado em'];_this.colunasRelatorioQuantExigencia=['ID','Exigência','Quantidade'];_this.colunasRelatorioQuantEspecial=['ID','Motivo','Quantidade'];_this.colunasRelatorioAnaliticoEspecial=['NIT','CPF','Matrícula','Protocolo','Tipo Requerimento','Tipo Aposentadoria','Nome Beneficiario','Dt. Criação Requerimento','Dt. Situação','Dias na Situação','Nome do Analista','Comentário Analista','Migrado em'];_this.colunasRelatorioAnaliticoEspecialCompleto=['NIT','CPF','Matrícula','Protocolo','Tipo Requerimento','Tipo Aposentadoria','Nome Beneficiario','Dt. Criação Requerimento','Dt. Situação','Motivo','Dias na Situação','Nome do Analista','Comentário Analista','Migrado em'];_this.handlePesquisar=function(valoresFiltro){var d1=valoresFiltro.competenciaInicial;var d2=valoresFiltro.competenciaFinal;if(d1.length!==6||d2.length!==6){_this.addMessage('Competências devem ser no formato AAAA-MM');return;}var d1Ano=parseInt(d1.substring(2,6),10);var d2Ano=parseInt(d2.substring(2,6),10);var d1Mes=parseInt(d1.substring(0,2),10);var d2Mes=parseInt(d2.substring(0,2),10);if(d1Mes>12){_this.addMessage('Competência inicial inválida.');return;}if(d2Mes>12){_this.addMessage('Competência final inválida.');return;}if(d2Ano<d1Ano||d2Ano===d1Ano&&d2Mes<d1Mes){_this.addMessage('Competência final deve ser maior ou igual a competência inicial');return;}var months=(d2Ano-d1Ano)*12;months-=d1Mes;months+=d2Mes;if(months>12||months<0){_this.addMessage('Competência final deve ser no máximo 12 meses maior que a competência inicial');return;}if(!valoresFiltro['destinatario-rpps']&&!valoresFiltro.gex&&months!==0&&_this.isRgps()){_this.addMessage('Com filtro de superintendência ou todos, intervalo máximo de competência deve ser um mês.');return;}_this.setState({filtrosAtuais:valoresFiltro},function(){return _this.executaConsulta(null,'sintetico');});};_this.isRgps=function(){return _this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','gerenciar-negocio-dcomp','auditar-comprev','analisar-negocio-dtpv','consultar-compensacao-rgps','analisar-negocio-sprev']);};_this.defineCompetenciaFiltro=function(row){var mes=row.mesCompetencia.toString().length===1?'0'+row.mesCompetencia:row.mesCompetencia.toString();return row.anoCompetencia+mes;};_this.defineNivelFiltro=function(){if(!_this.isRgps()){return 4;}else if(_this.state.filtrosAtuais['destinatario-rpps']){return 4;}else if(_this.state.filtrosAtuais.ente){return 4;}else if(_this.state.filtrosAtuais.aps){return 3;}else if(_this.state.filtrosAtuais.gex){return 2;}else if(_this.state.filtrosAtuais.superintendencia){return 1;}return 0;};_this.defineCodigo=function(parametros){var novosParametros=parametros;if(!_this.isRgps()){novosParametros.codigo='01000';}else if(_this.state.filtrosAtuais['destinatario-rpps']){novosParametros.codigo=_this.state.filtrosAtuais['destinatario-rpps'];}else if(_this.state.filtrosAtuais.ente){novosParametros.codigo=_this.state.filtrosAtuais.ente;}else if(_this.state.filtrosAtuais.aps){novosParametros.codigo=_this.state.filtrosAtuais.aps;}else if(_this.state.filtrosAtuais.gex){novosParametros.codigo=_this.state.filtrosAtuais.gex;}else if(_this.state.filtrosAtuais.superintendencia){novosParametros.codigo=_this.state.filtrosAtuais.superintendencia;}return novosParametros;};_this.recuperarCodigoParticipanteExibicao=function(nomeParticipante){var retorno='';if(nomeParticipante!==null&&nomeParticipante!==''){retorno=nomeParticipante.substring(nomeParticipante.lastIndexOf('-')+1,nomeParticipante.length);}return retorno;};_this.defineOutroParticipante=function(row){var solicitante=null;var destinatario=null;if(row.solicitante){// solicitante = row.solicitante === 'RGPS' ? '01000' : row.solicitante.split('-')[1];
// destinatario = row.destinatario === 'RGPS' ? '01000' : row.destinatario.split('-')[1];
solicitante=row.solicitante==='RGPS'?'01000':_this.recuperarCodigoParticipanteExibicao(row.solicitante);destinatario=row.destinatario==='RGPS'?'01000':_this.recuperarCodigoParticipanteExibicao(row.destinatario);}else{solicitante=_this.state.solicitanteAtual;destinatario=_this.state.destinatarioAtual;}if(_this.isRgps()){return solicitante==='01000'?destinatario:solicitante;}return solicitante==='01000'?solicitante:destinatario;};_this.defineModalidadeSemModalidade=function(row){var solicitante=null;var destinatario=null;if(row.solicitante){// solicitante = row.solicitante === 'RGPS' ? '01000' : row.solicitante.split('-')[1];
// destinatario = row.destinatario === 'RGPS' ? '01000' : row.destinatario.split('-')[1];
solicitante=row.solicitante==='RGPS'?'01000':_this.recuperarCodigoParticipanteExibicao(row.solicitante);destinatario=row.destinatario==='RGPS'?'01000':_this.recuperarCodigoParticipanteExibicao(row.destinatario);}else{solicitante=_this.state.solicitanteAtual;destinatario=_this.state.destinatarioAtual;}if(_this.isRgps()){return destinatario==='01000'?'solicitante':'destinatario';}return solicitante==='01000'?'solicitante':'destinatario';};_this.executaConsulta=function(row,relatorio,estado,idMotivo,motivo){var urlRelatorio=null;var solicitanteAtual=null;var destinatarioAtual=null;var paginado=false;var solCod=null;_this.setState({rowAtual:row});if(row&&row.solicitante){// solicitanteAtual = row.solicitante === 'RGPS' ? '01000' : row.solicitante.split('-')[1];
// destinatarioAtual = row.destinatario === 'RGPS' ? '01000' : row.destinatario.split('-')[1];
solicitanteAtual=row.solicitante==='RGPS'?'01000':_this.recuperarCodigoParticipanteExibicao(row.solicitante);destinatarioAtual=row.destinatario==='RGPS'?'01000':_this.recuperarCodigoParticipanteExibicao(row.destinatario);}var parametros={nivel:_this.defineNivelFiltro(relatorio),modalidadeRelacao:_this.state.filtrosAtuais.relacao};if(row!==null){var filtroCompetenciaConsultada='';var paramCompetencia='';var paramSolicitanteAtual='';var paramDestinatarioAtual='';if(row.competencia){filtroCompetenciaConsultada=_this.textoParaNumeroCompetencia(row.competencia);paramCompetencia=row.competencia;paramSolicitanteAtual=row.solicitante;paramDestinatarioAtual=row.destinatario;}else{filtroCompetenciaConsultada=_this.textoParaNumeroCompetencia(_this.state.competenciaSelecionada);paramCompetencia=_this.state.competenciaSelecionada;paramSolicitanteAtual=_this.state.nomeSolicitanteSelecionado;paramDestinatarioAtual=_this.state.nomeDestinatarioSelecionado;}parametros.competenciaConsultada=filtroCompetenciaConsultada;_this.setState({nomeSolicitanteSelecionado:paramSolicitanteAtual,nomeDestinatarioSelecionado:paramDestinatarioAtual,competenciaSelecionada:paramCompetencia});}else{var filtroCompetenciaInicial=_this.state.filtrosAtuais.competenciaInicial.substring(2,6)+_this.state.filtrosAtuais.competenciaInicial.substring(0,2);var filtroCompetenciaFinal=_this.state.filtrosAtuais.competenciaFinal.substring(2,6)+_this.state.filtrosAtuais.competenciaFinal.substring(0,2);parametros.competenciaInicial=filtroCompetenciaInicial;parametros.competenciaFinal=filtroCompetenciaFinal;}parametros=_this.defineCodigo(parametros);if(!_this.isRgps()&&solicitanteAtual!=='01000'&&destinatarioAtual!=='01000'&&(relatorio==='analitico-geral'||relatorio==='quantitativo-exigencia'||relatorio==='quantitativo-especial')){parametros.codigo=solicitanteAtual;}else if(!_this.isRgps()&&solicitanteAtual!=='01000'&&destinatarioAtual!=='01000'&&relatorio!=='sintetico'){solCod=_this.state.nomeSolicitanteSelecionado;parametros.codigo=solCod.substring(solCod.length-5,solCod.length);}if(relatorio!=='sintetico'){parametros.outroParticipante=_this.defineOutroParticipante(row);parametros.estadoRequerimento=estado;if(_this.state.filtrosAtuais.relacao==='todos'){parametros.modalidadeSemModalidade=_this.defineModalidadeSemModalidade(row);}paginado=true;}if(relatorio==='sintetico'){urlRelatorio='filtro-requerimentos-sintetico';}else if(relatorio==='analitico-geral'){urlRelatorio='filtro-requerimentos-analitico';}else if(relatorio==='quantitativo-exigencia'){urlRelatorio='filtro-requerimentos-analitico-totalizador-exigencia';}else if(relatorio==='quantitativo-especial'){urlRelatorio='filtro-requerimentos-analitico-totalizador-motivo';}else if(relatorio==='analitico-especial'){urlRelatorio='filtro-requerimentos-analitico-motivo-exigencia';parametros.idMotivoExigencia=idMotivo!=null?idMotivo:'';}else if(relatorio==='analitico-especial-completo'){urlRelatorio='filtro-requerimentos-analitico-motivo-exigencia-completo';parametros.motivoCompleto=1;}_this.setState({dataHistory:[].concat(_toConsumableArray(_this.state.dataHistory),[_this.state.listaResultados]),nomeRelatorioHistory:[].concat(_toConsumableArray(_this.state.nomeRelatorioHistory),[_this.state.nomeRelatorio]),colunasHistory:[].concat(_toConsumableArray(_this.state.colunasHistory),[_this.state.colunasRelatorio]),dataFormatHistory:[].concat(_toConsumableArray(_this.state.dataFormatHistory),[_this.state.dataFormatOptions]),tipoRelatorioHistory:[].concat(_toConsumableArray(_this.state.tipoRelatorioHistory),[_this.state.tipoRelatorio]),estadoRequerimentoAtual:estado,solicitanteAtual:solicitanteAtual==null?_this.state.solicitanteAtual:solicitanteAtual,destinatarioAtual:destinatarioAtual==null?_this.state.destinatarioAtual:destinatarioAtual},function(){return _this.preparaRequest(urlRelatorio,relatorio,motivo,parametros,paginado);});};_this.preparaRequest=function(urlRelatorio,relatorio,motivo,parametros,paginado){if(paginado){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["i" /* doGetPaginado */])('relatorios-requerimentos/'+urlRelatorio,_this.tratarSucesso(relatorio,motivo),_this.tratarErro,parametros,10000);}else{Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('relatorios-requerimentos/'+urlRelatorio,_this.tratarSucesso(relatorio,motivo),_this.tratarErro,parametros);}};_this.tratarSucesso=function(relatorio,motivo){return function(response){if(response.data!==''){var novoNome='';var novasColunas=[];var dataFormatOptions={};var paramExibirBotaoRelatorioAnalitico='';var competencia='- '+_this.state.competenciaSelecionada;var solicitante=' - solicitante: '+_this.state.nomeSolicitanteSelecionado;var destinatario=' - destinat\xE1rio: '+_this.state.nomeDestinatarioSelecionado;var complementoTitulo=''+competencia+solicitante+destinatario;if(relatorio==='sintetico'){novoNome='Relatório de Requerimentos Sintético';novasColunas=_this.colunasRelatorioRequerimentos;dataFormatOptions=_this.sinteticoDataFormatOptions;}else if(relatorio==='analitico-geral'){novoNome='Relat\xF3rio de Requerimentos Anal\xEDtico '+complementoTitulo;novasColunas=_this.colunasRelatorioAnaliticoGeral;// A coluna Competência Cessação só aparece se o
// estado do requerimento clicado no link for Compensado.
if(_this.state.estadoRequerimentoAtual===11){novasColunas.push('Competência Cessação');}else{var index=novasColunas.findIndex(function(item){return item==='Competência Cessação';});if(index!==-1){novasColunas.splice(index,1);}}dataFormatOptions=_this.analiticoDataFormatOptions;}else if(relatorio==='quantitativo-exigencia'){novoNome='Relat\xF3rio Quantitativo de Exig\xEAncias '+complementoTitulo;novasColunas=_this.colunasRelatorioQuantExigencia;dataFormatOptions=_this.quantExigenciasDataFormatOptions;}else if(relatorio==='quantitativo-especial'){novoNome='Relat\xF3rio Quantitativo de Motivos '+complementoTitulo;novasColunas=_this.colunasRelatorioQuantEspecial;dataFormatOptions=_this.quantEspecialDataFormatOptions;paramExibirBotaoRelatorioAnalitico=true;}else if(relatorio==='analitico-especial'){novoNome='Relat\xF3rio de Requerimentos Anal\xEDtico com motivo "'+(motivo!=null?motivo:'')+'"\n        '+complementoTitulo;novasColunas=_this.colunasRelatorioAnaliticoEspecial;dataFormatOptions=_this.analiticoEspecialDataFormatOptions;paramExibirBotaoRelatorioAnalitico=false;}else if(relatorio==='analitico-especial-completo'){novoNome='Relat\xF3rio de Requerimentos Anal\xEDtico com motivo "'+(motivo!=null?motivo:'')+'"\n        '+complementoTitulo;novasColunas=_this.colunasRelatorioAnaliticoEspecialCompleto;dataFormatOptions=_this.analiticoEspecialDataFormatOptions;paramExibirBotaoRelatorioAnalitico=false;}_this.setState({listaResultados:response.data,colunasRelatorio:novasColunas,nomeRelatorio:novoNome,dataFormatOptions:dataFormatOptions,exibirBotaoRelatorioAnalitico:paramExibirBotaoRelatorioAnalitico,tipoRelatorio:relatorio});}};};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.handleVoltar=function(){var _this$state=Object.assign({},_this.state),tipoRelatorio=_this$state.tipoRelatorio;var data=_this.state.dataHistory.pop();if(tipoRelatorio==='analitico-geral'){var novasColunas=_this.colunasRelatorioAnaliticoGeral;var index=novasColunas.findIndex(function(item){return item==='Competência Cessação';});if(index!==-1){novasColunas.splice(index,1);}}_this.setState({listaResultados:data,colunasRelatorio:_this.state.colunasHistory.pop(),nomeRelatorio:_this.state.nomeRelatorioHistory.pop(),dataFormatOptions:_this.state.dataFormatHistory.pop(),tipoRelatorio:_this.state.tipoRelatorioHistory.pop()});};_this.textoParaNumeroCompetencia=function(competencia){var numeroCompetencia='';var ano=competencia.toString().slice(competencia.length-4);if(competencia.indexOf('jan')!==-1){numeroCompetencia=ano+'01';}if(competencia.indexOf('fev')!==-1){numeroCompetencia=ano+'02';}if(competencia.indexOf('mar')!==-1){numeroCompetencia=ano+'03';}if(competencia.indexOf('abr')!==-1){numeroCompetencia=ano+'04';}if(competencia.indexOf('mai')!==-1){numeroCompetencia=ano+'05';}if(competencia.indexOf('jun')!==-1){numeroCompetencia=ano+'06';}if(competencia.indexOf('jul')!==-1){numeroCompetencia=ano+'07';}if(competencia.indexOf('ago')!==-1){numeroCompetencia=ano+'08';}if(competencia.indexOf('set')!==-1){numeroCompetencia=ano+'09';}if(competencia.indexOf('out')!==-1){numeroCompetencia=ano+'10';}if(competencia.indexOf('nov')!==-1){numeroCompetencia=ano+'11';}if(competencia.indexOf('dez')!==-1){numeroCompetencia=ano+'12';}return numeroCompetencia;};_this.montaColuna=function(relatorio,estado,tipo){return function(cell,row){var valor=cell;var estadoAtual=estado;var motivoAtual=row.motivo?row.motivo:row.exigencia;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}var id=null;if(estado===__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].EM_EXIGENCIA){id=row.idExigencia;}else if([__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].INDEFERIDO,__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].ANALISE_SUSPENSA,__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].COMPENSADO].includes(_this.state.estadoRequerimentoAtual)){id=row.idMotivo;}if(relatorio==='analitico-especial'){estadoAtual=_this.state.estadoRequerimentoAtual;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,relatorio?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:function onClick(){return _this.executaConsulta(row,relatorio,estadoAtual,id,motivoAtual);}},valor):valor);};};_this.sinteticoDataFormatOptions={3:_this.montaColuna('analitico-geral',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].AGUARDANDO_ANALISE),4:_this.montaColuna('analitico-geral',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].AGUARDANDO_ANALISE_MEDICO),5:_this.montaColuna('analitico-geral',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].AGUARDANDO_COMPENSACAO_APOSENTADORIA),6:_this.montaColuna('quantitativo-especial',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].ANALISE_SUSPENSA),7:_this.montaColuna('quantitativo-especial',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].COMPENSADO),8:_this.montaColuna('analitico-geral',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].CRIADO),9:_this.montaColuna('analitico-geral',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].DEFERIDO),10:_this.montaColuna('analitico-geral',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].EM_ANALISE),11:_this.montaColuna('analitico-geral',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].EM_COMPENSACAO),12:_this.montaColuna('quantitativo-exigencia',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].EM_EXIGENCIA),13:_this.montaColuna('quantitativo-especial',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].INDEFERIDO),14:_this.montaColuna('analitico-geral',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].EM_ANALISE_MEDICO),15:_this.montaColuna('analitico-geral',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].ALTERADO),16:_this.montaColuna('analitico-geral',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].EXIGENCIA_INDEFERIDO),17:_this.montaColuna('analitico-geral',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].INDEFERIDO_RATIFICADO)};_this.analiticoDataFormatOptions={1:_this.montaColuna(null,null,'cpf')};_this.quantExigenciasDataFormatOptions={2:_this.montaColuna('analitico-especial',__WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* estadosRequerimento */].EM_EXIGENCIA)};_this.quantEspecialDataFormatOptions={2:_this.montaColuna('analitico-especial')};_this.analiticoEspecialDataFormatOptions={1:_this.montaColuna(null,null,'cpf')};_this.defineContainerStyle=function(){var width=_this.state.colunasRelatorio.length*150;if(width<1140){width=1140;}return{width:width+'px'};};_this.state={listaResultados:[],colunasRelatorio:[],nomeRelatorio:'',filtrosAtuais:{},dataFormatOptions:{},dataHistory:[],nomeRelatorioHistory:[],colunasHistory:[],dataFormatHistory:[],tipoRelatorioHistory:[],estadoRequerimentoAtual:null,solicitanteAtual:null,destinatarioAtual:null,competenciaSelecionada:null,nomeSolicitanteSelecionado:null,nomeDestinatarioSelecionado:null,exibirBotaoRelatorioAnalitico:false,tipoRelatorio:null,rowAtual:null};return _this;}_createClass(TelaRelatorioRequerimentos,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["g" /* manterApenasFiltro */])('');if(this.props.destinatarios.length===0&&this.isRgps()){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}}},{key:'render',value:function render(){var hidden=null;if(this.state.nomeRelatorio==='Relatório Quantitativo de Exigências'||this.state.nomeRelatorio==='Relatório Quantitativo de Motivos'){hidden=[0];}var options={noDataText:'Nenhum resultado a ser exibido',hideSizePerPage:true,hidden:hidden};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FiltroRelatorio__["a" /* default */],{handleSearchFilter:this.handlePesquisar,destinatarios:this.props.destinatarios,filtroModalidade:true,rgps:this.isRgps(),tipo:'requerimentos'}),this.state.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Relatorio__["a" /* default */],{paramExibirBotaoRelatorioAnalitico:this.state.tipoRelatorio==='quantitativo-especial'||this.state.tipoRelatorio==='quantitativo-exigencia',estado:this.state.estadoRequerimentoAtual,legend:this.state.nomeRelatorio,bordered:true,headers:this.state.colunasRelatorio,data:this.state.listaResultados,options:options,pagination:true,dataFormatOptions:this.state.dataFormatOptions,landscape:true,voltarAction:this.handleVoltar,exigenciasCompletoAction:this.executaConsulta,containerStyle:this.defineContainerStyle(),rowAtual:this.state.rowAtual}):null);}}]);return TelaRelatorioRequerimentos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TelaRelatorioRequerimentos.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};TelaRelatorioRequerimentos.defaultProps={destinatarios:[]};// eslint-disable-next-line
var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(TelaRelatorioRequerimentos));

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Inicio_css__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Inicio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Inicio_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_cadastros_cronograma_pagamentos_InfoCronograma__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_cadastros_cronograma_pagamentos_impressaoCronogramaPagamento_css__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_cadastros_cronograma_pagamentos_impressaoCronogramaPagamento_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_cadastros_cronograma_pagamentos_impressaoCronogramaPagamento_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */// import {
//   DtpNoContent,
// } from 'dtp-react-components';
// const STYLES_CSS = {
//   painelGeral: {
//     textAlign: 'left',
//     margin: '0 auto',
//   },
// };
var Inicio=function(_Component){_inherits(Inicio,_Component);function Inicio(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Inicio);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Inicio.__proto__||Object.getPrototypeOf(Inicio)).call.apply(_ref,[this].concat(args))),_this),_this.getMessage=function(chave){var texto='';if(_this.props.configuracoesFrontend&&_this.props.configuracoesFrontend.listaMensagens){var mensagem=_this.props.configuracoesFrontend.listaMensagens.filter(function(m){return m.chave===chave;});if(mensagem.length>0){texto=mensagem[0].valor;}}return texto;},_this.showPendencia=function(visao){_this.props.history.push('/controledepagamentos/home/'+visao+'/pendencias');},_this.montaLinkPendencias=function(visao){var textoVisao='';var nomeParticipante='';if(visao===1){textoVisao='análise de pagamento';}if(visao===2){textoVisao='valores a pagar';}if(_this.props.configuracoesFrontend&&_this.props.configuracoesFrontend.nomeParticipantePendencia){nomeParticipante=_this.props.configuracoesFrontend.nomeParticipantePendencia;}var botaoLink=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{style:{align:'left',top:'-4px',position:'relative'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components__["a" /* Button */],{hint:_this.props.configuracoesFrontend&&nomeParticipante?'Pend\xEAncias de '+textoVisao+' identificados para o ente '+nomeParticipante+'.':'',icon:'ico-money-bag',mini:true,onClick:function onClick(){return _this.showPendencia(visao);}}));var textoLink=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{style:{color:'#C32F27'}},_this.props.configuracoesFrontend&&nomeParticipante?'Pend\xEAncias de '+textoVisao+' identificadas para o ente '+nomeParticipante+'.':'');return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,botaoLink,textoLink);},_this.mensagemBloqueio=function(){var URLS={comprev:'https://servicos.dataprev.gov.br/comprev/',sprev:'https://www.gov.br/trabalho-e-previdencia/pt-br/assuntos/previdencia-no-servico-publico/compensacao-previdenciaria/compensacao-previdenciaria',faq:'https://docs.dataprev.gov.br/docs/comprev/perguntas-frequentes/'};var EMAIL='comprev@dataprev.gov.br';return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{textAlign:'justify',fontSize:'16px',lineHeight:'2.2',color:'#C32F27',fontWeight:'bold'}},'A contrata\xE7\xE3o do COMPREV ser\xE1 realizada por meio do marketplace (',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:URLS.comprev},URLS.comprev),'). N\xE3o \xE9 poss\xEDvel a celebra\xE7\xE3o do contrato por outro canal. O primeiro passo antes de iniciar o processo de contrata\xE7\xE3o do COMPREV junto \xE0 DATAPREV, \xE9 importante que o Ente se certifique que est\xE1 devidamente habilitado pela SPREV para contratar o COMPREV. Ap\xF3s a celebra\xE7\xE3o do Termo de Ades\xE3o junto a SPREV, o Ente est\xE1 apto para realizar a contrata\xE7\xE3o do COMPREV junto \xE0 DATAPREV. Para tanto, o Ente dever\xE1 acessar o portal da SPREV ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:URLS.sprev},URLS.sprev),' e acessar os documentos (Projeto B\xE1sico, Minuta de Contrato e Modelo de Neg\xF3cio) que ser\xE3o necess\xE1rios para o Ente instaurar o processo administrativo de contrata\xE7\xE3o do COMPREV. \xC9 importante que o Ente siga as recomenda\xE7\xF5es de preenchimento presentes nesses documentos e que n\xE3o utilize outros documentos que n\xE3o sejam aqueles disponibilizados no portal da SPREV. Ap\xF3s a conclus\xE3o das etapas internas relativas \xE0 contrata\xE7\xE3o, o Ente dever\xE1 acessar o marketplace da DATAPREV ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:URLS.comprev},URLS.comprev),' e preencher o formul\xE1rio eletr\xF4nico com todas as informa\xE7\xF5es solicitadas. Existem dois canais de relacionamento para dirimir d\xFAvidas com os Entes relacionadas \xE0 Contrata\xE7\xE3o do COMPREV. 1 - Sala Virtual, sempre ter\xE7as e quintas, das 09:30h \xE0s 12:00h e 14:30 \xE0s 17:00. Para solicitar acesso e participar, basta ligar para o n\xFAmero (61) 2021-5555. 2 - Caixa de Email do COMPREV: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:'mailto:'+EMAIL},EMAIL),'. Segue link do FAQ relacionado \xE0 contrata\xE7\xE3o do COMPREV: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:URLS.faq},URLS.faq));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Inicio,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["g" /* manterApenasFiltro */])('');if(!this.props.configuracoesFrontend){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["I" /* solicitarHabilitarQualificacao */])();}// solicitarPendenciasPorEnteLogado();
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',alignItems:'flex-start'}},this.props.configuracoesFrontend&&this.props.configuracoesFrontend.exibirLinkPesquisaPendenciasAReceber&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'esconder-print',style:{width:'1380px',margin:'0 auto',padding:'40px 6px 20px 6px',textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',{style:{fontSize:'20px'}},this.montaLinkPendencias(1))),this.props.configuracoesFrontend&&this.props.configuracoesFrontend.exibirLinkPesquisaPendenciasAPagar&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'esconder-print',style:{width:'1380px',margin:'0 auto',padding:'20px 6px',textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',{style:{fontSize:'20px'}},this.montaLinkPendencias(2))),this.props.configuracoesFrontend&&this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:'alerta-bloqueio',style:{width:'1380px',margin:'0 auto',padding:'20px 6px',textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{style:{display:'block',color:'red',fontWeight:'bold',fontSize:'14px'}},this.mensagemBloqueio())),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'esconder-print',style:{width:'1380px',margin:'0 auto',padding:'20px 6px',textAlign:'left',marginBottom:'40px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{style:{display:'block',fontSize:'24px',color:'#3060A0',fontWeight:'bold',paddingTop:'30px'}},this.getMessage('msgprimaria')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{style:{display:'block',fontSize:'24px',color:'#3060A0',marginTop:'8px',fontWeight:'bold'}},this.getMessage('msgsecundaria'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__pages_cadastros_cronograma_pagamentos_InfoCronograma__["a" /* default */],null));}}]);return Inicio;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);Inicio.defaultProps={configuracoesFrontend:null};Inicio.propTypes={configuracoesFrontend:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired};var mapStateToProps=function mapStateToProps(state){return{filtroBloqueio:state.base.filtroBloqueio,configuracoesFrontend:state.base.configuracoesFrontend};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(Inicio));

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__impressaoCronogramaPagamento_css__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__impressaoCronogramaPagamento_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__impressaoCronogramaPagamento_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MENSAGENS={noContentPrimary:'Não foi possível consultar o cronograma.',noContentSecondary:'Contate o administrador do sistema.',cronogramaNaoEncontrado:'Cronograma não encontrado para a chave informada.',informeCronogramaValido:'Informe um cronograma válido.'};var CLASSES_CSS={esconderPrint:'esconder-print',cabecalho:'dtp-header',logoUsuario:'user-target',footer:'dtp-footer'};var STYLES_CSS={painelGeral:{textAlign:'center',margin:'0 auto'},painelCronograma:{display:'inline-block',width:'460px',padding:'6px 6px'},itemCronograma:{display:'flex',padding:'3px',borderRadius:'8px',color:'#FFFFFF',height:'70px',marginBottom:'8px',boxShadow:'0 2px 6px rgba(0,0,0,.15)'},itemCronogramaData:{display:'inline-block',width:'71px',fontWeight:'500',fontSize:'20px',padding:'17px 6px 0',borderRight:'2px solid rgba(255, 255, 255, 0.9)',verticalAlign:'middle',flexGrow:'1'},itemCronogramaDescricao:{display:'inline-block',textAlign:'left',verticalAlign:'middle',fontWeight:'600',paddingTop:'12px',fontSize:'15px',marginLeft:'10px',flexGrow:'0',width:'367px'}};var ITEMS=[{cor:'rgba(0, 105, 177, 1)',descricao:'Consulta de débito dos entes federativos na RFB/PGFN e do contratação da Dataprev.'},{cor:'rgba(133, 104, 90, 1)',descricao:'Consulta de óbitos dos requerimentos do COMPREV.'},{cor:'rgba(98, 103, 16, 1)',descricao:'Fechamento da prévia da folha de pagamento do COMPREV.'},{cor:'rgba(91, 155, 213, 1)',descricao:'Início do período de consulta prévia da folha de pagamento.'},{cor:'rgba(191, 103, 163, 1)',descricao:'Fechamento da folha de pagamento do COMPREV.'},{cor:'rgba(0, 95, 107, 1)',descricao:'Disponibilização dos relatórios de pagamento com o fechamento.'},{cor:'rgba(110, 91, 110, 1)',descricao:'Envio do arquivo de pagamentos do RGPS ao Banco do Brasil.'},{cor:'rgba(192, 80, 77, 1)',descricao:'Prazo para pagamento dos valores devidos pelos regime.'},{cor:'rgba(226, 148, 2, 1)',descricao:'Marco Limite para Informar Rejeição de Pagamento.'},{cor:'rgba(103, 181, 136, 1)',descricao:'Marco Limite para Analisar Rejeição de Pagamento.'}];var InfoCronograma=function(_React$Component){_inherits(InfoCronograma,_React$Component);function InfoCronograma(props){_classCallCheck(this,InfoCronograma);var _this=_possibleConstructorReturn(this,(InfoCronograma.__proto__||Object.getPrototypeOf(InfoCronograma)).call(this,props));_this.getInitialState=function(){return{infoCronogramaAberto:_this.createCronograma(),infoCronogramaFechadoAntePenultimo:_this.createCronograma(),infoCronogramaFechado:_this.createCronograma(),dados:[],showNoContent:false,noContentPrimaryMessage:'',noContentSecondaryMessage:''};};_this.createCronograma=function(){return{ano:null,mes:null,dataCND:null,dataObitos:null,dataFechamentoPrevia:null,dataConsultaPrevia:null,dataFechamentoFolha:null,dataRelatoriosBG:null,dataEnvioBB:null,dataPrazoPagamento:null,dataPrazoDefesa:null,dataPrazoAnalise:null,competencia:null};};_this.mudarPrintClasses=function(action){var elements=[document.getElementsByClassName(CLASSES_CSS.cabecalho)[0],document.getElementsByClassName(CLASSES_CSS.logoUsuario)[0],document.getElementsByClassName(CLASSES_CSS.footer)[0]];elements.forEach(function(element){if(element)element.classList[action](CLASSES_CSS.esconderPrint);});};_this.buscaCronograma=function(){var url='cronogramas-pagamento/painel-cronograma';Object(__WEBPACK_IMPORTED_MODULE_2__utils_requests__["e" /* doGet */])(url,_this.handleSuccess,_this.handleError);};_this.handleSuccess=function(response){if(response.data){_this.setState({dados:response.data,infoCronogramaAberto:Object.assign({},_this.state.infoCronogramaAberto,response.data[0]),infoCronogramaFechado:Object.assign({},_this.state.infoCronogramaFechado,response.data[1]),infoCronogramaFechadoAntePenultimo:Object.assign({},_this.state.infoCronogramaFechadoAntePenultimo,response.data[2])});}};_this.handleError=function(error){var mensagemPrimaria=MENSAGENS.noContentPrimary;var mensagemSecundaria=MENSAGENS.noContentSecondary;if(error){if(error.status){if(error.status===404){mensagemPrimaria=MENSAGENS.cronogramaNaoEncontrado;mensagemSecundaria=MENSAGENS.informeCronogramaValido;}}}_this.setState(Object.assign({},_this.state,{showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria}));};_this.obterDiaMes=function(data){if(data){var lista=data.split('/');return lista[0]+'/'+lista[1];}return'';};_this.obterMesAno=function(data){if(data){var lista=data.split('/');return lista[1]+'/'+lista[2];}return'';};_this.gerarItem=function(cor,data,descricao,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,style:Object.assign({},STYLES_CSS.itemCronograma,{backgroundColor:cor}),className:'cronograma-card imprimirCronograma'+String(index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:STYLES_CSS.itemCronogramaData},_this.obterDiaMes(data)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:STYLES_CSS.itemCronogramaDescricao},descricao));};_this.renderCronograma=function(cronograma,titulo){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:STYLES_CSS.painelCronograma},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{color:'#3060a0',fontSize:'22px',textAlign:'left'}},titulo,': ',cronograma.competencia),ITEMS.map(function(item,index){return _this.gerarItem(item.cor,cronograma[Object.keys(cronograma)[index+2]],item.descricao,index);}));};_this.state=_this.getInitialState();return _this;}_createClass(InfoCronograma,[{key:'componentDidMount',value:function componentDidMount(){this.buscaCronograma();this.mudarPrintClasses('add');}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.mudarPrintClasses('remove');}},{key:'render',value:function render(){var _state=this.state,infoCronogramaAberto=_state.infoCronogramaAberto,infoCronogramaFechado=_state.infoCronogramaFechado,infoCronogramaFechadoAntePenultimo=_state.infoCronogramaFechadoAntePenultimo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.state.dados.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:Object.assign({},STYLES_CSS.painelGeral,{paddingBottom:'20px'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{style:{color:'#3060a0',fontSize:'24px',fontWeight:'600'}},'Cronograma Comprev'),this.renderCronograma(infoCronogramaFechadoAntePenultimo,'Competência Fechada'),this.renderCronograma(infoCronogramaFechado,'Competência Fechada'),this.renderCronograma(infoCronogramaAberto,'Competência Aberta')));}}]);return InfoCronograma;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);InfoCronograma.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({mes1:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ano1:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mes2:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ano2:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.function}),auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func})};InfoCronograma.defaultProps={match:null,auth:null,history:null};/* harmony default export */ __webpack_exports__["a"] = (InfoCronograma);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Mensagem=function(_Component){_inherits(Mensagem,_Component);function Mensagem(props){_classCallCheck(this,Mensagem);var _this=_possibleConstructorReturn(this,(Mensagem.__proto__||Object.getPrototypeOf(Mensagem)).call(this,props));_this.handleChange=function(chave,event){var listaMensagemAlterada=_this.props.listaMensagens.map(function(m){var mensagemAlterada=Object.assign({},m);if(mensagemAlterada.chave===chave){mensagemAlterada.valor=event.value;}return mensagemAlterada;});Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["F" /* salvarListaMensagens */])(listaMensagemAlterada);};_this.atualizarMensagens=function(){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["n" /* doPut */])('config/frontend/',{listaMensagens:_this.props.listaMensagens},_this.trataSucesso);};_this.trataSucesso=function(){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["J" /* trataMensagemSucesso */])(['Mensagem atualizado.']);};_this.renderRows=function(){var listaMensagensAtual=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(_this.props.listaMensagens||[],['id'],['desc']);return listaMensagensAtual.map(function(m){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["k" /* Input */],{maxlength:'255',label:m.descricao+' ('+m.chave+')',value:m.valor,onChange:function onChange(e){return _this.handleChange(m.chave,e);}});});};_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(Mensagem,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["e" /* DataGrid */],{title:'Configura\xE7\xE3o de Mensagens do Sistema',icon:'ico-doc-pencil'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["i" /* Grid */],{cols:'12 12 12 12'},this.renderRows(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{className:'dtp-primary right',title:'Alterar',onClick:this.atualizarMensagens,hint:'Alterar mensagens'}))));}}]);return Mensagem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Mensagem.propTypes={listaMensagens:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf({id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,chave:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,valor:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string}).isRequired};var mapStateToProps=function mapStateToProps(state){return{listaMensagens:state.base.listaMensagens};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Mensagem));

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cadastros_EntesFederativos_Rpps_OrgaoVinculado__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CadastroOrgaosVinculados=function(_Component){_inherits(CadastroOrgaosVinculados,_Component);function CadastroOrgaosVinculados(props,context){_classCallCheck(this,CadastroOrgaosVinculados);var _this=_possibleConstructorReturn(this,(CadastroOrgaosVinculados.__proto__||Object.getPrototypeOf(CadastroOrgaosVinculados)).call(this,props,context));_this.getInitialState=function(){return{orgaoVinculado:{cnpj:null,idParticipante:null,nomeOrgaoVinculado:null,situacao:null},cnpj:null,touched:false,validadeCampos:{cnpj:false,nomeOrgaoVinculado:false,situacao:true},abrangenciasEntidadeParticipanteRPPS:[],showNoContent:false,noContentPrimaryMessage:'Regime Próprio não encontrado para o cnpj informado.',noContentSecondaryMessage:'Informe um protocolo válido.'};};_this.handleErrorBusca=function(error){var mensagemPrimaria='Não foi possível consultar o regime próprio.';var mensagemSecundaria='Contate o administrador do sistema.';if(error){if(error.status){if(error.status===404){mensagemPrimaria='Ente  Federativo não encontrado para o filtro informado.';mensagemSecundaria='Informe um filtro válido.';}}}_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.formularioProntoParaEnvio=function(){return Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);};_this.buscarAbrangenciasEntidadeParticipanteRPPS=function(){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["o" /* requestAbrangenciasEntidadeParticipanteRPPS */])(_this.handleErrorBusca,'99999');};_this.montaFormulario=function(){_this.setState(_this.buscarAbrangenciasEntidadeParticipanteRPPS());};_this.handleModal=function(){_this.setState({showModal:!_this.state.showModal,acaoModal:_this.state.acaoModal});};_this.createCustomInsertButton=function(orgao){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.props.auth.checkPermission(['analisar-negocio-sprev'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Adicionar Org\xE3o Vinculado',icon:'ico-user-plus',onClick:function onClick(){return _this.incluirOrgaoVinculado(orgao);}}):'');};_this.createActionColumn=function(indice,orgao){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.props.auth.checkPermission(['analisar-negocio-sprev'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Editar Org\xE3o Vinculado',icon:'ico-pencil',mini:true,onClick:function onClick(){return _this.editOrgaoVinculado(indice,orgao);}}):'');};_this.addSituacaoLabel=function(situacaoSelecionado){var obj=Object(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */])(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["A" /* situacaoOrgaoVinculado */],situacaoSelecionado);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;// const obj = getObject(situacao, situacaoSelecionado);
// return obj.label;
};_this.montaOrgaoVinculadoTableHeader=function(){var tableHeader=[{id:'cnpj',label:'CNPJ'},{id:'nomeOrgaoVinculado',label:'Orgão'},{id:'situacao',label:'Situação',dataFormat:_this.addSituacaoLabel}];if(_this.props.auth.checkPermission(['analisar-negocio-sprev'])){tableHeader.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});}return tableHeader;};_this.options={hideSizePerPage:true,insertBtn:_this.createCustomInsertButton,noDataText:'Nenhum Orgão foi adicionado à lista',sizePerPage:5};_this.addOrgaoVinculado=function(orgao,edit){var _this$props=Object.assign({},_this.props),abrangenciasEntidadeParticipanteRPPS=_this$props.abrangenciasEntidadeParticipanteRPPS;if(edit){var orgaoVinculado=Object.assign({},orgao);if(orgaoVinculado.situacao===''){orgaoVinculado.situacao=0;orgaoVinculado.flagOperacao=2;}else{orgaoVinculado.flagOperacao=2;}abrangenciasEntidadeParticipanteRPPS[_this.state.cell]=orgaoVinculado;}else{var orgaoExisteNaLista=false;// const cnpjNovoOrgao = orgao.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
var cnpjNovoOrgao=orgao.cnpj.replace(/(.{2})(.{3})(.{3})(.{4})(.{2})/,'$1.$2.$3/$4-$5');abrangenciasEntidadeParticipanteRPPS.forEach(function(orgaoExistente){var orgaoAux=orgaoExistente;orgaoAux.cnpj=orgaoExistente.cnpj;if(orgaoAux.cnpj===cnpjNovoOrgao){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['O orgão já foi cadastrado anteriormente.']);orgaoExisteNaLista=true;}});if(orgaoExisteNaLista===false){var orgaoInclusao=orgao;orgaoInclusao.flagOperacao=1;// orgaoInclusao.idParticipante = null;
abrangenciasEntidadeParticipanteRPPS.unshift(orgaoInclusao);}}_this.alteraListaOrgaosVinculados(abrangenciasEntidadeParticipanteRPPS,null);};_this.editOrgaoVinculado=function(indice,orgaoVinculadoSelecionado){var errosOrgaoVinculadoSelecionado=null;if(_this.errosOrgaoVinculado){errosOrgaoVinculadoSelecionado=_this.errosOrgaoVinculado.filter(function(erro){return erro.indiceLista===indice;});}_this.setState({cell:indice,acaoModal:'edicao',orgaoVinculadoSelecionado:orgaoVinculadoSelecionado,errosOrgaoVinculadoSelecionado:errosOrgaoVinculadoSelecionado},_this.handleModal);};_this.incluirOrgaoVinculado=function(){_this.setState({acaoModal:'criacao'},_this.handleModal);};_this.validacaoErrosOrgaoVinculado=function(errosOrgaoVinculado){var camposInvalidos=null;// if (isDelete) {
//   camposInvalidos = errosOrgaoVinculado;
// } else {
camposInvalidos=_this.state.camposOrgaosVinculadosInvalidos.filter(function(erro){return errosOrgaoVinculado.includes(erro)?null:erro;});// }
_this.setState({camposOrgaosVinculadosInvalidos:camposInvalidos});};_this.handleChange=function(changeObj,name){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var _this$state=Object.assign({},_this.state),orgaoVinculado=_this$state.orgaoVinculado;_this.setState({orgaoVinculado:Object.assign({},orgaoVinculado,_defineProperty({},name,changeObj.value)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))},callback);};_this.montaValidadeCampos=function(periodo){var _this$state2=Object.assign({},_this.state),validadeCampos=_this$state2.validadeCampos;Object.keys(periodo).forEach(function(key){validadeCampos[key]=true;});return validadeCampos;};_this.handleChangeOrgaosVinculados=function(changeObj,name){var _this$state3=Object.assign({},_this.state),orgaoVinculado=_this$state3.orgaoVinculado;var validadeCampos=_this.montaValidadeCampos(orgaoVinculado);_this.setState({orgaoVinculado:Object.assign({},orgaoVinculado,_defineProperty({},name,changeObj)),validadeCampos:Object.assign({},validadeCampos)});};_this.alteraListaOrgaosVinculados=function(listaOrgaosVinculados,errosOrgaosVinculados){if(errosOrgaosVinculados){_this.validacaoErrosOrgaoVinculado(errosOrgaosVinculados,true);}_this.handleChangeOrgaosVinculados(listaOrgaosVinculados,'abrangenciasEntidadeParticipanteRPPS');};_this.resetOrgaoVinculadoSelecionado=function(){_this.setState({orgaoVinculadoSelecionado:null,acaoModal:null,errosOrgaoVinculadoSelecionado:null});};_this.handleSaveButton=function(){_this.confirmSendData();};_this.confirmSendData=function(){var touched=true;var url='abrangencia-entidade-participante';var _this$state4=Object.assign({},_this.state),validadeCampos=_this$state4.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});_this.setState({touched:touched,validadeCampos:validadeCampos,requestPesquisa:null},function(){return _this.handleSave(url);});};_this.handleSave=function(url){if(_this.formularioProntoParaEnvio()){// let { periodosVigencia } = { ...this.state };
var listaOrgaos=_this.props.abrangenciasEntidadeParticipanteRPPS;if(listaOrgaos&&listaOrgaos.length>0){var colecao=[];listaOrgaos.forEach(function(periodo){if(periodo.flagOperacao){colecao.push(periodo);}});if(colecao.length>0){listaOrgaos=colecao;}else{// não alterou e nem incluiu orgao vinculado
var listaAux=[];listaOrgaos.map(function(item,i){var itemIndexado=item;itemIndexado.contador=i;if(i<=5){listaAux.push(itemIndexado);}return listaAux;});listaOrgaos=[];listaOrgaos=listaAux;}}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["n" /* doPut */])(url,{orgaosVinculados:listaOrgaos},_this.trataSucesso);// doPut(
//   url,
//   regimeProprio,
//   this.trataSucessoResponseEnvio,
//   this.trataErrosResponse,
//   options,
// );
}else{Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Informe corretamente os atributos indicados na tela.']);}};_this.trataSucesso=function(){var mensagemSucesso='Orgão Vinculado atualizado.';// this.props.history.goBack();
_this.montaFormulario();_this.setState({estadoFormulario:'criado'});Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["J" /* trataMensagemSucesso */])([mensagemSucesso]);};_this.trataSucessoResponseEnvio=function(){if(_this.state.chaveConfirmacao){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta},_this.trataSucesso);}else{_this.trataSucesso();}};_this.state=_this.getInitialState();return _this;}_createClass(CadastroOrgaosVinculados,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["g" /* manterApenasFiltro */])('');this.montaFormulario();}/**
   * Determina quais colunas devem ser exibidas na tabela de dependentes
   *//**
   * Adiciona Orgao Vinculado a lista
   * FLAG OPERACAO = 1 - INCLUSAO
   * FLAG OPERACAO = 2 - ALTERACAO
   *//**
   * Altera um orgao da lista
   *//**
   * inclui um orgao da lista
   *//**
   * Remove a selecao do dependente
   *//**
  * Trata o click do botao de submissao do formulario
  * Se analise estiver indeferindo, exibir alerta de confirmacao
  *//**
  * Trata envio dos dados
  *//**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */},{key:'render',value:function render(){if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}var listaOrgaosVinculadosIndexada=this.props.abrangenciasEntidadeParticipanteRPPS.map(function(item,i){var itemIndexado=item;itemIndexado.acoes=i;// itemIndexado.cnpj = itemIndexado.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
itemIndexado.cnpj=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["d" /* formatarCnpj */])(itemIndexado.cnpj);return itemIndexado;});var modalOrgaoVinculado=this.state.showModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__cadastros_EntesFederativos_Rpps_OrgaoVinculado__["a" /* default */],{acaoModal:this.state.acaoModal,acao:this.props.acao,addOrgaoVinculado:this.addOrgaoVinculado,orgaoVinculado:this.state.orgaoVinculadoSelecionado,errosOrgaoVinculado:this.state.errosOrgaoVinculadoSelecionado,validacaoErrosOrgaoVinculado:this.validacaoErrosOrgaoVinculado,onHide:this.handleModal,resetOrgaoVinculado:this.resetOrgaoVinculadoSelecionado,showModal:true}):null;var botaoAcaoPrincipal=void 0;var configBotaoPrincipal={onClick:this.handleSaveButton};configBotaoPrincipal.permissoes=['analisar-negocio-sprev'];configBotaoPrincipal.titulo='Salvar';configBotaoPrincipal.hint='Salvar Período';var botaoAcaoVoltar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{className:'left',onClick:this.props.history.goBack,title:'Voltar',hint:'Voltar para tela anterior'});if(configBotaoPrincipal.titulo){botaoAcaoPrincipal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:configBotaoPrincipal.permissoes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:configBotaoPrincipal.titulo,onClick:configBotaoPrincipal.onClick,hint:configBotaoPrincipal.hint}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["e" /* DataGrid */],{title:'Dados dos Org\xE3os Vinculados',icon:'ico-users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["u" /* Table */],{bordered:true,data:listaOrgaosVinculadosIndexada,insertRow:'true',options:this.options,listaTableHeader:this.montaOrgaoVinculadoTableHeader(),pagination:true,fetchInfo:this.fetchInfo}),modalOrgaoVinculado),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},botaoAcaoVoltar,botaoAcaoPrincipal));}}]);return CadastroOrgaosVinculados;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CadastroOrgaosVinculados.propTypes={acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.function}).isRequired,abrangenciasEntidadeParticipanteRPPS:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({cnpj:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,situacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}),match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func})};CadastroOrgaosVinculados.defaultProps={match:null,auth:null,abrangenciasEntidadeParticipanteRPPS:[]};var mapStateToProps=function mapStateToProps(state){return{abrangenciasEntidadeParticipanteRPPS:state.base.abrangenciasEntidadeParticipanteRPPS};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(CadastroOrgaosVinculados));

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalCadastroPeriodos__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var CadastroPeriodos=function(_Component){_inherits(CadastroPeriodos,_Component);function CadastroPeriodos(props,context){_classCallCheck(this,CadastroPeriodos);var _this=_possibleConstructorReturn(this,(CadastroPeriodos.__proto__||Object.getPrototypeOf(CadastroPeriodos)).call(this,props,context));_this.getInitialState=function(){return{periodo:{cnpj:null,dataCriacaoRpps:null,dataEncerramentoRpps:null},validadeCampos:{dataCriacaoRpps:false,dataEncerramentoRpps:false},cnpj:null,botaoIncluirDesabilitado:true,periodosVigencia:[],acao:'novo',acaoModal:'alterar',estadoFormulario:'inicial',noContentPrimaryMessage:'Período não encontrado.',noContentSecondaryMessage:'Informe outro período.',showModal:false,errosPeriodoSelecionado:null,periodoSelecionado:null};};_this.buscarPeriodosVigenciaRegimesProprios=function(){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["A" /* requestPeriodosVigencia */])(_this.handleErrorBusca,'99999');};_this.montaFormulario=function(){_this.setState(_this.buscarPeriodosVigenciaRegimesProprios());var _this$state=Object.assign({},_this.state),acao=_this$state.acao;var _this$state2=Object.assign({},_this.state),validadeCampos=_this$state2.validadeCampos;var paramPeriodosVigencia=_this.props.periodosVigencia;var paramBotaoIncluirDesabilitado=true;// let paramCnpj = '';
if(paramPeriodosVigencia&&paramPeriodosVigencia.length>0){// paramCnpj = paramPeriodosVigencia[0].cnpj;
paramPeriodosVigencia.forEach(function(aux){if(!aux.dataEncerramentoRpps){paramBotaoIncluirDesabilitado=true;}else if(acao!=='criacao'&&aux.dataEncerramentoRpps!==null&&aux.dataEncerramentoRpps!==null){// habilitar o botao de inclusao
paramBotaoIncluirDesabilitado=false;}});validadeCampos.dataEncerramentoRpps=false;}else{paramBotaoIncluirDesabilitado=false;}_this.setState({botaoIncluirDesabilitado:paramBotaoIncluirDesabilitado,// cnpj: paramCnpj,
validadeCampos:Object.assign({},validadeCampos)});};_this.montaValidadeCampos=function(periodo){var _this$state3=Object.assign({},_this.state),validadeCampos=_this$state3.validadeCampos;Object.keys(periodo).forEach(function(key){validadeCampos[key]=true;});return validadeCampos;};_this.formularioProntoParaEnvio=function(){return Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);};_this.handleChange=function(changeObj,name){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var _this$state4=Object.assign({},_this.state),periodo=_this$state4.periodo;_this.setState({periodo:Object.assign({},periodo,_defineProperty({},name,changeObj.value)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))},callback);};_this.validacaoErrosPeriodo=function(errosPeriodos){var camposInvalidos=null;// if (isDelete) {
//   camposInvalidos = errosOrgaoVinculado;
// } else {
camposInvalidos=_this.state.camposOrgaosVinculadosInvalidos.filter(function(erro){return errosPeriodos.includes(erro)?null:erro;});// }
_this.setState({camposOrgaosVinculadosInvalidos:camposInvalidos});};_this.handleChangePeriodos=function(changeObj,name){var _this$state5=Object.assign({},_this.state),periodo=_this$state5.periodo;// let desabilitar = true;
var validadeCampos=void 0;// if (periodo) {
//   if (periodo.dataCriacaoRpps !== '' && periodo.dataEncerramentoRpps !== '') {
//     desabilitar = false;
//     validadeCampos = this.montaValidadeCampos(periodo);
//   }
// }
var paramAcao='';if(changeObj[0].flagOperacao===2){paramAcao='edicao';}else{paramAcao='criacao';}_this.setState({periodo:Object.assign({},periodo,_defineProperty({},name,changeObj)),cnpj:changeObj[0].cnpj,botaoIncluirDesabilitado:true,acao:paramAcao,validadeCampos:Object.assign({},validadeCampos)});};_this.alteraListaPeriodos=function(listaPeriodos,errosPeriodos){if(errosPeriodos){_this.validacaoErrosOrgaoVinculado(errosPeriodos,true);}_this.handleChangePeriodos(listaPeriodos,'periodosVigencia');};_this.addPeriodo=function(periodo,edit){var _this$props=Object.assign({},_this.props),periodosVigencia=_this$props.periodosVigencia;if(edit&&edit.cnpj==null&&edit.dataCriacaoRpps==null&&edit.dataEncerramentoRpps==null){edit=null;}if(edit){var periodoVigencia=Object.assign({},periodo);if(periodoVigencia.dataEncerramentoRpps!==''){periodoVigencia.flagOperacao=2;}periodosVigencia[_this.state.cell]=periodoVigencia;}else{var periodoInclusao=periodo;periodoInclusao.flagOperacao=1;if(periodosVigencia&&periodosVigencia.length>0){periodoInclusao.cnpj=periodosVigencia[0].cnpj;}periodosVigencia.unshift(periodoInclusao);}_this.alteraListaPeriodos(periodosVigencia,null);};_this.trataSucesso=function(){var _this$state6=Object.assign({},_this.state),acao=_this$state6.acao;var mensagemSucesso='Período criado.';if(acao!=='criacao'){mensagemSucesso='Período alterado.';}_this.montaFormulario();_this.setState({estadoFormulario:'criado'});Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["J" /* trataMensagemSucesso */])([mensagemSucesso]);};_this.trataSucessoResponseEnvio=function(){_this.trataSucesso();};_this.incluirPeriodo=function(){var _this$state7=Object.assign({},_this.state),cnpj=_this$state7.cnpj;if(_this.props.periodosVigencia&&_this.props.periodosVigencia.length>0){cnpj=_this.props.periodosVigencia[0].cnpj;}_this.setState({acaoModal:'criacao',cnpj:cnpj},_this.handleModal);};_this.createCustomInsertButton=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.props.auth.checkPermission(['analisar-negocio-sprev'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{disabled:_this.state.botaoIncluirDesabilitado,hint:'Adicionar Per\xEDodo',icon:'ico-user-plus',onClick:function onClick(){return _this.incluirPeriodo();}}):'');};_this.handleModal=function(){_this.setState({showModal:!_this.state.showModal,acaoModal:_this.state.acaoModal});};_this.editPeriodo=function(indice,periodo){var errosPeriodoSelecionado=null;if(_this.errosPeriodo){errosPeriodoSelecionado=_this.errosPeriodo.filter(function(erro){return erro.indiceLista===indice;});}_this.setState({cell:indice,acaoModal:'edicao',periodo:periodo,errosPeriodoSelecionado:errosPeriodoSelecionado},_this.handleModal);};_this.createActionColumn=function(indice,periodo){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.props.auth.checkPermission(['analisar-negocio-sprev'])&&!periodo.periodoFinalizado?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Alterar Per\xEDodo',icon:'ico-doc-pencil',mini:true,onClick:function onClick(){return _this.editPeriodo(indice,periodo);}}):'');};_this.options={hideSizePerPage:true,insertBtn:_this.createCustomInsertButton,noDataText:'Nenhum período adicionado à lista',sizePerPage:10};_this.montaTableHeader=function(){var tableHeader=[{id:'cnpj',label:'CNPJ'},{id:'dataCriacaoRpps',label:'Data de Criação'},{id:'dataEncerramentoRpps',label:'Data de Encerramento'}];if(_this.props.auth.checkPermission(['analisar-negocio-sprev'])){tableHeader.push({id:'acoes',label:'Ações',dataFormat:_this.createActionColumn});}return tableHeader;};_this.resetPeriodoSelecionado=function(){_this.setState({periodo:null,acaoModal:null,errosPeriodoSelecionado:null});};_this.handleSaveButton=function(){_this.confirmSendData();};_this.confirmSendData=function(){var touched=true;var url='regimes-proprios';var _this$state8=Object.assign({},_this.state),validadeCampos=_this$state8.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});_this.setState({touched:touched,validadeCampos:validadeCampos,requestPesquisa:null},function(){return _this.handleSave(url);});};_this.handleSave=function(url){if(_this.formularioProntoParaEnvio()){// let { periodosVigencia } = { ...this.state };
var listaPeriodosVigencia=_this.props.periodosVigencia;if(listaPeriodosVigencia&&listaPeriodosVigencia.length>0){var colecao=[];listaPeriodosVigencia.forEach(function(periodo){if(periodo.flagOperacao){colecao.push(periodo);}});if(colecao.length>0){listaPeriodosVigencia=colecao;}else{// não alterou e nem incluiu orgao vinculado
var listaAux=[];listaPeriodosVigencia.map(function(item,i){var itemIndexado=item;itemIndexado.contador=i;if(i<=5){listaAux.push(itemIndexado);}return listaAux;});listaPeriodosVigencia=[];listaPeriodosVigencia=listaAux;}}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["n" /* doPut */])(url,{periodosVigencia:listaPeriodosVigencia},_this.trataSucesso);}else{Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Informe corretamente os atributos indicados na tela.']);}};_this.state=_this.getInitialState();return _this;}_createClass(CadastroPeriodos,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["g" /* manterApenasFiltro */])('');this.montaFormulario();}/**
* Trata o click do botao de submissao do formulario
* Se analise estiver indeferindo, exibir alerta de confirmacao
*//**
* Trata envio dos dados
*/},{key:'render',value:function render(){var _this2=this;if(this.state.reset){return null;}if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}var listaPeriodosIndexada=this.props.periodosVigencia.map(function(item,i){var itemIndexado=item;itemIndexado.acoes=i;itemIndexado.cnpj=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["d" /* formatarCnpj */])(itemIndexado.cnpj);return itemIndexado;});var botaoAcaoPrincipal=void 0;var configBotaoPrincipal={onClick:this.handleSaveButton};configBotaoPrincipal.permissoes=['analisar-negocio-sprev'];configBotaoPrincipal.titulo='Salvar';configBotaoPrincipal.hint='Salvar Período';var botaoAcaoVoltar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{className:'left',onClick:this.props.history.goBack,title:'Voltar',hint:'Voltar para tela anterior'});if(configBotaoPrincipal.titulo){botaoAcaoPrincipal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:configBotaoPrincipal.permissoes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:configBotaoPrincipal.titulo,onClick:configBotaoPrincipal.onClick,hint:configBotaoPrincipal.hint}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["e" /* DataGrid */],{title:'Periodos RPPS da Uni\xE3o',icon:'ico-doc-book'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["u" /* Table */],{bordered:true,insertRow:'true',data:listaPeriodosIndexada,options:this.options,listaTableHeader:this.montaTableHeader(),pagination:true,fetchInfo:this.fetchInfo}),this.state.showModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ModalCadastroPeriodos__["a" /* default */],{auth:this.props.auth,acao:this.state.acao,acaoModal:this.state.acaoModal,periodo:this.state.periodo,cnpj:this.state.cnpj,habilitarCampoCpf:this.props.periodosVigencia.length===0,showModal:this.state.showModal,handleModal:function handleModal(){return _this2.handleModal('showModal');},handleChange:this.handleChange,addPeriodo:this.addPeriodo,onHide:this.handleModal,errosPeriodo:this.state.errosPeriodoSelecionado,validacaoErrosPeriodo:this.validacaoErrosPeriodo,resetPeriodo:this.resetPeriodoSelecionado}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},botaoAcaoVoltar,botaoAcaoPrincipal));}}]);return CadastroPeriodos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CadastroPeriodos.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({protocolo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.function}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}),periodosVigencia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({cnpj:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataCriacaoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dataEncerramentoRpps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};CadastroPeriodos.defaultProps={match:null,auth:null,periodosVigencia:[]};var mapStateToProps=function mapStateToProps(state){return{periodosVigencia:state.base.periodosVigencia};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(CadastroPeriodos));

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_validator_cnpjValidator__ = __webpack_require__(118);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalCadastroPeriodos=function(_Component){_inherits(ModalCadastroPeriodos,_Component);_createClass(ModalCadastroPeriodos,null,[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){var _state=Object.assign({},state),validadeCampos=_state.validadeCampos;if(props.periodo&&!state.didProps){if(props.errosPeriodo){props.errosPeriodo.forEach(function(item){validadeCampos[item.atributo]=false;});return{periodo:Object.assign({},props.periodo),validadeCampos:validadeCampos,errosPeriodo:props.errosPeriodo,touched:true,didProps:true};}return{periodo:Object.assign({},props.periodo),touched:true,didProps:true};}return null;}}]);function ModalCadastroPeriodos(props){_classCallCheck(this,ModalCadastroPeriodos);var _this=_possibleConstructorReturn(this,(ModalCadastroPeriodos.__proto__||Object.getPrototypeOf(ModalCadastroPeriodos)).call(this));_this.getInitialState=function(){var initialState={periodo:{cnpj:null,dataCriacaoRpps:null,dataEncerramentoRpps:null},touched:false,validadeCampos:{cnpj:false,dataCriacaoRpps:false// dataEncerramentoRpps: false,
},didUpdate:false,didProps:false,errosPeriodo:null,estadoFormulario:'inicial',cnpj:null};return initialState;};_this.popularCnpj=function(){var _this$state=Object.assign({},_this.state),periodo=_this$state.periodo;periodo.cnpj=_this.props.cnpj;_this.setState({periodo:Object.assign({},periodo)});};_this.formularioProntoParaEnvio=function(){return Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);};_this.resetState=function(){_this.setState(_this.getInitialState());_this.props.onHide();_this.props.resetPeriodo();};_this.handleButton=function(){var cnpjValido=Object(__WEBPACK_IMPORTED_MODULE_5__utils_validator_cnpjValidator__["a" /* default */])(_this.state.periodo.cnpj);if(!cnpjValido){Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["L" /* trataMensagensErro */])(['CNPJ Inválido. Informe um CNPJ válido.']);}else{var touched=true;_this.setState(Object.assign({},_this.state,{touched:touched}),_this.handleEnviar);}};_this.handleEnviar=function(){_this.props.addPeriodo(_this.state.periodo,_this.props.periodo);if(_this.state.errosOrgaoVinculado){_this.props.validacaoErrosOrgaoVinculado(_this.state.errosOrgaoVinculado);}_this.resetState();};_this.handleChange=function(changeObj,name){var _this$props=Object.assign({},_this.props),acao=_this$props.acao;var _this$state2=Object.assign({},_this.state),estadoFormulario=_this$state2.estadoFormulario;// const validadeCampos = { ...this.state };
if(acao==='novo'&&_this.state.errosOrgaoVinculado&&_this.state.errosOrgaoVinculado.length>=1){estadoFormulario='alterado';}// if (!this.props.habilitarCampoCpf) {
//   validadeCampos.cnpj = true;
// }
_this.setState({periodo:Object.assign({},_this.state.periodo,_defineProperty({},name,changeObj.value)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid)),estadoFormulario:estadoFormulario});};_this.desabilitaInput=function(listaAcoesEditaveis){return(// if (this.props.consulta) {
//   return true;
// }
!listaAcoesEditaveis.includes(_this.props.acaoModal));};_this.determinaTitulo=function(){var titulo=void 0;switch(_this.props.acaoModal){case'edicao':titulo='Edição de Período';break;default:titulo='Inclusão de Períodos';}return titulo;};_this.handleClose=function(){_this.setState(_this.props.handleModal('showAlteracaoValorMedioBeneficioModal'));};var state=_this.getInitialState();if(props.periodo){var _state2=Object.assign({},state),validadeCampos=_state2.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});state.validadeCampos=validadeCampos;}_this.state=state;return _this;}_createClass(ModalCadastroPeriodos,[{key:'componentDidMount',value:function componentDidMount(){this.popularCnpj();}// Para cada Input, sinalizar as acoes em que o mesmo pode ser alterado
// Escolhe o titulo do modal baseado na acao
},{key:'render',value:function render(){var _this2=this;var modalContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["g" /* DataGridSemHeader */],{title:'',icon:'ico-doc-book'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:!this.props.habilitarCampoCpf,error:!this.state.periodo.cnpj// integer
,label:'CNPJ',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].cnpj,onChange:function onChange(e){return _this2.handleChange(e,'cnpj');},required:true,showMask:true,touched:this.state.touched,value:this.state.periodo.cnpj})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:!this.props.auth.checkPermission(['analisar-negocio-sprev']),mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,label:'Data de Cria\xE7\xE3o',error:!this.state.periodo.dataCriacaoRpps,touched:this.state.touched,maxLength:'16',value:this.state.periodo.dataCriacaoRpps,required:this.props.auth.checkPermission(['analisar-negocio-sprev']),onChange:function onChange(e){return _this2.handleChange(e,'dataCriacaoRpps');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:!this.props.auth.checkPermission(['analisar-negocio-sprev']),mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].date,label:'Data de Encerramento',error:!this.state.periodo.dataEncerramentoRpps,touched:this.state.touched,maxLength:'16',value:this.state.periodo.dataEncerramentoRpps// required={(this.props.auth.checkPermission(['analisar-negocio-sprev']))}
,onChange:function onChange(e){return _this2.handleChange(e,'dataEncerramentoRpps');}})))));var modalFooter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{title:'Cancelar',onClick:this.resetState,hint:'Cancelar'}),this.props.auth.checkPermission(['analisar-negocio-sprev'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!this.formularioProntoParaEnvio(),title:this.props.periodo?'Salvar':'Adicionar',onClick:this.handleButton,hint:this.props.periodo?'Salvar período':'Adicionar período'}):''));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudomodal:modalContent,conteudofooter:modalFooter,onHide:this.resetState,showTitle:true,size:'lg',title:this.determinaTitulo()}));}}]);return ModalCadastroPeriodos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalCadastroPeriodos.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,cnpj:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalCadastroPeriodos);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Calculadora=function(_Component){_inherits(Calculadora,_Component);function Calculadora(props){_classCallCheck(this,Calculadora);var _this=_possibleConstructorReturn(this,(Calculadora.__proto__||Object.getPrototypeOf(Calculadora)).call(this,props));_this.handleChange=function(changeObj,name){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var _this$state=Object.assign({},_this.state),acrescimosLegaisPesquisa=_this$state.acrescimosLegaisPesquisa;_this.setState({acrescimosLegaisPesquisa:Object.assign({},acrescimosLegaisPesquisa,_defineProperty({},name,changeObj.value))},callback);};_this.handleKeyUp=function(e){var retorno=e.target.value;if(retorno.indexOf('_')!==-1){retorno=retorno.toString().replace('_','');}retorno=retorno.toString().replace(/\D/g,'');retorno=retorno.toString().replace(/(\d)(\d{11})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{8})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{5})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{2})$/,'$1,$2');e.target.value=retorno;return retorno;};_this.habilitarBotao=function(){var valido=false;var _this$state2=Object.assign({},_this.state),acrescimosLegaisPesquisa=_this$state2.acrescimosLegaisPesquisa;if(acrescimosLegaisPesquisa.dataVencimento&&acrescimosLegaisPesquisa.dataPagamento&&acrescimosLegaisPesquisa.valorBaseCalculo){valido=true;}return valido;};_this.handleCalcular=function(){var _this$state3=Object.assign({},_this.state),acrescimosLegaisPesquisa=_this$state3.acrescimosLegaisPesquisa;if(acrescimosLegaisPesquisa.dataVencimento&&acrescimosLegaisPesquisa.dataPagamento&&acrescimosLegaisPesquisa.valorBaseCalculo){var dataVencimento=acrescimosLegaisPesquisa.dataVencimento.replace(/\//g,'').replace(/_/g,'');var dataPagamento=acrescimosLegaisPesquisa.dataPagamento.replace(/\//g,'').replace(/_/g,'');var valorBaseCalculo=acrescimosLegaisPesquisa.valorBaseCalculo.replace(/\./g,'').replace(/,/g,'.');if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(dataPagamento,'DD/MM/YYYY').toDate()<__WEBPACK_IMPORTED_MODULE_2_moment___default()(dataVencimento,'DD/MM/YYYY').toDate()){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["L" /* trataMensagensErro */])(['A data de pagamento deve ser maior ou igual a data de vencimento.']);}else{var url='acrescimos-legais/'+dataVencimento+'/'+dataPagamento+'/'+valorBaseCalculo;Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])(url,_this.trataSucessoResponse);}}};_this.trataSucessoResponse=function(response){if(response.data){_this.setState({listaAcrescimosLegaisResultado:[response.data]});}};_this.recuperarColunasDescritivoMulta=function(){var cabecalhoTabela=[{id:'diasAtraso',label:'Dias de Atraso'},{id:'multaPorDia',label:'% Multa (diária)',dataFormat:_this.formatarPercentual},{id:'multaAcumulada',label:'% Multa (acumulada)',dataFormat:_this.formatarPercentual},{id:'valorTotalMulta',label:'Valor Total Multa',dataFormat:_this.formatarValor}];return cabecalhoTabela;};_this.recuperarColunasDescritivoJuroSelic=function(){var cabecalhoTabela=[{id:'listaMeAnoSelicAcumulada',label:'Meses Considerados',dataFormat:_this.formatarMesesConsiderados},{id:'selicAcumulada',label:'% Selic Acumulada',dataFormat:_this.formatarPercentual},{id:'valorTotalJuroSelicAcumulada',label:'Valor Total da Selic Acumulada',dataFormat:_this.formatarValor}];return cabecalhoTabela;};_this.recuperarColunasDescritivoJuroFixo=function(){var cabecalhoTabela=[{id:'juroFixo',label:'% Juro Fixo',dataFormat:_this.formatarPercentual},{id:'valorTotalJuroFixo',label:'Valor Total do Juro Fixo',dataFormat:_this.formatarValor}];return cabecalhoTabela;};_this.recuperarColunasCalculoFinal=function(){var cabecalhoTabela=[{id:'dataVencimento',label:'Data de Vencimento',dataFormat:_this.formatarData},{id:'dataPagamento',label:'Data de Pagamento',dataFormat:_this.formatarData},{id:'valorBaseCalculo',label:'Valor Base de Cálculo',dataFormat:_this.formatarValor},{id:'valorTotalMulta',label:'Valor Total da Multa',dataFormat:_this.formatarValor},{id:'valorTotalJuros',label:'Valor Total de Juros',dataFormat:_this.formatarValor},{id:'valorTotalPagamento',label:'Valor Total de Pagamento',dataFormat:_this.formatarValor}];return cabecalhoTabela;};_this.formatarValor=function(valor){var valorFormatado='0.0';if(valor){var formato={minimumFractionDigits:2,maximumFractionDigits:3,style:'currency',currency:'BRL'};valorFormatado=valor.toLocaleString('pt-BR',formato);}return valorFormatado;};_this.formatarPercentual=function(valor){var valorFormatado='0.0';if(valor){var formato={minimumFractionDigits:2,maximumFractionDigits:3};valorFormatado=valor.toLocaleString('pt-BR',formato);}return valorFormatado;};_this.formatarMesesConsiderados=function(lista){var listaMesesConsideradosFormatado='--------';if(lista){if(lista.length===1){listaMesesConsideradosFormatado=lista;}else{listaMesesConsideradosFormatado=lista[0].concat(' a ').concat(lista[lista.length-1]);}}return listaMesesConsideradosFormatado;};_this.formatarData=function(data){var dataFormatada='';if(data){dataFormatada=__WEBPACK_IMPORTED_MODULE_2_moment___default()(data).format('DD/MM/YYYY');}return dataFormatada;};_this.state={acrescimosLegaisPesquisa:{dataVencimento:null,dataPagamento:null,valorBaseCalculo:null},listaAcrescimosLegaisResultado:[]};return _this;}_createClass(Calculadora,[{key:'render',value:function render(){var _this2=this;var options={withoutNoDataText:true};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'calculo',panelId:'calculo-acrescimos-legais',icon:'ico-calc',title:'Calculadora de Acr\xE9scimos Legais'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].date,label:'Data de Vencimento',required:true,onChange:function onChange(e){return _this2.handleChange(e,'dataVencimento');},value:this.state.acrescimosLegaisPesquisa.dataVencimento})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{mask:__WEBPACK_IMPORTED_MODULE_5__utils_masks__["a" /* default */].date,label:'Data de Pagamento',required:true,onChange:function onChange(e){return _this2.handleChange(e,'dataPagamento');},value:this.state.acrescimosLegaisPesquisa.dataPagamento})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["k" /* Input */],{currency:true,showMask:false,label:'Valor em Atraso',maxLength:'16',required:true,value:this.state.acrescimosLegaisPesquisa.valorBaseCalculo,onChange:function onChange(e){return _this2.handleChange(e,'valorBaseCalculo');},onKeyUp:function onKeyUp(e){return _this2.handleKeyUp(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* Button */],{className:'dtp-primary',disabled:!this.habilitarBotao(),title:'Calcular',hint:'Calcular Acr\xE9scimos Legais',onClick:this.handleCalcular}))))),this.state.listaAcrescimosLegaisResultado!==null&&this.state.listaAcrescimosLegaisResultado.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["u" /* Table */],{bordered:true,legend:'Descritivo do c\xE1lculo da multa',data:this.state.listaAcrescimosLegaisResultado!==null?this.state.listaAcrescimosLegaisResultado:[],listaTableHeader:this.recuperarColunasDescritivoMulta(),options:options}),this.state.listaAcrescimosLegaisResultado!==null&&this.state.listaAcrescimosLegaisResultado.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["u" /* Table */],{bordered:true,legend:'Descritivo do c\xE1lculo do Juro Selic',data:this.state.listaAcrescimosLegaisResultado!==null?this.state.listaAcrescimosLegaisResultado:[],listaTableHeader:this.recuperarColunasDescritivoJuroSelic(),options:options}),this.state.listaAcrescimosLegaisResultado!==null&&this.state.listaAcrescimosLegaisResultado.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["u" /* Table */],{bordered:true,legend:'Descritivo do c\xE1lculo do Juro Fixo',data:this.state.listaAcrescimosLegaisResultado!==null?this.state.listaAcrescimosLegaisResultado:[],listaTableHeader:this.recuperarColunasDescritivoJuroFixo(),options:options}),this.state.listaAcrescimosLegaisResultado!==null&&this.state.listaAcrescimosLegaisResultado.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["u" /* Table */],{bordered:true,legend:'C\xE1lculo Final',data:this.state.listaAcrescimosLegaisResultado!==null?this.state.listaAcrescimosLegaisResultado:[],listaTableHeader:this.recuperarColunasCalculoFinal(),options:options}),this.state.listaAcrescimosLegaisResultado!==null&&this.state.listaAcrescimosLegaisResultado.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowFundamentacao'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Fundamenta\xE7\xE3o legal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'I - Multa de Mora'),' - Art. 70 da Portaria n\xBA 1400/2024',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'A multa de mora n\xE3o se aplica.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),this.state.listaAcrescimosLegaisResultado!==null&&this.state.listaAcrescimosLegaisResultado.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rowFundamentacao'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'II - Juros de Mora'),' - Art. 35 da Lei n\xBA 8.212/1991',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Os juros de mora devem ser calculados \xE0 taxa do Sistema Especial de Liquida\xE7\xE3o e Cust\xF3dia (SELIC), a partir do 1\xBA dia do m\xEAs subsequente ao vencimento do prazo at\xE9 o m\xEAs anterior ao do pagamento e de 1% no m\xEAs do pagamento.'));}}]);return Calculadora;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Calculadora.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(Calculadora));

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__templates_InfoPagamento__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__templates_infoPagamentoRGPS__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__templates_infoPagamentoGRU__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__templates_Mensagem__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__templates_NovaMensagem__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__templates_impressaoDetalheControlePagto_css__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__templates_impressaoDetalheControlePagto_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__templates_impressaoDetalheControlePagto_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable*/var classeParaInibirImpressao="esconder-print";var classeCabecalho='dtp-header';var classeLogoUsuario='user-target';var classeBotaoVoltar='dtp-btn';var PAGAMENTO_GRU_FORA_COMPREV='Pagamento efetuado fora do COMPREV (GPS ou GRU cobrança)';var DetalhePagamento=function(_React$Component){_inherits(DetalhePagamento,_React$Component);function DetalhePagamento(props,context){_classCallCheck(this,DetalhePagamento);var _this=_possibleConstructorReturn(this,(DetalhePagamento.__proto__||Object.getPrototypeOf(DetalhePagamento)).call(this,props,context));_this.getInitialState=function(){return{infoPagamento:{idControlePagamento:null,nomeEntidadePagadora:'',nomeEntidadeRecebedora:'',codigoBanco:'',nomeBanco:'',numeroAgencia:'',dvAgencia:'',numeroContaCorrente:'',dvContaCorrente:'',cnpj:'',mes:'',ano:'',valorCompensacao:'',dataVencimento:'',dataPagamentoAtraso:'',valorMulta:'',valorJuros:'',mensagens:[],estado:null,codigoParticipanteLogado:null,indicadorAtraso:null,novasMensagensPossiveis:[],grusTO:[],valorCarregado:null,dataPrazo:null},papelUsuarioLogado:null};};_this.definePapelFiltro=function(){var retorno='';var isAnalistaDcomp=_this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);var isRpps=_this.props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps','consultar-compensacao-rpps']);var isAnalistaSprev=_this.props.auth.checkPermission(['analisar-negocio-sprev']);var isAnalistaDtp=_this.props.auth.checkPermission(['analisar-negocio-dtpv']);if(isAnalistaDcomp){retorno='analista-rgps';}if(isRpps){retorno='analista-rpps';}if(isAnalistaSprev){retorno='analista-sprev';}if(isAnalistaDtp){retorno='analista-dtp';}_this.setState({papelUsuarioLogado:retorno});};_this.montaFormulario=function(){if(_this.props.match.params.idControlePagamento){_this.setState(_this.buscaPagamento(_this.props.match.params.idControlePagamento));}};_this.buscaPagamento=function(chave){var url='controle-pagamentos/'+chave+'/'+_this.props.match.params.tipoControle;Object(__WEBPACK_IMPORTED_MODULE_9__utils_requests__["e" /* doGet */])(url,_this.handleSuccess,_this.handleError);};_this.verificaIdGruNossoNumero=function(lista){if(lista&&lista.length>0){var listaMensagens=lista.map(function(mensagem){var mensagemIndexado=mensagem;mensagemIndexado.idGruNossoNumero=mensagem.idGruNossoNumero!=='0'?mensagem.idGruNossoNumero:PAGAMENTO_GRU_FORA_COMPREV;return mensagemIndexado;});_this.setState(Object.assign({},_this.state,{infoPagamento:{mensagens:listaMensagens}}));}};_this.handleSuccess=function(response){if(response.data){_this.setState({infoPagamento:Object.assign({},_this.state.infoPagamento,response.data)});}};_this.handleError=function(error){var mensagemPrimaria='Não foi possível consultar o pagamento.';var mensagemSecundaria='Contate o administrador do sistema.';if(error){if(error.status){if(error.status===404){mensagemPrimaria='Pagamento não encontrado para a chave informado.';mensagemSecundaria='Informe um pagamento válido.';}}}_this.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};_this.obterUltimoValorParcial=function(){var ultimoValorParcial=null;_this.state.infoPagamento.mensagens.filter(function(item){return item.valorParcial!==null&&item.valorParcial>0;}).map(function(item){return ultimoValorParcial=item.valorParcial;});return ultimoValorParcial;};_this.validaExibicaoDoChatMensagens=function(){return _this.state.infoPagamento.mensagens&&_this.state.infoPagamento.mensagens.length>0;};_this.renderDetalheComGRU=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__templates_infoPagamentoRGPS__["a" /* default */],{estadoFormulario:_this.state}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__templates_infoPagamentoGRU__["a" /* default */],{estadoFormulario:_this.state}));};_this.renderDetalheComGRUEMensagens=function(mensagemStyle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__templates_infoPagamentoRGPS__["a" /* default */],{estadoFormulario:_this.state}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__templates_infoPagamentoGRU__["a" /* default */],{estadoFormulario:_this.state}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,_this.validaExibicaoDoChatMensagens()&&_this.ordernarMensagens().map(function(msg){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__templates_Mensagem__["a" /* Mensagem */],{mensagem:msg,valorCompensacao:_this.state.infoPagamento.valorCompensacao,controlePagamento:_this.state.infoPagamento});}),_this.state.infoPagamento.mensagens.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:mensagemStyle},'N\xE3o h\xE1 mensagens entre os participantes deste pagamento.'),_this.state.infoPagamento.idControlePagamento&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__templates_NovaMensagem__["a" /* default */],{infoPagamento:_this.state.infoPagamento,acaoBuscarPagamento:_this.buscaPagamento,estadoFormulario:_this.state,handleChange:_this.handleChange,valorParcial:_this.obterUltimoValorParcial(),tipoControle:_this.props.match.params.tipoControle}),_this.state.infoPagamento.estado===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:Object.assign({},mensagemStyle,{padding:_this.state.infoPagamento.mensagens.length===0?'12px 0px 25px':'20px 0px 30px'})},'N\xE3o \xE9 poss\xEDvel apresentar defesa enquanto houver GRU em processamento. O processamento leva at\xE9 10 dias, ap\xF3s a data de vencimento da GRU. Aguardar o retorno para o estado "N\xE3o Pago" para apresentar defesa.')));};_this.ordernarMensagens=function(){var _this$state$infoPagam=Object.assign({},_this.state.infoPagamento),mensagens=_this$state$infoPagam.mensagens;return mensagens.sort(function(a,b){return a.idMensagem>b.idMensagem?1:b.idMensagem>a.idMensagem?-1:0;});};_this.renderDetalheComMensagens=function(mensagemStyle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__templates_InfoPagamento__["a" /* default */],{estadoFormulario:_this.state}),_this.validaExibicaoDoChatMensagens()&&_this.ordernarMensagens().map(function(msg){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__templates_Mensagem__["a" /* Mensagem */],{mensagem:msg,valorCompensacao:_this.state.infoPagamento.valorCompensacao,controlePagamento:_this.state.infoPagamento});}),_this.state.infoPagamento.mensagens.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:mensagemStyle},'N\xE3o h\xE1 mensagens entre os participantes deste pagamento.'),_this.state.infoPagamento.idControlePagamento&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__templates_NovaMensagem__["a" /* default */],{infoPagamento:_this.state.infoPagamento,acaoBuscarPagamento:_this.buscaPagamento,estadoFormulario:_this.state,handleChange:_this.handleChange,valorParcial:_this.obterUltimoValorParcial(),tipoControle:_this.props.match.params.tipoControle}),_this.state.infoPagamento.estado===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:Object.assign({},mensagemStyle,{padding:_this.state.infoPagamento.mensagens.length===0?'12px 0px 25px':'20px 0px 30px'})},'N\xE3o \xE9 poss\xEDvel apresentar defesa enquanto houver GRU em processamento. O processamento leva at\xE9 10 dias, ap\xF3s a data de vencimento da GRU. Aguardar o retorno para o estado "N\xE3o Pago" para apresentar defesa.'));};_this.renderDetalhe=function(){var mensagemStyle={margin:'auto',padding:'20px 0px 30px',color:'rgb(169 168 168)',textAlign:'center',fontSize:'17px',fontStyle:'italic'/*if (this.props.match.params.tipoControle === 'controle-pagamentos') {
      return (this.state.infoPagamento.tipoPagamento === 1) ? this.renderDetalheComGRU() : this.renderDetalheComMensagens();
    } else {
      return (this.state.infoPagamento.entidadeRecebedora === '01000') ? this.renderDetalheComGRUEMensagens() : this.renderDetalheComMensagens();
    }*/};return _this.state.infoPagamento.tipoPagamento===1?_this.renderDetalheComGRUEMensagens(mensagemStyle):_this.renderDetalheComMensagens(mensagemStyle);};_this.state=_this.getInitialState();return _this;}_createClass(DetalhePagamento,[{key:'componentDidMount',value:function componentDidMount(){this.montaFormulario();this.definePapelFiltro();var header=document.getElementsByClassName(classeCabecalho)[0];var logoUsuario=document.getElementsByClassName(classeLogoUsuario)[0];var botaoVoltar=document.getElementsByClassName(classeBotaoVoltar)[0];header.classList.add(classeParaInibirImpressao);logoUsuario.classList.add(classeParaInibirImpressao);botaoVoltar.classList.add(classeParaInibirImpressao);}},{key:'print',value:function print(){window.print();}},{key:'componentWillUnmount',value:function componentWillUnmount(){var header=document.getElementsByClassName(classeCabecalho)[0];var logoUsuario=document.getElementsByClassName(classeLogoUsuario)[0];var botaoVoltar=document.getElementsByClassName(classeBotaoVoltar)[0];header.classList.remove(classeParaInibirImpressao);logoUsuario.classList.remove(classeParaInibirImpressao);botaoVoltar.classList.add(classeParaInibirImpressao);}},{key:'render',value:function render(){var botaoAcaoVoltar=void 0;botaoAcaoVoltar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{className:'left',onClick:this.props.history.goBack//onClick={this.print}
,title:'Voltar',hint:'Voltar para tela anterior'});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'print-detalhamento-cp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["j" /* DtpContentContainer */],null,this.renderDetalhe(),botaoAcaoVoltar));}}]);return DetalhePagamento;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);DetalhePagamento.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,idControlePagamento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tipoControle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.function}).isRequired,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};DetalhePagamento.defaultProps={match:null,readOnly:null};/* harmony default export */ __webpack_exports__["a"] = (DetalhePagamento);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoPagamento=function(_React$Component){_inherits(InfoPagamento,_React$Component);function InfoPagamento(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InfoPagamento);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InfoPagamento.__proto__||Object.getPrototypeOf(InfoPagamento)).call.apply(_ref,[this].concat(args))),_this),_this.textoDestaque=function(texto){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'600'}},texto);},_this.formatarCompetencia=function(mes,ano){var objCompetencia=mes+'/'+ano;if(objCompetencia.length!==7){objCompetencia='0'+objCompetencia;}return objCompetencia;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InfoPagamento,[{key:'getTagStatus',value:function getTagStatus(){var listaEstados=__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["g" /* estadosPagamento */];if(this.props.estadoFormulario.infoPagamento.idControlePagamento){var estadoCss='';switch(this.props.estadoFormulario.infoPagamento.estado){case 1:estadoCss='estadoAberto';break;case 2:estadoCss='estadoEmProcessamento';break;case 3:estadoCss='estadoContestado';break;case 4:estadoCss='estadoAguardandoAnaliseDefesa';break;case 5:estadoCss='estadoPago';break;case 6:estadoCss='estadoRejeitado';break;case 7:estadoCss='estadoNaoPago';break;case 8:estadoCss='estadoNaoMonitorado';break;case 9:estadoCss='estadoEmAnaliseDefesaRegularidadePagamento';break;case 10:estadoCss='estadoEmAnaliseDefesaGru';break;case 11:estadoCss='estadoEmAnaliseDefesaExtraordinaria';break;case 12:estadoCss='estadoContestacaoExtraordinaria';break;default:estadoCss='';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:estadoCss,style:{textAlign:'center',fontSize:'12px',maxWidth:'inherit',padding:'5px 7px 5px 7px',minHeight:'inherit'}},__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */](listaEstados,this.props.estadoFormulario.infoPagamento.estado).label);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'.');}// formatarValor = (valor) => {
//   let valorFormatado = '0.0';
//   if ((valor !== undefined) && (valor !== null)) {
//     const formato = {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 3,
//       style: 'currency',
//       currency: 'BRL',
//     };
//     if (valor === 0 || valor === '') {
//       return 'R$ 0,00';
//     }
//     valorFormatado = valor.toLocaleString('pt-BR', formato);
//   }
//   return valorFormatado;
// };
},{key:'render',value:function render(){var rowStyle={marginBottom:'10px',fontSize:'16px'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["y" /* DtpPanel */],{title:'Informa\xE7\xF5es do Pagamento'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right'}},this.getTagStatus()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Pagador: '),'  ',this.props.estadoFormulario.infoPagamento.nomeEntidadePagadora)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'5 5 5 5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Recebedor: '),'  ',this.props.estadoFormulario.infoPagamento.nomeEntidadeRecebedora)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Prazo Resposta: '),'  ',this.props.estadoFormulario.infoPagamento.dataPrazo,' ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Banco: '),this.props.estadoFormulario.infoPagamento.codigoBanco+' - '+this.props.estadoFormulario.infoPagamento.nomeBanco)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Agência: '),this.props.estadoFormulario.infoPagamento.numeroAgencia+' - '+this.props.estadoFormulario.infoPagamento.dvAgencia)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Conta corrente: '),this.props.estadoFormulario.infoPagamento.numeroContaCorrente+' - '+this.props.estadoFormulario.infoPagamento.dvContaCorrente)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('CNPJ RPPS: '),'  ',Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["d" /* formatarCnpj */])(this.props.estadoFormulario.infoPagamento.cnpj))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Competência: '),this.formatarCompetencia(this.props.estadoFormulario.infoPagamento.mes,this.props.estadoFormulario.infoPagamento.ano))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Valor: '),'  ',Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["e" /* formatarValor */])(this.props.estadoFormulario.infoPagamento.valorCompensacao))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Vencimento: '),'  ',this.props.estadoFormulario.infoPagamento.dataVencimento,' ')))),this.props.estadoFormulario.infoPagamento.dataPagamentoAtraso&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'dtp-datagrid-header',style:{fontSize:'18px'}},'Pagamento em atraso')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Data do pagamento: '),'  ',this.props.estadoFormulario.infoPagamento.dataPagamentoAtraso)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Multa: '),'  ',Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["e" /* formatarValor */])(this.props.estadoFormulario.infoPagamento.valorMulta))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Juros: '),'  ',Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["e" /* formatarValor */])(this.props.estadoFormulario.infoPagamento.valorJuros),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Valor total: '),' ',Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["e" /* formatarValor */])(this.props.estadoFormulario.infoPagamento.valorCompensacao+this.props.estadoFormulario.infoPagamento.valorMulta+this.props.estadoFormulario.infoPagamento.valorJuros)))))));}}]);return InfoPagamento;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);InfoPagamento.propTypes={estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (InfoPagamento);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import moment from 'moment';
var InfoPagamentoRGPS=function(_React$Component){_inherits(InfoPagamentoRGPS,_React$Component);function InfoPagamentoRGPS(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InfoPagamentoRGPS);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InfoPagamentoRGPS.__proto__||Object.getPrototypeOf(InfoPagamentoRGPS)).call.apply(_ref,[this].concat(args))),_this),_this.textoDestaque=function(texto){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'600'}},texto);},_this.textoInformativo=function(texto){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'500'}},texto);},_this.formatarCompetencia=function(mes,ano){var objCompetencia=mes+'/'+ano;if(objCompetencia.length!==7){objCompetencia='0'+objCompetencia;}return objCompetencia;},_this.buscaGruPelaData=function(data,grusPagas){// const datas = this.props.estadoFormulario.infoPagamento.grusTO.filter(gru => (
//   gru.dataVencimento === data
// ));
var datas=grusPagas.filter(function(gru){return gru.dataVencimento===data;});return datas;},_this.buscaRegistroComMaiorDataVencimento=function(){var grusPagas=_this.props.estadoFormulario.infoPagamento.grusTO.filter(function(gru){return gru.situacao===2&&gru.dataPagamento!==undefined;});var datas=Math.max.apply(Math,_toConsumableArray(grusPagas.map(function(gru){var dateString=gru.dataVencimento;var dateParts=dateString.split('/');var dateObject=new Date(+dateParts[2],dateParts[1]-1,+dateParts[0]);return dateObject;})));return _this.buscaGruPelaData(new Date(datas).toLocaleDateString(),grusPagas);// return this.buscaGruPelaData(gruPagaComMaiorData.dataVencimento);
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InfoPagamentoRGPS,[{key:'getTagStatus',value:function getTagStatus(){var listaEstados=__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["g" /* estadosPagamento */];if(this.props.estadoFormulario.infoPagamento.idControlePagamento){var estadoCss='';switch(this.props.estadoFormulario.infoPagamento.estado){case 1:estadoCss='estadoAberto';break;case 2:estadoCss='estadoEmProcessamento';break;case 3:estadoCss='estadoContestado';break;case 4:estadoCss='estadoAguardandoAnaliseDefesa';break;case 5:estadoCss='estadoPago';break;case 6:estadoCss='estadoRejeitado';break;case 7:estadoCss='estadoNaoPago';break;case 8:estadoCss='estadoNaoMonitorado';break;case 9:estadoCss='estadoEmAnaliseDefesaRegularidadePagamento';break;case 10:estadoCss='estadoEmAnaliseDefesaGru';break;case 11:estadoCss='estadoEmAnaliseDefesaExtraordinaria';break;case 12:estadoCss='estadoContestacaoExtraordinaria';break;default:estadoCss='';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:estadoCss,style:{textAlign:'center',fontSize:'12px',maxWidth:'inherit',padding:'5px 7px 5px 7px',minHeight:'inherit'}},__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["n" /* getObject */](listaEstados,this.props.estadoFormulario.infoPagamento.estado).label);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'.');}// formatarValor = (valor) => {
//   let valorFormatado = '0.0';
//   if ((valor !== undefined) && (valor !== null)) {
//     const formato = {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 3,
//       style: 'currency',
//       currency: 'BRL',
//     };
//     if (valor === 0 || valor === '') {
//       return 'R$ 0,00';
//     }
//     valorFormatado = valor.toLocaleString('pt-BR', formato);
//   }
//   return valorFormatado;
// };
// gru.situacao === 2
},{key:'render',value:function render(){var _this2=this;var rowStyle={marginBottom:'10px',fontSize:'16px'};var infomativoStyle={margin:'18px 0px 10px 0px',fontSize:'16px'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["y" /* DtpPanel */],{title:'Informa\xE7\xF5es do Pagamento RGPS'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right'}},this.getTagStatus()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Pagador: '),'  ',this.props.estadoFormulario.infoPagamento.nomeEntidadePagadora)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('CNPJ RPPS: '),'  ',Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["d" /* formatarCnpj */])(this.props.estadoFormulario.infoPagamento.cnpjPagador))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'7 7 7 7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Recebedor: '),'  ',this.props.estadoFormulario.infoPagamento.nomeEntidadeRecebedora)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Competência: '),this.formatarCompetencia(this.props.estadoFormulario.infoPagamento.mes,this.props.estadoFormulario.infoPagamento.ano))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Valor: '),'  ',Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["e" /* formatarValor */])(this.props.estadoFormulario.infoPagamento.valorCompensacao))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Vencimento: '),'  ',this.props.estadoFormulario.infoPagamento.dataVencimento,' ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Débito carregado:'),' ',this.props.estadoFormulario.infoPagamento.indicadorCobrancaCarregada===1?'Sim':'Não')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'7 7 7 7'},this.props.estadoFormulario.infoPagamento.indicadorCobrancaCarregada===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Valor débito carregado: '),'  ',Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["e" /* formatarValor */])(this.props.estadoFormulario.infoPagamento.valorCarregado)):''))),this.buscaRegistroComMaiorDataVencimento().map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this2.textoDestaque('Multa: '),'  ',Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["e" /* formatarValor */])(element.valorMulta))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this2.textoDestaque('Juros: '),'  ',Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["e" /* formatarValor */])(element.valorJuros),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this2.textoDestaque('Valor do documento: '),'  ',Object(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["e" /* formatarValor */])(element.valorDocumento)))));})// this.buscaRegistroComMaiorDataVencimento() moment(gru.dataVencimento, 'DD/MM/YYYY').toDate() >= moment(new Date().toLocaleDateString(), 'DD/MM/YYYY').toDate()
,this.props.estadoFormulario.infoPagamento.indicadorCobrancaCarregada===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:infomativoStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoInformativo('Esta cobrança foi carregada na versão 3.6.0 do Comprev, através de um levantamento de débitos feito pelo RGPS.'+' Caso discorde do valor ou da cobrança, favor apresentar uma defesa de regularidade do pagamento para que seja analisada pelo RGPS.')))):'');}}]);return InfoPagamentoRGPS;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);InfoPagamentoRGPS.propTypes={estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (InfoPagamentoRGPS);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable*/var InfoPagamentoGRU=function(_React$Component){_inherits(InfoPagamentoGRU,_React$Component);function InfoPagamentoGRU(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InfoPagamentoGRU);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InfoPagamentoGRU.__proto__||Object.getPrototypeOf(InfoPagamentoGRU)).call.apply(_ref,[this].concat(args))),_this),_this.textoDestaque=function(texto){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'600',marginLeft:'10px'}},texto);},_this.compararDatas=function(a,b){if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.dataVencimento,'DD/MM/YYYY').toDate()<__WEBPACK_IMPORTED_MODULE_2_moment___default()(b.dataVencimento,'DD/MM/YYYY').toDate()){return-1;}if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(a.dataVencimento,'DD/MM/YYYY').toDate()>__WEBPACK_IMPORTED_MODULE_2_moment___default()(b.dataVencimento,'DD/MM/YYYY').toDate()){return 1;}return 0;},_this.ordenarLista=function(lista){return lista.sort(_this.compararDatas);},_this.buscaGruPelaData=function(data){var datas=_this.props.estadoFormulario.infoPagamento.grusTO.filter(function(gru){return gru.dataVencimento===data;});return datas;},_this.buscaRegistroComMaiorDataVencimento=function(){var datas=Math.max.apply(Math,_toConsumableArray(_this.props.estadoFormulario.infoPagamento.grusTO.map(function(gru){var dateString=gru.dataVencimento;var dateParts=dateString.split('/');var dateObject=new Date(+dateParts[2],dateParts[1]-1,+dateParts[0]);return dateObject;})));return _this.buscaGruPelaData(new Date(datas).toLocaleDateString());},_this.buscaTipoSituacaoGru=function(situacao){var buscaTipoSituacao=__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["O" /* tipoSituacaoGRUControlePagamento */];var situacaoFormatada=__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["n" /* getObject */](buscaTipoSituacao,situacao).label;return situacaoFormatada;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InfoPagamentoGRU,[{key:'render',value:function render(){var _this2=this;var rowStyle={marginBottom:'10px',fontSize:'16px'};var rowStyleGuias={marginTop:'20px',marginBottom:'10px',fontSize:'16px'};/* const rowStyleGuiasVencidasNossoNumero = {
    marginTop: '20px',
    marginBottom: '10px',
    fontSize: '16px',
    textAlign: 'left',
  }; *//* const rowStyleGuiasVencidas = {
    marginTop: '20px',
    marginBottom: '10px',
    marginLeft: '20px',
    marginRight: '15px',
    fontSize: '16px',
    textAlign: 'left',
  }; */return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["y" /* DtpPanel */],{title:'Informa\xE7\xF5es do Pagamento GRU'},this.buscaRegistroComMaiorDataVencimento().filter(function(gru){return __WEBPACK_IMPORTED_MODULE_2_moment___default()(gru.dataVencimento,'DD/MM/YYYY').toDate()>=__WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date().toLocaleDateString(),'DD/MM/YYYY').toDate();}).map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this2.textoDestaque('Guia de recolhimento (GRU): '),element.idGruNossoNumero)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this2.textoDestaque('gerada em: '),element.dataCriacao)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this2.textoDestaque('Vencimento: '),element.dataVencimento)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this2.textoDestaque('Situação: '),_this2.buscaTipoSituacaoGru(element.situacao))))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyleGuias},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["i" /* Grid */],{cols:'12 12 12 12'},this.props.estadoFormulario.infoPagamento.grusTO&&this.props.estadoFormulario.infoPagamento.grusTO.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Guias vencidas')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.textoDestaque('Sem guias vencidas'))))),this.ordenarLista(this.props.estadoFormulario.infoPagamento.grusTO).filter(function(gru){return __WEBPACK_IMPORTED_MODULE_2_moment___default()(gru.dataVencimento,'DD/MM/YYYY').toDate()<__WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date().toLocaleDateString(),'DD/MM/YYYY').toDate();}).map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyleGuias},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["i" /* Grid */],{cols:'12 12 12 12'},_this2.textoDestaque('GRU: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.idGruNossoNumero),_this2.textoDestaque('gerada em: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.dataCriacao),_this2.textoDestaque('vencimento: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,element.dataVencimento))));}));}}]);return InfoPagamentoGRU;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);InfoPagamentoGRU.propTypes={estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (InfoPagamentoGRU);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mensagem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DownloadArquivoMsg__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tiposMensagens__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(7);
/* eslint-disable */var rowStyle={marginBottom:'13px',fontSize:'16px',textAlign:'justify'};var textoDestaque=function textoDestaque(texto){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'600'}},texto);};var PAGAMENTO_GRU_FORA_COMPREV='Pagamento efetuado fora do COMPREV (GPS ou GRU cobrança)';// const formatarValor = (valor) => {
//     let valorFormatado = '0.0';
//     if (valor !== null) {
//         const formato = {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 3,
//         style: 'currency',
//         currency: 'BRL',        
//         };
//         valorFormatado = valor.toLocaleString('pt-BR', formato);
//     }
//     return valorFormatado;
// };
var montarTituloGru=function montarTituloGru(mensagem,grusTO){var retorno='';if(mensagem.idGruNossoNumero&&grusTO&&grusTO.length>0){var index=grusTO.findIndex(function(gru){return gru.idGruNossoNumero===mensagem.idGruNossoNumero;});if(index!==-1){retorno=mensagem.idGruNossoNumero+' gerada em '+grusTO[index].dataCriacao+' com vencimento em '+grusTO[index].dataVencimento;}else{retorno=mensagem.idGruNossoNumero;}}else if(mensagem.idGruNossoNumero===undefined&&mensagem.tipoMensagem===12){retorno=PAGAMENTO_GRU_FORA_COMPREV;}return retorno;};var contarNumeroMensagensContestacao=function contarNumeroMensagensContestacao(tipo,mensagens){var cont=0;mensagens.forEach(function(item){if(item.tipoMensagem===tipo){cont+=1;}});return cont;};var obterMensagem=function obterMensagem(tipo,ehSistema,mensagens){var retorno='';var contadorMensagemTipo2=0;var contadorMensagemTipo1=0;if(tipo===8){contadorMensagemTipo1=contarNumeroMensagensContestacao(1,mensagens);contadorMensagemTipo2=contarNumeroMensagensContestacao(2,mensagens);if(contadorMensagemTipo1>1||contadorMensagemTipo2>1){retorno='Pagamento reprovado automaticamente por falta de aprovação';}}else{if(ehSistema){retorno=Object(__WEBPACK_IMPORTED_MODULE_5__tiposMensagens__["a" /* obterTipoMensagem */])(tipo).msgSistema;}else{retorno=Object(__WEBPACK_IMPORTED_MODULE_5__tiposMensagens__["a" /* obterTipoMensagem */])(tipo).descricaoMotivo;}}return retorno;};var Mensagem=function Mensagem(props){var mensagem=props.mensagem;var tipo=props.mensagem.tipoMensagem;var ehContestacao=tipo===1||tipo===2;var ehContestacaoExtraordinaria=tipo===16;var ehDefesaExtraordinaria=tipo===15;var ehDefesa=tipo===3||tipo===4||tipo===5||tipo===9||tipo===12||tipo===15;// const ehTermino = (tipo === 6 || tipo === 7 || tipo === 8);
var ehSistema=props.mensagem.tipoEmissor===3;/*define a margem de acordo o tipo de mensagem*/var margin='0 5%';/*margim de termino*/if(ehContestacao||ehContestacaoExtraordinaria||ehDefesaExtraordinaria){margin='0 20% 0 0';};if(ehDefesa){margin='0 0 0 20%';};/*define titulo painel*/var tituloPainel="Conclusão da análise";/*texto de termino da análise*/if(ehContestacao){tituloPainel='Contestação';};if(ehDefesa){tituloPainel='Defesa';};if(ehContestacaoExtraordinaria){tituloPainel='Contestação Extraordinária';};if(ehDefesaExtraordinaria){tituloPainel='Defesa Extraordinária';};tituloPainel=tituloPainel+' - '+props.mensagem.dataMensagemFormatada;/* Motivo do tipo da mensagem */var motivo=Object(__WEBPACK_IMPORTED_MODULE_5__tiposMensagens__["a" /* obterTipoMensagem */])(tipo).motivo;// let descricaoMotivo = ehSistema ? obterTipoMensagem(tipo).msgSistema : obterTipoMensagem(tipo).descricaoMotivo;
var descricaoMotivo=obterMensagem(tipo,ehSistema,props.controlePagamento.mensagens);/*Mensagem de rejeição RGPS*/if(!ehSistema&&tipo===7&&props.mensagem.tipoEmissor===2){descricaoMotivo='O INSS informou pagamento rejeitado por divergência de dados bancários.';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:margin,backgroundColor:'white'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["y" /* DtpPanel */],{title:tituloPainel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right',color:'white'}},props.mensagem.idMensagem),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,textoDestaque(motivo))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,descricaoMotivo)))),(!ehSistema||!ehSistema&&tipo!==7)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,tipo===12&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'dtp-datagrid-header',style:{fontSize:'16px',fontWeight:'600',color:'#44707B',marginRight:"30px"}},'Op\xE7\xE3o de pagamento'),tipo===12&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,montarTituloGru(mensagem,props.controlePagamento.grusTO),'\xA0\xA0\xA0\xA0')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'dtp-datagrid-header',style:{fontSize:'16px',fontWeight:'600',color:'#44707B',marginRight:"30px"}},'Observa\xE7\xE3o do analista'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,mensagem.textoMensagem)))),mensagem.valorParcial&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'dtp-datagrid-header',style:{fontSize:'16px',fontWeight:'600',color:'#44707B',marginRight:"30px"}},'Valor parcial informado'),mensagem.valorParcial&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,textoDestaque(Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["e" /* formatarValor */])(mensagem.valorParcial)))))),mensagem.dataPagamento&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Data do pagamento do valor total: ',textoDestaque(mensagem.dataPagamento))))),[9,10].includes(tipo)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'dtp-datagrid-header',style:{fontSize:'16px',fontWeight:'600',color:'#44707B',marginRight:"30px"}},'Novo valor de cobran\xE7a'):'',[9,10].includes(tipo)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["e" /* formatarValor */])(mensagem.valorCobrancaAtualizado))))):'',9===tipo&&(mensagem.valorCobrancaAtualizado===null||mensagem.valorCobrancaAtualizado===''||mensagem.valorCobrancaAtualizado===0)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,textoDestaque('Não reconheço esse valor'))))):'',10===tipo&&(mensagem.valorCobrancaAtualizado===null||mensagem.valorCobrancaAtualizado===''||mensagem.valorCobrancaAtualizado===0)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,textoDestaque('Cobrança cancelada'))))):'',mensagem.valorJuros?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Valor total: ',textoDestaque(Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["e" /* formatarValor */])(props.valorCompensacao+mensagem.valorMulta+mensagem.valorJuros)),'\xA0\xA0\xA0\xA0','(multa: '+Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["e" /* formatarValor */])(mensagem.valorMulta)+'  + juros: '+Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["e" /* formatarValor */])(mensagem.valorJuros)+")")))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'dtp-datagrid-header',style:{fontSize:'16px',fontWeight:'600',color:'#44707B',marginRight:"30px"}},'Informa\xE7\xF5es de contato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'E-mail: ',mensagem.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,mensagem.informacoesContato)))),mensagem.documentosMensagem&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DownloadArquivoMsg__["a" /* DownloadArquivoMsg */],{arquivos:mensagem.documentosMensagem}))));};Mensagem.propTypes={mensagem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired};/* unused harmony default export */ var _unused_webpack_default_export = (Mensagem);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownloadArquivoMsg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_requests__ = __webpack_require__(3);
/* eslint-disable */var DownloadArquivoMsg=function DownloadArquivoMsg(props){// console.log(props.arquivos)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},props.arquivos.map(function(arquivo,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["i" /* Grid */],{cols:'2',style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["a" /* Button */],{flat:true,mini:'true',hint:'baixar arquivo',icon:'ico-download',onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_2__utils_requests__["h" /* doGetFileMsgPagamento */])(arquivo.idDocumento,arquivo.legenda);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,arquivo.legenda));}))));};

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CalculadoraPagamento__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__templates_UploadArquivosMsg__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tiposMensagens__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable*/var rowStyle={marginBottom:'10px',fontSize:'16px'};var spanStyle={margin:'0px',position:'relative',color:'#44707B',padding:'5px',fontSize:'14px'};var pemissoesAcaoPrincipal=['analisar-compensacao-rgps','analisar-compensacao-rpps','requerer-compensacao-rgps','requerer-compensacao-rpps','gerenciar-negocio-dcomp'];var VAZIO='';var PAGAMENTO_GRU_FORA_COMPREV='Pagamento efetuado fora do COMPREV (GPS ou GRU cobrança)';var NovaMensagem=function(_React$Component){_inherits(NovaMensagem,_React$Component);function NovaMensagem(props,context){_classCallCheck(this,NovaMensagem);var _this=_possibleConstructorReturn(this,(NovaMensagem.__proto__||Object.getPrototypeOf(NovaMensagem)).call(this,props,context));_this.getInitialState=function(){return{readOnly:false,opcaoNovaMensagem:null,arquivos:[],sucessoUpload:false,mensagem:{idControlePagamento:null,idMensagem:null,motivo:null,textoMensagem:null,valorParcial:_this.props.valorParcial,dataPagamento:null,email:null,informacoesContato:null,cpf:null,nomeUsuario:null,tipoMensagem:null,tipoEmissor:null,documentosMensagem:[],valorJuros:null,valorMulta:null,valorCobrancaAtualizado:null,idGruNossoNumero:null},validadeCampos:{textoMensagem:false,email:false,camposCalculadora:true},naoReconhecoEstaCobranca:0,cancelarCobranca:0,listaGrusDoPagamento:[],idParticipanteLogado:null,listaTiposMensagens:[]};};_this.montarListaGrusDoPagamento=function(){var gru={};var lista=[];if(_this.props.infoPagamento&&_this.props.infoPagamento.grusTO.length>0){_this.props.infoPagamento.grusTO.forEach(function(item){gru={value:item.idGruNossoNumero,label:item.idGruNossoNumero+' gerada em '+item.dataCriacao+' com vencimento em '+item.dataVencimento};lista.push(gru);});}gru={value:0,label:PAGAMENTO_GRU_FORA_COMPREV};lista.push(gru);_this.setState({listaGrusDoPagamento:lista});};_this.handleSuccessBuscaPeloCnpjLogado=function(response){var id='';if(response.data){id=response.data.codigo;_this.setState({idParticipanteLogado:id});}};_this.handleErrorBuscaPeloCnpjLogado=function(){return'';};_this.buscarParticipantePeloCnpjLogado=function(){var usuarioLogado=new __WEBPACK_IMPORTED_MODULE_10__domain_User__["a" /* default */](localStorage.getItem('jwt'));var cnpj=usuarioLogado.cnpjDoPapel();if(cnpj){Object(__WEBPACK_IMPORTED_MODULE_11__utils_requests__["e" /* doGet */])('participantes-compensacao/'+cnpj,_this.handleSuccessBuscaPeloCnpjLogado,_this.handleErrorBuscaPeloCnpjLogado);}};_this.filtrarTiposMensagem=function(){var lista=[];var mensagensPossiveisDoBackend=_this.props.infoPagamento.novasMensagensPossiveis;//const mensagensPossiveisDoBackend = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];
// const { idParticipanteLogado } = { ...this.state };
// const usuarioLogado = new User(localStorage.getItem('jwt'));
// const ehRecebedor = usuarioLogado.cnpjDoPapel() === undefined || (usuarioLogado.cnpjDoPapel() === this.props.infoPagamento.cnpj);
// const ehControleDebitoPendente = this.props.tipoControle !== 'controle-pagamentos';
// const ehRecebedor = (idParticipanteLogado === this.props.infoPagamento.entidadeRecebedora ||
// (ehControleDebitoPendente && this.props.infoPagamento.codigoParticipanteLogado === '01000') );
var ehRecebedor=_this.props.infoPagamento.codigoParticipanteLogado===_this.props.infoPagamento.entidadeRecebedora;if(mensagensPossiveisDoBackend&&mensagensPossiveisDoBackend.length>0){mensagensPossiveisDoBackend.filter(function(item){return!ehRecebedor&&(item>=3&&item<=5||(item===9||item===12||item===15||item===16)&&item!==11);}).map(function(item){return lista.push(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["T" /* tiposMensagem */][item-1]);});mensagensPossiveisDoBackend.filter(function(item){return ehRecebedor&&(!(item>=3&&item<=5)||item==10||item==11||item==13||item==14);}).map(function(item){return lista.push(__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["T" /* tiposMensagem */][item-1]);});}return lista;};_this.handleComboTipoMensagemChange=function(changeObj){var _this$state=Object.assign({},_this.state),mensagem=_this$state.mensagem;var _this$state2=Object.assign({},_this.state),validadeCampos=_this$state2.validadeCampos;validadeCampos.dataPagamento=changeObj.value!=='3';if(changeObj.value==='2'){validadeCampos.valorParcial=false;}else if(changeObj.value!=='2'&&mensagem.valorParcial!==''&&mensagem.valorParcial!==null){mensagem.valorParcial=null;validadeCampos.valorParcial=true;}if(changeObj.value!=='3'&&mensagem.dataPagamento!==''&&mensagem.dataPagamento!==null){mensagem.dataPagamento=null;validadeCampos.dataPagamento=true;}if(changeObj.value==='4'){validadeCampos.camposCalculadora=false;}else{validadeCampos.camposCalculadora=true;}if(changeObj.value==='9'){if(mensagem.idGruNossoNumero!==null){mensagem.idGruNossoNumero=null;}}if(changeObj.value==='10'){validadeCampos.valorCobrancaAtualizado=false;}else{validadeCampos.valorCobrancaAtualizado=true;}if(changeObj.value==='11'/*&& this.state.cancelarCobranca === 1*/){_this.state.cancelarCobranca===0;validadeCampos.valorCobrancaAtualizado=true;}if(changeObj.value==='12'){// this.montarListaGrusDoPagamento();
validadeCampos.idGruNossoNumero=false;}else{validadeCampos.idGruNossoNumero=true;}if(changeObj.value==='15'){validadeCampos.camposCalculadora=false;}else{validadeCampos.camposCalculadora=true;}_this.setState(Object.assign({},_this.state,{opcaoNovaMensagem:changeObj.value,validadeCampos:validadeCampos}));};_this.handleTextChange=function(changeObj,name){var _this$state3=Object.assign({},_this.state),mensagem=_this$state3.mensagem;// const { validadeCampos } = { ...this.state };
_this.setState(Object.assign({},_this.state,{mensagem:Object.assign({},mensagem,_defineProperty({},name,changeObj.value)),validadeCampos:Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))}));};_this.handleChangeValorCobrancaAtualizado=function(name){var _this$state4=Object.assign({},_this.state),mensagem=_this$state4.mensagem;if((name==='naoReconhecoEstaCobranca'||name==='cancelarCobranca')&&(mensagem.valorCobrancaAtualizado!==null||mensagem.valorCobrancaAtualizado!==VAZIO)){mensagem.valorCobrancaAtualizado=VAZIO;_this.setState({validadeCampos:Object.assign({},_this.state.validadeCampos,{valorCobrancaAtualizado:true})});}_this.setState({mensagem:Object.assign({},mensagem)});};_this.handleChangeCheckbox=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value),_this.handleChangeValorCobrancaAtualizado(name));};_this.handleArquivostChange=function(changeObj){// const { mensagem } = { ...this.state };
//const { infoPagamento } = { ...this.state };
//const { validadeCampos } = { ...this.state };
_this.setState(Object.assign({},_this.state,{arquivos:changeObj.value}));};_this.handleKeyUp=function(e){var retorno=e.target.value;if(retorno.indexOf('_')!==-1){retorno=retorno.toString().replace('_','');}retorno=retorno.toString().replace(/\D/g,'');retorno=retorno.toString().replace(/(\d)(\d{11})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{8})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{5})$/,'$1.$2');retorno=retorno.toString().replace(/(\d)(\d{2})$/,'$1,$2');e.target.value=retorno;return retorno;};_this.replaceMoeda=function(valor,id){var _this$state5=Object.assign({},_this.state),mensagem=_this$state5.mensagem;var valorReplace=valor;if(valorReplace){if(typeof valorReplace!=='number'){var _valor=valorReplace;_valor=_valor.replace(/\./g,'').replace(/,/g,'.');if(id===1){mensagem.valorParcial=Number(_valor);}if(id===2){mensagem.valorCobrancaAtualizado=Number(_valor);}_this.setState({mensagem:Object.assign({},mensagem)});}}};_this.handleSaveButton=function(){var _this$state6=Object.assign({},_this.state),mensagem=_this$state6.mensagem;var _this$state7=Object.assign({},_this.state),validadeCampos=_this$state7.validadeCampos;//Object.keys(validadeCampos).forEach((key) => {
//  validadeCampos[key] = true;
//});
if(mensagem.valorParcial!==null&&mensagem.valorParcial!==''){_this.replaceMoeda(mensagem.valorParcial,1);}else{mensagem.valorParcial=null;}if(mensagem.valorCobrancaAtualizado&&mensagem.valorCobrancaAtualizado!==''){_this.replaceMoeda(mensagem.valorCobrancaAtualizado,2);}else{mensagem.valorCobrancaAtualizado=null;}if(mensagem.idGruNossoNumero==='0'){mensagem.idGruNossoNumero=null;}_this.setState({validadeCampos:validadeCampos// requestPesquisa: null,
},function(){return _this.fazerRequestNovaMensagem();});};_this.formularioProntoParaEnvio=function(){return Object(__WEBPACK_IMPORTED_MODULE_11__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);};_this.fazerRequestNovaMensagem=function(){if(_this.formularioProntoParaEnvio()){var _this$state8=Object.assign({},_this.state),mensagem=_this$state8.mensagem;var usuario=__WEBPACK_IMPORTED_MODULE_10__domain_User__["a" /* default */].logged();var urlPosMensagem='mensagem-pagamento-participante';mensagem.idControlePagamento=_this.props.infoPagamento.idControlePagamento;mensagem.cpf=usuario.data.id;mensagem.nomeUsuario=usuario.data.name;mensagem.tipoMensagem=Number(_this.state.opcaoNovaMensagem);mensagem.arquivos=_this.state.arquivos;Object(__WEBPACK_IMPORTED_MODULE_11__utils_requests__["l" /* doPost */])(urlPosMensagem,mensagem,_this.trataSucessoResponseEnvio,_this.trataErrosResponse);}else{Object(__WEBPACK_IMPORTED_MODULE_11__utils_requests__["L" /* trataMensagensErro */])(['Informe corretamente os atributos indicados na tela.']);}};_this.trataSucessoResponseEnvio=function(response){if(_this.state.arquivos.length>0){_this.uploadFile(response);}else{_this.props.acaoBuscarPagamento(_this.props.infoPagamento.idControlePagamento);Object(__WEBPACK_IMPORTED_MODULE_11__utils_requests__["J" /* trataMensagemSucesso */])(['Mensagem inserida.']);}_this.setState({opcaoNovaMensagem:null});};_this.trataErrosResponse=function(error){var _this$state9=Object.assign({},_this.state),validadeCampos=_this$state9.validadeCampos;if(error){var _error=Object.assign({},error),data=_error.data;if(error.status===400){if(data.erros&&data.erros.length>=1){data.erros.forEach(function(erro){if(erro.atributo in validadeCampos){validadeCampos[[erro.atributo]]=false;}});_this.setState(Object.assign({},_this.state,{validadeCampos:validadeCampos}));}}}};_this.uploadFile=function(response){var _this$state10=Object.assign({},_this.state),arquivos=_this$state10.arquivos;var _this$state11=Object.assign({},_this.state),mensagem=_this$state11.mensagem;var url='documentos-mensagem';if(arquivos.length>0){for(var i=0,docs=arquivos.length;i<docs;i+=1){var body={idControlePagamento:_this.props.infoPagamento.idControlePagamento,idMensagem:response.data.idMensagem,legenda:arquivos[i].legenda,documento:arquivos[i]};Object(__WEBPACK_IMPORTED_MODULE_11__utils_requests__["j" /* doMultipartFormPost */])(url,body,_this.handleDocumentSent,_this.handleFailDocumentSent);}}};_this.handleDocumentSent=function(){_this.props.acaoBuscarPagamento(_this.props.infoPagamento.idControlePagamento);Object(__WEBPACK_IMPORTED_MODULE_11__utils_requests__["J" /* trataMensagemSucesso */])(['Documento(s) anexado(s) com sucesso.']);};_this.handleFailDocumentSent=function(){_this.props.acaoBuscarPagamento(_this.props.infoPagamento.idControlePagamento);Object(__WEBPACK_IMPORTED_MODULE_11__utils_requests__["L" /* trataMensagensErro */])(['Falha ao enviar os arquivos']);};_this.incluirJuroseMultaNaMensagem=function(response,dataPagamento){var _this$state12=Object.assign({},_this.state),mensagem=_this$state12.mensagem;var _this$state13=Object.assign({},_this.state),validadeCampos=_this$state13.validadeCampos;validadeCampos.camposCalculadora=response?true:false;mensagem.valorJuros=response?response.valorTotalJuros:null;mensagem.valorMulta=response?response.valorTotalMulta:null;mensagem.dataPagamento=dataPagamento?dataPagamento:null;_this.setState({mensagem:Object.assign({},mensagem),validadeCampos:Object.assign({},validadeCampos)});};_this.toggleCheckbox=function(acaoToggle,nome){var acao={MARCAR:'marcar',DESMARCAR:'desmarcar'};var changeObj={};if(acaoToggle===acao.DESMARCAR){changeObj.value=0;}else{changeObj.value=1;}_this.handleChangeCheckbox(changeObj,nome);};_this.checkedNaoReconhecoEstaCobranca=function(){return _this.state.naoReconhecoEstaCobranca&&_this.state.naoReconhecoEstaCobranca===1;};_this.checkedCancelarCobranca=function(){return _this.state.cancelarCobranca&&_this.state.cancelarCobranca===1;};_this.acaoNaoReconhecoEstaCobranca=function(){return _this.checkedNaoReconhecoEstaCobranca()?acao.DESMARCAR:acao.MARCAR;};_this.acaoCancelarCobranca=function(marcado){var acao={MARCAR:'marcar',DESMARCAR:'desmarcar'};return marcado===1?acao.DESMARCAR:acao.MARCAR;};_this.montaFormDefesaPagamento=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:_this.state.naoReconhecoEstaCobranca,key:'naoReconhecoEstaCobranca',label:'N\xE3o reconhe\xE7o esta cobran\xE7a.',type:'checkbox',checked:_this.state.naoReconhecoEstaCobranca===1,onClick:function onClick(){return _this.toggleCheckbox(_this.acaoCancelarCobranca(_this.state.naoReconhecoEstaCobranca),'naoReconhecoEstaCobranca');},style:{paddingLeft:'5px',position:'relative',top:'25px',fontSize:'14px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingLeft:'5px',position:'relative',top:'24px',fontSize:'14px'}},'N\xE3o reconhe\xE7o esta cobran\xE7a.')));};_this.montaFormAprovacaoReprovacaoPagamento=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:_this.state.cancelarCobranca,key:'cancelarCobranca',label:'Cancelar cobran\xE7a.',type:'checkbox',checked:_this.state.cancelarCobranca===1,onClick:function onClick(){return _this.toggleCheckbox(_this.acaoCancelarCobranca(_this.state.cancelarCobranca),'cancelarCobranca');},style:{paddingLeft:'5px',position:'relative',top:'25px',fontSize:'14px'},disabled:_this.state.opcaoNovaMensagem==='11'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingLeft:'5px',position:'relative',top:'24px',fontSize:'14px'}},'Cancelar cobran\xE7a.')));};_this.montaFormDefesaPagamentoGRU=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{itemList:_this.state.listaGrusDoPagamento,label:'Op\xE7\xE3o de pagamento',onChange:function onChange(e){return _this.handleTextChange(e,'idGruNossoNumero');},placeholder:'Selecione o n\xFAmero da GRU',value:_this.state.mensagem.idGruNossoNumero,custom:true,required:true}));};_this.verificaTamanhoInput=function(tipoMensagem){var tamanho={maxWidth:'450px',margin:'auto'};if(tipoMensagem==='10'){tamanho={maxWidth:'600px',margin:'auto'};}return tamanho;};_this.state=_this.getInitialState(props);return _this;}_createClass(NovaMensagem,[{key:'componentDidMount',value:function componentDidMount(){this.montarListaGrusDoPagamento();this.buscarParticipantePeloCnpjLogado();}},{key:'mostraTextoJustificativa',value:function mostraTextoJustificativa(){return this.state.opcaoNovaMensagem==='5'||this.state.opcaoNovaMensagem==='7'?'Justificativa':'Observação do analista';}// const textoDestaque = texto =>(<span style={{fontWeight:'600'}}>{texto}</span>);
},{key:'render',value:function render(){var _this2=this;if(this.filtrarTiposMensagem().length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{backgroundColor:'#f8f9fa',padding:'3px 0 3px 0'}},!Object(__WEBPACK_IMPORTED_MODULE_9__utils_helpers__["b" /* ehPapelObservadorPagamento */])(this.props.estadoFormulario.papelUsuarioLogado)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.verificaTamanhoInput(this.state.opcaoNovaMensagem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{itemList:this.filtrarTiposMensagem(),label:'Nova Mensagem',onChange:function onChange(e){return _this2.handleComboTipoMensagemChange(e);},placeholder:'Selecione o tipo de mensagem',value:this.state.opcaoNovaMensagem,custom:true})):'',this.state.opcaoNovaMensagem&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'900px',margin:'auto',backgroundColor:'white',padding:'25px',marginBottom:'80px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.opcaoNovaMensagem?Object(__WEBPACK_IMPORTED_MODULE_5__tiposMensagens__["a" /* obterTipoMensagem */])(parseInt(this.state.opcaoNovaMensagem)).descricaoMotivo:'')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["s" /* SimpleGrid */],null,this.state.opcaoNovaMensagem==='2'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{currency:true,showMask:false,label:'Valor recebido identificado',onChange:function onChange(e){return _this2.handleTextChange(e,'valorParcial');},onKeyUp:function onKeyUp(e){return _this2.handleKeyUp(e,'rendaMensalInicial');},maxLength:'12',required:true,value:this.state.mensagem.valorParcial})),this.state.opcaoNovaMensagem==='12'&&this.montaFormDefesaPagamentoGRU(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{cols:'80',componentClass:'textarea',label:this.mostraTextoJustificativa(),maxlength:'400',onChange:function onChange(e){return _this2.handleTextChange(e,'textoMensagem');},rows:'2',required:true,value:this.state.mensagem.textoMensagem,textarea:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Email de contato:',maxlength:'100',onChange:function onChange(e){return _this2.handleTextChange(e,'email');},required:true,value:this.state.mensagem.email})),this.state.opcaoNovaMensagem==='3'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Data de Pagamento',mask:__WEBPACK_IMPORTED_MODULE_6__utils_masks__["a" /* default */].date,onChange:function onChange(e){return _this2.handleTextChange(e,'dataPagamento');},required:true,value:this.state.mensagem.dataPagamento})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Informa\xE7\xF5es adicionais de contato',maxlength:'200',onChange:function onChange(e){return _this2.handleTextChange(e,'informacoesContato');},value:this.state.mensagem.informacoesContato})),['4','15'].includes(this.state.opcaoNovaMensagem)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CalculadoraPagamento__["a" /* default */],{valorParcial:this.state.mensagem.valorParcial,infoPagamento:this.props.infoPagamento,handleChange:this.props.handleChange,handleKeyUp:this.props.handleKeyUp,incluirJuroseMultaNaMensagem:this.incluirJuroseMultaNaMensagem,opcaoNovaMensagem:this.state.opcaoNovaMensagem})),['9','10'].includes(this.state.opcaoNovaMensagem)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:this.state.opcaoNovaMensagem==='11'||this.state.naoReconhecoEstaCobranca===1||this.state.cancelarCobranca===1,currency:true,showMask:false,label:'Novo valor de cobran\xE7a.',onChange:function onChange(e){return _this2.handleTextChange(e,'valorCobrancaAtualizado');},onKeyUp:function onKeyUp(e){return _this2.handleKeyUp(e,'valorCobrancaAtualizado');},maxLength:'12',value:this.state.mensagem.valorCobrancaAtualizado,required:(this.state.opcaoNovaMensagem==='10'||this.state.opcaoNovaMensagem==='11')&&this.state.cancelarCobranca===0})),this.state.opcaoNovaMensagem==='9'&&this.montaFormDefesaPagamento(),this.state.opcaoNovaMensagem==='10'&&this.montaFormAprovacaoReprovacaoPagamento(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__templates_UploadArquivosMsg__["a" /* default */],{arquivos:[].concat(_toConsumableArray(this.state.arquivos)),estadoFormulario:this.state,handleChange:function handleChange(e){return _this2.handleArquivostChange(e);},infoPagamento:this.props.estadoFormulario.infoPagamento}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["s" /* SimpleGrid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:pemissoesAcaoPrincipal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:'Enviar',onClick:this.handleSaveButton,hint:'Enviar mensagem'})))))));}}]);return NovaMensagem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);;NovaMensagem.propTypes={estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleKeyUp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,incluirJuroseMultaNaMensagem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,tipoControle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (NovaMensagem);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_constants__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_controle_pagamento_templates_ModalUploadDocumentoMsg__ = __webpack_require__(664);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UploadArquivosMsg=function(_Component){_inherits(UploadArquivosMsg,_Component);function UploadArquivosMsg(){_classCallCheck(this,UploadArquivosMsg);var _this=_possibleConstructorReturn(this,(UploadArquivosMsg.__proto__||Object.getPrototypeOf(UploadArquivosMsg)).call(this));_this.getInitialState=function(){return{acaoModal:'criacao',showModal:false,showDocumentUploadModal:false,apagouArquivo:false,desabilitado:false};};_this.showDocumentUploadModal=function(){_this.setState({showDocumentUploadModal:!_this.state.showDocumentUploadModal});};_this.createCustomInsertButton=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{disabled:_this.state.desabilitado,onClick:function onClick(){return _this.showDocumentUploadModal();},hint:'Carregar Arquivo',icon:'ico-upload'});};_this.createActionColumn=function(indice){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-inverse',hint:'Excluir arquivo',icon:'ico-doc-minus',mini:true,onClick:function onClick(){return _this.deleteArquivo(indice);}}));};_this.addSituacaoLabel=function(tipoDocumento){var obj=Object(__WEBPACK_IMPORTED_MODULE_3__utils_listsSelect__["n" /* getObject */])(_this.props.tiposDocumentos,tipoDocumento);var valorlabel=null;if(obj){valorlabel=obj.label;}return valorlabel;// const obj = getObject(situacao, situacaoSelecionado);
// return obj.label;
};_this.montaArquivosTableHeader=function(){var tableHeader=[{id:'legenda',label:'Legenda'},{id:'nome',label:'Arquivo'}];tableHeader.push({id:'acoes',label:'Ação',dataFormat:_this.createActionColumn});return tableHeader;};_this.options={hideSizePerPage:true,insertBtn:_this.createCustomInsertButton,noDataText:'Nenhum arquivo foi adicionado à lista',sizePerPage:5};_this.editArquivo=function(indice,arquivoSelecionado){_this.setState({cell:indice,arquivoSelecionado:arquivoSelecionado});};_this.deleteArquivo=function(row){var _this$props=Object.assign({},_this.props),arquivos=_this$props.arquivos;arquivos.splice(row,1);_this.alteraListaArquivos(arquivos);};_this.alteraListaArquivos=function(listaArquivos){_this.props.handleChange({value:listaArquivos,isValid:listaArquivos.length>0});};_this.handleModal=function(modal){_this.setState(_defineProperty({},modal,!_this.state[modal]));};_this.addArquivo=function(arquivo){if(arquivo){var _this$props2=Object.assign({},_this.props),arquivos=_this$props2.arquivos;var tamanhoDocumentoUpload=arquivo.size;var arquivoValido=arquivo.type==='application/pdf';arquivoValido=arquivoValido&&tamanhoDocumentoUpload<=__WEBPACK_IMPORTED_MODULE_5__utils_constants__["z" /* tamanhoMaximoArquivoUpload */];if(arquivoValido){arquivos.push(arquivo);}else{Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(['Certifique-se de que o documento '+arquivo.name+' \xE9 um PDF e possui tamanho inferior a 3 mb.']);}_this.alteraListaArquivos(arquivos,null);_this.setState(_this.handleModal('showDocumentUploadModal'));}};_this.handleResponseUploadDocumento=function(response){_this.setState({requerimentoModalDocumento:response.data},function(){return _this.handleModal('showDocumentUploadModal');});};_this.handleErrorEncerramentoExigencia=function(){};var initialState=_this.getInitialState();_this.state=initialState;return _this;}/**
   * Determina a acao que estara disponivel para cada dependente:
   * - Usuario esta criando um requerimento ou cumprindo exigencias, dependente pode ser alterado;
   * - Usuario esta emitindo parecer, dependente pode ser alterado se tiver a Capacidade adequada;
   * - Em outras situacoes, o dependente pode apenas ser visualizado.
   *//**
   * Determina quais colunas devem ser exibidas na tabela de arquivos
   *//**
   * Altera um dependente da lista
   *//**
   * Exclui um arquivo da lista
   *//**
   * Adiciona arquivo a lista
   */_createClass(UploadArquivosMsg,[{key:'render',value:function render(){var _this2=this;var listaArquivosIndexada=this.props.arquivos.map(function(item,i){var itemIndexado=item;itemIndexado.acoes=i;itemIndexado.nome=itemIndexado.name;return itemIndexado;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["s" /* SimpleGrid */],{title:'Upload de Arquivos',icon:'ico-doc-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["u" /* Table */],{bordered:true,data:listaArquivosIndexada,insertRow:true,options:this.options,listaTableHeader:this.montaArquivosTableHeader(),pagination:true,fetchInfo:this.fetchInfo}),this.state.showDocumentUploadModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__pages_controle_pagamento_templates_ModalUploadDocumentoMsg__["a" /* default */],Object.assign({},this.props,{infoPagamento:this.props.infoPagamento,handleModal:function handleModal(){return _this2.handleModal('showDocumentUploadModal');},showModal:this.state.showDocumentUploadModal,addArquivo:this.addArquivo})):'');}}]);return UploadArquivosMsg;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UploadArquivosMsg.propTypes={arquivos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({legenda:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nome:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired,estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired};/* harmony default export */ __webpack_exports__["a"] = (UploadArquivosMsg);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ComponentesBasicos_UploadDragDrop__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalUploadDocumento=function(_Component){_inherits(ModalUploadDocumento,_Component);function ModalUploadDocumento(){_classCallCheck(this,ModalUploadDocumento);var _this=_possibleConstructorReturn(this,(ModalUploadDocumento.__proto__||Object.getPrototypeOf(ModalUploadDocumento)).call(this));_this.checkIfFileCanBeSent=function(){return _this.state.document&&_this.state.legenda;};_this.modalDocumentUploadContent=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'8 8 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{label:'Legenda',maxlength:'100',onChange:function onChange(e){return _this.handleChange(e,'legenda');},required:true,value:_this.state.legenda}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ComponentesBasicos_UploadDragDrop__["a" /* default */],{files:_this.state.documents,onChange:function onChange(documents){return _this.setState({documents:documents});},onSelect:_this.handleChangeFile,multiple:false,accept:'application/pdf,.pdf',minHeight:70,titulo:'Arraste o arquivo PDF aqui',subtitulo:'ou clique para selecionar',largura:'12'}))));};_this.modalDocumentUploadFooter=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{className:'dtp-primary',disabled:!_this.checkIfFileCanBeSent(),hint:'Anexar documento',onClick:_this.addArquivo,title:'Anexar'})));};_this.addArquivo=function(){if(_this.state.document){var arquivo={};arquivo={chave:_this.props.infoPagamento.idControlePagamento,documento:_this.state.document,legenda:_this.state.legenda};_this.state.arquivo=arquivo.documento;_this.state.arquivo.legenda=arquivo.legenda;_this.props.addArquivo(_this.state.arquivo,_this.props.arquivo);}};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value));};_this.handleChangeFile=function(file){_this.setState({document:file});};_this.handleDocumentSent=function(response){_this.setState({document:null,legenda:null},function(){return _this.props.handleDocumentSent(response.headers.location);});};_this.handleClose=function(){_this.setState({document:null},_this.props.handleModal('showDocumentUploadModal'));};_this.state={document:null,documents:[],legenda:null};return _this;}_createClass(ModalUploadDocumento,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},this.props,{conteudofooter:this.modalDocumentUploadFooter(),conteudomodal:this.modalDocumentUploadContent(),onHide:this.handleClose,size:'md',showModal:this.props.showModal,title:'Incluir documento'}));}}]);return ModalUploadDocumento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalUploadDocumento.propTypes={idControlePagamento:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,showModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleDocumentSent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (ModalUploadDocumento);

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DadosCronogramaPagamento__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ComponentesAutenticacao_ProtectedItem__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CronogramaPagamento=function(_Component){_inherits(CronogramaPagamento,_Component);function CronogramaPagamento(props,context){_classCallCheck(this,CronogramaPagamento);var _this=_possibleConstructorReturn(this,(CronogramaPagamento.__proto__||Object.getPrototypeOf(CronogramaPagamento)).call(this,props,context));_this.getInitialState=function(){return{cronogramaPagamento:{ano:null,mes:null,dataCND:null,dataObitos:null,dataFechamentoPrevia:null,dataConsultaPrevia:null,dataFechamentoFolha:null,dataRelatoriosBG:null,dataEnvioBB:null,dataPrazoDefesa:null,dataPrazoAnalise:null,dataPrazoPagamento:null,competencia:null,habilitarBotao:null},cronogramaPagamentoPesquisa:{ano:null,mes:null},touched:false,validadeCampos:{dataCND:false,dataObitos:false,dataFechamentoPrevia:false,dataConsultaPrevia:false,dataFechamentoFolha:false,dataRelatoriosBG:false,dataEnvioBB:false,dataPrazoDefesa:null,dataPrazoAnalise:null,dataPrazoPagamento:false,competencia:true},bloqueio:{competencia:true},acao:'novo',showNoContent:true,noContentPrimaryMessage:'Cronograma de pagamento não encontrado para o participante informado.',noContentSecondaryMessage:'Informe um cronograma válido.',chaveConfirmacao:null};};_this.montaValidadeCampos=function(cronogramaPagamento){var _this$state=Object.assign({},_this.state),validadeCampos=_this$state.validadeCampos;Object.keys(cronogramaPagamento).forEach(function(key){validadeCampos[key]=true;});return validadeCampos;};_this.montaFormulario=function(){_this.setState({acao:_this.props.match.params.acao,cronogramaPagamento:{ano:_this.props.match.params.ano,mes:_this.props.match.params.mes}});if(_this.props.match.params.acao==='novo'){_this.setState({cronogramaPagamento:{ano:_this.props.match.params.ano,mes:_this.props.match.params.mes,competencia:_this.formatarCompetencia(_this.props.match.params.mes,_this.props.match.params.ano)},validadeCampos:Object.assign({},_this.state.validadeCampos)});}else{_this.setState({acao:_this.props.match.params.acao,validadeCampos:Object.assign({},_this.state.validadeCampos)},_this.buscaCronogramaPagamento);}};_this.trataSucessoResponsePesquisa=function(response){_this.setState({bloqueio:Object.assign({},response.data),requestPesquisa:null});};_this.handleSuccessBuscaCronograma=function(response){var _this$state2=Object.assign({},_this.state),acao=_this$state2.acao;if(response.data){if(acao==='alterar'){var validadeCampos=_this.montaValidadeCampos(response.data);_this.setState({validadeCampos:validadeCampos});}_this.setState({cronogramaPagamento:Object.assign({},_this.state.cronogramaPagamento,response.data)});}};_this.buscaCronogramaPagamento=function(){var _this$state3=Object.assign({},_this.state),cronogramaPagamentoPesquisa=_this$state3.cronogramaPagamentoPesquisa;var url='cronogramas-pagamento';cronogramaPagamentoPesquisa.mes=_this.props.match.params.mes;cronogramaPagamentoPesquisa.ano=_this.props.match.params.ano;Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["e" /* doGet */])(url,_this.handleSuccessBuscaCronograma,_this.handleErrorBuscaCronograma,Object.assign({},_this.state.cronogramaPagamentoPesquisa));};_this.handleErrorBuscaCronograma=function(error){if(error){if(error.status){_this.setState({showNoContent:true});}}};_this.formularioProntoParaEnvio=function(){var _this$state4=Object.assign({},_this.state),acao=_this$state4.acao;if(acao==='novo'||acao==='alterar'){return Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["M" /* validateObject */])(_this.state.validadeCampos);}return false;};_this.handleChange=function(changeObj,name){var _this$setState;var _this$state5=Object.assign({},_this.state),cronogramaPagamento=_this$state5.cronogramaPagamento;_this.setState((_this$setState={},_defineProperty(_this$setState,name,changeObj.value),_defineProperty(_this$setState,'cronogramaPagamento',Object.assign({},cronogramaPagamento,_defineProperty({},name,changeObj.value))),_defineProperty(_this$setState,'validadeCampos',Object.assign({},_this.state.validadeCampos,_defineProperty({},name,changeObj.isValid))),_this$setState));};_this.handleSaveButton=function(){_this.confirmSendData();};_this.confirmSendData=function(){var touched=true;var url='cronogramas-pagamento';var _this$state6=Object.assign({},_this.state),validadeCampos=_this$state6.validadeCampos;Object.keys(validadeCampos).forEach(function(key){validadeCampos[key]=true;});_this.setState({touched:touched,validadeCampos:validadeCampos},function(){return _this.handleSave(url);});};_this.handleSave=function(url){if(_this.formularioProntoParaEnvio()){var _this$state7=Object.assign({},_this.state),acao=_this$state7.acao;var _this$state8=Object.assign({},_this.state),cronogramaPagamento=_this$state8.cronogramaPagamento;var competenciaPrimeiraParte=cronogramaPagamento.competencia.substring(0,cronogramaPagamento.competencia.indexOf('/'));var competenciaSegundaParte=cronogramaPagamento.competencia.substring(cronogramaPagamento.competencia.indexOf('/')+1,cronogramaPagamento.competencia.toString().length);if(competenciaPrimeiraParte){cronogramaPagamento.mes=Number(competenciaPrimeiraParte);}if(competenciaSegundaParte){cronogramaPagamento.ano=Number(competenciaSegundaParte);}if(acao==='novo'){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["l" /* doPost */])(url,cronogramaPagamento,_this.trataSucessoResponseEnvio,_this.trataErrosResponse);}else{Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["n" /* doPut */])(url,cronogramaPagamento,_this.trataSucessoResponseEnvio,_this.trataErrosResponse);}}else{Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(['Informe corretamente os atributos indicados na tela.']);}};_this.trataSucessoResponseEnvio=function(){_this.trataSucesso();_this.props.history.goBack();};_this.trataSucesso=function(){var mensagemConfirmacao='';if(_this.state.acao==='novo'){mensagemConfirmacao='Cronograma criado';}else{mensagemConfirmacao='Cronograma alterado';}Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["J" /* trataMensagemSucesso */])([mensagemConfirmacao]);};_this.trataErrosResponse=function(error){if(error&&error.data){var _error=Object.assign({},error),data=_error.data;_this.setState({chaveConfirmacao:data.chaveConfirmacao,alertas:data.alertas,showModalAlerta:!_this.state.showModalAlerta});}};_this.trataBotaoVoltar=function(){_this.props.history.goBack();};_this.formularioCronograma=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DadosCronogramaPagamento__["a" /* default */],{acao:_this.state.acao,auth:_this.props.auth,estadoFormulario:_this.state,handleChange:_this.handleChange,handleChangeComboNome:_this.handleChangeComboNome,match:_this.props.match});};_this.formatarCompetencia=function(mes,ano){var objCompetencia=null+'/'+null;if(mes!=='0'&&ano!=='0'){objCompetencia=mes+'/'+ano;if(objCompetencia.length!==7){objCompetencia='0'+objCompetencia;}}return objCompetencia;};_this.handleFechamentoModalAlerta=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta});};_this.state=_this.getInitialState();return _this;}_createClass(CronogramaPagamento,[{key:'componentDidMount',value:function componentDidMount(){this.montaFormulario();}/**
   * Trata envio dos dados
   *//**
   * Trata as acoes dos botao Salvar
   *//**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */},{key:'render',value:function render(){var botaoAcaoVoltar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{className:'left',onClick:this.props.history.goBack// onClick={this.props.history.push('/consultaBloqueio/bloqueio')}
,title:'Voltar',hint:'Voltar para tela anterior'});var botaoAcaoPrincipal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ComponentesAutenticacao_ProtectedItem__["a" /* default */],{allowedPermissions:['analisar-negocio-sprev']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["a" /* Button */],{className:'dtp-primary right',disabled:!this.formularioProntoParaEnvio(),title:'Salvar',onClick:this.handleSaveButton,hint:'Salvar'}));var retorno=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["j" /* DtpContentContainer */],null,this.formularioCronograma(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},botaoAcaoVoltar,this.state.acao!=='detalhar'?botaoAcaoPrincipal:''));return retorno;}}]);return CronogramaPagamento;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CronogramaPagamento.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({mes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ano:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,acao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})})}.isRequired;CronogramaPagamento.defaultProps={match:null,auth:null,destinatarios:[]};/* harmony default export */ __webpack_exports__["a"] = (CronogramaPagamento);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masks__ = __webpack_require__(10);
var CronogramaPagamento=function CronogramaPagamento(props){var verificaSeCampoDesabilitado=function verificaSeCampoDesabilitado(nomeCampo){var _props$estadoFormular=Object.assign({},props.estadoFormulario),acao=_props$estadoFormular.acao;if(acao==='detalhar'){return true;}if(acao==='novo'&&nomeCampo==='competencia'&&props.estadoFormulario.cronogramaPagamento.ano!==null&&props.estadoFormulario.cronogramaPagamento.ano!=='0'){return true;}if(acao==='novo'&&nomeCampo==='competencia'&&props.estadoFormulario.cronogramaPagamento.ano==='0'){return false;}if(acao==='alterar'&&nomeCampo==='competencia'){return true;}return false;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["e" /* DataGrid */],{title:'Dados do Cronograma',icon:'ico-calendar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('competencia'),error:!props.estadoFormulario.validadeCampos.competencia,label:'Compet\xEAncia',value:props.estadoFormulario.cronogramaPagamento.competencia,onChange:function onChange(e){return props.handleChange(e,'competencia');},mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].competencia})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataCND'),error:!props.estadoFormulario.validadeCampos.dataCND,touched:props.estadoFormulario.touched,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:'CND',value:props.estadoFormulario.cronogramaPagamento.dataCND,onChange:function onChange(e){return props.handleChange(e,'dataCND');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataObitos'),error:!props.estadoFormulario.validadeCampos.dataObitos,touched:props.estadoFormulario.touched,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:'Consulta de \xD3bitos',value:props.estadoFormulario.cronogramaPagamento.dataObitos,onChange:function onChange(e){return props.handleChange(e,'dataObitos');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataFechamentoPrevia'),error:!props.estadoFormulario.validadeCampos.dataFechamentoPrevia,touched:props.estadoFormulario.touched,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:'Fechamento da Pr\xE9via',value:props.estadoFormulario.cronogramaPagamento.dataFechamentoPrevia,onChange:function onChange(e){return props.handleChange(e,'dataFechamentoPrevia');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataConsultaPrevia'),error:!props.estadoFormulario.validadeCampos.dataConsultaPrevia,touched:props.estadoFormulario.touched,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:'In\xEDcio do Per\xEDodo de Consulta da Pr\xE9via',value:props.estadoFormulario.cronogramaPagamento.dataConsultaPrevia,onChange:function onChange(e){return props.handleChange(e,'dataConsultaPrevia');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataFechamentoFolha'),error:!props.estadoFormulario.validadeCampos.dataFechamentoFolha,touched:props.estadoFormulario.touched,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:'Fechamento da Folha de Pagamento COMPREV',value:props.estadoFormulario.cronogramaPagamento.dataFechamentoFolha,onChange:function onChange(e){return props.handleChange(e,'dataFechamentoFolha');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataRelatoriosBG'),error:!props.estadoFormulario.validadeCampos.dataRelatoriosBG,touched:props.estadoFormulario.touched,label:'Disponibiliza\xE7\xE3o dos Relat\xF3rios de Pagamento (Carga BG)',value:props.estadoFormulario.cronogramaPagamento.dataRelatoriosBG,onChange:function onChange(e){return props.handleChange(e,'dataRelatoriosBG');},mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataEnvioBB'),error:!props.estadoFormulario.validadeCampos.dataEnvioBB,touched:props.estadoFormulario.touched,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:'Envio do Arquivo do BB',value:props.estadoFormulario.cronogramaPagamento.dataEnvioBB,onChange:function onChange(e){return props.handleChange(e,'dataEnvioBB');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataPrazoPagamento'),error:!props.estadoFormulario.validadeCampos.dataPrazoPagamento,touched:props.estadoFormulario.touched,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:'Prazo para Pagamento dos Valores',value:props.estadoFormulario.cronogramaPagamento.dataPrazoPagamento,onChange:function onChange(e){return props.handleChange(e,'dataPrazoPagamento');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataPrazoDefesa'),error:!props.estadoFormulario.validadeCampos.dataPrazoDefesa,touched:props.estadoFormulario.touched,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:'Marco Limite para Defesa (Informa\xE7\xE3o Pagamento Rejeitado)',value:props.estadoFormulario.cronogramaPagamento.dataPrazoDefesa,onChange:function onChange(e){return props.handleChange(e,'dataPrazoDefesa');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["i" /* Grid */],{cols:'6 6 6 6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["k" /* Input */],{disabled:verificaSeCampoDesabilitado('dataPrazoAnalise'),error:!props.estadoFormulario.validadeCampos.dataPrazoAnalise,touched:props.estadoFormulario.touched,mask:__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* default */].date,label:'Marco Limite para An\xE1lise de Pagamento Rejeitado',value:props.estadoFormulario.cronogramaPagamento.dataPrazoAnalise,onChange:function onChange(e){return props.handleChange(e,'dataPrazoAnalise');}})))));};CronogramaPagamento.propTypes={// acao: PropTypes.string.isRequired,
// auth: PropTypes.objectOf(PropTypes.object).isRequired,
estadoFormulario:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CronogramaPagamento);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FiltroConsultaCpf__ = __webpack_require__(669);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConsultaCpf=function(_Component){_inherits(ConsultaCpf,_Component);function ConsultaCpf(props){_classCallCheck(this,ConsultaCpf);var _this=_possibleConstructorReturn(this,(ConsultaCpf.__proto__||Object.getPrototypeOf(ConsultaCpf)).call(this,props));_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.realizaConsulta=function(filtrosPesquisa){var filtrosConsulta={};if(filtrosPesquisa){filtrosConsulta=_this.montaFiltros(filtrosPesquisa);}_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta}),_this.executaConsulta);};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["e" /* doGet */])('requerimento-por-cpf',_this.tratarSucesso,_this.tratarErro,Object.assign({},_this.state.filtrosConsulta,{'start-position':primeiroItem,'max-results':resultadosPorPagina}));}else{_this.setState({listaRequerimentosIndexada:[],listaRequerimentosIndexadaAtualizada:true});}};_this.montaFiltros=function(atributosPesquisa){var atributos={};if(atributosPesquisa.cpf){atributos=Object.assign({},atributos,{cpf:atributosPesquisa.cpf});}var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;if(atributosPesquisa.cliqueiNoBotao===1){_this.state.estadoTabela.paginaAtual=1;}var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.tratarSucesso=function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data===''){_this.setState({showNoContent:false,listaRequerimentosIndexada:[],listaRequerimentosIndexadaAtualizada:true,estadoTabela:estadoTabela});}else{_this.setState({showNoContent:false,listaRequerimentosIndexada:response.data,listaRequerimentosIndexadaAtualizada:true,estadoTabela:estadoTabela});}};_this.tratarFiltroNaLista=function(listaRequerimentosFiltrada){_this.setState({listaRequerimentosFiltrada:listaRequerimentosFiltrada,listaRequerimentosIndexadaAtualizada:false});};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.setState({showNoContent:true,noContentPrimaryMessage:'Não econtrado requerimento para este CPF.',noContentSecondaryMessage:'Informe CPF Válido.'});}else{_this.setState({showNoContent:false,noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao});}}else{_this.setState({showNoContent:true,noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleChange=function(e,name){_this.setState(Object.assign({},_this.state,_defineProperty({},name,e)));};_this.handleClickNovoEstadoFail=function(){_this.realizaConsulta();};_this.addTipoRequerimentoLabel=function(tipo){return __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["M" /* tipoRequerimento */],tipo).label;};_this.addTipoEstadoLabel=function(tipo){if(tipo===15){return'Exigência/indeferido';}if(tipo===16){return'Indeferimento ratificado';}return __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};_this.colunasDefault=[{id:'matricula',label:'Matrícula'},{id:'solicitante',label:'Solicitante'},{id:'destinatario',label:'Destinatário'},{id:'tipoRequerimento',label:'Tipo',dataFormat:_this.addTipoRequerimentoLabel},{id:'estado',label:'Estado',dataFormat:_this.addTipoEstadoLabel},{id:'dataIngresso',label:'Data de Ingresso'},{id:'dataDesvinculacao',label:'Data de Desvinculação'}];_this.montaColunas=function(){var requerimentosPorCpfTableHeader=_this.colunasDefault.slice();return requerimentosPorCpfTableHeader;};_this.defineListaParaTabela=function(){if(_this.state.listaRequerimentosFiltrada!==null){return _this.state.listaRequerimentosFiltrada;}return _this.state.listaRequerimentosIndexada;};_this.alterarPagina=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.paginaAtual=pagina;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.alterarResultadosPorPagina=function(resultadosPorPagina){var _this$state3=Object.assign({},_this.state),estadoTabela=_this$state3.estadoTabela;estadoTabela.resultadosPorPagina=resultadosPorPagina;_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.montaTituloTabela=function(){return'Requerimentos';};_this.state={listaRequerimentosFiltrada:null,listaRequerimentosIndexada:[],requerimentoVindoDoRequest:null,showNoContent:false,listaRequerimentosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{}};return _this;}_createClass(ConsultaCpf,[{key:'componentDidMount',value:function componentDidMount(){if(!sessionStorage.getItem('filtroPesquisa')){this.realizaConsulta();}}/**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */},{key:'render',value:function render(){var options={noDataText:'Nenhum requerimento a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};var requerimentosPorCpfTableHeader=this.montaColunas();return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FiltroConsultaCpf__["a" /* default */],{handleSearchFilter:this.realizaConsulta,handleChangeList:this.tratarFiltroNaLista,list:this.state.listaRequerimentosIndexada,listaRequerimentosIndexadaAtualizada:this.state.listaRequerimentosIndexadaAtualizada}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["u" /* Table */],{legend:this.montaTituloTabela(),bordered:true,fetchInfo:fetchInfo,data:this.defineListaParaTabela(),options:options,listaTableHeader:requerimentosPorCpfTableHeader,pagination:true,remote:true}));}}]);return ConsultaCpf;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaCpf.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ConsultaCpf);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_masks__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FiltroConsultaCpf=function(_Component){_inherits(FiltroConsultaCpf,_Component);function FiltroConsultaCpf(){_classCallCheck(this,FiltroConsultaCpf);var _this=_possibleConstructorReturn(this,(FiltroConsultaCpf.__proto__||Object.getPrototypeOf(FiltroConsultaCpf)).call(this));_this.preparaNovaConsulta=function(){var filtroPesquisa={cpf:null};filtroPesquisa=JSON.stringify(filtroPesquisa);sessionStorage.setItem('filtroConsultaCpf',filtroPesquisa);_this.setState({cpf:null});};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value));};_this.handleKeyDown=function(e){var retorno=null;if(e.keyCode===13){retorno=_this.handleSearchButton();}return retorno;};_this.handleSearchButton=function(){var filtroPesquisa={cpf:_this.state.cpf};filtroPesquisa=JSON.stringify(filtroPesquisa);sessionStorage.setItem('filtroConsultaCpf',filtroPesquisa);_this.setState({cliqueiNoBotao:1},function(){_this.handleChange({value:1,isValid:true},'cliqueiNoBotao');});_this.handleSearch();};_this.handleListFilter=function(){var listaFiltrada=_this.props.list;_this.props.handleChangeList(listaFiltrada);};_this.handleSearch=function(){var paramCpf='';if(_this.state.cpf){paramCpf=_this.state.cpf.toUpperCase();if(_this.state.cpf.indexOf('_')!==-1){paramCpf=_this.state.cpf.toString().replace(/_/g,'');}}_this.state.cpf=paramCpf;if(_this.state.cpf){_this.props.handleSearchFilter(_this.state);}else{Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Informe o CPF para pesquisa.']);}};_this.montaFiltro=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{cpf:true,integer:true,label:'CPF',mask:__WEBPACK_IMPORTED_MODULE_4__utils_masks__["a" /* default */].cpf,onChange:function onChange(e){return _this.handleChange(e,'cpf');},onKeyDown:function onKeyDown(e){return _this.handleKeyDown(e,'cpf');},showMask:true,value:_this.state.cpf,validationState:'active'}))));};_this.filtroConsultaCpf=JSON.parse(sessionStorage.getItem('filtroConsultaCpf'));_this.state={cpf:_this.filtroConsultaCpf&&_this.filtroConsultaCpf.cpf?_this.filtroConsultaCpf.cpf:null};return _this;}_createClass(FiltroConsultaCpf,[{key:'componentDidMount',value:function componentDidMount(){if(sessionStorage.getItem('filtroConsultaCpf')){this.handleSearchButton();}}},{key:'render',value:function render(){var _this2=this;var filtrosPesquisa=this.montaFiltro();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'pesquisa',panelId:'filtro-pesquisa',icon:'ico-filter',title:'Filtro de Pesquisa'},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();},hint:'Pesquisar de acordo com o  CPF informado.'}))));}}]);return FiltroConsultaCpf;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroConsultaCpf.propTypes={handleChangeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroConsultaCpf);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Conversor=function(_Component){_inherits(Conversor,_Component);function Conversor(props){_classCallCheck(this,Conversor);var _this=_possibleConstructorReturn(this,(Conversor.__proto__||Object.getPrototypeOf(Conversor)).call(this,props));_this.handleChangeConversorAnoMesDiaParaDias=function(changeObj,name){var _this$state=Object.assign({},_this.state),conversorAnoMesDiaParaDias=_this$state.conversorAnoMesDiaParaDias;_this.setState({conversorAnoMesDiaParaDias:Object.assign({},conversorAnoMesDiaParaDias,_defineProperty({},name,changeObj.value))});};_this.handleChangeDiaParaAnoMesDia=function(changeObj,name){var _this$state2=Object.assign({},_this.state),conversorDiaParaAnoMesDia=_this$state2.conversorDiaParaAnoMesDia;_this.setState({conversorDiaParaAnoMesDia:Object.assign({},conversorDiaParaAnoMesDia,_defineProperty({},name,changeObj.value))});};_this.handleCalcularAnoMesDiaParaDias=function(){var _this$state3=Object.assign({},_this.state),conversorAnoMesDiaParaDias=_this$state3.conversorAnoMesDiaParaDias;var ano=365;var mes=30;var dia=0;var resultadoAnoDia=0;var resultadoMesDia=0;if(conversorAnoMesDiaParaDias.anoParaDias){var qtdAnosDigitados=conversorAnoMesDiaParaDias.anoParaDias;resultadoAnoDia=ano*qtdAnosDigitados;}if(conversorAnoMesDiaParaDias.mesParaDias){var qtdMesesDigitados=conversorAnoMesDiaParaDias.mesParaDias;resultadoMesDia=mes*qtdMesesDigitados;}if(conversorAnoMesDiaParaDias.diaParaDias){var qtdDiasDigitados=conversorAnoMesDiaParaDias.diaParaDias;dia=qtdDiasDigitados;}conversorAnoMesDiaParaDias.resultadoDias=Math.round(Number(resultadoAnoDia)+Number(resultadoMesDia)+Number(dia));_this.setState({conversorAnoMesDiaParaDias:Object.assign({},_this.state.conversorAnoMesDiaParaDias,{conversorAnoMesDiaParaDias:conversorAnoMesDiaParaDias})});};_this.handleLimparConversorDiaParaAnoMesDia=function(){var _this$state4=Object.assign({},_this.state),conversorDiaParaAnoMesDia=_this$state4.conversorDiaParaAnoMesDia;conversorDiaParaAnoMesDia.dias='';conversorDiaParaAnoMesDia.resultadoDiasParaAno='';conversorDiaParaAnoMesDia.resultadoDiasParaMes='';conversorDiaParaAnoMesDia.resultadoDiasParaDia='';_this.setState({conversorDiaParaAnoMesDia:Object.assign({},_this.state.conversorDiaParaAnoMesDia,{conversorDiaParaAnoMesDia:conversorDiaParaAnoMesDia})});};_this.handleLimparConversorAnoMesDiaParaDias=function(){var _this$state5=Object.assign({},_this.state),conversorAnoMesDiaParaDias=_this$state5.conversorAnoMesDiaParaDias;conversorAnoMesDiaParaDias.anoParaDias='';conversorAnoMesDiaParaDias.mesParaDias='';conversorAnoMesDiaParaDias.diaParaDias='';conversorAnoMesDiaParaDias.resultadoDias='';_this.setState({conversorAnoMesDiaParaDias:Object.assign({},_this.state.conversorAnoMesDiaParaDias,{conversorAnoMesDiaParaDias:conversorAnoMesDiaParaDias})});};_this.handleCalcularDiaParaAnoMesDia=function(){var _this$state6=Object.assign({},_this.state),conversorDiaParaAnoMesDia=_this$state6.conversorDiaParaAnoMesDia;var ano=365;var mes=30;var dia=1;var resultadoDiaAno=0;var resultadoDiaMes=0;var resultadoDiaDia=0;if(conversorDiaParaAnoMesDia.dias){var qtdDiasDigitados=conversorDiaParaAnoMesDia.dias;resultadoDiaAno=qtdDiasDigitados/ano;resultadoDiaMes=qtdDiasDigitados%ano/mes;resultadoDiaDia=qtdDiasDigitados%ano%mes/dia;}conversorDiaParaAnoMesDia.resultadoDiasParaMes=Math.trunc(Number(resultadoDiaMes));conversorDiaParaAnoMesDia.resultadoDiasParaAno=Math.trunc(Number(resultadoDiaAno));conversorDiaParaAnoMesDia.resultadoDiasParaDia=Math.trunc(Number(resultadoDiaDia));_this.setState({conversorDiaParaAnoMesDia:Object.assign({},_this.state.conversorDiaParaAnoMesDia,{conversorDiaParaAnoMesDia:conversorDiaParaAnoMesDia})});};_this.state={conversorAnoMesDiaParaDias:{anoParaDias:null,mesParaDias:null,diaParaDias:null,resultadoDias:null},conversorDiaParaAnoMesDia:{dias:null,resultadoDiasParaAno:null,resultadoDiasParaMes:null,resultadoDiasParaDia:null}};return _this;}_createClass(Conversor,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'conversor',panelId:'conversor-amd',icon:'ico-calc',title:'Conversor Ano Mes Dia para Dia'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["y" /* DtpPanel */],{title:'Converter amd/d'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Anos',maxLength:'2',integer:true,value:this.state.conversorAnoMesDiaParaDias.anoParaDias,onChange:function onChange(e){return _this2.handleChangeConversorAnoMesDiaParaDias(e,'anoParaDias');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Meses',maxLength:'2',integer:true,value:this.state.conversorAnoMesDiaParaDias.mesParaDias,onChange:function onChange(e){return _this2.handleChangeConversorAnoMesDiaParaDias(e,'mesParaDias');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Dias',integer:true,maxLength:'2',value:this.state.conversorAnoMesDiaParaDias.diaParaDias,onChange:function onChange(e){return _this2.handleChangeConversorAnoMesDiaParaDias(e,'diaParaDias');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{disabled:true,value:'|',style:{borderBottom:'none','text-align':'center'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Dias',disabled:true,value:this.state.conversorAnoMesDiaParaDias.resultadoDias})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Button */],{className:'dtp-btn',title:'Limpar',hint:'Limpar',onClick:this.handleLimparConversorAnoMesDiaParaDias}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Button */],{className:'dtp-primary',title:'Converter',hint:'Converter amd/d',onClick:this.handleCalcularAnoMesDiaParaDias})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["y" /* DtpPanel */],{title:'Converter d/amd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Dias',maxLength:'5',integer:true,value:this.state.conversorDiaParaAnoMesDia.dias,onChange:function onChange(e){return _this2.handleChangeDiaParaAnoMesDia(e,'dias');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{disabled:true,value:'|',style:{borderBottom:'none','text-align':'center'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Anos',integer:true,disabled:true,value:this.state.conversorDiaParaAnoMesDia.resultadoDiasParaAno})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Meses',integer:true,disabled:true,value:this.state.conversorDiaParaAnoMesDia.resultadoDiasParaMes})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Dia',disabled:true,value:this.state.conversorDiaParaAnoMesDia.resultadoDiasParaDia})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Button */],{className:'dtp-btn',title:'Limpar',hint:'Limpar',onClick:this.handleLimparConversorDiaParaAnoMesDia}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Button */],{className:'dtp-primary',title:'Converter',hint:'Converter d/amd',onClick:this.handleCalcularDiaParaAnoMesDia})))))));}}]);return Conversor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Conversor.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (Conversor);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calculador_amd_ModalAlertaNumeroNegativo__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var Calculador=function(_Component){_inherits(Calculador,_Component);function Calculador(props){_classCallCheck(this,Calculador);var _this=_possibleConstructorReturn(this,(Calculador.__proto__||Object.getPrototypeOf(Calculador)).call(this,props));_this.handleModal=function(modal){_this.setState(_defineProperty({},modal,!_this.state[modal]));};_this.handleFechamentoModalAlerta=function(){_this.setState({chaveConfirmacao:null,alertas:[],showModalAlerta:!_this.state.showModalAlerta});};_this.handleChangeParcelas=function(changeObj,name){var _this$state=Object.assign({},_this.state),calculadorParcelas=_this$state.calculadorParcelas;_this.setState({calculadorParcelas:Object.assign({},calculadorParcelas,_defineProperty({},name,changeObj.value))});};_this.converterValoresParaTipoNumerico=function(valor){var retorno=null;if(valor){retorno=Number(valor);}return retorno;};_this.handleCalcularSoma=function(){var _this$state2=Object.assign({},_this.state),calculadorParcelas=_this$state2.calculadorParcelas;var anos=calculadorParcelas.parcelaAno?calculadorParcelas.parcelaAno:0;var meses=calculadorParcelas.parcelaMes?calculadorParcelas.parcelaMes:0;var dias=calculadorParcelas.parcelaDia?calculadorParcelas.parcelaDia:0;var anosInf=calculadorParcelas.parcelaInferiorAno?calculadorParcelas.parcelaInferiorAno:0;var mesesInf=calculadorParcelas.parcelaInferiorMes?calculadorParcelas.parcelaInferiorMes:0;var diasInf=calculadorParcelas.parcelaInferiorDia?calculadorParcelas.parcelaInferiorDia:0;var adicionarAno=0;var adicionarMes=0;var somaMes=0;var somaAno=0;var somaDia=0;var restoMes=0;var restoAno=0;var mes=1;var ano=12;var diasMes=30;somaMes=Math.trunc(Number(dias)+Number(diasInf));somaAno=Math.trunc(Number(meses)+Number(mesesInf));somaDia=Math.trunc(Number(dias)+Number(diasInf));if(somaDia>diasMes){somaDia=somaDia-diasMes;somaMes=somaMes+mes;}if(somaAno>='12'){adicionarAno=somaAno/ano;}if(somaMes>='30'){adicionarMes=somaMes/mes;}calculadorParcelas.resultadoAno=Math.trunc(Number(anos)+Number(anosInf));calculadorParcelas.resultadoMes=Math.trunc(Number(meses)+Number(mesesInf));calculadorParcelas.resultadoDia=Math.trunc(Number(dias)+Number(diasInf));calculadorParcelas.ultimaOperacao='soma';if(adicionarAno!==0&&calculadorParcelas.resultadoAno){calculadorParcelas.resultadoAno=Math.trunc(calculadorParcelas.resultadoAno+Number(adicionarAno));calculadorParcelas.resultadoMes=Math.trunc(Number(restoAno));}if(adicionarMes!==0&&calculadorParcelas.resultadoMes){calculadorParcelas.resultadoMes=Math.trunc(calculadorParcelas.resultadoMes+Number(adicionarMes));calculadorParcelas.resultadoDia=Math.trunc(Number(restoMes));}_this.setState({calculadorParcelas:Object.assign({},_this.state.calculadorParcelas)});};_this.handleCalcularSubtracao=function(){var _this$state3=Object.assign({},_this.state),calculadorParcelas=_this$state3.calculadorParcelas;var resultadoAnos=0;var resultadoMeses=0;var resultadoDias=0;var anos=calculadorParcelas.parcelaAno?calculadorParcelas.parcelaAno:0;var meses=calculadorParcelas.parcelaMes?calculadorParcelas.parcelaMes:0;var dias=calculadorParcelas.parcelaDia?calculadorParcelas.parcelaDia:0;var anosInf=calculadorParcelas.parcelaInferiorAno?calculadorParcelas.parcelaInferiorAno:0;var mesesInf=calculadorParcelas.parcelaInferiorMes?calculadorParcelas.parcelaInferiorMes:0;var diasInf=calculadorParcelas.parcelaInferiorDia?calculadorParcelas.parcelaInferiorDia:0;var operacaoAno=0;var operacaoAnoInf=0;var operacaoMes=0;var operacaoMesInf=0;var operacaoDia=0;var operacaoDiaInf=0;var acrescentarDia=1;var acrescentarDias=30;var reduzirMes=1;var acrescentarMeses=12;var reduzirAno=1;operacaoAno=Math.trunc(Number(anos));operacaoAnoInf=Math.trunc(anosInf);operacaoMes=Math.trunc(Number(meses));operacaoMesInf=Math.trunc(Number(mesesInf));operacaoDia=Math.trunc(Number(dias));operacaoDiaInf=Math.trunc(Number(diasInf));// Se necessário empresta 30 dias de 1 mês
if(operacaoDia<operacaoDiaInf){operacaoDia=Math.trunc(operacaoDia+acrescentarDias);operacaoMes=Math.trunc(operacaoMes-reduzirMes);}if(operacaoMes<operacaoMesInf){// Se necessário empresta 12 meses de 1 ano
operacaoMes=Math.trunc(operacaoMes+acrescentarMeses);operacaoAno=Math.trunc(operacaoAno-reduzirAno);}resultadoAnos=operacaoAno-operacaoAnoInf;resultadoMeses=operacaoMes-operacaoMesInf;resultadoDias=operacaoDia-operacaoDiaInf;calculadorParcelas.resultadoAno=Math.trunc(Number(resultadoAnos));calculadorParcelas.resultadoMes=Math.trunc(Number(resultadoMeses));calculadorParcelas.resultadoDia=Math.trunc(Number(resultadoDias+acrescentarDia));calculadorParcelas.ultimaOperacao='subtracao';// Exibe mensagem de erro se valor do resultado ano for negativo
if(resultadoAnos<0){_this.handleModal('showModalAlerta');}_this.setState({calculadorParcelas:Object.assign({},_this.state.calculadorParcelas,{calculadorParcelas:calculadorParcelas})});};_this.handleReset=function(){var _this$state4=Object.assign({},_this.state),calculadorParcelas=_this$state4.calculadorParcelas;calculadorParcelas.parcelaAno='';calculadorParcelas.parcelaMes='';calculadorParcelas.parcelaDia='';calculadorParcelas.parcelaInferiorAno='';calculadorParcelas.parcelaInferiorMes='';calculadorParcelas.parcelaInferiorDia='';calculadorParcelas.resultadoAno='';calculadorParcelas.resultadoMes='';calculadorParcelas.resultadoDia='';_this.setState({calculadorParcelas:{calculadorParcelas:calculadorParcelas}});};_this.handleProximo=function(){var _this$state5=Object.assign({},_this.state),calculadorParcelas=_this$state5.calculadorParcelas;calculadorParcelas.parcelaInferiorAno='';calculadorParcelas.parcelaInferiorMes='';calculadorParcelas.parcelaInferiorDia='';calculadorParcelas.parcelaAno=calculadorParcelas.resultadoAno;calculadorParcelas.parcelaMes=calculadorParcelas.resultadoMes;// Verifica a operação para reduzir o dia acrescentado na subtração
if(calculadorParcelas.ultimaOperacao==='subtracao'){calculadorParcelas.parcelaDia=Math.trunc(calculadorParcelas.resultadoDia-1);}else{calculadorParcelas.parcelaDia=calculadorParcelas.resultadoDia;}calculadorParcelas.resultadoAno='';calculadorParcelas.resultadoMes='';calculadorParcelas.resultadoDia='';_this.setState({calculadorParcelas:Object.assign({},calculadorParcelas)});};_this.verificarPreenchimentoInputs=function(){// const { calculadorParcelas } = { ...this.state };
var retorno=false;if(!(_this.state.calculadorParcelas.parcelaAno||_this.state.calculadorParcelas.parcelaMes||_this.state.calculadorParcelas.parcelaDia)){retorno=true;}return retorno;};_this.verificarPreenchimentoInputsResultado=function(){var _this$state6=Object.assign({},_this.state),calculadorParcelas=_this$state6.calculadorParcelas;var retorno=false;if(!(calculadorParcelas.resultadoAno||calculadorParcelas.resultadoMes||calculadorParcelas.resultadoDia)){retorno=true;}return retorno;};_this.state={showModalAlerta:false,calculadorParcelas:{parcelaAno:null,parcelaMes:null,parcelaDia:null,parcelaInferiorAno:null,parcelaInferiorMes:null,parcelaInferiorDia:null,resultadoAno:null,resultadoMes:null,resultadoDia:null,ultimaOperacao:null}};return _this;}_createClass(Calculador,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'calculador',panelId:'calculador-amd',icon:'ico-calc',title:'Soma/Subtra\xE7\xE3o de Datas'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Anos',maxLength:'4',integer:true,value:this.state.calculadorParcelas.parcelaAno,onChange:function onChange(e){return _this2.handleChangeParcelas(e,'parcelaAno');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Meses',maxLength:'2',integer:true,value:this.state.calculadorParcelas.parcelaMes,onChange:function onChange(e){return _this2.handleChangeParcelas(e,'parcelaMes');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Dias',integer:true,maxLength:'2',value:this.state.calculadorParcelas.parcelaDia,onChange:function onChange(e){return _this2.handleChangeParcelas(e,'parcelaDia');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Button */],{className:'ico-plus',mini:true,hint:'Somar',disabled:this.verificarPreenchimentoInputs(),onClick:this.handleCalcularSoma})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Button */],{className:'ico-triangle-right2',mini:true,hint:'Pr\xF3ximo',onClick:this.handleProximo,disabled:this.verificarPreenchimentoInputsResultado()}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Anos',integer:true,maxLength:'4',value:this.state.calculadorParcelas.parcelaInferiorAno,onChange:function onChange(e){return _this2.handleChangeParcelas(e,'parcelaInferiorAno');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Meses',integer:true,maxLength:'2',value:this.state.calculadorParcelas.parcelaInferiorMes,onChange:function onChange(e){return _this2.handleChangeParcelas(e,'parcelaInferiorMes');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Dias',integer:true,maxLength:'2',value:this.state.calculadorParcelas.parcelaInferiorDia,onChange:function onChange(e){return _this2.handleChangeParcelas(e,'parcelaInferiorDia');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Button */],{className:'ico-minus',mini:true,disabled:this.verificarPreenchimentoInputs(),hint:'Subtrair',onClick:this.handleCalcularSubtracao})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Button */],{className:'ico-eraser',mini:true,hint:'Limpar',onClick:this.handleReset,disabled:this.verificarPreenchimentoInputs()}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Anos',integer:true,disabled:true,value:this.state.calculadorParcelas.resultadoAno})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Meses',integer:true,disabled:true,value:this.state.calculadorParcelas.resultadoMes})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["k" /* Input */],{showMask:false,label:'Dias',integer:true,disabled:true,value:this.state.calculadorParcelas.resultadoDia}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'observacaoCalculador'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'* Observa\xE7\xF5es:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'observacaoCalculador'},'Na Soma n\xE3o utilize datas para o ano, ex.: 1999,2000. Tal pr\xE1tica ocorrer\xE1 em valor absurdo para o n\xFAmero de anos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'observacaoCalculador'},'Na Subtra\xE7\xE3o podem ser utilizadas datas para o ano, ex.: 1999,2000.'))),this.state.showModalAlerta?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__calculador_amd_ModalAlertaNumeroNegativo__["a" /* default */],{alertas:[__WEBPACK_IMPORTED_MODULE_4__utils_constants__["l" /* msgsCalculadorConversorNumeroNegativo */].aviso],aceitar:this.handleFechamentoModalAlerta,handleModal:this.handleFechamentoModalAlerta,showModal:this.state.showModalAlerta}):'')));}}]);return Calculador;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Calculador.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (Calculador);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(2);
var ModalAlertaNumeroNegativo=function ModalAlertaNumeroNegativo(props){var montaAlerta=function montaAlerta(alerta){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},alerta.descricao);};var montaListaAlertas=function montaListaAlertas(){var listaRelacoes=[];props.alertas.forEach(function(alerta){listaRelacoes.push(montaAlerta(alerta));});return listaRelacoes;};var montaModalContent=function montaModalContent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,montaListaAlertas());};var modalFooter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["a" /* Button */],{title:'Fechar',onClick:props.handleModal,hint:'Fechar'})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["n" /* Modal */],Object.assign({},props,{alert:true,alertType:'warning',conteudomodal:montaModalContent(),conteudofooter:modalFooter,onHide:props.handleModal,showTitle:true,size:'sm',title:'',showModal:true}));};ModalAlertaNumeroNegativo.propTypes={handleModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,aceitar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,alertas:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf({descricao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (ModalAlertaNumeroNegativo);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_img_logo_png__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_img_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_img_logo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var Logotipo=function(_Component){_inherits(Logotipo,_Component);function Logotipo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Logotipo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Logotipo.__proto__||Object.getPrototypeOf(Logotipo)).call.apply(_ref,[this].concat(args))),_this),_this.handleExibirLogotipo=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'logo-comprev',style:{textAlign:'center',width:'100%',paddingTop:'100px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__src_img_logo_png___default.a,alt:'img'})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Logotipo,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.handleExibirLogotipo());}}]);return Logotipo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Logotipo);

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.51e8341b.png";

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NovoRelatorioTotalizadorEstados__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FiltroRelatorioTotalizadorEstados__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_User__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var TelaRelatorioTotalizadorEstados=function(_Component){_inherits(TelaRelatorioTotalizadorEstados,_Component);function TelaRelatorioTotalizadorEstados(props){_classCallCheck(this,TelaRelatorioTotalizadorEstados);var _this=_possibleConstructorReturn(this,(TelaRelatorioTotalizadorEstados.__proto__||Object.getPrototypeOf(TelaRelatorioTotalizadorEstados)).call(this,props));_this.montaFiltros=function(atributosPesquisa){var atributos={};if(atributosPesquisa.participanteObservador){atributos=Object.assign({},atributos,{participanteObservador:atributosPesquisa.participanteObservador});}if(atributosPesquisa.participante){atributos=Object.assign({},atributos,{participante:atributosPesquisa.participante});}if(atributosPesquisa.estado){atributos=Object.assign({},atributos,{estado:atributosPesquisa.estado});}if(atributosPesquisa.opcao){atributos=Object.assign({},atributos,{opcao:atributosPesquisa.opcao});}if(atributosPesquisa.motivo){atributos=Object.assign({},atributos,{motivo:atributosPesquisa.motivo});}if(atributosPesquisa.superintendencia){atributos=Object.assign({},atributos,{superintendencia:atributosPesquisa.superintendencia});}if(atributosPesquisa.gex){atributos=Object.assign({},atributos,{gex:atributosPesquisa.gex});}if(atributosPesquisa.aps){atributos=Object.assign({},atributos,{aps:atributosPesquisa.aps});}if(atributosPesquisa.lista){atributos=Object.assign({},atributos,{lista:atributosPesquisa.lista});}var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.realizaConsulta=function(valoresFiltro){var filtrosEscolhidos={};if(valoresFiltro){filtrosEscolhidos=_this.montaFiltros(valoresFiltro);}_this.setState(Object.assign({},_this.state,{filtrosEscolhidos:filtrosEscolhidos,filtrosAtuais:valoresFiltro}),function(){return _this.executaConsulta();});};_this.zerarPaginacao=function(){_this.preparaNovaConsulta();};_this.definePapelFiltro=function(){var retorno='';var isRgps=_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','consultar-compensacao-rgps']);var isRpps=_this.props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps','consultar-compensacao-rpps']);var isAnalistaSprev=_this.props.auth.checkPermission(['analisar-negocio-sprev']);var isAnalistaDtp=_this.props.auth.checkPermission(['analisar-negocio-dtpv']);var isAnalistaDcomp=_this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);var isAuditorComprev=_this.props.auth.checkPermission(['auditar-comprev']);if(isRgps){retorno='analista-rgps';}if(isRpps){retorno='analista-rpps';}if(isAnalistaSprev){retorno='analista-sprev';}if(isAnalistaDtp){retorno='analista-dtp';}if(isAnalistaDcomp){retorno='analista-rgps';}if(isAuditorComprev){retorno='auditor-comprev';}_this.setState({papelUsuarioLogado:retorno},function(){return _this.buscarParticipantePeloCnpjLogado();});};_this.defineNivelFiltro=function(){if(_this.state.filtrosEscolhidos.participante){return 4;}else if(_this.state.filtrosEscolhidos.aps){return 3;}else if(_this.state.filtrosEscolhidos.gex){return 2;}else if(_this.state.filtrosEscolhidos.superintendencia){return 1;}return 0;};_this.definirValorUo=function(nivel){if(nivel===3){return _this.state.filtrosEscolhidos.aps;}else if(nivel===2){return _this.state.filtrosEscolhidos.gex;}else if(nivel===1){return _this.state.filtrosEscolhidos.superintendencia;}return 0;};_this.defineCodigoOutroParticipante=function(parametros){var novosParametros=parametros;if(_this.state.papelUsuarioLogado!=='analista-rgps'){novosParametros.outroParticipante='01000';}if(_this.state.filtrosEscolhidos.participante){novosParametros.codigo=_this.state.filtrosEscolhidos.participante;}else if(_this.state.filtrosEscolhidos.aps){novosParametros.codigo=_this.state.filtrosEscolhidos.aps;}else if(_this.state.filtrosEscolhidos.gex){novosParametros.codigo=_this.state.filtrosEscolhidos.gex;}else if(_this.state.filtrosEscolhidos.superintendencia){novosParametros.codigo=_this.state.filtrosEscolhidos.superintendencia;}return novosParametros;};_this.converterValoresParaTipoNumerico=function(valor){var retorno=null;if(valor){retorno=Number(valor);}return retorno;};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosEscolhidos).length!==0){var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;var urlRelatorio=null;var nivel=_this.defineNivelFiltro();urlRelatorio='relatorios/totalizadores';var parametros={tipoParticipacao:_this.converterValoresParaTipoNumerico(_this.state.filtrosEscolhidos.opcao),participante:_this.state.filtrosEscolhidos.participante,'start-position':primeiroItem,'max-results':resultadosPorPagina};if(_this.state.filtrosEscolhidos.participanteObservador){parametros.participanteObservador=_this.state.filtrosEscolhidos.participanteObservador;}if(_this.isConsultaPorVisao()){if(_this.state.papelUsuarioLogado==='analista-rgps'||_this.state.filtrosEscolhidos.participanteObservador==='01000'){parametros.nivelUo=nivel;parametros.idUo=_this.definirValorUo(nivel);}}_this.setState({urlExportacao:urlRelatorio,parametrosExportacao:parametros},function(){return _this.preparaRequest(urlRelatorio,parametros);});}};_this.preparaRequest=function(urlRelatorio,parametros){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["l" /* doPost */])(urlRelatorio,parametros,_this.tratarSucesso(),_this.tratarErro);};_this.recuperarTituloPorId=function(lista,id){var retorno='';var index=lista.findIndex(function(item){return item.value===id;});if(index!==-1){retorno=lista[index].label;}return retorno;};_this.exibirComplementoPorNivelSuperintendencia=function(){var nivel=_this.defineNivelFiltro();var retorno='';var nome='';switch(nivel){case 1:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaSuperintendencias,_this.state.filtrosEscolhidos.superintendencia);retorno='SUPERINTEND\xCANCIA: '+_this.state.filtrosEscolhidos.superintendencia+' - '+nome;break;case 2:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaGexs,_this.state.filtrosEscolhidos.gex);retorno='GEX: '+_this.state.filtrosEscolhidos.gex+' - '+nome;break;case 3:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaAps,_this.state.filtrosEscolhidos.aps);retorno='APS: '+_this.state.filtrosEscolhidos.aps+' - '+nome;break;default:break;}return retorno.toUpperCase();};_this.exibirNomeEstado=function(estado){return __WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["Q" /* tiposEstado */],estado).label.toUpperCase();};_this.handleClickNovoEstadoSuccess=function(response){_this.pushNavegacao(_this.state.tipoRequerimentoSelecionado,response.data.protocolo);};_this.handleClickNovoEstadoFail=function(){};_this.pushNavegacao=function(tipo,protocolo){_this.props.history.push('/requerimento/'+tipo+'/'+protocolo);};_this.limparTipoRequerimento=function(tipoAposentadoria){var retorno=tipoAposentadoria;if(tipoAposentadoria.indexOf('ã')!==-1){retorno='pensao';}return retorno.toLowerCase();};_this.handleClickDetalhe=function(tipoAposentadoria,protocolo){_this.setState({tipoRequerimentoSelecionado:_this.limparTipoRequerimento(tipoAposentadoria)});Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('requerimentos-compensacao-'+_this.limparTipoRequerimento(tipoAposentadoria)+'/'+protocolo,_this.handleClickNovoEstadoSuccess,_this.handleClickNovoEstadoFail);};_this.isConsultaPorVisao=function(){var ehVisao=false;if([2,3].includes(_this.state.filtrosEscolhidos.opcao)){ehVisao=true;}return ehVisao;};_this.handleSuccessBuscaPeloCnpjLogado=function(response){var nome='';if(response.data){nome=response.data.nome+' - '+response.data.codigo;_this.setState({nomeSolicitante:nome});}};_this.handleErrorBuscaPeloCnpjLogado=function(){return'';};_this.buscarParticipantePeloCnpjLogado=function(){if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)||_this.state.papelUsuarioLogado==='analista-rpps'){var usuarioLogado=new __WEBPACK_IMPORTED_MODULE_10__domain_User__["a" /* default */](localStorage.getItem('jwt'));var cnpj=usuarioLogado.cnpjDoPapel();if(cnpj){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('participantes-compensacao/'+cnpj,_this.handleSuccessBuscaPeloCnpjLogado,_this.handleErrorBuscaPeloCnpjLogado);}}else if(_this.state.papelUsuarioLogado==='analista-rgps'){_this.setState({nomeSolicitante:'RGPS'});}};_this.buscarDestinatario=function(){var nivel=_this.defineNivelFiltro();var retorno='';var nome='';switch(nivel){case 1:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaSuperintendencias,_this.state.filtrosEscolhidos.superintendencia);retorno='SUPERINTEND\xCANCIA: '+_this.state.filtrosEscolhidos.superintendencia+' - '+nome;break;case 2:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaGexs,_this.state.filtrosEscolhidos.gex);retorno='GEX: '+_this.state.filtrosEscolhidos.gex+' - '+nome;break;case 3:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaAps,_this.state.filtrosEscolhidos.aps);retorno='APS: '+_this.state.filtrosEscolhidos.aps+' - '+nome;break;case 4:if(_this.state.filtrosEscolhidos.participante==='01000'){nome='RGPS';}else{nome=_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participante);}retorno='DESTINAT\xC1RIO: '+_this.state.filtrosEscolhidos.participante+' - '+nome;break;default:break;}return retorno.toUpperCase();};_this.exibirNomeSolicitante=function(){var retorno='';if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)){retorno='SOLICITANTE: '+_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participanteObservador)+' -\n      '+_this.state.filtrosEscolhidos.participanteObservador;}else{retorno='SOLICITANTE: '+_this.state.nomeSolicitante;}return' - '+retorno.toUpperCase();};_this.montarTituloSolicitanteOuDestinatario=function(titulo){var retorno='';if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)){var participanteObservadorSelecionado=_this.state.filtrosEscolhidos.participanteObservador;retorno=titulo+' '+_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participanteObservador)+' - '+participanteObservadorSelecionado;}else{retorno=titulo+' '+_this.state.nomeSolicitante;}return retorno;};_this.especificarConsultaPorVisao=function(){var retorno='';switch(_this.state.filtrosEscolhidos.opcao){case 2:retorno=_this.montarTituloSolicitanteOuDestinatario('SOLICITANTE:');break;case 3:retorno=_this.montarTituloSolicitanteOuDestinatario('DESTINATÁRIO:');break;default:break;}return retorno;};_this.montarLegendaNomeRelatorioPorFiltroSelecionado=function(){var textoFinal='';var titulo='TOTALIZADORES DE REQUERIMENTOS POR ESTADO';var dataAtual=''+__WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('DD/MM/YYYY HH:mm:ss');if(_this.isConsultaPorVisao()){// (VISÃO: OPCAO SOLICITANTE OU DESTINATARIO ESCOLHIDA)
// textoFinal = `${titulo} ${nomeEstado} - ${this.especificarConsultaPorVisao()} ${dataAtual} ${complementoPorNivelSuperintendencia} ${complementoPorTipoDeLista}`;
textoFinal=titulo+' '+_this.exibirComplementoPorNivelSuperintendencia()+' '+dataAtual;}else{// textoFinal = `${titulo} ${nomeEstado} ${this.exibirNomeSolicitante()} ${this.buscarDestinatario()} ${dataAtual} ${complementoPorTipoDeLista}`;
// textoFinal = `${titulo} - AMBOS - ${dataAtual}`;
textoFinal=titulo+' - '+dataAtual;}return textoFinal;};_this.colunasRelatorio=['Solicitante','Destinatário','Criado','Em exigência','Alterado','Aguardando análise','Aguardando análise médico','Em análise','Em análise médico','Deferido','Análise suspensa','Em compensação','Aguardando compensação de aposentadoria','Rejeitado','Exigência / Indeferido','Criado / Rejeitado','Em Conflito'];_this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){var objSolicitante=item[Object.keys(item)[1]]+'-'+item[Object.keys(item)[0]];var objDestinatario=item[Object.keys(item)[3]]+'-'+item[Object.keys(item)[2]];objetoLinha={solicitante:objSolicitante,destinatario:objDestinatario,criado:item[Object.keys(item)[4]],emExigencia:item[Object.keys(item)[5]],alterado:item[Object.keys(item)[6]],aguardandoAnalise:item[Object.keys(item)[7]],aguardandoAnaliseMedico:item[Object.keys(item)[8]],emAnalise:item[Object.keys(item)[9]],emAnaliseMedico:item[Object.keys(item)[10]],deferido:item[Object.keys(item)[11]],analiseSuspensa:item[Object.keys(item)[13]],emCompensacao:item[Object.keys(item)[14]],aguardandoCompensacaoAposentadoria:item[Object.keys(item)[16]],rejeitado:item[Object.keys(item)[17]],exigenciaIndeferido:item[Object.keys(item)[18]],criadoRejeitado:item[Object.keys(item)[20]],emConflito:item[Object.keys(item)[21]]};return objetoLinha;});return dados;};_this.tratarSucesso=function(){return function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data!==''){var lista=_this.extrairColunasJson(response.data);var dadosFormatados=_this.prepararColunasExportacao(lista);_this.setState({listaResultados:lista,listaResultadosFormatados:dadosFormatados,colunasRelatorio:_this.colunasRelatorio,nomeRelatorio:_this.montarLegendaNomeRelatorioPorFiltroSelecionado(),estadoTabela:estadoTabela});}};};_this.prepararColunasExportacao=function(data){var dados=data.map(function(item){var linha=Object.assign({},item);return linha;});return dados;};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.formatarColuna=function(cell,tipo){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='moeda'){valor=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).formatToParts(cell).map(function(_ref){var type=_ref.type,value=_ref.value;switch(type){case'currency':return'';default:return value;}}).reduce(function(string,part){return string+part;});}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='booleano'){valor=cell===1?'S':'N';}return valor.trim();};_this.defineContainerStyle=function(){var width=_this.state.colunasRelatorio.length*130;if(width<1140){width=1140;}return{width:width+'px'};};_this.alterarPagina=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.paginaAtual=pagina;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.state={listaResultados:[],listaResultadosFormatados:[],colunasRelatorio:[],nomeRelatorio:'',dataFormatOptions:{},papelUsuarioLogado:null,nomeSolicitante:'',estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosAtuais:{},filtrosEscolhidos:{},urlExportacao:null,parametrosExportacao:null};return _this;}_createClass(TelaRelatorioTotalizadorEstados,[{key:'componentDidMount',value:function componentDidMount(){sessionStorage.removeItem('filtroRelatorioAnalitico');if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}this.definePapelFiltro();}// SE AS OPÇOES SOLICITANTE OU DESTINATARIO
// ESTIVEREM SELECIONADAS, TRATA-SE DE UMA
// CONSULTA POR VISÃO.
// montarColunasCabecalho = () => {
//   const tableHeader = this.colunasRelatorio.slice();
//   tableHeader.push('Detalhe');
//   return tableHeader;
// }
// FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
},{key:'render',value:function render(){var options={noDataText:'Nenhum registro a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FiltroRelatorioTotalizadorEstados__["a" /* default */],{tipo:'Totalizador por estados',handleSearchFilter:this.realizaConsulta,filtroModalidade:false,papelUsuarioLogado:this.state.papelUsuarioLogado,destinatarios:this.props.destinatarios,observardorDeMudanca:this.zerarPaginacao,nomeFiltro:'filtroRelatorioTotalizadorEstados'}),this.state.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NovoRelatorioTotalizadorEstados__["a" /* default */],{legend:this.state.nomeRelatorio,bordered:true,headers:this.state.colunasRelatorio,data:this.state.listaResultados,options:options,pagination:true,remote:true,dataFormatOptions:this.state.dataFormatOptions,landscape:true,containerStyle:this.defineContainerStyle()// exportacao={this.state.listaResultadosFormatados}
,fetchInfo:fetchInfo,rowAtual:this.state.rowAtual,urlExportacao:this.state.urlExportacao,parametrosExportacao:this.state.parametrosExportacao}):null);}}]);return TelaRelatorioTotalizadorEstados;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TelaRelatorioTotalizadorEstados.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};TelaRelatorioTotalizadorEstados.defaultProps={destinatarios:[]};// eslint-disable-next-line
var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(TelaRelatorioTotalizadorEstados));

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colunasRelatorioTotalizador=['Solicitante','Destinatário','Criado','Em exigência','Alterado','Aguardando análise','Aguardando análise médico','Em análise','Em análise médico','Deferido','Análise suspensa','Em compensação','Aguardando compensação de aposentadoria','Rejeitado','Exigência / Indeferido','Criado / Rejeitado','Em conflito'];var NovoRelatorioTotalizadorEstados=function(_Component){_inherits(NovoRelatorioTotalizadorEstados,_Component);function NovoRelatorioTotalizadorEstados(props){_classCallCheck(this,NovoRelatorioTotalizadorEstados);var _this=_possibleConstructorReturn(this,(NovoRelatorioTotalizadorEstados.__proto__||Object.getPrototypeOf(NovoRelatorioTotalizadorEstados)).call(this,props));_initialiseProps.call(_this);_this.state={showNoContent:false,noContentPrimaryMessage:null,noContentSecondaryMessage:null,legendaRelatorio:null};return _this;}_createClass(NovoRelatorioTotalizadorEstados,[{key:'render',value:function render(){var _this2=this;if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.data&&this.props.data.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Exportar para CSV',onClick:function onClick(){_this2.exportarCsv(_this2.props);},icon:'ico-doc-sheet',mini:true}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relatorio',style:{'--relatorioWidth':this.props.containerStyle.width}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["H" /* DtpTable */],this.props,this.props.headers.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["I" /* DtpTableHeader */],{key:item,dataField:_this2.props.data[0]?Object.keys(_this2.props.data[0])[i]:'default',dataAlign:'center',isKey:i===0,header:item,tdStyle:{wordBreak:'break-word'},dataFormat:_this2.props.dataFormatOptions[i],hidden:_this2.props.options.hidden&&_this2.props.options.hidden.includes(i)});})))):null);}}]);return NovoRelatorioTotalizadorEstados;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.gerarCsv=function(lista){if(lista&&lista!==undefined&&lista.length>0){var csvExporter=new __WEBPACK_IMPORTED_MODULE_3_export_to_csv__["ExportToCsv"]({filename:'relatorio',fieldSeparator:';',showTitle:true,title:_this3.state.legendaRelatorio,showLabels:true,headers:colunasRelatorioTotalizador});csvExporter.generateCsv(lista);}};this.prepararColunasExportacao=function(data){var dados=data.map(function(item){var linha=Object.assign({},item);return linha;});return dados;};this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){var objSolicitante=item[Object.keys(item)[1]]+'-'+item[Object.keys(item)[0]];var objDestinatario=item[Object.keys(item)[3]]+'-'+item[Object.keys(item)[2]];objetoLinha={solicitante:objSolicitante,destinatario:objDestinatario,criado:item[Object.keys(item)[4]],emExigencia:item[Object.keys(item)[5]],alterado:item[Object.keys(item)[6]],aguardandoAnalise:item[Object.keys(item)[7]],aguardandoAnaliseMedico:item[Object.keys(item)[8]],emAnalise:item[Object.keys(item)[9]],emAnaliseMedico:item[Object.keys(item)[10]],deferido:item[Object.keys(item)[11]],// indeferido: item[Object.keys(item)[12]],
analiseSuspensa:item[Object.keys(item)[13]],emCompensacao:item[Object.keys(item)[14]],aguardandoCompensacaoAposentadoria:item[Object.keys(item)[16]],rejeitado:item[Object.keys(item)[17]],exigenciaIndeferido:item[Object.keys(item)[18]],criadoRejeitado:item[Object.keys(item)[20]],emConflito:item[Object.keys(item)[21]]};return objetoLinha;});return dados;};this.tratarSucessoListaExportacao=function(response){if(response.data!==''){var lista=_this3.extrairColunasJson(response.data);var dadosFormatados=_this3.prepararColunasExportacao(lista);_this3.setState({},_this3.gerarCsv(dadosFormatados));}};this.tratarErro=function(){var mensagemPrimaria='Não foi possível consultar os requerimentos.';var mensagemSecundaria='Contate o administrador do sistema.';_this3.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};this.preparaRequest=function(url,parametros){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["l" /* doPost */])(url,parametros,_this3.tratarSucessoListaExportacao,_this3.tratarErro);};this.exportarCsv=function(props){_this3.setState({legendaRelatorio:props.legend});if(props.urlExportacao&&props.parametrosExportacao){var parametros=props.parametrosExportacao;parametros['start-position']=0;parametros['max-results']=100000;_this3.preparaRequest(props.urlExportacao,parametros);}};};NovoRelatorioTotalizadorEstados.propTypes={dataFormatOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object}.isRequired;NovoRelatorioTotalizadorEstados.defaultProps={voltarAction:function voltarAction(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (NovoRelatorioTotalizadorEstados);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NovoRelatorioAnalitico__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FiltroRelatorioAnalitico__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__domain_User__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var TODOS_OS_RESULTADOS='TODOS';var TelaRelatorioAnalitico=function(_Component){_inherits(TelaRelatorioAnalitico,_Component);function TelaRelatorioAnalitico(props){_classCallCheck(this,TelaRelatorioAnalitico);var _this=_possibleConstructorReturn(this,(TelaRelatorioAnalitico.__proto__||Object.getPrototypeOf(TelaRelatorioAnalitico)).call(this,props));_this.montaFiltros=function(atributosPesquisa){var atributos={};if(atributosPesquisa.participanteObservador){atributos=Object.assign({},atributos,{participanteObservador:atributosPesquisa.participanteObservador});}if(atributosPesquisa.participante){atributos=Object.assign({},atributos,{participante:atributosPesquisa.participante});}if(atributosPesquisa.estado){atributos=Object.assign({},atributos,{estado:atributosPesquisa.estado});}if(atributosPesquisa.opcao){atributos=Object.assign({},atributos,{opcao:atributosPesquisa.opcao});}if(atributosPesquisa.motivo){atributos=Object.assign({},atributos,{motivo:atributosPesquisa.motivo});}if(atributosPesquisa.superintendencia){atributos=Object.assign({},atributos,{superintendencia:atributosPesquisa.superintendencia});}if(atributosPesquisa.gex){atributos=Object.assign({},atributos,{gex:atributosPesquisa.gex});}if(atributosPesquisa.aps){atributos=Object.assign({},atributos,{aps:atributosPesquisa.aps});}if(atributosPesquisa.lista){atributos=Object.assign({},atributos,{lista:atributosPesquisa.lista});}var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.realizaConsulta=function(valoresFiltro){var filtrosEscolhidos={};if(valoresFiltro){filtrosEscolhidos=_this.montaFiltros(valoresFiltro);}_this.setState(Object.assign({},_this.state,{filtrosEscolhidos:filtrosEscolhidos,filtrosAtuais:valoresFiltro}),function(){return _this.executaConsulta();});};_this.zerarPaginacao=function(){_this.preparaNovaConsulta();};_this.definePapelFiltro=function(){var retorno='';var isRgps=_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','consultar-compensacao-rgps']);var isRpps=_this.props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps','consultar-compensacao-rpps']);var isAnalistaSprev=_this.props.auth.checkPermission(['analisar-negocio-sprev']);var isAnalistaDtp=_this.props.auth.checkPermission(['analisar-negocio-dtpv']);var isAnalistaDcomp=_this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);var isAuditorComprev=_this.props.auth.checkPermission(['auditar-comprev']);if(isRgps){retorno='analista-rgps';}if(isRpps){retorno='analista-rpps';}if(isAnalistaSprev){retorno='analista-sprev';}if(isAnalistaDtp){retorno='analista-dtp';}if(isAnalistaDcomp){retorno='analista-rgps';}if(isAuditorComprev){retorno='auditor-comprev';}_this.setState({papelUsuarioLogado:retorno},function(){return _this.buscarParticipantePeloCnpjLogado();});};_this.defineNivelFiltro=function(){if(_this.state.filtrosEscolhidos.participante){return 4;}else if(_this.state.filtrosEscolhidos.aps){return 3;}else if(_this.state.filtrosEscolhidos.gex){return 2;}else if(_this.state.filtrosEscolhidos.superintendencia){return 1;}return 0;};_this.definirValorUo=function(nivel){if(nivel===3){return _this.state.filtrosEscolhidos.aps;}else if(nivel===2){return _this.state.filtrosEscolhidos.gex;}else if(nivel===1){return _this.state.filtrosEscolhidos.superintendencia;}return 0;};_this.defineCodigoOutroParticipante=function(parametros){var novosParametros=parametros;if(_this.state.papelUsuarioLogado!=='analista-rgps'){novosParametros.outroParticipante='01000';}if(_this.state.filtrosEscolhidos.participante){novosParametros.codigo=_this.state.filtrosEscolhidos.participante;}else if(_this.state.filtrosEscolhidos.aps){novosParametros.codigo=_this.state.filtrosEscolhidos.aps;}else if(_this.state.filtrosEscolhidos.gex){novosParametros.codigo=_this.state.filtrosEscolhidos.gex;}else if(_this.state.filtrosEscolhidos.superintendencia){novosParametros.codigo=_this.state.filtrosEscolhidos.superintendencia;}return novosParametros;};_this.extrairValoresParaPesquisar=function(){var listaValores=_this.state.filtrosEscolhidos.lista;var lista=[];var valor=void 0;if(listaValores.length>0){listaValores.forEach(function(item){if(item.value){valor=Number(item.value);lista.push(valor);}});}return lista;};_this.converterValoresParaTipoNumerico=function(valor){var retorno=null;if(valor){retorno=Number(valor);}return retorno;};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosEscolhidos).length!==0){var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;var urlRelatorio=null;var nivel=_this.defineNivelFiltro();urlRelatorio='relatorios/analiticos';var parametros={tipoParticipacao:_this.converterValoresParaTipoNumerico(_this.state.filtrosEscolhidos.opcao),participante:_this.state.filtrosEscolhidos.participante,estado:_this.converterValoresParaTipoNumerico(_this.state.filtrosEscolhidos.estado),tipos:_this.extrairValoresParaPesquisar(),'start-position':primeiroItem,'max-results':resultadosPorPagina};if(_this.state.filtrosEscolhidos.participanteObservador){parametros.participanteObservador=_this.state.filtrosEscolhidos.participanteObservador;}if(_this.isConsultaPorVisao()){if(_this.state.papelUsuarioLogado==='analista-rgps'||_this.state.filtrosEscolhidos.participanteObservador==='01000'){parametros.nivelUo=nivel;parametros.idUo=_this.definirValorUo(nivel);}}_this.setState({urlExportacao:urlRelatorio,parametrosExportacao:parametros},function(){return _this.preparaRequest(urlRelatorio,parametros);});}};_this.preparaRequest=function(urlRelatorio,parametros){Object(__WEBPACK_IMPORTED_MODULE_7__utils_requests__["l" /* doPost */])(urlRelatorio,parametros,_this.tratarSucesso(),_this.tratarErro);};_this.exibirComplementoPorTipoDeLista=function(estado,listaAtual){var listaPreenchida=listaAtual.length>0;var retorno='';switch(estado){case 2:retorno='com as exig\xEAncias: [ '+(listaPreenchida?_this.extrairValoresParaPesquisar():TODOS_OS_RESULTADOS)+' ]';break;case 9:retorno='com os motivos de indeferimento: [ '+(listaPreenchida?_this.extrairValoresParaPesquisar():TODOS_OS_RESULTADOS)+' ]';break;case 10:retorno='com o motivo de suspens\xE3o: ( '+(listaPreenchida?_this.state.filtrosEscolhidos.lista[0].value+' - '+_this.state.filtrosEscolhidos.lista[0].label:TODOS_OS_RESULTADOS)+' )';break;case 12:retorno='com o motivo de cessa\xE7\xE3o: ('+(listaPreenchida?_this.state.filtrosEscolhidos.lista[0].value+' - '+_this.state.filtrosEscolhidos.lista[0].label:TODOS_OS_RESULTADOS)+' )';break;default:break;}return retorno.toUpperCase();};_this.recuperarTituloPorId=function(lista,id){var retorno='';var index=lista.findIndex(function(item){return item.value===id;});if(index!==-1){retorno=lista[index].label;}return retorno;};_this.exibirComplementoPorNivelSuperintendencia=function(){var nivel=_this.defineNivelFiltro();var retorno='';var nome='';switch(nivel){case 1:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaSuperintendencias,_this.state.filtrosEscolhidos.superintendencia);retorno='SUPERINTEND\xCANCIA: '+_this.state.filtrosEscolhidos.superintendencia+' - '+nome;break;case 2:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaGexs,_this.state.filtrosEscolhidos.gex);retorno='GEX: '+_this.state.filtrosEscolhidos.gex+' - '+nome;break;case 3:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaAps,_this.state.filtrosEscolhidos.aps);retorno='APS: '+_this.state.filtrosEscolhidos.aps+' - '+nome;break;default:break;}return retorno.toUpperCase();};_this.exibirNomeEstado=function(estado){return __WEBPACK_IMPORTED_MODULE_10__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_10__utils_listsSelect__["Q" /* tiposEstado */],estado).label.toUpperCase();};_this.handleClickNovoEstadoSuccess=function(response){_this.pushNavegacao(_this.state.tipoRequerimentoSelecionado,response.data.protocolo);};_this.handleClickNovoEstadoFail=function(){};_this.pushNavegacao=function(tipo,protocolo){_this.props.history.push('/requerimento/'+tipo+'/'+protocolo);};_this.limparTipoRequerimento=function(tipoAposentadoria){var retorno=tipoAposentadoria;if(tipoAposentadoria.indexOf('ã')!==-1){retorno='pensao';}return retorno.toLowerCase();};_this.handleClickDetalhe=function(tipoAposentadoria,protocolo){_this.setState({tipoRequerimentoSelecionado:_this.limparTipoRequerimento(tipoAposentadoria)});Object(__WEBPACK_IMPORTED_MODULE_7__utils_requests__["e" /* doGet */])('requerimentos-compensacao-'+_this.limparTipoRequerimento(tipoAposentadoria)+'/'+protocolo,_this.handleClickNovoEstadoSuccess,_this.handleClickNovoEstadoFail);};_this.montarColunasCabecalho=function(){var tableHeader=_this.colunasRelatorio.slice();tableHeader.push('Detalhe');return tableHeader;};_this.isConsultaPorVisao=function(){var ehVisao=false;if([2,3].includes(_this.state.filtrosEscolhidos.opcao)){ehVisao=true;}return ehVisao;};_this.handleSuccessBuscaPeloCnpjLogado=function(response){var nome='';if(response.data){nome=response.data.nome+' - '+response.data.codigo;_this.setState({nomeSolicitante:nome});}};_this.handleErrorBuscaPeloCnpjLogado=function(){return'';};_this.buscarParticipantePeloCnpjLogado=function(){if(Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)||_this.state.papelUsuarioLogado==='analista-rpps'){var usuarioLogado=new __WEBPACK_IMPORTED_MODULE_11__domain_User__["a" /* default */](localStorage.getItem('jwt'));var cnpj=usuarioLogado.cnpjDoPapel();if(cnpj){Object(__WEBPACK_IMPORTED_MODULE_7__utils_requests__["e" /* doGet */])('participantes-compensacao/'+cnpj,_this.handleSuccessBuscaPeloCnpjLogado,_this.handleErrorBuscaPeloCnpjLogado);}}else if(_this.state.papelUsuarioLogado==='analista-rgps'){_this.setState({nomeSolicitante:'RGPS'});}};_this.buscarDestinatario=function(){var nivel=_this.defineNivelFiltro();var retorno='';var nome='';switch(nivel){case 1:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaSuperintendencias,_this.state.filtrosEscolhidos.superintendencia);retorno='SUPERINTEND\xCANCIA: '+_this.state.filtrosEscolhidos.superintendencia+' - '+nome;break;case 2:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaGexs,_this.state.filtrosEscolhidos.gex);retorno='GEX: '+_this.state.filtrosEscolhidos.gex+' - '+nome;break;case 3:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaAps,_this.state.filtrosEscolhidos.aps);retorno='APS: '+_this.state.filtrosEscolhidos.aps+' - '+nome;break;case 4:if(_this.state.filtrosEscolhidos.participante==='01000'){nome='RGPS';}else{nome=_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participante);}retorno='DESTINAT\xC1RIO: '+_this.state.filtrosEscolhidos.participante+' - '+nome;break;default:break;}return retorno.toUpperCase();};_this.exibirNomeSolicitante=function(){var retorno='';if(Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)){retorno='SOLICITANTE: '+_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participanteObservador)+' -\n      '+_this.state.filtrosEscolhidos.participanteObservador;}else{retorno='SOLICITANTE: '+_this.state.nomeSolicitante;}return' - '+retorno.toUpperCase();};_this.montarTituloSolicitanteOuDestinatario=function(titulo){var retorno='';if(Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)){var participanteObservadorSelecionado=_this.state.filtrosEscolhidos.participanteObservador;retorno=titulo+' '+_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participanteObservador)+' - '+participanteObservadorSelecionado;}else{retorno=titulo+' '+_this.state.nomeSolicitante;}return retorno;};_this.especificarConsultaPorVisao=function(){var retorno='';switch(_this.state.filtrosEscolhidos.opcao){case 2:retorno=_this.montarTituloSolicitanteOuDestinatario('SOLICITANTE:');break;case 3:retorno=_this.montarTituloSolicitanteOuDestinatario('DESTINATÁRIO:');break;default:break;}return retorno;};_this.montarLegendaNomeRelatorioPorFiltroSelecionado=function(){var complementoPorTipoDeLista='';var textoFinal='';var estado=_this.converterValoresParaTipoNumerico(_this.state.filtrosEscolhidos.estado);var titulo='REQUERIMENTOS NO ESTADO';var dataAtual=''+__WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('DD/MM/YYYY HH:mm:ss');var nomeEstado=_this.exibirNomeEstado(estado);var listaAtual=_this.state.filtrosEscolhidos.lista;complementoPorTipoDeLista=''+_this.exibirComplementoPorTipoDeLista(estado,listaAtual);if(_this.isConsultaPorVisao()){// (VISÃO: OPCAO SOLICITANTE OU DESTINATARIO ESCOLHIDA)
// textoFinal = `${titulo} ${nomeEstado} - ${this.especificarConsultaPorVisao()} ${dataAtual} ${complementoPorNivelSuperintendencia} ${complementoPorTipoDeLista}`;
textoFinal=titulo+' '+nomeEstado+' '+_this.exibirComplementoPorNivelSuperintendencia()+' '+dataAtual+' '+complementoPorTipoDeLista;}else{// textoFinal = `${titulo} ${nomeEstado} ${this.exibirNomeSolicitante()} ${this.buscarDestinatario()} ${dataAtual} ${complementoPorTipoDeLista}`;
// textoFinal = `${titulo} ${nomeEstado} - AMBOS - ${dataAtual} ${complementoPorTipoDeLista}`;
textoFinal=titulo+' '+nomeEstado+' - '+dataAtual+' '+complementoPorTipoDeLista;}return textoFinal;};_this.pesquisarColunaJson=function(json,coluna){var retorno=json[coluna];if(retorno===undefined){retorno='';}return retorno;};_this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){var objSolicitante=item[Object.keys(item)[1]]+'-'+item[Object.keys(item)[0]];var objDestinatario=item[Object.keys(item)[3]]+'-'+item[Object.keys(item)[2]];objetoLinha={solicitante:objSolicitante,destinatario:objDestinatario,nit:_this.pesquisarColunaJson(item,'nit'),cpf:_this.pesquisarColunaJson(item,'cpf'),matricula:_this.pesquisarColunaJson(item,'matricula'),protocolo:_this.pesquisarColunaJson(item,'protocolo'),tipoRequerimento:_this.pesquisarColunaJson(item,'tipoRequerimento'),tipoAposentadoria:_this.pesquisarColunaJson(item,'tipoAposentadoria'),nomeBeneficiario:_this.pesquisarColunaJson(item,'nomeBeneficiario'),dataAbertura:_this.pesquisarColunaJson(item,'dataAbertura'),dataSituacao:_this.pesquisarColunaJson(item,'dataSituacao'),diasSituacao:_this.pesquisarColunaJson(item,'diasSituacao'),dataMigracao:_this.pesquisarColunaJson(item,'dataMigracao')};return objetoLinha;});return dados;};_this.tratarSucesso=function(){return function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;var colunasFormatarExportacao=[];var dataFormatOptions={};if(response.data!==''){var lista=_this.extrairColunasJson(response.data);dataFormatOptions=_this.relatorioDataFormatOptions;colunasFormatarExportacao=_this.listaColunasFormatar;var dadosFormatados=_this.prepararColunasExportacao(lista,colunasFormatarExportacao);_this.setState({listaResultados:lista,listaResultadosFormatados:dadosFormatados,colunasRelatorio:_this.montarColunasCabecalho(),dataFormatOptions:dataFormatOptions,nomeRelatorio:_this.montarLegendaNomeRelatorioPorFiltroSelecionado(),estadoTabela:estadoTabela});}};};_this.prepararColunasExportacao=function(data,colunas){var dados=data.map(function(item){var linha=Object.assign({},item);colunas.forEach(function(c){var key=Object.keys(item)[c.index];var coluna=item[key];var colunaFormatada=_this.formatarColuna(coluna,c.tipo);linha[key]=colunaFormatada;});return linha;});return dados;};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.colunasRelatorio=['Solicitante','Destinatário','NIT','CPF','Matrícula','Protocolo','Tipo do requerimento','Tipo do aposentadoria','Nome do beneficiário','Data da abertura','Data da situação','Dias na situação','Data da migração'];_this.listaColunasFormatar=[{index:2,tipo:'nit'},{index:3,tipo:'cpf'},{index:5,tipo:'protocolo'}];_this.formatarColuna=function(cell,tipo){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='nit'){if(Number.isInteger(cell)){valor=cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}else{valor=cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}}else if(tipo==='protocolo'){valor='\''+cell;}return valor.trim();};_this.montaColuna=function(tipo){return function(cell,row){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='nit'){if(Number.isInteger(cell)){valor=cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}else{valor=cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}}else if(tipo==='botao'){valor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{hint:'ir para o requerimento',icon:'ico-doc-magnifier',mini:true,onClick:function onClick(){return _this.handleClickDetalhe(row.tipoRequerimento,row.protocolo);}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,valor);};};_this.relatorioDataFormatOptions={2:_this.montaColuna('nit'),3:_this.montaColuna('cpf'),13:_this.montaColuna('botao')};_this.defineContainerStyle=function(){var width=_this.state.colunasRelatorio.length*130;if(width<1140){width=1140;}return{width:width+'px'};};_this.alterarPagina=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.paginaAtual=pagina;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,listaResultados:[],nomeRelatorio:'',estadoTabela:estadoTabela},_this.realizaConsulta());};_this.state={listaResultados:[],listaResultadosFormatados:[],colunasRelatorio:[],nomeRelatorio:'',dataFormatOptions:{},papelUsuarioLogado:null,nomeSolicitante:'',estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosAtuais:{},filtrosEscolhidos:{},urlExportacao:null,parametrosExportacao:null};return _this;}_createClass(TelaRelatorioAnalitico,[{key:'componentDidMount',value:function componentDidMount(){sessionStorage.removeItem('filtroRelatorioAnalitico');if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_7__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}this.definePapelFiltro();}// SE AS OPÇOES SOLICITANTE OU DESTINATARIO
// ESTIVEREM SELECIONADAS, TRATA-SE DE UMA
// CONSULTA POR VISÃO.
// FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
},{key:'render',value:function render(){var options={noDataText:'Nenhum requerimento a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_10__utils_listsSelect__["o" /* linhasPorPagina */]// alwaysShowAllBtns: false,
};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FiltroRelatorioAnalitico__["a" /* default */],{tipo:'Relat\xF3rio anal\xEDtico',handleSearchFilter:this.realizaConsulta,filtroModalidade:false,papelUsuarioLogado:this.state.papelUsuarioLogado,destinatarios:this.props.destinatarios,observardorDeMudanca:this.zerarPaginacao}),this.state.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NovoRelatorioAnalitico__["a" /* default */],{legend:this.state.nomeRelatorio,bordered:true,headers:this.state.colunasRelatorio,data:this.state.listaResultados,options:options,pagination:true,remote:true,dataFormatOptions:this.state.dataFormatOptions,landscape:true,containerStyle:this.defineContainerStyle()// exportacao={this.state.listaResultadosFormatados}
,fetchInfo:fetchInfo,rowAtual:this.state.rowAtual,urlExportacao:this.state.urlExportacao,parametrosExportacao:this.state.parametrosExportacao}):null);}}]);return TelaRelatorioAnalitico;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TelaRelatorioAnalitico.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};TelaRelatorioAnalitico.defaultProps={destinatarios:[]};// eslint-disable-next-line
var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(TelaRelatorioAnalitico));

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NovoRelatorioAnalitico=function(_Component){_inherits(NovoRelatorioAnalitico,_Component);function NovoRelatorioAnalitico(props){_classCallCheck(this,NovoRelatorioAnalitico);var _this=_possibleConstructorReturn(this,(NovoRelatorioAnalitico.__proto__||Object.getPrototypeOf(NovoRelatorioAnalitico)).call(this,props));_initialiseProps.call(_this);_this.state={showNoContent:false,noContentPrimaryMessage:null,noContentSecondaryMessage:null,legendaRelatorio:null};return _this;}// FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
_createClass(NovoRelatorioAnalitico,[{key:'render',value:function render(){var _this2=this;if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.data&&this.props.data.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Exportar para CSV',onClick:function onClick(){_this2.exportarCsv(_this2.props);},icon:'ico-doc-sheet',mini:true}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relatorio',style:{'--relatorioWidth':this.props.containerStyle.width}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["H" /* DtpTable */],this.props,this.props.headers.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["I" /* DtpTableHeader */],{key:item,dataField:_this2.props.data[0]?Object.keys(_this2.props.data[0])[i]:'default',dataAlign:'center',isKey:i===0,header:item,tdStyle:{wordBreak:'break-word'},dataFormat:_this2.props.dataFormatOptions[i],hidden:_this2.props.options.hidden&&_this2.props.options.hidden.includes(i)});})))):null);}}]);return NovoRelatorioAnalitico;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.gerarCsv=function(lista){if(lista&&lista!==undefined&&lista.length>0){var csvExporter=new __WEBPACK_IMPORTED_MODULE_3_export_to_csv__["ExportToCsv"]({filename:'relatorio',fieldSeparator:';',showTitle:true,title:_this3.state.legendaRelatorio,showLabels:true,headers:_this3.colunasRelatorio});csvExporter.generateCsv(lista);}};this.formatarColuna=function(cell,tipo){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='nit'){if(Number.isInteger(cell)){valor=cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}else{valor=cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}}else if(tipo==='protocolo'){valor='\''+cell;}return valor.trim();};this.prepararColunasExportacao=function(data,colunas){var dados=data.map(function(item){var linha=Object.assign({},item);colunas.forEach(function(c){var key=Object.keys(item)[c.index];var coluna=item[key];var colunaFormatada=_this3.formatarColuna(coluna,c.tipo);linha[key]=colunaFormatada;});return linha;});return dados;};this.pesquisarColunaJson=function(json,coluna){var retorno=json[coluna];if(retorno===undefined){retorno='';}return retorno;};this.colunasRelatorio=['Solicitante','Destinatário','NIT','CPF','Matrícula','Protocolo','Tipo do requerimento','Tipo do aposentadoria','Nome do beneficiário','Data da abertura','Data da situação','Dias na situação','Data da migração'];this.listaColunasFormatar=[{index:2,tipo:'nit'},{index:3,tipo:'cpf'},{index:5,tipo:'protocolo'}];this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){var objSolicitante=item[Object.keys(item)[1]]+'-'+item[Object.keys(item)[0]];var objDestinatario=item[Object.keys(item)[3]]+'-'+item[Object.keys(item)[2]];objetoLinha={solicitante:objSolicitante,destinatario:objDestinatario,nit:_this3.pesquisarColunaJson(item,'nit'),cpf:_this3.pesquisarColunaJson(item,'cpf'),matricula:_this3.pesquisarColunaJson(item,'matricula'),protocolo:_this3.pesquisarColunaJson(item,'protocolo'),tipoRequerimento:_this3.pesquisarColunaJson(item,'tipoRequerimento'),tipoAposentadoria:_this3.pesquisarColunaJson(item,'tipoAposentadoria'),nomeBeneficiario:_this3.pesquisarColunaJson(item,'nomeBeneficiario'),dataAbertura:_this3.pesquisarColunaJson(item,'dataAbertura'),dataSituacao:_this3.pesquisarColunaJson(item,'dataSituacao'),diasSituacao:_this3.pesquisarColunaJson(item,'diasSituacao'),dataMigracao:_this3.pesquisarColunaJson(item,'dataMigracao')};return objetoLinha;});return dados;};this.tratarSucessoListaExportacao=function(response){if(response.data!==''){var lista=_this3.extrairColunasJson(response.data);var dadosFormatados=_this3.prepararColunasExportacao(lista,_this3.listaColunasFormatar);_this3.setState({},_this3.gerarCsv(dadosFormatados));}};this.tratarErro=function(){var mensagemPrimaria='Não foi possível consultar os requerimentos.';var mensagemSecundaria='Contate o administrador do sistema.';_this3.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};this.preparaRequest=function(url,parametros){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["l" /* doPost */])(url,parametros,_this3.tratarSucessoListaExportacao,_this3.tratarErro);};this.exportarCsv=function(props){_this3.setState({legendaRelatorio:props.legend});if(props.urlExportacao&&props.parametrosExportacao){var parametros=props.parametrosExportacao;parametros['start-position']=0;parametros['max-results']=100000;_this3.preparaRequest(props.urlExportacao,parametros);}};};NovoRelatorioAnalitico.propTypes={dataFormatOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object}.isRequired;NovoRelatorioAnalitico.defaultProps={voltarAction:function voltarAction(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (NovoRelatorioAnalitico);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelecaoSuperintendencia__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var participanteRGPS='01000';var FiltroRelatorioAnalitico=function(_Component){_inherits(FiltroRelatorioAnalitico,_Component);function FiltroRelatorioAnalitico(){_classCallCheck(this,FiltroRelatorioAnalitico);var _this=_possibleConstructorReturn(this,(FiltroRelatorioAnalitico.__proto__||Object.getPrototypeOf(FiltroRelatorioAnalitico)).call(this));_this.configurarSelecaoMultipla=function(estado){var configuracao=void 0;switch(estado){case'2':configuracao={// listaSource: this.props.exigencias,
labelCombobox:"Exigência",titulo:"Tipos de exigência",exibirBotaoIncluir:true,exibirTabelaItens:true,retirarLinhaSeparadora:false,exibirComboBox:true};break;case'9':configuracao={// listaSource: this.props.motivosIndeferimento,
labelCombobox:"Motivo de indeferimento",titulo:"Tipos de indeferimento",exibirBotaoIncluir:true,exibirTabelaItens:true,retirarLinhaSeparadora:false,exibirComboBox:true};break;case'10':configuracao={// listaSource: this.props.motivosSuspensao,
labelCombobox:"Motivo de suspensão",titulo:"Tipos de suspensão",exibirBotaoIncluir:false,exibirTabelaItens:false,retirarLinhaSeparadora:false,exibirComboBox:true};break;case'12':configuracao={// listaSource: this.props.motivosCessacao,
labelCombobox:"Motivo de cessação",titulo:"Tipos de cessação",exibirBotaoIncluir:false,exibirTabelaItens:false,retirarLinhaSeparadora:false,exibirComboBox:true};break;default:configuracao={// listaSource: [],
labelCombobox:"",titulo:"",exibirBotaoIncluir:false,exibirTabelaItens:false,retirarLinhaSeparadora:true,exibirComboBox:false};break;}return configuracao;};_this.filtrarRegimes=function(){var retorno=_this.state.listaTiposRegimes;if(_this.props.papelUsuarioLogado==='analista-rgps'||_this.state.tipoRegimeObservador===1&&Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)){retorno=_this.state.listaTiposRegimes.filter(function(item){return item.label!=='RGPS';});}if(_this.props.papelUsuarioLogado!=='analista-rgps'||_this.state.tipoRegimeObservador===2&&Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)){retorno=__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */];}_this.setState({listaTiposRegimes:retorno});};_this.handleChangeOpcao=function(value){_this.filtrarRegimes();var ehVisao=false;if([2,3].includes(value)){ehVisao=true;}else{ehVisao=false;}_this.setState({opcao:value,consultaPorVisao:ehVisao},function(){return _this.limparFormulario(value);});};_this.handleChange=function(changeObj,name){var _this$setState;var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var configuracao=_this.state.configComponenteSelecaoMultipla;var limparCampos=false;if(name==='estado'){configuracao=_this.configurarSelecaoMultipla(changeObj.value);_this.setState({lista:[]});}if(name==='tipoRegimeObservador'){if(changeObj.value===1){_this.setState({participanteObservador:participanteRGPS});}_this.setState({tipoRegimeObservador:changeObj.value},_this.filtrarRegimes);// if (this.state.tipoRegimeObservador !== null && (this.state.tipoRegimeObservador !== changeObj.value)) {
//   limparCampos = true;
// }
}if(name==='tipoRegime'){if(changeObj.value===1){_this.setState({participante:participanteRGPS});}// if (this.state.tipoRegime !== null && (this.state.tipoRegime !== changeObj.value)) {
//   limparCampos = true;
// }
}if(name==='estado'){if(_this.state.valorComboSelecaoMultipla!==null&&_this.state.valorComboSelecaoMultipla!==changeObj.value){limparCampos=true;}}if(callback===null){callback=function callback(){return _this.trataFormulario(limparCampos,name);};}_this.setState((_this$setState={},_defineProperty(_this$setState,name,changeObj.value),_defineProperty(_this$setState,'configComponenteSelecaoMultipla',configuracao),_this$setState),callback);};_this.handleChangeRadio=function(changeObj,name){var _this$setState2;_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,changeObj.value),_defineProperty(_this$setState2,'consultaPorVisao',true),_this$setState2));};_this.trataFormulario=function(limparCampos,campoAlterado){if(campoAlterado==='tipoRegimeObservador'&&limparCampos){_this.setState({tipoEntidadeObservador:null,uFObservador:null,participanteObservador:null,opcao:null,participante:null,tipoEntidade:null,uf:null});}if(campoAlterado==='tipoRegime'&&limparCampos){_this.setState({tipoEntidade:null,uF:null,participante:null});}if(campoAlterado==='estado'&&limparCampos){_this.setState({valorComboSelecaoMultipla:null});}if(campoAlterado==='tipoEntidade'){_this.setState({participante:null,uf:null});}if(campoAlterado==='uf'){_this.setState({participante:null});}if(campoAlterado==='superintendencia'){_this.setState({gex:null,aps:null,ente:null});if(_this.state.superintendencia){_this.carregaUnidadesOrganicas(3,_this.state.superintendencia,_this.carregaGexs);}}if(campoAlterado==='gex'){_this.setState({aps:null,ente:null});if(_this.state.gex){_this.carregaUnidadesOrganicas(4,_this.state.gex,_this.carregaAps);}}_this.props.observardorDeMudanca();};_this.limparFormulario=function(valor){if(valor===''||(valor===2||valor===3)&&_this.state.tipoEntidade!==null){_this.setState({tipoEntidade:null});}if((valor===2||valor===3)&&_this.state.participante!==null){_this.setState({participante:null});}if(_this.state.tipoRegime!==null){_this.setState({tipoRegime:null});}if(_this.state.superintendencia!==null){_this.setState({superintendencia:null});}if(_this.state.gex!==null){_this.setState({gex:null});}if(_this.state.visao!==null){_this.setState({visao:null});}_this.props.observardorDeMudanca();};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.carregarListaTiposRegimes=function(){_this.setState({listaTiposRegimes:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */]});};_this.carregaUnidadesOrganicas=function(categoria,codigoSuperior,sucesso){var parametros={};if(codigoSuperior){parametros.codigoSuperior=codigoSuperior;}if(categoria){parametros.categoria=categoria;}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('unidades-organicas',sucesso,_this.tratarErro,parametros);};_this.carregaSuperintendencias=function(response){var superintendencias=[];response.data.forEach(function(item){superintendencias.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaSuperintendencias:superintendencias});};_this.carregaGexs=function(response){var gexs=[];response.data.forEach(function(item){gexs.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaGexs:gexs});};_this.carregaAps=function(response){var aps=[];response.data.forEach(function(item){aps.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaAps:aps});};_this.carregaEntesFederativos=function(aps){var parametros={aps:aps};Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('entes-federativos',_this.tratarSucessoEntesFederativos,_this.tratarErro,parametros);};_this.tratarSucessoEntesFederativos=function(response){var entes=[];response.data.forEach(function(item){entes.push({label:item.nomeRpps,value:item.idParticipante});});_this.setState({listaEntes:entes});};_this.validaNaoEhSuperintendenciaESelecionouAmbos=function(){var opcaoAmbos=1;return!_this.state.superintendencia&&_this.state.opcao===opcaoAmbos;};_this.validaEhPapelObservador=function(){return Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)&&!_this.state.tipoRegimeObservador;};_this.validaEhPapelObservadorERegimeSelecionado=function(){return _this.props.papelUsuarioLogado==='analista-rgps'&&_this.state.opcao!==1||Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)&&_this.state.tipoRegimeObservador===1&&_this.state.opcao!==1;};_this.verificarTextoHintBotaoInclusao=function(){var retorno='item';switch(_this.state.estado){case'2':retorno='exigência';break;case'9':retorno='motivo';break;case'10':retorno='motivo';break;default:break;}return retorno;};_this.montaFiltrosDefault=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__["a" /* default */],{handleChange:_this.handleChange,destinatarios:_this.props.destinatarios,papelUsuarioLogado:_this.props.papelUsuarioLogado,titulo:'Visualizar como',retirarLinhaSeparadora:false,tipoRegime:_this.state.tipoRegimeObservador,tipoEntidade:_this.state.tipoEntidadeObservador,uf:_this.state.uFObservador,participante:_this.state.participanteObservador,nomeAtributoComboboxRegime:'tipoRegimeObservador',nomeAtributoComboboxParticipante:'participanteObservador',nomeAtributoComboboxTipoEntidade:'tipoEntidadeObservador',nomeAtributoComboboxUF:'uFObservador',listaTiposRegimes:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */],labelComboboxParticipante:'Participante Observador'}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["f" /* DataGridCustom */],{title:'Filtro b\xE1sico'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["p" /* RadioComLabel */],{value:_this.state.opcao,name:'opcao',itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["r" /* opcaoFiltroTipoParticipacao */],onChange:function onChange(value){return _this.handleChangeOpcao(value);},animate:false,label:'Op\xE7\xE3o',disabled:_this.validaEhPapelObservador(),disposicao:'horizontal',required:true}))),_this.validaNaoEhSuperintendenciaESelecionouAmbos()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__["a" /* default */],{handleChange:_this.handleChange,destinatarios:_this.props.destinatarios,papelUsuarioLogado:_this.props.papelUsuarioLogado,titulo:'',retirarLinhaSeparadora:true,tipoRegime:_this.state.tipoRegime,tipoEntidade:_this.state.tipoEntidade,uf:_this.state.uf,participante:_this.state.participante,nomeAtributoComboboxRegime:'tipoRegime',nomeAtributoComboboxParticipante:'participante',nomeAtributoComboboxTipoEntidade:'tipoEntidade',nomeAtributoComboboxUF:'uf',listaTiposRegimes:_this.state.listaTiposRegimes,labelComboboxParticipante:'Participante'}):'',_this.validaEhPapelObservadorERegimeSelecionado()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SelecaoSuperintendencia__["a" /* default */],{handleChange:_this.handleChange,tipoRegime:_this.state.tipoRegime,papelUsuarioLogado:_this.props.papelUsuarioLogado,listaSuperintendencias:_this.state.listaSuperintendencias,listaGexs:_this.state.listaGexs,listaAps:_this.state.listaAps,superintendencia:_this.state.superintendencia,gex:_this.state.gex,aps:_this.state.aps,tipoRegimeObservador:_this.state.tipoRegimeObservador,titulo:'',retirarLinhaSeparadora:true}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["f" /* DataGridCustom */],{title:'Estado do requerimento'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Estado',name:'estado',onChange:function onChange(e){return _this.handleChange(e,'estado');},itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["Q" /* tiposEstado */],value:_this.state.estado,validationState:'active',custom:true,placeholder:'Selecione uma op\xE7\xE3o para filtrar',disabled:_this.validaEhPapelObservador(),required:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["q" /* SelecaoMultipla */],{handleChange:_this.handleChange,configuracao:_this.state.configComponenteSelecaoMultipla,estado:_this.state.estado,hint:_this.verificarTextoHintBotaoInclusao(),listaEstadosComSelecaoMultipla:[2,9,10],lista:_this.state.lista// ehPapelObservadorRelatorio={ehPapelObservadorRelatorio(this.props.papelUsuarioLogado)}
,valorComboSelecaoMultipla:_this.state.valorComboSelecaoMultipla,observardorDeMudanca:_this.props.observardorDeMudanca}));};_this.handleSearch=function(){var participanteObservadorSelecionado=_this.state.participanteObservador;var regimeSelecionado=_this.state.tipoRegime;var entidadeSelecionada=_this.state.tipoEntidade;var ufSelecionada=_this.state.uf;var participanteSelecionado=_this.state.participante;var estadoSelecionado=_this.state.estado;var opcaoSelecionada=_this.state.opcao;var superintendenciaSelecionada=_this.state.superintendencia;if(Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)&&!participanteObservadorSelecionado){_this.addMessage('Selecione o participante Observador.');return;}if(!opcaoSelecionada){_this.addMessage('Selecione uma opção.');return;}// refatorar essa parte
if(_this.props.papelUsuarioLogado==='analista-rgps'||participanteObservadorSelecionado==='01000'){if(opcaoSelecionada&&opcaoSelecionada===1){if(!regimeSelecionado){_this.addMessage('Selecione um regime.');return;}if(regimeSelecionado!==1&&!entidadeSelecionada){_this.addMessage('Selecione uma entidade.');return;}if(entidadeSelecionada&&entidadeSelecionada===2&&ufSelecionada===null){_this.addMessage('Selecione uma UF.');return;}if(!participanteSelecionado){_this.addMessage('Selecione um participante.');return;}}else if(opcaoSelecionada&&opcaoSelecionada!==1){if(!superintendenciaSelecionada){_this.addMessage('Selecione uma superintendência.');return;}}}else{if(opcaoSelecionada&&opcaoSelecionada===1){if(!regimeSelecionado){_this.addMessage('Selecione um regime.');return;}if(regimeSelecionado!==1&&!entidadeSelecionada){_this.addMessage('Selecione uma entidade.');return;}if(entidadeSelecionada&&entidadeSelecionada===2&&ufSelecionada===null){_this.addMessage('Selecione uma UF.');return;}if(!participanteSelecionado){_this.addMessage('Selecione um participante.');return;}}}if(!estadoSelecionado){_this.addMessage('Selecione um estado.');return;}_this.props.handleSearchFilter(_this.state);};_this.handleSearchButton=function(){var filtroRelatorioAnalitico={tipoRegime:_this.state.tipoRegime,tipoRegimeObservador:_this.state.tipoRegimeObservador,tipoEntidade:_this.state.tipoEntidade,tipoEntidadeObservador:_this.state.tipoEntidadeObservador,uf:_this.state.uf,uFObservador:_this.state.uFObservador,participante:_this.state.participante,participanteObservador:_this.state.participanteObservador,superintendencia:_this.state.superintendencia,gex:_this.state.gex,aps:_this.state.aps,visao:_this.state.visao,opcao:_this.state.opcao,estado:_this.state.estado,consultaPorVisao:_this.state.consultaPorVisao,lista:_this.state.lista,configComponenteSelecaoMultipla:_this.state.configComponenteSelecaoMultipla,valorComboSelecaoMultipla:_this.state.valorComboSelecaoMultipla};filtroRelatorioAnalitico=JSON.stringify(filtroRelatorioAnalitico);sessionStorage.setItem('filtroRelatorioAnalitico',filtroRelatorioAnalitico);_this.handleSearch();};_this.filtroRelatorioAnalitico=JSON.parse(sessionStorage.getItem('filtroRelatorioAnalitico'));_this.state={tipoRegime:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.tipoRegime?_this.filtroRelatorioAnalitico.tipoRegime:null,tipoRegimeObservador:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.tipoRegimeObservador?_this.filtroRelatorioAnalitico.tipoRegimeObservador:null,tipoEntidade:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.tipoEntidade?_this.filtroRelatorioAnalitico.tipoEntidade:null,tipoEntidadeObservador:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.tipoEntidadeObservador?_this.filtroRelatorioAnalitico.tipoEntidadeObservador:null,uf:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.uf?_this.filtroRelatorioAnalitico.uf:null,uFObservador:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.uFObservador?_this.filtroRelatorioAnalitico.uFObservador:null,participante:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.participante?_this.filtroRelatorioAnalitico.participante:null,participanteObservador:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.participanteObservador?_this.filtroRelatorioAnalitico.participanteObservador:null,superintendencia:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.superintendencia?_this.filtroRelatorioAnalitico.superintendencia:null,gex:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.gex?_this.filtroRelatorioAnalitico.gex:null,aps:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.aps?_this.filtroRelatorioAnalitico.aps:null,visao:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.visao?_this.filtroRelatorioAnalitico.visao:null,opcao:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.opcao?_this.filtroRelatorioAnalitico.opcao:null,estado:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.estado?_this.filtroRelatorioAnalitico.estado:null,consultaPorVisao:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.consultaPorVisao?_this.filtroRelatorioAnalitico.consultaPorVisao:null,configComponenteSelecaoMultipla:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.configComponenteSelecaoMultipla?_this.filtroRelatorioAnalitico.configComponenteSelecaoMultipla:null,lista:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.lista?_this.filtroRelatorioAnalitico.lista:[],valorComboSelecaoMultipla:_this.filtroRelatorioAnalitico&&_this.filtroRelatorioAnalitico.valorComboSelecaoMultipla?_this.filtroRelatorioAnalitico.valorComboSelecaoMultipla:null,listaSuperintendencias:[],listaGexs:[],listaAps:[],listaEntes:[],listaTiposRegimes:[],listaTiposRegimesOutrosPapeis:[]};return _this;}_createClass(FiltroRelatorioAnalitico,[{key:'componentDidMount',value:function componentDidMount(){if(sessionStorage.getItem('filtroRelatorioAnalitico')){this.handleSearch();}this.carregaUnidadesOrganicas(24,null,this.carregaSuperintendencias);this.carregarListaTiposRegimes();}},{key:'render',value:function render(){var _this2=this;var filtrosPesquisa=this.montaFiltrosDefault();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'relatorio',panelId:'filtro-relatorio',icon:'ico-filter',title:''+this.props.tipo},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroRelatorioAnalitico;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroRelatorioAnalitico.propTypes={handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,observardorDeMudanca:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,papelUsuarioLogado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroRelatorioAnalitico);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NovoRelatorioTotalizadorExigencias__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FiltroRelatorioTotalizadorEstados__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_User__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var TelaRelatorioTotalizadorEstados=function(_Component){_inherits(TelaRelatorioTotalizadorEstados,_Component);function TelaRelatorioTotalizadorEstados(props){_classCallCheck(this,TelaRelatorioTotalizadorEstados);var _this=_possibleConstructorReturn(this,(TelaRelatorioTotalizadorEstados.__proto__||Object.getPrototypeOf(TelaRelatorioTotalizadorEstados)).call(this,props));_this.montaFiltros=function(atributosPesquisa){var atributos={};if(atributosPesquisa.participanteObservador){atributos=Object.assign({},atributos,{participanteObservador:atributosPesquisa.participanteObservador});}if(atributosPesquisa.participante){atributos=Object.assign({},atributos,{participante:atributosPesquisa.participante});}if(atributosPesquisa.estado){atributos=Object.assign({},atributos,{estado:atributosPesquisa.estado});}if(atributosPesquisa.opcao){atributos=Object.assign({},atributos,{opcao:atributosPesquisa.opcao});}if(atributosPesquisa.motivo){atributos=Object.assign({},atributos,{motivo:atributosPesquisa.motivo});}if(atributosPesquisa.superintendencia){atributos=Object.assign({},atributos,{superintendencia:atributosPesquisa.superintendencia});}if(atributosPesquisa.gex){atributos=Object.assign({},atributos,{gex:atributosPesquisa.gex});}if(atributosPesquisa.aps){atributos=Object.assign({},atributos,{aps:atributosPesquisa.aps});}if(atributosPesquisa.lista){atributos=Object.assign({},atributos,{lista:atributosPesquisa.lista});}var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.realizaConsulta=function(valoresFiltro){var filtrosEscolhidos={};if(valoresFiltro){filtrosEscolhidos=_this.montaFiltros(valoresFiltro);}_this.setState(Object.assign({},_this.state,{filtrosEscolhidos:filtrosEscolhidos,filtrosAtuais:valoresFiltro}),function(){return _this.executaConsulta();});};_this.zerarPaginacao=function(){_this.preparaNovaConsulta();};_this.definePapelFiltro=function(){var retorno='';var isRgps=_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','consultar-compensacao-rgps']);var isRpps=_this.props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps','consultar-compensacao-rpps']);var isAnalistaSprev=_this.props.auth.checkPermission(['analisar-negocio-sprev']);var isAnalistaDtp=_this.props.auth.checkPermission(['analisar-negocio-dtpv']);var isAnalistaDcomp=_this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);var isAuditorComprev=_this.props.auth.checkPermission(['auditar-comprev']);if(isRgps){retorno='analista-rgps';}if(isRpps){retorno='analista-rpps';}if(isAnalistaSprev){retorno='analista-sprev';}if(isAnalistaDtp){retorno='analista-dtp';}if(isAnalistaDcomp){retorno='analista-rgps';}if(isAuditorComprev){retorno='auditor-comprev';}_this.setState({papelUsuarioLogado:retorno},function(){return _this.buscarParticipantePeloCnpjLogado();});};_this.defineNivelFiltro=function(){if(_this.state.filtrosEscolhidos.participante){return 4;}else if(_this.state.filtrosEscolhidos.aps){return 3;}else if(_this.state.filtrosEscolhidos.gex){return 2;}else if(_this.state.filtrosEscolhidos.superintendencia){return 1;}return 0;};_this.definirValorUo=function(nivel){if(nivel===3){return _this.state.filtrosEscolhidos.aps;}else if(nivel===2){return _this.state.filtrosEscolhidos.gex;}else if(nivel===1){return _this.state.filtrosEscolhidos.superintendencia;}return 0;};_this.defineCodigoOutroParticipante=function(parametros){var novosParametros=parametros;if(_this.state.papelUsuarioLogado!=='analista-rgps'){novosParametros.outroParticipante='01000';}if(_this.state.filtrosEscolhidos.participante){novosParametros.codigo=_this.state.filtrosEscolhidos.participante;}else if(_this.state.filtrosEscolhidos.aps){novosParametros.codigo=_this.state.filtrosEscolhidos.aps;}else if(_this.state.filtrosEscolhidos.gex){novosParametros.codigo=_this.state.filtrosEscolhidos.gex;}else if(_this.state.filtrosEscolhidos.superintendencia){novosParametros.codigo=_this.state.filtrosEscolhidos.superintendencia;}return novosParametros;};_this.converterValoresParaTipoNumerico=function(valor){var retorno=null;if(valor){retorno=Number(valor);}return retorno;};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosEscolhidos).length!==0){var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;var urlRelatorio=null;var nivel=_this.defineNivelFiltro();urlRelatorio='relatorios/totalizadores-por-exigencias';var parametros={tipoParticipacao:_this.converterValoresParaTipoNumerico(_this.state.filtrosEscolhidos.opcao),participante:_this.state.filtrosEscolhidos.participante,'start-position':primeiroItem,'max-results':resultadosPorPagina};if(_this.state.filtrosEscolhidos.participanteObservador){parametros.participanteObservador=_this.state.filtrosEscolhidos.participanteObservador;}if(_this.isConsultaPorVisao()){if(_this.state.papelUsuarioLogado==='analista-rgps'||_this.state.filtrosEscolhidos.participanteObservador==='01000'){parametros.nivelUo=nivel;parametros.idUo=_this.definirValorUo(nivel);}}_this.setState({urlExportacao:urlRelatorio,parametrosExportacao:parametros},function(){return _this.preparaRequest(urlRelatorio,parametros);});}};_this.preparaRequest=function(urlRelatorio,parametros){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["l" /* doPost */])(urlRelatorio,parametros,_this.tratarSucesso(),_this.tratarErro);};_this.recuperarTituloPorId=function(lista,id){var retorno='';var index=lista.findIndex(function(item){return item.value===id;});if(index!==-1){retorno=lista[index].label;}return retorno;};_this.exibirComplementoPorNivelSuperintendencia=function(){var nivel=_this.defineNivelFiltro();var retorno='';var nome='';switch(nivel){case 1:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaSuperintendencias,_this.state.filtrosEscolhidos.superintendencia);retorno='SUPERINTEND\xCANCIA: '+_this.state.filtrosEscolhidos.superintendencia+' - '+nome;break;case 2:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaGexs,_this.state.filtrosEscolhidos.gex);retorno='GEX: '+_this.state.filtrosEscolhidos.gex+' - '+nome;break;case 3:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaAps,_this.state.filtrosEscolhidos.aps);retorno='APS: '+_this.state.filtrosEscolhidos.aps+' - '+nome;break;default:break;}return retorno.toUpperCase();};_this.exibirNomeEstado=function(estado){return __WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["Q" /* tiposEstado */],estado).label.toUpperCase();};_this.handleClickNovoEstadoSuccess=function(response){_this.pushNavegacao(_this.state.tipoRequerimentoSelecionado,response.data.protocolo);};_this.handleClickNovoEstadoFail=function(){};_this.pushNavegacao=function(tipo,protocolo){_this.props.history.push('/requerimento/'+tipo+'/'+protocolo);};_this.limparTipoRequerimento=function(tipoAposentadoria){var retorno=tipoAposentadoria;if(tipoAposentadoria.indexOf('ã')!==-1){retorno='pensao';}return retorno.toLowerCase();};_this.handleClickDetalhe=function(tipoAposentadoria,protocolo){_this.setState({tipoRequerimentoSelecionado:_this.limparTipoRequerimento(tipoAposentadoria)});Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('requerimentos-compensacao-'+_this.limparTipoRequerimento(tipoAposentadoria)+'/'+protocolo,_this.handleClickNovoEstadoSuccess,_this.handleClickNovoEstadoFail);};_this.isConsultaPorVisao=function(){var ehVisao=false;if([2,3].includes(_this.state.filtrosEscolhidos.opcao)){ehVisao=true;}return ehVisao;};_this.handleSuccessBuscaPeloCnpjLogado=function(response){var nome='';if(response.data){nome=response.data.nome+' - '+response.data.codigo;_this.setState({nomeSolicitante:nome});}};_this.handleErrorBuscaPeloCnpjLogado=function(){return'';};_this.buscarParticipantePeloCnpjLogado=function(){if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)||_this.state.papelUsuarioLogado==='analista-rpps'){var usuarioLogado=new __WEBPACK_IMPORTED_MODULE_10__domain_User__["a" /* default */](localStorage.getItem('jwt'));var cnpj=usuarioLogado.cnpjDoPapel();if(cnpj){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('participantes-compensacao/'+cnpj,_this.handleSuccessBuscaPeloCnpjLogado,_this.handleErrorBuscaPeloCnpjLogado);}}else if(_this.state.papelUsuarioLogado==='analista-rgps'){_this.setState({nomeSolicitante:'RGPS'});}};_this.buscarDestinatario=function(){var nivel=_this.defineNivelFiltro();var retorno='';var nome='';switch(nivel){case 1:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaSuperintendencias,_this.state.filtrosEscolhidos.superintendencia);retorno='SUPERINTEND\xCANCIA: '+_this.state.filtrosEscolhidos.superintendencia+' - '+nome;break;case 2:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaGexs,_this.state.filtrosEscolhidos.gex);retorno='GEX: '+_this.state.filtrosEscolhidos.gex+' - '+nome;break;case 3:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaAps,_this.state.filtrosEscolhidos.aps);retorno='APS: '+_this.state.filtrosEscolhidos.aps+' - '+nome;break;case 4:if(_this.state.filtrosEscolhidos.participante==='01000'){nome='RGPS';}else{nome=_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participante);}retorno='DESTINAT\xC1RIO: '+_this.state.filtrosEscolhidos.participante+' - '+nome;break;default:break;}return retorno.toUpperCase();};_this.exibirNomeSolicitante=function(){var retorno='';if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)){retorno='SOLICITANTE: '+_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participanteObservador)+' -\n      '+_this.state.filtrosEscolhidos.participanteObservador;}else{retorno='SOLICITANTE: '+_this.state.nomeSolicitante;}return' - '+retorno.toUpperCase();};_this.montarTituloSolicitanteOuDestinatario=function(titulo){var retorno='';if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)){var participanteObservadorSelecionado=_this.state.filtrosEscolhidos.participanteObservador;retorno=titulo+' '+_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participanteObservador)+' - '+participanteObservadorSelecionado;}else{retorno=titulo+' '+_this.state.nomeSolicitante;}return retorno;};_this.especificarConsultaPorVisao=function(){var retorno='';switch(_this.state.filtrosEscolhidos.opcao){case 2:retorno=_this.montarTituloSolicitanteOuDestinatario('SOLICITANTE:');break;case 3:retorno=_this.montarTituloSolicitanteOuDestinatario('DESTINATÁRIO:');break;default:break;}return retorno;};_this.montarLegendaNomeRelatorioPorFiltroSelecionado=function(){var textoFinal='';var titulo='TOTALIZADORES DE REQUERIMENTOS POR EXIGÊNCIA';var dataAtual=''+__WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('DD/MM/YYYY HH:mm:ss');if(_this.isConsultaPorVisao()){// (VISÃO: OPCAO SOLICITANTE OU DESTINATARIO ESCOLHIDA)
// textoFinal = `${titulo} ${nomeEstado} - ${this.especificarConsultaPorVisao()} ${dataAtual} ${complementoPorNivelSuperintendencia} ${complementoPorTipoDeLista}`;
textoFinal=titulo+' '+_this.exibirComplementoPorNivelSuperintendencia()+' '+dataAtual;}else{// textoFinal = `${titulo} ${nomeEstado} ${this.exibirNomeSolicitante()} ${this.buscarDestinatario()} ${dataAtual} ${complementoPorTipoDeLista}`;
// textoFinal = `${titulo} - AMBOS - ${dataAtual}`;
textoFinal=titulo+' - '+dataAtual;}return textoFinal;};_this.colunasRelatorio=['Exigência','Total'];_this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){objetoLinha={nomeExigencia:item[Object.keys(item)[0]],total:item[Object.keys(item)[1]]};return objetoLinha;});return dados;};_this.tratarSucesso=function(){return function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data!==''){var lista=_this.extrairColunasJson(response.data);var dadosFormatados=_this.prepararColunasExportacao(lista);_this.setState({listaResultados:lista,listaResultadosFormatados:dadosFormatados,colunasRelatorio:_this.colunasRelatorio,nomeRelatorio:_this.montarLegendaNomeRelatorioPorFiltroSelecionado(),estadoTabela:estadoTabela});}};};_this.prepararColunasExportacao=function(data){var dados=data.map(function(item){var linha=Object.assign({},item);return linha;});return dados;};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.formatarColuna=function(cell,tipo){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='moeda'){valor=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).formatToParts(cell).map(function(_ref){var type=_ref.type,value=_ref.value;switch(type){case'currency':return'';default:return value;}}).reduce(function(string,part){return string+part;});}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='booleano'){valor=cell===1?'S':'N';}return valor.trim();};_this.defineContainerStyle=function(){var width=_this.state.colunasRelatorio.length*130;if(width<1140){width=1140;}return{width:width+'px'};};_this.alterarPagina=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.paginaAtual=pagina;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.state={listaResultados:[],listaResultadosFormatados:[],colunasRelatorio:[],nomeRelatorio:'',dataFormatOptions:{},papelUsuarioLogado:null,nomeSolicitante:'',estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosAtuais:{},filtrosEscolhidos:{},urlExportacao:null,parametrosExportacao:null};return _this;}_createClass(TelaRelatorioTotalizadorEstados,[{key:'componentDidMount',value:function componentDidMount(){sessionStorage.removeItem('filtroRelatorioAnalitico');if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}this.definePapelFiltro();}// SE AS OPÇOES SOLICITANTE OU DESTINATARIO
// ESTIVEREM SELECIONADAS, TRATA-SE DE UMA
// CONSULTA POR VISÃO.
// montarColunasCabecalho = () => {
//   const tableHeader = this.colunasRelatorio.slice();
//   tableHeader.push('Detalhe');
//   return tableHeader;
// }
// FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
},{key:'render',value:function render(){var options={noDataText:'Nenhum registro a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_9__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FiltroRelatorioTotalizadorEstados__["a" /* default */],{tipo:'Totalizador por exig\xEAncias',handleSearchFilter:this.realizaConsulta,filtroModalidade:false,papelUsuarioLogado:this.state.papelUsuarioLogado,destinatarios:this.props.destinatarios,observardorDeMudanca:this.zerarPaginacao,nomeFiltro:'filtroRelatorioTotalizadorExigencias'}),this.state.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NovoRelatorioTotalizadorExigencias__["a" /* default */],{legend:this.state.nomeRelatorio,bordered:true,headers:this.state.colunasRelatorio,data:this.state.listaResultados,options:options,pagination:true,remote:true,dataFormatOptions:this.state.dataFormatOptions,landscape:true,containerStyle:this.defineContainerStyle(),fetchInfo:fetchInfo,rowAtual:this.state.rowAtual,urlExportacao:this.state.urlExportacao,parametrosExportacao:this.state.parametrosExportacao}):null);}}]);return TelaRelatorioTotalizadorEstados;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TelaRelatorioTotalizadorEstados.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};TelaRelatorioTotalizadorEstados.defaultProps={destinatarios:[]};// eslint-disable-next-line
var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(TelaRelatorioTotalizadorEstados));

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colunasRelatorioTotalizador=['Exigência','Total'];var NovoRelatorioTotalizadorExigencias=function(_Component){_inherits(NovoRelatorioTotalizadorExigencias,_Component);function NovoRelatorioTotalizadorExigencias(props){_classCallCheck(this,NovoRelatorioTotalizadorExigencias);var _this=_possibleConstructorReturn(this,(NovoRelatorioTotalizadorExigencias.__proto__||Object.getPrototypeOf(NovoRelatorioTotalizadorExigencias)).call(this,props));_initialiseProps.call(_this);_this.state={showNoContent:false,noContentPrimaryMessage:null,noContentSecondaryMessage:null,legendaRelatorio:null};return _this;}_createClass(NovoRelatorioTotalizadorExigencias,[{key:'render',value:function render(){var _this2=this;if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.data&&this.props.data.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Exportar para CSV',onClick:function onClick(){_this2.exportarCsv(_this2.props);},icon:'ico-doc-sheet',mini:true}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["H" /* DtpTable */],this.props,this.props.headers.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["I" /* DtpTableHeader */],{key:item,dataField:_this2.props.data[0]?Object.keys(_this2.props.data[0])[i]:'default',dataAlign:'center',isKey:i===0,header:item,tdStyle:{wordBreak:'break-word'},dataFormat:_this2.props.dataFormatOptions[i],hidden:_this2.props.options.hidden&&_this2.props.options.hidden.includes(i)});})))):null);}}]);return NovoRelatorioTotalizadorExigencias;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.gerarCsv=function(lista){if(lista&&lista!==undefined&&lista.length>0){var csvExporter=new __WEBPACK_IMPORTED_MODULE_3_export_to_csv__["ExportToCsv"]({filename:'relatorio',fieldSeparator:';',showTitle:true,title:_this3.state.legendaRelatorio,showLabels:true,headers:colunasRelatorioTotalizador});csvExporter.generateCsv(lista);}};this.prepararColunasExportacao=function(data){var dados=data.map(function(item){var linha=Object.assign({},item);return linha;});return dados;};this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){objetoLinha={nomeExigencia:item[Object.keys(item)[0]],total:item[Object.keys(item)[1]]};return objetoLinha;});return dados;};this.tratarSucessoListaExportacao=function(response){if(response.data!==''){var lista=_this3.extrairColunasJson(response.data);var dadosFormatados=_this3.prepararColunasExportacao(lista);_this3.setState({},_this3.gerarCsv(dadosFormatados));}};this.tratarErro=function(){var mensagemPrimaria='Não foi possível consultar os requerimentos.';var mensagemSecundaria='Contate o administrador do sistema.';_this3.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};this.preparaRequest=function(url,parametros){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["l" /* doPost */])(url,parametros,_this3.tratarSucessoListaExportacao,_this3.tratarErro);};this.exportarCsv=function(props){_this3.setState({legendaRelatorio:props.legend});if(props.urlExportacao&&props.parametrosExportacao){var parametros=props.parametrosExportacao;parametros['start-position']=0;parametros['max-results']=100000;_this3.preparaRequest(props.urlExportacao,parametros);}};};NovoRelatorioTotalizadorExigencias.propTypes={dataFormatOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object}.isRequired;NovoRelatorioTotalizadorExigencias.defaultProps={voltarAction:function voltarAction(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (NovoRelatorioTotalizadorExigencias);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FiltroRelatorioExigenciaAnalitico__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NovoRelatorioExigenciasAnalitico__ = __webpack_require__(684);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TelaRelatorioExigenciaAnalitico=function(_Component){_inherits(TelaRelatorioExigenciaAnalitico,_Component);function TelaRelatorioExigenciaAnalitico(props){_classCallCheck(this,TelaRelatorioExigenciaAnalitico);var _this=_possibleConstructorReturn(this,(TelaRelatorioExigenciaAnalitico.__proto__||Object.getPrototypeOf(TelaRelatorioExigenciaAnalitico)).call(this,props));_this.colunasRelatorio=['Tipo Exigência','Comentário Exigência','CPF','Protocolo','Tipo Requerimento','Nome do beneficiário','Data da abertura','Data da situação'];_this.listaColunasFormatar=[{index:2,tipo:'cpf'}];_this.limparTipoRequerimento=function(tipoAposentadoria){var retorno=tipoAposentadoria;if(tipoAposentadoria.indexOf('ã')!==-1){retorno='pensao';}return retorno.toLowerCase();};_this.handleClickDetalhe=function(tipoAposentadoria,protocolo){_this.setState({tipoRequerimentoSelecionado:_this.limparTipoRequerimento(tipoAposentadoria)});Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('requerimentos-compensacao-'+_this.limparTipoRequerimento(tipoAposentadoria)+'/'+protocolo,_this.handleClickNovoEstadoSuccess,_this.handleClickNovoEstadoFail);};_this.handleClickNovoEstadoSuccess=function(response){_this.pushNavegacao(_this.state.tipoRequerimentoSelecionado,response.data.protocolo);};_this.pushNavegacao=function(tipo,protocolo){_this.props.history.push('/requerimento/'+tipo+'/'+protocolo);};_this.handleClickNovoEstadoFail=function(){};_this.montaColuna=function(tipo){return function(cell,row){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='nit'){if(Number.isInteger(cell)){valor=cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}else{valor=cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}}else if(tipo==='botao'){valor=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["a" /* Button */],{hint:'ir para o requerimento',icon:'ico-doc-magnifier',mini:true,onClick:function onClick(){return _this.handleClickDetalhe(row.tipoRequerimento,row.protocolo);}});}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,valor);};};_this.relatorioDataFormatOptions={2:_this.montaColuna('cpf'),8:_this.montaColuna('botao')};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.definePapelFiltro=function(){var retorno='';var isRgps=_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','consultar-compensacao-rgps']);var isRpps=_this.props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps','consultar-compensacao-rpps']);var isAnalistaSprev=_this.props.auth.checkPermission(['analisar-negocio-sprev']);var isAnalistaDtp=_this.props.auth.checkPermission(['analisar-negocio-dtpv']);var isAnalistaDcomp=_this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);var isAuditorComprev=_this.props.auth.checkPermission(['auditar-comprev']);if(isRgps){retorno='analista-rgps';}if(isRpps){retorno='analista-rpps';}if(isAnalistaSprev){retorno='analista-sprev';}if(isAnalistaDtp){retorno='analista-dtp';}if(isAnalistaDcomp){retorno='analista-rgps';}if(isAuditorComprev){retorno='auditor-comprev';}_this.setState({papelUsuarioLogado:retorno},function(){return _this.buscarParticipantePeloCnpjLogado();});};_this.buscarParticipantePeloCnpjLogado=function(){if(Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)||_this.state.papelUsuarioLogado==='analista-rpps'){var usuarioLogado=new __WEBPACK_IMPORTED_MODULE_9__domain_User__["a" /* default */](localStorage.getItem('jwt'));var cnpj=usuarioLogado.cnpjDoPapel();if(cnpj){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('participantes-compensacao/'+cnpj,_this.handleSuccessBuscaPeloCnpjLogado,_this.handleErrorBuscaPeloCnpjLogado);}}else if(_this.state.papelUsuarioLogado==='analista-rgps'){_this.setState({nomeSolicitante:'RGPS'});}};_this.handleSuccessBuscaPeloCnpjLogado=function(response){var nome='';if(response.data){nome=response.data.nome+' - '+response.data.codigo;_this.setState({nomeSolicitante:nome});}};_this.defineNivelFiltro=function(){if(_this.state.filtrosEscolhidos.participante){return 4;}else if(_this.state.filtrosEscolhidos.aps){return 3;}else if(_this.state.filtrosEscolhidos.gex){return 2;}else if(_this.state.filtrosEscolhidos.superintendencia){return 1;}return 0;};_this.handleErrorBuscaPeloCnpjLogado=function(){return'';};_this.definirValorUo=function(nivel){if(nivel===3){return _this.state.filtrosEscolhidos.aps;}else if(nivel===2){return _this.state.filtrosEscolhidos.gex;}else if(nivel===1){return _this.state.filtrosEscolhidos.superintendencia;}return 0;};_this.realizaConsulta=function(filtro){var filtrosEscolhidos={};if(filtro){filtrosEscolhidos=_this.montaFiltros(filtro);}_this.setState(Object.assign({},_this.state,{filtrosEscolhidos:filtrosEscolhidos,filtrosAtuais:filtro}),function(){return _this.buscarRelatorio();});};_this.converterValoresParaTipoNumerico=function(valor){var retorno=null;if(valor){retorno=Number(valor);}return retorno;};_this.extrairValoresParaPesquisar=function(){var listaValores=_this.state.filtrosEscolhidos.lista;var lista=[];var valor=void 0;if(listaValores.length>0){listaValores.forEach(function(item){if(item.value){valor=Number(item.value);lista.push(valor);}});}return lista;};_this.buscarRelatorio=function(){if(Object.entries(_this.state.filtrosEscolhidos).length===0){return;}var url='relatorios/analiticos/exigencias';var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;var nivel=_this.defineNivelFiltro();var parametros={tipoParticipacao:_this.converterValoresParaTipoNumerico(_this.state.filtrosEscolhidos.opcao),participante:_this.state.filtrosEscolhidos.participante,estado:_this.converterValoresParaTipoNumerico(_this.state.filtrosEscolhidos.estado),tipos:_this.extrairValoresParaPesquisar(),'start-position':primeiroItem,'max-results':resultadosPorPagina};if(_this.state.filtrosEscolhidos.participanteObservador){parametros.participanteObservador=_this.state.filtrosEscolhidos.participanteObservador;}if(_this.state.papelUsuarioLogado==='analista-rgps'||_this.state.filtrosEscolhidos.participanteObservador==='01000'){parametros.nivelUo=nivel;parametros.idUo=_this.definirValorUo(nivel);}_this.setState({urlExportacao:url,parametrosExportacao:parametros},function(){return _this.preparaRequest(url,parametros);});};_this.preparaRequest=function(url,parametros){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["l" /* doPost */])(url,parametros,_this.tratarSucesso(),_this.tratarErro);};_this.pesquisarColunaJson=function(json,coluna){var retorno=json[coluna];if(retorno===undefined){retorno='';}return retorno;};_this.tratarSucesso=function(){return function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;var colunasFormatarExportacao=[];var dataFormatOptions={};if(response.data!==''){var lista=_this.extrairColunasJson(response.data);dataFormatOptions=_this.relatorioDataFormatOptions;colunasFormatarExportacao=_this.listaColunasFormatar;var dadosFormatados=_this.prepararColunasExportacao(lista,colunasFormatarExportacao);_this.setState({listaResultados:lista,listaResultadosFormatados:dadosFormatados,colunasRelatorio:_this.montarColunasCabecalho(),dataFormatOptions:dataFormatOptions,nomeRelatorio:_this.montarLegendaNomeRelatorioPorFiltroSelecionado(),estadoTabela:estadoTabela});}};};_this.montarColunasCabecalho=function(){var tableHeader=_this.colunasRelatorio.slice();tableHeader.push('Detalhe');return tableHeader;};_this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){objetoLinha={tipoExigencia:_this.pesquisarColunaJson(item,'tipoExigencia'),comentarioExigencia:_this.pesquisarColunaJson(item,'comentarioExigencia')?_this.pesquisarColunaJson(item,'comentarioExigencia'):'-',cpf:_this.pesquisarColunaJson(item,'cpf'),protocolo:_this.pesquisarColunaJson(item,'protocolo'),tipoRequerimento:_this.pesquisarColunaJson(item,'tipoRequerimento'),nomeBeneficiario:_this.pesquisarColunaJson(item,'nomeBeneficiario'),dataAbertura:_this.pesquisarColunaJson(item,'dataAbertura'),dataSituacao:_this.pesquisarColunaJson(item,'dataSituacao')};return objetoLinha;});return dados;};_this.prepararColunasExportacao=function(data,colunas){var dados=data.map(function(item){var linha=Object.assign({},item);colunas.forEach(function(c){var key=Object.keys(item)[c.index];var coluna=item[key];var colunaFormatada=_this.formatarColuna(coluna,c.tipo);linha[key]=colunaFormatada;});return linha;});return dados;};_this.formatarColuna=function(cell,tipo){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='nit'){if(Number.isInteger(cell)){valor=cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}else{valor=cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}}else if(tipo==='protocolo'){valor='\''+cell;}return valor.trim();};_this.montarLegendaNomeRelatorioPorFiltroSelecionado=function(){var textoFiltro='Requerimentos no estado em Exigencia';var dataAtual=''+__WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()).format('DD/MM/YYYY HH:mm:ss');var listaAtual=_this.state.filtrosEscolhidos.lista;var exigencias='com as exig\xEAncias: [ '+(listaAtual.length?_this.extrairValoresParaPesquisar():'TODOS')+' ]';return textoFiltro+' - '+dataAtual+' '+exigencias;};_this.montaFiltros=function(atributosPesquisa){var atributos={};if(atributosPesquisa.participanteObservador){atributos=Object.assign({},atributos,{participanteObservador:atributosPesquisa.participanteObservador});}if(atributosPesquisa.participante){atributos=Object.assign({},atributos,{participante:atributosPesquisa.participante});}if(atributosPesquisa.estado){atributos=Object.assign({},atributos,{estado:atributosPesquisa.estado});}if(atributosPesquisa.opcao){atributos=Object.assign({},atributos,{opcao:atributosPesquisa.opcao});}if(atributosPesquisa.motivo){atributos=Object.assign({},atributos,{motivo:atributosPesquisa.motivo});}if(atributosPesquisa.superintendencia){atributos=Object.assign({},atributos,{superintendencia:atributosPesquisa.superintendencia});}if(atributosPesquisa.gex){atributos=Object.assign({},atributos,{gex:atributosPesquisa.gex});}if(atributosPesquisa.aps){atributos=Object.assign({},atributos,{aps:atributosPesquisa.aps});}if(atributosPesquisa.lista){atributos=Object.assign({},atributos,{lista:atributosPesquisa.lista});}var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.alterarPagina=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.paginaAtual=pagina;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.defineContainerStyle=function(){var width=_this.state.colunasRelatorio.length*130;if(width<1140){width=1140;}return{width:width+'px'};};_this.zerarPaginacao=function(){_this.preparaNovaConsulta();};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.state={nomeRelatorio:'',papelUsuarioLogado:null,colunasRelatorio:[],listaResultados:[],rowAtual:null,listaResultadosFormatados:[],dataFormatOptions:{},estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1}};return _this;}_createClass(TelaRelatorioExigenciaAnalitico,[{key:'componentDidMount',value:function componentDidMount(){sessionStorage.removeItem('filtroRelatorioExigenciaAnalitico');if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}this.definePapelFiltro();}},{key:'render',value:function render(){var options={noDataText:'Nenhum requerimento a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_10__utils_listsSelect__["o" /* linhasPorPagina */]// alwaysShowAllBtns: false,
};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FiltroRelatorioExigenciaAnalitico__["a" /* default */],{titulo:'Relat\xF3rio de Exig\xEAncia Anal\xEDtico',papelUsuarioLogado:this.state.papelUsuarioLogado,destinatarios:this.props.destinatarios,userData:this.props.auth.userData,handleSearchFilter:this.realizaConsulta,observardorDeMudanca:this.zerarPaginacao}),this.state.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NovoRelatorioExigenciasAnalitico__["a" /* default */],{legend:this.state.nomeRelatorio,bordered:true,headers:this.state.colunasRelatorio,data:this.state.listaResultados,options:options,pagination:true,remote:true,dataFormatOptions:this.state.dataFormatOptions,landscape:true,containerStyle:this.defineContainerStyle(),fetchInfo:fetchInfo,rowAtual:this.state.rowAtual,urlExportacao:this.state.urlExportacao,parametrosExportacao:this.state.parametrosExportacao}):null);}}]);return TelaRelatorioExigenciaAnalitico;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);TelaRelatorioExigenciaAnalitico.propTypes={history:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string}))};TelaRelatorioExigenciaAnalitico.defaultProps={destinatarios:[]};// eslint-disable-next-line
var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(TelaRelatorioExigenciaAnalitico));

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelecaoSuperintendencia__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var participanteRGPS='01000';var FiltroRelatorioExigenciaAnalitico=function(_Component){_inherits(FiltroRelatorioExigenciaAnalitico,_Component);function FiltroRelatorioExigenciaAnalitico(props){_classCallCheck(this,FiltroRelatorioExigenciaAnalitico);var _this=_possibleConstructorReturn(this,(FiltroRelatorioExigenciaAnalitico.__proto__||Object.getPrototypeOf(FiltroRelatorioExigenciaAnalitico)).call(this,props));_this.handleSearch=function(){var participanteObservadorSelecionado=_this.state.participanteObservador;var regimeSelecionado=_this.state.tipoRegime;var entidadeSelecionada=_this.state.tipoEntidade;var ufSelecionada=_this.state.uf;var participanteSelecionado=_this.state.participante;var opcaoSelecionada=_this.state.opcao;var superintendenciaSelecionada=_this.state.superintendencia;if(Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)&&!participanteObservadorSelecionado){_this.addMessage('Selecione o participante Observador.');return;}if(_this.props.papelUsuarioLogado==='analista-rgps'||participanteObservadorSelecionado==='01000'){if(opcaoSelecionada&&opcaoSelecionada!==1){if(!superintendenciaSelecionada){_this.addMessage('Selecione uma superintendência.');return;}}}else if(opcaoSelecionada&&opcaoSelecionada===1){if(!regimeSelecionado){_this.addMessage('Selecione um regime.');return;}if(regimeSelecionado!==1&&!entidadeSelecionada){_this.addMessage('Selecione uma entidade.');return;}if(entidadeSelecionada&&entidadeSelecionada===2&&ufSelecionada===null){_this.addMessage('Selecione uma UF.');return;}if(!participanteSelecionado){_this.addMessage('Selecione um participante.');return;}}_this.props.handleSearchFilter(_this.state);};_this.carregaSuperintendencias=function(response){var superintendencias=[];response.data.forEach(function(item){superintendencias.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaSuperintendencias:superintendencias});};_this.carregaAps=function(response){var aps=[];response.data.forEach(function(item){aps.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaAps:aps});};_this.carregaGexs=function(response){var gexs=[];response.data.forEach(function(item){gexs.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaGexs:gexs});};_this.carregaUnidadesOrganicas=function(categoria,codigoSuperior,sucesso){var parametros={};if(codigoSuperior){parametros.codigoSuperior=codigoSuperior;}if(categoria){parametros.categoria=categoria;}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('unidades-organicas',sucesso,_this.tratarErro,parametros);};_this.carregarListaTiposRegimes=function(){_this.setState({listaTiposRegimes:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */]});};_this.handleSearchButton=function(){var filtroRelatorioExigenciaAnalitico={participanteObservador:_this.state.participanteObservador,tipoRegimeObservador:_this.state.tipoRegimeObservador,participante:_this.state.participante,valorComboSelecaoMultipla:_this.state.valorComboSelecaoMultipla,tipoEntidadeObservador:_this.state.tipoEntidadeObservador,superintendencia:_this.state.superintendencia,lista:_this.state.lista,listaTiposRegimes:_this.state.listaTiposRegimes,listaSuperintendencias:_this.state.listaSuperintendencias,listaGexs:_this.state.listaGexs,listaAps:_this.state.listaAps};filtroRelatorioExigenciaAnalitico=JSON.stringify(filtroRelatorioExigenciaAnalitico);sessionStorage.setItem('filtroRelatorioExigenciaAnalitico',filtroRelatorioExigenciaAnalitico);_this.handleSearch();};_this.filtrarRegimes=function(){var retorno=_this.state.listaTiposRegimes;if(_this.props.papelUsuarioLogado==='analista-rgps'||_this.state.tipoRegimeObservador===1&&Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)){retorno=_this.state.listaTiposRegimes.filter(function(item){return item.label!=='RGPS';});}if(_this.props.papelUsuarioLogado!=='analista-rgps'||_this.state.tipoRegimeObservador===2&&Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)){retorno=__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */];}_this.setState({listaTiposRegimes:retorno});};_this.trataFormulario=function(limparCampos,campoAlterado){if(campoAlterado==='tipoRegimeObservador'&&limparCampos){_this.setState({tipoEntidadeObservador:null,uFObservador:null,participanteObservador:null,opcao:null,participante:null,tipoEntidade:null,uf:null});}if(campoAlterado==='tipoRegime'&&limparCampos){_this.setState({tipoEntidade:null,uF:null,participante:null});}if(campoAlterado==='estado'&&limparCampos){_this.setState({valorComboSelecaoMultipla:null});}if(campoAlterado==='tipoEntidade'){_this.setState({participante:null,uf:null});}if(campoAlterado==='uf'){_this.setState({participante:null});}if(campoAlterado==='superintendencia'){_this.setState({gex:null,aps:null,ente:null});if(_this.state.superintendencia){_this.carregaUnidadesOrganicas(3,_this.state.superintendencia,_this.carregaGexs);}}if(campoAlterado==='gex'){_this.setState({aps:null,ente:null});if(_this.state.gex){_this.carregaUnidadesOrganicas(4,_this.state.gex,_this.carregaAps);}}};_this.handleChange=function(changeObj,name){var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var limparCampos=false;if(name==='tipoRegimeObservador'){if(changeObj.value===1){_this.setState({participanteObservador:participanteRGPS});}_this.setState({tipoRegimeObservador:changeObj.value},_this.filtrarRegimes);// if (this.state.tipoRegimeObservador !== null && (this.state.tipoRegimeObservador !== changeObj.value)) {
//   limparCampos = true;
// }
}if(name==='tipoRegime'){if(changeObj.value===1){_this.setState({participante:participanteRGPS});}// if (this.state.tipoRegime !== null && (this.state.tipoRegime !== changeObj.value)) {
//   limparCampos = true;
// }
}if(callback===null){// eslint-disable-next-line no-param-reassign
callback=function callback(){return _this.trataFormulario(limparCampos,name);};}_this.setState(_defineProperty({},name,changeObj.value),callback);};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.validaNaoEhSuperintendenciaESelecionouAmbos=function(){var opcaoAmbos=1;return!_this.state.superintendencia&&_this.state.opcao===opcaoAmbos;};_this.carregaUnidadesOrganicas=function(categoria,codigoSuperior,sucesso){var parametros={};if(codigoSuperior){parametros.codigoSuperior=codigoSuperior;}if(categoria){parametros.categoria=categoria;}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('unidades-organicas',sucesso,_this.tratarErro,parametros);};_this.validaEhPapelObservadorERegimeSelecionado=function(){return _this.props.papelUsuarioLogado==='analista-rgps'&&_this.state.opcao!==1||Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)&&_this.state.tipoRegimeObservador===1&&_this.state.opcao!==1;};_this.verificarTextoHintBotaoInclusao=function(){var retorno='item';switch(_this.state.estado){case'2':retorno='exigência';break;case'9':retorno='motivo';break;default:break;}return retorno;};_this.montarFiltroPesquisa=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__["a" /* default */],{handleChange:_this.handleChange,destinatarios:_this.props.destinatarios,papelUsuarioLogado:_this.props.papelUsuarioLogado,titulo:'Visualizar como',retirarLinhaSeparadora:false,tipoRegime:_this.state.tipoRegimeObservador,tipoEntidade:_this.state.tipoEntidadeObservador,uf:_this.state.uFObservador,participante:_this.state.participanteObservador,nomeAtributoComboboxRegime:'tipoRegimeObservador',nomeAtributoComboboxParticipante:'participanteObservador',nomeAtributoComboboxTipoEntidade:'tipoEntidadeObservador',nomeAtributoComboboxUF:'uFObservador',listaTiposRegimes:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */],labelComboboxParticipante:'Participante Observador'}):'',_this.validaNaoEhSuperintendenciaESelecionouAmbos()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__["a" /* default */],{handleChange:_this.handleChange,destinatarios:_this.props.destinatarios,papelUsuarioLogado:_this.props.papelUsuarioLogado,titulo:'',retirarLinhaSeparadora:true,tipoRegime:_this.state.tipoRegime,tipoEntidade:_this.state.tipoEntidade,uf:_this.state.uf,participante:_this.state.participante,nomeAtributoComboboxRegime:'tipoRegime',nomeAtributoComboboxParticipante:'participante',nomeAtributoComboboxTipoEntidade:'tipoEntidade',nomeAtributoComboboxUF:'uf',listaTiposRegimes:_this.state.listaTiposRegimes,labelComboboxParticipante:'Participante'}):'',_this.validaEhPapelObservadorERegimeSelecionado()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SelecaoSuperintendencia__["a" /* default */],{handleChange:_this.handleChange,tipoRegime:_this.state.tipoRegime,papelUsuarioLogado:_this.props.papelUsuarioLogado,listaSuperintendencias:_this.state.listaSuperintendencias,listaGexs:_this.state.listaGexs,listaAps:_this.state.listaAps,superintendencia:_this.state.superintendencia,gex:_this.state.gex,aps:_this.state.aps,tipoRegimeObservador:_this.state.tipoRegimeObservador,titulo:'',retirarLinhaSeparadora:true}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["q" /* SelecaoMultipla */],{handleChange:_this.handleChange,configuracao:_this.state.configComponenteSelecaoMultipla,estado:'2',hint:_this.verificarTextoHintBotaoInclusao(),listaEstadosComSelecaoMultipla:[2],lista:_this.state.lista,valorComboSelecaoMultipla:_this.state.valorComboSelecaoMultipla}));};_this.filtroRelatorioExigenciaAnalitico=JSON.parse(sessionStorage.getItem('filtroRelatorioExigenciaAnalitico'));_this.state={configComponenteSelecaoMultipla:{labelCombobox:'Exigência',titulo:'Tipos de exigência',exibirBotaoIncluir:true,exibirTabelaItens:true,retirarLinhaSeparadora:false,exibirComboBox:true},participanteObservador:_this.filtroRelatorioExigenciaAnalitico&&_this.filtroRelatorioExigenciaAnalitico.participanteObservador?_this.filtroRelatorioExigenciaAnalitico.participanteObservador:null,tipoRegimeObservador:_this.filtroRelatorioExigenciaAnalitico&&_this.filtroRelatorioExigenciaAnalitico.tipoRegimeObservador?_this.filtroRelatorioExigenciaAnalitico.tipoRegimeObservador:null,participante:_this.participante&&_this.filtroRelatorioExigenciaAnalitico.participante?_this.filtroRelatorioExigenciaAnalitico.participante:null,valorComboSelecaoMultipla:_this.filtroRelatorioExigenciaAnalitico&&_this.filtroRelatorioExigenciaAnalitico.valorComboSelecaoMultipla?_this.filtroRelatorioExigenciaAnalitico.valorComboSelecaoMultipla:null,tipoEntidadeObservador:_this.filtroRelatorioExigenciaAnalitico&&_this.filtroRelatorioExigenciaAnalitico.tipoEntidadeObservador?_this.filtroRelatorioExigenciaAnalitico.tipoEntidadeObservador:null,superintendencia:_this.filtroRelatorioExigenciaAnalitico&&_this.filtroRelatorioExigenciaAnalitico.superintendencia?_this.filtroRelatorioExigenciaAnalitico.superintendencia:null,opcao:2,estado:2,lista:_this.filtroRelatorioExigenciaAnalitico&&_this.filtroRelatorioExigenciaAnalitico.lista?_this.filtroRelatorioExigenciaAnalitico.lista:[],listaTiposRegimes:[],listaSuperintendencias:[],listaGexs:[],listaAps:[]};return _this;}_createClass(FiltroRelatorioExigenciaAnalitico,[{key:'componentDidMount',value:function componentDidMount(){if(sessionStorage.getItem('filtroRelatorioExigenciaAnalitico')){this.handleSearch();}this.carregaUnidadesOrganicas(24,null,this.carregaSuperintendencias);this.carregarListaTiposRegimes();}},{key:'render',value:function render(){var _this2=this;var filtroPesquisa=this.montarFiltroPesquisa();if(!filtroPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'relatorio',panelId:'filtro-relatorio',icon:'ico-filter',title:''+this.props.titulo},filtroPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroRelatorioExigenciaAnalitico;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroRelatorioExigenciaAnalitico.propTypes={titulo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,papelUsuarioLogado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};FiltroRelatorioExigenciaAnalitico.defaultProps={destinatarios:[]};/* harmony default export */ __webpack_exports__["a"] = (FiltroRelatorioExigenciaAnalitico);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NovoRelatorioExigenciasAnalitico=function(_Component){_inherits(NovoRelatorioExigenciasAnalitico,_Component);function NovoRelatorioExigenciasAnalitico(props){_classCallCheck(this,NovoRelatorioExigenciasAnalitico);var _this=_possibleConstructorReturn(this,(NovoRelatorioExigenciasAnalitico.__proto__||Object.getPrototypeOf(NovoRelatorioExigenciasAnalitico)).call(this,props));_initialiseProps.call(_this);_this.state={showNoContent:false,noContentPrimaryMessage:null,noContentSecondaryMessage:null,legendaRelatorio:null};return _this;}// FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
_createClass(NovoRelatorioExigenciasAnalitico,[{key:'render',value:function render(){var _this2=this;if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.data&&this.props.data.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Exportar para CSV',onClick:function onClick(){_this2.exportarCsv(_this2.props);},icon:'ico-doc-sheet',mini:true}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relatorio',style:{'--relatorioWidth':this.props.containerStyle.width}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["H" /* DtpTable */],this.props,this.props.headers.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["I" /* DtpTableHeader */],{key:item,dataField:_this2.props.data[0]?Object.keys(_this2.props.data[0])[i]:'default',dataAlign:'center',isKey:i===0,header:item,tdStyle:{wordBreak:'break-word'},dataFormat:_this2.props.dataFormatOptions[i],hidden:_this2.props.options.hidden&&_this2.props.options.hidden.includes(i)});})))):null);}}]);return NovoRelatorioExigenciasAnalitico;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.gerarCsv=function(lista){if(lista&&lista!==undefined&&lista.length>0){var csvExporter=new __WEBPACK_IMPORTED_MODULE_3_export_to_csv__["ExportToCsv"]({filename:'relatorio',fieldSeparator:';',showTitle:true,title:_this3.state.legendaRelatorio,showLabels:true,headers:_this3.colunasRelatorio});csvExporter.generateCsv(lista);}};this.formatarColuna=function(cell,tipo){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='nit'){if(Number.isInteger(cell)){valor=cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}else{valor=cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}}else if(tipo==='protocolo'){valor='\''+cell;}return valor.trim();};this.prepararColunasExportacao=function(data,colunas){var dados=data.map(function(item){var linha=Object.assign({},item);colunas.forEach(function(c){var key=Object.keys(item)[c.index];var coluna=item[key];var colunaFormatada=_this3.formatarColuna(coluna,c.tipo);linha[key]=colunaFormatada;});return linha;});return dados;};this.pesquisarColunaJson=function(json,coluna){var retorno=json[coluna];if(retorno===undefined){retorno='';}return retorno;};this.colunasRelatorio=['Tipo Exigência','Comentário Exigência','CPF','Protocolo','Nome do beneficiário','Data da abertura','Data da situação','Tipo do requerimento'];this.listaColunasFormatar=[{index:2,tipo:'cpf'},{index:3,tipo:'protocolo'}];this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){objetoLinha={tipoExigencia:_this3.pesquisarColunaJson(item,'tipoExigencia'),comentarioExigencia:_this3.pesquisarColunaJson(item,'comentarioExigencia')?_this3.pesquisarColunaJson(item,'comentarioExigencia'):'-',cpf:_this3.pesquisarColunaJson(item,'cpf'),protocolo:_this3.pesquisarColunaJson(item,'protocolo'),nomeBeneficiario:_this3.pesquisarColunaJson(item,'nomeBeneficiario'),dataAbertura:_this3.pesquisarColunaJson(item,'dataAbertura'),dataSituacao:_this3.pesquisarColunaJson(item,'dataSituacao'),tipoRequerimento:_this3.pesquisarColunaJson(item,'tipoRequerimento')};return objetoLinha;});return dados;};this.tratarSucessoListaExportacao=function(response){if(response.data!==''){var lista=_this3.extrairColunasJson(response.data);var dadosFormatados=_this3.prepararColunasExportacao(lista,_this3.listaColunasFormatar);_this3.setState({},_this3.gerarCsv(dadosFormatados));}};this.tratarErro=function(){var mensagemPrimaria='Não foi possível consultar os requerimentos.';var mensagemSecundaria='Contate o administrador do sistema.';_this3.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};this.preparaRequest=function(url,parametros){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["l" /* doPost */])(url,parametros,_this3.tratarSucessoListaExportacao,_this3.tratarErro);};this.exportarCsv=function(props){_this3.setState({legendaRelatorio:props.legend});if(props.urlExportacao&&props.parametrosExportacao){var parametros=props.parametrosExportacao;parametros['start-position']=0;parametros['max-results']=100000;_this3.preparaRequest(props.urlExportacao,parametros);}};};NovoRelatorioExigenciasAnalitico.propTypes={dataFormatOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object}.isRequired;NovoRelatorioExigenciasAnalitico.defaultProps={voltarAction:function voltarAction(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (NovoRelatorioExigenciasAnalitico);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NovoRelatorioConflitoPeriodos__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domain_User__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FiltroRelatorioConflitoPeriodos__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var TelaRelatorioConflitoPeriodos=function(_Component){_inherits(TelaRelatorioConflitoPeriodos,_Component);function TelaRelatorioConflitoPeriodos(props){_classCallCheck(this,TelaRelatorioConflitoPeriodos);var _this=_possibleConstructorReturn(this,(TelaRelatorioConflitoPeriodos.__proto__||Object.getPrototypeOf(TelaRelatorioConflitoPeriodos)).call(this,props));_this.montaFiltros=function(atributosPesquisa){var atributos={};if(atributosPesquisa.participanteObservador){atributos=Object.assign({},atributos,{participanteObservador:atributosPesquisa.participanteObservador});}if(atributosPesquisa.participante){atributos=Object.assign({},atributos,{participante:atributosPesquisa.participante});}if(atributosPesquisa.estado){atributos=Object.assign({},atributos,{estado:atributosPesquisa.estado});}if(atributosPesquisa.opcao){atributos=Object.assign({},atributos,{opcao:atributosPesquisa.opcao});}if(atributosPesquisa.motivo){atributos=Object.assign({},atributos,{motivo:atributosPesquisa.motivo});}if(atributosPesquisa.superintendencia){atributos=Object.assign({},atributos,{superintendencia:atributosPesquisa.superintendencia});}if(atributosPesquisa.gex){atributos=Object.assign({},atributos,{gex:atributosPesquisa.gex});}if(atributosPesquisa.aps){atributos=Object.assign({},atributos,{aps:atributosPesquisa.aps});}if(atributosPesquisa.estadoConflito){atributos=Object.assign({},atributos,{estadoConflito:atributosPesquisa.estadoConflito});}var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.realizaConsulta=function(valoresFiltro){var filtrosEscolhidos={};if(valoresFiltro){filtrosEscolhidos=_this.montaFiltros(valoresFiltro);}_this.setState(Object.assign({},_this.state,{filtrosEscolhidos:filtrosEscolhidos,filtrosAtuais:valoresFiltro}),function(){return _this.executaConsulta();});};_this.zerarPaginacao=function(){_this.preparaNovaConsulta();};_this.definePapelFiltro=function(){var retorno='';var isRgps=_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','consultar-compensacao-rgps']);var isRpps=_this.props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps','consultar-compensacao-rpps']);var isAnalistaSprev=_this.props.auth.checkPermission(['analisar-negocio-sprev']);var isAnalistaDtp=_this.props.auth.checkPermission(['analisar-negocio-dtpv']);var isAnalistaDcomp=_this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);var isAuditorComprev=_this.props.auth.checkPermission(['auditar-comprev']);if(isRgps){retorno='analista-rgps';}if(isRpps){retorno='analista-rpps';}if(isAnalistaSprev){retorno='analista-sprev';}if(isAnalistaDtp){retorno='analista-dtp';}if(isAnalistaDcomp){retorno='analista-rgps';}if(isAuditorComprev){retorno='auditor-comprev';}_this.setState({papelUsuarioLogado:retorno},function(){return _this.buscarParticipantePeloCnpjLogado();});};_this.defineNivelFiltro=function(){if(_this.state.filtrosEscolhidos.participante){return 4;}else if(_this.state.filtrosEscolhidos.aps){return 3;}else if(_this.state.filtrosEscolhidos.gex){return 2;}else if(_this.state.filtrosEscolhidos.superintendencia){return 1;}return 0;};_this.definirValorUo=function(nivel){if(nivel===3){return _this.state.filtrosEscolhidos.aps;}else if(nivel===2){return _this.state.filtrosEscolhidos.gex;}else if(nivel===1){return _this.state.filtrosEscolhidos.superintendencia;}return 0;};_this.defineCodigoOutroParticipante=function(parametros){var novosParametros=parametros;if(_this.state.papelUsuarioLogado!=='analista-rgps'){novosParametros.outroParticipante='01000';}if(_this.state.filtrosEscolhidos.participante){novosParametros.codigo=_this.state.filtrosEscolhidos.participante;}else if(_this.state.filtrosEscolhidos.aps){novosParametros.codigo=_this.state.filtrosEscolhidos.aps;}else if(_this.state.filtrosEscolhidos.gex){novosParametros.codigo=_this.state.filtrosEscolhidos.gex;}else if(_this.state.filtrosEscolhidos.superintendencia){novosParametros.codigo=_this.state.filtrosEscolhidos.superintendencia;}return novosParametros;};_this.converterValoresParaTipoNumerico=function(valor){var retorno=null;if(valor){retorno=Number(valor);}return retorno;};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosEscolhidos).length!==0){var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;var urlRelatorio=null;var nivel=_this.defineNivelFiltro();urlRelatorio='relatorios/conflitos-periodos';var parametros={tipoParticipacao:_this.converterValoresParaTipoNumerico(_this.state.filtrosEscolhidos.opcao),participante:_this.state.filtrosEscolhidos.participante,estado:_this.converterValoresParaTipoNumerico(_this.state.filtrosEscolhidos.estado),estadoConflito:_this.converterValoresParaTipoNumerico(_this.state.filtrosEscolhidos.estadoConflito),'start-position':primeiroItem,'max-results':resultadosPorPagina};if(_this.state.filtrosEscolhidos.participanteObservador){parametros.participanteObservador=_this.state.filtrosEscolhidos.participanteObservador;}if(_this.isConsultaPorVisao()){if(_this.state.papelUsuarioLogado==='analista-rgps'||_this.state.filtrosEscolhidos.participanteObservador==='01000'){parametros.nivelUo=nivel;parametros.idUo=_this.definirValorUo(nivel);}}_this.setState({urlExportacao:urlRelatorio,parametrosExportacao:parametros},function(){return _this.preparaRequest(urlRelatorio,parametros);});}};_this.preparaRequest=function(urlRelatorio,parametros){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["l" /* doPost */])(urlRelatorio,parametros,_this.tratarSucesso(),_this.tratarErro);};_this.recuperarTituloPorId=function(lista,id){var retorno='';var index=lista.findIndex(function(item){return item.value===id;});if(index!==-1){retorno=lista[index].label;}return retorno;};_this.exibirComplementoPorNivelSuperintendencia=function(){var nivel=_this.defineNivelFiltro();var retorno='';var nome='';switch(nivel){case 1:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaSuperintendencias,_this.state.filtrosEscolhidos.superintendencia);retorno='SUPERINTEND\xCANCIA: '+_this.state.filtrosEscolhidos.superintendencia+' - '+nome;break;case 2:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaGexs,_this.state.filtrosEscolhidos.gex);retorno='GEX: '+_this.state.filtrosEscolhidos.gex+' - '+nome;break;case 3:nome=_this.recuperarTituloPorId(_this.state.filtrosAtuais.listaAps,_this.state.filtrosEscolhidos.aps);retorno='APS: '+_this.state.filtrosEscolhidos.aps+' - '+nome;break;default:break;}return retorno.toUpperCase();};_this.exibirNomeEstado=function(estado){return __WEBPACK_IMPORTED_MODULE_8__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_8__utils_listsSelect__["Q" /* tiposEstado */],estado).label.toUpperCase();};_this.handleClickNovoEstadoSuccess=function(response){_this.pushNavegacao(response.data.protocolo);};_this.handleClickNovoEstadoFail=function(){};_this.pushNavegacao=function(protocolo){_this.props.history.push('/requerimento/aposentadoria/'+protocolo);};_this.handleClickDetalhe=function(protocolo){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('requerimentos-compensacao-aposentadoria/'+protocolo,_this.handleClickNovoEstadoSuccess,_this.handleClickNovoEstadoFail);};_this.isConsultaPorVisao=function(){var ehVisao=false;if([2,3].includes(_this.state.filtrosEscolhidos.opcao)){ehVisao=true;}return ehVisao;};_this.handleSuccessBuscaPeloCnpjLogado=function(response){var nome='';if(response.data){nome=response.data.nome+' - '+response.data.codigo;_this.setState({nomeSolicitante:nome});}};_this.handleErrorBuscaPeloCnpjLogado=function(){return'';};_this.buscarParticipantePeloCnpjLogado=function(){if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)||_this.state.papelUsuarioLogado==='analista-rpps'){var usuarioLogado=new __WEBPACK_IMPORTED_MODULE_9__domain_User__["a" /* default */](localStorage.getItem('jwt'));var cnpj=usuarioLogado.cnpjDoPapel();if(cnpj){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["e" /* doGet */])('participantes-compensacao/'+cnpj,_this.handleSuccessBuscaPeloCnpjLogado,_this.handleErrorBuscaPeloCnpjLogado);}}else if(_this.state.papelUsuarioLogado==='analista-rgps'){_this.setState({nomeSolicitante:'RGPS'});}};_this.buscarDestinatario=function(){var nivel=_this.defineNivelFiltro();var retorno='';var nome='';switch(nivel){case 1:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaSuperintendencias,_this.state.filtrosEscolhidos.superintendencia);retorno='SUPERINTEND\xCANCIA: '+_this.state.filtrosEscolhidos.superintendencia+' - '+nome;break;case 2:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaGexs,_this.state.filtrosEscolhidos.gex);retorno='GEX: '+_this.state.filtrosEscolhidos.gex+' - '+nome;break;case 3:nome=_this.recuperarTituloPorId(_this.state.filtrosEscolhidos.listaAps,_this.state.filtrosEscolhidos.aps);retorno='APS: '+_this.state.filtrosEscolhidos.aps+' - '+nome;break;case 4:if(_this.state.filtrosEscolhidos.participante==='01000'){nome='RGPS';}else{nome=_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participante);}retorno='DESTINAT\xC1RIO: '+_this.state.filtrosEscolhidos.participante+' - '+nome;break;default:break;}return retorno.toUpperCase();};_this.exibirNomeSolicitante=function(){var retorno='';if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)){retorno='SOLICITANTE: '+_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participanteObservador)+' -\n      '+_this.state.filtrosEscolhidos.participanteObservador;}else{retorno='SOLICITANTE: '+_this.state.nomeSolicitante;}return' - '+retorno.toUpperCase();};_this.montarTituloSolicitanteOuDestinatario=function(titulo){var retorno='';if(Object(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.state.papelUsuarioLogado)){var participanteObservadorSelecionado=_this.state.filtrosEscolhidos.participanteObservador;retorno=titulo+' '+_this.recuperarTituloPorId(_this.props.destinatarios,_this.state.filtrosEscolhidos.participanteObservador)+' - '+participanteObservadorSelecionado;}else{retorno=titulo+' '+_this.state.nomeSolicitante;}return retorno;};_this.especificarConsultaPorVisao=function(){var retorno='';switch(_this.state.filtrosEscolhidos.opcao){case 2:retorno=_this.montarTituloSolicitanteOuDestinatario('SOLICITANTE:');break;case 3:retorno=_this.montarTituloSolicitanteOuDestinatario('DESTINATÁRIO:');break;default:break;}return retorno;};_this.montarLegendaNomeRelatorioPorFiltroSelecionado=function(){var textoFinal='';var titulo='conflitos de períodos';var dataAtual=''+__WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('DD/MM/YYYY HH:mm:ss');if(_this.isConsultaPorVisao()){// (VISÃO: OPCAO SOLICITANTE OU DESTINATARIO ESCOLHIDA)
// textoFinal = `${titulo} ${nomeEstado} - ${this.especificarConsultaPorVisao()} ${dataAtual} ${complementoPorNivelSuperintendencia} ${complementoPorTipoDeLista}`;
textoFinal=titulo+' '+_this.exibirComplementoPorNivelSuperintendencia()+' '+dataAtual;}else{// textoFinal = `${titulo} ${nomeEstado} ${this.exibirNomeSolicitante()} ${this.buscarDestinatario()} ${dataAtual} ${complementoPorTipoDeLista}`;
// textoFinal = `${titulo} - AMBOS - ${dataAtual}`;
textoFinal=titulo+' - '+dataAtual;}return textoFinal;};_this.colunasRelatorio=['CPF','Nome','Matrícula','Solicitante','Destinatário','Estado','Detalhe'];_this.addTipoEstadoLabel=function(tipo){if(tipo===15){return'Exigência/indeferido';}if(tipo===16){return'Indeferimento ratificado';}if(tipo===undefined||tipo===null){return'';}return __WEBPACK_IMPORTED_MODULE_8__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_8__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};_this.pesquisarColunaJson=function(json,coluna){var retorno=json[coluna];if(retorno===undefined){retorno='';}return retorno;};_this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){var objSolicitante=item[Object.keys(item)[1]]+'-'+item[Object.keys(item)[0]];var objDestinatario=item[Object.keys(item)[3]]+'-'+item[Object.keys(item)[2]];objetoLinha={cpf:_this.pesquisarColunaJson(item,'cpf'),nome:_this.pesquisarColunaJson(item,'nome'),matricula:_this.pesquisarColunaJson(item,'matricula'),solicitante:objSolicitante,destinatario:objDestinatario,estado:_this.addTipoEstadoLabel(_this.pesquisarColunaJson(item,'estado')),protocolo:_this.pesquisarColunaJson(item,'protocolo')};return objetoLinha;});return dados;};_this.montaColuna=function(tipo){return function(cell,row){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='nit'){if(Number.isInteger(cell)){valor=cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}else{valor=cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}}else if(tipo==='botao'){valor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components__["a" /* Button */],{hint:'ir para o requerimento',icon:'ico-doc-magnifier',mini:true,onClick:function onClick(){return _this.handleClickDetalhe(row.protocolo);}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,valor);};};_this.relatorioDataFormatOptions={6:_this.montaColuna('botao')};_this.tratarSucesso=function(){return function(response){var quantidadeTotalResultados=0;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}var _this$state=Object.assign({},_this.state),estadoTabela=_this$state.estadoTabela;estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;var dataFormatOptions={};if(response.data!==''){var lista=_this.extrairColunasJson(response.data);dataFormatOptions=_this.relatorioDataFormatOptions;var dadosFormatados=_this.prepararColunasExportacao(lista);_this.setState({listaResultados:lista,listaResultadosFormatados:dadosFormatados,colunasRelatorio:_this.colunasRelatorio,nomeRelatorio:_this.montarLegendaNomeRelatorioPorFiltroSelecionado(),estadoTabela:estadoTabela,dataFormatOptions:dataFormatOptions});}};};_this.prepararColunasExportacao=function(data){var dados=data.map(function(item){var linha=Object.assign({},item);return linha;});return dados;};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.formatarColuna=function(cell,tipo){var valor=cell;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='moeda'){valor=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).formatToParts(cell).map(function(_ref){var type=_ref.type,value=_ref.value;switch(type){case'currency':return'';default:return value;}}).reduce(function(string,part){return string+part;});}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='booleano'){valor=cell===1?'S':'N';}return valor.trim();};_this.defineContainerStyle=function(){var width=_this.state.colunasRelatorio.length*130;if(width<1140){width=1140;}return{width:width+'px'};};_this.alterarPagina=function(pagina,page){var _this$state2=Object.assign({},_this.state),estadoTabela=_this$state2.estadoTabela;estadoTabela.paginaAtual=pagina;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(page){estadoTabela.resultadosPorPagina=page;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),_this.realizaConsulta());};_this.preparaNovaConsulta=function(){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};_this.setState({listaRequerimentosFiltrada:null,estadoTabela:estadoTabela},_this.realizaConsulta());};_this.state={listaResultados:[],listaResultadosFormatados:[],colunasRelatorio:[],nomeRelatorio:'',dataFormatOptions:{},papelUsuarioLogado:null,nomeSolicitante:'',estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosAtuais:{},filtrosEscolhidos:{},urlExportacao:null,parametrosExportacao:null};return _this;}_createClass(TelaRelatorioConflitoPeriodos,[{key:'componentDidMount',value:function componentDidMount(){sessionStorage.removeItem('filtroRelatorioAnalitico');if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}this.definePapelFiltro();}// SE AS OPÇOES SOLICITANTE OU DESTINATARIO
// ESTIVEREM SELECIONADAS, TRATA-SE DE UMA
// CONSULTA POR VISÃO.
// FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
},{key:'render',value:function render(){var options={noDataText:'Nenhum registro a ser exibido',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_8__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__FiltroRelatorioConflitoPeriodos__["a" /* default */],{tipo:'Conflitos de per\xEDodos',filtroModalidade:false,handleSearchFilter:this.realizaConsulta,papelUsuarioLogado:this.state.papelUsuarioLogado,destinatarios:this.props.destinatarios,observardorDeMudanca:this.zerarPaginacao,nomeFiltro:'FiltroRelatorioConflitoPeriodos'}),this.state.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NovoRelatorioConflitoPeriodos__["a" /* default */],{legend:this.state.nomeRelatorio,bordered:true,headers:this.state.colunasRelatorio,data:this.state.listaResultados,options:options,pagination:true,remote:true,dataFormatOptions:this.state.dataFormatOptions,landscape:true,containerStyle:this.defineContainerStyle()// exportacao={this.state.listaResultadosFormatados}
,fetchInfo:fetchInfo,rowAtual:this.state.rowAtual,urlExportacao:this.state.urlExportacao,parametrosExportacao:this.state.parametrosExportacao}):null);}}]);return TelaRelatorioConflitoPeriodos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TelaRelatorioConflitoPeriodos.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};TelaRelatorioConflitoPeriodos.defaultProps={destinatarios:[]};// eslint-disable-next-line
var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(TelaRelatorioConflitoPeriodos));

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colunasRelatorioTotalizador=['Cpf','Nome','Matrícula','Solicitante','Destinatário','Estado','Detalhe'];var NovoRelatorioTotalizadorEstados=function(_Component){_inherits(NovoRelatorioTotalizadorEstados,_Component);function NovoRelatorioTotalizadorEstados(props){_classCallCheck(this,NovoRelatorioTotalizadorEstados);var _this=_possibleConstructorReturn(this,(NovoRelatorioTotalizadorEstados.__proto__||Object.getPrototypeOf(NovoRelatorioTotalizadorEstados)).call(this,props));_initialiseProps.call(_this);_this.state={showNoContent:false,noContentPrimaryMessage:null,noContentSecondaryMessage:null,legendaRelatorio:null};return _this;}_createClass(NovoRelatorioTotalizadorEstados,[{key:'render',value:function render(){var _this2=this;if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.data&&this.props.data.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* Button */],{hint:'Exportar para CSV',onClick:function onClick(){_this2.exportarCsv(_this2.props);},icon:'ico-doc-sheet',mini:true}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relatorio',style:{'--relatorioWidth':this.props.containerStyle.width}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["H" /* DtpTable */],this.props,this.props.headers.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["I" /* DtpTableHeader */],{key:item,dataField:_this2.props.data[0]?Object.keys(_this2.props.data[0])[i]:'default',dataAlign:'center',isKey:i===0,header:item,tdStyle:{wordBreak:'break-word'},dataFormat:_this2.props.dataFormatOptions[i],hidden:_this2.props.options.hidden&&_this2.props.options.hidden.includes(i)});})))):null);}}]);return NovoRelatorioTotalizadorEstados;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.gerarCsv=function(lista){if(lista&&lista!==undefined&&lista.length>0){var csvExporter=new __WEBPACK_IMPORTED_MODULE_3_export_to_csv__["ExportToCsv"]({filename:'relatorio',fieldSeparator:';',showTitle:true,title:_this3.state.legendaRelatorio,showLabels:true,headers:colunasRelatorioTotalizador});csvExporter.generateCsv(lista);}};this.prepararColunasExportacao=function(data){var dados=data.map(function(item){var linha=Object.assign({},item);return linha;});return dados;};this.addTipoEstadoLabel=function(tipo){if(tipo===15){return'Exigência/indeferido';}if(tipo===16){return'Indeferimento ratificado';}if(tipo===undefined||tipo===null){return'';}return __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){var objSolicitante=item[Object.keys(item)[1]]+'-'+item[Object.keys(item)[0]];var objDestinatario=item[Object.keys(item)[3]]+'-'+item[Object.keys(item)[2]];objetoLinha={cpf:_this3.pesquisarColunaJson(item,'cpf'),nome:_this3.pesquisarColunaJson(item,'nome'),matricula:_this3.pesquisarColunaJson(item,'matricula'),solicitante:objSolicitante,destinatario:objDestinatario,estado:_this3.addTipoEstadoLabel(_this3.pesquisarColunaJson(item,'estado')),protocolo:_this3.pesquisarColunaJson(item,'protocolo')};return objetoLinha;});return dados;};this.pesquisarColunaJson=function(json,coluna){var retorno=json[coluna];if(retorno===undefined){retorno='';}return retorno;};this.tratarSucessoListaExportacao=function(response){if(response.data!==''){var lista=_this3.extrairColunasJson(response.data);var dadosFormatados=_this3.prepararColunasExportacao(lista);_this3.setState({},_this3.gerarCsv(dadosFormatados));}};this.tratarErro=function(){var mensagemPrimaria='Não foi possível consultar os requerimentos.';var mensagemSecundaria='Contate o administrador do sistema.';_this3.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};this.preparaRequest=function(url,parametros){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["l" /* doPost */])(url,parametros,_this3.tratarSucessoListaExportacao,_this3.tratarErro);};this.exportarCsv=function(props){_this3.setState({legendaRelatorio:props.legend});if(props.urlExportacao&&props.parametrosExportacao){var parametros=props.parametrosExportacao;parametros['start-position']=0;parametros['max-results']=100000;_this3.preparaRequest(props.urlExportacao,parametros);}};};NovoRelatorioTotalizadorEstados.propTypes={dataFormatOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object}.isRequired;NovoRelatorioTotalizadorEstados.defaultProps={voltarAction:function voltarAction(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (NovoRelatorioTotalizadorEstados);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelecaoSuperintendencia__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var participanteRGPS='01000';var FiltroRelatorioConflitoPeriodos=function(_Component){_inherits(FiltroRelatorioConflitoPeriodos,_Component);function FiltroRelatorioConflitoPeriodos(){_classCallCheck(this,FiltroRelatorioConflitoPeriodos);var _this=_possibleConstructorReturn(this,(FiltroRelatorioConflitoPeriodos.__proto__||Object.getPrototypeOf(FiltroRelatorioConflitoPeriodos)).call(this));_this.filtrarRegimes=function(){var retorno=_this.state.listaTiposRegimes;if(_this.props.papelUsuarioLogado==='analista-rgps'||_this.state.tipoRegimeObservador===1&&Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)){retorno=_this.state.listaTiposRegimes.filter(function(item){return item.label!=='RGPS';});}if(_this.props.papelUsuarioLogado!=='analista-rgps'||_this.state.tipoRegimeObservador===2&&Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)){retorno=__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */];}_this.setState({listaTiposRegimes:retorno});};_this.handleChangeOpcao=function(value){_this.filtrarRegimes();var ehVisao=false;if([2,3].includes(value)){ehVisao=true;}else{ehVisao=false;}_this.setState({opcao:value,consultaPorVisao:ehVisao},function(){return _this.limparFormulario(value);});};_this.handleChange=function(changeObj,name){var _this$setState;var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var configuracao=_this.state.configComponenteSelecaoMultipla;var limparCampos=false;if(name==='tipoRegimeObservador'){if(changeObj.value===1){_this.setState({participanteObservador:participanteRGPS});}_this.setState({tipoRegimeObservador:changeObj.value},_this.filtrarRegimes);// if (this.state.tipoRegimeObservador !== null && (this.state.tipoRegimeObservador !== changeObj.value)) {
//   limparCampos = true;
// }
}if(name==='tipoRegime'){if(changeObj.value===1){_this.setState({participante:participanteRGPS});}// if (this.state.tipoRegime !== null && (this.state.tipoRegime !== changeObj.value)) {
//   limparCampos = true;
// }
}if(name==='estado'){if(_this.state.valorComboSelecaoMultipla!==null&&_this.state.valorComboSelecaoMultipla!==changeObj.value){limparCampos=true;}}if(callback===null){callback=function callback(){return _this.trataFormulario(limparCampos,name);};}_this.setState((_this$setState={},_defineProperty(_this$setState,name,changeObj.value),_defineProperty(_this$setState,'configComponenteSelecaoMultipla',configuracao),_this$setState),callback);};_this.handleChangeRadio=function(changeObj,name){var _this$setState2;_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,changeObj.value),_defineProperty(_this$setState2,'consultaPorVisao',true),_this$setState2));};_this.trataFormulario=function(limparCampos,campoAlterado){if(campoAlterado==='tipoRegimeObservador'&&limparCampos){_this.setState({tipoEntidadeObservador:null,uFObservador:null,participanteObservador:null,opcao:null,participante:null,tipoEntidade:null,uf:null});}if(campoAlterado==='tipoRegime'&&limparCampos){_this.setState({tipoEntidade:null,uF:null,participante:null});}if(campoAlterado==='estado'&&limparCampos){_this.setState({valorComboSelecaoMultipla:null});}if(campoAlterado==='tipoEntidade'){_this.setState({participante:null,uf:null});}if(campoAlterado==='uf'){_this.setState({participante:null});}if(campoAlterado==='superintendencia'){_this.setState({gex:null,aps:null,ente:null});if(_this.state.superintendencia){_this.carregaUnidadesOrganicas(3,_this.state.superintendencia,_this.carregaGexs);}}if(campoAlterado==='gex'){_this.setState({aps:null,ente:null});if(_this.state.gex){_this.carregaUnidadesOrganicas(4,_this.state.gex,_this.carregaAps);}}_this.props.observardorDeMudanca();};_this.limparFormulario=function(valor){if(valor===''||(valor===2||valor===3)&&_this.state.tipoEntidade!==null){_this.setState({tipoEntidade:null});}if((valor===2||valor===3)&&_this.state.participante!==null){_this.setState({participante:null});}if(_this.state.tipoRegime!==null){_this.setState({tipoRegime:null});}if(_this.state.superintendencia!==null){_this.setState({superintendencia:null});}if(_this.state.gex!==null){_this.setState({gex:null});}if(_this.state.visao!==null){_this.setState({visao:null});}_this.props.observardorDeMudanca();};_this.addMessage=function(text){var message={title:'Titulo',text:text,timeout:5000,type:'danger'};window.DtpSnackbar.addMessage(message);};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;if(error.status){if(error.status===404){_this.addMessage('Nenhum resultado encontrado para o filtro informado.');}else{_this.addMessage(''+data.mensagem);}}else{_this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');}}};_this.carregarListaTiposRegimes=function(){_this.setState({listaTiposRegimes:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */]});};_this.carregaUnidadesOrganicas=function(categoria,codigoSuperior,sucesso){var parametros={};if(codigoSuperior){parametros.codigoSuperior=codigoSuperior;}if(categoria){parametros.categoria=categoria;}Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('unidades-organicas',sucesso,_this.tratarErro,parametros);};_this.carregaSuperintendencias=function(response){var superintendencias=[];response.data.forEach(function(item){superintendencias.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaSuperintendencias:superintendencias});};_this.carregaGexs=function(response){var gexs=[];response.data.forEach(function(item){gexs.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaGexs:gexs});};_this.carregaAps=function(response){var aps=[];response.data.forEach(function(item){aps.push({label:item.nomeUnidade,value:item.codigoUnidade});});_this.setState({listaAps:aps});};_this.carregaEntesFederativos=function(aps){var parametros={aps:aps};Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('entes-federativos',_this.tratarSucessoEntesFederativos,_this.tratarErro,parametros);};_this.tratarSucessoEntesFederativos=function(response){var entes=[];response.data.forEach(function(item){entes.push({label:item.nomeRpps,value:item.idParticipante});});_this.setState({listaEntes:entes});};_this.validaNaoEhSuperintendenciaESelecionouAmbos=function(){var opcaoAmbos=1;return!_this.state.superintendencia&&_this.state.opcao===opcaoAmbos;};_this.validaEhPapelObservador=function(){return Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)&&!_this.state.tipoRegimeObservador;};_this.validaEhPapelObservadorERegimeSelecionado=function(){return _this.props.papelUsuarioLogado==='analista-rgps'&&_this.state.opcao!==1||Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)&&_this.state.tipoRegimeObservador===1&&_this.state.opcao!==1;};_this.verificarTextoHintBotaoInclusao=function(){var retorno='item';switch(_this.state.estado){case'2':retorno='exigência';break;case'9':retorno='motivo';break;case'10':retorno='motivo';break;default:break;}return retorno;};_this.montaFiltrosDefault=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__["a" /* default */],{handleChange:_this.handleChange,destinatarios:_this.props.destinatarios,papelUsuarioLogado:_this.props.papelUsuarioLogado,titulo:'Visualizar como',retirarLinhaSeparadora:false,tipoRegime:_this.state.tipoRegimeObservador,tipoEntidade:_this.state.tipoEntidadeObservador,uf:_this.state.uFObservador,participante:_this.state.participanteObservador,nomeAtributoComboboxRegime:'tipoRegimeObservador',nomeAtributoComboboxParticipante:'participanteObservador',nomeAtributoComboboxTipoEntidade:'tipoEntidadeObservador',nomeAtributoComboboxUF:'uFObservador',listaTiposRegimes:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["L" /* tipoRegime */],labelComboboxParticipante:'Participante Observador'}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["f" /* DataGridCustom */],{title:'Filtro b\xE1sico'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'12 12 12 12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["p" /* RadioComLabel */],{value:_this.state.opcao,name:'opcao',itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["K" /* tipoParticipacaoConflitosPeriodos */],onChange:function onChange(value){return _this.handleChangeOpcao(value);},animate:false,label:'Op\xE7\xE3o',disabled:_this.validaEhPapelObservador(),disposicao:'horizontal',required:true}))),_this.validaNaoEhSuperintendenciaESelecionouAmbos()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelecaoEntidade__["a" /* default */],{handleChange:_this.handleChange,destinatarios:_this.props.destinatarios,papelUsuarioLogado:_this.props.papelUsuarioLogado,titulo:'',retirarLinhaSeparadora:true,tipoRegime:_this.state.tipoRegime,tipoEntidade:_this.state.tipoEntidade,uf:_this.state.uf,participante:_this.state.participante,nomeAtributoComboboxRegime:'tipoRegime',nomeAtributoComboboxParticipante:'participante',nomeAtributoComboboxTipoEntidade:'tipoEntidade',nomeAtributoComboboxUF:'uf',listaTiposRegimes:_this.state.listaTiposRegimes,labelComboboxParticipante:'Participante'}):'',_this.validaEhPapelObservadorERegimeSelecionado()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SelecaoSuperintendencia__["a" /* default */],{handleChange:_this.handleChange,tipoRegime:_this.state.tipoRegime,papelUsuarioLogado:_this.props.papelUsuarioLogado,listaSuperintendencias:_this.state.listaSuperintendencias,listaGexs:_this.state.listaGexs,listaAps:_this.state.listaAps,superintendencia:_this.state.superintendencia,gex:_this.state.gex,aps:_this.state.aps,tipoRegimeObservador:_this.state.tipoRegimeObservador,titulo:'',retirarLinhaSeparadora:true}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["f" /* DataGridCustom */],{title:'Estado do requerimento'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Estado',name:'estado',onChange:function onChange(e){return _this.handleChange(e,'estado');},itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["Q" /* tiposEstado */],value:_this.state.estado,validationState:'active',custom:true,placeholder:'Selecione uma op\xE7\xE3o para filtrar'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["f" /* DataGridCustom */],{title:'Situa\xE7\xE3o do conflito'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Situa\xE7\xE3o do conflito',name:'estadoConflito',onChange:function onChange(e){return _this.handleChange(e,'estadoConflito');},itemList:__WEBPACK_IMPORTED_MODULE_4__utils_listsSelect__["d" /* estadoConflito */],value:_this.state.estadoConflito,validationState:'active',custom:true,placeholder:'Selecione a situa\xE7\xE3o do conflito'})))));};_this.handleSearch=function(){var participanteObservadorSelecionado=_this.state.participanteObservador;var regimeSelecionado=_this.state.tipoRegime;var entidadeSelecionada=_this.state.tipoEntidade;var ufSelecionada=_this.state.uf;var participanteSelecionado=_this.state.participante;var opcaoSelecionada=_this.state.opcao;var superintendenciaSelecionada=_this.state.superintendencia;if(Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)&&!participanteObservadorSelecionado){_this.addMessage('Selecione o participante Observador.');return;}if(!opcaoSelecionada){_this.addMessage('Selecione uma opção.');return;}// refatorar essa parte
if(_this.props.papelUsuarioLogado==='analista-rgps'||participanteObservadorSelecionado==='01000'){if(opcaoSelecionada&&opcaoSelecionada===1){if(!regimeSelecionado){_this.addMessage('Selecione um regime.');return;}if(regimeSelecionado!==1&&!entidadeSelecionada){_this.addMessage('Selecione uma entidade.');return;}if(entidadeSelecionada&&entidadeSelecionada===2&&ufSelecionada===null){_this.addMessage('Selecione uma UF.');return;}if(!participanteSelecionado){_this.addMessage('Selecione um participante.');return;}}else if(opcaoSelecionada&&opcaoSelecionada!==1){if(!superintendenciaSelecionada){_this.addMessage('Selecione uma superintendência.');return;}}}else{if(opcaoSelecionada&&opcaoSelecionada===1){if(!regimeSelecionado){_this.addMessage('Selecione um regime.');return;}if(regimeSelecionado!==1&&!entidadeSelecionada){_this.addMessage('Selecione uma entidade.');return;}if(entidadeSelecionada&&entidadeSelecionada===2&&ufSelecionada===null){_this.addMessage('Selecione uma UF.');return;}if(!participanteSelecionado){_this.addMessage('Selecione um participante.');return;}}}_this.props.handleSearchFilter(_this.state);};_this.handleSearchButton=function(){var filtroRelatorioConflitoPeriodos={tipoRegime:_this.state.tipoRegime,tipoRegimeObservador:_this.state.tipoRegimeObservador,tipoEntidade:_this.state.tipoEntidade,tipoEntidadeObservador:_this.state.tipoEntidadeObservador,uf:_this.state.uf,uFObservador:_this.state.uFObservador,participante:_this.state.participante,participanteObservador:_this.state.participanteObservador,superintendencia:_this.state.superintendencia,gex:_this.state.gex,aps:_this.state.aps,visao:_this.state.visao,opcao:_this.state.opcao,estado:_this.state.estado,consultaPorVisao:_this.state.consultaPorVisao,lista:_this.state.lista,configComponenteSelecaoMultipla:_this.state.configComponenteSelecaoMultipla,valorComboSelecaoMultipla:_this.state.valorComboSelecaoMultipla};filtroRelatorioConflitoPeriodos=JSON.stringify(filtroRelatorioConflitoPeriodos);sessionStorage.setItem(_this.props.nomeFiltro,filtroRelatorioConflitoPeriodos);_this.handleSearch();};_this.filtroRelatorioConflitoPeriodos=JSON.parse(sessionStorage.getItem('filtroRelatorioConflitoPeriodos'));_this.state={tipoRegime:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.tipoRegime?_this.filtroRelatorioConflitoPeriodos.tipoRegime:null,tipoRegimeObservador:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.tipoRegimeObservador?_this.filtroRelatorioConflitoPeriodos.tipoRegimeObservador:null,tipoEntidade:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.tipoEntidade?_this.filtroRelatorioConflitoPeriodos.tipoEntidade:null,tipoEntidadeObservador:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.tipoEntidadeObservador?_this.filtroRelatorioConflitoPeriodos.tipoEntidadeObservador:null,uf:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.uf?_this.filtroRelatorioConflitoPeriodos.uf:null,uFObservador:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.uFObservador?_this.filtroRelatorioConflitoPeriodos.uFObservador:null,participante:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.participante?_this.filtroRelatorioConflitoPeriodos.participante:null,participanteObservador:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.participanteObservador?_this.filtroRelatorioConflitoPeriodos.participanteObservador:null,superintendencia:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.superintendencia?_this.filtroRelatorioConflitoPeriodos.superintendencia:null,gex:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.gex?_this.filtroRelatorioConflitoPeriodos.gex:null,aps:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.aps?_this.filtroRelatorioConflitoPeriodos.aps:null,visao:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.visao?_this.filtroRelatorioConflitoPeriodos.visao:null,opcao:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.opcao?_this.filtroRelatorioConflitoPeriodos.opcao:null,estado:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.estado?_this.filtroRelatorioConflitoPeriodos.estado:null,consultaPorVisao:_this.filtroRelatorioConflitoPeriodos&&_this.filtroRelatorioConflitoPeriodos.consultaPorVisao?_this.filtroRelatorioConflitoPeriodos.consultaPorVisao:null,listaSuperintendencias:[],listaGexs:[],listaAps:[],listaEntes:[],listaTiposRegimes:[],listaTiposRegimesOutrosPapeis:[]};return _this;}_createClass(FiltroRelatorioConflitoPeriodos,[{key:'componentDidMount',value:function componentDidMount(){if(sessionStorage.getItem('filtroRelatorioConflitoPeriodos')){this.handleSearch();}this.carregaUnidadesOrganicas(24,null,this.carregaSuperintendencias);this.carregarListaTiposRegimes();}},{key:'render',value:function render(){var _this2=this;var filtrosPesquisa=this.montaFiltrosDefault();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'relatorio',panelId:'filtro-relatorio',icon:'ico-filter',title:''+this.props.tipo},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this2.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroRelatorioConflitoPeriodos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroRelatorioConflitoPeriodos.propTypes={handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,observardorDeMudanca:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,papelUsuarioLogado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nomeFiltro:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroRelatorioConflitoPeriodos);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FiltroSimulacaoCompensacao__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SimulacaoCompensacao__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_User__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var TODOS_OS_RESULTADOS='TODOS';var CODIGO_RGPS='01000';var ConsultaSimulacaoCompensacao=function(_Component){_inherits(ConsultaSimulacaoCompensacao,_Component);function ConsultaSimulacaoCompensacao(props){_classCallCheck(this,ConsultaSimulacaoCompensacao);var _this=_possibleConstructorReturn(this,(ConsultaSimulacaoCompensacao.__proto__||Object.getPrototypeOf(ConsultaSimulacaoCompensacao)).call(this,props));_this.definePapelFiltro=function(){var retorno='';var isRgps=_this.props.auth.checkPermission(['requerer-compensacao-rgps','analisar-compensacao-rgps','consultar-compensacao-rgps']);var isRpps=_this.props.auth.checkPermission(['requerer-compensacao-rpps','analisar-compensacao-rpps','consultar-compensacao-rpps']);var isAnalistaSprev=_this.props.auth.checkPermission(['analisar-negocio-sprev']);var isAnalistaDtp=_this.props.auth.checkPermission(['analisar-negocio-dtpv']);var isAnalistaDcomp=_this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);var isAuditorComprev=_this.props.auth.checkPermission(['auditar-comprev']);if(isRgps){retorno='analista-rgps';}if(isRpps){retorno='analista-rpps';}if(isAnalistaSprev){retorno='analista-sprev';}if(isAnalistaDtp){retorno='analista-dtp';}if(isAnalistaDcomp){retorno='analista-rgps';}if(isAuditorComprev){retorno='auditor-comprev';}_this.setState({papelUsuarioLogado:retorno},function(){return _this.recuperarEstadosSimulacaoCompensacao(_this.tratarErro);});};_this.handleErrorBuscaPeloCnpjLogado=function(){return'';};_this.recuperarEstadosSimulacaoCompensacao=function(callback){if(_this.props.estadosSimulacaoCompensacao.length===0){if(_this.state.papelUsuarioLogado==='analista-rpps'){var usuarioLogado=new __WEBPACK_IMPORTED_MODULE_10__domain_User__["a" /* default */](localStorage.getItem('jwt'));var cnpj=usuarioLogado.cnpjDoPapel();if(cnpj){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["e" /* doGet */])('participantes-compensacao/'+cnpj,_this.handleSuccessBuscaPeloCnpjLogado,callback);}}else if(_this.state.papelUsuarioLogado==='analista-rgps'){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["b" /* buscaEstadosSimulacaoCompensacao */])(_this.tratarErro,CODIGO_RGPS);}}};_this.recuperarCnpjParticipanteComoObservador=function(codigo){if(codigo){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["b" /* buscaEstadosSimulacaoCompensacao */])(_this.tratarErro,codigo);}};_this.handleSuccessBuscaPeloCnpjLogado=function(response){if(response.data){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["b" /* buscaEstadosSimulacaoCompensacao */])(_this.tratarErro,response.data.codigo);}};_this.extrairValoresParaPesquisar=function(exportacao){var _this$state=Object.assign({},_this.state),filtrosConsulta=_this$state.filtrosConsulta;var retorno=[];var valor=void 0;if(filtrosConsulta.lista&&filtrosConsulta.lista.length>0){filtrosConsulta.lista.forEach(function(item){if(exportacao){if(item.value&&item.label){valor=item.label.concat(' - ',item.value);retorno.push(valor);}}else{// if (item.value) {
valor=Number(item.value);retorno.push(valor);// }
}});}return retorno;};_this.preparaNovaConsulta=function(filtrosPesquisa){var estadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1};var _this$state2=Object.assign({},_this.state),filtrosConsulta=_this$state2.filtrosConsulta;var filtro={};if(filtrosPesquisa){filtro=filtrosPesquisa;}else{filtro=filtrosConsulta;}filtrosConsulta=_this.montaFiltros(filtro);_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta,estadoTabela:estadoTabela,listaRequerimentosFiltrada:null,nivel:1}),_this.executaConsulta);};_this.preparaNovaConsultaListaRequerimentos=function(row){var _this$state3=Object.assign({},_this.state),historicoEstadoTabelaPrimeiroNivel=_this$state3.historicoEstadoTabelaPrimeiroNivel;var _this$state4=Object.assign({},_this.state),estadoTabela=_this$state4.estadoTabela;historicoEstadoTabelaPrimeiroNivel=estadoTabela;var novoEstadoTabela={quantidadeTotalResultados:0,resultadosPorPagina:5,paginaAtual:1};var filtrosConsulta={};if(row){filtrosConsulta=_this.montaFiltrosListaRequerimentos(row);}else{filtrosConsulta=_this.montaFiltrosListaRequerimentos(_this.state.filtrosConsulta);}_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta,estadoTabela:novoEstadoTabela,historicoEstadoTabelaPrimeiroNivel:historicoEstadoTabelaPrimeiroNivel}),_this.executaConsultaListaRequerimentos);};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){var _this$state$estadoTab=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;var urlRelatorio='relatorios/simulacao-calculo';var listaEstados=_this.extrairValoresParaPesquisar(false);var parametros={visaoSimulacaoCompensacao:_this.state.filtrosConsulta.visaoSimulacaoCompensacao,'start-position':primeiroItem,'max-results':resultadosPorPagina};var callback=_this.tratarSucesso();if(_this.state.filtrosConsulta.participante){parametros.participante=_this.state.filtrosConsulta.participante;}if(_this.state.filtrosConsulta.participanteObservador){parametros.participanteObservador=_this.state.filtrosConsulta.participanteObservador;}if(listaEstados!==null&&listaEstados.length>0){parametros.estados=listaEstados;}// checkbox marcado
if(_this.state.filtrosConsulta.pesquisarRequerimentosNaoAptos){parametros.pesquisarRequerimentosNaoAptos=_this.state.filtrosConsulta.pesquisarRequerimentosNaoAptos;urlRelatorio=urlRelatorio+'/lista-requerimentos-nao-aptos';callback=_this.tratarSucessoNaoAptos();}_this.setState({urlExportacao:urlRelatorio,parametrosExportacao:parametros,historicoParametrosExportacaoPrimeiroNivel:parametros},function(){return _this.preparaRequest(urlRelatorio,parametros,callback);});}};_this.preparaRequest=function(urlRelatorio,parametros,callback){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["l" /* doPost */])(urlRelatorio,parametros,callback,_this.tratarErro);};_this.realizaConsulta=function(filtrosPesquisa){_this.preparaNovaConsulta(filtrosPesquisa);};_this.realizaConsultaAlterarPagina=function(filtrosPesquisa){var _this$state5=Object.assign({},_this.state),filtrosConsulta=_this$state5.filtrosConsulta;var filtro={};if(filtrosPesquisa){filtro=filtrosPesquisa;}else{filtro=filtrosConsulta;}filtrosConsulta=_this.montaFiltros(filtro);_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta}),_this.executaConsulta);};_this.montaFiltros=function(atributosPesquisa){var atributos=[];var _this$state$estadoTab2=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab2.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;if(atributosPesquisa.participanteObservador){atributos=Object.assign({},atributos,{participanteObservador:atributosPesquisa.participanteObservador});}if(atributosPesquisa.visaoSimulacaoCompensacao){atributos=Object.assign({},atributos,{visaoSimulacaoCompensacao:atributosPesquisa.visaoSimulacaoCompensacao});}if(atributosPesquisa.tipoEntidade){if(atributosPesquisa.tipoEntidade==='01000'){atributos=Object.assign({},atributos,{participante:'01000'});}}if(atributosPesquisa['destinatario-rpps']){atributos=Object.assign({},atributos,{participante:atributosPesquisa['destinatario-rpps']});}else if(atributosPesquisa.participante){atributos=Object.assign({},atributos,{participante:atributosPesquisa.participante});}if(atributosPesquisa.lista&&atributosPesquisa.lista.length>0){atributos=Object.assign({},atributos,{lista:atributosPesquisa.lista});}if(atributosPesquisa.superintendencia){atributos=Object.assign({},atributos,{superintendencia:atributosPesquisa.superintendencia});}if(atributosPesquisa.gex){atributos=Object.assign({},atributos,{gex:atributosPesquisa.gex});}if(atributosPesquisa.aps){atributos=Object.assign({},atributos,{aps:atributosPesquisa.aps});}if(atributosPesquisa.pesquisarRequerimentosNaoAptos){atributos=Object.assign({},atributos,{pesquisarRequerimentosNaoAptos:atributosPesquisa.pesquisarRequerimentosNaoAptos});}atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.trataErrosResponse=function(error){if(error&&error.data){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["L" /* trataMensagensErro */])(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);}};_this.prepararColunasExportacao=function(data,colunas){var dados=data.map(function(item){var linha=Object.assign({},item);colunas.forEach(function(c){var key=Object.keys(item)[c.index];var coluna=item[key];var colunaFormatada=_this.formatarColuna(coluna,c.tipo);linha[key]=colunaFormatada;});return linha;});return dados;};_this.montarColunasCabecalho=function(){var tableHeader=_this.colunasRelatorio.slice();return tableHeader;};_this.pesquisarColunaJson=function(json,coluna){var retorno=json[coluna];if(retorno===undefined){retorno='';}return retorno;};_this.colunasRelatorio=['Solicitante','Destinatário','Valor Estoque','Valor Fluxo Acumulado','Valor Fluxo','Valor Total'];_this.colunasRelatorioRequerimentosNaoAptos=['Solicitante','Destinatário','Protocolo','Cpf','Tipo requerimento','Motivo','Estado'];_this.colunasSimulacaoRequerimentos=['Nome beneficiário','Protocolo','Solicitante','Destinatário','CPF','Matrícula','Estado','Tipo requerimento','Tipo aposentadoria','Número benefício','Regra de cálculo','Valor pro rata mensal','Valor estoque','Valor 13º estoque','Valor total estoque','Valor fluxo','Valor 13º fluxo','Valor total fluxo','Valor fluxo acumulado','Valor 13º fluxo acumulado','Valor total fluxo acumulado','Valor total requerimento','Data inicio fluxo acumulado','Data fim fluxo acumulado','Data inicio estoque','Data fim estoque'];_this.addTipoEstadoLabel=function(tipo){return __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};_this.addTipoProRataInicialLabel=function(tipo){var retorno='';if(tipo&&tipo!==null){retorno=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["U" /* tiposProRataInicial */],tipo).label;}return retorno;};_this.extrairColunasJsonNaoApto=function(data){var objetoLinha={};var dados=data.map(function(item){var objDestinatario=item[Object.keys(item)[5]]+'-'+item[Object.keys(item)[4]];var objSolicitante=item[Object.keys(item)[3]]+'-'+item[Object.keys(item)[2]];objetoLinha={solicitante:objSolicitante,destinatario:objDestinatario,protocolo:_this.pesquisarColunaJson(item,'idProtocolo'),cpf:_this.pesquisarColunaJson(item,'idCpf'),tipoRequerimento:_this.pesquisarColunaJson(item,'tipoRequerimento'),motivoNaoAptidao:_this.pesquisarColunaJson(item,'motivoNaoAptidao'),estado:_this.addTipoEstadoLabel(_this.pesquisarColunaJson(item,'estado'))};return objetoLinha;});return dados;};_this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){var objDestinatario=item[Object.keys(item)[1]]+'-'+item[Object.keys(item)[0]];var objSolicitante=item[Object.keys(item)[3]]+'-'+item[Object.keys(item)[2]];objetoLinha={solicitante:objSolicitante,destinatario:objDestinatario,valorEstoque:_this.pesquisarColunaJson(item,'valorEstoque'),valorFluxoAcumulado:_this.pesquisarColunaJson(item,'valorFluxoAcumulado'),valorFluxo:_this.pesquisarColunaJson(item,'valorFluxo'),valorTotal:_this.pesquisarColunaJson(item,'valorTotal'),visaoSimulacaoCompensacao:_this.state.filtrosConsulta.visaoSimulacaoCompensacao};return objetoLinha;});return dados;};_this.extrairColunasListaRequerimentosJson=function(data){var objetoLinha={};var dados=data.map(function(item){objetoLinha={nomeBeneficiario:_this.pesquisarColunaJson(item,'nomeBeneficiario'),idProtocolo:_this.pesquisarColunaJson(item,'idProtocolo'),solicitante:_this.pesquisarColunaJson(item,'nomeSolicitante')+' - '+_this.pesquisarColunaJson(item,'idSolicitante'),destinatario:_this.pesquisarColunaJson(item,'nomeDestinatario')+' - '+_this.pesquisarColunaJson(item,'idDestinatario'),idCpf:_this.pesquisarColunaJson(item,'idCpf'),matricula:_this.pesquisarColunaJson(item,'matricula'),estado:_this.addTipoEstadoLabel(_this.pesquisarColunaJson(item,'estado')),tipoRequerimento:_this.pesquisarColunaJson(item,'tipoRequerimento'),tipoAposentadoria:_this.pesquisarColunaJson(item,'tipoAposentadoria'),numeroBeneficio:_this.pesquisarColunaJson(item,'numeroBeneficio'),tipoProRataInicial:_this.addTipoProRataInicialLabel(_this.pesquisarColunaJson(item,'tipoProRataInicial')),valorProRataMensal:_this.pesquisarColunaJson(item,'valorProRataMensal'),valorEstoque:_this.pesquisarColunaJson(item,'valorEstoque'),valor13Estoque:_this.pesquisarColunaJson(item,'valor13Estoque'),valorTotalEstoque:_this.pesquisarColunaJson(item,'valorTotalEstoque'),valorFluxo:_this.pesquisarColunaJson(item,'valorFluxo'),valor13Fluxo:_this.pesquisarColunaJson(item,'valor13Fluxo'),valorTotalFluxo:_this.pesquisarColunaJson(item,'valorTotalFluxo'),valorFluxoAcumulado:_this.pesquisarColunaJson(item,'valorFluxoAcumulado'),valor13FluxoAcumuladorFluxo:_this.pesquisarColunaJson(item,'valor13FluxoAcumuladorFluxo'),valorTotalFluxoAcumulado:_this.pesquisarColunaJson(item,'valorTotalFluxoAcumulado'),valorTotalRequerimento:_this.pesquisarColunaJson(item,'valorTotalRequerimento'),dataInicioFluxoAcumulado:_this.pesquisarColunaJson(item,'dataInicioFluxoAcumulado'),dataFimFluxoAcumulado:_this.pesquisarColunaJson(item,'dataFimFluxoAcumulado'),dataInicioEstoque:_this.pesquisarColunaJson(item,'dataInicioEstoque'),dataFimEstoque:_this.pesquisarColunaJson(item,'dataFimEstoque')};return objetoLinha;});return dados;};_this.tratarSucesso=function(){return function(response){var quantidadeTotalResultados=0;var colunasFormatarExportacao=[];var dataFormatOptions={};var _this$state6=Object.assign({},_this.state),estadoTabela=_this$state6.estadoTabela;if(response.headers['content-range']){var _response=Object.assign({},response),headers=_response.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;var estadoTabelaPrimeiroNivel={quantidadeTotalResultados:estadoTabela.quantidadeTotalResultados,resultadosPorPagina:estadoTabela.resultadosPorPagina,paginaAtual:estadoTabela.paginaAtual};if(response.data!==''){var lista=_this.extrairColunasJson(response.data.simulacoes);dataFormatOptions=_this.relatorioDataFormatOptions;colunasFormatarExportacao=_this.listaColunasFormatar;var dadosFormatados=_this.prepararColunasExportacao(lista,colunasFormatarExportacao);var competencia=_this.formatarCompetencia(response.data.mes,response.data.ano);_this.setState({listaResultados:lista,listaResultadosFormatados:dadosFormatados,dataFormatOptions:dataFormatOptions,estadoTabela:estadoTabela,colunasRetorno:_this.colunasRelatorio,dataHistory:[].concat(_toConsumableArray(_this.state.dataHistory),[dadosFormatados]),colunasHistory:[].concat(_toConsumableArray(_this.state.colunasHistory),[_this.colunasRelatorio]),dataFormatHistory:[].concat(_toConsumableArray(_this.state.dataFormatHistory),[dataFormatOptions]),estadoTabelaHistory:[].concat(_toConsumableArray(_this.state.estadoTabelaHistory),[estadoTabelaPrimeiroNivel]),competencia:competencia},_this.montarTitulo(response.data.totalizador,competencia,dadosFormatados,response.data.nivel));}else{_this.setState({colunasRetorno:_this.colunasRelatorio,listaResultados:[],listaResultadosFormatados:[],estadoTabela:estadoTabela,dataFormatOptions:{},dataHistory:[],colunasHistory:[],dataFormatHistory:[],exibirBotaoVoltar:false},_this.montarTitulo('','',[],''));}};};_this.tratarSucessoNaoAptos=function(){return function(response){var quantidadeTotalResultados=0;var _this$state7=Object.assign({},_this.state),estadoTabela=_this$state7.estadoTabela;var colunasFormatarExportacao=[];var dataFormatOptions={};if(response.headers['content-range']){var _response2=Object.assign({},response),headers=_response2.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;if(response.data!==''){var lista=_this.extrairColunasJsonNaoApto(response.data);colunasFormatarExportacao=_this.listaColunasFormatarRequerimentosNaoAptos;var dadosFormatados=_this.prepararColunasExportacao(lista,colunasFormatarExportacao);_this.setState({listaResultadosFormatados:dadosFormatados,estadoTabela:estadoTabela,colunasRetorno:_this.colunasRelatorioRequerimentosNaoAptos,dataFormatOptions:dataFormatOptions},_this.montarTituloNaoAptos(lista));}else{_this.setState({listaResultadosFormatados:[],estadoTabela:estadoTabela,colunasRetorno:_this.colunasRelatorioRequerimentosNaoAptos},_this.montarTitulo([]));}};};_this.tratarFiltroNaLista=function(listaRegistrosFiltrada){_this.setState({listaRegistrosFiltrada:listaRegistrosFiltrada,listaRegistrosIndexadaAtualizada:false});};_this.tratarErro=function(error){if(error){var _error=Object.assign({},error),data=_error.data;var lista=void 0;if(error.status){if(error.data.erros){if(error.data.erros[0]){var codigoErro=error.data.erros[0].codigo;if(codigoErro===1587){lista=[];}}}_this.setState({noContentPrimaryMessage:''+data.mensagem,noContentSecondaryMessage:''+data.descricao,listaRegistrosIndexada:lista});}else{_this.setState({noContentPrimaryMessage:'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',noContentSecondaryMessage:'Tente novamente mais tarde.'});}}};_this.handleChange=function(e,name){_this.setState(Object.assign({},_this.state,_defineProperty({},name,e)));};_this.formatarValorLabel=function(valorCompensacao){var valorFormatado='';if(valorCompensacao){valorFormatado=valorCompensacao.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3});}return valorFormatado;};_this.showDetalhe=function(row){_this.props.history.push('/simulacaocompensacao/detalhe/'+row.idSimulacaoCompensacao);};_this.formatarColuna=function(cell,tipo){var valor=cell;var cellDataPreenchida=cell!==null&&cell!==''&&cell!==undefined;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='moeda'){valor=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).formatToParts(cell).map(function(_ref){var type=_ref.type,value=_ref.value;switch(type){case'currency':return'';default:return value;}}).reduce(function(string,part){return string+part;});}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='nit'){if(Number.isInteger(cell)){valor=cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}else{valor=cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}}else if(tipo==='protocolo'){valor='\''+cell;}else if(tipo==='data'){if(cellDataPreenchida){valor=__WEBPACK_IMPORTED_MODULE_3_moment___default()(cell).format('DD/MM/YYYY');}}return valor.trim();};_this.montaLink=function(){return function(cell,row){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:function onClick(){return _this.preparaNovaConsultaListaRequerimentos(row);}},cell));};};_this.montaColuna=function(tipo){return function(cell){var valor=cell;var cellDataPreenchida=cell!==null&&cell!==''&&cell!==undefined;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='moeda'){valor=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).formatToParts(cell).map(function(_ref2){var type=_ref2.type,value=_ref2.value;switch(type){case'currency':return'';default:return value;}}).reduce(function(string,part){return string+part;});}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='nit'){if(Number.isInteger(cell)){valor=cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}else{valor=cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}}else if(tipo==='data'){if(cellDataPreenchida){valor=__WEBPACK_IMPORTED_MODULE_3_moment___default()(cell).format('DD/MM/YYYY');}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,valor.trim());};};_this.relatorioDataFormatNaoAptosOptions={3:_this.formatarColuna('cpf')};_this.relatorioDataFormatOptions={0:_this.montaLink('solicitante'),1:_this.montaLink('destinatario')};_this.listaRequerimentosDataFormatOptions={4:_this.formatarColuna('cpf'),11:_this.formatarColuna('moeda'),12:_this.formatarColuna('moeda'),13:_this.formatarColuna('moeda'),14:_this.formatarColuna('moeda'),15:_this.formatarColuna('moeda'),16:_this.formatarColuna('moeda'),17:_this.formatarColuna('moeda'),18:_this.formatarColuna('moeda'),19:_this.formatarColuna('moeda'),20:_this.formatarColuna('moeda'),21:_this.formatarColuna('moeda'),22:_this.formatarColuna('data'),23:_this.formatarColuna('data'),24:_this.formatarColuna('data'),25:_this.formatarColuna('data')};_this.listaColunasFormatar=[{index:2,tipo:'moeda'},{index:3,tipo:'moeda'},{index:4,tipo:'moeda'},{index:5,tipo:'moeda'}];_this.listaColunasRequerimentoFormatar=[{index:4,tipo:'cpf'},{index:11,tipo:'moeda'},{index:12,tipo:'moeda'},{index:13,tipo:'moeda'},{index:14,tipo:'moeda'},{index:15,tipo:'moeda'},{index:16,tipo:'moeda'},{index:17,tipo:'moeda'},{index:18,tipo:'moeda'},{index:19,tipo:'moeda'},{index:20,tipo:'moeda'},{index:21,tipo:'moeda'},{index:22,tipo:'data'},{index:23,tipo:'data'},{index:24,tipo:'data'},{index:25,tipo:'data'}];_this.listaColunasFormatarRequerimentosNaoAptos=[{index:3,tipo:'cpf'}];_this.defineContainerStyle=function(){var width=_this.state.colunasRetorno.length*130;if(width<1140){width=1140;}return{width:width+'px'};};_this.addTipoRequerimentoLabel=function(tipo){return __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["M" /* tipoRequerimento */],tipo).label;};_this.addTipoAposentadoriaLabel=function(tipo){var analistaRGPSLogado=__WEBPACK_IMPORTED_MODULE_10__domain_User__["a" /* default */].logged().isRGPS();var lista=null;if(analistaRGPSLogado){lista=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["B" /* tipoAposentadoriaRGPS */];}else{lista=__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["C" /* tipoAposentadoriaRPPS */];}return __WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["n" /* getObject */](lista,tipo).label;};_this.formatarLista=function(lista){var retorno=[];if(lista){lista.forEach(function(item){var aux=item;aux.tipoRequerimento=_this.addTipoRequerimentoLabel(item.tipoRequerimento);aux.tipoAposentadoria=_this.addTipoAposentadoriaLabel(item.tipoAposentadoria);retorno.push(aux);});}return retorno;};_this.tratarSucessoListaRequerimentos=function(){return function(response){var quantidadeTotalResultados=0;var colunasFormatarExportacao=[];var dataFormatOptions={};var _this$state8=Object.assign({},_this.state),estadoTabela=_this$state8.estadoTabela;var _this$state9=Object.assign({},_this.state),estadoTabelaHistory=_this$state9.estadoTabelaHistory;if(response.headers['content-range']){var _response3=Object.assign({},response),headers=_response3.headers;// eslint-disable-next-line
quantidadeTotalResultados=headers['content-range'].split('/')[1];}estadoTabela.quantidadeTotalResultados=quantidadeTotalResultados;var estadoTabelaHistorico=null;if(estadoTabelaHistory.length>0){estadoTabelaHistorico={quantidadeTotalResultados:estadoTabelaHistory[0].quantidadeTotalResultados,resultadosPorPagina:estadoTabelaHistory[0].resultadosPorPagina,paginaAtual:estadoTabela.paginaAtual};_this.setState({estadoTabelaHistory:[].concat(_toConsumableArray(_this.state.estadoTabelaHistory),[estadoTabelaHistorico])});}if(response.data!==''){var lista=_this.extrairColunasListaRequerimentosJson(response.data.requerimentos);colunasFormatarExportacao=_this.listaColunasRequerimentoFormatar;var dadosFormatados=_this.prepararColunasExportacao(lista,colunasFormatarExportacao);_this.setState({listaResultados:lista,listaResultadosFormatados:dadosFormatados,dataFormatOptions:dataFormatOptions,colunasRetorno:_this.colunasSimulacaoRequerimentos,estadoTabela:estadoTabela,colunasHistory:[].concat(_toConsumableArray(_this.state.colunasHistory),[_this.state.colunasRetorno]),exibirBotaoVoltar:true,nivel:response.data.nivel},_this.montarTituloListaRequerimentos(lista));}else{_this.setState({colunasRetorno:_this.colunasSimulacaoRequerimentos,listaResultados:[],listaResultadosFormatados:[],estadoTabela:estadoTabela,exibirBotaoVoltar:true},_this.montarTitulo('','',[],''));}};};_this.extrairCodigoParticipante=function(participante){var retorno=participante;if(participante.indexOf('-')!==-1){var split=participante.split('-')[1];retorno=split;}return retorno;};_this.montaFiltrosListaRequerimentos=function(atributosPesquisa){var atributos=[];var _this$state10=Object.assign({},_this.state),filtrosConsulta=_this$state10.filtrosConsulta;var _this$state11=Object.assign({},_this.state),nivel=_this$state11.nivel;if(atributosPesquisa.visaoSimulacaoCompensacao){atributos=Object.assign({},atributos,{visaoSimulacaoCompensacao:atributosPesquisa.visaoSimulacaoCompensacao});}var atributoParticipante='';if(atributosPesquisa.visaoSimulacaoCompensacao&&atributosPesquisa.visaoSimulacaoCompensacao===1){atributoParticipante=atributosPesquisa.destinatario?atributosPesquisa.destinatario:'';}else{atributoParticipante=atributosPesquisa.solicitante?atributosPesquisa.solicitante:'';}if(nivel!==null&&nivel===2){atributoParticipante=atributosPesquisa.participante;atributos=Object.assign({},atributos,{participante:atributoParticipante});}else{atributos=Object.assign({},atributos,{participante:_this.extrairCodigoParticipante(atributoParticipante)});}if(filtrosConsulta.participanteObservador){atributos=Object.assign({},atributos,{participanteObservador:filtrosConsulta.participanteObservador});}if(filtrosConsulta.lista&&filtrosConsulta.lista.length>0){atributos=Object.assign({},atributos,{lista:filtrosConsulta.lista});}// if (atributosPesquisa.solicitante) {
//   atributos = { ...atributos, solicitante: this.extrairCodigoParticipante(atributosPesquisa.solicitante) };
// }
// if (atributosPesquisa.destinatario) {
//   atributos = { ...atributos, participante: this.extrairCodigoParticipante(atributosPesquisa.destinatario) };
// }
var _this$state$estadoTab3=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab3.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;if(atributosPesquisa.cliqueiNoBotao===1){_this.state.estadoTabela.paginaAtual=1;}if(nivel===null||nivel===1){primeiroItem=0;}atributos=Object.assign({},atributos,{'max-results':resultadosPorPagina});atributos=Object.assign({},atributos,{'start-position':primeiroItem});return atributos;};_this.realizaConsultaListaRequerimentos=function(row){_this.preparaNovaConsultaListaRequerimentos(row);};_this.realizaConsultaListaRequerimentosAlterarPagina=function(row){var filtrosConsulta={};if(row){filtrosConsulta=_this.montaFiltrosListaRequerimentos(row);}else{filtrosConsulta=_this.montaFiltrosListaRequerimentos(_this.state.filtrosConsulta);}_this.setState(Object.assign({},_this.state,{filtrosConsulta:filtrosConsulta}),_this.executaConsultaListaRequerimentos);};_this.executaConsultaListaRequerimentos=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){var _this$state$estadoTab4=Object.assign({},_this.state.estadoTabela),resultadosPorPagina=_this$state$estadoTab4.resultadosPorPagina;var primeiroItem=(_this.state.estadoTabela.paginaAtual-1)*resultadosPorPagina;var _this$state12=Object.assign({},_this.state),nivel=_this$state12.nivel;var urlRelatorio='relatorios/simulacao-calculo/lista-requerimentos';var listaEstados=_this.extrairValoresParaPesquisar(false);if(nivel===null||nivel===1){primeiroItem=0;}var parametros={visaoSimulacaoCompensacao:_this.state.filtrosConsulta.visaoSimulacaoCompensacao,// participante: this.state.filtrosConsulta.participante,
'start-position':primeiroItem,'max-results':resultadosPorPagina};if(_this.state.filtrosConsulta.participante){parametros.participante=_this.state.filtrosConsulta.participante;}if(_this.state.filtrosConsulta.participanteObservador){parametros.participanteObservador=_this.state.filtrosConsulta.participanteObservador;}if(listaEstados!==null&&listaEstados.length>0){parametros.estados=listaEstados;}_this.setState({urlExportacao:urlRelatorio,parametrosExportacao:parametros},function(){return _this.preparaRequest(urlRelatorio,parametros,_this.tratarSucessoListaRequerimentos());});}else{_this.setState({listaRegistrosIndexada:[],listaRegistrosIndexadaAtualizada:true});}};_this.defineListaParaTabela=function(){if(_this.state.listaRegistrosFiltrada!==null){return _this.state.listaRegistrosFiltrada;}return _this.state.listaRegistrosIndexada;};_this.alterarPagina=function(pagina,quantidadeResultadosPorPagina){var _this$state13=Object.assign({},_this.state),estadoTabela=_this$state13.estadoTabela;var _this$state14=Object.assign({},_this.state),nivel=_this$state14.nivel;if(pagina===0){estadoTabela.paginaAtual=1;}else{estadoTabela.paginaAtual=pagina;}if(quantidadeResultadosPorPagina){estadoTabela.resultadosPorPagina=quantidadeResultadosPorPagina;}var callback=_this.realizaConsultaAlterarPagina;if(nivel!==null&&nivel===2){callback=_this.realizaConsultaListaRequerimentosAlterarPagina;}_this.setState(Object.assign({estadoTabela:estadoTabela},_this.state),callback);};_this.exibirComplementoEstadosSelecionados=function(lista,exportacao){var listaPreenchida=lista.length>0;var retorno='';retorno='com os estados: [ '+(listaPreenchida?_this.extrairValoresParaPesquisar(exportacao):TODOS_OS_RESULTADOS)+' ]';return retorno.toUpperCase();};_this.montarTituloListaRequerimentos=function(listaRetorno){var nomeSolicitante='';var nomeDestinatario='';if(listaRetorno&&listaRetorno.length>0){nomeSolicitante=listaRetorno[0].solicitante;nomeDestinatario=listaRetorno[0].destinatario;}var titulo=' - Lista de requerimentos para o solicitante '+nomeSolicitante+' e o destinat\xE1rio '+nomeDestinatario;_this.setState({nomeRelatorio:'Simula\xE7\xE3o de Compensa\xE7\xE3o'+titulo,nomeRelatorioExportacao:'Simula\xE7\xE3o de Compensa\xE7\xE3o'+titulo});};_this.montarTituloNaoAptos=function(listaRetorno){var retornoTituloSemDescricaoEstado='';var retornoTituloComDescricaoEstado='';var complementoEstadosSemDescricao='';var complementoEstadosComDescricao='';var _this$state15=Object.assign({},_this.state),filtrosConsulta=_this$state15.filtrosConsulta;var titulo=' - Requerimentos que não foram aptos para realizar a simulação';retornoTituloSemDescricaoEstado=titulo;retornoTituloComDescricaoEstado=titulo;if(filtrosConsulta.lista&&filtrosConsulta.lista.length>0){complementoEstadosSemDescricao=''+_this.exibirComplementoEstadosSelecionados(filtrosConsulta.lista,false);complementoEstadosComDescricao=''+_this.exibirComplementoEstadosSelecionados(filtrosConsulta.lista,true);}if(listaRetorno&&listaRetorno.length>0){retornoTituloComDescricaoEstado=retornoTituloSemDescricaoEstado;if(complementoEstadosSemDescricao!==''){retornoTituloSemDescricaoEstado=retornoTituloSemDescricaoEstado+' '+complementoEstadosSemDescricao;}if(complementoEstadosComDescricao!==''){retornoTituloComDescricaoEstado=retornoTituloComDescricaoEstado+' '+complementoEstadosComDescricao;}}_this.setState({nomeRelatorio:'Simula\xE7\xE3o de Compensa\xE7\xE3o'+retornoTituloSemDescricaoEstado,nomeRelatorioExportacao:'Simula\xE7\xE3o de Compensa\xE7\xE3o'+retornoTituloComDescricaoEstado});};_this.montarTitulo=function(totalizador,competencia,listaRetorno,nivel){var retornoTituloSemDescricaoEstado='';var retornoTituloComDescricaoEstado='';var paramComplementoTitulo='';var complementoEstadosSemDescricao='';var complementoEstadosComDescricao='';var _this$props=Object.assign({},_this.props),complementoTitulo=_this$props.complementoTitulo;var _this$state16=Object.assign({},_this.state),filtrosConsulta=_this$state16.filtrosConsulta;if(complementoTitulo!==null){paramComplementoTitulo=JSON.parse(complementoTitulo);if(paramComplementoTitulo.complementoTitulo&&paramComplementoTitulo.complementoTitulo!==''){retornoTituloSemDescricaoEstado=' - '+paramComplementoTitulo.complementoTitulo;retornoTituloComDescricaoEstado=' - '+paramComplementoTitulo.complementoTitulo;}}if(filtrosConsulta.lista&&filtrosConsulta.lista.length>0){complementoEstadosSemDescricao=''+_this.exibirComplementoEstadosSelecionados(filtrosConsulta.lista,false);complementoEstadosComDescricao=''+_this.exibirComplementoEstadosSelecionados(filtrosConsulta.lista,true);}if(listaRetorno&&listaRetorno.length>0){retornoTituloSemDescricaoEstado=retornoTituloSemDescricaoEstado+' \xE9 de R$ '+totalizador.toLocaleString('pt-BR',{minimumFractionDigits:2,maximumFractionDigits:3});retornoTituloSemDescricaoEstado=retornoTituloSemDescricaoEstado+' na compet\xEAncia '+(competencia!==null?competencia:_this.state.competencia);retornoTituloComDescricaoEstado=retornoTituloSemDescricaoEstado;if(complementoEstadosSemDescricao!==''){retornoTituloSemDescricaoEstado=retornoTituloSemDescricaoEstado+' '+complementoEstadosSemDescricao;}if(complementoEstadosComDescricao!==''){retornoTituloComDescricaoEstado=retornoTituloComDescricaoEstado+' '+complementoEstadosComDescricao;}}if(nivel===1){_this.setState({nomeRelatorioHistory:[].concat(_toConsumableArray(_this.state.nomeRelatorioHistory),['Simula\xE7\xE3o de Compensa\xE7\xE3o'+retornoTituloSemDescricaoEstado]),nomeRelatorioExportacaoHistory:[].concat(_toConsumableArray(_this.state.nomeRelatorioExportacaoHistory),['Simula\xE7\xE3o de Compensa\xE7\xE3o'+retornoTituloSemDescricaoEstado])});}_this.setState({nomeRelatorio:'Simula\xE7\xE3o de Compensa\xE7\xE3o'+retornoTituloSemDescricaoEstado,nomeRelatorioExportacao:'Simula\xE7\xE3o de Compensa\xE7\xE3o'+retornoTituloComDescricaoEstado});};_this.formatarCompetencia=function(mes,ano){var objCompetencia=null+'/'+null;if(mes!=='0'&&ano!=='0'){objCompetencia=mes+'/'+ano;if(objCompetencia.length!==7){objCompetencia='0'+objCompetencia;}}return objCompetencia;};_this.handleVoltar=function(){var _this$state17=Object.assign({},_this.state),historicoPrimeiroNivel=_this$state17.historicoPrimeiroNivel,historicoEstadoTabelaPrimeiroNivel=_this$state17.historicoEstadoTabelaPrimeiroNivel,historicoParametrosExportacaoPrimeiroNivel=_this$state17.historicoParametrosExportacaoPrimeiroNivel;var _this$state18=Object.assign({},_this.state),nivel=_this$state18.nivel;var historicoDados=_this.state.dataHistory.pop();var historicoColunas=_this.state.colunasHistory.pop();var historicoNomeRelatorio=_this.state.nomeRelatorioHistory.pop();var historicoNomeRelatorioExportacao=_this.state.nomeRelatorioExportacaoHistory.pop();var historicoDataFormatOptions=_this.relatorioDataFormatOptions;var historicoEstadoTabela=_this.state.estadoTabelaHistory.pop();if(historicoPrimeiroNivel&&historicoPrimeiroNivel.length===0){_this.setState({historicoPrimeiroNivel:historicoDados});}var estadoTabelaAtual=historicoEstadoTabela;if(historicoEstadoTabelaPrimeiroNivel&&historicoEstadoTabelaPrimeiroNivel.length===0){_this.setState({historicoEstadoTabelaPrimeiroNivel:historicoEstadoTabela});}else if(historicoEstadoTabelaPrimeiroNivel&&historicoEstadoTabelaPrimeiroNivel.length!==0){estadoTabelaAtual=historicoEstadoTabelaPrimeiroNivel;_this.setState({historicoEstadoTabelaPrimeiroNivel:historicoEstadoTabela});}_this.setState({urlExportacao:'relatorios/simulacao-calculo',parametrosExportacao:historicoParametrosExportacaoPrimeiroNivel,listaResultadosFormatados:historicoDados&&historicoDados.length===0?historicoPrimeiroNivel:historicoDados,colunasRetorno:historicoColunas===undefined||nivel===2?_this.colunasRelatorio:historicoColunas,nomeRelatorio:historicoNomeRelatorio,nomeRelatorioExportacao:historicoNomeRelatorioExportacao,dataFormatOptions:historicoDataFormatOptions,exibirBotaoVoltar:false,dataHistory:[].concat(_toConsumableArray(_this.state.dataHistory),[historicoPrimeiroNivel]),estadoTabelaHistory:[].concat(_toConsumableArray(_this.state.estadoTabelaHistory),[historicoEstadoTabelaPrimeiroNivel]),nomeRelatorioHistory:[].concat(_toConsumableArray(_this.state.nomeRelatorioHistory),[historicoNomeRelatorio]),// estadoTabela: historicoEstadoTabela,
estadoTabela:estadoTabelaAtual,nivel:1});};_this.verificarSeListaConsultaPreenchida=function(limpar){if(limpar){_this.setState({listaResultadosFormatados:[],nomeRelatorio:''});}};_this.state={acao:null,listaRegistrosFiltrada:null,listaRegistrosIndexada:[],listaRegistrosExportacao:[],listaResultadosFormatados:[],historicoPrimeiroNivel:[],historicoEstadoTabelaPrimeiroNivel:[],historicoParametrosExportacaoPrimeiroNivel:null,registroVindoDoRequest:null,showNoContent:false,rowSelecionada:null,listaRegistrosIndexadaAtualizada:false,estadoTabela:{quantidadeTotalResultados:0,resultadosPorPagina:10,paginaAtual:1},filtrosPesquisa:{},dataFormatOptions:{},exibirDetalhamento:false,colunasRetorno:_this.colunasRelatorio,urlExportacao:null,parametrosExportacao:null,nomeRelatorio:'',nomeRelatorioExportacao:'',exibirBotaoVoltar:false,papelUsuarioLogado:null,estadosSimulacaoCompensacaoObservador:[],competencia:null,nivel:null,dataHistory:[],nomeRelatorioHistory:[],nomeRelatorioExportacaoHistory:[],colunasHistory:[],dataFormatHistory:[],estadoTabelaHistory:[]};return _this;}_createClass(ConsultaSimulacaoCompensacao,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_8__utils_helpers__["g" /* manterApenasFiltro */])('filtroSimulacaoCompensacao');if(this.props.destinatarios.length===0){Object(__WEBPACK_IMPORTED_MODULE_5__utils_requests__["a" /* buscaDestinatarios */])(this.tratarErro);}// if (this.props.estadosSimulacaoCompensacao.length === 0) {
//   this.recuperarEstadosSimulacaoCompensacao(this.tratarErro);
// }
this.definePapelFiltro();}// filtro escolhido na tela
/**
   * Trata filtros na lista que veio do servidor (Componente FiltroPagamentos)
   */// FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
// Lista de requerimentos trazida quando o link do destinatario ou do solicitante é clicado
// alterarResultadosPorPagina = (resultadosPorPagina) => {
//   const { estadoTabela } = { ...this.state };
//   estadoTabela.resultadosPorPagina = resultadosPorPagina;
//   this.setState({
//     estadoTabela,
//     ...this.state,
//   }, this.realizaConsulta());
// }
},{key:'render',value:function render(){var options={noDataText:'Nenhum resultado a ser exibido.',hideSizePerPage:false,onPageChange:this.alterarPagina,page:this.state.estadoTabela.paginaAtual,sizePerPage:this.state.estadoTabela.resultadosPorPagina,sizePerPageList:__WEBPACK_IMPORTED_MODULE_6__utils_listsSelect__["o" /* linhasPorPagina */]};var fetchInfo={dataTotalSize:this.state.estadoTabela.quantidadeTotalResultados};return this.state.showNoContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["x" /* DtpNoContent */],{primarylabel:this.state.noContentPrimaryMessage,secondarylabel:this.state.noContentSecondaryMessage,show:this.state.showNoContent}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FiltroSimulacaoCompensacao__["a" /* default */]// handleSearchFilter={this.realizaConsulta}
,{handleSearchFilter:this.preparaNovaConsulta,handleChangeList:this.tratarFiltroNaLista,list:this.state.listaRegistrosIndexada,listaRegistrosIndexadaAtualizada:this.state.listaRegistrosIndexadaAtualizada,destinatarios:this.props.destinatarios,estadosSimulacaoCompensacao:this.props.estadosSimulacaoCompensacao,estadosSimulacaoCompensacaoObservador:this.state.estadosSimulacaoCompensacaoObservador,papelUsuarioLogado:this.state.papelUsuarioLogado,recuperarCnpjParticipanteComoObservador:this.recuperarCnpjParticipanteComoObservador,verificarSeListaConsultaPreenchida:this.verificarSeListaConsultaPreenchida}),this.state.nomeRelatorio!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SimulacaoCompensacao__["a" /* default */],{legend:this.state.nomeRelatorio,legendExportacao:this.state.nomeRelatorioExportacao,bordered:true,headers:this.state.colunasRetorno,data:this.state.listaResultadosFormatados,options:options,pagination:true,remote:true,dataFormatOptions:this.state.dataFormatOptions,landscape:true,containerStyle:this.defineContainerStyle(),fetchInfo:fetchInfo,rowAtual:this.state.rowAtual,urlExportacao:this.state.urlExportacao,parametrosExportacao:this.state.parametrosExportacao,voltarAction:this.handleVoltar,exibirBotaoVoltar:this.state.exibirBotaoVoltar}));}}]);return ConsultaSimulacaoCompensacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaSimulacaoCompensacao.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,auth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({userData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,checkPermission:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}).isRequired,destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),estadosSimulacaoCompensacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}))};ConsultaSimulacaoCompensacao.defaultProps={destinatarios:[],estadosSimulacaoCompensacao:[]};var mapStateToProps=function mapStateToProps(state){return{destinatarios:state.base.destinatarios,complementoTitulo:state.base.complementoTitulo,estadosSimulacaoCompensacao:state.base.estadosSimulacaoCompensacao};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ConsultaSimulacaoCompensacao));

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelecaoEntidade__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VAZIO='';var participanteRGPS='01000';var rowStyle={width:'2px',paddingRigth:'10px'};var spanStyle={margin:'0px',position:'relative',color:'#44707B',top:'25px',padding:'5px'};var FiltroSimulacaoCompensacao=function(_Component){_inherits(FiltroSimulacaoCompensacao,_Component);function FiltroSimulacaoCompensacao(){_classCallCheck(this,FiltroSimulacaoCompensacao);var _this=_possibleConstructorReturn(this,(FiltroSimulacaoCompensacao.__proto__||Object.getPrototypeOf(FiltroSimulacaoCompensacao)).call(this));_this.preparaNovaConsulta=function(){var filtroSimulacaoCompensacao={visaoSimulacaoCompensacao:null,estadoCompensacao:null,'destinatario-rpps':null,tipoEntidade:null,uf:null,lista:[],pesquisarRequerimentosNaoAptos:false};filtroSimulacaoCompensacao=JSON.stringify(filtroSimulacaoCompensacao);sessionStorage.setItem('filtroSimulacaoCompensacao',filtroSimulacaoCompensacao);_this.setState({visaoSimulacaoCompensacao:null,estadoCompensacao:null,'destinatario-rpps':null,tipoEntidade:null,uf:null,lista:[],pesquisarRequerimentosNaoAptos:false});};_this.filtrarRegimes=function(){var retorno=_this.state.listaTiposRegimes;if(_this.props.papelUsuarioLogado==='analista-rgps'||_this.state.tipoRegimeObservador===1&&Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)){retorno=_this.state.listaTiposRegimes.filter(function(item){return item.label!=='RGPS';});}if(_this.props.papelUsuarioLogado!=='analista-rgps'||_this.state.tipoRegimeObservador===2&&Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(_this.props.papelUsuarioLogado)){retorno=__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["L" /* tipoRegime */];}_this.setState({listaTiposRegimes:retorno});};_this.handleChange=function(changeObj,name){if(name==='visaoSimulacaoCompensacao'){_this.setState({complementoTitulo:_this.montaComplementoTitulo(changeObj.value)});}if(name==='tipoRegimeObservador'){if(changeObj.value===1){_this.setState({participanteObservador:participanteRGPS});}_this.setState({tipoRegimeObservador:changeObj.value},_this.filtrarRegimes);}if(name==='participanteObservador'){_this.props.recuperarCnpjParticipanteComoObservador(changeObj.value);}_this.setState(_defineProperty({},name,changeObj.value),function(){return _this.trataFormulario(name);});};_this.handleKeyDown=function(e){var retorno=null;if(e.keyCode===13){retorno=_this.handleSearchButton();}return retorno;};_this.trataFormulario=function(campoAlterado){if(campoAlterado==='tipoEntidade'){_this.trataTipoEntidade();}if(campoAlterado==='uf'){_this.trataUf();}if(campoAlterado==='visaoSimulacaoCompensacao'){var complementoTitulo={complementoTitulo:_this.state.complementoTitulo};complementoTitulo=JSON.stringify(complementoTitulo);Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["B" /* requestSalvaComplementoTitulo */])(complementoTitulo);}};_this.trataUf=function(){_this.setState({'destinatario-rpps':null,exibirCampoNome:true});};_this.trataTipoEntidade=function(){var paramTipoEntidade=_this.state.tipoEntidade;_this.setState({'destinatario-rpps':null,uf:null,exibirCampoNome:paramTipoEntidade===1||paramTipoEntidade===3});};_this.handleSearchButton=function(){var filtroSimulacaoCompensacao={};if(_this.state.tipoEntidade===participanteRGPS){filtroSimulacaoCompensacao={visaoSimulacaoCompensacao:_this.state.visaoSimulacaoCompensacao,estadoCompensacao:_this.state.estadoCompensacao,lista:_this.state.lista,'destinatario-rpps':participanteRGPS,tipoEntidade:1,pesquisarRequerimentosNaoAptos:_this.state.pesquisarRequerimentosNaoAptos};}else{filtroSimulacaoCompensacao={visaoSimulacaoCompensacao:_this.state.visaoSimulacaoCompensacao,estadoCompensacao:_this.state.estadoCompensacao,'destinatario-rpps':_this.state['destinatario-rpps'],tipoEntidade:_this.state.tipoEntidade,uf:_this.state.uf,lista:_this.state.lista,tipoRegimeObservador:_this.state.tipoRegimeObservador,tipoEntidadeObservador:_this.state.tipoEntidadeObservador,uFObservador:_this.state.uFObservador,participanteObservador:_this.state.participanteObservador,pesquisarRequerimentosNaoAptos:_this.state.pesquisarRequerimentosNaoAptos};}_this.setState({cliqueiNoBotao:1},function(){_this.handleChange({value:1,isValid:true},'cliqueiNoBotao');});filtroSimulacaoCompensacao=JSON.stringify(filtroSimulacaoCompensacao);sessionStorage.setItem('filtroSimulacaoCompensacao',filtroSimulacaoCompensacao);_this.handleSearch();};_this.handleKeyUp=function(e){var retorno=e.target.value;retorno=_this.formatarValorMonetario(retorno);e.target.value=retorno;return retorno;};_this.handleLimparFiltro=function(){_this.setState({visaoSimulacaoCompensacao:null,estadoCompensacao:null,'destinatario-rpps':null,tipoEntidade:null,uf:null,lista:[],tipoRegimeObservador:null,tipoEntidadeObservador:null,uFObservador:null,participanteObservador:null,pesquisarRequerimentosNaoAptos:false,valorComboSelecaoMultipla:null,exibirCampoNome:false,limparFiltro:true},_this.props.verificarSeListaConsultaPreenchida(true));if(sessionStorage.getItem('filtroSimulacaoCompensacao')){sessionStorage.removeItem('filtroSimulacaoCompensacao');}if(document.getElementById('naoAptos').checked===true){document.getElementById('naoAptos').checked=false;document.getElementById('naoAptos').click();}};_this.handleSearch=function(){// visao é obrigatório
if(_this.state.visaoSimulacaoCompensacao){if(_this.state.tipoEntidade){if(_this.state.tipoEntidade===2&&!_this.state.uf&&!_this.state['destinatario-rpps']){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(['Escolha uma UF']);return;}_this.props.handleSearchFilter(_this.state);}else{_this.props.handleSearchFilter(_this.state);}}else{Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(['É necessario informar a visão.']);}};_this.listaFiltradaDestinatarios=function(){var listaOrgaosFederais=[];var listaParticipantes=_this.props.destinatarios.filter(function(item){// if (item.inOrgaoCentralizador === 1) {
//   listaOrgaosFederais.push(item);
// } else if (!(item.inOrgaoExtinto) &&
//   ((item.tipoRegimeProprio === this.state.tipoEntidade && ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)))) {
//   return item;
// }
// return null;
if(item.inOrgaoUniao&&(!item.inOrgaoExtinto&&item.inOrgaoCentralizador===1||!item.inOrgaoExtinto&&item.inOrgaoCentralizador===0)){listaOrgaosFederais.push(item);}else if(!item.inOrgaoExtinto&&item.tipoRegimeProprio===_this.state.tipoEntidade&&(item.uf&&_this.state.tipoEntidade===2?item.uf===_this.state.uf:true)){return item;}return null;});if(listaOrgaosFederais.length>0&&_this.state.tipoEntidade===1){listaParticipantes=listaOrgaosFederais;}return listaParticipantes;};_this.carregaUfDosMunicipios=function(){var listaUf=[];_this.props.destinatarios.forEach(function(item){if(item.uf&&!listaUf.find(function(itemLista){return itemLista.value===item.uf;})){listaUf.push({label:item.uf,value:item.uf});}});listaUf.sort(function(a,b){if(a.value>b.value){return 1;}if(a.value<b.value){return-1;}return 0;});return listaUf;};_this.montaComplementoTitulo=function(visao){var complemento='';if(visao&&visao!==''&&visao!==undefined){if(visao===1){complemento='Previsão de Valores a Receber';}else{complemento='Previsão de Valores a Pagar';}}return complemento;};_this.formularioProntoParaEnvio=function(){var _this$state=Object.assign({},_this.state),visaoSimulacaoCompensacao=_this$state.visaoSimulacaoCompensacao;var retorno=false;if(visaoSimulacaoCompensacao!==null&&visaoSimulacaoCompensacao!==VAZIO){retorno=true;}return retorno;};_this.verificarSeAlgumCampoPreenchido=function(){var _this$state2=Object.assign({},_this.state),visaoSimulacaoCompensacao=_this$state2.visaoSimulacaoCompensacao,tipoEntidade=_this$state2.tipoEntidade,uf=_this$state2.uf,pesquisarRequerimentosNaoAptos=_this$state2.pesquisarRequerimentosNaoAptos,valorComboSelecaoMultipla=_this$state2.valorComboSelecaoMultipla,lista=_this$state2.lista;var retorno=true;var visaoSimulacaoCompensacaoSelecionado=visaoSimulacaoCompensacao!==null&&visaoSimulacaoCompensacao!==VAZIO&&visaoSimulacaoCompensacao!==undefined;if(visaoSimulacaoCompensacaoSelecionado){retorno=false;}if(tipoEntidade!==null&&tipoEntidade!==VAZIO){retorno=false;}if(uf!==null&&uf!==VAZIO){retorno=false;}if(pesquisarRequerimentosNaoAptos===true){retorno=false;}var valorComboSelecaoMultiplaSelecionado=valorComboSelecaoMultipla!==null&&valorComboSelecaoMultipla!==VAZIO&&valorComboSelecaoMultipla!==undefined;if(valorComboSelecaoMultiplaSelecionado){retorno=false;}if(lista!==null&&lista.length>0){retorno=false;}return retorno;};_this.filtroSimulacaoCompensacao=JSON.parse(sessionStorage.getItem('filtroSimulacaoCompensacao'));_this.state={visaoSimulacaoCompensacao:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.visaoSimulacaoCompensacao?_this.filtroSimulacaoCompensacao.visaoSimulacaoCompensacao:null,estadoCompensacao:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.estadoCompensacao?_this.filtroSimulacaoCompensacao.estadoCompensacao:null,participanteLogado:_this.participanteLogado&&_this.filtroSimulacaoCompensacao.participanteLogado?_this.filtroSimulacaoCompensacao.participanteLogado:null,'destinatario-rpps':_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao['destinatario-rpps']?_this.filtroSimulacaoCompensacao['destinatario-rpps']:null,cliqueiNoBotao:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.cliqueiNoBotao?_this.filtroSimulacaoCompensacao.cliqueiNoBotao:null,tipoEntidade:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.tipoEntidade?_this.filtroSimulacaoCompensacao.tipoEntidade:null,uf:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.uf?_this.filtroSimulacaoCompensacao.uf:null,exibirCampoNome:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.exibirCampoNome?_this.filtroSimulacaoCompensacao.exibirCampoNome:false,complementoTitulo:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.complementoTitulo?_this.filtroSimulacaoCompensacao.complementoTitulo:'',validadeCampos:{visaoSimulacaoCompensacao:false},lista:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.lista?_this.filtroSimulacaoCompensacao.lista:[],configComponenteSelecaoMultipla:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.configComponenteSelecaoMultipla?_this.filtroSimulacaoCompensacao.configComponenteSelecaoMultipla:null,configuracao:{origem:'filtroSimulacaoCompensacao',labelCombobox:'Estado para simulação de compensação',titulo:'',exibirBotaoIncluir:true,exibirTabelaItens:true,retirarLinhaSeparadora:true,exibirComboBox:true},tipoRegimeObservador:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.tipoRegimeObservador?_this.filtroSimulacaoCompensacao.tipoRegimeObservador:null,tipoEntidadeObservador:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.tipoEntidadeObservador?_this.filtroSimulacaoCompensacao.tipoEntidadeObservador:null,uFObservador:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.uFObservador?_this.filtroSimulacaoCompensacao.uFObservador:null,participanteObservador:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.participanteObservador?_this.filtroSimulacaoCompensacao.participanteObservador:null,listaTiposRegimes:[],listaTiposRegimesOutrosPapeis:[],pesquisarRequerimentosNaoAptos:_this.filtroSimulacaoCompensacao&&_this.filtroSimulacaoCompensacao.pesquisarRequerimentosNaoAptos?_this.filtroSimulacaoCompensacao.pesquisarRequerimentosNaoAptos:false,limparFiltro:false};return _this;}_createClass(FiltroSimulacaoCompensacao,[{key:'componentDidMount',value:function componentDidMount(){// if (sessionStorage.getItem('filtroSimulacaoCompensacao')) {
//   this.handleSearchButton();
// }
sessionStorage.removeItem('filtroSimulacaoCompensacao');Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["p" /* requestApagaComplementoTitulo */])();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.tipoConsulta!==prevProps.tipoConsulta){this.preparaNovaConsulta();}}/**
   * Encaminha para as funcoes que tratam alteracoes em cada campo
   */// verificarSeListaConsultaPreenchida = () => {
//   this.props.handleSearchFilter(this.state);
// }
},{key:'montaFiltros',value:function montaFiltros(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["c" /* ehPapelObservadorRelatorio */])(this.props.papelUsuarioLogado)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SelecaoEntidade__["a" /* default */],{handleChange:this.handleChange,destinatarios:this.props.destinatarios,papelUsuarioLogado:this.props.papelUsuarioLogado,titulo:'Visualizar como',retirarLinhaSeparadora:false,tipoRegime:this.state.tipoRegimeObservador,tipoEntidade:this.state.tipoEntidadeObservador,uf:this.state.uFObservador,participante:this.state.participanteObservador,nomeAtributoComboboxRegime:'tipoRegimeObservador',nomeAtributoComboboxParticipante:'participanteObservador',nomeAtributoComboboxTipoEntidade:'tipoEntidadeObservador',nomeAtributoComboboxUF:'uFObservador',listaTiposRegimes:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["L" /* tipoRegime */],labelComboboxParticipante:'Participante Observador'}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Vis\xE3o',required:true,onChange:function onChange(e){return _this2.handleChange(e,'visaoSimulacaoCompensacao');},value:this.state.visaoSimulacaoCompensacao,itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["Z" /* visoesSimulacaoCompensacao */],placeholder:'Selecione a Vis\xE3o',number:true,custom:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Tipo de Entidade',onChange:function onChange(e){return _this2.handleChange(e,'tipoEntidade');},placeholder:'Selecione a Entidade',value:this.state.tipoEntidade,itemList:__WEBPACK_IMPORTED_MODULE_5__utils_listsSelect__["I" /* tipoEntidadeSimulacaoCompensacao */],custom:true,number:true})),this.state.tipoEntidade===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'UF',onChange:function onChange(e){return _this2.handleChange(e,'uf');},placeholder:'Selecione a UF',value:this.state.uf,itemList:this.carregaUfDosMunicipios(),custom:true})):'',this.state.exibirCampoNome?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'4 4 4 4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:this.state.visaoSimulacaoCompensacao===1?'Nome do Destinatário':'Nome do Solicitante',name:'destinatario-rpps',onChange:function onChange(e){return _this2.handleChange(e,'destinatario-rpps');},placeholder:this.state.visaoSimulacaoCompensacao===1?'Selecione o Destinatário':'Selecione o Solicitante',value:this.state['destinatario-rpps'],itemList:this.listaFiltradaDestinatarios(),custom:true})):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'1 1 1 1',style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{id:'naoAptos',onChange:function onChange(e){return _this2.handleChange(e,'pesquisarRequerimentosNaoAptos');},check:true,value:this.state.pesquisarRequerimentosNaoAptos}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:spanStyle},'Requerimentos que n\xE3o foram aptos para realizar a simula\xE7\xE3o.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["q" /* SelecaoMultipla */],{handleChange:this.handleChange,configuracao:this.state.configuracao,estado:this.state.estado,hint:'Estado para simula\xE7\xE3o de compensa\xE7\xE3o',listaEstadosComSelecaoMultipla:[],lista:this.state.lista,valorComboSelecaoMultipla:this.state.valorComboSelecaoMultipla})));}},{key:'render',value:function render(){var _this3=this;var filtrosPesquisa=this.montaFiltros();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'pesquisa',panelId:'filtro-pesquisa',icon:'ico-filter',title:'simula\xE7\xE3o de compensa\xE7\xE3o'},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{disabled:!this.formularioProntoParaEnvio(),className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this3.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */]// disabled={this.verificarSeAlgumCampoPreenchido()}
,{className:'right',title:'limpar',onClick:function onClick(){return _this3.handleLimparFiltro();},hint:'limpar o filtro aplicado'}))));}}]);return FiltroSimulacaoCompensacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroSimulacaoCompensacao.propTypes={destinatarios:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf().isRequired,handleChangeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,estadosSimulacaoCompensacao:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf().isRequired,estadosSimulacaoCompensacaoObservador:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf().isRequired,papelUsuarioLogado:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,recuperarCnpjParticipanteComoObservador:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,verificarSeListaConsultaPreenchida:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroSimulacaoCompensacao);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_export_to_csv__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_export_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_export_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimulacaoCompensacao=function(_Component){_inherits(SimulacaoCompensacao,_Component);function SimulacaoCompensacao(props){_classCallCheck(this,SimulacaoCompensacao);var _this=_possibleConstructorReturn(this,(SimulacaoCompensacao.__proto__||Object.getPrototypeOf(SimulacaoCompensacao)).call(this,props));_initialiseProps.call(_this);_this.state={showNoContent:false,noContentPrimaryMessage:null,noContentSecondaryMessage:null,legendaRelatorio:null};return _this;}// FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
// tratarSucessoListaExportacao = () => {
//   if (this.props.data && this.props.data.length > 0) {
//     this.setState({
//     }, this.gerarCsv(this.props.data));
//   }
// };
_createClass(SimulacaoCompensacao,[{key:'render',value:function render(){var _this2=this;if(this.state.showNoContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["x" /* DtpNoContent */],{primaryText:this.state.noContentPrimaryMessage,secondaryText:this.state.noContentSecondaryMessage,show:this.state.showNoContent});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.nomeRelatorio!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.data&&this.props.data.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{hint:'Exportar para CSV',onClick:function onClick(){_this2.exportarCsv(_this2.props);},icon:'ico-doc-sheet',mini:true}),this.props.exibirBotaoVoltar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* Button */],{hint:'Voltar',icon:'ico-arrow-curve-left',mini:true,onClick:function onClick(){return _this2.props.voltarAction();}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.exibirBotaoVoltar?'relatorio':'',style:{'--relatorioWidth':this.props.containerStyle.width}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["H" /* DtpTable */],this.props,this.props.headers.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_dtp_react_components__["I" /* DtpTableHeader */],{key:item,dataField:_this2.props.data[0]?Object.keys(_this2.props.data[0])[i]:'default',dataAlign:'center',isKey:i===0,header:item,tdStyle:{wordBreak:'break-word'},dataFormat:_this2.props.dataFormatOptions[i],hidden:_this2.props.options.hidden&&_this2.props.options.hidden.includes(i)});})))):null);}}]);return SimulacaoCompensacao;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.gerarCsv=function(lista){if(lista&&lista!==undefined&&lista.length>0){var csvExporter=new __WEBPACK_IMPORTED_MODULE_4_export_to_csv__["ExportToCsv"]({filename:'relatorio',fieldSeparator:';',showTitle:true,title:_this3.state.legendaRelatorio,showLabels:true,headers:_this3.props.headers});csvExporter.generateCsv(lista);}};this.formatarColuna=function(cell,tipo){var valor=cell;var cellDataPreenchida=cell!==null&&cell!==''&&cell!==undefined;if(tipo==='numero'){valor=new Intl.NumberFormat('pt-BR').format(cell);}else if(tipo==='moeda'){valor=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).formatToParts(cell).map(function(_ref){var type=_ref.type,value=_ref.value;switch(type){case'currency':return'';default:return value;}}).reduce(function(string,part){return string+part;});}else if(tipo==='cpf'){valor=cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,'$1.$2.$3-$4');}else if(tipo==='cnpj'){valor=cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,'$1.$2.$3/$4-$5');}else if(tipo==='nit'){if(Number.isInteger(cell)){valor=cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}else{valor=cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g,'$1.$2.$3.$4-$5');}}else if(tipo==='protocolo'){valor='\''+cell;}else if(cellDataPreenchida){if(cell!==null&&cell!==undefined){valor=__WEBPACK_IMPORTED_MODULE_2_moment___default()(cell).format('DD/MM/YYYY');}}return valor.trim();};this.prepararColunasExportacao=function(data,colunas){var dados=data.map(function(item){var linha=Object.assign({},item);colunas.forEach(function(c){var key=Object.keys(item)[c.index];var coluna=item[key];var colunaFormatada=_this3.formatarColuna(coluna,c.tipo);linha[key]=colunaFormatada;});return linha;});return dados;};this.pesquisarColunaJson=function(json,coluna){var retorno=json[coluna];if(retorno===undefined){retorno='';}return retorno;};this.listaColunasFormatar=[{index:2,tipo:'moeda'},{index:3,tipo:'moeda'},{index:4,tipo:'moeda'},{index:5,tipo:'moeda'}];this.listaColunasRequerimentoFormatar=[{index:1,tipo:'protocolo'},{index:4,tipo:'cpf'},{index:11,tipo:'moeda'},{index:12,tipo:'moeda'},{index:13,tipo:'moeda'},{index:14,tipo:'moeda'},{index:15,tipo:'moeda'},{index:16,tipo:'moeda'},{index:17,tipo:'moeda'},{index:18,tipo:'moeda'},{index:19,tipo:'moeda'},{index:20,tipo:'moeda'},{index:21,tipo:'moeda'},{index:22,tipo:'data'},{index:23,tipo:'data'},{index:24,tipo:'data'},{index:25,tipo:'data'}];this.listaColunasRequerimentoNaoAptoFormatar=[{index:2,tipo:'protocolo'},{index:3,tipo:'cpf'}];this.extrairColunasJson=function(data){var objetoLinha={};var dados=data.map(function(item){var objDestinatario=item[Object.keys(item)[1]]+'-'+item[Object.keys(item)[0]];var objSolicitante=item[Object.keys(item)[3]]+'-'+item[Object.keys(item)[2]];objetoLinha={solicitante:objSolicitante,destinatario:objDestinatario,valorEstoque:_this3.pesquisarColunaJson(item,'valorEstoque'),valorFluxoAcumulado:_this3.pesquisarColunaJson(item,'valorFluxoAcumulado'),valorFluxo:_this3.pesquisarColunaJson(item,'valorFluxo'),valorTotal:_this3.pesquisarColunaJson(item,'valorTotal')};return objetoLinha;});return dados;};this.extrairColunasListaRequerimentosJson=function(data){var objetoLinha={};var dados=data.map(function(item){objetoLinha={nomeBeneficiario:_this3.pesquisarColunaJson(item,'nomeBeneficiario'),idProtocolo:_this3.pesquisarColunaJson(item,'idProtocolo'),solicitante:_this3.pesquisarColunaJson(item,'nomeSolicitante')+' - '+_this3.pesquisarColunaJson(item,'idSolicitante'),destinatario:_this3.pesquisarColunaJson(item,'nomeDestinatario')+' - '+_this3.pesquisarColunaJson(item,'idDestinatario'),idCpf:_this3.pesquisarColunaJson(item,'idCpf'),matricula:_this3.pesquisarColunaJson(item,'matricula'),estado:_this3.addTipoEstadoLabel(_this3.pesquisarColunaJson(item,'estado')),tipoRequerimento:_this3.pesquisarColunaJson(item,'tipoRequerimento'),tipoAposentadoria:_this3.pesquisarColunaJson(item,'tipoAposentadoria'),numeroBeneficio:_this3.pesquisarColunaJson(item,'numeroBeneficio'),tipoProRataInicial:_this3.addTipoProRataInicialLabel(_this3.pesquisarColunaJson(item,'tipoProRataInicial')),valorProRataMensal:_this3.pesquisarColunaJson(item,'valorProRataMensal'),valorEstoque:_this3.pesquisarColunaJson(item,'valorEstoque'),valor13Estoque:_this3.pesquisarColunaJson(item,'valor13Estoque'),valorTotalEstoque:_this3.pesquisarColunaJson(item,'valorTotalEstoque'),valorFluxo:_this3.pesquisarColunaJson(item,'valorFluxo'),valor13Fluxo:_this3.pesquisarColunaJson(item,'valor13Fluxo'),valorTotalFluxo:_this3.pesquisarColunaJson(item,'valorTotalFluxo'),valorFluxoAcumulado:_this3.pesquisarColunaJson(item,'valorFluxoAcumulado'),valor13FluxoAcumuladorFluxo:_this3.pesquisarColunaJson(item,'valor13FluxoAcumuladorFluxo'),valorTotalFluxoAcumulado:_this3.pesquisarColunaJson(item,'valorTotalFluxoAcumulado'),valorTotalRequerimento:_this3.pesquisarColunaJson(item,'valorTotalRequerimento'),dataInicioFluxoAcumulado:_this3.pesquisarColunaJson(item,'dataInicioFluxoAcumulado'),dataFimFluxoAcumulado:_this3.pesquisarColunaJson(item,'dataFimFluxoAcumulado'),dataInicioEstoque:_this3.pesquisarColunaJson(item,'dataInicioEstoque'),dataFimEstoque:_this3.pesquisarColunaJson(item,'dataFimEstoque')};return objetoLinha;});return dados;};this.addTipoEstadoLabel=function(tipo){return __WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["Q" /* tiposEstado */],tipo).label;};this.addTipoProRataInicialLabel=function(tipo){var retorno='';if(tipo&&tipo!==null){retorno=__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["n" /* getObject */](__WEBPACK_IMPORTED_MODULE_7__utils_listsSelect__["U" /* tiposProRataInicial */],tipo).label;}return retorno;};this.extrairColunasJsonNaoApto=function(data){var objetoLinha={};var dados=data.map(function(item){var objDestinatario=item[Object.keys(item)[5]]+'-'+item[Object.keys(item)[4]];var objSolicitante=item[Object.keys(item)[3]]+'-'+item[Object.keys(item)[2]];objetoLinha={solicitante:objSolicitante,destinatario:objDestinatario,idProtocolo:_this3.pesquisarColunaJson(item,'idProtocolo'),cpf:_this3.pesquisarColunaJson(item,'idCpf'),tipoRequerimento:_this3.pesquisarColunaJson(item,'tipoRequerimento'),motivoNaoAptidao:_this3.pesquisarColunaJson(item,'motivoNaoAptidao'),estado:_this3.addTipoEstadoLabel(_this3.pesquisarColunaJson(item,'estado'))};return objetoLinha;});return dados;};this.tratarSucessoListaExportacao=function(response){if(response.data!==''){var lista=[];var dadosFormatados=[];if(response.data.nivel===undefined){// consulta de requerimentos nao aptos
lista=_this3.extrairColunasJsonNaoApto(response.data);dadosFormatados=_this3.prepararColunasExportacao(lista,_this3.listaColunasRequerimentoNaoAptoFormatar);}else if(response.data.nivel!==undefined){if(response.data.nivel===1){lista=_this3.extrairColunasJson(response.data.simulacoes);dadosFormatados=_this3.prepararColunasExportacao(lista,_this3.listaColunasFormatar);}else{lista=_this3.extrairColunasListaRequerimentosJson(response.data.requerimentos);dadosFormatados=_this3.prepararColunasExportacao(lista,_this3.listaColunasRequerimentoFormatar);}}_this3.setState({},_this3.gerarCsv(dadosFormatados));}};this.tratarErro=function(){var mensagemPrimaria='Não foi possível consultar os requerimentos.';var mensagemSecundaria='Contate o administrador do sistema.';_this3.setState({showNoContent:true,noContentPrimaryMessage:mensagemPrimaria,noContentSecondaryMessage:mensagemSecundaria});};this.preparaRequest=function(url,parametros){Object(__WEBPACK_IMPORTED_MODULE_6__utils_requests__["l" /* doPost */])(url,parametros,_this3.tratarSucessoListaExportacao,_this3.tratarErro);};this.exportarCsv=function(props){_this3.setState({legendaRelatorio:props.legendExportacao});if(props.urlExportacao&&props.parametrosExportacao){var parametros=props.parametrosExportacao;parametros['start-position']=0;parametros['max-results']=100000;_this3.preparaRequest(props.urlExportacao,parametros);}};};SimulacaoCompensacao.propTypes={dataFormatOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,voltarAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,exibirBotaoVoltar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}.isRequired;SimulacaoCompensacao.defaultProps={voltarAction:function voltarAction(){return null;}};/* harmony default export */ __webpack_exports__["a"] = (SimulacaoCompensacao);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Periodo__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helpers__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable*/var CalculadoraPeriodos=function(_Component){_inherits(CalculadoraPeriodos,_Component);function CalculadoraPeriodos(props){_classCallCheck(this,CalculadoraPeriodos);var _this=_possibleConstructorReturn(this,(CalculadoraPeriodos.__proto__||Object.getPrototypeOf(CalculadoraPeriodos)).call(this,props));_this.montaFormulario=function(){var _this$state=Object.assign({},_this.state),listaPeriodos=_this$state.listaPeriodos;if(listaPeriodos.length===0){var periodo={};periodo.index=0;periodo['dataInicio-0']='';periodo['dataFim-0']='';periodo.totalAno='';periodo.totalMes='';periodo.totalDia='';periodo.diasCorridos='';periodo.calculado=false;listaPeriodos.push(periodo);_this.setState({listaPeriodos:listaPeriodos});}};_this.handleChangeDate=function(obj,name){_this.setState(_defineProperty({},name,obj.value));};_this.verificarPreenchimentoPeriodos=function(){var _this$state2=Object.assign({},_this.state),listaPeriodos=_this$state2.listaPeriodos;var retorno=false;listaPeriodos.forEach(function(periodo){if(!periodo.calculado){retorno=true;}});return retorno;};_this.criarPeriodoVazio=function(indice){var retorno={};retorno.index=indice;retorno['dataInicio-'+indice]='';retorno['dataFim-'+indice]='';retorno.totalAno='';retorno.totalMes='';retorno.totalDia='';retorno.diasCorridos='';retorno.calculado=false;return retorno;};_this.validarRegrasPeriodo=function(){var _this$state3=Object.assign({},_this.state),listaPeriodos=_this$state3.listaPeriodos;listaPeriodos.forEach(function(periodo){var possuiDataInicio=_this.state['dataInicio-'+periodo.index]!==undefined&&_this.state['dataInicio-'+periodo.index]!==null&&_this.state['dataInicio-'+periodo.index]!==''&&!_this.state['dataInicio-'+periodo.index].includes('_');var possuiDataFim=_this.state['dataFim-'+periodo.index]!==undefined&&_this.state['dataFim-'+periodo.index]!==null&&_this.state['dataFim-'+periodo.index]!==''&&!_this.state['dataFim-'+periodo.index].includes('_');if(possuiDataInicio&&possuiDataFim){periodo['dataInicio-'+periodo.index]=_this.state['dataInicio-'+periodo.index];periodo['dataFim-'+periodo.index]=_this.state['dataFim-'+periodo.index];var mesFev=2;var ultimoDiaFevBissexto=29;var diaDataInicio=Number(periodo['dataInicio-'+periodo.index].split('/')[0]);var mesDataInicio=Number(periodo['dataInicio-'+periodo.index].split('/')[1]);var anoInicioBissexto=__WEBPACK_IMPORTED_MODULE_1_moment___default()(periodo['dataInicio-'+periodo.index],'DD/MM/YYYY').isLeapYear();var diaDataFim=Number(periodo['dataFim-'+periodo.index].split('/')[0]);var mesDataFim=Number(periodo['dataFim-'+periodo.index].split('/')[1]);var anoFimBissexto=__WEBPACK_IMPORTED_MODULE_1_moment___default()(periodo['dataFim-'+periodo.index],'DD/MM/YYYY').isLeapYear();if(!anoInicioBissexto&&mesDataInicio===mesFev&&diaDataInicio===ultimoDiaFevBissexto||!anoFimBissexto&&mesDataFim===mesFev&&diaDataFim===ultimoDiaFevBissexto){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(['A Data Início ou Data Fim não corresponde a ano Bissexto']);_this.limparInputDataAmd(periodo);}else{var dataInicioCompleto=__WEBPACK_IMPORTED_MODULE_1_moment___default()(periodo['dataInicio-'+periodo.index],'DD/MM/YYYY');var dataFimCompleto=__WEBPACK_IMPORTED_MODULE_1_moment___default()(periodo['dataFim-'+periodo.index],'DD/MM/YYYY');if(dataFimCompleto.isSameOrAfter(dataInicioCompleto)){var temConcomitancia=_this.verificarConcomitancias(listaPeriodos,periodo.index);if(temConcomitancia){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(['O Per\xEDodo de '+periodo['dataInicio-'+periodo.index]+' at\xE9 '+periodo['dataFim-'+periodo.index]+' \xE9 concomitante com outros per\xEDodos existentes na lista.']);_this.limparInputDataAmd(periodo);_this.verificarPreenchimentoPeriodos();}else{periodo.calculado=true;periodo=_this.handleCalcularAmd(periodo);periodo=_this.handleCalcularDiasCorridos(periodo);}}else{Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(['A Data de Início deve ser menor que a Data de Fim.']);_this.limparInputDataAmd(periodo);_this.verificarPreenchimentoPeriodos();}}_this.limparInputFormulas();}else{_this.limparInputDataAmd(periodo);}});_this.setState({listaPeriodos:listaPeriodos});};_this.verificarConcomitancias=function(lista,index){var _this$state4=Object.assign({},_this.state),listaPeriodos=_this$state4.listaPeriodos;var periodoAtual=0;listaPeriodos.forEach(function(periodo,arrayIndex){if(index===periodo.index){index=arrayIndex;periodoAtual=lista[arrayIndex];}});for(var i=0,tamanhoI=lista.length;i<tamanhoI;i+=1){if(index!=i){var periodoAux=lista[i];if(Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["k" /* stringToData */])(periodoAtual['dataInicio-'+periodoAtual.index])<=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["k" /* stringToData */])(periodoAux['dataFim-'+periodoAux.index])&&Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["k" /* stringToData */])(periodoAux['dataInicio-'+periodoAux.index])<=Object(__WEBPACK_IMPORTED_MODULE_6__utils_helpers__["k" /* stringToData */])(periodoAtual['dataFim-'+periodoAtual.index])){return true;}}};return false;};_this.handleAdicionarPeriodo=function(){var _this$state5=Object.assign({},_this.state),listaPeriodos=_this$state5.listaPeriodos;listaPeriodos.forEach(function(periodo){listaPeriodos.push(_this.criarPeriodoVazio(periodo.index+1));listaPeriodos=_this.reorganizarIndiceLista(_this.ordenarListaPeriodos(listaPeriodos));_this.setState({listaPeriodos:listaPeriodos},_this.reorganizarInputData(listaPeriodos));});_this.limparInputFormulas();};_this.reorganizarIndiceLista=function(){var _this$state6=Object.assign({},_this.state),listaPeriodos=_this$state6.listaPeriodos;var listaIndiceCorrigido=[];listaPeriodos.forEach(function(periodo,arrayIndex){var retorno={};if(periodo.index===arrayIndex){retorno.index=periodo.index;retorno['dataInicio-'+arrayIndex]=periodo['dataInicio-'+arrayIndex];retorno['dataFim-'+arrayIndex]=periodo['dataFim-'+arrayIndex];retorno.totalAno=periodo.totalAno;retorno.totalMes=periodo.totalMes;retorno.totalDia=periodo.totalDia;retorno.diasCorridos=periodo.diasCorridos;retorno.calculado=periodo.calculado;}else{retorno.index=arrayIndex;retorno['dataInicio-'+arrayIndex]=periodo['dataInicio-'+periodo.index];retorno['dataFim-'+arrayIndex]=periodo['dataFim-'+periodo.index];retorno.totalAno=periodo.totalAno;retorno.totalMes=periodo.totalMes;retorno.totalDia=periodo.totalDia;retorno.diasCorridos=periodo.diasCorridos;retorno.calculado=periodo.calculado;}listaIndiceCorrigido.push(retorno);});return listaIndiceCorrigido;};_this.reorganizarInputData=function(lista){lista.forEach(function(periodo,arrayIndex){var _this$setState2;_this.setState((_this$setState2={},_defineProperty(_this$setState2,'dataInicio-'+arrayIndex,periodo['dataInicio-'+arrayIndex]),_defineProperty(_this$setState2,'dataFim-'+arrayIndex,periodo['dataFim-'+arrayIndex]),_this$setState2));});};_this.handleRemoverPeriodo=function(indice){var _this$state7=Object.assign({},_this.state),listaPeriodos=_this$state7.listaPeriodos;listaPeriodos.forEach(function(periodo,arrayIndex){if(periodo.index===indice){listaPeriodos.splice(arrayIndex,1);}});listaPeriodos=_this.reorganizarIndiceLista(_this.ordenarListaPeriodos(listaPeriodos));_this.setState({listaPeriodos:listaPeriodos},_this.reorganizarInputData(listaPeriodos));_this.limparInputFormulas();};_this.compararDatasInicio=function(a,b){if(__WEBPACK_IMPORTED_MODULE_1_moment___default()(a['dataInicio-'+a.index],'DD/MM/YYYY').toDate()<__WEBPACK_IMPORTED_MODULE_1_moment___default()(b['dataInicio-'+b.index],'DD/MM/YYYY').toDate()){return-1;}if(__WEBPACK_IMPORTED_MODULE_1_moment___default()(a['dataInicio-'+a.index],'DD/MM/YYYY').toDate()>__WEBPACK_IMPORTED_MODULE_1_moment___default()(b['dataInicio-'+b.index],'DD/MM/YYYY').toDate()){return 1;}return 0;};_this.ordenarListaPeriodos=function(lista){return lista.sort(_this.compararDatasInicio);};_this.handleCalcularAmd=function(periodo){var acrescentarDia=1;var acrescentarMesDias=30;var trintaUm=31;var qtdDiasMes=30;var qtdMesesAno=12;var acrescentarAno=12;var reduzirMes=1;var reduzirAno=1;var mesFev=2;var ultimoDiaFevBissexto=29;var ultimoDiaFevNaoBissexto=28;var resultadoDia=0;var resultadoMes=0;var resultadoAno=0;var resultadoQtdMeses=0;var restoDivisaoDia=0;var resultadoQtdAnos=0;var restoDivisaoMes=0;var diaInicio=periodo['dataInicio-'+periodo.index].split('/')[0];var mesInicio=periodo['dataInicio-'+periodo.index].split('/')[1];var anoInicio=periodo['dataInicio-'+periodo.index].split('/')[2];var diaFim=periodo['dataFim-'+periodo.index].split('/')[0];var mesFim=periodo['dataFim-'+periodo.index].split('/')[1];var anoFim=periodo['dataFim-'+periodo.index].split('/')[2];if(__WEBPACK_IMPORTED_MODULE_1_moment___default()([anoFim]).isLeapYear()){if(Number(mesFim)===mesFev&&Number(diaFim)===ultimoDiaFevBissexto){diaFim=Number(diaFim)+1;}}else{if(Number(mesFim)===mesFev&&Number(diaFim)===ultimoDiaFevNaoBissexto){diaFim=Number(diaFim)+2;}}if(Number(diaFim)<trintaUm){diaFim=Number(diaFim)+acrescentarDia;if(Number(diaInicio>diaFim)){diaFim=Number(diaFim)+acrescentarMesDias;mesFim=Number(mesFim)-reduzirMes;}}resultadoDia=Number(diaFim-diaInicio);resultadoQtdMeses=Math.trunc(resultadoDia/qtdDiasMes);restoDivisaoDia=resultadoDia%qtdDiasMes;resultadoDia=restoDivisaoDia;if(Number(mesFim<mesInicio)){mesFim=Number(mesFim)+acrescentarAno;anoFim=Number(anoFim)-reduzirAno;}resultadoMes=Number(mesFim-mesInicio);resultadoMes+=resultadoQtdMeses;resultadoQtdAnos=Math.trunc(resultadoMes/qtdMesesAno);restoDivisaoMes=resultadoMes%qtdMesesAno;resultadoMes=restoDivisaoMes;resultadoAno=Number(anoFim-anoInicio);resultadoAno+=resultadoQtdAnos;periodo.totalAno=Math.trunc(Number(resultadoAno));periodo.totalMes=Math.trunc(Number(resultadoMes));periodo.totalDia=Math.trunc(Number(resultadoDia));return periodo;};_this.limparInputDataAmd=function(periodo){periodo['dataInicio-'+periodo.index]='';periodo['dataFim-'+periodo.index]='';periodo.totalAno='';periodo.totalMes='';periodo.totalDia='';periodo.diasCorridos='';periodo.calculado=false;return periodo;};_this.handleCalcularDiasCorridos=function(periodo){var retorno=periodo;var dataInicioCorrido=__WEBPACK_IMPORTED_MODULE_1_moment___default()(periodo['dataInicio-'+periodo.index],'DD/MM/YYYY');var dataFimCorrido=__WEBPACK_IMPORTED_MODULE_1_moment___default()(periodo['dataFim-'+periodo.index],'DD/MM/YYYY');var acrescentarDataFinal=1;var diffDatas=dataFimCorrido.diff(dataInicioCorrido,'days')+acrescentarDataFinal;retorno.diasCorridos=diffDatas;return retorno;};_this.handleCalcularRgps=function(){var _this$state8=Object.assign({},_this.state),periodosRgps=_this$state8.periodosRgps;var _this$state9=Object.assign({},_this.state),listaPeriodos=_this$state9.listaPeriodos;var resultadoDia=0;var resultadoMes=0;var resultadoAno=0;var resultadoQtdMeses=0;var restoDivisaoDia=0;var resultadoQtdAnos=0;var restoDivisaoMes=0;var acrescentarMesDias=30;var qtdDiasMes=30;var qtdMesesAno=12;var acrescentarAnoDias=365;listaPeriodos.forEach(function(periodo){if(periodo.totalDia!==''&&periodo.totalMes!==''&&periodo.totalAno!==''){resultadoDia+=periodo.totalDia;resultadoQtdMeses=Math.trunc(resultadoDia/qtdDiasMes);restoDivisaoDia=resultadoDia%qtdDiasMes;resultadoDia=restoDivisaoDia;resultadoMes+=periodo.totalMes+resultadoQtdMeses;resultadoQtdAnos=Math.trunc(resultadoMes/qtdMesesAno);restoDivisaoMes=resultadoMes%qtdMesesAno;resultadoMes=restoDivisaoMes;resultadoAno+=periodo.totalAno+resultadoQtdAnos;}});periodosRgps.totalDia=resultadoDia;periodosRgps.totalMes=resultadoMes;periodosRgps.totalAno=resultadoAno;periodosRgps.qtdTotalDias=Number(resultadoAno*acrescentarAnoDias+resultadoMes*acrescentarMesDias+resultadoDia);_this.setState({periodosRgps:Object.assign({},_this.state.periodosRgps,{periodosRgps:periodosRgps})});};_this.handleCalcularRpps=function(){var _this$state10=Object.assign({},_this.state),listaPeriodos=_this$state10.listaPeriodos;var _this$state11=Object.assign({},_this.state),periodosRpps=_this$state11.periodosRpps;var resultadoDiasCorridos=0;// let resultadoAno = 0;
// let resultadoMes = 0;
// let resultadoDia = 0;
// let restoDivisaoAno = 0;
// const umAno = 365;
// const umMes = 30;
listaPeriodos.forEach(function(periodo){if(periodo.diasCorridos!==''){resultadoDiasCorridos+=periodo.diasCorridos;}});// if (resultadoDiasCorridos >= umAno) {
//   resultadoAno = Math.trunc(resultadoDiasCorridos / umAno);
//   restoDivisaoAno = (resultadoDiasCorridos % umAno);
//   if (restoDivisaoAno >= umMes) {
//     resultadoMes = Math.trunc(restoDivisaoAno / umMes);
//     resultadoDia = (restoDivisaoAno % umMes);
//   } else {
//     resultadoDia = restoDivisaoAno;
//   }
// } else {
//   if (resultadoDiasCorridos >= umMes) {
//     resultadoMes = Math.trunc(resultadoDiasCorridos / umMes);
//     resultadoDia = (resultadoDiasCorridos % umMes);
//   } else {
//     resultadoDia = resultadoDiasCorridos;
//   }
// }
periodosRpps.qtdTotalDiasCorridos=resultadoDiasCorridos;// periodosRpps.totalAno = resultadoAno;
// periodosRpps.totalMes = resultadoMes;
// periodosRpps.totalDia = resultadoDia;
_this.setState({periodosRpps:Object.assign({},_this.state.periodosRpps,{periodosRpps:periodosRpps})});};_this.verificarPeriodoAdicionado=function(){var _this$state12=Object.assign({},_this.state),listaPeriodos=_this$state12.listaPeriodos;var retorno=false;var possuiPeriodo=listaPeriodos.some(function(periodo){return periodo['dataInicio-'+periodo.index]!==''&&periodo['dataInicio-'+periodo.index]!==null&&periodo['dataFim-'+periodo.index]!==''&&periodo['dataFim-'+periodo.index]!==null&&!periodo['dataInicio-'+periodo.index].includes('_')&&!periodo['dataFim-'+periodo.index].includes('_');});if(possuiPeriodo){retorno=true;return;}else{retorno=true;}return retorno;};_this.handleCalcularTodosPeriodos=function(){_this.handleCalcularRgps();_this.handleCalcularRpps();};_this.handleLimparTodosPeriodos=function(){var _this$state13=Object.assign({},_this.state),listaPeriodos=_this$state13.listaPeriodos,periodosRgps=_this$state13.periodosRgps,periodosRpps=_this$state13.periodosRpps;listaPeriodos.forEach(function(periodo){var _this$setState3;_this.setState((_this$setState3={},_defineProperty(_this$setState3,'dataInicio-'+periodo.index,''),_defineProperty(_this$setState3,'dataFim-'+periodo.index,''),_this$setState3));});listaPeriodos=[];periodosRgps={};periodosRpps={};_this.setState({listaPeriodos:listaPeriodos,periodosRgps:periodosRgps,periodosRpps:periodosRpps},_this.montaFormulario);};_this.limparInputFormulas=function(){var _this$state14=Object.assign({},_this.state),periodosRgps=_this$state14.periodosRgps;var _this$state15=Object.assign({},_this.state),periodosRpps=_this$state15.periodosRpps;periodosRgps.totalDia='';periodosRgps.totalMes='';periodosRgps.totalAno='';periodosRgps.qtdTotalDias='';periodosRpps.qtdTotalDiasCorridos='';// periodosRpps.totalAno = '';
// periodosRpps.totalMes = '';
// periodosRpps.totalDia = '';
_this.setState({periodosRgps:Object.assign({},_this.state.periodosRgps,{periodosRgps:periodosRgps}),periodosRpps:Object.assign({},_this.state.periodosRpps,{periodosRpps:periodosRpps})});};_this.state={periodosRgps:{totalAno:'',totalMes:'',totalDia:'',qtdTotalDias:''},periodosRpps:{qtdTotalDiasCorridos:''// totalAno: '',
// totalMes: '',
// totalDia: '',
},listaPeriodos:[],periodo:{index:0,dataInicio:'',dataFim:'',totalAno:'',totalMes:'',totalDia:'',diasCorridos:''}};return _this;}_createClass(CalculadoraPeriodos,[{key:'componentDidMount',value:function componentDidMount(){this.montaFormulario();}},{key:'render',value:function render(){var _this2=this;var _state=Object.assign({},this.state),listaPeriodos=_state.listaPeriodos;var colecao=[];listaPeriodos.forEach(function(periodo){colecao.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Periodo__["a" /* default */],{state:_this2.state,periodo:periodo,listaPeriodos:_this2.state.listaPeriodos,changePeriodo:_this2.handleChangeDate,validarRegras:_this2.validarRegrasPeriodo,verificarPreenchimentoPeriodos:_this2.verificarPreenchimentoPeriodos,adicionarPeriodo:_this2.handleAdicionarPeriodo,removerPeriodo:_this2.handleRemoverPeriodo,displayButton:true,disabledInputDate:false})));return colecao;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'CalculadoraPeriodos',panelId:'calculadora-periodos',icon:'ico-calc',title:'Calculadora de Per\xEDodos'},colecao,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-btn',title:'Limpar',hint:'Limpar',onClick:function onClick(){return _this2.handleLimparTodosPeriodos();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary',title:'Calcular',hint:'Calcular Per\xEDodos',disabled:this.verificarPeriodoAdicionado(),onClick:function onClick(){return _this2.handleCalcularTodosPeriodos();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["y" /* DtpPanel */],{title:'F\xF3rmula do RGPS'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{showMask:false,label:'Anos',integer:true,disabled:true,value:this.state.periodosRgps.totalAno})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{showMask:false,label:'Meses',integer:true,disabled:true,value:this.state.periodosRgps.totalMes})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{showMask:false,label:'Dia',integer:true,disabled:true,value:this.state.periodosRgps.totalDia})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'1 1 1 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{disabled:true,value:'|',style:{borderBottom:'none','text-align':'center'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{showMask:false,label:'Dias',disabled:true,value:this.state.periodosRgps.qtdTotalDias})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["y" /* DtpPanel */],{title:'F\xF3rmula do RPPS'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'2 2 2 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{showMask:false,label:'Dias',disabled:true,value:this.state.periodosRpps.qtdTotalDiasCorridos})))))));}}]);return CalculadoraPeriodos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CalculadoraPeriodos.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (CalculadoraPeriodos);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requests__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FiltroExtratoCnis__ = __webpack_require__(693);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid */var ConsultaExtratoCnis=function(_Component){_inherits(ConsultaExtratoCnis,_Component);function ConsultaExtratoCnis(){_classCallCheck(this,ConsultaExtratoCnis);var _this=_possibleConstructorReturn(this,(ConsultaExtratoCnis.__proto__||Object.getPrototypeOf(ConsultaExtratoCnis)).call(this));_this.getInitialState=function(){return{listaExtratoCnis:[],filtrosPesquisa:{},showNoContent:false,noContentPrimaryMessage:'Json de retorno não encontrado para o nit informado.',noContentSecondaryMessage:'Informe um nit válido.',exibirBotaoSelecionarTudo:false};};_this.montaFiltros=function(atributosPesquisa){var atributos=[];if(atributosPesquisa.nitCnis){atributos=Object.assign({},atributos,{nitFiltro:atributosPesquisa.nitCnis});}if(atributosPesquisa.elosCnis){atributos=Object.assign({},atributos,{elosFiltro:atributosPesquisa.elosCnis});}return atributos;};_this.realizaConsulta=function(filtrosPesquisa){var filtrosConsulta={};if(filtrosPesquisa){filtrosConsulta=_this.montaFiltros(filtrosPesquisa);}_this.setState({filtrosConsulta:filtrosConsulta},_this.executaConsulta);};_this.executaConsulta=function(){if(Object.entries(_this.state.filtrosConsulta).length!==0){Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["e" /* doGet */])('integracao/extrato-cnis',_this.handleSucessBuscarNitElos,_this.handleErrorBuscarNitElos,_this.state.filtrosConsulta);}};_this.handleErrorBuscarNitElos=function(){};_this.preparaRequest=function(urlRelatorio,parametros,callback){Object(__WEBPACK_IMPORTED_MODULE_3__utils_requests__["e" /* doGet */])(urlRelatorio,parametros,callback,_this.tratarErro);};_this.handleSucessBuscarNitElos=function(response){if(response.data){var jsonRetorno=document.getElementById('jsonRetorno');var obj=JSON.parse(response.data.json);jsonRetorno.innerHTML=JSON.stringify(obj,undefined,2);// this.setState({ listaExtratoCnis: [response.data.json] });
_this.setState({exibirBotaoSelecionarTudo:true});}};_this.selecionarTudo=function(element){var doc=document;var text=doc.getElementById(element);if(doc.body.createTextRange){var range=doc.body.createTextRange();range.moveToElementText(text);range.select();}else if(window.getSelection){var selection=window.getSelection();var _range=doc.createRange();_range.selectNodeContents(text);selection.removeAllRanges();selection.addRange(_range);}};_this.copiarParaAreaDeTransferencia=function(element){var doc=document;var text=doc.getElementById(element);var selection=window.getSelection();var range=doc.createRange();range.selectNodeContents(text);selection.removeAllRanges();selection.addRange(range);document.execCommand('copy');};var initialState=_this.getInitialState();_this.state=initialState;return _this;}// handleSearch = () => {
//   let paramNit = '';
//   let paramElos = '';
//   if (this.state.nitCnis) {
//     paramNit = this.state.nitCnis;
//   }
//   if (this.state.elosCnis) {
//     paramElos = this.state.elosCnis;
//   }
//   const parametros = {
//     nitFiltro: paramNit,
//     elosFiltro: paramElos,
//   };
//   this.buscarJsonExtratoCnis(parametros);
// }
// buscarJsonExtratoCnis = () => {
//   const url = 'integracao/extrato-cnis';
//   // doPost(url, parametros, this.handleSucessBuscarNitElos);
//   doGet(url, this.handleSucessBuscarNitElos, this.handleErrorBuscarNitElos, parametros);
// }
// buscarJsonExtratoCnis = (parametros) => {
//   const url = 'integracao/extrato-cnis';
//   // doPost(url, parametros, this.handleSucessBuscarNitElos);
//   doGet(url, this.handleSucessBuscarNitElos, this.handleErrorBuscarNitElos, parametros);
// }
_createClass(ConsultaExtratoCnis,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_dtp_react_components__["j" /* DtpContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FiltroExtratoCnis__["a" /* default */],{handleSearchFilter:this.realizaConsulta}),this.state.exibirBotaoSelecionarTudo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Button */],{className:'dtp-button left',onClick:function onClick(){return _this2.copiarParaAreaDeTransferencia('jsonRetorno');},hint:'Copiar o conte\xFAdo do JSON para a \xE1rea de transfer\xEAncia.',mini:true,icon:'ico-doc-copy'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:this.state.exibirBotaoSelecionarTudo?'0px':'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre',{style:{paddingTop:'20px',backgroundColor:'#ffffff'// height: '400px',
// 'overflow-y': 'auto',
},id:'jsonRetorno'})));}}]);return ConsultaExtratoCnis;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConsultaExtratoCnis.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (ConsultaExtratoCnis);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dtp_react_components__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_requests__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FiltroExtratoCnis=function(_Component){_inherits(FiltroExtratoCnis,_Component);function FiltroExtratoCnis(){_classCallCheck(this,FiltroExtratoCnis);var _this=_possibleConstructorReturn(this,(FiltroExtratoCnis.__proto__||Object.getPrototypeOf(FiltroExtratoCnis)).call(this));_this.preparaNovaConsulta=function(){var filtroExtratoCnis={nitFiltro:null,elosFiltro:null};filtroExtratoCnis=JSON.stringify(filtroExtratoCnis);sessionStorage.setItem('filtroExtratoCnis',filtroExtratoCnis);_this.setState({nitFiltro:null,elosFiltro:null});};_this.handleChange=function(changeObj,name){_this.setState(_defineProperty({},name,changeObj.value));};_this.handleSearchButton=function(){var filtroExtratoCnis={nitFiltro:_this.state.nitFiltro,elosFiltro:_this.state.elosFiltro};filtroExtratoCnis=JSON.stringify(filtroExtratoCnis);sessionStorage.setItem('filtroExtratoCnis',filtroExtratoCnis);_this.handleSearch();};_this.handleSearch=function(){// if (((this.state.elosCnis === null || this.state.elosCnis === '') &&
// (this.state.nitCnis === null || this.state.elosCnis === '')) ||
// ((this.state.elosCnis !== null && this.state.elosCnis !== '') &&
// (this.state.nitCnis === null || this.state.nitCnis === ''))) {
if(_this.state.elosCnis!==null&&_this.state.elosCnis!==''&&(_this.state.nitCnis===null||_this.state.nitCnis==='')){Object(__WEBPACK_IMPORTED_MODULE_4__utils_requests__["L" /* trataMensagensErro */])(['É necessário digitar um nit para o elo digitado.']);}else{_this.props.handleSearchFilter(_this.state);}};_this.filtroExtratoCnis=JSON.parse(sessionStorage.getItem('FiltroExtratoCnis'));_this.state={nitFiltro:_this.filtroExtratoCnis&&_this.filtroExtratoCnis.nitFiltro?_this.filtroExtratoCnis.nitFiltro:null,elosFiltro:_this.filtroExtratoCnis&&_this.filtroExtratoCnis.elosFiltro?_this.filtroExtratoCnis.elosFiltro:null};return _this;}_createClass(FiltroExtratoCnis,[{key:'componentDidMount',value:function componentDidMount(){if(sessionStorage.getItem('filtroExtratoCnis')){this.handleSearchButton();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// Apenas repete consulta se parametro da url for alterado
if(this.props.tipoConsulta!==prevProps.tipoConsulta){this.preparaNovaConsulta();}}},{key:'montaFiltros',value:function montaFiltros(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'3 3 3 3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{integer:true,label:'Nit principal',value:this.state.nitCnis,onChange:function onChange(e){return _this2.handleChange(e,'nitCnis');},maxlength:'11'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["i" /* Grid */],{cols:'9 9 9 9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Input */],{label:'Elos (separados por v\xEDrgulas)',value:this.state.elosCnis,onChange:function onChange(e){return _this2.handleChange(e,'elosCnis');},nitElado:true}))));}},{key:'render',value:function render(){var _this3=this;var filtrosPesquisa=this.montaFiltros();if(!filtrosPesquisa){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["a" /* DtpAccordionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_dtp_react_components__["b" /* DtpAccordionPanel */],{headingId:'pesquisa',panelId:'filtro-pesquisa',icon:'ico-filter',title:'Filtro de Pesquisa'},filtrosPesquisa,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Button */],{className:'dtp-primary right',title:'Pesquisar',onClick:function onClick(){return _this3.handleSearchButton();},hint:'Pesquisar de acordo com o filtro aplicado'}))));}}]);return FiltroExtratoCnis;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FiltroExtratoCnis.propTypes={handleChangeList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleSearchFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,list:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array}.isRequired;/* harmony default export */ __webpack_exports__["a"] = (FiltroExtratoCnis);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.e7b8efac.js